export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateTime: { input: string; output: string; }
  JSON: { input: any; output: any; }
  JSONObject: { input: any; output: any; }
  Upload: { input: File; output: File; }
};

export type AcfiAssessment = {
  __typename?: 'ACFIAssessment';
  approvedDate?: Maybe<Scalars['DateTime']['output']>;
  assessedBy: Scalars['ID']['output'];
  assessedByName?: Maybe<Scalars['String']['output']>;
  assessmentDate: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  domainScores: Array<AcfiDomainScore>;
  estimatedDailyRate?: Maybe<Scalars['Float']['output']>;
  expiryDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  /** Imported SarahCare history: read-only, never current work */
  isHistoricalRecord?: Maybe<Scalars['Boolean']['output']>;
  /** Legacy ACFI appraisal details from SarahCare */
  legacyDetails?: Maybe<AcfiLegacyDetails>;
  notes?: Maybe<Scalars['String']['output']>;
  overallFundingCategory?: Maybe<Scalars['String']['output']>;
  residentId: Scalars['ID']['output'];
  residentName?: Maybe<Scalars['String']['output']>;
  residentRoom?: Maybe<Scalars['String']['output']>;
  residentWing?: Maybe<Scalars['String']['output']>;
  /** Who entered it in SarahCare */
  sourceAuthor?: Maybe<Scalars['String']['output']>;
  sourceBackupDate?: Maybe<Scalars['DateTime']['output']>;
  /** Original SarahCare columns (provenance) */
  sourceFields?: Maybe<Array<AcfiSarahSourceField>>;
  /** SarahCare table and key, e.g. ACFIScores:<ACFIID> */
  sourceId?: Maybe<Scalars['String']['output']>;
  /** SARAHCARE for imported history */
  sourceSystem?: Maybe<Scalars['String']['output']>;
  status: AcfiStatus;
  submittedDate?: Maybe<Scalars['DateTime']['output']>;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type AcfiAssessmentFilterInput = {
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  residentId?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<AcfiStatus>;
  wing?: InputMaybe<Scalars['String']['input']>;
};

export type AcfiAssessmentsResponse = {
  __typename?: 'ACFIAssessmentsResponse';
  assessments: Array<AcfiAssessment>;
  limit: Scalars['Int']['output'];
  offset: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type AcfiDetails = {
  __typename?: 'ACFIDetails';
  /** ACAS Reference Number */
  acasRefNumber?: Maybe<Scalars['String']['output']>;
  accommodationPaymentStatus?: Maybe<AccommodationPaymentStatus>;
  accommodationPaymentType?: Maybe<AccommodationPaymentType>;
  /** Care Recipient ID */
  careRecipientId?: Maybe<Scalars['String']['output']>;
  /** Previous aged care provider (if applicable) */
  previousProvider?: Maybe<Scalars['String']['output']>;
  /** RACS ID (Residential Aged Care Service ID) */
  racsId?: Maybe<Scalars['String']['output']>;
};

export type AcfiDetailsInput = {
  acasRefNumber?: InputMaybe<Scalars['String']['input']>;
  accommodationPaymentStatus?: InputMaybe<AccommodationPaymentStatus>;
  accommodationPaymentType?: InputMaybe<AccommodationPaymentType>;
  careRecipientId?: InputMaybe<Scalars['String']['input']>;
  previousProvider?: InputMaybe<Scalars['String']['input']>;
  racsId?: InputMaybe<Scalars['String']['input']>;
};

/** ACFI assessment domain — ADL (Activities of Daily Living), BHC (Behaviour), CHC (Complex Health Care) */
export enum AcfiDomain {
  Adl = 'ADL',
  Bhc = 'BHC',
  Chc = 'CHC'
}

export type AcfiDomainScore = {
  __typename?: 'ACFIDomainScore';
  domain: AcfiDomain;
  evidence?: Maybe<Scalars['String']['output']>;
  questions: Array<AcfiQuestionResponse>;
  rating: AcfiRating;
};

export type AcfiDomainScoreInput = {
  domain: AcfiDomain;
  evidence?: InputMaybe<Scalars['String']['input']>;
  questions?: InputMaybe<Array<AcfiQuestionResponseInput>>;
  rating: AcfiRating;
};

export type AcfiFundingSummaryResponse = {
  __typename?: 'ACFIFundingSummaryResponse';
  approvedCount: Scalars['Int']['output'];
  assessedCount: Scalars['Int']['output'];
  draftCount: Scalars['Int']['output'];
  expiringWithin30Days: Scalars['Int']['output'];
  /** SarahCare history records (status HISTORICAL); never counted as current work */
  historicalCount: Scalars['Int']['output'];
  submittedCount: Scalars['Int']['output'];
  totalResidents: Scalars['Int']['output'];
};

export type AcfiLegacyDetails = {
  __typename?: 'ACFILegacyDetails';
  /** ADL domain total score */
  adlScore?: Maybe<Scalars['Float']['output']>;
  amended?: Maybe<Scalars['Boolean']['output']>;
  /** Appraisal type code, e.g. NEW, CNR, MCA */
  appraisalType?: Maybe<Scalars['String']['output']>;
  /** Appraisal type in words, from SarahCare's own lookup */
  appraisalTypeDescription?: Maybe<Scalars['String']['output']>;
  /** Behaviour domain total score */
  behaviourScore?: Maybe<Scalars['Float']['output']>;
  /** Overall care level SarahCare recorded (High / Low) */
  careLevel?: Maybe<Scalars['String']['output']>;
  /** Complex health care domain level 0–3 */
  chcLevel?: Maybe<Scalars['Int']['output']>;
  downgraded?: Maybe<Scalars['Boolean']['output']>;
  /** Appraisal came from another facility */
  fromOtherFacility?: Maybe<Scalars['Boolean']['output']>;
  /** SarahCare lock status: sent, lock or unlock */
  lockStatus?: Maybe<Scalars['String']['output']>;
  /** Psychogeriatric Assessment Scale score */
  pasScore?: Maybe<Scalars['Float']['output']>;
  questionRatings: Array<AcfiLegacyQuestionRating>;
  /** SarahCare sub-type code, e.g. CNR1 */
  sarahAppraisalType?: Maybe<Scalars['String']['output']>;
  sarahAppraisalTypeDescription?: Maybe<Scalars['String']['output']>;
  /** Scheme letter SarahCare recorded (A / B) */
  scheme?: Maybe<Scalars['String']['output']>;
  signedDate?: Maybe<Scalars['DateTime']['output']>;
  supportingAssessments: Array<AcfiLegacySupportingAssessment>;
};

export type AcfiLegacyQuestionRating = {
  __typename?: 'ACFILegacyQuestionRating';
  /** ACFI question name, e.g. "Nutrition" */
  question: Scalars['String']['output'];
  /** ACFI question number 1–12 */
  questionNumber: Scalars['Int']['output'];
  /** SarahCare letter rating A–D (A is the lowest need) */
  rating?: Maybe<Scalars['String']['output']>;
};

export type AcfiLegacySupportingAssessment = {
  __typename?: 'ACFILegacySupportingAssessment';
  /** Appraiser profession as SarahCare recorded it */
  appraiserProfession?: Maybe<Scalars['String']['output']>;
  assessmentDate?: Maybe<Scalars['DateTime']['output']>;
  /** VERBAL, PHYSICAL, WANDERING, CONTINENCE, PAS or DEPRESSION */
  kind: Scalars['String']['output'];
  /** Observation days recorded for the behaviour/continence chart */
  observationDates: Array<Scalars['DateTime']['output']>;
  /** Tool score (PAS) when SarahCare held one */
  score?: Maybe<Scalars['Float']['output']>;
  /** SarahCare key of the supporting record */
  sourceId?: Maybe<Scalars['String']['output']>;
};

export type AcfiQuestionResponse = {
  __typename?: 'ACFIQuestionResponse';
  questionCode: Scalars['String']['output'];
  response: Scalars['String']['output'];
  score: Scalars['Int']['output'];
};

export type AcfiQuestionResponseInput = {
  questionCode: Scalars['String']['input'];
  response: Scalars['String']['input'];
  score: Scalars['Int']['input'];
};

/** ACFI funding rating level per domain */
export enum AcfiRating {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM',
  Nil = 'NIL'
}

/** Status of an ACFI assessment submission */
export enum AcfiStatus {
  Approved = 'APPROVED',
  Draft = 'DRAFT',
  Historical = 'HISTORICAL',
  Rejected = 'REJECTED',
  Submitted = 'SUBMITTED',
  UnderReview = 'UNDER_REVIEW'
}

export type AbaFileResult = {
  __typename?: 'AbaFileResult';
  /** ABA file body (120-char fixed-width records, CRLF line endings) */
  aba: Scalars['String']['output'];
  filename: Scalars['String']['output'];
  recordCount: Scalars['Int']['output'];
  settlementDate: Scalars['DateTime']['output'];
  totalAmount: Scalars['Float']['output'];
  warnings: Array<Scalars['String']['output']>;
};

export type AbbeyPainAssessment = {
  __typename?: 'AbbeyPainAssessment';
  assessedBy: Scalars['ID']['output'];
  assessedByName?: Maybe<Scalars['String']['output']>;
  assessmentDate: Scalars['DateTime']['output'];
  autoProgressNote: Scalars['Boolean']['output'];
  behaviouralChange: Scalars['Int']['output'];
  bodyLanguage: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  facialExpression: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  painCategory: Scalars['String']['output'];
  physical: Scalars['Int']['output'];
  physiological: Scalars['Int']['output'];
  progressNoteId?: Maybe<Scalars['ID']['output']>;
  residentId: Scalars['ID']['output'];
  residentName?: Maybe<Scalars['String']['output']>;
  residentRoom?: Maybe<Scalars['String']['output']>;
  residentWing?: Maybe<Scalars['String']['output']>;
  sourceAuthor?: Maybe<Scalars['String']['output']>;
  sourceBackupDate?: Maybe<Scalars['DateTime']['output']>;
  sourceFields?: Maybe<Array<HistoricalAssessmentSourceField>>;
  sourceId?: Maybe<Scalars['String']['output']>;
  sourceSystem?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  totalScore: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
  vocalization: Scalars['Int']['output'];
};

export type AbbeyPainAssessmentFilterInput = {
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  residentId?: InputMaybe<Scalars['ID']['input']>;
  wing?: InputMaybe<Scalars['String']['input']>;
};

export type AbbeyPainAssessmentsResponse = {
  __typename?: 'AbbeyPainAssessmentsResponse';
  assessments: Array<AbbeyPainAssessment>;
  limit: Scalars['Int']['output'];
  offset: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

/** Reason for an employee's absence from a shift */
export enum AbsenceReason {
  AnnualLeave = 'ANNUAL_LEAVE',
  Bereavement = 'BEREAVEMENT',
  EducationTraining = 'EDUCATION_TRAINING',
  FamilyEmergency = 'FAMILY_EMERGENCY',
  LongServiceLeave = 'LONG_SERVICE_LEAVE',
  Meeting = 'MEETING',
  NoShowUnexcused = 'NO_SHOW_UNEXCUSED',
  Other = 'OTHER',
  PersonalLeave = 'PERSONAL_LEAVE',
  PublicHolidayNotWorked = 'PUBLIC_HOLIDAY_NOT_WORKED',
  SickLeave = 'SICK_LEAVE',
  WorkersComp = 'WORKERS_COMP'
}

export type AbsenceSegment = {
  __typename?: 'AbsenceSegment';
  endTime?: Maybe<Scalars['DateTime']['output']>;
  hours: Scalars['Float']['output'];
  isPaidLeave?: Maybe<Scalars['Boolean']['output']>;
  markedAt?: Maybe<Scalars['DateTime']['output']>;
  markedBy?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  reason: AbsenceReason;
  startTime?: Maybe<Scalars['DateTime']['output']>;
};

export type AbsenceSegmentInput = {
  endTime?: InputMaybe<Scalars['DateTime']['input']>;
  hours: Scalars['Float']['input'];
  isPaidLeave?: InputMaybe<Scalars['Boolean']['input']>;
  markedAt?: InputMaybe<Scalars['DateTime']['input']>;
  markedBy?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  reason: AbsenceReason;
  startTime?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AcceptBankingBalanceInput = {
  accountId: Scalars['ID']['input'];
  at?: InputMaybe<Scalars['DateTime']['input']>;
  balanceMinor?: InputMaybe<Scalars['Int']['input']>;
};

export type AcceptEmailReplyDraftInput = {
  body: Scalars['String']['input'];
  inboundEmailId: Scalars['ID']['input'];
  subject: Scalars['String']['input'];
};

export type AcceptGovInviteInput = {
  fName?: InputMaybe<Scalars['String']['input']>;
  lName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  slug: Scalars['String']['input'];
  statement?: InputMaybe<Scalars['String']['input']>;
};

/** Accommodation payment status for ACFI reporting */
export enum AccommodationPaymentStatus {
  Assisted = 'ASSISTED',
  Concessional = 'CONCESSIONAL',
  Neither = 'NEITHER'
}

/** Type of accommodation payment arrangement */
export enum AccommodationPaymentType {
  Bond = 'BOND',
  Combination = 'COMBINATION',
  Dap = 'DAP'
}

/** Types of meal accompaniments (sides) */
export enum AccompanimentType {
  Garnish = 'GARNISH',
  Sauce = 'SAUCE',
  Starch = 'STARCH',
  Vegetable = 'VEGETABLE'
}

export type AccompanimentUsage = {
  __typename?: 'AccompanimentUsage';
  lastUsedDate: Scalars['String']['output'];
  name: Scalars['String']['output'];
  type: AccompanimentType;
  usageCount: Scalars['Int']['output'];
};

/** Outcome of an authentication verify call: existing client logged in, new client created (tenant allows self-signup), no matching account found (tenant blocks self-signup), or the account exists but sign-in is switched off (ACCESS_BLOCKED — no token issued). */
export enum AccountStatus {
  AccessBlocked = 'ACCESS_BLOCKED',
  CreatedNew = 'CREATED_NEW',
  Existing = 'EXISTING',
  LookupFailed = 'LOOKUP_FAILED'
}

export type AccountabilityGoal = {
  __typename?: 'AccountabilityGoal';
  achievedAt?: Maybe<Scalars['DateTime']['output']>;
  actionCount?: Maybe<Scalars['Int']['output']>;
  aspectColor?: Maybe<Scalars['String']['output']>;
  aspectId: Scalars['ID']['output'];
  aspectName: Scalars['String']['output'];
  capacityIndex?: Maybe<CapacityIndex>;
  completedActionCount?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['DateTime']['output'];
  currentRating: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  importance?: Maybe<Scalars['Int']['output']>;
  integrationNotes?: Maybe<Scalars['String']['output']>;
  internalExperience?: Maybe<Scalars['Int']['output']>;
  reflectionNotes?: Maybe<Scalars['String']['output']>;
  snapshotId?: Maybe<Scalars['ID']['output']>;
  status: AccountabilityGoalStatus;
  targetDate?: Maybe<Scalars['DateTime']['output']>;
  targetRating: Scalars['Int']['output'];
  tenantId: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  userId: Scalars['ID']['output'];
};

/** Status of an accountability goal */
export enum AccountabilityGoalStatus {
  Abandoned = 'ABANDONED',
  Achieved = 'ACHIEVED',
  Active = 'ACTIVE',
  Paused = 'PAUSED'
}

export type AccountingBankAccount = {
  __typename?: 'AccountingBankAccount';
  accountNumberMasked?: Maybe<Scalars['String']['output']>;
  companyId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdByClientId?: Maybe<Scalars['String']['output']>;
  enabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  institutionName?: Maybe<Scalars['String']['output']>;
  lastImportedAt?: Maybe<Scalars['DateTime']['output']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']['output']>;
  ledgerAccountId?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  purpose: AccountingBankPurpose;
  redbarkAccountId?: Maybe<Scalars['String']['output']>;
  source: AccountingBankSource;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** One bank account's balance, read from Xero's bank summary */
export type AccountingBankBalance = {
  __typename?: 'AccountingBankBalance';
  balanceCents: Scalars['Float']['output'];
  bankAccountId: Scalars['ID']['output'];
  bankName: Scalars['String']['output'];
  xeroAccountName: Scalars['String']['output'];
};

/** The cash position: each bank account's balance at the end of a Brisbane day */
export type AccountingBankBalances = {
  __typename?: 'AccountingBankBalances';
  asAtDay: Scalars['String']['output'];
  balances: Array<AccountingBankBalance>;
  notHere: Array<Scalars['String']['output']>;
  source: Scalars['String']['output'];
  totalCents: Scalars['Float']['output'];
};

/** Day-to-day, government claims, payroll or other */
export enum AccountingBankPurpose {
  DayToDay = 'DAY_TO_DAY',
  GovernmentClaims = 'GOVERNMENT_CLAIMS',
  Other = 'OTHER',
  Payroll = 'PAYROLL'
}

export type AccountingBankPurposeSummary = {
  __typename?: 'AccountingBankPurposeSummary';
  accountCount: Scalars['Int']['output'];
  accountNames: Array<Scalars['String']['output']>;
  purpose: AccountingBankPurpose;
  unexplainedCount: Scalars['Int']['output'];
};

/** Redbark bank feed or bank CSV import */
export enum AccountingBankSource {
  Csv = 'CSV',
  Redbark = 'REDBARK'
}

/** 13-week cash-flow forecast for one entity, projected from its own bank history */
export type AccountingCashForecast = {
  __typename?: 'AccountingCashForecast';
  asAtDay: Scalars['String']['output'];
  assumptions: Array<Scalars['String']['output']>;
  averageInPerWeekCents: Scalars['Float']['output'];
  averageOutPerWeekCents: Scalars['Float']['output'];
  historyFrom: Scalars['String']['output'];
  historyRows: Scalars['Int']['output'];
  historyTo: Scalars['String']['output'];
  lowestClosingCents?: Maybe<Scalars['Float']['output']>;
  lowestWeekStart?: Maybe<Scalars['String']['output']>;
  openingBalances: Array<AccountingBankBalance>;
  openingCents?: Maybe<Scalars['Float']['output']>;
  openingNote?: Maybe<Scalars['String']['output']>;
  recurring: Array<AccountingRecurringFlow>;
  transfersLeftOut: Scalars['Int']['output'];
  weeks: Array<AccountingForecastWeek>;
};

/** Uncoded, suggested, coded (confirmed by a person) or excluded */
export enum AccountingCodingStatus {
  Coded = 'CODED',
  Excluded = 'EXCLUDED',
  Suggested = 'SUGGESTED',
  Uncoded = 'UNCODED'
}

export type AccountingCompany = {
  __typename?: 'AccountingCompany';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  tradingName?: Maybe<Scalars['String']['output']>;
};

export type AccountingDashboard = {
  __typename?: 'AccountingDashboard';
  companyId: Scalars['String']['output'];
  ledgerAccountCount: Scalars['Int']['output'];
  month: Scalars['String']['output'];
  monthExpensesCents: Scalars['Float']['output'];
  monthNetCents: Scalars['Float']['output'];
  monthRevenueCents: Scalars['Float']['output'];
  monthUncodedCount: Scalars['Int']['output'];
  purposes: Array<AccountingBankPurposeSummary>;
  transactionCount: Scalars['Int']['output'];
  unexplainedCount: Scalars['Int']['output'];
};

/** Money in (CREDIT) or money out (DEBIT) */
export enum AccountingDirection {
  Credit = 'CREDIT',
  Debit = 'DEBIT'
}

/** One expected amount inside a forecast week */
export type AccountingForecastLine = {
  __typename?: 'AccountingForecastLine';
  cents: Scalars['Float']['output'];
  day?: Maybe<Scalars['String']['output']>;
  kind: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

/** One Monday–Sunday week of the cash-flow forecast */
export type AccountingForecastWeek = {
  __typename?: 'AccountingForecastWeek';
  closingCents?: Maybe<Scalars['Float']['output']>;
  inCents: Scalars['Float']['output'];
  lines: Array<AccountingForecastLine>;
  openingCents?: Maybe<Scalars['Float']['output']>;
  outCents: Scalars['Float']['output'];
  weekEnd: Scalars['String']['output'];
  weekStart: Scalars['String']['output'];
};

/** What importing this row would do */
export enum AccountingImportAction {
  ChangedKept = 'CHANGED_KEPT',
  Duplicate = 'DUPLICATE',
  Error = 'ERROR',
  New = 'NEW',
  Same = 'SAME',
  Update = 'UPDATE'
}

export type AccountingPnlLine = {
  __typename?: 'AccountingPnlLine';
  code: Scalars['String']['output'];
  isClinical: Scalars['Boolean']['output'];
  ledgerAccountId: Scalars['ID']['output'];
  monthCents: Array<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  totalCents: Scalars['Float']['output'];
};

export type AccountingProfitLoss = {
  __typename?: 'AccountingProfitLoss';
  balanceSheetCount: Scalars['Int']['output'];
  basis: Scalars['String']['output'];
  clinicalExpensesTotal: Scalars['Float']['output'];
  expenses: Array<AccountingPnlLine>;
  expensesByMonth: Array<Scalars['Float']['output']>;
  expensesTotal: Scalars['Float']['output'];
  months: Array<Scalars['String']['output']>;
  netByMonth: Array<Scalars['Float']['output']>;
  netTotal: Scalars['Float']['output'];
  nonClinicalExpensesTotal: Scalars['Float']['output'];
  revenue: Array<AccountingPnlLine>;
  revenueByMonth: Array<Scalars['Float']['output']>;
  revenueTotal: Scalars['Float']['output'];
  suggestedCount: Scalars['Int']['output'];
  uncodedCount: Scalars['Int']['output'];
};

export type AccountingProfitLossInput = {
  companyId: Scalars['ID']['input'];
  fromMonth: Scalars['String']['input'];
  toMonth: Scalars['String']['input'];
};

/** A payee that comes round on a steady rhythm in the bank history — projected forward on it */
export type AccountingRecurringFlow = {
  __typename?: 'AccountingRecurringFlow';
  cadence: Scalars['String']['output'];
  lastDay: Scalars['String']['output'];
  nextDay: Scalars['String']['output'];
  occurrences: Scalars['Int']['output'];
  payee: Scalars['String']['output'];
  typicalCents: Scalars['Float']['output'];
};

export type AccountingResidentOption = {
  __typename?: 'AccountingResidentOption';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  room?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
};

/** Which direction a coding rule matches */
export enum AccountingRuleDirection {
  Any = 'ANY',
  Credit = 'CREDIT',
  Debit = 'DEBIT'
}

export type AccountingRuleRun = {
  __typename?: 'AccountingRuleRun';
  examined: Scalars['Int']['output'];
  suggested: Scalars['Int']['output'];
};

export type AccountingSettingsView = {
  __typename?: 'AccountingSettingsView';
  connectedAt?: Maybe<Scalars['DateTime']['output']>;
  hasApiKey: Scalars['Boolean']['output'];
  keyLast4?: Maybe<Scalars['String']['output']>;
  lastSyncAt?: Maybe<Scalars['DateTime']['output']>;
  lastSyncStatus?: Maybe<Scalars['String']['output']>;
  plan?: Maybe<Scalars['String']['output']>;
  webhookRegistered: Scalars['Boolean']['output'];
  xeroAppSaved: Scalars['Boolean']['output'];
  xeroClientIdHint?: Maybe<Scalars['String']['output']>;
  xeroClientIdStart?: Maybe<Scalars['String']['output']>;
  xeroConnected: Scalars['Boolean']['output'];
  xeroConnectedAt?: Maybe<Scalars['DateTime']['output']>;
  xeroCredentialHint?: Maybe<Scalars['String']['output']>;
  xeroMissingScopes: Array<Scalars['String']['output']>;
  xeroOrgs: Array<AccountingXeroOrg>;
};

/** A coding rule or the AI accounting mate */
export enum AccountingSuggestedBy {
  Ai = 'AI',
  Rule = 'RULE',
  Xero = 'XERO'
}

export type AccountingSyncResult = {
  __typename?: 'AccountingSyncResult';
  accounts: Scalars['Int']['output'];
  inserted: Scalars['Int']['output'];
  problems: Array<Scalars['String']['output']>;
  skippedPending: Scalars['Int']['output'];
  suggested: Scalars['Int']['output'];
  summary: Scalars['String']['output'];
  updated: Scalars['Int']['output'];
};

export type AccountingTransaction = {
  __typename?: 'AccountingTransaction';
  amountCents: Scalars['Int']['output'];
  bankAccountId: Scalars['ID']['output'];
  coding: TransactionCoding;
  companyId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  currency: Scalars['String']['output'];
  description: Scalars['String']['output'];
  direction: AccountingDirection;
  firstSeenAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  importLine?: Maybe<Scalars['Int']['output']>;
  importedByClientId?: Maybe<Scalars['String']['output']>;
  localDate: Scalars['DateTime']['output'];
  merchantName?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  origin: AccountingTransactionOrigin;
  reference?: Maybe<Scalars['String']['output']>;
  sourceKey: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type AccountingTransactionListInput = {
  bankAccountId?: InputMaybe<Scalars['ID']['input']>;
  companyId: Scalars['ID']['input'];
  fromDay?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<AccountingCodingStatus>>;
  toDay?: InputMaybe<Scalars['String']['input']>;
  unexplainedOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Redbark bank feed, a bank CSV import, or Xero */
export enum AccountingTransactionOrigin {
  CsvImport = 'CSV_IMPORT',
  Redbark = 'REDBARK',
  Xero = 'XERO'
}

export type AccountingTransactionPage = {
  __typename?: 'AccountingTransactionPage';
  hasMore: Scalars['Boolean']['output'];
  items: Array<AccountingTransaction>;
  totalCount: Scalars['Int']['output'];
};

export type AccountingXeroOrg = {
  __typename?: 'AccountingXeroOrg';
  name: Scalars['String']['output'];
  xeroTenantId: Scalars['String']['output'];
};

export type AcfiSarahSourceField = {
  __typename?: 'AcfiSarahSourceField';
  /** SarahCare table and column, e.g. `ACFIScores.AppraisalType` */
  column: Scalars['String']['output'];
  /** The original value as text; null when SarahCare held no value */
  value?: Maybe<Scalars['String']['output']>;
};

export type AcknowledgeReferralInput = {
  referralId: Scalars['ID']['input'];
};

export type AcmaRegistration = {
  __typename?: 'AcmaRegistration';
  abn?: Maybe<Scalars['String']['output']>;
  contactEmail?: Maybe<Scalars['String']['output']>;
  contactFirstName?: Maybe<Scalars['String']['output']>;
  contactLastName?: Maybe<Scalars['String']['output']>;
  contactPhone?: Maybe<Scalars['String']['output']>;
  contactPosition?: Maybe<Scalars['String']['output']>;
  organisationName?: Maybe<Scalars['String']['output']>;
  registeredAddress?: Maybe<TenantAddress>;
  registeredAt?: Maybe<Scalars['DateTime']['output']>;
  senderId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<AcmaRegistrationStatus>;
  submittedAt?: Maybe<Scalars['DateTime']['output']>;
  website?: Maybe<Scalars['String']['output']>;
};

export type AcmaRegistrationInput = {
  abn?: InputMaybe<Scalars['String']['input']>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactFirstName?: InputMaybe<Scalars['String']['input']>;
  contactLastName?: InputMaybe<Scalars['String']['input']>;
  contactPhone?: InputMaybe<Scalars['String']['input']>;
  contactPosition?: InputMaybe<Scalars['String']['input']>;
  organisationName?: InputMaybe<Scalars['String']['input']>;
  registeredAddress?: InputMaybe<TenantAddressInput>;
  registeredAt?: InputMaybe<Scalars['DateTime']['input']>;
  senderId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<AcmaRegistrationStatus>;
  submittedAt?: InputMaybe<Scalars['DateTime']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

/** ACMA Sender ID registration status */
export enum AcmaRegistrationStatus {
  DetailsCollected = 'DETAILS_COLLECTED',
  NotStarted = 'NOT_STARTED',
  Registered = 'REGISTERED',
  SubmittedToProvider = 'SUBMITTED_TO_PROVIDER'
}

export type ActionFilterInput = {
  dueBefore?: InputMaybe<Scalars['DateTime']['input']>;
  goalId?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<ActionStatus>;
};

/** Status of a goal action item */
export enum ActionStatus {
  Archived = 'ARCHIVED',
  Backlog = 'BACKLOG',
  Blocked = 'BLOCKED',
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS',
  Pending = 'PENDING'
}

/** A unit-type option with value + display label (filtered to active). */
export type ActiveUnitOption = {
  __typename?: 'ActiveUnitOption';
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type ActivitiesProfile = {
  __typename?: 'ActivitiesProfile';
  groupActivities?: Maybe<Array<Scalars['String']['output']>>;
  interests?: Maybe<Array<Scalars['String']['output']>>;
  leisureNotes?: Maybe<Scalars['String']['output']>;
  limitationsOrPrecautions?: Maybe<Array<Scalars['String']['output']>>;
  oneOnOnePreferences?: Maybe<Array<Scalars['String']['output']>>;
};

export type ActivitiesProfileInput = {
  groupActivities?: InputMaybe<Array<Scalars['String']['input']>>;
  interests?: InputMaybe<Array<Scalars['String']['input']>>;
  leisureNotes?: InputMaybe<Scalars['String']['input']>;
  limitationsOrPrecautions?: InputMaybe<Array<Scalars['String']['input']>>;
  oneOnOnePreferences?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ActivitiesUpdateInput = {
  activityLimitations?: InputMaybe<Scalars['String']['input']>;
  groupActivities?: InputMaybe<Array<Scalars['String']['input']>>;
  interests?: InputMaybe<Array<Scalars['String']['input']>>;
  notes?: InputMaybe<Scalars['String']['input']>;
  oneOnOneActivities?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type AddAllergyInput = {
  allergen: Scalars['String']['input'];
  discoveredDate?: InputMaybe<Scalars['DateTime']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  reactionSeverity?: InputMaybe<AllergySeverity>;
  reactionType?: InputMaybe<Scalars['String']['input']>;
  reportedBy?: InputMaybe<Scalars['String']['input']>;
  residentId: Scalars['ID']['input'];
};

export type AddAwardVersionInput = {
  awardId: Scalars['String']['input'];
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['DateTime']['input'];
  version: Scalars['String']['input'];
};

export type AddBankingCashEntryInput = {
  accountId: Scalars['ID']['input'];
  amountMinor: Scalars['Int']['input'];
  counterpartyClientId?: InputMaybe<Scalars['ID']['input']>;
  day: Scalars['String']['input'];
  description: Scalars['String']['input'];
  direction: BankingDirection;
  note?: InputMaybe<Scalars['String']['input']>;
  shape?: InputMaybe<BankingIncomeShape>;
};

export type AddBankingTransactionCommentInput = {
  body: Scalars['String']['input'];
  files?: InputMaybe<Array<BankingFileInput>>;
  transactionId: Scalars['ID']['input'];
};

export type AddCiActivityNoteInput = {
  action?: InputMaybe<Scalars['String']['input']>;
  attachments?: InputMaybe<Array<CiMediaAttachmentSimpleInput>>;
  documents?: InputMaybe<Array<CiDocumentAttachmentSimpleInput>>;
  note: Scalars['String']['input'];
};

export type AddCiAgendaItemInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  linkedItemId?: InputMaybe<Scalars['ID']['input']>;
  linkedItemType?: InputMaybe<CiMeetingNoteLinkedItemType>;
  topic: Scalars['String']['input'];
};

export type AddCiMeetingNoteInput = {
  attachments?: InputMaybe<Array<CiMeetingNoteMediaInput>>;
  documents?: InputMaybe<Array<CiMeetingNoteDocumentInput>>;
  linkedItemId?: InputMaybe<Scalars['ID']['input']>;
  linkedItemType: CiMeetingNoteLinkedItemType;
  noteText: Scalars['String']['input'];
};

export type AddChecklistItemInput = {
  text: Scalars['String']['input'];
};

export type AddEmployeeActivityCommentInput = {
  attachments?: InputMaybe<Array<EmployeeActivityAttachmentInput>>;
  body: Scalars['String']['input'];
  employeeId: Scalars['String']['input'];
  subjectId: Scalars['String']['input'];
  subjectType: EmployeeActivityCommentSubject;
};

export type AddEmployeeChecklistItemInput = {
  checklistId: Scalars['String']['input'];
  label: Scalars['String']['input'];
};

export type AddEmpowermentOneOffQuestionInput = {
  answerType: EmpowermentAnswerType;
  checkInId: Scalars['ID']['input'];
  managerText?: InputMaybe<Scalars['String']['input']>;
  selfText: Scalars['String']['input'];
};

export type AddFeedbackNoteInput = {
  attachments?: InputMaybe<Array<FeedbackMediaInput>>;
  details: Scalars['String']['input'];
  feedbackId: Scalars['ID']['input'];
};

export type AddGovActivityCommentInput = {
  activityId: Scalars['ID']['input'];
  attachments?: InputMaybe<Array<GovFileInput>>;
  body?: InputMaybe<Scalars['String']['input']>;
  fileId?: InputMaybe<Scalars['String']['input']>;
  mentions?: InputMaybe<Array<GovMentionInput>>;
};

export type AddGovActivityNoteInput = {
  attachments?: InputMaybe<Array<GovFileInput>>;
  body: Scalars['String']['input'];
  mentions?: InputMaybe<Array<GovMentionInput>>;
  organisationId: Scalars['ID']['input'];
};

export type AddGovChecklistItemInput = {
  checklistId: Scalars['ID']['input'];
  label: Scalars['String']['input'];
  order?: InputMaybe<Scalars['Int']['input']>;
};

export type AddInvestorDocumentInput = {
  fileUrl: Scalars['String']['input'];
  name: Scalars['String']['input'];
  type: InvestorDocumentType;
};

export type AddInvestorNoteInput = {
  content: Scalars['String']['input'];
  type?: InputMaybe<InvestorNoteType>;
};

export type AddJobChecklistItemInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Float']['input']>;
  text: Scalars['String']['input'];
};

export type AddJobMediaInput = {
  mechanicPhone?: InputMaybe<Scalars['String']['input']>;
  media: JobMediaInput;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type AddJobProgressNoteInput = {
  action: Scalars['String']['input'];
  activityType?: InputMaybe<JobActivityType>;
  attachments?: InputMaybe<Array<JobMediaInput>>;
  details?: InputMaybe<Scalars['String']['input']>;
  financialAmount?: InputMaybe<Scalars['Float']['input']>;
  financialCategory?: InputMaybe<Scalars['String']['input']>;
  isFinancialActivity?: InputMaybe<Scalars['Boolean']['input']>;
  mechanicPhone?: InputMaybe<Scalars['String']['input']>;
};

export type AddMaintenanceActivityNoteInput = {
  attachments?: InputMaybe<Array<MaintenanceActivityAttachmentInput>>;
  details: Scalars['String']['input'];
  requestId: Scalars['ID']['input'];
};

export type AddMonthlyRoomCheckProgressNoteInput = {
  action: Scalars['String']['input'];
  attachments?: InputMaybe<Array<MaintenanceMediaInput>>;
  details?: InputMaybe<Scalars['String']['input']>;
};

export type AddOpportunityProgressNoteInput = {
  action: Scalars['String']['input'];
  attachments?: InputMaybe<Array<ProgressNoteAttachmentInput>>;
  details?: InputMaybe<Scalars['String']['input']>;
  newValue?: InputMaybe<Scalars['String']['input']>;
  previousValue?: InputMaybe<Scalars['String']['input']>;
};

export type AddPolicyNoteInput = {
  details?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export type AddProgressNoteInput = {
  action: Scalars['String']['input'];
  attachments?: InputMaybe<Array<MaintenanceMediaInput>>;
  details?: InputMaybe<Scalars['String']['input']>;
};

export type AddProjectDocumentInput = {
  fileUrl: Scalars['String']['input'];
  isConfidential?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  type: ProjectDocumentType;
};

export type AddProjectTeamMemberInput = {
  bio?: InputMaybe<Scalars['String']['input']>;
  clientId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  photoUrl?: InputMaybe<Scalars['String']['input']>;
  role: Scalars['String']['input'];
};

export type AddSovereigntyAdjustmentInput = {
  amountCents: Scalars['Int']['input'];
  journeyId: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
  sourceReference: Scalars['String']['input'];
};

export type AddSovereigntyStepInput = {
  category: Scalars['String']['input'];
  clientVisible?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  evidenceReference?: InputMaybe<Scalars['String']['input']>;
  journeyId: Scalars['ID']['input'];
  status: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type AddStageNoteInput = {
  dealId: Scalars['ID']['input'];
  text: Scalars['String']['input'];
};

export type AddStagePhotosInput = {
  dealId: Scalars['ID']['input'];
  photos: Array<BuildUpdateFileInput>;
};

export type AddVideosInput = {
  sourceId: Scalars['ID']['input'];
  urls: Array<Scalars['String']['input']>;
};

export type AddWaitingListChecklistItemInput = {
  text: Scalars['String']['input'];
};

export type AddWaitingListNoteInput = {
  text: Scalars['String']['input'];
};

export type AddWitnessInput = {
  statement?: InputMaybe<Scalars['String']['input']>;
  statementDate?: InputMaybe<Scalars['DateTime']['input']>;
  witnessContact?: InputMaybe<Scalars['String']['input']>;
  witnessName: Scalars['String']['input'];
  witnessType: WitnessType;
};

export type AddressPartsPreview = {
  __typename?: 'AddressPartsPreview';
  postcode?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  streetNumber?: Maybe<Scalars['String']['output']>;
  suburb?: Maybe<Scalars['String']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
};

export type AddressSplitResult = {
  __typename?: 'AddressSplitResult';
  applied: Scalars['Int']['output'];
  skipped: Scalars['Int']['output'];
};

export type AddressSplitRow = {
  __typename?: 'AddressSplitRow';
  address: Scalars['String']['output'];
  clientName?: Maybe<Scalars['String']['output']>;
  dealId: Scalars['ID']['output'];
  dealNumber: Scalars['String']['output'];
  parts?: Maybe<AddressPartsPreview>;
  reason?: Maybe<Scalars['String']['output']>;
  verdict: Scalars['String']['output'];
};

export type AdjustLeaveBalanceInput = {
  /** Positive = add, negative = subtract */
  deltaAccruedHours: Scalars['Float']['input'];
  employeeId: Scalars['ID']['input'];
  leaveType: Scalars['String']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type AdminAddCompetitionEntryInput = {
  ageBand: CompetitionAgeBand;
  competitionId: Scalars['ID']['input'];
  contact?: InputMaybe<CompetitionEntrantContactInput>;
  enteredForName: Scalars['String']['input'];
  entrantClientId?: InputMaybe<Scalars['ID']['input']>;
  followCompetition?: InputMaybe<Scalars['Boolean']['input']>;
  guardianConsent: Scalars['Boolean']['input'];
  imageCid: Scalars['String']['input'];
  notifyEntrant?: InputMaybe<Scalars['Boolean']['input']>;
  printConsent?: InputMaybe<Scalars['Boolean']['input']>;
  schoolId?: InputMaybe<Scalars['ID']['input']>;
  sessionId?: InputMaybe<Scalars['ID']['input']>;
  statement?: InputMaybe<Scalars['String']['input']>;
  thumbnailCid?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export type AdminAddCompetitionEntryResult = {
  __typename?: 'AdminAddCompetitionEntryResult';
  entrantCreated: Scalars['Boolean']['output'];
  entrantMatchedExisting: Scalars['Boolean']['output'];
  entry: CompetitionEntry;
  notification?: Maybe<CompetitionNotificationReport>;
};

export type AdminBusinessListingInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  /** Every category; the first is the primary unless `category` says otherwise. */
  categories?: InputMaybe<Array<Scalars['String']['input']>>;
  category?: InputMaybe<Scalars['String']['input']>;
  contactName?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  logoCid?: InputMaybe<Scalars['String']['input']>;
  /** YYYY-MM-DD (or an ISO date-time, read as its Brisbane date). Null clears. */
  memberSince?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  openingHours?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  productsAndServices?: InputMaybe<Scalars['String']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  socialLinks?: InputMaybe<Array<BusinessSocialLinkInput>>;
  sourceUrl?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  suburb?: InputMaybe<Scalars['String']['input']>;
  tagline?: InputMaybe<Scalars['String']['input']>;
  websiteUrl?: InputMaybe<Scalars['String']['input']>;
  whatWeOffer?: InputMaybe<Scalars['String']['input']>;
};

export type AdminResetPasswordInput = {
  newPassword: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  sendSms?: InputMaybe<Scalars['Boolean']['input']>;
  userId: Scalars['String']['input'];
};

export type AdministerPrnInput = {
  administeredDate: Scalars['DateTime']['input'];
  administeredTime: Scalars['String']['input'];
  checkTime?: InputMaybe<Scalars['String']['input']>;
  createProgressNote?: InputMaybe<Scalars['Boolean']['input']>;
  dosageGiven: Scalars['String']['input'];
  indication: Scalars['String']['input'];
  medicationId: Scalars['ID']['input'];
  requestedBy?: InputMaybe<Scalars['String']['input']>;
  residentId: Scalars['ID']['input'];
  scheduleEffectivenessCheck?: InputMaybe<Scalars['Boolean']['input']>;
  severity?: InputMaybe<Scalars['Float']['input']>;
  severityDescription?: InputMaybe<Scalars['String']['input']>;
  witnessedBy?: InputMaybe<Scalars['ID']['input']>;
  witnessedByName?: InputMaybe<Scalars['String']['input']>;
};

export type AdministrationComplianceEntry = {
  __typename?: 'AdministrationComplianceEntry';
  complianceRate: Scalars['Float']['output'];
  givenCount: Scalars['Float']['output'];
  medicationId: Scalars['ID']['output'];
  medicationName: Scalars['String']['output'];
  missedCount: Scalars['Float']['output'];
  refusedCount: Scalars['Float']['output'];
  scheduledCount: Scalars['Float']['output'];
  withheldCount: Scalars['Float']['output'];
};

export type AdministrationComplianceReport = {
  __typename?: 'AdministrationComplianceReport';
  endDate: Scalars['DateTime']['output'];
  entries: Array<AdministrationComplianceEntry>;
  generatedAt: Scalars['DateTime']['output'];
  overallComplianceRate: Scalars['Float']['output'];
  startDate: Scalars['DateTime']['output'];
  totalGiven: Scalars['Float']['output'];
  totalScheduled: Scalars['Float']['output'];
};

export type AdministrationFilterInput = {
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  limit?: InputMaybe<Scalars['Float']['input']>;
  medicationId?: InputMaybe<Scalars['ID']['input']>;
  offset?: InputMaybe<Scalars['Float']['input']>;
  residentId?: InputMaybe<Scalars['ID']['input']>;
  roundId?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<AdministrationStatus>;
};

export type AdministrationHistoryResponse = {
  __typename?: 'AdministrationHistoryResponse';
  administrations: Array<MedicationAdministration>;
  total: Scalars['Float']['output'];
};

/** Route of medication administration */
export enum AdministrationRoute {
  Enteral = 'ENTERAL',
  Inhaled = 'INHALED',
  Intramuscular = 'INTRAMUSCULAR',
  Intravenous = 'INTRAVENOUS',
  Nasal = 'NASAL',
  Optic = 'OPTIC',
  Oral = 'ORAL',
  Otic = 'OTIC',
  Rectal = 'RECTAL',
  Subcutaneous = 'SUBCUTANEOUS',
  Sublingual = 'SUBLINGUAL',
  Topical = 'TOPICAL',
  Transdermal = 'TRANSDERMAL'
}

/** Status of a medication administration */
export enum AdministrationStatus {
  Given = 'GIVEN',
  Missed = 'MISSED',
  NotRequired = 'NOT_REQUIRED',
  Refused = 'REFUSED',
  Scheduled = 'SCHEDULED',
  Withheld = 'WITHHELD'
}

export type AdmissionChecklist = {
  __typename?: 'AdmissionChecklist';
  /** Set when every task has been completed */
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  /** Day of admission today is, 1-based, in the facility timezone (Brisbane). */
  dayOffset: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  /** Resident this checklist belongs to */
  residentId: Scalars['ID']['output'];
  /** Anchor date for dueDay computation — usually the resident.admissionDate at the time of seeding */
  startedAt: Scalars['DateTime']['output'];
  tasks: Array<ChecklistTask>;
  /** Template this checklist was seeded from (if any) */
  templateId?: Maybe<Scalars['ID']['output']>;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type AdmissionChecklistTemplate = {
  __typename?: 'AdmissionChecklistTemplate';
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** When true, admitResident uses this template by default */
  isDefault: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  tasks: Array<ChecklistTemplateTask>;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type AdmissionDischargeStats = {
  __typename?: 'AdmissionDischargeStats';
  admissions: Scalars['Int']['output'];
  deaths: Scalars['Int']['output'];
  discharges: Scalars['Int']['output'];
};

/** How to resolve the notification recipient(s) */
export enum AdmissionNotificationRecipientType {
  AllManagers = 'ALL_MANAGERS',
  Role = 'ROLE',
  SpecificEmployee = 'SPECIFIC_EMPLOYEE'
}

export type AdmissionNotificationRule = {
  __typename?: 'AdmissionNotificationRule';
  channels: Array<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  filterEntryType?: Maybe<EntryType>;
  filterInquirySource?: Maybe<Scalars['String']['output']>;
  filterPriority?: Maybe<WaitingListPriority>;
  fireCount: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  isEnabled: Scalars['Boolean']['output'];
  lastFiredAt?: Maybe<Scalars['DateTime']['output']>;
  messageTemplate?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  recipientIds?: Maybe<Array<Scalars['String']['output']>>;
  recipientRole?: Maybe<Scalars['String']['output']>;
  recipientType: AdmissionNotificationRecipientType;
  scope?: Maybe<AdmissionNotificationScope>;
  tenantId: Scalars['String']['output'];
  triggers: Array<AdmissionNotificationTrigger>;
  updatedAt: Scalars['DateTime']['output'];
};

/** Which module's notification page a rule belongs to — Waitlist (enquiry events) or Admissions (resident events) */
export enum AdmissionNotificationScope {
  Admissions = 'ADMISSIONS',
  Waitlist = 'WAITLIST'
}

/** Event that can trigger an admissions notification */
export enum AdmissionNotificationTrigger {
  AcatApprovalExpiryApproaching = 'ACAT_APPROVAL_EXPIRY_APPROACHING',
  ChecklistOverdueDigest = 'CHECKLIST_OVERDUE_DIGEST',
  InquiryCreated = 'INQUIRY_CREATED',
  InquiryPriorityChanged = 'INQUIRY_PRIORITY_CHANGED',
  LeaveReturnOverdue = 'LEAVE_RETURN_OVERDUE',
  LeaveStarted = 'LEAVE_STARTED',
  ResidentAdmitted = 'RESIDENT_ADMITTED',
  ResidentDischarged = 'RESIDENT_DISCHARGED',
  ResidentTransferred = 'RESIDENT_TRANSFERRED',
  SuitabilityApproved = 'SUITABILITY_APPROVED',
  SuitabilityDeclined = 'SUITABILITY_DECLINED'
}

export type AdmissionResult = {
  __typename?: 'AdmissionResult';
  message?: Maybe<Scalars['String']['output']>;
  resident?: Maybe<Resident>;
  success: Scalars['Boolean']['output'];
};

export type AdmissionsSettings = {
  __typename?: 'AdmissionsSettings';
  /** Responsible admin person given to every public-form inquiry (login id) */
  defaultResponsibleAdminId?: Maybe<Scalars['ID']['output']>;
  defaultResponsibleAdminName?: Maybe<Scalars['String']['output']>;
  /** Responsible clinical person given to every public-form inquiry (login id) */
  defaultResponsibleClinicalId?: Maybe<Scalars['ID']['output']>;
  defaultResponsibleClinicalName?: Maybe<Scalars['String']['output']>;
  /** Send waitlist messages to families (staff still press Send each time). Default OFF. */
  familyMessagesEnabled: Scalars['Boolean']['output'];
  /** Accept enquiries from the public form (/enquiry). Default OFF — a manager switches it on. */
  publicEnquiryFormEnabled: Scalars['Boolean']['output'];
  /** Where tours happen — printed in the tour details sent to a family (Katie, 15 Oct 2026) */
  tourAddress?: Maybe<Scalars['String']['output']>;
  /** The number a family calls about a tour — printed in the tour details */
  tourPhone?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedByName?: Maybe<Scalars['String']['output']>;
};

export type AdmissionsStatistics = {
  __typename?: 'AdmissionsStatistics';
  demographics: DemographicStats;
  financial: FinancialSummary;
  lengthOfStay: LengthOfStayStats;
  occupancy: OccupancyStats;
};

export type AdmitResidentInput = {
  admissionDate: Scalars['DateTime']['input'];
  bedNumber?: InputMaybe<Scalars['String']['input']>;
  careType?: InputMaybe<CareType>;
  entryType: EntryType;
  notes?: InputMaybe<Scalars['String']['input']>;
  /** For respite entries - expected departure date */
  respiteDueOutDate?: InputMaybe<Scalars['DateTime']['input']>;
  roomId?: InputMaybe<Scalars['ID']['input']>;
  roomNumber?: InputMaybe<Scalars['String']['input']>;
  wing?: InputMaybe<Scalars['String']['input']>;
};

export type AdpCsvExportResult = {
  __typename?: 'AdpCsvExportResult';
  /** CSV body (RFC 4180). Hand to FE Blob download. */
  csv: Scalars['String']['output'];
  filename: Scalars['String']['output'];
  format: AdpCsvFormat;
  rowCount: Scalars['Int']['output'];
  /** Sum of amount column — sanity check */
  totalAmount: Scalars['Float']['output'];
};

/** Row granularity for the ADP CSV export */
export enum AdpCsvFormat {
  Detailed = 'DETAILED',
  Summary = 'SUMMARY'
}

export type AdpFormStatus = {
  __typename?: 'AdpFormStatus';
  employeeName: Scalars['String']['output'];
  /** The employment category that WILL be printed — shown so it can be checked before download. */
  employmentCategory?: Maybe<Scalars['String']['output']>;
  /** ADP's own template version, which rides the generated filename. */
  formVersion: Scalars['String']['output'];
  isComplete: Scalars['Boolean']['output'];
  missing: Array<AdpMissingFieldType>;
  paymentType?: Maybe<Scalars['String']['output']>;
};

export type AdpMissingFieldType = {
  __typename?: 'AdpMissingFieldType';
  label: Scalars['String']['output'];
  /** Which tab on the employee page holds this field. */
  where: Scalars['String']['output'];
};

/** Where the advance care directive is up to */
export enum AdvanceCareDirectiveStatus {
  DiscussedNoneWanted = 'DISCUSSED_NONE_WANTED',
  Documented = 'DOCUMENTED',
  InProgress = 'IN_PROGRESS',
  NotDiscussed = 'NOT_DISCUSSED'
}

export type AdvanceCareLinkedPlan = {
  __typename?: 'AdvanceCareLinkedPlan';
  category: Scalars['String']['output'];
  detailUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  planName: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type AdvanceCarePlan = {
  __typename?: 'AdvanceCarePlan';
  createdAt: Scalars['DateTime']['output'];
  directiveDate?: Maybe<Scalars['DateTime']['output']>;
  directiveLocation?: Maybe<Scalars['String']['output']>;
  directiveStatus: AdvanceCareDirectiveStatus;
  discussedWith: Array<CarePlanParticipant>;
  endOfLifeWishes?: Maybe<Scalars['String']['output']>;
  history: Array<AdvanceCarePlanHistoryEntry>;
  id: Scalars['ID']['output'];
  lastReviewedAt?: Maybe<Scalars['DateTime']['output']>;
  lastReviewedByName?: Maybe<Scalars['String']['output']>;
  linkedCarePlanIds: Array<Scalars['ID']['output']>;
  linkedCarePlans: Array<AdvanceCareLinkedPlan>;
  nextReviewDate?: Maybe<Scalars['DateTime']['output']>;
  preferredPlaceOfCare?: Maybe<Scalars['String']['output']>;
  residentId: Scalars['ID']['output'];
  /** The resident's name, for headings */
  residentName: Scalars['String']['output'];
  resuscitationDate?: Maybe<Scalars['DateTime']['output']>;
  resuscitationDetails?: Maybe<Scalars['String']['output']>;
  resuscitationDocumentedBy?: Maybe<Scalars['String']['output']>;
  resuscitationWish: ResuscitationWish;
  spiritualAndCulturalWishes?: Maybe<Scalars['String']['output']>;
  substituteDecisionMakerContactIds: Array<Scalars['ID']['output']>;
  substituteDecisionMakerNote?: Maybe<Scalars['String']['output']>;
  /** Decision-makers, read live from admissions contacts */
  substituteDecisionMakers: Array<CarePlanPersonOption>;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type AdvanceCarePlanHistoryEntry = {
  __typename?: 'AdvanceCarePlanHistoryEntry';
  changedAt: Scalars['DateTime']['output'];
  changedByName?: Maybe<Scalars['String']['output']>;
  summary: Scalars['String']['output'];
};

export type AdvisoryBody = {
  __typename?: 'AdvisoryBody';
  /** Hex colour for the chart card border + chip tint. */
  color?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  memberClientIds: Array<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type AgentBoard = {
  __typename?: 'AgentBoard';
  jobs: Array<AgentJob>;
  olderReviewedCount: Scalars['Int']['output'];
  reviewedDays: Scalars['Int']['output'];
  runners: Array<AgentRunnerStatus>;
};

export type AgentBoardEvent = {
  __typename?: 'AgentBoardEvent';
  at: Scalars['DateTime']['output'];
  kind: AgentBoardEventKind;
};

/** What changed on the Agent Board. */
export enum AgentBoardEventKind {
  Reported = 'REPORTED',
  Reviewed = 'REVIEWED'
}

export type AgentJob = {
  __typename?: 'AgentJob';
  createdAt: Scalars['DateTime']['output'];
  externalId: Scalars['String']['output'];
  finishedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  lane: AgentJobLane;
  queuePosition?: Maybe<Scalars['Int']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  result?: Maybe<Scalars['String']['output']>;
  reviewedAt?: Maybe<Scalars['DateTime']['output']>;
  reviewedByName?: Maybe<Scalars['String']['output']>;
  source: Scalars['String']['output'];
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  state: AgentJobState;
  submittedAt: Scalars['DateTime']['output'];
  tenantId: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** Which slot an agent job runs in. */
export enum AgentJobLane {
  Main = 'MAIN',
  Parallel = 'PARALLEL',
  Push = 'PUSH',
  Quick = 'QUICK'
}

export type AgentJobReportInput = {
  externalId: Scalars['String']['input'];
  finishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  lane: AgentJobLane;
  queuePosition?: InputMaybe<Scalars['Int']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  result?: InputMaybe<Scalars['String']['input']>;
  startedAt?: InputMaybe<Scalars['DateTime']['input']>;
  state: AgentJobState;
  submittedAt: Scalars['DateTime']['input'];
  title: Scalars['String']['input'];
};

/** Where an agent job is in its life. */
export enum AgentJobState {
  Cancelled = 'CANCELLED',
  Done = 'DONE',
  Failed = 'FAILED',
  Queued = 'QUEUED',
  Running = 'RUNNING'
}

export type AgentRunnerReportInput = {
  jobTimeoutMinutes?: InputMaybe<Scalars['Int']['input']>;
  jobs: Array<AgentJobReportInput>;
  label: Scalars['String']['input'];
  mainBusy: Scalars['Boolean']['input'];
  parallelBusy: Scalars['Int']['input'];
  parallelMax: Scalars['Int']['input'];
  queuedCount: Scalars['Int']['input'];
  quickBusy: Scalars['Int']['input'];
  quickMax: Scalars['Int']['input'];
  runnerStartedAt?: InputMaybe<Scalars['DateTime']['input']>;
  source: Scalars['String']['input'];
};

export type AgentRunnerStatus = {
  __typename?: 'AgentRunnerStatus';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  jobTimeoutMinutes?: Maybe<Scalars['Int']['output']>;
  label: Scalars['String']['output'];
  mainBusy: Scalars['Boolean']['output'];
  parallelBusy: Scalars['Int']['output'];
  parallelMax: Scalars['Int']['output'];
  queuedCount: Scalars['Int']['output'];
  quickBusy: Scalars['Int']['output'];
  quickMax: Scalars['Int']['output'];
  reportedAt: Scalars['DateTime']['output'];
  runnerStartedAt?: Maybe<Scalars['DateTime']['output']>;
  source: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** Type of supply chain agent (REA model) */
export enum AgentType {
  Government = 'GOVERNMENT',
  Refinery = 'REFINERY',
  ShippingCompany = 'SHIPPING_COMPANY',
  StationOperator = 'STATION_OPERATOR',
  Terminal = 'TERMINAL'
}

export type AggregatedIngredient = {
  __typename?: 'AggregatedIngredient';
  estimatedCost?: Maybe<Scalars['Float']['output']>;
  ingredientId: Scalars['ID']['output'];
  ingredientName: Scalars['String']['output'];
  mealPlanCount?: Maybe<Scalars['Float']['output']>;
  sources: Array<AggregatedIngredientSource>;
  supplierId?: Maybe<Scalars['ID']['output']>;
  supplierName?: Maybe<Scalars['String']['output']>;
  totalQuantity: Scalars['Float']['output'];
  unit: UnitType;
  unitCost?: Maybe<Scalars['Float']['output']>;
};

export type AggregatedIngredientSource = {
  __typename?: 'AggregatedIngredientSource';
  convertedQuantity?: Maybe<Scalars['Float']['output']>;
  destinationUnit: UnitType;
  lineCost?: Maybe<Scalars['Float']['output']>;
  mealDate: Scalars['DateTime']['output'];
  mealPlanId: Scalars['ID']['output'];
  mealServings: Scalars['Float']['output'];
  mealType: Scalars['String']['output'];
  mismatch: Scalars['Boolean']['output'];
  rawQuantity: Scalars['Float']['output'];
  rawUnit: UnitType;
  recipeBaseServings: Scalars['Float']['output'];
  recipeId: Scalars['ID']['output'];
  recipeName: Scalars['String']['output'];
  scaledQuantity: Scalars['Float']['output'];
};

/** Tom-recorded decision on an AI audit line variance */
export enum AiAuditDecision {
  AcceptedAi = 'ACCEPTED_AI',
  AcceptedPlatform = 'ACCEPTED_PLATFORM',
  Investigating = 'INVESTIGATING',
  Pending = 'PENDING'
}

/** Scope of an AI Pay Audit run */
export enum AiAuditScope {
  SingleDay = 'SINGLE_DAY',
  SingleLine = 'SINGLE_LINE',
  WholeRun = 'WHOLE_RUN'
}

export type AiOpsCancelResult = {
  __typename?: 'AiOpsCancelResult';
  detail: Scalars['String']['output'];
  ok: Scalars['Boolean']['output'];
};

export type AiOpsCapacity = {
  __typename?: 'AiOpsCapacity';
  atCapacity: Scalars['Boolean']['output'];
  instances: Array<AiOpsInstanceCapacity>;
  sampledAt: Scalars['String']['output'];
  totalBusy: Scalars['Int']['output'];
  totalSlots: Scalars['Int']['output'];
  totalWaiting: Scalars['Int']['output'];
  voiceLease?: Maybe<AiOpsVoiceLeaseInfo>;
};

export type AiOpsCapturePolicyInput = {
  capture: Scalars['Boolean']['input'];
  keyAlias: Scalars['String']['input'];
};

export enum AiOpsCaptureState {
  Default = 'DEFAULT',
  Off = 'OFF',
  On = 'ON',
  Unknown = 'UNKNOWN'
}

export type AiOpsHardwareSample = {
  __typename?: 'AiOpsHardwareSample';
  cpuPct?: Maybe<Scalars['Float']['output']>;
  diskFreeGb?: Maybe<Scalars['Float']['output']>;
  gpuPct?: Maybe<Scalars['Float']['output']>;
  instances?: Maybe<Scalars['JSON']['output']>;
  kind: Scalars['String']['output'];
  memFreePct?: Maybe<Scalars['Float']['output']>;
  memUsedGb?: Maybe<Scalars['Float']['output']>;
  memWiredGb?: Maybe<Scalars['Float']['output']>;
  periodStart?: Maybe<Scalars['DateTime']['output']>;
  swapUsedMb?: Maybe<Scalars['Float']['output']>;
  thermalWarning?: Maybe<Scalars['Boolean']['output']>;
  ts: Scalars['DateTime']['output'];
};

export type AiOpsHiddenCounts = {
  __typename?: 'AiOpsHiddenCounts';
  listings: Scalars['Int']['output'];
  probes: Scalars['Int']['output'];
  unauthenticated: Scalars['Int']['output'];
};

export type AiOpsInstanceCapacity = {
  __typename?: 'AiOpsInstanceCapacity';
  activeMemoryGb?: Maybe<Scalars['Float']['output']>;
  cacheEntries?: Maybe<Scalars['Int']['output']>;
  cacheEvictions?: Maybe<Scalars['Int']['output']>;
  cacheHitRate?: Maybe<Scalars['Float']['output']>;
  cacheMaxGb?: Maybe<Scalars['Float']['output']>;
  cacheUsedGb?: Maybe<Scalars['Float']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  generating: Scalars['Int']['output'];
  generationTps?: Maybe<Scalars['Float']['output']>;
  model: Scalars['String']['output'];
  openCallers?: Maybe<Array<AiOpsOpenCall>>;
  peakMemoryGb?: Maybe<Scalars['Float']['output']>;
  port: Scalars['Int']['output'];
  prefilling: Scalars['Int']['output'];
  promptTps?: Maybe<Scalars['Float']['output']>;
  reachable: Scalars['Boolean']['output'];
  requests: Array<AiOpsLiveRequest>;
  role: Scalars['String']['output'];
  running: Scalars['Int']['output'];
  slots: Scalars['Int']['output'];
  status?: Maybe<Scalars['String']['output']>;
  totalRequests?: Maybe<Scalars['Int']['output']>;
  uptimeS?: Maybe<Scalars['Float']['output']>;
  waiting: Scalars['Int']['output'];
};

export type AiOpsKeyActionResult = {
  __typename?: 'AiOpsKeyActionResult';
  keyAlias?: Maybe<Scalars['String']['output']>;
  /** Set when the action succeeded but left something for a person to do. */
  warning?: Maybe<Scalars['String']['output']>;
};

export type AiOpsKeyEvent = {
  __typename?: 'AiOpsKeyEvent';
  action: Scalars['String']['output'];
  actorClientId?: Maybe<Scalars['String']['output']>;
  actorName?: Maybe<Scalars['String']['output']>;
  at: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  detail?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  keyAlias?: Maybe<Scalars['String']['output']>;
  keyIdShort?: Maybe<Scalars['String']['output']>;
  outcome: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type AiOpsKeyEventList = {
  __typename?: 'AiOpsKeyEventList';
  hasMore: Scalars['Boolean']['output'];
  items: Array<AiOpsKeyEvent>;
  totalCount: Scalars['Int']['output'];
};

export type AiOpsKeyEventListInput = {
  /** MINT | PAUSE | RESUME | EDIT | REPLACE | DELETE | CONCURRENCY | CAPTURE */
  action?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** CONFIRMED | FAILED */
  outcome?: InputMaybe<Scalars['String']['input']>;
  /** Matches the key alias, who acted, what changed, or the error. */
  search?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<AiOpsKeyEventSortField>;
  sortOrder?: InputMaybe<AiOpsSortOrder>;
};

export type AiOpsKeyEventPage = {
  __typename?: 'AiOpsKeyEventPage';
  events: Array<AiOpsKeyEvent>;
  /** All events ever recorded — the page shows the latest `events.length` of these. */
  total: Scalars['Int']['output'];
};

export enum AiOpsKeyEventSortField {
  Action = 'ACTION',
  At = 'AT',
  Key = 'KEY',
  Outcome = 'OUTCOME',
  Who = 'WHO'
}

export type AiOpsKeyList = {
  __typename?: 'AiOpsKeyList';
  hasMore: Scalars['Boolean']['output'];
  items: Array<AiOpsVirtualKey>;
  /** Keys matching the search and filter — the page holds `items.length` of them. */
  totalCount: Scalars['Int']['output'];
};

export type AiOpsKeyListInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Matches the alias, an allowed model, or the last characters of the key id. */
  search?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<AiOpsKeySortField>;
  sortOrder?: InputMaybe<AiOpsSortOrder>;
  status?: InputMaybe<AiOpsKeyStatus>;
};

export type AiOpsKeyMintResult = {
  __typename?: 'AiOpsKeyMintResult';
  key: Scalars['String']['output'];
  keyAlias: Scalars['String']['output'];
  /** Replace only: set when the old key is stopped but its deletion was not confirmed. */
  warning?: Maybe<Scalars['String']['output']>;
};

export type AiOpsKeySettingsInput = {
  /** 1d | 7d | 1mo. LiteLLM cannot remove a reset period once set. */
  budgetDuration?: InputMaybe<Scalars['String']['input']>;
  /** ISO timestamp. Null = never expires. */
  expiresAt?: InputMaybe<Scalars['String']['input']>;
  /** US$. Null clears the budget. */
  maxBudget?: InputMaybe<Scalars['Float']['input']>;
  maxParallelRequests?: InputMaybe<Scalars['Int']['input']>;
  models?: InputMaybe<Array<Scalars['String']['input']>>;
  rpmLimit?: InputMaybe<Scalars['Int']['input']>;
  tpmLimit?: InputMaybe<Scalars['Int']['input']>;
};

export enum AiOpsKeySortField {
  Alias = 'ALIAS',
  Budget = 'BUDGET',
  Created = 'CREATED',
  LastUsed = 'LAST_USED',
  Spend = 'SPEND',
  Status = 'STATUS'
}

export enum AiOpsKeyStatus {
  Active = 'ACTIVE',
  Expired = 'EXPIRED',
  Paused = 'PAUSED'
}

export type AiOpsLive = {
  __typename?: 'AiOpsLive';
  mongo: Scalars['Boolean']['output'];
  openCalls: Scalars['Int']['output'];
  rows: Array<AiOpsUsageRecord>;
  sampledAt: Scalars['String']['output'];
  source: Scalars['String']['output'];
  windowSec: Scalars['Int']['output'];
};

export type AiOpsLiveRequest = {
  __typename?: 'AiOpsLiveRequest';
  cacheHitType?: Maybe<Scalars['String']['output']>;
  cachedTokens?: Maybe<Scalars['Int']['output']>;
  callId?: Maybe<Scalars['String']['output']>;
  caller?: Maybe<Scalars['String']['output']>;
  callerMatch?: Maybe<Scalars['String']['output']>;
  completionTokens?: Maybe<Scalars['Int']['output']>;
  elapsedS?: Maybe<Scalars['Float']['output']>;
  maxTokens?: Maybe<Scalars['Int']['output']>;
  phase?: Maybe<Scalars['String']['output']>;
  progress?: Maybe<Scalars['Float']['output']>;
  promptTokens?: Maybe<Scalars['Int']['output']>;
  requestId: Scalars['String']['output'];
  status?: Maybe<Scalars['String']['output']>;
  tokensPerSecond?: Maybe<Scalars['Float']['output']>;
  ttftS?: Maybe<Scalars['Float']['output']>;
};

export type AiOpsMintKeyInput = {
  /** 1d | 7d | 1mo. Absent = the budget never resets. */
  budgetDuration?: InputMaybe<Scalars['String']['input']>;
  /** ISO timestamp. Absent = never expires. */
  expiresAt?: InputMaybe<Scalars['String']['input']>;
  keyAlias: Scalars['String']['input'];
  maxBudget?: InputMaybe<Scalars['Float']['input']>;
  maxParallelRequests?: InputMaybe<Scalars['Int']['input']>;
  models?: InputMaybe<Array<Scalars['String']['input']>>;
  rpmLimit?: InputMaybe<Scalars['Int']['input']>;
  tpmLimit?: InputMaybe<Scalars['Int']['input']>;
};

export type AiOpsModelRun = {
  __typename?: 'AiOpsModelRun';
  avgLatencyMs?: Maybe<Scalars['Float']['output']>;
  completionTokens: Scalars['Int']['output'];
  durationSec: Scalars['Float']['output'];
  endedAt: Scalars['DateTime']['output'];
  failures: Scalars['Int']['output'];
  keyAlias: Scalars['String']['output'];
  model: Scalars['String']['output'];
  peakPromptTokens: Scalars['Int']['output'];
  promptTokens: Scalars['Int']['output'];
  requests: Scalars['Int']['output'];
  runId: Scalars['String']['output'];
  startedAt: Scalars['DateTime']['output'];
  tokensPerSec?: Maybe<Scalars['Float']['output']>;
  totalTokens: Scalars['Int']['output'];
};

export type AiOpsOpenCall = {
  __typename?: 'AiOpsOpenCall';
  callId: Scalars['String']['output'];
  caller: Scalars['String']['output'];
  startedAt: Scalars['String']['output'];
  stream: Scalars['Boolean']['output'];
};

export type AiOpsServedModel = {
  __typename?: 'AiOpsServedModel';
  id: Scalars['String']['output'];
  /** Nominal US$ per million input tokens. */
  inputUsdPerMillion?: Maybe<Scalars['Float']['output']>;
  maxInputTokens?: Maybe<Scalars['Int']['output']>;
  /** Nominal US$ per million output tokens. */
  outputUsdPerMillion?: Maybe<Scalars['Float']['output']>;
};

export type AiOpsServiceStatus = {
  __typename?: 'AiOpsServiceStatus';
  buffered: Scalars['Int']['output'];
  contents: Scalars['Int']['output'];
  mongo: Scalars['Boolean']['output'];
  ok: Scalars['Boolean']['output'];
  openCalls?: Maybe<Scalars['Int']['output']>;
};

export type AiOpsSession = {
  __typename?: 'AiOpsSession';
  command?: Maybe<Scalars['String']['output']>;
  detail?: Maybe<Scalars['JSON']['output']>;
  outcome?: Maybe<Scalars['String']['output']>;
  phases?: Maybe<Scalars['JSON']['output']>;
  scoutCount?: Maybe<Scalars['Int']['output']>;
  scoutModel?: Maybe<Scalars['String']['output']>;
  source: Scalars['String']['output'];
  totalSec?: Maybe<Scalars['Float']['output']>;
  ts: Scalars['DateTime']['output'];
};

export type AiOpsSessionContent = {
  __typename?: 'AiOpsSessionContent';
  request?: Maybe<Scalars['JSON']['output']>;
  response?: Maybe<Scalars['JSON']['output']>;
};

export enum AiOpsSortOrder {
  Asc = 'ASC',
  Desc = 'DESC'
}

export enum AiOpsStartedByKind {
  NotRecorded = 'NOT_RECORDED',
  User = 'USER',
  Visitor = 'VISITOR'
}

export type AiOpsUsageBucket = {
  __typename?: 'AiOpsUsageBucket';
  avgLatencyMs?: Maybe<Scalars['Float']['output']>;
  completionTokens: Scalars['Int']['output'];
  key: Scalars['String']['output'];
  promptTokens: Scalars['Int']['output'];
  requests: Scalars['Int']['output'];
  totalTokens: Scalars['Int']['output'];
};

export type AiOpsUsageRecord = {
  __typename?: 'AiOpsUsageRecord';
  authKind?: Maybe<Scalars['String']['output']>;
  cachedTokens?: Maybe<Scalars['Int']['output']>;
  callType?: Maybe<Scalars['String']['output']>;
  caller?: Maybe<Scalars['String']['output']>;
  completionTokens: Scalars['Int']['output'];
  contentRef?: Maybe<Scalars['String']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  finishReason?: Maybe<Scalars['String']['output']>;
  firstTokenMs?: Maybe<Scalars['Float']['output']>;
  keyAlias?: Maybe<Scalars['String']['output']>;
  keyHashShort?: Maybe<Scalars['String']['output']>;
  kind?: Maybe<Scalars['String']['output']>;
  latencyMs?: Maybe<Scalars['Float']['output']>;
  model: Scalars['String']['output'];
  promptTokens: Scalars['Int']['output'];
  requesterIp?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  timingSource?: Maybe<Scalars['String']['output']>;
  totalTokens: Scalars['Int']['output'];
  ts: Scalars['DateTime']['output'];
  userId?: Maybe<Scalars['String']['output']>;
};

export type AiOpsVirtualKey = {
  __typename?: 'AiOpsVirtualKey';
  /** true = paused: the holder's next request gets 401 'Key is blocked'. */
  blocked?: Maybe<Scalars['Boolean']['output']>;
  /** LiteLLM budget reset period (1d, 7d, 1mo). Null = the budget never resets. */
  budgetDuration?: Maybe<Scalars['String']['output']>;
  budgetResetAt?: Maybe<Scalars['String']['output']>;
  captureState: AiOpsCaptureState;
  createdAt?: Maybe<Scalars['String']['output']>;
  expires?: Maybe<Scalars['String']['output']>;
  keyAlias?: Maybe<Scalars['String']['output']>;
  /** Newest request AI Ops recorded for this key in the last 90 days. Null = none in that window. */
  lastUsed?: Maybe<Scalars['String']['output']>;
  maxBudget?: Maybe<Scalars['Float']['output']>;
  maxParallelRequests?: Maybe<Scalars['Int']['output']>;
  models?: Maybe<Array<Scalars['String']['output']>>;
  /** Models this key allows that the Mac Studio no longer serves. */
  retiredModels: Array<Scalars['String']['output']>;
  rpmLimit?: Maybe<Scalars['Int']['output']>;
  /** US$ at the nominal per-token rates in the LiteLLM config — a budget meter, not an invoice. */
  spend?: Maybe<Scalars['Float']['output']>;
  token?: Maybe<Scalars['String']['output']>;
  tpmLimit?: Maybe<Scalars['Int']['output']>;
};

export type AiOpsVoiceCall = {
  __typename?: 'AiOpsVoiceCall';
  agentKey?: Maybe<Scalars['String']['output']>;
  durationSec?: Maybe<Scalars['Int']['output']>;
  /** ended | expired | replaced; null while the call is live. */
  endReason?: Maybe<Scalars['String']['output']>;
  endedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Requests from other callers refused while this call held the Studio. */
  held: Scalars['Int']['output'];
  leaseId: Scalars['String']['output'];
  live: Scalars['Boolean']['output'];
  siteName?: Maybe<Scalars['String']['output']>;
  startedAt: Scalars['DateTime']['output'];
  startedByClientId?: Maybe<Scalars['String']['output']>;
  /** USER | VISITOR | NOT_RECORDED (calls before 2026-09-17) */
  startedByKind: Scalars['String']['output'];
  startedByName?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  turns: Scalars['Int']['output'];
};

export type AiOpsVoiceCallList = {
  __typename?: 'AiOpsVoiceCallList';
  hasMore: Scalars['Boolean']['output'];
  items: Array<AiOpsVoiceCall>;
  totalCount: Scalars['Int']['output'];
  window: AiOpsWindow;
};

export type AiOpsVoiceCallListInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Matches who started the call, the agent, or the site's name or domain. */
  search?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<AiOpsVoiceCallSortField>;
  sortOrder?: InputMaybe<AiOpsSortOrder>;
  startedByKind?: InputMaybe<AiOpsStartedByKind>;
  window?: InputMaybe<AiOpsWindow>;
};

export type AiOpsVoiceCallPage = {
  __typename?: 'AiOpsVoiceCallPage';
  calls: Array<AiOpsVoiceCall>;
  /** Calls in the window — the page shows the latest `calls.length` of these. */
  total: Scalars['Int']['output'];
  window: AiOpsWindow;
};

export enum AiOpsVoiceCallSortField {
  Held = 'HELD',
  Length = 'LENGTH',
  Started = 'STARTED',
  StartedBy = 'STARTED_BY',
  Turns = 'TURNS'
}

export type AiOpsVoiceDay = {
  __typename?: 'AiOpsVoiceDay';
  calls: Scalars['Int']['output'];
  /** Brisbane calendar day, YYYY-MM-DD */
  day: Scalars['String']['output'];
  /** Requests from other callers refused while a voice call ran that day. */
  held: Scalars['Int']['output'];
  minutes: Scalars['Float']['output'];
  turns: Scalars['Int']['output'];
};

export type AiOpsVoiceHeldCaller = {
  __typename?: 'AiOpsVoiceHeldCaller';
  caller: Scalars['String']['output'];
  held: Scalars['Int']['output'];
};

export type AiOpsVoiceLeaseInfo = {
  __typename?: 'AiOpsVoiceLeaseInfo';
  active: Scalars['Boolean']['output'];
  agentKey?: Maybe<Scalars['String']['output']>;
  elapsedSec?: Maybe<Scalars['Int']['output']>;
  /** Requests refused so far because this call holds the Studio. */
  held?: Maybe<Scalars['Int']['output']>;
  leaseId?: Maybe<Scalars['String']['output']>;
  sessionId?: Maybe<Scalars['String']['output']>;
  startedAt?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  turns?: Maybe<Scalars['Int']['output']>;
};

export type AiOpsVoiceStats = {
  __typename?: 'AiOpsVoiceStats';
  calls: Scalars['Int']['output'];
  days: Array<AiOpsVoiceDay>;
  generatedAt: Scalars['String']['output'];
  held: Scalars['Int']['output'];
  heldByCaller: Array<AiOpsVoiceHeldCaller>;
  minutes: Scalars['Float']['output'];
  turns: Scalars['Int']['output'];
  window: AiOpsWindow;
};

export enum AiOpsWindow {
  Day = 'DAY',
  Month = 'MONTH',
  Week = 'WEEK'
}

export type AiPayAudit = {
  __typename?: 'AiPayAudit';
  /** IPFS CID for the emailed PDF report (M2.B) */
  auditReportPdfCid?: Maybe<Scalars['String']['output']>;
  /** Cost in AUD */
  costAud: Scalars['Float']['output'];
  createdAt: Scalars['DateTime']['output'];
  emailedAt?: Maybe<Scalars['DateTime']['output']>;
  emailedTo?: Maybe<Scalars['String']['output']>;
  /** Required for SINGLE_LINE / SINGLE_DAY scopes */
  employeeId?: Maybe<Scalars['ID']['output']>;
  /** Free-text error if Anthropic returned an unparseable response */
  errorMessage?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  inputTokens: Scalars['Int']['output'];
  /** Latency in milliseconds */
  latencyMs: Scalars['Int']['output'];
  /** Comparison rows per employee in scope */
  linesAudited: Array<AiPayAuditLine>;
  linesOutsideTolerance: Scalars['Int']['output'];
  linesWithinTolerance: Scalars['Int']['output'];
  /** Largest |variancePct| across all lines */
  maxVariancePct: Scalars['Float']['output'];
  modelName: Scalars['String']['output'];
  outputTokens: Scalars['Int']['output'];
  payRunId: Scalars['ID']['output'];
  /** SHA-256 of the prompt for audit replay */
  promptHash: Scalars['String']['output'];
  runAt: Scalars['DateTime']['output'];
  /** Client.id who initiated the audit (Tom in 99% of cases) */
  runBy: Scalars['ID']['output'];
  scope: AiAuditScope;
  /** Required for SINGLE_DAY scope (UTC midnight) */
  shiftDate?: Maybe<Scalars['DateTime']['output']>;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type AiPayAuditLine = {
  __typename?: 'AiPayAuditLine';
  aiGrossGross: Scalars['Float']['output'];
  aiHoursOrdinary: Scalars['Float']['output'];
  aiHoursTotal: Scalars['Float']['output'];
  aiNetPay: Scalars['Float']['output'];
  /** Claude reasoning (truncated to ~2000 chars for display) */
  aiReasoning: Scalars['String']['output'];
  aiSuperGuarantee: Scalars['Float']['output'];
  employeeId: Scalars['ID']['output'];
  employeeNameSnapshot: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** The PayRunLine._id being audited */
  payRunLineId: Scalars['ID']['output'];
  platformGrossGross: Scalars['Float']['output'];
  platformHoursOrdinary: Scalars['Float']['output'];
  platformHoursTotal: Scalars['Float']['output'];
  platformNetPay: Scalars['Float']['output'];
  platformSuperGuarantee: Scalars['Float']['output'];
  tomDecision: AiAuditDecision;
  tomDecisionAt?: Maybe<Scalars['DateTime']['output']>;
  tomDecisionNote?: Maybe<Scalars['String']['output']>;
  /** AI gross minus platform gross (positive = AI says more) */
  varianceAbs: Scalars['Float']['output'];
  /** Variance as % of platform gross (signed) */
  variancePct: Scalars['Float']['output'];
  /** True if |variancePct| <= PaySettings.aiAuditTolerancePct */
  withinTolerance: Scalars['Boolean']['output'];
};

export type AiRoute = {
  __typename?: 'AiRoute';
  directAvailable: Scalars['Boolean']['output'];
  host: Scalars['String']['output'];
  route: Scalars['String']['output'];
};

export type AiUsageClientBreakdown = {
  __typename?: 'AiUsageClientBreakdown';
  callCount: Scalars['Int']['output'];
  clientId: Scalars['String']['output'];
  clientName: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  tenantName: Scalars['String']['output'];
  totalCostCents: Scalars['Float']['output'];
  totalInputTokens: Scalars['Int']['output'];
  totalOutputTokens: Scalars['Int']['output'];
};

export type AiUsageFilter = {
  clientId?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  module?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
};

export type AiUsageLog = {
  __typename?: 'AiUsageLog';
  conversationId?: Maybe<Scalars['String']['output']>;
  costCents: Scalars['Float']['output'];
  createdAt: Scalars['DateTime']['output'];
  errorMessage?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  inputTokens: Scalars['Int']['output'];
  latencyMs: Scalars['Int']['output'];
  model: Scalars['String']['output'];
  module: Scalars['String']['output'];
  operation?: Maybe<Scalars['String']['output']>;
  outputTokens: Scalars['Int']['output'];
  success: Scalars['Boolean']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  userId?: Maybe<Scalars['String']['output']>;
};

export type AiUsageModuleBreakdown = {
  __typename?: 'AiUsageModuleBreakdown';
  callCount: Scalars['Int']['output'];
  module: Scalars['String']['output'];
  totalCostCents: Scalars['Float']['output'];
  totalInputTokens: Scalars['Int']['output'];
  totalOutputTokens: Scalars['Int']['output'];
};

export type AiUsageOverall = {
  __typename?: 'AiUsageOverall';
  avgLatencyMs: Scalars['Float']['output'];
  totalCalls: Scalars['Int']['output'];
  totalCostCents: Scalars['Float']['output'];
  totalInputTokens: Scalars['Int']['output'];
  totalOutputTokens: Scalars['Int']['output'];
};

export type AiUsageStats = {
  __typename?: 'AiUsageStats';
  byClient: Array<AiUsageClientBreakdown>;
  byModule: Array<AiUsageModuleBreakdown>;
  byTenant: Array<AiUsageTenantBreakdown>;
  overall: AiUsageOverall;
};

export type AiUsageTenantBreakdown = {
  __typename?: 'AiUsageTenantBreakdown';
  callCount: Scalars['Int']['output'];
  tenantId: Scalars['String']['output'];
  tenantName: Scalars['String']['output'];
  totalCostCents: Scalars['Float']['output'];
  totalInputTokens: Scalars['Int']['output'];
  totalOutputTokens: Scalars['Int']['output'];
};

export type AlertConfigInput = {
  bslHigh?: InputMaybe<Scalars['Float']['input']>;
  bslLow?: InputMaybe<Scalars['Float']['input']>;
  diastolicHigh?: InputMaybe<Scalars['Int']['input']>;
  diastolicLow?: InputMaybe<Scalars['Int']['input']>;
  o2SaturationMin?: InputMaybe<Scalars['Float']['input']>;
  observationType: ObservationType;
  systolicHigh?: InputMaybe<Scalars['Int']['input']>;
  systolicLow?: InputMaybe<Scalars['Int']['input']>;
  temperatureRanges?: InputMaybe<Array<TemperatureRangeConfigInput>>;
  weightChangeThreshold?: InputMaybe<Scalars['Float']['input']>;
};

export type AlertCountByType = {
  __typename?: 'AlertCountByType';
  alertType: IncidentAlertType;
  count: Scalars['Int']['output'];
};

export type AlertFilterInput = {
  alertTypes?: InputMaybe<Array<IncidentAlertType>>;
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  incidentId?: InputMaybe<Scalars['ID']['input']>;
  isRead?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  residentId?: InputMaybe<Scalars['ID']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type AlertsResponse = {
  __typename?: 'AlertsResponse';
  alerts: Array<IncidentAlert>;
  total: Scalars['Int']['output'];
  unreadCount: Scalars['Int']['output'];
};

export type AlertsSummary = {
  __typename?: 'AlertsSummary';
  byType: Array<AlertCountByType>;
  total: Scalars['Int']['output'];
  unread: Scalars['Int']['output'];
};

/** Severity of an allergy reaction */
export enum AllergySeverity {
  LifeThreatening = 'LIFE_THREATENING',
  Mild = 'MILD',
  Moderate = 'MODERATE',
  Severe = 'SEVERE'
}

export type AllowanceEntry = {
  __typename?: 'AllowanceEntry';
  amount: Scalars['Float']['output'];
  description: Scalars['String']['output'];
  rate: Scalars['Float']['output'];
  units: Scalars['Float']['output'];
};

export type AllowanceEntryInput = {
  amount: Scalars['Float']['input'];
  description: Scalars['String']['input'];
  rate: Scalars['Float']['input'];
  units: Scalars['Float']['input'];
};

/** STP Phase 2 allowance type code */
export enum AllowanceTypeCode {
  Ad = 'AD',
  Cd = 'CD',
  Kn = 'KN',
  Ld = 'LD',
  Md = 'MD',
  Od = 'OD',
  Qn = 'QN',
  Td = 'TD'
}

export type AnaccClassification = {
  __typename?: 'AnaccClassification';
  /** Claim months (YYYY-MM) this class appeared in; CLAIM source only */
  claimMonths: Array<Scalars['String']['output']>;
  /** AN-ACC class exactly as recorded, e.g. "7" or "101" */
  classification: Scalars['String']['output'];
  /** RESIDENT_RECORD or CLAIM (see entity notes) */
  classificationSource: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  /** Empty when SarahCare had not recorded an end */
  endDate?: Maybe<Scalars['DateTime']['output']>;
  /** Funding type on the claim, e.g. AN-ACC */
  fundingType?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Always true: SarahCare history, read-only */
  isHistoricalRecord: Scalars['Boolean']['output'];
  recordedBy?: Maybe<Scalars['ID']['output']>;
  recordedByName?: Maybe<Scalars['String']['output']>;
  residentId: Scalars['ID']['output'];
  residentName?: Maybe<Scalars['String']['output']>;
  residentRoom?: Maybe<Scalars['String']['output']>;
  residentWing?: Maybe<Scalars['String']['output']>;
  reviewCompleted?: Maybe<Scalars['Boolean']['output']>;
  reviewCompletedDate?: Maybe<Scalars['DateTime']['output']>;
  reviewRequested?: Maybe<Scalars['Boolean']['output']>;
  reviewRequestedDate?: Maybe<Scalars['DateTime']['output']>;
  sourceAuthor?: Maybe<Scalars['String']['output']>;
  sourceBackupDate?: Maybe<Scalars['DateTime']['output']>;
  sourceFields?: Maybe<Array<AcfiSarahSourceField>>;
  sourceId?: Maybe<Scalars['String']['output']>;
  sourceSystem?: Maybe<Scalars['String']['output']>;
  startDate: Scalars['DateTime']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type AnaccClassificationFilterInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  residentId?: InputMaybe<Scalars['ID']['input']>;
};

export type AnaccClassificationsResponse = {
  __typename?: 'AnaccClassificationsResponse';
  items: Array<AnaccClassification>;
  limit: Scalars['Int']['output'];
  offset: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type AnalyticsEvent = {
  __typename?: 'AnalyticsEvent';
  browser?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deviceType?: Maybe<Scalars['String']['output']>;
  eventName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  label?: Maybe<Scalars['String']['output']>;
  metadata?: Maybe<Scalars['String']['output']>;
  pagePath: Scalars['String']['output'];
  pageTitle?: Maybe<Scalars['String']['output']>;
  sessionId: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  timestamp: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  userId?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
  visitorId: Scalars['String']['output'];
};

export type AnalyticsFilters = {
  browser?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  dateRange?: InputMaybe<DateRange>;
  deviceType?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  pagePath?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  trafficSource?: InputMaybe<Scalars['String']['input']>;
};

/** How to resolve the notification recipient(s) */
export enum AnalyticsNotificationRecipientType {
  AllAnalyticsAdmins = 'ALL_ANALYTICS_ADMINS',
  ClientTag = 'CLIENT_TAG',
  SpecificClient = 'SPECIFIC_CLIENT',
  SpecificEmployee = 'SPECIFIC_EMPLOYEE'
}

export type AnalyticsNotificationRule = {
  __typename?: 'AnalyticsNotificationRule';
  channels: Array<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  isEnabled: Scalars['Boolean']['output'];
  messageTemplate?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  recipientIds?: Maybe<Array<Scalars['String']['output']>>;
  recipientTag?: Maybe<Scalars['String']['output']>;
  recipientType: AnalyticsNotificationRecipientType;
  tenantId: Scalars['String']['output'];
  thresholdPath?: Maybe<Scalars['String']['output']>;
  thresholdValue?: Maybe<Scalars['Float']['output']>;
  timing: AnalyticsNotificationTiming;
  timingMinutes?: Maybe<Scalars['Float']['output']>;
  trigger: AnalyticsNotificationTrigger;
  updatedAt: Scalars['DateTime']['output'];
};

/** When to send the notification relative to the trigger */
export enum AnalyticsNotificationTiming {
  Immediate = 'IMMEDIATE',
  MinutesAfter = 'MINUTES_AFTER'
}

/** Event that triggers the analytics notification. ALL_EVENTS is a special value that matches any fired trigger. */
export enum AnalyticsNotificationTrigger {
  AllEvents = 'ALL_EVENTS',
  BounceRateAlert = 'BOUNCE_RATE_ALERT',
  ConversionMilestone = 'CONVERSION_MILESTONE',
  DailyDigest = 'DAILY_DIGEST',
  NewTrafficSource = 'NEW_TRAFFIC_SOURCE',
  PerformanceAlert = 'PERFORMANCE_ALERT',
  SessionMilestone = 'SESSION_MILESTONE',
  TrafficSpike = 'TRAFFIC_SPIKE',
  WeeklyDigest = 'WEEKLY_DIGEST'
}

export type AnalyticsOverview = {
  __typename?: 'AnalyticsOverview';
  avgPagesPerSession: Scalars['Float']['output'];
  avgSessionDuration: Scalars['Float']['output'];
  bounceRate: Scalars['Float']['output'];
  bounceRateChange?: Maybe<Scalars['Float']['output']>;
  pageViewsChange?: Maybe<Scalars['Float']['output']>;
  totalEvents: Scalars['Int']['output'];
  totalPageViews: Scalars['Int']['output'];
  totalSessions: Scalars['Int']['output'];
  uniqueVisitors: Scalars['Int']['output'];
  visitorsChange?: Maybe<Scalars['Float']['output']>;
};

export type AnalyticsSession = {
  __typename?: 'AnalyticsSession';
  avgScrollDepth?: Maybe<Scalars['Float']['output']>;
  browser?: Maybe<Scalars['String']['output']>;
  conversionGoal?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deviceType?: Maybe<Scalars['String']['output']>;
  duration: Scalars['Int']['output'];
  endedAt?: Maybe<Scalars['DateTime']['output']>;
  eventCount: Scalars['Int']['output'];
  exitPage?: Maybe<Scalars['String']['output']>;
  hasBounced: Scalars['Boolean']['output'];
  hasConverted: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  landingPage: Scalars['String']['output'];
  os?: Maybe<Scalars['String']['output']>;
  pageViewCount: Scalars['Int']['output'];
  referrer?: Maybe<Scalars['String']['output']>;
  referrerDomain?: Maybe<Scalars['String']['output']>;
  sessionId: Scalars['String']['output'];
  startedAt: Scalars['DateTime']['output'];
  tenantId: Scalars['String']['output'];
  trafficSource?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  userId?: Maybe<Scalars['String']['output']>;
  utmCampaign?: Maybe<Scalars['String']['output']>;
  utmMedium?: Maybe<Scalars['String']['output']>;
  utmSource?: Maybe<Scalars['String']['output']>;
  visitorId: Scalars['String']['output'];
};

export type AnnounceOpenShiftResult = {
  __typename?: 'AnnounceOpenShiftResult';
  allSent: Scalars['Boolean']['output'];
  failedCount: Scalars['Int']['output'];
  outcomes: Array<ShiftNotificationOutcome>;
  recipientCount: Scalars['Int']['output'];
  sentCount: Scalars['Int']['output'];
  skippedCount: Scalars['Int']['output'];
};

export type AnswerChecklistItemInput = {
  /** Named staff member allocated to this assessment */
  assignedToName?: InputMaybe<Scalars['String']['input']>;
  /** Record created off the back of this item (incident, note, referral) */
  linkedRecordId?: InputMaybe<Scalars['ID']['input']>;
  linkedRecordType?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  /** Yes / No / NA. Pass null to CLEAR the answer and return the item to unanswered. */
  outcome?: InputMaybe<ChecklistTaskOutcome>;
};

export type AnswerDigitalManagerOqInput = {
  answer: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};

export type AnswerEmailAiQuestionInput = {
  answer: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};

export type AnswerWaitingListConfirmationInput = {
  answer: WaitingListFamilyAnswer;
  details?: InputMaybe<Scalars['String']['input']>;
  token: Scalars['String']['input'];
};

export enum ApiAuthType {
  ApiKeyHeader = 'API_KEY_HEADER',
  ApiKeyQuery = 'API_KEY_QUERY',
  Basic = 'BASIC',
  Bearer = 'BEARER',
  None = 'NONE'
}

export type ApiCategory = {
  __typename?: 'ApiCategory';
  apiCount: Scalars['Float']['output'];
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Float']['output'];
  slug: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type ApiEndpoint = {
  __typename?: 'ApiEndpoint';
  apiListingId: Scalars['String']['output'];
  codeExamples?: Maybe<Array<CodeExample>>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  exampleResponse?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  method: HttpMethod;
  name: Scalars['String']['output'];
  order: Scalars['Float']['output'];
  parameters?: Maybe<Array<EndpointParam>>;
  path: Scalars['String']['output'];
  requestMapping?: Maybe<RequestMapping>;
  responseMapping?: Maybe<ResponseMapping>;
  responseSchema?: Maybe<Scalars['JSON']['output']>;
  slug: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** Response from an API Hub proxy call */
export type ApiHubResponse = {
  __typename?: 'ApiHubResponse';
  data?: Maybe<Scalars['JSON']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  quotaRemaining: Scalars['Float']['output'];
  rateLimitRemaining: Scalars['Float']['output'];
  requestId: Scalars['String']['output'];
  responseTime: Scalars['Float']['output'];
  statusCode: Scalars['Float']['output'];
  success: Scalars['Boolean']['output'];
};

export type ApiHubUsageStats = {
  __typename?: 'ApiHubUsageStats';
  avgResponseTime: Scalars['Float']['output'];
  failedRequests: Scalars['Float']['output'];
  successfulRequests: Scalars['Float']['output'];
  totalApis: Scalars['Float']['output'];
  totalRequests: Scalars['Float']['output'];
};

export type ApiKey = {
  __typename?: 'ApiKey';
  clientId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  environment: ApiKeyEnvironment;
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  ipWhitelist?: Maybe<Array<Scalars['String']['output']>>;
  keyPrefix: Scalars['String']['output'];
  lastUsedAt?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  status: ApiKeyStatus;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export enum ApiKeyEnvironment {
  Live = 'LIVE',
  Test = 'TEST'
}

export enum ApiKeyStatus {
  Active = 'ACTIVE',
  Expired = 'EXPIRED',
  Revoked = 'REVOKED'
}

export type ApiKeyWithSecret = {
  __typename?: 'ApiKeyWithSecret';
  createdAt: Scalars['DateTime']['output'];
  environment: ApiKeyEnvironment;
  id: Scalars['String']['output'];
  key: Scalars['String']['output'];
  keyPrefix: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type ApiListing = {
  __typename?: 'ApiListing';
  authHeaderName?: Maybe<Scalars['String']['output']>;
  authType: ApiAuthType;
  averageLatency: Scalars['Float']['output'];
  baseUrl: Scalars['String']['output'];
  categoryId?: Maybe<Scalars['String']['output']>;
  coverImage?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  defaultHeaders?: Maybe<Scalars['JSON']['output']>;
  description: Scalars['String']['output'];
  envFallbackKey?: Maybe<Scalars['String']['output']>;
  featured: Scalars['Boolean']['output'];
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Float']['output'];
  popularity: Scalars['Float']['output'];
  pricing?: Maybe<ApiPricing>;
  providerName: Scalars['String']['output'];
  providerType: ApiProviderType;
  providerUrl?: Maybe<Scalars['String']['output']>;
  rateLimits?: Maybe<ApiRateLimits>;
  shortDescription?: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  status: ApiListingStatus;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  tenantApiKeyField?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  uptime: Scalars['Float']['output'];
  version?: Maybe<Scalars['String']['output']>;
};

export enum ApiListingStatus {
  Deprecated = 'DEPRECATED',
  Draft = 'DRAFT',
  Published = 'PUBLISHED'
}

export type ApiPlanTier = {
  __typename?: 'ApiPlanTier';
  features?: Maybe<Array<Scalars['String']['output']>>;
  name: Scalars['String']['output'];
  price: Scalars['Float']['output'];
  quota: Scalars['Float']['output'];
};

export type ApiPricing = {
  __typename?: 'ApiPricing';
  freeQuota: Scalars['Float']['output'];
  model: ApiPricingModel;
  monthlyPlans?: Maybe<Array<ApiPlanTier>>;
  pricePerRequest: Scalars['Float']['output'];
};

export enum ApiPricingModel {
  Free = 'FREE',
  Freemium = 'FREEMIUM',
  Paid = 'PAID',
  UsageBased = 'USAGE_BASED'
}

export enum ApiProviderType {
  External = 'EXTERNAL',
  Internal = 'INTERNAL',
  TenantByo = 'TENANT_BYO'
}

export type ApiRateLimits = {
  __typename?: 'ApiRateLimits';
  freePerMinute: Scalars['Float']['output'];
  freePerMonth: Scalars['Float']['output'];
  paidPerMinute: Scalars['Float']['output'];
  paidPerMonth: Scalars['Float']['output'];
};

export type ApiSubscription = {
  __typename?: 'ApiSubscription';
  apiListingId: Scalars['String']['output'];
  clientId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  currentMonthUsage: Scalars['Float']['output'];
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  lastResetAt?: Maybe<Scalars['DateTime']['output']>;
  monthlyQuota: Scalars['Float']['output'];
  plan: Scalars['String']['output'];
  status: ApiSubscriptionStatus;
  stripeSubscriptionId?: Maybe<Scalars['String']['output']>;
  subscribedAt: Scalars['DateTime']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  userApiKey?: Maybe<Scalars['String']['output']>;
};

export enum ApiSubscriptionStatus {
  Active = 'ACTIVE',
  Cancelled = 'CANCELLED',
  Suspended = 'SUSPENDED',
  Trial = 'TRIAL'
}

export type ApiUsageLog = {
  __typename?: 'ApiUsageLog';
  apiEndpointId: Scalars['String']['output'];
  apiKeyId?: Maybe<Scalars['String']['output']>;
  apiListingId: Scalars['String']['output'];
  billedAmount: Scalars['Float']['output'];
  clientId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  errorMessage?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  ipAddress?: Maybe<Scalars['String']['output']>;
  isBillable: Scalars['Boolean']['output'];
  requestedAt: Scalars['DateTime']['output'];
  responseTime: Scalars['Float']['output'];
  statusCode: Scalars['Float']['output'];
  success: Scalars['Boolean']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type ApiUsageSummary = {
  __typename?: 'ApiUsageSummary';
  apiListingId: Scalars['String']['output'];
  avgResponseTime: Scalars['Float']['output'];
  clientId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  date: Scalars['DateTime']['output'];
  failedRequests: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  peakRpm: Scalars['Float']['output'];
  successfulRequests: Scalars['Float']['output'];
  tenantId: Scalars['String']['output'];
  totalBilledAmount: Scalars['Float']['output'];
  totalRequests: Scalars['Float']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type ApproveMedicalRecordAccessRequestInput = {
  accessLevel: MedicalAccessLevel;
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  requestId: Scalars['ID']['input'];
  scope: MedicalRecordAccessScope;
};

export type ApproveWithdrawalInput = {
  requestId: Scalars['String']['input'];
  transactionHash?: InputMaybe<Scalars['String']['input']>;
};

export type ArtSession = {
  __typename?: 'ArtSession';
  ageBands: Array<CompetitionAgeBand>;
  competitionId?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['DateTime']['output'];
  endsAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  isFree: Scalars['Boolean']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  preferredTimes?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  requestEmailOutcome?: Maybe<Scalars['String']['output']>;
  requesterEmail?: Maybe<Scalars['String']['output']>;
  requesterName?: Maybe<Scalars['String']['output']>;
  requesterPhone?: Maybe<Scalars['String']['output']>;
  schoolId?: Maybe<Scalars['ID']['output']>;
  schoolName?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  startsAt?: Maybe<Scalars['DateTime']['output']>;
  status: ArtSessionStatus;
  tenantId: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type ArtSessionChangeResult = {
  __typename?: 'ArtSessionChangeResult';
  calendar?: Maybe<CompetitionCalendarOutcome>;
  session: ArtSession;
};

export type ArtSessionInput = {
  ageBands?: InputMaybe<Array<CompetitionAgeBand>>;
  competitionId?: InputMaybe<Scalars['ID']['input']>;
  endsAt?: InputMaybe<Scalars['DateTime']['input']>;
  isFree?: InputMaybe<Scalars['Boolean']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  schoolId?: InputMaybe<Scalars['ID']['input']>;
  startsAt?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<ArtSessionStatus>;
  title: Scalars['String']['input'];
};

export type ArtSessionRequestResult = {
  __typename?: 'ArtSessionRequestResult';
  message: Scalars['String']['output'];
  ok: Scalars['Boolean']['output'];
};

/** Requested → Confirmed → Done / Cancelled */
export enum ArtSessionStatus {
  Cancelled = 'CANCELLED',
  Confirmed = 'CONFIRMED',
  Done = 'DONE',
  Requested = 'REQUESTED'
}

/** Content type for knowledge articles (HTML from WYSIWYG or raw Markdown) */
export enum ArticleContentType {
  Html = 'HTML',
  Markdown = 'MARKDOWN'
}

/** Visibility levels for knowledge articles */
export enum ArticleVisibility {
  AllLoggedIn = 'ALL_LOGGED_IN',
  Private = 'PRIVATE',
  Public = 'PUBLIC',
  Restricted = 'RESTRICTED'
}

export type Artifact = {
  __typename?: 'Artifact';
  assignedClientIds: Array<Scalars['String']['output']>;
  body?: Maybe<Scalars['String']['output']>;
  clientId?: Maybe<Scalars['String']['output']>;
  commentsEnabled: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdById?: Maybe<Scalars['String']['output']>;
  createdByName?: Maybe<Scalars['String']['output']>;
  currentVersion: Scalars['Float']['output'];
  description?: Maybe<Scalars['String']['output']>;
  emoji?: Maybe<Scalars['String']['output']>;
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  lastViewedAt?: Maybe<Scalars['DateTime']['output']>;
  shareToken?: Maybe<Scalars['String']['output']>;
  shareUrlToken?: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  tags: Array<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  viewCount: Scalars['Float']['output'];
  visibility: ArtifactVisibility;
};

export type ArtifactAnchor = {
  __typename?: 'ArtifactAnchor';
  diagramIndex?: Maybe<Scalars['Int']['output']>;
  headingSlug?: Maybe<Scalars['String']['output']>;
  kind: ArtifactAnchorKind;
  nodeId?: Maybe<Scalars['String']['output']>;
  nodeLabel?: Maybe<Scalars['String']['output']>;
  quotedText?: Maybe<Scalars['String']['output']>;
  selector?: Maybe<Scalars['String']['output']>;
  x?: Maybe<Scalars['Float']['output']>;
  y?: Maybe<Scalars['Float']['output']>;
};

export type ArtifactAnchorInput = {
  diagramIndex?: InputMaybe<Scalars['Int']['input']>;
  headingSlug?: InputMaybe<Scalars['String']['input']>;
  kind: ArtifactAnchorKind;
  nodeId?: InputMaybe<Scalars['String']['input']>;
  nodeLabel?: InputMaybe<Scalars['String']['input']>;
  quotedText?: InputMaybe<Scalars['String']['input']>;
  selector?: InputMaybe<Scalars['String']['input']>;
  x?: InputMaybe<Scalars['Float']['input']>;
  y?: InputMaybe<Scalars['Float']['input']>;
};

/** How an artifact comment is pinned to the document. */
export enum ArtifactAnchorKind {
  DiagramNode = 'DIAGRAM_NODE',
  General = 'GENERAL',
  Region = 'REGION',
  Text = 'TEXT'
}

export type ArtifactComment = {
  __typename?: 'ArtifactComment';
  anchor: ArtifactAnchor;
  artifactId: Scalars['String']['output'];
  authorClientId?: Maybe<Scalars['String']['output']>;
  authorEmail?: Maybe<Scalars['String']['output']>;
  authorName: Scalars['String']['output'];
  body: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  parentId?: Maybe<Scalars['String']['output']>;
  resolvedAt?: Maybe<Scalars['DateTime']['output']>;
  resolvedById?: Maybe<Scalars['String']['output']>;
  status: ArtifactCommentStatus;
  tenantId: Scalars['String']['output'];
  threadId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  versionAtComment: Scalars['Float']['output'];
};

/** Whether a comment thread is open or resolved. */
export enum ArtifactCommentStatus {
  Open = 'OPEN',
  Resolved = 'RESOLVED'
}

export type ArtifactFilterInput = {
  clientId?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  visibility?: InputMaybe<ArtifactVisibility>;
};

/** Storage format of an artifact version body. */
export enum ArtifactFormat {
  Html = 'HTML',
  Markdown = 'MARKDOWN'
}

export type ArtifactVersion = {
  __typename?: 'ArtifactVersion';
  artifactId: Scalars['String']['output'];
  body: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdById?: Maybe<Scalars['String']['output']>;
  createdByName?: Maybe<Scalars['String']['output']>;
  format: ArtifactFormat;
  id: Scalars['ID']['output'];
  label?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  version: Scalars['Float']['output'];
};

/** Who can view a published artifact (checked server-side). */
export enum ArtifactVisibility {
  Client = 'CLIENT',
  Private = 'PRIVATE',
  Public = 'PUBLIC',
  Unlisted = 'UNLISTED'
}

export type AssessmentCustomField = {
  __typename?: 'AssessmentCustomField';
  category?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  fieldType: FieldType;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  isRequired: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
  max?: Maybe<Scalars['Int']['output']>;
  min?: Maybe<Scalars['Int']['output']>;
  options?: Maybe<Array<Scalars['String']['output']>>;
  order: Scalars['Int']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type AssessmentDomain = {
  __typename?: 'AssessmentDomain';
  color?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  isDefault: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** Assessed falls risk level */
export enum AssessmentFallsRiskLevel {
  High = 'HIGH',
  Low = 'LOW',
  Moderate = 'MODERATE',
  VeryHigh = 'VERY_HIGH'
}

export type AssessmentMedicalData = {
  __typename?: 'AssessmentMedicalData';
  additionalComments?: Maybe<Scalars['String']['output']>;
  adlStatus?: Maybe<Scalars['String']['output']>;
  age?: Maybe<Scalars['String']['output']>;
  alcoholConsumption?: Maybe<Scalars['String']['output']>;
  allergiesReactions?: Maybe<Scalars['String']['output']>;
  anxietyScores?: Maybe<Scalars['String']['output']>;
  baselineFunction?: Maybe<Scalars['String']['output']>;
  bmi?: Maybe<Scalars['String']['output']>;
  bodyFat?: Maybe<Scalars['String']['output']>;
  dentalHistory?: Maybe<Scalars['String']['output']>;
  drivingStatus?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  gp?: Maybe<Scalars['String']['output']>;
  healthGoals?: Maybe<Scalars['String']['output']>;
  height?: Maybe<Scalars['String']['output']>;
  hospital?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  medications?: Maybe<Scalars['String']['output']>;
  occupation?: Maybe<Scalars['String']['output']>;
  otherHealthProfessionals?: Maybe<Scalars['String']['output']>;
  pastMedicalHistory?: Maybe<Array<Scalars['String']['output']>>;
  pastMedicalHistoryOther?: Maybe<Scalars['String']['output']>;
  pastPsychiatricHistory?: Maybe<Scalars['String']['output']>;
  pastSurgicalHistory?: Maybe<Scalars['String']['output']>;
  patientActivation?: Maybe<Scalars['String']['output']>;
  pleasurableActivities?: Maybe<Scalars['String']['output']>;
  smokingStatus?: Maybe<Scalars['String']['output']>;
  socialNeeds?: Maybe<Scalars['String']['output']>;
  supplementsAlternative?: Maybe<Scalars['String']['output']>;
  supportPersons?: Maybe<Scalars['String']['output']>;
  surgeon?: Maybe<Scalars['String']['output']>;
  surgeryDate?: Maybe<Scalars['String']['output']>;
  surgeryType?: Maybe<Scalars['String']['output']>;
  vaccinationStatus?: Maybe<Scalars['String']['output']>;
  vitalSigns?: Maybe<Scalars['String']['output']>;
  vo2Max?: Maybe<Scalars['String']['output']>;
  weight?: Maybe<Scalars['String']['output']>;
};

export type AssessmentMedicalDataInput = {
  additionalComments?: InputMaybe<Scalars['String']['input']>;
  adlStatus?: InputMaybe<Scalars['String']['input']>;
  age?: InputMaybe<Scalars['String']['input']>;
  alcoholConsumption?: InputMaybe<Scalars['String']['input']>;
  allergiesReactions?: InputMaybe<Scalars['String']['input']>;
  anxietyScores?: InputMaybe<Scalars['String']['input']>;
  baselineFunction?: InputMaybe<Scalars['String']['input']>;
  bmi?: InputMaybe<Scalars['String']['input']>;
  bodyFat?: InputMaybe<Scalars['String']['input']>;
  dentalHistory?: InputMaybe<Scalars['String']['input']>;
  drivingStatus?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  gp?: InputMaybe<Scalars['String']['input']>;
  healthGoals?: InputMaybe<Scalars['String']['input']>;
  height?: InputMaybe<Scalars['String']['input']>;
  hospital?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  medications?: InputMaybe<Scalars['String']['input']>;
  occupation?: InputMaybe<Scalars['String']['input']>;
  otherHealthProfessionals?: InputMaybe<Scalars['String']['input']>;
  pastMedicalHistory?: InputMaybe<Array<Scalars['String']['input']>>;
  pastMedicalHistoryOther?: InputMaybe<Scalars['String']['input']>;
  pastPsychiatricHistory?: InputMaybe<Scalars['String']['input']>;
  pastSurgicalHistory?: InputMaybe<Scalars['String']['input']>;
  patientActivation?: InputMaybe<Scalars['String']['input']>;
  pleasurableActivities?: InputMaybe<Scalars['String']['input']>;
  smokingStatus?: InputMaybe<Scalars['String']['input']>;
  socialNeeds?: InputMaybe<Scalars['String']['input']>;
  supplementsAlternative?: InputMaybe<Scalars['String']['input']>;
  supportPersons?: InputMaybe<Scalars['String']['input']>;
  surgeon?: InputMaybe<Scalars['String']['input']>;
  surgeryDate?: InputMaybe<Scalars['String']['input']>;
  surgeryType?: InputMaybe<Scalars['String']['input']>;
  vaccinationStatus?: InputMaybe<Scalars['String']['input']>;
  vitalSigns?: InputMaybe<Scalars['String']['input']>;
  vo2Max?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['String']['input']>;
};

/** Level of mobility independence */
export enum AssessmentMobilityLevel {
  Independent = 'INDEPENDENT',
  IndependentWithAid = 'INDEPENDENT_WITH_AID',
  MaximumAssist = 'MAXIMUM_ASSIST',
  MinimalAssist = 'MINIMAL_ASSIST',
  ModerateAssist = 'MODERATE_ASSIST',
  NotRecorded = 'NOT_RECORDED',
  Supervision = 'SUPERVISION',
  TotalCare = 'TOTAL_CARE'
}

/** How to resolve the assessment notification recipient(s) */
export enum AssessmentNotificationRecipientType {
  Admin = 'ADMIN',
  AllClients = 'ALL_CLIENTS',
  ClientTag = 'CLIENT_TAG',
  SpecificClient = 'SPECIFIC_CLIENT'
}

export type AssessmentNotificationRule = {
  __typename?: 'AssessmentNotificationRule';
  channels: Array<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  isEnabled: Scalars['Boolean']['output'];
  messageTemplate?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  recipientIds?: Maybe<Array<Scalars['String']['output']>>;
  recipientTag?: Maybe<Scalars['String']['output']>;
  recipientType: AssessmentNotificationRecipientType;
  tenantId: Scalars['String']['output'];
  timing: AssessmentNotificationTiming;
  timingMinutes?: Maybe<Scalars['Float']['output']>;
  trigger: AssessmentNotificationTrigger;
  updatedAt: Scalars['DateTime']['output'];
};

/** When to send the assessment notification relative to the trigger */
export enum AssessmentNotificationTiming {
  Immediate = 'IMMEDIATE',
  MinutesAfter = 'MINUTES_AFTER',
  MinutesBefore = 'MINUTES_BEFORE'
}

/** Event that triggers the assessment notification */
export enum AssessmentNotificationTrigger {
  AssessmentCompleted = 'ASSESSMENT_COMPLETED',
  AssessmentMilestone = 'ASSESSMENT_MILESTONE',
  AssessmentScoreDeclined = 'ASSESSMENT_SCORE_DECLINED',
  AssessmentScoreImproved = 'ASSESSMENT_SCORE_IMPROVED'
}

export type AssessmentRating = {
  __typename?: 'AssessmentRating';
  domainColor?: Maybe<Scalars['String']['output']>;
  domainId: Scalars['ID']['output'];
  domainName: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  rating: Scalars['Int']['output'];
};

export type AssessmentRatingInput = {
  domainColor?: InputMaybe<Scalars['String']['input']>;
  domainId: Scalars['ID']['input'];
  domainName: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  rating: Scalars['Int']['input'];
};

export type AssessmentSnapshot = {
  __typename?: 'AssessmentSnapshot';
  averageScore?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['DateTime']['output'];
  customFields?: Maybe<Array<CustomFieldResponse>>;
  id: Scalars['ID']['output'];
  medicalData?: Maybe<AssessmentMedicalData>;
  notes?: Maybe<Scalars['String']['output']>;
  ratings: Array<AssessmentRating>;
  status: AssessmentStatus;
  surgeryDate?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  userId: Scalars['ID']['output'];
};

export type AssessmentSnapshotFilterInput = {
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

/** Status of an assessment snapshot */
export enum AssessmentStatus {
  Archived = 'ARCHIVED',
  Completed = 'COMPLETED',
  Draft = 'DRAFT'
}

export type AssignCiIssueReportInput = {
  assignedTo: Scalars['ID']['input'];
};

export type AssignEmployeeInput = {
  departmentIds?: InputMaybe<Array<Scalars['String']['input']>>;
  employeeId: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  onLeave?: InputMaybe<AssignOnLeaveInput>;
  roleId?: InputMaybe<Scalars['String']['input']>;
  shiftId: Scalars['String']['input'];
};

export type AssignFeedbackInput = {
  assignedToId?: InputMaybe<Scalars['ID']['input']>;
  feedbackId: Scalars['ID']['input'];
};

export type AssignMaintenanceRequestInput = {
  assignedTo: Scalars['ID']['input'];
  estimatedCompletionDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AssignMechanicInput = {
  mechanicId?: InputMaybe<Scalars['ID']['input']>;
  mechanicName: Scalars['String']['input'];
  mechanicPhone: Scalars['String']['input'];
};

export type AssignOnLeaveInput = {
  endTime?: InputMaybe<Scalars['DateTime']['input']>;
  fullShift?: InputMaybe<Scalars['Boolean']['input']>;
  hours?: InputMaybe<Scalars['Float']['input']>;
  isPaidLeave?: InputMaybe<Scalars['Boolean']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  reason: AbsenceReason;
  startTime?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AssignSourcesInput = {
  attach?: InputMaybe<Scalars['Boolean']['input']>;
  baseId: Scalars['ID']['input'];
  sourceIds: Array<Scalars['ID']['input']>;
};

export type AssignedClientInfo = {
  __typename?: 'AssignedClientInfo';
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

/** Status of an employee's shift assignment */
export enum AssignmentStatus {
  Cancelled = 'CANCELLED',
  CheckedIn = 'CHECKED_IN',
  CheckedOut = 'CHECKED_OUT',
  Confirmed = 'CONFIRMED',
  Declined = 'DECLINED',
  NoShow = 'NO_SHOW',
  Pending = 'PENDING'
}

export type AttachDailyAllocationVersionInput = {
  date: Scalars['DateTime']['input'];
  fileName: Scalars['String']['input'];
  fileSize: Scalars['Int']['input'];
  ipfsCid: Scalars['String']['input'];
  mimeType: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
};

export type AttachGovFileInput = {
  files: Array<GovFileInput>;
  mentions?: InputMaybe<Array<GovMentionInput>>;
  note?: InputMaybe<Scalars['String']['input']>;
  organisationId: Scalars['ID']['input'];
};

/** Attendee role in event */
export enum AttendeeRole {
  Chair = 'CHAIR',
  NonParticipant = 'NON_PARTICIPANT',
  OptParticipant = 'OPT_PARTICIPANT',
  ReqParticipant = 'REQ_PARTICIPANT'
}

/** Attendee response status */
export enum AttendeeStatus {
  Accepted = 'ACCEPTED',
  Declined = 'DECLINED',
  Delegated = 'DELEGATED',
  NeedsAction = 'NEEDS_ACTION',
  Tentative = 'TENTATIVE'
}

/** Status of the audio/video transcription job */
export enum AudioTranscriptionStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Processing = 'PROCESSING',
  Uploading = 'UPLOADING'
}

/** Actions that can be performed on medical records */
export enum AuditAction {
  AuditExport = 'AUDIT_EXPORT',
  EmergencyAccess = 'EMERGENCY_ACCESS',
  FailedAccess = 'FAILED_ACCESS',
  FileDelete = 'FILE_DELETE',
  FileDownload = 'FILE_DOWNLOAD',
  FileRestore = 'FILE_RESTORE',
  FileUpload = 'FILE_UPLOAD',
  FileView = 'FILE_VIEW',
  KeyAccess = 'KEY_ACCESS',
  KeyGenerate = 'KEY_GENERATE',
  KeyRotate = 'KEY_ROTATE',
  PermissionCheck = 'PERMISSION_CHECK',
  PermissionGrant = 'PERMISSION_GRANT',
  PermissionRevoke = 'PERMISSION_REVOKE',
  SettingsChange = 'SETTINGS_CHANGE',
  SourceMetadataImport = 'SOURCE_METADATA_IMPORT',
  SuspiciousActivity = 'SUSPICIOUS_ACTIVITY'
}

export type AuditLogFilterInput = {
  action?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  patientId?: InputMaybe<Scalars['ID']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  suspiciousOnly?: InputMaybe<Scalars['Boolean']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

/** Outcome of an audit action */
export enum AuditOutcome {
  Denied = 'DENIED',
  Error = 'ERROR',
  Failure = 'FAILURE',
  Success = 'SUCCESS'
}

export type Auth = {
  __typename?: 'Auth';
  email?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
};

export type AuthProfileFieldPolicy = {
  __typename?: 'AuthProfileFieldPolicy';
  email: Scalars['String']['output'];
  fName: Scalars['String']['output'];
  lName: Scalars['String']['output'];
  phoneNumber: Scalars['String']['output'];
};

export type AuthProfileFieldPolicyInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  fName?: InputMaybe<Scalars['String']['input']>;
  lName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type AuthProfileInput = {
  fName?: InputMaybe<Scalars['String']['input']>;
  lName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type AuthProfileStatus = {
  __typename?: 'AuthProfileStatus';
  requiredFields: Array<Scalars['String']['output']>;
  suggestedCredentials: Array<Scalars['String']['output']>;
  suggestedFields: Array<Scalars['String']['output']>;
};

export type AuthResponse = {
  __typename?: 'AuthResponse';
  accountStatus: AccountStatus;
  client?: Maybe<Client>;
  identifier?: Maybe<Scalars['String']['output']>;
  token?: Maybe<Scalars['String']['output']>;
};

export type AutomationRunResults = {
  __typename?: 'AutomationRunResults';
  emailsSent: Scalars['Int']['output'];
  opportunitiesAnalyzed: Scalars['Int']['output'];
  overdueTasksFound: Scalars['Int']['output'];
  smsSent: Scalars['Int']['output'];
  staleDealsFound: Scalars['Int']['output'];
  suggestedActions?: Maybe<Array<AutomationSuggestedAction>>;
  tasksCreated: Scalars['Int']['output'];
  unsignedProposals: Scalars['Int']['output'];
};

/** Current status of an automation run */
export enum AutomationRunStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Running = 'RUNNING'
}

/** How the automation run was triggered */
export enum AutomationRunType {
  DailyCron = 'DAILY_CRON',
  Manual = 'MANUAL'
}

export type AutomationSuggestedAction = {
  __typename?: 'AutomationSuggestedAction';
  actionTaken: Scalars['Boolean']['output'];
  description: Scalars['String']['output'];
  opportunityId?: Maybe<Scalars['String']['output']>;
  opportunityTitle?: Maybe<Scalars['String']['output']>;
  priority?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export type Availability = {
  __typename?: 'Availability';
  createdAt: Scalars['DateTime']['output'];
  endTime: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  isAvailable: Scalars['Boolean']['output'];
  isRecurring: Scalars['Boolean']['output'];
  practitioner: Client;
  reason?: Maybe<Scalars['String']['output']>;
  recurrenceRule?: Maybe<Scalars['String']['output']>;
  startTime: Scalars['DateTime']['output'];
  status: AvailabilityStatus;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type AvailabilityInput = {
  endTime: Scalars['DateTime']['input'];
  isAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  isRecurring?: InputMaybe<Scalars['Boolean']['input']>;
  practitioner: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
  recurrenceRule?: InputMaybe<Scalars['String']['input']>;
  startTime: Scalars['DateTime']['input'];
  status?: AvailabilityStatus;
};

/** The status of the availability slot */
export enum AvailabilityStatus {
  Cancelled = 'CANCELLED',
  Confirmed = 'CONFIRMED',
  Draft = 'DRAFT'
}

/** A model the local-AI endpoint can serve. Surfaced by proxying LiteLLM /v1/models. */
export type AvailableLocalAiModel = {
  __typename?: 'AvailableLocalAiModel';
  /** User-friendly display label including hardware-context where useful */
  displayName: Scalars['String']['output'];
  /** Friendly model name (e.g. 'qwen3.6-35b') */
  id: Scalars['String']['output'];
  /** Underlying provider as reported by the upstream runtime */
  ownedBy?: Maybe<Scalars['String']['output']>;
};

export type AvailablePhoneNumber = {
  __typename?: 'AvailablePhoneNumber';
  capabilities: Array<PhoneCapability>;
  currency: Scalars['String']['output'];
  friendlyName: Scalars['String']['output'];
  isoCountry?: Maybe<Scalars['String']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  monthlyCost: Scalars['Float']['output'];
  phoneNumber: Scalars['String']['output'];
  postalCode?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
};

export type AvailableTimeSlot = {
  __typename?: 'AvailableTimeSlot';
  available: Scalars['Boolean']['output'];
  endTime: Scalars['DateTime']['output'];
  startTime: Scalars['DateTime']['output'];
};

export type AwardClassification = {
  __typename?: 'AwardClassification';
  awardName: Scalars['String']['output'];
  baseHourlyRate?: Maybe<Scalars['Float']['output']>;
  casualHourlyRate?: Maybe<Scalars['Float']['output']>;
  code: Scalars['String']['output'];
  color?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  displayOrder?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  payLevel?: Maybe<Scalars['Float']['output']>;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type AwardClassificationInput = {
  awardName: Scalars['String']['input'];
  baseHourlyRate?: InputMaybe<Scalars['Float']['input']>;
  casualHourlyRate?: InputMaybe<Scalars['Float']['input']>;
  code: Scalars['String']['input'];
  color?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayOrder?: InputMaybe<Scalars['Float']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  payLevel?: InputMaybe<Scalars['Float']['input']>;
};

export type AwardEntity = {
  __typename?: 'AwardEntity';
  code: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  industry?: Maybe<Scalars['String']['output']>;
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  versions: Array<AwardVersion>;
};

export type AwardRateTable = {
  __typename?: 'AwardRateTable';
  /** Ref to AwardClassification (employees module) */
  awardClassificationId: Scalars['ID']['output'];
  /** Base hourly rate AUD (ordinary Mon-Fri 06:00-18:00) */
  baseHourlyRate: Scalars['Float']['output'];
  /** Casual hourly rate AUD (typically base × 1.25 already loaded) */
  casualHourlyRate?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['DateTime']['output'];
  currency: Scalars['String']['output'];
  /** Rate effective from this date (UTC midnight) */
  effectiveFromDate: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type AwardVersion = {
  __typename?: 'AwardVersion';
  endDate?: Maybe<Scalars['DateTime']['output']>;
  ipfsHash: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  pdfUrl: Scalars['String']['output'];
  ragStatus?: Maybe<Scalars['String']['output']>;
  ragVectorId?: Maybe<Scalars['String']['output']>;
  startDate: Scalars['DateTime']['output'];
  uploadedAt: Scalars['DateTime']['output'];
  uploadedBy?: Maybe<Scalars['String']['output']>;
  version: Scalars['String']['output'];
};

export type BmiHistory = {
  __typename?: 'BMIHistory';
  bmi: Scalars['Float']['output'];
  calculatedAt: Scalars['DateTime']['output'];
  category: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  height: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  residentId: Scalars['ID']['output'];
  residentName?: Maybe<Scalars['String']['output']>;
  residentRoom?: Maybe<Scalars['String']['output']>;
  residentWing?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  weight: Scalars['Float']['output'];
};

export type BmiHistoryResponse = {
  __typename?: 'BMIHistoryResponse';
  history: Array<BmiHistory>;
  total: Scalars['Int']['output'];
};

export type BpAlertRanges = {
  __typename?: 'BPAlertRanges';
  diastolicHigh: Scalars['Int']['output'];
  diastolicLow: Scalars['Int']['output'];
  systolicHigh: Scalars['Int']['output'];
  systolicLow: Scalars['Int']['output'];
};

/** Position during blood pressure measurement */
export enum BpPosition {
  Lying = 'LYING',
  Sitting = 'SITTING',
  Standing = 'STANDING',
  Unspecified = 'UNSPECIFIED'
}

export type BslAlertRanges = {
  __typename?: 'BSLAlertRanges';
  alertHigh: Scalars['Float']['output'];
  alertLow: Scalars['Float']['output'];
};

export type BackfillConfigResult = {
  __typename?: 'BackfillConfigResult';
  domain?: Maybe<Scalars['String']['output']>;
  improvmxConfigured: Scalars['Boolean']['output'];
  improvmxRegistered: Scalars['Boolean']['output'];
  message?: Maybe<Scalars['String']['output']>;
};

export type BankAccountDetails = {
  __typename?: 'BankAccountDetails';
  accountName?: Maybe<Scalars['String']['output']>;
  accountNumber?: Maybe<Scalars['String']['output']>;
  bankName?: Maybe<Scalars['String']['output']>;
  bsb?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  swiftCode?: Maybe<Scalars['String']['output']>;
};

export type BankAccountDetailsInput = {
  accountName?: InputMaybe<Scalars['String']['input']>;
  accountNumber?: InputMaybe<Scalars['String']['input']>;
  bankName?: InputMaybe<Scalars['String']['input']>;
  bsb?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  swiftCode?: InputMaybe<Scalars['String']['input']>;
};

export type BankCsvImportInput = {
  bankAccountId: Scalars['ID']['input'];
  csvText: Scalars['String']['input'];
};

export type BankImportResult = {
  __typename?: 'BankImportResult';
  committed: Scalars['Boolean']['output'];
  detectedFormat: Scalars['String']['output'];
  duplicateCount: Scalars['Int']['output'];
  errorCount: Scalars['Int']['output'];
  insertedCount: Scalars['Int']['output'];
  newCount: Scalars['Int']['output'];
  rows: Array<BankImportRow>;
  shownRows: Scalars['Int']['output'];
  suggestedCount: Scalars['Int']['output'];
  totalRows: Scalars['Int']['output'];
};

export type BankImportRow = {
  __typename?: 'BankImportRow';
  action: AccountingImportAction;
  amountCents?: Maybe<Scalars['Int']['output']>;
  day?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  direction?: Maybe<AccountingDirection>;
  line: Scalars['Int']['output'];
  message?: Maybe<Scalars['String']['output']>;
};

export type BankingAccount = {
  __typename?: 'BankingAccount';
  accountNumberMasked?: Maybe<Scalars['String']['output']>;
  balanceAvailableMinor?: Maybe<Scalars['Int']['output']>;
  balanceCurrentMinor?: Maybe<Scalars['Int']['output']>;
  balanceFreshness?: Maybe<Scalars['String']['output']>;
  balanceObservedAt?: Maybe<Scalars['DateTime']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  connectionStatus?: Maybe<Scalars['String']['output']>;
  consentExpiresAt?: Maybe<Scalars['DateTime']['output']>;
  consentStatus?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  currency: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  includeInPosition: Scalars['Boolean']['output'];
  institutionId?: Maybe<Scalars['String']['output']>;
  institutionLogoUrl?: Maybe<Scalars['String']['output']>;
  institutionName?: Maybe<Scalars['String']['output']>;
  isLiability: Scalars['Boolean']['output'];
  lastTransactionAt?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  nickname?: Maybe<Scalars['String']['output']>;
  providerLastRefreshedAt?: Maybe<Scalars['DateTime']['output']>;
  providerStatus?: Maybe<Scalars['String']['output']>;
  reconciledAt?: Maybe<Scalars['DateTime']['output']>;
  reconciledBalanceMinor?: Maybe<Scalars['Int']['output']>;
  redbarkAccountId: Scalars['String']['output'];
  redbarkConnectionId?: Maybe<Scalars['String']['output']>;
  redbarkType?: Maybe<Scalars['String']['output']>;
  source: BankingAccountSource;
  tenantId: Scalars['String']['output'];
  type?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  viewerClientIds: Array<Scalars['String']['output']>;
};

export type BankingAccountDigest = {
  __typename?: 'BankingAccountDigest';
  accountId: Scalars['ID']['output'];
  frequency: BankingDigestFrequency;
};

export type BankingAccountDigestInput = {
  accountId: Scalars['ID']['input'];
  frequency: BankingDigestFrequency;
};

/** Where an account's numbers come from: the bank feed, or typed in by hand */
export enum BankingAccountSource {
  Manual = 'MANUAL',
  Redbark = 'REDBARK'
}

/** A page of feed events with the full match count stated */
export type BankingActivityPage = {
  __typename?: 'BankingActivityPage';
  limit: Scalars['Int']['output'];
  offset: Scalars['Int']['output'];
  rows: Array<BankingFeedEvent>;
  total: Scalars['Int']['output'];
};

/** Which direction an alert rule watches */
export enum BankingAlertDirection {
  Any = 'ANY',
  Credit = 'CREDIT',
  Debit = 'DEBIT'
}

export type BankingAlertRule = {
  __typename?: 'BankingAlertRule';
  /** True while every account the rule names is still visible to its owner */
  accessOk: Scalars['Boolean']['output'];
  accountIds: Array<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  direction: BankingAlertDirection;
  enabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  includePending: Scalars['Boolean']['output'];
  keyword?: Maybe<Scalars['String']['output']>;
  lastFiredAt?: Maybe<Scalars['DateTime']['output']>;
  maxAmountMinor?: Maybe<Scalars['Int']['output']>;
  minAmountMinor?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  notifyEmail: Scalars['Boolean']['output'];
  notifySms: Scalars['Boolean']['output'];
  ownerClientId: Scalars['ID']['output'];
  tenantId: Scalars['String']['output'];
  timesFired: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** A bank account whose balance its transactions don't yet explain — usually rows the bank hasn't sent yet */
export type BankingBalanceGap = {
  __typename?: 'BankingBalanceGap';
  accountId: Scalars['ID']['output'];
  accountName: Scalars['String']['output'];
  /** When that was */
  anchorAt: Scalars['DateTime']['output'];
  /** The last balance the rows fully explained */
  anchorMinor: Scalars['Int']['output'];
  /** The bank's current balance, cents */
  balanceMinor: Scalars['Int']['output'];
  balanceObservedAt?: Maybe<Scalars['DateTime']['output']>;
  /** balance − (anchor + rows since): + = more money than the rows explain */
  gapMinor: Scalars['Int']['output'];
  /** Net of the rows still pending (never in a current balance) */
  pendingMinor: Scalars['Int']['output'];
  rowsSince: Scalars['Int']['output'];
  /** Net of the posted rows since then */
  rowsSinceMinor: Scalars['Int']['output'];
  /** Open for more than 48 hours — Redbark is no longer nudged; accept the balance or ask the bank */
  stale: Scalars['Boolean']['output'];
};

/** A removed cash movement and the wallet's balance after it */
export type BankingCashRemoval = {
  __typename?: 'BankingCashRemoval';
  account: BankingAccount;
  balanceMinor: Scalars['Int']['output'];
  transactionId: Scalars['ID']['output'];
};

/** A cash movement as saved, plus the wallet it is in (with its derived balance) */
export type BankingCashWrite = {
  __typename?: 'BankingCashWrite';
  account: BankingAccount;
  transaction: BankingTransaction;
};

/** Whether the month can be closed now, and why not */
export type BankingCloseGate = {
  __typename?: 'BankingCloseGate';
  canClose: Scalars['Boolean']['output'];
  reason?: Maybe<Scalars['String']['output']>;
};

export type BankingCloseResult = {
  __typename?: 'BankingCloseResult';
  close: BankingMonthClose;
  month: Scalars['String']['output'];
  /** Prices that could not be had — the close still records the money */
  priceFailures: Array<Scalars['String']['output']>;
};

/** NOT_CLOSED = this month has no close yet; FIRST_CLOSE = no earlier close to compare with; COMPARED = compared with the most recent earlier close */
export enum BankingCompareStatus {
  Compared = 'COMPARED',
  FirstClose = 'FIRST_CLOSE',
  NotClosed = 'NOT_CLOSED'
}

export type BankingCompareTile = {
  __typename?: 'BankingCompareTile';
  current?: Maybe<Scalars['Float']['output']>;
  delta?: Maybe<Scalars['Float']['output']>;
  /** true = forward for you, false = backward, null = nothing to compare */
  forward?: Maybe<Scalars['Boolean']['output']>;
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  note?: Maybe<Scalars['String']['output']>;
  previous?: Maybe<Scalars['Float']['output']>;
  trend: BankingTrend;
  /** AUD_MINOR, OZ or PCT */
  unit: Scalars['String']['output'];
};

/** A CSV of transactions the caller can see. `truncated` is true when `total` exceeded `cap`. */
export type BankingCsvExport = {
  __typename?: 'BankingCsvExport';
  cap: Scalars['Int']['output'];
  csv: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
  rowCount: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  truncated: Scalars['Boolean']['output'];
};

/** How often a person receives a banking digest */
export enum BankingDigestFrequency {
  Daily = 'DAILY',
  Monthly = 'MONTHLY',
  None = 'NONE',
  Weekly = 'WEEKLY'
}

export type BankingDigestPreference = {
  __typename?: 'BankingDigestPreference';
  combinedFrequency: BankingDigestFrequency;
  createdAt: Scalars['DateTime']['output'];
  email: Scalars['Boolean']['output'];
  hourBrisbane: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  lastDailyAt?: Maybe<Scalars['DateTime']['output']>;
  lastMonthlyAt?: Maybe<Scalars['DateTime']['output']>;
  lastWeeklyAt?: Maybe<Scalars['DateTime']['output']>;
  ownerClientId: Scalars['ID']['output'];
  perAccount: Array<BankingAccountDigest>;
  sms: Scalars['Boolean']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  weeklyDay: Scalars['Int']['output'];
};

/** Money in (CREDIT) or money out (DEBIT) */
export enum BankingDirection {
  Credit = 'CREDIT',
  Debit = 'DEBIT'
}

export type BankingFeedEvent = {
  __typename?: 'BankingFeedEvent';
  actorClientId?: Maybe<Scalars['ID']['output']>;
  actorName?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  detailJson?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  kind: BankingFeedEventKind;
  redbarkEventId?: Maybe<Scalars['String']['output']>;
  summary: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** What happened to the bank feed */
export enum BankingFeedEventKind {
  AccessChanged = 'ACCESS_CHANGED',
  AccountsDiscovered = 'ACCOUNTS_DISCOVERED',
  BackfillRun = 'BACKFILL_RUN',
  Connected = 'CONNECTED',
  ConnectionStatus = 'CONNECTION_STATUS',
  Disconnected = 'DISCONNECTED',
  ExportDownloaded = 'EXPORT_DOWNLOADED',
  FeedHealth = 'FEED_HEALTH',
  ManualEntry = 'MANUAL_ENTRY',
  PollRun = 'POLL_RUN',
  ProviderEvent = 'PROVIDER_EVENT',
  SyncRun = 'SYNC_RUN',
  WebhookDelivery = 'WEBHOOK_DELIVERY',
  WebhookDisabled = 'WEBHOOK_DISABLED',
  WebhookRegistered = 'WEBHOOK_REGISTERED'
}

/** How bank transactions currently reach the module */
export enum BankingFeedMode {
  NotConnected = 'NOT_CONNECTED',
  PollOnly = 'POLL_ONLY',
  Webhook = 'WEBHOOK'
}

export type BankingFile = {
  __typename?: 'BankingFile';
  cid: Scalars['String']['output'];
  fileName?: Maybe<Scalars['String']['output']>;
  mimeType?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['Float']['output']>;
  uploadedAt?: Maybe<Scalars['DateTime']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type BankingFileInput = {
  cid: Scalars['String']['input'];
  fileName?: InputMaybe<Scalars['String']['input']>;
  mimeType?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
};

export type BankingHolding = {
  __typename?: 'BankingHolding';
  asset: BankingHoldingAsset;
  at: Scalars['DateTime']['output'];
  audMinor: Scalars['Int']['output'];
  closeMonth?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  kind: BankingHoldingKind;
  note?: Maybe<Scalars['String']['output']>;
  quantity: Scalars['Float']['output'];
  tenantId: Scalars['String']['output'];
  transactionId?: Maybe<Scalars['ID']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

/** XAU = gold, counted in grams; BTC = bitcoin, counted in sats */
export enum BankingHoldingAsset {
  Btc = 'BTC',
  Xau = 'XAU'
}

/** BUY adds to what you hold; SELL takes it away */
export enum BankingHoldingKind {
  Buy = 'BUY',
  Sell = 'SELL'
}

/** What you hold of one asset, valued at the latest stored price */
export type BankingHoldingLine = {
  __typename?: 'BankingHoldingLine';
  asset: BankingHoldingAsset;
  /** Net AUD paid (buys − sells), cents */
  costAudMinor: Scalars['Int']['output'];
  price?: Maybe<BankingPrice>;
  /** Grams of gold, or sats of bitcoin */
  quantity: Scalars['Float']['output'];
  /** g or sats */
  unit: Scalars['String']['output'];
  /** Null when something is held and there is no price */
  valueAudMinor?: Maybe<Scalars['Int']['output']>;
  valueUsdMinor?: Maybe<Scalars['Int']['output']>;
};

export type BankingIncomeRule = {
  __typename?: 'BankingIncomeRule';
  createdAt: Scalars['DateTime']['output'];
  enabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  match: Scalars['String']['output'];
  note?: Maybe<Scalars['String']['output']>;
  rank: Scalars['Int']['output'];
  shape: BankingIncomeShape;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** What a credit is: untaxed receipt, PAYG wage, household money, an asset sold, an internal move, someone else's money held or passed on (both directions), or other */
export enum BankingIncomeShape {
  AssetSale = 'ASSET_SALE',
  HeldForOthers = 'HELD_FOR_OTHERS',
  Household = 'HOUSEHOLD',
  Internal = 'INTERNAL',
  Other = 'OTHER',
  ReceiptUntaxed = 'RECEIPT_UNTAXED',
  WagePayg = 'WAGE_PAYG'
}

/** One IOU token as the LENDER sees it */
export type BankingIouToken = {
  __typename?: 'BankingIouToken';
  amountMinor: Scalars['Int']['output'];
  lentAt: Scalars['DateTime']['output'];
  payoutJobId?: Maybe<Scalars['ID']['output']>;
  /** A payout request is already sitting on the admin's month */
  payoutRequested: Scalars['Boolean']['output'];
  rewardTokenId: Scalars['ID']['output'];
  status: Scalars['String']['output'];
  stillOwedMinor: Scalars['Int']['output'];
  tokenNumber: Scalars['Int']['output'];
};

/** DUE_THEN_AZ = due day then A–Z (default); CURATED = the admin's own drag order */
export enum BankingJobOrder {
  Curated = 'CURATED',
  DueThenAz = 'DUE_THEN_AZ'
}

export type BankingLoan = {
  __typename?: 'BankingLoan';
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  lenderClientId: Scalars['ID']['output'];
  lenderEmail?: Maybe<Scalars['String']['output']>;
  lenderName: Scalars['String']['output'];
  note?: Maybe<Scalars['String']['output']>;
  settledAt?: Maybe<Scalars['DateTime']['output']>;
  status: BankingLoanStatus;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** Money borrowed (DRAWDOWN) or paid back (REPAYMENT) */
export enum BankingLoanKind {
  Drawdown = 'DRAWDOWN',
  Repayment = 'REPAYMENT'
}

export type BankingLoanMovement = {
  __typename?: 'BankingLoanMovement';
  amountMinor: Scalars['Int']['output'];
  at: Scalars['DateTime']['output'];
  confirmedBy?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  kind: BankingLoanKind;
  loanId: Scalars['ID']['output'];
  monthJobId?: Maybe<Scalars['ID']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  rewardTokenId?: Maybe<Scalars['ID']['output']>;
  tenantId: Scalars['String']['output'];
  transactionId?: Maybe<Scalars['ID']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

/** OPEN while anything is owed; SETTLED once paid back */
export enum BankingLoanStatus {
  Open = 'OPEN',
  Settled = 'SETTLED'
}

/** A loan with its movements and the derived balance */
export type BankingLoanView = {
  __typename?: 'BankingLoanView';
  balanceMinor: Scalars['Int']['output'];
  borrowedMinor: Scalars['Int']['output'];
  loan: BankingLoan;
  movements: Array<BankingLoanMovement>;
  repaidMinor: Scalars['Int']['output'];
};

export type BankingLoanWrite = {
  __typename?: 'BankingLoanWrite';
  settledTokenIds: Array<Scalars['ID']['output']>;
  tokenError?: Maybe<Scalars['String']['output']>;
  view: BankingLoanView;
};

/** The month: buckets, safe-to-spend, trajectory. All cents, all Brisbane. */
export type BankingMonth = {
  __typename?: 'BankingMonth';
  /** Accounts the month is computed over (enabled + in position + AUD) */
  accounts: Scalars['Int']['output'];
  assetSaleMinor: Scalars['Int']['output'];
  /** Credits on the IOU ledger this month — borrowed, never income */
  borrowedMinor: Scalars['Int']['output'];
  byShape: Array<BankingMonthShapeRow>;
  /** The close record, once the month is closed */
  close?: Maybe<BankingMonthClose>;
  closedAt?: Maybe<Scalars['DateTime']['output']>;
  daysElapsed: Scalars['Int']['output'];
  daysInMonth: Scalars['Int']['output'];
  daysLeft: Scalars['Int']['output'];
  expectedIncomeMinor?: Maybe<Scalars['Int']['output']>;
  /** Enabled in-position accounts in another currency, left out of every sum here */
  foreignAccountsLeftOut: Scalars['Int']['output'];
  gstMinor: Scalars['Int']['output'];
  gstRegistered: Scalars['Boolean']['output'];
  /** Someone else's money that came in this month (posted) — never income */
  heldForOthersInMinor: Scalars['Int']['output'];
  /** Someone else's money passed on to them this month (posted) — never spend */
  heldForOthersOutMinor: Scalars['Int']['output'];
  /** Rows marked as someone else's money (pending included) */
  heldForOthersRows: Scalars['Int']['output'];
  incomeMinor: Scalars['Int']['output'];
  internalMinor: Scalars['Int']['output'];
  internalRows: Scalars['Int']['output'];
  isCurrent: Scalars['Boolean']['output'];
  month: Scalars['String']['output'];
  pendingSpendMinor: Scalars['Int']['output'];
  /** True when no plan row exists yet — the knobs shown are inherited defaults */
  planIsDefault: Scalars['Boolean']['output'];
  /** Debits on the IOU ledger this month — paid back, never spend */
  repaidMinor: Scalars['Int']['output'];
  /** True when the goal is the shipped default, not one the admin set */
  revenueGoalIsDefault: Scalars['Boolean']['output'];
  /** The month's revenue goal in cents (the plan's, inherited, or the $10k default) */
  revenueGoalMinor: Scalars['Int']['output'];
  /** Revenue received this month: posted income that is not household money */
  revenueMinor: Scalars['Int']['output'];
  /** True when the site has no rules of its own and the shipped defaults were used */
  rulesAreDefault: Scalars['Boolean']['output'];
  rulesUsed: Scalars['Int']['output'];
  safeToSpendPerDayMinor?: Maybe<Scalars['Int']['output']>;
  savePct: Scalars['Float']['output'];
  saveTargetMinor: Scalars['Int']['output'];
  spendBudgetMinor: Scalars['Int']['output'];
  spendPerDayMinor: Scalars['Int']['output'];
  spentMinor: Scalars['Int']['output'];
  surplusMinor: Scalars['Int']['output'];
  taxAccount?: Maybe<BankingMonthTaxAccount>;
  taxMinor: Scalars['Int']['output'];
  taxRatePct: Scalars['Float']['output'];
  today: Scalars['String']['output'];
  trajectory: BankingTrajectory;
  untaxedMinor: Scalars['Int']['output'];
  /** Accounts in the month whose balance the transactions don't yet explain — money the bank has moved but not sent rows for. Current month only. */
  waitingForBank: Array<BankingBalanceGap>;
};

/** A closed month: the money, the prices, the gold-vs-bitcoin tilt and the decision */
export type BankingMonthClose = {
  __typename?: 'BankingMonthClose';
  /** The Brisbane day the figures are as of (the month's last day, or today while it is still running) */
  asOfDay: Scalars['String']['output'];
  borrowedMinor: Scalars['Int']['output'];
  boughtBtcAudMinor?: Maybe<Scalars['Int']['output']>;
  boughtBtcSats?: Maybe<Scalars['Int']['output']>;
  boughtGoldAudMinor?: Maybe<Scalars['Int']['output']>;
  boughtGoldGrams?: Maybe<Scalars['Float']['output']>;
  btcAudEnd?: Maybe<Scalars['Float']['output']>;
  btcAudStart?: Maybe<Scalars['Float']['output']>;
  btcChangeAudPct?: Maybe<Scalars['Float']['output']>;
  btcUsdEnd?: Maybe<Scalars['Float']['output']>;
  btcUsdStart?: Maybe<Scalars['Float']['output']>;
  /** Cash across the month's accounts at the end of the as-of day (AUD). Null when an account had no balance. */
  cashMinor?: Maybe<Scalars['Int']['output']>;
  closedAt: Scalars['DateTime']['output'];
  /** Closed more than 3 days after the month ended — balances were derived back from today's, and prices taken from history */
  closedLate: Scalars['Boolean']['output'];
  decidedAt?: Maybe<Scalars['DateTime']['output']>;
  decision?: Maybe<BankingMonthDecision>;
  /** Gold + bitcoin at the as-of day's price. Null when a held asset had no price. */
  holdingsAudMinor?: Maybe<Scalars['Int']['output']>;
  incomeMinor: Scalars['Int']['output'];
  /** Still owed to people (IOUs) at the end of the as-of day */
  owedToPeopleMinor: Scalars['Int']['output'];
  /** YYYY-MM-DD of the start-of-month prices */
  priceFromDay: Scalars['String']['output'];
  /** YYYY-MM-DD of the end-of-month prices */
  priceToDay: Scalars['String']['output'];
  /** True when a start or end price was missing — the recommendation falls back to 50/50 and says so */
  pricesUnavailable: Scalars['Boolean']['output'];
  recommendBtcPct: Scalars['Int']['output'];
  /** Simon's rule: the asset that fell more gets 70%, never 100 */
  recommendGoldPct: Scalars['Int']['output'];
  recommendation: Scalars['String']['output'];
  repaidMinor: Scalars['Int']['output'];
  savePct: Scalars['Float']['output'];
  spentMinor: Scalars['Int']['output'];
  /** income − tax − spend */
  surplusMinor: Scalars['Int']['output'];
  taxAccountBalanceMinor?: Maybe<Scalars['Int']['output']>;
  /** Tax account balance ÷ tax owed this month, percent */
  taxFundedPct?: Maybe<Scalars['Int']['output']>;
  /** Income tax + GST set aside on the month's untaxed receipts */
  taxOwedMinor: Scalars['Int']['output'];
  untaxedMinor: Scalars['Int']['output'];
  usdAudEnd?: Maybe<Scalars['Float']['output']>;
  /** AUD for one USD at the start */
  usdAudStart?: Maybe<Scalars['Float']['output']>;
  /** cash − owed to people + holdings */
  wealthAudMinor?: Maybe<Scalars['Int']['output']>;
  /** Wealth in troy ounces of gold — Simon's chart */
  wealthGoldOz?: Maybe<Scalars['Float']['output']>;
  wealthUsdMinor?: Maybe<Scalars['Int']['output']>;
  xauAudEnd?: Maybe<Scalars['Float']['output']>;
  xauAudStart?: Maybe<Scalars['Float']['output']>;
  /** Gold's move in AUD over the month, percent */
  xauChangeAudPct?: Maybe<Scalars['Float']['output']>;
  xauUsdEnd?: Maybe<Scalars['Float']['output']>;
  xauUsdStart?: Maybe<Scalars['Float']['output']>;
};

/** A month against the most recent earlier close */
export type BankingMonthComparison = {
  __typename?: 'BankingMonthComparison';
  month: Scalars['String']['output'];
  previousMonth?: Maybe<Scalars['String']['output']>;
  status: BankingCompareStatus;
  tiles: Array<BankingCompareTile>;
};

/** What was bought when the month closed (recorded, never executed) */
export enum BankingMonthDecision {
  BoughtBitcoin = 'BOUGHT_BITCOIN',
  BoughtBoth = 'BOUGHT_BOTH',
  BoughtGold = 'BOUGHT_GOLD',
  Skipped = 'SKIPPED'
}

/** One month of the 12-month strip */
export type BankingMonthHistoryRow = {
  __typename?: 'BankingMonthHistoryRow';
  closed: Scalars['Boolean']['output'];
  month: Scalars['String']['output'];
  previousMonth?: Maybe<Scalars['String']['output']>;
  tiles: Array<BankingCompareTile>;
};

export type BankingMonthJob = {
  __typename?: 'BankingMonthJob';
  autoMatched?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['DateTime']['output'];
  doneAt?: Maybe<Scalars['DateTime']['output']>;
  dueDay?: Maybe<Scalars['Int']['output']>;
  expectedMinor: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  landedAt?: Maybe<Scalars['DateTime']['output']>;
  linkedTransactionId?: Maybe<Scalars['ID']['output']>;
  loanId?: Maybe<Scalars['ID']['output']>;
  month: Scalars['String']['output'];
  note?: Maybe<Scalars['String']['output']>;
  occurrenceDate?: Maybe<Scalars['String']['output']>;
  rank?: Maybe<Scalars['Int']['output']>;
  rewardPayoutRequestId?: Maybe<Scalars['ID']['output']>;
  rewardTokenId?: Maybe<Scalars['ID']['output']>;
  rolledFromMonth?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  standingMoveId?: Maybe<Scalars['ID']['output']>;
  tenantId: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type BankingMonthJobsPage = {
  __typename?: 'BankingMonthJobsPage';
  done: Scalars['Int']['output'];
  jobs: Array<BankingMonthJob>;
  month: Scalars['String']['output'];
  open: Scalars['Int']['output'];
  /** Σ expectedMinor over open jobs */
  openExpectedMinor: Scalars['Int']['output'];
  order: BankingJobOrder;
  /** The one open job to do today (overdue or due today first, else the first in order) */
  today?: Maybe<BankingMonthJob>;
};

export type BankingMonthPlan = {
  __typename?: 'BankingMonthPlan';
  close?: Maybe<BankingMonthClose>;
  closedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  expectedIncomeMinor?: Maybe<Scalars['Int']['output']>;
  gstRegistered: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  jobsCurated: Scalars['Boolean']['output'];
  month: Scalars['String']['output'];
  revenueGoalMinor?: Maybe<Scalars['Int']['output']>;
  savePct: Scalars['Float']['output'];
  taxAccountId?: Maybe<Scalars['ID']['output']>;
  taxRatePct: Scalars['Float']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** Posted credits of one shape this month */
export type BankingMonthShapeRow = {
  __typename?: 'BankingMonthShapeRow';
  amountMinor: Scalars['Int']['output'];
  rows: Scalars['Int']['output'];
  shape: BankingIncomeShape;
};

/** Where the tax bucket physically lives, and whether it is funded from the account's REAL balance */
export type BankingMonthTaxAccount = {
  __typename?: 'BankingMonthTaxAccount';
  accountId: Scalars['ID']['output'];
  balanceMinor?: Maybe<Scalars['Int']['output']>;
  fundedPct?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  observedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** What this site owes ME */
export type BankingMyIous = {
  __typename?: 'BankingMyIous';
  balanceMinor: Scalars['Int']['output'];
  tokens: Array<BankingIouToken>;
};

/** Channel a banking notification went out on */
export enum BankingNotificationChannel {
  Email = 'EMAIL',
  Sms = 'SMS'
}

/** The kind of banking notification sent to a person */
export enum BankingNotificationKind {
  AccessGranted = 'ACCESS_GRANTED',
  AlertAmountChanged = 'ALERT_AMOUNT_CHANGED',
  AlertMoneyIn = 'ALERT_MONEY_IN',
  AlertMoneyOut = 'ALERT_MONEY_OUT',
  DigestDaily = 'DIGEST_DAILY',
  DigestMonthly = 'DIGEST_MONTHLY',
  DigestWeekly = 'DIGEST_WEEKLY',
  FeedHealth = 'FEED_HEALTH'
}

export type BankingNotificationLog = {
  __typename?: 'BankingNotificationLog';
  channel: BankingNotificationChannel;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  kind: BankingNotificationKind;
  providerMessageId?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  recipientClientId: Scalars['ID']['output'];
  recipientName?: Maybe<Scalars['String']['output']>;
  ruleId?: Maybe<Scalars['ID']['output']>;
  sentAt: Scalars['DateTime']['output'];
  status: BankingNotificationStatus;
  tenantId: Scalars['String']['output'];
  transactionId?: Maybe<Scalars['ID']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type BankingNotificationLogFilterInput = {
  channel?: InputMaybe<BankingNotificationChannel>;
  kind?: InputMaybe<BankingNotificationKind>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  recipientClientId?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<BankingNotificationStatus>;
  transactionId?: InputMaybe<Scalars['ID']['input']>;
};

export type BankingNotificationLogPage = {
  __typename?: 'BankingNotificationLogPage';
  rows: Array<BankingNotificationLog>;
  total: Scalars['Int']['output'];
};

export type BankingNotificationOutcome = {
  __typename?: 'BankingNotificationOutcome';
  channel: BankingNotificationChannel;
  reason?: Maybe<Scalars['String']['output']>;
  status: BankingNotificationStatus;
  to?: Maybe<Scalars['String']['output']>;
};

export type BankingNotificationScheduleRow = {
  __typename?: 'BankingNotificationScheduleRow';
  accountId?: Maybe<Scalars['ID']['output']>;
  email: Scalars['Boolean']['output'];
  frequency: Scalars['String']['output'];
  frequencyLabel: Scalars['String']['output'];
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  on: Scalars['Boolean']['output'];
  reason: Scalars['String']['output'];
  settingsField: Scalars['String']['output'];
  sms: Scalars['Boolean']['output'];
};

/** Per-recipient outcome of a banking notification */
export enum BankingNotificationStatus {
  Failed = 'FAILED',
  Sent = 'SENT',
  Skipped = 'SKIPPED'
}

/** A bill of this site that is sent and unpaid (money owed to you), or a draft still to send or cancel. Read from the bills module. */
export type BankingOwedBill = {
  __typename?: 'BankingOwedBill';
  /** What is still owed, cents */
  amountMinor: Scalars['Int']['output'];
  billId: Scalars['ID']['output'];
  /** Server-computed from the BILLS module's manifest: the viewer may open this bill */
  canViewDetail: Scalars['Boolean']['output'];
  clientId?: Maybe<Scalars['ID']['output']>;
  clientName: Scalars['String']['output'];
  /** Brisbane days since sent, else since created */
  daysOld: Scalars['Int']['output'];
  /** Days since it was sent (Brisbane days); null for a draft or an undated send */
  daysSinceSent?: Maybe<Scalars['Int']['output']>;
  /** /bill/<id> when canViewDetail, else null */
  detailUrl?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['DateTime']['output']>;
  sentAt?: Maybe<Scalars['DateTime']['output']>;
  /** SENT (owed, unpaid), DRAFT (not sent yet) or PROPOSAL (a quote) */
  status: Scalars['String']['output'];
  /** The first line item, shortened */
  title: Scalars['String']['output'];
};

/** One open IOU — what is still owed to a person */
export type BankingOwedRow = {
  __typename?: 'BankingOwedRow';
  balanceMinor: Scalars['Int']['output'];
  lenderName: Scalars['String']['output'];
  loanId: Scalars['ID']['output'];
};

/** Money owed to you: sent-and-unpaid bills, and drafts not yet sent. Paid = the bills module's isPaid; cancelled bills never appear. */
export type BankingOwedToYou = {
  __typename?: 'BankingOwedToYou';
  /** False when the viewer has no Bills view permission — the lists are empty because they are hidden, not because nothing is owed */
  billsAvailable: Scalars['Boolean']['output'];
  drafts: Array<BankingOwedBill>;
  draftsMinor: Scalars['Int']['output'];
  /** Quotes (PROPOSAL bills) not yet accepted, newest first. They never count toward the goal. */
  proposals: Array<BankingOwedBill>;
  sent: Array<BankingOwedBill>;
  sentMinor: Scalars['Int']['output'];
};

export type BankingPayoutRequest = {
  __typename?: 'BankingPayoutRequest';
  alreadyRequested: Scalars['Boolean']['output'];
  job: BankingMonthJob;
};

/** A reporting period, resolved in Australia/Brisbane */
export enum BankingPeriod {
  Custom = 'CUSTOM',
  Last_7Days = 'LAST_7_DAYS',
  Last_30Days = 'LAST_30_DAYS',
  LastMonth = 'LAST_MONTH',
  ThisMonth = 'THIS_MONTH',
  Today = 'TODAY',
  YearToDate = 'YEAR_TO_DATE',
  Yesterday = 'YESTERDAY'
}

export type BankingPlanLimits = {
  __typename?: 'BankingPlanLimits';
  accounts: Scalars['Int']['output'];
  connections: Scalars['Int']['output'];
  destinations: Scalars['Int']['output'];
  syncs: Scalars['Int']['output'];
};

/** Combined position over the caller's includeInPosition accounts; liabilities negative. */
export type BankingPosition = {
  __typename?: 'BankingPosition';
  accounts: Array<BankingPositionAccount>;
  /** Foreign-currency accounts with no AUD rate — the total omits them */
  accountsNotConverted: Scalars['Int']['output'];
  /** Included accounts with no balance — the total omits them */
  accountsWithoutBalance: Scalars['Int']['output'];
  /** Oldest observation among the counted accounts */
  asOf?: Maybe<Scalars['DateTime']['output']>;
  assetsMinor: Scalars['Int']['output'];
  currency: Scalars['String']['output'];
  /** Positive — what is owed */
  liabilitiesMinor: Scalars['Int']['output'];
  /** Admins only: open IOUs. Null for a viewer. */
  owedToPeople?: Maybe<Array<BankingOwedRow>>;
  /** Admins only: Σ open IOU balances (positive = what you owe people) */
  owedToPeopleMinor?: Maybe<Scalars['Int']['output']>;
  /** Admins only: totalMinor − owedToPeopleMinor — the honest number */
  totalAfterOwedMinor?: Maybe<Scalars['Int']['output']>;
  totalMinor: Scalars['Int']['output'];
};

/** One account's contribution to the combined position. */
export type BankingPositionAccount = {
  __typename?: 'BankingPositionAccount';
  /** The account's currency (aud, usd…) */
  accountCurrency: Scalars['String']['output'];
  accountId: Scalars['ID']['output'];
  /** AUD for one unit of the account's currency, when converted */
  audRate?: Maybe<Scalars['Float']['output']>;
  /** Brisbane day of that rate */
  audRateDay?: Maybe<Scalars['String']['output']>;
  /** In the account's own currency */
  balanceMinor?: Maybe<Scalars['Int']['output']>;
  freshness?: Maybe<Scalars['String']['output']>;
  isLiability: Scalars['Boolean']['output'];
  /** Foreign account with a balance but no AUD rate — left out of the total */
  notConverted: Scalars['Boolean']['output'];
  observedAt?: Maybe<Scalars['DateTime']['output']>;
  /** In AUD; negative for a liability; null with no balance or no rate */
  signedMinor?: Maybe<Scalars['Int']['output']>;
};

/** One stored price: what one unit (troy oz of gold, one bitcoin, one US dollar) cost that Brisbane day */
export type BankingPrice = {
  __typename?: 'BankingPrice';
  asset: BankingPriceAsset;
  aud?: Maybe<Scalars['Float']['output']>;
  day: Scalars['String']['output'];
  note?: Maybe<Scalars['String']['output']>;
  observedAt: Scalars['DateTime']['output'];
  source: Scalars['String']['output'];
  usd?: Maybe<Scalars['Float']['output']>;
};

/** XAU = one troy ounce of gold, BTC = one bitcoin, USD = one US dollar */
export enum BankingPriceAsset {
  Btc = 'BTC',
  Usd = 'USD',
  Xau = 'XAU'
}

export type BankingPriceCapture = {
  __typename?: 'BankingPriceCapture';
  day: Scalars['String']['output'];
  /** What could not be fetched, in words */
  failures: Array<Scalars['String']['output']>;
  stored: Array<BankingPrice>;
};

export type BankingRolloverResult = {
  __typename?: 'BankingRolloverResult';
  moved: Scalars['Int']['output'];
  to: Scalars['String']['output'];
};

export type BankingRunSummary = {
  __typename?: 'BankingRunSummary';
  accounts: Scalars['Int']['output'];
  alertsFired: Scalars['Int']['output'];
  inserted: Scalars['Int']['output'];
  ok: Scalars['Boolean']['output'];
  problems: Array<Scalars['String']['output']>;
  settings: BankingSettingsView;
  /** Rows Redbark returned that could not be used (reasons in problems) */
  skippedRows: Scalars['Int']['output'];
  skippedUnknownAccount: Scalars['Int']['output'];
  status: Scalars['String']['output'];
  updated: Scalars['Int']['output'];
};

/** The path a transaction first arrived through */
export enum BankingSeenVia {
  Backfill = 'BACKFILL',
  Manual = 'MANUAL',
  Poll = 'POLL',
  Webhook = 'WEBHOOK'
}

export type BankingSettingsView = {
  __typename?: 'BankingSettingsView';
  apiAccess: Scalars['Boolean']['output'];
  backfillMonths: Scalars['Int']['output'];
  connectedAt?: Maybe<Scalars['DateTime']['output']>;
  connectedByClientId?: Maybe<Scalars['String']['output']>;
  eventDestinationId?: Maybe<Scalars['String']['output']>;
  feedMode: BankingFeedMode;
  hasApiKey: Scalars['Boolean']['output'];
  hookId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  keyLast4?: Maybe<Scalars['String']['output']>;
  lastBackfillAt?: Maybe<Scalars['DateTime']['output']>;
  lastPollAt?: Maybe<Scalars['DateTime']['output']>;
  lastPollStatus?: Maybe<Scalars['String']['output']>;
  lastWebhookAt?: Maybe<Scalars['DateTime']['output']>;
  lastWebhookStatus?: Maybe<Scalars['String']['output']>;
  limits: BankingPlanLimits;
  missingWriteScopes: Array<Scalars['String']['output']>;
  plan?: Maybe<Scalars['String']['output']>;
  planStatus?: Maybe<Scalars['String']['output']>;
  pollEnabled: Scalars['Boolean']['output'];
  redbarkTimezone?: Maybe<Scalars['String']['output']>;
  scopes: Array<Scalars['String']['output']>;
  syncId?: Maybe<Scalars['String']['output']>;
  webhookDestinationId?: Maybe<Scalars['String']['output']>;
  webhookDisabledAt?: Maybe<Scalars['DateTime']['output']>;
  webhookUrl?: Maybe<Scalars['String']['output']>;
};

/** Period snapshot over the caller's visible accounts. Buckets and labels are Australia/Brisbane. */
export type BankingSnapshot = {
  __typename?: 'BankingSnapshot';
  accountIds: Array<Scalars['ID']['output']>;
  /** Oldest balanceObservedAt among the accounts */
  balanceAsOf?: Maybe<Scalars['DateTime']['output']>;
  balancesDerived: Scalars['Boolean']['output'];
  byCategory: Array<BankingSnapshotMoneyRow>;
  /** Derived from current balances; null when any selected account has no balance */
  closingBalanceMinor?: Maybe<Scalars['Int']['output']>;
  /** POSTED rows in range */
  count: Scalars['Int']['output'];
  currency: Scalars['String']['output'];
  dailySeries: Array<BankingSnapshotDailyPoint>;
  /** Foreign-currency accounts left out because the selection mixed currencies (never summed together) */
  foreignAccountsLeftOut?: Maybe<Scalars['Int']['output']>;
  /** Inclusive Brisbane date, YYYY-MM-DD */
  fromDate: Scalars['String']['output'];
  /** POSTED rows marked as someone else's money — left out of money in/out/net, categories, merchants, largest and the daily series (never the balances) */
  heldForOthersCount: Scalars['Int']['output'];
  heldForOthersInMinor: Scalars['Int']['output'];
  heldForOthersOutMinor: Scalars['Int']['output'];
  largestIn?: Maybe<BankingSnapshotLargest>;
  largestOut?: Maybe<BankingSnapshotLargest>;
  moneyInMinor: Scalars['Int']['output'];
  moneyOutMinor: Scalars['Int']['output'];
  netMinor: Scalars['Int']['output'];
  openingBalanceMinor?: Maybe<Scalars['Int']['output']>;
  /** PENDING rows in range — counted, never summed */
  pendingCount: Scalars['Int']['output'];
  period: BankingPeriod;
  /** Inclusive Brisbane date, YYYY-MM-DD */
  toDate: Scalars['String']['output'];
  /** Capped — see topMerchantsCap */
  topMerchants: Array<BankingSnapshotMoneyRow>;
  topMerchantsCap: Scalars['Int']['output'];
};

/** One Brisbane day of a snapshot (zero-filled across the range). */
export type BankingSnapshotDailyPoint = {
  __typename?: 'BankingSnapshotDailyPoint';
  count: Scalars['Int']['output'];
  /** YYYY-MM-DD, Australia/Brisbane */
  date: Scalars['String']['output'];
  moneyInMinor: Scalars['Int']['output'];
  moneyOutMinor: Scalars['Int']['output'];
};

export type BankingSnapshotInput = {
  accountIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  from?: InputMaybe<Scalars['DateTime']['input']>;
  period: BankingPeriod;
  to?: InputMaybe<Scalars['DateTime']['input']>;
};

/** The largest single POSTED transaction in a direction. */
export type BankingSnapshotLargest = {
  __typename?: 'BankingSnapshotLargest';
  amountMinor: Scalars['Int']['output'];
  description: Scalars['String']['output'];
  /** YYYY-MM-DD, the bank's local date */
  localDate: Scalars['String']['output'];
  merchantName?: Maybe<Scalars['String']['output']>;
  transactionId: Scalars['ID']['output'];
};

/** One category / merchant line of a snapshot. amountMinor is SIGNED net (credits +, debits −). */
export type BankingSnapshotMoneyRow = {
  __typename?: 'BankingSnapshotMoneyRow';
  amountMinor: Scalars['Int']['output'];
  count: Scalars['Int']['output'];
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

/** Every week, every second week, or every month, counted from the start date */
export enum BankingStandingCadence {
  Fortnightly = 'FORTNIGHTLY',
  Monthly = 'MONTHLY',
  Weekly = 'WEEKLY'
}

export type BankingStandingMove = {
  __typename?: 'BankingStandingMove';
  cadence: BankingStandingCadence;
  cadenceLabel: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  enabled: Scalars['Boolean']['output'];
  endDate?: Maybe<Scalars['String']['output']>;
  expectedMinor: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  matchText?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  skippedDates: Array<Scalars['String']['output']>;
  startDate: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type BankingTrajectory = {
  __typename?: 'BankingTrajectory';
  assumptions: BankingTrajectoryAssumptions;
  landingMinor: Scalars['Int']['output'];
  landingWithJobsMinor: Scalars['Int']['output'];
  points: Array<BankingTrajectoryPoint>;
};

/** Every number the projection rests on — printed under the chart */
export type BankingTrajectoryAssumptions = {
  __typename?: 'BankingTrajectoryAssumptions';
  expectedIncomeMinor: Scalars['Int']['output'];
  expectedIncomeSource: Scalars['String']['output'];
  openJobs: Scalars['Int']['output'];
  openJobsMinor: Scalars['Int']['output'];
  remainingIncomeMinor: Scalars['Int']['output'];
  spendPerDayMinor: Scalars['Int']['output'];
};

export type BankingTrajectoryPoint = {
  __typename?: 'BankingTrajectoryPoint';
  actualMinor?: Maybe<Scalars['Int']['output']>;
  date: Scalars['String']['output'];
  projectedMinor?: Maybe<Scalars['Int']['output']>;
  withJobsMinor?: Maybe<Scalars['Int']['output']>;
};

export type BankingTransaction = {
  __typename?: 'BankingTransaction';
  /** The account this transaction belongs to */
  account?: Maybe<BankingAccount>;
  accountId: Scalars['ID']['output'];
  alertsEvaluatedAt?: Maybe<Scalars['DateTime']['output']>;
  amountMinor: Scalars['Int']['output'];
  attachmentCount: Scalars['Int']['output'];
  categoryId?: Maybe<Scalars['String']['output']>;
  categoryName?: Maybe<Scalars['String']['output']>;
  class?: Maybe<Scalars['String']['output']>;
  commentCount: Scalars['Int']['output'];
  counterpartyClientId?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['DateTime']['output'];
  currency: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  direction: BankingDirection;
  enteredByClientId?: Maybe<Scalars['ID']['output']>;
  extendedDescription?: Maybe<Scalars['String']['output']>;
  firstSeenAt: Scalars['DateTime']['output'];
  firstSeenVia: BankingSeenVia;
  id: Scalars['ID']['output'];
  localDate: Scalars['DateTime']['output'];
  merchantCategoryCode?: Maybe<Scalars['String']['output']>;
  merchantName?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  postedAt?: Maybe<Scalars['DateTime']['output']>;
  postedDatetime?: Maybe<Scalars['DateTime']['output']>;
  postedSeenAt?: Maybe<Scalars['DateTime']['output']>;
  providerCategory?: Maybe<Scalars['String']['output']>;
  redbarkTransactionId: Scalars['String']['output'];
  reference?: Maybe<Scalars['String']['output']>;
  shapeOverride?: Maybe<BankingIncomeShape>;
  /** amountMinor with its sign: negative for a DEBIT */
  signedAmountMinor: Scalars['Int']['output'];
  status: BankingTransactionStatus;
  tenantId: Scalars['String']['output'];
  transactionAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  updatedByClientId?: Maybe<Scalars['ID']['output']>;
  updatedFromProviderAt?: Maybe<Scalars['DateTime']['output']>;
  valueDate?: Maybe<Scalars['DateTime']['output']>;
};

export type BankingTransactionComment = {
  __typename?: 'BankingTransactionComment';
  authorClientId?: Maybe<Scalars['ID']['output']>;
  authorName?: Maybe<Scalars['String']['output']>;
  body?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  editedAt?: Maybe<Scalars['DateTime']['output']>;
  files: Array<BankingFile>;
  id: Scalars['ID']['output'];
  retractedAt?: Maybe<Scalars['DateTime']['output']>;
  retractedByClientId?: Maybe<Scalars['ID']['output']>;
  retractedByName?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  transactionId: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** A page of transactions. `total` is the full match count so the UI can say 'showing N of total'. */
export type BankingTransactionPage = {
  __typename?: 'BankingTransactionPage';
  limit: Scalars['Int']['output'];
  offset: Scalars['Int']['output'];
  rows: Array<BankingTransaction>;
  total: Scalars['Int']['output'];
};

/** Whether the bank has settled the transaction */
export enum BankingTransactionStatus {
  Pending = 'PENDING',
  Posted = 'POSTED'
}

export type BankingTransactionsFilterInput = {
  accountIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  direction?: InputMaybe<BankingDirection>;
  from?: InputMaybe<Scalars['DateTime']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  period?: InputMaybe<BankingPeriod>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<BankingTransactionStatus>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Which way a figure moved against the previous closed month; NONE = nothing to compare */
export enum BankingTrend {
  Down = 'DOWN',
  Flat = 'FLAT',
  None = 'NONE',
  Up = 'UP'
}

export type BankingViewer = {
  __typename?: 'BankingViewer';
  clientId: Scalars['ID']['output'];
  email?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

/** What I have: cash + gold + bitcoin − what is owed to people, in AUD, USD and gold ounces */
export type BankingWealth = {
  __typename?: 'BankingWealth';
  accountsNotConverted: Scalars['Int']['output'];
  accountsWithoutBalance: Scalars['Int']['output'];
  cashAsOf?: Maybe<Scalars['DateTime']['output']>;
  /** The net position (AUD; foreign accounts converted or left out) */
  cashMinor: Scalars['Int']['output'];
  holdings: Array<BankingHoldingLine>;
  holdingsAudMinor?: Maybe<Scalars['Int']['output']>;
  owedToPeopleMinor: Scalars['Int']['output'];
  prices: Array<BankingPrice>;
  /** Assets with no stored price yet */
  pricesMissing: Array<Scalars['String']['output']>;
  /** cash − owed to people + holdings; null when a held asset has no price */
  totalAudMinor?: Maybe<Scalars['Int']['output']>;
  totalGoldOz?: Maybe<Scalars['Float']['output']>;
  totalUsdMinor?: Maybe<Scalars['Int']['output']>;
};

export type BankingWebhookDelivery = {
  __typename?: 'BankingWebhookDelivery';
  chunk?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deliveryId: Scalars['String']['output'];
  error?: Maybe<Scalars['String']['output']>;
  eventType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  processedAt?: Maybe<Scalars['DateTime']['output']>;
  receivedAt: Scalars['DateTime']['output'];
  tenantId: Scalars['String']['output'];
  totalChunks?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  verified: Scalars['Boolean']['output'];
};

export type BatchAdministrationResponse = {
  __typename?: 'BatchAdministrationResponse';
  count: Scalars['Float']['output'];
  success: Scalars['Boolean']['output'];
};

/** Frequency of bathing/showering */
export enum BathingFrequency {
  AlternateDays = 'ALTERNATE_DAYS',
  AsPreferred = 'AS_PREFERRED',
  Daily = 'DAILY',
  TwiceWeekly = 'TWICE_WEEKLY'
}

export type BdayGuest = {
  __typename?: 'BdayGuest';
  createdAt: Scalars['DateTime']['output'];
  dietaryRequirements?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  eveReminderSentAt?: Maybe<Scalars['DateTime']['output']>;
  firstName: Scalars['String']['output'];
  followUp1SentAt?: Maybe<Scalars['DateTime']['output']>;
  followUp2SentAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  inviteSentAt?: Maybe<Scalars['DateTime']['output']>;
  isFamily: Scalars['Boolean']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  plusOneNames?: Maybe<Array<Scalars['String']['output']>>;
  plusOnes: Scalars['Float']['output'];
  rsvpRespondedAt?: Maybe<Scalars['DateTime']['output']>;
  rsvpStatus: RsvpStatus;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  urlSlug: Scalars['String']['output'];
};

export type BdayGuestInput = {
  dietaryRequirements?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  isFamily?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  urlSlug: Scalars['String']['input'];
};

export type BdayStats = {
  __typename?: 'BdayStats';
  attending: Scalars['Float']['output'];
  invitesSent: Scalars['Float']['output'];
  maybe: Scalars['Float']['output'];
  notAttending: Scalars['Float']['output'];
  pending: Scalars['Float']['output'];
  totalGuests: Scalars['Float']['output'];
  totalHeadcount: Scalars['Float']['output'];
  totalPlusOnes: Scalars['Float']['output'];
};

export type BeginRosterBulkOpInput = {
  description: Scalars['String']['input'];
  expectedCount: Scalars['Int']['input'];
  kind: RosterBulkOpKind;
};

export type BehavioralConsiderations = {
  __typename?: 'BehavioralConsiderations';
  behaviorPattern?: Maybe<Scalars['String']['output']>;
  calmingStrategies?: Maybe<Array<Scalars['String']['output']>>;
  notes?: Maybe<Scalars['String']['output']>;
  safetyPrecautions?: Maybe<Array<Scalars['String']['output']>>;
  triggers?: Maybe<Array<Scalars['String']['output']>>;
};

export type BehavioralConsiderationsInput = {
  behaviorPattern?: InputMaybe<Scalars['String']['input']>;
  calmingStrategies?: InputMaybe<Array<Scalars['String']['input']>>;
  notes?: InputMaybe<Scalars['String']['input']>;
  safetyPrecautions?: InputMaybe<Array<Scalars['String']['input']>>;
  triggers?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type BehavioralUpdateInput = {
  calmingStrategies?: InputMaybe<Array<Scalars['String']['input']>>;
  notes?: InputMaybe<Scalars['String']['input']>;
  safetyPrecautions?: InputMaybe<Array<Scalars['String']['input']>>;
  triggers?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type Bill = {
  __typename?: 'Bill';
  acceptBankTransfer?: Maybe<Scalars['Boolean']['output']>;
  acceptCardPayment?: Maybe<Scalars['Boolean']['output']>;
  acceptCryptoPayment?: Maybe<Scalars['Boolean']['output']>;
  acceptTokenPayment?: Maybe<Scalars['Boolean']['output']>;
  /** amountTotal − amountPaid, floored at zero. */
  amountOutstanding: Scalars['Float']['output'];
  /** Sum of COMPLETED payment events. A PENDING bank transfer is not money in hand. */
  amountPaid: Scalars['Float']['output'];
  /** Sum of line items, before tax and discounts. */
  amountSubtotal: Scalars['Float']['output'];
  /** What the payer owes in total: subtotal + tax − token discount. This is the figure the card is charged. */
  amountTotal: Scalars['Float']['output'];
  bankAccountId?: Maybe<Scalars['String']['output']>;
  billToCompanyId?: Maybe<Scalars['ID']['output']>;
  billedTenantId?: Maybe<Scalars['ID']['output']>;
  billingPeriod?: Maybe<Scalars['String']['output']>;
  cancellationReason?: Maybe<Scalars['String']['output']>;
  cancelledAt?: Maybe<Scalars['DateTime']['output']>;
  /** True once payment has been received (isPaid, or any COMPLETED payment event) — the bill's client can no longer be changed. Derived, never stored; `status` (including CANCELLED) never locks. */
  clientEditLocked: Scalars['Boolean']['output'];
  clientId?: Maybe<Scalars['ID']['output']>;
  clientSnapshot?: Maybe<BillClientSnapshot>;
  companyId?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['DateTime']['output'];
  currency: BillCurrency;
  draftInvoiceId?: Maybe<Scalars['ID']['output']>;
  dueDate?: Maybe<Scalars['DateTime']['output']>;
  finalInvoiceId?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  isPaid: Scalars['Boolean']['output'];
  isSubscriptionBill?: Maybe<Scalars['Boolean']['output']>;
  issuedBy?: Maybe<Scalars['ID']['output']>;
  lineItems?: Maybe<Array<LineItem>>;
  paidAt?: Maybe<Scalars['DateTime']['output']>;
  paymentEvents?: Maybe<Array<PaymentEvent>>;
  paymentMethod?: Maybe<PaymentProvider>;
  /** Derived reporting bucket. Paid-ness wins over `status`, which has no PAID value — a paid bill routinely sits at SENT. */
  paymentState: BillPaymentState;
  paymentTerms?: Maybe<Scalars['String']['output']>;
  percentageOfTotal?: Maybe<Scalars['Float']['output']>;
  projectId?: Maybe<Scalars['ID']['output']>;
  sentAt?: Maybe<Scalars['DateTime']['output']>;
  showPaymentDetails?: Maybe<Scalars['Boolean']['output']>;
  status: BillStatus;
  subscriptionId?: Maybe<Scalars['ID']['output']>;
  subscriptionTokensIssuedAt?: Maybe<Scalars['DateTime']['output']>;
  subtotal?: Maybe<Scalars['Float']['output']>;
  taxAmount?: Maybe<Scalars['Float']['output']>;
  taxPercentage?: Maybe<Scalars['Float']['output']>;
  tenantId: Scalars['String']['output'];
  /** Payment terms and due date as they apply now: the bill's own, else the billing-settings defaults (a sent bill's due date counted from when it was sent; none on a cancelled bill). Frozen onto the bill when it is sent. Public on purpose — the payer reads them on /bill/:id. */
  terms: BillTermsView;
  tokenDiscountAmount?: Maybe<Scalars['Float']['output']>;
  tokenRedemptionId?: Maybe<Scalars['ID']['output']>;
  tokensApplied?: Maybe<Scalars['Int']['output']>;
  totalAmount?: Maybe<Scalars['Float']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type BillClientSnapshot = {
  __typename?: 'BillClientSnapshot';
  businessName?: Maybe<Scalars['String']['output']>;
  capturedAt?: Maybe<Scalars['DateTime']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  fName?: Maybe<Scalars['String']['output']>;
  lName?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
};

/** The currency for the bill */
export enum BillCurrency {
  Aud = 'AUD',
  Usd = 'USD'
}

export type BillInput = {
  acceptBankTransfer?: InputMaybe<Scalars['Boolean']['input']>;
  acceptCardPayment?: InputMaybe<Scalars['Boolean']['input']>;
  acceptCryptoPayment?: InputMaybe<Scalars['Boolean']['input']>;
  acceptTokenPayment?: InputMaybe<Scalars['Boolean']['input']>;
  bankAccountId?: InputMaybe<Scalars['String']['input']>;
  billToCompanyId?: InputMaybe<Scalars['ID']['input']>;
  billedTenantId?: InputMaybe<Scalars['ID']['input']>;
  billingPeriod?: InputMaybe<Scalars['String']['input']>;
  cancellationReason?: InputMaybe<Scalars['String']['input']>;
  clientId?: InputMaybe<Scalars['ID']['input']>;
  companyId?: InputMaybe<Scalars['ID']['input']>;
  currency?: BillCurrency;
  draftInvoiceId?: InputMaybe<Scalars['ID']['input']>;
  dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  finalInvoiceId?: InputMaybe<Scalars['ID']['input']>;
  isPaid: Scalars['Boolean']['input'];
  isSubscriptionBill?: InputMaybe<Scalars['Boolean']['input']>;
  issuedBy?: InputMaybe<Scalars['ID']['input']>;
  lineItems?: InputMaybe<Array<LineItemInput>>;
  paymentMethod?: InputMaybe<PaymentProvider>;
  paymentTerms?: InputMaybe<Scalars['String']['input']>;
  percentageOfTotal?: InputMaybe<Scalars['Float']['input']>;
  projectId?: InputMaybe<Scalars['ID']['input']>;
  showPaymentDetails?: InputMaybe<Scalars['Boolean']['input']>;
  status?: BillStatus;
  subscriptionId?: InputMaybe<Scalars['ID']['input']>;
  subtotal?: InputMaybe<Scalars['Float']['input']>;
  taxAmount?: InputMaybe<Scalars['Float']['input']>;
  taxPercentage?: InputMaybe<Scalars['Float']['input']>;
  tokenDiscountAmount?: InputMaybe<Scalars['Float']['input']>;
  tokensApplied?: InputMaybe<Scalars['Int']['input']>;
  totalAmount?: InputMaybe<Scalars['Float']['input']>;
};

/** How to resolve the billing notification recipient(s) */
export enum BillNotificationRecipientType {
  Admin = 'ADMIN',
  AllClients = 'ALL_CLIENTS',
  ClientTag = 'CLIENT_TAG',
  SpecificClient = 'SPECIFIC_CLIENT'
}

export type BillNotificationRule = {
  __typename?: 'BillNotificationRule';
  channels: Array<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  isEnabled: Scalars['Boolean']['output'];
  messageTemplate?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  recipientIds?: Maybe<Array<Scalars['String']['output']>>;
  recipientTag?: Maybe<Scalars['String']['output']>;
  recipientType: BillNotificationRecipientType;
  tenantId: Scalars['String']['output'];
  timing: BillNotificationTiming;
  timingMinutes?: Maybe<Scalars['Float']['output']>;
  trigger: BillNotificationTrigger;
  updatedAt: Scalars['DateTime']['output'];
};

/** When to send the billing notification relative to the trigger */
export enum BillNotificationTiming {
  Immediate = 'IMMEDIATE',
  MinutesAfter = 'MINUTES_AFTER',
  MinutesBefore = 'MINUTES_BEFORE'
}

/** Event that triggers the billing notification */
export enum BillNotificationTrigger {
  BankTransferConfirmed = 'BANK_TRANSFER_CONFIRMED',
  BankTransferSubmitted = 'BANK_TRANSFER_SUBMITTED',
  BillCancelled = 'BILL_CANCELLED',
  BillCreated = 'BILL_CREATED',
  BillOverdue = 'BILL_OVERDUE',
  BillPaid = 'BILL_PAID',
  BillSent = 'BILL_SENT',
  ChargeOnActivation = 'CHARGE_ON_ACTIVATION',
  PaymentMethodSaved = 'PAYMENT_METHOD_SAVED',
  PaymentReceived = 'PAYMENT_RECEIVED',
  PaymentReminder = 'PAYMENT_REMINDER',
  ProRataBillCreated = 'PRO_RATA_BILL_CREATED',
  SubscriptionCancelled = 'SUBSCRIPTION_CANCELLED',
  SubscriptionCreated = 'SUBSCRIPTION_CREATED',
  TokenPaymentApplied = 'TOKEN_PAYMENT_APPLIED'
}

export type BillPaymentResponse = {
  __typename?: 'BillPaymentResponse';
  clientSecret?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  paymentIntentId?: Maybe<Scalars['String']['output']>;
  requiresAction: Scalars['Boolean']['output'];
  success: Scalars['Boolean']['output'];
};

/** Derived, mutually-exclusive payment bucket for a bill. NOT BillStatus — BillStatus is the document lifecycle and has no PAID value, which is why a paid bill can sit at SENT. Paid-ness wins here. */
export enum BillPaymentState {
  AwaitingPayment = 'AWAITING_PAYMENT',
  Cancelled = 'CANCELLED',
  Draft = 'DRAFT',
  Overdue = 'OVERDUE',
  Paid = 'PAID',
  PartiallyPaid = 'PARTIALLY_PAID',
  Proposal = 'PROPOSAL'
}

/** The status of a payment event on a bill */
export enum BillPaymentStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Refunded = 'REFUNDED'
}

export type BillPdfDocumentPayload = {
  __typename?: 'BillPdfDocumentPayload';
  contentBase64: Scalars['String']['output'];
  /** Byte length of the decoded PDF */
  contentLength: Scalars['Int']['output'];
  filename: Scalars['String']['output'];
};

/** The status of the bill */
export enum BillStatus {
  Cancelled = 'CANCELLED',
  Draft = 'DRAFT',
  Proposal = 'PROPOSAL',
  Sent = 'SENT'
}

export type BillTermsView = {
  __typename?: 'BillTermsView';
  /** Date-only (T00:00:00.000Z = the Brisbane day). */
  dueDate?: Maybe<Scalars['DateTime']['output']>;
  /** BILL (set on this bill) · AFTER_SENDING (unsent; due dueDaysAfterSending days after it is sent) · DEFAULT (sent; the default counted from when it was sent) · NONE */
  dueDateSource: Scalars['String']['output'];
  dueDaysAfterSending?: Maybe<Scalars['Int']['output']>;
  paymentTerms?: Maybe<Scalars['String']['output']>;
  /** BILL (set on this bill) · DEFAULT (billing settings) · NONE */
  paymentTermsSource: Scalars['String']['output'];
};

export type BillingActionResult = {
  __typename?: 'BillingActionResult';
  errorCount: Scalars['Float']['output'];
  results: Array<BillingResultItem>;
  skippedCount: Scalars['Float']['output'];
  success: Scalars['Boolean']['output'];
  successCount: Scalars['Float']['output'];
  totalAmountCharged: Scalars['Float']['output'];
  totalProcessed: Scalars['Float']['output'];
};

export enum BillingInterval {
  Daily = 'DAILY',
  Monthly = 'MONTHLY',
  OneTime = 'ONE_TIME',
  Weekly = 'WEEKLY',
  Yearly = 'YEARLY'
}

export type BillingResultItem = {
  __typename?: 'BillingResultItem';
  amount?: Maybe<Scalars['Float']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  skippedReason?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  tenantId: Scalars['String']['output'];
  tenantName: Scalars['String']['output'];
};

export type BillingSubscription = {
  __typename?: 'BillingSubscription';
  accessUntil?: Maybe<Scalars['DateTime']['output']>;
  /** Always MANUAL today — auto-charge is not implemented. See SubscriptionBillingMode. */
  billingMode: SubscriptionBillingMode;
  /** Derived, Brisbane-anchored. What is OWED — never what will happen, because nothing happens on its own. */
  billingState: SubscriptionBillingState;
  canceledAt?: Maybe<Scalars['DateTime']['output']>;
  cancellationReason?: Maybe<Scalars['String']['output']>;
  client: Client;
  clientSecret?: Maybe<Scalars['String']['output']>;
  couponCode?: Maybe<Scalars['String']['output']>;
  couponDiscountAmount?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['DateTime']['output'];
  cyclesBilled?: Maybe<Scalars['Int']['output']>;
  cyclesTotal?: Maybe<Scalars['Int']['output']>;
  /** Whole Brisbane days the due date is past. Never negative. */
  daysOverdue?: Maybe<Scalars['Int']['output']>;
  discountCycles?: Maybe<Scalars['Int']['output']>;
  discountedUntil?: Maybe<Scalars['DateTime']['output']>;
  /** Brisbane calendar day (yyyy-MM-dd) the next bill is due. */
  dueDayBrisbane?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  listAmount?: Maybe<Scalars['Float']['output']>;
  nextBillingDate: Scalars['DateTime']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  pausedAt?: Maybe<Scalars['DateTime']['output']>;
  plan: SubscriptionPlan;
  startDate: Scalars['DateTime']['output'];
  status: SubscriptionStatus;
  stripeCustomerId?: Maybe<Scalars['String']['output']>;
  stripeSubscriptionId?: Maybe<Scalars['String']['output']>;
  subscriptionProductId?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  termCompletedAt?: Maybe<Scalars['DateTime']['output']>;
  trialEndsAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

/** Which IPFS-stored image slot to upload into for Bills emails */
export enum BillsBrandingPhotoField {
  Banner = 'BANNER',
  Profile = 'PROFILE',
  Signature = 'SIGNATURE'
}

export type BillsEmailBranding = {
  __typename?: 'BillsEmailBranding';
  accentColor?: Maybe<Scalars['String']['output']>;
  bannerImageCid?: Maybe<Scalars['String']['output']>;
  bannerImageUrl?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  ctaButtonStyle?: Maybe<CtaButtonStyle>;
  ctaButtonText?: Maybe<Scalars['String']['output']>;
  ctaButtonUrl?: Maybe<Scalars['String']['output']>;
  emailFont?: Maybe<EmailFont>;
  emailFooterText?: Maybe<Scalars['String']['output']>;
  emailStyle?: Maybe<EmailStyle>;
  hideSiteName?: Maybe<Scalars['Boolean']['output']>;
  hideTagline?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  penName?: Maybe<Scalars['String']['output']>;
  previewSampleBody?: Maybe<Scalars['String']['output']>;
  primaryColor?: Maybe<Scalars['String']['output']>;
  profilePhotoCid?: Maybe<Scalars['String']['output']>;
  profilePhotoSize?: Maybe<Scalars['Int']['output']>;
  profilePhotoUrl?: Maybe<Scalars['String']['output']>;
  secondaryColor?: Maybe<Scalars['String']['output']>;
  signatureImageCid?: Maybe<Scalars['String']['output']>;
  signatureImageUrl?: Maybe<Scalars['String']['output']>;
  socialIconStyle?: Maybe<SocialIconStyle>;
  socialLinks?: Maybe<TenantSocialLinks>;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type BillsEmailBrandingInput = {
  accentColor?: InputMaybe<Scalars['String']['input']>;
  bannerImageCid?: InputMaybe<Scalars['String']['input']>;
  ctaButtonStyle?: InputMaybe<CtaButtonStyle>;
  ctaButtonText?: InputMaybe<Scalars['String']['input']>;
  ctaButtonUrl?: InputMaybe<Scalars['String']['input']>;
  emailFont?: InputMaybe<EmailFont>;
  emailFooterText?: InputMaybe<Scalars['String']['input']>;
  emailStyle?: InputMaybe<EmailStyle>;
  hideSiteName?: InputMaybe<Scalars['Boolean']['input']>;
  hideTagline?: InputMaybe<Scalars['Boolean']['input']>;
  penName?: InputMaybe<Scalars['String']['input']>;
  previewSampleBody?: InputMaybe<Scalars['String']['input']>;
  primaryColor?: InputMaybe<Scalars['String']['input']>;
  profilePhotoCid?: InputMaybe<Scalars['String']['input']>;
  profilePhotoSize?: InputMaybe<Scalars['Int']['input']>;
  secondaryColor?: InputMaybe<Scalars['String']['input']>;
  signatureImageCid?: InputMaybe<Scalars['String']['input']>;
  socialIconStyle?: InputMaybe<SocialIconStyle>;
  socialLinks?: InputMaybe<TenantSocialLinksInput>;
};

export type BillsReport = {
  __typename?: 'BillsReport';
  /** Per issuer brand. Empty when no bill in the period names a company. */
  byBrand: Array<BillsReportBrandRow>;
  /** The single currency every amount on this report is denominated in. */
  currency: BillCurrency;
  generatedAt: Scalars['DateTime']['output'];
  metrics: Array<BillsReportMetric>;
  /** Caveats the reader must see — e.g. bills counted as paid with no known payment date. */
  notes: Array<Scalars['String']['output']>;
  /** EXCLUSIVE end — the UTC instant of Brisbane 00:00 after the last day. */
  periodEnd: Scalars['DateTime']['output'];
  /** Brisbane calendar day of the last day in the period (YYYY-MM-DD). */
  periodEndDay: Scalars['String']['output'];
  /** Inclusive start — the UTC instant of Brisbane 00:00 on the first day. */
  periodStart: Scalars['DateTime']['output'];
  /** Brisbane calendar day of periodStart (YYYY-MM-DD). */
  periodStartDay: Scalars['String']['output'];
  /** The business timezone every period boundary is anchored to. */
  timeZone: Scalars['String']['output'];
};

export type BillsReportBrandRow = {
  __typename?: 'BillsReportBrandRow';
  /** Bill.companyId; null for bills issued under the tenant's own company details. */
  brandId?: Maybe<Scalars['ID']['output']>;
  brandName: Scalars['String']['output'];
  metrics: Array<BillsReportMetric>;
  /** How this brand was identified. */
  source: Scalars['String']['output'];
};

export type BillsReportInput = {
  /** Bills are AUD or USD and the two must never be added together. Counts AND amounts are both restricted to this currency; anything excluded is declared in notes. */
  currency?: InputMaybe<BillCurrency>;
  /** Inclusive last Brisbane calendar day, YYYY-MM-DD. */
  endDay: Scalars['String']['input'];
  includeBrands?: InputMaybe<Scalars['Boolean']['input']>;
  /** Inclusive first Brisbane calendar day, YYYY-MM-DD. */
  startDay: Scalars['String']['input'];
};

export type BillsReportMetric = {
  __typename?: 'BillsReportMetric';
  /** Money total for this metric, in the report's currency. */
  amount: Scalars['Float']['output'];
  /** False when the underlying data cannot support this metric — render unavailableReason, not the zero. */
  available: Scalars['Boolean']['output'];
  count: Scalars['Int']['output'];
  /** Stable machine key, e.g. 'paid'. */
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  /** Which stored fields produced this figure, and which date field bucketed it into the period. Rendered under the tile. */
  source: Scalars['String']['output'];
  /** What is missing, in plain language, when available is false. */
  unavailableReason?: Maybe<Scalars['String']['output']>;
};

export type BillsReportingSettings = {
  __typename?: 'BillsReportingSettings';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  /** When a snapshot was last written for this tenant. */
  lastSnapshotAt?: Maybe<Scalars['DateTime']['output']>;
  /** How many complete weeks back the catch-up may fill in one pass (1-52). */
  snapshotBackfillWeeks: Scalars['Int']['output'];
  tenantId: Scalars['String']['output'];
  timeZone: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  weeklySnapshotEnabled: Scalars['Boolean']['output'];
};

export type BillsReportingSettingsInput = {
  snapshotBackfillWeeks?: InputMaybe<Scalars['Int']['input']>;
  weeklySnapshotEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BillsSettings = {
  __typename?: 'BillsSettings';
  createdAt: Scalars['DateTime']['output'];
  /** A bill is due this many days after it is sent. Unset = no default due date. */
  defaultDueDays?: Maybe<Scalars['Int']['output']>;
  /** Payment terms printed on every bill that doesn't set its own. */
  defaultPaymentTerms?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedByName?: Maybe<Scalars['String']['output']>;
};

export type BillsSettingsInput = {
  defaultDueDays?: InputMaybe<Scalars['Int']['input']>;
  defaultPaymentTerms?: InputMaybe<Scalars['String']['input']>;
};

export type BillsSnapshotMetric = {
  __typename?: 'BillsSnapshotMetric';
  amount: Scalars['Float']['output'];
  available: Scalars['Boolean']['output'];
  count: Scalars['Int']['output'];
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  source: Scalars['String']['output'];
  unavailableReason?: Maybe<Scalars['String']['output']>;
};

export type BillsWeeklySnapshot = {
  __typename?: 'BillsWeeklySnapshot';
  createdAt: Scalars['DateTime']['output'];
  generatedAt: Scalars['DateTime']['output'];
  /** True when the catch-up generated it rather than an operator pressing Generate. */
  generatedAutomatically: Scalars['Boolean']['output'];
  /** Client id of whoever triggered it; absent for the demand-driven catch-up. */
  generatedBy?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** ISO week label, e.g. 2026-W32. */
  isoWeek: Scalars['String']['output'];
  metrics: Array<BillsSnapshotMetric>;
  notes: Array<Scalars['String']['output']>;
  /** EXCLUSIVE. */
  periodEnd: Scalars['DateTime']['output'];
  periodStart: Scalars['DateTime']['output'];
  tenantId: Scalars['String']['output'];
  timeZone: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  /** Brisbane Sunday of the week, YYYY-MM-DD. */
  weekEndDay: Scalars['String']['output'];
  /** Brisbane Monday of the week, YYYY-MM-DD. Unique per tenant. */
  weekStartDay: Scalars['String']['output'];
};

export type BladderRecord = {
  __typename?: 'BladderRecord';
  autoProgressNote: Scalars['Boolean']['output'];
  catheterOutputMl?: Maybe<Scalars['Float']['output']>;
  catheterType?: Maybe<CatheterType>;
  createdAt: Scalars['DateTime']['output'];
  fluidIntakeMl?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  observedAt: Scalars['DateTime']['output'];
  padChanged: Scalars['Boolean']['output'];
  padType?: Maybe<PadType>;
  progressNoteId?: Maybe<Scalars['ID']['output']>;
  recordedBy: Scalars['ID']['output'];
  recordedByName?: Maybe<Scalars['String']['output']>;
  residentId: Scalars['ID']['output'];
  residentName?: Maybe<Scalars['String']['output']>;
  residentRoom?: Maybe<Scalars['String']['output']>;
  residentWing?: Maybe<Scalars['String']['output']>;
  status: ContinenceStatus;
  tenantId: Scalars['String']['output'];
  toiletingAssisted: Scalars['Boolean']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type BladderRecordFilterInput = {
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  residentId?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<ContinenceStatus>;
  wing?: InputMaybe<Scalars['String']['input']>;
};

export type BladderRecordsResponse = {
  __typename?: 'BladderRecordsResponse';
  limit: Scalars['Int']['output'];
  offset: Scalars['Int']['output'];
  records: Array<BladderRecord>;
  total: Scalars['Int']['output'];
};

export type BlogCategory = {
  __typename?: 'BlogCategory';
  color?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  parentId?: Maybe<Scalars['ID']['output']>;
  slug: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** How to determine who receives a blog notification */
export enum BlogNotificationRecipientType {
  AllAdmins = 'ALL_ADMINS',
  AllAuthors = 'ALL_AUTHORS',
  SpecificClients = 'SPECIFIC_CLIENTS'
}

export type BlogNotificationRule = {
  __typename?: 'BlogNotificationRule';
  channels: Array<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  isEnabled: Scalars['Boolean']['output'];
  messageTemplate?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  recipientIds?: Maybe<Array<Scalars['String']['output']>>;
  recipientType: BlogNotificationRecipientType;
  tenantId: Scalars['String']['output'];
  timing: BlogNotificationTiming;
  timingMinutes?: Maybe<Scalars['Int']['output']>;
  trigger: BlogNotificationTrigger;
  updatedAt: Scalars['DateTime']['output'];
};

/** When to send a blog notification relative to trigger */
export enum BlogNotificationTiming {
  Immediate = 'IMMEDIATE',
  MinutesAfter = 'MINUTES_AFTER'
}

/** Events that can trigger a blog notification */
export enum BlogNotificationTrigger {
  NewCommentReceived = 'NEW_COMMENT_RECEIVED',
  PollVoteReceived = 'POLL_VOTE_RECEIVED',
  PostArchived = 'POST_ARCHIVED',
  PostPublished = 'POST_PUBLISHED',
  PostUpdated = 'POST_UPDATED',
  ReactionMilestone = 'REACTION_MILESTONE',
  ViewMilestone = 'VIEW_MILESTONE'
}

export type BlogPost = {
  __typename?: 'BlogPost';
  aiChatEnabled: Scalars['Boolean']['output'];
  aiChatSeedQuestions?: Maybe<Array<Scalars['String']['output']>>;
  audioUrl?: Maybe<Scalars['String']['output']>;
  author?: Maybe<Scalars['String']['output']>;
  authorAvatarUrl?: Maybe<Scalars['String']['output']>;
  authorBio?: Maybe<Scalars['String']['output']>;
  bonusContent?: Maybe<Scalars['String']['output']>;
  bonusUnlockPercent?: Maybe<Scalars['Int']['output']>;
  categories?: Maybe<Array<Scalars['String']['output']>>;
  content: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  excerpt?: Maybe<Scalars['String']['output']>;
  featuredImage?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  leadFormId?: Maybe<Scalars['String']['output']>;
  leadMagnetDescription?: Maybe<Scalars['String']['output']>;
  leadMagnetTitle?: Maybe<Scalars['String']['output']>;
  metaDescription?: Maybe<Scalars['String']['output']>;
  metaTitle?: Maybe<Scalars['String']['output']>;
  ogImage?: Maybe<Scalars['String']['output']>;
  personalizationOptions?: Maybe<Array<PersonalizationOption>>;
  personalizationQuestion?: Maybe<Scalars['String']['output']>;
  pollOptions?: Maybe<Array<PollOption>>;
  pollQuestion?: Maybe<Scalars['String']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  readTime?: Maybe<Scalars['Int']['output']>;
  slug: Scalars['String']['output'];
  status: BlogPostStatus;
  subtitle?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  tenantId: Scalars['String']['output'];
  title: Scalars['String']['output'];
  toolCtaDescription?: Maybe<Scalars['String']['output']>;
  toolCtaText?: Maybe<Scalars['String']['output']>;
  toolCtaUrl?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  videoCid?: Maybe<Scalars['String']['output']>;
  videoCustomIframe?: Maybe<Scalars['String']['output']>;
  videoEmbedUrl?: Maybe<Scalars['String']['output']>;
  videoIpfsHash?: Maybe<Scalars['String']['output']>;
  videoProvider?: Maybe<BlogVideoProvider>;
  viewCount: Scalars['Int']['output'];
  visibility: BlogPostVisibility;
};

export type BlogPostFilterInput = {
  author?: InputMaybe<Scalars['String']['input']>;
  categoryId?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<BlogPostStatus>;
  tag?: InputMaybe<Scalars['String']['input']>;
  visibility?: InputMaybe<BlogPostVisibility>;
};

/** The publication status of a blog post */
export enum BlogPostStatus {
  Archived = 'ARCHIVED',
  Draft = 'DRAFT',
  Published = 'PUBLISHED'
}

export type BlogPostView = {
  __typename?: 'BlogPostView';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  personaChoice?: Maybe<Scalars['String']['output']>;
  postId: Scalars['ID']['output'];
  scrollDepth?: Maybe<Scalars['Int']['output']>;
  sessionId: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  viewedAt: Scalars['DateTime']['output'];
};

/** Who can view this blog post */
export enum BlogPostVisibility {
  Authenticated = 'AUTHENTICATED',
  Premium = 'PREMIUM',
  Public = 'PUBLIC'
}

export type BlogReaction = {
  __typename?: 'BlogReaction';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  postId: Scalars['ID']['output'];
  reactionType: BlogReactionType;
  sessionId: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type BlogReactionCounts = {
  __typename?: 'BlogReactionCounts';
  helpful: Scalars['Int']['output'];
  inspiring: Scalars['Int']['output'];
  notHelpful: Scalars['Int']['output'];
  postId: Scalars['ID']['output'];
  practical: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type BlogReactionInput = {
  postId: Scalars['ID']['input'];
  reactionType: BlogReactionType;
  sessionId: Scalars['String']['input'];
};

/** Types of reactions readers can leave on posts */
export enum BlogReactionType {
  Helpful = 'HELPFUL',
  Inspiring = 'INSPIRING',
  NotHelpful = 'NOT_HELPFUL',
  Practical = 'PRACTICAL'
}

/** Video hosting provider for embedded blog videos */
export enum BlogVideoProvider {
  Bitchute = 'BITCHUTE',
  CustomIframe = 'CUSTOM_IFRAME',
  Ipfs = 'IPFS',
  None = 'NONE',
  Rumble = 'RUMBLE',
  Vimeo = 'VIMEO',
  Youtube = 'YOUTUBE'
}

export type BloodPressureFilterInput = {
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  position?: InputMaybe<BpPosition>;
  residentId?: InputMaybe<Scalars['ID']['input']>;
  wing?: InputMaybe<Scalars['String']['input']>;
};

export type BloodPressureObservation = {
  __typename?: 'BloodPressureObservation';
  alertMessage?: Maybe<Scalars['String']['output']>;
  autoProgressNote: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  diastolic: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  position: BpPosition;
  progressNoteId?: Maybe<Scalars['ID']['output']>;
  residentId: Scalars['ID']['output'];
  residentName?: Maybe<Scalars['String']['output']>;
  residentRoom?: Maybe<Scalars['String']['output']>;
  residentWing?: Maybe<Scalars['String']['output']>;
  sourceAuthor?: Maybe<Scalars['String']['output']>;
  sourceBackupDate?: Maybe<Scalars['DateTime']['output']>;
  sourceContext?: Maybe<SarahObservationSourceContext>;
  sourceContextBackupDate?: Maybe<Scalars['DateTime']['output']>;
  sourceContextImportedAt?: Maybe<Scalars['DateTime']['output']>;
  sourceHash?: Maybe<Scalars['String']['output']>;
  sourceId?: Maybe<Scalars['String']['output']>;
  sourceSystem?: Maybe<Scalars['String']['output']>;
  systolic: Scalars['Int']['output'];
  takenAt: Scalars['DateTime']['output'];
  takenBy: Scalars['ID']['output'];
  takenByName?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  triggeredAlert: Scalars['Boolean']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type BloodPressureObservationsResponse = {
  __typename?: 'BloodPressureObservationsResponse';
  limit: Scalars['Int']['output'];
  observations: Array<BloodPressureObservation>;
  offset: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type BloodSugarFilterInput = {
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  residentId?: InputMaybe<Scalars['ID']['input']>;
  wing?: InputMaybe<Scalars['String']['input']>;
};

export type BloodSugarObservation = {
  __typename?: 'BloodSugarObservation';
  alertMessage?: Maybe<Scalars['String']['output']>;
  autoProgressNote: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  level: Scalars['Float']['output'];
  progressNoteId?: Maybe<Scalars['ID']['output']>;
  residentId: Scalars['ID']['output'];
  residentName?: Maybe<Scalars['String']['output']>;
  residentRoom?: Maybe<Scalars['String']['output']>;
  residentWing?: Maybe<Scalars['String']['output']>;
  sourceAuthor?: Maybe<Scalars['String']['output']>;
  sourceBackupDate?: Maybe<Scalars['DateTime']['output']>;
  sourceHash?: Maybe<Scalars['String']['output']>;
  sourceId?: Maybe<Scalars['String']['output']>;
  sourceSystem?: Maybe<Scalars['String']['output']>;
  takenAt: Scalars['DateTime']['output'];
  takenBy: Scalars['ID']['output'];
  takenByName?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  triggeredAlert: Scalars['Boolean']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type BloodSugarObservationsResponse = {
  __typename?: 'BloodSugarObservationsResponse';
  limit: Scalars['Int']['output'];
  observations: Array<BloodSugarObservation>;
  offset: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

/** Body location of wound */
export enum BodyLocation {
  Abdomen = 'ABDOMEN',
  Chest = 'CHEST',
  Coccyx = 'COCCYX',
  Face = 'FACE',
  Head = 'HEAD',
  LeftAnkle = 'LEFT_ANKLE',
  LeftButtock = 'LEFT_BUTTOCK',
  LeftElbow = 'LEFT_ELBOW',
  LeftFoot = 'LEFT_FOOT',
  LeftForearm = 'LEFT_FOREARM',
  LeftHand = 'LEFT_HAND',
  LeftHeel = 'LEFT_HEEL',
  LeftHip = 'LEFT_HIP',
  LeftKnee = 'LEFT_KNEE',
  LeftShin = 'LEFT_SHIN',
  LeftThigh = 'LEFT_THIGH',
  LeftUpperArm = 'LEFT_UPPER_ARM',
  LowerBack = 'LOWER_BACK',
  Neck = 'NECK',
  NotRecorded = 'NOT_RECORDED',
  Other = 'OTHER',
  RightAnkle = 'RIGHT_ANKLE',
  RightButtock = 'RIGHT_BUTTOCK',
  RightElbow = 'RIGHT_ELBOW',
  RightFoot = 'RIGHT_FOOT',
  RightForearm = 'RIGHT_FOREARM',
  RightHand = 'RIGHT_HAND',
  RightHeel = 'RIGHT_HEEL',
  RightHip = 'RIGHT_HIP',
  RightKnee = 'RIGHT_KNEE',
  RightShin = 'RIGHT_SHIN',
  RightThigh = 'RIGHT_THIGH',
  RightUpperArm = 'RIGHT_UPPER_ARM',
  Sacrum = 'SACRUM',
  UpperBack = 'UPPER_BACK'
}

export type Bond = {
  __typename?: 'Bond';
  /** Full bond amount charged */
  bondAmount: Scalars['Float']['output'];
  /** Bond amount from previous facility */
  bondFromPreviousFacility?: Maybe<Scalars['Float']['output']>;
  /** Bond interest account code */
  bondInterestAccount?: Maybe<Scalars['String']['output']>;
  /** Bond liability account code */
  bondLiabilityAccount?: Maybe<Scalars['String']['output']>;
  /** Government-set bond threshold */
  bondThreshold: Scalars['Float']['output'];
  /** Bond amount transferred to next facility */
  bondToNextFacility?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<Scalars['ID']['output']>;
  /** Current outstanding balance */
  currentBalance: Scalars['Float']['output'];
  /** Initial deposit amount */
  deposit: Scalars['Float']['output'];
  depositChequeDetails?: Maybe<ChequeDetails>;
  depositDate?: Maybe<Scalars['DateTime']['output']>;
  /** Was deposit paid by cheque */
  depositPaidByCheque?: Maybe<Scalars['Boolean']['output']>;
  /** Deposit receipt number */
  depositReceiptNumber?: Maybe<Scalars['String']['output']>;
  /** Day bond retention amounts cease */
  endDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  /** Interest rate (as decimal, e.g., 0.05 for 5%) */
  interestRate: Scalars['Float']['output'];
  /** Is bond fully paid */
  isFullyPaid: Scalars['Boolean']['output'];
  /** Maximum retention limit */
  maxRetentionLimit?: Maybe<Scalars['Float']['output']>;
  /** Monthly retention amount */
  monthlyRetentionAmount?: Maybe<Scalars['Float']['output']>;
  /** Next facility name */
  nextFacilityName?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  /** Has opening balance been created */
  openingBalanceCreated: Scalars['Boolean']['output'];
  /** Number of payments made */
  paymentCount: Scalars['Int']['output'];
  payments?: Maybe<Array<BondPayment>>;
  payout?: Maybe<BondPayout>;
  /** Previous facility name */
  previousFacilityName?: Maybe<Scalars['String']['output']>;
  residentId: Scalars['ID']['output'];
  retentions?: Maybe<Array<BondRetention>>;
  /** SarahCare interest rates in effect during this bond (Bond IntRates) */
  sarahInterestRateHistory?: Maybe<Array<BondSarahRateHistory>>;
  /** SarahCare bond thresholds in effect during this bond (Bond Threshholds) */
  sarahThresholdHistory?: Maybe<Array<BondSarahRateHistory>>;
  /** Who entered the bond in SarahCare */
  sourceAuthor?: Maybe<Scalars['String']['output']>;
  sourceBackupDate?: Maybe<Scalars['DateTime']['output']>;
  /** Original SarahCare Bond Residents columns */
  sourceFields?: Maybe<SarahBondSourceFields>;
  sourceHash?: Maybe<Scalars['String']['output']>;
  /** Bond Residents:<CustID> */
  sourceId?: Maybe<Scalars['String']['output']>;
  /** SARAHCARE when this bond is imported history (read-only) */
  sourceSystem?: Maybe<Scalars['String']['output']>;
  /** Opening balance (bond amount - deposit) */
  startBalance: Scalars['Float']['output'];
  /** Day interest starts being charged */
  startDate: Scalars['DateTime']['output'];
  status: BondStatus;
  tenantId: Scalars['String']['output'];
  /** Total interest accrued */
  totalInterestAccrued?: Maybe<Scalars['Float']['output']>;
  /** Total amount paid */
  totalPaid: Scalars['Float']['output'];
  /** Total retentions to date */
  totalRetentions?: Maybe<Scalars['Float']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy?: Maybe<Scalars['ID']['output']>;
};

export type BondInterestResult = {
  __typename?: 'BondInterestResult';
  calculatedAt: Scalars['DateTime']['output'];
  daysSinceLastPayment: Scalars['Int']['output'];
  interestAccrued: Scalars['Float']['output'];
  interestRate: Scalars['Float']['output'];
  lastPaymentDate?: Maybe<Scalars['DateTime']['output']>;
  principalOutstanding: Scalars['Float']['output'];
  totalOwing: Scalars['Float']['output'];
};

export type BondPayment = {
  __typename?: 'BondPayment';
  amount: Scalars['Float']['output'];
  /** Balance after this payment */
  balanceAfter?: Maybe<Scalars['Float']['output']>;
  /** Balance before this payment */
  balanceBefore?: Maybe<Scalars['Float']['output']>;
  chequeDetails?: Maybe<ChequeDetails>;
  createdAt: Scalars['DateTime']['output'];
  datePaid: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  /** Interest calculated at time of payment */
  interestAmount?: Maybe<Scalars['Float']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  paymentMethod: BondPaymentMethod;
  receiptNumber?: Maybe<Scalars['String']['output']>;
  recordedBy?: Maybe<Scalars['ID']['output']>;
  /** Original SarahCare Bond Payments columns */
  sourceFields?: Maybe<SarahBondPaymentSourceFields>;
  /** SarahCare Bond Payments PaymentID when this payment is SarahCare history */
  sourceId?: Maybe<Scalars['String']['output']>;
};

export type BondPaymentInput = {
  amount: Scalars['Float']['input'];
  chequeDetails?: InputMaybe<ChequeDetailsInput>;
  datePaid: Scalars['DateTime']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  paymentMethod: BondPaymentMethod;
};

/** Payment method for bond transactions */
export enum BondPaymentMethod {
  Bpay = 'BPAY',
  Cash = 'CASH',
  Cheque = 'CHEQUE',
  CreditCard = 'CREDIT_CARD',
  Eft = 'EFT',
  NotRecorded = 'NOT_RECORDED',
  Transfer = 'TRANSFER'
}

export type BondPayout = {
  __typename?: 'BondPayout';
  /** Total amount paid out */
  amount: Scalars['Float']['output'];
  /** Bank account for EFT */
  bankAccount?: Maybe<Scalars['String']['output']>;
  chequeDetails?: Maybe<ChequeDetails>;
  date: Scalars['DateTime']['output'];
  /** Reason for other deductions */
  deductionReason?: Maybe<Scalars['String']['output']>;
  /** Interest accrued to payout date */
  interestAccrued?: Maybe<Scalars['Float']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  /** Other deductions */
  otherDeductions?: Maybe<Scalars['Float']['output']>;
  /** Payee name */
  payeeName?: Maybe<Scalars['String']['output']>;
  paymentMethod: BondPaymentMethod;
  processedBy?: Maybe<Scalars['ID']['output']>;
  /** Total retentions deducted */
  retentionsDeducted?: Maybe<Scalars['Float']['output']>;
};

export type BondPayoutInput = {
  bankAccount?: InputMaybe<Scalars['String']['input']>;
  chequeDetails?: InputMaybe<ChequeDetailsInput>;
  date: Scalars['DateTime']['input'];
  deductionReason?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  otherDeductions?: InputMaybe<Scalars['Float']['input']>;
  payeeName?: InputMaybe<Scalars['String']['input']>;
  paymentMethod: BondPaymentMethod;
};

export type BondRegister = {
  __typename?: 'BondRegister';
  activeBonds: Scalars['Int']['output'];
  entries: Array<BondRegisterEntry>;
  totalBondAmount: Scalars['Float']['output'];
  totalDeposits: Scalars['Float']['output'];
  totalOutstanding: Scalars['Float']['output'];
};

export type BondRegisterEntry = {
  __typename?: 'BondRegisterEntry';
  bondAmount: Scalars['Float']['output'];
  bondId: Scalars['ID']['output'];
  currentBalance: Scalars['Float']['output'];
  deposit: Scalars['Float']['output'];
  interestAccrued?: Maybe<Scalars['Float']['output']>;
  residentId: Scalars['ID']['output'];
  residentName: Scalars['String']['output'];
  roomNumber?: Maybe<Scalars['String']['output']>;
  startDate: Scalars['DateTime']['output'];
  status: BondStatus;
  totalRetentions?: Maybe<Scalars['Float']['output']>;
};

export type BondRetention = {
  __typename?: 'BondRetention';
  amount: Scalars['Float']['output'];
  /** Running total of retentions */
  cumulativeRetention?: Maybe<Scalars['Float']['output']>;
  date: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  isPosted: Scalars['Boolean']['output'];
  /** Month number (1-60) */
  monthNumber: Scalars['Int']['output'];
  postedBy?: Maybe<Scalars['ID']['output']>;
  postedDate?: Maybe<Scalars['DateTime']['output']>;
  /** Invoice/transaction reference */
  transactionRef?: Maybe<Scalars['String']['output']>;
};

export type BondSarahRateHistory = {
  __typename?: 'BondSarahRateHistory';
  /** Effective from (SarahCare date text) */
  effectiveFromText: Scalars['String']['output'];
  /** Rate (decimal) or threshold (dollars) as SarahCare recorded it */
  value: Scalars['Float']['output'];
};

/** Status of a resident bond */
export enum BondStatus {
  Active = 'ACTIVE',
  PaidOut = 'PAID_OUT',
  PayingOut = 'PAYING_OUT',
  SarahcareHistory = 'SARAHCARE_HISTORY',
  TransferredIn = 'TRANSFERRED_IN',
  TransferredOut = 'TRANSFERRED_OUT'
}

export type BookEmpowermentCatchUpInput = {
  calendarId?: InputMaybe<Scalars['ID']['input']>;
  checkInId: Scalars['ID']['input'];
  durationMinutes: Scalars['Int']['input'];
  location?: InputMaybe<Scalars['String']['input']>;
  mode: EmpowermentCatchUpMode;
  scheduledStart: Scalars['String']['input'];
  sendPrepNote?: InputMaybe<Scalars['Boolean']['input']>;
  senderEmailAddressId?: InputMaybe<Scalars['ID']['input']>;
};

export type BookWaitingListTourInput = {
  /** Video call only: make a calendar event with a Meet room on your calendar (true), take it off (false), or leave it as it is (omitted) */
  createVideoInvite?: InputMaybe<Scalars['Boolean']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  /** When the tour is (a moment — the page sends Brisbane time) */
  scheduledAt: Scalars['DateTime']['input'];
  /** Login (client) id from waitingListAssignablePeople; omitted = the person booking it */
  shownById?: InputMaybe<Scalars['ID']['input']>;
  tourType: SiteTourType;
  /** Which of your calendars the video call goes on; omitted = your main calendar */
  videoCalendarId?: InputMaybe<Scalars['ID']['input']>;
};

export type BookableEventTypeStats = {
  __typename?: 'BookableEventTypeStats';
  cancelledBookings: Scalars['Float']['output'];
  confirmedBookings: Scalars['Float']['output'];
  currency: Scalars['String']['output'];
  totalBookings: Scalars['Float']['output'];
  totalRevenue: Scalars['Float']['output'];
};

export type Booking = {
  __typename?: 'Booking';
  bookingTime: Scalars['DateTime']['output'];
  cancellationReason?: Maybe<Scalars['String']['output']>;
  client: Client;
  createdAt: Scalars['DateTime']['output'];
  endTime?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  payment: BookingPayment;
  practitionerId?: Maybe<Scalars['String']['output']>;
  remindersSent: Array<Scalars['DateTime']['output']>;
  sendReminders: Scalars['Boolean']['output'];
  session?: Maybe<Session>;
  sessionType?: Maybe<SessionType>;
  startTime?: Maybe<Scalars['DateTime']['output']>;
  status: BookingStatus;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type BookingInput = {
  brand?: InputMaybe<Scalars['String']['input']>;
  clientId: Scalars['String']['input'];
  endTime?: InputMaybe<Scalars['DateTime']['input']>;
  payment?: InputMaybe<BookingPaymentInput>;
  practitionerId?: InputMaybe<Scalars['String']['input']>;
  returnUrl?: InputMaybe<Scalars['String']['input']>;
  sendReminders?: InputMaybe<Scalars['Boolean']['input']>;
  sessionId?: InputMaybe<Scalars['String']['input']>;
  sessionTypeId?: InputMaybe<Scalars['String']['input']>;
  startTime?: InputMaybe<Scalars['DateTime']['input']>;
};

export type BookingPayment = {
  __typename?: 'BookingPayment';
  amount: Scalars['Float']['output'];
  bankTransferReceipt?: Maybe<Scalars['String']['output']>;
  bankTransferReference?: Maybe<Scalars['String']['output']>;
  cryptoAmount?: Maybe<Scalars['String']['output']>;
  cryptoNetwork?: Maybe<Scalars['String']['output']>;
  cryptoToken?: Maybe<Scalars['String']['output']>;
  cryptoTransactionHash?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  method: BookingPaymentMethod;
  notes?: Maybe<Scalars['String']['output']>;
  paidAt?: Maybe<Scalars['DateTime']['output']>;
  status: BookingPaymentStatus;
  stripePaymentIntentId?: Maybe<Scalars['String']['output']>;
};

export type BookingPaymentInput = {
  amount: Scalars['Float']['input'];
  bankTransferReference?: InputMaybe<Scalars['String']['input']>;
  cryptoAmount?: InputMaybe<Scalars['String']['input']>;
  cryptoNetwork?: InputMaybe<Scalars['String']['input']>;
  cryptoToken?: InputMaybe<Scalars['String']['input']>;
  cryptoTransactionHash?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  method: BookingPaymentMethod;
  notes?: InputMaybe<Scalars['String']['input']>;
  stripePaymentIntentId?: InputMaybe<Scalars['String']['input']>;
};

/** Method of booking payment */
export enum BookingPaymentMethod {
  BankTransfer = 'BANK_TRANSFER',
  Crypto = 'CRYPTO',
  Other = 'OTHER',
  Stripe = 'STRIPE'
}

/** Status of the booking payment */
export enum BookingPaymentStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Processing = 'PROCESSING',
  Refunded = 'REFUNDED'
}

/** Status of the booking */
export enum BookingStatus {
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Confirmed = 'CONFIRMED',
  Pending = 'PENDING'
}

/** Types of influencer booking engagements */
export enum BookingType {
  Campaign = 'CAMPAIGN',
  Consultation = 'CONSULTATION',
  Content = 'CONTENT',
  Education = 'EDUCATION',
  Other = 'OTHER',
  Speaking = 'SPEAKING'
}

/** Bowel movement amount */
export enum BowelAmount {
  ExtraLarge = 'EXTRA_LARGE',
  Large = 'LARGE',
  Moderate = 'MODERATE',
  Small = 'SMALL'
}

export type BowelRecord = {
  __typename?: 'BowelRecord';
  abnormalities: Array<Scalars['String']['output']>;
  amount?: Maybe<BowelAmount>;
  autoProgressNote: Scalars['Boolean']['output'];
  bristolType?: Maybe<BristolStoolType>;
  color?: Maybe<StoolColor>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  /** SarahCare Incontinence tick (history only; null for records made here) */
  incontinent?: Maybe<Scalars['Boolean']['output']>;
  /** True for SarahCare history: read-only, never current work */
  isHistoricalRecord?: Maybe<Scalars['Boolean']['output']>;
  laxativeGiven: Scalars['Boolean']['output'];
  laxativeName?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  observedAt: Scalars['DateTime']['output'];
  /** SarahCare Pad Change tick (history only) */
  padChanged?: Maybe<Scalars['Boolean']['output']>;
  progressNoteId?: Maybe<Scalars['ID']['output']>;
  recordedBy: Scalars['ID']['output'];
  recordedByName?: Maybe<Scalars['String']['output']>;
  residentId: Scalars['ID']['output'];
  residentName?: Maybe<Scalars['String']['output']>;
  residentRoom?: Maybe<Scalars['String']['output']>;
  residentWing?: Maybe<Scalars['String']['output']>;
  result: BowelResult;
  /** SarahCare Self Toileted tick (history only) */
  selfToileted?: Maybe<Scalars['Boolean']['output']>;
  /** The SarahCare user who charted it */
  sourceAuthor?: Maybe<Scalars['String']['output']>;
  sourceBackupDate?: Maybe<Scalars['DateTime']['output']>;
  /** Original SarahCare columns (provenance only) */
  sourceFields?: Maybe<Array<ContinenceSourceField>>;
  sourceId?: Maybe<Scalars['String']['output']>;
  /** SARAHCARE for imported history; null for records made here */
  sourceSystem?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type BowelRecordFilterInput = {
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  residentId?: InputMaybe<Scalars['ID']['input']>;
  result?: InputMaybe<BowelResult>;
  /** true = only SarahCare history; false = only records made here */
  sarahHistory?: InputMaybe<Scalars['Boolean']['input']>;
  wing?: InputMaybe<Scalars['String']['input']>;
};

export type BowelRecordsResponse = {
  __typename?: 'BowelRecordsResponse';
  limit: Scalars['Int']['output'];
  offset: Scalars['Int']['output'];
  records: Array<BowelRecord>;
  total: Scalars['Int']['output'];
};

/** Bowel movement result */
export enum BowelResult {
  Constipated = 'CONSTIPATED',
  Diarrhoea = 'DIARRHOEA',
  Incontinent = 'INCONTINENT',
  Normal = 'NORMAL',
  NotRecorded = 'NOT_RECORDED',
  NoResult = 'NO_RESULT',
  Opened = 'OPENED'
}

export type BradenAssessment = {
  __typename?: 'BradenAssessment';
  activity: Scalars['Int']['output'];
  assessedBy: Scalars['ID']['output'];
  assessedByName?: Maybe<Scalars['String']['output']>;
  assessmentDate: Scalars['DateTime']['output'];
  autoProgressNote: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  frictionShear: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  mobility: Scalars['Int']['output'];
  moisture: Scalars['Int']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  nutrition: Scalars['Int']['output'];
  progressNoteId?: Maybe<Scalars['ID']['output']>;
  residentId: Scalars['ID']['output'];
  residentName?: Maybe<Scalars['String']['output']>;
  residentRoom?: Maybe<Scalars['String']['output']>;
  residentWing?: Maybe<Scalars['String']['output']>;
  riskCategory: Scalars['String']['output'];
  sensoryPerception: Scalars['Int']['output'];
  sourceAuthor?: Maybe<Scalars['String']['output']>;
  sourceBackupDate?: Maybe<Scalars['DateTime']['output']>;
  sourceHash?: Maybe<Scalars['String']['output']>;
  sourceId?: Maybe<Scalars['String']['output']>;
  sourceSystem?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  totalScore: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type BradenAssessmentFilterInput = {
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  residentId?: InputMaybe<Scalars['ID']['input']>;
  wing?: InputMaybe<Scalars['String']['input']>;
};

export type BradenAssessmentsResponse = {
  __typename?: 'BradenAssessmentsResponse';
  assessments: Array<BradenAssessment>;
  limit: Scalars['Int']['output'];
  offset: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

/** Which IPFS-stored image slot to upload into */
export enum BrandingPhotoField {
  Banner = 'BANNER',
  Profile = 'PROFILE',
  Signature = 'SIGNATURE'
}

export type BreakPeriod = {
  __typename?: 'BreakPeriod';
  durationMinutes: Scalars['Float']['output'];
  endTime: Scalars['DateTime']['output'];
  isPaid: Scalars['Boolean']['output'];
  startTime: Scalars['DateTime']['output'];
  type?: Maybe<Scalars['String']['output']>;
};

export type BreakPeriodInput = {
  durationMinutes: Scalars['Float']['input'];
  endTime: Scalars['DateTime']['input'];
  isPaid: Scalars['Boolean']['input'];
  startTime: Scalars['DateTime']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
};

export type BreakdownRow = {
  __typename?: 'BreakdownRow';
  deals: Scalars['Int']['output'];
  expected: Scalars['Float']['output'];
  key: Scalars['String']['output'];
  linkTo?: Maybe<Scalars['String']['output']>;
  owed: Scalars['Float']['output'];
  received: Scalars['Float']['output'];
};

/** Bristol Stool Chart types 1-7 */
export enum BristolStoolType {
  Type_1 = 'TYPE_1',
  Type_2 = 'TYPE_2',
  Type_3 = 'TYPE_3',
  Type_4 = 'TYPE_4',
  Type_5 = 'TYPE_5',
  Type_6 = 'TYPE_6',
  Type_7 = 'TYPE_7'
}

export type BroadcastDraft = {
  __typename?: 'BroadcastDraft';
  emailBody: Scalars['String']['output'];
  emailSubject: Scalars['String']['output'];
  smsCharCount: Scalars['Int']['output'];
  smsContent: Scalars['String']['output'];
  smsOverLimit: Scalars['Boolean']['output'];
};

export type BrowserStats = {
  __typename?: 'BrowserStats';
  browser: Scalars['String']['output'];
  percentage: Scalars['Float']['output'];
  sessions: Scalars['Int']['output'];
};

/** Time-period selector for food budget spend aggregation */
export enum BudgetPeriod {
  Custom = 'CUSTOM',
  Day = 'DAY',
  Fy = 'FY',
  Month = 'MONTH',
  Week = 'WEEK'
}

export type BuildAccessView = {
  __typename?: 'BuildAccessView';
  clientId: Scalars['String']['output'];
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  inviteOutcome?: Maybe<Scalars['String']['output']>;
  invitedAt?: Maybe<Scalars['DateTime']['output']>;
  invitedByName?: Maybe<Scalars['String']['output']>;
  lastOpenedAt?: Maybe<Scalars['DateTime']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
};

export type BuildContactView = {
  __typename?: 'BuildContactView';
  email?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  profileKey?: Maybe<Scalars['String']['output']>;
};

export type BuildCorrespondenceView = {
  __typename?: 'BuildCorrespondenceView';
  at: Scalars['DateTime']['output'];
  body?: Maybe<Scalars['String']['output']>;
  byName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  kind: Scalars['String']['output'];
  photoCount: Scalars['Int']['output'];
  recipients: Array<BuildUpdateRecipient>;
  stageLabel?: Maybe<Scalars['String']['output']>;
  subject: Scalars['String']['output'];
};

export type BuildEmailDraft = {
  __typename?: 'BuildEmailDraft';
  body: Scalars['String']['output'];
  subject: Scalars['String']['output'];
};

export type BuildEmailTemplatePreview = {
  __typename?: 'BuildEmailTemplatePreview';
  body: Scalars['String']['output'];
  subject: Scalars['String']['output'];
};

export type BuildEmailTemplateView = {
  __typename?: 'BuildEmailTemplateView';
  body: Scalars['String']['output'];
  isDefault: Scalars['Boolean']['output'];
  kind: Scalars['String']['output'];
  stageKey: Scalars['String']['output'];
  stageLabel: Scalars['String']['output'];
  subject: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedByName?: Maybe<Scalars['String']['output']>;
};

export type BuildInfo = {
  __typename?: 'BuildInfo';
  errors: Array<Scalars['String']['output']>;
  healthy: Scalars['Boolean']['output'];
  status: Scalars['String']['output'];
  warnings: Array<Scalars['String']['output']>;
};

export type BuildListItem = {
  __typename?: 'BuildListItem';
  address?: Maybe<Scalars['String']['output']>;
  bucket: Scalars['String']['output'];
  clientCount: Scalars['Int']['output'];
  clientName?: Maybe<Scalars['String']['output']>;
  daysOver: Scalars['Int']['output'];
  dealId: Scalars['ID']['output'];
  dealNumber?: Maybe<Scalars['String']['output']>;
  lastContactAt?: Maybe<Scalars['DateTime']['output']>;
  lastUpdateAt?: Maybe<Scalars['DateTime']['output']>;
  progressPercent: Scalars['Int']['output'];
  stageLabel?: Maybe<Scalars['String']['output']>;
  unreadClientMessages: Scalars['Int']['output'];
  updateCount: Scalars['Int']['output'];
};

export type BuildMessageView = {
  __typename?: 'BuildMessageView';
  body: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  fromKind: Scalars['String']['output'];
  fromName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  mine: Scalars['Boolean']['output'];
  seenAt?: Maybe<Scalars['DateTime']['output']>;
  toldTo: Array<BuildUpdateRecipient>;
};

export type BuildNotifyOutcome = {
  __typename?: 'BuildNotifyOutcome';
  emailSent: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  problem?: Maybe<Scalars['String']['output']>;
  smsSent: Scalars['Boolean']['output'];
};

export type BuildPortalSettings = {
  __typename?: 'BuildPortalSettings';
  coordinatorKey?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  pipedriveWriteBack: Scalars['Boolean']['output'];
  tenantId: Scalars['String']['output'];
  updateEveryDays: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type BuildPortalSettingsInput = {
  coordinatorKey?: InputMaybe<Scalars['String']['input']>;
  pipedriveWriteBack?: InputMaybe<Scalars['Boolean']['input']>;
  updateEveryDays?: InputMaybe<Scalars['Int']['input']>;
};

export type BuildProjectEntryView = {
  __typename?: 'BuildProjectEntryView';
  byName?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  file?: Maybe<BuildUpdateFile>;
  id: Scalars['ID']['output'];
  kind: Scalars['String']['output'];
  recipients: Array<BuildUpdateRecipient>;
  sendToClient?: Maybe<Scalars['Boolean']['output']>;
  stageKey: Scalars['String']['output'];
  stageLabel?: Maybe<Scalars['String']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type BuildProjectStageView = {
  __typename?: 'BuildProjectStageView';
  blurb: Scalars['String']['output'];
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  noteCount: Scalars['Int']['output'];
  photoCount: Scalars['Int']['output'];
  state: Scalars['String']['output'];
  trackerStage?: Maybe<Scalars['String']['output']>;
};

export type BuildProjectView = {
  __typename?: 'BuildProjectView';
  address?: Maybe<Scalars['String']['output']>;
  builder?: Maybe<BuildContactView>;
  builderDraft: BuildEmailDraft;
  builderEmails: Array<BuildCorrespondenceView>;
  builderFollowUpDue: Scalars['Boolean']['output'];
  client?: Maybe<BuildContactView>;
  clientCount: Scalars['Int']['output'];
  clientDraft: BuildEmailDraft;
  clientEmails: Array<BuildCorrespondenceView>;
  clientName?: Maybe<Scalars['String']['output']>;
  contactBucket: Scalars['String']['output'];
  coordinatorName?: Maybe<Scalars['String']['output']>;
  dealId: Scalars['ID']['output'];
  dealNumber?: Maybe<Scalars['String']['output']>;
  entries: Array<BuildProjectEntryView>;
  lastContactAt?: Maybe<Scalars['DateTime']['output']>;
  nextStageKey?: Maybe<Scalars['String']['output']>;
  nextStageLabel?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  notesUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  notesUpdatedByName?: Maybe<Scalars['String']['output']>;
  propertyFile?: Maybe<BuildUpdateFile>;
  stageCount: Scalars['Int']['output'];
  stageDrafts: Array<BuildStageDraft>;
  stageKey?: Maybe<Scalars['String']['output']>;
  stageLabel?: Maybe<Scalars['String']['output']>;
  stageNumber: Scalars['Int']['output'];
  stages: Array<BuildProjectStageView>;
  trackerStage?: Maybe<Scalars['String']['output']>;
};

export type BuildResearchBaseInput = {
  baseId: Scalars['ID']['input'];
  force?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type BuildSendResult = {
  __typename?: 'BuildSendResult';
  outcomes: Array<BuildUpdateRecipient>;
  summary: Scalars['String']['output'];
};

export type BuildServiceStatus = {
  __typename?: 'BuildServiceStatus';
  active: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type BuildStageDraft = {
  __typename?: 'BuildStageDraft';
  body: Scalars['String']['output'];
  isCurrent: Scalars['Boolean']['output'];
  isDefault: Scalars['Boolean']['output'];
  kind: Scalars['String']['output'];
  stageKey: Scalars['String']['output'];
  stageLabel: Scalars['String']['output'];
  stageNumber: Scalars['Int']['output'];
  subject: Scalars['String']['output'];
};

export type BuildStageView = {
  __typename?: 'BuildStageView';
  blurb: Scalars['String']['output'];
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  state: Scalars['String']['output'];
};

export type BuildStatusResult = {
  __typename?: 'BuildStatusResult';
  build: BuildInfo;
  error?: Maybe<Scalars['String']['output']>;
  lastChecked: Scalars['String']['output'];
  service: BuildServiceStatus;
  siteId: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type BuildTeamMemberView = {
  __typename?: 'BuildTeamMemberView';
  name: Scalars['String']['output'];
  photoCid?: Maybe<Scalars['String']['output']>;
  photoUrl?: Maybe<Scalars['String']['output']>;
  profileKey?: Maybe<Scalars['String']['output']>;
  role: Scalars['String']['output'];
};

export type BuildTeamProfile = {
  __typename?: 'BuildTeamProfile';
  bio?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  kind: Scalars['String']['output'];
  matchNames: Array<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  photoCid?: Maybe<Scalars['String']['output']>;
  photoUrl?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  website?: Maybe<Scalars['String']['output']>;
};

export type BuildTeamProfileInput = {
  bio?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  kind?: InputMaybe<Scalars['String']['input']>;
  matchNames?: InputMaybe<Array<Scalars['String']['input']>>;
  name: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  photoCid?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type BuildUpdateEdit = {
  __typename?: 'BuildUpdateEdit';
  at: Scalars['DateTime']['output'];
  byId?: Maybe<Scalars['String']['output']>;
  byName?: Maybe<Scalars['String']['output']>;
  changes: Array<Scalars['String']['output']>;
  clientsNotified: Scalars['Boolean']['output'];
  sentTo: Array<BuildUpdateRecipient>;
};

export type BuildUpdateFile = {
  __typename?: 'BuildUpdateFile';
  fileName?: Maybe<Scalars['String']['output']>;
  fileSize?: Maybe<Scalars['Int']['output']>;
  ipfsCid: Scalars['String']['output'];
  mimeType?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type BuildUpdateFileInput = {
  fileName?: InputMaybe<Scalars['String']['input']>;
  fileSize?: InputMaybe<Scalars['Int']['input']>;
  ipfsCid: Scalars['String']['input'];
  mimeType?: InputMaybe<Scalars['String']['input']>;
};

export type BuildUpdatePipedriveNote = {
  __typename?: 'BuildUpdatePipedriveNote';
  at: Scalars['DateTime']['output'];
  detail?: Maybe<Scalars['String']['output']>;
  noteId?: Maybe<Scalars['String']['output']>;
  outcome: Scalars['String']['output'];
};

export type BuildUpdateRecipient = {
  __typename?: 'BuildUpdateRecipient';
  address?: Maybe<Scalars['String']['output']>;
  at: Scalars['DateTime']['output'];
  channel: Scalars['String']['output'];
  clientId?: Maybe<Scalars['String']['output']>;
  detail?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  outcome: Scalars['String']['output'];
};

export type BuildUpdateView = {
  __typename?: 'BuildUpdateView';
  body?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  editedAt?: Maybe<Scalars['DateTime']['output']>;
  edits: Array<BuildUpdateEdit>;
  id: Scalars['ID']['output'];
  photos: Array<BuildUpdateFile>;
  pipedriveNote?: Maybe<BuildUpdatePipedriveNote>;
  postedByName?: Maybe<Scalars['String']['output']>;
  readByMe: Scalars['Boolean']['output'];
  readByNames: Array<Scalars['String']['output']>;
  report?: Maybe<BuildUpdateFile>;
  sentTo: Array<BuildUpdateRecipient>;
  stageKey?: Maybe<Scalars['String']['output']>;
  stageLabel?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type BuildView = {
  __typename?: 'BuildView';
  address?: Maybe<Scalars['String']['output']>;
  clientCount: Scalars['Int']['output'];
  clientName?: Maybe<Scalars['String']['output']>;
  dealClientEmail?: Maybe<Scalars['String']['output']>;
  dealClientPhone?: Maybe<Scalars['String']['output']>;
  dealId: Scalars['ID']['output'];
  dealNumber?: Maybe<Scalars['String']['output']>;
  nextStageLabel?: Maybe<Scalars['String']['output']>;
  practicalCompletionDue?: Maybe<Scalars['String']['output']>;
  progressPercent: Scalars['Int']['output'];
  stageCount: Scalars['Int']['output'];
  stageKey?: Maybe<Scalars['String']['output']>;
  stageLabel?: Maybe<Scalars['String']['output']>;
  stageNumber: Scalars['Int']['output'];
  stages: Array<BuildStageView>;
  team: Array<BuildTeamMemberView>;
  updates: Array<BuildUpdateView>;
  viewerIsStaff: Scalars['Boolean']['output'];
};

export type BulkCreateMealPlanInput = {
  meals: Array<MealPlanItemInput>;
  shiftId: Scalars['ID']['input'];
};

export type BulkCreateP2ChargeInput = {
  amount: Scalars['Float']['input'];
  campaignId: Scalars['ID']['input'];
  currency?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  pledgeIds: Array<Scalars['ID']['input']>;
};

export type BulkCreateP2DeliveryUpdateInput = {
  campaignId: Scalars['ID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  pledgeIds: Array<Scalars['ID']['input']>;
  status: P2DeliveryStatus;
};

export type BulkDeploymentResult = {
  __typename?: 'BulkDeploymentResult';
  failedDeployments: Scalars['Float']['output'];
  moduleId: Scalars['String']['output'];
  results: Array<DeploymentResult>;
  successfulDeployments: Scalars['Float']['output'];
  totalTenants: Scalars['Float']['output'];
};

export type BulkGrantBankingViewersInput = {
  accountIds: Array<Scalars['ID']['input']>;
  clientIds: Array<Scalars['ID']['input']>;
};

export type BulkHolidayNotWorkedResult = {
  __typename?: 'BulkHolidayNotWorkedResult';
  /** Already carried the public-holiday absence — left alone. */
  alreadyMarked: Scalars['Int']['output'];
  assignmentsMarked: Scalars['Int']['output'];
  /** The Brisbane day that was processed (YYYY-MM-DD). */
  dayKey: Scalars['String']['output'];
  shiftsMatched: Scalars['Int']['output'];
  /** Human-readable list of what was skipped and why, so the caller reports the truth. */
  skipped: Array<Scalars['String']['output']>;
  /** Already on other leave (annual/sick) — deliberately NOT rewritten. */
  skippedHadOtherAbsence: Scalars['Int']['output'];
};

export type BulkImportResult = {
  __typename?: 'BulkImportResult';
  errors: Array<Scalars['String']['output']>;
  failureCount: Scalars['Float']['output'];
  successCount: Scalars['Float']['output'];
};

export type BulkIngredientInput = {
  category: IngredientCategory;
  defaultUnit?: InputMaybe<UnitType>;
  minOrderQty?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  supplierName?: InputMaybe<Scalars['String']['input']>;
  supplierSku?: InputMaybe<Scalars['String']['input']>;
  unitCost?: InputMaybe<Scalars['Float']['input']>;
};

export type BulkReplaceRecipeIngredientInput = {
  ingredientName: Scalars['String']['input'];
  isOptional?: InputMaybe<Scalars['Boolean']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  quantity: Scalars['Float']['input'];
  sortOrder?: InputMaybe<Scalars['Float']['input']>;
  unit: UnitType;
};

export type BulkReplaceRecipeIngredientsResult = {
  __typename?: 'BulkReplaceRecipeIngredientsResult';
  created: Scalars['Float']['output'];
  errors: Array<Scalars['String']['output']>;
  ingredients: Array<RecipeIngredient>;
  replaced: Scalars['Float']['output'];
  skipped: Scalars['Float']['output'];
};

export type BulkSendResult = {
  __typename?: 'BulkSendResult';
  errors: Array<Scalars['String']['output']>;
  failed: Scalars['Int']['output'];
  sent: Scalars['Int']['output'];
};

export type BulkShiftResult = {
  __typename?: 'BulkShiftResult';
  created: Scalars['Float']['output'];
  skippedDays: Scalars['Float']['output'];
};

export type BulkUpsertIngredientInput = {
  category: IngredientCategory;
  defaultUnit?: InputMaybe<UnitType>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  minOrderQty?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  shelfLifeDays?: InputMaybe<Scalars['Int']['input']>;
  storageInstructions?: InputMaybe<Scalars['String']['input']>;
  supplierId?: InputMaybe<Scalars['ID']['input']>;
  supplierSku?: InputMaybe<Scalars['String']['input']>;
  unitCost?: InputMaybe<Scalars['Float']['input']>;
};

export type BulkUpsertResult = {
  __typename?: 'BulkUpsertResult';
  created: Scalars['Int']['output'];
  errors: Array<BulkUpsertRowError>;
  ingredients: Array<Ingredient>;
  skipped: Scalars['Int']['output'];
  updated: Scalars['Int']['output'];
};

export type BulkUpsertRowError = {
  __typename?: 'BulkUpsertRowError';
  message: Scalars['String']['output'];
  rowIndex: Scalars['Int']['output'];
  rowName?: Maybe<Scalars['String']['output']>;
};

export type BusinessCalendar = {
  __typename?: 'BusinessCalendar';
  allowPublicBooking: Scalars['Boolean']['output'];
  audienceShares?: Maybe<Array<CalendarAudienceShare>>;
  bookingConfirmationEmailTemplate?: Maybe<Scalars['String']['output']>;
  bookingPageBranding?: Maybe<Scalars['JSONObject']['output']>;
  bookingPageDescription?: Maybe<Scalars['String']['output']>;
  bookingPageLogo?: Maybe<Scalars['String']['output']>;
  bookingPageProfilePhoto?: Maybe<Scalars['String']['output']>;
  bookingPageProfilePhotoCid?: Maybe<Scalars['String']['output']>;
  bookingPageSlug?: Maybe<Scalars['String']['output']>;
  bookingPageTitle?: Maybe<Scalars['String']['output']>;
  bookingReminderEmailTemplate?: Maybe<Scalars['String']['output']>;
  caldavUrl?: Maybe<Scalars['String']['output']>;
  color?: Maybe<Scalars['String']['output']>;
  companyId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deactivatedAt?: Maybe<Scalars['DateTime']['output']>;
  deactivatedReason?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  displayOrder: Scalars['Float']['output'];
  eventCount?: Maybe<Scalars['Int']['output']>;
  iCalUrl?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  isPublic: Scalars['Boolean']['output'];
  lastEventAt?: Maybe<Scalars['DateTime']['output']>;
  lastPublicBookingAt?: Maybe<Scalars['DateTime']['output']>;
  linkedEmailAddressId?: Maybe<Scalars['String']['output']>;
  linkedModules?: Maybe<Array<Scalars['String']['output']>>;
  moduleData?: Maybe<Scalars['JSONObject']['output']>;
  name: Scalars['String']['output'];
  ownerType?: Maybe<Scalars['String']['output']>;
  projectId?: Maybe<Scalars['String']['output']>;
  publicUrl?: Maybe<Scalars['String']['output']>;
  requirePaymentUpfront: Scalars['Boolean']['output'];
  responsibleOwnerId?: Maybe<Scalars['String']['output']>;
  sendBookingConfirmations: Scalars['Boolean']['output'];
  sendBookingReminders: Scalars['Boolean']['output'];
  settings?: Maybe<CalendarSettings>;
  sharedAt?: Maybe<Scalars['DateTime']['output']>;
  sharedFromEmail?: Maybe<Scalars['String']['output']>;
  sharedFromName?: Maybe<Scalars['String']['output']>;
  shares?: Maybe<Array<CalendarShare>>;
  slug?: Maybe<Scalars['String']['output']>;
  syncInfo?: Maybe<CalendarSyncInfo>;
  tenantId: Scalars['String']['output'];
  totalEvents: Scalars['Float']['output'];
  totalPublicBookings: Scalars['Float']['output'];
  type: CalendarType;
  upcomingEvents: Scalars['Float']['output'];
  updatedAt: Scalars['DateTime']['output'];
  visibility: CalendarVisibility;
};

export type BusinessCalendarAvailability = {
  __typename?: 'BusinessCalendarAvailability';
  blockedDates?: Maybe<Array<Scalars['DateTime']['output']>>;
  calendarId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  extraAvailableDates?: Maybe<Array<Scalars['DateTime']['output']>>;
  id: Scalars['ID']['output'];
  slots: Array<BusinessCalendarAvailabilitySlot>;
  tenantId: Scalars['String']['output'];
  timezone: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type BusinessCalendarAvailabilitySlot = {
  __typename?: 'BusinessCalendarAvailabilitySlot';
  dayOfWeek: Scalars['Float']['output'];
  endTime: Scalars['String']['output'];
  startTime: Scalars['String']['output'];
};

export type BusinessCalendarAvailabilitySlotInput = {
  dayOfWeek: Scalars['Float']['input'];
  endTime: Scalars['String']['input'];
  startTime: Scalars['String']['input'];
};

export type BusinessCalendarBookableEventType = {
  __typename?: 'BusinessCalendarBookableEventType';
  allowedDaysOfWeek?: Maybe<Array<Scalars['Int']['output']>>;
  autoGenerateMeetingLink: Scalars['Boolean']['output'];
  bufferAfterMinutes: Scalars['Float']['output'];
  bufferBeforeMinutes: Scalars['Float']['output'];
  calendarId: Scalars['String']['output'];
  color?: Maybe<Scalars['String']['output']>;
  confirmationMessage?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  displayOrder: Scalars['Float']['output'];
  durationMinutes: Scalars['Float']['output'];
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  isPaid: Scalars['Boolean']['output'];
  lastBookedAt?: Maybe<Scalars['DateTime']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  locationType?: Maybe<Scalars['String']['output']>;
  maxBookingsPerDay?: Maybe<Scalars['Float']['output']>;
  maxFutureDays: Scalars['Float']['output'];
  meetingLink?: Maybe<Scalars['String']['output']>;
  minNoticeHours: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  price?: Maybe<Scalars['Float']['output']>;
  questions?: Maybe<Array<BusinessCalendarBookingQuestion>>;
  reminderHoursBefore: Scalars['Float']['output'];
  stripePriceId?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  totalBookings: Scalars['Float']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type BusinessCalendarBookingQuestion = {
  __typename?: 'BusinessCalendarBookingQuestion';
  id: Scalars['String']['output'];
  options?: Maybe<Array<Scalars['String']['output']>>;
  question: Scalars['String']['output'];
  required: Scalars['Boolean']['output'];
  type: Scalars['String']['output'];
};

export type BusinessCalendarBookingQuestionInput = {
  id: Scalars['String']['input'];
  options?: InputMaybe<Array<Scalars['String']['input']>>;
  question: Scalars['String']['input'];
  required: Scalars['Boolean']['input'];
  type: Scalars['String']['input'];
};

export type BusinessCalendarInput = {
  allowPublicBooking?: InputMaybe<Scalars['Boolean']['input']>;
  bookingConfirmationEmailTemplate?: InputMaybe<Scalars['String']['input']>;
  bookingPageBranding?: InputMaybe<Scalars['JSONObject']['input']>;
  bookingPageDescription?: InputMaybe<Scalars['String']['input']>;
  bookingPageLogo?: InputMaybe<Scalars['String']['input']>;
  bookingPageProfilePhoto?: InputMaybe<Scalars['String']['input']>;
  bookingPageProfilePhotoCid?: InputMaybe<Scalars['String']['input']>;
  bookingPageSlug?: InputMaybe<Scalars['String']['input']>;
  bookingPageTitle?: InputMaybe<Scalars['String']['input']>;
  bookingReminderEmailTemplate?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  companyId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  iCalUrl?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  linkedEmailAddressId?: InputMaybe<Scalars['String']['input']>;
  linkedModules?: InputMaybe<Array<Scalars['String']['input']>>;
  name: Scalars['String']['input'];
  projectId?: InputMaybe<Scalars['String']['input']>;
  requirePaymentUpfront?: InputMaybe<Scalars['Boolean']['input']>;
  sendBookingConfirmations?: InputMaybe<Scalars['Boolean']['input']>;
  sendBookingReminders?: InputMaybe<Scalars['Boolean']['input']>;
  settings?: InputMaybe<CalendarSettingsInput>;
  sharedFromEmail?: InputMaybe<Scalars['String']['input']>;
  sharedFromName?: InputMaybe<Scalars['String']['input']>;
  syncInfo?: InputMaybe<CalendarSyncInfoInput>;
  type: CalendarType;
  visibility?: InputMaybe<CalendarVisibility>;
};

export enum BusinessChatAnswerMode {
  Ai = 'AI',
  Search = 'SEARCH'
}

export type BusinessChatEnquiryInput = {
  email: Scalars['String']['input'];
  /** The business's slug (from /directory/:slug). */
  listingSlug: Scalars['String']['input'];
  message: Scalars['String']['input'];
  name: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  preferredContact?: InputMaybe<BusinessEnquiryPreferredContact>;
  sessionToken: Scalars['String']['input'];
  /** Honeypot — never shown to a person. A filled one is silently dropped. */
  website?: InputMaybe<Scalars['String']['input']>;
};

export type BusinessChatMessage = {
  __typename?: 'BusinessChatMessage';
  at: Scalars['DateTime']['output'];
  mode?: Maybe<BusinessChatAnswerMode>;
  role: BusinessChatRole;
  suggestedListingIds: Array<Scalars['String']['output']>;
  text: Scalars['String']['output'];
};

export type BusinessChatMessageInput = {
  /** The business page the chat was opened from. */
  listingSlug?: InputMaybe<Scalars['String']['input']>;
  message: Scalars['String']['input'];
  /** The token from the previous reply; omit to start a new chat. */
  sessionToken?: InputMaybe<Scalars['String']['input']>;
  /** Honeypot. */
  website?: InputMaybe<Scalars['String']['input']>;
};

export type BusinessChatReply = {
  __typename?: 'BusinessChatReply';
  /** A draft of the enquiry in the visitor's words, for them to check. */
  enquiryDraft?: Maybe<Scalars['String']['output']>;
  enquirySlug?: Maybe<Scalars['String']['output']>;
  mode: Scalars['String']['output'];
  readyToSend: Scalars['Boolean']['output'];
  reply: Scalars['String']['output'];
  sessionToken: Scalars['String']['output'];
  suggestions: Array<BusinessChatSuggestion>;
  turnsLeft: Scalars['Int']['output'];
};

export enum BusinessChatRole {
  Agent = 'AGENT',
  Visitor = 'VISITOR'
}

export type BusinessChatSession = {
  __typename?: 'BusinessChatSession';
  createdAt: Scalars['DateTime']['output'];
  enquiryId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  inputTokens: Scalars['Int']['output'];
  lastAiError?: Maybe<Scalars['String']['output']>;
  matchedListingIds: Array<Scalars['String']['output']>;
  messages: Array<BusinessChatMessage>;
  model?: Maybe<Scalars['String']['output']>;
  outputTokens: Scalars['Int']['output'];
  startedFromListingId?: Maybe<Scalars['String']['output']>;
  status: BusinessChatStatus;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  visitorTurns: Scalars['Int']['output'];
};

export enum BusinessChatStatus {
  HandedOff = 'HANDED_OFF',
  Open = 'OPEN'
}

export type BusinessChatSuggestion = {
  __typename?: 'BusinessChatSuggestion';
  acceptsEnquiries: Scalars['Boolean']['output'];
  category?: Maybe<Scalars['String']['output']>;
  detailUrl: Scalars['String']['output'];
  logoCid?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  suburb?: Maybe<Scalars['String']['output']>;
  tagline?: Maybe<Scalars['String']['output']>;
};

export enum BusinessDirectoryAction {
  ClaimApproved = 'CLAIM_APPROVED',
  ClaimRejected = 'CLAIM_REJECTED',
  ClaimRequested = 'CLAIM_REQUESTED',
  Created = 'CREATED',
  Deleted = 'DELETED',
  Edited = 'EDITED',
  EditedByAdmin = 'EDITED_BY_ADMIN',
  HiddenByAdmin = 'HIDDEN_BY_ADMIN',
  Imported = 'IMPORTED',
  Published = 'PUBLISHED',
  RestoredByAdmin = 'RESTORED_BY_ADMIN',
  Unpublished = 'UNPUBLISHED'
}

export type BusinessDirectoryActivity = {
  __typename?: 'BusinessDirectoryActivity';
  action: BusinessDirectoryAction;
  actorClientId?: Maybe<Scalars['String']['output']>;
  changes: Array<BusinessDirectoryFieldChange>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  listingId: Scalars['String']['output'];
  summary: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type BusinessDirectoryCategory = {
  __typename?: 'BusinessDirectoryCategory';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type BusinessDirectoryDashboard = {
  __typename?: 'BusinessDirectoryDashboard';
  agentEnquiries: Scalars['Int']['output'];
  aiInputTokens: Scalars['Int']['output'];
  aiOutputTokens: Scalars['Int']['output'];
  chatSessions: Scalars['Int']['output'];
  enquiries: Scalars['Int']['output'];
  formEnquiries: Scalars['Int']['output'];
  handOffs: Scalars['Int']['output'];
  listingStatsTotal: Scalars['Int']['output'];
  listings: Scalars['Int']['output'];
  liveListings: Scalars['Int']['output'];
  /** Listings with no email — enquiries go to the admins instead. A–Z, every one. */
  missingEmail: Array<BusinessListingGap>;
  /** Listings with no logo. A–Z, every one. */
  missingLogo: Array<BusinessListingGap>;
  /** Not delivered to the business (no email, or the send failed). */
  notDelivered: Scalars['Int']['output'];
  pendingClaims: Scalars['Int']['output'];
  /** Most enquiries first (a ranking, not a pick-list). Capped at 50 — see listingStatsTotal. */
  perListing: Array<BusinessDirectoryListingStat>;
  /** Accepted by the business's own email. */
  sentToBusiness: Scalars['Int']['output'];
  unclaimedListings: Scalars['Int']['output'];
  /** Oldest first; every week present, zeros included. */
  weeks: Array<BusinessDirectoryWeek>;
  weeksCovered: Scalars['Int']['output'];
};

export type BusinessDirectoryFieldChange = {
  __typename?: 'BusinessDirectoryFieldChange';
  field: Scalars['String']['output'];
  from?: Maybe<Scalars['String']['output']>;
  to?: Maybe<Scalars['String']['output']>;
};

export type BusinessDirectoryListingStat = {
  __typename?: 'BusinessDirectoryListingStat';
  agentEnquiries: Scalars['Int']['output'];
  enquiries: Scalars['Int']['output'];
  lastEnquiryAt?: Maybe<Scalars['DateTime']['output']>;
  listingId: Scalars['String']['output'];
  name: Scalars['String']['output'];
  slug?: Maybe<Scalars['String']['output']>;
  timesSuggested: Scalars['Int']['output'];
};

export enum BusinessDirectoryNotificationRecipientType {
  AllDirectoryAdmins = 'ALL_DIRECTORY_ADMINS',
  SpecificClient = 'SPECIFIC_CLIENT'
}

export type BusinessDirectoryNotificationRule = {
  __typename?: 'BusinessDirectoryNotificationRule';
  channels: Array<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  isEnabled: Scalars['Boolean']['output'];
  messageTemplate?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  recipientIds: Array<Scalars['String']['output']>;
  recipientType: BusinessDirectoryNotificationRecipientType;
  tenantId: Scalars['String']['output'];
  trigger: BusinessDirectoryNotificationTrigger;
  updatedAt: Scalars['DateTime']['output'];
};

export type BusinessDirectoryNotificationRuleInput = {
  channels: Array<Scalars['String']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  messageTemplate?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  recipientIds?: InputMaybe<Array<Scalars['String']['input']>>;
  recipientType: BusinessDirectoryNotificationRecipientType;
  trigger: BusinessDirectoryNotificationTrigger;
};

export enum BusinessDirectoryNotificationTrigger {
  ClaimRequested = 'CLAIM_REQUESTED',
  EnquiryReceived = 'ENQUIRY_RECEIVED',
  EnquirySentToBusiness = 'ENQUIRY_SENT_TO_BUSINESS'
}

export type BusinessDirectoryWeek = {
  __typename?: 'BusinessDirectoryWeek';
  agentEnquiries: Scalars['Int']['output'];
  chatSessions: Scalars['Int']['output'];
  formEnquiries: Scalars['Int']['output'];
  handOffs: Scalars['Int']['output'];
  /** Monday of the week, Brisbane calendar date (YYYY-MM-DD). */
  weekStart: Scalars['String']['output'];
};

export type BusinessEnquiry = {
  __typename?: 'BusinessEnquiry';
  channel: BusinessEnquiryChannel;
  chatSessionId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deliveries: Array<BusinessEnquiryDelivery>;
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  listingId: Scalars['String']['output'];
  listingName: Scalars['String']['output'];
  listingSlug?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  name: Scalars['String']['output'];
  outcome?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  preferredContact: BusinessEnquiryPreferredContact;
  status: BusinessEnquiryStatus;
  statusChangedAt?: Maybe<Scalars['DateTime']['output']>;
  statusNote?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export enum BusinessEnquiryChannel {
  Agent = 'AGENT',
  Form = 'FORM'
}

export type BusinessEnquiryDelivery = {
  __typename?: 'BusinessEnquiryDelivery';
  at: Scalars['DateTime']['output'];
  channel: Scalars['String']['output'];
  kind: BusinessEnquiryDeliveryKind;
  reason?: Maybe<Scalars['String']['output']>;
  recipient?: Maybe<Scalars['String']['output']>;
  recipientName: Scalars['String']['output'];
  status: BusinessEnquiryDeliveryStatus;
};

export enum BusinessEnquiryDeliveryKind {
  Admin = 'ADMIN',
  Business = 'BUSINESS',
  Rule = 'RULE'
}

export enum BusinessEnquiryDeliveryStatus {
  Failed = 'FAILED',
  Sent = 'SENT',
  Skipped = 'SKIPPED'
}

export type BusinessEnquiryFilterInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  listingId?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<BusinessEnquiryStatus>;
};

export type BusinessEnquiryInput = {
  email: Scalars['String']['input'];
  /** The business's slug (from /directory/:slug). */
  listingSlug: Scalars['String']['input'];
  message: Scalars['String']['input'];
  name: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  preferredContact?: InputMaybe<BusinessEnquiryPreferredContact>;
  /** Honeypot — never shown to a person. A filled one is silently dropped. */
  website?: InputMaybe<Scalars['String']['input']>;
};

export enum BusinessEnquiryPreferredContact {
  Email = 'EMAIL',
  Phone = 'PHONE',
  Sms = 'SMS'
}

/** What the visitor is told. No ids: an anonymous caller never learns record ids. */
export type BusinessEnquiryReceipt = {
  __typename?: 'BusinessEnquiryReceipt';
  message: Scalars['String']['output'];
  ok: Scalars['Boolean']['output'];
  sentToBusiness: Scalars['Boolean']['output'];
};

export enum BusinessEnquiryStatus {
  Closed = 'CLOSED',
  New = 'NEW',
  Replied = 'REPLIED',
  Sent = 'SENT'
}

export enum BusinessImportAction {
  Created = 'CREATED',
  Skipped = 'SKIPPED',
  Updated = 'UPDATED'
}

export type BusinessListing = {
  __typename?: 'BusinessListing';
  address?: Maybe<Scalars['String']['output']>;
  categories: Array<Scalars['String']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  claimDecidedAt?: Maybe<Scalars['DateTime']['output']>;
  claimDecisionReason?: Maybe<Scalars['String']['output']>;
  claimNote?: Maybe<Scalars['String']['output']>;
  claimRequestedAt?: Maybe<Scalars['DateTime']['output']>;
  claimStatus: BusinessListingClaimStatus;
  claimantName?: Maybe<Scalars['String']['output']>;
  claimedByClientId?: Maybe<Scalars['String']['output']>;
  contactName?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  email?: Maybe<Scalars['String']['output']>;
  featured: Scalars['Boolean']['output'];
  hiddenByAdmin: Scalars['Boolean']['output'];
  hiddenReason?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  importedAt?: Maybe<Scalars['DateTime']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  logoCid?: Maybe<Scalars['String']['output']>;
  memberSince?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  openingHours?: Maybe<Scalars['String']['output']>;
  ownerClientId: Scalars['String']['output'];
  ownerName?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  productsAndServices?: Maybe<Scalars['String']['output']>;
  published: Scalars['Boolean']['output'];
  slug: Scalars['String']['output'];
  socialLinks: Array<BusinessSocialLink>;
  sourceUrl?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  suburb?: Maybe<Scalars['String']['output']>;
  tagline?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  /** Imported and nobody has claimed it yet (no member behind it). */
  unclaimed: Scalars['Boolean']['output'];
  updatedAt: Scalars['DateTime']['output'];
  websiteUrl?: Maybe<Scalars['String']['output']>;
  whatWeOffer?: Maybe<Scalars['String']['output']>;
};

export enum BusinessListingClaimStatus {
  Approved = 'APPROVED',
  None = 'NONE',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export type BusinessListingGap = {
  __typename?: 'BusinessListingGap';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
};

export type BusinessListingImportOptions = {
  /** Add categories the tenant's list lacks. Default true. */
  addMissingCategories?: InputMaybe<Scalars['Boolean']['input']>;
  /** Report what WOULD happen; write nothing. Default false. */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update unclaimed listings already imported. Default true. */
  updateExisting?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BusinessListingImportOutcome = {
  __typename?: 'BusinessListingImportOutcome';
  action: BusinessImportAction;
  index: Scalars['Int']['output'];
  listingId?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  reason?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  warnings: Array<Scalars['String']['output']>;
};

export type BusinessListingImportResult = {
  __typename?: 'BusinessListingImportResult';
  /** Categories added to the tenant's list (A–Z). */
  categoriesAdded: Array<Scalars['String']['output']>;
  created: Scalars['Int']['output'];
  dryRun: Scalars['Boolean']['output'];
  outcomes: Array<BusinessListingImportOutcome>;
  skipped: Scalars['Int']['output'];
  updated: Scalars['Int']['output'];
};

export type BusinessListingImportRow = {
  address?: InputMaybe<Scalars['String']['input']>;
  categories?: InputMaybe<Array<Scalars['String']['input']>>;
  contactName?: InputMaybe<Scalars['String']['input']>;
  /** An address that isn't an email is dropped with a warning, not refused. */
  email?: InputMaybe<Scalars['String']['input']>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  logoCid?: InputMaybe<Scalars['String']['input']>;
  /** YYYY-MM-DD, or an ISO date-time read as its Brisbane date. */
  memberSince?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  openingHours?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  /** Stored verbatim. */
  productsAndServices?: InputMaybe<Scalars['String']['input']>;
  /** Default true. */
  published?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  socialLinks?: InputMaybe<Array<BusinessSocialLinkInput>>;
  /** Where it came from — the idempotency key (else the slug). */
  sourceUrl?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  suburb?: InputMaybe<Scalars['String']['input']>;
  tagline?: InputMaybe<Scalars['String']['input']>;
  websiteUrl?: InputMaybe<Scalars['String']['input']>;
  /** Stored verbatim. */
  whatWeOffer?: InputMaybe<Scalars['String']['input']>;
};

export type BusinessListingInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  /** Every category; the first is the primary unless `category` says otherwise. */
  categories?: InputMaybe<Array<Scalars['String']['input']>>;
  category?: InputMaybe<Scalars['String']['input']>;
  contactName?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  logoCid?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  openingHours?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  productsAndServices?: InputMaybe<Scalars['String']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  socialLinks?: InputMaybe<Array<BusinessSocialLinkInput>>;
  state?: InputMaybe<Scalars['String']['input']>;
  suburb?: InputMaybe<Scalars['String']['input']>;
  tagline?: InputMaybe<Scalars['String']['input']>;
  websiteUrl?: InputMaybe<Scalars['String']['input']>;
  whatWeOffer?: InputMaybe<Scalars['String']['input']>;
};

export type BusinessListingLink = {
  __typename?: 'BusinessListingLink';
  canViewDetail: Scalars['Boolean']['output'];
  detailUrl?: Maybe<Scalars['String']['output']>;
  logoCid?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  tagline?: Maybe<Scalars['String']['output']>;
};

/** A page of the public directory. `total` is every listing that matched, not just this page. */
export type BusinessListingPage = {
  __typename?: 'BusinessListingPage';
  items: Array<BusinessListing>;
  limit: Scalars['Int']['output'];
  offset: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type BusinessListingSearchInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  /** Only the admin's featured picks. */
  featuredOnly?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type BusinessSnapshot = {
  __typename?: 'BusinessSnapshot';
  createdAt: Scalars['DateTime']['output'];
  generatedBy?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  period: SnapshotPeriod;
  periodEnd: Scalars['DateTime']['output'];
  periodStart: Scalars['DateTime']['output'];
  referencedIds: Array<Scalars['String']['output']>;
  scope: SnapshotScope;
  source: SnapshotSource;
  subjectKey?: Maybe<Scalars['String']['output']>;
  subjectLabel?: Maybe<Scalars['String']['output']>;
  summaryMarkdown?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  totalItems: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type BusinessSnapshotFilterInput = {
  period?: InputMaybe<SnapshotPeriod>;
  scope?: InputMaybe<SnapshotScope>;
  source?: InputMaybe<SnapshotSource>;
  subjectKey?: InputMaybe<Scalars['String']['input']>;
};

export type BusinessSocialLink = {
  __typename?: 'BusinessSocialLink';
  label?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type BusinessSocialLinkInput = {
  label?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

/** The type of business for the seller profile */
export enum BusinessType {
  ClothingFashion = 'CLOTHING_FASHION',
  EconomicWellbeing = 'ECONOMIC_WELLBEING',
  EmergencyPreparedness = 'EMERGENCY_PREPAREDNESS',
  EssentialOils = 'ESSENTIAL_OILS',
  FamilyDevelopment = 'FAMILY_DEVELOPMENT',
  Farm = 'FARM',
  FoodBeverage = 'FOOD_BEVERAGE',
  HandmadeCrafts = 'HANDMADE_CRAFTS',
  HealthyFoods = 'HEALTHY_FOODS',
  HealthyHome = 'HEALTHY_HOME',
  HealthWellness = 'HEALTH_WELLNESS',
  HomeGarden = 'HOME_GARDEN',
  LifelongLearning = 'LIFELONG_LEARNING',
  Other = 'OTHER',
  PersonalWellbeing = 'PERSONAL_WELLBEING',
  Relationships = 'RELATIONSHIPS',
  Services = 'SERVICES',
  SustainabilityCommunity = 'SUSTAINABILITY_COMMUNITY'
}

export type BusinessUnitRow = {
  __typename?: 'BusinessUnitRow';
  cogs?: Maybe<Scalars['Float']['output']>;
  connected: Scalars['Boolean']['output'];
  grossProfit?: Maybe<Scalars['Float']['output']>;
  marginPct?: Maybe<Scalars['Float']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  revenue?: Maybe<Scalars['Float']['output']>;
  unit: Scalars['String']['output'];
};

/** Status of a planned action */
export enum CiActionStatus {
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS',
  Pending = 'PENDING'
}

export type CiActivityLogEntry = {
  __typename?: 'CIActivityLogEntry';
  action: Scalars['String']['output'];
  attachments?: Maybe<Array<CiMediaAttachmentSimple>>;
  details?: Maybe<Scalars['String']['output']>;
  documents?: Maybe<Array<CiDocumentAttachmentSimple>>;
  linkedMeetingId?: Maybe<Scalars['ID']['output']>;
  linkedMeetingNumber?: Maybe<Scalars['Float']['output']>;
  linkedMeetingTitle?: Maybe<Scalars['String']['output']>;
  newValue?: Maybe<Scalars['String']['output']>;
  performedAt: Scalars['DateTime']['output'];
  performedBy: Scalars['String']['output'];
  performedById?: Maybe<Scalars['ID']['output']>;
  previousValue?: Maybe<Scalars['String']['output']>;
};

export type CiAgendaItem = {
  __typename?: 'CIAgendaItem';
  actionDueDate?: Maybe<Scalars['DateTime']['output']>;
  actionRequired?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  discussionNotes?: Maybe<Scalars['String']['output']>;
  linkedItemId?: Maybe<Scalars['ID']['output']>;
  linkedItemNumber?: Maybe<Scalars['Float']['output']>;
  linkedItemTitle?: Maybe<Scalars['String']['output']>;
  linkedItemType: CiMeetingNoteLinkedItemType;
  responsiblePerson?: Maybe<Scalars['String']['output']>;
  responsiblePersonId?: Maybe<Scalars['ID']['output']>;
  status: CiAgendaItemStatus;
  submittedAt: Scalars['DateTime']['output'];
  submittedBy: Scalars['String']['output'];
  submittedById?: Maybe<Scalars['ID']['output']>;
  topic: Scalars['String']['output'];
};

/** Status of an agenda item */
export enum CiAgendaItemStatus {
  Actioned = 'ACTIONED',
  Approved = 'APPROVED',
  Deferred = 'DEFERRED',
  Discussed = 'DISCUSSED',
  Submitted = 'SUBMITTED'
}

export type CiAssignablePerson = {
  __typename?: 'CIAssignablePerson';
  clientId: Scalars['ID']['output'];
  employeeId: Scalars['ID']['output'];
  fName?: Maybe<Scalars['String']['output']>;
  lName?: Maybe<Scalars['String']['output']>;
  preferredName?: Maybe<Scalars['String']['output']>;
  primaryRole?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type CiDecisionAction = {
  __typename?: 'CIDecisionAction';
  actionType: CiDecisionActionType;
  assignedTo?: Maybe<Scalars['String']['output']>;
  completedDate?: Maybe<Scalars['DateTime']['output']>;
  description: Scalars['String']['output'];
  dueDate?: Maybe<Scalars['DateTime']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  status: CiDecisionActionStatus;
};

export type CiDecisionActionInput = {
  actionType: CiDecisionActionType;
  assignedTo?: InputMaybe<Scalars['String']['input']>;
  completedDate?: InputMaybe<Scalars['DateTime']['input']>;
  description: Scalars['String']['input'];
  dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<CiDecisionActionStatus>;
};

/** Status of a decision/action item */
export enum CiDecisionActionStatus {
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS',
  Pending = 'PENDING'
}

/** Type of decision/action item */
export enum CiDecisionActionType {
  Action = 'ACTION',
  Decision = 'DECISION'
}

export type CiDocumentAttachment = {
  __typename?: 'CIDocumentAttachment';
  cid?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  uploadedAt: Scalars['DateTime']['output'];
  uploadedBy?: Maybe<Scalars['ID']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type CiDocumentAttachmentInput = {
  cid?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type CiDocumentAttachmentSimple = {
  __typename?: 'CIDocumentAttachmentSimple';
  cid?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type CiDocumentAttachmentSimpleInput = {
  cid?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type CiGovernanceMeeting = {
  __typename?: 'CIGovernanceMeeting';
  agenda?: Maybe<Scalars['String']['output']>;
  agendaItems?: Maybe<Array<CiAgendaItem>>;
  attendees?: Maybe<Array<CiMeetingAttendee>>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['ID']['output'];
  createdByName?: Maybe<Scalars['String']['output']>;
  decisionsAndActions?: Maybe<Array<CiDecisionAction>>;
  documents?: Maybe<Array<CiDocumentAttachment>>;
  duration?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  initiativesReviewed?: Maybe<Array<Scalars['ID']['output']>>;
  isDeleted: Scalars['Boolean']['output'];
  issuesReviewed?: Maybe<Array<Scalars['ID']['output']>>;
  location?: Maybe<Scalars['String']['output']>;
  meetingNotes?: Maybe<Array<CiMeetingNote>>;
  meetingNumber: Scalars['Float']['output'];
  meetingType: CiMeetingType;
  minutes?: Maybe<Scalars['String']['output']>;
  qualityStandardsDiscussed?: Maybe<Array<CiQualityStandard>>;
  scheduledDate: Scalars['DateTime']['output'];
  scheduledTime: Scalars['String']['output'];
  status: CiMeetingStatus;
  tenantId: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type CiGovernanceMeetingStats = {
  __typename?: 'CIGovernanceMeetingStats';
  cancelled: Scalars['Float']['output'];
  completed: Scalars['Float']['output'];
  overdueActions: Scalars['Float']['output'];
  pendingActions: Scalars['Float']['output'];
  scheduled: Scalars['Float']['output'];
  thisMonth: Scalars['Float']['output'];
  total: Scalars['Float']['output'];
};

export type CiImprovementInitiative = {
  __typename?: 'CIImprovementInitiative';
  activityLog?: Maybe<Array<CiActivityLogEntry>>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['ID']['output'];
  createdByName?: Maybe<Scalars['String']['output']>;
  dateIdentified: Scalars['DateTime']['output'];
  documents?: Maybe<Array<CiDocumentAttachment>>;
  id: Scalars['ID']['output'];
  initiativeNumber: Scalars['Float']['output'];
  isDeleted: Scalars['Boolean']['output'];
  isSuccessful?: Maybe<Scalars['Boolean']['output']>;
  isSustainable?: Maybe<Scalars['Boolean']['output']>;
  issueDescription: Scalars['String']['output'];
  issueSource: CiIssueSource;
  issueSourceDetails?: Maybe<Scalars['String']['output']>;
  issueTitle: Scalars['String']['output'];
  linkedIssueId?: Maybe<Scalars['ID']['output']>;
  linkedMaintenanceRequestId?: Maybe<Scalars['ID']['output']>;
  linkedMaintenanceRequestNumber?: Maybe<Scalars['Float']['output']>;
  maintenanceLinkReason?: Maybe<Scalars['String']['output']>;
  maintenanceLinkedAt?: Maybe<Scalars['DateTime']['output']>;
  maintenanceLinkedBy?: Maybe<Scalars['String']['output']>;
  measurementDetails?: Maybe<Scalars['String']['output']>;
  outcomes?: Maybe<Scalars['String']['output']>;
  photos?: Maybe<Array<CiMediaAttachment>>;
  plannedActions?: Maybe<Array<CiPlannedAction>>;
  plannedCompletionDate?: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Use standardLinks instead — initiatives can now be tagged with multiple standards. */
  relatedStandard?: Maybe<CiQualityStandard>;
  responsiblePersons?: Maybe<Array<CiResponsiblePerson>>;
  reviewCompletedDate?: Maybe<Scalars['DateTime']['output']>;
  reviewDate?: Maybe<Scalars['DateTime']['output']>;
  reviewEvidence?: Maybe<Array<CiDocumentAttachmentSimple>>;
  reviewNotes?: Maybe<Scalars['String']['output']>;
  reviewedBy?: Maybe<Scalars['ID']['output']>;
  reviewedByName?: Maybe<Scalars['String']['output']>;
  reviewedInMeetings?: Maybe<Array<Scalars['ID']['output']>>;
  standardLinks: Array<CiStandardLink>;
  standardReferenceUrl?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use standardLinks[].subClause instead. */
  standardSubClause?: Maybe<Scalars['String']['output']>;
  status: CiInitiativeStatus;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type CiInitiativeStats = {
  __typename?: 'CIInitiativeStats';
  actionsCompleted: Scalars['Float']['output'];
  actionsTotal: Scalars['Float']['output'];
  archived: Scalars['Float']['output'];
  completed: Scalars['Float']['output'];
  dueForReview: Scalars['Float']['output'];
  identified: Scalars['Float']['output'];
  inProgress: Scalars['Float']['output'];
  overdueCompletions: Scalars['Float']['output'];
  overdueReviews: Scalars['Float']['output'];
  planned: Scalars['Float']['output'];
  total: Scalars['Float']['output'];
  underReview: Scalars['Float']['output'];
};

/** Status of a continuous improvement initiative */
export enum CiInitiativeStatus {
  Archived = 'ARCHIVED',
  Completed = 'COMPLETED',
  Identified = 'IDENTIFIED',
  InProgress = 'IN_PROGRESS',
  Planned = 'PLANNED',
  UnderReview = 'UNDER_REVIEW'
}

/** Category of the reported issue */
export enum CiIssueCategory {
  CareQuality = 'CARE_QUALITY',
  Clinical = 'CLINICAL',
  Communication = 'COMMUNICATION',
  DignityChoice = 'DIGNITY_CHOICE',
  Environment = 'ENVIRONMENT',
  FoodNutrition = 'FOOD_NUTRITION',
  Governance = 'GOVERNANCE',
  Other = 'OTHER',
  Safety = 'SAFETY',
  Staffing = 'STAFFING'
}

export type CiIssueReport = {
  __typename?: 'CIIssueReport';
  activityLog?: Maybe<Array<CiActivityLogEntry>>;
  assignedAt?: Maybe<Scalars['DateTime']['output']>;
  assignedTo?: Maybe<Scalars['ID']['output']>;
  assignedToName?: Maybe<Scalars['String']['output']>;
  category: CiIssueCategory;
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  documents?: Maybe<Array<CiDocumentAttachment>>;
  followUpDate?: Maybe<Scalars['DateTime']['output']>;
  followUpNotes?: Maybe<Scalars['String']['output']>;
  followUpRequired?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  isDeleted: Scalars['Boolean']['output'];
  issueNumber: Scalars['Float']['output'];
  linkedInitiativeId?: Maybe<Scalars['ID']['output']>;
  linkedMaintenanceRequestId?: Maybe<Scalars['ID']['output']>;
  linkedMaintenanceRequestNumber?: Maybe<Scalars['Float']['output']>;
  linkedMeetingIds?: Maybe<Array<Scalars['ID']['output']>>;
  locationId?: Maybe<Scalars['ID']['output']>;
  maintenanceLinkReason?: Maybe<Scalars['String']['output']>;
  photos?: Maybe<Array<CiMediaAttachment>>;
  qualityStandards?: Maybe<Array<CiQualityStandard>>;
  reportedAt: Scalars['DateTime']['output'];
  reportedBy: Scalars['ID']['output'];
  reportedByName?: Maybe<Scalars['String']['output']>;
  reporterType: CiStakeholderType;
  resolutionDetails?: Maybe<Scalars['String']['output']>;
  resolvedAt?: Maybe<Scalars['DateTime']['output']>;
  resolvedBy?: Maybe<Scalars['ID']['output']>;
  resolvedByName?: Maybe<Scalars['String']['output']>;
  room?: Maybe<Scalars['String']['output']>;
  severity: CiIssueSeverity;
  status: CiIssueStatus;
  tenantId: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  wing?: Maybe<Scalars['String']['output']>;
};

export type CiIssueReportStats = {
  __typename?: 'CIIssueReportStats';
  closed: Scalars['Float']['output'];
  criticalCount: Scalars['Float']['output'];
  highCount: Scalars['Float']['output'];
  improvementPlanned: Scalars['Float']['output'];
  inProgress: Scalars['Float']['output'];
  reported: Scalars['Float']['output'];
  reportedThisWeek: Scalars['Float']['output'];
  resolved: Scalars['Float']['output'];
  resolvedThisWeek: Scalars['Float']['output'];
  total: Scalars['Float']['output'];
  underReview: Scalars['Float']['output'];
};

/** Severity level of the issue */
export enum CiIssueSeverity {
  Critical = 'CRITICAL',
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM'
}

/** Source of the identified issue */
export enum CiIssueSource {
  Complaint = 'COMPLAINT',
  ConsumerMeeting = 'CONSUMER_MEETING',
  ExternalAudit = 'EXTERNAL_AUDIT',
  FamilyFeedback = 'FAMILY_FEEDBACK',
  IncidentReport = 'INCIDENT_REPORT',
  InternalAudit = 'INTERNAL_AUDIT',
  Other = 'OTHER',
  QualityIndicator = 'QUALITY_INDICATOR',
  RegulatorFeedback = 'REGULATOR_FEEDBACK',
  ResidentFeedback = 'RESIDENT_FEEDBACK',
  SelfAssessment = 'SELF_ASSESSMENT',
  StaffFeedback = 'STAFF_FEEDBACK'
}

/** Status of a reported issue */
export enum CiIssueStatus {
  Closed = 'CLOSED',
  ImprovementPlanned = 'IMPROVEMENT_PLANNED',
  InProgress = 'IN_PROGRESS',
  Reported = 'REPORTED',
  Resolved = 'RESOLVED',
  UnderReview = 'UNDER_REVIEW'
}

export type CiMediaAttachment = {
  __typename?: 'CIMediaAttachment';
  cid?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  uploadedAt: Scalars['DateTime']['output'];
  uploadedBy?: Maybe<Scalars['ID']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type CiMediaAttachmentInitiativeInput = {
  cid?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type CiMediaAttachmentSimple = {
  __typename?: 'CIMediaAttachmentSimple';
  cid?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type CiMediaAttachmentSimpleInput = {
  cid?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type CiMeetingAttendee = {
  __typename?: 'CIMeetingAttendee';
  apologies?: Maybe<Scalars['String']['output']>;
  attended: Scalars['Boolean']['output'];
  attendeeId?: Maybe<Scalars['ID']['output']>;
  name: Scalars['String']['output'];
  role: Scalars['String']['output'];
  stakeholderType: CiStakeholderType;
};

export type CiMeetingAttendeeInput = {
  apologies?: InputMaybe<Scalars['String']['input']>;
  attended?: InputMaybe<Scalars['Boolean']['input']>;
  attendeeId?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  role: Scalars['String']['input'];
  stakeholderType: CiStakeholderType;
};

export type CiMeetingLinkedInitiative = {
  __typename?: 'CIMeetingLinkedInitiative';
  id: Scalars['ID']['output'];
  initiativeNumber: Scalars['Float']['output'];
  relatedStandard: Scalars['String']['output'];
  status: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type CiMeetingLinkedIssue = {
  __typename?: 'CIMeetingLinkedIssue';
  category: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  issueNumber: Scalars['Float']['output'];
  severity: Scalars['String']['output'];
  status: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type CiMeetingNote = {
  __typename?: 'CIMeetingNote';
  addedAt: Scalars['DateTime']['output'];
  addedBy: Scalars['String']['output'];
  addedById?: Maybe<Scalars['ID']['output']>;
  attachments?: Maybe<Array<CiMediaAttachmentSimple>>;
  documents?: Maybe<Array<CiDocumentAttachmentSimple>>;
  linkedItemId?: Maybe<Scalars['ID']['output']>;
  linkedItemNumber?: Maybe<Scalars['Float']['output']>;
  linkedItemTitle?: Maybe<Scalars['String']['output']>;
  linkedItemType: CiMeetingNoteLinkedItemType;
  noteText: Scalars['String']['output'];
};

export type CiMeetingNoteDocumentInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

/** Type of item a meeting note is linked to */
export enum CiMeetingNoteLinkedItemType {
  General = 'GENERAL',
  Initiative = 'INITIATIVE',
  Issue = 'ISSUE'
}

export type CiMeetingNoteMediaInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  url: Scalars['String']['input'];
};

/** Status of a governance meeting */
export enum CiMeetingStatus {
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS',
  Scheduled = 'SCHEDULED'
}

/** Type of governance meeting */
export enum CiMeetingType {
  AuditReview = 'AUDIT_REVIEW',
  BoardMeeting = 'BOARD_MEETING',
  ContinuousImprovement = 'CONTINUOUS_IMPROVEMENT',
  FamilyMeeting = 'FAMILY_MEETING',
  IncidentReview = 'INCIDENT_REVIEW',
  Other = 'OTHER',
  QualityCommittee = 'QUALITY_COMMITTEE',
  ResidentMeeting = 'RESIDENT_MEETING',
  StaffMeeting = 'STAFF_MEETING'
}

/** How to resolve the CI notification recipient(s) */
export enum CiNotificationRecipientType {
  AllCiManagers = 'ALL_CI_MANAGERS',
  AssignedPerson = 'ASSIGNED_PERSON',
  Role = 'ROLE',
  SpecificEmployee = 'SPECIFIC_EMPLOYEE'
}

export type CiNotificationRule = {
  __typename?: 'CINotificationRule';
  channels: Array<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  filterStandard?: Maybe<CiQualityStandard>;
  id: Scalars['ID']['output'];
  isEnabled: Scalars['Boolean']['output'];
  messageTemplate?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  recipientIds?: Maybe<Array<Scalars['String']['output']>>;
  recipientRole?: Maybe<Scalars['String']['output']>;
  recipientType: CiNotificationRecipientType;
  scheduledDay?: Maybe<CiScheduleDay>;
  scheduledHour?: Maybe<Scalars['Float']['output']>;
  tenantId: Scalars['String']['output'];
  trigger: CiNotificationTrigger;
  updatedAt: Scalars['DateTime']['output'];
};

/** Event that triggers the CI notification */
export enum CiNotificationTrigger {
  ActionCompleted = 'ACTION_COMPLETED',
  AllEvents = 'ALL_EVENTS',
  EvidenceUploaded = 'EVIDENCE_UPLOADED',
  InitiativeCompleted = 'INITIATIVE_COMPLETED',
  InitiativeCreated = 'INITIATIVE_CREATED',
  InitiativeDueForReview = 'INITIATIVE_DUE_FOR_REVIEW',
  InitiativeOverdue = 'INITIATIVE_OVERDUE',
  InitiativeStatusChanged = 'INITIATIVE_STATUS_CHANGED',
  IssueAssigned = 'ISSUE_ASSIGNED',
  IssueReported = 'ISSUE_REPORTED',
  IssueResolved = 'ISSUE_RESOLVED',
  IssueStatusChanged = 'ISSUE_STATUS_CHANGED',
  MeetingReminder = 'MEETING_REMINDER',
  MeetingScheduled = 'MEETING_SCHEDULED',
  WeeklyReport = 'WEEKLY_REPORT'
}

export type CiPlannedAction = {
  __typename?: 'CIPlannedAction';
  actionId?: Maybe<Scalars['String']['output']>;
  assignedTo?: Maybe<Scalars['ID']['output']>;
  assignedToName?: Maybe<Scalars['String']['output']>;
  completedBy?: Maybe<Scalars['String']['output']>;
  completedDate?: Maybe<Scalars['DateTime']['output']>;
  description: Scalars['String']['output'];
  evidence?: Maybe<Array<CiDocumentAttachmentSimple>>;
  notes?: Maybe<Scalars['String']['output']>;
  status: CiActionStatus;
};

export type CiPlannedActionInput = {
  actionId?: InputMaybe<Scalars['String']['input']>;
  assignedTo?: InputMaybe<Scalars['ID']['input']>;
  assignedToName?: InputMaybe<Scalars['String']['input']>;
  completedBy?: InputMaybe<Scalars['String']['input']>;
  completedDate?: InputMaybe<Scalars['DateTime']['input']>;
  description: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<CiActionStatus>;
};

/** The 7 Strengthened Aged Care Quality Standards (ACQSC) - effective 1 November 2025 */
export enum CiQualityStandard {
  Standard_1 = 'STANDARD_1',
  Standard_2 = 'STANDARD_2',
  Standard_3 = 'STANDARD_3',
  Standard_4 = 'STANDARD_4',
  Standard_5 = 'STANDARD_5',
  Standard_6 = 'STANDARD_6',
  Standard_7 = 'STANDARD_7'
}

export type CiQualityStandardSummary = {
  __typename?: 'CIQualityStandardSummary';
  activeInitiatives: Scalars['Float']['output'];
  completedInitiatives: Scalars['Float']['output'];
  openIssues: Scalars['Float']['output'];
  overdueItems: Scalars['Float']['output'];
  referenceUrl?: Maybe<Scalars['String']['output']>;
  standard: CiQualityStandard;
  standardDescription?: Maybe<Scalars['String']['output']>;
  standardName: Scalars['String']['output'];
  totalInitiatives: Scalars['Float']['output'];
  totalIssues: Scalars['Float']['output'];
};

export type CiResponsiblePerson = {
  __typename?: 'CIResponsiblePerson';
  name: Scalars['String']['output'];
  personId?: Maybe<Scalars['ID']['output']>;
  role?: Maybe<Scalars['String']['output']>;
};

export type CiResponsiblePersonInput = {
  name: Scalars['String']['input'];
  personId?: InputMaybe<Scalars['ID']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
};

/** Day of the week for scheduled CI report rules */
export enum CiScheduleDay {
  Friday = 'FRIDAY',
  Monday = 'MONDAY',
  Saturday = 'SATURDAY',
  Sunday = 'SUNDAY',
  Thursday = 'THURSDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY'
}

/** Type of stakeholder */
export enum CiStakeholderType {
  Advocate = 'ADVOCATE',
  BoardMember = 'BOARD_MEMBER',
  Family = 'FAMILY',
  Other = 'OTHER',
  Resident = 'RESIDENT',
  Staff = 'STAFF',
  Visitor = 'VISITOR',
  Volunteer = 'VOLUNTEER'
}

export type CiStandardLink = {
  __typename?: 'CIStandardLink';
  standard: CiQualityStandard;
  subClause?: Maybe<Scalars['String']['output']>;
};

export type CiStandardLinkInput = {
  standard: CiQualityStandard;
  subClause?: InputMaybe<Scalars['String']['input']>;
};

export type CalculatorSubmission = {
  __typename?: 'CalculatorSubmission';
  calculatorName: Scalars['String']['output'];
  calculatorPath: Scalars['String']['output'];
  calculatorType: CalculatorType;
  clientId?: Maybe<Scalars['ID']['output']>;
  company?: Maybe<Scalars['String']['output']>;
  contactedAt?: Maybe<Scalars['DateTime']['output']>;
  contactedBy?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  ghlContactId?: Maybe<Scalars['String']['output']>;
  ghlOpportunityId?: Maybe<Scalars['String']['output']>;
  ghlSyncError?: Maybe<Scalars['String']['output']>;
  ghlSyncStatus?: Maybe<Scalars['String']['output']>;
  ghlSyncedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  inputData: Scalars['String']['output'];
  ipHash?: Maybe<Scalars['String']['output']>;
  isLeadCaptured: Scalars['Boolean']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  marketingConsent: Scalars['Boolean']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  pipedriveId?: Maybe<Scalars['String']['output']>;
  pipedriveSyncedAt?: Maybe<Scalars['DateTime']['output']>;
  pipedriveSyncedBy?: Maybe<Scalars['String']['output']>;
  referrer?: Maybe<Scalars['String']['output']>;
  resultData: Scalars['String']['output'];
  sessionId?: Maybe<Scalars['String']['output']>;
  status: SubmissionStatus;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  userAgent?: Maybe<Scalars['String']['output']>;
  utmCampaign?: Maybe<Scalars['String']['output']>;
  utmMedium?: Maybe<Scalars['String']['output']>;
  utmSource?: Maybe<Scalars['String']['output']>;
  visitorId?: Maybe<Scalars['String']['output']>;
};

export type CalculatorSubmissionFilters = {
  calculatorType?: InputMaybe<CalculatorType>;
  clientId?: InputMaybe<Scalars['ID']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  isLeadCaptured?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<SubmissionStatus>;
};

export type CalculatorSubmissionStats = {
  __typename?: 'CalculatorSubmissionStats';
  contactedLeads: Scalars['Int']['output'];
  convertedLeads: Scalars['Int']['output'];
  leadCaptureRate: Scalars['Float']['output'];
  leadsCaputured: Scalars['Int']['output'];
  pendingLeads: Scalars['Int']['output'];
  sentToPipedrive: Scalars['Int']['output'];
  totalSubmissions: Scalars['Int']['output'];
};

/** The type of calculator used */
export enum CalculatorType {
  BorrowingPower = 'BORROWING_POWER',
  LoanComparison = 'LOAN_COMPARISON',
  PersonalAssetFinance = 'PERSONAL_ASSET_FINANCE',
  PortfolioGrowth = 'PORTFOLIO_GROWTH',
  PropertyInvestmentRoi = 'PROPERTY_INVESTMENT_ROI',
  PropertySolarRoi = 'PROPERTY_SOLAR_ROI',
  RefinanceSavings = 'REFINANCE_SAVINGS',
  RentalYield = 'RENTAL_YIELD',
  SmsfProperty = 'SMSF_PROPERTY',
  SolarBatteryRoi = 'SOLAR_BATTERY_ROI',
  SolarSavings = 'SOLAR_SAVINGS',
  StampDuty = 'STAMP_DUTY',
  TaxOptimization = 'TAX_OPTIMIZATION'
}

export type CalculatorTypeStats = {
  __typename?: 'CalculatorTypeStats';
  calculatorName: Scalars['String']['output'];
  calculatorType: CalculatorType;
  conversionRate: Scalars['Float']['output'];
  leadCaptureRate: Scalars['Float']['output'];
  leadsCaputured: Scalars['Int']['output'];
  submissions: Scalars['Int']['output'];
};

/** What an audience calendar-share targets (employee role or client tag) */
export enum CalendarAudienceKind {
  Role = 'ROLE',
  Tag = 'TAG'
}

export type CalendarAudienceOptions = {
  __typename?: 'CalendarAudienceOptions';
  roles: Array<CalendarAudienceRoleOption>;
  tags: Array<Scalars['String']['output']>;
};

export type CalendarAudienceRoleOption = {
  __typename?: 'CalendarAudienceRoleOption';
  color?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type CalendarAudienceShare = {
  __typename?: 'CalendarAudienceShare';
  kind: CalendarAudienceKind;
  label?: Maybe<Scalars['String']['output']>;
  permission: CalendarPermission;
  sharedAt?: Maybe<Scalars['DateTime']['output']>;
  sharedBy?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

export type CalendarAudienceShareInfo = {
  __typename?: 'CalendarAudienceShareInfo';
  kind: CalendarAudienceKind;
  label?: Maybe<Scalars['String']['output']>;
  memberCount: Scalars['Float']['output'];
  permission: CalendarPermission;
  sharedAt?: Maybe<Scalars['DateTime']['output']>;
  sharedByName?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

export type CalendarAudienceTargetInput = {
  kind: CalendarAudienceKind;
  value: Scalars['String']['input'];
};

export type CalendarEvent = {
  __typename?: 'CalendarEvent';
  acceptedCount: Scalars['Float']['output'];
  attachments: Array<EventAttachment>;
  attendees: Array<EventAttendee>;
  billId?: Maybe<Scalars['String']['output']>;
  calendarId: Scalars['String']['output'];
  canViewDetail?: Maybe<Scalars['Boolean']['output']>;
  cancellationReason?: Maybe<Scalars['String']['output']>;
  cancelledAt?: Maybe<Scalars['DateTime']['output']>;
  categories?: Maybe<Array<Scalars['String']['output']>>;
  color?: Maybe<Scalars['String']['output']>;
  completedTasks: Scalars['Float']['output'];
  conference?: Maybe<ConferenceDetails>;
  createdAt: Scalars['DateTime']['output'];
  declinedCount: Scalars['Float']['output'];
  description?: Maybe<Scalars['String']['output']>;
  detailUrl?: Maybe<Scalars['String']['output']>;
  endTime: Scalars['DateTime']['output'];
  eventNotes?: Maybe<Scalars['String']['output']>;
  excludedDates?: Maybe<Array<Scalars['DateTime']['output']>>;
  externalEventId?: Maybe<Scalars['String']['output']>;
  iCalData?: Maybe<Scalars['String']['output']>;
  iCalHtmlBody?: Maybe<Scalars['String']['output']>;
  iCalMeetingLink?: Maybe<Scalars['String']['output']>;
  iCalMethod?: Maybe<Scalars['String']['output']>;
  iCalOrganizerEmail?: Maybe<Scalars['String']['output']>;
  iCalOrganizerName?: Maybe<Scalars['String']['output']>;
  iCalRawEmail?: Maybe<Scalars['String']['output']>;
  iCalReceivedAt?: Maybe<Scalars['DateTime']['output']>;
  iCalResponseDate?: Maybe<Scalars['DateTime']['output']>;
  iCalResponseStatus?: Maybe<Scalars['String']['output']>;
  iCalSequence?: Maybe<Scalars['Float']['output']>;
  iCalUID?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  importedFrom?: Maybe<Scalars['String']['output']>;
  inviteDispatchHistory?: Maybe<Array<EventInviteDispatch>>;
  invitedEmails?: Maybe<Array<Scalars['String']['output']>>;
  isAllDay: Scalars['Boolean']['output'];
  isCancelled: Scalars['Boolean']['output'];
  isInboundICalInvite: Scalars['Boolean']['output'];
  isPrivate: Scalars['Boolean']['output'];
  isRecurring: Scalars['Boolean']['output'];
  lastInviteDispatch?: Maybe<EventInviteDispatch>;
  lastModifiedAt?: Maybe<Scalars['DateTime']['output']>;
  lastModifiedBy?: Maybe<Scalars['String']['output']>;
  location?: Maybe<EventLocation>;
  metadata?: Maybe<Scalars['JSONObject']['output']>;
  moduleData?: Maybe<Scalars['JSONObject']['output']>;
  moduleRefId?: Maybe<Scalars['String']['output']>;
  moduleType?: Maybe<Scalars['String']['output']>;
  noResponseCount: Scalars['Float']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  organizerEmail?: Maybe<Scalars['String']['output']>;
  organizerId: Scalars['String']['output'];
  organizerName?: Maybe<Scalars['String']['output']>;
  originalStartTime?: Maybe<Scalars['DateTime']['output']>;
  recurrence?: Maybe<RecurrenceRule>;
  recurringEventId?: Maybe<Scalars['String']['output']>;
  reminders: Array<EventReminder>;
  remindersEnabled: Scalars['Boolean']['output'];
  sequence?: Maybe<Scalars['Float']['output']>;
  startTime: Scalars['DateTime']['output'];
  status: EventStatus;
  taskProgressPercentage: Scalars['Float']['output'];
  tenantId: Scalars['String']['output'];
  tentativeCount: Scalars['Float']['output'];
  timezone?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  totalTasks: Scalars['Float']['output'];
  type: EventType;
  uid?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  visibility: EventVisibility;
};

export type CalendarEventInput = {
  attachments?: InputMaybe<Array<EventAttachmentInput>>;
  attendees?: InputMaybe<Array<EventAttendeeInput>>;
  calendarId: Scalars['String']['input'];
  categories?: InputMaybe<Array<Scalars['String']['input']>>;
  color?: InputMaybe<Scalars['String']['input']>;
  conference?: InputMaybe<ConferenceDetailsInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  endTime: Scalars['DateTime']['input'];
  eventNotes?: InputMaybe<Scalars['String']['input']>;
  isAllDay?: InputMaybe<Scalars['Boolean']['input']>;
  isRecurring?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<EventLocationInput>;
  metadata?: InputMaybe<Scalars['JSONObject']['input']>;
  moduleRefId?: InputMaybe<Scalars['String']['input']>;
  moduleType?: InputMaybe<Scalars['String']['input']>;
  recurrence?: InputMaybe<RecurrenceRuleInput>;
  reminders?: InputMaybe<Array<EventReminderInput>>;
  startTime: Scalars['DateTime']['input'];
  status?: InputMaybe<EventStatus>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  type?: InputMaybe<EventType>;
  visibility?: InputMaybe<EventVisibility>;
};

export type CalendarEventTask = {
  __typename?: 'CalendarEventTask';
  assignedTo?: Maybe<Scalars['String']['output']>;
  calendarEventId: Scalars['String']['output'];
  checklistItems: Array<CalendarEventTaskChecklistItem>;
  completed: Scalars['Boolean']['output'];
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  completedBy?: Maybe<Scalars['String']['output']>;
  completedChecklistItems: Scalars['Float']['output'];
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  order: Scalars['Float']['output'];
  progressPercentage: Scalars['Float']['output'];
  status: CalendarEventTaskStatus;
  tenantId: Scalars['String']['output'];
  title: Scalars['String']['output'];
  totalChecklistItems: Scalars['Float']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type CalendarEventTaskChecklistItem = {
  __typename?: 'CalendarEventTaskChecklistItem';
  completed: Scalars['Boolean']['output'];
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  completedBy?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  order: Scalars['Float']['output'];
  title: Scalars['String']['output'];
};

export type CalendarEventTaskChecklistItemInput = {
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  completedBy?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Float']['input']>;
  title: Scalars['String']['input'];
};

export type CalendarEventTaskInput = {
  assignedTo?: InputMaybe<Scalars['String']['input']>;
  calendarEventId: Scalars['String']['input'];
  checklistItems?: InputMaybe<Array<CalendarEventTaskChecklistItemInput>>;
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Float']['input']>;
  status?: InputMaybe<CalendarEventTaskStatus>;
  title: Scalars['String']['input'];
};

/** Status of a calendar event task */
export enum CalendarEventTaskStatus {
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS',
  NotStarted = 'NOT_STARTED'
}

export type CalendarGoal = {
  __typename?: 'CalendarGoal';
  assignedTo?: Maybe<Scalars['String']['output']>;
  calendarId: Scalars['String']['output'];
  category: GoalCategory;
  checkpoints: Array<CalendarGoalCheckpoint>;
  color?: Maybe<Scalars['String']['output']>;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  completedBy?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  currentNumericValue?: Maybe<Scalars['Float']['output']>;
  currentValue?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  displayOrder: Scalars['Float']['output'];
  endDate: Scalars['DateTime']['output'];
  hasSubGoals: Scalars['Boolean']['output'];
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  imageCid?: Maybe<Scalars['String']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  isActive: Scalars['Boolean']['output'];
  isArchived: Scalars['Boolean']['output'];
  kpiMetric?: Maybe<Scalars['String']['output']>;
  kpiUnit?: Maybe<Scalars['String']['output']>;
  linkedLifeGoalEventId?: Maybe<Scalars['String']['output']>;
  month?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  ownerId: Scalars['String']['output'];
  parentGoalId?: Maybe<Scalars['String']['output']>;
  period: GoalPeriod;
  progressPercentage: Scalars['Float']['output'];
  startDate: Scalars['DateTime']['output'];
  status: GoalStatus;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  targetNumericValue?: Maybe<Scalars['Float']['output']>;
  targetValue?: Maybe<Scalars['String']['output']>;
  teamMembers?: Maybe<Array<Scalars['String']['output']>>;
  tenantId: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type CalendarGoalCheckpoint = {
  __typename?: 'CalendarGoalCheckpoint';
  assignedTo?: Maybe<Scalars['String']['output']>;
  completed: Scalars['Boolean']['output'];
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  completedBy?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  order: Scalars['Float']['output'];
  title: Scalars['String']['output'];
  weight?: Maybe<Scalars['Float']['output']>;
};

export type CalendarGoalCheckpointInput = {
  assignedTo?: InputMaybe<Scalars['String']['input']>;
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  completedBy?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Float']['input']>;
  title: Scalars['String']['input'];
  weight?: InputMaybe<Scalars['Float']['input']>;
};

export type CalendarGoalInput = {
  assignedTo?: InputMaybe<Scalars['String']['input']>;
  calendarId: Scalars['String']['input'];
  category?: InputMaybe<GoalCategory>;
  checkpoints?: InputMaybe<Array<CalendarGoalCheckpointInput>>;
  color?: InputMaybe<Scalars['String']['input']>;
  currentNumericValue?: InputMaybe<Scalars['Float']['input']>;
  currentValue?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayOrder?: InputMaybe<Scalars['Float']['input']>;
  endDate: Scalars['DateTime']['input'];
  icon?: InputMaybe<Scalars['String']['input']>;
  imageCid?: InputMaybe<Scalars['String']['input']>;
  kpiMetric?: InputMaybe<Scalars['String']['input']>;
  kpiUnit?: InputMaybe<Scalars['String']['input']>;
  linkedLifeGoalEventId?: InputMaybe<Scalars['String']['input']>;
  month?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  parentGoalId?: InputMaybe<Scalars['String']['input']>;
  period?: InputMaybe<GoalPeriod>;
  progressPercentage?: InputMaybe<Scalars['Float']['input']>;
  startDate: Scalars['DateTime']['input'];
  status?: InputMaybe<GoalStatus>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  targetNumericValue?: InputMaybe<Scalars['Float']['input']>;
  targetValue?: InputMaybe<Scalars['String']['input']>;
  teamMembers?: InputMaybe<Array<Scalars['String']['input']>>;
  title: Scalars['String']['input'];
};

export type CalendarInvitation = {
  __typename?: 'CalendarInvitation';
  acceptedAt?: Maybe<Scalars['DateTime']['output']>;
  calendarId: Scalars['String']['output'];
  calendarName: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  declinedAt?: Maybe<Scalars['DateTime']['output']>;
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  invitationToken: Scalars['String']['output'];
  invitationType: InvitationType;
  invitedBy: Scalars['String']['output'];
  invitedByName: Scalars['String']['output'];
  lastReminderSentAt?: Maybe<Scalars['DateTime']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  notificationSent: Scalars['Boolean']['output'];
  permissions: Array<CalendarPermission>;
  recipientClientId?: Maybe<Scalars['String']['output']>;
  recipientEmail?: Maybe<Scalars['String']['output']>;
  recipientPhone?: Maybe<Scalars['String']['output']>;
  reminderCount: Scalars['Float']['output'];
  shareLink?: Maybe<Scalars['String']['output']>;
  status: InvitationStatus;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** Calendar access permissions */
export enum CalendarPermission {
  Admin = 'ADMIN',
  Create = 'CREATE',
  Delete = 'DELETE',
  Edit = 'EDIT',
  Share = 'SHARE',
  View = 'VIEW'
}

export type CalendarPersonInfo = {
  __typename?: 'CalendarPersonInfo';
  clientId: Scalars['String']['output'];
  email?: Maybe<Scalars['String']['output']>;
  fName?: Maybe<Scalars['String']['output']>;
  isEmployee: Scalars['Boolean']['output'];
  lName?: Maybe<Scalars['String']['output']>;
  personalEmail?: Maybe<Scalars['String']['output']>;
  preferredName?: Maybe<Scalars['String']['output']>;
  roleNames?: Maybe<Array<Scalars['String']['output']>>;
  workEmail?: Maybe<Scalars['String']['output']>;
};

export type CalendarSettings = {
  __typename?: 'CalendarSettings';
  allowExternalInvites?: Maybe<Scalars['Boolean']['output']>;
  autoAcceptInvites?: Maybe<Scalars['Boolean']['output']>;
  defaultEventDuration?: Maybe<Scalars['String']['output']>;
  defaultReminderMinutes?: Maybe<Scalars['Float']['output']>;
  defaultView?: Maybe<Scalars['String']['output']>;
  emailNotifications?: Maybe<Scalars['Boolean']['output']>;
  showWeekNumbers?: Maybe<Scalars['Boolean']['output']>;
  smsNotifications?: Maybe<Scalars['Boolean']['output']>;
  timezone?: Maybe<Scalars['String']['output']>;
  workingDays?: Maybe<Array<Scalars['String']['output']>>;
  workingHoursEnd?: Maybe<Scalars['String']['output']>;
  workingHoursStart?: Maybe<Scalars['String']['output']>;
};

export type CalendarSettingsInput = {
  allowExternalInvites?: InputMaybe<Scalars['Boolean']['input']>;
  autoAcceptInvites?: InputMaybe<Scalars['Boolean']['input']>;
  defaultEventDuration?: InputMaybe<Scalars['String']['input']>;
  defaultReminderMinutes?: InputMaybe<Scalars['Float']['input']>;
  defaultView?: InputMaybe<Scalars['String']['input']>;
  emailNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  showWeekNumbers?: InputMaybe<Scalars['Boolean']['input']>;
  smsNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  workingDays?: InputMaybe<Array<Scalars['String']['input']>>;
  workingHoursEnd?: InputMaybe<Scalars['String']['input']>;
  workingHoursStart?: InputMaybe<Scalars['String']['input']>;
};

export type CalendarShare = {
  __typename?: 'CalendarShare';
  clientId: Scalars['String']['output'];
  permission: CalendarPermission;
  sharedAt?: Maybe<Scalars['DateTime']['output']>;
  sharedBy?: Maybe<Scalars['String']['output']>;
};

export type CalendarShareInfo = {
  __typename?: 'CalendarShareInfo';
  clientEmail?: Maybe<Scalars['String']['output']>;
  clientId: Scalars['String']['output'];
  clientName?: Maybe<Scalars['String']['output']>;
  isEmployee: Scalars['Boolean']['output'];
  permission: CalendarPermission;
  preferredName?: Maybe<Scalars['String']['output']>;
  roleNames?: Maybe<Array<Scalars['String']['output']>>;
  sharedAt?: Maybe<Scalars['DateTime']['output']>;
  sharedBy?: Maybe<Scalars['String']['output']>;
  sharedByName?: Maybe<Scalars['String']['output']>;
};

export type CalendarShareInput = {
  clientId: Scalars['String']['input'];
  permission: CalendarPermission;
};

export type CalendarSyncInfo = {
  __typename?: 'CalendarSyncInfo';
  externalCalendarId?: Maybe<Scalars['String']['output']>;
  lastSyncAt?: Maybe<Scalars['DateTime']['output']>;
  provider?: Maybe<Scalars['String']['output']>;
  syncDirection?: Maybe<Scalars['String']['output']>;
  syncEnabled?: Maybe<Scalars['Boolean']['output']>;
  syncToken?: Maybe<Scalars['String']['output']>;
  webhookUrl?: Maybe<Scalars['String']['output']>;
};

export type CalendarSyncInfoInput = {
  externalCalendarId?: InputMaybe<Scalars['String']['input']>;
  provider?: InputMaybe<Scalars['String']['input']>;
  syncDirection?: InputMaybe<Scalars['String']['input']>;
  syncEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  webhookUrl?: InputMaybe<Scalars['String']['input']>;
};

export type CalendarTag = {
  __typename?: 'CalendarTag';
  calendarId: Scalars['String']['output'];
  color: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  usageCount: Scalars['Float']['output'];
};

export type CalendarTagInput = {
  color: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

/** Types of calendars in the system */
export enum CalendarType {
  Business = 'BUSINESS',
  Company = 'COMPANY',
  Custom = 'CUSTOM',
  Email = 'EMAIL',
  Employee = 'EMPLOYEE',
  Personal = 'PERSONAL',
  Project = 'PROJECT',
  Resource = 'RESOURCE',
  SharedExternal = 'SHARED_EXTERNAL'
}

export type CalendarUserPreference = {
  __typename?: 'CalendarUserPreference';
  clientId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  mainCalendarId?: Maybe<Scalars['String']['output']>;
  pinnedCalendarIds: Array<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** Calendar visibility levels */
export enum CalendarVisibility {
  Company = 'COMPANY',
  Private = 'PRIVATE',
  Public = 'PUBLIC',
  Shared = 'SHARED',
  Team = 'TEAM'
}

/** The direction of the call */
export enum CallDirection {
  Both = 'BOTH',
  Inbound = 'INBOUND',
  Outbound = 'OUTBOUND'
}

export type CallLinkedParty = {
  __typename?: 'CallLinkedParty';
  detailUrl: Scalars['String']['output'];
  kind: CallPartyKind;
  label: Scalars['String']['output'];
  number: Scalars['String']['output'];
  residentId: Scalars['String']['output'];
};

/** What kind of record a call was matched to by phone number */
export enum CallPartyKind {
  Resident = 'RESIDENT',
  ResidentContact = 'RESIDENT_CONTACT'
}

export type CallRecording = {
  __typename?: 'CallRecording';
  audioCid?: Maybe<Scalars['String']['output']>;
  audioIpfsUrl?: Maybe<Scalars['String']['output']>;
  callSid?: Maybe<Scalars['String']['output']>;
  cid?: Maybe<Scalars['String']['output']>;
  cost: Scalars['Float']['output'];
  createdAt: Scalars['DateTime']['output'];
  currency: Scalars['String']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  direction: CallDirection;
  duration: Scalars['Float']['output'];
  errorMessage?: Maybe<Scalars['String']['output']>;
  from: Scalars['String']['output'];
  /** Matches this viewer is not allowed to see (no names, no links). */
  hiddenPartyCount: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  linkedParties: Array<CallLinkedParty>;
  localFilePath?: Maybe<Scalars['String']['output']>;
  phoneLine?: Maybe<PhoneLine>;
  phoneLineId?: Maybe<Scalars['ID']['output']>;
  phoneNumber?: Maybe<TwilioPhoneNumber>;
  phoneNumberId?: Maybe<Scalars['ID']['output']>;
  provider: PhoneProvider;
  recordedAt: Scalars['DateTime']['output'];
  recordingSid: Scalars['String']['output'];
  recordingUrl?: Maybe<Scalars['String']['output']>;
  source?: Maybe<CallSource>;
  status: RecordingStatus;
  tenantId: Scalars['String']['output'];
  to: Scalars['String']['output'];
  transcribedAt?: Maybe<Scalars['DateTime']['output']>;
  transcriptionConfidence?: Maybe<Scalars['Float']['output']>;
  transcriptionStatus: TranscriptionStatus;
  transcriptionText?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type CallRecordingConnection = {
  __typename?: 'CallRecordingConnection';
  items: Array<CallRecording>;
  pageInfo: PageInfo;
  totalCount: Scalars['Float']['output'];
};

export type CallRecordingFilterInput = {
  direction?: InputMaybe<CallDirection>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  from?: InputMaybe<Scalars['String']['input']>;
  phoneLineId?: InputMaybe<Scalars['ID']['input']>;
  phoneNumberId?: InputMaybe<Scalars['ID']['input']>;
  provider?: InputMaybe<PhoneProvider>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<RecordingStatus>;
  to?: InputMaybe<Scalars['String']['input']>;
  transcriptionStatus?: InputMaybe<TranscriptionStatus>;
};

/** The source of the call (phone device, browser, or webhook) */
export enum CallSource {
  Browser = 'BROWSER',
  Phone = 'PHONE',
  Webhook = 'WEBHOOK'
}

export type CallVolumeBucket = {
  __typename?: 'CallVolumeBucket';
  count: Scalars['Int']['output'];
  key: Scalars['String']['output'];
};

export type CancelOrderInput = {
  orderId: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
};

export type CancelReferralInput = {
  cancellationReason?: InputMaybe<Scalars['String']['input']>;
  referralId: Scalars['ID']['input'];
};

export type CancelRewardTokenInput = {
  reason: Scalars['String']['input'];
  tokenId: Scalars['ID']['input'];
};

export type Candidate = {
  __typename?: 'Candidate';
  addressCountry?: Maybe<Scalars['String']['output']>;
  addressPostcode?: Maybe<Scalars['String']['output']>;
  addressState?: Maybe<Scalars['String']['output']>;
  addressStreetName?: Maybe<Scalars['String']['output']>;
  addressStreetNumber?: Maybe<Scalars['String']['output']>;
  addressSuburb?: Maybe<Scalars['String']['output']>;
  ahpraUrl?: Maybe<Scalars['String']['output']>;
  /**
   * @deprecated Use credentials.certificates[].cid.
   * @deprecated Use credentials.certificates
   */
  certificateFileIds: Array<Scalars['ID']['output']>;
  /** Gateway URL per credentials.certificates entry (same order); empty string when the entry has no CID */
  certificateUrls: Array<Scalars['String']['output']>;
  chaseConfigId?: Maybe<Scalars['ID']['output']>;
  chatRoomSlug?: Maybe<Scalars['String']['output']>;
  companyId?: Maybe<Scalars['ID']['output']>;
  convertedAt?: Maybe<Scalars['DateTime']['output']>;
  convertedToEmployeeId?: Maybe<Scalars['ID']['output']>;
  /**
   * @deprecated Use credentials.coverLetterCid.
   * @deprecated Use credentials.coverLetterCid
   */
  coverLetterFileId?: Maybe<Scalars['ID']['output']>;
  coverLetterUrl?: Maybe<Scalars['String']['output']>;
  cprUrl?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<Scalars['ID']['output']>;
  credentialChecklist: CredentialChecklistStatus;
  credentials?: Maybe<CandidateCredentials>;
  dateOfBirth?: Maybe<Scalars['DateTime']['output']>;
  departmentId?: Maybe<Scalars['ID']['output']>;
  /** Date-only, stored at T00:00:00.000Z */
  earliestStart?: Maybe<Scalars['DateTime']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstAidUrl?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  /** The CandidateForm this candidate applied through (source of minReferences and preScreenQuestions) */
  formId?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  interviewNotes: Array<InterviewNote>;
  jobTitle?: Maybe<Scalars['String']['output']>;
  lastName: Scalars['String']['output'];
  locationId?: Maybe<Scalars['ID']['output']>;
  middleName?: Maybe<Scalars['String']['output']>;
  offerAcceptedAt?: Maybe<Scalars['DateTime']['output']>;
  offerAmount?: Maybe<Scalars['Float']['output']>;
  offerExtendedAt?: Maybe<Scalars['DateTime']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  phoneScreeningAt?: Maybe<Scalars['DateTime']['output']>;
  phoneScreeningNotes?: Maybe<Scalars['String']['output']>;
  /**
   * @deprecated Use credentials.policeCheck.cid.
   * @deprecated Use credentials.policeCheck.cid
   */
  policeCheckFileId?: Maybe<Scalars['ID']['output']>;
  policeCheckUrl?: Maybe<Scalars['String']['output']>;
  preScreen?: Maybe<CandidatePreScreen>;
  /**
   * @deprecated JSON-encoded public-form answers; new pre-screens are structured under preScreen.
   * @deprecated Use preScreen.answers
   */
  preScreeningAnswers?: Maybe<Scalars['String']['output']>;
  preScreeningInviteId?: Maybe<Scalars['ID']['output']>;
  preScreeningSubmittedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Earlier REJECTED/WITHDRAWN rows for the same person on this tenant */
  previousApplications: Array<CandidatePreviousApplication>;
  rateContext?: Maybe<Scalars['String']['output']>;
  referenceContacts: Array<ReferenceContact>;
  referencesReceived: Scalars['Int']['output'];
  referencesRequired: Scalars['Int']['output'];
  referrerClientId?: Maybe<Scalars['ID']['output']>;
  rejectionReason?: Maybe<Scalars['String']['output']>;
  /**
   * @deprecated Use credentials.resumeCid. Legacy IPFS hash stored under the old name.
   * @deprecated Use credentials.resumeCid
   */
  resumeFileId?: Maybe<Scalars['ID']['output']>;
  resumeUrl?: Maybe<Scalars['String']['output']>;
  rightToWorkStatus?: Maybe<Scalars['String']['output']>;
  /** Copied from the CandidateForm at application; drives credentialChecklist */
  roleCategory?: Maybe<RoleCategory>;
  source?: Maybe<CandidateSource>;
  sourceNote?: Maybe<Scalars['String']['output']>;
  stage: CandidateStage;
  status: CandidateStatus;
  tags: Array<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  urgency?: Maybe<CandidateUrgency>;
  workingRightsUrl?: Maybe<Scalars['String']['output']>;
};

export type CandidateActivity = {
  __typename?: 'CandidateActivity';
  at: Scalars['DateTime']['output'];
  byId?: Maybe<Scalars['ID']['output']>;
  byName: Scalars['String']['output'];
  candidateId: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  /** JSON string; sensitive values are redacted before save */
  details?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  summary: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  type: CandidateActivityType;
  updatedAt: Scalars['DateTime']['output'];
};

export enum CandidateActivityType {
  DeclinedByCompany = 'DECLINED_BY_COMPANY',
  DocumentAccepted = 'DOCUMENT_ACCEPTED',
  DocumentRejected = 'DOCUMENT_REJECTED',
  DocumentUploaded = 'DOCUMENT_UPLOADED',
  InterviewDone = 'INTERVIEW_DONE',
  InterviewScheduled = 'INTERVIEW_SCHEDULED',
  Note = 'NOTE',
  Placed = 'PLACED',
  PreScreenCompleted = 'PRE_SCREEN_COMPLETED',
  PutForward = 'PUT_FORWARD',
  Reapplied = 'REAPPLIED',
  ReferenceReceived = 'REFERENCE_RECEIVED',
  ReferenceRequested = 'REFERENCE_REQUESTED',
  Rejected = 'REJECTED',
  StageChanged = 'STAGE_CHANGED',
  Withdrawn = 'WITHDRAWN'
}

export type CandidateCertificate = {
  __typename?: 'CandidateCertificate';
  /** IPFS CID of the certificate */
  cid?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  type: CandidateCertificateType;
};

export type CandidateCertificateInput = {
  cid?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  type: CandidateCertificateType;
};

export enum CandidateCertificateType {
  CertIii = 'CERT_III',
  CertIv = 'CERT_IV',
  Other = 'OTHER'
}

export type CandidateChatInviteResult = {
  __typename?: 'CandidateChatInviteResult';
  emailSent: Scalars['Boolean']['output'];
  publicUrl: Scalars['String']['output'];
  roomId: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  smsSent: Scalars['Boolean']['output'];
  success: Scalars['Boolean']['output'];
  warning?: Maybe<Scalars['String']['output']>;
};

export type CandidateChatRoomInfo = {
  __typename?: 'CandidateChatRoomInfo';
  createdNew: Scalars['Boolean']['output'];
  roomId: Scalars['String']['output'];
  slug: Scalars['String']['output'];
};

export type CandidateCredentialInput = {
  ahpraCid?: InputMaybe<Scalars['String']['input']>;
  /** YYYY-MM-DD */
  ahpraExpiry?: InputMaybe<Scalars['String']['input']>;
  ahpraNumber?: InputMaybe<Scalars['String']['input']>;
  /** true = stamp bannedRegisterCheckedAt now */
  bannedRegisterChecked?: InputMaybe<Scalars['Boolean']['input']>;
  bannedRegisterListed?: InputMaybe<Scalars['Boolean']['input']>;
  /** Replaces the whole list when given */
  certificates?: InputMaybe<Array<CandidateCertificateInput>>;
  coverLetterCid?: InputMaybe<Scalars['String']['input']>;
  covidImmunised?: InputMaybe<Scalars['Boolean']['input']>;
  cprCid?: InputMaybe<Scalars['String']['input']>;
  /** YYYY-MM-DD */
  cprExpiry?: InputMaybe<Scalars['String']['input']>;
  firstAidCid?: InputMaybe<Scalars['String']['input']>;
  /** YYYY-MM-DD */
  firstAidExpiry?: InputMaybe<Scalars['String']['input']>;
  fluImmunised?: InputMaybe<Scalars['Boolean']['input']>;
  medicationsEndorsement?: InputMaybe<Scalars['Boolean']['input']>;
  policeCheck?: InputMaybe<CandidatePoliceCheckInput>;
  resumeCid?: InputMaybe<Scalars['String']['input']>;
  workingRightsCid?: InputMaybe<Scalars['String']['input']>;
  workingRightsStatus?: InputMaybe<Scalars['String']['input']>;
};

export type CandidateCredentials = {
  __typename?: 'CandidateCredentials';
  ahpraCid?: Maybe<Scalars['String']['output']>;
  /** Date-only, stored at T00:00:00.000Z */
  ahpraExpiry?: Maybe<Scalars['DateTime']['output']>;
  ahpraNumber?: Maybe<Scalars['String']['output']>;
  bannedRegisterCheckedAt?: Maybe<Scalars['DateTime']['output']>;
  bannedRegisterListed?: Maybe<Scalars['Boolean']['output']>;
  certificates: Array<CandidateCertificate>;
  coverLetterCid?: Maybe<Scalars['String']['output']>;
  covidImmunised?: Maybe<Scalars['Boolean']['output']>;
  cprCid?: Maybe<Scalars['String']['output']>;
  /** Date-only, stored at T00:00:00.000Z */
  cprExpiry?: Maybe<Scalars['DateTime']['output']>;
  firstAidCid?: Maybe<Scalars['String']['output']>;
  /** Date-only, stored at T00:00:00.000Z */
  firstAidExpiry?: Maybe<Scalars['DateTime']['output']>;
  fluImmunised?: Maybe<Scalars['Boolean']['output']>;
  /** EN only — medication endorsement on the AHPRA registration */
  medicationsEndorsement?: Maybe<Scalars['Boolean']['output']>;
  policeCheck?: Maybe<CandidatePoliceCheck>;
  resumeCid?: Maybe<Scalars['String']['output']>;
  workingRightsCid?: Maybe<Scalars['String']['output']>;
  workingRightsStatus?: Maybe<Scalars['String']['output']>;
};

export type CandidateExtraction = {
  __typename?: 'CandidateExtraction';
  addressCountry?: Maybe<Scalars['String']['output']>;
  addressPostcode?: Maybe<Scalars['String']['output']>;
  addressState?: Maybe<Scalars['String']['output']>;
  addressStreetName?: Maybe<Scalars['String']['output']>;
  addressStreetNumber?: Maybe<Scalars['String']['output']>;
  addressSuburb?: Maybe<Scalars['String']['output']>;
  dateOfBirth?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  jobTitle?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  middleName?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  rateContext?: Maybe<Scalars['String']['output']>;
  warnings: Array<Scalars['String']['output']>;
};

export type CandidateExtractionInput = {
  text: Scalars['String']['input'];
};

export type CandidateForm = {
  __typename?: 'CandidateForm';
  /** Employer company id from the companies module (plain string, not a Ref) */
  companyId?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  earliestStartRequired: Scalars['Boolean']['output'];
  employerBrandColor?: Maybe<Scalars['String']['output']>;
  employerLogoUrl?: Maybe<Scalars['String']['output']>;
  employerName?: Maybe<Scalars['String']['output']>;
  fields: Array<CandidateFormField>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  isDefault: Scalars['Boolean']['output'];
  jobTitle?: Maybe<Scalars['String']['output']>;
  /** References a candidate needs before SUITABLE (default 2) */
  minReferences?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  /** Advertised title; copied to Candidate.jobTitle at application */
  positionTitle?: Maybe<Scalars['String']['output']>;
  preScreenQuestions: Array<PreScreenQuestion>;
  /** Copied to the candidate; drives the credential checklist */
  roleCategory?: Maybe<RoleCategory>;
  slug: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type CandidateFormAnswer = {
  __typename?: 'CandidateFormAnswer';
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
  values: Array<Scalars['String']['output']>;
};

export type CandidateFormAnswerInput = {
  key: Scalars['String']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
  values?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CandidateFormField = {
  __typename?: 'CandidateFormField';
  fileAcceptTypes?: Maybe<Scalars['String']['output']>;
  helpText?: Maybe<Scalars['String']['output']>;
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  maxReferences?: Maybe<Scalars['Float']['output']>;
  minReferences?: Maybe<Scalars['Float']['output']>;
  options: Array<Scalars['String']['output']>;
  order?: Maybe<Scalars['Float']['output']>;
  required: Scalars['Boolean']['output'];
  type: CandidateFormFieldType;
};

export type CandidateFormFieldInput = {
  fileAcceptTypes?: InputMaybe<Scalars['String']['input']>;
  helpText?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  label: Scalars['String']['input'];
  maxReferences?: InputMaybe<Scalars['Float']['input']>;
  minReferences?: InputMaybe<Scalars['Float']['input']>;
  options?: InputMaybe<Array<Scalars['String']['input']>>;
  order?: InputMaybe<Scalars['Float']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  type: CandidateFormFieldType;
};

/** Type of a field on a candidate pre-screening form */
export enum CandidateFormFieldType {
  Checkbox = 'CHECKBOX',
  Date = 'DATE',
  Email = 'EMAIL',
  File = 'FILE',
  Number = 'NUMBER',
  Phone = 'PHONE',
  ReferenceGroup = 'REFERENCE_GROUP',
  Select = 'SELECT',
  Text = 'TEXT',
  Textarea = 'TEXTAREA'
}

export type CandidateFormSubmission = {
  __typename?: 'CandidateFormSubmission';
  answers: Array<CandidateFormAnswer>;
  candidateId: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  formId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  inviteId: Scalars['ID']['output'];
  ipAddress?: Maybe<Scalars['String']['output']>;
  submittedAt: Scalars['DateTime']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  userAgent?: Maybe<Scalars['String']['output']>;
};

export type CandidateFormSubmitResult = {
  __typename?: 'CandidateFormSubmitResult';
  candidateId?: Maybe<Scalars['ID']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  submissionId?: Maybe<Scalars['ID']['output']>;
  success: Scalars['Boolean']['output'];
};

export type CandidateInvite = {
  __typename?: 'CandidateInvite';
  candidateId: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdByName?: Maybe<Scalars['String']['output']>;
  customMessage?: Maybe<Scalars['String']['output']>;
  emailSentAt?: Maybe<Scalars['DateTime']['output']>;
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  formId?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  slug: Scalars['String']['output'];
  smsSentAt?: Maybe<Scalars['DateTime']['output']>;
  status: CandidateInviteStatus;
  submissionId?: Maybe<Scalars['ID']['output']>;
  submittedAt?: Maybe<Scalars['DateTime']['output']>;
  tenantId: Scalars['String']['output'];
  type: CandidateInviteType;
  updatedAt: Scalars['DateTime']['output'];
};

export type CandidateInviteSendResult = {
  __typename?: 'CandidateInviteSendResult';
  emailSent: Scalars['Boolean']['output'];
  invite: CandidateInvite;
  publicUrl: Scalars['String']['output'];
  smsSent: Scalars['Boolean']['output'];
  success: Scalars['Boolean']['output'];
  warning?: Maybe<Scalars['String']['output']>;
};

/** Delivery / completion status of a candidate invite */
export enum CandidateInviteStatus {
  Expired = 'EXPIRED',
  Pending = 'PENDING',
  Submitted = 'SUBMITTED'
}

/** Purpose of a candidate invite link */
export enum CandidateInviteType {
  DocumentRequest = 'DOCUMENT_REQUEST',
  InterviewConfirm = 'INTERVIEW_CONFIRM',
  OfferAccept = 'OFFER_ACCEPT',
  PreScreening = 'PRE_SCREENING'
}

export type CandidateMessage = {
  __typename?: 'CandidateMessage';
  candidateId: Scalars['ID']['output'];
  channel: CandidateMessageChannel;
  context: CandidateMessageContext;
  createdAt: Scalars['DateTime']['output'];
  createdByUserId?: Maybe<Scalars['ID']['output']>;
  emailBody?: Maybe<Scalars['String']['output']>;
  emailSubject?: Maybe<Scalars['String']['output']>;
  failureReason?: Maybe<Scalars['String']['output']>;
  formUrl?: Maybe<Scalars['String']['output']>;
  goal?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  meetingUrl?: Maybe<Scalars['String']['output']>;
  parentDraftId?: Maybe<Scalars['ID']['output']>;
  scheduledAt?: Maybe<Scalars['DateTime']['output']>;
  scheduledCalendarEventId?: Maybe<Scalars['ID']['output']>;
  sentAt?: Maybe<Scalars['DateTime']['output']>;
  smsCharCount?: Maybe<Scalars['Int']['output']>;
  smsContent?: Maybe<Scalars['String']['output']>;
  status: CandidateMessageStatus;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export enum CandidateMessageChannel {
  Both = 'BOTH',
  Email = 'EMAIL',
  Sms = 'SMS'
}

export enum CandidateMessageContext {
  Chase = 'CHASE',
  General = 'GENERAL',
  Interview = 'INTERVIEW',
  Invite = 'INVITE',
  PhoneScreening = 'PHONE_SCREENING',
  Rejection = 'REJECTION'
}

export enum CandidateMessageStatus {
  Cancelled = 'CANCELLED',
  Draft = 'DRAFT',
  Failed = 'FAILED',
  Scheduled = 'SCHEDULED',
  Sent = 'SENT'
}

export type CandidatePoliceCheck = {
  __typename?: 'CandidatePoliceCheck';
  assessedAt?: Maybe<Scalars['DateTime']['output']>;
  assessedById?: Maybe<Scalars['ID']['output']>;
  assessedByName?: Maybe<Scalars['String']['output']>;
  /** IPFS CID of the police certificate */
  cid?: Maybe<Scalars['String']['output']>;
  disclosedConvictions?: Maybe<Scalars['Boolean']['output']>;
  outcome: PoliceCheckOutcome;
  /** A precluding offence under the Aged Care Act — the candidate cannot be placed */
  precluded?: Maybe<Scalars['Boolean']['output']>;
  receivedAt?: Maybe<Scalars['DateTime']['output']>;
  requestedAt?: Maybe<Scalars['DateTime']['output']>;
  requiresFurtherAssessment?: Maybe<Scalars['Boolean']['output']>;
};

export type CandidatePoliceCheckInput = {
  cid?: InputMaybe<Scalars['String']['input']>;
  /** ISO datetime */
  receivedAt?: InputMaybe<Scalars['String']['input']>;
  /** ISO datetime */
  requestedAt?: InputMaybe<Scalars['String']['input']>;
};

export type CandidatePreScreen = {
  __typename?: 'CandidatePreScreen';
  answers: Array<KeyValueAnswer>;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  completedById?: Maybe<Scalars['ID']['output']>;
  completedByName?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  outcome?: Maybe<PreScreenOutcome>;
};

export type CandidatePreviousApplication = {
  __typename?: 'CandidatePreviousApplication';
  at: Scalars['DateTime']['output'];
  candidateId: Scalars['ID']['output'];
  stage: Scalars['String']['output'];
};

export type CandidatePutForwardResult = {
  __typename?: 'CandidatePutForwardResult';
  candidate: Candidate;
  /** false when the candidate had already been put forward and the snapshot was refreshed */
  created: Scalars['Boolean']['output'];
  /** Recruitment mailbox the employer was emailed at, if any */
  emailTo?: Maybe<Scalars['String']['output']>;
  /** Employer HR managers notified in-app */
  inAppRecipients: Scalars['Int']['output'];
  /** The employer's Invites page deep link for this recommendation */
  link: Scalars['String']['output'];
  /** The EmployeeRecommendation id on the employer tenant */
  recommendationId: Scalars['ID']['output'];
  targetTenantId: Scalars['ID']['output'];
  targetTenantName: Scalars['String']['output'];
};

export type CandidateReference = {
  __typename?: 'CandidateReference';
  answers: Array<KeyValueAnswer>;
  candidateId: Scalars['ID']['output'];
  checkedById?: Maybe<Scalars['ID']['output']>;
  checkedByName?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  email?: Maybe<Scalars['String']['output']>;
  emailSentAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  method: CandidateReferenceMethod;
  name: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  /** 1–5 */
  rating?: Maybe<Scalars['Int']['output']>;
  receivedAt?: Maybe<Scalars['DateTime']['output']>;
  relation?: Maybe<Scalars['String']['output']>;
  requestedAt: Scalars['DateTime']['output'];
  status: CandidateReferenceStatus;
  tenantId: Scalars['String']['output'];
  /** Referee-link token; the only credential the public page holds */
  token: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export enum CandidateReferenceMethod {
  Email = 'EMAIL',
  Link = 'LINK',
  Phone = 'PHONE'
}

export enum CandidateReferenceStatus {
  Declined = 'DECLINED',
  Received = 'RECEIVED',
  Requested = 'REQUESTED'
}

/** How the candidate was sourced */
export enum CandidateSource {
  Agency = 'AGENCY',
  DirectCv = 'DIRECT_CV',
  JobAd = 'JOB_AD',
  Other = 'OTHER',
  Referral = 'REFERRAL'
}

/** Pipeline stage for a prospecting candidate. Ladder: APPLIED → PRE_SCREEN → INTERVIEW_SCHEDULED → INTERVIEW_DONE → REFERENCE_CHECK → DOCUMENT_CHECK → SUITABLE → PUT_FORWARD → PLACED; exits REJECTED/WITHDRAWN. CV_RECEIVED/SCREENING_SENT/SCREENING_REPLIED = APPLIED, PHONE_SCREENING = PRE_SCREEN, SHORTLIST = SUITABLE, OFFER_MADE/HIRED = PLACED (legacy aliases). */
export enum CandidateStage {
  Applied = 'APPLIED',
  CvReceived = 'CV_RECEIVED',
  DocumentCheck = 'DOCUMENT_CHECK',
  Hired = 'HIRED',
  InterviewDone = 'INTERVIEW_DONE',
  InterviewScheduled = 'INTERVIEW_SCHEDULED',
  OfferMade = 'OFFER_MADE',
  PhoneScreening = 'PHONE_SCREENING',
  Placed = 'PLACED',
  PreScreen = 'PRE_SCREEN',
  PutForward = 'PUT_FORWARD',
  ReferenceCheck = 'REFERENCE_CHECK',
  Rejected = 'REJECTED',
  ScreeningReplied = 'SCREENING_REPLIED',
  ScreeningSent = 'SCREENING_SENT',
  Shortlist = 'SHORTLIST',
  Suitable = 'SUITABLE',
  Withdrawn = 'WITHDRAWN'
}

/** High-level status of a candidate */
export enum CandidateStatus {
  Active = 'ACTIVE',
  Hired = 'HIRED',
  Rejected = 'REJECTED',
  Withdrawn = 'WITHDRAWN'
}

/** How urgent is the hire */
export enum CandidateUrgency {
  Asap = 'ASAP',
  Pipeline = 'PIPELINE',
  Standard = 'STANDARD'
}

export type CapacityIndex = {
  __typename?: 'CapacityIndex';
  emotionalLoad?: Maybe<Scalars['Int']['output']>;
  emotionalLoadNotes?: Maybe<Scalars['String']['output']>;
  energy?: Maybe<Scalars['Int']['output']>;
  energyNotes?: Maybe<Scalars['String']['output']>;
  money?: Maybe<Scalars['Int']['output']>;
  moneyNotes?: Maybe<Scalars['String']['output']>;
  overallCapacity?: Maybe<Scalars['Float']['output']>;
  structure?: Maybe<Scalars['Int']['output']>;
  structureNotes?: Maybe<Scalars['String']['output']>;
  support?: Maybe<Scalars['Int']['output']>;
  supportNotes?: Maybe<Scalars['String']['output']>;
  time?: Maybe<Scalars['Int']['output']>;
  timeNotes?: Maybe<Scalars['String']['output']>;
};

export type CapacityIndexInput = {
  emotionalLoad?: InputMaybe<Scalars['Int']['input']>;
  emotionalLoadNotes?: InputMaybe<Scalars['String']['input']>;
  energy?: InputMaybe<Scalars['Int']['input']>;
  energyNotes?: InputMaybe<Scalars['String']['input']>;
  money?: InputMaybe<Scalars['Int']['input']>;
  moneyNotes?: InputMaybe<Scalars['String']['input']>;
  structure?: InputMaybe<Scalars['Int']['input']>;
  structureNotes?: InputMaybe<Scalars['String']['input']>;
  support?: InputMaybe<Scalars['Int']['input']>;
  supportNotes?: InputMaybe<Scalars['String']['input']>;
  time?: InputMaybe<Scalars['Int']['input']>;
  timeNotes?: InputMaybe<Scalars['String']['input']>;
};

export type CaptureClub52WalletAddressInput = {
  playerEmail: Scalars['String']['input'];
  roomName: Scalars['String']['input'];
  walletAddress: Scalars['String']['input'];
};

export type CapturedIngredient = {
  __typename?: 'CapturedIngredient';
  category?: Maybe<Scalars['String']['output']>;
  ingredientName: Scalars['String']['output'];
  isOptional?: Maybe<Scalars['Boolean']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
};

export type CapturedIngredientInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  ingredientName: Scalars['String']['input'];
  isOptional?: InputMaybe<Scalars['Boolean']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
};

export type CapturedRecipe = {
  __typename?: 'CapturedRecipe';
  caloriesPerServing?: Maybe<Scalars['Int']['output']>;
  cookTime?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dietaryTags?: Maybe<Array<Scalars['String']['output']>>;
  dishType?: Maybe<Scalars['String']['output']>;
  ingredients?: Maybe<Array<CapturedIngredient>>;
  instructions?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  prepTime?: Maybe<Scalars['Int']['output']>;
  rawNotes?: Maybe<Scalars['String']['output']>;
  servings?: Maybe<Scalars['Int']['output']>;
  sessionType?: Maybe<Scalars['String']['output']>;
  sourceUrl?: Maybe<Scalars['String']['output']>;
  unreadable?: Maybe<Scalars['Boolean']['output']>;
};

export type CardDetails = {
  __typename?: 'CardDetails';
  brand?: Maybe<Scalars['String']['output']>;
  expMonth?: Maybe<Scalars['Float']['output']>;
  expYear?: Maybe<Scalars['Float']['output']>;
  fingerprint?: Maybe<Scalars['String']['output']>;
  last4?: Maybe<Scalars['String']['output']>;
};

export type CardDetailsInput = {
  brand?: InputMaybe<Scalars['String']['input']>;
  expMonth?: InputMaybe<Scalars['Float']['input']>;
  expYear?: InputMaybe<Scalars['Float']['input']>;
  fingerprint?: InputMaybe<Scalars['String']['input']>;
  last4?: InputMaybe<Scalars['String']['input']>;
};

export type CareDayRecord = {
  __typename?: 'CareDayRecord';
  createdAt: Scalars['DateTime']['output'];
  dayKey: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  residentCount: Scalars['Int']['output'];
  residentSource: CareDayValueSource;
  targetMinutesPerResident: Scalars['Float']['output'];
  targetRnMinutesPerResident?: Maybe<Scalars['Float']['output']>;
  targetSource: CareDayValueSource;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedByName?: Maybe<Scalars['String']['output']>;
};

/** How a care-day value was set */
export enum CareDayValueSource {
  Auto = 'AUTO',
  Manual = 'MANUAL'
}

export type CareHome = {
  __typename?: 'CareHome';
  address?: Maybe<Scalars['String']['output']>;
  /** How we plan to approach this home, in plain words. */
  approachStrategy?: Maybe<Scalars['String']['output']>;
  /** high / medium / low — how sure the research was. */
  contactConfidence?: Maybe<Scalars['String']['output']>;
  /** How many contacts are logged. */
  contactCount: Scalars['Int']['output'];
  /** Where the contact details came from (links). */
  contactSources?: Maybe<Scalars['String']['output']>;
  /** Local council area. */
  council?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  /** Published enquiries / reception email. */
  email?: Maybe<Scalars['String']['output']>;
  /** Australian Government funding in 2024–25, in dollars. */
  governmentFunding?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  /** One line on the last contact. */
  lastContactSummary?: Maybe<Scalars['String']['output']>;
  /** When we last contacted them (UTC). Kept in step by the contact log. */
  lastContactedAt?: Maybe<Scalars['DateTime']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  /** Facility / residential manager, only if published. */
  managerName?: Maybe<Scalars['String']['output']>;
  myAgedCareUrl?: Maybe<Scalars['String']['output']>;
  /** The home's name as the government lists it. */
  name: Scalars['String']['output'];
  nextStep?: Maybe<Scalars['String']['output']>;
  /** Date-only, stored at T00:00:00.000Z. */
  nextStepDue?: Maybe<Scalars['DateTime']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  /** Private company, religious, charitable, community-based, government… */
  organisationType?: Maybe<Scalars['String']['output']>;
  /** Main or reception line, E.164 (+61…). */
  phone?: Maybe<Scalars['String']['output']>;
  /** Residential places (beds) on the service list. */
  places?: Maybe<Scalars['Int']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  priority: CareHomePriority;
  providerAbn?: Maybe<Scalars['String']['output']>;
  /** How many homes the same provider runs in this state (from the service list). */
  providerHomesInState?: Maybe<Scalars['Int']['output']>;
  /** The approved provider — the company that owns or runs the home. */
  providerName?: Maybe<Scalars['String']['output']>;
  /** Who answers the front desk, and anything useful about reaching them. */
  receptionContact?: Maybe<Scalars['String']['output']>;
  /** Primary Health Network region. */
  region?: Maybe<Scalars['String']['output']>;
  /** Major city, inner/outer regional, remote. */
  remoteness?: Maybe<Scalars['String']['output']>;
  segment: CareHomeSegment;
  /** The dataset the row came from, e.g. 'GEN Aged Care Service List, 30 Jun 2025'. */
  sourceDataset?: Maybe<Scalars['String']['output']>;
  stage: CareHomeStage;
  /** Overall Star Rating (1–5), when published. */
  starRating?: Maybe<Scalars['Int']['output']>;
  state: Scalars['String']['output'];
  suburb?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  /** The name it trades under, when different from the listed name. */
  tradingName?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  website?: Maybe<Scalars['String']['output']>;
};

export enum CareHomeAction {
  ContactLogged = 'CONTACT_LOGGED',
  Created = 'CREATED',
  Edited = 'EDITED',
  Imported = 'IMPORTED',
  RefreshedFromSource = 'REFRESHED_FROM_SOURCE',
  StageChanged = 'STAGE_CHANGED'
}

export type CareHomeActivity = {
  __typename?: 'CareHomeActivity';
  action: CareHomeAction;
  actorClientId?: Maybe<Scalars['String']['output']>;
  actorName?: Maybe<Scalars['String']['output']>;
  /** When it happened (UTC). For a contact, when the contact took place. */
  at: Scalars['DateTime']['output'];
  careHomeId: Scalars['String']['output'];
  changes: Array<CareHomeFieldChange>;
  channel?: Maybe<CareHomeContactChannel>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  summary: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export enum CareHomeContactChannel {
  Email = 'EMAIL',
  InPerson = 'IN_PERSON',
  Letter = 'LETTER',
  Meeting = 'MEETING',
  Other = 'OTHER',
  Phone = 'PHONE'
}

export type CareHomeContactInput = {
  /** When it happened (defaults to now). */
  at?: InputMaybe<Scalars['DateTime']['input']>;
  careHomeId: Scalars['ID']['input'];
  channel: CareHomeContactChannel;
  /** Move the home to this stage at the same time. */
  newStage?: InputMaybe<CareHomeStage>;
  summary: Scalars['String']['input'];
};

export type CareHomeCount = {
  __typename?: 'CareHomeCount';
  count: Scalars['Int']['output'];
  key: Scalars['String']['output'];
};

export type CareHomeFieldChange = {
  __typename?: 'CareHomeFieldChange';
  field: Scalars['String']['output'];
  from?: Maybe<Scalars['String']['output']>;
  to?: Maybe<Scalars['String']['output']>;
};

export type CareHomeFilterOptions = {
  __typename?: 'CareHomeFilterOptions';
  /** Health network regions, A–Z. */
  regions: Array<Scalars['String']['output']>;
  /** States that have homes, A–Z. */
  states: Array<Scalars['String']['output']>;
};

/** A page of homes. `total` counts every home that matched, not just this page. */
export type CareHomePage = {
  __typename?: 'CareHomePage';
  items: Array<CareHome>;
  limit: Scalars['Int']['output'];
  offset: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum CareHomePriority {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM'
}

export type CareHomeSearchInput = {
  /** Only homes whose next step is due today or earlier. */
  dueOnly?: InputMaybe<Scalars['Boolean']['input']>;
  /** Only homes with a phone number. */
  hasPhone?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Only homes of 30–120 places. */
  midSizeOnly?: InputMaybe<Scalars['Boolean']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  priority?: InputMaybe<CareHomePriority>;
  region?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  segment?: InputMaybe<CareHomeSegment>;
  sort?: InputMaybe<CareHomeSort>;
  /** true = descending. */
  sortDesc?: InputMaybe<Scalars['Boolean']['input']>;
  stage?: InputMaybe<CareHomeStage>;
  state?: InputMaybe<Scalars['String']['input']>;
};

export enum CareHomeSegment {
  Chain = 'CHAIN',
  Government = 'GOVERNMENT',
  Independent = 'INDEPENDENT'
}

export enum CareHomeSort {
  LastContacted = 'LAST_CONTACTED',
  Name = 'NAME',
  Places = 'PLACES',
  Priority = 'PRIORITY',
  Suburb = 'SUBURB'
}

export enum CareHomeStage {
  Attended = 'ATTENDED',
  DoNotContact = 'DO_NOT_CONTACT',
  Invited = 'INVITED',
  Member = 'MEMBER',
  NotContacted = 'NOT_CONTACTED',
  NotInterested = 'NOT_INTERESTED',
  Replied = 'REPLIED',
  Researched = 'RESEARCHED'
}

/** Counts for the dashboard, all computed from the same filter as the list. */
export type CareHomeStats = {
  __typename?: 'CareHomeStats';
  byPriority: Array<CareHomeCount>;
  bySegment: Array<CareHomeCount>;
  byStage: Array<CareHomeCount>;
  contacted: Scalars['Int']['output'];
  /** Homes whose next step is due today or earlier (Brisbane date). */
  nextStepDue: Scalars['Int']['output'];
  places: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  withEmail: Scalars['Int']['output'];
  withPhone: Scalars['Int']['output'];
  withWebsite: Scalars['Int']['output'];
};

export type CareHomeUpdateInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  approachStrategy?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  managerName?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nextStep?: InputMaybe<Scalars['String']['input']>;
  /** YYYY-MM-DD (a Brisbane calendar date). Stored at T00:00:00.000Z. */
  nextStepDue?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  organisationType?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  places?: InputMaybe<Scalars['Int']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<CareHomePriority>;
  providerAbn?: InputMaybe<Scalars['String']['input']>;
  providerName?: InputMaybe<Scalars['String']['input']>;
  receptionContact?: InputMaybe<Scalars['String']['input']>;
  segment?: InputMaybe<CareHomeSegment>;
  stage?: InputMaybe<CareHomeStage>;
  starRating?: InputMaybe<Scalars['Int']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  suburb?: InputMaybe<Scalars['String']['input']>;
  tradingName?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

/** A care-planning requirement, whether the law sets it, and where it comes from */
export type CareLegalRequirement = {
  __typename?: 'CareLegalRequirement';
  appliesTo: Array<Scalars['String']['output']>;
  basis: LegalBasis;
  /** e.g. "Aged Care Rules 2025 s 148-xx" or "Quality Standard Outcome 3.1" */
  citation: Scalars['String']['output'];
  /** Number of days the law itself fixes, when it fixes one */
  daysFixedByLaw?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  /** True when the law sets this requirement (Act, Rules, Quality Standards, funding rules) */
  isLegal: Scalars['Boolean']['output'];
  /** True when this is the built-in wording (no tenant copy saved) */
  isStandard: Scalars['Boolean']['output'];
  /** True when this tenant added the row (there is no built-in row with this key) */
  isTenantOnly: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  /** The requirement in plain words */
  requirement: Scalars['String']['output'];
  sourceTitle?: Maybe<Scalars['String']['output']>;
  sourceUrl?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedByName?: Maybe<Scalars['String']['output']>;
  /** Date-only (YYYY-MM-DD) the citation was last checked against the source */
  verifiedOn?: Maybe<Scalars['String']['output']>;
};

/** Narrow the legal requirements list */
export type CareLegalRequirementFilterInput = {
  /** Only rows that apply to any of these */
  appliesTo?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Include rows switched off */
  includeInactive?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Level of assistance required for care activities */
export enum CareLevel {
  FullAssist = 'FULL_ASSIST',
  Independent = 'INDEPENDENT',
  PartialAssist = 'PARTIAL_ASSIST',
  Supervision = 'SUPERVISION'
}

export type CareMinutesChatAnswer = {
  __typename?: 'CareMinutesChatAnswer';
  answer: Scalars['String']['output'];
  model: Scalars['String']['output'];
  ms: Scalars['Int']['output'];
};

export type CareMinutesChatInput = {
  facts: Scalars['String']['input'];
  model?: InputMaybe<Scalars['String']['input']>;
  question: Scalars['String']['input'];
};

export type CareMinutesStatementResult = {
  __typename?: 'CareMinutesStatementResult';
  bedDayIssues: Array<StatementIssue>;
  blocks: Array<StatementPeriodBlock>;
  costCoverageNote: Scalars['String']['output'];
  costDaysCovered: Scalars['Int']['output'];
  costDaysInRange: Scalars['Int']['output'];
  dataStartDate?: Maybe<Scalars['String']['output']>;
  facilityName: Scalars['String']['output'];
  fileBase64?: Maybe<Scalars['String']['output']>;
  fileName?: Maybe<Scalars['String']['output']>;
  rnCoverage: Array<StatementRnCoverage>;
};

export type CareNeedsAssessment = {
  __typename?: 'CareNeedsAssessment';
  careTypeNeeded?: Maybe<CareType>;
  hasBehaviorConcerns?: Maybe<Scalars['Boolean']['output']>;
  hasCognitiveImpairment?: Maybe<Scalars['Boolean']['output']>;
  hasComplexMedicalNeeds?: Maybe<Scalars['Boolean']['output']>;
  hasMobilityIssues?: Maybe<Scalars['Boolean']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  otherDiagnoses?: Maybe<Array<Scalars['String']['output']>>;
  primaryDiagnosis?: Maybe<Scalars['String']['output']>;
  requiresSecureUnit?: Maybe<Scalars['Boolean']['output']>;
  requiresSingleRoom?: Maybe<Scalars['Boolean']['output']>;
};

export type CareNeedsAssessmentInput = {
  careTypeNeeded?: InputMaybe<CareType>;
  hasBehaviorConcerns?: InputMaybe<Scalars['Boolean']['input']>;
  hasCognitiveImpairment?: InputMaybe<Scalars['Boolean']['input']>;
  hasComplexMedicalNeeds?: InputMaybe<Scalars['Boolean']['input']>;
  hasMobilityIssues?: InputMaybe<Scalars['Boolean']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  otherDiagnoses?: InputMaybe<Array<Scalars['String']['input']>>;
  primaryDiagnosis?: InputMaybe<Scalars['String']['input']>;
  requiresSecureUnit?: InputMaybe<Scalars['Boolean']['input']>;
  requiresSingleRoom?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CarePlan = {
  __typename?: 'CarePlan';
  activityLog: Array<CarePlanActivityLog>;
  approvalDate?: Maybe<Scalars['DateTime']['output']>;
  approvalNotes?: Maybe<Scalars['String']['output']>;
  approvedBy?: Maybe<Scalars['ID']['output']>;
  approvedByName?: Maybe<Scalars['String']['output']>;
  assessment?: Maybe<CarePlanAssessment>;
  category: CarePlanCategory;
  copiesGiven?: Maybe<Array<CarePlanCopyGiven>>;
  copyStatus: CarePlanCopyStatus;
  createdAt: Scalars['DateTime']['output'];
  customizedFromTemplate: Scalars['Boolean']['output'];
  effectiveDate: Scalars['DateTime']['output'];
  evaluations: Array<CarePlanEvaluation>;
  expiryDate?: Maybe<Scalars['DateTime']['output']>;
  goals: Array<CarePlanGoal>;
  id: Scalars['ID']['output'];
  interventions: Array<CarePlanIntervention>;
  /** A superseded SarahCare version — history only, never current care */
  isSarahHistory?: Maybe<Scalars['Boolean']['output']>;
  lastReviewDate?: Maybe<Scalars['DateTime']['output']>;
  nextReviewDate?: Maybe<Scalars['DateTime']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  participants?: Maybe<Array<CarePlanParticipant>>;
  planName: Scalars['String']['output'];
  preparedBy: Scalars['ID']['output'];
  preparedByName?: Maybe<Scalars['String']['output']>;
  residentId: Scalars['ID']['output'];
  reviewFrequency: ReviewFrequency;
  sarahSource?: Maybe<SarahCarePlanSourceFields>;
  sourceAuthor?: Maybe<Scalars['String']['output']>;
  sourceBackupDate?: Maybe<Scalars['DateTime']['output']>;
  sourceHash?: Maybe<Scalars['String']['output']>;
  sourceId?: Maybe<Scalars['String']['output']>;
  sourceSystem?: Maybe<Scalars['String']['output']>;
  status: CarePlanStatus;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  templateId?: Maybe<Scalars['ID']['output']>;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type CarePlanActivityLog = {
  __typename?: 'CarePlanActivityLog';
  action: Scalars['String']['output'];
  details?: Maybe<Scalars['String']['output']>;
  performedBy: Scalars['ID']['output'];
  performedByName?: Maybe<Scalars['String']['output']>;
  timestamp: Scalars['DateTime']['output'];
};

/** A participant's agreement to the plan */
export enum CarePlanAgreement {
  Agreed = 'AGREED',
  AgreedWithChanges = 'AGREED_WITH_CHANGES',
  DidNotAgree = 'DID_NOT_AGREE',
  NotAsked = 'NOT_ASKED'
}

export type CarePlanAssessment = {
  __typename?: 'CarePlanAssessment';
  background?: Maybe<Scalars['String']['output']>;
  cultureAndBeliefs?: Maybe<Scalars['String']['output']>;
  needs?: Maybe<Scalars['String']['output']>;
  preferences?: Maybe<Scalars['String']['output']>;
  risks?: Maybe<Scalars['String']['output']>;
  strengths?: Maybe<Scalars['String']['output']>;
  whatMattersToMe?: Maybe<Scalars['String']['output']>;
};

export type CarePlanAssessmentInput = {
  background?: InputMaybe<Scalars['String']['input']>;
  cultureAndBeliefs?: InputMaybe<Scalars['String']['input']>;
  needs?: InputMaybe<Scalars['String']['input']>;
  preferences?: InputMaybe<Scalars['String']['input']>;
  risks?: InputMaybe<Scalars['String']['input']>;
  strengths?: InputMaybe<Scalars['String']['input']>;
  whatMattersToMe?: InputMaybe<Scalars['String']['input']>;
};

/** Category of care plan */
export enum CarePlanCategory {
  Behavior = 'BEHAVIOR',
  Cognitive = 'COGNITIVE',
  Communication = 'COMMUNICATION',
  Complex = 'COMPLEX',
  Continence = 'CONTINENCE',
  DailyLiving = 'DAILY_LIVING',
  Medication = 'MEDICATION',
  Nutritional = 'NUTRITIONAL',
  Other = 'OTHER',
  Pain = 'PAIN',
  Palliative = 'PALLIATIVE',
  Physical = 'PHYSICAL',
  RiskManagement = 'RISK_MANAGEMENT',
  Skin = 'SKIN',
  Sleep = 'SLEEP',
  Social = 'SOCIAL',
  Spiritual = 'SPIRITUAL'
}

export type CarePlanComplianceReport = {
  __typename?: 'CarePlanComplianceReport';
  carePlanId: Scalars['ID']['output'];
  carePlanName: Scalars['String']['output'];
  interventionStats: Array<InterventionComplianceStats>;
  overallComplianceRate: Scalars['Float']['output'];
  periodEnd: Scalars['DateTime']['output'];
  periodStart: Scalars['DateTime']['output'];
  residentId: Scalars['ID']['output'];
  totalInterventionsCompleted: Scalars['Int']['output'];
  totalInterventionsExpected: Scalars['Int']['output'];
  totalInterventionsMissed: Scalars['Int']['output'];
};

export type CarePlanCopyGiven = {
  __typename?: 'CarePlanCopyGiven';
  contactId?: Maybe<Scalars['ID']['output']>;
  copyKind: CarePlanCopyKind;
  coversChangeAt?: Maybe<Scalars['DateTime']['output']>;
  givenAt: Scalars['DateTime']['output'];
  givenByName?: Maybe<Scalars['String']['output']>;
  givenToKind: CarePlanParticipantKind;
  givenToName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  method: CarePlanCopyMethod;
  notes?: Maybe<Scalars['String']['output']>;
};

/** Whether the whole plan or a summary was given */
export enum CarePlanCopyKind {
  FullPlan = 'FULL_PLAN',
  Summary = 'SUMMARY'
}

/** How a copy of the plan was given */
export enum CarePlanCopyMethod {
  Email = 'EMAIL',
  FamilyPortal = 'FAMILY_PORTAL',
  InPerson = 'IN_PERSON',
  Post = 'POST'
}

export type CarePlanCopyStatus = {
  __typename?: 'CarePlanCopyStatus';
  copyOwed: Scalars['Boolean']['output'];
  lastChangeAt?: Maybe<Scalars['DateTime']['output']>;
  lastCopyGivenAt?: Maybe<Scalars['DateTime']['output']>;
  words: Scalars['String']['output'];
};

export type CarePlanCountsByStatus = {
  __typename?: 'CarePlanCountsByStatus';
  active: Scalars['Int']['output'];
  archived: Scalars['Int']['output'];
  draft: Scalars['Int']['output'];
  /** Superseded SarahCare versions (history only, not in total) */
  sarahHistory?: Maybe<Scalars['Int']['output']>;
  total: Scalars['Int']['output'];
  underReview: Scalars['Int']['output'];
};

export type CarePlanEvaluation = {
  __typename?: 'CarePlanEvaluation';
  attendees?: Maybe<Array<Scalars['String']['output']>>;
  date: Scalars['DateTime']['output'];
  evaluatedBy: Scalars['ID']['output'];
  evaluatorName?: Maybe<Scalars['String']['output']>;
  goalsReviewed?: Maybe<Array<Scalars['Float']['output']>>;
  interventionsModified?: Maybe<Array<Scalars['Float']['output']>>;
  nextSteps?: Maybe<Scalars['String']['output']>;
  outcome?: Maybe<Scalars['String']['output']>;
  progress?: Maybe<Scalars['String']['output']>;
  sarahSource?: Maybe<SarahCarePlanEvaluationSource>;
};

export type CarePlanFilterInput = {
  categories?: InputMaybe<Array<CarePlanCategory>>;
  /** Also return superseded SarahCare versions (hidden by default) */
  includeSarahHistory?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Float']['input']>;
  offset?: InputMaybe<Scalars['Float']['input']>;
  residentId?: InputMaybe<Scalars['ID']['input']>;
  reviewDueBefore?: InputMaybe<Scalars['DateTime']['input']>;
  /** Return ONLY superseded SarahCare versions */
  sarahHistoryOnly?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<CarePlanStatus>>;
};

export type CarePlanGoal = {
  __typename?: 'CarePlanGoal';
  achievedDate?: Maybe<Scalars['DateTime']['output']>;
  achievementCriteria?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  milestones?: Maybe<Array<GoalMilestone>>;
  notes?: Maybe<Scalars['String']['output']>;
  priority?: Maybe<Scalars['Float']['output']>;
  progress?: Maybe<Scalars['String']['output']>;
  progressPercentage?: Maybe<Scalars['Float']['output']>;
  status: CarePlanGoalStatus;
  targetDate?: Maybe<Scalars['DateTime']['output']>;
};

export type CarePlanGoalInput = {
  achievementCriteria?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  priority?: InputMaybe<Scalars['Float']['input']>;
  progress?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<CarePlanGoalStatus>;
  targetDate?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Status of a care plan goal */
export enum CarePlanGoalStatus {
  Achieved = 'ACHIEVED',
  Discontinued = 'DISCONTINUED',
  InProgress = 'IN_PROGRESS',
  NotAchieved = 'NOT_ACHIEVED',
  Ongoing = 'ONGOING'
}

export type CarePlanIntervention = {
  __typename?: 'CarePlanIntervention';
  calendarEventId?: Maybe<Scalars['ID']['output']>;
  completionCount?: Maybe<Scalars['Float']['output']>;
  completionRecords?: Maybe<Array<InterventionCompletion>>;
  description: Scalars['String']['output'];
  duration?: Maybe<Scalars['String']['output']>;
  /** Reference to EmployeeRole for dynamic role assignment */
  employeeRoleId?: Maybe<Scalars['ID']['output']>;
  frequency: InterventionFrequency;
  goalIndex?: Maybe<Scalars['Float']['output']>;
  instructions?: Maybe<Scalars['String']['output']>;
  isActive: Scalars['Boolean']['output'];
  lastCompletedAt?: Maybe<Scalars['DateTime']['output']>;
  linkedMedicationId?: Maybe<Scalars['ID']['output']>;
  /** @deprecated Use employeeRoleId for dynamic roles */
  responsibleRole?: Maybe<ResponsibleRole>;
  /** Resolved role name (from EmployeeRole or legacy enum) */
  roleName?: Maybe<Scalars['String']['output']>;
  scheduleTimes?: Maybe<Array<Scalars['String']['output']>>;
};

export type CarePlanInterventionInput = {
  description: Scalars['String']['input'];
  duration?: InputMaybe<Scalars['String']['input']>;
  /** Reference to EmployeeRole for dynamic role assignment */
  employeeRoleId?: InputMaybe<Scalars['ID']['input']>;
  frequency?: InputMaybe<InterventionFrequency>;
  goalIndex?: InputMaybe<Scalars['Float']['input']>;
  instructions?: InputMaybe<Scalars['String']['input']>;
  linkedMedicationId?: InputMaybe<Scalars['ID']['input']>;
  scheduleTimes?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CarePlanPdfExport = {
  __typename?: 'CarePlanPDFExport';
  base64Content: Scalars['String']['output'];
  filename: Scalars['String']['output'];
  mimeType: Scalars['String']['output'];
  sizeBytes: Scalars['Int']['output'];
};

export type CarePlanParticipant = {
  __typename?: 'CarePlanParticipant';
  agreement: CarePlanAgreement;
  comments?: Maybe<Scalars['String']['output']>;
  contactId?: Maybe<Scalars['ID']['output']>;
  kind: CarePlanParticipantKind;
  name: Scalars['String']['output'];
  recordedAt: Scalars['DateTime']['output'];
  recordedByName?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
};

export type CarePlanParticipantInput = {
  agreement?: InputMaybe<CarePlanAgreement>;
  comments?: InputMaybe<Scalars['String']['input']>;
  contactId?: InputMaybe<Scalars['ID']['input']>;
  kind: CarePlanParticipantKind;
  name?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
};

/** Who a care-plan participant (or copy recipient) is */
export enum CarePlanParticipantKind {
  FamilyOrRepresentative = 'FAMILY_OR_REPRESENTATIVE',
  HealthProfessional = 'HEALTH_PROFESSIONAL',
  Resident = 'RESIDENT',
  Staff = 'STAFF'
}

export type CarePlanPersonOption = {
  __typename?: 'CarePlanPersonOption';
  canMakeDecisions: Scalars['Boolean']['output'];
  contactId: Scalars['ID']['output'];
  email?: Maybe<Scalars['String']['output']>;
  hasFamilyPortal: Scalars['Boolean']['output'];
  isGuardian: Scalars['Boolean']['output'];
  isMedicalPowerOfAttorney: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  relationship: Scalars['String']['output'];
};

export type CarePlanReview = {
  __typename?: 'CarePlanReview';
  actionItems: Array<ReviewActionItem>;
  actualDate?: Maybe<Scalars['DateTime']['output']>;
  approvalDate?: Maybe<Scalars['DateTime']['output']>;
  approvalNotes?: Maybe<Scalars['String']['output']>;
  approvedBy?: Maybe<Scalars['ID']['output']>;
  approvedByName?: Maybe<Scalars['String']['output']>;
  attendees: Array<ReviewAttendee>;
  carePlanId: Scalars['ID']['output'];
  carePlanName?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  familyInput?: Maybe<Scalars['String']['output']>;
  goalOutcomes: Array<GoalReviewOutcome>;
  id: Scalars['ID']['output'];
  isFamilyMeeting: Scalars['Boolean']['output'];
  nextReviewDate?: Maybe<Scalars['DateTime']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  progress?: Maybe<Scalars['String']['output']>;
  recommendations?: Maybe<Scalars['String']['output']>;
  residentId: Scalars['ID']['output'];
  residentName?: Maybe<Scalars['String']['output']>;
  reviewType?: Maybe<Scalars['String']['output']>;
  reviewedBy: Scalars['ID']['output'];
  reviewedByName?: Maybe<Scalars['String']['output']>;
  scheduledDate: Scalars['DateTime']['output'];
  status: ReviewStatus;
  summary?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type CarePlanReviewFilterInput = {
  carePlanId?: InputMaybe<Scalars['ID']['input']>;
  isFamilyMeeting?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Float']['input']>;
  offset?: InputMaybe<Scalars['Float']['input']>;
  residentId?: InputMaybe<Scalars['ID']['input']>;
  scheduledAfter?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledBefore?: InputMaybe<Scalars['DateTime']['input']>;
  statuses?: InputMaybe<Array<ReviewStatus>>;
};

/** Where a care plan stands on its review date */
export enum CarePlanReviewState {
  DueSoon = 'DUE_SOON',
  NotSet = 'NOT_SET',
  OnTrack = 'ON_TRACK',
  Overdue = 'OVERDUE'
}

export type CarePlanReviewsResponse = {
  __typename?: 'CarePlanReviewsResponse';
  limit: Scalars['Int']['output'];
  offset: Scalars['Int']['output'];
  reviews: Array<CarePlanReview>;
  total: Scalars['Int']['output'];
};

export type CarePlanStatistics = {
  __typename?: 'CarePlanStatistics';
  activeCarePlans: Scalars['Int']['output'];
  averageGoalAchievementRate: Scalars['Float']['output'];
  goalsAchieved: Scalars['Int']['output'];
  goalsInProgress: Scalars['Int']['output'];
  reviewsDueThisMonth: Scalars['Int']['output'];
  totalCarePlans: Scalars['Int']['output'];
};

/** Status of a care plan */
export enum CarePlanStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
  Draft = 'DRAFT',
  UnderReview = 'UNDER_REVIEW'
}

export type CarePlanTemplate = {
  __typename?: 'CarePlanTemplate';
  assessmentTemplate?: Maybe<Scalars['String']['output']>;
  category: CarePlanCategory;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['ID']['output'];
  createdByName?: Maybe<Scalars['String']['output']>;
  defaultReviewFrequency: ReviewFrequency;
  description?: Maybe<Scalars['String']['output']>;
  goals: Array<TemplateGoal>;
  id: Scalars['ID']['output'];
  interventions: Array<TemplateIntervention>;
  isActive: Scalars['Boolean']['output'];
  lastModifiedBy?: Maybe<Scalars['ID']['output']>;
  lastModifiedByName?: Maybe<Scalars['String']['output']>;
  lastModifiedDate?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  usageCount: Scalars['Float']['output'];
  version: Scalars['Float']['output'];
};

export type CarePlanTemplateFilterInput = {
  category?: InputMaybe<CarePlanCategory>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Float']['input']>;
  offset?: InputMaybe<Scalars['Float']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type CarePlanTemplatesResponse = {
  __typename?: 'CarePlanTemplatesResponse';
  limit: Scalars['Int']['output'];
  offset: Scalars['Int']['output'];
  templates: Array<CarePlanTemplate>;
  total: Scalars['Int']['output'];
};

export type CarePlansResponse = {
  __typename?: 'CarePlansResponse';
  carePlans: Array<CarePlan>;
  limit: Scalars['Int']['output'];
  offset: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type CareQuarterTarget = {
  __typename?: 'CareQuarterTarget';
  createdAt: Scalars['DateTime']['output'];
  enMinutesPerResident?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  quarter: Scalars['String']['output'];
  rnMinutesPerResident: Scalars['Float']['output'];
  source: CareTargetSource;
  tenantId: Scalars['String']['output'];
  totalMinutesPerResident: Scalars['Float']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedByName?: Maybe<Scalars['String']['output']>;
};

export type CareReview = {
  __typename?: 'CareReview';
  actionItems: Array<CareReviewActionItem>;
  attendees: Array<Scalars['String']['output']>;
  carePlanUpdateNotes?: Maybe<Scalars['String']['output']>;
  carePlanUpdatesRequired: Scalars['Boolean']['output'];
  changeTrigger?: Maybe<CareReviewChangeTrigger>;
  conductedBy: Scalars['ID']['output'];
  conductedByName?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  familyFeedback?: Maybe<Scalars['String']['output']>;
  familyNotified: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  /** The incident (e.g. a fall) this review answers; completing it closes that incident's review after a change */
  incidentId?: Maybe<Scalars['ID']['output']>;
  isHistoricalRecord?: Maybe<Scalars['Boolean']['output']>;
  nextReviewDate?: Maybe<Scalars['DateTime']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  outcomes?: Maybe<Scalars['String']['output']>;
  residentId: Scalars['ID']['output'];
  residentName?: Maybe<Scalars['String']['output']>;
  residentRoom?: Maybe<Scalars['String']['output']>;
  residentWing?: Maybe<Scalars['String']['output']>;
  reviewDate: Scalars['DateTime']['output'];
  reviewType: CareReviewType;
  reviewTypeLabel?: Maybe<Scalars['String']['output']>;
  sourceAuthor?: Maybe<Scalars['String']['output']>;
  sourceBackupDate?: Maybe<Scalars['DateTime']['output']>;
  sourceFields?: Maybe<Array<CareReviewSourceField>>;
  sourceHash?: Maybe<Scalars['String']['output']>;
  sourceId?: Maybe<Scalars['String']['output']>;
  sourceSystem?: Maybe<Scalars['String']['output']>;
  status: CareReviewStatus;
  summary?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type CareReviewActionItem = {
  __typename?: 'CareReviewActionItem';
  action: Scalars['String']['output'];
  assignedTo?: Maybe<Scalars['String']['output']>;
  completed: Scalars['Boolean']['output'];
  dueDate?: Maybe<Scalars['String']['output']>;
};

export type CareReviewActionItemInput = {
  action: Scalars['String']['input'];
  assignedTo?: InputMaybe<Scalars['String']['input']>;
  completed: Scalars['Boolean']['input'];
  dueDate?: InputMaybe<Scalars['String']['input']>;
};

/** What changed, for a review booked after a change in condition or circumstances */
export enum CareReviewChangeTrigger {
  Decline = 'DECLINE',
  Fall = 'FALL',
  HospitalReturn = 'HOSPITAL_RETURN',
  OtherChange = 'OTHER_CHANGE'
}

/** A tenant's care review cycle settings (days) */
export type CareReviewCycleSettings = {
  __typename?: 'CareReviewCycleSettings';
  /** Days from admission by which the admission assessment and care plan must be done */
  admissionWindowDays: Scalars['Int']['output'];
  /** Days between care plan reviews */
  carePlanReviewIntervalDays: Scalars['Int']['output'];
  /** Days after a change (fall, hospital return, decline) by which the review must be done */
  changeReviewWithinDays: Scalars['Int']['output'];
  /** Days before a due date that a review shows as "due soon" */
  dueSoonDays: Scalars['Int']['output'];
  /** Treat every fall logged in the incidents module as a change that needs a review (closed by a completed review linked to that incident) */
  fallIncidentTriggersReview: Scalars['Boolean']['output'];
  /** Treat every return from hospital leave as a change that needs a review */
  hospitalReturnTriggersReview: Scalars['Boolean']['output'];
  /** Days between full reassessments */
  reassessmentIntervalDays: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedByName?: Maybe<Scalars['String']['output']>;
};

/** The tenant's cycle settings plus where each one comes from */
export type CareReviewCycleSettingsView = {
  __typename?: 'CareReviewCycleSettingsView';
  /** True when nothing has been saved yet and the defaults apply */
  isDefault: Scalars['Boolean']['output'];
  rules: Array<ReviewCycleRule>;
  settings: CareReviewCycleSettings;
};

export type CareReviewFilterInput = {
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  /** Only reviews linked to this incident */
  incidentId?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  residentId?: InputMaybe<Scalars['ID']['input']>;
  reviewType?: InputMaybe<CareReviewType>;
  sarahHistory?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<CareReviewStatus>;
  wing?: InputMaybe<Scalars['String']['input']>;
};

/** One original SarahCare column kept on an imported care review */
export type CareReviewSourceField = {
  __typename?: 'CareReviewSourceField';
  /** SarahCare table and column, e.g. `ResCareReviewDates.ReviewType` */
  column: Scalars['String']['output'];
  /** The original value as text; null when SarahCare held no value */
  value?: Maybe<Scalars['String']['output']>;
};

/** Status of a care review */
export enum CareReviewStatus {
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS',
  Scheduled = 'SCHEDULED'
}

/** Type of care review */
export enum CareReviewType {
  Admission = 'ADMISSION',
  Annual = 'ANNUAL',
  FamilyMeeting = 'FAMILY_MEETING',
  IncidentTriggered = 'INCIDENT_TRIGGERED',
  Multidisciplinary = 'MULTIDISCIPLINARY',
  Other = 'OTHER',
  Quarterly = 'QUARTERLY'
}

export type CareReviewsResponse = {
  __typename?: 'CareReviewsResponse';
  limit: Scalars['Int']['output'];
  offset: Scalars['Int']['output'];
  reviews: Array<CareReview>;
  total: Scalars['Int']['output'];
};

export type CareStatementPeriodInput = {
  fromDay: Scalars['String']['input'];
  label: Scalars['String']['input'];
  toDay: Scalars['String']['input'];
};

/** Where a quarter's care-minute target came from — a real statement, or the federal floor standing in */
export enum CareTargetSource {
  AnAccStatement = 'AN_ACC_STATEMENT',
  FederalDefault = 'FEDERAL_DEFAULT'
}

/** Level of care required by the resident */
export enum CareType {
  High = 'HIGH',
  Low = 'LOW',
  Palliative = 'PALLIATIVE'
}

export type CareTypeDistribution = {
  __typename?: 'CareTypeDistribution';
  careType: Scalars['String']['output'];
  count: Scalars['Int']['output'];
};

export type CastGovVoteInput = {
  choiceKeys: Array<Scalars['String']['input']>;
  proposalId: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
  signature?: InputMaybe<Scalars['String']['input']>;
  signedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CategorizedLogs = {
  __typename?: 'CategorizedLogs';
  errors: Array<LogEntry>;
  info: Array<LogEntry>;
  warnings: Array<LogEntry>;
};

/** Type of catheter */
export enum CatheterType {
  Condom = 'CONDOM',
  Indwelling = 'INDWELLING',
  Intermittent = 'INTERMITTENT',
  None = 'NONE',
  Suprapubic = 'SUPRAPUBIC'
}

export type CeaseMedicationInput = {
  ceaseReason: Scalars['String']['input'];
  ceasedDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CellcastImportContactGroup = {
  __typename?: 'CellcastImportContactGroup';
  clientName?: Maybe<Scalars['String']['output']>;
  counterpartNumber: Scalars['String']['output'];
  inbound: Scalars['Int']['output'];
  outbound: Scalars['Int']['output'];
};

export type CellcastImportSampleRow = {
  __typename?: 'CellcastImportSampleRow';
  body: Scalars['String']['output'];
  counterpartNumber: Scalars['String']['output'];
  direction: Scalars['String']['output'];
  occurredAt?: Maybe<Scalars['DateTime']['output']>;
  sender?: Maybe<Scalars['String']['output']>;
};

export type CellcastImportSummary = {
  __typename?: 'CellcastImportSummary';
  byContact: Array<CellcastImportContactGroup>;
  dryRun: Scalars['Boolean']['output'];
  /** Rows on the shared account that are another site's, or could not be placed — never imported. */
  hiddenOtherSites: Scalars['Int']['output'];
  imported: Scalars['Int']['output'];
  inboundFound: Scalars['Int']['output'];
  outboundFound: Scalars['Int']['output'];
  sampleRows: Array<CellcastImportSampleRow>;
  skippedDuplicate: Scalars['Int']['output'];
  wouldImport: Scalars['Int']['output'];
};

/** Software certification proficiency level */
export enum CertificationLevel {
  Basic = 'BASIC',
  Expert = 'EXPERT',
  Proficient = 'PROFICIENT'
}

export type CertifiedCoach = {
  __typename?: 'CertifiedCoach';
  bio?: Maybe<Scalars['String']['output']>;
  bookingUrl?: Maybe<Scalars['String']['output']>;
  certificateNumber: Scalars['String']['output'];
  certificationProgramme: Scalars['String']['output'];
  certifiedAt: Scalars['DateTime']['output'];
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  photoCid?: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
};

export type CertifyCoachInput = {
  certifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  certifiedBy?: InputMaybe<Scalars['String']['input']>;
};

export type ChangePasswordInput = {
  currentPassword: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
};

export type ChangedFileInfo = {
  __typename?: 'ChangedFileInfo';
  filename: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

/** Which channel tab to harvest */
export enum ChannelContent {
  All = 'ALL',
  Shorts = 'SHORTS',
  Streams = 'STREAMS',
  Videos = 'VIDEOS'
}

export type ChannelContentCountsType = {
  __typename?: 'ChannelContentCountsType';
  shorts: Scalars['Int']['output'];
  streams: Scalars['Int']['output'];
  videos: Scalars['Int']['output'];
};

/** Channel used for client chase messages */
export enum ChaseChannel {
  Both = 'BOTH',
  Email = 'EMAIL',
  Sms = 'SMS'
}

export type ChaseDraftSendPreview = {
  __typename?: 'ChaseDraftSendPreview';
  canSendEmail: Scalars['Boolean']['output'];
  canSendSms: Scalars['Boolean']['output'];
  fromEmail?: Maybe<Scalars['String']['output']>;
  fromName?: Maybe<Scalars['String']['output']>;
  replyToEmail?: Maybe<Scalars['String']['output']>;
  sendAsTenantId: Scalars['String']['output'];
  sendAsTenantName: Scalars['String']['output'];
  smsSenderAlphaId?: Maybe<Scalars['String']['output']>;
  warning?: Maybe<Scalars['String']['output']>;
};

export type ChaseNotificationRule = {
  __typename?: 'ChaseNotificationRule';
  action: ChaseRuleAction;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  lastFiredAt?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  targetConfigIds?: Maybe<Array<Scalars['String']['output']>>;
  targetMilestoneId?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  triggerEvent: ChaseTriggerEvent;
  updatedAt: Scalars['DateTime']['output'];
};

export type ChaseRecipient = {
  __typename?: 'ChaseRecipient';
  clientEmail?: Maybe<Scalars['String']['output']>;
  clientId: Scalars['String']['output'];
  clientName: Scalars['String']['output'];
};

export type ChaseRecipientInput = {
  clientEmail?: InputMaybe<Scalars['String']['input']>;
  clientId: Scalars['String']['input'];
  clientName: Scalars['String']['input'];
};

/** What the rule does when its trigger fires */
export enum ChaseRuleAction {
  CreateDraft = 'CREATE_DRAFT',
  NotifyTom = 'NOTIFY_TOM'
}

/** How often to generate chase suggestions */
export enum ChaseSchedule {
  Daily = 'DAILY',
  Weekdays = 'WEEKDAYS',
  Weekly = 'WEEKLY'
}

/** How to send to multiple recipients: CC (one email, all CC'd) or INDIVIDUAL (separate email per person) */
export enum ChaseSendMode {
  Cc = 'CC',
  Individual = 'INDIVIDUAL'
}

/** Status of a chase email suggestion */
export enum ChaseSuggestionStatus {
  Failed = 'FAILED',
  Scheduled = 'SCHEDULED',
  Sent = 'SENT',
  Skipped = 'SKIPPED',
  Suggested = 'SUGGESTED'
}

/** Event types that can trigger creation of a chase draft */
export enum ChaseTriggerEvent {
  AiToolUsed = 'AI_TOOL_USED',
  FirstLogin = 'FIRST_LOGIN',
  Manual = 'MANUAL',
  MilestoneCompleted = 'MILESTONE_COMPLETED',
  ScheduledCron = 'SCHEDULED_CRON',
  StaleNoActivity = 'STALE_NO_ACTIVITY'
}

export type ChatMessage = {
  __typename?: 'ChatMessage';
  content: Scalars['String']['output'];
  contentType: MessageContentType;
  createdAt: Scalars['DateTime']['output'];
  editedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  isDeleted: Scalars['Boolean']['output'];
  replyToId?: Maybe<Scalars['String']['output']>;
  roomId: Scalars['String']['output'];
  senderId: Scalars['String']['output'];
  senderName: Scalars['String']['output'];
  senderType: SenderType;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type ChatParticipant = {
  __typename?: 'ChatParticipant';
  createdAt: Scalars['DateTime']['output'];
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isBanned: Scalars['Boolean']['output'];
  isTyping: Scalars['Boolean']['output'];
  joinedAt: Scalars['DateTime']['output'];
  lastSeenAt?: Maybe<Scalars['DateTime']['output']>;
  participantId: Scalars['String']['output'];
  participantType: SenderType;
  role: ParticipantRole;
  roomId: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type ChatRoom = {
  __typename?: 'ChatRoom';
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isPublic: Scalars['Boolean']['output'];
  lastMessageAt?: Maybe<Scalars['DateTime']['output']>;
  lastMessagePreview?: Maybe<Scalars['String']['output']>;
  messageCount: Scalars['Int']['output'];
  ownerId?: Maybe<Scalars['String']['output']>;
  ownerType?: Maybe<Scalars['String']['output']>;
  participantCount: Scalars['Int']['output'];
  slug: Scalars['String']['output'];
  status: ChatRoomStatus;
  tenantId: Scalars['String']['output'];
  title: Scalars['String']['output'];
  type: ChatRoomType;
  updatedAt: Scalars['DateTime']['output'];
};

export type ChatRoomInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  title: Scalars['String']['input'];
  type?: InputMaybe<ChatRoomType>;
};

/** Status of the chat room */
export enum ChatRoomStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
  Closed = 'CLOSED'
}

/** Type of chat room */
export enum ChatRoomType {
  Direct = 'DIRECT',
  Feedback = 'FEEDBACK',
  Support = 'SUPPORT',
  Topic = 'TOPIC'
}

export type ChatRoomUpdateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<ChatRoomStatus>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CheckIn = {
  __typename?: 'CheckIn';
  actualHoursWorked?: Maybe<Scalars['Float']['output']>;
  breakMinutesTaken?: Maybe<Scalars['Int']['output']>;
  checkInCoordinates?: Maybe<CheckInCoordinates>;
  checkInMethod: CheckInMethod;
  checkInTime: Scalars['DateTime']['output'];
  checkOutCoordinates?: Maybe<CheckInCoordinates>;
  checkOutMethod?: Maybe<CheckInMethod>;
  checkOutTime?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  disputeReason?: Maybe<Scalars['String']['output']>;
  distanceFromLocation?: Maybe<Scalars['Float']['output']>;
  earlyLeaveReason?: Maybe<Scalars['String']['output']>;
  employeeId: Scalars['ID']['output'];
  employeeName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isDisputed?: Maybe<Scalars['Boolean']['output']>;
  lateReason?: Maybe<Scalars['String']['output']>;
  locationId?: Maybe<Scalars['ID']['output']>;
  locationName?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  qrCodeUsed?: Maybe<Scalars['String']['output']>;
  reportedCheckOutTime?: Maybe<Scalars['DateTime']['output']>;
  requiresReview?: Maybe<Scalars['Boolean']['output']>;
  reviewReason?: Maybe<Scalars['String']['output']>;
  scheduledEndTime?: Maybe<Scalars['DateTime']['output']>;
  scheduledStartTime?: Maybe<Scalars['DateTime']['output']>;
  shiftId?: Maybe<Scalars['ID']['output']>;
  shiftTitle?: Maybe<Scalars['String']['output']>;
  status: CheckInStatus;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  varianceMinutes?: Maybe<Scalars['Int']['output']>;
  verifiedAt?: Maybe<Scalars['DateTime']['output']>;
  verifiedBy?: Maybe<Scalars['String']['output']>;
};

export type CheckInCoordinates = {
  __typename?: 'CheckInCoordinates';
  accuracy?: Maybe<Scalars['Float']['output']>;
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
};

export type CheckInCoordinatesInput = {
  accuracy?: InputMaybe<Scalars['Float']['input']>;
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
};

export type CheckInFilterInput = {
  employeeId?: InputMaybe<Scalars['ID']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  requiresReview?: InputMaybe<Scalars['Boolean']['input']>;
  shiftId?: InputMaybe<Scalars['ID']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<CheckInStatus>;
};

export type CheckInInput = {
  checkInMethod?: InputMaybe<CheckInMethod>;
  coordinates?: InputMaybe<CheckInCoordinatesInput>;
  employeeId: Scalars['ID']['input'];
  locationId?: InputMaybe<Scalars['ID']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  qrCodeUsed?: InputMaybe<Scalars['String']['input']>;
  shiftId?: InputMaybe<Scalars['ID']['input']>;
};

/** Method used to verify check-in */
export enum CheckInMethod {
  Biometric = 'BIOMETRIC',
  Gps = 'GPS',
  Manual = 'MANUAL',
  Nfc = 'NFC',
  QrCode = 'QR_CODE'
}

/** Status of the check-in record */
export enum CheckInStatus {
  Acknowledged = 'ACKNOWLEDGED',
  CheckedIn = 'CHECKED_IN',
  CheckedOut = 'CHECKED_OUT',
  EarlyLeave = 'EARLY_LEAVE',
  Late = 'LATE',
  Missed = 'MISSED'
}

export type CheckOutInput = {
  breakMinutesTaken?: InputMaybe<Scalars['Int']['input']>;
  checkInId: Scalars['ID']['input'];
  checkOutMethod?: InputMaybe<CheckInMethod>;
  coordinates?: InputMaybe<CheckInCoordinatesInput>;
  notes?: InputMaybe<Scalars['String']['input']>;
};

export type ChecklistGridEntry = {
  __typename?: 'ChecklistGridEntry';
  /** Which day of the grid this cell belongs to (1, 2 or 3) */
  dayOffset: Scalars['Int']['output'];
  /** The PCW's initials, as written on the paper form */
  initials?: Maybe<Scalars['String']['output']>;
  /** When this cell was filled in (audit stamp) */
  recordedAt?: Maybe<Scalars['DateTime']['output']>;
  recordedBy?: Maybe<Scalars['ID']['output']>;
  recordedByName?: Maybe<Scalars['String']['output']>;
  /** Date-only — stored at T00:00:00.000Z */
  recordedDate?: Maybe<Scalars['DateTime']['output']>;
  shift: ChecklistShift;
};

export type ChecklistProgress = {
  __typename?: 'ChecklistProgress';
  completed: Scalars['Int']['output'];
  overdue: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

/** Shift for a checklist grid entry — AM, PM or ND (night duty) */
export enum ChecklistShift {
  Am = 'AM',
  Nd = 'ND',
  Pm = 'PM'
}

export type ChecklistTask = {
  __typename?: 'ChecklistTask';
  /** When the outcome was recorded */
  answeredAt?: Maybe<Scalars['DateTime']['output']>;
  answeredBy?: Maybe<Scalars['ID']['output']>;
  /** Display name of the staff member who answered */
  answeredByName?: Maybe<Scalars['String']['output']>;
  /** Role(s) responsible, verbatim from the paper form — "CM/RN", "RN/Physio", "DT RN to check". Deliberately a free string, not an enum: the form uses compound and prose values. */
  assignedRole?: Maybe<Scalars['String']['output']>;
  /** Named staff member allocated to this assessment — set up-front, distinct from who answered it. */
  assignedToName?: Maybe<Scalars['String']['output']>;
  /** Optional grouping (e.g. "Clinical", "Financial", "Family") */
  category?: Maybe<Scalars['String']['output']>;
  /** When this task was completed (null = not yet done) */
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  completedBy?: Maybe<Scalars['ID']['output']>;
  /** Display name of the staff member who completed it */
  completedByName?: Maybe<Scalars['String']['output']>;
  /** Day of admission this task is due (1..28) */
  dueDay: Scalars['Int']['output'];
  /** End of the due window for ranged items — the paper form's "Day 8-21". Null = a single-day item. */
  dueDayEnd?: Maybe<Scalars['Int']['output']>;
  /** Populated only when kind = SHIFT_GRID */
  entries: Array<ChecklistGridEntry>;
  /** Stable task identifier within this checklist (matches template task id when seeded from a template) */
  id: Scalars['String']['output'];
  /** SIMPLE (one outcome) or SHIFT_GRID (the continence chart) */
  kind: ChecklistTaskKind;
  label: Scalars['String']['output'];
  /** The record actually created, so the tick is provable */
  linkedRecordId?: Maybe<Scalars['ID']['output']>;
  /** For rows that instruct staff to create a record elsewhere ("to create a log", "complete an Incident"). One of INCIDENT | PROGRESS_NOTE | PHYSIO_REFERRAL | PCW_TASK | CARE_PLAN_TASK. */
  linkedRecordType?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  /** Yes / No / NA. Null = not yet answered. NO and NA are ANSWERS — never overdue. */
  outcome?: Maybe<ChecklistTaskOutcome>;
};

/** Whether a checklist item is a single outcome or a multi-day shift grid */
export enum ChecklistTaskKind {
  ShiftGrid = 'SHIFT_GRID',
  Simple = 'SIMPLE'
}

/** Yes / No / NA outcome of an admission-assessment item */
export enum ChecklistTaskOutcome {
  Na = 'NA',
  No = 'NO',
  Yes = 'YES'
}

export type ChecklistTemplateTask = {
  __typename?: 'ChecklistTemplateTask';
  /** Role(s) responsible, verbatim from the source form */
  assignedRole?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  /** Outcome the item is seeded with — the paper form pre-marks four rows "N" (NA). */
  defaultOutcome?: Maybe<ChecklistTaskOutcome>;
  dueDay: Scalars['Int']['output'];
  /** End of the due window — "Day 8-21" */
  dueDayEnd?: Maybe<Scalars['Int']['output']>;
  id: Scalars['String']['output'];
  /** SIMPLE or SHIFT_GRID */
  kind: ChecklistTaskKind;
  label: Scalars['String']['output'];
  /** Downstream record this item asks staff to create */
  linkedRecordType?: Maybe<Scalars['String']['output']>;
};

export type ChecklistTemplateTaskInput = {
  assignedRole?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  defaultOutcome?: InputMaybe<ChecklistTaskOutcome>;
  dueDay: Scalars['Int']['input'];
  dueDayEnd?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['String']['input'];
  kind?: InputMaybe<ChecklistTaskKind>;
  label: Scalars['String']['input'];
  linkedRecordType?: InputMaybe<Scalars['String']['input']>;
};

export type ChequeDetails = {
  __typename?: 'ChequeDetails';
  accountName?: Maybe<Scalars['String']['output']>;
  bankName?: Maybe<Scalars['String']['output']>;
  /** BSB for Australian banks */
  bsb?: Maybe<Scalars['String']['output']>;
  chequeNumber: Scalars['String']['output'];
  clearedDate?: Maybe<Scalars['DateTime']['output']>;
  dateOnCheque?: Maybe<Scalars['DateTime']['output']>;
  /** pending, cleared, bounced */
  status?: Maybe<Scalars['String']['output']>;
};

export type ChequeDetailsInput = {
  accountName?: InputMaybe<Scalars['String']['input']>;
  bankName?: InputMaybe<Scalars['String']['input']>;
  bsb?: InputMaybe<Scalars['String']['input']>;
  chequeNumber: Scalars['String']['input'];
  dateOnCheque?: InputMaybe<Scalars['DateTime']['input']>;
};

/** One message in a Chloe assistant session — user prompt, assistant reply, or tool result. */
export type ChloeMessage = {
  __typename?: 'ChloeMessage';
  /** Message text. Empty string permitted for assistant turns that only emit tool calls. */
  content: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  errorMessage?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  inputTokens?: Maybe<Scalars['Int']['output']>;
  latencyMs?: Maybe<Scalars['Int']['output']>;
  /** Model that produced this assistant message */
  model?: Maybe<Scalars['String']['output']>;
  outputTokens?: Maybe<Scalars['Int']['output']>;
  role: ChloeMessageRole;
  /** Owning ChloeSession._id */
  sessionId: Scalars['String']['output'];
  /** True if the upstream call succeeded (only meaningful on ASSISTANT messages) */
  success: Scalars['Boolean']['output'];
  tenantId: Scalars['String']['output'];
  /** Tool-call ID this TOOL-role message is responding to */
  toolCallId?: Maybe<Scalars['String']['output']>;
  /** JSON-serialized array of OpenAI-style tool_call objects emitted by the model */
  toolCalls?: Maybe<Scalars['String']['output']>;
  /** Name of the tool (for TOOL-role messages) */
  toolName?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

/** OpenAI-style chat role for a Chloe message */
export enum ChloeMessageRole {
  Assistant = 'ASSISTANT',
  System = 'SYSTEM',
  Tool = 'TOOL',
  User = 'USER'
}

/** A write-action the assistant proposed and parked for user confirmation. v1: read tools fire immediately; write tools land here. */
export type ChloePendingAction = {
  __typename?: 'ChloePendingAction';
  /** JSON-serialized tool arguments as proposed by the model */
  args: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  /** Human-readable summary of what will happen if confirmed — rendered in the modal */
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** ChloeMessage._id of the assistant turn that proposed this action */
  messageId?: Maybe<Scalars['String']['output']>;
  /** JSON-serialized resolver result on EXECUTED, or error detail on FAILED */
  result?: Maybe<Scalars['String']['output']>;
  /** Owning ChloeSession._id */
  sessionId: Scalars['String']['output'];
  status: ChloePendingActionStatus;
  tenantId: Scalars['String']['output'];
  /** Tool name (e.g. 'proposeAdmission'). Maps to the tool registry on execution. */
  tool: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  /** Client._id of the user who must confirm — the session owner */
  userId: Scalars['String']['output'];
};

/** Lifecycle status of a Chloe-proposed write action awaiting user confirmation */
export enum ChloePendingActionStatus {
  Cancelled = 'CANCELLED',
  Confirmed = 'CONFIRMED',
  Executed = 'EXECUTED',
  Failed = 'FAILED',
  Pending = 'PENDING'
}

export type ChloeSendMessageInput = {
  /** User prompt content */
  content: Scalars['String']['input'];
  /** Owning ChloeSession._id */
  sessionId: Scalars['String']['input'];
};

/** A Chloe assistant conversation — healthcare-gated, tool-equipped chat against the Mac Studio LiteLLM endpoint. One session per chat thread per user. */
export type ChloeSession = {
  __typename?: 'ChloeSession';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  /** Timestamp of the most recent message in this session */
  lastMessageAt?: Maybe<Scalars['DateTime']['output']>;
  /** Running count of messages in this session */
  messageCount: Scalars['Float']['output'];
  /** Currently-selected model name from LiteLLM, e.g. 'qwen3.6-35b' */
  model: Scalars['String']['output'];
  status: ChloeSessionStatus;
  tenantId: Scalars['String']['output'];
  /** Human-readable title — first user message snippet, or 'New chat' on init */
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  /** Client._id of the user who owns the session */
  userId: Scalars['String']['output'];
};

/** Lifecycle status of a Chloe assistant session */
export enum ChloeSessionStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED'
}

export type ChloeStartSessionInput = {
  /** Model name from LiteLLM (e.g. 'qwen3.6-35b') */
  model: Scalars['String']['input'];
  /** Optional explicit session title; otherwise derived from the first prompt */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ClassifyMicrosoftEmailInput = {
  aiSummary?: InputMaybe<Scalars['String']['input']>;
  classifiedBy?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  isRoomEnquiry?: InputMaybe<Scalars['Boolean']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  threadKey?: InputMaybe<Scalars['String']['input']>;
};

export type Client = {
  __typename?: 'Client';
  billingAddresses: Array<ClientShippingDetails>;
  businessName?: Maybe<Scalars['String']['output']>;
  businessRegistrationNumber?: Maybe<Scalars['String']['output']>;
  cellcastId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  digitalManagerId?: Maybe<Scalars['ID']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  encryptedSignatureIpfsUrl?: Maybe<Scalars['String']['output']>;
  fName?: Maybe<Scalars['String']['output']>;
  hasPasskey: Scalars['Boolean']['output'];
  hasUsernamePassword: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isDigitalManager?: Maybe<Scalars['Boolean']['output']>;
  isVerifiedSeller?: Maybe<Scalars['Boolean']['output']>;
  knowledgeSlug?: Maybe<Scalars['String']['output']>;
  lName?: Maybe<Scalars['String']['output']>;
  lastLoginAt?: Maybe<Scalars['DateTime']['output']>;
  lastLoginMethod?: Maybe<Scalars['String']['output']>;
  lastPasskeyUsedAt?: Maybe<Scalars['DateTime']['output']>;
  loginBlockedAt?: Maybe<Scalars['DateTime']['output']>;
  loginBlockedByClientId?: Maybe<Scalars['String']['output']>;
  loginBlockedNote?: Maybe<Scalars['String']['output']>;
  loginBlockedReason?: Maybe<ClientLoginBlockReason>;
  mergedAt?: Maybe<Scalars['DateTime']['output']>;
  mergedIntoClientId?: Maybe<Scalars['ID']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  opportunityCount?: Maybe<Scalars['Float']['output']>;
  passwordChangedAt?: Maybe<Scalars['DateTime']['output']>;
  paymentReceivingDetails?: Maybe<PaymentReceivingDetails>;
  permissions?: Maybe<Array<ClientPermission>>;
  personalCalendarId?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  preferences?: Maybe<ClientPreferences>;
  profilePhoto?: Maybe<Scalars['String']['output']>;
  role?: Maybe<ClientRole>;
  shippingAddresses: Array<ClientShippingDetails>;
  stripeCustomerId?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  tenantId: Scalars['String']['output'];
  totalOpportunityValue?: Maybe<Scalars['Float']['output']>;
  twoFactorEnabledAt?: Maybe<Scalars['DateTime']['output']>;
  twoFactorRecoveryIssuedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  username?: Maybe<Scalars['String']['output']>;
  websites?: Maybe<Array<Scalars['String']['output']>>;
};

export type ClientActivity = {
  __typename?: 'ClientActivity';
  activityDate: Scalars['DateTime']['output'];
  activityType: Scalars['String']['output'];
  canEdit: Scalars['Boolean']['output'];
  clientId: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdById?: Maybe<Scalars['String']['output']>;
  createdByName: Scalars['String']['output'];
  details?: Maybe<Scalars['String']['output']>;
  editedAt?: Maybe<Scalars['DateTime']['output']>;
  editedByName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isDeleted: Scalars['Boolean']['output'];
  mentions: Array<ClientMention>;
  tenantId: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type ClientActivityFiltersInput = {
  activityType?: InputMaybe<Scalars['String']['input']>;
  fromDate?: InputMaybe<Scalars['DateTime']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  toDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ClientAddress = {
  __typename?: 'ClientAddress';
  city: Scalars['String']['output'];
  country: Scalars['String']['output'];
  postcode: Scalars['String']['output'];
  state: Scalars['String']['output'];
  street: Scalars['String']['output'];
};

export type ClientAddressInput = {
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  postcode: Scalars['String']['input'];
  state: Scalars['String']['input'];
  street: Scalars['String']['input'];
};

export type ClientBillingDetailsInput = {
  address: ClientAddressInput;
  companyName?: InputMaybe<Scalars['String']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  taxId?: InputMaybe<Scalars['String']['input']>;
  vatNumber?: InputMaybe<Scalars['String']['input']>;
};

export type ClientChaseConfig = {
  __typename?: 'ClientChaseConfig';
  aiPrompt: Scalars['String']['output'];
  channel: ChaseChannel;
  clientGoal?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  currentMilestone?: Maybe<Scalars['String']['output']>;
  goalActionLabel?: Maybe<Scalars['String']['output']>;
  goalActionUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  journeyTemplateId?: Maybe<Scalars['String']['output']>;
  lastRunAt?: Maybe<Scalars['DateTime']['output']>;
  milestoneHistory?: Maybe<Array<MilestoneEvent>>;
  nextRunAt?: Maybe<Scalars['DateTime']['output']>;
  recipients?: Maybe<Array<ChaseRecipient>>;
  schedule: ChaseSchedule;
  scheduleTime: Scalars['String']['output'];
  sendMode: ChaseSendMode;
  targetCandidateId?: Maybe<Scalars['String']['output']>;
  targetClientEmail?: Maybe<Scalars['String']['output']>;
  targetClientId?: Maybe<Scalars['String']['output']>;
  targetClientName?: Maybe<Scalars['String']['output']>;
  targetTenantId: Scalars['String']['output'];
  targetTenantName: Scalars['String']['output'];
  targetTenantUrl?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  timezone: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type ClientChaseLog = {
  __typename?: 'ClientChaseLog';
  activitySummary?: Maybe<Scalars['String']['output']>;
  bodyHtml?: Maybe<Scalars['String']['output']>;
  bodyText?: Maybe<Scalars['String']['output']>;
  claudePrompt?: Maybe<Scalars['String']['output']>;
  configId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  emailId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  milestoneId?: Maybe<Scalars['String']['output']>;
  milestoneLabel?: Maybe<Scalars['String']['output']>;
  scheduledCalendarEventId?: Maybe<Scalars['String']['output']>;
  scheduledCalendarId?: Maybe<Scalars['String']['output']>;
  scheduledFor?: Maybe<Scalars['DateTime']['output']>;
  sendAsTenantId?: Maybe<Scalars['String']['output']>;
  sentAt?: Maybe<Scalars['DateTime']['output']>;
  sentBy?: Maybe<Scalars['String']['output']>;
  skipReason?: Maybe<Scalars['String']['output']>;
  skippedAt?: Maybe<Scalars['DateTime']['output']>;
  skippedBy?: Maybe<Scalars['String']['output']>;
  smsBody?: Maybe<Scalars['String']['output']>;
  smsError?: Maybe<Scalars['String']['output']>;
  smsMessageId?: Maybe<Scalars['String']['output']>;
  smsSentAt?: Maybe<Scalars['DateTime']['output']>;
  smsSentBy?: Maybe<Scalars['String']['output']>;
  status: ChaseSuggestionStatus;
  subject?: Maybe<Scalars['String']['output']>;
  suggestedAt: Scalars['DateTime']['output'];
  targetCandidateId?: Maybe<Scalars['String']['output']>;
  targetClientEmail?: Maybe<Scalars['String']['output']>;
  targetClientName?: Maybe<Scalars['String']['output']>;
  targetClientPhone?: Maybe<Scalars['String']['output']>;
  targetTenantId: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  triggerEvent?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type ClientDashboard = {
  __typename?: 'ClientDashboard';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  shortAssessment?: Maybe<DashboardShortAssessment>;
  surgeryDate?: Maybe<Scalars['DateTime']['output']>;
  surgeryDateIsRough?: Maybe<Scalars['Boolean']['output']>;
  surgeryTimeframe?: Maybe<Scalars['String']['output']>;
  surgeryType?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  todos?: Maybe<Array<DashboardTodo>>;
  updatedAt: Scalars['DateTime']['output'];
  userId: Scalars['ID']['output'];
};

export type ClientDeleteCount = {
  __typename?: 'ClientDeleteCount';
  collection: Scalars['String']['output'];
  deleted: Scalars['Int']['output'];
};

export type ClientDeleteResult = {
  __typename?: 'ClientDeleteResult';
  blockReason?: Maybe<Scalars['String']['output']>;
  cascaded: Array<ClientDeleteCount>;
  clientDeleted: Scalars['Boolean']['output'];
  clientId: Scalars['String']['output'];
  errors: Array<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
};

export type ClientDuplicateGroup = {
  __typename?: 'ClientDuplicateGroup';
  clients: Array<Client>;
  count: Scalars['Float']['output'];
  groupId: Scalars['String']['output'];
  matchValue: Scalars['String']['output'];
  reason: ClientDuplicateReason;
};

/** Reason why clients are considered duplicates */
export enum ClientDuplicateReason {
  SameEmail = 'SAME_EMAIL',
  SamePhone = 'SAME_PHONE',
  SimilarName = 'SIMILAR_NAME'
}

export type ClientInput = {
  billingAddresses?: InputMaybe<Array<ClientBillingDetailsInput>>;
  businessName?: InputMaybe<Scalars['String']['input']>;
  businessRegistrationNumber?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  encryptedSignatureIpfsUrl?: InputMaybe<Scalars['String']['input']>;
  fName?: InputMaybe<Scalars['String']['input']>;
  lName?: InputMaybe<Scalars['String']['input']>;
  paymentReceivingDetails?: InputMaybe<PaymentReceivingDetailsInput>;
  permissions?: InputMaybe<Array<ClientPermission>>;
  personalCalendarId?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  preferences?: InputMaybe<ClientPreferencesInput>;
  profilePhoto?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<ClientRole>;
  shippingAddresses?: InputMaybe<Array<ClientShippingDetailsInput>>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  websites?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ClientLatestNote = {
  __typename?: 'ClientLatestNote';
  activityDate: Scalars['DateTime']['output'];
  clientId: Scalars['ID']['output'];
  createdByName: Scalars['String']['output'];
  details?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

/** Why sign-in is switched off for a client account: set by the employees module on termination, or by an admin by hand. */
export enum ClientLoginBlockReason {
  EmployeeTerminated = 'EMPLOYEE_TERMINATED',
  Manual = 'MANUAL'
}

export type ClientMention = {
  __typename?: 'ClientMention';
  clientId: Scalars['ID']['output'];
  email?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  notifiedAt?: Maybe<Scalars['DateTime']['output']>;
  notifiedEmail?: Maybe<Scalars['Boolean']['output']>;
};

export type ClientMentionInput = {
  clientId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export type ClientMentionNotifyChoiceInput = {
  clientId: Scalars['ID']['input'];
  email: Scalars['Boolean']['input'];
};

export type ClientMentionNotifyInput = {
  activityId: Scalars['ID']['input'];
  choices: Array<ClientMentionNotifyChoiceInput>;
};

export type ClientMentionNotifyResult = {
  __typename?: 'ClientMentionNotifyResult';
  rows: Array<ClientMentionNotifyRow>;
  summary: Scalars['String']['output'];
};

export type ClientMentionNotifyRow = {
  __typename?: 'ClientMentionNotifyRow';
  clientId: Scalars['ID']['output'];
  emailSent: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  problem?: Maybe<Scalars['String']['output']>;
};

export type ClientMentionablePerson = {
  __typename?: 'ClientMentionablePerson';
  clientId: Scalars['ID']['output'];
  hasEmail: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  roleLabel?: Maybe<Scalars['String']['output']>;
};

/** How to resolve the notification recipient(s) */
export enum ClientNotificationRecipientType {
  AllClientsAdmins = 'ALL_CLIENTS_ADMINS',
  ClientTag = 'CLIENT_TAG',
  SpecificClient = 'SPECIFIC_CLIENT',
  SpecificEmployee = 'SPECIFIC_EMPLOYEE'
}

export type ClientNotificationRule = {
  __typename?: 'ClientNotificationRule';
  channels: Array<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  isEnabled: Scalars['Boolean']['output'];
  messageTemplate?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  recipientIds?: Maybe<Array<Scalars['String']['output']>>;
  recipientTag?: Maybe<Scalars['String']['output']>;
  recipientType: ClientNotificationRecipientType;
  tenantId: Scalars['String']['output'];
  timing: ClientNotificationTiming;
  timingMinutes?: Maybe<Scalars['Float']['output']>;
  trigger: ClientNotificationTrigger;
  updatedAt: Scalars['DateTime']['output'];
};

/** When to send the notification relative to the trigger */
export enum ClientNotificationTiming {
  Immediate = 'IMMEDIATE',
  MinutesAfter = 'MINUTES_AFTER'
}

/** Event that triggers the client notification. ALL_EVENTS is a special value that matches any fired trigger. */
export enum ClientNotificationTrigger {
  AllEvents = 'ALL_EVENTS',
  ClientCreated = 'CLIENT_CREATED',
  ClientDeleted = 'CLIENT_DELETED',
  ClientLogin = 'CLIENT_LOGIN',
  ClientUpdated = 'CLIENT_UPDATED',
  PermissionAdded = 'PERMISSION_ADDED',
  PermissionRemoved = 'PERMISSION_REMOVED',
  TagAdded = 'TAG_ADDED',
  TagRemoved = 'TAG_REMOVED'
}

/** Available permissions for clients */
export enum ClientPermission {
  AccountabilityAdmin = 'ACCOUNTABILITY_ADMIN',
  AccountabilityEdit = 'ACCOUNTABILITY_EDIT',
  AccountabilityView = 'ACCOUNTABILITY_VIEW',
  AccountingAdmin = 'ACCOUNTING_ADMIN',
  AccountingEdit = 'ACCOUNTING_EDIT',
  AccountingView = 'ACCOUNTING_VIEW',
  AddressBookAdmin = 'ADDRESS_BOOK_ADMIN',
  AddressBookUser = 'ADDRESS_BOOK_USER',
  Admin = 'ADMIN',
  AdminDashboard = 'ADMIN_DASHBOARD',
  AdminPasswordReset = 'ADMIN_PASSWORD_RESET',
  AdmissionAdmin = 'ADMISSION_ADMIN',
  AdmissionApprove = 'ADMISSION_APPROVE',
  AdmissionEdit = 'ADMISSION_EDIT',
  AdmissionFinancial = 'ADMISSION_FINANCIAL',
  AdmissionView = 'ADMISSION_VIEW',
  AgentBoardAdmin = 'AGENT_BOARD_ADMIN',
  AgentBoardView = 'AGENT_BOARD_VIEW',
  AgreementsAdmin = 'AGREEMENTS_ADMIN',
  AgreementsEdit = 'AGREEMENTS_EDIT',
  AgreementsView = 'AGREEMENTS_VIEW',
  AiOpsAdmin = 'AI_OPS_ADMIN',
  AiOpsView = 'AI_OPS_VIEW',
  ApiHubAdmin = 'API_HUB_ADMIN',
  ApiHubEdit = 'API_HUB_EDIT',
  ApiHubView = 'API_HUB_VIEW',
  ArtifactAdmin = 'ARTIFACT_ADMIN',
  ArtifactEdit = 'ARTIFACT_EDIT',
  ArtifactView = 'ARTIFACT_VIEW',
  AssessmentSnapshotAdmin = 'ASSESSMENT_SNAPSHOT_ADMIN',
  AssessmentSnapshotEdit = 'ASSESSMENT_SNAPSHOT_EDIT',
  AssessmentSnapshotView = 'ASSESSMENT_SNAPSHOT_VIEW',
  AssetAdmin = 'ASSET_ADMIN',
  AssetManager = 'ASSET_MANAGER',
  AssetViewer = 'ASSET_VIEWER',
  BankingAdmin = 'BANKING_ADMIN',
  BankingView = 'BANKING_VIEW',
  BillsAdmin = 'BILLS_ADMIN',
  BillsUser = 'BILLS_USER',
  BlogAdmin = 'BLOG_ADMIN',
  BlogUser = 'BLOG_USER',
  BuildPortalClient = 'BUILD_PORTAL_CLIENT',
  BusinessDirectoryAdmin = 'BUSINESS_DIRECTORY_ADMIN',
  BusinessDirectoryView = 'BUSINESS_DIRECTORY_VIEW',
  BusinessSnapshotAdmin = 'BUSINESS_SNAPSHOT_ADMIN',
  BusinessSnapshotView = 'BUSINESS_SNAPSHOT_VIEW',
  CalendarAccountsAdmin = 'CALENDAR_ACCOUNTS_ADMIN',
  CalendarAdmin = 'CALENDAR_ADMIN',
  CalendarManager = 'CALENDAR_MANAGER',
  CalendarUser = 'CALENDAR_USER',
  CalendarViewer = 'CALENDAR_VIEWER',
  CareHomesAdmin = 'CARE_HOMES_ADMIN',
  CareHomesEdit = 'CARE_HOMES_EDIT',
  CareHomesView = 'CARE_HOMES_VIEW',
  CarePlanAdmin = 'CARE_PLAN_ADMIN',
  CarePlanEdit = 'CARE_PLAN_EDIT',
  CarePlanReview = 'CARE_PLAN_REVIEW',
  CarePlanView = 'CARE_PLAN_VIEW',
  CateringRole = 'CATERING_ROLE',
  ChatAdmin = 'CHAT_ADMIN',
  ChatModerator = 'CHAT_MODERATOR',
  CiAdmin = 'CI_ADMIN',
  CiManager = 'CI_MANAGER',
  CiRegulator = 'CI_REGULATOR',
  Client = 'CLIENT',
  ClientAdmin = 'CLIENT_ADMIN',
  ClientPermissionsManagement = 'CLIENT_PERMISSIONS_MANAGEMENT',
  Club52Admin = 'CLUB52_ADMIN',
  Club52User = 'CLUB52_USER',
  CoachesAdmin = 'COACHES_ADMIN',
  CoachesEdit = 'COACHES_EDIT',
  CoachesView = 'COACHES_VIEW',
  CommandAdmin = 'COMMAND_ADMIN',
  CommandEdit = 'COMMAND_EDIT',
  CommandView = 'COMMAND_VIEW',
  CommsHealthAdmin = 'COMMS_HEALTH_ADMIN',
  CommsHealthView = 'COMMS_HEALTH_VIEW',
  CommsLogAdmin = 'COMMS_LOG_ADMIN',
  CommsLogView = 'COMMS_LOG_VIEW',
  CommunityAdmin = 'COMMUNITY_ADMIN',
  CommunityEdit = 'COMMUNITY_EDIT',
  CommunityView = 'COMMUNITY_VIEW',
  CompanyAdmin = 'COMPANY_ADMIN',
  CompanyKnowledgeAdmin = 'COMPANY_KNOWLEDGE_ADMIN',
  CompanyKnowledgeAuthor = 'COMPANY_KNOWLEDGE_AUTHOR',
  CompanyKnowledgeEditor = 'COMPANY_KNOWLEDGE_EDITOR',
  CompanyManager = 'COMPANY_MANAGER',
  CompanyViewer = 'COMPANY_VIEWER',
  CompetitionsAdmin = 'COMPETITIONS_ADMIN',
  CompetitionEntrant = 'COMPETITION_ENTRANT',
  CustodyAdmin = 'CUSTODY_ADMIN',
  CustodyManager = 'CUSTODY_MANAGER',
  CustodyValidator = 'CUSTODY_VALIDATOR',
  DashboardAdmin = 'DASHBOARD_ADMIN',
  DashboardView = 'DASHBOARD_VIEW',
  DayBookDelete = 'DAY_BOOK_DELETE',
  DayBookEdit = 'DAY_BOOK_EDIT',
  DayBookView = 'DAY_BOOK_VIEW',
  DigitalManagerAdmin = 'DIGITAL_MANAGER_ADMIN',
  DigitalManagerTrain = 'DIGITAL_MANAGER_TRAIN',
  DigitalManagerView = 'DIGITAL_MANAGER_VIEW',
  EmailAdmin = 'EMAIL_ADMIN',
  EmailInboxAdmin = 'EMAIL_INBOX_ADMIN',
  EmailUser = 'EMAIL_USER',
  Employee = 'EMPLOYEE',
  EmployeeAdmin = 'EMPLOYEE_ADMIN',
  EmployeeHr = 'EMPLOYEE_HR',
  EmployeeHrFinance = 'EMPLOYEE_HR_FINANCE',
  EmployeeManager = 'EMPLOYEE_MANAGER',
  EmployeeViewer = 'EMPLOYEE_VIEWER',
  EmpowermentJourneyAdmin = 'EMPOWERMENT_JOURNEY_ADMIN',
  EmpowermentJourneyManager = 'EMPOWERMENT_JOURNEY_MANAGER',
  EmpowermentJourneyReports = 'EMPOWERMENT_JOURNEY_REPORTS',
  EnergyTrackerAdmin = 'ENERGY_TRACKER_ADMIN',
  EnergyTrackerEdit = 'ENERGY_TRACKER_EDIT',
  EnergyTrackerView = 'ENERGY_TRACKER_VIEW',
  Family = 'FAMILY',
  FeedbackAdmin = 'FEEDBACK_ADMIN',
  FeedbackManager = 'FEEDBACK_MANAGER',
  FeedbackView = 'FEEDBACK_VIEW',
  FrontendUpgradesAdmin = 'FRONTEND_UPGRADES_ADMIN',
  GovernanceAdmin = 'GOVERNANCE_ADMIN',
  GovernanceMember = 'GOVERNANCE_MEMBER',
  GrowthEngineAdmin = 'GROWTH_ENGINE_ADMIN',
  GrowthEngineManager = 'GROWTH_ENGINE_MANAGER',
  GrowthEngineViewer = 'GROWTH_ENGINE_VIEWER',
  HealthcareRole = 'HEALTHCARE_ROLE',
  HostingDeploy = 'HOSTING_DEPLOY',
  HostingManage = 'HOSTING_MANAGE',
  HostingView = 'HOSTING_VIEW',
  IncidentsConfig = 'INCIDENTS_CONFIG',
  IncidentsDelete = 'INCIDENTS_DELETE',
  IncidentsEdit = 'INCIDENTS_EDIT',
  IncidentsReports = 'INCIDENTS_REPORTS',
  IncidentsRiskAssessment = 'INCIDENTS_RISK_ASSESSMENT',
  IncidentsView = 'INCIDENTS_VIEW',
  InvestmentProjectsAdmin = 'INVESTMENT_PROJECTS_ADMIN',
  InvestmentProjectsEdit = 'INVESTMENT_PROJECTS_EDIT',
  InvestmentProjectsView = 'INVESTMENT_PROJECTS_VIEW',
  InvestorsAdmin = 'INVESTORS_ADMIN',
  InvestorsEdit = 'INVESTORS_EDIT',
  InvestorsView = 'INVESTORS_VIEW',
  IpfsNodeAdmin = 'IPFS_NODE_ADMIN',
  IpfsNodeView = 'IPFS_NODE_VIEW',
  KnowledgeExplorerAdmin = 'KNOWLEDGE_EXPLORER_ADMIN',
  KnowledgeExplorerEdit = 'KNOWLEDGE_EXPLORER_EDIT',
  LaunchAdmin = 'LAUNCH_ADMIN',
  LaunchUser = 'LAUNCH_USER',
  LeadflowAdmin = 'LEADFLOW_ADMIN',
  LeadflowEdit = 'LEADFLOW_EDIT',
  LeadflowView = 'LEADFLOW_VIEW',
  LmAdmin = 'LM_ADMIN',
  LmInstructor = 'LM_INSTRUCTOR',
  LmStudent = 'LM_STUDENT',
  LocalAiQuery = 'LOCAL_AI_QUERY',
  LocalAiView = 'LOCAL_AI_VIEW',
  MaintenanceAdmin = 'MAINTENANCE_ADMIN',
  MaintenanceManager = 'MAINTENANCE_MANAGER',
  MaintenanceTechnician = 'MAINTENANCE_TECHNICIAN',
  MaintenanceUser = 'MAINTENANCE_USER',
  MasterAdmin = 'MASTER_ADMIN',
  MasterKnowledge = 'MASTER_KNOWLEDGE',
  MealPlanningAdmin = 'MEAL_PLANNING_ADMIN',
  MealPlanningEdit = 'MEAL_PLANNING_EDIT',
  MealPlanningView = 'MEAL_PLANNING_VIEW',
  MechanicJobsDelete = 'MECHANIC_JOBS_DELETE',
  MechanicJobsEdit = 'MECHANIC_JOBS_EDIT',
  MechanicJobsFinancial = 'MECHANIC_JOBS_FINANCIAL',
  MechanicJobsView = 'MECHANIC_JOBS_VIEW',
  MedicalRecordsAdmin = 'MEDICAL_RECORDS_ADMIN',
  MedicalRecordsDelete = 'MEDICAL_RECORDS_DELETE',
  MedicalRecordsDownload = 'MEDICAL_RECORDS_DOWNLOAD',
  MedicalRecordsUpload = 'MEDICAL_RECORDS_UPLOAD',
  MedicalRecordsView = 'MEDICAL_RECORDS_VIEW',
  MeetAdmin = 'MEET_ADMIN',
  MeetUser = 'MEET_USER',
  MergeClients = 'MERGE_CLIENTS',
  MicrosoftEmailAdmin = 'MICROSOFT_EMAIL_ADMIN',
  ModuleUpgradeAdmin = 'MODULE_UPGRADE_ADMIN',
  ModuleUpgradeView = 'MODULE_UPGRADE_VIEW',
  MonitorAdmin = 'MONITOR_ADMIN',
  MonitorTrain = 'MONITOR_TRAIN',
  MonitorView = 'MONITOR_VIEW',
  Onboarding = 'ONBOARDING',
  OpportunitiesAdmin = 'OPPORTUNITIES_ADMIN',
  OpportunitiesManager = 'OPPORTUNITIES_MANAGER',
  OrgChartAdmin = 'ORG_CHART_ADMIN',
  OrgChartEdit = 'ORG_CHART_EDIT',
  OrgChartView = 'ORG_CHART_VIEW',
  P2Admin = 'P2_ADMIN',
  P2CampaignManager = 'P2_CAMPAIGN_MANAGER',
  P2Create = 'P2_CREATE',
  P2Edit = 'P2_EDIT',
  P2View = 'P2_VIEW',
  PasswordAdmin = 'PASSWORD_ADMIN',
  PasswordUser = 'PASSWORD_USER',
  PayAdmin = 'PAY_ADMIN',
  PayAiAuditor = 'PAY_AI_AUDITOR',
  PayApprove = 'PAY_APPROVE',
  PayEdit = 'PAY_EDIT',
  PayFinancial = 'PAY_FINANCIAL',
  PayLodge = 'PAY_LODGE',
  PayView = 'PAY_VIEW',
  PhoneSystemAdmin = 'PHONE_SYSTEM_ADMIN',
  PhoneSystemMaster = 'PHONE_SYSTEM_MASTER',
  PhoneSystemUser = 'PHONE_SYSTEM_USER',
  PoliciesAdmin = 'POLICIES_ADMIN',
  PoliciesEdit = 'POLICIES_EDIT',
  Practitioner = 'PRACTITIONER',
  ProgressNotesEdit = 'PROGRESS_NOTES_EDIT',
  ProgressNotesView = 'PROGRESS_NOTES_VIEW',
  ProjectsAdmin = 'PROJECTS_ADMIN',
  PropertyIntelAdmin = 'PROPERTY_INTEL_ADMIN',
  PropertyIntelEdit = 'PROPERTY_INTEL_EDIT',
  PropertyIntelView = 'PROPERTY_INTEL_VIEW',
  ProposalsAdmin = 'PROPOSALS_ADMIN',
  ProposalsCreate = 'PROPOSALS_CREATE',
  ProposalsView = 'PROPOSALS_VIEW',
  ProspectAdmin = 'PROSPECT_ADMIN',
  ProspectAiUser = 'PROSPECT_AI_USER',
  ProspectManager = 'PROSPECT_MANAGER',
  ProspectViewer = 'PROSPECT_VIEWER',
  PublicTrustAdmin = 'PUBLIC_TRUST_ADMIN',
  PublicTrustEdit = 'PUBLIC_TRUST_EDIT',
  PublicTrustView = 'PUBLIC_TRUST_VIEW',
  ReferralsManage = 'REFERRALS_MANAGE',
  ReferralsView = 'REFERRALS_VIEW',
  RewardsAdmin = 'REWARDS_ADMIN',
  RewardsIssue = 'REWARDS_ISSUE',
  RewardsRedeem = 'REWARDS_REDEEM',
  RewardsRedeemOnBehalf = 'REWARDS_REDEEM_ON_BEHALF',
  RewardsView = 'REWARDS_VIEW',
  SecurityAdmin = 'SECURITY_ADMIN',
  SecurityScanner = 'SECURITY_SCANNER',
  Seller = 'SELLER',
  SeparationAdmin = 'SEPARATION_ADMIN',
  SeparationCoparent = 'SEPARATION_COPARENT',
  SeparationToolkit = 'SEPARATION_TOOLKIT',
  SeparationView = 'SEPARATION_VIEW',
  ShelvAdmin = 'SHELV_ADMIN',
  ShelvDelete = 'SHELV_DELETE',
  ShelvEdit = 'SHELV_EDIT',
  ShelvPro = 'SHELV_PRO',
  ShelvView = 'SHELV_VIEW',
  ShiftsEdit = 'SHIFTS_EDIT',
  ShiftsFloor = 'SHIFTS_FLOOR',
  ShiftsMaster = 'SHIFTS_MASTER',
  SiteEditorAdmin = 'SITE_EDITOR_ADMIN',
  SiteEditorMasterAdmin = 'SITE_EDITOR_MASTER_ADMIN',
  SiteTrackerAdmin = 'SITE_TRACKER_ADMIN',
  SiteTrackerManager = 'SITE_TRACKER_MANAGER',
  SiteTrackerUser = 'SITE_TRACKER_USER',
  SmsAdmin = 'SMS_ADMIN',
  SmsEdit = 'SMS_EDIT',
  SmsView = 'SMS_VIEW',
  SopAdmin = 'SOP_ADMIN',
  SopUser = 'SOP_USER',
  TenantAdmin = 'TENANT_ADMIN',
  TenantMasterAdmin = 'TENANT_MASTER_ADMIN',
  TenantUser = 'TENANT_USER',
  TestModuleAdmin = 'TEST_MODULE_ADMIN',
  TestModuleEdit = 'TEST_MODULE_EDIT',
  TestModuleView = 'TEST_MODULE_VIEW',
  TheprogramAdmin = 'THEPROGRAM_ADMIN',
  TheprogramEdit = 'THEPROGRAM_EDIT',
  TheprogramView = 'THEPROGRAM_VIEW',
  TranscriptionAdmin = 'TRANSCRIPTION_ADMIN',
  TranscriptionUser = 'TRANSCRIPTION_USER',
  TranscriptMinerAdmin = 'TRANSCRIPT_MINER_ADMIN',
  TranscriptMinerUser = 'TRANSCRIPT_MINER_USER',
  User = 'USER',
  VapiAdmin = 'VAPI_ADMIN',
  VapiUser = 'VAPI_USER',
  VaultInsightsAdmin = 'VAULT_INSIGHTS_ADMIN',
  VaultInsightsDelete = 'VAULT_INSIGHTS_DELETE',
  VaultInsightsEdit = 'VAULT_INSIGHTS_EDIT',
  VaultInsightsView = 'VAULT_INSIGHTS_VIEW',
  VisionBoardAdmin = 'VISION_BOARD_ADMIN',
  VisionBoardEdit = 'VISION_BOARD_EDIT',
  VisionBoardManager = 'VISION_BOARD_MANAGER',
  VisionBoardView = 'VISION_BOARD_VIEW',
  VlogAdmin = 'VLOG_ADMIN',
  VlogUser = 'VLOG_USER',
  VoiceSignatureAdmin = 'VOICE_SIGNATURE_ADMIN',
  VoiceSignatureEdit = 'VOICE_SIGNATURE_EDIT',
  VoiceSignatureView = 'VOICE_SIGNATURE_VIEW',
  VoipSnapshotAdmin = 'VOIP_SNAPSHOT_ADMIN',
  VoipSnapshotView = 'VOIP_SNAPSHOT_VIEW',
  WalletAdmin = 'WALLET_ADMIN',
  WalletUser = 'WALLET_USER',
  WorkerAdmin = 'WORKER_ADMIN',
  WorkerEdit = 'WORKER_EDIT',
  WorkerView = 'WORKER_VIEW'
}

export type ClientPreferences = {
  __typename?: 'ClientPreferences';
  currency?: Maybe<Scalars['String']['output']>;
  emailNotifications?: Maybe<Scalars['Boolean']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  marketingEmails?: Maybe<Scalars['Boolean']['output']>;
  quickLinks?: Maybe<ClientQuickLinks>;
  securityAlerts?: Maybe<Scalars['Boolean']['output']>;
  sessionTimeout?: Maybe<Scalars['String']['output']>;
  smsNotifications?: Maybe<Scalars['Boolean']['output']>;
  timezone?: Maybe<Scalars['String']['output']>;
  twoFactorEnabled?: Maybe<Scalars['Boolean']['output']>;
};

export type ClientPreferencesInput = {
  currency?: InputMaybe<Scalars['String']['input']>;
  emailNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  marketingEmails?: InputMaybe<Scalars['Boolean']['input']>;
  quickLinks?: InputMaybe<ClientQuickLinksInput>;
  securityAlerts?: InputMaybe<Scalars['Boolean']['input']>;
  sessionTimeout?: InputMaybe<Scalars['String']['input']>;
  smsNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  twoFactorEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ClientQuickLinks = {
  __typename?: 'ClientQuickLinks';
  hidden?: Maybe<Array<Scalars['String']['output']>>;
  order?: Maybe<Array<Scalars['String']['output']>>;
};

export type ClientQuickLinksInput = {
  hidden?: InputMaybe<Array<Scalars['String']['input']>>;
  order?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ClientRewardBalance = {
  __typename?: 'ClientRewardBalance';
  activeTokens: Scalars['Float']['output'];
  clientId: Scalars['ID']['output'];
  clientName: Scalars['String']['output'];
  expiringWithin30Days: Scalars['Float']['output'];
  owedTokens?: Maybe<Scalars['Float']['output']>;
  owedValue?: Maybe<Scalars['Float']['output']>;
  totalValue: Scalars['Float']['output'];
};

/** The role of the client in the system */
export enum ClientRole {
  Both = 'BOTH',
  Buyer = 'BUYER',
  Seller = 'SELLER'
}

export type ClientShippingDetails = {
  __typename?: 'ClientShippingDetails';
  address: ClientAddress;
  instructions?: Maybe<Scalars['String']['output']>;
  isDefault: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  phone: Scalars['String']['output'];
};

export type ClientShippingDetailsInput = {
  address: ClientAddressInput;
  instructions?: InputMaybe<Scalars['String']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  phone: Scalars['String']['input'];
};

export type ClientStoryEntry = {
  __typename?: 'ClientStoryEntry';
  activityType: Scalars['String']['output'];
  canEdit: Scalars['Boolean']['output'];
  clientId: Scalars['ID']['output'];
  createdByName?: Maybe<Scalars['String']['output']>;
  details?: Maybe<Scalars['String']['output']>;
  editedAt?: Maybe<Scalars['DateTime']['output']>;
  editedByName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  kind: Scalars['String']['output'];
  link?: Maybe<Scalars['String']['output']>;
  linkLabel?: Maybe<Scalars['String']['output']>;
  mentions: Array<ClientMention>;
  occurredAt: Scalars['DateTime']['output'];
  source: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type ClientStoryInput = {
  /** Default 20, max 100. */
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Only notes people wrote (no record changes, no other modules). */
  onlyNotes?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches the title, the words, and who wrote it. */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Only these sources (NOTES, EMAILS, BILLS, SUBSCRIPTIONS, EVENTS). */
  sources?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ClientStoryPage = {
  __typename?: 'ClientStoryPage';
  cap: Scalars['Int']['output'];
  rows: Array<ClientStoryEntry>;
  sources: Array<ClientStorySource>;
  total: Scalars['Int']['output'];
};

export type ClientStorySource = {
  __typename?: 'ClientStorySource';
  available: Scalars['Boolean']['output'];
  count: Scalars['Int']['output'];
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  note?: Maybe<Scalars['String']['output']>;
};

export type ClientWithEmployee = {
  __typename?: 'ClientWithEmployee';
  client: Client;
  employee?: Maybe<Employee>;
};

export type ClientWithTenant = {
  __typename?: 'ClientWithTenant';
  email?: Maybe<Scalars['String']['output']>;
  fName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isTenantOwner: Scalars['Boolean']['output'];
  lName?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  tenantDomain?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  tenantName?: Maybe<Scalars['String']['output']>;
  username?: Maybe<Scalars['String']['output']>;
};

export type ClinicalTask = {
  __typename?: 'ClinicalTask';
  assignedTo?: Maybe<Scalars['ID']['output']>;
  assignedToName?: Maybe<Scalars['String']['output']>;
  completedBy?: Maybe<Scalars['ID']['output']>;
  completedByName?: Maybe<Scalars['String']['output']>;
  completedDate?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['ID']['output'];
  createdByName?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  isHistoricalRecord?: Maybe<Scalars['Boolean']['output']>;
  isRecurring: Scalars['Boolean']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  priority: ClinicalTaskPriority;
  recurrencePattern?: Maybe<Scalars['String']['output']>;
  referralRecipients?: Maybe<Array<ClinicalTaskReferralRecipient>>;
  residentId?: Maybe<Scalars['ID']['output']>;
  residentName?: Maybe<Scalars['String']['output']>;
  residentRoom?: Maybe<Scalars['String']['output']>;
  residentWing?: Maybe<Scalars['String']['output']>;
  sourceAuthor?: Maybe<Scalars['String']['output']>;
  sourceBackupDate?: Maybe<Scalars['DateTime']['output']>;
  sourceCreatedAt?: Maybe<Scalars['DateTime']['output']>;
  sourceFields?: Maybe<Array<ClinicalTaskSourceField>>;
  sourceHash?: Maybe<Scalars['String']['output']>;
  sourceId?: Maybe<Scalars['String']['output']>;
  sourceSystem?: Maybe<Scalars['String']['output']>;
  status: ClinicalTaskStatus;
  taskType: ClinicalTaskType;
  tenantId: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  wing?: Maybe<Scalars['String']['output']>;
};

export type ClinicalTaskFilterInput = {
  assignedTo?: InputMaybe<Scalars['ID']['input']>;
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  priority?: InputMaybe<ClinicalTaskPriority>;
  residentId?: InputMaybe<Scalars['ID']['input']>;
  sarahHistory?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<ClinicalTaskStatus>;
  taskType?: InputMaybe<ClinicalTaskType>;
  wing?: InputMaybe<Scalars['String']['input']>;
};

/** Priority level for clinical task */
export enum ClinicalTaskPriority {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM',
  Urgent = 'URGENT'
}

/** One recipient's copy of a SarahCare referral (ReferralActions row) */
export type ClinicalTaskReferralRecipient = {
  __typename?: 'ClinicalTaskReferralRecipient';
  /** What the recipient wrote they did (ActionTaken) */
  actionTaken?: Maybe<Scalars['String']['output']>;
  attachmentOpened?: Maybe<Scalars['Boolean']['output']>;
  /** SarahCare Clear flag: the recipient cleared it from their list */
  cleared?: Maybe<Scalars['Boolean']['output']>;
  /** When they cleared it (ClearedOnDate, Brisbane clock → UTC) */
  clearedAt?: Maybe<Scalars['DateTime']['output']>;
  displayedToUser?: Maybe<Scalars['Boolean']['output']>;
  /** Who they passed it on to (ReferredOnTo), as text */
  referredOnTo?: Maybe<Scalars['String']['output']>;
  /** SarahCare user or group the referral went to (RefferedTo), as text */
  referredTo?: Maybe<Scalars['String']['output']>;
  /** ReferralActions.ReferralItemID */
  sourceId: Scalars['String']['output'];
  userViewed?: Maybe<Scalars['Boolean']['output']>;
};

/** One original SarahCare column kept on an imported clinical task */
export type ClinicalTaskSourceField = {
  __typename?: 'ClinicalTaskSourceField';
  /** SarahCare table and column, e.g. `Referral.CreatedBy` */
  column: Scalars['String']['output'];
  /** The original value as text; null when SarahCare held no value */
  value?: Maybe<Scalars['String']['output']>;
};

/** Current status of clinical task */
export enum ClinicalTaskStatus {
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Historical = 'HISTORICAL',
  InProgress = 'IN_PROGRESS',
  Overdue = 'OVERDUE',
  Pending = 'PENDING'
}

/** Type of clinical task */
export enum ClinicalTaskType {
  AssessmentDue = 'ASSESSMENT_DUE',
  CareTask = 'CARE_TASK',
  DailyCheck = 'DAILY_CHECK',
  General = 'GENERAL',
  HandoverItem = 'HANDOVER_ITEM',
  MedicationTask = 'MEDICATION_TASK',
  Referral = 'REFERRAL'
}

export type ClinicalTasksResponse = {
  __typename?: 'ClinicalTasksResponse';
  limit: Scalars['Int']['output'];
  offset: Scalars['Int']['output'];
  tasks: Array<ClinicalTask>;
  total: Scalars['Int']['output'];
};

export type CloseIncidentInput = {
  closeReason?: InputMaybe<Scalars['String']['input']>;
};

export type Club52EarningsSummary = {
  __typename?: 'Club52EarningsSummary';
  perDay: Array<Club52PeriodEarnings>;
  perGame: Array<Club52GameEarnings>;
  perWeek: Array<Club52PeriodEarnings>;
  rakeOwnerAddress?: Maybe<Scalars['String']['output']>;
  rakeOwnerBalanceMicro: Scalars['String']['output'];
  rakeOwnerReachable: Scalars['Boolean']['output'];
  totalRakeMicro: Scalars['String']['output'];
};

export type Club52FundResult = {
  __typename?: 'Club52FundResult';
  amountMicro: Scalars['String']['output'];
  explorerUrl: Scalars['String']['output'];
  playerEmail: Scalars['String']['output'];
  txHash: Scalars['String']['output'];
};

export type Club52FundingPanel = {
  __typename?: 'Club52FundingPanel';
  appAccessInstructions?: Maybe<Scalars['String']['output']>;
  bankTopUpInstructions?: Maybe<Scalars['String']['output']>;
  dailyCapMicro: Scalars['String']['output'];
  dailySpentMicro: Scalars['String']['output'];
  explorerBaseUrl: Scalars['String']['output'];
  perGameBudgetMicro: Scalars['String']['output'];
  perGameSpentMicro: Scalars['String']['output'];
  presetsMicro: Array<Scalars['String']['output']>;
  rakeOwnerAddress?: Maybe<Scalars['String']['output']>;
  treasuryAddress?: Maybe<Scalars['String']['output']>;
  treasuryBalanceMicro: Scalars['String']['output'];
  treasuryReachable: Scalars['Boolean']['output'];
  walletPageUrl?: Maybe<Scalars['String']['output']>;
};

export type Club52Game = {
  __typename?: 'Club52Game';
  bigBlindMicro: Scalars['String']['output'];
  calendarEventId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  discreetTitle?: Maybe<Scalars['String']['output']>;
  endedAt?: Maybe<Scalars['DateTime']['output']>;
  hostClientId?: Maybe<Scalars['String']['output']>;
  hostName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  joinUrl: Scalars['String']['output'];
  lastStartedAt?: Maybe<Scalars['DateTime']['output']>;
  maxBuyInMicro: Scalars['String']['output'];
  maxPlayers: Scalars['Int']['output'];
  minBuyInMicro: Scalars['String']['output'];
  players: Array<Club52GamePlayer>;
  rakeCapMicro: Scalars['String']['output'];
  rakeFreeThresholdMicro: Scalars['String']['output'];
  rakePercentage: Scalars['Int']['output'];
  replacedTableIds: Array<Scalars['String']['output']>;
  roomName: Scalars['String']['output'];
  scheduledEnd?: Maybe<Scalars['DateTime']['output']>;
  scheduledStart?: Maybe<Scalars['DateTime']['output']>;
  sentMessages: Array<Club52MessageLog>;
  smallBlindMicro: Scalars['String']['output'];
  status: Club52GameStatus;
  tableCreateTxHash?: Maybe<Scalars['String']['output']>;
  tableFormat: Club52TableFormat;
  tableId?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type Club52GameEarnings = {
  __typename?: 'Club52GameEarnings';
  hands: Scalars['Int']['output'];
  players: Scalars['Int']['output'];
  rakeMicro: Scalars['String']['output'];
  roomName: Scalars['String']['output'];
  scheduledStart?: Maybe<Scalars['DateTime']['output']>;
  tableId?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type Club52GamePlayer = {
  __typename?: 'Club52GamePlayer';
  email: Scalars['String']['output'];
  fundedTotalMicro: Scalars['String']['output'];
  invitedAt?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  playerId: Scalars['ID']['output'];
  rsvp: Club52Rsvp;
  rsvpAt?: Maybe<Scalars['DateTime']['output']>;
  walletAddress?: Maybe<Scalars['String']['output']>;
};

/** Lifecycle state of a Club52 game night */
export enum Club52GameStatus {
  Active = 'ACTIVE',
  Cancelled = 'CANCELLED',
  Ended = 'ENDED',
  Scheduled = 'SCHEDULED'
}

export type Club52GeneratedWallet = {
  __typename?: 'Club52GeneratedWallet';
  address: Scalars['String']['output'];
  mnemonic: Scalars['String']['output'];
  target: Club52WalletTarget;
};

export type Club52Goal = {
  __typename?: 'Club52Goal';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  emoji?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  kind: Club52GoalKind;
  status: Club52GoalStatus;
  systemKey?: Maybe<Scalars['String']['output']>;
  targetDate?: Maybe<Scalars['DateTime']['output']>;
  targetGames?: Maybe<Scalars['Int']['output']>;
  targetRakeMicro?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** System ladder rung, custom goal, or record marker */
export enum Club52GoalKind {
  Custom = 'CUSTOM',
  Record = 'RECORD',
  System = 'SYSTEM'
}

/** Goal lifecycle */
export enum Club52GoalStatus {
  Active = 'ACTIVE',
  Dismissed = 'DISMISSED',
  Done = 'DONE'
}

export type Club52InviteeInput = {
  email: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type Club52Issue = {
  __typename?: 'Club52Issue';
  createdAt: Scalars['DateTime']['output'];
  handNumber?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  note: Scalars['String']['output'];
  reporterIdentity?: Maybe<Scalars['String']['output']>;
  reporterName?: Maybe<Scalars['String']['output']>;
  roomName: Scalars['String']['output'];
  seat?: Maybe<Scalars['Int']['output']>;
  tableId?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type Club52Journey = {
  __typename?: 'Club52Journey';
  activeGoal?: Maybe<Club52Goal>;
  bestPlayersInGame: Scalars['Int']['output'];
  bestWeekRakeMicro: Scalars['String']['output'];
  gamesHosted: Scalars['Int']['output'];
  goalProgressPct?: Maybe<Scalars['Int']['output']>;
  justCompletedGoalTitle?: Maybe<Scalars['String']['output']>;
  lastWeek: Club52WeekStats;
  newRecordLabel?: Maybe<Scalars['String']['output']>;
  nextGame?: Maybe<Club52NextGame>;
  phase: Scalars['String']['output'];
  playersInvited: Scalars['Int']['output'];
  steps: Array<Club52JourneyStep>;
  streakAtRisk: Scalars['Boolean']['output'];
  thisWeek: Club52WeekStats;
  totalRakeMicro: Scalars['String']['output'];
  weeklyStreak: Scalars['Int']['output'];
};

export type Club52JourneyStep = {
  __typename?: 'Club52JourneyStep';
  done: Scalars['Boolean']['output'];
  href: Scalars['String']['output'];
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

/** Send a game message via email or SMS */
export enum Club52MessageChannel {
  Email = 'EMAIL',
  Sms = 'SMS'
}

/** Invite, join-link, reminder, or custom message */
export enum Club52MessageKind {
  Custom = 'CUSTOM',
  Invite = 'INVITE',
  JoinLink = 'JOIN_LINK',
  Reminder = 'REMINDER',
  Reschedule = 'RESCHEDULE'
}

export type Club52MessageLog = {
  __typename?: 'Club52MessageLog';
  body: Scalars['String']['output'];
  channel: Club52MessageChannel;
  createdAt: Scalars['DateTime']['output'];
  errorMessage?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  kind: Club52MessageKind;
  recipientName?: Maybe<Scalars['String']['output']>;
  roomName: Scalars['String']['output'];
  subject?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  tenantId: Scalars['String']['output'];
  to: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type Club52NextGame = {
  __typename?: 'Club52NextGame';
  roomName: Scalars['String']['output'];
  scheduledStart?: Maybe<Scalars['DateTime']['output']>;
  title: Scalars['String']['output'];
};

export type Club52PeriodEarnings = {
  __typename?: 'Club52PeriodEarnings';
  games: Scalars['Int']['output'];
  hands: Scalars['Int']['output'];
  period: Scalars['String']['output'];
  rakeMicro: Scalars['String']['output'];
};

export type Club52Player = {
  __typename?: 'Club52Player';
  createdAt: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  gamesInvited: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  totalFundedMicro: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  walletAddress?: Maybe<Scalars['String']['output']>;
};

export type Club52PlayerBalance = {
  __typename?: 'Club52PlayerBalance';
  balanceMicro: Scalars['String']['output'];
  email: Scalars['String']['output'];
  fundedTotalMicro: Scalars['String']['output'];
  name: Scalars['String']['output'];
  playerId: Scalars['ID']['output'];
  reachable: Scalars['Boolean']['output'];
  ready: Scalars['Boolean']['output'];
  rsvp: Scalars['String']['output'];
  walletAddress?: Maybe<Scalars['String']['output']>;
};

/** Invitee RSVP state */
export enum Club52Rsvp {
  Maybe = 'MAYBE',
  No = 'NO',
  Pending = 'PENDING',
  Yes = 'YES'
}

export type Club52RsvpInput = {
  inviteToken: Scalars['String']['input'];
  roomName: Scalars['String']['input'];
  rsvp: Club52Rsvp;
};

export type Club52Settings = {
  __typename?: 'Club52Settings';
  appAccessInstructions?: Maybe<Scalars['String']['output']>;
  bankTopUpInstructions?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  dailyTreasuryCapMicro: Scalars['String']['output'];
  explorerBaseUrl: Scalars['String']['output'];
  hasRakeOwnerMnemonic: Scalars['Boolean']['output'];
  hasTreasuryMnemonic: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  nodeRestUrl: Scalars['String']['output'];
  nodeRpcUrl: Scalars['String']['output'];
  perGameBudgetMicro: Scalars['String']['output'];
  quickFundPresetsMicro: Array<Scalars['String']['output']>;
  rakeOwnerAddress?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  treasuryAddress?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  walletPageUrl: Scalars['String']['output'];
};

export type Club52SetupStatus = {
  __typename?: 'Club52SetupStatus';
  encryptionConfigured: Scalars['Boolean']['output'];
  hasRakeOwner: Scalars['Boolean']['output'];
  hasTreasury: Scalars['Boolean']['output'];
  rakeOwnerAddress?: Maybe<Scalars['String']['output']>;
  ready: Scalars['Boolean']['output'];
  treasuryAddress?: Maybe<Scalars['String']['output']>;
  treasuryBalanceMicro: Scalars['String']['output'];
  treasuryReachable: Scalars['Boolean']['output'];
};

export type Club52Stats = {
  __typename?: 'Club52Stats';
  gamesHosted: Scalars['Int']['output'];
  uniquePlayers: Scalars['Int']['output'];
  upcomingGames: Scalars['Int']['output'];
  weeklyStreak: Scalars['Int']['output'];
};

/** Block52 table format. Rake is cash-game-only (the chain rejects rake on SNG). */
export enum Club52TableFormat {
  Cash = 'CASH',
  SitAndGo = 'SIT_AND_GO'
}

export type Club52TokenResult = {
  __typename?: 'Club52TokenResult';
  canPublish: Scalars['Boolean']['output'];
  displayName: Scalars['String']['output'];
  gameTitle?: Maybe<Scalars['String']['output']>;
  identity: Scalars['String']['output'];
  isInvitedPlayer: Scalars['Boolean']['output'];
  roomName: Scalars['String']['output'];
  token: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type Club52TreasuryStatus = {
  __typename?: 'Club52TreasuryStatus';
  address?: Maybe<Scalars['String']['output']>;
  balanceMicro: Scalars['String']['output'];
  reachable: Scalars['Boolean']['output'];
};

/** Treasury (stakes players) or the house/rake-owner wallet */
export enum Club52WalletTarget {
  RakeOwner = 'RAKE_OWNER',
  Treasury = 'TREASURY'
}

export type Club52WeekStats = {
  __typename?: 'Club52WeekStats';
  games: Scalars['Int']['output'];
  players: Scalars['Int']['output'];
  rakeMicro: Scalars['String']['output'];
};

/** A condition the GP noted on the assessment */
export type CmaConditionEntry = {
  __typename?: 'CmaConditionEntry';
  condition?: Maybe<Scalars['String']['output']>;
  conditionDate?: Maybe<Scalars['DateTime']['output']>;
  sourceId?: Maybe<Scalars['String']['output']>;
};

/** One medicine as the GP listed it on the assessment (text exactly as written) */
export type CmaMedicationEntry = {
  __typename?: 'CmaMedicationEntry';
  /** Dose and frequency as one piece of text — never parsed */
  doseFrequency?: Maybe<Scalars['String']['output']>;
  medicationName?: Maybe<Scalars['String']['output']>;
  sourceId?: Maybe<Scalars['String']['output']>;
  strength?: Maybe<Scalars['String']['output']>;
};

/** A review date set by the assessment, and whether SarahCare recorded it done */
export type CmaReviewEntry = {
  __typename?: 'CmaReviewEntry';
  completedBy?: Maybe<Scalars['String']['output']>;
  completedOn?: Maybe<Scalars['DateTime']['output']>;
  dueDate?: Maybe<Scalars['DateTime']['output']>;
  sourceId?: Maybe<Scalars['String']['output']>;
};

export type Coach = {
  __typename?: 'Coach';
  activatedAt?: Maybe<Scalars['DateTime']['output']>;
  bio?: Maybe<Scalars['String']['output']>;
  calendarId?: Maybe<Scalars['String']['output']>;
  certificateNumber?: Maybe<Scalars['String']['output']>;
  certificationProgramme?: Maybe<Scalars['String']['output']>;
  certifiedAt?: Maybe<Scalars['DateTime']['output']>;
  certifiedBy?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  externalBookingUrl?: Maybe<Scalars['String']['output']>;
  fName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  invitedAt?: Maybe<Scalars['DateTime']['output']>;
  lName: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  photoCid?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  status: CoachStatus;
  tenantId: Scalars['String']['output'];
  tier: CoachTier;
  updatedAt: Scalars['DateTime']['output'];
};

export type CoachAgreement = {
  __typename?: 'CoachAgreement';
  agreementType: CoachAgreementType;
  coachId: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  effectiveDate?: Maybe<Scalars['DateTime']['output']>;
  expiryDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  pProposalId?: Maybe<Scalars['String']['output']>;
  signedAt?: Maybe<Scalars['DateTime']['output']>;
  status: CoachAgreementStatus;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** Lifecycle status of a coach's licensing agreement */
export enum CoachAgreementStatus {
  Draft = 'DRAFT',
  Expired = 'EXPIRED',
  Sent = 'SENT',
  Signed = 'SIGNED',
  Terminated = 'TERMINATED'
}

/** Which agreement template this coach's agreement is based on */
export enum CoachAgreementType {
  Custom = 'CUSTOM',
  Reseller = 'RESELLER',
  WhiteLabelPlatform = 'WHITE_LABEL_PLATFORM'
}

/** Coach onboarding/lifecycle status */
export enum CoachStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  Invited = 'INVITED'
}

/** Coach licensing tier — Clinician (solo) or Practitioner (multi-coach practice) */
export enum CoachTier {
  Clinician = 'CLINICIAN',
  Practitioner = 'PRACTITIONER'
}

export type CodeAccountingTransactionInput = {
  gstCents?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['ID']['input'];
  ledgerAccountId?: InputMaybe<Scalars['ID']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  residentId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<AccountingCodingStatus>;
};

export type CodeExample = {
  __typename?: 'CodeExample';
  code: Scalars['String']['output'];
  language: Scalars['String']['output'];
};

export type CodeExampleInput = {
  code: Scalars['String']['input'];
  language: Scalars['String']['input'];
};

export type CodingRule = {
  __typename?: 'CodingRule';
  companyId: Scalars['String']['output'];
  contains: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdByClientId?: Maybe<Scalars['String']['output']>;
  direction: AccountingRuleDirection;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  ledgerAccountId: Scalars['String']['output'];
  priority: Scalars['Int']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type ColdStorageEquipment = {
  __typename?: 'ColdStorageEquipment';
  capacity: Scalars['String']['output'];
  id: Scalars['String']['output'];
  location: Scalars['String']['output'];
  maxTemp: Scalars['Float']['output'];
  minTemp: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type CommandActivityComment = {
  __typename?: 'CommandActivityComment';
  activityId: Scalars['ID']['output'];
  attachments?: Maybe<Array<CommandActivityFile>>;
  authorClientId?: Maybe<Scalars['ID']['output']>;
  authorName: Scalars['String']['output'];
  body?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  dealId?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  isReply: Scalars['Boolean']['output'];
  mentions?: Maybe<Array<CommandMention>>;
  retractedAt?: Maybe<Scalars['DateTime']['output']>;
  retractedByName?: Maybe<Scalars['String']['output']>;
  subjectId?: Maybe<Scalars['String']['output']>;
  subjectType?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type CommandActivityFile = {
  __typename?: 'CommandActivityFile';
  cid: Scalars['String']['output'];
  fileId?: Maybe<Scalars['String']['output']>;
  fileName?: Maybe<Scalars['String']['output']>;
  mimeType?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['Float']['output']>;
  uploadedAt?: Maybe<Scalars['DateTime']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type CommandActivityFileInput = {
  cid: Scalars['String']['input'];
  fileName?: InputMaybe<Scalars['String']['input']>;
  mimeType?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
};

export type CommandActivityFilters = {
  activityType?: InputMaybe<Scalars['String']['input']>;
  actorId?: InputMaybe<Scalars['String']['input']>;
  dealId?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  subjectType?: InputMaybe<Scalars['String']['input']>;
};

export type CommandActivityPage = {
  __typename?: 'CommandActivityPage';
  cap: Scalars['Int']['output'];
  rows: Array<CommissionDealActivity>;
  total: Scalars['Int']['output'];
};

export type CommandAddActivityCommentInput = {
  activityId: Scalars['ID']['input'];
  asReply?: InputMaybe<Scalars['Boolean']['input']>;
  attachments?: InputMaybe<Array<CommandActivityFileInput>>;
  body?: InputMaybe<Scalars['String']['input']>;
  fileId?: InputMaybe<Scalars['String']['input']>;
  mentions?: InputMaybe<Array<CommandMentionInput>>;
};

export type CommandAddActivityNoteInput = {
  attachments?: InputMaybe<Array<CommandActivityFileInput>>;
  body: Scalars['String']['input'];
  dealId: Scalars['ID']['input'];
  mentions?: InputMaybe<Array<CommandMentionInput>>;
};

export type CommandAttachActivityFilesInput = {
  dealId: Scalars['ID']['input'];
  files: Array<CommandActivityFileInput>;
  mentions?: InputMaybe<Array<CommandMentionInput>>;
  note?: InputMaybe<Scalars['String']['input']>;
};

export type CommandCannotSeeDeal = {
  __typename?: 'CommandCannotSeeDeal';
  clientId?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  reason: Scalars['String']['output'];
  source: CommandMentionSource;
};

export type CommandClient = {
  __typename?: 'CommandClient';
  address?: Maybe<Scalars['String']['output']>;
  clientId?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['DateTime']['output'];
  email?: Maybe<Scalars['String']['output']>;
  ghlContactId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isDemo?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  pipedrivePersonId?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  xeroContactId?: Maybe<Scalars['String']['output']>;
};

export type CommandClientMatch = {
  __typename?: 'CommandClientMatch';
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
};

export type CommandDeal = {
  __typename?: 'CommandDeal';
  address?: Maybe<Scalars['String']['output']>;
  appSetter?: Maybe<Scalars['String']['output']>;
  buildPrice?: Maybe<Scalars['Float']['output']>;
  builder?: Maybe<Scalars['String']['output']>;
  client: Scalars['String']['output'];
  commandClientId?: Maybe<Scalars['ID']['output']>;
  commsOwed?: Maybe<Scalars['Float']['output']>;
  commsPaid?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['DateTime']['output'];
  eoiDate?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  ipValue?: Maybe<Scalars['Float']['output']>;
  isDemo?: Maybe<Scalars['Boolean']['output']>;
  landPrice?: Maybe<Scalars['Float']['output']>;
  mortStage?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  payStatus?: Maybe<Scalars['String']['output']>;
  pcDue?: Maybe<Scalars['String']['output']>;
  sourceId?: Maybe<Scalars['String']['output']>;
  sourceSystem: CommandSourceSystem;
  stage?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  strategist?: Maybe<Scalars['String']['output']>;
  structure?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  totalComms?: Maybe<Scalars['Float']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  xeroInvoiceId?: Maybe<Scalars['String']['output']>;
};

export type CommandDealAccess = {
  __typename?: 'CommandDealAccess';
  admins: Array<CommandDealAccessPerson>;
  dealId: Scalars['ID']['output'];
  isPrivate: Scalars['Boolean']['output'];
  privateSetAt?: Maybe<Scalars['DateTime']['output']>;
  privateSetByName?: Maybe<Scalars['String']['output']>;
  sharedWith: Array<CommandDealAccessPerson>;
};

export type CommandDealAccessPerson = {
  __typename?: 'CommandDealAccessPerson';
  canOpenModule: Scalars['Boolean']['output'];
  clientId: Scalars['ID']['output'];
  email?: Maybe<Scalars['String']['output']>;
  isAdmin: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export type CommandDealExtraction = {
  __typename?: 'CommandDealExtraction';
  buildContractDate?: Maybe<Scalars['String']['output']>;
  buildPrice?: Maybe<Scalars['Float']['output']>;
  buildType?: Maybe<Scalars['String']['output']>;
  builder?: Maybe<Scalars['String']['output']>;
  builderMatched: Scalars['Boolean']['output'];
  clientEmail?: Maybe<Scalars['String']['output']>;
  clientName?: Maybe<Scalars['String']['output']>;
  clientPhone?: Maybe<Scalars['String']['output']>;
  closingDate?: Maybe<Scalars['String']['output']>;
  commissionTerms?: Maybe<Scalars['String']['output']>;
  eoiSignedDate?: Maybe<Scalars['String']['output']>;
  instalments?: Maybe<Array<CommissionInstalment>>;
  ipValue?: Maybe<Scalars['Float']['output']>;
  landPrice?: Maybe<Scalars['Float']['output']>;
  landRegistrationDate?: Maybe<Scalars['String']['output']>;
  lender?: Maybe<Scalars['String']['output']>;
  propSalesCommsExpected?: Maybe<Scalars['Float']['output']>;
  propertyAddress?: Maybe<Scalars['String']['output']>;
  warnings: Array<Scalars['String']['output']>;
};

export type CommandDealExtractionInput = {
  text: Scalars['String']['input'];
};

export type CommandDealFilters = {
  builder?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  strategist?: InputMaybe<Scalars['String']['input']>;
};

export type CommandGhlPipeline = {
  __typename?: 'CommandGhlPipeline';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  stages: Array<CommandGhlStage>;
};

export type CommandGhlStage = {
  __typename?: 'CommandGhlStage';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type CommandIntegrationConfig = {
  __typename?: 'CommandIntegrationConfig';
  createdAt: Scalars['DateTime']['output'];
  ghlApiToken?: Maybe<Scalars['String']['output']>;
  ghlFieldKeys?: Maybe<Scalars['String']['output']>;
  ghlLocationId?: Maybe<Scalars['String']['output']>;
  ghlPipelineId?: Maybe<Scalars['String']['output']>;
  ghlStageId?: Maybe<Scalars['String']['output']>;
  googleServiceAccountEmail?: Maybe<Scalars['String']['output']>;
  googleServiceAccountKeySet?: Maybe<Scalars['Boolean']['output']>;
  googleSheetId?: Maybe<Scalars['String']['output']>;
  googleSheetLastSyncedAt?: Maybe<Scalars['String']['output']>;
  googleSheetRange?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  onePropertyGhlApiToken?: Maybe<Scalars['String']['output']>;
  onePropertyGhlLocationId?: Maybe<Scalars['String']['output']>;
  onePropertyGhlPipelineId?: Maybe<Scalars['String']['output']>;
  onePropertyGhlStageId?: Maybe<Scalars['String']['output']>;
  pipedriveApiToken?: Maybe<Scalars['String']['output']>;
  pipedriveCompanyDomain?: Maybe<Scalars['String']['output']>;
  pipedriveCreateDeals?: Maybe<Scalars['Boolean']['output']>;
  pipedriveCreateDealsChangedAt?: Maybe<Scalars['DateTime']['output']>;
  pipedriveCreateDealsChangedBy?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  xeroClientId?: Maybe<Scalars['String']['output']>;
  xeroClientSecretPreview?: Maybe<Scalars['String']['output']>;
  xeroClientSecretSet?: Maybe<Scalars['Boolean']['output']>;
  xeroConfigured?: Maybe<Scalars['Boolean']['output']>;
  xeroOrgName?: Maybe<Scalars['String']['output']>;
  xeroTenantId?: Maybe<Scalars['String']['output']>;
};

export type CommandIntegrationStatus = {
  __typename?: 'CommandIntegrationStatus';
  ghl: IntegrationStatus;
  pipedrive: IntegrationStatus;
  xero: IntegrationStatus;
};

export type CommandMention = {
  __typename?: 'CommandMention';
  answerBack?: Maybe<Scalars['Boolean']['output']>;
  clientId?: Maybe<Scalars['ID']['output']>;
  doneAt?: Maybe<Scalars['DateTime']['output']>;
  doneById?: Maybe<Scalars['ID']['output']>;
  doneByName?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  notifiedAt?: Maybe<Scalars['DateTime']['output']>;
  notifiedEmail?: Maybe<Scalars['Boolean']['output']>;
  notifiedSms?: Maybe<Scalars['Boolean']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  repliedAt?: Maybe<Scalars['DateTime']['output']>;
  replyCommentId?: Maybe<Scalars['ID']['output']>;
  source: CommandMentionSource;
};

export type CommandMentionInput = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  source: CommandMentionSource;
};

export type CommandMentionNotifyChoiceInput = {
  email: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
  sms: Scalars['Boolean']['input'];
  source: CommandMentionSource;
};

export type CommandMentionNotifyResult = {
  __typename?: 'CommandMentionNotifyResult';
  rows: Array<CommandMentionNotifyRow>;
  summary?: Maybe<Scalars['String']['output']>;
};

export type CommandMentionNotifyRow = {
  __typename?: 'CommandMentionNotifyRow';
  emailSent: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  problem?: Maybe<Scalars['String']['output']>;
  smsSent: Scalars['Boolean']['output'];
  source: CommandMentionSource;
};

/** Where a tagged person was found: a People option, a Broker option, or a client login */
export enum CommandMentionSource {
  Broker = 'BROKER',
  Client = 'CLIENT',
  Person = 'PERSON'
}

export type CommandMentionablePerson = {
  __typename?: 'CommandMentionablePerson';
  clientId?: Maybe<Scalars['ID']['output']>;
  hasEmail: Scalars['Boolean']['output'];
  hasPhone: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  roleLabel?: Maybe<Scalars['String']['output']>;
  source: CommandMentionSource;
};

export type CommandNotificationAudienceInfo = {
  __typename?: 'CommandNotificationAudienceInfo';
  description: Scalars['String']['output'];
  external: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

export type CommandNotificationCatalogue = {
  __typename?: 'CommandNotificationCatalogue';
  audiences: Array<CommandNotificationAudienceInfo>;
  events: Array<CommandNotificationEvent>;
  unreachablePeople: Array<Scalars['String']['output']>;
};

export type CommandNotificationEvent = {
  __typename?: 'CommandNotificationEvent';
  audiences: Array<Scalars['String']['output']>;
  defaultAudiences: Array<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  enabledRuleCount: Scalars['Int']['output'];
  firesWhen: Scalars['String']['output'];
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  live: Scalars['Boolean']['output'];
  mergeFields: Array<Scalars['String']['output']>;
  notLiveReason?: Maybe<Scalars['String']['output']>;
  optionList?: Maybe<Scalars['String']['output']>;
  ruleCount: Scalars['Int']['output'];
  trigger: Scalars['String']['output'];
};

export type CommandNotificationLog = {
  __typename?: 'CommandNotificationLog';
  actorName?: Maybe<Scalars['String']['output']>;
  clientName?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  dealId?: Maybe<Scalars['String']['output']>;
  dealNumber?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  eventKey: Scalars['String']['output'];
  eventLabel?: Maybe<Scalars['String']['output']>;
  failedCount: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  isTest: Scalars['Boolean']['output'];
  outcome: Scalars['String']['output'];
  recipients?: Maybe<Array<CommandNotificationRecipient>>;
  ruleId?: Maybe<Scalars['String']['output']>;
  sentCount: Scalars['Int']['output'];
  tenantId: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type CommandNotificationRecipient = {
  __typename?: 'CommandNotificationRecipient';
  address?: Maybe<Scalars['String']['output']>;
  channel: Scalars['String']['output'];
  detail?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  outcome: Scalars['String']['output'];
};

export type CommandNotificationRule = {
  __typename?: 'CommandNotificationRule';
  audiences: Array<Scalars['String']['output']>;
  channels: Array<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdByName?: Maybe<Scalars['String']['output']>;
  customBody?: Maybe<Scalars['String']['output']>;
  customSubject?: Maybe<Scalars['String']['output']>;
  eventKey: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isEnabled: Scalars['Boolean']['output'];
  optionId?: Maybe<Scalars['String']['output']>;
  optionName?: Maybe<Scalars['String']['output']>;
  specificClientIds?: Maybe<Array<Scalars['String']['output']>>;
  specificOptionIds?: Maybe<Array<Scalars['String']['output']>>;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedByName?: Maybe<Scalars['String']['output']>;
};

export type CommandNotificationRuleInput = {
  audiences?: InputMaybe<Array<Scalars['String']['input']>>;
  channels?: InputMaybe<Array<Scalars['String']['input']>>;
  customBody?: InputMaybe<Scalars['String']['input']>;
  customSubject?: InputMaybe<Scalars['String']['input']>;
  eventKey: Scalars['String']['input'];
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  optionId?: InputMaybe<Scalars['String']['input']>;
  optionName?: InputMaybe<Scalars['String']['input']>;
  specificClientIds?: InputMaybe<Array<Scalars['String']['input']>>;
  specificOptionIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CommandOpenTags = {
  __typename?: 'CommandOpenTags';
  people: Array<CommandTagPerson>;
  recentClosedCap: Scalars['Int']['output'];
  recentClosedDays: Scalars['Int']['output'];
};

export type CommandReplyNoticeChoiceInput = {
  clientId: Scalars['ID']['input'];
  email: Scalars['Boolean']['input'];
  sms: Scalars['Boolean']['input'];
};

export type CommandRuleAudiencePreview = {
  __typename?: 'CommandRuleAudiencePreview';
  dealsInScope: Scalars['Int']['output'];
  dealsReachingNobody: Scalars['Int']['output'];
  dealsReachingSomebody: Scalars['Int']['output'];
  people: Array<CommandRulePreviewPerson>;
  perDealPeople: Array<CommandRulePreviewPerDeal>;
};

export type CommandRulePreviewPerDeal = {
  __typename?: 'CommandRulePreviewPerDeal';
  deals: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type CommandRulePreviewPerson = {
  __typename?: 'CommandRulePreviewPerson';
  audience: Scalars['String']['output'];
  email?: Maybe<Scalars['String']['output']>;
  hasLogin: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  reachable: Scalars['Boolean']['output'];
};

/** External system a Command Centre deal was sourced from */
export enum CommandSourceSystem {
  Ghl = 'GHL',
  Manual = 'MANUAL',
  Pipedrive = 'PIPEDRIVE',
  Xero = 'XERO'
}

export type CommandSummary = {
  __typename?: 'CommandSummary';
  actNowCount: Scalars['Int']['output'];
  commissionsOwed: Scalars['Float']['output'];
  commissionsPaid: Scalars['Float']['output'];
  totalCommissions: Scalars['Float']['output'];
  totalDeals: Scalars['Int']['output'];
  totalIpValue: Scalars['Float']['output'];
};

export type CommandTagChase = {
  __typename?: 'CommandTagChase';
  createdAt: Scalars['DateTime']['output'];
  enabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  lastOwnerRunSummary?: Maybe<Scalars['String']['output']>;
  lastRunAt?: Maybe<Scalars['DateTime']['output']>;
  lastRunSent?: Maybe<Scalars['Int']['output']>;
  lastRunSummary?: Maybe<Scalars['String']['output']>;
  lastRunWeek?: Maybe<Scalars['String']['output']>;
  ownerSummaryEnabled?: Maybe<Scalars['Boolean']['output']>;
  switchedAt?: Maybe<Scalars['DateTime']['output']>;
  switchedByName?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type CommandTagChaseCount = {
  __typename?: 'CommandTagChaseCount';
  name: Scalars['String']['output'];
  openCount: Scalars['Int']['output'];
};

export type CommandTagChaseOwner = {
  __typename?: 'CommandTagChaseOwner';
  clientId?: Maybe<Scalars['ID']['output']>;
  hasEmail: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export type CommandTagChaseRecipients = {
  __typename?: 'CommandTagChaseRecipients';
  cannotEmail: Array<CommandTagChaseCount>;
  notOnTeam: Array<CommandTagChaseCount>;
  owners: Array<CommandTagChaseOwner>;
  team: Array<CommandTagChaseOwner>;
  willEmail: Array<CommandTagChaseCount>;
};

export type CommandTagChaseSendResult = {
  __typename?: 'CommandTagChaseSendResult';
  failed: Scalars['Int']['output'];
  noEmail: Scalars['Int']['output'];
  openTags: Scalars['Int']['output'];
  sent: Scalars['Int']['output'];
  summary: Scalars['String']['output'];
};

export type CommandTagItem = {
  __typename?: 'CommandTagItem';
  answerBack: Scalars['Boolean']['output'];
  ask?: Maybe<Scalars['String']['output']>;
  clientName?: Maybe<Scalars['String']['output']>;
  commentId?: Maybe<Scalars['ID']['output']>;
  dealId?: Maybe<Scalars['ID']['output']>;
  dealNumber?: Maybe<Scalars['String']['output']>;
  doneAt?: Maybe<Scalars['DateTime']['output']>;
  doneByName?: Maybe<Scalars['String']['output']>;
  entryId: Scalars['ID']['output'];
  mentionId: Scalars['ID']['output'];
  notifiedAt?: Maybe<Scalars['DateTime']['output']>;
  path: Scalars['String']['output'];
  repliedAt?: Maybe<Scalars['DateTime']['output']>;
  source: Scalars['String']['output'];
  taggedAt: Scalars['DateTime']['output'];
  taggedByName?: Maybe<Scalars['String']['output']>;
  what: Scalars['String']['output'];
};

export type CommandTagPerson = {
  __typename?: 'CommandTagPerson';
  hasEmail: Scalars['Boolean']['output'];
  hasSignedIn?: Maybe<Scalars['Boolean']['output']>;
  isMe: Scalars['Boolean']['output'];
  isTeam: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  lastActiveAt?: Maybe<Scalars['DateTime']['output']>;
  lastSignInMethod?: Maybe<Scalars['String']['output']>;
  lastSignedInAt?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  oldestOpenAt?: Maybe<Scalars['DateTime']['output']>;
  open: Array<CommandTagItem>;
  openCount: Scalars['Int']['output'];
  recentlyClosed: Array<CommandTagItem>;
  roleLabel?: Maybe<Scalars['String']['output']>;
  toAcknowledge: Array<CommandTagItem>;
  totalTagged: Scalars['Int']['output'];
};

export type CommandTaggedPersonInput = {
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  source: CommandMentionSource;
};

export type CommissionDeal = {
  __typename?: 'CommissionDeal';
  appSetter?: Maybe<Scalars['String']['output']>;
  archived?: Maybe<Scalars['Boolean']['output']>;
  baseDue?: Maybe<Scalars['String']['output']>;
  baseDueNote?: Maybe<Scalars['String']['output']>;
  broker?: Maybe<Scalars['String']['output']>;
  buildContractDate?: Maybe<Scalars['String']['output']>;
  buildDeliveryStatus?: Maybe<Scalars['String']['output']>;
  buildPrice?: Maybe<Scalars['Float']['output']>;
  buildStage?: Maybe<Scalars['String']['output']>;
  buildType?: Maybe<Scalars['String']['output']>;
  builder?: Maybe<Scalars['String']['output']>;
  clientEmail?: Maybe<Scalars['String']['output']>;
  clientName?: Maybe<Scalars['String']['output']>;
  clientPhone?: Maybe<Scalars['String']['output']>;
  closingDate?: Maybe<Scalars['String']['output']>;
  closingDateNote?: Maybe<Scalars['String']['output']>;
  commissionDueDate?: Maybe<Scalars['String']['output']>;
  commissionsPayStatus?: Maybe<Scalars['String']['output']>;
  commissionsStageReached?: Maybe<Scalars['String']['output']>;
  commsOwed?: Maybe<Scalars['Float']['output']>;
  commsReceived?: Maybe<Scalars['Float']['output']>;
  commsReceivedOffXero?: Maybe<Scalars['Float']['output']>;
  commsReceivedXero?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['DateTime']['output'];
  dealNumber: Scalars['String']['output'];
  eoiSignedDate?: Maybe<Scalars['String']['output']>;
  frameDue?: Maybe<Scalars['String']['output']>;
  frameDueNote?: Maybe<Scalars['String']['output']>;
  ghlOpportunityId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  importRowKey?: Maybe<Scalars['String']['output']>;
  importedAt?: Maybe<Scalars['String']['output']>;
  importedCommsOwed?: Maybe<Scalars['Float']['output']>;
  importedCommsReceived?: Maybe<Scalars['Float']['output']>;
  importedFromTab?: Maybe<Scalars['String']['output']>;
  instalments?: Maybe<Array<CommissionInstalment>>;
  ipValue?: Maybe<Scalars['Float']['output']>;
  isPrivate?: Maybe<Scalars['Boolean']['output']>;
  landComms?: Maybe<Scalars['Float']['output']>;
  landPrice?: Maybe<Scalars['Float']['output']>;
  landRegistrationDate?: Maybe<Scalars['String']['output']>;
  lastContactedAt?: Maybe<Scalars['String']['output']>;
  leadSource?: Maybe<Scalars['String']['output']>;
  lender?: Maybe<Scalars['String']['output']>;
  matchStatus?: Maybe<Scalars['String']['output']>;
  matchedPayments?: Maybe<Array<MatchedPayment>>;
  mortCommsExpected?: Maybe<Scalars['Float']['output']>;
  mortCommsResidual?: Maybe<Scalars['Float']['output']>;
  mortgageStage?: Maybe<Scalars['String']['output']>;
  nextReviewDue?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  offXeroReceipts?: Maybe<Array<OffXeroReceipt>>;
  parseProblems?: Maybe<Array<Scalars['String']['output']>>;
  pipedrive?: Maybe<CommissionDealPipedrive>;
  pipedriveCheck?: Maybe<PipedriveCheck>;
  practicalCompletion?: Maybe<PracticalCompletionChecklist>;
  practicalCompletionDue?: Maybe<Scalars['String']['output']>;
  practicalCompletionDueNote?: Maybe<Scalars['String']['output']>;
  privateSetAt?: Maybe<Scalars['DateTime']['output']>;
  privateSetByName?: Maybe<Scalars['String']['output']>;
  propSalesCommsExpected?: Maybe<Scalars['Float']['output']>;
  propertyAddress?: Maybe<Scalars['String']['output']>;
  propertyAddressParts?: Maybe<PropertyAddressParts>;
  receivedVariance?: Maybe<Scalars['Float']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  strategist?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type CommissionDealActivity = {
  __typename?: 'CommissionDealActivity';
  activityDate: Scalars['DateTime']['output'];
  activityType: Scalars['String']['output'];
  attachments?: Maybe<Array<CommandActivityFile>>;
  changedById?: Maybe<Scalars['String']['output']>;
  changedByName?: Maybe<Scalars['String']['output']>;
  changes?: Maybe<Array<DealFieldChange>>;
  createdAt: Scalars['DateTime']['output'];
  dealId?: Maybe<Scalars['ID']['output']>;
  details?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  mentions?: Maybe<Array<CommandMention>>;
  subjectId?: Maybe<Scalars['String']['output']>;
  subjectLabel?: Maybe<Scalars['String']['output']>;
  subjectType?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type CommissionDealFilters = {
  broker?: InputMaybe<Scalars['String']['input']>;
  buildStage?: InputMaybe<Scalars['String']['input']>;
  builder?: InputMaybe<Scalars['String']['input']>;
  dateField?: InputMaybe<Scalars['String']['input']>;
  dateFrom?: InputMaybe<Scalars['String']['input']>;
  dateTo?: InputMaybe<Scalars['String']['input']>;
  hideFullyPaid?: InputMaybe<Scalars['Boolean']['input']>;
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  onlyArchived?: InputMaybe<Scalars['Boolean']['input']>;
  onlyNeedsAction?: InputMaybe<Scalars['Boolean']['input']>;
  onlyNoBroker?: InputMaybe<Scalars['Boolean']['input']>;
  onlyNoBuilder?: InputMaybe<Scalars['Boolean']['input']>;
  onlyNoStatus?: InputMaybe<Scalars['Boolean']['input']>;
  onlyOverReceived?: InputMaybe<Scalars['Boolean']['input']>;
  onlySettledUnmatched?: InputMaybe<Scalars['Boolean']['input']>;
  pipedrive?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  strategist?: InputMaybe<Scalars['String']['input']>;
};

export type CommissionDealInput = {
  appSetter?: InputMaybe<Scalars['String']['input']>;
  baseDue?: InputMaybe<Scalars['String']['input']>;
  baseDueNote?: InputMaybe<Scalars['String']['input']>;
  broker?: InputMaybe<Scalars['String']['input']>;
  buildContractDate?: InputMaybe<Scalars['String']['input']>;
  buildDeliveryStatus?: InputMaybe<Scalars['String']['input']>;
  buildPrice?: InputMaybe<Scalars['Float']['input']>;
  buildStage?: InputMaybe<Scalars['String']['input']>;
  buildType?: InputMaybe<Scalars['String']['input']>;
  builder?: InputMaybe<Scalars['String']['input']>;
  clientEmail?: InputMaybe<Scalars['String']['input']>;
  clientName?: InputMaybe<Scalars['String']['input']>;
  clientPhone?: InputMaybe<Scalars['String']['input']>;
  closingDate?: InputMaybe<Scalars['String']['input']>;
  closingDateNote?: InputMaybe<Scalars['String']['input']>;
  commissionDueDate?: InputMaybe<Scalars['String']['input']>;
  commissionsPayStatus?: InputMaybe<Scalars['String']['input']>;
  commissionsStageReached?: InputMaybe<Scalars['String']['input']>;
  eoiSignedDate?: InputMaybe<Scalars['String']['input']>;
  frameDue?: InputMaybe<Scalars['String']['input']>;
  frameDueNote?: InputMaybe<Scalars['String']['input']>;
  ghlOpportunityId?: InputMaybe<Scalars['String']['input']>;
  instalments?: InputMaybe<Array<CommissionInstalmentInput>>;
  ipValue?: InputMaybe<Scalars['Float']['input']>;
  landComms?: InputMaybe<Scalars['Float']['input']>;
  landPrice?: InputMaybe<Scalars['Float']['input']>;
  landRegistrationDate?: InputMaybe<Scalars['String']['input']>;
  lastContactedAt?: InputMaybe<Scalars['String']['input']>;
  leadSource?: InputMaybe<Scalars['String']['input']>;
  lender?: InputMaybe<Scalars['String']['input']>;
  mortCommsExpected?: InputMaybe<Scalars['Float']['input']>;
  mortCommsResidual?: InputMaybe<Scalars['Float']['input']>;
  mortgageStage?: InputMaybe<Scalars['String']['input']>;
  nextReviewDue?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  practicalCompletion?: InputMaybe<PracticalCompletionInput>;
  practicalCompletionDue?: InputMaybe<Scalars['String']['input']>;
  practicalCompletionDueNote?: InputMaybe<Scalars['String']['input']>;
  propSalesCommsExpected?: InputMaybe<Scalars['Float']['input']>;
  propertyAddress?: InputMaybe<Scalars['String']['input']>;
  propertyAddressParts?: InputMaybe<PropertyAddressPartsInput>;
  status?: InputMaybe<Scalars['String']['input']>;
  strategist?: InputMaybe<Scalars['String']['input']>;
};

export type CommissionDealPipedrive = {
  __typename?: 'CommissionDealPipedrive';
  commissionTotal?: Maybe<Scalars['Float']['output']>;
  dealId: Scalars['String']['output'];
  differences?: Maybe<Array<PipedriveDifference>>;
  lastPulledAt?: Maybe<Scalars['String']['output']>;
  linkedAt?: Maybe<Scalars['String']['output']>;
  linkedBy?: Maybe<Scalars['String']['output']>;
  linkedByName?: Maybe<Scalars['String']['output']>;
  orgId?: Maybe<Scalars['String']['output']>;
  ownerName?: Maybe<Scalars['String']['output']>;
  personId?: Maybe<Scalars['String']['output']>;
  personName?: Maybe<Scalars['String']['output']>;
  pipedriveUpdatedAt?: Maybe<Scalars['String']['output']>;
  pipelineId?: Maybe<Scalars['String']['output']>;
  problem?: Maybe<Scalars['String']['output']>;
  stageId?: Maybe<Scalars['String']['output']>;
  stageName?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type CommissionDealsPage = {
  __typename?: 'CommissionDealsPage';
  deadExcludedCount?: Maybe<Scalars['Int']['output']>;
  deals: Array<CommissionDeal>;
  limit: Scalars['Int']['output'];
  offset: Scalars['Int']['output'];
  openDealCount: Scalars['Int']['output'];
  overdueCount: Scalars['Int']['output'];
  settledUnmatchedCount?: Maybe<Scalars['Int']['output']>;
  total: Scalars['Int']['output'];
  totalDeadExcluded?: Maybe<Scalars['Float']['output']>;
  totalExpected: Scalars['Float']['output'];
  totalExpectedClosed: Scalars['Float']['output'];
  totalExpectedOpen: Scalars['Float']['output'];
  totalIpValue: Scalars['Float']['output'];
  totalOverReceived?: Maybe<Scalars['Float']['output']>;
  totalOwed: Scalars['Float']['output'];
  totalReceived: Scalars['Float']['output'];
  totalReceivedOffXero?: Maybe<Scalars['Float']['output']>;
  totalSettledUnmatched?: Maybe<Scalars['Float']['output']>;
  totalSheetReceived: Scalars['Float']['output'];
};

export type CommissionImportPreview = {
  __typename?: 'CommissionImportPreview';
  archivedCount: Scalars['Int']['output'];
  dealCount: Scalars['Int']['output'];
  duplicateGroups: Array<ImportDuplicateGroup>;
  problems: Array<ImportRowProblem>;
  sheetClaimedPipeline?: Maybe<Scalars['Float']['output']>;
  tabs: Array<ImportTabSummary>;
  totals: ImportTotals;
  unknownValues: Array<ImportUnknownValue>;
};

export type CommissionImportResult = {
  __typename?: 'CommissionImportResult';
  created: Scalars['Int']['output'];
  problems: Array<Scalars['String']['output']>;
  skipped: Scalars['Int']['output'];
  unknownValues: Array<ImportUnknownValue>;
  updated: Scalars['Int']['output'];
};

export type CommissionInstalment = {
  __typename?: 'CommissionInstalment';
  amount?: Maybe<Scalars['Float']['output']>;
  bonusEarnedOn?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['String']['output']>;
  invoiceNumber?: Maybe<Scalars['String']['output']>;
  isBonus?: Maybe<Scalars['Boolean']['output']>;
  label: Scalars['String']['output'];
  paidAmount?: Maybe<Scalars['Float']['output']>;
  percentage?: Maybe<Scalars['Float']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  triggerStage?: Maybe<Scalars['String']['output']>;
};

export type CommissionInstalmentInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  bonusEarnedOn?: InputMaybe<Scalars['String']['input']>;
  dueDate?: InputMaybe<Scalars['String']['input']>;
  invoiceNumber?: InputMaybe<Scalars['String']['input']>;
  isBonus?: InputMaybe<Scalars['Boolean']['input']>;
  label: Scalars['String']['input'];
  percentage?: InputMaybe<Scalars['Float']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  triggerStage?: InputMaybe<Scalars['String']['input']>;
};

export type CommissionOption = {
  __typename?: 'CommissionOption';
  client?: Maybe<CommissionOptionLogin>;
  clientId?: Maybe<Scalars['String']['output']>;
  clientName?: Maybe<Scalars['String']['output']>;
  color?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  displayOrder?: Maybe<Scalars['Int']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  excludeFromPipeline?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  isAppSetter?: Maybe<Scalars['Boolean']['output']>;
  isBaseline: Scalars['Boolean']['output'];
  isComplete?: Maybe<Scalars['Boolean']['output']>;
  isFinance?: Maybe<Scalars['Boolean']['output']>;
  isSettled?: Maybe<Scalars['Boolean']['output']>;
  isStrategist?: Maybe<Scalars['Boolean']['output']>;
  isTeam?: Maybe<Scalars['Boolean']['output']>;
  kind: Scalars['String']['output'];
  name: Scalars['String']['output'];
  needsAction?: Maybe<Scalars['Boolean']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  triggersCommission?: Maybe<Scalars['Boolean']['output']>;
  usageCount: Scalars['Int']['output'];
  xeroContactName?: Maybe<Scalars['String']['output']>;
};

export type CommissionOptionFilters = {
  activeOnly?: InputMaybe<Scalars['Boolean']['input']>;
  kind: Scalars['String']['input'];
};

export type CommissionOptionInput = {
  clientId?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayOrder?: InputMaybe<Scalars['Int']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  excludeFromPipeline?: InputMaybe<Scalars['Boolean']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isAppSetter?: InputMaybe<Scalars['Boolean']['input']>;
  isComplete?: InputMaybe<Scalars['Boolean']['input']>;
  isFinance?: InputMaybe<Scalars['Boolean']['input']>;
  isSettled?: InputMaybe<Scalars['Boolean']['input']>;
  isStrategist?: InputMaybe<Scalars['Boolean']['input']>;
  isTeam?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  needsAction?: InputMaybe<Scalars['Boolean']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  triggersCommission?: InputMaybe<Scalars['Boolean']['input']>;
  xeroContactName?: InputMaybe<Scalars['String']['input']>;
};

export type CommissionOptionLogin = {
  __typename?: 'CommissionOptionLogin';
  canOpenModule: Scalars['Boolean']['output'];
  email?: Maybe<Scalars['String']['output']>;
  hasSignedIn: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  lastActiveAt?: Maybe<Scalars['DateTime']['output']>;
  lastSignInMethod?: Maybe<Scalars['String']['output']>;
  lastSignedInAt?: Maybe<Scalars['DateTime']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
};

export type CommissionProject = {
  __typename?: 'CommissionProject';
  appSetter?: Maybe<Scalars['String']['output']>;
  baseDue?: Maybe<Scalars['String']['output']>;
  buildDeliveryStatus?: Maybe<Scalars['String']['output']>;
  buildPrice?: Maybe<Scalars['Float']['output']>;
  buildStage?: Maybe<Scalars['String']['output']>;
  builder?: Maybe<Scalars['String']['output']>;
  clientName?: Maybe<Scalars['String']['output']>;
  closingDate?: Maybe<Scalars['String']['output']>;
  commissionsPayStatus?: Maybe<Scalars['String']['output']>;
  commissionsStageReached?: Maybe<Scalars['String']['output']>;
  commsOwed?: Maybe<Scalars['Float']['output']>;
  commsReceived?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['DateTime']['output'];
  eoiSignedDate?: Maybe<Scalars['String']['output']>;
  frameDue?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  ipValue?: Maybe<Scalars['Float']['output']>;
  landComms?: Maybe<Scalars['Float']['output']>;
  landPrice?: Maybe<Scalars['Float']['output']>;
  lastContactedAt?: Maybe<Scalars['String']['output']>;
  matchStatus?: Maybe<Scalars['String']['output']>;
  matchedAmount?: Maybe<Scalars['Float']['output']>;
  matchedPaymentIds?: Maybe<Array<Scalars['String']['output']>>;
  missingFromSheet?: Maybe<Scalars['Boolean']['output']>;
  mortCommsExpected?: Maybe<Scalars['Float']['output']>;
  mortCommsResidual?: Maybe<Scalars['Float']['output']>;
  mortgageStage?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  parseProblems?: Maybe<Array<Scalars['String']['output']>>;
  practicalCompletionDue?: Maybe<Scalars['String']['output']>;
  propSalesCommsExpected?: Maybe<Scalars['Float']['output']>;
  propertyAddress?: Maybe<Scalars['String']['output']>;
  reviewNotes?: Maybe<Scalars['String']['output']>;
  sheetRowNumber?: Maybe<Scalars['Int']['output']>;
  sourceRowKey: Scalars['String']['output'];
  status?: Maybe<Scalars['String']['output']>;
  strategist?: Maybe<Scalars['String']['output']>;
  syncedAt?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type CommissionProjectFilters = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type CommissionSplit = {
  __typename?: 'CommissionSplit';
  notes?: Maybe<Scalars['String']['output']>;
  paymentType: Scalars['String']['output'];
  payoutDate?: Maybe<Scalars['DateTime']['output']>;
  payoutDelayDays?: Maybe<Scalars['Int']['output']>;
  percentage: Scalars['Float']['output'];
};

export type CommissionSplitInput = {
  notes?: InputMaybe<Scalars['String']['input']>;
  paymentType: Scalars['String']['input'];
  payoutDate?: InputMaybe<Scalars['DateTime']['input']>;
  payoutDelayDays?: InputMaybe<Scalars['Int']['input']>;
  percentage: Scalars['Float']['input'];
};

export type CommissionSyncResultType = {
  __typename?: 'CommissionSyncResultType';
  added: Scalars['Int']['output'];
  error?: Maybe<Scalars['String']['output']>;
  missing: Scalars['Int']['output'];
  problems: Array<Scalars['String']['output']>;
  skipped: Scalars['Int']['output'];
  unchanged: Scalars['Int']['output'];
  updated: Scalars['Int']['output'];
};

export type CommissionTrendBucket = {
  __typename?: 'CommissionTrendBucket';
  avgDaysToPaid?: Maybe<Scalars['Float']['output']>;
  dealsWon: Scalars['Int']['output'];
  deltaDealsWon?: Maybe<Scalars['Int']['output']>;
  deltaExpectedWon?: Maybe<Scalars['Float']['output']>;
  deltaMoneyIn?: Maybe<Scalars['Float']['output']>;
  deltaOwedAtEnd?: Maybe<Scalars['Float']['output']>;
  expectedWon: Scalars['Float']['output'];
  ipValueWon: Scalars['Float']['output'];
  isPartial: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
  moneyIn: Scalars['Float']['output'];
  moneyInOffXero: Scalars['Float']['output'];
  moneyInXero: Scalars['Float']['output'];
  owedAtEnd: Scalars['Float']['output'];
  paymentCount: Scalars['Int']['output'];
  periodEnd: Scalars['String']['output'];
  periodStart: Scalars['String']['output'];
};

export type CommissionTrendCoverage = {
  __typename?: 'CommissionTrendCoverage';
  anchoredByBuildContract: Scalars['Int']['output'];
  anchoredByEoiSigned: Scalars['Int']['output'];
  anchoredByLandRegistration: Scalars['Int']['output'];
  dealsInScope: Scalars['Int']['output'];
  dealsOutsideRange: Scalars['Int']['output'];
  dealsWithoutAnchorDate: Scalars['Int']['output'];
  expectedWithoutAnchorDate: Scalars['Float']['output'];
  moneyOutsideRange: Scalars['Float']['output'];
  moneyWithoutDate: Scalars['Float']['output'];
  paymentsWithoutDate: Scalars['Int']['output'];
};

export enum CommissionTrendGranularity {
  Month = 'MONTH',
  Week = 'WEEK'
}

export type CommissionTrends = {
  __typename?: 'CommissionTrends';
  buckets: Array<CommissionTrendBucket>;
  coverage: CommissionTrendCoverage;
  granularity: CommissionTrendGranularity;
  periodsCap: Scalars['Int']['output'];
  rangeEnd: Scalars['String']['output'];
  rangeStart: Scalars['String']['output'];
};

/** Outbound communication channel */
export enum CommsChannel {
  Email = 'EMAIL',
  Sms = 'SMS'
}

export type CommsHealthSettings = {
  __typename?: 'CommsHealthSettings';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  minProbeIntervalMinutes: Scalars['Int']['output'];
  /** Email addresses the weekly status report goes to. Empty = fall back to the tenant's fromEmail. */
  reportRecipients: Array<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  /** Mailboxes tested end to end on Run test now and the weekly run. Each gets a test email that must arrive on the site owning its domain. */
  watchedAddresses: Array<Scalars['String']['output']>;
  weeklyReportEnabled: Scalars['Boolean']['output'];
};

export type CommsIsolationView = {
  __typename?: 'CommsIsolationView';
  /** The caller is a platform master admin and may link SMS apps. */
  canManageSmsApps: Scalars['Boolean']['output'];
  /** On a shared email server, this site held it first (gets unstamped history). */
  emailServerFirstHolder: Scalars['Boolean']['output'];
  /** This site's email server token is also configured on another site. */
  emailServerShared: Scalars['Boolean']['output'];
  /** This site's own SMS app links (never another site's). */
  smsApps: Array<CommsSmsAppLinkView>;
  /** This site's sender id is also configured on another site. */
  smsSenderShared: Scalars['Boolean']['output'];
};

export type CommsLogSettingsView = {
  __typename?: 'CommsLogSettingsView';
  cellcastKeyIsOverride: Scalars['Boolean']['output'];
  cellcastKeyLast4?: Maybe<Scalars['String']['output']>;
  dailySummaryEnabled: Scalars['Boolean']['output'];
  hasCellcastKey: Scalars['Boolean']['output'];
  hasPostmarkKey: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  lastDailySummaryAt?: Maybe<Scalars['DateTime']['output']>;
  lastWeeklySummaryAt?: Maybe<Scalars['DateTime']['output']>;
  postmarkKeyIsOverride: Scalars['Boolean']['output'];
  postmarkKeyLast4?: Maybe<Scalars['String']['output']>;
  senderFilter: Array<Scalars['String']['output']>;
  summaryHourBrisbane: Scalars['Int']['output'];
  summaryRecipientClientIds: Array<Scalars['String']['output']>;
  weeklySummaryEnabled: Scalars['Boolean']['output'];
};

/** Evidence that an outgoing message was sent by the viewing site */
export enum CommsMatchBasis {
  FirstSiteOnServer = 'FIRST_SITE_ON_SERVER',
  OwnEmailServer = 'OWN_EMAIL_SERVER',
  SenderId = 'SENDER_ID',
  SendRecord = 'SEND_RECORD',
  SiteStamp = 'SITE_STAMP',
  SmsApp = 'SMS_APP'
}

export type CommsSmsAppLinkView = {
  __typename?: 'CommsSmsAppLinkView';
  appName: Scalars['String']['output'];
  basis: Scalars['String']['output'];
  evidenceCount: Scalars['Int']['output'];
  lastSeenAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CommsSmsAppSiteView = {
  __typename?: 'CommsSmsAppSiteView';
  basis: Scalars['String']['output'];
  blocked: Scalars['Boolean']['output'];
  siteName: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
};

export type CommsSmsAppView = {
  __typename?: 'CommsSmsAppView';
  appName: Scalars['String']['output'];
  blockedForThisSite: Scalars['Boolean']['output'];
  lastSentAt?: Maybe<Scalars['DateTime']['output']>;
  linkedSites: Array<CommsSmsAppSiteView>;
  linkedToThisSite: Scalars['Boolean']['output'];
  senders: Array<Scalars['String']['output']>;
  smsCount: Scalars['Int']['output'];
};

export type CommsSmsAppsResult = {
  __typename?: 'CommsSmsAppsResult';
  apps: Array<CommsSmsAppView>;
  capped: Scalars['Boolean']['output'];
  days: Scalars['Int']['output'];
  smsScanned: Scalars['Int']['output'];
};

/** Comms summary email period */
export enum CommsSummaryPeriod {
  Daily = 'DAILY',
  Weekly = 'WEEKLY'
}

export type CommsSummarySendView = {
  __typename?: 'CommsSummarySendView';
  emails: Scalars['Int']['output'];
  note?: Maybe<Scalars['String']['output']>;
  recipients: Array<Scalars['String']['output']>;
  sent: Scalars['Boolean']['output'];
  sms: Scalars['Int']['output'];
  tenantId: Scalars['String']['output'];
};

export type CommunicationProfile = {
  __typename?: 'CommunicationProfile';
  communicationDifficulties?: Maybe<Scalars['String']['output']>;
  communicationNotes?: Maybe<Scalars['String']['output']>;
  hasGlasses?: Maybe<Scalars['Boolean']['output']>;
  hasHearingAid?: Maybe<Scalars['Boolean']['output']>;
  hearingAidDetails?: Maybe<Scalars['String']['output']>;
  otherLanguages?: Maybe<Array<Scalars['String']['output']>>;
  preferredCommunicationMethod?: Maybe<Scalars['String']['output']>;
  primaryLanguage?: Maybe<Scalars['String']['output']>;
  requiresInterpreter?: Maybe<Scalars['Boolean']['output']>;
  visionDetails?: Maybe<Scalars['String']['output']>;
};

export type CommunicationProfileInput = {
  communicationDifficulties?: InputMaybe<Scalars['String']['input']>;
  communicationNotes?: InputMaybe<Scalars['String']['input']>;
  hasGlasses?: InputMaybe<Scalars['Boolean']['input']>;
  hasHearingAid?: InputMaybe<Scalars['Boolean']['input']>;
  hearingAidDetails?: InputMaybe<Scalars['String']['input']>;
  otherLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
  preferredCommunicationMethod?: InputMaybe<Scalars['String']['input']>;
  primaryLanguage?: InputMaybe<Scalars['String']['input']>;
  requiresInterpreter?: InputMaybe<Scalars['Boolean']['input']>;
  visionDetails?: InputMaybe<Scalars['String']['input']>;
};

export type CommunicationTask = {
  __typename?: 'CommunicationTask';
  assignedTo?: Maybe<Array<Client>>;
  communicationId?: Maybe<Scalars['ID']['output']>;
  communicationType: CommunicationType;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  completedBy?: Maybe<Client>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<Client>;
  description?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  isArchived: Scalars['Boolean']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  order: Scalars['Float']['output'];
  priority: CommunicationTaskPriority;
  status: CommunicationTaskStatus;
  tenantId: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type CommunicationTaskInput = {
  assignedTo?: InputMaybe<Array<Scalars['ID']['input']>>;
  communicationId?: InputMaybe<Scalars['ID']['input']>;
  communicationType: CommunicationType;
  description?: InputMaybe<Scalars['String']['input']>;
  dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Float']['input']>;
  priority?: InputMaybe<CommunicationTaskPriority>;
  status?: InputMaybe<CommunicationTaskStatus>;
  title: Scalars['String']['input'];
};

/** The priority level of a communication task */
export enum CommunicationTaskPriority {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM',
  Urgent = 'URGENT'
}

/** The status of a communication task */
export enum CommunicationTaskStatus {
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS',
  Todo = 'TODO'
}

/** The type of communication this task is associated with */
export enum CommunicationType {
  InboundEmail = 'INBOUND_EMAIL',
  Meeting = 'MEETING',
  Other = 'OTHER',
  OutboundEmail = 'OUTBOUND_EMAIL',
  PhoneCall = 'PHONE_CALL',
  Sms = 'SMS'
}

export type CommunicationUpdateInput = {
  hasGlasses?: InputMaybe<Scalars['Boolean']['input']>;
  hasHearingAid?: InputMaybe<Scalars['Boolean']['input']>;
  hearingAidDetails?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  otherLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
  preferredCommunication?: InputMaybe<Scalars['String']['input']>;
  primaryLanguage?: InputMaybe<Scalars['String']['input']>;
  requiresInterpreter?: InputMaybe<Scalars['Boolean']['input']>;
  visionDetails?: InputMaybe<Scalars['String']['input']>;
};

/** What kind of file a post carries — decides how it renders */
export enum CommunityAttachmentKind {
  Document = 'DOCUMENT',
  Image = 'IMAGE',
  Video = 'VIDEO'
}

export type CommunityCallToken = {
  __typename?: 'CommunityCallToken';
  displayName: Scalars['String']['output'];
  identity: Scalars['String']['output'];
  roomName: Scalars['String']['output'];
  token: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type CommunityCampaign = {
  __typename?: 'CommunityCampaign';
  audience: CommunityCampaignAudience;
  body: Scalars['String']['output'];
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdByName?: Maybe<Scalars['String']['output']>;
  failedCount: Scalars['Int']['output'];
  fromEmail?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  message?: Maybe<Scalars['String']['output']>;
  recipientCount: Scalars['Int']['output'];
  sendAt: Scalars['DateTime']['output'];
  sentCount: Scalars['Int']['output'];
  status: CommunityCampaignStatus;
  subject: Scalars['String']['output'];
};

/** Who a Vibe Tribe campaign goes to */
export enum CommunityCampaignAudience {
  AllMembers = 'ALL_MEMBERS',
  Chosen = 'CHOSEN',
  EmailOn = 'EMAIL_ON'
}

export type CommunityCampaignAudienceInput = {
  audience: CommunityCampaignAudience;
  clientIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type CommunityCampaignAudiencePreview = {
  __typename?: 'CommunityCampaignAudiencePreview';
  emailOffCount: Scalars['Int']['output'];
  fromEmail: Scalars['String']['output'];
  fromName?: Maybe<Scalars['String']['output']>;
  noEmailCount: Scalars['Int']['output'];
  recipientCount: Scalars['Int']['output'];
};

export type CommunityCampaignDetail = {
  __typename?: 'CommunityCampaignDetail';
  audience: CommunityCampaignAudience;
  body: Scalars['String']['output'];
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdByName?: Maybe<Scalars['String']['output']>;
  failedCount: Scalars['Int']['output'];
  fromEmail?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  message?: Maybe<Scalars['String']['output']>;
  recipientCount: Scalars['Int']['output'];
  recipients: Array<CommunityCampaignRecipient>;
  sendAt: Scalars['DateTime']['output'];
  sentCount: Scalars['Int']['output'];
  status: CommunityCampaignStatus;
  subject: Scalars['String']['output'];
};

export type CommunityCampaignInput = {
  audience: CommunityCampaignAudience;
  body: Scalars['String']['input'];
  clientIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  sendAt?: InputMaybe<Scalars['DateTime']['input']>;
  subject: Scalars['String']['input'];
};

export type CommunityCampaignList = {
  __typename?: 'CommunityCampaignList';
  campaigns: Array<CommunityCampaign>;
  total: Scalars['Int']['output'];
};

export type CommunityCampaignRecipient = {
  __typename?: 'CommunityCampaignRecipient';
  clientId: Scalars['ID']['output'];
  email?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  outcome: CommunityCampaignRecipientOutcome;
  reason?: Maybe<Scalars['String']['output']>;
};

export enum CommunityCampaignRecipientOutcome {
  Failed = 'FAILED',
  Sent = 'SENT',
  Waiting = 'WAITING'
}

/** Where a campaign is, read from its broadcast event */
export enum CommunityCampaignStatus {
  Cancelled = 'CANCELLED',
  Failed = 'FAILED',
  Scheduled = 'SCHEDULED',
  Sending = 'SENDING',
  Sent = 'SENT'
}

export type CommunityCampaignTestInput = {
  body: Scalars['String']['input'];
  subject: Scalars['String']['input'];
};

export type CommunityCampaignTestResult = {
  __typename?: 'CommunityCampaignTestResult';
  sentTo: Scalars['String']['output'];
};

export type CommunityCheckInStatus = {
  __typename?: 'CommunityCheckInStatus';
  affirmations: Array<Scalars['String']['output']>;
  checkedIn: Scalars['Boolean']['output'];
};

export type CommunityConfig = {
  __typename?: 'CommunityConfig';
  createdAt: Scalars['DateTime']['output'];
  customAffirmations: Array<Scalars['String']['output']>;
  dailyEmailAutoSendEnabled: Scalars['Boolean']['output'];
  dailySendHour: Scalars['Float']['output'];
  defaultDailyReminderEnabled: Scalars['Boolean']['output'];
  defaultEmailEnabled: Scalars['Boolean']['output'];
  defaultEngagementFrequency: CommunityEngagementFrequency;
  defaultNotifyOnLapsed: Scalars['Boolean']['output'];
  defaultNotifyOnReplies: Scalars['Boolean']['output'];
  defaultSmsEnabled: Scalars['Boolean']['output'];
  displayName: Scalars['String']['output'];
  domainSubscriptionProductId?: Maybe<Scalars['String']['output']>;
  entryRewardEnabled: Scalars['Boolean']['output'];
  entryRewardValue: Scalars['Float']['output'];
  globeEnabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  lapsedNudgeAfterDays: Scalars['Float']['output'];
  lapsedNudgeBookingUrl?: Maybe<Scalars['String']['output']>;
  lapsedNudgeEnabled: Scalars['Boolean']['output'];
  lastDailyDigestSentAt?: Maybe<Scalars['DateTime']['output']>;
  lastDailyReminderSentAt?: Maybe<Scalars['DateTime']['output']>;
  lastLeaderboardEmailSentAt?: Maybe<Scalars['DateTime']['output']>;
  lastWeeklyDigestSentAt?: Maybe<Scalars['DateTime']['output']>;
  leaderboardEmailFrequency: CommunityLeaderboardEmailFrequency;
  leaderboardPrizeText?: Maybe<Scalars['String']['output']>;
  merchCtaLabel?: Maybe<Scalars['String']['output']>;
  merchCtaUrl?: Maybe<Scalars['String']['output']>;
  notificationsPaused: Scalars['Boolean']['output'];
  notifyOnEveryPost: Scalars['Boolean']['output'];
  postsEnabled: Scalars['Boolean']['output'];
  publicQrSignupEnabled: Scalars['Boolean']['output'];
  publicSlug?: Maybe<Scalars['String']['output']>;
  referralRewardEnabled: Scalars['Boolean']['output'];
  referralRewardValue: Scalars['Float']['output'];
  repliesEnabled: Scalars['Boolean']['output'];
  smsChannelAvailable: Scalars['Boolean']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  videoCallEnabled: Scalars['Boolean']['output'];
};

export type CommunityDailyEmailPreview = {
  __typename?: 'CommunityDailyEmailPreview';
  html: Scalars['String']['output'];
  recipientCount: Scalars['Float']['output'];
  subject: Scalars['String']['output'];
};

export type CommunityDailyEmailScheduleResult = {
  __typename?: 'CommunityDailyEmailScheduleResult';
  calendarEventId?: Maybe<Scalars['String']['output']>;
  recipientCount: Scalars['Float']['output'];
  scheduled: Scalars['Boolean']['output'];
};

export type CommunityDomainAccess = {
  __typename?: 'CommunityDomainAccess';
  domainName?: Maybe<Scalars['String']['output']>;
  subscribed: Scalars['Boolean']['output'];
  subscriptionProductId: Scalars['ID']['output'];
  subscriptionProductSlug: Scalars['String']['output'];
};

/** How often a community member wants to be prompted */
export enum CommunityEngagementFrequency {
  Daily = 'DAILY',
  Immediate = 'IMMEDIATE',
  Off = 'OFF',
  Weekly = 'WEEKLY'
}

export type CommunityEntry = {
  __typename?: 'CommunityEntry';
  affirmation?: Maybe<Scalars['String']['output']>;
  affirmationIsOwn?: Maybe<Scalars['Boolean']['output']>;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  forOthers: Scalars['String']['output'];
  forSelf: Scalars['String']['output'];
  goodDetail?: Maybe<Scalars['String']['output']>;
  goodForOther?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  intentionDetail?: Maybe<Scalars['String']['output']>;
  intentionSet?: Maybe<Scalars['Boolean']['output']>;
  profileBio?: Maybe<Scalars['String']['output']>;
  profileVibeName?: Maybe<Scalars['String']['output']>;
  state: CommunityEntryState;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  userId: Scalars['ID']['output'];
  visibleDate: Scalars['DateTime']['output'];
};

export type CommunityEntryReplyView = {
  __typename?: 'CommunityEntryReplyView';
  body: Scalars['String']['output'];
  canDelete: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  displayName: Scalars['String']['output'];
  entryId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  isMine: Scalars['Boolean']['output'];
  profilePhoto?: Maybe<Scalars['String']['output']>;
  userId: Scalars['ID']['output'];
};

/** Whether a community entry is something planned or already done */
export enum CommunityEntryState {
  Done = 'DONE',
  Planned = 'PLANNED'
}

export type CommunityErasureLogView = {
  __typename?: 'CommunityErasureLogView';
  clientId: Scalars['ID']['output'];
  countsJson: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type CommunityErasureSummary = {
  __typename?: 'CommunityErasureSummary';
  businessListings: Scalars['Int']['output'];
  comments: Scalars['Int']['output'];
  invites: Scalars['Int']['output'];
  leftCommunity: Scalars['Boolean']['output'];
  likes: Scalars['Int']['output'];
  notTouched: Array<Scalars['String']['output']>;
  posts: Scalars['Int']['output'];
  settings: Scalars['Int']['output'];
  tagsRemoved: Scalars['Int']['output'];
  vibeReplies: Scalars['Int']['output'];
  vibes: Scalars['Int']['output'];
  videoViews: Scalars['Int']['output'];
};

export type CommunityFeedEntry = {
  __typename?: 'CommunityFeedEntry';
  affirmation?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  displayName: Scalars['String']['output'];
  forOthers: Scalars['String']['output'];
  forSelf: Scalars['String']['output'];
  goodForOther?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  intentionSet?: Maybe<Scalars['Boolean']['output']>;
  likeCount: Scalars['Float']['output'];
  likedByMe: Scalars['Boolean']['output'];
  profilePhoto?: Maybe<Scalars['String']['output']>;
  profileVibeName?: Maybe<Scalars['String']['output']>;
  replyCount: Scalars['Float']['output'];
  state: CommunityEntryState;
  userId?: Maybe<Scalars['ID']['output']>;
};

export type CommunityForYouItem = {
  __typename?: 'CommunityForYouItem';
  actorName: Scalars['String']['output'];
  at: Scalars['DateTime']['output'];
  kind: Scalars['String']['output'];
  postId: Scalars['ID']['output'];
  snippet: Scalars['String']['output'];
};

export type CommunityGlobeCountryPoint = {
  __typename?: 'CommunityGlobeCountryPoint';
  count: Scalars['Float']['output'];
  country: Scalars['String']['output'];
};

export type CommunityInvite = {
  __typename?: 'CommunityInvite';
  accessMode: CommunityInviteAccessMode;
  accessedAt?: Maybe<Scalars['DateTime']['output']>;
  activatedAt?: Maybe<Scalars['DateTime']['output']>;
  clientId?: Maybe<Scalars['ID']['output']>;
  couponCode?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdByName?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  emailSentAt?: Maybe<Scalars['DateTime']['output']>;
  existingClientId?: Maybe<Scalars['ID']['output']>;
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  expiringSoonNotifiedAt?: Maybe<Scalars['DateTime']['output']>;
  fName?: Maybe<Scalars['String']['output']>;
  firstEntryAddedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  invitedByClientId?: Maybe<Scalars['ID']['output']>;
  lName?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  smsSentAt?: Maybe<Scalars['DateTime']['output']>;
  status: CommunityInviteStatus;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** How the invitee gets access to the community feed */
export enum CommunityInviteAccessMode {
  Coupon = 'COUPON',
  Free = 'FREE',
  Paid = 'PAID',
  RewardTokens = 'REWARD_TOKENS'
}

export type CommunityInviteClaimResult = {
  __typename?: 'CommunityInviteClaimResult';
  hadExistingAccount: Scalars['Boolean']['output'];
  message: Scalars['String']['output'];
  requiresLogin: Scalars['Boolean']['output'];
  success: Scalars['Boolean']['output'];
  token?: Maybe<Scalars['String']['output']>;
};

export type CommunityInviteGraphNode = {
  __typename?: 'CommunityInviteGraphNode';
  canViewDetail: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  detailUrl?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  inviteId: Scalars['ID']['output'];
  invitedByClientId?: Maybe<Scalars['ID']['output']>;
  invitedByDisplayName?: Maybe<Scalars['String']['output']>;
  status: CommunityInviteStatus;
};

/** Status of a community onboarding invite */
export enum CommunityInviteStatus {
  Accessed = 'ACCESSED',
  Active = 'ACTIVE',
  Expired = 'EXPIRED',
  Paid = 'PAID',
  Pending = 'PENDING'
}

export type CommunityJobEmailPreview = {
  __typename?: 'CommunityJobEmailPreview';
  enabled: Scalars['Boolean']['output'];
  html: Scalars['String']['output'];
  recipientCount: Scalars['Float']['output'];
  schedule: Scalars['String']['output'];
  subject: Scalars['String']['output'];
};

export type CommunityLeaderboard = {
  __typename?: 'CommunityLeaderboard';
  me?: Maybe<CommunityLeaderboardRow>;
  period: CommunityLeaderboardPeriod;
  prizeText?: Maybe<Scalars['String']['output']>;
  rows: Array<CommunityLeaderboardRow>;
  tokenName: Scalars['String']['output'];
  tokenNamePlural: Scalars['String']['output'];
  totalRanked: Scalars['Float']['output'];
};

/** How often the community token leaderboard is emailed to members */
export enum CommunityLeaderboardEmailFrequency {
  Fortnightly = 'FORTNIGHTLY',
  Monthly = 'MONTHLY',
  Off = 'OFF',
  Weekly = 'WEEKLY'
}

/** Window the community leaderboard counts tokens and vibes over */
export enum CommunityLeaderboardPeriod {
  AllTime = 'ALL_TIME',
  ThisMonth = 'THIS_MONTH',
  ThisWeek = 'THIS_WEEK'
}

export type CommunityLeaderboardRow = {
  __typename?: 'CommunityLeaderboardRow';
  displayName: Scalars['String']['output'];
  isMe: Scalars['Boolean']['output'];
  memberKey: Scalars['String']['output'];
  profilePhoto?: Maybe<Scalars['String']['output']>;
  rank: Scalars['Float']['output'];
  streakDays: Scalars['Float']['output'];
  tokens: Scalars['Float']['output'];
  tokensFromEntries: Scalars['Float']['output'];
  tokensFromReferrals: Scalars['Float']['output'];
  vibes: Scalars['Float']['output'];
};

export type CommunityLikeResult = {
  __typename?: 'CommunityLikeResult';
  likeCount: Scalars['Int']['output'];
  liked: Scalars['Boolean']['output'];
  targetId: Scalars['ID']['output'];
  targetType: CommunityReactionTarget;
};

export type CommunityMemberRow = {
  __typename?: 'CommunityMemberRow';
  adminOverrodeAt?: Maybe<Scalars['DateTime']['output']>;
  dailyReminderEnabled: Scalars['Boolean']['output'];
  daysSinceLastVibe?: Maybe<Scalars['Float']['output']>;
  displayName: Scalars['String']['output'];
  domainName?: Maybe<Scalars['String']['output']>;
  domainSubscriptionActive: Scalars['Boolean']['output'];
  email?: Maybe<Scalars['String']['output']>;
  emailEnabled: Scalars['Boolean']['output'];
  engagementFrequency?: Maybe<CommunityEngagementFrequency>;
  forecast: Array<CommunityNotificationForecastItem>;
  hasMobile?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  lastContactAt?: Maybe<Scalars['DateTime']['output']>;
  lastContactChannel?: Maybe<Scalars['String']['output']>;
  lastContactSummary?: Maybe<Scalars['String']['output']>;
  lastEntryAt?: Maybe<Scalars['DateTime']['output']>;
  lastLapsedNudgeAt?: Maybe<Scalars['DateTime']['output']>;
  notifyOnCompleted: Scalars['Boolean']['output'];
  notifyOnLapsed: Scalars['Boolean']['output'];
  notifyOnPlanned: Scalars['Boolean']['output'];
  notifyOnReplies: Scalars['Boolean']['output'];
  postedThisWeek: Scalars['Boolean']['output'];
  postedToday: Scalars['Boolean']['output'];
  profilePhoto?: Maybe<Scalars['String']['output']>;
  selfSetAt?: Maybe<Scalars['DateTime']['output']>;
  selfSetSnapshot?: Maybe<CommunityMemberSettingsSnapshot>;
  settingsEverSet: Scalars['Boolean']['output'];
  settingsSelfUpdated: Scalars['Boolean']['output'];
  smsEnabled: Scalars['Boolean']['output'];
  streakDays: Scalars['Float']['output'];
  tokens: Scalars['Float']['output'];
  totalVibes: Scalars['Float']['output'];
};

export type CommunityMemberSettings = {
  __typename?: 'CommunityMemberSettings';
  adminOverrodeAt?: Maybe<Scalars['DateTime']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  dailyReminderEnabled: Scalars['Boolean']['output'];
  domainName?: Maybe<Scalars['String']['output']>;
  emailEnabled: Scalars['Boolean']['output'];
  engagementFrequency: CommunityEngagementFrequency;
  id: Scalars['ID']['output'];
  lastLapsedNudgeAt?: Maybe<Scalars['DateTime']['output']>;
  lastUpdatedBySelf: Scalars['Boolean']['output'];
  notifyOnCompleted: Scalars['Boolean']['output'];
  notifyOnLapsed?: Maybe<Scalars['Boolean']['output']>;
  notifyOnPlanned: Scalars['Boolean']['output'];
  notifyOnReplies?: Maybe<Scalars['Boolean']['output']>;
  selfSetAt?: Maybe<Scalars['DateTime']['output']>;
  selfSetSnapshot?: Maybe<CommunityMemberSettingsSnapshot>;
  smsEnabled: Scalars['Boolean']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  userId: Scalars['String']['output'];
};

export type CommunityMemberSettingsSnapshot = {
  __typename?: 'CommunityMemberSettingsSnapshot';
  dailyReminderEnabled: Scalars['Boolean']['output'];
  emailEnabled: Scalars['Boolean']['output'];
  engagementFrequency: CommunityEngagementFrequency;
  notifyOnCompleted: Scalars['Boolean']['output'];
  notifyOnLapsed?: Maybe<Scalars['Boolean']['output']>;
  notifyOnPlanned: Scalars['Boolean']['output'];
  notifyOnReplies?: Maybe<Scalars['Boolean']['output']>;
  smsEnabled: Scalars['Boolean']['output'];
};

export type CommunityMemberStats = {
  __typename?: 'CommunityMemberStats';
  currentStreakDays: Scalars['Float']['output'];
  leaderboardRank?: Maybe<Scalars['Float']['output']>;
  longestStreakDays: Scalars['Float']['output'];
  memberCount: Scalars['Float']['output'];
  milestoneReached?: Maybe<Scalars['Float']['output']>;
  nextMilestone?: Maybe<Scalars['Float']['output']>;
  tokensEarned: Scalars['Float']['output'];
  tokensFromEntries: Scalars['Float']['output'];
  tokensFromReferrals: Scalars['Float']['output'];
  totalVibes: Scalars['Float']['output'];
  vibedTodayCount: Scalars['Float']['output'];
};

export type CommunityMention = {
  __typename?: 'CommunityMention';
  clientId: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  notifiedAt?: Maybe<Scalars['DateTime']['output']>;
  notifiedEmail?: Maybe<Scalars['Boolean']['output']>;
};

export type CommunityMentionInput = {
  clientId: Scalars['ID']['input'];
};

export type CommunityMentionablePerson = {
  __typename?: 'CommunityMentionablePerson';
  clientId: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  photo?: Maybe<Scalars['String']['output']>;
};

export type CommunityNotificationForecastItem = {
  __typename?: 'CommunityNotificationForecastItem';
  channels: Array<Scalars['String']['output']>;
  kind: Scalars['String']['output'];
  what: Scalars['String']['output'];
  whenLabel: Scalars['String']['output'];
};

export type CommunityNotificationLinkAuthResult = {
  __typename?: 'CommunityNotificationLinkAuthResult';
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
  token?: Maybe<Scalars['String']['output']>;
};

export type CommunityNotificationScheduleRow = {
  __typename?: 'CommunityNotificationScheduleRow';
  description: Scalars['String']['output'];
  email: Scalars['Boolean']['output'];
  field: Scalars['String']['output'];
  frequencyLabel: Scalars['String']['output'];
  kind: Scalars['String']['output'];
  label: Scalars['String']['output'];
  on: Scalars['Boolean']['output'];
  sms: Scalars['Boolean']['output'];
  tenantOff: Scalars['Boolean']['output'];
};

export type CommunityNotifyRow = {
  __typename?: 'CommunityNotifyRow';
  clientId: Scalars['ID']['output'];
  emailSent: Scalars['Boolean']['output'];
  inApp: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  problem?: Maybe<Scalars['String']['output']>;
};

export type CommunityPinnedVideoViewer = {
  __typename?: 'CommunityPinnedVideoViewer';
  clientId: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type CommunityPinnedVideoViews = {
  __typename?: 'CommunityPinnedVideoViews';
  count: Scalars['Int']['output'];
  members: Array<CommunityPinnedVideoViewer>;
  seenByMe: Scalars['Boolean']['output'];
  videoKey: Scalars['String']['output'];
};

export type CommunityPostAttachment = {
  __typename?: 'CommunityPostAttachment';
  cid: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
  fileSize?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  kind: CommunityAttachmentKind;
  mimeType: Scalars['String']['output'];
};

export type CommunityPostAttachmentInput = {
  cid: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
  fileSize?: InputMaybe<Scalars['Float']['input']>;
  mimeType: Scalars['String']['input'];
};

export type CommunityPostCommentResult = {
  __typename?: 'CommunityPostCommentResult';
  comment: CommunityPostCommentView;
  notified: Array<CommunityNotifyRow>;
};

export type CommunityPostCommentView = {
  __typename?: 'CommunityPostCommentView';
  authorId: Scalars['ID']['output'];
  authorName: Scalars['String']['output'];
  authorPhoto?: Maybe<Scalars['String']['output']>;
  body: Scalars['String']['output'];
  canDelete: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  isMine: Scalars['Boolean']['output'];
  likeCount: Scalars['Int']['output'];
  likedByMe: Scalars['Boolean']['output'];
  mentions: Array<CommunityMention>;
  postId: Scalars['ID']['output'];
};

export type CommunityPostPage = {
  __typename?: 'CommunityPostPage';
  limit: Scalars['Int']['output'];
  offset: Scalars['Int']['output'];
  rows: Array<CommunityPostView>;
  total: Scalars['Int']['output'];
};

export type CommunityPostResult = {
  __typename?: 'CommunityPostResult';
  notified: Array<CommunityNotifyRow>;
  post: CommunityPostView;
};

export type CommunityPostView = {
  __typename?: 'CommunityPostView';
  attachments: Array<CommunityPostAttachment>;
  authorId: Scalars['ID']['output'];
  authorName: Scalars['String']['output'];
  authorPhoto?: Maybe<Scalars['String']['output']>;
  body: Scalars['String']['output'];
  canDelete: Scalars['Boolean']['output'];
  commentCount: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  isMine: Scalars['Boolean']['output'];
  likeCount: Scalars['Int']['output'];
  likedByMe: Scalars['Boolean']['output'];
  mentions: Array<CommunityMention>;
};

export type CommunityPublicStats = {
  __typename?: 'CommunityPublicStats';
  displayName: Scalars['String']['output'];
  memberCount: Scalars['Float']['output'];
  publicQrSignupEnabled: Scalars['Boolean']['output'];
};

export type CommunityQrSignupInput = {
  email: Scalars['String']['input'];
  fName?: InputMaybe<Scalars['String']['input']>;
  lName?: InputMaybe<Scalars['String']['input']>;
};

/** What a like is on */
export enum CommunityReactionTarget {
  Entry = 'ENTRY',
  Post = 'POST',
  PostComment = 'POST_COMMENT'
}

export type CommunityReminderScheduleResult = {
  __typename?: 'CommunityReminderScheduleResult';
  recipientCount: Scalars['Float']['output'];
  scheduled: Scalars['Boolean']['output'];
};

export type Company = {
  __typename?: 'Company';
  abn?: Maybe<Scalars['String']['output']>;
  accountManager?: Maybe<Client>;
  acn?: Maybe<Scalars['String']['output']>;
  annualRevenue?: Maybe<Scalars['Float']['output']>;
  assetCount: Scalars['Float']['output'];
  assets?: Maybe<Array<Scalars['String']['output']>>;
  billingEmail?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  email?: Maybe<Scalars['String']['output']>;
  employeeCount: Scalars['Float']['output'];
  employeeDetails: Array<Employee>;
  employees?: Maybe<Array<Scalars['String']['output']>>;
  establishedDate?: Maybe<Scalars['DateTime']['output']>;
  fax?: Maybe<Scalars['String']['output']>;
  financialYearEnd?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  industry?: Maybe<Scalars['String']['output']>;
  isActive: Scalars['Boolean']['output'];
  /** Tenant id this company record represents on the platform (the receiving side of a recruitment hand-over). Both halves of the partner handshake must agree. */
  linkedTenantId?: Maybe<Scalars['String']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  numberOfEmployees?: Maybe<Scalars['Float']['output']>;
  passwordCount: Scalars['Float']['output'];
  passwords?: Maybe<Array<Scalars['String']['output']>>;
  phone?: Maybe<Scalars['String']['output']>;
  physicalAddress?: Maybe<CompanyAddress>;
  postalAddress?: Maybe<CompanyAddress>;
  primaryContact?: Maybe<CompanyContact>;
  /** Mailbox that receives candidate recommendations for this company (falls back to the linked tenant emailConfig.fromEmail). */
  recruitmentContactEmail?: Maybe<Scalars['String']['output']>;
  status: CompanyStatus;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  taxNumber?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  tradingName?: Maybe<Scalars['String']['output']>;
  type?: Maybe<CompanyType>;
  updatedAt: Scalars['DateTime']['output'];
  website?: Maybe<Scalars['String']['output']>;
};

export type CompanyAddress = {
  __typename?: 'CompanyAddress';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
};

export type CompanyAddressInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
};

export type CompanyContact = {
  __typename?: 'CompanyContact';
  email?: Maybe<Scalars['String']['output']>;
  mobile?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['String']['output']>;
};

export type CompanyContactInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  mobile?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['String']['input']>;
};

export type CompanyInput = {
  abn?: InputMaybe<Scalars['String']['input']>;
  accountManager?: InputMaybe<Scalars['ID']['input']>;
  acn?: InputMaybe<Scalars['String']['input']>;
  annualRevenue?: InputMaybe<Scalars['Float']['input']>;
  billingEmail?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  employees?: InputMaybe<Array<Scalars['ID']['input']>>;
  establishedDate?: InputMaybe<Scalars['DateTime']['input']>;
  fax?: InputMaybe<Scalars['String']['input']>;
  financialYearEnd?: InputMaybe<Scalars['String']['input']>;
  industry?: InputMaybe<Scalars['String']['input']>;
  linkedTenantId?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  numberOfEmployees?: InputMaybe<Scalars['Float']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  physicalAddress?: InputMaybe<CompanyAddressInput>;
  postalAddress?: InputMaybe<CompanyAddressInput>;
  primaryContact?: InputMaybe<CompanyContactInput>;
  recruitmentContactEmail?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<CompanyStatus>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  taxNumber?: InputMaybe<Scalars['String']['input']>;
  tradingName?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<CompanyType>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type CompanyKnowledge = {
  __typename?: 'CompanyKnowledge';
  allowPublicAccess: Scalars['Boolean']['output'];
  allowedClientIds?: Maybe<Array<Scalars['String']['output']>>;
  authorId?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  content: Scalars['String']['output'];
  contentType: ArticleContentType;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  embeddedImages?: Maybe<Array<EmbeddedImage>>;
  embeddedVideos?: Maybe<Array<EmbeddedVideo>>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  isPinned: Scalars['Boolean']['output'];
  isPublished: Scalars['Boolean']['output'];
  lastViewedAt?: Maybe<Scalars['DateTime']['output']>;
  metaDescription?: Maybe<Scalars['String']['output']>;
  metaKeywords?: Maybe<Array<Scalars['String']['output']>>;
  publicSlug?: Maybe<Scalars['String']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  relatedArticleIds?: Maybe<Array<Scalars['String']['output']>>;
  requiredClientTags?: Maybe<Array<Scalars['String']['output']>>;
  shareToken?: Maybe<Scalars['String']['output']>;
  shortCode?: Maybe<Scalars['String']['output']>;
  showArticlePreview?: Maybe<Scalars['Boolean']['output']>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  tenantId: Scalars['String']['output'];
  title: Scalars['String']['output'];
  unpublishedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  videoFileSize?: Maybe<Scalars['Float']['output']>;
  videoIpfsHash?: Maybe<Scalars['String']['output']>;
  videoIpfsUrl?: Maybe<Scalars['String']['output']>;
  videoMimeType?: Maybe<Scalars['String']['output']>;
  viewCount: Scalars['Float']['output'];
  visibility: ArticleVisibility;
};

export type CompanyKnowledgeInput = {
  allowPublicAccess?: InputMaybe<Scalars['Boolean']['input']>;
  allowedClientIds?: InputMaybe<Array<Scalars['String']['input']>>;
  category?: InputMaybe<Scalars['String']['input']>;
  content: Scalars['String']['input'];
  contentType?: InputMaybe<ArticleContentType>;
  embeddedImages?: InputMaybe<Array<EmbeddedImageInput>>;
  embeddedVideos?: InputMaybe<Array<EmbeddedVideoInput>>;
  isPinned?: InputMaybe<Scalars['Boolean']['input']>;
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  metaDescription?: InputMaybe<Scalars['String']['input']>;
  metaKeywords?: InputMaybe<Array<Scalars['String']['input']>>;
  publicSlug?: InputMaybe<Scalars['String']['input']>;
  relatedArticleIds?: InputMaybe<Array<Scalars['String']['input']>>;
  requiredClientTags?: InputMaybe<Array<Scalars['String']['input']>>;
  showArticlePreview?: InputMaybe<Scalars['Boolean']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  title: Scalars['String']['input'];
  videoFileSize?: InputMaybe<Scalars['Float']['input']>;
  videoIpfsHash?: InputMaybe<Scalars['String']['input']>;
  videoMimeType?: InputMaybe<Scalars['String']['input']>;
  visibility?: InputMaybe<ArticleVisibility>;
};

/** The current status of the company */
export enum CompanyStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  Pending = 'PENDING',
  Suspended = 'SUSPENDED'
}

/** The type of company or organization */
export enum CompanyType {
  Corporation = 'CORPORATION',
  Government = 'GOVERNMENT',
  NonProfit = 'NON_PROFIT',
  Other = 'OTHER',
  Partnership = 'PARTNERSHIP',
  SoleTrader = 'SOLE_TRADER',
  Trust = 'TRUST'
}

export type Competition = {
  __typename?: 'Competition';
  ageBands: Array<CompetitionAgeBand>;
  aiPolicy?: Maybe<Scalars['String']['output']>;
  announceWinnersAt?: Maybe<Scalars['DateTime']['output']>;
  briefMd?: Maybe<Scalars['String']['output']>;
  closesAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdById?: Maybe<Scalars['ID']['output']>;
  entryCount: Scalars['Int']['output'];
  followerCount: Scalars['Int']['output'];
  heroImageCid?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  maxEntriesPerPerson: Scalars['Int']['output'];
  newEntryEmails: Scalars['Boolean']['output'];
  notificationRuns: Array<CompetitionNotificationRun>;
  opensAt?: Maybe<Scalars['DateTime']['output']>;
  peoplesChoiceEntryId?: Maybe<Scalars['ID']['output']>;
  prizes: Array<CompetitionPrize>;
  rightsTermsMd?: Maybe<Scalars['String']['output']>;
  rulesMd?: Maybe<Scalars['String']['output']>;
  shortlistRequired: Scalars['Boolean']['output'];
  slug: Scalars['String']['output'];
  sponsorIds: Array<Scalars['ID']['output']>;
  status: CompetitionStatus;
  tenantId: Scalars['String']['output'];
  theme?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  visibility: CompetitionVisibility;
  voteTotal: Scalars['Int']['output'];
  votingClosesAt?: Maybe<Scalars['DateTime']['output']>;
  votingMode: CompetitionVotingMode;
  votingOpensAt?: Maybe<Scalars['DateTime']['output']>;
  winnersAnnouncedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CompetitionActivity = {
  __typename?: 'CompetitionActivity';
  actorClientId?: Maybe<Scalars['ID']['output']>;
  actorName?: Maybe<Scalars['String']['output']>;
  competitionId: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  detailJson?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  kind: CompetitionActivityKind;
  subjectId?: Maybe<Scalars['ID']['output']>;
  subjectType?: Maybe<Scalars['String']['output']>;
  summary: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** What happened on a competition */
export enum CompetitionActivityKind {
  ArtSessionChanged = 'ART_SESSION_CHANGED',
  CalendarWritten = 'CALENDAR_WRITTEN',
  CompetitionCreated = 'COMPETITION_CREATED',
  CompetitionUpdated = 'COMPETITION_UPDATED',
  EmailsSent = 'EMAILS_SENT',
  EntryAddedByAdmin = 'ENTRY_ADDED_BY_ADMIN',
  EntryStatusChanged = 'ENTRY_STATUS_CHANGED',
  EntrySubmitted = 'ENTRY_SUBMITTED',
  EntryWithdrawn = 'ENTRY_WITHDRAWN',
  FollowerEmailsSent = 'FOLLOWER_EMAILS_SENT',
  PrintsOffered = 'PRINTS_OFFERED',
  PrintOfferUpdated = 'PRINT_OFFER_UPDATED',
  PrintPayoutRecorded = 'PRINT_PAYOUT_RECORDED',
  StatusChanged = 'STATUS_CHANGED',
  WinnersAnnounced = 'WINNERS_ANNOUNCED'
}

export type CompetitionActivityPage = {
  __typename?: 'CompetitionActivityPage';
  rows: Array<CompetitionActivity>;
  total: Scalars['Int']['output'];
};

/** Under 4 · Under 8 · 8–12 · 13–17 · Adults (in that order, everywhere). Winners are judged per band. */
export enum CompetitionAgeBand {
  Adult = 'ADULT',
  Age_8_12 = 'AGE_8_12',
  Age_13_17 = 'AGE_13_17',
  Under_4 = 'UNDER_4',
  Under_8 = 'UNDER_8'
}

export type CompetitionAnnounceResult = {
  __typename?: 'CompetitionAnnounceResult';
  competition: Competition;
  notification?: Maybe<CompetitionNotificationReport>;
  peoplesChoiceEntryId?: Maybe<Scalars['ID']['output']>;
  peoplesChoiceVotes: Scalars['Int']['output'];
};

export type CompetitionCalendarOutcome = {
  __typename?: 'CompetitionCalendarOutcome';
  skippedReason?: Maybe<Scalars['String']['output']>;
  written: Scalars['Int']['output'];
};

export type CompetitionEntrantContact = {
  __typename?: 'CompetitionEntrantContact';
  clientId: Scalars['ID']['output'];
  email?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  phoneNumber?: Maybe<Scalars['String']['output']>;
};

export type CompetitionEntrantContactInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  fName: Scalars['String']['input'];
  lName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type CompetitionEntry = {
  __typename?: 'CompetitionEntry';
  addedByClientId?: Maybe<Scalars['ID']['output']>;
  addedByName?: Maybe<Scalars['String']['output']>;
  adminNote?: Maybe<Scalars['String']['output']>;
  ageBand: CompetitionAgeBand;
  competitionId: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  enteredForName: Scalars['String']['output'];
  entrant?: Maybe<CompetitionEntrantContact>;
  entrantClientId?: Maybe<Scalars['ID']['output']>;
  guardianConsent: Scalars['Boolean']['output'];
  guardianConsentAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  imageCid: Scalars['String']['output'];
  offlineContactName?: Maybe<Scalars['String']['output']>;
  peoplesChoice: Scalars['Boolean']['output'];
  placement?: Maybe<Scalars['Int']['output']>;
  printConsent: Scalars['Boolean']['output'];
  printConsentAt?: Maybe<Scalars['DateTime']['output']>;
  publicHidden: Scalars['Boolean']['output'];
  schoolId?: Maybe<Scalars['ID']['output']>;
  schoolName?: Maybe<Scalars['String']['output']>;
  sessionId?: Maybe<Scalars['ID']['output']>;
  shareSlug: Scalars['String']['output'];
  statement?: Maybe<Scalars['String']['output']>;
  status: CompetitionEntryStatus;
  tenantId: Scalars['String']['output'];
  thumbnailCid?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  voteCount: Scalars['Int']['output'];
  withdrawnAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CompetitionEntryAllowance = {
  __typename?: 'CompetitionEntryAllowance';
  competitionId: Scalars['ID']['output'];
  max: Scalars['Int']['output'];
  remaining: Scalars['Int']['output'];
  used: Scalars['Int']['output'];
};

/** Where one entry is up to. Public only once winners are announced. */
export enum CompetitionEntryStatus {
  HighlyCommended = 'HIGHLY_COMMENDED',
  NotSelected = 'NOT_SELECTED',
  Shortlisted = 'SHORTLISTED',
  Submitted = 'SUBMITTED',
  Winner = 'WINNER',
  Withdrawn = 'WITHDRAWN'
}

export type CompetitionHeartResult = {
  __typename?: 'CompetitionHeartResult';
  competitionId: Scalars['ID']['output'];
  entryId: Scalars['ID']['output'];
  hearted: Scalars['Boolean']['output'];
};

/** Which email the competition sends */
export enum CompetitionNotificationKind {
  EntryReceived = 'ENTRY_RECEIVED',
  NewEntries = 'NEW_ENTRIES',
  Shortlisted = 'SHORTLISTED',
  VotingOpen = 'VOTING_OPEN',
  WinnersAnnounced = 'WINNERS_ANNOUNCED'
}

export type CompetitionNotificationReport = {
  __typename?: 'CompetitionNotificationReport';
  failed: Scalars['Int']['output'];
  kind: CompetitionNotificationKind;
  outcomes: Array<CompetitionRecipientOutcome>;
  sent: Scalars['Int']['output'];
  skipped: Scalars['Int']['output'];
};

export type CompetitionNotificationRun = {
  __typename?: 'CompetitionNotificationRun';
  at: Scalars['DateTime']['output'];
  byName?: Maybe<Scalars['String']['output']>;
  failed: Scalars['Int']['output'];
  kind: CompetitionNotificationKind;
  sent: Scalars['Int']['output'];
  skipped: Scalars['Int']['output'];
};

export type CompetitionPrintLedger = {
  __typename?: 'CompetitionPrintLedger';
  artistShare: Scalars['Float']['output'];
  balanceOwed: Scalars['Float']['output'];
  lines: Array<CompetitionPrintLedgerLine>;
  paidOut: Scalars['Float']['output'];
  printCosts: Scalars['Float']['output'];
  profit: Scalars['Float']['output'];
  revenue: Scalars['Float']['output'];
  salesKnown: Scalars['Boolean']['output'];
  salesUnknownReason?: Maybe<Scalars['String']['output']>;
  unitsSold: Scalars['Int']['output'];
};

export type CompetitionPrintLedgerLine = {
  __typename?: 'CompetitionPrintLedgerLine';
  artistShare: Scalars['Float']['output'];
  balanceOwed: Scalars['Float']['output'];
  competitionTitle: Scalars['String']['output'];
  enteredForName: Scalars['String']['output'];
  entryTitle: Scalars['String']['output'];
  offer: CompetitionPrintOffer;
  paidOrderCount: Scalars['Int']['output'];
  paidOut: Scalars['Float']['output'];
  payouts: Array<CompetitionPrintPayout>;
  printCosts: Scalars['Float']['output'];
  productFound: Scalars['Boolean']['output'];
  profit: Scalars['Float']['output'];
  revenue: Scalars['Float']['output'];
  unitsSold: Scalars['Int']['output'];
};

export type CompetitionPrintOffer = {
  __typename?: 'CompetitionPrintOffer';
  active: Scalars['Boolean']['output'];
  artistSharePercent: Scalars['Int']['output'];
  competitionId: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdById?: Maybe<Scalars['ID']['output']>;
  entryId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  p2ProductId: Scalars['ID']['output'];
  price: Scalars['Float']['output'];
  printCost: Scalars['Float']['output'];
  size: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type CompetitionPrintOfferResult = {
  __typename?: 'CompetitionPrintOfferResult';
  offer: CompetitionPrintOffer;
  quickCheckout: Scalars['Boolean']['output'];
  shippingCopiedFrom?: Maybe<Scalars['String']['output']>;
};

export type CompetitionPrintPayout = {
  __typename?: 'CompetitionPrintPayout';
  amount: Scalars['Float']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  method?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  offerId: Scalars['ID']['output'];
  paidAt: Scalars['DateTime']['output'];
  recordedById?: Maybe<Scalars['ID']['output']>;
  recordedByName?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type CompetitionPrintsAvailability = {
  __typename?: 'CompetitionPrintsAvailability';
  available: Scalars['Boolean']['output'];
  reason?: Maybe<Scalars['String']['output']>;
};

export type CompetitionPrize = {
  __typename?: 'CompetitionPrize';
  ageBand?: Maybe<CompetitionAgeBand>;
  description: Scalars['String']['output'];
  place: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type CompetitionPrizeInput = {
  ageBand?: InputMaybe<CompetitionAgeBand>;
  description: Scalars['String']['input'];
  place: Scalars['String']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
};

export type CompetitionRecipientOutcome = {
  __typename?: 'CompetitionRecipientOutcome';
  email?: Maybe<Scalars['String']['output']>;
  entrantClientId?: Maybe<Scalars['ID']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  recipientName: Scalars['String']['output'];
  status: CompetitionSendStatus;
};

export type CompetitionSchool = {
  __typename?: 'CompetitionSchool';
  contactEmail?: Maybe<Scalars['String']['output']>;
  contactName?: Maybe<Scalars['String']['output']>;
  contactPhone?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  entryCount: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  lastContactedAt?: Maybe<Scalars['DateTime']['output']>;
  listedPublicly: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  sessionCount: Scalars['Int']['output'];
  source?: Maybe<Scalars['String']['output']>;
  status: CompetitionSchoolStatus;
  suburb?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type CompetitionSchoolInput = {
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactName?: InputMaybe<Scalars['String']['input']>;
  contactPhone?: InputMaybe<Scalars['String']['input']>;
  lastContactedAt?: InputMaybe<Scalars['DateTime']['input']>;
  listedPublicly?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<CompetitionSchoolStatus>;
  suburb?: InputMaybe<Scalars['String']['input']>;
};

/** Prospect → Contacted → Booked → Active / Declined */
export enum CompetitionSchoolStatus {
  Active = 'ACTIVE',
  Booked = 'BOOKED',
  Contacted = 'CONTACTED',
  Declined = 'DECLINED',
  Prospect = 'PROSPECT'
}

/** What happened to one email */
export enum CompetitionSendStatus {
  Failed = 'FAILED',
  Sent = 'SENT',
  Skipped = 'SKIPPED'
}

export type CompetitionSponsor = {
  __typename?: 'CompetitionSponsor';
  active: Scalars['Boolean']['output'];
  blurb?: Maybe<Scalars['String']['output']>;
  companyId?: Maybe<Scalars['ID']['output']>;
  contactEmail?: Maybe<Scalars['String']['output']>;
  contactName?: Maybe<Scalars['String']['output']>;
  contactPhone?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  lastContactedAt?: Maybe<Scalars['DateTime']['output']>;
  logoCid?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  pipelineStatus: CompetitionSponsorPipelineStatus;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type CompetitionSponsorInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  blurb?: InputMaybe<Scalars['String']['input']>;
  companyId?: InputMaybe<Scalars['ID']['input']>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactName?: InputMaybe<Scalars['String']['input']>;
  contactPhone?: InputMaybe<Scalars['String']['input']>;
  lastContactedAt?: InputMaybe<Scalars['DateTime']['input']>;
  logoCid?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  pipelineStatus?: InputMaybe<CompetitionSponsorPipelineStatus>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/** Prospect → Contacted → Agreed / Declined. Admin-only. */
export enum CompetitionSponsorPipelineStatus {
  Agreed = 'AGREED',
  Contacted = 'CONTACTED',
  Declined = 'DECLINED',
  Prospect = 'PROSPECT'
}

/** Where a competition is up to. DRAFT is never public. */
export enum CompetitionStatus {
  Archived = 'ARCHIVED',
  Closed = 'CLOSED',
  Draft = 'DRAFT',
  Open = 'OPEN',
  Shortlisting = 'SHORTLISTING',
  Voting = 'VOTING'
}

export type CompetitionStatusChangeResult = {
  __typename?: 'CompetitionStatusChangeResult';
  calendar?: Maybe<CompetitionCalendarOutcome>;
  competition: Competition;
  notification?: Maybe<CompetitionNotificationReport>;
};

export type CompetitionUnfollowResult = {
  __typename?: 'CompetitionUnfollowResult';
  competitionSlug?: Maybe<Scalars['String']['output']>;
  competitionTitle?: Maybe<Scalars['String']['output']>;
  unfollowed: Scalars['Boolean']['output'];
};

/** PUBLIC (listed) or UNLISTED (link-only — not on the list page, same privacy rules) */
export enum CompetitionVisibility {
  Public = 'PUBLIC',
  Unlisted = 'UNLISTED'
}

export type CompetitionVoteResult = {
  __typename?: 'CompetitionVoteResult';
  changed: Scalars['Boolean']['output'];
  competitionId: Scalars['ID']['output'];
  entryId: Scalars['ID']['output'];
  previousEntryId?: Maybe<Scalars['ID']['output']>;
};

/** ONE_VOTE (one vote per person) or HEARTS (one heart per artwork, as many artworks as you like) */
export enum CompetitionVotingMode {
  Hearts = 'HEARTS',
  OneVote = 'ONE_VOTE'
}

export type CompleteActionInput = {
  completionNotes?: InputMaybe<Scalars['String']['input']>;
};

export type CompleteBankingMonthJobInput = {
  id: Scalars['ID']['input'];
  landed?: InputMaybe<Scalars['Boolean']['input']>;
  linkedTransactionId?: InputMaybe<Scalars['ID']['input']>;
};

export type CompleteCarePlanReviewInput = {
  actionItems?: InputMaybe<Array<ReviewActionItemInput>>;
  actualDate?: InputMaybe<Scalars['DateTime']['input']>;
  attendees?: InputMaybe<Array<ReviewAttendeeInput>>;
  familyInput?: InputMaybe<Scalars['String']['input']>;
  goalOutcomes?: InputMaybe<Array<GoalReviewOutcomeInput>>;
  nextReviewDate?: InputMaybe<Scalars['DateTime']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  progress?: InputMaybe<Scalars['String']['input']>;
  recommendations?: InputMaybe<Scalars['String']['input']>;
  summary?: InputMaybe<Scalars['String']['input']>;
};

export type CompleteChecklistItemInput = {
  /** Pass false to UN-complete a task (clears completedAt) */
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
};

export type CompleteEmailLinkSignupInput = {
  fName?: InputMaybe<Scalars['String']['input']>;
  lName?: InputMaybe<Scalars['String']['input']>;
  phoneCode?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  proof: Scalars['String']['input'];
};

export type CompleteEmpowermentCheckInInput = {
  checkInId: Scalars['ID']['input'];
  probationNote?: InputMaybe<Scalars['String']['input']>;
};

export type CompleteInterviewInput = {
  feedback?: InputMaybe<Scalars['String']['input']>;
  /** 1–5 */
  rating?: InputMaybe<Scalars['Float']['input']>;
  /** AI or manual summary of the interview transcript */
  transcriptSummary?: InputMaybe<Scalars['String']['input']>;
};

export type CompleteMaintenanceRequestInput = {
  completionNotes?: InputMaybe<Scalars['String']['input']>;
  completionPhotos?: InputMaybe<Array<MaintenanceMediaInput>>;
};

export type CompletePreScreenInput = {
  answers?: InputMaybe<Array<KeyValueAnswerInput>>;
  notes?: InputMaybe<Scalars['String']['input']>;
  outcome: PreScreenOutcome;
  /** Rejection reason when outcome is FAIL */
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type CompleteReferralInput = {
  completionNote?: InputMaybe<Scalars['String']['input']>;
  referralId: Scalars['ID']['input'];
};

export type ComplianceCalculation = {
  __typename?: 'ComplianceCalculation';
  actualAmount: Scalars['Float']['output'];
  actualRate?: Maybe<Scalars['Float']['output']>;
  baseRate?: Maybe<Scalars['Float']['output']>;
  category: Scalars['String']['output'];
  expectedAmount: Scalars['Float']['output'];
  expectedRate?: Maybe<Scalars['Float']['output']>;
  hours?: Maybe<Scalars['Float']['output']>;
  legalReference: Scalars['String']['output'];
  penaltyRate?: Maybe<Scalars['Float']['output']>;
  status: Scalars['String']['output'];
  units?: Maybe<Scalars['Float']['output']>;
};

export type ComplianceCalculationInput = {
  actualAmount: Scalars['Float']['input'];
  actualRate?: InputMaybe<Scalars['Float']['input']>;
  baseRate?: InputMaybe<Scalars['Float']['input']>;
  category: Scalars['String']['input'];
  expectedAmount: Scalars['Float']['input'];
  expectedRate?: InputMaybe<Scalars['Float']['input']>;
  hours?: InputMaybe<Scalars['Float']['input']>;
  legalReference: Scalars['String']['input'];
  penaltyRate?: InputMaybe<Scalars['Float']['input']>;
  status: Scalars['String']['input'];
  units?: InputMaybe<Scalars['Float']['input']>;
};

export type ComplianceResults = {
  __typename?: 'ComplianceResults';
  awardConfidence: Scalars['Float']['output'];
  awardUsed: Scalars['String']['output'];
  calculations: Array<ComplianceCalculation>;
  compliancePercentage: Scalars['Float']['output'];
  totalActual: Scalars['Float']['output'];
  totalExpected: Scalars['Float']['output'];
  variance: Scalars['Float']['output'];
};

export type ComplianceResultsInput = {
  awardConfidence: Scalars['Float']['input'];
  awardUsed: Scalars['String']['input'];
  calculations: Array<ComplianceCalculationInput>;
  compliancePercentage: Scalars['Float']['input'];
  totalActual: Scalars['Float']['input'];
  totalExpected: Scalars['Float']['input'];
  variance: Scalars['Float']['input'];
};

export type ComprehensiveMedicalAssessment = {
  __typename?: 'ComprehensiveMedicalAssessment';
  /** Date of the assessment (date only, stored T00:00:00Z) */
  assessmentDate: Scalars['DateTime']['output'];
  conditions: Array<CmaConditionEntry>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  /** History from an earlier system — read-only, never current work */
  isHistoricalRecord: Scalars['Boolean']['output'];
  /** The GP asked for a medication management review */
  medicationReviewRequested?: Maybe<Scalars['Boolean']['output']>;
  medications: Array<CmaMedicationEntry>;
  previousAssessmentDate?: Maybe<Scalars['DateTime']['output']>;
  reasonForAssessment?: Maybe<Scalars['String']['output']>;
  reasonForAssessmentOther?: Maybe<Scalars['String']['output']>;
  recordedBy?: Maybe<Scalars['ID']['output']>;
  recordedByName?: Maybe<Scalars['String']['output']>;
  residentId: Scalars['ID']['output'];
  residentName?: Maybe<Scalars['String']['output']>;
  residentRoom?: Maybe<Scalars['String']['output']>;
  /** New or existing resident at the time */
  residentType?: Maybe<Scalars['String']['output']>;
  residentWing?: Maybe<Scalars['String']['output']>;
  reviews: Array<CmaReviewEntry>;
  /** How the GP service was provided */
  serviceProvided?: Maybe<Scalars['String']['output']>;
  sourceAuthor?: Maybe<Scalars['String']['output']>;
  sourceBackupDate?: Maybe<Scalars['DateTime']['output']>;
  /** Every original SarahCare column, as text */
  sourceFields: Array<SarahSourceFieldValue>;
  sourceId?: Maybe<Scalars['String']['output']>;
  sourceSystem?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type ComprehensiveMedicalAssessmentsResponse = {
  __typename?: 'ComprehensiveMedicalAssessmentsResponse';
  items: Array<ComprehensiveMedicalAssessment>;
  total: Scalars['Int']['output'];
};

export type ConferenceDetails = {
  __typename?: 'ConferenceDetails';
  dialIn?: Maybe<Scalars['String']['output']>;
  instructions?: Maybe<Scalars['String']['output']>;
  meetingId?: Maybe<Scalars['String']['output']>;
  passcode?: Maybe<Scalars['String']['output']>;
  provider?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type ConferenceDetailsInput = {
  dialIn?: InputMaybe<Scalars['String']['input']>;
  instructions?: InputMaybe<Scalars['String']['input']>;
  meetingId?: InputMaybe<Scalars['String']['input']>;
  passcode?: InputMaybe<Scalars['String']['input']>;
  provider?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type ConfirmAccountingSuggestionsInput = {
  ids: Array<Scalars['ID']['input']>;
};

export type ConfirmGeneratedTaskInput = {
  description: Scalars['String']['input'];
  priority: Scalars['String']['input'];
  subtaskTitles?: Array<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type ConfirmGeneratedTasksInput = {
  opportunityId: Scalars['String']['input'];
  tasks: Array<ConfirmGeneratedTaskInput>;
};

export type ConfirmMealPlanEntryInput = {
  date: Scalars['String']['input'];
  mealType: MealType;
  recipeId: Scalars['ID']['input'];
};

export type ConfirmProposalDraftInput = {
  agreementMarkdown: Scalars['String']['input'];
  companyName: Scalars['String']['input'];
  opportunityId: Scalars['String']['input'];
  paymentSchedule: Array<ProposalPaymentInput>;
  slug: Scalars['String']['input'];
  taskId?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  totalValue: Scalars['Float']['input'];
};

export type ConfirmSiteSpecInput = {
  accentColor?: InputMaybe<Scalars['String']['input']>;
  brandIdentifier?: InputMaybe<Scalars['String']['input']>;
  businessName?: InputMaybe<Scalars['String']['input']>;
  businessType?: InputMaybe<Scalars['String']['input']>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactName?: InputMaybe<Scalars['String']['input']>;
  contactPhone?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  enabledModules?: InputMaybe<Array<Scalars['String']['input']>>;
  industry?: InputMaybe<Scalars['String']['input']>;
  logoEmoji?: InputMaybe<Scalars['String']['input']>;
  primaryColor?: InputMaybe<Scalars['String']['input']>;
  secondaryColor?: InputMaybe<Scalars['String']['input']>;
  siteName: Scalars['String']['input'];
  tagline?: InputMaybe<Scalars['String']['input']>;
};

export type ConnectAccountingRedbarkInput = {
  apiKey: Scalars['String']['input'];
  companyId: Scalars['ID']['input'];
};

export type ConnectAccountingXeroInput = {
  code: Scalars['String']['input'];
  redirectUri: Scalars['String']['input'];
  state: Scalars['String']['input'];
};

export type ConnectRedbarkInput = {
  apiKey: Scalars['String']['input'];
};

export type ConstructionSite = {
  __typename?: 'ConstructionSite';
  address: Scalars['String']['output'];
  assignedCrew: Array<SiteCrewMember>;
  createdAt: Scalars['DateTime']['output'];
  createdById?: Maybe<Scalars['ID']['output']>;
  createdByName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  ownerClientId?: Maybe<Scalars['ID']['output']>;
  ownerName?: Maybe<Scalars['String']['output']>;
  siteNumber: Scalars['Float']['output'];
  startDate?: Maybe<Scalars['DateTime']['output']>;
  status: SiteStatus;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type ContactFormSubmission = {
  __typename?: 'ContactFormSubmission';
  acknowledgementChecked?: Maybe<Scalars['Boolean']['output']>;
  acn?: Maybe<Scalars['String']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  formType?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  industry?: Maybe<Scalars['String']['output']>;
  investorType?: Maybe<Scalars['String']['output']>;
  ipAddress?: Maybe<Scalars['String']['output']>;
  isInterestedInBecomingHealer?: Maybe<Scalars['Boolean']['output']>;
  isSeekingSupport?: Maybe<Scalars['Boolean']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  numberOfEmployees?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  sessionId?: Maybe<Scalars['String']['output']>;
  sophisticatedInvestorCertificateHash?: Maybe<Scalars['String']['output']>;
  sophisticatedInvestorCertificateUrl?: Maybe<Scalars['String']['output']>;
  submissionUrl?: Maybe<Scalars['String']['output']>;
  telegram?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  userAgent?: Maybe<Scalars['String']['output']>;
  website?: Maybe<Scalars['String']['output']>;
};

export type ContactInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
};

/** Relationship of contact to the resident */
export enum ContactRelationship {
  Daughter = 'DAUGHTER',
  Friend = 'FRIEND',
  Grandchild = 'GRANDCHILD',
  Guardian = 'GUARDIAN',
  NextOfKin = 'NEXT_OF_KIN',
  NieceNephew = 'NIECE_NEPHEW',
  Other = 'OTHER',
  Parent = 'PARENT',
  PowerOfAttorney = 'POWER_OF_ATTORNEY',
  Sibling = 'SIBLING',
  Solicitor = 'SOLICITOR',
  Son = 'SON',
  Spouse = 'SPOUSE'
}

/** Content niches for influencers */
export enum ContentNiche {
  Culture = 'CULTURE',
  Economics = 'ECONOMICS',
  Education = 'EDUCATION',
  Environment = 'ENVIRONMENT',
  HealthWellness = 'HEALTH_WELLNESS',
  HumanRights = 'HUMAN_RIGHTS',
  InternationalRelations = 'INTERNATIONAL_RELATIONS',
  Other = 'OTHER',
  PeaceAdvocacy = 'PEACE_ADVOCACY',
  Philosophy = 'PHILOSOPHY',
  Politics = 'POLITICS',
  SocialJustice = 'SOCIAL_JUSTICE',
  Technology = 'TECHNOLOGY'
}

/** Type of continence aid used */
export enum ContinenceAidType {
  AllInOne = 'ALL_IN_ONE',
  BedPan = 'BED_PAN',
  CatheterCondom = 'CATHETER_CONDOM',
  CatheterIdc = 'CATHETER_IDC',
  CatheterSpc = 'CATHETER_SPC',
  Commode = 'COMMODE',
  InsertPad = 'INSERT_PAD',
  PullUp = 'PULL_UP',
  Urinal = 'URINAL'
}

export type ContinenceSourceField = {
  __typename?: 'ContinenceSourceField';
  /** SarahCare table and column, e.g. `ResBowelChartData.Amount` */
  column: Scalars['String']['output'];
  /** The original value as text */
  value?: Maybe<Scalars['String']['output']>;
};

/** Bladder continence status */
export enum ContinenceStatus {
  Dry = 'DRY',
  Partial = 'PARTIAL',
  Soiled = 'SOILED',
  Wet = 'WET'
}

/** Continence status of the resident */
export enum ContinenceType {
  Continent = 'CONTINENT',
  DoubleIncontinent = 'DOUBLE_INCONTINENT',
  IncontinentBladder = 'INCONTINENT_BLADDER',
  IncontinentBowel = 'INCONTINENT_BOWEL'
}

/** Modern Award the contract template is written against. MA000034 = Nurses Award 2020; MA000018 = Aged Care Award 2010. */
export enum ContractAwardCode {
  Ma000018 = 'MA000018',
  Ma000034 = 'MA000034'
}

/** PPT = permanent part-time; FT = full-time; CASUAL = casual */
export enum ContractEmploymentBasis {
  Casual = 'CASUAL',
  Ft = 'FT',
  Ppt = 'PPT'
}

export type ContractMergeField = {
  __typename?: 'ContractMergeField';
  /** Token name without braces, e.g. employeeFullName */
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  required: Scalars['Boolean']['output'];
};

export type ContractMergeFieldInput = {
  key: Scalars['String']['input'];
  label: Scalars['String']['input'];
  required?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContributingFactor = {
  __typename?: 'ContributingFactor';
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type ContributingFactorFilterInput = {
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type ContributingFactorTrend = {
  __typename?: 'ContributingFactorTrend';
  count: Scalars['Int']['output'];
  factorName: Scalars['String']['output'];
};

/** Which side sent a conversation's newest message: INBOUND (someone else) or OUTBOUND (the viewer) */
export enum ConversationDirection {
  Inbound = 'INBOUND',
  Outbound = 'OUTBOUND'
}

export type Coupon = {
  __typename?: 'Coupon';
  appliesToProductIds: Array<Scalars['String']['output']>;
  code: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  discountType: CouponDiscountType;
  discountValue: Scalars['Float']['output'];
  durationMonths?: Maybe<Scalars['Int']['output']>;
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  maxRedemptions?: Maybe<Scalars['Int']['output']>;
  perClientLimit: Scalars['Int']['output'];
  redemptionCount: Scalars['Int']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** How a coupon's discountValue is interpreted */
export enum CouponDiscountType {
  Fixed = 'FIXED',
  Percent = 'PERCENT'
}

export type CouponRedemption = {
  __typename?: 'CouponRedemption';
  clientId: Scalars['String']['output'];
  couponCode: Scalars['String']['output'];
  couponId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  discountApplied: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  productId?: Maybe<Scalars['String']['output']>;
  redeemedAt: Scalars['DateTime']['output'];
  subscriptionId?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** Result of validating a coupon against a product/amount */
export type CouponValidationResult = {
  __typename?: 'CouponValidationResult';
  code?: Maybe<Scalars['String']['output']>;
  couponId?: Maybe<Scalars['ID']['output']>;
  discountApplied?: Maybe<Scalars['Float']['output']>;
  discountType?: Maybe<CouponDiscountType>;
  discountValue?: Maybe<Scalars['Float']['output']>;
  durationMonths?: Maybe<Scalars['Int']['output']>;
  finalAmount?: Maybe<Scalars['Float']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  valid: Scalars['Boolean']['output'];
};

/** Staff coverage level indicator */
export enum CoverageLevel {
  Amber = 'AMBER',
  Green = 'GREEN',
  Red = 'RED'
}

export type CreateAcfiAssessmentInput = {
  assessmentDate?: InputMaybe<Scalars['DateTime']['input']>;
  domainScores: Array<AcfiDomainScoreInput>;
  estimatedDailyRate?: InputMaybe<Scalars['Float']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  residentId: Scalars['ID']['input'];
};

export type CrazytelPollResult = {
  __typename?: 'CrazytelPollResult';
  found: Scalars['Float']['output'];
  message: Scalars['String']['output'];
  ok: Scalars['Boolean']['output'];
  saved: Scalars['Float']['output'];
};

export type CrazytelSettingsInput = {
  apiBaseUrl?: InputMaybe<Scalars['String']['input']>;
  apiKey?: InputMaybe<Scalars['String']['input']>;
  clearApiKey?: InputMaybe<Scalars['Boolean']['input']>;
  clearWebhookSecret?: InputMaybe<Scalars['Boolean']['input']>;
  pollingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  webhookSecret?: InputMaybe<Scalars['String']['input']>;
};

export type CrazytelSetupStatus = {
  __typename?: 'CrazytelSetupStatus';
  apiBaseUrl?: Maybe<Scalars['String']['output']>;
  apiKeySet: Scalars['Boolean']['output'];
  lastPollMessage?: Maybe<Scalars['String']['output']>;
  lastPollOk?: Maybe<Scalars['Boolean']['output']>;
  lastPolledAt?: Maybe<Scalars['DateTime']['output']>;
  lastWebhookAt?: Maybe<Scalars['DateTime']['output']>;
  missing: Array<Scalars['String']['output']>;
  pollingEnabled: Scalars['Boolean']['output'];
  webhookSecretSet: Scalars['Boolean']['output'];
  webhookUrl: Scalars['String']['output'];
};

export type CreateAbbeyPainAssessmentInput = {
  assessmentDate?: InputMaybe<Scalars['DateTime']['input']>;
  autoProgressNote?: InputMaybe<Scalars['Boolean']['input']>;
  behaviouralChange: Scalars['Int']['input'];
  bodyLanguage: Scalars['Int']['input'];
  facialExpression: Scalars['Int']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  physical: Scalars['Int']['input'];
  physiological: Scalars['Int']['input'];
  residentId: Scalars['ID']['input'];
  vocalization: Scalars['Int']['input'];
};

export type CreateAccountabilityGoalInput = {
  aspectColor?: InputMaybe<Scalars['String']['input']>;
  aspectId: Scalars['ID']['input'];
  aspectName: Scalars['String']['input'];
  capacityIndex?: InputMaybe<CapacityIndexInput>;
  currentRating: Scalars['Int']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  importance?: InputMaybe<Scalars['Int']['input']>;
  internalExperience?: InputMaybe<Scalars['Int']['input']>;
  snapshotId?: InputMaybe<Scalars['ID']['input']>;
  targetDate?: InputMaybe<Scalars['DateTime']['input']>;
  targetRating: Scalars['Int']['input'];
  title: Scalars['String']['input'];
};

export type CreateAccountingBankAccountInput = {
  accountNumberLast4?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['ID']['input'];
  institutionName?: InputMaybe<Scalars['String']['input']>;
  ledgerAccountId?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  purpose: AccountingBankPurpose;
};

export type CreateAdmissionNotificationRuleInput = {
  channels: Array<Scalars['String']['input']>;
  filterEntryType?: InputMaybe<EntryType>;
  filterInquirySource?: InputMaybe<Scalars['String']['input']>;
  filterPriority?: InputMaybe<WaitingListPriority>;
  messageTemplate?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  recipientIds?: InputMaybe<Array<Scalars['String']['input']>>;
  recipientRole?: InputMaybe<Scalars['String']['input']>;
  recipientType: AdmissionNotificationRecipientType;
  triggers: Array<AdmissionNotificationTrigger>;
};

export type CreateAdvisoryBodyInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  memberClientIds?: InputMaybe<Array<Scalars['String']['input']>>;
  name: Scalars['String']['input'];
};

export type CreateAnalyticsNotificationRuleInput = {
  channels: Array<Scalars['String']['input']>;
  messageTemplate?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  recipientIds?: InputMaybe<Array<Scalars['String']['input']>>;
  recipientTag?: InputMaybe<Scalars['String']['input']>;
  recipientType: AnalyticsNotificationRecipientType;
  thresholdPath?: InputMaybe<Scalars['String']['input']>;
  thresholdValue?: InputMaybe<Scalars['Float']['input']>;
  timing?: InputMaybe<AnalyticsNotificationTiming>;
  timingMinutes?: InputMaybe<Scalars['Float']['input']>;
  trigger: AnalyticsNotificationTrigger;
};

export type CreateApiCategoryInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  order?: InputMaybe<Scalars['Float']['input']>;
  slug: Scalars['String']['input'];
};

export type CreateApiEndpointInput = {
  apiListingId: Scalars['String']['input'];
  codeExamples?: InputMaybe<Array<CodeExampleInput>>;
  description?: InputMaybe<Scalars['String']['input']>;
  exampleResponse?: InputMaybe<Scalars['JSON']['input']>;
  method?: InputMaybe<HttpMethod>;
  name: Scalars['String']['input'];
  parameters?: InputMaybe<Array<EndpointParamInput>>;
  path: Scalars['String']['input'];
  requestMappingBody?: InputMaybe<Scalars['JSON']['input']>;
  requestMappingHeaders?: InputMaybe<Scalars['JSON']['input']>;
  requestMappingQuery?: InputMaybe<Scalars['JSON']['input']>;
  responseMappingErrorPath?: InputMaybe<Scalars['String']['input']>;
  responseMappingSuccessPath?: InputMaybe<Scalars['String']['input']>;
  slug: Scalars['String']['input'];
};

export type CreateApiKeyInput = {
  environment?: InputMaybe<ApiKeyEnvironment>;
  name: Scalars['String']['input'];
};

export type CreateApiListingInput = {
  authHeaderName?: InputMaybe<Scalars['String']['input']>;
  authType?: InputMaybe<ApiAuthType>;
  baseUrl: Scalars['String']['input'];
  categoryId?: InputMaybe<Scalars['String']['input']>;
  defaultHeaders?: InputMaybe<Scalars['JSON']['input']>;
  description: Scalars['String']['input'];
  envFallbackKey?: InputMaybe<Scalars['String']['input']>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  providerName: Scalars['String']['input'];
  providerType?: InputMaybe<ApiProviderType>;
  providerUrl?: InputMaybe<Scalars['String']['input']>;
  shortDescription?: InputMaybe<Scalars['String']['input']>;
  slug: Scalars['String']['input'];
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  tenantApiKeyField?: InputMaybe<Scalars['String']['input']>;
};

export type CreateArtifactCommentInput = {
  anchor: ArtifactAnchorInput;
  artifactId: Scalars['ID']['input'];
  authorEmail?: InputMaybe<Scalars['String']['input']>;
  authorName?: InputMaybe<Scalars['String']['input']>;
  body: Scalars['String']['input'];
  parentId?: InputMaybe<Scalars['String']['input']>;
  shareToken?: InputMaybe<Scalars['String']['input']>;
  threadId?: InputMaybe<Scalars['String']['input']>;
  versionAtComment: Scalars['Float']['input'];
};

export type CreateArtifactInput = {
  assignedClientIds?: InputMaybe<Array<Scalars['String']['input']>>;
  body: Scalars['String']['input'];
  clientId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  emoji?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  title: Scalars['String']['input'];
  versionLabel?: InputMaybe<Scalars['String']['input']>;
  visibility?: InputMaybe<ArtifactVisibility>;
};

export type CreateAssessmentCustomFieldInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  fieldType: FieldType;
  isRequired?: InputMaybe<Scalars['Boolean']['input']>;
  label: Scalars['String']['input'];
  max?: InputMaybe<Scalars['Int']['input']>;
  min?: InputMaybe<Scalars['Int']['input']>;
  options?: InputMaybe<Array<Scalars['String']['input']>>;
  order?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateAssessmentDomainInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  order?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateAssessmentNotificationRuleInput = {
  channels: Array<Scalars['String']['input']>;
  messageTemplate?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  recipientIds?: InputMaybe<Array<Scalars['String']['input']>>;
  recipientTag?: InputMaybe<Scalars['String']['input']>;
  recipientType: AssessmentNotificationRecipientType;
  timing?: InputMaybe<AssessmentNotificationTiming>;
  timingMinutes?: InputMaybe<Scalars['Float']['input']>;
  trigger: AssessmentNotificationTrigger;
};

export type CreateAssessmentSnapshotInput = {
  customFields?: InputMaybe<Array<CustomFieldResponseInput>>;
  medicalData?: InputMaybe<AssessmentMedicalDataInput>;
  notes?: InputMaybe<Scalars['String']['input']>;
  ratings: Array<AssessmentRatingInput>;
  surgeryDate?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CreateAwardInput = {
  code: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  industry?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type CreateAwardRateInput = {
  awardClassificationId: Scalars['ID']['input'];
  baseHourlyRate: Scalars['Float']['input'];
  casualHourlyRate?: InputMaybe<Scalars['Float']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  effectiveFromDate: Scalars['DateTime']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
};

export type CreateBillNotificationRuleInput = {
  channels: Array<Scalars['String']['input']>;
  messageTemplate?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  recipientIds?: InputMaybe<Array<Scalars['String']['input']>>;
  recipientTag?: InputMaybe<Scalars['String']['input']>;
  recipientType: BillNotificationRecipientType;
  timing?: InputMaybe<BillNotificationTiming>;
  timingMinutes?: InputMaybe<Scalars['Float']['input']>;
  trigger: BillNotificationTrigger;
};

export type CreateBladderRecordInput = {
  autoProgressNote?: InputMaybe<Scalars['Boolean']['input']>;
  catheterOutputMl?: InputMaybe<Scalars['Float']['input']>;
  catheterType?: InputMaybe<CatheterType>;
  fluidIntakeMl?: InputMaybe<Scalars['Float']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  observedAt?: InputMaybe<Scalars['DateTime']['input']>;
  padChanged?: InputMaybe<Scalars['Boolean']['input']>;
  padType?: InputMaybe<PadType>;
  residentId: Scalars['ID']['input'];
  status: ContinenceStatus;
  toiletingAssisted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateBlogCategoryInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  order?: InputMaybe<Scalars['Int']['input']>;
  parentId?: InputMaybe<Scalars['ID']['input']>;
  slug: Scalars['String']['input'];
};

export type CreateBlogNotificationRuleInput = {
  channels: Array<Scalars['String']['input']>;
  messageTemplate?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  recipientIds?: InputMaybe<Array<Scalars['String']['input']>>;
  recipientType: BlogNotificationRecipientType;
  timing?: InputMaybe<BlogNotificationTiming>;
  timingMinutes?: InputMaybe<Scalars['Int']['input']>;
  trigger: BlogNotificationTrigger;
};

export type CreateBlogPostInput = {
  aiChatEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  aiChatSeedQuestions?: InputMaybe<Array<Scalars['String']['input']>>;
  audioUrl?: InputMaybe<Scalars['String']['input']>;
  author?: InputMaybe<Scalars['String']['input']>;
  authorAvatarUrl?: InputMaybe<Scalars['String']['input']>;
  authorBio?: InputMaybe<Scalars['String']['input']>;
  bonusContent?: InputMaybe<Scalars['String']['input']>;
  bonusUnlockPercent?: InputMaybe<Scalars['Int']['input']>;
  categories?: InputMaybe<Array<Scalars['String']['input']>>;
  content: Scalars['String']['input'];
  excerpt?: InputMaybe<Scalars['String']['input']>;
  featuredImage?: InputMaybe<Scalars['String']['input']>;
  leadFormId?: InputMaybe<Scalars['String']['input']>;
  leadMagnetDescription?: InputMaybe<Scalars['String']['input']>;
  leadMagnetTitle?: InputMaybe<Scalars['String']['input']>;
  metaDescription?: InputMaybe<Scalars['String']['input']>;
  metaTitle?: InputMaybe<Scalars['String']['input']>;
  ogImage?: InputMaybe<Scalars['String']['input']>;
  personalizationOptions?: InputMaybe<Array<PersonalizationOptionInput>>;
  personalizationQuestion?: InputMaybe<Scalars['String']['input']>;
  pollOptions?: InputMaybe<Array<PollOptionInput>>;
  pollQuestion?: InputMaybe<Scalars['String']['input']>;
  readTime?: InputMaybe<Scalars['Int']['input']>;
  slug: Scalars['String']['input'];
  status?: InputMaybe<BlogPostStatus>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  title: Scalars['String']['input'];
  toolCtaDescription?: InputMaybe<Scalars['String']['input']>;
  toolCtaText?: InputMaybe<Scalars['String']['input']>;
  toolCtaUrl?: InputMaybe<Scalars['String']['input']>;
  videoCid?: InputMaybe<Scalars['String']['input']>;
  videoCustomIframe?: InputMaybe<Scalars['String']['input']>;
  videoEmbedUrl?: InputMaybe<Scalars['String']['input']>;
  videoIpfsHash?: InputMaybe<Scalars['String']['input']>;
  videoProvider?: InputMaybe<BlogVideoProvider>;
  visibility?: InputMaybe<BlogPostVisibility>;
};

export type CreateBloodPressureObservationInput = {
  autoProgressNote?: InputMaybe<Scalars['Boolean']['input']>;
  diastolic: Scalars['Int']['input'];
  position?: InputMaybe<BpPosition>;
  residentId: Scalars['ID']['input'];
  systolic: Scalars['Int']['input'];
  takenAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CreateBloodSugarObservationInput = {
  autoProgressNote?: InputMaybe<Scalars['Boolean']['input']>;
  level: Scalars['Float']['input'];
  residentId: Scalars['ID']['input'];
  takenAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CreateBondInput = {
  bondAmount: Scalars['Float']['input'];
  bondFromPreviousFacility?: InputMaybe<Scalars['Float']['input']>;
  bondInterestAccount?: InputMaybe<Scalars['String']['input']>;
  bondLiabilityAccount?: InputMaybe<Scalars['String']['input']>;
  bondThreshold: Scalars['Float']['input'];
  deposit: Scalars['Float']['input'];
  depositChequeDetails?: InputMaybe<ChequeDetailsInput>;
  depositDate?: InputMaybe<Scalars['DateTime']['input']>;
  depositPaidByCheque?: InputMaybe<Scalars['Boolean']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  interestRate: Scalars['Float']['input'];
  maxRetentionLimit?: InputMaybe<Scalars['Float']['input']>;
  monthlyRetentionAmount?: InputMaybe<Scalars['Float']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  previousFacilityName?: InputMaybe<Scalars['String']['input']>;
  residentId: Scalars['ID']['input'];
  startDate: Scalars['DateTime']['input'];
};

export type CreateBowelRecordInput = {
  abnormalities?: InputMaybe<Array<Scalars['String']['input']>>;
  amount?: InputMaybe<BowelAmount>;
  autoProgressNote?: InputMaybe<Scalars['Boolean']['input']>;
  bristolType?: InputMaybe<BristolStoolType>;
  color?: InputMaybe<StoolColor>;
  laxativeGiven?: InputMaybe<Scalars['Boolean']['input']>;
  laxativeName?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  observedAt?: InputMaybe<Scalars['DateTime']['input']>;
  residentId: Scalars['ID']['input'];
  result: BowelResult;
};

export type CreateBradenAssessmentInput = {
  activity: Scalars['Int']['input'];
  assessmentDate?: InputMaybe<Scalars['DateTime']['input']>;
  autoProgressNote?: InputMaybe<Scalars['Boolean']['input']>;
  frictionShear: Scalars['Int']['input'];
  mobility: Scalars['Int']['input'];
  moisture: Scalars['Int']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  nutrition: Scalars['Int']['input'];
  residentId: Scalars['ID']['input'];
  sensoryPerception: Scalars['Int']['input'];
};

export type CreateBusinessCalendarAvailabilityInput = {
  blockedDates?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  calendarId: Scalars['String']['input'];
  extraAvailableDates?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  slots: Array<BusinessCalendarAvailabilitySlotInput>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type CreateBusinessCalendarBookableEventTypeInput = {
  allowedDaysOfWeek?: InputMaybe<Array<Scalars['Int']['input']>>;
  autoGenerateMeetingLink?: InputMaybe<Scalars['Boolean']['input']>;
  bufferAfterMinutes?: InputMaybe<Scalars['Float']['input']>;
  bufferBeforeMinutes?: InputMaybe<Scalars['Float']['input']>;
  calendarId: Scalars['String']['input'];
  color?: InputMaybe<Scalars['String']['input']>;
  confirmationMessage?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayOrder?: InputMaybe<Scalars['Float']['input']>;
  durationMinutes: Scalars['Float']['input'];
  icon?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isPaid?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  locationType?: InputMaybe<Scalars['String']['input']>;
  maxBookingsPerDay?: InputMaybe<Scalars['Float']['input']>;
  maxFutureDays?: InputMaybe<Scalars['Float']['input']>;
  meetingLink?: InputMaybe<Scalars['String']['input']>;
  minNoticeHours?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  price?: InputMaybe<Scalars['Float']['input']>;
  questions?: InputMaybe<Array<BusinessCalendarBookingQuestionInput>>;
  reminderHoursBefore?: InputMaybe<Scalars['Float']['input']>;
  stripePriceId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateCiGovernanceMeetingInput = {
  agenda?: InputMaybe<Scalars['String']['input']>;
  attendees?: InputMaybe<Array<CiMeetingAttendeeInput>>;
  documents?: InputMaybe<Array<CiDocumentAttachmentInput>>;
  duration?: InputMaybe<Scalars['Float']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  meetingType: CiMeetingType;
  qualityStandardsDiscussed?: InputMaybe<Array<CiQualityStandard>>;
  scheduledDate: Scalars['DateTime']['input'];
  scheduledTime: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type CreateCiImprovementInitiativeInput = {
  dateIdentified: Scalars['DateTime']['input'];
  documents?: InputMaybe<Array<CiDocumentAttachmentInput>>;
  issueDescription: Scalars['String']['input'];
  issueSource: CiIssueSource;
  issueSourceDetails?: InputMaybe<Scalars['String']['input']>;
  issueTitle: Scalars['String']['input'];
  linkedIssueId?: InputMaybe<Scalars['ID']['input']>;
  plannedActions?: InputMaybe<Array<CiPlannedActionInput>>;
  plannedCompletionDate?: InputMaybe<Scalars['DateTime']['input']>;
  responsiblePersons?: InputMaybe<Array<CiResponsiblePersonInput>>;
  reviewDate?: InputMaybe<Scalars['DateTime']['input']>;
  standardLinks?: InputMaybe<Array<CiStandardLinkInput>>;
};

export type CreateCiIssueReportInput = {
  category: CiIssueCategory;
  description: Scalars['String']['input'];
  documents?: InputMaybe<Array<CiDocumentAttachmentInput>>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  photos?: InputMaybe<Array<CiMediaAttachmentInitiativeInput>>;
  qualityStandards?: InputMaybe<Array<CiQualityStandard>>;
  reporterType?: InputMaybe<CiStakeholderType>;
  room?: InputMaybe<Scalars['String']['input']>;
  severity?: InputMaybe<CiIssueSeverity>;
  title: Scalars['String']['input'];
  wing?: InputMaybe<Scalars['String']['input']>;
};

export type CreateCiNotificationRuleInput = {
  channels: Array<Scalars['String']['input']>;
  filterStandard?: InputMaybe<CiQualityStandard>;
  messageTemplate?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  recipientIds?: InputMaybe<Array<Scalars['String']['input']>>;
  recipientRole?: InputMaybe<Scalars['String']['input']>;
  recipientType: CiNotificationRecipientType;
  scheduledDay?: InputMaybe<CiScheduleDay>;
  scheduledHour?: InputMaybe<Scalars['Float']['input']>;
  trigger: CiNotificationTrigger;
};

export type CreateCandidateFormInput = {
  companyId?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  earliestStartRequired?: InputMaybe<Scalars['Boolean']['input']>;
  employerBrandColor?: InputMaybe<Scalars['String']['input']>;
  employerLogoUrl?: InputMaybe<Scalars['String']['input']>;
  employerName?: InputMaybe<Scalars['String']['input']>;
  fields: Array<CandidateFormFieldInput>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  minReferences?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  positionTitle?: InputMaybe<Scalars['String']['input']>;
  preScreenQuestions?: InputMaybe<Array<PreScreenQuestionInput>>;
  roleCategory?: InputMaybe<RoleCategory>;
};

export type CreateCandidateInput = {
  addressCountry?: InputMaybe<Scalars['String']['input']>;
  addressPostcode?: InputMaybe<Scalars['String']['input']>;
  addressState?: InputMaybe<Scalars['String']['input']>;
  addressStreetName?: InputMaybe<Scalars['String']['input']>;
  addressStreetNumber?: InputMaybe<Scalars['String']['input']>;
  addressSuburb?: InputMaybe<Scalars['String']['input']>;
  /** Employer company id (companies module) — a plain string, not a Ref */
  companyId?: InputMaybe<Scalars['ID']['input']>;
  dateOfBirth?: InputMaybe<Scalars['String']['input']>;
  departmentId?: InputMaybe<Scalars['ID']['input']>;
  /** YYYY-MM-DD */
  earliestStart?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  lastName: Scalars['String']['input'];
  locationId?: InputMaybe<Scalars['ID']['input']>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  rateContext?: InputMaybe<Scalars['String']['input']>;
  referrerClientId?: InputMaybe<Scalars['ID']['input']>;
  /** IPFS CID of the resume */
  resumeCid?: InputMaybe<Scalars['String']['input']>;
  roleCategory?: InputMaybe<RoleCategory>;
  source?: InputMaybe<CandidateSource>;
  sourceNote?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  urgency?: InputMaybe<CandidateUrgency>;
};

export type CreateCandidateInviteInput = {
  candidateId: Scalars['ID']['input'];
  channels?: InputMaybe<Array<InviteChannel>>;
  customMessage?: InputMaybe<Scalars['String']['input']>;
  formId?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<CandidateInviteType>;
};

export type CreateCarePlanInput = {
  assessment?: InputMaybe<CarePlanAssessmentInput>;
  category: CarePlanCategory;
  effectiveDate?: InputMaybe<Scalars['DateTime']['input']>;
  goals?: InputMaybe<Array<CarePlanGoalInput>>;
  interventions?: InputMaybe<Array<CarePlanInterventionInput>>;
  notes?: InputMaybe<Scalars['String']['input']>;
  planName: Scalars['String']['input'];
  residentId: Scalars['ID']['input'];
  reviewFrequency?: InputMaybe<ReviewFrequency>;
  templateId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateCarePlanReviewInput = {
  attendees?: InputMaybe<Array<ReviewAttendeeInput>>;
  carePlanId: Scalars['ID']['input'];
  isFamilyMeeting?: InputMaybe<Scalars['Boolean']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  residentId: Scalars['ID']['input'];
  reviewType?: InputMaybe<Scalars['String']['input']>;
  scheduledDate: Scalars['DateTime']['input'];
};

export type CreateCarePlanTemplateInput = {
  assessmentTemplate?: InputMaybe<Scalars['String']['input']>;
  category: CarePlanCategory;
  defaultReviewFrequency?: InputMaybe<ReviewFrequency>;
  description?: InputMaybe<Scalars['String']['input']>;
  goals?: InputMaybe<Array<TemplateGoalInput>>;
  interventions?: InputMaybe<Array<TemplateInterventionInput>>;
  name: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CreateCareReviewInput = {
  actionItems?: InputMaybe<Array<CareReviewActionItemInput>>;
  attendees?: InputMaybe<Array<Scalars['String']['input']>>;
  carePlanUpdatesRequired?: InputMaybe<Scalars['Boolean']['input']>;
  changeTrigger?: InputMaybe<CareReviewChangeTrigger>;
  familyFeedback?: InputMaybe<Scalars['String']['input']>;
  familyNotified?: InputMaybe<Scalars['Boolean']['input']>;
  /** Link the review to the incident it answers (same resident) */
  incidentId?: InputMaybe<Scalars['ID']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  residentId: Scalars['ID']['input'];
  reviewDate?: InputMaybe<Scalars['DateTime']['input']>;
  reviewType: CareReviewType;
  summary?: InputMaybe<Scalars['String']['input']>;
};

export type CreateChaseNotificationRuleInput = {
  action?: InputMaybe<ChaseRuleAction>;
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  targetConfigIds?: InputMaybe<Array<Scalars['String']['input']>>;
  targetMilestoneId?: InputMaybe<Scalars['String']['input']>;
  triggerEvent: ChaseTriggerEvent;
};

export type CreateClientActivityInput = {
  activityDate?: InputMaybe<Scalars['DateTime']['input']>;
  activityType?: InputMaybe<Scalars['String']['input']>;
  details?: InputMaybe<Scalars['String']['input']>;
  mentions?: InputMaybe<Array<ClientMentionInput>>;
  title: Scalars['String']['input'];
};

export type CreateClientChaseConfigInput = {
  aiPrompt: Scalars['String']['input'];
  channel?: InputMaybe<ChaseChannel>;
  clientGoal?: InputMaybe<Scalars['String']['input']>;
  currentMilestone?: InputMaybe<Scalars['String']['input']>;
  goalActionLabel?: InputMaybe<Scalars['String']['input']>;
  goalActionUrl?: InputMaybe<Scalars['String']['input']>;
  journeyTemplateId?: InputMaybe<Scalars['String']['input']>;
  schedule?: InputMaybe<ChaseSchedule>;
  scheduleTime?: InputMaybe<Scalars['String']['input']>;
  sendMode?: InputMaybe<ChaseSendMode>;
  targetCandidateId?: InputMaybe<Scalars['String']['input']>;
  targetClientEmail?: InputMaybe<Scalars['String']['input']>;
  targetClientId?: InputMaybe<Scalars['String']['input']>;
  targetClientName?: InputMaybe<Scalars['String']['input']>;
  targetTenantId: Scalars['String']['input'];
  targetTenantName: Scalars['String']['input'];
  targetTenantUrl?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type CreateClientNotificationRuleInput = {
  channels: Array<Scalars['String']['input']>;
  messageTemplate?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  recipientIds?: InputMaybe<Array<Scalars['String']['input']>>;
  recipientTag?: InputMaybe<Scalars['String']['input']>;
  recipientType: ClientNotificationRecipientType;
  timing?: InputMaybe<ClientNotificationTiming>;
  timingMinutes?: InputMaybe<Scalars['Float']['input']>;
  trigger: ClientNotificationTrigger;
};

export type CreateClinicalTaskInput = {
  assignedTo?: InputMaybe<Scalars['ID']['input']>;
  assignedToName?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  isRecurring?: InputMaybe<Scalars['Boolean']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<ClinicalTaskPriority>;
  recurrencePattern?: InputMaybe<Scalars['String']['input']>;
  residentId?: InputMaybe<Scalars['ID']['input']>;
  taskType: ClinicalTaskType;
  title: Scalars['String']['input'];
  wing?: InputMaybe<Scalars['String']['input']>;
};

export type CreateClub52GameInput = {
  bigBlindMicro?: InputMaybe<Scalars['String']['input']>;
  discreetTitle?: InputMaybe<Scalars['String']['input']>;
  invitees?: InputMaybe<Array<Club52InviteeInput>>;
  maxBuyInMicro?: InputMaybe<Scalars['String']['input']>;
  maxPlayers?: InputMaybe<Scalars['Int']['input']>;
  minBuyInMicro?: InputMaybe<Scalars['String']['input']>;
  rakeCapMicro?: InputMaybe<Scalars['String']['input']>;
  rakeFreeThresholdMicro?: InputMaybe<Scalars['String']['input']>;
  rakePercentage?: InputMaybe<Scalars['Int']['input']>;
  scheduledEnd?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledStart: Scalars['DateTime']['input'];
  sendInvites?: InputMaybe<Scalars['Boolean']['input']>;
  smallBlindMicro?: InputMaybe<Scalars['String']['input']>;
  tableFormat?: InputMaybe<Club52TableFormat>;
  title: Scalars['String']['input'];
};

export type CreateClub52GoalInput = {
  emoji?: InputMaybe<Scalars['String']['input']>;
  targetDate?: InputMaybe<Scalars['DateTime']['input']>;
  targetGames?: InputMaybe<Scalars['Int']['input']>;
  targetRakeMicro?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export type CreateClub52TableInput = {
  replace?: InputMaybe<Scalars['Boolean']['input']>;
  roomName: Scalars['String']['input'];
};

export type CreateCoParentInviteInput = {
  caseId?: InputMaybe<Scalars['ID']['input']>;
  customMessage?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  fName?: InputMaybe<Scalars['String']['input']>;
};

export type CreateCoachAgreementInput = {
  agreementType?: InputMaybe<CoachAgreementType>;
  coachId: Scalars['ID']['input'];
  effectiveDate?: InputMaybe<Scalars['DateTime']['input']>;
  expiryDate?: InputMaybe<Scalars['DateTime']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  pProposalId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateCoachInput = {
  email: Scalars['String']['input'];
  fName: Scalars['String']['input'];
  lName: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  tier?: InputMaybe<CoachTier>;
};

export type CreateCodingRuleInput = {
  companyId: Scalars['ID']['input'];
  contains: Scalars['String']['input'];
  direction?: InputMaybe<AccountingRuleDirection>;
  ledgerAccountId: Scalars['ID']['input'];
  priority?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateCommunityEntryInput = {
  affirmation?: InputMaybe<Scalars['String']['input']>;
  affirmationIsOwn?: InputMaybe<Scalars['Boolean']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  forOthers?: InputMaybe<Scalars['String']['input']>;
  forSelf?: InputMaybe<Scalars['String']['input']>;
  goodDetail?: InputMaybe<Scalars['String']['input']>;
  goodForOther?: InputMaybe<Scalars['Boolean']['input']>;
  intentionDetail?: InputMaybe<Scalars['String']['input']>;
  intentionSet?: InputMaybe<Scalars['Boolean']['input']>;
  localDate: Scalars['String']['input'];
  profileBio?: InputMaybe<Scalars['String']['input']>;
  profileVibeName?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<CommunityEntryState>;
};

export type CreateCommunityEntryReplyInput = {
  body: Scalars['String']['input'];
  entryId: Scalars['ID']['input'];
};

export type CreateCommunityInviteInput = {
  accessMode: CommunityInviteAccessMode;
  couponCode?: InputMaybe<Scalars['String']['input']>;
  customMessage?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  existingClientId?: InputMaybe<Scalars['ID']['input']>;
  fName?: InputMaybe<Scalars['String']['input']>;
  lName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type CreateCommunityMemberInviteInput = {
  email: Scalars['String']['input'];
  fName?: InputMaybe<Scalars['String']['input']>;
};

export type CreateCommunityPostCommentInput = {
  body: Scalars['String']['input'];
  mentions?: InputMaybe<Array<CommunityMentionInput>>;
  postId: Scalars['ID']['input'];
};

export type CreateCommunityPostInput = {
  attachments?: InputMaybe<Array<CommunityPostAttachmentInput>>;
  body?: InputMaybe<Scalars['String']['input']>;
  localDate: Scalars['String']['input'];
  mentions?: InputMaybe<Array<CommunityMentionInput>>;
};

export type CreateCompetitionInput = {
  ageBands?: InputMaybe<Array<CompetitionAgeBand>>;
  aiPolicy?: InputMaybe<Scalars['String']['input']>;
  announceWinnersAt?: InputMaybe<Scalars['DateTime']['input']>;
  briefMd?: InputMaybe<Scalars['String']['input']>;
  closesAt?: InputMaybe<Scalars['DateTime']['input']>;
  heroImageCid?: InputMaybe<Scalars['String']['input']>;
  maxEntriesPerPerson?: InputMaybe<Scalars['Int']['input']>;
  newEntryEmails?: InputMaybe<Scalars['Boolean']['input']>;
  opensAt?: InputMaybe<Scalars['DateTime']['input']>;
  prizes?: InputMaybe<Array<CompetitionPrizeInput>>;
  rightsTermsMd?: InputMaybe<Scalars['String']['input']>;
  rulesMd?: InputMaybe<Scalars['String']['input']>;
  shortlistRequired?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  sponsorIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  theme?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  visibility?: InputMaybe<CompetitionVisibility>;
  votingClosesAt?: InputMaybe<Scalars['DateTime']['input']>;
  votingMode?: InputMaybe<CompetitionVotingMode>;
  votingOpensAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CreateConstructionSiteInput = {
  address: Scalars['String']['input'];
  assignedCrew?: InputMaybe<Array<SiteCrewMemberInput>>;
  name: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  ownerClientId?: InputMaybe<Scalars['ID']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CreateContributingFactorInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  order?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateCouponInput = {
  appliesToProductIds?: InputMaybe<Array<Scalars['String']['input']>>;
  code: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  discountType: CouponDiscountType;
  discountValue: Scalars['Float']['input'];
  durationMonths?: InputMaybe<Scalars['Int']['input']>;
  expiresAt?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  maxRedemptions?: InputMaybe<Scalars['Int']['input']>;
  perClientLimit?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateCustomQuestionInput = {
  helpText?: InputMaybe<Scalars['String']['input']>;
  incidentTypeId: Scalars['ID']['input'];
  isRequired?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<Array<Scalars['String']['input']>>;
  order?: InputMaybe<Scalars['Int']['input']>;
  question: Scalars['String']['input'];
  questionType: CustomQuestionType;
};

export type CreateCustomTestDefinitionInput = {
  assignedRole: Scalars['String']['input'];
  category?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  moduleId: Scalars['String']['input'];
  moduleName?: InputMaybe<Scalars['String']['input']>;
  tier: TestTier;
  userStoryAction?: InputMaybe<Scalars['String']['input']>;
  userStoryExpected?: InputMaybe<Scalars['String']['input']>;
  userStoryPage?: InputMaybe<Scalars['String']['input']>;
  userStoryRole?: InputMaybe<Scalars['String']['input']>;
};

export type CreateDailyCareProfileInput = {
  activities?: InputMaybe<ActivitiesProfileInput>;
  behavioralConsiderations?: InputMaybe<BehavioralConsiderationsInput>;
  communication?: InputMaybe<CommunicationProfileInput>;
  effectiveDate?: InputMaybe<Scalars['DateTime']['input']>;
  mobility?: InputMaybe<MobilityProfileInput>;
  notes?: InputMaybe<Scalars['String']['input']>;
  nutrition?: InputMaybe<NutritionProfileInput>;
  pain?: InputMaybe<PainProfileInput>;
  personalCare?: InputMaybe<PersonalCareInput>;
  pressureCare?: InputMaybe<PressureCareProfileInput>;
  profileType?: InputMaybe<ProfileType>;
  residentId: Scalars['ID']['input'];
  sleepPattern?: InputMaybe<SleepPatternInput>;
};

export type CreateDayBookEntryInput = {
  content: Scalars['String']['input'];
  entryDate?: InputMaybe<Scalars['DateTime']['input']>;
  entryTime?: InputMaybe<Scalars['String']['input']>;
};

export type CreateDigitalManagerMemoryInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  body: Scalars['String']['input'];
  managerId: Scalars['ID']['input'];
  priority?: InputMaybe<Scalars['Float']['input']>;
  scope?: InputMaybe<DigitalManagerMemoryScope>;
  scopeValue?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<DigitalManagerMemorySource>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  title: Scalars['String']['input'];
};

export type CreateDigitalManagerNotificationRuleInput = {
  channels: Array<Scalars['String']['input']>;
  costThresholdCents?: InputMaybe<Scalars['Int']['input']>;
  filterManagerId?: InputMaybe<Scalars['ID']['input']>;
  filterPriority?: InputMaybe<Scalars['String']['input']>;
  filterStatus?: InputMaybe<Scalars['String']['input']>;
  filterTemplate?: InputMaybe<Scalars['String']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  messageTemplate?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  recipientIds?: InputMaybe<Array<Scalars['String']['input']>>;
  recipientRole?: InputMaybe<Scalars['String']['input']>;
  recipientType: DigitalManagerNotificationRecipientType;
  timing?: InputMaybe<DigitalManagerNotificationTiming>;
  timingMinutes?: InputMaybe<Scalars['Int']['input']>;
  trigger: DigitalManagerNotificationTrigger;
};

export type CreateDigitalManagerRuleInput = {
  actions: Array<DigitalManagerRuleActionInput>;
  conditionCombinator?: InputMaybe<DigitalManagerRuleCombinator>;
  conditions: Array<DigitalManagerRuleConditionInput>;
  createdBySource?: InputMaybe<DigitalManagerRuleSource>;
  description?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  managerId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  priority?: InputMaybe<Scalars['Float']['input']>;
};

export type CreateDigitalManagerTemplateInput = {
  defaultModelOverride?: InputMaybe<Scalars['String']['input']>;
  defaultPersonaName?: InputMaybe<Scalars['String']['input']>;
  defaultProactiveChasingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  defaultResponsibilitiesMarkdown?: InputMaybe<Scalars['String']['input']>;
  defaultScheduleCron?: InputMaybe<Scalars['String']['input']>;
  defaultScopeToolIds?: InputMaybe<Array<Scalars['String']['input']>>;
  defaultStandupCron?: InputMaybe<Scalars['String']['input']>;
  defaultStandupEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  defaultTimezone?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  eventHookEntityNames?: InputMaybe<Array<Scalars['String']['input']>>;
  key: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type CreateDraftPayRunInput = {
  /** Restrict to specific employees; null = all active employees on tenant */
  employeeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  notes?: InputMaybe<Scalars['String']['input']>;
  /** Payment date (date-only) */
  paymentDate: Scalars['DateTime']['input'];
  /** Pay period end (date-only) */
  periodEnd: Scalars['DateTime']['input'];
  /** Pay period start (date-only, sent as YYYY-MM-DDT00:00:00.000Z) */
  periodStart: Scalars['DateTime']['input'];
  /** Override the auto-generated run number */
  runNumber?: InputMaybe<Scalars['String']['input']>;
};

export type CreateDressingScheduleInput = {
  dressingType: Scalars['String']['input'];
  frequencyHours: Scalars['Int']['input'];
  nextDueAt: Scalars['DateTime']['input'];
  residentId: Scalars['ID']['input'];
  specialInstructions?: InputMaybe<Scalars['String']['input']>;
  woundId: Scalars['ID']['input'];
};

export type CreateDroneSessionInput = {
  droneName?: InputMaybe<Scalars['String']['input']>;
  droneSerial: Scalars['String']['input'];
  sessionId: Scalars['String']['input'];
  stagingPath?: InputMaybe<Scalars['String']['input']>;
};

export type CreateEoiInput = {
  investmentAmount?: InputMaybe<Scalars['Float']['input']>;
  investorId: Scalars['ID']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
  projectId: Scalars['ID']['input'];
};

export type CreateEmailAddressWithAliasInput = {
  alias: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type CreateEmailAiMemoryInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  body: Scalars['String']['input'];
  priority?: InputMaybe<Scalars['Float']['input']>;
  scope?: InputMaybe<EmailAiMemoryScope>;
  scopeValue?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<EmailAiMemorySource>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  title: Scalars['String']['input'];
};

export type CreateEmailAiRuleInput = {
  actions: Array<EmailAiRuleActionInput>;
  conditionCombinator?: InputMaybe<EmailAiRuleCombinator>;
  conditions: Array<EmailAiRuleConditionInput>;
  createdBySource?: InputMaybe<EmailAiRuleSource>;
  description?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  priority?: InputMaybe<Scalars['Float']['input']>;
};

export type CreateEmployeeChecklistInput = {
  employeeId?: InputMaybe<Scalars['String']['input']>;
  fromTemplateId?: InputMaybe<Scalars['String']['input']>;
  initialItems?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Create as a reusable template. */
  isTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  title: Scalars['String']['input'];
};

export type CreateEmployeeIncidentNotificationRuleInput = {
  channels: Array<Scalars['String']['input']>;
  messageTemplate?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  recipientIds?: InputMaybe<Array<Scalars['String']['input']>>;
  recipientRole?: InputMaybe<Scalars['String']['input']>;
  recipientType: EmployeeIncidentNotificationRecipientType;
  trigger: EmployeeIncidentNotificationTrigger;
};

export type CreateEmployeeInviteInput = {
  attachmentCids?: InputMaybe<Array<EmployeeInviteAttachmentInput>>;
  /** AwardClassification for the primary role. Required when a contract template is attached. */
  awardClassificationId?: InputMaybe<Scalars['ID']['input']>;
  /** Agreed base hourly rate ($/h) for the primary role — at or above the classification floor. Required when a contract template is attached. */
  baseHourlyRate?: InputMaybe<Scalars['Float']['input']>;
  companyId: Scalars['String']['input'];
  /** Edited contract text for this invite only (markdown). Requires a contract template; may keep only {{employeeFullName}}, {{employeeGivenName}}, {{employeeAddress}}, {{employeeEmail}}. */
  contractMarkdownOverride?: InputMaybe<Scalars['String']['input']>;
  /** JSON object of {{token}} → value for the contract template. */
  contractMergeValues?: InputMaybe<Scalars['String']['input']>;
  contractTemplateId?: InputMaybe<Scalars['String']['input']>;
  departmentId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  /** PPT / FT / CASUAL — defaults from the contract template when omitted. */
  employmentBasis?: InputMaybe<ContractEmploymentBasis>;
  /** Invitee first name — the letter greets them by it ("Dear Tom,"). Blank → "Dear new team member,". */
  fName?: InputMaybe<Scalars['String']['input']>;
  /** Invitee last name. */
  lName?: InputMaybe<Scalars['String']['input']>;
  /** Minimum contracted hours per week. */
  minimumHoursPerWeek?: InputMaybe<Scalars['Float']['input']>;
  /** EmployeePosition id — optional; when set, the letter and contract name the position, else the primary role. */
  positionId?: InputMaybe<Scalars['String']['input']>;
  /** Probation period in months — default 6. */
  probationMonths?: InputMaybe<Scalars['Int']['input']>;
  recommendationId?: InputMaybe<Scalars['String']['input']>;
  /** Position/s the employee reports to. */
  reportsTo?: InputMaybe<Scalars['String']['input']>;
  /** Override the tenant-default required sign-forms for this invite. */
  requiredFormTypes?: InputMaybe<Array<EmployeeFormType>>;
  /** EmployeeRole ids in order — at least one (server-enforced). The FIRST is the primary role the pay facts describe. */
  roleIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Award + rate per invited role. Omit to let the server derive the primary row from baseHourlyRate/awardClassificationId. */
  roleRates?: InputMaybe<Array<EmployeeInviteRoleRateInput>>;
  /** Offered start date (date-only; normalised to T00:00:00.000Z). */
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CreateEmployeeNotificationRuleInput = {
  channels: Array<Scalars['String']['input']>;
  chatRecipientCooldownMinutes?: InputMaybe<Scalars['Float']['input']>;
  chatSessionGapMinutes?: InputMaybe<Scalars['Float']['input']>;
  filterDepartmentId?: InputMaybe<Scalars['String']['input']>;
  inviteLetterBody?: InputMaybe<Scalars['String']['input']>;
  inviteLetterSubject?: InputMaybe<Scalars['String']['input']>;
  messageTemplate?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  recipientDepartmentId?: InputMaybe<Scalars['String']['input']>;
  recipientIds?: InputMaybe<Array<Scalars['String']['input']>>;
  recipientRole?: InputMaybe<Scalars['String']['input']>;
  recipientType: EmployeeNotificationRecipientType;
  trigger: EmployeeNotificationTrigger;
};

/** Input for creating an employee with login credentials directly */
export type CreateEmployeeWithCredentialsInput = {
  companyId: Scalars['ID']['input'];
  departmentId?: InputMaybe<Scalars['ID']['input']>;
  email: Scalars['String']['input'];
  fName: Scalars['String']['input'];
  lName: Scalars['String']['input'];
  /** Auto-generated if not provided */
  password?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['String']['input']>;
  /** Onboarding forms this employee must digitally sign (defaults to tenant form settings when omitted). */
  requiredFormTypes?: InputMaybe<Array<EmployeeFormType>>;
  /** EmployeeRole ids in order — the FIRST is the primary role. */
  roleIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Award + rate per role. Optional — a role added without one cannot be rostered until a rate exists. */
  roleRates?: InputMaybe<Array<EmployeeInviteRoleRateInput>>;
  /** Email the login details to the employee. Default true. False creates the account and tells nobody. */
  sendCredentialsEmail?: InputMaybe<Scalars['Boolean']['input']>;
  /** Start date (date-only; normalised to UTC midnight). Defaults to today in Brisbane. */
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Auto-generated if not provided */
  username?: InputMaybe<Scalars['String']['input']>;
};

export type CreateEmpowermentExtraCheckInInput = {
  dueDate: Scalars['String']['input'];
  followUpOfCheckInId?: InputMaybe<Scalars['ID']['input']>;
  journeyId: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
};

export type CreateEmpowermentGoalInput = {
  agreedTogether?: InputMaybe<Scalars['Boolean']['input']>;
  journeyId: Scalars['ID']['input'];
  setAtCheckInId?: InputMaybe<Scalars['ID']['input']>;
  steps?: InputMaybe<Array<EmpowermentGoalStepInput>>;
  targetDate?: InputMaybe<Scalars['String']['input']>;
  themeKey?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  whyMarkdown?: InputMaybe<Scalars['String']['input']>;
};

export type CreateEmpowermentQuestionInput = {
  answerType: EmpowermentAnswerType;
  helpText?: InputMaybe<Scalars['String']['input']>;
  managerText?: InputMaybe<Scalars['String']['input']>;
  milestoneKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  order?: InputMaybe<Scalars['Int']['input']>;
  section: EmpowermentQuestionSection;
  selfText: Scalars['String']['input'];
  themeLabel: Scalars['String']['input'];
};

export type CreateEnergyTrackerNotificationRuleInput = {
  channels: Array<Scalars['String']['input']>;
  messageTemplate?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  recipientIds?: InputMaybe<Array<Scalars['String']['input']>>;
  recipientType: EnergyTrackerRecipientType;
  timing?: InputMaybe<EnergyTrackerNotificationTiming>;
  timingMinutes?: InputMaybe<Scalars['Float']['input']>;
  trigger: EnergyTrackerNotificationTrigger;
};

export type CreateFarmerInput = {
  aboutSection?: InputMaybe<FarmerAboutSectionInput>;
  allowedEditors?: InputMaybe<Array<Scalars['String']['input']>>;
  branding?: InputMaybe<FarmerBrandingInput>;
  contactInfo?: InputMaybe<FarmerContactInfoInput>;
  enableBlog?: InputMaybe<Scalars['Boolean']['input']>;
  enableCSA?: InputMaybe<Scalars['Boolean']['input']>;
  enableNewsletter?: InputMaybe<Scalars['Boolean']['input']>;
  enableRecipes?: InputMaybe<Scalars['Boolean']['input']>;
  enableReviews?: InputMaybe<Scalars['Boolean']['input']>;
  featuredProducts?: InputMaybe<Array<FarmerProductShowcaseInput>>;
  heroSection?: InputMaybe<FarmerHeroSectionInput>;
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  seoSettings?: InputMaybe<FarmerSeoSettingsInput>;
  status?: InputMaybe<FarmerStatus>;
  urlSlug?: InputMaybe<Scalars['String']['input']>;
  valuePropositions?: InputMaybe<Array<FarmerValuePropositionInput>>;
};

export type CreateFeedbackNotificationRuleInput = {
  channels: Array<FeedbackNotificationChannel>;
  filterKind?: InputMaybe<Scalars['String']['input']>;
  filterTopic?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  recipientIds?: InputMaybe<Array<Scalars['String']['input']>>;
  recipientRole?: InputMaybe<Scalars['String']['input']>;
  recipientType: FeedbackNotificationRecipientType;
  trigger: FeedbackNotificationTrigger;
};

export type CreateFileTransferInput = {
  capturedAt?: InputMaybe<Scalars['DateTime']['input']>;
  checksum?: InputMaybe<Scalars['String']['input']>;
  fileSize: Scalars['Float']['input'];
  fileType: FileTransferType;
  mimeType: Scalars['String']['input'];
  originalFilename: Scalars['String']['input'];
  originalPath: Scalars['String']['input'];
  sessionId: Scalars['String']['input'];
};

export type CreateFollowUpInput = {
  assignedTo?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  followUpType: Scalars['String']['input'];
  incidentId: Scalars['ID']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  riskAssessmentId?: InputMaybe<Scalars['ID']['input']>;
  scheduledDate: Scalars['DateTime']['input'];
};

export type CreateFrontendUpgradeInput = {
  appliedToTenants?: InputMaybe<Array<TenantUpgradeStatusInput>>;
  category: UpgradeCategory;
  description: Scalars['String']['input'];
  gitCommitUrls: Array<Scalars['String']['input']>;
  markdownDocumentation?: InputMaybe<Scalars['String']['input']>;
  originTenantId: Scalars['ID']['input'];
  originTenantName: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type CreateFuelReadingInput = {
  fuelType: FuelType;
  levelPercent?: InputMaybe<Scalars['Float']['input']>;
  pricePerLitre?: InputMaybe<Scalars['Float']['input']>;
  source?: InputMaybe<DataSource>;
  stationId: Scalars['String']['input'];
};

export type CreateGoalActionInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  goalId: Scalars['ID']['input'];
  order?: InputMaybe<Scalars['Int']['input']>;
  title: Scalars['String']['input'];
};

export type CreateGoalRewardInput = {
  aspectColor?: InputMaybe<Scalars['String']['input']>;
  aspectName?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  goalId?: InputMaybe<Scalars['ID']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  type?: InputMaybe<GoalRewardType>;
};

export type CreateGovAccountInput = {
  currency?: InputMaybe<Scalars['String']['input']>;
  identifier?: InputMaybe<Scalars['String']['input']>;
  kind?: InputMaybe<GovAccountKind>;
  label: Scalars['String']['input'];
  organisationId: Scalars['ID']['input'];
};

export type CreateGovApplicationInput = {
  abn?: InputMaybe<Scalars['String']['input']>;
  applicantEmail?: InputMaybe<Scalars['String']['input']>;
  applicantName?: InputMaybe<Scalars['String']['input']>;
  businessName?: InputMaybe<Scalars['String']['input']>;
  clientId?: InputMaybe<Scalars['ID']['input']>;
  organisationId: Scalars['ID']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  planId?: InputMaybe<Scalars['ID']['input']>;
  statement?: InputMaybe<Scalars['String']['input']>;
};

export type CreateGovChecklistInput = {
  isTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  items?: InputMaybe<Array<Scalars['String']['input']>>;
  organisationId: Scalars['ID']['input'];
  subjectId?: InputMaybe<Scalars['ID']['input']>;
  subjectType?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export type CreateGovInviteInput = {
  customMessage?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  existingClientId?: InputMaybe<Scalars['ID']['input']>;
  fName?: InputMaybe<Scalars['String']['input']>;
  lName?: InputMaybe<Scalars['String']['input']>;
  organisationId: Scalars['ID']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  sendNow?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateGovJobSpecInput = {
  doneLooksLike?: InputMaybe<Scalars['String']['input']>;
  estimatedHours?: InputMaybe<Scalars['Float']['input']>;
  evidenceRequired?: InputMaybe<Scalars['String']['input']>;
  organisationId: Scalars['ID']['input'];
  priceTokens?: InputMaybe<Scalars['Float']['input']>;
  publicListed?: InputMaybe<Scalars['Boolean']['input']>;
  sopEpisodeId?: InputMaybe<Scalars['ID']['input']>;
  steps?: InputMaybe<Scalars['String']['input']>;
  summary?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export type CreateGovMemberInput = {
  clientId: Scalars['ID']['input'];
  organisationId: Scalars['ID']['input'];
  role?: InputMaybe<GovMemberRole>;
  sponsoredByMemberId?: InputMaybe<Scalars['ID']['input']>;
  votingWeight?: InputMaybe<Scalars['Float']['input']>;
};

export type CreateGovMembershipPlanInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  gstInclusive?: InputMaybe<Scalars['Boolean']['input']>;
  interval: GovPlanInterval;
  name: Scalars['String']['input'];
  organisationId: Scalars['ID']['input'];
  priceCents: Scalars['Int']['input'];
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateGovNotificationRuleInput = {
  channels: Array<GovNotificationChannel>;
  customMessage?: InputMaybe<Scalars['String']['input']>;
  hoursBefore?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  organisationId: Scalars['ID']['input'];
  recipientEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  recipientType: GovNotificationRecipientType;
  trigger: GovNotificationTrigger;
};

export type CreateGovOrganisationInput = {
  legalWrapper?: InputMaybe<GovLegalWrapper>;
  name: Scalars['String']['input'];
  purpose?: InputMaybe<Scalars['String']['input']>;
  registrationNumber?: InputMaybe<Scalars['String']['input']>;
  rulesMarkdown?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  tokenKind?: InputMaybe<GovTokenKind>;
  tokenSymbol?: InputMaybe<Scalars['String']['input']>;
};

export type CreateGovProposalInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  amountUnit?: InputMaybe<Scalars['String']['input']>;
  attachments?: InputMaybe<Array<GovFileInput>>;
  body?: InputMaybe<Scalars['String']['input']>;
  choices?: InputMaybe<Array<GovProposalChoiceInput>>;
  citedActivityIds?: InputMaybe<Array<Scalars['String']['input']>>;
  closesAt?: InputMaybe<Scalars['DateTime']['input']>;
  organisationId: Scalars['ID']['input'];
  sopEpisodeId?: InputMaybe<Scalars['ID']['input']>;
  title: Scalars['String']['input'];
  type?: InputMaybe<GovProposalType>;
  votingSystem?: InputMaybe<GovVotingSystem>;
};

export type CreateGovWorkItemInput = {
  brief?: InputMaybe<Scalars['String']['input']>;
  decisionId?: InputMaybe<Scalars['ID']['input']>;
  dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  maxClaimants?: InputMaybe<Scalars['Int']['input']>;
  organisationId: Scalars['ID']['input'];
  rewardAmount?: InputMaybe<Scalars['Float']['input']>;
  rewardUnit?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export type CreateHarvestSourceInput = {
  checkIntervalHours?: InputMaybe<Scalars['Float']['input']>;
  contentType?: InputMaybe<ChannelContent>;
  maxHeight?: InputMaybe<Scalars['Float']['input']>;
  maxShorts?: InputMaybe<Scalars['Float']['input']>;
  maxStreams?: InputMaybe<Scalars['Float']['input']>;
  maxVideos?: InputMaybe<Scalars['Float']['input']>;
  platform?: InputMaybe<SourcePlatform>;
  sourceUrl: Scalars['String']['input'];
  watchEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateHeightObservationInput = {
  autoProgressNote?: InputMaybe<Scalars['Boolean']['input']>;
  height: Scalars['Float']['input'];
  residentId: Scalars['ID']['input'];
  takenAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CreateHolisticSnapshotInput = {
  notes?: InputMaybe<Scalars['String']['input']>;
  ratings: Array<SnapshotRatingInput>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CreateHostingAffiliateInput = {
  clientId: Scalars['ID']['input'];
  code: Scalars['String']['input'];
  defaultPercent?: InputMaybe<Scalars['Float']['input']>;
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type CreateHostingOfferInput = {
  currency?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  monthlyPrice: Scalars['Float']['input'];
  name: Scalars['String']['input'];
  slug: Scalars['String']['input'];
  subscriptionProductId?: InputMaybe<Scalars['ID']['input']>;
  subscriptionProductSlug?: InputMaybe<Scalars['String']['input']>;
};

export type CreateHostingReferralInput = {
  affiliateId: Scalars['ID']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  offerId: Scalars['ID']['input'];
  percent?: InputMaybe<Scalars['Float']['input']>;
  referredEmail?: InputMaybe<Scalars['String']['input']>;
  referredName: Scalars['String']['input'];
};

export type CreateHostingSiteInput = {
  branch?: InputMaybe<Scalars['String']['input']>;
  disabledReason?: InputMaybe<Scalars['String']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  liveUrl?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  ownerClientId?: InputMaybe<Scalars['ID']['input']>;
  repoUrl?: InputMaybe<Scalars['String']['input']>;
  vercelDeployHookUrl?: InputMaybe<Scalars['String']['input']>;
  vercelProjectId?: InputMaybe<Scalars['String']['input']>;
  vercelTeamId?: InputMaybe<Scalars['String']['input']>;
  viewerClientIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type CreateIncidentInput = {
  autoProgressNote?: InputMaybe<Scalars['Boolean']['input']>;
  comments: Scalars['String']['input'];
  contributingFactorId?: InputMaybe<Scalars['ID']['input']>;
  hasInjury?: InputMaybe<Scalars['Boolean']['input']>;
  hospitalDetails?: InputMaybe<Scalars['String']['input']>;
  incidentTypeId: Scalars['ID']['input'];
  injuryDescription?: InputMaybe<Scalars['String']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  logDate?: InputMaybe<Scalars['DateTime']['input']>;
  logTime?: InputMaybe<Scalars['String']['input']>;
  residentId: Scalars['ID']['input'];
  wasHospitalized?: InputMaybe<Scalars['Boolean']['input']>;
  wing?: InputMaybe<Scalars['String']['input']>;
};

export type CreateIncidentLocationInput = {
  name: Scalars['String']['input'];
  order?: InputMaybe<Scalars['Int']['input']>;
  wing?: InputMaybe<Scalars['String']['input']>;
};

export type CreateIncidentTypeInput = {
  category?: InputMaybe<IncidentCategory>;
  defaultContributingFactorIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  order?: InputMaybe<Scalars['Int']['input']>;
  requiresRiskAssessment?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateIncomingDeliveryTemperatureInput = {
  foodType: DeliveryFoodType;
  notes?: InputMaybe<Scalars['String']['input']>;
  photos?: Array<MealMediaInput>;
  recordedAt: Scalars['String']['input'];
  supplierId: Scalars['ID']['input'];
  temperature: Scalars['Float']['input'];
};

export type CreateInfluencerBookingInput = {
  additionalNotes?: InputMaybe<Scalars['String']['input']>;
  bookingType: BookingType;
  budgetRange?: InputMaybe<Scalars['String']['input']>;
  contactEmail: Scalars['String']['input'];
  contactName: Scalars['String']['input'];
  contactPhone?: InputMaybe<Scalars['String']['input']>;
  expectedDeliverables?: InputMaybe<Scalars['String']['input']>;
  influencerId: Scalars['String']['input'];
  organization?: InputMaybe<Scalars['String']['input']>;
  projectDescription: Scalars['String']['input'];
  projectTitle: Scalars['String']['input'];
  targetAudience?: InputMaybe<Scalars['String']['input']>;
  timeline?: InputMaybe<Scalars['String']['input']>;
  urgency?: InputMaybe<UrgencyLevel>;
};

export type CreateIngredientInput = {
  category: IngredientCategory;
  conversions?: InputMaybe<Array<IngredientConversionInput>>;
  defaultUnit?: InputMaybe<UnitType>;
  description?: InputMaybe<Scalars['String']['input']>;
  minOrderQty?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  purchaseUnitsPerRecipeUnit?: InputMaybe<Scalars['Float']['input']>;
  purchasedUnit?: InputMaybe<UnitType>;
  shelfLifeDays?: InputMaybe<Scalars['Float']['input']>;
  storageInstructions?: InputMaybe<Scalars['String']['input']>;
  supplierId?: InputMaybe<Scalars['ID']['input']>;
  supplierSku?: InputMaybe<Scalars['String']['input']>;
  unitCost?: InputMaybe<Scalars['Float']['input']>;
};

export type CreateInvestmentProjectInput = {
  businessModel?: InputMaybe<Scalars['String']['input']>;
  capitalRaised?: InputMaybe<Scalars['Float']['input']>;
  capitalRequired?: InputMaybe<Scalars['Float']['input']>;
  companyRegistration?: InputMaybe<Scalars['String']['input']>;
  coverImageUrl?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  galleryImageUrls?: InputMaybe<Array<Scalars['String']['input']>>;
  hasEmploymentContracts?: InputMaybe<Scalars['Boolean']['input']>;
  hasFullTimeEmployees?: InputMaybe<Scalars['Boolean']['input']>;
  hasPhysicalOffice?: InputMaybe<Scalars['Boolean']['input']>;
  highlights?: InputMaybe<Array<Scalars['String']['input']>>;
  investmentCommitteeRole?: InputMaybe<Scalars['Boolean']['input']>;
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  minimumInvestment?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  passiveInvestmentMinimum?: InputMaybe<Scalars['Float']['input']>;
  risks?: InputMaybe<Array<Scalars['String']['input']>>;
  sector: ProjectSector;
  shortDescription?: InputMaybe<Scalars['String']['input']>;
  stage?: InputMaybe<ProjectStage>;
  status?: InputMaybe<ProjectStatus>;
  subSector?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  targetReturn?: InputMaybe<Scalars['String']['input']>;
  visaSuitable?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateInvestorInput = {
  clientId?: InputMaybe<Scalars['String']['input']>;
  countryOfOrigin?: InputMaybe<Scalars['String']['input']>;
  currentLocation?: InputMaybe<Scalars['String']['input']>;
  cvFileUrl?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  entrepreneurialExperience?: InputMaybe<Scalars['String']['input']>;
  fullName: Scalars['String']['input'];
  fundsAvailableLocally?: InputMaybe<Scalars['Boolean']['input']>;
  fundsTransferMethod?: InputMaybe<Scalars['String']['input']>;
  intentions?: InputMaybe<Scalars['String']['input']>;
  investmentBudgetMax?: InputMaybe<Scalars['Float']['input']>;
  investmentBudgetMin?: InputMaybe<Scalars['Float']['input']>;
  investorType: InvestorType;
  phone?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<InvestorPriority>;
  professionalBackground?: InputMaybe<Scalars['String']['input']>;
  riskTolerance?: InputMaybe<RiskTolerance>;
  sectorInterests?: InputMaybe<Array<Scalars['String']['input']>>;
  sourceOfFunds?: InputMaybe<Scalars['String']['input']>;
  stage?: InputMaybe<InvestorStage>;
  visaExpiryDate?: InputMaybe<Scalars['DateTime']['input']>;
  visaStatus?: InputMaybe<VisaStatus>;
  visaSubclass?: InputMaybe<Scalars['String']['input']>;
};

export type CreateJobVehicleInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  currentOdometer?: InputMaybe<Scalars['Float']['input']>;
  engineCode?: InputMaybe<Scalars['String']['input']>;
  make: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  ownerEmail?: InputMaybe<Scalars['String']['input']>;
  ownerName?: InputMaybe<Scalars['String']['input']>;
  ownerPhone?: InputMaybe<Scalars['String']['input']>;
  photoCid?: InputMaybe<Scalars['String']['input']>;
  photoUrl?: InputMaybe<Scalars['String']['input']>;
  registration?: InputMaybe<Scalars['String']['input']>;
  transmissionType?: InputMaybe<Scalars['String']['input']>;
  variant?: InputMaybe<Scalars['String']['input']>;
  vehicleModel: Scalars['String']['input'];
  vehicleType?: InputMaybe<VehicleType>;
  vin?: InputMaybe<Scalars['String']['input']>;
  year?: InputMaybe<Scalars['String']['input']>;
};

export type CreateJourneyTemplateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  milestones: Array<JourneyMilestoneInput>;
  name: Scalars['String']['input'];
  slug: Scalars['String']['input'];
};

export type CreateLaunchedSiteInput = {
  clientId?: InputMaybe<Scalars['String']['input']>;
  domain?: InputMaybe<Scalars['String']['input']>;
  githubOwner?: InputMaybe<Scalars['String']['input']>;
  monthlyFee?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  opportunityId?: InputMaybe<Scalars['String']['input']>;
  resellerId?: InputMaybe<Scalars['String']['input']>;
  resellerName?: InputMaybe<Scalars['String']['input']>;
  setupFee?: InputMaybe<Scalars['Float']['input']>;
  vercelTeamId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateLeadFlowActionInput = {
  body: Scalars['String']['input'];
  isHtml?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  subject?: InputMaybe<Scalars['String']['input']>;
  type: LeadFlowActionType;
};

export type CreateLeadFlowFormInput = {
  displayStyle?: InputMaybe<LeadFlowFormDisplayStyle>;
  fields?: InputMaybe<Array<LeadFlowFormFieldInput>>;
  name: Scalars['String']['input'];
  notificationEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  redirectUrl?: InputMaybe<Scalars['String']['input']>;
  rewardTokensOnSubmit?: InputMaybe<Scalars['Int']['input']>;
  slug: Scalars['String']['input'];
  thankYouMessage?: InputMaybe<Scalars['String']['input']>;
};

export type CreateLeadFlowNotificationRuleInput = {
  channels: Array<Scalars['String']['input']>;
  messageTemplate?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  recipientIds?: InputMaybe<Array<Scalars['String']['input']>>;
  recipientRole?: InputMaybe<Scalars['String']['input']>;
  recipientType: LeadFlowNotificationRecipientType;
  timing?: InputMaybe<LeadFlowNotificationTiming>;
  timingMinutes?: InputMaybe<Scalars['Float']['input']>;
  trigger: LeadFlowNotificationTrigger;
};

export type CreateLeadFlowSequenceInput = {
  brandingId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  steps?: Array<LeadFlowSequenceStepInput>;
  trigger?: InputMaybe<LeadFlowSequenceTrigger>;
  triggerStageId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateLeadFlowStageInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  order?: InputMaybe<Scalars['Float']['input']>;
};

export type CreateLeaveRequestInput = {
  attachments?: InputMaybe<Array<Scalars['String']['input']>>;
  employeeId: Scalars['String']['input'];
  employeeName: Scalars['String']['input'];
  endDate: Scalars['DateTime']['input'];
  leaveType: ShiftLeaveType;
  partialDayType?: InputMaybe<PartialDayType>;
  reason?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['DateTime']['input'];
  totalDays: Scalars['Float']['input'];
};

export type CreateLedgerAccountInput = {
  code: Scalars['String']['input'];
  companyId: Scalars['ID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  isClinical?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  taxType?: InputMaybe<LedgerTaxType>;
  type: LedgerAccountType;
};

export type CreateLifeAspectInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  order?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateMaintenanceNotificationRuleInput = {
  channels: Array<Scalars['String']['input']>;
  filterCategory?: InputMaybe<Scalars['String']['input']>;
  filterLocation?: InputMaybe<Scalars['String']['input']>;
  messageTemplate?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  recipientIds?: InputMaybe<Array<Scalars['String']['input']>>;
  recipientRole?: InputMaybe<Scalars['String']['input']>;
  recipientType: MaintenanceNotificationRecipientType;
  scheduledDay?: InputMaybe<MaintenanceScheduleDay>;
  scheduledHour?: InputMaybe<Scalars['Float']['input']>;
  /** Deprecated: only IMMEDIATE is honoured. */
  timing?: InputMaybe<MaintenanceNotificationTiming>;
  timingMinutes?: InputMaybe<Scalars['Float']['input']>;
  trigger: MaintenanceNotificationTrigger;
};

export type CreateMaintenanceRequestInput = {
  category?: InputMaybe<MaintenanceCategory>;
  details: Scalars['String']['input'];
  locationId?: InputMaybe<Scalars['ID']['input']>;
  maintenanceItem?: InputMaybe<Scalars['String']['input']>;
  monthlyCheckId?: InputMaybe<Scalars['ID']['input']>;
  occupantPresent?: InputMaybe<Scalars['Boolean']['input']>;
  photos?: InputMaybe<Array<MaintenanceMediaInput>>;
  priority?: InputMaybe<MaintenancePriority>;
  requestedBy?: InputMaybe<RequestedByType>;
  room?: InputMaybe<Scalars['String']['input']>;
  wing?: InputMaybe<Scalars['String']['input']>;
};

export type CreateMealFeedbackInput = {
  comments?: InputMaybe<Scalars['String']['input']>;
  feedbackType?: InputMaybe<FeedbackType>;
  mealPlanId: Scalars['ID']['input'];
  photos?: InputMaybe<Array<MealMediaInput>>;
  rating: Scalars['Float']['input'];
  reportedBy?: InputMaybe<Scalars['String']['input']>;
};

export type CreateMealPlanInput = {
  accompaniments?: InputMaybe<Array<MealAccompanimentInput>>;
  mealDate: Scalars['String']['input'];
  mealType: MealType;
  quickDescription?: InputMaybe<Scalars['String']['input']>;
  recipeId?: InputMaybe<Scalars['ID']['input']>;
  servings: Scalars['Float']['input'];
  shiftId?: InputMaybe<Scalars['ID']['input']>;
  specialNotes?: InputMaybe<Scalars['String']['input']>;
};

export type CreateMealPlanNotificationRuleInput = {
  channels: Array<Scalars['String']['input']>;
  isEnabled?: Scalars['Boolean']['input'];
  messageTemplate?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  recipientClientIds?: Array<Scalars['String']['input']>;
  recipientRole?: InputMaybe<Scalars['String']['input']>;
  recipientType: MealPlanNotificationRecipientType;
  trigger: MealPlanNotificationTrigger;
};

export type CreateMechanicJobInput = {
  checklist?: InputMaybe<Array<AddJobChecklistItemInput>>;
  customerAddress?: InputMaybe<Scalars['String']['input']>;
  customerEmail?: InputMaybe<Scalars['String']['input']>;
  customerName?: InputMaybe<Scalars['String']['input']>;
  customerPhone?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  estimatedDuration?: InputMaybe<Scalars['Float']['input']>;
  photos?: InputMaybe<Array<JobMediaInput>>;
  priority?: InputMaybe<MechanicJobPriority>;
  scheduledDate?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledTime?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  vehicles?: InputMaybe<Array<JobVehicleRefInput>>;
  videos?: InputMaybe<Array<JobMediaInput>>;
};

export type CreateMechanicNotificationRuleInput = {
  channels: Array<MechanicNotificationChannel>;
  dailyCap?: InputMaybe<Scalars['Int']['input']>;
  messageTemplate?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  recipientClientIds?: InputMaybe<Array<Scalars['String']['input']>>;
  recipientType: MechanicNotificationRecipientType;
  trigger: MechanicNotificationTrigger;
};

export type CreateMediaFolderInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  parentId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateMediaItemInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  folderId?: InputMaybe<Scalars['String']['input']>;
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CreateMedicationInput = {
  administrationTimes?: InputMaybe<Array<Scalars['String']['input']>>;
  crushable?: InputMaybe<Scalars['Boolean']['input']>;
  dosage: Scalars['String']['input'];
  drugSchedule?: InputMaybe<DrugSchedule>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  form: MedicationForm;
  frequency: Scalars['String']['input'];
  genericName?: InputMaybe<Scalars['String']['input']>;
  highAlertMedication?: InputMaybe<Scalars['Boolean']['input']>;
  medicationName: Scalars['String']['input'];
  medicationType: MedicationType;
  prescriberId: Scalars['ID']['input'];
  prescriberName: Scalars['String']['input'];
  prescriptionDate: Scalars['DateTime']['input'];
  prescriptionNumber?: InputMaybe<Scalars['String']['input']>;
  residentId: Scalars['ID']['input'];
  route: AdministrationRoute;
  s8Controlled?: InputMaybe<Scalars['Boolean']['input']>;
  selfAdministered?: InputMaybe<Scalars['Boolean']['input']>;
  specialInstructions?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['DateTime']['input'];
  strength: Scalars['String']['input'];
};

export type CreateMeetingInput = {
  calendarEventId?: InputMaybe<Scalars['String']['input']>;
  recordingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  scheduledEnd?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledStart?: InputMaybe<Scalars['DateTime']['input']>;
  title: Scalars['String']['input'];
};

export type CreateMobilityAidsInput = {
  assistanceRequired?: InputMaybe<Scalars['Float']['input']>;
  dentureNotes?: InputMaybe<Scalars['String']['input']>;
  dentureType?: InputMaybe<Scalars['String']['input']>;
  dentures?: InputMaybe<Scalars['Boolean']['input']>;
  fireEvacAssistance?: InputMaybe<Scalars['Float']['input']>;
  fireEvacMobility?: InputMaybe<Scalars['String']['input']>;
  fireEvacSensory?: InputMaybe<Scalars['String']['input']>;
  glasses?: InputMaybe<Scalars['Boolean']['input']>;
  glassesNotes?: InputMaybe<Scalars['String']['input']>;
  glassesType?: InputMaybe<Scalars['String']['input']>;
  hearingAid?: InputMaybe<Scalars['Boolean']['input']>;
  hearingAidNotes?: InputMaybe<Scalars['String']['input']>;
  hearingAidType?: InputMaybe<Scalars['String']['input']>;
  manualHandlingNotes?: InputMaybe<Scalars['String']['input']>;
  mobilityAids?: InputMaybe<Array<Scalars['String']['input']>>;
  mobilityLevel?: InputMaybe<MedicationMobilityLevel>;
  otherAids?: InputMaybe<Array<Scalars['String']['input']>>;
  otherAidsUsed?: InputMaybe<Scalars['String']['input']>;
  pacemaker?: InputMaybe<Scalars['Boolean']['input']>;
  pacemakerInsertDate?: InputMaybe<Scalars['DateTime']['input']>;
  pacemakerNotes?: InputMaybe<Scalars['String']['input']>;
  pacemakerType?: InputMaybe<Scalars['String']['input']>;
  residentId: Scalars['ID']['input'];
  selfMedicates?: InputMaybe<Scalars['Boolean']['input']>;
  selfMedicatesNotes?: InputMaybe<Scalars['String']['input']>;
  sensoryHearing?: InputMaybe<Scalars['String']['input']>;
  sensoryVision?: InputMaybe<Scalars['String']['input']>;
};

export type CreateMobilityAssessmentInput = {
  assessmentDate?: InputMaybe<Scalars['DateTime']['input']>;
  autoProgressNote?: InputMaybe<Scalars['Boolean']['input']>;
  fallsRiskFactors?: InputMaybe<Array<Scalars['String']['input']>>;
  fallsRiskLevel?: InputMaybe<AssessmentFallsRiskLevel>;
  gaitObservation?: InputMaybe<GaitObservation>;
  mobilityLevel: AssessmentMobilityLevel;
  notes?: InputMaybe<Scalars['String']['input']>;
  residentId: Scalars['ID']['input'];
  transferNotes?: InputMaybe<Scalars['String']['input']>;
  transferType?: InputMaybe<TransferType>;
};

export type CreateMoodEntryInput = {
  emotionZone?: InputMaybe<EmotionZone>;
  energyLevel?: InputMaybe<Scalars['Int']['input']>;
  moodLabel?: InputMaybe<Scalars['String']['input']>;
  moodScore: Scalars['Int']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  selectedEmotions?: InputMaybe<Array<Scalars['String']['input']>>;
  stressLevel?: InputMaybe<Scalars['Int']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CreateMultiResidentNoteInput = {
  content: Scalars['String']['input'];
  includeInException?: InputMaybe<Scalars['Boolean']['input']>;
  noteDate?: InputMaybe<Scalars['DateTime']['input']>;
  noteTime?: InputMaybe<Scalars['String']['input']>;
  relatedCarePlanCategories?: InputMaybe<Array<ProgressNoteCategory>>;
  repeatExceptionDays?: InputMaybe<Scalars['Int']['input']>;
  residentIds: Array<Scalars['ID']['input']>;
};

export type CreateMultipleObservationsInput = {
  autoProgressNote?: InputMaybe<Scalars['Boolean']['input']>;
  bpDiastolic?: InputMaybe<Scalars['Int']['input']>;
  bpPosition?: InputMaybe<BpPosition>;
  bpSystolic?: InputMaybe<Scalars['Int']['input']>;
  bsl?: InputMaybe<Scalars['Float']['input']>;
  height?: InputMaybe<Scalars['Float']['input']>;
  o2Saturation?: InputMaybe<Scalars['Float']['input']>;
  pulse?: InputMaybe<Scalars['Int']['input']>;
  residentId: Scalars['ID']['input'];
  respirations?: InputMaybe<Scalars['Int']['input']>;
  takenAt?: InputMaybe<Scalars['DateTime']['input']>;
  temperature?: InputMaybe<Scalars['Float']['input']>;
  temperatureMethod?: InputMaybe<TemperatureMethod>;
  weight?: InputMaybe<Scalars['Float']['input']>;
};

export type CreateNeurologicalObservationInput = {
  autoProgressNote?: InputMaybe<Scalars['Boolean']['input']>;
  bpDiastolic?: InputMaybe<Scalars['Int']['input']>;
  bpPosition?: InputMaybe<BpPosition>;
  bpSystolic?: InputMaybe<Scalars['Int']['input']>;
  bsl?: InputMaybe<Scalars['Float']['input']>;
  locGlasgowEye?: InputMaybe<Scalars['Int']['input']>;
  locGlasgowMotor?: InputMaybe<Scalars['Int']['input']>;
  locGlasgowVerbal?: InputMaybe<Scalars['Int']['input']>;
  locLevel?: InputMaybe<Scalars['String']['input']>;
  locMethod?: InputMaybe<LocMethod>;
  periodId: Scalars['ID']['input'];
  pulse?: InputMaybe<Scalars['Int']['input']>;
  pupillaryAssessment?: InputMaybe<PupillaryAssessmentInput>;
  respirations?: InputMaybe<Scalars['Int']['input']>;
  takenAt?: InputMaybe<Scalars['DateTime']['input']>;
  temperature?: InputMaybe<Scalars['Float']['input']>;
  temperatureMethod?: InputMaybe<TemperatureMethod>;
  weight?: InputMaybe<Scalars['Float']['input']>;
};

export type CreateNeurologicalPeriodInput = {
  autoProgressNote?: InputMaybe<Scalars['Boolean']['input']>;
  comments?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  frequencyHours: Scalars['Int']['input'];
  residentId: Scalars['ID']['input'];
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CreateOrgChartPlacementInput = {
  displayOrder?: InputMaybe<Scalars['Int']['input']>;
  kind: OrgChartPlacementKind;
  parentEmployeeId?: InputMaybe<Scalars['ID']['input']>;
  parentPlacementId?: InputMaybe<Scalars['ID']['input']>;
  refId: Scalars['ID']['input'];
};

export type CreateOxygenSaturationInput = {
  autoProgressNote?: InputMaybe<Scalars['Boolean']['input']>;
  percentage: Scalars['Float']['input'];
  residentId: Scalars['ID']['input'];
  takenAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CreateP2ActionInput = {
  body: Scalars['String']['input'];
  isHtml?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  subject?: InputMaybe<Scalars['String']['input']>;
  type: P2ActionType;
};

export type CreateP2CampaignMessageInput = {
  body: Scalars['String']['input'];
  campaignId: Scalars['ID']['input'];
  channel: P2MessageChannel;
  name: Scalars['String']['input'];
  order?: InputMaybe<Scalars['Float']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
};

export type CreateP2ChargeInput = {
  amount: Scalars['Float']['input'];
  campaignId?: InputMaybe<Scalars['ID']['input']>;
  clientId: Scalars['ID']['input'];
  currency?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  pledgeId?: InputMaybe<Scalars['ID']['input']>;
  savedCardId: Scalars['ID']['input'];
};

export type CreateP2DeliveryUpdateInput = {
  campaignId: Scalars['ID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  pledgeId: Scalars['ID']['input'];
  status: P2DeliveryStatus;
};

export type CreateP2InviteInput = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
};

export type CreateP2NotificationRuleInput = {
  channels: Array<Scalars['String']['input']>;
  messageTemplate?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  recipientIds?: InputMaybe<Array<Scalars['String']['input']>>;
  recipientType: P2NotificationRecipientType;
  timing?: InputMaybe<P2NotificationTiming>;
  timingMinutes?: InputMaybe<Scalars['Float']['input']>;
  trigger: P2NotificationTrigger;
};

export type CreateP2PledgeCampaignInput = {
  chatEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  productId: Scalars['ID']['input'];
  referralEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  referralRewardAmount?: InputMaybe<Scalars['Float']['input']>;
};

export type CreateP2RefundInput = {
  amount: Scalars['Float']['input'];
  chargeId?: InputMaybe<Scalars['String']['input']>;
  clientId: Scalars['ID']['input'];
  currency?: InputMaybe<Scalars['String']['input']>;
  orderId?: InputMaybe<Scalars['String']['input']>;
  pledgeId?: InputMaybe<Scalars['String']['input']>;
  reason: Scalars['String']['input'];
};

export type CreateP2SupplierInput = {
  campaignId: Scalars['ID']['input'];
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactName?: InputMaybe<Scalars['String']['input']>;
  contactPhone?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  leadTimeDays?: InputMaybe<Scalars['Float']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  moq: Scalars['Float']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  productId: Scalars['ID']['input'];
  shippingCostEstimate?: InputMaybe<Scalars['Float']['input']>;
  status?: InputMaybe<P2SupplierStatus>;
  supplierName: Scalars['String']['input'];
  unitCost: Scalars['Float']['input'];
};

export type CreatePProposalInput = {
  agreementMarkdown: Scalars['String']['input'];
  autoCreateOpportunity?: InputMaybe<Scalars['Boolean']['input']>;
  clientEmail?: InputMaybe<Scalars['String']['input']>;
  clientId?: InputMaybe<Scalars['ID']['input']>;
  clientName?: InputMaybe<Scalars['String']['input']>;
  clientPhone?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  lineItems?: InputMaybe<Array<PProposalLineItemInput>>;
  notes?: InputMaybe<Scalars['String']['input']>;
  notifyEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  notifyOnSign?: InputMaybe<Scalars['Boolean']['input']>;
  notifyOnView?: InputMaybe<Scalars['Boolean']['input']>;
  opportunityId?: InputMaybe<Scalars['ID']['input']>;
  paymentSchedule?: InputMaybe<Array<PProposalPaymentScheduleItemInput>>;
  priority?: InputMaybe<PProposalPriority>;
  proposalType?: InputMaybe<PProposalType>;
  requiredSignerCount?: InputMaybe<Scalars['Int']['input']>;
  signerInstructions?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  title: Scalars['String']['input'];
  totalValue?: InputMaybe<Scalars['Float']['input']>;
};

export type CreatePartsOrderInput = {
  currency?: InputMaybe<Scalars['String']['input']>;
  discountAmount?: InputMaybe<Scalars['Float']['input']>;
  discountCode?: InputMaybe<Scalars['String']['input']>;
  expectedDeliveryDate?: InputMaybe<Scalars['DateTime']['input']>;
  financialCategory?: InputMaybe<Scalars['String']['input']>;
  isFinancialActivity?: InputMaybe<Scalars['Boolean']['input']>;
  items: Array<PartsOrderItemInput>;
  notes?: InputMaybe<Scalars['String']['input']>;
  orderId?: InputMaybe<Scalars['String']['input']>;
  receiptCid?: InputMaybe<Scalars['String']['input']>;
  receiptUrl?: InputMaybe<Scalars['String']['input']>;
  receipts?: InputMaybe<Array<ReceiptAttachmentInput>>;
  shippingCost?: InputMaybe<Scalars['Float']['input']>;
  status?: InputMaybe<PartsOrderStatus>;
  subtotal: Scalars['Float']['input'];
  supplierId?: InputMaybe<Scalars['ID']['input']>;
  supplierName?: InputMaybe<Scalars['String']['input']>;
  supplierOrderImageUrl?: InputMaybe<Scalars['String']['input']>;
  supplierOrderUrl?: InputMaybe<Scalars['String']['input']>;
  taxAmount?: InputMaybe<Scalars['Float']['input']>;
  total: Scalars['Float']['input'];
  trackingNumber?: InputMaybe<Scalars['String']['input']>;
  trackingUrl?: InputMaybe<Scalars['String']['input']>;
};

export type CreatePenaltyRateRuleInput = {
  additionalRate?: InputMaybe<Scalars['Float']['input']>;
  awardName: Scalars['String']['input'];
  dayOfWeek?: InputMaybe<PayDayOfWeek>;
  effectiveFromDate?: InputMaybe<Scalars['DateTime']['input']>;
  effectiveToDate?: InputMaybe<Scalars['DateTime']['input']>;
  employmentTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  multiplier: Scalars['Float']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  ruleType: PenaltyRateRuleType;
  timeEndMinutes?: InputMaybe<Scalars['Int']['input']>;
  timeStartMinutes?: InputMaybe<Scalars['Int']['input']>;
};

export type CreatePersonEventInput = {
  classification?: InputMaybe<EventClassification>;
  description?: InputMaybe<Scalars['String']['input']>;
  eventDate: Scalars['DateTime']['input'];
  impact?: InputMaybe<ImpactLevel>;
  personId: Scalars['String']['input'];
  source?: InputMaybe<Scalars['String']['input']>;
  sourceType?: InputMaybe<NewsSourceType>;
  title: Scalars['String']['input'];
};

export type CreatePersonalEmailInput = {
  alias: Scalars['String']['input'];
};

export type CreatePledgeCampaignInput = {
  coverImageUrl?: InputMaybe<Scalars['String']['input']>;
  deadlineAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  heroHeadline?: InputMaybe<Scalars['String']['input']>;
  heroSubhead?: InputMaybe<Scalars['String']['input']>;
  isReferralEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  productName: Scalars['String']['input'];
  slug: Scalars['String']['input'];
  status?: InputMaybe<PledgeCampaignStatus>;
  tiers: Array<PledgeCampaignTierInput>;
};

export type CreatePolicyInput = {
  applicableRoles?: InputMaybe<Array<Scalars['String']['input']>>;
  approvedBy?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  docId: Scalars['String']['input'];
  issueDate?: InputMaybe<Scalars['String']['input']>;
  markdown?: InputMaybe<Scalars['String']['input']>;
  regulatoryReference?: InputMaybe<Scalars['String']['input']>;
  reviewDate?: InputMaybe<Scalars['String']['input']>;
  statusNote?: InputMaybe<Scalars['String']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export type CreatePrescriberInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  clinic?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  fax?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  providerNumber: Scalars['String']['input'];
  specialty?: InputMaybe<Scalars['String']['input']>;
};

export type CreateProgramActivityInput = {
  activityDate?: InputMaybe<Scalars['DateTime']['input']>;
  activityType: Scalars['String']['input'];
  attachments?: InputMaybe<Array<ProgramActivityAttachmentInput>>;
  details?: InputMaybe<Scalars['String']['input']>;
  isPrivate?: InputMaybe<Scalars['Boolean']['input']>;
  memberId: Scalars['ID']['input'];
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  title: Scalars['String']['input'];
};

export type CreateProgramApplicationInput = {
  billId?: InputMaybe<Scalars['String']['input']>;
  businessDescription: Scalars['String']['input'];
  financialCapacityAnswer: Scalars['String']['input'];
  memberId: Scalars['ID']['input'];
  proofOfAssetsCids?: InputMaybe<Array<Scalars['String']['input']>>;
  willingnessScore: Scalars['Int']['input'];
};

export type CreateProgramCallNoteInput = {
  callNumber: Scalars['Int']['input'];
  meetSessionId?: InputMaybe<Scalars['String']['input']>;
  memberId: Scalars['ID']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  outcome?: InputMaybe<Scalars['String']['input']>;
  scheduledFor?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CreateProgramCommissionInput = {
  introducerContactId: Scalars['ID']['input'];
  level: Scalars['Int']['input'];
  ongoingPct?: InputMaybe<Scalars['Float']['input']>;
  programMemberId: Scalars['ID']['input'];
  saleAmountCents: Scalars['Int']['input'];
  upfrontPct?: InputMaybe<Scalars['Float']['input']>;
};

export type CreateProgramMemberInput = {
  currentStage?: InputMaybe<ProgramMemberStage>;
  leadId: Scalars['ID']['input'];
  pProposalId?: InputMaybe<Scalars['String']['input']>;
  selectedTierId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateProgressNoteInput = {
  content: Scalars['String']['input'];
  includeInException?: InputMaybe<Scalars['Boolean']['input']>;
  noteDate?: InputMaybe<Scalars['DateTime']['input']>;
  noteTime?: InputMaybe<Scalars['String']['input']>;
  relatedAssessmentId?: InputMaybe<Scalars['ID']['input']>;
  relatedCarePlanCategories?: InputMaybe<Array<ProgressNoteCategory>>;
  relatedDoctorVisitId?: InputMaybe<Scalars['ID']['input']>;
  relatedIncidentId?: InputMaybe<Scalars['ID']['input']>;
  repeatExceptionDays?: InputMaybe<Scalars['Int']['input']>;
  residentId: Scalars['ID']['input'];
  sourceModule?: InputMaybe<NoteSourceModule>;
};

export type CreateProposalInput = {
  agreementMarkdown: Scalars['String']['input'];
  billId?: InputMaybe<Scalars['ID']['input']>;
  companyName: Scalars['String']['input'];
  customPagePath?: InputMaybe<Scalars['String']['input']>;
  draftBillId?: InputMaybe<Scalars['ID']['input']>;
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['ID']['input']>;
  scheduledPayments?: InputMaybe<Array<ScheduledPaymentInput>>;
  slug: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type CreateProspectingNotificationRuleInput = {
  channels: Array<ProspectingNotificationChannel>;
  chatRecipientCooldownMinutes?: InputMaybe<Scalars['Float']['input']>;
  chatSessionGapMinutes?: InputMaybe<Scalars['Float']['input']>;
  filterDepartmentId?: InputMaybe<Scalars['String']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  messageTemplate?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  recipientIds?: InputMaybe<Array<Scalars['String']['input']>>;
  recipientType: ProspectingNotificationRecipientType;
  trigger: ProspectingNotificationTrigger;
};

export type CreatePublicBookingInput = {
  answers?: InputMaybe<Scalars['JSONObject']['input']>;
  bookerEmail: Scalars['String']['input'];
  bookerName: Scalars['String']['input'];
  bookerPhone?: InputMaybe<Scalars['String']['input']>;
  bookerTimezone?: InputMaybe<Scalars['String']['input']>;
  calendarSlug: Scalars['String']['input'];
  eventTypeId: Scalars['String']['input'];
  startTime: Scalars['DateTime']['input'];
};

export type CreatePulseObservationInput = {
  autoProgressNote?: InputMaybe<Scalars['Boolean']['input']>;
  bpm: Scalars['Int']['input'];
  residentId: Scalars['ID']['input'];
  takenAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CreateRecipeIngredientInput = {
  ingredientId: Scalars['ID']['input'];
  isOptional?: InputMaybe<Scalars['Boolean']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  quantity: Scalars['Float']['input'];
  recipeId: Scalars['ID']['input'];
  sortOrder?: InputMaybe<Scalars['Float']['input']>;
  unit: UnitType;
};

export type CreateRecipeInput = {
  caloriesPerServing?: InputMaybe<Scalars['Float']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  cookTime?: InputMaybe<Scalars['Float']['input']>;
  cuisine?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dietaryTags?: InputMaybe<Array<DietaryTag>>;
  dishType?: InputMaybe<RecipeDishType>;
  imageCid?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  instructions?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  prepTime?: InputMaybe<Scalars['Float']['input']>;
  servings: Scalars['Float']['input'];
  sessionType?: InputMaybe<RecipeSessionType>;
};

export type CreateReferralInput = {
  designation?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  referToUserIds: Array<Scalars['ID']['input']>;
  sourceNoteId: Scalars['ID']['input'];
};

export type CreateReferralResponse = {
  __typename?: 'CreateReferralResponse';
  createdCount: Scalars['Int']['output'];
  referralIds: Array<Scalars['ID']['output']>;
};

export type CreateResearchBaseInput = {
  basePath: Scalars['String']['input'];
  createRootIfMissing?: InputMaybe<Scalars['Boolean']['input']>;
  customFsUrl?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  extractModel?: InputMaybe<Scalars['String']['input']>;
  host?: InputMaybe<KnowledgeHost>;
  knowledgeRoot: Scalars['String']['input'];
  proseModel?: InputMaybe<Scalars['String']['input']>;
  sharedRootAcknowledged?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  sourceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  title: Scalars['String']['input'];
  writerHost?: InputMaybe<KnowledgeHost>;
};

export type CreateResidentContactInput = {
  bestTimeToContact?: InputMaybe<Scalars['String']['input']>;
  canMakeDecisions?: InputMaybe<Scalars['Boolean']['input']>;
  canReceiveUpdates?: InputMaybe<Scalars['Boolean']['input']>;
  chatEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emergencyContactOrder?: InputMaybe<Scalars['Int']['input']>;
  firstName: Scalars['String']['input'];
  hasPortalAccess?: InputMaybe<Scalars['Boolean']['input']>;
  isEmergencyContact?: InputMaybe<Scalars['Boolean']['input']>;
  isGuardian?: InputMaybe<Scalars['Boolean']['input']>;
  isNextOfKin?: InputMaybe<Scalars['Boolean']['input']>;
  isPrimaryContact?: InputMaybe<Scalars['Boolean']['input']>;
  lastName: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  phoneHome?: InputMaybe<Scalars['String']['input']>;
  phoneMobile?: InputMaybe<Scalars['String']['input']>;
  phoneWork?: InputMaybe<Scalars['String']['input']>;
  portalPermissionLevel?: InputMaybe<Scalars['String']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  powerOfAttorney?: InputMaybe<PowerOfAttorneyDetailsInput>;
  preferredContactMethod?: InputMaybe<Scalars['String']['input']>;
  relationship: ContactRelationship;
  relationshipOther?: InputMaybe<Scalars['String']['input']>;
  residentId: Scalars['ID']['input'];
  state?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  suburb?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CreateResidentInput = {
  acfi?: InputMaybe<AcfiDetailsInput>;
  admissionDate?: InputMaybe<Scalars['DateTime']['input']>;
  admittedFrom?: InputMaybe<Scalars['String']['input']>;
  allergies?: InputMaybe<Array<Scalars['String']['input']>>;
  ambulanceFundNumber?: InputMaybe<Scalars['String']['input']>;
  bedNumber?: InputMaybe<Scalars['String']['input']>;
  careType?: InputMaybe<CareType>;
  centrelinkNumber?: InputMaybe<Scalars['String']['input']>;
  cognitionLevel?: InputMaybe<Scalars['String']['input']>;
  culturalOrigin?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth: Scalars['DateTime']['input'];
  diagnoses?: InputMaybe<Array<Scalars['String']['input']>>;
  dietaryRequirements?: InputMaybe<Array<Scalars['String']['input']>>;
  dva?: InputMaybe<DvaDetailsInput>;
  email?: InputMaybe<Scalars['String']['input']>;
  entryType?: InputMaybe<EntryType>;
  externalPatientId?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  gender: Gender;
  hasHealthDirective?: InputMaybe<Scalars['Boolean']['input']>;
  hasPacemaker?: InputMaybe<Scalars['Boolean']['input']>;
  healthFund?: InputMaybe<HealthFundDetailsInput>;
  hospitalPreference?: InputMaybe<HospitalPreferenceInput>;
  interpreter?: InputMaybe<InterpreterDetailsInput>;
  isShellRecord?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  lastName: Scalars['String']['input'];
  /** Linked Client ID for resident portal access */
  linkedClientId?: InputMaybe<Scalars['ID']['input']>;
  maritalStatus?: InputMaybe<MaritalStatus>;
  medicare?: InputMaybe<MedicareDetailsInput>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  mobilityLevel?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  paymentMethod?: InputMaybe<Scalars['String']['input']>;
  pension?: InputMaybe<PensionDetailsInput>;
  pharmaceuticalSafetyNetNumber?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  preAdmissionDate?: InputMaybe<Scalars['DateTime']['input']>;
  preferredName?: InputMaybe<Scalars['String']['input']>;
  previousAddress?: InputMaybe<ResidentAddressInput>;
  primaryDiagnosis?: InputMaybe<Scalars['String']['input']>;
  religion?: InputMaybe<Scalars['String']['input']>;
  respiteDueOutDate?: InputMaybe<Scalars['DateTime']['input']>;
  roomId?: InputMaybe<Scalars['ID']['input']>;
  roomNumber?: InputMaybe<Scalars['String']['input']>;
  sarahCareId?: InputMaybe<Scalars['String']['input']>;
  seniorCard?: InputMaybe<SeniorCardDetailsInput>;
  status?: InputMaybe<ResidentStatus>;
  title?: InputMaybe<Scalars['String']['input']>;
  treatingDoctor?: InputMaybe<TreatingDoctorDetailsInput>;
  wing?: InputMaybe<Scalars['String']['input']>;
};

export type CreateResidentLeaveInput = {
  belongingsTaken?: InputMaybe<Scalars['String']['input']>;
  departureDate: Scalars['DateTime']['input'];
  departureTime?: InputMaybe<Scalars['String']['input']>;
  destination?: InputMaybe<Scalars['String']['input']>;
  destinationContact?: InputMaybe<Scalars['String']['input']>;
  destinationPhone?: InputMaybe<Scalars['String']['input']>;
  expectedReturnDate?: InputMaybe<Scalars['DateTime']['input']>;
  hospitalBed?: InputMaybe<Scalars['String']['input']>;
  hospitalDiagnosis?: InputMaybe<Scalars['String']['input']>;
  hospitalDoctor?: InputMaybe<Scalars['String']['input']>;
  hospitalWard?: InputMaybe<Scalars['String']['input']>;
  leaveType: LeaveType;
  notes?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  residentId: Scalars['ID']['input'];
};

export type CreateResidentRiskAssessmentInput = {
  assessmentDate?: InputMaybe<Scalars['DateTime']['input']>;
  autoProgressNote?: InputMaybe<Scalars['Boolean']['input']>;
  mitigationStrategies?: InputMaybe<Array<Scalars['String']['input']>>;
  notes?: InputMaybe<Scalars['String']['input']>;
  residentId: Scalars['ID']['input'];
  reviewDate?: InputMaybe<Scalars['DateTime']['input']>;
  riskFactors?: InputMaybe<Array<Scalars['String']['input']>>;
  riskLevel: ResidentRiskLevel;
  riskType: ResidentRiskType;
};

export type CreateRespirationObservationInput = {
  autoProgressNote?: InputMaybe<Scalars['Boolean']['input']>;
  residentId: Scalars['ID']['input'];
  respirationsPerMinute: Scalars['Int']['input'];
  takenAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CreateRespiteCareBookingInput = {
  bookingType?: InputMaybe<RespiteCareBookingType>;
  clientDateOfBirth?: InputMaybe<Scalars['DateTime']['input']>;
  clientEmail?: InputMaybe<Scalars['String']['input']>;
  clientName: Scalars['String']['input'];
  clientPhone?: InputMaybe<Scalars['String']['input']>;
  dailyRate?: InputMaybe<Scalars['Float']['input']>;
  dietaryNeeds?: InputMaybe<Scalars['String']['input']>;
  emergencyContactName?: InputMaybe<Scalars['String']['input']>;
  emergencyContactPhone?: InputMaybe<Scalars['String']['input']>;
  emergencyContactRelation?: InputMaybe<Scalars['String']['input']>;
  endDate: Scalars['DateTime']['input'];
  fundingSource?: InputMaybe<RespiteFundingSource>;
  gpName?: InputMaybe<Scalars['String']['input']>;
  gpPhone?: InputMaybe<Scalars['String']['input']>;
  medicationNotes?: InputMaybe<Scalars['String']['input']>;
  mobilityNotes?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  roomNumber?: InputMaybe<Scalars['String']['input']>;
  specialRequirements?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['DateTime']['input'];
  wing?: InputMaybe<Scalars['String']['input']>;
};

export type CreateRestraintCheckInput = {
  checkTime?: InputMaybe<Scalars['DateTime']['input']>;
  circulationOk?: InputMaybe<Scalars['Boolean']['input']>;
  fluidOffered?: InputMaybe<Scalars['Boolean']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  outcome: RestraintCheckOutcome;
  releaseOffered?: InputMaybe<Scalars['Boolean']['input']>;
  repositioned?: InputMaybe<Scalars['Boolean']['input']>;
  residentId: Scalars['ID']['input'];
  restraintRecordId: Scalars['ID']['input'];
  skinCondition?: InputMaybe<Scalars['String']['input']>;
  toiletingOffered?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateRestraintRecordInput = {
  consentDate?: InputMaybe<Scalars['DateTime']['input']>;
  consentStatus: RestraintConsentStatus;
  consentedBy?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  reason: RestraintReason;
  residentId: Scalars['ID']['input'];
  restraintType: RestraintType;
  reviewDate?: InputMaybe<Scalars['DateTime']['input']>;
  reviewFrequencyDays?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CreateRiskAssessmentInput = {
  comments?: InputMaybe<Scalars['String']['input']>;
  consequences: RiskConsequences;
  controlMeasuresTaken?: InputMaybe<Scalars['String']['input']>;
  exposure: RiskExposure;
  followUpNotes?: InputMaybe<Scalars['String']['input']>;
  numberOfPersonsAffected?: InputMaybe<Scalars['Int']['input']>;
  probability: RiskProbability;
  sentToFollowUp?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateRoundInput = {
  notes?: InputMaybe<Scalars['String']['input']>;
  roundDate: Scalars['DateTime']['input'];
  roundName: Scalars['String']['input'];
  roundTime: Scalars['String']['input'];
  wing?: InputMaybe<Scalars['String']['input']>;
};

export type CreateSeoMetadataInput = {
  canonicalUrl?: InputMaybe<Scalars['String']['input']>;
  conversionGoal?: InputMaybe<Scalars['String']['input']>;
  linkedInDescription?: InputMaybe<Scalars['String']['input']>;
  linkedInImageCid?: InputMaybe<Scalars['String']['input']>;
  linkedInTitle?: InputMaybe<Scalars['String']['input']>;
  metaDescription: Scalars['String']['input'];
  metaKeywords?: InputMaybe<Array<Scalars['String']['input']>>;
  metaTitle: Scalars['String']['input'];
  ogDescription?: InputMaybe<Scalars['String']['input']>;
  ogImageCid?: InputMaybe<Scalars['String']['input']>;
  ogTitle?: InputMaybe<Scalars['String']['input']>;
  ogType?: InputMaybe<Scalars['String']['input']>;
  pagePath: Scalars['String']['input'];
  pageTitle: Scalars['String']['input'];
  pinterestDescription?: InputMaybe<Scalars['String']['input']>;
  pinterestImageCid?: InputMaybe<Scalars['String']['input']>;
  pinterestTitle?: InputMaybe<Scalars['String']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  robots?: InputMaybe<Scalars['String']['input']>;
  structuredData?: InputMaybe<Scalars['String']['input']>;
  trackPageViews?: InputMaybe<Scalars['Boolean']['input']>;
  twitterCard?: InputMaybe<Scalars['String']['input']>;
  twitterDescription?: InputMaybe<Scalars['String']['input']>;
  twitterImageCid?: InputMaybe<Scalars['String']['input']>;
  twitterTitle?: InputMaybe<Scalars['String']['input']>;
};

export type CreateSeparationAffiliateInput = {
  clientId: Scalars['ID']['input'];
  code: Scalars['String']['input'];
  defaultPercent?: InputMaybe<Scalars['Float']['input']>;
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type CreateSeparationInviteInput = {
  accessMode: SeparationInviteAccessMode;
  couponCode?: InputMaybe<Scalars['String']['input']>;
  customMessage?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  existingClientId?: InputMaybe<Scalars['ID']['input']>;
  fName?: InputMaybe<Scalars['String']['input']>;
  lName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type CreateShelvInviteInput = {
  accessMode?: InputMaybe<ShelvInviteAccessMode>;
  couponCode?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  existingClientId?: InputMaybe<Scalars['ID']['input']>;
  expiresInDays?: InputMaybe<Scalars['Float']['input']>;
  fName?: InputMaybe<Scalars['String']['input']>;
  kitchenId?: InputMaybe<Scalars['ID']['input']>;
  lName?: InputMaybe<Scalars['String']['input']>;
  sections?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CreateShelvMemberInviteInput = {
  email: Scalars['String']['input'];
  fName?: InputMaybe<Scalars['String']['input']>;
  personalNote?: InputMaybe<Scalars['String']['input']>;
};

export type CreateShiftNotificationRuleInput = {
  channels: Array<Scalars['String']['input']>;
  filterDepartmentId?: InputMaybe<Scalars['String']['input']>;
  filterLocation?: InputMaybe<Scalars['String']['input']>;
  filterTeam?: InputMaybe<Scalars['String']['input']>;
  messageTemplate?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  recipientDepartmentId?: InputMaybe<Scalars['String']['input']>;
  recipientIds?: InputMaybe<Array<Scalars['String']['input']>>;
  recipientRole?: InputMaybe<Scalars['String']['input']>;
  recipientType: ShiftNotificationRecipientType;
  timing?: InputMaybe<ShiftNotificationTiming>;
  timingMinutes?: InputMaybe<Scalars['Float']['input']>;
  trigger: ShiftNotificationTrigger;
};

export type CreateShiftTemplateInput = {
  breakMinutes?: InputMaybe<Scalars['Float']['input']>;
  department?: InputMaybe<Scalars['String']['input']>;
  departmentIds?: InputMaybe<Array<Scalars['String']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  employeeRoleId?: InputMaybe<Scalars['String']['input']>;
  endTime: Scalars['String']['input'];
  isFloat?: InputMaybe<Scalars['Boolean']['input']>;
  isOvernight?: InputMaybe<Scalars['Boolean']['input']>;
  locationIds?: InputMaybe<Array<Scalars['String']['input']>>;
  requiredStaffCount?: InputMaybe<Scalars['Float']['input']>;
  shiftType?: InputMaybe<Scalars['String']['input']>;
  skills?: InputMaybe<Array<Scalars['String']['input']>>;
  sortOrder?: InputMaybe<Scalars['Float']['input']>;
  startTime: Scalars['String']['input'];
  team?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  weekdaysOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateShiftsFromTemplatesInput = {
  dates: Array<Scalars['DateTime']['input']>;
  skipExistingDays?: Scalars['Boolean']['input'];
  templateTitles?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CreateSiteEditorSiteInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  devServerIp?: InputMaybe<Scalars['String']['input']>;
  devServerPort?: InputMaybe<Scalars['Float']['input']>;
  githubToken?: InputMaybe<Scalars['String']['input']>;
  linkedTenantId?: InputMaybe<Scalars['String']['input']>;
  previewUrl?: InputMaybe<Scalars['String']['input']>;
  productionUrl?: InputMaybe<Scalars['String']['input']>;
  relayApiKey: Scalars['String']['input'];
  relayUrl: Scalars['String']['input'];
  repoUrl?: InputMaybe<Scalars['String']['input']>;
  siteId: Scalars['String']['input'];
  siteName: Scalars['String']['input'];
};

export type CreateSleepCheckInput = {
  autoProgressNote?: InputMaybe<Scalars['Boolean']['input']>;
  checkTime?: InputMaybe<Scalars['DateTime']['input']>;
  disturbance?: InputMaybe<SleepDisturbance>;
  disturbanceNotes?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<SleepPosition>;
  residentId: Scalars['ID']['input'];
  shiftDate: Scalars['DateTime']['input'];
  status: SleepStatus;
};

export type CreateSmsNotificationRuleInput = {
  channels: Array<Scalars['String']['input']>;
  filterKeyword?: InputMaybe<Scalars['String']['input']>;
  messageTemplate?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  recipientIds?: InputMaybe<Array<Scalars['String']['input']>>;
  recipientRole?: InputMaybe<Scalars['String']['input']>;
  recipientType: SmsNotificationRecipientType;
  triggers: Array<SmsNotificationTrigger>;
};

export type CreateSopAgendaItemInput = {
  note?: InputMaybe<Scalars['String']['input']>;
  targetEpisodeId?: InputMaybe<Scalars['ID']['input']>;
  text: Scalars['String']['input'];
  topicId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateSopCommentInput = {
  audioCid?: InputMaybe<Scalars['String']['input']>;
  authorEmail?: InputMaybe<Scalars['String']['input']>;
  authorName?: InputMaybe<Scalars['String']['input']>;
  body?: InputMaybe<Scalars['String']['input']>;
  slug: Scalars['String']['input'];
};

export type CreateSopEpisodeInput = {
  calendarEventId?: InputMaybe<Scalars['ID']['input']>;
  cta?: InputMaybe<SopCtaInput>;
  durationMinutes?: InputMaybe<Scalars['Int']['input']>;
  mermaidSource?: InputMaybe<Scalars['String']['input']>;
  presenterNotes?: InputMaybe<Scalars['String']['input']>;
  roomName?: InputMaybe<Scalars['String']['input']>;
  scheduledEnd?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledStart?: InputMaybe<Scalars['DateTime']['input']>;
  skin?: InputMaybe<SopSkin>;
  slug?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  topicId?: InputMaybe<Scalars['ID']['input']>;
  visibility?: InputMaybe<SopVisibility>;
};

export type CreateSopTopicInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  order?: InputMaybe<Scalars['Int']['input']>;
  parentId?: InputMaybe<Scalars['ID']['input']>;
  slug: Scalars['String']['input'];
};

export type CreateSphereOfInfluenceInput = {
  actionRequired?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<InfluenceCategory>;
  demandRating?: InputMaybe<Scalars['Int']['input']>;
  energyRating?: InputMaybe<Scalars['Int']['input']>;
  engagement?: InputMaybe<Scalars['Int']['input']>;
  impactScore: Scalars['Int']['input'];
  influence: InfluenceType;
  interactionFrequency?: InputMaybe<InteractionFrequency>;
  linkedAspectIds?: InputMaybe<Array<Scalars['String']['input']>>;
  name: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  proximity?: InputMaybe<Scalars['Int']['input']>;
  relationshipLayer?: InputMaybe<RelationshipLayer>;
  relationshipType?: InputMaybe<Scalars['String']['input']>;
  roleTags?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CreateSupplierInput = {
  abn?: InputMaybe<Scalars['String']['input']>;
  accountNumber?: InputMaybe<Scalars['String']['input']>;
  address?: InputMaybe<Scalars['String']['input']>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactName?: InputMaybe<Scalars['String']['input']>;
  contactPhone?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  leadTimeDays?: InputMaybe<Scalars['Float']['input']>;
  minimumOrder?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  paymentTerms?: InputMaybe<Scalars['String']['input']>;
  preferredCategories?: InputMaybe<Array<IngredientCategory>>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type CreateSupplierOrderInput = {
  expectedDelivery?: InputMaybe<Scalars['DateTime']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  supplierId: Scalars['ID']['input'];
};

export type CreateTemperatureAlarmInput = {
  alarmType: Scalars['String']['input'];
  deadlineTime: Scalars['String']['input'];
  enabled?: Scalars['Boolean']['input'];
  equipmentId: Scalars['String']['input'];
  maxTemp?: InputMaybe<Scalars['Float']['input']>;
  minTemp?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  notifyViaEmail: Scalars['Boolean']['input'];
  notifyViaSms: Scalars['Boolean']['input'];
  recipientClientIds: Array<Scalars['String']['input']>;
  session: Scalars['String']['input'];
};

export type CreateTemperatureLogInput = {
  actionNote?: InputMaybe<Scalars['String']['input']>;
  equipmentId: Scalars['String']['input'];
  flagReason?: InputMaybe<TemperatureFlagReason>;
  flagReasonOther?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  recordedAt: Scalars['String']['input'];
  session?: InputMaybe<Scalars['String']['input']>;
  temperature: Scalars['Float']['input'];
};

export type CreateTemperatureObservationInput = {
  autoProgressNote?: InputMaybe<Scalars['Boolean']['input']>;
  method?: InputMaybe<TemperatureMethod>;
  residentId: Scalars['ID']['input'];
  takenAt?: InputMaybe<Scalars['DateTime']['input']>;
  temperature: Scalars['Float']['input'];
};

export type CreateTimesheetInput = {
  fileType?: InputMaybe<Scalars['String']['input']>;
  ipfsHash?: InputMaybe<Scalars['String']['input']>;
  ipfsUrl?: InputMaybe<Scalars['String']['input']>;
  matterId: Scalars['String']['input'];
  originalFileName?: InputMaybe<Scalars['String']['input']>;
};

export type CreateTomConversationInput = {
  entityContext?: InputMaybe<Scalars['String']['input']>;
  moduleContext: Scalars['String']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CreateTreatmentPlanInput = {
  administeredAt?: InputMaybe<Scalars['DateTime']['input']>;
  followUpDate?: InputMaybe<Scalars['DateTime']['input']>;
  followUpRequired?: InputMaybe<Scalars['Boolean']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  treatmentDescription: Scalars['String']['input'];
};

export type CreateTrustPersonInput = {
  confirmed?: InputMaybe<Scalars['Boolean']['input']>;
  electorate?: InputMaybe<Scalars['String']['input']>;
  kind?: InputMaybe<TrustPersonKind>;
  level: TrustLevel;
  name: Scalars['String']['input'];
  party?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  slug: Scalars['String']['input'];
  sources?: InputMaybe<TrustPersonSourcesInput>;
  topics?: InputMaybe<Array<Scalars['String']['input']>>;
  why?: InputMaybe<Scalars['String']['input']>;
};

export type CreateUrinalysisObservationInput = {
  autoProgressNote?: InputMaybe<Scalars['Boolean']['input']>;
  bilirubin?: InputMaybe<Scalars['String']['input']>;
  blood?: InputMaybe<Scalars['String']['input']>;
  comments?: InputMaybe<Scalars['String']['input']>;
  glucose?: InputMaybe<Scalars['String']['input']>;
  ketones?: InputMaybe<Scalars['String']['input']>;
  leucocytes?: InputMaybe<Scalars['String']['input']>;
  nitrites?: InputMaybe<Scalars['String']['input']>;
  ph?: InputMaybe<Scalars['String']['input']>;
  protein?: InputMaybe<Scalars['String']['input']>;
  residentId: Scalars['ID']['input'];
  specificGravity?: InputMaybe<Scalars['String']['input']>;
  takenAt?: InputMaybe<Scalars['DateTime']['input']>;
  urobilinogen?: InputMaybe<Scalars['String']['input']>;
};

export type CreateVaccinationInput = {
  administeredDate?: InputMaybe<Scalars['DateTime']['input']>;
  batchNumber?: InputMaybe<Scalars['String']['input']>;
  consentDate?: InputMaybe<Scalars['DateTime']['input']>;
  consentObtained?: InputMaybe<Scalars['Boolean']['input']>;
  declinedReason?: InputMaybe<Scalars['String']['input']>;
  expiryDate?: InputMaybe<Scalars['DateTime']['input']>;
  nextDueDate?: InputMaybe<Scalars['DateTime']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  residentId: Scalars['ID']['input'];
  site?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<VaccinationStatus>;
  vaccineName?: InputMaybe<Scalars['String']['input']>;
  vaccineType: VaccineType;
};

export type CreateVaultInput = {
  ownerBtcAddress?: InputMaybe<Scalars['String']['input']>;
  ownerEmail?: InputMaybe<Scalars['String']['input']>;
  ownerName: Scalars['String']['input'];
  ownerWalletAddress?: InputMaybe<Scalars['String']['input']>;
};

export type CreateVaultInsightRuleInput = {
  cadence: VaultInsightCadence;
  channels: Array<VaultInsightChannel>;
  customPromptAddendum?: InputMaybe<Scalars['String']['input']>;
  daysOfWeek?: InputMaybe<Array<Scalars['Int']['input']>>;
  lookbackDays?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  recipientClientIds?: InputMaybe<Array<Scalars['String']['input']>>;
  recipientTag?: InputMaybe<Scalars['String']['input']>;
  recipientType: VaultInsightRecipientType;
  sections: Array<VaultInsightSection>;
  timeOfDay?: InputMaybe<Scalars['String']['input']>;
};

export type CreateVisionBoardInviteInput = {
  accessMode: VisionBoardInviteAccessMode;
  couponCode?: InputMaybe<Scalars['String']['input']>;
  customMessage?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  existingClientId?: InputMaybe<Scalars['ID']['input']>;
  fName?: InputMaybe<Scalars['String']['input']>;
  lName?: InputMaybe<Scalars['String']['input']>;
};

export type CreateVisionBoardItemInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  imageCid?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  positionX?: InputMaybe<Scalars['Int']['input']>;
  positionY?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<VisionBoardItemType>;
};

export type CreateVisionBoardMemberInviteInput = {
  email: Scalars['String']['input'];
  fName?: InputMaybe<Scalars['String']['input']>;
};

export type CreateVisionBoardNotificationRuleInput = {
  channels: Array<Scalars['String']['input']>;
  messageTemplate?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  recipientIds?: InputMaybe<Array<Scalars['String']['input']>>;
  recipientType: VisionBoardNotificationRecipientType;
  trigger: VisionBoardNotificationTrigger;
};

export type CreateVlogCategoryInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  order?: InputMaybe<Scalars['Int']['input']>;
  parentId?: InputMaybe<Scalars['ID']['input']>;
  slug: Scalars['String']['input'];
};

export type CreateVlogNotificationRuleInput = {
  channels: Array<Scalars['String']['input']>;
  messageTemplate?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  recipientIds?: InputMaybe<Array<Scalars['String']['input']>>;
  recipientType: VlogNotificationRecipientType;
  timing?: InputMaybe<VlogNotificationTiming>;
  timingMinutes?: InputMaybe<Scalars['Int']['input']>;
  trigger: VlogNotificationTrigger;
};

export type CreateVlogPostInput = {
  aiChatEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  aiChatSeedQuestions?: InputMaybe<Array<Scalars['String']['input']>>;
  author?: InputMaybe<Scalars['String']['input']>;
  authorAvatarUrl?: InputMaybe<Scalars['String']['input']>;
  authorBio?: InputMaybe<Scalars['String']['input']>;
  bonusContent?: InputMaybe<Scalars['String']['input']>;
  bonusUnlockPercent?: InputMaybe<Scalars['Int']['input']>;
  bulletPoints?: InputMaybe<Array<Scalars['String']['input']>>;
  categories?: InputMaybe<Array<Scalars['String']['input']>>;
  companionArticleMarkdown?: InputMaybe<Scalars['String']['input']>;
  durationSeconds?: InputMaybe<Scalars['Int']['input']>;
  episodeNumber?: InputMaybe<Scalars['Int']['input']>;
  excerpt?: InputMaybe<Scalars['String']['input']>;
  leadFormId?: InputMaybe<Scalars['String']['input']>;
  leadMagnetDescription?: InputMaybe<Scalars['String']['input']>;
  leadMagnetTitle?: InputMaybe<Scalars['String']['input']>;
  metaDescription?: InputMaybe<Scalars['String']['input']>;
  metaTitle?: InputMaybe<Scalars['String']['input']>;
  ogImage?: InputMaybe<Scalars['String']['input']>;
  personalizationOptions?: InputMaybe<Array<VlogPersonalizationOptionInput>>;
  personalizationQuestion?: InputMaybe<Scalars['String']['input']>;
  pollOptions?: InputMaybe<Array<VlogPollOptionInput>>;
  pollQuestion?: InputMaybe<Scalars['String']['input']>;
  previewClipUrl?: InputMaybe<Scalars['String']['input']>;
  seriesId?: InputMaybe<Scalars['ID']['input']>;
  skin?: InputMaybe<Scalars['String']['input']>;
  slug: Scalars['String']['input'];
  status?: InputMaybe<VlogPostStatus>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  thumbnailCid?: InputMaybe<Scalars['String']['input']>;
  thumbnailUrl?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  toolCtaDescription?: InputMaybe<Scalars['String']['input']>;
  toolCtaText?: InputMaybe<Scalars['String']['input']>;
  toolCtaUrl?: InputMaybe<Scalars['String']['input']>;
  transcript?: InputMaybe<Scalars['String']['input']>;
  videoCid?: InputMaybe<Scalars['String']['input']>;
  videoCustomIframe?: InputMaybe<Scalars['String']['input']>;
  videoIpfsHash?: InputMaybe<Scalars['String']['input']>;
  videoProvider: VlogVideoProvider;
  videoUrl?: InputMaybe<Scalars['String']['input']>;
  visibility?: InputMaybe<VlogPostVisibility>;
};

export type CreateVlogSeriesInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  heroImage?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  order?: InputMaybe<Scalars['Int']['input']>;
  slug: Scalars['String']['input'];
};

export type CreateWaitingListEntryInput = {
  acatApprovalExpiry?: InputMaybe<Scalars['DateTime']['input']>;
  acatAssessmentDate?: InputMaybe<Scalars['DateTime']['input']>;
  acatReferenceNumber?: InputMaybe<Scalars['String']['input']>;
  accommodationPayment?: InputMaybe<WaitingListAccommodationPayment>;
  careNeeds?: InputMaybe<CareNeedsAssessmentInput>;
  contactPerson?: InputMaybe<WaitingListContactInput>;
  currentAddress?: InputMaybe<Scalars['String']['input']>;
  currentLocation?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<Scalars['DateTime']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  entryType?: InputMaybe<EntryType>;
  expectedAdmissionDate?: InputMaybe<Scalars['DateTime']['input']>;
  firstName: Scalars['String']['input'];
  fundingNotes?: InputMaybe<Scalars['String']['input']>;
  fundingSupport?: InputMaybe<FundingSupport>;
  gender?: InputMaybe<Gender>;
  hasAcatApproval?: InputMaybe<Scalars['Boolean']['input']>;
  inquirySource?: InputMaybe<InquirySource>;
  interestedInHomeCare?: InputMaybe<Scalars['Boolean']['input']>;
  isFundingEligible?: InputMaybe<Scalars['Boolean']['input']>;
  lastName: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  preferredName?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<WaitingListPriority>;
  receivingCareAtHome?: InputMaybe<Scalars['Boolean']['input']>;
  referralDate?: InputMaybe<Scalars['DateTime']['input']>;
  referralSource?: InputMaybe<Scalars['String']['input']>;
  referredBy?: InputMaybe<Scalars['String']['input']>;
  roomPreferences?: InputMaybe<RoomPreferencesInput>;
  suitabilityAssessment?: InputMaybe<SuitabilityAssessmentInput>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CreateWaterlowAssessmentInput = {
  age: Scalars['Int']['input'];
  appetite: Scalars['Int']['input'];
  assessmentDate?: InputMaybe<Scalars['DateTime']['input']>;
  autoProgressNote?: InputMaybe<Scalars['Boolean']['input']>;
  buildWeight: Scalars['Int']['input'];
  continence: Scalars['Int']['input'];
  gender: Scalars['Int']['input'];
  medication: Scalars['Int']['input'];
  mobility: Scalars['Int']['input'];
  neurologicalDeficit: Scalars['Int']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  residentId: Scalars['ID']['input'];
  skinType: Scalars['Int']['input'];
  surgery: Scalars['Int']['input'];
  tissueNutrition: Scalars['Int']['input'];
};

export type CreateWeightObservationInput = {
  autoProgressNote?: InputMaybe<Scalars['Boolean']['input']>;
  residentId: Scalars['ID']['input'];
  takenAt?: InputMaybe<Scalars['DateTime']['input']>;
  weight: Scalars['Float']['input'];
};

export type CreateWithdrawalRequestInput = {
  amount: Scalars['Float']['input'];
  asset: SupportedAsset;
  chain: SupportedChain;
  destinationAddress: Scalars['String']['input'];
  vaultId: Scalars['String']['input'];
  withdrawalType: WithdrawalType;
};

export type CreateWorkerInput = {
  availableHoursPerWeek?: InputMaybe<Scalars['Int']['input']>;
  certifications?: InputMaybe<Array<WorkerCertificationInput>>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  documents?: InputMaybe<Array<WorkerDocumentInput>>;
  education?: InputMaybe<Array<WorkerEducationInput>>;
  email?: InputMaybe<Scalars['String']['input']>;
  experience?: InputMaybe<Array<WorkerExperienceInput>>;
  firstName: Scalars['String']['input'];
  isAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  languages?: InputMaybe<Array<WorkerLanguageInput>>;
  lastName: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  preferredWorkingHours?: InputMaybe<Scalars['String']['input']>;
  profilePhoto?: InputMaybe<Scalars['String']['input']>;
  referralPercentage?: InputMaybe<Scalars['Float']['input']>;
  referredBy?: InputMaybe<Scalars['String']['input']>;
  skills?: InputMaybe<Array<Scalars['String']['input']>>;
  status?: InputMaybe<WorkerStatus>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  videoIntroUrl?: InputMaybe<Scalars['String']['input']>;
};

export type CreateWorkerTimeEntryInput = {
  category: WorkerTimeEntryCategory;
  date: Scalars['DateTime']['input'];
  description: Scalars['String']['input'];
  durationMinutes: Scalars['Int']['input'];
  hourlyRate: Scalars['Float']['input'];
  lawFirmName: Scalars['String']['input'];
  matterReference: Scalars['String']['input'];
  workerId: Scalars['ID']['input'];
};

export type CreateWoundAssessmentInput = {
  assessmentDate?: InputMaybe<Scalars['DateTime']['input']>;
  autoProgressNote?: InputMaybe<Scalars['Boolean']['input']>;
  depthCm?: InputMaybe<Scalars['Float']['input']>;
  dressingApplied?: InputMaybe<Scalars['String']['input']>;
  exudateAmount?: InputMaybe<ExudateAmount>;
  exudateType?: InputMaybe<ExudateType>;
  lengthCm?: InputMaybe<Scalars['Float']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  painLevel?: InputMaybe<Scalars['Int']['input']>;
  periwoundSkin?: InputMaybe<Scalars['String']['input']>;
  residentId: Scalars['ID']['input'];
  signsOfInfection?: InputMaybe<Array<Scalars['String']['input']>>;
  widthCm?: InputMaybe<Scalars['Float']['input']>;
  woundBed?: InputMaybe<WoundBedAppearance>;
  woundId: Scalars['ID']['input'];
};

export type CreateWoundInput = {
  bodyLocation: BodyLocation;
  cause?: InputMaybe<Scalars['String']['input']>;
  locationDetail?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  onsetDate: Scalars['DateTime']['input'];
  pressureInjuryStage?: InputMaybe<PressureInjuryStage>;
  residentId: Scalars['ID']['input'];
  status?: InputMaybe<WoundStatus>;
  woundType: WoundType;
};

export type CredentialChecklistItem = {
  __typename?: 'CredentialChecklistItem';
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

export type CredentialChecklistStatus = {
  __typename?: 'CredentialChecklistStatus';
  complete: Scalars['Boolean']['output'];
  missing: Array<CredentialChecklistItem>;
  required: Array<CredentialChecklistItem>;
};

export type CrewSiteView = {
  __typename?: 'CrewSiteView';
  address: Scalars['String']['output'];
  crewName: Scalars['String']['output'];
  name: Scalars['String']['output'];
  siteId: Scalars['ID']['output'];
  siteNumber: Scalars['Float']['output'];
  submittedToday: Scalars['Boolean']['output'];
};

export type CrmSyncResult = {
  __typename?: 'CrmSyncResult';
  crmType?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  ghlContactId?: Maybe<Scalars['String']['output']>;
  ghlOpportunityId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type CryptoVault = {
  __typename?: 'CryptoVault';
  balances?: Maybe<Array<VaultBalance>>;
  contractAddress?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  lastDepositAt?: Maybe<Scalars['DateTime']['output']>;
  lastWithdrawalAt?: Maybe<Scalars['DateTime']['output']>;
  notificationConfigHash?: Maybe<Scalars['String']['output']>;
  notificationContacts?: Maybe<Array<NotificationContact>>;
  ownerBtcAddress?: Maybe<Scalars['String']['output']>;
  ownerEmail?: Maybe<Scalars['String']['output']>;
  ownerId: Scalars['ID']['output'];
  ownerName: Scalars['String']['output'];
  ownerWalletAddress?: Maybe<Scalars['String']['output']>;
  status: VaultStatus;
  tenantId: Scalars['String']['output'];
  timelockDays: Scalars['Float']['output'];
  totalDepositedUsd: Scalars['Float']['output'];
  totalFeesCollected: Scalars['Float']['output'];
  updatedAt: Scalars['DateTime']['output'];
  validatorIds: Array<Scalars['String']['output']>;
  validatorWalletAddresses: Array<Scalars['String']['output']>;
};

export type CryptoWalletDetails = {
  __typename?: 'CryptoWalletDetails';
  memo?: Maybe<Scalars['String']['output']>;
  network?: Maybe<Scalars['String']['output']>;
  walletAddress?: Maybe<Scalars['String']['output']>;
};

export type CryptoWalletDetailsInput = {
  memo?: InputMaybe<Scalars['String']['input']>;
  network?: InputMaybe<Scalars['String']['input']>;
  walletAddress?: InputMaybe<Scalars['String']['input']>;
};

/** Visual style for the email CTA button */
export enum CtaButtonStyle {
  Primary = 'PRIMARY',
  Secondary = 'SECONDARY',
  Subtle = 'SUBTLE'
}

export type CurrentBmi = {
  __typename?: 'CurrentBMI';
  bmi?: Maybe<Scalars['Float']['output']>;
  calculatedAt?: Maybe<Scalars['DateTime']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  hasData: Scalars['Boolean']['output'];
  height?: Maybe<Scalars['Float']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
};

export type CurrentDraftInput = {
  emailBody: Scalars['String']['input'];
  emailSubject: Scalars['String']['input'];
  smsCharCount: Scalars['Int']['input'];
  smsContent: Scalars['String']['input'];
  smsOverLimit: Scalars['Boolean']['input'];
};

export type CustodyValidator = {
  __typename?: 'CustodyValidator';
  assignedVaults: Scalars['Int']['output'];
  averageResponseTimeMinutes?: Maybe<Scalars['Float']['output']>;
  btcPublicKey?: Maybe<Scalars['String']['output']>;
  clientId: Scalars['ID']['output'];
  completedApprovals: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastApprovalAt?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  registeredAt: Scalars['DateTime']['output'];
  stakedAmount: Scalars['Float']['output'];
  status: ValidatorStatus;
  tenantId: Scalars['String']['output'];
  totalFeesEarned: Scalars['Float']['output'];
  updatedAt: Scalars['DateTime']['output'];
  walletAddress: Scalars['String']['output'];
};

export type CustomAnswerInput = {
  answer?: InputMaybe<Scalars['String']['input']>;
  customQuestionId: Scalars['ID']['input'];
  multipleAnswers?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CustomAnswerWithQuestion = {
  __typename?: 'CustomAnswerWithQuestion';
  answer?: Maybe<Scalars['String']['output']>;
  answeredAt?: Maybe<Scalars['DateTime']['output']>;
  answeredByName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  multipleAnswers?: Maybe<Array<Scalars['String']['output']>>;
  question: Scalars['String']['output'];
  questionId: Scalars['ID']['output'];
  questionType: Scalars['String']['output'];
};

export type CustomFieldResponse = {
  __typename?: 'CustomFieldResponse';
  fieldId: Scalars['ID']['output'];
  fieldType: Scalars['String']['output'];
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type CustomFieldResponseInput = {
  fieldId: Scalars['ID']['input'];
  fieldType: Scalars['String']['input'];
  label: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

/** Type of custom question field */
export enum CustomQuestionType {
  Checkbox = 'CHECKBOX',
  Date = 'DATE',
  Multiselect = 'MULTISELECT',
  Number = 'NUMBER',
  Select = 'SELECT',
  Text = 'TEXT'
}

export type CustomTestDefinition = {
  __typename?: 'CustomTestDefinition';
  assignedRole: Scalars['String']['output'];
  category: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['ID']['output'];
  createdByName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isArchived: Scalars['Boolean']['output'];
  isSystem: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  moduleId: Scalars['String']['output'];
  moduleName: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  tier: TestTier;
  updatedAt: Scalars['DateTime']['output'];
  userStoryAction?: Maybe<Scalars['String']['output']>;
  userStoryExpected?: Maybe<Scalars['String']['output']>;
  userStoryPage?: Maybe<Scalars['String']['output']>;
  userStoryRole?: Maybe<Scalars['String']['output']>;
};

export type CustomizeLeadFlowActionInput = {
  actionId: Scalars['String']['input'];
  instruction: Scalars['String']['input'];
  leadId: Scalars['String']['input'];
};

export type CustomizeP2ActionInput = {
  actionId: Scalars['String']['input'];
  instruction: Scalars['String']['input'];
  orderId: Scalars['String']['input'];
};

export type CustomizedLeadFlowAction = {
  __typename?: 'CustomizedLeadFlowAction';
  body: Scalars['String']['output'];
  htmlBody?: Maybe<Scalars['String']['output']>;
  isHtml?: Maybe<Scalars['Boolean']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
};

export type CustomizedP2Action = {
  __typename?: 'CustomizedP2Action';
  body: Scalars['String']['output'];
  htmlBody?: Maybe<Scalars['String']['output']>;
  isHtml?: Maybe<Scalars['Boolean']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
};

/** Type of DVA card held by the resident */
export enum DvaCardType {
  Gold = 'GOLD',
  None = 'NONE',
  White = 'WHITE'
}

export type DvaDetails = {
  __typename?: 'DVADetails';
  cardType?: Maybe<DvaCardType>;
  number?: Maybe<Scalars['String']['output']>;
};

export type DvaDetailsInput = {
  cardType?: InputMaybe<DvaCardType>;
  number?: InputMaybe<Scalars['String']['input']>;
};

export type DailyAllocationSheet = {
  __typename?: 'DailyAllocationSheet';
  createdAt: Scalars['DateTime']['output'];
  date: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  versions: Array<DailyAllocationVersion>;
};

export type DailyAllocationStaleness = {
  __typename?: 'DailyAllocationStaleness';
  date: Scalars['DateTime']['output'];
  isStale: Scalars['Boolean']['output'];
  latestUploadedAt?: Maybe<Scalars['DateTime']['output']>;
  versionCount: Scalars['Int']['output'];
};

export type DailyAllocationVersion = {
  __typename?: 'DailyAllocationVersion';
  fileName: Scalars['String']['output'];
  fileSize: Scalars['Int']['output'];
  ipfsCid: Scalars['String']['output'];
  mimeType: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  uploadedAt: Scalars['DateTime']['output'];
  uploadedById?: Maybe<Scalars['ID']['output']>;
  uploadedByName?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
  version: Scalars['Int']['output'];
};

/** Result of generating calendar events from daily care profile */
export type DailyCareCalendarResult = {
  __typename?: 'DailyCareCalendarResult';
  created: Scalars['Int']['output'];
  deleted: Scalars['Int']['output'];
  eventIds: Array<Scalars['String']['output']>;
  updated: Scalars['Int']['output'];
};

/** Daily care profile section heading configuration */
export type DailyCareHeadingConfig = {
  __typename?: 'DailyCareHeadingConfig';
  _id: Scalars['ID']['output'];
  behaviorHeading?: Maybe<Scalars['String']['output']>;
  careImplementedHeading?: Maybe<Scalars['String']['output']>;
  careNeedsHeading?: Maybe<Scalars['String']['output']>;
  communicationHeading?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  delegateToHeading?: Maybe<Scalars['String']['output']>;
  eliminationHeading?: Maybe<Scalars['String']['output']>;
  hygieneHeading?: Maybe<Scalars['String']['output']>;
  leisureHeading?: Maybe<Scalars['String']['output']>;
  mobilityHeading?: Maybe<Scalars['String']['output']>;
  nutritionHeading?: Maybe<Scalars['String']['output']>;
  painHeading?: Maybe<Scalars['String']['output']>;
  physioTherapyHeading?: Maybe<Scalars['String']['output']>;
  pressureCareHeading?: Maybe<Scalars['String']['output']>;
  profileType: ProfileType;
  restraintHeading?: Maybe<Scalars['String']['output']>;
  skinIntegrityHeading?: Maybe<Scalars['String']['output']>;
  sleepHeading?: Maybe<Scalars['String']['output']>;
  specialHeading?: Maybe<Scalars['String']['output']>;
  supportingEvidenceHeading?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** Input for configuring daily care headings */
export type DailyCareHeadingsInput = {
  behaviorHeading?: InputMaybe<Scalars['String']['input']>;
  careImplementedHeading?: InputMaybe<Scalars['String']['input']>;
  careNeedsHeading?: InputMaybe<Scalars['String']['input']>;
  communicationHeading?: InputMaybe<Scalars['String']['input']>;
  delegateToHeading?: InputMaybe<Scalars['String']['input']>;
  eliminationHeading?: InputMaybe<Scalars['String']['input']>;
  hygieneHeading?: InputMaybe<Scalars['String']['input']>;
  leisureHeading?: InputMaybe<Scalars['String']['input']>;
  mobilityHeading?: InputMaybe<Scalars['String']['input']>;
  nutritionHeading?: InputMaybe<Scalars['String']['input']>;
  painHeading?: InputMaybe<Scalars['String']['input']>;
  physioTherapyHeading?: InputMaybe<Scalars['String']['input']>;
  pressureCareHeading?: InputMaybe<Scalars['String']['input']>;
  restraintHeading?: InputMaybe<Scalars['String']['input']>;
  skinIntegrityHeading?: InputMaybe<Scalars['String']['input']>;
  sleepHeading?: InputMaybe<Scalars['String']['input']>;
  specialHeading?: InputMaybe<Scalars['String']['input']>;
  supportingEvidenceHeading?: InputMaybe<Scalars['String']['input']>;
};

export type DailyCareProfile = {
  __typename?: 'DailyCareProfile';
  activities?: Maybe<ActivitiesProfile>;
  behavioralConsiderations?: Maybe<BehavioralConsiderations>;
  communication?: Maybe<CommunicationProfile>;
  createdAt: Scalars['DateTime']['output'];
  effectiveDate: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  /** A superseded SarahCare version — history only, never the current profile */
  isSarahHistory?: Maybe<Scalars['Boolean']['output']>;
  lastUpdatedBy: Scalars['ID']['output'];
  lastUpdatedByName?: Maybe<Scalars['String']['output']>;
  lastUpdatedDate: Scalars['DateTime']['output'];
  mobility?: Maybe<MobilityProfile>;
  notes?: Maybe<Scalars['String']['output']>;
  nutrition?: Maybe<NutritionProfile>;
  pain?: Maybe<PainProfile>;
  personalCare?: Maybe<PersonalCare>;
  pressureCare?: Maybe<PressureCareProfile>;
  profileType: ProfileType;
  residentId: Scalars['ID']['output'];
  sarahSource?: Maybe<SarahDailyCareSourceFields>;
  sleepPattern?: Maybe<SleepPattern>;
  sourceAuthor?: Maybe<Scalars['String']['output']>;
  sourceBackupDate?: Maybe<Scalars['DateTime']['output']>;
  sourceHash?: Maybe<Scalars['String']['output']>;
  sourceId?: Maybe<Scalars['String']['output']>;
  sourceSystem?: Maybe<Scalars['String']['output']>;
  /** When SarahCare archived (replaced) this version */
  supersededDate?: Maybe<Scalars['DateTime']['output']>;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type DailyCareProfileFilterInput = {
  /** Also return superseded SarahCare versions (hidden by default) */
  includeSarahHistory?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Float']['input']>;
  offset?: InputMaybe<Scalars['Float']['input']>;
  profileType?: InputMaybe<ProfileType>;
  residentId?: InputMaybe<Scalars['ID']['input']>;
  /** Return ONLY superseded SarahCare versions */
  sarahHistoryOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DailyCareProfilesResponse = {
  __typename?: 'DailyCareProfilesResponse';
  limit: Scalars['Int']['output'];
  offset: Scalars['Int']['output'];
  profiles: Array<DailyCareProfile>;
  total: Scalars['Int']['output'];
};

export type DailyQrCode = {
  __typename?: 'DailyQRCode';
  code: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  expiresAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  lastScannedAt?: Maybe<Scalars['DateTime']['output']>;
  lastScannedBy?: Maybe<Scalars['String']['output']>;
  locationCode?: Maybe<Scalars['String']['output']>;
  locationId: Scalars['ID']['output'];
  locationName?: Maybe<Scalars['String']['output']>;
  scanCount: Scalars['Float']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  validDate: Scalars['DateTime']['output'];
};

export type DailyTrendDataPoint = {
  __typename?: 'DailyTrendDataPoint';
  byType: Array<IncidentTrendByType>;
  date: Scalars['String']['output'];
};

export type DashboardShortAssessment = {
  __typename?: 'DashboardShortAssessment';
  age?: Maybe<Scalars['Int']['output']>;
  anxietyScore?: Maybe<Scalars['Int']['output']>;
  disabilityScore?: Maybe<Scalars['Int']['output']>;
  goals?: Maybe<Scalars['String']['output']>;
  hospital?: Maybe<Scalars['String']['output']>;
  painScore?: Maybe<Scalars['Int']['output']>;
};

export type DashboardShortAssessmentInput = {
  age?: InputMaybe<Scalars['Int']['input']>;
  anxietyScore?: InputMaybe<Scalars['Int']['input']>;
  disabilityScore?: InputMaybe<Scalars['Int']['input']>;
  goals?: InputMaybe<Scalars['String']['input']>;
  hospital?: InputMaybe<Scalars['String']['input']>;
  painScore?: InputMaybe<Scalars['Int']['input']>;
};

export type DashboardSurgeryInput = {
  surgeryDate?: InputMaybe<Scalars['DateTime']['input']>;
  surgeryDateIsRough?: InputMaybe<Scalars['Boolean']['input']>;
  surgeryTimeframe?: InputMaybe<Scalars['String']['input']>;
  surgeryType?: InputMaybe<Scalars['String']['input']>;
};

export type DashboardTodo = {
  __typename?: 'DashboardTodo';
  done: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
  seeded: Scalars['Boolean']['output'];
  sortOrder: Scalars['Int']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type DashboardTodoInput = {
  done?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['String']['input'];
  label: Scalars['String']['input'];
  seeded?: InputMaybe<Scalars['Boolean']['input']>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/** Source of fuel data */
export enum DataSource {
  Api = 'API',
  Estimate = 'ESTIMATE',
  Manual = 'MANUAL',
  Osm = 'OSM'
}

/** Predefined date ranges for analytics queries */
export enum DateRange {
  Custom = 'CUSTOM',
  Last_7Days = 'LAST_7_DAYS',
  Last_30Days = 'LAST_30_DAYS',
  Last_90Days = 'LAST_90_DAYS',
  LastMonth = 'LAST_MONTH',
  ThisMonth = 'THIS_MONTH',
  Today = 'TODAY',
  Yesterday = 'YESTERDAY'
}

export type DayBookEntriesResponse = {
  __typename?: 'DayBookEntriesResponse';
  entries: Array<DayBookEntry>;
  limit: Scalars['Int']['output'];
  offset: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  unreadCount: Scalars['Int']['output'];
};

export type DayBookEntry = {
  __typename?: 'DayBookEntry';
  content: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['ID']['output'];
  createdByName?: Maybe<Scalars['String']['output']>;
  entryDate: Scalars['DateTime']['output'];
  entryTime?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type DayBookFilterInput = {
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type DayBookSignOff = {
  __typename?: 'DayBookSignOff';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  signedOffAt: Scalars['DateTime']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  userId: Scalars['ID']['output'];
  userName?: Maybe<Scalars['String']['output']>;
};

export type DayBookSignOffHistoryResponse = {
  __typename?: 'DayBookSignOffHistoryResponse';
  byDate?: Maybe<Array<SignOffHistoryByDate>>;
  byLogin?: Maybe<Array<SignOffHistoryByLogin>>;
  type: SignOffHistoryType;
};

/** Days of the week */
export enum DayOfWeek {
  Friday = 'FRIDAY',
  Monday = 'MONDAY',
  Saturday = 'SATURDAY',
  Sunday = 'SUNDAY',
  Thursday = 'THURSDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY'
}

export type DealFieldChange = {
  __typename?: 'DealFieldChange';
  field: Scalars['String']['output'];
  from?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  to?: Maybe<Scalars['String']['output']>;
};

/** What was done with the month's surplus. Recorded; never executed. */
export type DecideBankingMonthInput = {
  boughtOn?: InputMaybe<Scalars['String']['input']>;
  btcAudMinor?: InputMaybe<Scalars['Int']['input']>;
  btcSats?: InputMaybe<Scalars['Int']['input']>;
  decision: BankingMonthDecision;
  goldAudMinor?: InputMaybe<Scalars['Int']['input']>;
  goldGrams?: InputMaybe<Scalars['Float']['input']>;
  month: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
};

export type DeclineMedicalRecordAccessRequestInput = {
  note: Scalars['String']['input'];
  requestId: Scalars['ID']['input'];
};

export type DeductionEntry = {
  __typename?: 'DeductionEntry';
  amount: Scalars['Float']['output'];
  description: Scalars['String']['output'];
};

export type DeductionEntryInput = {
  amount: Scalars['Float']['input'];
  description: Scalars['String']['input'];
};

/** STP Phase 2 deduction type code */
export enum DeductionTypeCode {
  F = 'F',
  G = 'G',
  H = 'H',
  Rd = 'RD',
  W = 'W'
}

export type DeleteEventResponse = {
  __typename?: 'DeleteEventResponse';
  attendeesNotified?: Maybe<Scalars['Int']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  notifyMessage?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type DeleteMedicalRecordInput = {
  reason: Scalars['String']['input'];
  recordId: Scalars['ID']['input'];
};

export type DeleteMyCommunityDataInput = {
  confirm: Scalars['String']['input'];
  leaveCommunity?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DeleteResult = {
  __typename?: 'DeleteResult';
  databaseDeleted: Scalars['Boolean']['output'];
  ipfsUnpinned: Scalars['Boolean']['output'];
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Food temperature category for an incoming supplier delivery */
export enum DeliveryFoodType {
  Chilled = 'CHILLED',
  Frozen = 'FROZEN'
}

export type DemographicStats = {
  __typename?: 'DemographicStats';
  averageAge: Scalars['Int']['output'];
  careTypeDistribution: Array<CareTypeDistribution>;
  entryTypeDistribution: Array<EntryTypeDistribution>;
  genderDistribution: Array<GenderDistribution>;
};

export type Department = {
  __typename?: 'Department';
  code: Scalars['String']['output'];
  color?: Maybe<Scalars['String']['output']>;
  countsTowardCareMinutes: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  displayOrder?: Maybe<Scalars['Float']['output']>;
  employeeUsageCount: Scalars['Int']['output'];
  employeeUsageNames: Array<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  shiftUsageCount: Scalars['Int']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type DepartmentInput = {
  code: Scalars['String']['input'];
  color?: InputMaybe<Scalars['String']['input']>;
  countsTowardCareMinutes?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayOrder?: InputMaybe<Scalars['Float']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
};

export type DepartmentLeaveEntry = {
  __typename?: 'DepartmentLeaveEntry';
  endDate: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  leaveType: Scalars['String']['output'];
  partialDayType: Scalars['String']['output'];
  startDate: Scalars['DateTime']['output'];
  status: Scalars['String']['output'];
};

export type DeploymentInfo = {
  __typename?: 'DeploymentInfo';
  commitMessage?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  id: Scalars['String']['output'];
  state: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type DeploymentResult = {
  __typename?: 'DeploymentResult';
  commitSha?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  repoName: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
  tenantId: Scalars['String']['output'];
  tenantName: Scalars['String']['output'];
};

export type DeploymentSummary = {
  __typename?: 'DeploymentSummary';
  deploymentResults: Array<ModuleDeploymentResult>;
  newModules: Array<Scalars['String']['output']>;
};

export type DevServerLogsResult = {
  __typename?: 'DevServerLogsResult';
  categorized: CategorizedLogs;
  error?: Maybe<Scalars['String']['output']>;
  logs: Array<LogEntry>;
  service: Scalars['String']['output'];
  siteId: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
  totalLines: Scalars['Float']['output'];
};

export type DeviceStats = {
  __typename?: 'DeviceStats';
  deviceType: Scalars['String']['output'];
  percentage: Scalars['Float']['output'];
  sessions: Scalars['Int']['output'];
};

/** Type of diet for the resident */
export enum DietType {
  Diabetic = 'DIABETIC',
  GlutenFree = 'GLUTEN_FREE',
  Halal = 'HALAL',
  HighProtein = 'HIGH_PROTEIN',
  Kosher = 'KOSHER',
  LowFat = 'LOW_FAT',
  LowSalt = 'LOW_SALT',
  Normal = 'NORMAL',
  Puree = 'PUREE',
  Soft = 'SOFT',
  TextureModified = 'TEXTURE_MODIFIED',
  ThickenedFluids = 'THICKENED_FLUIDS',
  Vegan = 'VEGAN',
  Vegetarian = 'VEGETARIAN'
}

/** Dietary restrictions and preferences for recipes */
export enum DietaryTag {
  DairyFree = 'DAIRY_FREE',
  DiabeticFriendly = 'DIABETIC_FRIENDLY',
  GlutenFree = 'GLUTEN_FREE',
  Halal = 'HALAL',
  Kosher = 'KOSHER',
  LowSodium = 'LOW_SODIUM',
  NutFree = 'NUT_FREE',
  Vegan = 'VEGAN',
  Vegetarian = 'VEGETARIAN'
}

export type DigitalManager = {
  __typename?: 'DigitalManager';
  avatarCid?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  digitalClientId?: Maybe<Scalars['ID']['output']>;
  digitalEmailAddressId?: Maybe<Scalars['ID']['output']>;
  digitalEmployeeId?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  lastRunAt?: Maybe<Scalars['DateTime']['output']>;
  m365SharedMailboxId?: Maybe<Scalars['String']['output']>;
  m365TransportRuleId?: Maybe<Scalars['String']['output']>;
  modelOverride?: Maybe<Scalars['String']['output']>;
  nextRunAt?: Maybe<Scalars['DateTime']['output']>;
  personaName: Scalars['String']['output'];
  proactiveChasingEnabled: Scalars['Boolean']['output'];
  reportTo: Array<DigitalManagerReportToContact>;
  responsibilitiesMarkdown: Scalars['String']['output'];
  scheduleCron: Scalars['String']['output'];
  scopeToolIds: Array<Scalars['String']['output']>;
  standupCron: Scalars['String']['output'];
  standupEnabled: Scalars['Boolean']['output'];
  status: DigitalManagerStatus;
  template: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  timezone: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export enum DigitalManagerChaseChannel {
  Email = 'EMAIL',
  Sms = 'SMS'
}

export type DigitalManagerChaseFilterInput = {
  managerId?: InputMaybe<Scalars['ID']['input']>;
  reportToClientId?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<DigitalManagerChaseStatus>;
};

export type DigitalManagerChaseItem = {
  __typename?: 'DigitalManagerChaseItem';
  blockingSessionId?: Maybe<Scalars['String']['output']>;
  body: Scalars['String']['output'];
  channel: DigitalManagerChaseChannel;
  createdAt: Scalars['DateTime']['output'];
  failureReason?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  managerId: Scalars['ID']['output'];
  metadata?: Maybe<Scalars['JSONObject']['output']>;
  reportToClientId: Scalars['ID']['output'];
  resolvedAt?: Maybe<Scalars['DateTime']['output']>;
  respondedAt?: Maybe<Scalars['DateTime']['output']>;
  responseEmailId?: Maybe<Scalars['String']['output']>;
  responseText?: Maybe<Scalars['String']['output']>;
  sentAt?: Maybe<Scalars['DateTime']['output']>;
  status: DigitalManagerChaseStatus;
  subject: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export enum DigitalManagerChaseStatus {
  Dismissed = 'DISMISSED',
  Draft = 'DRAFT',
  Failed = 'FAILED',
  Resolved = 'RESOLVED',
  Responded = 'RESPONDED',
  Sent = 'SENT'
}

export type DigitalManagerFilterInput = {
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<DigitalManagerStatus>;
  template?: InputMaybe<Scalars['String']['input']>;
};

export type DigitalManagerInputSnapshot = {
  __typename?: 'DigitalManagerInputSnapshot';
  recordId: Scalars['String']['output'];
  recordType: Scalars['String']['output'];
  snapshotJson: Scalars['String']['output'];
};

export type DigitalManagerM365SetupStatusType = {
  __typename?: 'DigitalManagerM365SetupStatusType';
  automationAttempted: Scalars['Boolean']['output'];
  automationErrors: Array<Scalars['String']['output']>;
  sharedMailboxLikely: Scalars['Boolean']['output'];
  transportRuleLikely: Scalars['Boolean']['output'];
};

export type DigitalManagerMemory = {
  __typename?: 'DigitalManagerMemory';
  active: Scalars['Boolean']['output'];
  body: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  managerId: Scalars['ID']['output'];
  priority: Scalars['Float']['output'];
  scope: DigitalManagerMemoryScope;
  scopeValue?: Maybe<Scalars['String']['output']>;
  source: DigitalManagerMemorySource;
  tags: Array<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type DigitalManagerMemoryFilterInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  managerId: Scalars['ID']['input'];
  scope?: InputMaybe<DigitalManagerMemoryScope>;
  scopeValue?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export enum DigitalManagerMemoryScope {
  Global = 'GLOBAL',
  RecordType = 'RECORD_TYPE',
  ReportTo = 'REPORT_TO',
  SpecificRecord = 'SPECIFIC_RECORD'
}

export enum DigitalManagerMemorySource {
  AiAuto = 'AI_AUTO',
  AiSuggested = 'AI_SUGGESTED',
  User = 'USER'
}

/** How to resolve the notification recipient(s) */
export enum DigitalManagerNotificationRecipientType {
  AllDigitalManagerAdmins = 'ALL_DIGITAL_MANAGER_ADMINS',
  ReportToChain = 'REPORT_TO_CHAIN',
  Role = 'ROLE',
  SpecificClient = 'SPECIFIC_CLIENT'
}

export type DigitalManagerNotificationRule = {
  __typename?: 'DigitalManagerNotificationRule';
  channels: Array<Scalars['String']['output']>;
  costThresholdCents?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  filterManagerId?: Maybe<Scalars['ID']['output']>;
  filterPriority?: Maybe<Scalars['String']['output']>;
  filterStatus?: Maybe<Scalars['String']['output']>;
  filterTemplate?: Maybe<Scalars['String']['output']>;
  fireCount: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  isEnabled: Scalars['Boolean']['output'];
  lastFiredAt?: Maybe<Scalars['DateTime']['output']>;
  messageTemplate?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  recipientIds?: Maybe<Array<Scalars['String']['output']>>;
  recipientRole?: Maybe<Scalars['String']['output']>;
  recipientType: DigitalManagerNotificationRecipientType;
  tenantId: Scalars['String']['output'];
  timing: DigitalManagerNotificationTiming;
  timingMinutes?: Maybe<Scalars['Int']['output']>;
  trigger: DigitalManagerNotificationTrigger;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type DigitalManagerNotificationRuleFilterInput = {
  filterManagerId?: InputMaybe<Scalars['ID']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  trigger?: InputMaybe<DigitalManagerNotificationTrigger>;
};

/** When to send the notification relative to the trigger */
export enum DigitalManagerNotificationTiming {
  Immediate = 'IMMEDIATE',
  MinutesAfter = 'MINUTES_AFTER',
  MinutesBefore = 'MINUTES_BEFORE'
}

/** Event that triggers a digital-manager notification dispatch */
export enum DigitalManagerNotificationTrigger {
  ChaseFailed = 'CHASE_FAILED',
  ChaseResolved = 'CHASE_RESOLVED',
  ChaseResponded = 'CHASE_RESPONDED',
  ChaseSent = 'CHASE_SENT',
  CostThresholdExceeded = 'COST_THRESHOLD_EXCEEDED',
  ManagerOverdue = 'MANAGER_OVERDUE',
  ManagerPaused = 'MANAGER_PAUSED',
  ManagerProvisioned = 'MANAGER_PROVISIONED',
  ManagerResumed = 'MANAGER_RESUMED',
  ManagerRetired = 'MANAGER_RETIRED',
  MemoryCreatedByAi = 'MEMORY_CREATED_BY_AI',
  OqEnqueued = 'OQ_ENQUEUED',
  OqHighPriorityEnqueued = 'OQ_HIGH_PRIORITY_ENQUEUED',
  SessionCompleted = 'SESSION_COMPLETED',
  SessionFailed = 'SESSION_FAILED',
  SessionSkipped = 'SESSION_SKIPPED',
  StandupFailed = 'STANDUP_FAILED',
  StandupPartial = 'STANDUP_PARTIAL',
  StandupSent = 'STANDUP_SENT'
}

export type DigitalManagerOqContext = {
  __typename?: 'DigitalManagerOQContext';
  classification?: Maybe<Scalars['String']['output']>;
  recordId?: Maybe<Scalars['String']['output']>;
  recordType?: Maybe<Scalars['String']['output']>;
  ruleId?: Maybe<Scalars['String']['output']>;
  sessionId?: Maybe<Scalars['String']['output']>;
};

export enum DigitalManagerOqPriority {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM'
}

export enum DigitalManagerOqStatus {
  Answered = 'ANSWERED',
  Dismissed = 'DISMISSED',
  Expired = 'EXPIRED',
  Open = 'OPEN'
}

export enum DigitalManagerOqTrigger {
  AmbiguousCase = 'AMBIGUOUS_CASE',
  FailedToolCall = 'FAILED_TOOL_CALL',
  NewRecordShape = 'NEW_RECORD_SHAPE',
  PeriodicCheckin = 'PERIODIC_CHECKIN',
  ProposalAwaitingApproval = 'PROPOSAL_AWAITING_APPROVAL',
  RuleConflict = 'RULE_CONFLICT'
}

export type DigitalManagerOutstandingQuestion = {
  __typename?: 'DigitalManagerOutstandingQuestion';
  answer?: Maybe<Scalars['String']['output']>;
  answeredAt?: Maybe<Scalars['DateTime']['output']>;
  answeredBy?: Maybe<Scalars['String']['output']>;
  approvedAt?: Maybe<Scalars['DateTime']['output']>;
  approvedByClientId?: Maybe<Scalars['String']['output']>;
  approverEmailSentAt?: Maybe<Scalars['DateTime']['output']>;
  askedAt: Scalars['DateTime']['output'];
  context?: Maybe<DigitalManagerOqContext>;
  createdAt: Scalars['DateTime']['output'];
  executionResultJson?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  managerId: Scalars['ID']['output'];
  priority: DigitalManagerOqPriority;
  proposalDiff?: Maybe<Array<Scalars['String']['output']>>;
  proposalKind?: Maybe<DmOqProposalKind>;
  proposalPayload?: Maybe<Scalars['JSONObject']['output']>;
  proposalSummaryMarkdown?: Maybe<Scalars['String']['output']>;
  proposedActions: Array<Scalars['String']['output']>;
  question: Scalars['String']['output'];
  rejectionReason?: Maybe<Scalars['String']['output']>;
  resultingMemoryId?: Maybe<Scalars['String']['output']>;
  status: DigitalManagerOqStatus;
  tenantId: Scalars['String']['output'];
  triggerType: DigitalManagerOqTrigger;
  updatedAt: Scalars['DateTime']['output'];
};

export type DigitalManagerReportToContact = {
  __typename?: 'DigitalManagerReportToContact';
  clientId: Scalars['ID']['output'];
  displayName?: Maybe<Scalars['String']['output']>;
};

export type DigitalManagerReportToContactInput = {
  clientId: Scalars['ID']['input'];
  displayName?: InputMaybe<Scalars['String']['input']>;
};

export type DigitalManagerRule = {
  __typename?: 'DigitalManagerRule';
  actions: Array<DigitalManagerRuleAction>;
  conditionCombinator: DigitalManagerRuleCombinator;
  conditions: Array<DigitalManagerRuleCondition>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  createdBySource: DigitalManagerRuleSource;
  description?: Maybe<Scalars['String']['output']>;
  enabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  lastMatchedSessionId?: Maybe<Scalars['String']['output']>;
  lastRunAt?: Maybe<Scalars['DateTime']['output']>;
  managerId: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  priority: Scalars['Float']['output'];
  runCount: Scalars['Int']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type DigitalManagerRuleAction = {
  __typename?: 'DigitalManagerRuleAction';
  memoryRefs?: Maybe<Array<Scalars['String']['output']>>;
  template?: Maybe<Scalars['String']['output']>;
  type: DigitalManagerRuleActionType;
  value?: Maybe<Scalars['String']['output']>;
};

export type DigitalManagerRuleActionInput = {
  memoryRefs?: InputMaybe<Array<Scalars['String']['input']>>;
  template?: InputMaybe<Scalars['String']['input']>;
  type: DigitalManagerRuleActionType;
  value?: InputMaybe<Scalars['String']['input']>;
};

export enum DigitalManagerRuleActionType {
  CreateTask = 'CREATE_TASK',
  DraftEmail = 'DRAFT_EMAIL',
  EnqueueChase = 'ENQUEUE_CHASE',
  MarkRecordField = 'MARK_RECORD_FIELD',
  NotifyReportTo = 'NOTIFY_REPORT_TO',
  OpenOutstandingQuestion = 'OPEN_OUTSTANDING_QUESTION'
}

export enum DigitalManagerRuleCombinator {
  All = 'ALL',
  Any = 'ANY'
}

export type DigitalManagerRuleCondition = {
  __typename?: 'DigitalManagerRuleCondition';
  negate?: Maybe<Scalars['Boolean']['output']>;
  type: DigitalManagerRuleConditionType;
  value: Scalars['String']['output'];
};

export type DigitalManagerRuleConditionInput = {
  negate?: InputMaybe<Scalars['Boolean']['input']>;
  type: DigitalManagerRuleConditionType;
  value: Scalars['String']['input'];
};

export enum DigitalManagerRuleConditionType {
  AiClassifiedAs = 'AI_CLASSIFIED_AS',
  HoursSinceFieldGreaterThan = 'HOURS_SINCE_FIELD_GREATER_THAN',
  RecordFieldEquals = 'RECORD_FIELD_EQUALS',
  RecordFieldMissing = 'RECORD_FIELD_MISSING',
  RecordTypeIs = 'RECORD_TYPE_IS'
}

export type DigitalManagerRuleFilterInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  managerId: Scalars['ID']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
};

export enum DigitalManagerRuleSource {
  AiAuto = 'AI_AUTO',
  AiSuggested = 'AI_SUGGESTED',
  User = 'USER'
}

export type DigitalManagerSession = {
  __typename?: 'DigitalManagerSession';
  aiResponseSummary?: Maybe<Scalars['String']['output']>;
  aiSystemPrompt?: Maybe<Scalars['String']['output']>;
  aiUserMessage?: Maybe<Scalars['String']['output']>;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  costCents: Scalars['Float']['output'];
  createdAt: Scalars['DateTime']['output'];
  durationMs: Scalars['Int']['output'];
  errorMessage?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  inputSnapshots: Array<DigitalManagerInputSnapshot>;
  inputTokens: Scalars['Int']['output'];
  managerId: Scalars['ID']['output'];
  model: Scalars['String']['output'];
  outputTokens: Scalars['Int']['output'];
  resultingChaseItemIds: Array<Scalars['String']['output']>;
  resultingOutstandingQuestionIds: Array<Scalars['String']['output']>;
  resultingStandupId?: Maybe<Scalars['String']['output']>;
  status: DigitalManagerSessionStatus;
  tenantId: Scalars['String']['output'];
  toolCalls: Array<DigitalManagerToolCall>;
  triggerContextJson?: Maybe<Scalars['String']['output']>;
  triggerType: DigitalManagerSessionTrigger;
  updatedAt: Scalars['DateTime']['output'];
};

export type DigitalManagerSessionFilterInput = {
  managerId: Scalars['ID']['input'];
  status?: InputMaybe<DigitalManagerSessionStatus>;
  triggerType?: InputMaybe<DigitalManagerSessionTrigger>;
};

export enum DigitalManagerSessionStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Running = 'RUNNING',
  Skipped = 'SKIPPED'
}

export enum DigitalManagerSessionTrigger {
  ChaseResponse = 'CHASE_RESPONSE',
  Cron = 'CRON',
  EventHook = 'EVENT_HOOK',
  InboundEmail = 'INBOUND_EMAIL',
  Manual = 'MANUAL'
}

export type DigitalManagerStandup = {
  __typename?: 'DigitalManagerStandup';
  createdAt: Scalars['DateTime']['output'];
  deliveredAt?: Maybe<Scalars['DateTime']['output']>;
  digestHtml?: Maybe<Scalars['String']['output']>;
  digestMarkdown: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  managerId: Scalars['ID']['output'];
  openChaseItemIds: Array<Scalars['String']['output']>;
  period: DigitalManagerStandupPeriod;
  periodEnd: Scalars['DateTime']['output'];
  periodStart: Scalars['DateTime']['output'];
  recipients: Array<DigitalManagerStandupRecipient>;
  sessionIds: Array<Scalars['String']['output']>;
  status: DigitalManagerStandupStatus;
  subject: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type DigitalManagerStandupFilterInput = {
  managerId: Scalars['ID']['input'];
  period?: InputMaybe<DigitalManagerStandupPeriod>;
  status?: InputMaybe<DigitalManagerStandupStatus>;
};

export enum DigitalManagerStandupPeriod {
  AdHoc = 'AD_HOC',
  Daily = 'DAILY',
  Weekly = 'WEEKLY'
}

export type DigitalManagerStandupRecipient = {
  __typename?: 'DigitalManagerStandupRecipient';
  clientId: Scalars['ID']['output'];
  delivered: Scalars['Boolean']['output'];
  emailAddress: Scalars['String']['output'];
  failureReason?: Maybe<Scalars['String']['output']>;
};

export enum DigitalManagerStandupStatus {
  Failed = 'FAILED',
  Partial = 'PARTIAL',
  Pending = 'PENDING',
  Sent = 'SENT'
}

export enum DigitalManagerStatus {
  Active = 'ACTIVE',
  Paused = 'PAUSED',
  Retired = 'RETIRED'
}

export type DigitalManagerTemplate = {
  __typename?: 'DigitalManagerTemplate';
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  defaultModelOverride?: Maybe<Scalars['String']['output']>;
  defaultPersonaName: Scalars['String']['output'];
  defaultProactiveChasingEnabled: Scalars['Boolean']['output'];
  defaultResponsibilitiesMarkdown: Scalars['String']['output'];
  defaultScheduleCron: Scalars['String']['output'];
  defaultScopeToolIds: Array<Scalars['String']['output']>;
  defaultStandupCron: Scalars['String']['output'];
  defaultStandupEnabled: Scalars['Boolean']['output'];
  defaultTimezone: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  eventHookEntityNames: Array<Scalars['String']['output']>;
  executorBranchExists: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isSystemTemplate: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type DigitalManagerToolCall = {
  __typename?: 'DigitalManagerToolCall';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  startedAt: Scalars['DateTime']['output'];
  status: DigitalManagerToolCallStatus;
  toolInput: Scalars['String']['output'];
  toolName: Scalars['String']['output'];
  toolResult?: Maybe<Scalars['String']['output']>;
};

export enum DigitalManagerToolCallStatus {
  Executed = 'EXECUTED',
  Failed = 'FAILED',
  Pending = 'PENDING'
}

export type DigitizedData = {
  __typename?: 'DigitizedData';
  allowances: Array<AllowanceEntry>;
  award: Scalars['String']['output'];
  classificationLevel: Scalars['String']['output'];
  deductions: Array<DeductionEntry>;
  employeeId?: Maybe<Scalars['String']['output']>;
  employeeName: Scalars['String']['output'];
  employmentType: Scalars['String']['output'];
  grossEarnings: Scalars['Float']['output'];
  netPay: Scalars['Float']['output'];
  payDate: Scalars['String']['output'];
  payPeriodEnd: Scalars['String']['output'];
  payPeriodStart: Scalars['String']['output'];
  position: Scalars['String']['output'];
  timeEntries: Array<TimeEntry>;
  totalDeductions: Scalars['Float']['output'];
};

export type DigitizedDataInput = {
  allowances: Array<AllowanceEntryInput>;
  award: Scalars['String']['input'];
  classificationLevel: Scalars['String']['input'];
  deductions: Array<DeductionEntryInput>;
  employeeId?: InputMaybe<Scalars['String']['input']>;
  employeeName: Scalars['String']['input'];
  employmentType: Scalars['String']['input'];
  grossEarnings: Scalars['Float']['input'];
  netPay: Scalars['Float']['input'];
  payDate: Scalars['String']['input'];
  payPeriodEnd: Scalars['String']['input'];
  payPeriodStart: Scalars['String']['input'];
  position: Scalars['String']['input'];
  timeEntries: Array<TimeEntryInput>;
  totalDeductions: Scalars['Float']['input'];
};

export type DischargeInfo = {
  __typename?: 'DischargeInfo';
  /** Cremation (true) or Burial (false) */
  cremation?: Maybe<Scalars['Boolean']['output']>;
  date?: Maybe<Scalars['DateTime']['output']>;
  /** Time and date of death (if deceased) */
  deceasedDateTime?: Maybe<Scalars['DateTime']['output']>;
  /** Destination (hospital name, facility name, home address) */
  destination?: Maybe<Scalars['String']['output']>;
  funeralArrangements?: Maybe<Scalars['String']['output']>;
  funeralDirector?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<DischargeReason>;
};

export type DischargeInfoInput = {
  cremation?: InputMaybe<Scalars['Boolean']['input']>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  deceasedDateTime?: InputMaybe<Scalars['DateTime']['input']>;
  destination?: InputMaybe<Scalars['String']['input']>;
  funeralArrangements?: InputMaybe<Scalars['String']['input']>;
  funeralDirector?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<DischargeReason>;
};

/** Reason for discharge from the facility */
export enum DischargeReason {
  Deceased = 'DECEASED',
  DeceasedHospital = 'DECEASED_HOSPITAL',
  FacilityTransfer = 'FACILITY_TRANSFER',
  HospitalTransfer = 'HOSPITAL_TRANSFER',
  LeftAgainstAdvice = 'LEFT_AGAINST_ADVICE',
  Other = 'OTHER',
  RespiteEnd = 'RESPITE_END',
  ReturnedHome = 'RETURNED_HOME'
}

export type DischargeResidentInput = {
  /** Cremation (true) or Burial (false) */
  cremation?: InputMaybe<Scalars['Boolean']['input']>;
  /** Date and time of death (if deceased) */
  deceasedDateTime?: InputMaybe<Scalars['DateTime']['input']>;
  /** Destination (hospital, facility, home address) */
  destination?: InputMaybe<Scalars['String']['input']>;
  dischargeDate: Scalars['DateTime']['input'];
  funeralArrangements?: InputMaybe<Scalars['String']['input']>;
  funeralDirector?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  reason: DischargeReason;
};

export enum DmOqProposalKind {
  ProposeApproveLeaveRequest = 'PROPOSE_APPROVE_LEAVE_REQUEST',
  ProposeCalendarEvent = 'PROPOSE_CALENDAR_EVENT',
  ProposeClientNotesUpdate = 'PROPOSE_CLIENT_NOTES_UPDATE',
  ProposeDenyLeaveRequest = 'PROPOSE_DENY_LEAVE_REQUEST',
  ProposeMarkRoomsOccupied = 'PROPOSE_MARK_ROOMS_OCCUPIED',
  ProposeRegisterRoomOccupancy = 'PROPOSE_REGISTER_ROOM_OCCUPANCY'
}

export type DnsRecordInput = {
  mxPriority?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  ttl?: InputMaybe<Scalars['Float']['input']>;
  type: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export enum DoctorTestPolicy {
  AfterOnly = 'AFTER_ONLY',
  BaselineCompare = 'BASELINE_COMPARE'
}

export type DocumentsResponse = {
  __typename?: 'DocumentsResponse';
  documents: Array<IncidentDocument>;
  total: Scalars['Int']['output'];
};

export type DograhAgent = {
  __typename?: 'DograhAgent';
  embedToken?: Maybe<Scalars['String']['output']>;
  key: Scalars['String']['output'];
  workflowId?: Maybe<Scalars['String']['output']>;
};

export type DograhAgentInput = {
  embedToken?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  workflowId?: InputMaybe<Scalars['String']['input']>;
};

export type DograhConfig = {
  __typename?: 'DograhConfig';
  apiBaseUrl?: Maybe<Scalars['String']['output']>;
  embedToken?: Maybe<Scalars['String']['output']>;
  isConfigured: Scalars['Boolean']['output'];
  workflowId?: Maybe<Scalars['String']['output']>;
};

export type Domain = {
  __typename?: 'Domain';
  authCode?: Maybe<Scalars['String']['output']>;
  autoRenew?: Maybe<Scalars['Boolean']['output']>;
  clientId?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['DateTime']['output'];
  cryptoPaymentAddress?: Maybe<Scalars['String']['output']>;
  cryptoTransactionHash?: Maybe<Scalars['String']['output']>;
  domainName: Scalars['String']['output'];
  expiryDate: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  nameservers?: Maybe<Array<DomainNameserver>>;
  notes?: Maybe<Scalars['String']['output']>;
  paymentMethod?: Maybe<Scalars['String']['output']>;
  paymentStatus: DomainPaymentStatus;
  pricing: DomainPricing;
  privacyProtection?: Maybe<Scalars['Boolean']['output']>;
  registrarOrderId?: Maybe<Scalars['String']['output']>;
  registrationDate: Scalars['DateTime']['output'];
  status: DomainStatus;
  tenantId: Scalars['String']['output'];
  tld: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  years: Scalars['Float']['output'];
};

export type DomainAvailability = {
  __typename?: 'DomainAvailability';
  available: Scalars['Boolean']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  domain: Scalars['String']['output'];
  premium?: Maybe<Scalars['Boolean']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
};

export type DomainAvailabilityResult = {
  __typename?: 'DomainAvailabilityResult';
  available: Scalars['Boolean']['output'];
  domain: Scalars['String']['output'];
  price?: Maybe<Scalars['Float']['output']>;
  renewalPrice?: Maybe<Scalars['Float']['output']>;
  tldSupported: Scalars['Boolean']['output'];
};

export type DomainDnsRecord = {
  __typename?: 'DomainDnsRecord';
  id: Scalars['String']['output'];
  mxPriority?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  ttl: Scalars['Float']['output'];
  type: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type DomainHealthStatus = {
  __typename?: 'DomainHealthStatus';
  configuredBy?: Maybe<Scalars['String']['output']>;
  dmarcRecord: Scalars['Boolean']['output'];
  dnsPointingToVercel: Scalars['Boolean']['output'];
  domain: Scalars['String']['output'];
  mxRecords: Scalars['Boolean']['output'];
  nameservers: Array<Scalars['String']['output']>;
  nameserversAtVercel: Scalars['Boolean']['output'];
  postmarkDkim: Scalars['Boolean']['output'];
  postmarkReturnPath: Scalars['Boolean']['output'];
  spfRecord: Scalars['Boolean']['output'];
};

export type DomainNameserver = {
  __typename?: 'DomainNameserver';
  hostname: Scalars['String']['output'];
  ip?: Maybe<Scalars['String']['output']>;
};

/** Payment status for domain registration */
export enum DomainPaymentStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Refunded = 'REFUNDED'
}

export type DomainPricing = {
  __typename?: 'DomainPricing';
  currency: Scalars['String']['output'];
  registrationPrice: Scalars['Float']['output'];
  renewalPrice: Scalars['Float']['output'];
  transferPrice: Scalars['Float']['output'];
};

export type DomainRenewInput = {
  domainId: Scalars['ID']['input'];
  paymentMethod?: InputMaybe<Scalars['String']['input']>;
  years: Scalars['Float']['input'];
};

export type DomainSearchInput = {
  domainName: Scalars['String']['input'];
  tlds?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Domain registration status */
export enum DomainStatus {
  Available = 'AVAILABLE',
  Expired = 'EXPIRED',
  Locked = 'LOCKED',
  Pending = 'PENDING',
  Registered = 'REGISTERED',
  Transferred = 'TRANSFERRED'
}

export type DomainTransferInput = {
  authCode: Scalars['String']['input'];
  clientId: Scalars['ID']['input'];
  domainName: Scalars['String']['input'];
  paymentMethod?: InputMaybe<Scalars['String']['input']>;
};

export type DraftBroadcastInput = {
  channel: Scalars['String']['input'];
  goal: Scalars['String']['input'];
  invoiceLink?: InputMaybe<Scalars['String']['input']>;
  recipientNames?: InputMaybe<Array<Scalars['String']['input']>>;
  scheduledAt?: InputMaybe<Scalars['String']['input']>;
  senderName?: InputMaybe<Scalars['String']['input']>;
  sourceContext?: InputMaybe<Scalars['String']['input']>;
};

export type DraftCandidateMessageInput = {
  candidateId: Scalars['ID']['input'];
  channel: Scalars['String']['input'];
  context: Scalars['String']['input'];
  formUrl?: InputMaybe<Scalars['String']['input']>;
  goal: Scalars['String']['input'];
  meetingAt?: InputMaybe<Scalars['String']['input']>;
  meetingUrl?: InputMaybe<Scalars['String']['input']>;
};

export type DraftGovProposalInput = {
  brief: Scalars['String']['input'];
  instruction?: InputMaybe<Scalars['String']['input']>;
  organisationId: Scalars['ID']['input'];
};

export type DraftReplyForEmailInput = {
  goal?: InputMaybe<Scalars['String']['input']>;
  inboundEmailId: Scalars['ID']['input'];
};

export type DressingSchedule = {
  __typename?: 'DressingSchedule';
  createdAt: Scalars['DateTime']['output'];
  dressingType: Scalars['String']['output'];
  frequencyHours: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  lastCompletedAt?: Maybe<Scalars['DateTime']['output']>;
  lastCompletedBy?: Maybe<Scalars['ID']['output']>;
  lastCompletedByName?: Maybe<Scalars['String']['output']>;
  nextDueAt: Scalars['DateTime']['output'];
  residentId: Scalars['ID']['output'];
  residentName?: Maybe<Scalars['String']['output']>;
  residentRoom?: Maybe<Scalars['String']['output']>;
  residentWing?: Maybe<Scalars['String']['output']>;
  specialInstructions?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  woundId: Scalars['ID']['output'];
};

export type DressingScheduleFilterInput = {
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  overdueOnly?: InputMaybe<Scalars['Boolean']['input']>;
  residentId?: InputMaybe<Scalars['ID']['input']>;
  woundId?: InputMaybe<Scalars['ID']['input']>;
};

export type DroneSession = {
  __typename?: 'DroneSession';
  completedFiles: Scalars['Float']['output'];
  createdAt: Scalars['DateTime']['output'];
  downloadCompletedAt?: Maybe<Scalars['DateTime']['output']>;
  downloadStartedAt?: Maybe<Scalars['DateTime']['output']>;
  droneName?: Maybe<Scalars['String']['output']>;
  droneSerial: Scalars['String']['output'];
  failedFiles: Scalars['Float']['output'];
  folderId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  imageCount: Scalars['Float']['output'];
  isPublic: Scalars['Boolean']['output'];
  lastError?: Maybe<Scalars['String']['output']>;
  retryCount: Scalars['Float']['output'];
  sessionDate: Scalars['DateTime']['output'];
  sessionId: Scalars['String']['output'];
  shareExpiresAt?: Maybe<Scalars['DateTime']['output']>;
  sharePassword?: Maybe<Scalars['String']['output']>;
  shareToken?: Maybe<Scalars['String']['output']>;
  stagingCleared: Scalars['Boolean']['output'];
  stagingPath?: Maybe<Scalars['String']['output']>;
  status: DroneSessionStatus;
  tenantId: Scalars['String']['output'];
  totalBytes: Scalars['Float']['output'];
  totalFiles: Scalars['Float']['output'];
  updatedAt: Scalars['DateTime']['output'];
  uploadCompletedAt?: Maybe<Scalars['DateTime']['output']>;
  uploadStartedAt?: Maybe<Scalars['DateTime']['output']>;
  uploadedBytes: Scalars['Float']['output'];
  videoCount: Scalars['Float']['output'];
};

export type DroneSessionFilters = {
  droneSerial?: InputMaybe<Scalars['String']['input']>;
  fromDate?: InputMaybe<Scalars['DateTime']['input']>;
  limit?: InputMaybe<Scalars['Float']['input']>;
  offset?: InputMaybe<Scalars['Float']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<DroneSessionStatus>;
  toDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DroneSessionListResult = {
  __typename?: 'DroneSessionListResult';
  hasMore: Scalars['Boolean']['output'];
  limit: Scalars['Float']['output'];
  offset: Scalars['Float']['output'];
  total: Scalars['Float']['output'];
};

/** Status of a drone sync session */
export enum DroneSessionStatus {
  Complete = 'COMPLETE',
  Downloading = 'DOWNLOADING',
  Failed = 'FAILED',
  Partial = 'PARTIAL',
  Pending = 'PENDING',
  Uploading = 'UPLOADING'
}

export type DroneUploadStats = {
  __typename?: 'DroneUploadStats';
  completedSessions: Scalars['Float']['output'];
  imageCount: Scalars['Float']['output'];
  totalBytes: Scalars['Float']['output'];
  totalFiles: Scalars['Float']['output'];
  totalSessions: Scalars['Float']['output'];
  videoCount: Scalars['Float']['output'];
};

/** Australian drug schedule classification */
export enum DrugSchedule {
  S2 = 'S2',
  S3 = 'S3',
  S4 = 'S4',
  S8 = 'S8',
  Unscheduled = 'UNSCHEDULED'
}

export type DuplicateAccountCluster = {
  __typename?: 'DuplicateAccountCluster';
  accounts: Array<DuplicateAccountSummary>;
  identifier: Scalars['String']['output'];
  identifierType: Scalars['String']['output'];
};

export type DuplicateAccountSummary = {
  __typename?: 'DuplicateAccountSummary';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  fName?: Maybe<Scalars['String']['output']>;
  hasPassword: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  lName?: Maybe<Scalars['String']['output']>;
  lastLoginAt?: Maybe<Scalars['DateTime']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  username?: Maybe<Scalars['String']['output']>;
};

export type DuplicateCandidate = {
  __typename?: 'DuplicateCandidate';
  aEvidence: Array<Scalars['String']['output']>;
  aName: Scalars['String']['output'];
  aSlug: Scalars['String']['output'];
  bEvidence: Array<Scalars['String']['output']>;
  bName: Scalars['String']['output'];
  bSlug: Scalars['String']['output'];
  kind: Scalars['String']['output'];
  reason: Scalars['String']['output'];
  similarity: Scalars['Int']['output'];
};

export type DuplicateEmployeeGroup = {
  __typename?: 'DuplicateEmployeeGroup';
  client?: Maybe<Client>;
  clientId: Scalars['ID']['output'];
  count: Scalars['Float']['output'];
  employees: Array<Employee>;
};

/** Reason why records were flagged as potential duplicates */
export enum DuplicateReason {
  SameClientMultipleEmployees = 'SAME_CLIENT_MULTIPLE_EMPLOYEES',
  SameEmail = 'SAME_EMAIL',
  SameName = 'SAME_NAME',
  SamePhoneSimilarName = 'SAME_PHONE_SIMILAR_NAME'
}

/** Expression of Interest status */
export enum EoiStatus {
  Accepted = 'ACCEPTED',
  Declined = 'DECLINED',
  Submitted = 'SUBMITTED',
  UnderReview = 'UNDER_REVIEW',
  Withdrawn = 'WITHDRAWN'
}

export type EditBuildUpdateInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  notifyClients?: InputMaybe<Scalars['Boolean']['input']>;
  photos?: InputMaybe<Array<BuildUpdateFileInput>>;
  title?: InputMaybe<Scalars['String']['input']>;
  updateId: Scalars['ID']['input'];
};

export type EditCommandResult = {
  __typename?: 'EditCommandResult';
  changedFiles?: Maybe<Array<ChangedFileInfo>>;
  commandId: Scalars['String']['output'];
  duration?: Maybe<Scalars['Float']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  filesChanged?: Maybe<Scalars['Float']['output']>;
  output?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type Email = {
  __typename?: 'Email';
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  assignedAt?: Maybe<Scalars['DateTime']['output']>;
  assignedBy?: Maybe<Scalars['String']['output']>;
  assignedClients?: Maybe<Array<Scalars['String']['output']>>;
  attachments?: Maybe<Array<OutboundEmailAttachment>>;
  bcc?: Maybe<Scalars['String']['output']>;
  bodyHtml: Scalars['String']['output'];
  bodyMarkdown: Scalars['String']['output'];
  cc?: Maybe<Scalars['String']['output']>;
  clicks?: Maybe<Scalars['Float']['output']>;
  conversationKey?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  deletedBy?: Maybe<Scalars['String']['output']>;
  deletedByName?: Maybe<Scalars['String']['output']>;
  direction: EmailDirection;
  errorMessage?: Maybe<Scalars['String']['output']>;
  filed?: Maybe<EmailFiledStatus>;
  from: Scalars['String']['output'];
  fromEmailAddress?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  inReplyTo?: Maybe<Scalars['String']['output']>;
  isArchived: Scalars['Boolean']['output'];
  isAssigned: Scalars['Boolean']['output'];
  isRead: Scalars['Boolean']['output'];
  labels?: Maybe<Array<Scalars['String']['output']>>;
  linkedOpportunityIds?: Maybe<Array<Scalars['String']['output']>>;
  messageId?: Maybe<Scalars['String']['output']>;
  opens?: Maybe<Scalars['Float']['output']>;
  preview?: Maybe<Scalars['String']['output']>;
  readAt?: Maybe<Scalars['DateTime']['output']>;
  receivedAt?: Maybe<Scalars['DateTime']['output']>;
  references?: Maybe<Array<Scalars['String']['output']>>;
  replyTo?: Maybe<Scalars['String']['output']>;
  scheduledFor?: Maybe<Scalars['DateTime']['output']>;
  sentAt?: Maybe<Scalars['DateTime']['output']>;
  status: EmailStatus;
  statusBeforeDelete?: Maybe<EmailStatus>;
  subject: Scalars['String']['output'];
  tasks?: Maybe<Array<CommunicationTask>>;
  tenantId: Scalars['String']['output'];
  threadId?: Maybe<Scalars['String']['output']>;
  to: Scalars['String']['output'];
  toEmailAddress?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type EmailAddress = {
  __typename?: 'EmailAddress';
  acceptCalendarInvitesFromAnyone?: Maybe<Scalars['Boolean']['output']>;
  acceptedSenderEmailsForCalendarInvites?: Maybe<Array<Scalars['String']['output']>>;
  associatedClients?: Maybe<Array<Scalars['String']['output']>>;
  autoAcceptInvites: Scalars['Boolean']['output'];
  blockedDomainsForCalendarInvites?: Maybe<Array<Scalars['String']['output']>>;
  canReceiveMarketing: Scalars['Boolean']['output'];
  canReceiveTransactional: Scalars['Boolean']['output'];
  company?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  domain?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  emailsReceived: Scalars['Float']['output'];
  emailsSent: Scalars['Float']['output'];
  firstSeenAt?: Maybe<Scalars['DateTime']['output']>;
  forwardingProvider: ForwardingProvider;
  id: Scalars['ID']['output'];
  isBlocked: Scalars['Boolean']['output'];
  isRegisteredWithImprovMX: Scalars['Boolean']['output'];
  isVerified: Scalars['Boolean']['output'];
  lastSeenAt?: Maybe<Scalars['DateTime']['output']>;
  linkedCalendarIds?: Maybe<Array<Scalars['String']['output']>>;
  linkedCalendars?: Maybe<Array<LinkedCalendar>>;
  name?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  postmarkEndpoint?: Maybe<Scalars['String']['output']>;
  primaryCalendarId?: Maybe<Scalars['String']['output']>;
  sendAsName?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  tenantId: Scalars['String']['output'];
  type: EmailAddressType;
  updatedAt: Scalars['DateTime']['output'];
};

export type EmailAddressInfo = {
  __typename?: 'EmailAddressInfo';
  displayName: Scalars['String']['output'];
  email: Scalars['String']['output'];
  isDefault?: Maybe<Scalars['Boolean']['output']>;
  recordId?: Maybe<Scalars['String']['output']>;
  totalCount: Scalars['Int']['output'];
  type: Scalars['String']['output'];
  unreadCount: Scalars['Int']['output'];
};

export type EmailAddressInput = {
  acceptCalendarInvitesFromAnyone?: InputMaybe<Scalars['Boolean']['input']>;
  acceptedSenderEmailsForCalendarInvites?: InputMaybe<Array<Scalars['String']['input']>>;
  associatedClients?: InputMaybe<Array<Scalars['String']['input']>>;
  blockedDomainsForCalendarInvites?: InputMaybe<Array<Scalars['String']['input']>>;
  canReceiveMarketing?: InputMaybe<Scalars['Boolean']['input']>;
  canReceiveTransactional?: InputMaybe<Scalars['Boolean']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  forwardingProvider?: InputMaybe<ForwardingProvider>;
  isBlocked?: InputMaybe<Scalars['Boolean']['input']>;
  isRegisteredWithImprovMX?: InputMaybe<Scalars['Boolean']['input']>;
  isVerified?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  postmarkEndpoint?: InputMaybe<Scalars['String']['input']>;
  sendAsName?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  type?: InputMaybe<EmailAddressType>;
};

export type EmailAddressStats = {
  __typename?: 'EmailAddressStats';
  blockedAddresses: Scalars['Int']['output'];
  businessEmails: Scalars['Int']['output'];
  personalEmails: Scalars['Int']['output'];
  totalAddresses: Scalars['Int']['output'];
  totalEmailsReceived: Scalars['Int']['output'];
  totalEmailsSent: Scalars['Int']['output'];
  verifiedAddresses: Scalars['Int']['output'];
};

/** Type of email address */
export enum EmailAddressType {
  Business = 'BUSINESS',
  Marketing = 'MARKETING',
  Noreply = 'NOREPLY',
  Personal = 'PERSONAL',
  Support = 'SUPPORT',
  Unknown = 'UNKNOWN'
}

export type EmailAddressUpdateInput = {
  acceptCalendarInvitesFromAnyone?: InputMaybe<Scalars['Boolean']['input']>;
  acceptedSenderEmailsForCalendarInvites?: InputMaybe<Array<Scalars['String']['input']>>;
  associatedClients?: InputMaybe<Array<Scalars['String']['input']>>;
  blockedDomainsForCalendarInvites?: InputMaybe<Array<Scalars['String']['input']>>;
  canReceiveMarketing?: InputMaybe<Scalars['Boolean']['input']>;
  canReceiveTransactional?: InputMaybe<Scalars['Boolean']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  forwardingProvider?: InputMaybe<ForwardingProvider>;
  isBlocked?: InputMaybe<Scalars['Boolean']['input']>;
  isRegisteredWithImprovMX?: InputMaybe<Scalars['Boolean']['input']>;
  isVerified?: InputMaybe<Scalars['Boolean']['input']>;
  linkedCalendarIds?: InputMaybe<Array<Scalars['String']['input']>>;
  linkedCalendars?: InputMaybe<Array<LinkedCalendarInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  primaryCalendarId?: InputMaybe<Scalars['String']['input']>;
  sendAsName?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  type?: InputMaybe<EmailAddressType>;
};

export type EmailAiActionProposal = {
  __typename?: 'EmailAiActionProposal';
  reasoning?: Maybe<Scalars['String']['output']>;
  suggestedMemory?: Maybe<ProposedEmailAiMemory>;
  suggestedRule?: Maybe<ProposedEmailAiRule>;
};

export type EmailAiMemory = {
  __typename?: 'EmailAiMemory';
  active: Scalars['Boolean']['output'];
  body: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  priority: Scalars['Float']['output'];
  scope: EmailAiMemoryScope;
  scopeValue?: Maybe<Scalars['String']['output']>;
  source: EmailAiMemorySource;
  tags: Array<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type EmailAiMemoryFilterInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  scope?: InputMaybe<EmailAiMemoryScope>;
  scopeValue?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

/** Scope — when the AI loads this memory into its system prompt. */
export enum EmailAiMemoryScope {
  Client = 'CLIENT',
  Domain = 'DOMAIN',
  Folder = 'FOLDER',
  Global = 'GLOBAL',
  Sender = 'SENDER'
}

/** Who authored the memory — user, AI-proposed-then-confirmed, or AI-auto-from-training. */
export enum EmailAiMemorySource {
  AiAuto = 'AI_AUTO',
  AiSuggested = 'AI_SUGGESTED',
  User = 'USER'
}

export type EmailAiOutstandingQuestion = {
  __typename?: 'EmailAiOutstandingQuestion';
  answer?: Maybe<Scalars['String']['output']>;
  answeredAt?: Maybe<Scalars['DateTime']['output']>;
  askedAt: Scalars['DateTime']['output'];
  context?: Maybe<EmailAiOutstandingQuestionContext>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  priority: EmailAiOutstandingQuestionPriority;
  proposedActions: Array<Scalars['String']['output']>;
  question: Scalars['String']['output'];
  resultingMemoryId?: Maybe<Scalars['String']['output']>;
  resultingRuleId?: Maybe<Scalars['String']['output']>;
  status: EmailAiOutstandingQuestionStatus;
  tenantId: Scalars['String']['output'];
  triggerType: EmailAiOutstandingQuestionTrigger;
  updatedAt: Scalars['DateTime']['output'];
  userId?: Maybe<Scalars['String']['output']>;
};

export type EmailAiOutstandingQuestionContext = {
  __typename?: 'EmailAiOutstandingQuestionContext';
  classification?: Maybe<Scalars['String']['output']>;
  memoryId?: Maybe<Scalars['String']['output']>;
  recordId?: Maybe<Scalars['String']['output']>;
  ruleId?: Maybe<Scalars['String']['output']>;
};

export enum EmailAiOutstandingQuestionPriority {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM'
}

export enum EmailAiOutstandingQuestionStatus {
  Answered = 'ANSWERED',
  Dismissed = 'DISMISSED',
  Expired = 'EXPIRED',
  Open = 'OPEN'
}

export enum EmailAiOutstandingQuestionTrigger {
  AmbiguousClassification = 'AMBIGUOUS_CLASSIFICATION',
  BacklogFeedback = 'BACKLOG_FEEDBACK',
  FailedAction = 'FAILED_ACTION',
  NewSender = 'NEW_SENDER',
  PeriodicCheckin = 'PERIODIC_CHECKIN',
  RuleConflict = 'RULE_CONFLICT'
}

export type EmailAiProactiveSettings = {
  __typename?: 'EmailAiProactiveSettings';
  activeHoursEnd?: Maybe<Scalars['String']['output']>;
  activeHoursStart?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  enabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  maxPerSession: Scalars['Int']['output'];
  suppressedUntil?: Maybe<Scalars['DateTime']['output']>;
  tenantId: Scalars['String']['output'];
  timezone?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  userId: Scalars['String']['output'];
  weeklyStaleDigest: Scalars['Boolean']['output'];
};

export type EmailAiProcessingAction = {
  __typename?: 'EmailAiProcessingAction';
  errorMessage?: Maybe<Scalars['String']['output']>;
  outcome: EmailAiProcessingOutcome;
  type: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type EmailAiProcessingLog = {
  __typename?: 'EmailAiProcessingLog';
  actionsTaken: Array<EmailAiProcessingAction>;
  aiReasoning?: Maybe<Scalars['String']['output']>;
  aiUsageLogId?: Maybe<Scalars['String']['output']>;
  classification?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  durationMs: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  inboundEmailId: Scalars['ID']['output'];
  matchedRuleIds: Array<Scalars['ID']['output']>;
  memorySnapshotHash?: Maybe<Scalars['String']['output']>;
  runAt: Scalars['DateTime']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export enum EmailAiProcessingOutcome {
  Failed = 'FAILED',
  Skipped = 'SKIPPED',
  Success = 'SUCCESS'
}

export type EmailAiRule = {
  __typename?: 'EmailAiRule';
  actions: Array<EmailAiRuleAction>;
  conditionCombinator: EmailAiRuleCombinator;
  conditions: Array<EmailAiRuleCondition>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  createdBySource: EmailAiRuleSource;
  description?: Maybe<Scalars['String']['output']>;
  enabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  lastMatchedEmailId?: Maybe<Scalars['String']['output']>;
  lastRunAt?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  priority: Scalars['Float']['output'];
  runCount: Scalars['Int']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type EmailAiRuleAction = {
  __typename?: 'EmailAiRuleAction';
  memoryRefs?: Maybe<Array<Scalars['String']['output']>>;
  replyTemplate?: Maybe<Scalars['String']['output']>;
  type: EmailAiRuleActionType;
  value?: Maybe<Scalars['String']['output']>;
};

export type EmailAiRuleActionInput = {
  memoryRefs?: InputMaybe<Array<Scalars['String']['input']>>;
  replyTemplate?: InputMaybe<Scalars['String']['input']>;
  type: EmailAiRuleActionType;
  value?: InputMaybe<Scalars['String']['input']>;
};

export enum EmailAiRuleActionType {
  AddLabel = 'ADD_LABEL',
  Archive = 'ARCHIVE',
  AttachToOpportunity = 'ATTACH_TO_OPPORTUNITY',
  Block = 'BLOCK',
  CreateTask = 'CREATE_TASK',
  DraftReply = 'DRAFT_REPLY',
  MarkAsRead = 'MARK_AS_READ',
  MoveToFolder = 'MOVE_TO_FOLDER',
  NotifySms = 'NOTIFY_SMS',
  RemoveLabel = 'REMOVE_LABEL',
  Star = 'STAR'
}

export enum EmailAiRuleCombinator {
  All = 'ALL',
  Any = 'ANY'
}

export type EmailAiRuleCondition = {
  __typename?: 'EmailAiRuleCondition';
  negate?: Maybe<Scalars['Boolean']['output']>;
  type: EmailAiRuleConditionType;
  value: Scalars['String']['output'];
};

export type EmailAiRuleConditionInput = {
  negate?: InputMaybe<Scalars['Boolean']['input']>;
  type: EmailAiRuleConditionType;
  value: Scalars['String']['input'];
};

export enum EmailAiRuleConditionType {
  AiClassifiedAs = 'AI_CLASSIFIED_AS',
  BodyContains = 'BODY_CONTAINS',
  FromDomain = 'FROM_DOMAIN',
  FromDomainContains = 'FROM_DOMAIN_CONTAINS',
  FromEmail = 'FROM_EMAIL',
  FromEmailContains = 'FROM_EMAIL_CONTAINS',
  HasLabel = 'HAS_LABEL',
  SubjectContains = 'SUBJECT_CONTAINS'
}

export type EmailAiRuleFilterInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

/** Sensible-default rule shapes for one-click in-context training. */
export enum EmailAiRulePreset {
  NewsletterMarkRead = 'NEWSLETTER_MARK_READ',
  ReceiptAutoArchive = 'RECEIPT_AUTO_ARCHIVE',
  ReceiptLabelOnly = 'RECEIPT_LABEL_ONLY'
}

export enum EmailAiRuleSource {
  AiAuto = 'AI_AUTO',
  AiSuggested = 'AI_SUGGESTED',
  User = 'USER'
}

export type EmailAttachment = {
  __typename?: 'EmailAttachment';
  content?: Maybe<Scalars['String']['output']>;
  contentId?: Maybe<Scalars['String']['output']>;
  contentLength: Scalars['Float']['output'];
  contentType: Scalars['String']['output'];
  ipfsCid?: Maybe<Scalars['String']['output']>;
  ipfsUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  originalName?: Maybe<Scalars['String']['output']>;
  uploadError?: Maybe<Scalars['String']['output']>;
};

export type EmailBacklogJob = {
  __typename?: 'EmailBacklogJob';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  currentBatchCursor?: Maybe<Scalars['String']['output']>;
  failedEmails: Scalars['Int']['output'];
  failures: Array<EmailBacklogJobFailure>;
  folder?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  limit?: Maybe<Scalars['Int']['output']>;
  processedEmails: Scalars['Int']['output'];
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  status: EmailBacklogJobStatus;
  tenantId: Scalars['String']['output'];
  totalEmails: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
  userId?: Maybe<Scalars['String']['output']>;
};

export type EmailBacklogJobFailure = {
  __typename?: 'EmailBacklogJobFailure';
  at: Scalars['DateTime']['output'];
  inboundEmailId: Scalars['String']['output'];
  reason: Scalars['String']['output'];
};

export enum EmailBacklogJobStatus {
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Queued = 'QUEUED',
  Running = 'RUNNING'
}

export type EmailComposeInput = {
  assignedClients?: InputMaybe<Array<Scalars['String']['input']>>;
  attachments?: InputMaybe<Array<OutboundEmailAttachmentInput>>;
  bcc?: InputMaybe<Scalars['String']['input']>;
  bodyMarkdown: Scalars['String']['input'];
  cc?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<EmailDirection>;
  from?: InputMaybe<Scalars['String']['input']>;
  inReplyToInboundEmailId?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<Array<Scalars['String']['input']>>;
  linkedOpportunityIds?: InputMaybe<Array<Scalars['String']['input']>>;
  replyTo?: InputMaybe<Scalars['String']['input']>;
  scheduledFor?: InputMaybe<Scalars['DateTime']['input']>;
  subject: Scalars['String']['input'];
  to: Scalars['String']['input'];
};

export type EmailConversation = {
  __typename?: 'EmailConversation';
  conversationMessageCount: Scalars['Int']['output'];
  folders: Array<Scalars['String']['output']>;
  hasUnreadReply: Scalars['Boolean']['output'];
  hiddenFolders: Array<Scalars['String']['output']>;
  hiddenSiblingCount: Scalars['Int']['output'];
  key: Scalars['ID']['output'];
  lastActivityAt: Scalars['DateTime']['output'];
  lastMessage?: Maybe<EmailConversationLastMessage>;
  latestInbound?: Maybe<InboundEmail>;
  latestOutbound?: Maybe<Email>;
  messageCount: Scalars['Int']['output'];
  messageIds: Array<Scalars['ID']['output']>;
  participants: Array<EmailConversationParticipant>;
  unreadCount: Scalars['Int']['output'];
};

export type EmailConversationLastMessage = {
  __typename?: 'EmailConversationLastMessage';
  at: Scalars['DateTime']['output'];
  direction: ConversationDirection;
  fromEmail: Scalars['String']['output'];
  fromName?: Maybe<Scalars['String']['output']>;
};

export type EmailConversationParticipant = {
  __typename?: 'EmailConversationParticipant';
  email: Scalars['String']['output'];
  isMe: Scalars['Boolean']['output'];
  messageCount: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

/** Email direction */
export enum EmailDirection {
  Inbound = 'INBOUND',
  Outbound = 'OUTBOUND'
}

/** Filing state of an email against a tenant's biz-in-a-folder knowledge root. */
export enum EmailFiledState {
  Failed = 'FAILED',
  Filed = 'FILED',
  NotApplicable = 'NOT_APPLICABLE',
  Pending = 'PENDING'
}

export type EmailFiledStatus = {
  __typename?: 'EmailFiledStatus';
  at?: Maybe<Scalars['DateTime']['output']>;
  attempts?: Maybe<Scalars['Int']['output']>;
  lastError?: Maybe<Scalars['String']['output']>;
  path?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  root?: Maybe<Scalars['String']['output']>;
  state: EmailFiledState;
};

export type EmailFilterInput = {
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  emailAddress?: InputMaybe<Scalars['String']['input']>;
  folder?: InputMaybe<Scalars['String']['input']>;
  fromEmail?: InputMaybe<Scalars['String']['input']>;
  groupBy?: InputMaybe<EmailListGroupBy>;
  isRead?: InputMaybe<Scalars['Boolean']['input']>;
  isStarred?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
};

/** Font family for emails */
export enum EmailFont {
  Arial = 'ARIAL',
  Cambria = 'CAMBRIA',
  Courier = 'COURIER',
  Garamond = 'GARAMOND',
  Georgia = 'GEORGIA',
  Helvetica = 'HELVETICA',
  Palatino = 'PALATINO',
  Roboto = 'ROBOTO',
  System = 'SYSTEM',
  Tahoma = 'TAHOMA',
  Trebuchet = 'TREBUCHET',
  Verdana = 'VERDANA'
}

export type EmailHeader = {
  __typename?: 'EmailHeader';
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type EmailHealthAddressStatus = {
  __typename?: 'EmailHealthAddressStatus';
  address: Scalars['String']['output'];
  /** Tests that finished (passed, failed or timed out) in the last 30 days */
  concludedCount30d: Scalars['Int']['output'];
  /** The site this address's mail must land on (from the latest test) */
  expectedTenantName?: Maybe<Scalars['String']['output']>;
  latestProbe?: Maybe<EmailHealthProbe>;
  /** Tests that arrived correctly in the last 30 days */
  passCount30d: Scalars['Int']['output'];
  /** Newest first, up to 5 */
  recentProbes: Array<EmailHealthProbe>;
};

export type EmailHealthCheck = {
  __typename?: 'EmailHealthCheck';
  detail: Scalars['String']['output'];
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  ok: Scalars['Boolean']['output'];
};

export type EmailHealthProbe = {
  __typename?: 'EmailHealthProbe';
  createdAt: Scalars['DateTime']['output'];
  expectedTenantId?: Maybe<Scalars['String']['output']>;
  expectedTenantName?: Maybe<Scalars['String']['output']>;
  failReason?: Maybe<Scalars['String']['output']>;
  fromAddress: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  kind: EmailProbeKind;
  latencyMs?: Maybe<Scalars['Int']['output']>;
  probeToken: Scalars['String']['output'];
  receivedAt?: Maybe<Scalars['DateTime']['output']>;
  sentAt: Scalars['DateTime']['output'];
  /** Derived status: a PENDING probe older than 15 minutes reads TIMED_OUT (computed at read time) */
  status: EmailProbeStatus;
  storedStatus: EmailProbeStoredStatus;
  targetAddress: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  triggeredBy: EmailProbeTrigger;
  updatedAt: Scalars['DateTime']['output'];
};

export type EmailHealthStatus = {
  __typename?: 'EmailHealthStatus';
  checks: Array<EmailHealthCheck>;
  /** This site's own loop-back tests (watched-address tests are under watchedAddresses) */
  probes: Array<EmailHealthProbe>;
  settings: CommsHealthSettings;
  /** PASS/(PASS+FAILED+TIMED_OUT) over the last 30 days (derived status). Null when no probe has concluded. */
  uptimePercent?: Maybe<Scalars['Float']['output']>;
  watchedAddresses: Array<EmailHealthAddressStatus>;
};

export type EmailHealthTenantRow = {
  __typename?: 'EmailHealthTenantRow';
  checksPassed: Scalars['Int']['output'];
  checksTotal: Scalars['Int']['output'];
  emailDomain?: Maybe<Scalars['String']['output']>;
  failedCheckKeys: Array<Scalars['String']['output']>;
  lastProbeAt?: Maybe<Scalars['DateTime']['output']>;
  lastProbeStatus?: Maybe<EmailProbeStatus>;
  tenantId: Scalars['String']['output'];
  tenantName: Scalars['String']['output'];
};

export type EmailInput = {
  bcc?: InputMaybe<Scalars['String']['input']>;
  brand: Scalars['String']['input'];
  cc?: InputMaybe<Scalars['String']['input']>;
  html: Scalars['String']['input'];
  replyTo?: InputMaybe<Scalars['String']['input']>;
  subject: Scalars['String']['input'];
  text: Scalars['String']['input'];
  to: Scalars['String']['input'];
};

/** Row shape of the paginated inbound list: one row per message, or one per conversation */
export enum EmailListGroupBy {
  Conversation = 'CONVERSATION',
  Message = 'MESSAGE'
}

export type EmailLoginBrowserResult = {
  __typename?: 'EmailLoginBrowserResult';
  auth?: Maybe<AuthResponse>;
  returnPath?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
};

export type EmailLoginLinkRequestResult = {
  __typename?: 'EmailLoginLinkRequestResult';
  accepted: Scalars['Boolean']['output'];
  browserLabel?: Maybe<Scalars['String']['output']>;
  browserToken?: Maybe<Scalars['String']['output']>;
  codeAvailable?: Maybe<Scalars['Boolean']['output']>;
  retryAfterSeconds: Scalars['Int']['output'];
};

export type EmailLoginLinkResult = {
  __typename?: 'EmailLoginLinkResult';
  auth?: Maybe<AuthResponse>;
  flow: Scalars['String']['output'];
  missingFields: Array<Scalars['String']['output']>;
  profileFields?: Maybe<AuthProfileFieldPolicy>;
  proof?: Maybe<Scalars['String']['output']>;
  readOnly?: Maybe<Scalars['Boolean']['output']>;
  returnPath: Scalars['String']['output'];
};

/** LOOPBACK: send to self via the inbound pipeline. ADDRESS: send to a watched address, PASS when it lands on the site that owns that address's domain */
export enum EmailProbeKind {
  Address = 'ADDRESS',
  Loopback = 'LOOPBACK'
}

/** Derived probe status: a PENDING probe older than 15 minutes reads TIMED_OUT */
export enum EmailProbeStatus {
  Failed = 'FAILED',
  Pass = 'PASS',
  Pending = 'PENDING',
  TimedOut = 'TIMED_OUT'
}

/** Persisted probe status. TIMED_OUT is never stored — it is derived at read time (see status) */
export enum EmailProbeStoredStatus {
  Failed = 'FAILED',
  Pass = 'PASS',
  Pending = 'PENDING'
}

/** What triggered the probe: MANUAL button, PAGE open (min-interval guarded), or the WEEKLY report */
export enum EmailProbeTrigger {
  Manual = 'MANUAL',
  Page = 'PAGE',
  Weekly = 'WEEKLY'
}

export type EmailReplyDraftOutput = {
  __typename?: 'EmailReplyDraftOutput';
  aiNotes?: Maybe<Scalars['String']['output']>;
  emailBody: Scalars['String']['output'];
  emailSubject: Scalars['String']['output'];
};

export type EmailResponse = {
  __typename?: 'EmailResponse';
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type EmailSearchMatch = {
  __typename?: 'EmailSearchMatch';
  emailId: Scalars['ID']['output'];
  matchedIn: Array<Scalars['String']['output']>;
  snippet?: Maybe<Scalars['String']['output']>;
};

/** Email status */
export enum EmailStatus {
  Deleted = 'DELETED',
  Draft = 'DRAFT',
  Failed = 'FAILED',
  Received = 'RECEIVED',
  Scheduled = 'SCHEDULED',
  Sent = 'SENT'
}

/** Overall email template style */
export enum EmailStyle {
  Branded = 'BRANDED',
  Minimal = 'MINIMAL',
  Personal = 'PERSONAL'
}

export type EmailTagCount = {
  __typename?: 'EmailTagCount';
  count: Scalars['Int']['output'];
  tag: Scalars['String']['output'];
};

export type EmailThreadAttachment = {
  __typename?: 'EmailThreadAttachment';
  content?: Maybe<Scalars['String']['output']>;
  contentId?: Maybe<Scalars['String']['output']>;
  contentLength?: Maybe<Scalars['Float']['output']>;
  contentType?: Maybe<Scalars['String']['output']>;
  ipfsCid?: Maybe<Scalars['String']['output']>;
  ipfsUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export type EmailThreadMessage = {
  __typename?: 'EmailThreadMessage';
  attachments: Array<EmailThreadAttachment>;
  cc: Array<Scalars['String']['output']>;
  date: Scalars['DateTime']['output'];
  folder?: Maybe<Scalars['String']['output']>;
  from: Scalars['String']['output'];
  fromName?: Maybe<Scalars['String']['output']>;
  htmlBody?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isDraft: Scalars['Boolean']['output'];
  isRead: Scalars['Boolean']['output'];
  source: EmailThreadSource;
  subject: Scalars['String']['output'];
  textBody?: Maybe<Scalars['String']['output']>;
  to: Array<Scalars['String']['output']>;
};

/** Which collection a thread message came from (received vs sent mail) */
export enum EmailThreadSource {
  Inbound = 'INBOUND',
  Outbound = 'OUTBOUND'
}

export type EmailTrainingSessionSummary = {
  __typename?: 'EmailTrainingSessionSummary';
  conversations: Scalars['Int']['output'];
  interactions: Scalars['Int']['output'];
  lastActiveAt?: Maybe<Scalars['DateTime']['output']>;
  memoriesCreated: Scalars['Int']['output'];
  rulesCreated: Scalars['Int']['output'];
  tenantId: Scalars['String']['output'];
};

export type EmailUpdateInput = {
  assignedClients?: InputMaybe<Array<Scalars['String']['input']>>;
  attachments?: InputMaybe<Array<OutboundEmailAttachmentInput>>;
  bcc?: InputMaybe<Scalars['String']['input']>;
  bodyMarkdown?: InputMaybe<Scalars['String']['input']>;
  cc?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<EmailDirection>;
  from?: InputMaybe<Scalars['String']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  isAssigned?: InputMaybe<Scalars['Boolean']['input']>;
  isRead?: InputMaybe<Scalars['Boolean']['input']>;
  labels?: InputMaybe<Array<Scalars['String']['input']>>;
  linkedOpportunityIds?: InputMaybe<Array<Scalars['String']['input']>>;
  replyTo?: InputMaybe<Scalars['String']['input']>;
  scheduledFor?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<EmailStatus>;
  subject?: InputMaybe<Scalars['String']['input']>;
  to?: InputMaybe<Scalars['String']['input']>;
};

export type EmailVolumeBucket = {
  __typename?: 'EmailVolumeBucket';
  count: Scalars['Int']['output'];
  key: Scalars['String']['output'];
};

export type EmbeddedImage = {
  __typename?: 'EmbeddedImage';
  alt?: Maybe<Scalars['String']['output']>;
  caption?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

export type EmbeddedImageInput = {
  alt?: InputMaybe<Scalars['String']['input']>;
  caption?: InputMaybe<Scalars['String']['input']>;
  url: Scalars['String']['input'];
};

export type EmbeddedVideo = {
  __typename?: 'EmbeddedVideo';
  description?: Maybe<Scalars['String']['output']>;
  ipfsHash?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type: VideoEmbedType;
  url: Scalars['String']['output'];
};

export type EmbeddedVideoInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  ipfsHash?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type: VideoEmbedType;
  url: Scalars['String']['input'];
};

/** Emotion zone category (Red=intense negative, Yellow=mixed, Green=positive, Blue=low negative, Gold=performance/drive overlay) */
export enum EmotionZone {
  Blue = 'BLUE',
  Gold = 'GOLD',
  Green = 'GREEN',
  Red = 'RED',
  Yellow = 'YELLOW'
}

export type Employee = {
  __typename?: 'Employee';
  address?: Maybe<EmployeeAddress>;
  adpLeaveBalanceAsAt?: Maybe<Scalars['DateTime']['output']>;
  adpOpeningAnnualLeaveHours?: Maybe<Scalars['Float']['output']>;
  adpOpeningLongServiceLeaveHours?: Maybe<Scalars['Float']['output']>;
  adpOpeningPersonalLeaveHours?: Maybe<Scalars['Float']['output']>;
  agencyCompany?: Maybe<Scalars['String']['output']>;
  annualLeaveEntitlementHours?: Maybe<Scalars['Float']['output']>;
  annualSalary?: Maybe<Scalars['Float']['output']>;
  awardClassification?: Maybe<AwardClassification>;
  awardClassificationId?: Maybe<Scalars['String']['output']>;
  bankAccountName?: Maybe<Scalars['String']['output']>;
  bankAccountNumber?: Maybe<Scalars['String']['output']>;
  bankBSB?: Maybe<Scalars['String']['output']>;
  carRegistration?: Maybe<Scalars['String']['output']>;
  certifications?: Maybe<Array<Scalars['String']['output']>>;
  /** Left-to-right ordering hint among siblings on the org chart. Lower numbers render further left. Unset = dagre auto order. Edited via the drawer's ← / → buttons. */
  chartDisplayOrder?: Maybe<Scalars['Float']['output']>;
  claimsTaxFreeThreshold?: Maybe<Scalars['Boolean']['output']>;
  /** Claims the tax-free threshold LOADING (leave loading) — ADP 'Loading' Y/N, distinct from claimsTaxFreeThreshold. */
  claimsThresholdLoading?: Maybe<Scalars['Boolean']['output']>;
  client?: Maybe<Client>;
  clientId: Scalars['ID']['output'];
  company?: Maybe<Company>;
  companyId: Scalars['ID']['output'];
  contractType?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  credentials?: Maybe<EmployeeCredentials>;
  customAwardName?: Maybe<Scalars['String']['output']>;
  dateDeclinedPTLetterSent?: Maybe<Scalars['DateTime']['output']>;
  dateOfBirth?: Maybe<Scalars['DateTime']['output']>;
  dateOfferedPT?: Maybe<Scalars['DateTime']['output']>;
  dateTfnSigned?: Maybe<Scalars['DateTime']['output']>;
  departmentIds?: Maybe<Array<Scalars['String']['output']>>;
  departments?: Maybe<Array<Department>>;
  digitalManagerId?: Maybe<Scalars['ID']['output']>;
  emergencyContact?: Maybe<EmployeeEmergencyContact>;
  employeeNumber?: Maybe<Scalars['String']['output']>;
  employmentType?: Maybe<EmploymentType>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  /** HELP, VSL, FS, SSL or TSL study/training support loan debt (TFN declaration Q10). */
  hasStudyTrainingLoan?: Maybe<Scalars['Boolean']['output']>;
  /** Paid under a voluntary agreement (contractor quoting an ABN) — ADP 'Voluntary Agreement' Y/N. */
  hasVoluntaryAgreement?: Maybe<Scalars['Boolean']['output']>;
  hourlyRate?: Maybe<Scalars['Float']['output']>;
  hoursBasis?: Maybe<HoursBasis>;
  id: Scalars['ID']['output'];
  isDigitalManager?: Maybe<Scalars['Boolean']['output']>;
  isShiftWorker?: Maybe<Scalars['Boolean']['output']>;
  locationIds?: Maybe<Array<Scalars['String']['output']>>;
  locations?: Maybe<Array<Location>>;
  maxHoursPerWeek?: Maybe<Scalars['Float']['output']>;
  middleName?: Maybe<Scalars['String']['output']>;
  minHoursPerWeek?: Maybe<Scalars['Float']['output']>;
  /** @deprecated Use hoursBasis=FORTNIGHTLY with minHoursPerWeek (which now carries the per-fortnight value when basis is FORTNIGHTLY). */
  minimumHoursPerFortnight?: Maybe<Scalars['Float']['output']>;
  mobileNumber?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  onboardingReminderLastSentAt?: Maybe<Scalars['DateTime']['output']>;
  /** OrgChartPlacement id when this employee sits directly under a group node (Company / Department / Advisory Body) instead of under another employee. Mutually exclusive with `reportsToEmployeeId`. */
  parentPlacementId?: Maybe<Scalars['String']['output']>;
  payFrequency?: Maybe<Scalars['String']['output']>;
  payPointCode?: Maybe<Scalars['String']['output']>;
  payRates?: Maybe<Array<EmployeePayRateEntry>>;
  /** The payee's own ABN — only meaningful when hasVoluntaryAgreement is true. */
  payeeAbn?: Maybe<Scalars['String']['output']>;
  /** Hourly vs salary. Explicit since 2026-08-21; previously only inferable from hourlyRate vs annualSalary. */
  paymentType?: Maybe<PaymentType>;
  personalLeaveEntitlementHours?: Maybe<Scalars['Float']['output']>;
  position?: Maybe<Scalars['String']['output']>;
  positionIds?: Maybe<Array<Scalars['String']['output']>>;
  positions?: Maybe<Array<EmployeePosition>>;
  preferredName?: Maybe<Scalars['String']['output']>;
  profilePhoto?: Maybe<Scalars['String']['output']>;
  profilePhotoCid?: Maybe<Scalars['String']['output']>;
  promptedFormTypes?: Maybe<Array<EmployeeFormType>>;
  qualifications?: Maybe<Array<Scalars['String']['output']>>;
  reportingTo?: Maybe<Scalars['String']['output']>;
  /** Structured manager Employee id — used by org-chart module for hierarchy visualisation. Distinct from the legacy freeform `reportingTo` field. */
  reportsToEmployeeId?: Maybe<Scalars['String']['output']>;
  /** Markdown of this person's responsibilities — mirrors DigitalManager.responsibilitiesMarkdown so the org chart can show responsibilities for both humans and AI managers in the same node-detail panel. */
  responsibilitiesMarkdown?: Maybe<Scalars['String']['output']>;
  roleIds?: Maybe<Array<Scalars['String']['output']>>;
  roleRates?: Maybe<Array<EmployeeRoleRateEntry>>;
  roles?: Maybe<Array<EmployeeRole>>;
  smsfAbn?: Maybe<Scalars['String']['output']>;
  smsfBankAccountName?: Maybe<Scalars['String']['output']>;
  smsfBankAccountNumber?: Maybe<Scalars['String']['output']>;
  smsfBankBSB?: Maybe<Scalars['String']['output']>;
  /** SMSF electronic service address (ESA) for SuperStream. */
  smsfEsa?: Maybe<Scalars['String']['output']>;
  sourceRecommendationId?: Maybe<Scalars['ID']['output']>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  superChoiceType?: Maybe<SuperChoiceType>;
  superFundABN?: Maybe<Scalars['String']['output']>;
  /** Unique superannuation identifier — identifies the fund product, distinct from the member account number. */
  superFundUSI?: Maybe<Scalars['String']['output']>;
  superMemberNumber?: Maybe<Scalars['String']['output']>;
  /** Name as it appears on the super account (may be a previous name). */
  superNameOnAccount?: Maybe<Scalars['String']['output']>;
  superannuationFund?: Maybe<Scalars['String']['output']>;
  taxFileNumber?: Maybe<Scalars['String']['output']>;
  taxResidencyStatus?: Maybe<TaxResidencyStatus>;
  taxScale?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  terminationReason?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  visaCountry?: Maybe<Scalars['String']['output']>;
  workEmail?: Maybe<Scalars['String']['output']>;
  workPhone?: Maybe<Scalars['String']['output']>;
  workingRights?: Maybe<Scalars['String']['output']>;
};

export type EmployeeActivity = {
  __typename?: 'EmployeeActivity';
  activityDate: Scalars['DateTime']['output'];
  activityType: Scalars['String']['output'];
  attachments: Array<EmployeeActivityAttachment>;
  createdAt: Scalars['DateTime']['output'];
  createdById?: Maybe<Scalars['String']['output']>;
  createdByName: Scalars['String']['output'];
  detailUrl?: Maybe<Scalars['String']['output']>;
  details?: Maybe<Scalars['String']['output']>;
  employeeId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  isDeleted: Scalars['Boolean']['output'];
  isPrivate: Scalars['Boolean']['output'];
  referenceId?: Maybe<Scalars['String']['output']>;
  referenceType?: Maybe<Scalars['String']['output']>;
  tags: Array<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type EmployeeActivityAttachment = {
  __typename?: 'EmployeeActivityAttachment';
  cid?: Maybe<Scalars['String']['output']>;
  fileName: Scalars['String']['output'];
  fileSize: Scalars['Float']['output'];
  mimeType?: Maybe<Scalars['String']['output']>;
  uploadedAt: Scalars['DateTime']['output'];
  url: Scalars['String']['output'];
};

export type EmployeeActivityAttachmentInput = {
  cid?: InputMaybe<Scalars['String']['input']>;
  fileName: Scalars['String']['input'];
  fileSize: Scalars['Float']['input'];
  mimeType?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type EmployeeActivityComment = {
  __typename?: 'EmployeeActivityComment';
  attachments: Array<EmployeeActivityAttachment>;
  authorClientId?: Maybe<Scalars['String']['output']>;
  authorName: Scalars['String']['output'];
  body?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  employeeId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  retractedAt?: Maybe<Scalars['DateTime']['output']>;
  retractedById?: Maybe<Scalars['String']['output']>;
  retractedByName?: Maybe<Scalars['String']['output']>;
  subjectId: Scalars['String']['output'];
  subjectType: EmployeeActivityCommentSubject;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export enum EmployeeActivityCommentSubject {
  Activity = 'ACTIVITY',
  Attachment = 'ATTACHMENT'
}

export type EmployeeActivityFiltersInput = {
  activityType?: InputMaybe<Scalars['String']['input']>;
  fromDate?: InputMaybe<Scalars['DateTime']['input']>;
  includePrivate?: InputMaybe<Scalars['Boolean']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  toDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type EmployeeActivityInput = {
  activityDate?: InputMaybe<Scalars['DateTime']['input']>;
  activityType: Scalars['String']['input'];
  attachments?: InputMaybe<Array<EmployeeActivityAttachmentInput>>;
  details?: InputMaybe<Scalars['String']['input']>;
  isPrivate?: InputMaybe<Scalars['Boolean']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  title: Scalars['String']['input'];
};

export type EmployeeActivityTag = {
  __typename?: 'EmployeeActivityTag';
  color: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  usageCount: Scalars['Float']['output'];
};

export type EmployeeActivityTagInput = {
  color: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type EmployeeAddress = {
  __typename?: 'EmployeeAddress';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  street2?: Maybe<Scalars['String']['output']>;
};

export type EmployeeAddressInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  street2?: InputMaybe<Scalars['String']['input']>;
};

export type EmployeeCertificate = {
  __typename?: 'EmployeeCertificate';
  cid?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type EmployeeCertificateInput = {
  cid?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type EmployeeChecklist = {
  __typename?: 'EmployeeChecklist';
  createdAt: Scalars['DateTime']['output'];
  createdById?: Maybe<Scalars['String']['output']>;
  createdByName: Scalars['String']['output'];
  employeeId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isTemplate: Scalars['Boolean']['output'];
  lastActivityAt: Scalars['DateTime']['output'];
  templateSourceId?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  visibility: EmployeeChecklistVisibility;
};

export type EmployeeChecklistItem = {
  __typename?: 'EmployeeChecklistItem';
  checklistId: Scalars['String']['output'];
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  completedById?: Maybe<Scalars['String']['output']>;
  completedByName?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  done: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export enum EmployeeChecklistVisibility {
  Hidden = 'HIDDEN',
  Private = 'PRIVATE',
  Published = 'PUBLISHED'
}

export type EmployeeChecklistWithItems = {
  __typename?: 'EmployeeChecklistWithItems';
  checklist: EmployeeChecklist;
  doneCount: Scalars['Int']['output'];
  items: Array<EmployeeChecklistItem>;
  totalCount: Scalars['Int']['output'];
};

export type EmployeeContractFactsInput = {
  awardClassificationId?: InputMaybe<Scalars['ID']['input']>;
  baseHourlyRate?: InputMaybe<Scalars['Float']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  employmentBasis?: InputMaybe<ContractEmploymentBasis>;
  fName?: InputMaybe<Scalars['String']['input']>;
  lName?: InputMaybe<Scalars['String']['input']>;
  minimumHoursPerWeek?: InputMaybe<Scalars['Float']['input']>;
  positionId?: InputMaybe<Scalars['String']['input']>;
  probationMonths?: InputMaybe<Scalars['Int']['input']>;
  roleIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Date-only (T00:00:00.000Z). */
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type EmployeeContractLetterhead = {
  __typename?: 'EmployeeContractLetterhead';
  abn?: Maybe<Scalars['String']['output']>;
  acn?: Maybe<Scalars['String']['output']>;
  address?: Maybe<Scalars['String']['output']>;
  companyName: Scalars['String']['output'];
  email?: Maybe<Scalars['String']['output']>;
  /** Absolute URL of the employer logo (company logo, else the site logo). */
  logoUrl?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  /** EMPLOYER = the employer Company record; TENANT = no employer set, site branding used. */
  source: Scalars['String']['output'];
  tradingName?: Maybe<Scalars['String']['output']>;
  website?: Maybe<Scalars['String']['output']>;
};

export type EmployeeContractTemplate = {
  __typename?: 'EmployeeContractTemplate';
  active: Scalars['Boolean']['output'];
  awardCode: ContractAwardCode;
  awardName: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  employmentBasis: ContractEmploymentBasis;
  id: Scalars['ID']['output'];
  /** Markdown body with {{token}} merge fields. */
  markdown: Scalars['String']['output'];
  mergeFields: Array<ContractMergeField>;
  name: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  version: Scalars['Int']['output'];
};

export type EmployeeContractTemplateInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  awardCode: ContractAwardCode;
  /** Defaults from awardCode when omitted. */
  awardName?: InputMaybe<Scalars['String']['input']>;
  employmentBasis: ContractEmploymentBasis;
  markdown: Scalars['String']['input'];
  mergeFields?: InputMaybe<Array<ContractMergeFieldInput>>;
  name: Scalars['String']['input'];
};

/** One credential's expiry for one employee — drives the readiness page's Compliance rows. */
export type EmployeeCredentialExpiryRow = {
  __typename?: 'EmployeeCredentialExpiryRow';
  /** Negative when already expired. */
  daysRemaining?: Maybe<Scalars['Float']['output']>;
  employeeId: Scalars['ID']['output'];
  employeeName: Scalars['String']['output'];
  employeeNumber?: Maybe<Scalars['String']['output']>;
  /** For POLICE_CHECK this is receivedAt + 3 years (the aged-care renewal cycle). */
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  item: EmployeeCredentialItem;
  status: EmployeeCredentialExpiryStatus;
};

/** EXPIRED = past the date; EXPIRING = within the window asked for; MISSING = no document/date on file; OK = outside the window */
export enum EmployeeCredentialExpiryStatus {
  Expired = 'EXPIRED',
  Expiring = 'EXPIRING',
  Missing = 'MISSING',
  Ok = 'OK'
}

/** Which credential an expiry row refers to */
export enum EmployeeCredentialItem {
  Ahpra = 'AHPRA',
  Cpr = 'CPR',
  FirstAid = 'FIRST_AID',
  PoliceCheck = 'POLICE_CHECK'
}

export type EmployeeCredentials = {
  __typename?: 'EmployeeCredentials';
  ahpraCid?: Maybe<Scalars['String']['output']>;
  /** Date-only (T00:00:00.000Z). */
  ahpraExpiry?: Maybe<Scalars['DateTime']['output']>;
  ahpraNumber?: Maybe<Scalars['String']['output']>;
  /** When the Aged Care banning-orders register was checked. */
  bannedRegisterCheckedAt?: Maybe<Scalars['DateTime']['output']>;
  certificates?: Maybe<Array<EmployeeCertificate>>;
  coverLetterCid?: Maybe<Scalars['String']['output']>;
  covidImmunised?: Maybe<Scalars['Boolean']['output']>;
  cprCid?: Maybe<Scalars['String']['output']>;
  /** Date-only (T00:00:00.000Z). */
  cprExpiry?: Maybe<Scalars['DateTime']['output']>;
  firstAidCid?: Maybe<Scalars['String']['output']>;
  /** Date-only (T00:00:00.000Z). */
  firstAidExpiry?: Maybe<Scalars['DateTime']['output']>;
  fluImmunised?: Maybe<Scalars['Boolean']['output']>;
  policeCheck?: Maybe<EmployeePoliceCheck>;
  resumeCid?: Maybe<Scalars['String']['output']>;
  workingRightsCid?: Maybe<Scalars['String']['output']>;
  /** CITIZEN | PERMANENT_RESIDENT | VISA | UNKNOWN */
  workingRightsStatus?: Maybe<Scalars['String']['output']>;
};

export type EmployeeCredentialsInput = {
  ahpraCid?: InputMaybe<Scalars['String']['input']>;
  ahpraExpiry?: InputMaybe<Scalars['DateTime']['input']>;
  ahpraNumber?: InputMaybe<Scalars['String']['input']>;
  bannedRegisterCheckedAt?: InputMaybe<Scalars['DateTime']['input']>;
  certificates?: InputMaybe<Array<EmployeeCertificateInput>>;
  coverLetterCid?: InputMaybe<Scalars['String']['input']>;
  covidImmunised?: InputMaybe<Scalars['Boolean']['input']>;
  cprCid?: InputMaybe<Scalars['String']['input']>;
  cprExpiry?: InputMaybe<Scalars['DateTime']['input']>;
  firstAidCid?: InputMaybe<Scalars['String']['input']>;
  firstAidExpiry?: InputMaybe<Scalars['DateTime']['input']>;
  fluImmunised?: InputMaybe<Scalars['Boolean']['input']>;
  policeCheck?: InputMaybe<EmployeePoliceCheckInput>;
  resumeCid?: InputMaybe<Scalars['String']['input']>;
  workingRightsCid?: InputMaybe<Scalars['String']['input']>;
  workingRightsStatus?: InputMaybe<Scalars['String']['input']>;
};

export type EmployeeEmergencyContact = {
  __typename?: 'EmployeeEmergencyContact';
  email?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  relationship?: Maybe<Scalars['String']['output']>;
};

export type EmployeeEmergencyContactInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  relationship?: InputMaybe<Scalars['String']['input']>;
};

export type EmployeeFormSetting = {
  __typename?: 'EmployeeFormSetting';
  /** ADP Client ID printed on the Employee Detail Form (PLCC = 154693). Max 7 chars — it is a comb field. */
  adpClientId?: Maybe<Scalars['String']['output']>;
  /** ADP Client Name — defaults to the tenant name when unset. */
  adpClientName?: Maybe<Scalars['String']['output']>;
  /** ADP Company Group Code (max 2 chars, comb field). */
  adpCompanyGroupCode?: Maybe<Scalars['String']['output']>;
  /** Standing answer for ADP 'Loading' when the employee record says nothing. Defaults to No. */
  adpDefaultThresholdLoading?: Maybe<Scalars['Boolean']['output']>;
  /** Standing answer for ADP 'Voluntary Agreement' when the employee record says nothing. Defaults to No. */
  adpDefaultVoluntaryAgreement?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['DateTime']['output'];
  defaultFundAbn?: Maybe<Scalars['String']['output']>;
  defaultFundName?: Maybe<Scalars['String']['output']>;
  defaultFundUsi?: Maybe<Scalars['String']['output']>;
  employerAbn?: Maybe<Scalars['String']['output']>;
  employerBusinessName?: Maybe<Scalars['String']['output']>;
  enabled: Scalars['Boolean']['output'];
  formType: EmployeeFormType;
  id: Scalars['ID']['output'];
  /** When true, new invites require this form by default. */
  mandatory: Scalars['Boolean']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** Onboarding forms an employee can digitally sign. TFN_DECLARATION = Tax file number declaration (NAT 3092). SUPER_CHOICE = Superannuation standard choice form (NAT 13080). EMPLOYMENT_CONTRACT = employment agreement rendered from the tenant contract template attached to the invite. */
export enum EmployeeFormType {
  EmploymentContract = 'EMPLOYMENT_CONTRACT',
  SuperChoice = 'SUPER_CHOICE',
  TfnDeclaration = 'TFN_DECLARATION'
}

export type EmployeeHoursBreakdownRow = {
  __typename?: 'EmployeeHoursBreakdownRow';
  aftn: Scalars['Float']['output'];
  /** The award the overtime thresholds were taken from — the ★ primary role's rate row first, the employee card's award as fallback. Empty when the employee has no award classification anywhere. */
  awardName: Scalars['String']['output'];
  /** OT-C2 needs a full pay fortnight; false on shorter windows. */
  c2Applicable: Scalars['Boolean']['output'];
  /** Public-holiday hours WORKED under the Nurses Award — double time (D/Time). */
  dtime: Scalars['Float']['output'];
  /** Public-holiday hours WORKED under an Aged Care award — double time and a half (D/Time HF). */
  dtimeHf: Scalars['Float']['output'];
  employeeId: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  night: Scalars['Float']['output'];
  /** All non-overtime worked hours — penalties are loadings on top, not slices out of this. */
  ord: Scalars['Float']['output'];
  /** False when overtime was NEVER COMPUTED for this person — no award classification, or an award the engine has no OT rule for (only Aged Care and Nurses are priced). The otC1/otC2 figures are then 0 because nothing ran, not because nobody crossed a threshold; show 'n/a', never the zeros (Leah Hardy, 14 Sep 2026). */
  otApplicable: Scalars['Boolean']['output'];
  otC1: Scalars['Float']['output'];
  /** OT-C1 paid at 200% — past the day's first 2 overtime hours. A SUNDAY's overtime is 200% for all of it, so a Sunday lands entirely here. */
  otC1After2: Scalars['Float']['output'];
  /** OT-C1 paid at 150% — the first 2 overtime hours on a Brisbane DAY. The boundary is per DAY, not per fortnight (Abby, 1 Sep 2026). */
  otC1First2: Scalars['Float']['output'];
  otC2: Scalars['Float']['output'];
  /** Why overtime was not computed — 'no award' or 'no OT rule for <award>'. Empty when otApplicable. */
  otNotComputedReason: Scalars['String']['output'];
  /** The role these hours were worked in. Present only when the person worked MORE THAN ONE role in the window — a single-role employee gets one unlabelled row, exactly as before (Abby, 1 Sep 2026). */
  roleName?: Maybe<Scalars['String']['output']>;
  /** False when any hour in this row was worked in a role the employee's card does not hold — hours the card cannot price (no rate, no award) until the role is added on the Financial tab. The employee card is the single source of truth for roles (2026-09-14). */
  roleOnCard: Scalars['Boolean']['output'];
  sat: Scalars['Float']['output'];
  shiftCount: Scalars['Int']['output'];
  sun: Scalars['Float']['output'];
  /** Net worked hours (leave excluded). */
  worked: Scalars['Float']['output'];
};

export type EmployeeIncident = {
  __typename?: 'EmployeeIncident';
  activityLogEntryId?: Maybe<Scalars['String']['output']>;
  attachments: Array<EmployeeActivityAttachment>;
  bodyPartAffected?: Maybe<Scalars['String']['output']>;
  closedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  employeeId: Scalars['String']['output'];
  employeeName?: Maybe<Scalars['String']['output']>;
  gpReferralNeeded?: Maybe<Scalars['Boolean']['output']>;
  harassmentSubType?: Maybe<HarassmentSubType>;
  howInjuryOccurred?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  immediateActionTaken?: Maybe<Scalars['String']['output']>;
  incidentDate: Scalars['DateTime']['output'];
  incidentNumber: Scalars['Int']['output'];
  incidentTime?: Maybe<Scalars['String']['output']>;
  incidentType: EmployeeIncidentType;
  location?: Maybe<Scalars['String']['output']>;
  medicalAttentionNeeded?: Maybe<Scalars['Boolean']['output']>;
  natureOfMisconduct?: Maybe<Scalars['String']['output']>;
  personsInvolved?: Maybe<Array<Scalars['String']['output']>>;
  resolvedAt?: Maybe<Scalars['DateTime']['output']>;
  reviewNotes?: Maybe<Scalars['String']['output']>;
  reviewedAt?: Maybe<Scalars['DateTime']['output']>;
  reviewedById?: Maybe<Scalars['String']['output']>;
  reviewedByName?: Maybe<Scalars['String']['output']>;
  status: EmployeeIncidentStatus;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  witnesses?: Maybe<Array<Scalars['String']['output']>>;
};

export type EmployeeIncidentFilterInput = {
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  employeeId?: InputMaybe<Scalars['String']['input']>;
  incidentTypes?: InputMaybe<Array<EmployeeIncidentType>>;
  search?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<EmployeeIncidentStatus>>;
};

/** How to resolve the employee incident notification recipient(s) */
export enum EmployeeIncidentNotificationRecipientType {
  AllHrManagers = 'ALL_HR_MANAGERS',
  Role = 'ROLE',
  SpecificEmployee = 'SPECIFIC_EMPLOYEE'
}

export type EmployeeIncidentNotificationRule = {
  __typename?: 'EmployeeIncidentNotificationRule';
  channels: Array<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  isEnabled: Scalars['Boolean']['output'];
  messageTemplate?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  recipientIds?: Maybe<Array<Scalars['String']['output']>>;
  recipientRole?: Maybe<Scalars['String']['output']>;
  recipientType: EmployeeIncidentNotificationRecipientType;
  tenantId: Scalars['String']['output'];
  trigger: EmployeeIncidentNotificationTrigger;
  updatedAt: Scalars['DateTime']['output'];
};

/** Event that triggers an employee incident notification */
export enum EmployeeIncidentNotificationTrigger {
  HarassmentReported = 'HARASSMENT_REPORTED',
  IncidentResolved = 'INCIDENT_RESOLVED',
  IncidentStatusChanged = 'INCIDENT_STATUS_CHANGED',
  IncidentSubmitted = 'INCIDENT_SUBMITTED',
  InjuryReported = 'INJURY_REPORTED',
  MisconductReported = 'MISCONDUCT_REPORTED'
}

/** Current status of the employee incident */
export enum EmployeeIncidentStatus {
  Closed = 'CLOSED',
  Investigating = 'INVESTIGATING',
  Resolved = 'RESOLVED',
  Submitted = 'SUBMITTED',
  UnderReview = 'UNDER_REVIEW'
}

/** Type of employee incident being reported */
export enum EmployeeIncidentType {
  Harassment = 'HARASSMENT',
  Other = 'OTHER',
  PersonalInjury = 'PERSONAL_INJURY',
  WorkplaceMisconduct = 'WORKPLACE_MISCONDUCT'
}

export type EmployeeIncidentsResponse = {
  __typename?: 'EmployeeIncidentsResponse';
  incidents: Array<EmployeeIncident>;
  total: Scalars['Int']['output'];
};

export type EmployeeInput = {
  address?: InputMaybe<EmployeeAddressInput>;
  adpLeaveBalanceAsAt?: InputMaybe<Scalars['DateTime']['input']>;
  adpOpeningAnnualLeaveHours?: InputMaybe<Scalars['Float']['input']>;
  adpOpeningLongServiceLeaveHours?: InputMaybe<Scalars['Float']['input']>;
  adpOpeningPersonalLeaveHours?: InputMaybe<Scalars['Float']['input']>;
  agencyCompany?: InputMaybe<Scalars['String']['input']>;
  annualLeaveEntitlementHours?: InputMaybe<Scalars['Float']['input']>;
  annualSalary?: InputMaybe<Scalars['Float']['input']>;
  awardClassificationId?: InputMaybe<Scalars['String']['input']>;
  bankAccountName?: InputMaybe<Scalars['String']['input']>;
  bankAccountNumber?: InputMaybe<Scalars['String']['input']>;
  bankBSB?: InputMaybe<Scalars['String']['input']>;
  carRegistration?: InputMaybe<Scalars['String']['input']>;
  certifications?: InputMaybe<Array<Scalars['String']['input']>>;
  claimsTaxFreeThreshold?: InputMaybe<Scalars['Boolean']['input']>;
  claimsThresholdLoading?: InputMaybe<Scalars['Boolean']['input']>;
  clientId: Scalars['ID']['input'];
  companyId: Scalars['ID']['input'];
  contractType?: InputMaybe<Scalars['String']['input']>;
  credentials?: InputMaybe<EmployeeCredentialsInput>;
  customAwardName?: InputMaybe<Scalars['String']['input']>;
  dateDeclinedPTLetterSent?: InputMaybe<Scalars['DateTime']['input']>;
  dateOfBirth?: InputMaybe<Scalars['DateTime']['input']>;
  dateOfferedPT?: InputMaybe<Scalars['DateTime']['input']>;
  dateTfnSigned?: InputMaybe<Scalars['DateTime']['input']>;
  departmentIds?: InputMaybe<Array<Scalars['String']['input']>>;
  emergencyContact?: InputMaybe<EmployeeEmergencyContactInput>;
  employeeNumber?: InputMaybe<Scalars['String']['input']>;
  employmentType?: InputMaybe<EmploymentType>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  hasStudyTrainingLoan?: InputMaybe<Scalars['Boolean']['input']>;
  hasVoluntaryAgreement?: InputMaybe<Scalars['Boolean']['input']>;
  hourlyRate?: InputMaybe<Scalars['Float']['input']>;
  hoursBasis?: InputMaybe<HoursBasis>;
  isShiftWorker?: InputMaybe<Scalars['Boolean']['input']>;
  locationIds?: InputMaybe<Array<Scalars['String']['input']>>;
  maxHoursPerWeek?: InputMaybe<Scalars['Float']['input']>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  minHoursPerWeek?: InputMaybe<Scalars['Float']['input']>;
  minimumHoursPerFortnight?: InputMaybe<Scalars['Float']['input']>;
  mobileNumber?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  payFrequency?: InputMaybe<Scalars['String']['input']>;
  payPointCode?: InputMaybe<Scalars['String']['input']>;
  payRates?: InputMaybe<Array<EmployeePayRateEntryInput>>;
  payeeAbn?: InputMaybe<Scalars['String']['input']>;
  paymentType?: InputMaybe<PaymentType>;
  personalLeaveEntitlementHours?: InputMaybe<Scalars['Float']['input']>;
  position?: InputMaybe<Scalars['String']['input']>;
  positionIds?: InputMaybe<Array<Scalars['String']['input']>>;
  preferredName?: InputMaybe<Scalars['String']['input']>;
  profilePhoto?: InputMaybe<Scalars['String']['input']>;
  profilePhotoCid?: InputMaybe<Scalars['String']['input']>;
  qualifications?: InputMaybe<Array<Scalars['String']['input']>>;
  reportingTo?: InputMaybe<Scalars['String']['input']>;
  reportsToEmployeeId?: InputMaybe<Scalars['String']['input']>;
  responsibilitiesMarkdown?: InputMaybe<Scalars['String']['input']>;
  roleIds?: InputMaybe<Array<Scalars['String']['input']>>;
  roleRates?: InputMaybe<Array<EmployeeRoleRateEntryInput>>;
  smsfAbn?: InputMaybe<Scalars['String']['input']>;
  smsfBankAccountName?: InputMaybe<Scalars['String']['input']>;
  smsfBankAccountNumber?: InputMaybe<Scalars['String']['input']>;
  smsfBankBSB?: InputMaybe<Scalars['String']['input']>;
  smsfEsa?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  superChoiceType?: InputMaybe<SuperChoiceType>;
  superFundABN?: InputMaybe<Scalars['String']['input']>;
  superFundUSI?: InputMaybe<Scalars['String']['input']>;
  superMemberNumber?: InputMaybe<Scalars['String']['input']>;
  superNameOnAccount?: InputMaybe<Scalars['String']['input']>;
  superannuationFund?: InputMaybe<Scalars['String']['input']>;
  taxFileNumber?: InputMaybe<Scalars['String']['input']>;
  taxResidencyStatus?: InputMaybe<TaxResidencyStatus>;
  taxScale?: InputMaybe<Scalars['String']['input']>;
  terminationReason?: InputMaybe<Scalars['String']['input']>;
  visaCountry?: InputMaybe<Scalars['String']['input']>;
  workEmail?: InputMaybe<Scalars['String']['input']>;
  workPhone?: InputMaybe<Scalars['String']['input']>;
  workingRights?: InputMaybe<Scalars['String']['input']>;
};

export type EmployeeInvite = {
  __typename?: 'EmployeeInvite';
  attachmentCids?: Maybe<Array<EmployeeInviteAttachment>>;
  /** AwardClassification the primary role is paid under. Required when a contract template is attached. */
  awardClassificationId?: Maybe<Scalars['ID']['output']>;
  /** Agreed base hourly rate for the primary role ($/h). Must be at or above the classification floor. Required when a contract template is attached. */
  baseHourlyRate?: Maybe<Scalars['Float']['output']>;
  clientId?: Maybe<Scalars['ID']['output']>;
  companyId: Scalars['ID']['output'];
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  /** True when the contract must be signed from the invite link before the details form (contract-first, since 2026-10-01). */
  contractFirst?: Maybe<Scalars['Boolean']['output']>;
  /** The manager's edited contract text for THIS invite (markdown). When set it is what is signed and PDF'd instead of the template render; only the employee's own {{tokens}} remain. */
  contractMarkdownOverride?: Maybe<Scalars['String']['output']>;
  /** JSON object of {{token}} → value for the contract template. */
  contractMergeValues?: Maybe<Scalars['String']['output']>;
  /** When the invitee signed the contract from the invite link. */
  contractSignedAt?: Maybe<Scalars['DateTime']['output']>;
  /** EmployeeSignedForm created from the invite signature when the employee record was created. */
  contractSignedFormId?: Maybe<Scalars['ID']['output']>;
  /** CID of the signed contract PDF (tenant IPFS node). */
  contractSignedPdfCid?: Maybe<Scalars['String']['output']>;
  /** The name the invitee typed when signing the contract. */
  contractSignerName?: Maybe<Scalars['String']['output']>;
  /** EmployeeContractTemplate to render + e-sign in the portal. */
  contractTemplateId?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdByName?: Maybe<Scalars['String']['output']>;
  departmentId?: Maybe<Scalars['ID']['output']>;
  email: Scalars['String']['output'];
  emailSentAt?: Maybe<Scalars['DateTime']['output']>;
  employeeId?: Maybe<Scalars['ID']['output']>;
  /** PPT / FT / CASUAL — defaults from the contract template; maps to Employee.employmentType on sign-up. */
  employmentBasis?: Maybe<ContractEmploymentBasis>;
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  /** Invitee's first name as typed on the offer — the letter says "Dear <first name>,". */
  fName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Invitee's last name as typed on the offer. */
  lName?: Maybe<Scalars['String']['output']>;
  /** Minimum contracted hours per week (the contract's {{minimumHoursPerWeek}}). */
  minimumHoursPerWeek?: Maybe<Scalars['Float']['output']>;
  /** Plain-English notes recorded when the invite was sent (e.g. the classification had no award floor to check the rate against). */
  payWarnings?: Maybe<Array<Scalars['String']['output']>>;
  position?: Maybe<Scalars['String']['output']>;
  /** EmployeePosition id (the positions module). Optional since 2026-09-04 — the ROLE is what the letter must carry; when absent the primary role names the job. */
  positionId?: Maybe<Scalars['ID']['output']>;
  /** Probation period in months (the contract's {{probationMonths}}); default 6. */
  probationMonths?: Maybe<Scalars['Int']['output']>;
  /** Server-computed onboarding progress (sections + required sign-forms). */
  progress: EmployeeOnboardingProgress;
  /** EmployeeRecommendation this invite answers (credentials are copied from it on onboarding). */
  recommendationId?: Maybe<Scalars['ID']['output']>;
  /** Last manual onboarding reminder (chase) sent for this invite. */
  reminderLastSentAt?: Maybe<Scalars['DateTime']['output']>;
  /** Position/s the employee reports to (the contract's {{reportsTo}}). */
  reportsTo?: Maybe<Scalars['String']['output']>;
  /** Onboarding forms this invitee must digitally sign. Defaulted from tenant EmployeeFormSetting rows at create time. */
  requiredFormTypes?: Maybe<Array<EmployeeFormType>>;
  /** @deprecated Use roleIds — roleId mirrors roleIds[0] (the primary role). */
  roleId?: Maybe<Scalars['ID']['output']>;
  /** EmployeeRole ids in order — at least one; the FIRST is the primary role the pay facts describe. Seeds Employee.roleIds on sign-up. */
  roleIds?: Maybe<Array<Scalars['ID']['output']>>;
  /** Award + rate per invited role. The row for roleIds[0] is the primary and mirrors baseHourlyRate/awardClassificationId. */
  roleRates?: Maybe<Array<EmployeeInviteRoleRate>>;
  slug: Scalars['String']['output'];
  /** Offered start date — date-only (T00:00:00.000Z). Copied to Employee.startDate on onboarding. */
  startDate?: Maybe<Scalars['DateTime']['output']>;
  status: EmployeeInviteStatus;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type EmployeeInviteAttachment = {
  __typename?: 'EmployeeInviteAttachment';
  cid: Scalars['String']['output'];
  contentType?: Maybe<Scalars['String']['output']>;
  label: Scalars['String']['output'];
};

export type EmployeeInviteAttachmentInput = {
  cid: Scalars['String']['input'];
  contentType?: InputMaybe<Scalars['String']['input']>;
  label: Scalars['String']['input'];
};

export type EmployeeInviteContractView = {
  __typename?: 'EmployeeInviteContractView';
  edited: Scalars['Boolean']['output'];
  email: Scalars['String']['output'];
  inviteId: Scalars['ID']['output'];
  letterhead: EmployeeContractLetterhead;
  /** Rendered agreement (markdown). Merge values are wrapped in highlight sentinels when asked. */
  markdown: Scalars['String']['output'];
  signed: Scalars['Boolean']['output'];
  signedAt?: Maybe<Scalars['DateTime']['output']>;
  signedPdfUrl?: Maybe<Scalars['String']['output']>;
  signerName?: Maybe<Scalars['String']['output']>;
  templateName: Scalars['String']['output'];
};

export type EmployeeInviteRoleRate = {
  __typename?: 'EmployeeInviteRoleRate';
  /** AwardClassification THIS role is paid under. Per-row: one person can work under two awards. */
  awardClassificationId?: Maybe<Scalars['ID']['output']>;
  /** Basis for THIS role — picks the casual vs base award floor. Defaults to the invite-level basis. */
  employmentBasis?: Maybe<ContractEmploymentBasis>;
  /** Agreed base hourly rate for THIS role ($/h). */
  rate: Scalars['Float']['output'];
  roleId: Scalars['ID']['output'];
};

export type EmployeeInviteRoleRateInput = {
  awardClassificationId?: InputMaybe<Scalars['ID']['input']>;
  employmentBasis?: InputMaybe<ContractEmploymentBasis>;
  rate: Scalars['Float']['input'];
  roleId: Scalars['ID']['input'];
};

/** Status of an employee onboarding invite */
export enum EmployeeInviteStatus {
  Completed = 'COMPLETED',
  Expired = 'EXPIRED',
  Pending = 'PENDING'
}

/** An employee's leave balances, as at the last pay run and today */
export type EmployeeLeaveBalance = {
  __typename?: 'EmployeeLeaveBalance';
  /** Balances at the end of payRunEnd */
  asAtPayRun: Array<LeaveBalanceLine>;
  /** Whether the viewer may open this employee's record in the Employees module (computed server-side) */
  canViewEmployeeDetail: Scalars['Boolean']['output'];
  /** Balances today, with booked, pending and free hours */
  current: Array<LeaveBalanceLine>;
  /** The employee's Finance tab (where the ADP starting point is entered) — only when canViewEmployeeDetail */
  employeeDetailUrl?: Maybe<Scalars['String']['output']>;
  employeeId: Scalars['ID']['output'];
  employeeName?: Maybe<Scalars['String']['output']>;
  employmentType?: Maybe<Scalars['String']['output']>;
  hasOpeningBalance: Scalars['Boolean']['output'];
  isCasual: Scalars['Boolean']['output'];
  notes: Array<Scalars['String']['output']>;
  /** The ADP as-at date (date-only) */
  openingAsAt?: Maybe<Scalars['DateTime']['output']>;
  /** Last day of the most recent pay period that has fully passed (date-only) */
  payRunEnd?: Maybe<Scalars['DateTime']['output']>;
  /** How the pay-run date was worked out, in plain words */
  payRunRule: Scalars['String']['output'];
};

export type EmployeeLinkAuthResult = {
  __typename?: 'EmployeeLinkAuthResult';
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
  token?: Maybe<Scalars['String']['output']>;
};

export type EmployeeLoginAccessSyncResult = {
  __typename?: 'EmployeeLoginAccessSyncResult';
  action: Scalars['String']['output'];
  clientId?: Maybe<Scalars['String']['output']>;
  employeeId: Scalars['ID']['output'];
  loginBlockedAt?: Maybe<Scalars['DateTime']['output']>;
  loginBlockedReason?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type EmployeeModuleSetting = {
  __typename?: 'EmployeeModuleSetting';
  createdAt: Scalars['DateTime']['output'];
  /** The Company that EMPLOYS this site's staff — the default Employer on the offer letter and the default Company when adding an employee directly. Unset = the forms ask, rather than guess. */
  employerCompanyId?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** How to resolve the employee notification recipient(s) */
export enum EmployeeNotificationRecipientType {
  AllHrManagers = 'ALL_HR_MANAGERS',
  Department = 'DEPARTMENT',
  Role = 'ROLE',
  SpecificEmployee = 'SPECIFIC_EMPLOYEE'
}

export type EmployeeNotificationRule = {
  __typename?: 'EmployeeNotificationRule';
  channels: Array<Scalars['String']['output']>;
  chatRecipientCooldownMinutes?: Maybe<Scalars['Float']['output']>;
  chatSessionGapMinutes?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['DateTime']['output'];
  filterDepartmentId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Invitee-facing letter body in markdown (INVITE_CREATED rules). Tokens: {{companyName}} {{positionTitle}} {{startDate}} {{portalLink}} {{attachments}} {{missingCredentials}} {{invitedBy}} {{expiresOn}}. */
  inviteLetterBody?: Maybe<Scalars['String']['output']>;
  /** Invitee-facing letter subject (INVITE_CREATED rules). Tokens: {{companyName}} {{positionTitle}} {{startDate}}. */
  inviteLetterSubject?: Maybe<Scalars['String']['output']>;
  isEnabled: Scalars['Boolean']['output'];
  messageTemplate?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  recipientDepartmentId?: Maybe<Scalars['String']['output']>;
  recipientIds?: Maybe<Array<Scalars['String']['output']>>;
  recipientRole?: Maybe<Scalars['String']['output']>;
  recipientType: EmployeeNotificationRecipientType;
  tenantId: Scalars['String']['output'];
  trigger: EmployeeNotificationTrigger;
  updatedAt: Scalars['DateTime']['output'];
};

/** Event that triggers an employee notification */
export enum EmployeeNotificationTrigger {
  ActivityCreated = 'ACTIVITY_CREATED',
  ActivityFileUploaded = 'ACTIVITY_FILE_UPLOADED',
  ActivityUpdated = 'ACTIVITY_UPDATED',
  AllEvents = 'ALL_EVENTS',
  ChatMessageReceived = 'CHAT_MESSAGE_RECEIVED',
  CredentialsGenerated = 'CREDENTIALS_GENERATED',
  DepartmentChanged = 'DEPARTMENT_CHANGED',
  EmployeeCreated = 'EMPLOYEE_CREATED',
  EmployeeDeleted = 'EMPLOYEE_DELETED',
  EmployeeLogin = 'EMPLOYEE_LOGIN',
  EmployeeStatusChanged = 'EMPLOYEE_STATUS_CHANGED',
  EmployeeUpdated = 'EMPLOYEE_UPDATED',
  FormSigned = 'FORM_SIGNED',
  HarassmentReported = 'HARASSMENT_REPORTED',
  IncidentResolved = 'INCIDENT_RESOLVED',
  IncidentStatusChanged = 'INCIDENT_STATUS_CHANGED',
  IncidentSubmitted = 'INCIDENT_SUBMITTED',
  InjuryReported = 'INJURY_REPORTED',
  InviteCreated = 'INVITE_CREATED',
  InviteReminderSent = 'INVITE_REMINDER_SENT',
  MisconductReported = 'MISCONDUCT_REPORTED',
  OnboardingCompleted = 'ONBOARDING_COMPLETED',
  PasswordReset = 'PASSWORD_RESET',
  PermissionAdded = 'PERMISSION_ADDED',
  PermissionRemoved = 'PERMISSION_REMOVED',
  RecommendationReceived = 'RECOMMENDATION_RECEIVED',
  TrainingAssigned = 'TRAINING_ASSIGNED',
  TrainingCompleted = 'TRAINING_COMPLETED',
  TrainingOverdue = 'TRAINING_OVERDUE'
}

/** Server-computed onboarding progress for an invite (replaces the old client-side 500-employee scan). */
export type EmployeeOnboardingProgress = {
  __typename?: 'EmployeeOnboardingProgress';
  completedCount: Scalars['Float']['output'];
  percent: Scalars['Float']['output'];
  promptedFormTypes?: Maybe<Array<EmployeeFormType>>;
  reminderLastSentAt?: Maybe<Scalars['DateTime']['output']>;
  sections: Array<OnboardingProgressSection>;
  totalCount: Scalars['Float']['output'];
};

export type EmployeePaginationInput = {
  contractType?: InputMaybe<Scalars['String']['input']>;
  departmentId?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  position?: InputMaybe<Scalars['String']['input']>;
  roleId?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<EmployeeSortField>;
  sortOrder?: InputMaybe<SortOrder>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type EmployeePayProfile = {
  __typename?: 'EmployeePayProfile';
  /** ADP-equivalent leave-rule code, e.g. "A07" */
  annualLeaveRuleCode?: Maybe<Scalars['String']['output']>;
  /** Employment category for display: Full Time / Part Time / Casual */
  category?: Maybe<Scalars['String']['output']>;
  /** Cost centre code, e.g. "Home" */
  costCentre?: Maybe<Scalars['String']['output']>;
  costCode?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  /** Contracted days per week (FT/PT) */
  daysPerWeek?: Maybe<Scalars['Float']['output']>;
  /** ADP department code */
  department?: Maybe<Scalars['String']['output']>;
  /** Number of dependants declared (Medicare reduction) */
  dependants?: Maybe<Scalars['Int']['output']>;
  employeeId: Scalars['ID']['output'];
  /** Contracted fortnightly hours (used for SALARIED_COMPENSATION) */
  fortnightlyHours?: Maybe<Scalars['Float']['output']>;
  /** HELP / STSL debt indicator */
  helpStslDebt: Scalars['Boolean']['output'];
  /** Contracted hours per day (FT/PT) */
  hoursPerDay?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  /** STP Phase 2 income type — almost always SAW */
  incomeType: IncomeType;
  /** ADP-equivalent LSL-rule code, e.g. "L08" */
  lslRuleCode?: Maybe<Scalars['String']['output']>;
  /** Medicare levy exemption flag */
  medicareLevyExempt: Scalars['Boolean']['output'];
  medicareVariation?: Maybe<MedicareVariation>;
  notes?: Maybe<Scalars['String']['output']>;
  /** ADP pay-point code, e.g. "04 CARE WORKER" */
  payPoint?: Maybe<Scalars['String']['output']>;
  /** ADP-equivalent personal-leave-rule code, e.g. "S04" */
  personalLeaveRuleCode?: Maybe<Scalars['String']['output']>;
  /** SFSS debt indicator (legacy) */
  sfssDebt: Scalars['Boolean']['output'];
  /** Exempt from SGC (e.g. director with chair role only) */
  sgcExempt: Scalars['Boolean']['output'];
  /** Reason for SGC exemption (audit trail) */
  sgcExemptReason?: Maybe<Scalars['String']['output']>;
  /** Super contribution % — default 12.0 from 1 July 2025 */
  superContributionPct: Scalars['Float']['output'];
  superFundABN?: Maybe<Scalars['String']['output']>;
  /** Super fund USI (Unique Superannuation Identifier) */
  superFundUSI?: Maybe<Scalars['String']['output']>;
  superMemberNumber?: Maybe<Scalars['String']['output']>;
  /** Tax-free threshold claimed on TFN declaration */
  taxFreeThresholdClaimed: Scalars['Boolean']['output'];
  taxScaleCode?: Maybe<TaxScale>;
  /** 6-character STP2 Tax Treatment Code, computed from declarations */
  taxTreatmentCode?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  /** Date the TFN declaration was lodged with ATO (UTC midnight) */
  tfnDeclarationLodged?: Maybe<Scalars['DateTime']['output']>;
  /** TFN authorized for super (ATO SGC reporting) */
  tfnForSuper: Scalars['Boolean']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type EmployeePayRateEntry = {
  __typename?: 'EmployeePayRateEntry';
  /** Rate effective from this date (UTC midnight) per date-standards.md */
  effectiveFrom: Scalars['DateTime']['output'];
  /** Last day the rate applies (UTC midnight, INCLUSIVE). Empty = ongoing. */
  effectiveTo?: Maybe<Scalars['DateTime']['output']>;
  rate: Scalars['Float']['output'];
};

export type EmployeePayRateEntryInput = {
  effectiveFrom: Scalars['DateTime']['input'];
  effectiveTo?: InputMaybe<Scalars['DateTime']['input']>;
  rate: Scalars['Float']['input'];
};

export type EmployeePoliceCheck = {
  __typename?: 'EmployeePoliceCheck';
  assessedAt?: Maybe<Scalars['DateTime']['output']>;
  assessedByName?: Maybe<Scalars['String']['output']>;
  cid?: Maybe<Scalars['String']['output']>;
  disclosedConvictions?: Maybe<Scalars['String']['output']>;
  /** CLEAR | DISCLOSABLE | PENDING — as assessed by the receiving manager. */
  outcome?: Maybe<Scalars['String']['output']>;
  receivedAt?: Maybe<Scalars['DateTime']['output']>;
  requiresFurtherAssessment?: Maybe<Scalars['Boolean']['output']>;
};

export type EmployeePoliceCheckInput = {
  assessedAt?: InputMaybe<Scalars['DateTime']['input']>;
  assessedByName?: InputMaybe<Scalars['String']['input']>;
  cid?: InputMaybe<Scalars['String']['input']>;
  disclosedConvictions?: InputMaybe<Scalars['String']['input']>;
  outcome?: InputMaybe<Scalars['String']['input']>;
  receivedAt?: InputMaybe<Scalars['DateTime']['input']>;
  requiresFurtherAssessment?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EmployeePosition = {
  __typename?: 'EmployeePosition';
  color?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  displayOrder?: Maybe<Scalars['Float']['output']>;
  employeeUsageCount: Scalars['Int']['output'];
  employeeUsageNames: Array<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type EmployeePositionInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayOrder?: InputMaybe<Scalars['Float']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
};

export type EmployeeReadinessRow = {
  __typename?: 'EmployeeReadinessRow';
  /** Agency name when employmentType is AGENCY. */
  agencyCompany?: Maybe<Scalars['String']['output']>;
  completedCount: Scalars['Int']['output'];
  departmentName?: Maybe<Scalars['String']['output']>;
  employeeId: Scalars['ID']['output'];
  employeeNumber?: Maybe<Scalars['String']['output']>;
  /** FULL_TIME / PART_TIME / CASUAL / CONTRACT / AGENCY. AGENCY records answer a shorter checklist — they are an agency, not a person. */
  employmentType?: Maybe<Scalars['String']['output']>;
  isReady: Scalars['Boolean']['output'];
  missingCount: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  sections: Array<ReadinessSectionRow>;
  status?: Maybe<Scalars['String']['output']>;
  totalCount: Scalars['Int']['output'];
};

export type EmployeeRecommendation = {
  __typename?: 'EmployeeRecommendation';
  attachments: Array<RecommendationAttachment>;
  createdAt: Scalars['DateTime']['output'];
  credentials?: Maybe<RecommendationCredentials>;
  decidedAt?: Maybe<Scalars['DateTime']['output']>;
  decidedById?: Maybe<Scalars['ID']['output']>;
  decidedByName?: Maybe<Scalars['String']['output']>;
  declineReason?: Maybe<Scalars['String']['output']>;
  /** Date-only (T00:00:00.000Z). */
  earliestStart?: Maybe<Scalars['DateTime']['output']>;
  employeeId?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  interviewSummary?: Maybe<Scalars['String']['output']>;
  /** Domain-relative link to the linked invite; only set when the viewer may view employees. */
  inviteDetailUrl?: Maybe<Scalars['String']['output']>;
  inviteId?: Maybe<Scalars['ID']['output']>;
  person: RecommendationPerson;
  positionTitle: Scalars['String']['output'];
  preScreenSummary?: Maybe<Scalars['String']['output']>;
  receivedAt: Scalars['DateTime']['output'];
  references: Array<RecommendationReference>;
  roleCategory?: Maybe<Scalars['String']['output']>;
  /** The candidate id ON THE RECRUITER'S tenant — an opaque key here, never a link. */
  sourceCandidateId: Scalars['String']['output'];
  sourceCompanyId?: Maybe<Scalars['String']['output']>;
  /** The recruiting tenant that put this candidate forward. */
  sourceTenantId: Scalars['String']['output'];
  sourceTenantName: Scalars['String']['output'];
  status: EmployeeRecommendationStatus;
  tenantId: Scalars['String']['output'];
  timeline: Array<RecommendationTimelineEntry>;
  updatedAt: Scalars['DateTime']['output'];
};

/** Lifecycle of a candidate recommendation received from a recruiting partner tenant */
export enum EmployeeRecommendationStatus {
  Declined = 'DECLINED',
  Invited = 'INVITED',
  Received = 'RECEIVED',
  Withdrawn = 'WITHDRAWN'
}

export type EmployeeRole = {
  __typename?: 'EmployeeRole';
  color?: Maybe<Scalars['String']['output']>;
  countsTowardCareMinutes: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  displayOrder?: Maybe<Scalars['Float']['output']>;
  employeeUsageCount: Scalars['Int']['output'];
  employeeUsageNames: Array<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  shiftUsageCount: Scalars['Int']['output'];
  shortCode?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type EmployeeRoleInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  countsTowardCareMinutes?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayOrder?: InputMaybe<Scalars['Float']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  shortCode?: InputMaybe<Scalars['String']['input']>;
};

export type EmployeeRoleRateEntry = {
  __typename?: 'EmployeeRoleRateEntry';
  /** AwardClassification this role's rate is paid under. Per-row: one person can work under two awards. */
  awardClassificationId?: Maybe<Scalars['ID']['output']>;
  /** Rate effective from this Brisbane day (stored UTC midnight) per date-standards.md */
  effectiveFrom: Scalars['DateTime']['output'];
  /** Last day the rate applies (UTC midnight, INCLUSIVE). Empty = ongoing. */
  effectiveTo?: Maybe<Scalars['DateTime']['output']>;
  rate: Scalars['Float']['output'];
  /** EmployeeRole this rate is for — must be one of the employee's roleIds. */
  roleId: Scalars['ID']['output'];
};

export type EmployeeRoleRateEntryInput = {
  awardClassificationId?: InputMaybe<Scalars['ID']['input']>;
  effectiveFrom: Scalars['DateTime']['input'];
  effectiveTo?: InputMaybe<Scalars['DateTime']['input']>;
  rate: Scalars['Float']['input'];
  roleId: Scalars['ID']['input'];
};

/** Per-employee assigned-hour totals for the week and pay fortnight containing a given shift. Used by the roster's candidate-staff list to enforce min/max compliance under either an employee's WEEKLY or FORTNIGHTLY hoursBasis. */
export type EmployeeShiftHoursContext = {
  __typename?: 'EmployeeShiftHoursContext';
  employeeId: Scalars['ID']['output'];
  fortnightEnd: Scalars['DateTime']['output'];
  fortnightHours: Scalars['Float']['output'];
  fortnightStart: Scalars['DateTime']['output'];
  weekEnd: Scalars['DateTime']['output'];
  weekHours: Scalars['Float']['output'];
  weekStart: Scalars['DateTime']['output'];
};

export type EmployeeSignedForm = {
  __typename?: 'EmployeeSignedForm';
  clientId?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['DateTime']['output'];
  /** Declaration wording shown to the signer, verbatim. */
  declarationText: Scalars['String']['output'];
  employeeId: Scalars['ID']['output'];
  /** SHA-256 over canonical payload + declaration text — proves what was signed. */
  formPayloadHash: Scalars['String']['output'];
  formType: EmployeeFormType;
  /** ATO form version this record replicates, e.g. NAT3092-11.2024 */
  formVersion: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  ipAddress?: Maybe<Scalars['String']['output']>;
  /** JSON snapshot of the answers as signed (server-derived from Employee + Client at sign time). */
  payloadJson: Scalars['String']['output'];
  signatureImage: Scalars['String']['output'];
  signatureImageCid?: Maybe<Scalars['String']['output']>;
  signedAt: Scalars['DateTime']['output'];
  signedPdfCid?: Maybe<Scalars['String']['output']>;
  /** Gateway URL of the signed PDF, rebuilt from the CID against the current tenant gateway. */
  signedPdfUrl?: Maybe<Scalars['String']['output']>;
  signerName: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  userAgent?: Maybe<Scalars['String']['output']>;
};

/** Fields that can be used to sort employees */
export enum EmployeeSortField {
  CreatedAt = 'CREATED_AT',
  EmployeeNumber = 'EMPLOYEE_NUMBER',
  HourlyRate = 'HOURLY_RATE',
  Name = 'NAME',
  Position = 'POSITION',
  StartDate = 'START_DATE'
}

export type EmployeeStatusOption = {
  __typename?: 'EmployeeStatusOption';
  color?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  displayOrder?: Maybe<Scalars['Float']['output']>;
  employeeUsageCount: Scalars['Int']['output'];
  employeeUsageNames: Array<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  isBaseline: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type EmployeeStatusOptionInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayOrder?: InputMaybe<Scalars['Float']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
};

export type EmployeeTrainingAssignment = {
  __typename?: 'EmployeeTrainingAssignment';
  assignedAt: Scalars['DateTime']['output'];
  assignedById: Scalars['ID']['output'];
  assignedByName: Scalars['String']['output'];
  category?: Maybe<EmployeeTrainingCategory>;
  categoryId?: Maybe<Scalars['ID']['output']>;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  courseId: Scalars['ID']['output'];
  courseName?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  dueDate?: Maybe<Scalars['DateTime']['output']>;
  employeeId: Scalars['ID']['output'];
  enrollmentId?: Maybe<Scalars['ID']['output']>;
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  isOverdue?: Maybe<Scalars['Boolean']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  overdueNotifiedAt?: Maybe<Scalars['DateTime']['output']>;
  priority: EmployeeTrainingPriority;
  progressPercentage?: Maybe<Scalars['Float']['output']>;
  status: EmployeeTrainingStatus;
  tenantId: Scalars['String']['output'];
  trainingType: EmployeeTrainingType;
  updatedAt: Scalars['DateTime']['output'];
};

export type EmployeeTrainingAssignmentInput = {
  categoryId?: InputMaybe<Scalars['ID']['input']>;
  courseId: Scalars['ID']['input'];
  dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  employeeId: Scalars['ID']['input'];
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<EmployeeTrainingPriority>;
  trainingType: EmployeeTrainingType;
};

export type EmployeeTrainingCategory = {
  __typename?: 'EmployeeTrainingCategory';
  code: Scalars['String']['output'];
  color?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  displayOrder?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  isRequired: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  renewalPeriodMonths?: Maybe<Scalars['Float']['output']>;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type EmployeeTrainingCategoryInput = {
  code: Scalars['String']['input'];
  color?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayOrder?: InputMaybe<Scalars['Float']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isRequired?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  renewalPeriodMonths?: InputMaybe<Scalars['Float']['input']>;
};

export type EmployeeTrainingDashboard = {
  __typename?: 'EmployeeTrainingDashboard';
  completedCount: Scalars['Float']['output'];
  dueThisWeek: Scalars['Float']['output'];
  expiredCount: Scalars['Float']['output'];
  inProgressCount: Scalars['Float']['output'];
  overdueCount: Scalars['Float']['output'];
  totalAssignments: Scalars['Float']['output'];
};

/** Priority level for training assignment */
export enum EmployeeTrainingPriority {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM'
}

/** Status of training assignment */
export enum EmployeeTrainingStatus {
  Assigned = 'ASSIGNED',
  Completed = 'COMPLETED',
  Expired = 'EXPIRED',
  InProgress = 'IN_PROGRESS',
  Overdue = 'OVERDUE'
}

/** Type of employee training assignment */
export enum EmployeeTrainingType {
  Compliance = 'COMPLIANCE',
  Optional = 'OPTIONAL',
  Orientation = 'ORIENTATION',
  Refresher = 'REFRESHER',
  Required = 'REQUIRED'
}

export type EmployeeUploadResult = {
  __typename?: 'EmployeeUploadResult';
  fileName: Scalars['String']['output'];
  fileSize: Scalars['Float']['output'];
  ipfsHash: Scalars['String']['output'];
  mimeType: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

/** Engagement type. AGENCY records represent an agency company (one Employee per agency, not per individual person). */
export enum EmploymentType {
  Agency = 'AGENCY',
  Casual = 'CASUAL',
  Contract = 'CONTRACT',
  FullTime = 'FULL_TIME',
  PartTime = 'PART_TIME'
}

export type EmpowermentActivity = {
  __typename?: 'EmpowermentActivity';
  activityType: Scalars['String']['output'];
  actorClientId?: Maybe<Scalars['ID']['output']>;
  actorName?: Maybe<Scalars['String']['output']>;
  clientId: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  details?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isPrivate: Scalars['Boolean']['output'];
  journeyId: Scalars['ID']['output'];
  occurredAt: Scalars['DateTime']['output'];
  subjectId?: Maybe<Scalars['ID']['output']>;
  subjectType: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type EmpowermentActivityPage = {
  __typename?: 'EmpowermentActivityPage';
  hasMore: Scalars['Boolean']['output'];
  items: Array<EmpowermentActivity>;
  totalCount: Scalars['Int']['output'];
};

export type EmpowermentAnswer = {
  __typename?: 'EmpowermentAnswer';
  answerType: EmpowermentAnswerType;
  comment?: Maybe<Scalars['String']['output']>;
  lineageId: Scalars['ID']['output'];
  questionId: Scalars['ID']['output'];
  questionText: Scalars['String']['output'];
  section: EmpowermentQuestionSection;
  stars?: Maybe<Scalars['Int']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  themeKey: Scalars['String']['output'];
  themeLabel: Scalars['String']['output'];
  version: Scalars['Int']['output'];
};

export type EmpowermentAnswerInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  questionId: Scalars['ID']['input'];
  stars?: InputMaybe<Scalars['Int']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export enum EmpowermentAnswerType {
  Stars_5 = 'STARS_5',
  Text = 'TEXT'
}

export type EmpowermentBiggestMove = {
  __typename?: 'EmpowermentBiggestMove';
  delta: EmpowermentDelta;
  side: EmpowermentSide;
  themeKey: Scalars['String']['output'];
  themeLabel: Scalars['String']['output'];
};

export type EmpowermentCalendarCapability = {
  __typename?: 'EmpowermentCalendarCapability';
  available: Scalars['Boolean']['output'];
  calendars: Array<EmpowermentCalendarOption>;
  canBook: Scalars['Boolean']['output'];
  reason?: Maybe<Scalars['String']['output']>;
};

export type EmpowermentCalendarOption = {
  __typename?: 'EmpowermentCalendarOption';
  id: Scalars['ID']['output'];
  linkedEmailAddressId?: Maybe<Scalars['ID']['output']>;
  linkedMailbox?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export type EmpowermentCapabilities = {
  __typename?: 'EmpowermentCapabilities';
  calendar: EmpowermentCalendarCapability;
  email: EmpowermentEmailCapability;
  employees: EmpowermentCapabilityStatus;
  meet: EmpowermentMeetCapability;
  preferredCalendarId?: Maybe<Scalars['ID']['output']>;
  preferredSenderEmailAddressId?: Maybe<Scalars['ID']['output']>;
  sms: EmpowermentCapabilityStatus;
  transcriptions: EmpowermentTranscriptionCapability;
};

export type EmpowermentCapabilityStatus = {
  __typename?: 'EmpowermentCapabilityStatus';
  available: Scalars['Boolean']['output'];
  reason?: Maybe<Scalars['String']['output']>;
};

export type EmpowermentCatchUp = {
  __typename?: 'EmpowermentCatchUp';
  calendarEventId?: Maybe<Scalars['ID']['output']>;
  calendarId?: Maybe<Scalars['ID']['output']>;
  checkInId: Scalars['ID']['output'];
  clientId: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  joinUrl?: Maybe<Scalars['String']['output']>;
  journeyId: Scalars['ID']['output'];
  location?: Maybe<Scalars['String']['output']>;
  meetRoomName?: Maybe<Scalars['String']['output']>;
  mode: EmpowermentCatchUpMode;
  notesByName?: Maybe<Scalars['String']['output']>;
  notesMarkdown?: Maybe<Scalars['String']['output']>;
  notesUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  organiserClientId: Scalars['ID']['output'];
  organiserName: Scalars['String']['output'];
  outcomes: Array<EmpowermentStepOutcome>;
  scheduledEnd: Scalars['DateTime']['output'];
  scheduledStart: Scalars['DateTime']['output'];
  senderEmail?: Maybe<Scalars['String']['output']>;
  status: EmpowermentCatchUpStatus;
  tenantId: Scalars['String']['output'];
  transcriptionId?: Maybe<Scalars['ID']['output']>;
  transcriptionTitle?: Maybe<Scalars['String']['output']>;
  transcriptionUrl?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  viewerCanManage: Scalars['Boolean']['output'];
};

export enum EmpowermentCatchUpMode {
  InPerson = 'IN_PERSON',
  Phone = 'PHONE',
  Video = 'VIDEO'
}

export enum EmpowermentCatchUpStatus {
  Booked = 'BOOKED',
  Cancelled = 'CANCELLED',
  Held = 'HELD',
  NoShow = 'NO_SHOW'
}

export type EmpowermentCheckIn = {
  __typename?: 'EmpowermentCheckIn';
  clientId: Scalars['ID']['output'];
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  completedByName?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdByName?: Maybe<Scalars['String']['output']>;
  daysOverdue?: Maybe<Scalars['Int']['output']>;
  daysUntilDue?: Maybe<Scalars['Int']['output']>;
  dueDate: Scalars['DateTime']['output'];
  dueDateLocked: Scalars['Boolean']['output'];
  dueDay: Scalars['String']['output'];
  followUpOfCheckInId?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  isOverdue: Scalars['Boolean']['output'];
  journeyId: Scalars['ID']['output'];
  kind: EmpowermentCheckInKind;
  lastPromptedAt?: Maybe<Scalars['DateTime']['output']>;
  managerClientIds: Array<Scalars['ID']['output']>;
  managerSubmittedAt?: Maybe<Scalars['DateTime']['output']>;
  managerSubmittedByName?: Maybe<Scalars['String']['output']>;
  milestoneKey?: Maybe<Scalars['String']['output']>;
  occurrence: Scalars['Int']['output'];
  openedAt?: Maybe<Scalars['DateTime']['output']>;
  opensDay: Scalars['String']['output'];
  opensOn: Scalars['DateTime']['output'];
  personName: Scalars['String']['output'];
  phase: EmpowermentCheckInPhase;
  probationNote?: Maybe<Scalars['String']['output']>;
  promptCount: Scalars['Int']['output'];
  questionIds: Array<Scalars['ID']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  releasedByName?: Maybe<Scalars['String']['output']>;
  releasedEarlyReason?: Maybe<Scalars['String']['output']>;
  revealedAt?: Maybe<Scalars['DateTime']['output']>;
  selfSubmittedAt?: Maybe<Scalars['DateTime']['output']>;
  skippedByName?: Maybe<Scalars['String']['output']>;
  skippedReason?: Maybe<Scalars['String']['output']>;
  state: EmpowermentCheckInState;
  tenantId: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  viewerSide?: Maybe<EmpowermentSide>;
};

export type EmpowermentCheckInCounts = {
  __typename?: 'EmpowermentCheckInCounts';
  comingUpSoon: Scalars['Int']['output'];
  completedThisMonth: Scalars['Int']['output'];
  overdue: Scalars['Int']['output'];
  waitingOnMe: Scalars['Int']['output'];
  waitingOnStaff: Scalars['Int']['output'];
};

export enum EmpowermentCheckInKind {
  Extra = 'EXTRA',
  Milestone = 'MILESTONE',
  Welcome = 'WELCOME'
}

export type EmpowermentCheckInListInput = {
  departmentIds?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  managerClientId?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  view?: InputMaybe<Scalars['String']['input']>;
};

export type EmpowermentCheckInPage = {
  __typename?: 'EmpowermentCheckInPage';
  counts: EmpowermentCheckInCounts;
  hasMore: Scalars['Boolean']['output'];
  items: Array<EmpowermentCheckIn>;
  totalCount: Scalars['Int']['output'];
};

export enum EmpowermentCheckInPhase {
  ComingUp = 'COMING_UP',
  Complete = 'COMPLETE',
  ReadyToComplete = 'READY_TO_COMPLETE',
  Skipped = 'SKIPPED',
  WaitingForRelease = 'WAITING_FOR_RELEASE',
  WaitingOnBoth = 'WAITING_ON_BOTH',
  WaitingOnManager = 'WAITING_ON_MANAGER',
  WaitingOnStaff = 'WAITING_ON_STAFF'
}

export enum EmpowermentCheckInState {
  Complete = 'COMPLETE',
  Open = 'OPEN',
  Scheduled = 'SCHEDULED',
  Skipped = 'SKIPPED'
}

export type EmpowermentDelta = {
  __typename?: 'EmpowermentDelta';
  basedOn: Scalars['Int']['output'];
  fromLabel: Scalars['String']['output'];
  toLabel: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};

export type EmpowermentDepartmentHead = {
  __typename?: 'EmpowermentDepartmentHead';
  clientId: Scalars['String']['output'];
  departmentIds: Array<Scalars['String']['output']>;
  departmentNames: Array<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export type EmpowermentDepartmentHeadInput = {
  clientId: Scalars['String']['input'];
  departmentIds: Array<Scalars['String']['input']>;
};

export type EmpowermentDepartmentOption = {
  __typename?: 'EmpowermentDepartmentOption';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type EmpowermentEmailCapability = {
  __typename?: 'EmpowermentEmailCapability';
  available: Scalars['Boolean']['output'];
  reason?: Maybe<Scalars['String']['output']>;
  senders: Array<EmpowermentSenderOption>;
  siteAddress?: Maybe<Scalars['String']['output']>;
};

export type EmpowermentEnrolDefaults = {
  __typename?: 'EmpowermentEnrolDefaults';
  managerClientIds: Array<Scalars['ID']['output']>;
  managerNames: Array<Scalars['String']['output']>;
  /** REPORTS_TO = their reporting line; ENROLLED_BY = you, the person enrolling them */
  managerSource: EmpowermentManagerSource;
  probationMonths: Scalars['Int']['output'];
  /** INVITE = their offer/contract; SITE_DEFAULT = this site's usual probation */
  probationSource: EmpowermentProbationSource;
  /** The start date on their employee card (YYYY-MM-DD); null when there isn't one */
  startDay?: Maybe<Scalars['String']['output']>;
};

export enum EmpowermentEnrolmentKind {
  InProbation = 'IN_PROBATION',
  NewStarter = 'NEW_STARTER',
  Welcome = 'WELCOME'
}

export enum EmpowermentEnrolmentScope {
  Everyone = 'EVERYONE',
  NewStarters = 'NEW_STARTERS'
}

export type EmpowermentGoal = {
  __typename?: 'EmpowermentGoal';
  clientId: Scalars['ID']['output'];
  closedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdByClientId: Scalars['ID']['output'];
  createdByName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  journeyId: Scalars['ID']['output'];
  reviews: Array<EmpowermentGoalReview>;
  setAtCheckInId?: Maybe<Scalars['ID']['output']>;
  setBy: EmpowermentGoalSetBy;
  status: EmpowermentGoalStatus;
  steps: Array<EmpowermentGoalStep>;
  targetDate?: Maybe<Scalars['DateTime']['output']>;
  targetDay?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  themeKey?: Maybe<Scalars['String']['output']>;
  themeLabel?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  whyMarkdown?: Maybe<Scalars['String']['output']>;
};

export enum EmpowermentGoalOutcome {
  Achieved = 'ACHIEVED',
  LetGo = 'LET_GO',
  NotYet = 'NOT_YET',
  Partly = 'PARTLY'
}

export type EmpowermentGoalReview = {
  __typename?: 'EmpowermentGoalReview';
  byClientId: Scalars['ID']['output'];
  byName: Scalars['String']['output'];
  checkInId?: Maybe<Scalars['ID']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  feeling?: Maybe<Scalars['Int']['output']>;
  goalId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  journeyId: Scalars['ID']['output'];
  outcome: EmpowermentGoalOutcome;
  reviewedAt: Scalars['DateTime']['output'];
  side: EmpowermentSide;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export enum EmpowermentGoalSetBy {
  Manager = 'MANAGER',
  Self = 'SELF',
  Together = 'TOGETHER'
}

export enum EmpowermentGoalStatus {
  Achieved = 'ACHIEVED',
  Active = 'ACTIVE',
  LetGo = 'LET_GO',
  Partly = 'PARTLY'
}

export type EmpowermentGoalStep = {
  __typename?: 'EmpowermentGoalStep';
  done: Scalars['Boolean']['output'];
  doneAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

export type EmpowermentGoalStepInput = {
  id: Scalars['String']['input'];
  label: Scalars['String']['input'];
};

export type EmpowermentGrowth = {
  __typename?: 'EmpowermentGrowth';
  biggestMoves: Array<EmpowermentBiggestMove>;
  journeyId: Scalars['ID']['output'];
  note?: Maybe<Scalars['String']['output']>;
  overall?: Maybe<EmpowermentThemeGrowth>;
  revealedCheckIns: Scalars['Int']['output'];
  themes: Array<EmpowermentThemeGrowth>;
};

export type EmpowermentGrowthPoint = {
  __typename?: 'EmpowermentGrowthPoint';
  checkInId: Scalars['ID']['output'];
  day: Scalars['String']['output'];
  label: Scalars['String']['output'];
  manager?: Maybe<Scalars['Float']['output']>;
  managerCount: Scalars['Int']['output'];
  self?: Maybe<Scalars['Float']['output']>;
  selfCount: Scalars['Int']['output'];
};

export type EmpowermentJourney = {
  __typename?: 'EmpowermentJourney';
  clientId: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  dayNumber: Scalars['Int']['output'];
  departmentNames: Array<Scalars['String']['output']>;
  employeeId?: Maybe<Scalars['ID']['output']>;
  endedAt?: Maybe<Scalars['DateTime']['output']>;
  enrolledAt: Scalars['DateTime']['output'];
  enrolledByName?: Maybe<Scalars['String']['output']>;
  enrolmentKind: EmpowermentEnrolmentKind;
  firstName: Scalars['String']['output'];
  generation: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  lastCompletedCheckIn?: Maybe<EmpowermentCheckIn>;
  managerClientIds: Array<Scalars['ID']['output']>;
  managerNames: Array<Scalars['String']['output']>;
  managerSource: EmpowermentManagerSource;
  nextCheckIn?: Maybe<EmpowermentCheckIn>;
  pausedUntil?: Maybe<Scalars['DateTime']['output']>;
  pendingStartDate?: Maybe<Scalars['DateTime']['output']>;
  pendingStartDay?: Maybe<Scalars['String']['output']>;
  personName: Scalars['String']['output'];
  probationEndDay?: Maybe<Scalars['String']['output']>;
  probationMonths: Scalars['Int']['output'];
  probationSource: EmpowermentProbationSource;
  startDate: Scalars['DateTime']['output'];
  startDateSource: EmpowermentStartDateSource;
  startDay: Scalars['String']['output'];
  status: EmpowermentJourneyStatus;
  statusReason?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  viewerCanManage: Scalars['Boolean']['output'];
  viewerIsSubject: Scalars['Boolean']['output'];
};

export type EmpowermentJourneyListInput = {
  departmentIds?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  managerClientId?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type EmpowermentJourneyPage = {
  __typename?: 'EmpowermentJourneyPage';
  hasMore: Scalars['Boolean']['output'];
  items: Array<EmpowermentJourney>;
  totalCount: Scalars['Int']['output'];
};

export enum EmpowermentJourneyStatus {
  Active = 'ACTIVE',
  Ended = 'ENDED',
  Paused = 'PAUSED'
}

export type EmpowermentJourneySummary = {
  __typename?: 'EmpowermentJourneySummary';
  activeGoals: Scalars['Int']['output'];
  biggestChange?: Maybe<Scalars['String']['output']>;
  completedCount: Scalars['Int']['output'];
  dayNumber: Scalars['Int']['output'];
  journeyId: Scalars['ID']['output'];
  lastCompletedCheckIn?: Maybe<EmpowermentCheckIn>;
  nextCheckIn?: Maybe<EmpowermentCheckIn>;
  probationEndDay?: Maybe<Scalars['String']['output']>;
  startDay: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export enum EmpowermentManagerScope {
  AllManagers = 'ALL_MANAGERS',
  Assigned = 'ASSIGNED'
}

export enum EmpowermentManagerSource {
  EnrolledBy = 'ENROLLED_BY',
  Manual = 'MANUAL',
  None = 'NONE',
  ReportsTo = 'REPORTS_TO',
  SiteDefault = 'SITE_DEFAULT'
}

export type EmpowermentMeetCapability = {
  __typename?: 'EmpowermentMeetCapability';
  available: Scalars['Boolean']['output'];
  canCreateRoom: Scalars['Boolean']['output'];
  reason?: Maybe<Scalars['String']['output']>;
};

export enum EmpowermentMilestoneAnchor {
  Anniversary = 'ANNIVERSARY',
  ProbationEnd = 'PROBATION_END',
  Start = 'START'
}

export type EmpowermentMilestoneDef = {
  __typename?: 'EmpowermentMilestoneDef';
  anchor: EmpowermentMilestoneAnchor;
  isActive: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  offsetDays?: Maybe<Scalars['Int']['output']>;
  offsetMonths?: Maybe<Scalars['Int']['output']>;
  order: Scalars['Int']['output'];
  repeatYearly: Scalars['Boolean']['output'];
};

export type EmpowermentMilestoneDefInput = {
  anchor: EmpowermentMilestoneAnchor;
  isActive: Scalars['Boolean']['input'];
  key: Scalars['String']['input'];
  label: Scalars['String']['input'];
  offsetDays?: InputMaybe<Scalars['Int']['input']>;
  offsetMonths?: InputMaybe<Scalars['Int']['input']>;
  order: Scalars['Int']['input'];
  repeatYearly: Scalars['Boolean']['input'];
};

export type EmpowermentPeopleFilter = {
  __typename?: 'EmpowermentPeopleFilter';
  /** The site's departments, A–Z */
  departments: Array<EmpowermentDepartmentOption>;
  managers: Array<EmpowermentDepartmentOption>;
  /** The departments the viewer heads (Settings → Department heads); empty = open on everyone */
  myDepartmentIds: Array<Scalars['ID']['output']>;
  myDepartmentNames: Array<Scalars['String']['output']>;
  viewerClientId?: Maybe<Scalars['String']['output']>;
};

export type EmpowermentPersonGap = {
  __typename?: 'EmpowermentPersonGap';
  canEnrol: Scalars['Boolean']['output'];
  clientId: Scalars['ID']['output'];
  departmentIds: Array<Scalars['ID']['output']>;
  departmentNames: Array<Scalars['String']['output']>;
  employeeId?: Maybe<Scalars['ID']['output']>;
  name: Scalars['String']['output'];
  reason: Scalars['String']['output'];
};

export type EmpowermentPersonOption = {
  __typename?: 'EmpowermentPersonOption';
  clientId: Scalars['ID']['output'];
  email?: Maybe<Scalars['String']['output']>;
  employeeId?: Maybe<Scalars['ID']['output']>;
  name: Scalars['String']['output'];
  onJourney?: Maybe<Scalars['Boolean']['output']>;
  startDay?: Maybe<Scalars['String']['output']>;
};

export enum EmpowermentProbationSource {
  Invite = 'INVITE',
  Manual = 'MANUAL',
  SiteDefault = 'SITE_DEFAULT'
}

export type EmpowermentPromptLog = {
  __typename?: 'EmpowermentPromptLog';
  channel: Scalars['String']['output'];
  checkInId: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  detail?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  journeyId: Scalars['ID']['output'];
  ok: Scalars['Boolean']['output'];
  recipientClientId: Scalars['ID']['output'];
  recipientName: Scalars['String']['output'];
  sentAt: Scalars['DateTime']['output'];
  sentByName?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  trigger: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export enum EmpowermentPromptMode {
  Auto = 'AUTO',
  Manual = 'MANUAL'
}

export type EmpowermentQuestion = {
  __typename?: 'EmpowermentQuestion';
  answerType: EmpowermentAnswerType;
  createdAt: Scalars['DateTime']['output'];
  createdByName?: Maybe<Scalars['String']['output']>;
  helpText?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  isCurrent: Scalars['Boolean']['output'];
  kind: EmpowermentQuestionKind;
  lineageId: Scalars['ID']['output'];
  managerText?: Maybe<Scalars['String']['output']>;
  milestoneKeys: Array<Scalars['String']['output']>;
  oneOffForCheckInId?: Maybe<Scalars['ID']['output']>;
  order: Scalars['Int']['output'];
  retiredAt?: Maybe<Scalars['DateTime']['output']>;
  section: EmpowermentQuestionSection;
  selfText: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  themeKey: Scalars['String']['output'];
  themeLabel: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  version: Scalars['Int']['output'];
};

export enum EmpowermentQuestionKind {
  Custom = 'CUSTOM',
  Standard = 'STANDARD'
}

export enum EmpowermentQuestionSection {
  HowImGoing = 'HOW_IM_GOING',
  HowWereGoing = 'HOW_WERE_GOING',
  Open = 'OPEN'
}

export type EmpowermentRecipientOutcome = {
  __typename?: 'EmpowermentRecipientOutcome';
  channel: Scalars['String']['output'];
  detail: Scalars['String']['output'];
  name: Scalars['String']['output'];
  ok: Scalars['Boolean']['output'];
};

export type EmpowermentReconcileSummary = {
  __typename?: 'EmpowermentReconcileSummary';
  ended: Scalars['Int']['output'];
  enrolled: Scalars['Int']['output'];
  message: Scalars['String']['output'];
  opened: Scalars['Int']['output'];
  ran: Scalars['Boolean']['output'];
  scheduled: Scalars['Int']['output'];
  startDateChanges: Scalars['Int']['output'];
};

export type EmpowermentReflection = {
  __typename?: 'EmpowermentReflection';
  answers: Array<EmpowermentAnswer>;
  authorClientId: Scalars['ID']['output'];
  authorName: Scalars['String']['output'];
  checkInId: Scalars['ID']['output'];
  clientId: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  journeyId: Scalars['ID']['output'];
  lastSavedAt?: Maybe<Scalars['DateTime']['output']>;
  side: EmpowermentSide;
  status: EmpowermentReflectionStatus;
  submittedAt?: Maybe<Scalars['DateTime']['output']>;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export enum EmpowermentReflectionStatus {
  Draft = 'DRAFT',
  Submitted = 'SUBMITTED'
}

export type EmpowermentReflectionView = {
  __typename?: 'EmpowermentReflectionView';
  answers?: Maybe<Array<EmpowermentAnswer>>;
  authorName?: Maybe<Scalars['String']['output']>;
  hiddenReason?: Maybe<Scalars['String']['output']>;
  isMine: Scalars['Boolean']['output'];
  lastSavedAt?: Maybe<Scalars['DateTime']['output']>;
  side: EmpowermentSide;
  status: EmpowermentReflectionViewStatus;
  submittedAt?: Maybe<Scalars['DateTime']['output']>;
};

export enum EmpowermentReflectionViewStatus {
  Draft = 'DRAFT',
  NotStarted = 'NOT_STARTED',
  Submitted = 'SUBMITTED'
}

export enum EmpowermentRevealRule {
  BothSubmitted = 'BOTH_SUBMITTED',
  ManagerReleases = 'MANAGER_RELEASES'
}

export type EmpowermentScheduleMove = {
  __typename?: 'EmpowermentScheduleMove';
  fromDay: Scalars['String']['output'];
  personName: Scalars['String']['output'];
  title: Scalars['String']['output'];
  toDay: Scalars['String']['output'];
};

export type EmpowermentSchedulePreview = {
  __typename?: 'EmpowermentSchedulePreview';
  examples: Array<EmpowermentScheduleMove>;
  movedCount: Scalars['Int']['output'];
};

export type EmpowermentSendResult = {
  __typename?: 'EmpowermentSendResult';
  failedCount: Scalars['Int']['output'];
  outcomes: Array<EmpowermentRecipientOutcome>;
  sentCount: Scalars['Int']['output'];
};

export type EmpowermentSenderOption = {
  __typename?: 'EmpowermentSenderOption';
  email: Scalars['String']['output'];
  emailAddressId: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type EmpowermentSettings = {
  __typename?: 'EmpowermentSettings';
  createdAt: Scalars['DateTime']['output'];
  defaultProbationMonths: Scalars['Int']['output'];
  departmentHeads: Array<EmpowermentDepartmentHead>;
  enrolmentEnabled: Scalars['Boolean']['output'];
  enrolmentManagerClientIds: Array<Scalars['String']['output']>;
  enrolmentManagerNames: Array<Scalars['String']['output']>;
  enrolmentScope: EmpowermentEnrolmentScope;
  enrolmentStartedOn?: Maybe<Scalars['DateTime']['output']>;
  followUpDefaultDays: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  introMarkdown: Scalars['String']['output'];
  lowScoreThreshold: Scalars['Int']['output'];
  managerScope: EmpowermentManagerScope;
  milestones: Array<EmpowermentMilestoneDef>;
  opensDaysBefore: Scalars['Int']['output'];
  promptMode: EmpowermentPromptMode;
  reportsMinResponses: Scalars['Int']['output'];
  revealRule: EmpowermentRevealRule;
  supportMarkdown: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedByName?: Maybe<Scalars['String']['output']>;
  welcomeSpreadWeeks: Scalars['Int']['output'];
  welcomeWeeklyCapPerManager: Scalars['Int']['output'];
};

export enum EmpowermentSide {
  Manager = 'MANAGER',
  Self = 'SELF'
}

export enum EmpowermentStartDateSource {
  EmployeeRecord = 'EMPLOYEE_RECORD',
  Manual = 'MANUAL'
}

export type EmpowermentStepOutcome = {
  __typename?: 'EmpowermentStepOutcome';
  detail: Scalars['String']['output'];
  ok: Scalars['Boolean']['output'];
  step: Scalars['String']['output'];
};

export type EmpowermentTeamCompletion = {
  __typename?: 'EmpowermentTeamCompletion';
  completed: Scalars['Int']['output'];
  completedOnTime: Scalars['Int']['output'];
  due: Scalars['Int']['output'];
  dueToday: Scalars['Int']['output'];
  months: Array<EmpowermentTeamCompletionMonth>;
  overdueNow: Scalars['Int']['output'];
  skipped: Scalars['Int']['output'];
};

export type EmpowermentTeamCompletionMonth = {
  __typename?: 'EmpowermentTeamCompletionMonth';
  completed: Scalars['Int']['output'];
  completedOnTime: Scalars['Int']['output'];
  due: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  month: Scalars['String']['output'];
};

export type EmpowermentTeamInsights = {
  __typename?: 'EmpowermentTeamInsights';
  completion: EmpowermentTeamCompletion;
  fromDay: Scalars['String']['output'];
  minResponses: Scalars['Int']['output'];
  monthsCovered: Scalars['Int']['output'];
  peopleResponding: Scalars['Int']['output'];
  themes: Array<EmpowermentTeamTheme>;
  toDay: Scalars['String']['output'];
};

export type EmpowermentTeamMonth = {
  __typename?: 'EmpowermentTeamMonth';
  average?: Maybe<Scalars['Float']['output']>;
  hidden: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
  month: Scalars['String']['output'];
  responses: Scalars['Int']['output'];
};

export type EmpowermentTeamTheme = {
  __typename?: 'EmpowermentTeamTheme';
  average?: Maybe<Scalars['Float']['output']>;
  distribution: Array<Scalars['Int']['output']>;
  hidden: Scalars['Boolean']['output'];
  months: Array<EmpowermentTeamMonth>;
  responses: Scalars['Int']['output'];
  themeKey: Scalars['String']['output'];
  themeLabel: Scalars['String']['output'];
};

export type EmpowermentThemeGrowth = {
  __typename?: 'EmpowermentThemeGrowth';
  latestGap?: Maybe<Scalars['Float']['output']>;
  latestManager?: Maybe<Scalars['Float']['output']>;
  latestSelf?: Maybe<Scalars['Float']['output']>;
  managerSinceLast?: Maybe<EmpowermentDelta>;
  managerSinceStart?: Maybe<EmpowermentDelta>;
  points: Array<EmpowermentGrowthPoint>;
  section: EmpowermentQuestionSection;
  selfSinceLast?: Maybe<EmpowermentDelta>;
  selfSinceStart?: Maybe<EmpowermentDelta>;
  themeKey: Scalars['String']['output'];
  themeLabel: Scalars['String']['output'];
};

export type EmpowermentTranscriptionCapability = {
  __typename?: 'EmpowermentTranscriptionCapability';
  available: Scalars['Boolean']['output'];
  canLink: Scalars['Boolean']['output'];
  reason?: Maybe<Scalars['String']['output']>;
};

export type EmpowermentTranscriptionOption = {
  __typename?: 'EmpowermentTranscriptionOption';
  id: Scalars['ID']['output'];
  recordedAt?: Maybe<Scalars['DateTime']['output']>;
  title: Scalars['String']['output'];
};

export type EnablePortalAccessInput = {
  /** Enable chat for this contact */
  chatEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  contactId: Scalars['ID']['input'];
  /** SMS or EMAIL */
  inviteMethod?: InputMaybe<Scalars['String']['input']>;
  /** REPRESENTATIVE or FAMILY_VIEW */
  portalPermissionLevel?: InputMaybe<Scalars['String']['input']>;
  /** Send invite via SMS or email */
  sendInvite?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EncryptionKey = {
  __typename?: 'EncryptionKey';
  createdAt: Scalars['DateTime']['output'];
  facilityId?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  keyType: EncryptionKeyType;
  patientId?: Maybe<Scalars['ID']['output']>;
  previousKeyId?: Maybe<Scalars['ID']['output']>;
  rotatedAt?: Maybe<Scalars['DateTime']['output']>;
  rotatedBy?: Maybe<Scalars['ID']['output']>;
  rotationReason?: Maybe<Scalars['String']['output']>;
  status: EncryptionKeyStatus;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  version: Scalars['Float']['output'];
};

/** Status of the encryption key */
export enum EncryptionKeyStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  PendingRotation = 'PENDING_ROTATION',
  Rotated = 'ROTATED'
}

/** Type of encryption key */
export enum EncryptionKeyType {
  Facility = 'FACILITY',
  Master = 'MASTER',
  Patient = 'PATIENT'
}

export type EndpointParam = {
  __typename?: 'EndpointParam';
  defaultValue?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  example?: Maybe<Scalars['String']['output']>;
  in: ParamLocation;
  name: Scalars['String']['output'];
  required: Scalars['Boolean']['output'];
  type: ParamType;
};

export type EndpointParamInput = {
  defaultValue?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  example?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<ParamLocation>;
  name: Scalars['String']['input'];
  required?: InputMaybe<Scalars['Boolean']['input']>;
  type: ParamType;
};

export type EnergyTrackerNotificationRule = {
  __typename?: 'EnergyTrackerNotificationRule';
  channels: Array<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  isEnabled: Scalars['Boolean']['output'];
  messageTemplate?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  recipientIds?: Maybe<Array<Scalars['String']['output']>>;
  recipientType: EnergyTrackerRecipientType;
  tenantId: Scalars['String']['output'];
  timing: EnergyTrackerNotificationTiming;
  timingMinutes?: Maybe<Scalars['Float']['output']>;
  trigger: EnergyTrackerNotificationTrigger;
  updatedAt: Scalars['DateTime']['output'];
};

/** When to send the notification relative to the trigger */
export enum EnergyTrackerNotificationTiming {
  Immediate = 'IMMEDIATE',
  MinutesAfter = 'MINUTES_AFTER'
}

/** Event that triggers the energy tracker notification */
export enum EnergyTrackerNotificationTrigger {
  EventAiClassified = 'EVENT_AI_CLASSIFIED',
  EventCreated = 'EVENT_CREATED',
  HighImpactEvent = 'HIGH_IMPACT_EVENT',
  RouteStatusChanged = 'ROUTE_STATUS_CHANGED',
  StationStatusChanged = 'STATION_STATUS_CHANGED'
}

/** How to resolve the notification recipient(s) */
export enum EnergyTrackerRecipientType {
  AllClients = 'ALL_CLIENTS',
  AllEnergyAdmins = 'ALL_ENERGY_ADMINS',
  SpecificClients = 'SPECIFIC_CLIENTS'
}

export type EnqueueDigitalManagerOqInput = {
  classification?: InputMaybe<Scalars['String']['input']>;
  managerId: Scalars['ID']['input'];
  priority?: InputMaybe<DigitalManagerOqPriority>;
  proposedActions?: InputMaybe<Array<Scalars['String']['input']>>;
  question: Scalars['String']['input'];
  recordId?: InputMaybe<Scalars['String']['input']>;
  recordType?: InputMaybe<Scalars['String']['input']>;
  ruleId?: InputMaybe<Scalars['String']['input']>;
  sessionId?: InputMaybe<Scalars['String']['input']>;
  triggerType: DigitalManagerOqTrigger;
};

export type EnqueueEmailAiQuestionInput = {
  classification?: InputMaybe<Scalars['String']['input']>;
  memoryId?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<EmailAiOutstandingQuestionPriority>;
  proposedActions?: InputMaybe<Array<Scalars['String']['input']>>;
  question: Scalars['String']['input'];
  recordId?: InputMaybe<Scalars['String']['input']>;
  ruleId?: InputMaybe<Scalars['String']['input']>;
  triggerType: EmailAiOutstandingQuestionTrigger;
};

export type EnqueueRollupInput = {
  acknowledgeSimilar?: InputMaybe<Scalars['Boolean']['input']>;
  baseId: Scalars['ID']['input'];
  rationale?: InputMaybe<Scalars['String']['input']>;
  scopeKind: RollupScopeKind;
  scopeValue?: InputMaybe<Scalars['String']['input']>;
  supersedesId?: InputMaybe<Scalars['ID']['input']>;
  title: Scalars['String']['input'];
  videoIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type EnrolEmpowermentPersonInput = {
  clientId: Scalars['ID']['input'];
  managerClientIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  probationMonths?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};

export type EnrolWalletKeyInput = {
  address: Scalars['String']['input'];
  countersignature?: InputMaybe<Scalars['String']['input']>;
  keystoreCiphertext?: InputMaybe<Scalars['String']['input']>;
  keystoreIv?: InputMaybe<Scalars['String']['input']>;
  kind?: InputMaybe<WalletKeyKind>;
  label?: InputMaybe<Scalars['String']['input']>;
  nonce: Scalars['String']['input'];
  publicKey?: InputMaybe<Scalars['String']['input']>;
  scope?: InputMaybe<Scalars['String']['input']>;
  signature: Scalars['String']['input'];
  unlockCode?: InputMaybe<Scalars['String']['input']>;
};

export type EnterCompetitionInput = {
  ageBand: CompetitionAgeBand;
  competitionId: Scalars['ID']['input'];
  enteredForName: Scalars['String']['input'];
  followCompetition?: InputMaybe<Scalars['Boolean']['input']>;
  guardianConsent: Scalars['Boolean']['input'];
  imageCid: Scalars['String']['input'];
  printConsent?: InputMaybe<Scalars['Boolean']['input']>;
  statement?: InputMaybe<Scalars['String']['input']>;
  thumbnailCid?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

/** Whether this is a person or company being tracked */
export enum EntityOfInterestType {
  Company = 'COMPANY',
  Person = 'PERSON'
}

/** Type of entry into the facility */
export enum EntryType {
  Permanent = 'PERMANENT',
  Respite = 'RESPITE'
}

export type EntryTypeDistribution = {
  __typename?: 'EntryTypeDistribution';
  count: Scalars['Int']['output'];
  entryType: Scalars['String']['output'];
};

/** A unit type option with value and display label */
export type EnumOption = {
  __typename?: 'EnumOption';
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type EquipmentDailyCompliance = {
  __typename?: 'EquipmentDailyCompliance';
  capacity: Scalars['String']['output'];
  equipmentId: Scalars['String']['output'];
  equipmentName: Scalars['String']['output'];
  eveningLog?: Maybe<TemperatureLog>;
  eveningRecorded: Scalars['Boolean']['output'];
  location: Scalars['String']['output'];
  maxTemp: Scalars['Float']['output'];
  minTemp: Scalars['Float']['output'];
  morningLog?: Maybe<TemperatureLog>;
  morningRecorded: Scalars['Boolean']['output'];
  type: Scalars['String']['output'];
};

export type ErcPdfResultGql = {
  __typename?: 'ErcPdfResultGql';
  employeeCount: Scalars['Int']['output'];
  filename: Scalars['String']['output'];
  /** Base64-encoded PDF body */
  pdfBase64: Scalars['String']['output'];
  sizeBytes: Scalars['Int']['output'];
};

export type EventAttachment = {
  __typename?: 'EventAttachment';
  cid?: Maybe<Scalars['String']['output']>;
  mimeType?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  size?: Maybe<Scalars['Float']['output']>;
  url: Scalars['String']['output'];
};

export type EventAttachmentInput = {
  cid?: InputMaybe<Scalars['String']['input']>;
  mimeType?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  size?: InputMaybe<Scalars['Float']['input']>;
  url: Scalars['String']['input'];
};

export type EventAttendee = {
  __typename?: 'EventAttendee';
  clientId?: Maybe<Scalars['String']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  isOrganizer: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  respondedAt?: Maybe<Scalars['DateTime']['output']>;
  responseSequence?: Maybe<Scalars['Float']['output']>;
  responseTime?: Maybe<Scalars['DateTime']['output']>;
  role: AttendeeRole;
  rsvpRequired: Scalars['Boolean']['output'];
  status: AttendeeStatus;
};

export type EventAttendeeInput = {
  clientId?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  isOrganizer: Scalars['Boolean']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  respondedAt?: InputMaybe<Scalars['DateTime']['input']>;
  responseSequence?: InputMaybe<Scalars['Float']['input']>;
  responseTime?: InputMaybe<Scalars['DateTime']['input']>;
  role: AttendeeRole;
  rsvpRequired: Scalars['Boolean']['input'];
  status: AttendeeStatus;
};

export type EventBillSummary = {
  __typename?: 'EventBillSummary';
  currency: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  publicUrl: Scalars['String']['output'];
  status: Scalars['String']['output'];
  totalAmount: Scalars['Float']['output'];
};

/** Classification of a person-of-interest event */
export enum EventClassification {
  Appointment = 'APPOINTMENT',
  CrisisResponse = 'CRISIS_RESPONSE',
  IndustryAction = 'INDUSTRY_ACTION',
  Meeting = 'MEETING',
  PolicyChange = 'POLICY_CHANGE',
  PublicStatement = 'PUBLIC_STATEMENT'
}

export type EventCopyDraft = {
  __typename?: 'EventCopyDraft';
  description: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type EventInviteDispatch = {
  __typename?: 'EventInviteDispatch';
  eventEndTime?: Maybe<Scalars['DateTime']['output']>;
  eventIsAllDay?: Maybe<Scalars['Boolean']['output']>;
  eventStartTime?: Maybe<Scalars['DateTime']['output']>;
  failedCount: Scalars['Float']['output'];
  failedRecipients?: Maybe<Array<Scalars['String']['output']>>;
  method: Scalars['String']['output'];
  reason?: Maybe<Scalars['String']['output']>;
  recipients: Array<Scalars['String']['output']>;
  sentAt: Scalars['DateTime']['output'];
  sentCount: Scalars['Float']['output'];
  sequence: Scalars['Float']['output'];
  successfulRecipients?: Maybe<Array<Scalars['String']['output']>>;
};

export type EventLocation = {
  __typename?: 'EventLocation';
  address?: Maybe<Scalars['String']['output']>;
  floor?: Maybe<Scalars['String']['output']>;
  instructions?: Maybe<Scalars['String']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  room?: Maybe<Scalars['String']['output']>;
};

export type EventLocationInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  floor?: InputMaybe<Scalars['String']['input']>;
  instructions?: InputMaybe<Scalars['String']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  room?: InputMaybe<Scalars['String']['input']>;
};

export type EventRegistration = {
  __typename?: 'EventRegistration';
  attendedAt?: Maybe<Scalars['DateTime']['output']>;
  cancelledAt?: Maybe<Scalars['DateTime']['output']>;
  confirmationEmailsSent: Scalars['Int']['output'];
  confirmationToken?: Maybe<Scalars['String']['output']>;
  confirmedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  eventId: Scalars['String']['output'];
  eventName: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  ipAddress?: Maybe<Scalars['String']['output']>;
  lastEmailSentAt?: Maybe<Scalars['DateTime']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  referredByClientId?: Maybe<Scalars['String']['output']>;
  referredByEmail?: Maybe<Scalars['String']['output']>;
  registeredAt: Scalars['DateTime']['output'];
  reminderEmailsSent: Scalars['Int']['output'];
  source: RegistrationSource;
  status: RegistrationStatus;
  stayedTillEnd?: Maybe<Scalars['Boolean']['output']>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  userAgent?: Maybe<Scalars['String']['output']>;
  utmCampaign?: Maybe<Scalars['String']['output']>;
  utmMedium?: Maybe<Scalars['String']['output']>;
  utmSource?: Maybe<Scalars['String']['output']>;
};

export type EventRegistrationFilterInput = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  eventId?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<RegistrationSource>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<RegistrationStatus>;
};

export type EventRegistrationResponse = {
  __typename?: 'EventRegistrationResponse';
  message?: Maybe<Scalars['String']['output']>;
  registration?: Maybe<EventRegistration>;
  success: Scalars['Boolean']['output'];
};

export type EventRegistrationStats = {
  __typename?: 'EventRegistrationStats';
  attended: Scalars['Int']['output'];
  cancelled: Scalars['Int']['output'];
  confirmed: Scalars['Int']['output'];
  noShow: Scalars['Int']['output'];
  pendingConfirmation: Scalars['Int']['output'];
  totalRegistrations: Scalars['Int']['output'];
};

export type EventReminder = {
  __typename?: 'EventReminder';
  enabled: Scalars['Boolean']['output'];
  method: Scalars['String']['output'];
  minutesBefore: Scalars['Float']['output'];
  sentAt?: Maybe<Scalars['DateTime']['output']>;
};

export type EventReminderInput = {
  enabled: Scalars['Boolean']['input'];
  method: Scalars['String']['input'];
  minutesBefore: Scalars['Float']['input'];
  sentAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type EventStats = {
  __typename?: 'EventStats';
  avgValue?: Maybe<Scalars['Float']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  count: Scalars['Int']['output'];
  eventName: Scalars['String']['output'];
  totalValue?: Maybe<Scalars['Float']['output']>;
  uniqueUsers: Scalars['Int']['output'];
};

/** Event status values */
export enum EventStatus {
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Confirmed = 'CONFIRMED',
  Draft = 'DRAFT',
  Tentative = 'TENTATIVE'
}

/** Types of calendar events */
export enum EventType {
  Appointment = 'APPOINTMENT',
  Availability = 'AVAILABILITY',
  Birthday = 'BIRTHDAY',
  Custom = 'CUSTOM',
  Event = 'EVENT',
  Holiday = 'HOLIDAY',
  IcalInvite = 'ICAL_INVITE',
  Maintenance = 'MAINTENANCE',
  Meeting = 'MEETING',
  OutOfOffice = 'OUT_OF_OFFICE',
  Reminder = 'REMINDER',
  Session = 'SESSION',
  Shift = 'SHIFT',
  Task = 'TASK',
  Webinar = 'WEBINAR'
}

/** Event visibility levels */
export enum EventVisibility {
  Confidential = 'CONFIDENTIAL',
  Private = 'PRIVATE',
  Public = 'PUBLIC',
  Transparent = 'TRANSPARENT'
}

export type ExceptionReport = {
  __typename?: 'ExceptionReport';
  dateFrom?: Maybe<Scalars['DateTime']['output']>;
  dateTo?: Maybe<Scalars['DateTime']['output']>;
  generatedAt: Scalars['DateTime']['output'];
  notes: Array<ExceptionReportNote>;
  timeFrom?: Maybe<Scalars['String']['output']>;
  timeTo?: Maybe<Scalars['String']['output']>;
  totalNotes: Scalars['Int']['output'];
  wingCounts: Array<ExceptionWingCount>;
  wings?: Maybe<Array<Scalars['String']['output']>>;
};

export type ExceptionReportFilterInput = {
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  exceptionOnly?: InputMaybe<Scalars['Boolean']['input']>;
  timeFrom?: InputMaybe<Scalars['String']['input']>;
  timeTo?: InputMaybe<Scalars['String']['input']>;
  wings?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ExceptionReportNote = {
  __typename?: 'ExceptionReportNote';
  content: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdByName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  noteDate: Scalars['DateTime']['output'];
  noteTime?: Maybe<Scalars['String']['output']>;
  relatedCarePlanCategories: Array<Scalars['String']['output']>;
  residentId: Scalars['ID']['output'];
  residentName?: Maybe<Scalars['String']['output']>;
  residentRoom?: Maybe<Scalars['String']['output']>;
  residentWing?: Maybe<Scalars['String']['output']>;
};

export type ExceptionWingCount = {
  __typename?: 'ExceptionWingCount';
  count: Scalars['Int']['output'];
  wing: Scalars['String']['output'];
};

export type ExecuteProposalTaskInput = {
  customInstructions?: InputMaybe<Scalars['String']['input']>;
  opportunityId: Scalars['String']['input'];
  taskDescription?: InputMaybe<Scalars['String']['input']>;
  taskId?: InputMaybe<Scalars['String']['input']>;
};

export type ExecutiveDashboardFilters = {
  period?: InputMaybe<Scalars['String']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
  view?: InputMaybe<Scalars['String']['input']>;
};

export type ExecutiveSummary = {
  __typename?: 'ExecutiveSummary';
  builderBreakdown?: Maybe<Array<BreakdownRow>>;
  builderBreakdownNote?: Maybe<Scalars['String']['output']>;
  builderBreakdownNoteLink?: Maybe<Scalars['String']['output']>;
  businessUnits: Array<BusinessUnitRow>;
  error?: Maybe<Scalars['String']['output']>;
  ghlConnected: Scalars['Boolean']['output'];
  pipelineStages: Array<PipelineStageRow>;
  receivableBuckets: Array<ReceivableBucket>;
  reportsAvailable: Scalars['Boolean']['output'];
  revenueTrend: Array<RevenueTrendPoint>;
  stageBreakdown?: Maybe<Array<BreakdownRow>>;
  stageBreakdownNote?: Maybe<Scalars['String']['output']>;
  stageBreakdownNoteLink?: Maybe<Scalars['String']['output']>;
  tiles: Array<MetricTile>;
  unit?: Maybe<Scalars['String']['output']>;
  unitNote?: Maybe<Scalars['String']['output']>;
  unitSource?: Maybe<Scalars['String']['output']>;
  weeklyRevenue?: Maybe<Array<WeeklyRevenuePoint>>;
  xeroConnected: Scalars['Boolean']['output'];
  xeroOrgName?: Maybe<Scalars['String']['output']>;
};

export type ExpressionOfInterest = {
  __typename?: 'ExpressionOfInterest';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  investmentAmount?: Maybe<Scalars['Float']['output']>;
  investorId: Scalars['ID']['output'];
  investorName?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  projectId: Scalars['ID']['output'];
  projectName?: Maybe<Scalars['String']['output']>;
  reviewedAt?: Maybe<Scalars['DateTime']['output']>;
  reviewedBy?: Maybe<Scalars['String']['output']>;
  status: EoiStatus;
  submittedAt: Scalars['DateTime']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type ExtendLeaveInput = {
  extensionReason?: InputMaybe<Scalars['String']['input']>;
  newExpectedReturnDate: Scalars['DateTime']['input'];
};

export type ExtendRewardTokenExpiryInput = {
  newExpiryDate: Scalars['DateTime']['input'];
  tokenId: Scalars['ID']['input'];
};

/** Amount of wound exudate */
export enum ExudateAmount {
  Copious = 'COPIOUS',
  Heavy = 'HEAVY',
  Low = 'LOW',
  Minimal = 'MINIMAL',
  Moderate = 'MODERATE',
  None = 'NONE'
}

/** Type of wound exudate */
export enum ExudateType {
  None = 'NONE',
  Purulent = 'PURULENT',
  Sanguineous = 'SANGUINEOUS',
  Serosanguineous = 'SEROSANGUINEOUS',
  Serous = 'SEROUS'
}

/** Falls risk assessment level */
export enum FallsRiskLevel {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM'
}

export type Farmer = {
  __typename?: 'Farmer';
  aboutSection: FarmerAboutSection;
  allowedEditors: Array<Client>;
  allowedEditorsIds: Array<Client>;
  branding: FarmerBranding;
  client: Client;
  clientId: Client;
  contactInfo?: Maybe<FarmerContactInfo>;
  createdAt: Scalars['DateTime']['output'];
  enableBlog: Scalars['Boolean']['output'];
  enableCSA: Scalars['Boolean']['output'];
  enableNewsletter: Scalars['Boolean']['output'];
  enableRecipes: Scalars['Boolean']['output'];
  enableReviews: Scalars['Boolean']['output'];
  featuredProducts: Array<FarmerProductShowcase>;
  heroSection: FarmerHeroSection;
  id: Scalars['ID']['output'];
  isPublic: Scalars['Boolean']['output'];
  seoSettings: FarmerSeoSettings;
  status: FarmerStatus;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  urlSlug?: Maybe<Scalars['String']['output']>;
  valuePropositions: Array<FarmerValueProposition>;
};

export type FarmerAboutSection = {
  __typename?: 'FarmerAboutSection';
  buttonLink: Scalars['String']['output'];
  buttonText: Scalars['String']['output'];
  description: Scalars['String']['output'];
  heading: Scalars['String']['output'];
  image: Scalars['String']['output'];
  longDescription?: Maybe<Scalars['String']['output']>;
  subheading: Scalars['String']['output'];
};

export type FarmerAboutSectionInput = {
  buttonLink: Scalars['String']['input'];
  buttonText: Scalars['String']['input'];
  description: Scalars['String']['input'];
  heading: Scalars['String']['input'];
  image: Scalars['String']['input'];
  longDescription?: InputMaybe<Scalars['String']['input']>;
  subheading: Scalars['String']['input'];
};

export type FarmerBranding = {
  __typename?: 'FarmerBranding';
  accentColor: Scalars['String']['output'];
  farmName: Scalars['String']['output'];
  favicon?: Maybe<Scalars['String']['output']>;
  logo: Scalars['String']['output'];
  primaryColor: Scalars['String']['output'];
  secondaryColor: Scalars['String']['output'];
};

export type FarmerBrandingInput = {
  accentColor: Scalars['String']['input'];
  farmName: Scalars['String']['input'];
  favicon?: InputMaybe<Scalars['String']['input']>;
  logo: Scalars['String']['input'];
  primaryColor: Scalars['String']['input'];
  secondaryColor: Scalars['String']['input'];
};

export type FarmerContactInfo = {
  __typename?: 'FarmerContactInfo';
  address?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  facebook?: Maybe<Scalars['String']['output']>;
  instagram?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  twitter?: Maybe<Scalars['String']['output']>;
  youtube?: Maybe<Scalars['String']['output']>;
};

export type FarmerContactInfoInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  facebook?: InputMaybe<Scalars['String']['input']>;
  instagram?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  twitter?: InputMaybe<Scalars['String']['input']>;
  youtube?: InputMaybe<Scalars['String']['input']>;
};

export type FarmerHeroSection = {
  __typename?: 'FarmerHeroSection';
  backgroundImage: Scalars['String']['output'];
  heading: Scalars['String']['output'];
  primaryButtonLink: Scalars['String']['output'];
  primaryButtonText: Scalars['String']['output'];
  productList?: Maybe<Scalars['String']['output']>;
  promotionalText?: Maybe<Scalars['String']['output']>;
  secondaryButtonLink: Scalars['String']['output'];
  secondaryButtonText: Scalars['String']['output'];
  subheading: Scalars['String']['output'];
};

export type FarmerHeroSectionInput = {
  backgroundImage: Scalars['String']['input'];
  heading: Scalars['String']['input'];
  primaryButtonLink: Scalars['String']['input'];
  primaryButtonText: Scalars['String']['input'];
  productList?: InputMaybe<Scalars['String']['input']>;
  promotionalText?: InputMaybe<Scalars['String']['input']>;
  secondaryButtonLink: Scalars['String']['input'];
  secondaryButtonText: Scalars['String']['input'];
  subheading: Scalars['String']['input'];
};

export type FarmerProductShowcase = {
  __typename?: 'FarmerProductShowcase';
  category?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  image: Scalars['String']['output'];
  link: Scalars['String']['output'];
  name: Scalars['String']['output'];
  price: Scalars['String']['output'];
};

export type FarmerProductShowcaseInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  image: Scalars['String']['input'];
  link: Scalars['String']['input'];
  name: Scalars['String']['input'];
  price: Scalars['String']['input'];
};

export type FarmerSeoSettings = {
  __typename?: 'FarmerSEOSettings';
  description: Scalars['String']['output'];
  keywords: Array<Scalars['String']['output']>;
  ogImage?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type FarmerSeoSettingsInput = {
  description: Scalars['String']['input'];
  keywords: Array<Scalars['String']['input']>;
  ogImage?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

/** The status of the farmer profile */
export enum FarmerStatus {
  Active = 'ACTIVE',
  Draft = 'DRAFT',
  Inactive = 'INACTIVE'
}

export type FarmerValueProposition = {
  __typename?: 'FarmerValueProposition';
  description: Scalars['String']['output'];
  icon: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type FarmerValuePropositionInput = {
  description: Scalars['String']['input'];
  icon: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type FeedbackActivity = {
  __typename?: 'FeedbackActivity';
  activityType: Scalars['String']['output'];
  actorId?: Maybe<Scalars['ID']['output']>;
  actorName?: Maybe<Scalars['String']['output']>;
  attachments: Array<FeedbackActivityAttachment>;
  createdAt: Scalars['DateTime']['output'];
  detailJson?: Maybe<Scalars['String']['output']>;
  details?: Maybe<Scalars['String']['output']>;
  feedbackId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  isDeleted: Scalars['Boolean']['output'];
  occurredAt: Scalars['DateTime']['output'];
  tenantId: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type FeedbackActivityAttachment = {
  __typename?: 'FeedbackActivityAttachment';
  cid: Scalars['String']['output'];
  fileName?: Maybe<Scalars['String']['output']>;
  mimeType?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

export type FeedbackActivityPage = {
  __typename?: 'FeedbackActivityPage';
  cap: Scalars['Int']['output'];
  rows: Array<FeedbackActivity>;
  total: Scalars['Int']['output'];
};

export type FeedbackCount = {
  __typename?: 'FeedbackCount';
  count: Scalars['Int']['output'];
  key: Scalars['String']['output'];
};

/** Who gave the feedback */
export enum FeedbackFrom {
  Family = 'FAMILY',
  Other = 'OTHER',
  Representative = 'REPRESENTATIVE',
  Resident = 'RESIDENT',
  Staff = 'STAFF',
  StaffOnBehalf = 'STAFF_ON_BEHALF',
  Visitor = 'VISITOR'
}

export type FeedbackItem = {
  __typename?: 'FeedbackItem';
  aboutResident?: Maybe<Scalars['String']['output']>;
  acknowledgedAt?: Maybe<Scalars['DateTime']['output']>;
  assignedAt?: Maybe<Scalars['DateTime']['output']>;
  assignedToId?: Maybe<Scalars['ID']['output']>;
  assignedToName?: Maybe<Scalars['String']['output']>;
  closedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  desiredOutcome?: Maybe<Scalars['String']['output']>;
  details: Scalars['String']['output'];
  dueDate?: Maybe<Scalars['DateTime']['output']>;
  feedbackNumber: Scalars['Int']['output'];
  fromOther?: Maybe<Scalars['String']['output']>;
  fromType: FeedbackFrom;
  id: Scalars['ID']['output'];
  immediateAction?: Maybe<Scalars['String']['output']>;
  isAnonymous: Scalars['Boolean']['output'];
  isConfidential: Scalars['Boolean']['output'];
  isDeleted: Scalars['Boolean']['output'];
  kind: FeedbackKind;
  media: Array<FeedbackMedia>;
  outcomes: Array<FeedbackOutcome>;
  receivedAt: Scalars['DateTime']['output'];
  resolvedAt?: Maybe<Scalars['DateTime']['output']>;
  resolvedByName?: Maybe<Scalars['String']['output']>;
  response?: Maybe<Scalars['String']['output']>;
  responseSentAt?: Maybe<Scalars['DateTime']['output']>;
  responseSentTo?: Maybe<Scalars['String']['output']>;
  room?: Maybe<Scalars['String']['output']>;
  status: FeedbackStatus;
  submittedById?: Maybe<Scalars['ID']['output']>;
  submitterEmail?: Maybe<Scalars['String']['output']>;
  submitterName?: Maybe<Scalars['String']['output']>;
  submitterPhone?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  topic: FeedbackTopic;
  updatedAt: Scalars['DateTime']['output'];
  wantsReply: Scalars['Boolean']['output'];
  wing?: Maybe<Scalars['String']['output']>;
};

/** Compliment, suggestion, complaint or problem */
export enum FeedbackKind {
  Complaint = 'COMPLAINT',
  Compliment = 'COMPLIMENT',
  Problem = 'PROBLEM',
  Suggestion = 'SUGGESTION'
}

export type FeedbackLinkCandidate = {
  __typename?: 'FeedbackLinkCandidate';
  id: Scalars['ID']['output'];
  number?: Maybe<Scalars['Int']['output']>;
  status: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type FeedbackLinkRef = {
  __typename?: 'FeedbackLinkRef';
  createdHere: Scalars['Boolean']['output'];
  detailUrl: Scalars['String']['output'];
  feedbackNumber: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  kind: FeedbackKind;
  receivedAt: Scalars['DateTime']['output'];
  status: FeedbackStatus;
  summary: Scalars['String']['output'];
};

export type FeedbackMedia = {
  __typename?: 'FeedbackMedia';
  cid: Scalars['String']['output'];
  fileName?: Maybe<Scalars['String']['output']>;
  mimeType?: Maybe<Scalars['String']['output']>;
  uploadedAt?: Maybe<Scalars['DateTime']['output']>;
  url: Scalars['String']['output'];
};

export type FeedbackMediaInput = {
  cid: Scalars['String']['input'];
  fileName?: InputMaybe<Scalars['String']['input']>;
  mimeType?: InputMaybe<Scalars['String']['input']>;
};

/** Delivery channel for a feedback notification */
export enum FeedbackNotificationChannel {
  Email = 'EMAIL',
  InApp = 'IN_APP',
  Sms = 'SMS'
}

/** How to resolve the feedback notification recipient(s) */
export enum FeedbackNotificationRecipientType {
  AllFeedbackManagers = 'ALL_FEEDBACK_MANAGERS',
  AssignedPerson = 'ASSIGNED_PERSON',
  Role = 'ROLE',
  SpecificEmployee = 'SPECIFIC_EMPLOYEE',
  Submitter = 'SUBMITTER'
}

export type FeedbackNotificationRule = {
  __typename?: 'FeedbackNotificationRule';
  channels: Array<FeedbackNotificationChannel>;
  createdAt: Scalars['DateTime']['output'];
  filterKind?: Maybe<Scalars['String']['output']>;
  filterTopic?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isEnabled: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  recipientIds: Array<Scalars['String']['output']>;
  recipientRole?: Maybe<Scalars['String']['output']>;
  recipientType: FeedbackNotificationRecipientType;
  tenantId: Scalars['String']['output'];
  trigger: FeedbackNotificationTrigger;
  updatedAt: Scalars['DateTime']['output'];
};

/** Event that triggers a feedback notification */
export enum FeedbackNotificationTrigger {
  AllEvents = 'ALL_EVENTS',
  FeedbackAssigned = 'FEEDBACK_ASSIGNED',
  FeedbackResolved = 'FEEDBACK_RESOLVED',
  FeedbackSubmitted = 'FEEDBACK_SUBMITTED',
  NoteAdded = 'NOTE_ADDED',
  OutcomeLinked = 'OUTCOME_LINKED',
  StatusChanged = 'STATUS_CHANGED'
}

export type FeedbackOutcome = {
  __typename?: 'FeedbackOutcome';
  createdHere: Scalars['Boolean']['output'];
  detailUrl?: Maybe<Scalars['String']['output']>;
  kind: FeedbackOutcomeKind;
  linkedAt: Scalars['DateTime']['output'];
  linkedById?: Maybe<Scalars['ID']['output']>;
  linkedByName?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  targetId: Scalars['ID']['output'];
  targetNumber?: Maybe<Scalars['Int']['output']>;
  targetTitle?: Maybe<Scalars['String']['output']>;
};

/** The module a feedback item was sent to */
export enum FeedbackOutcomeKind {
  CiIssue = 'CI_ISSUE',
  MaintenanceRequest = 'MAINTENANCE_REQUEST',
  MealFeedback = 'MEAL_FEEDBACK'
}

export type FeedbackPage = {
  __typename?: 'FeedbackPage';
  rows: Array<FeedbackItem>;
  total: Scalars['Int']['output'];
};

export type FeedbackPerson = {
  __typename?: 'FeedbackPerson';
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type FeedbackRegisterStats = {
  __typename?: 'FeedbackRegisterStats';
  byKind: Array<FeedbackCount>;
  byStatus: Array<FeedbackCount>;
  byTopic: Array<FeedbackCount>;
  newCount: Scalars['Int']['output'];
  open: Scalars['Int']['output'];
  overdue: Scalars['Int']['output'];
  receivedLast30Days: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type FeedbackResolveResult = {
  __typename?: 'FeedbackResolveResult';
  emailError?: Maybe<Scalars['String']['output']>;
  emailOutcome: Scalars['String']['output'];
  emailedTo?: Maybe<Scalars['String']['output']>;
  feedback: FeedbackItem;
};

export type FeedbackSettings = {
  __typename?: 'FeedbackSettings';
  createdAt: Scalars['DateTime']['output'];
  defaultAssigneeId?: Maybe<Scalars['ID']['output']>;
  defaultAssigneeName?: Maybe<Scalars['String']['output']>;
  emailDefaultAssignee: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type FeedbackStats = {
  __typename?: 'FeedbackStats';
  averageRating: Scalars['Float']['output'];
  feedbackByType: Array<FeedbackTypeCount>;
  highRatingCount: Scalars['Float']['output'];
  lowRatingCount: Scalars['Float']['output'];
  totalFeedback: Scalars['Float']['output'];
};

/** Where the feedback is up to */
export enum FeedbackStatus {
  Acknowledged = 'ACKNOWLEDGED',
  Closed = 'CLOSED',
  InProgress = 'IN_PROGRESS',
  New = 'NEW',
  Resolved = 'RESOLVED'
}

/** What the feedback is about */
export enum FeedbackTopic {
  Activities = 'ACTIVITIES',
  Building = 'BUILDING',
  Care = 'CARE',
  Cleaning = 'CLEANING',
  Communication = 'COMMUNICATION',
  Food = 'FOOD',
  Laundry = 'LAUNDRY',
  Other = 'OTHER',
  Staff = 'STAFF'
}

/** Types of meal feedback */
export enum FeedbackType {
  DietaryIssue = 'DIETARY_ISSUE',
  Other = 'OTHER',
  Portion = 'PORTION',
  Presentation = 'PRESENTATION',
  Taste = 'TASTE'
}

export type FeedbackTypeCount = {
  __typename?: 'FeedbackTypeCount';
  count: Scalars['Float']['output'];
  type: FeedbackType;
};

/** Type of custom assessment field */
export enum FieldType {
  Checkbox = 'CHECKBOX',
  Number = 'NUMBER',
  Select = 'SELECT',
  Slider = 'SLIDER',
  Text = 'TEXT',
  Textarea = 'TEXTAREA'
}

export type FileInput = {
  filename: Scalars['String']['input'];
  path: Scalars['String']['input'];
  size: Scalars['Float']['input'];
};

export type FileTransfer = {
  __typename?: 'FileTransfer';
  capturedAt?: Maybe<Scalars['DateTime']['output']>;
  checksum?: Maybe<Scalars['String']['output']>;
  checksumVerified: Scalars['Boolean']['output'];
  cloudUrl?: Maybe<Scalars['String']['output']>;
  copiedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  duration?: Maybe<Scalars['Float']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  fileSize: Scalars['Float']['output'];
  fileType: FileTransferType;
  height?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  ipfsHash?: Maybe<Scalars['String']['output']>;
  lastRetryAt?: Maybe<Scalars['DateTime']['output']>;
  localDeletedAt?: Maybe<Scalars['DateTime']['output']>;
  mediaItemId?: Maybe<Scalars['String']['output']>;
  mimeType: Scalars['String']['output'];
  originalFilename: Scalars['String']['output'];
  originalPath: Scalars['String']['output'];
  retryCount: Scalars['Float']['output'];
  sessionId: Scalars['String']['output'];
  stagingPath?: Maybe<Scalars['String']['output']>;
  state: FileTransferState;
  tenantId: Scalars['String']['output'];
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  totalChunks: Scalars['Float']['output'];
  updatedAt: Scalars['DateTime']['output'];
  uploadCompletedAt?: Maybe<Scalars['DateTime']['output']>;
  uploadId?: Maybe<Scalars['String']['output']>;
  uploadStartedAt?: Maybe<Scalars['DateTime']['output']>;
  uploadedBytes: Scalars['Float']['output'];
  uploadedChunks: Scalars['Float']['output'];
  verifiedAt?: Maybe<Scalars['DateTime']['output']>;
  width?: Maybe<Scalars['Float']['output']>;
};

export type FileTransferFilters = {
  fileType?: InputMaybe<FileTransferType>;
  limit?: InputMaybe<Scalars['Float']['input']>;
  offset?: InputMaybe<Scalars['Float']['input']>;
  sessionId?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<FileTransferState>;
};

/** State of a file transfer */
export enum FileTransferState {
  CloudOnly = 'CLOUD_ONLY',
  Copying = 'COPYING',
  Failed = 'FAILED',
  InCloud = 'IN_CLOUD',
  OnDrone = 'ON_DRONE',
  OnLaptop = 'ON_LAPTOP',
  Uploading = 'UPLOADING',
  Verified = 'VERIFIED'
}

/** Type of media file */
export enum FileTransferType {
  Image = 'IMAGE',
  Video = 'VIDEO'
}

export type FinancialActivityFilterInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  jobId?: InputMaybe<Scalars['ID']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  supplierId?: InputMaybe<Scalars['ID']['input']>;
};

export type FinancialActivityItem = {
  __typename?: 'FinancialActivityItem';
  amount: Scalars['Float']['output'];
  category?: Maybe<Scalars['String']['output']>;
  date: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
  jobNumber?: Maybe<Scalars['Float']['output']>;
  supplierName?: Maybe<Scalars['String']['output']>;
};

export type FinancialActivityReport = {
  __typename?: 'FinancialActivityReport';
  items: Array<FinancialActivityItem>;
  totalAmount: Scalars['Float']['output'];
};

export type FinancialSummary = {
  __typename?: 'FinancialSummary';
  activeBonds: Scalars['Int']['output'];
  totalBondValue: Scalars['Float']['output'];
  totalOutstanding: Scalars['Float']['output'];
  totalRetentions: Scalars['Float']['output'];
};

export type FinishRosterBulkOpInput = {
  createdCount: Scalars['Int']['input'];
  deletedCount: Scalars['Int']['input'];
  errors?: InputMaybe<Array<Scalars['String']['input']>>;
  failedCount: Scalars['Int']['input'];
  id: Scalars['ID']['input'];
};

export type FireVaultInsightRuleResult = {
  __typename?: 'FireVaultInsightRuleResult';
  emailsSent: Scalars['Int']['output'];
  error?: Maybe<Scalars['String']['output']>;
  recipientCount: Scalars['Int']['output'];
  runId?: Maybe<Scalars['String']['output']>;
  smsSent: Scalars['Int']['output'];
  success: Scalars['Boolean']['output'];
};

/** One Brisbane day of one resident's fluid balance chart: sums of the volumes charted that day */
export type FluidBalanceDay = {
  __typename?: 'FluidBalanceDay';
  /** The Brisbane calendar day, YYYY-MM-DD */
  day: Scalars['String']['output'];
  /** Entries charted that day */
  entries: Scalars['Int']['output'];
  /** Entries that had an intake volume */
  intakeEntries: Scalars['Int']['output'];
  /** Sum of the intake volumes charted (entries without a volume add nothing) */
  intakeMl: Scalars['Int']['output'];
  /** Entries that had an output volume */
  outputEntries: Scalars['Int']['output'];
  /** Sum of the output volumes charted (urine, bowel, vomit and unnamed types together) */
  outputMl: Scalars['Int']['output'];
  residentId: Scalars['ID']['output'];
  residentName?: Maybe<Scalars['String']['output']>;
};

export type FluidBalanceDaysResponse = {
  __typename?: 'FluidBalanceDaysResponse';
  days: Array<FluidBalanceDay>;
  limit: Scalars['Int']['output'];
  offset: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type FluidBalanceEntriesResponse = {
  __typename?: 'FluidBalanceEntriesResponse';
  limit: Scalars['Int']['output'];
  offset: Scalars['Int']['output'];
  records: Array<FluidBalanceEntry>;
  total: Scalars['Int']['output'];
};

export type FluidBalanceEntry = {
  __typename?: 'FluidBalanceEntry';
  comments?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  /** Intake in millilitres, as charted */
  intakeMl?: Maybe<Scalars['Int']['output']>;
  /** SarahCare's intake type code (raw) */
  intakeTypeCode?: Maybe<Scalars['String']['output']>;
  /** The words SarahCare's own lookup gives that intake code; null when it names none */
  intakeTypeWords?: Maybe<Scalars['String']['output']>;
  /** True for SarahCare history: read-only, never current work */
  isHistoricalRecord?: Maybe<Scalars['Boolean']['output']>;
  /** Output in millilitres, as charted */
  outputMl?: Maybe<Scalars['Int']['output']>;
  /** SarahCare's output type code (raw) */
  outputTypeCode?: Maybe<Scalars['String']['output']>;
  /** The words SarahCare's own lookup gives that output code (Urine, Bowel, Vomit); null when it names none */
  outputTypeWords?: Maybe<Scalars['String']['output']>;
  /** When it was charted (UTC instant; SarahCare wall clock was Brisbane) */
  recordedAt: Scalars['DateTime']['output'];
  recordedBy: Scalars['ID']['output'];
  recordedByName?: Maybe<Scalars['String']['output']>;
  residentId: Scalars['ID']['output'];
  residentName?: Maybe<Scalars['String']['output']>;
  residentRoom?: Maybe<Scalars['String']['output']>;
  residentWing?: Maybe<Scalars['String']['output']>;
  /** The SarahCare user who charted it */
  sourceAuthor?: Maybe<Scalars['String']['output']>;
  sourceBackupDate?: Maybe<Scalars['DateTime']['output']>;
  /** Original SarahCare columns (provenance only) */
  sourceFields?: Maybe<Array<ObservationChartSourceField>>;
  sourceId?: Maybe<Scalars['String']['output']>;
  /** SARAHCARE for imported history */
  sourceSystem?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type FluidBalanceFilterInput = {
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  residentId?: InputMaybe<Scalars['ID']['input']>;
  /** true = only SarahCare history; false = only records made here */
  sarahHistory?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FollowUpFilterInput = {
  assignedTo?: InputMaybe<Scalars['ID']['input']>;
  incidentId?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  overdue?: InputMaybe<Scalars['Boolean']['input']>;
  residentId?: InputMaybe<Scalars['ID']['input']>;
  scheduledFrom?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledTo?: InputMaybe<Scalars['DateTime']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sourceSystem?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<FollowUpStatus>>;
};

/** Status of incident follow-up task */
export enum FollowUpStatus {
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Overdue = 'OVERDUE',
  Scheduled = 'SCHEDULED'
}

export type FollowUpsResponse = {
  __typename?: 'FollowUpsResponse';
  completed: Scalars['Int']['output'];
  followUps: Array<IncidentFollowUp>;
  overdue: Scalars['Int']['output'];
  scheduled: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type FoodBudget = {
  __typename?: 'FoodBudget';
  createdAt: Scalars['DateTime']['output'];
  currency: Scalars['String']['output'];
  financialYearStartMonth: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  monthlyBudget: Scalars['Float']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type FoodBudgetSummary = {
  __typename?: 'FoodBudgetSummary';
  endDate: Scalars['DateTime']['output'];
  estimatedPercentUsed: Scalars['Float']['output'];
  estimatedRemaining: Scalars['Float']['output'];
  estimatedSpend: Scalars['Float']['output'];
  percentUsed: Scalars['Float']['output'];
  period: Scalars['String']['output'];
  periodBudget: Scalars['Float']['output'];
  remaining: Scalars['Float']['output'];
  spent: Scalars['Float']['output'];
  spentFromInvoices: Scalars['Float']['output'];
  spentFromOrders: Scalars['Float']['output'];
  startDate: Scalars['DateTime']['output'];
};

export type FoodIntakeDay = {
  __typename?: 'FoodIntakeDay';
  createdAt: Scalars['DateTime']['output'];
  /** SarahCare's day number on the chart, as stored */
  dayNumber?: Maybe<Scalars['Int']['output']>;
  evaluation?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** The chart day (date-only, stored T00:00:00.000Z) */
  intakeDate: Scalars['DateTime']['output'];
  /** True for SarahCare history: read-only, never current work */
  isHistoricalRecord?: Maybe<Scalars['Boolean']['output']>;
  items: Array<FoodIntakeItem>;
  recordedBy: Scalars['ID']['output'];
  recordedByName?: Maybe<Scalars['String']['output']>;
  residentId: Scalars['ID']['output'];
  residentName?: Maybe<Scalars['String']['output']>;
  residentRoom?: Maybe<Scalars['String']['output']>;
  residentWing?: Maybe<Scalars['String']['output']>;
  /** The SarahCare user who started the day */
  sourceAuthor?: Maybe<Scalars['String']['output']>;
  sourceBackupDate?: Maybe<Scalars['DateTime']['output']>;
  /** Original SarahCare columns of the day row (provenance only) */
  sourceFields?: Maybe<Array<ObservationChartSourceField>>;
  sourceId?: Maybe<Scalars['String']['output']>;
  /** SARAHCARE for imported history */
  sourceSystem?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type FoodIntakeDaysResponse = {
  __typename?: 'FoodIntakeDaysResponse';
  limit: Scalars['Int']['output'];
  offset: Scalars['Int']['output'];
  records: Array<FoodIntakeDay>;
  total: Scalars['Int']['output'];
};

export type FoodIntakeFilterInput = {
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  residentId?: InputMaybe<Scalars['ID']['input']>;
  /** true = only SarahCare history; false = only records made here */
  sarahHistory?: InputMaybe<Scalars['Boolean']['input']>;
};

/** One food item charted on a food intake day */
export type FoodIntakeItem = {
  __typename?: 'FoodIntakeItem';
  /** When SarahCare saved the item (its own clock, as text) */
  addedAtText?: Maybe<Scalars['String']['output']>;
  /** SarahCare user who charted the item */
  addedBy?: Maybe<Scalars['String']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  /** Fraction eaten as stored (0 = none, 1 = all) */
  consumed?: Maybe<Scalars['Float']['output']>;
  /** The food as picked or typed in SarahCare */
  food?: Maybe<Scalars['String']['output']>;
  /** Eating issues recorded for this item (text as recorded) */
  issues: Array<Scalars['String']['output']>;
  /** SarahCare ResFoodIntakeDetail.DetailID */
  sourceId?: Maybe<Scalars['String']['output']>;
  /** SarahCare's time-of-day slot number (1–7), as stored */
  timeOfDay?: Maybe<Scalars['Int']['output']>;
};

export type FoodInvoice = {
  __typename?: 'FoodInvoice';
  confirmedAt?: Maybe<Scalars['DateTime']['output']>;
  confirmedBy?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  dueDate?: Maybe<Scalars['DateTime']['output']>;
  extractionError?: Maybe<Scalars['String']['output']>;
  gst: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  invoiceDate?: Maybe<Scalars['DateTime']['output']>;
  invoiceNumber?: Maybe<Scalars['String']['output']>;
  lineItems: Array<FoodInvoiceLineItem>;
  linkedOrder?: Maybe<SupplierOrder>;
  linkedOrderId?: Maybe<Scalars['ID']['output']>;
  mismatchDetails: Array<FoodInvoiceMismatch>;
  originalFileCid?: Maybe<Scalars['String']['output']>;
  originalFileMimeType?: Maybe<Scalars['String']['output']>;
  originalFileUrl?: Maybe<Scalars['String']['output']>;
  status: FoodInvoiceStatus;
  subtotal: Scalars['Float']['output'];
  supplier?: Maybe<Supplier>;
  supplierAbnRaw?: Maybe<Scalars['String']['output']>;
  supplierId?: Maybe<Scalars['ID']['output']>;
  supplierNameRaw?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  total: Scalars['Float']['output'];
  updatedAt: Scalars['DateTime']['output'];
  uploadedBy?: Maybe<Scalars['String']['output']>;
};

export type FoodInvoiceEditInput = {
  dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  gst?: InputMaybe<Scalars['Float']['input']>;
  invoiceDate?: InputMaybe<Scalars['DateTime']['input']>;
  invoiceNumber?: InputMaybe<Scalars['String']['input']>;
  lineItems?: InputMaybe<Array<FoodInvoiceLineItemInput>>;
  linkedOrderId?: InputMaybe<Scalars['ID']['input']>;
  subtotal?: InputMaybe<Scalars['Float']['input']>;
  supplierAbnRaw?: InputMaybe<Scalars['String']['input']>;
  supplierId?: InputMaybe<Scalars['ID']['input']>;
  supplierNameRaw?: InputMaybe<Scalars['String']['input']>;
  total?: InputMaybe<Scalars['Float']['input']>;
};

export type FoodInvoiceLineItem = {
  __typename?: 'FoodInvoiceLineItem';
  categoryHint?: Maybe<IngredientCategory>;
  descriptionRaw: Scalars['String']['output'];
  ingredientId?: Maybe<Scalars['ID']['output']>;
  lineTotal: Scalars['Float']['output'];
  matchScore?: Maybe<Scalars['Float']['output']>;
  matchStatus: InvoiceLineItemMatchStatus;
  quantity: Scalars['Float']['output'];
  unit?: Maybe<Scalars['String']['output']>;
  unitPrice: Scalars['Float']['output'];
};

export type FoodInvoiceLineItemInput = {
  categoryHint?: InputMaybe<IngredientCategory>;
  descriptionRaw: Scalars['String']['input'];
  ingredientId?: InputMaybe<Scalars['ID']['input']>;
  lineTotal: Scalars['Float']['input'];
  matchStatus?: InputMaybe<InvoiceLineItemMatchStatus>;
  quantity: Scalars['Float']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  unitPrice: Scalars['Float']['input'];
};

export type FoodInvoiceMismatch = {
  __typename?: 'FoodInvoiceMismatch';
  detail?: Maybe<Scalars['String']['output']>;
  field: Scalars['String']['output'];
  invoiceValue?: Maybe<Scalars['String']['output']>;
  orderValue?: Maybe<Scalars['String']['output']>;
};

/** Lifecycle status of an uploaded food-supplier invoice */
export enum FoodInvoiceStatus {
  Confirmed = 'CONFIRMED',
  Discarded = 'DISCARDED',
  PendingExtraction = 'PENDING_EXTRACTION',
  PendingReview = 'PENDING_REVIEW'
}

export type FoodInvoicesFilter = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<FoodInvoiceStatus>;
  supplierId?: InputMaybe<Scalars['ID']['input']>;
};

export type FoodSpendByCategoryRow = {
  __typename?: 'FoodSpendByCategoryRow';
  category: Scalars['String']['output'];
  estimated: Scalars['Float']['output'];
  ingredients: Array<FoodSpendByIngredientRow>;
  percent: Scalars['Float']['output'];
  spent: Scalars['Float']['output'];
};

export type FoodSpendByIngredientRow = {
  __typename?: 'FoodSpendByIngredientRow';
  actual: Scalars['Float']['output'];
  actualFormula?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  estimated: Scalars['Float']['output'];
  estimatedFormula?: Maybe<Scalars['String']['output']>;
  ingredientId: Scalars['String']['output'];
  ingredientName: Scalars['String']['output'];
  supplierId?: Maybe<Scalars['String']['output']>;
  supplierName?: Maybe<Scalars['String']['output']>;
  totalQuantity?: Maybe<Scalars['Float']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
  variance: Scalars['Float']['output'];
};

export type FoodSpendBySupplierRow = {
  __typename?: 'FoodSpendBySupplierRow';
  estimated: Scalars['Float']['output'];
  ingredients: Array<FoodSpendByIngredientRow>;
  percent: Scalars['Float']['output'];
  spent: Scalars['Float']['output'];
  supplierId?: Maybe<Scalars['String']['output']>;
  supplierName: Scalars['String']['output'];
};

/** A computed fortnight period — start/end/payment-date + cycle index */
export type FortnightWindow = {
  __typename?: 'FortnightWindow';
  cycleIndex: Scalars['Int']['output'];
  paymentDate: Scalars['DateTime']['output'];
  periodEnd: Scalars['DateTime']['output'];
  periodStart: Scalars['DateTime']['output'];
};

/** Email forwarding service provider */
export enum ForwardingProvider {
  Google = 'GOOGLE',
  Improvmx = 'IMPROVMX',
  Microsoft = 'MICROSOFT',
  None = 'NONE',
  Other = 'OTHER'
}

export type FrontendUpgrade = {
  __typename?: 'FrontendUpgrade';
  appliedToTenants: Array<TenantUpgradeStatus>;
  category: UpgradeCategory;
  completedCount: Scalars['Float']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  createdDate: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  gitCommitUrls: Array<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isPendingForMaster: Scalars['Boolean']['output'];
  lastModified: Scalars['DateTime']['output'];
  markdownDocumentation?: Maybe<Scalars['String']['output']>;
  originTenantId: Scalars['ID']['output'];
  originTenantName: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  title: Scalars['String']['output'];
  totalTenantCount: Scalars['Float']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type FuelCapacity = {
  __typename?: 'FuelCapacity';
  tankBreakdown?: Maybe<Array<TankBreakdown>>;
  totalLitres?: Maybe<Scalars['Float']['output']>;
};

export type FuelLevel = {
  __typename?: 'FuelLevel';
  fuelType: FuelType;
  lastUpdated?: Maybe<Scalars['DateTime']['output']>;
  levelPercent?: Maybe<Scalars['Float']['output']>;
  pricePerLitre?: Maybe<Scalars['Float']['output']>;
};

export type FuelReading = {
  __typename?: 'FuelReading';
  createdAt: Scalars['DateTime']['output'];
  fuelType: FuelType;
  id: Scalars['ID']['output'];
  levelPercent?: Maybe<Scalars['Float']['output']>;
  pricePerLitre?: Maybe<Scalars['Float']['output']>;
  recordedAt: Scalars['DateTime']['output'];
  recordedBy?: Maybe<Scalars['String']['output']>;
  source: DataSource;
  stationId: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type FuelStation = {
  __typename?: 'FuelStation';
  agentId?: Maybe<Scalars['String']['output']>;
  brand?: Maybe<Scalars['String']['output']>;
  capacity?: Maybe<FuelCapacity>;
  createdAt: Scalars['DateTime']['output'];
  currentLevels: Array<FuelLevel>;
  fuelTypes: Array<FuelType>;
  id: Scalars['ID']['output'];
  isRefinery: Scalars['Boolean']['output'];
  isTerminal: Scalars['Boolean']['output'];
  lastSeeded?: Maybe<Scalars['DateTime']['output']>;
  location: GeoPoint;
  name: Scalars['String']['output'];
  operatingHours?: Maybe<Scalars['String']['output']>;
  osmId?: Maybe<Scalars['String']['output']>;
  stressStatus: StressStatus;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type FuelStationFiltersInput = {
  fuelTypes?: InputMaybe<Array<FuelType>>;
  isRefinery?: InputMaybe<Scalars['Boolean']['input']>;
  isTerminal?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  stressStatus?: InputMaybe<StressStatus>;
};

/** Types of fuel available at stations */
export enum FuelType {
  Diesel = 'DIESEL',
  E10 = 'E10',
  Lpg = 'LPG',
  Unleaded_91 = 'UNLEADED_91',
  Unleaded_95 = 'UNLEADED_95',
  Unleaded_98 = 'UNLEADED_98'
}

export type FundClub52PlayerInput = {
  amountMicro: Scalars['String']['input'];
  playerEmail: Scalars['String']['input'];
  roomName: Scalars['String']['input'];
};

/** SUPPORTED = government pays the accommodation; NON_SUPPORTED = pays their own (deposit needed) */
export enum FundingSupport {
  NonSupported = 'NON_SUPPORTED',
  Supported = 'SUPPORTED',
  Unknown = 'UNKNOWN'
}

/** Observed gait pattern */
export enum GaitObservation {
  Antalgic = 'ANTALGIC',
  Ataxic = 'ATAXIC',
  Festinating = 'FESTINATING',
  Normal = 'NORMAL',
  Shuffling = 'SHUFFLING',
  UnableToAmbulate = 'UNABLE_TO_AMBULATE',
  Unsteady = 'UNSTEADY',
  WideBased = 'WIDE_BASED'
}

/** Gender of the resident */
export enum Gender {
  Female = 'FEMALE',
  Male = 'MALE',
  Other = 'OTHER',
  PreferNotToSay = 'PREFER_NOT_TO_SAY'
}

export type GenderDistribution = {
  __typename?: 'GenderDistribution';
  count: Scalars['Int']['output'];
  gender: Scalars['String']['output'];
};

export type GenerateInboxSummaryInput = {
  period: InboxSummaryPeriod;
};

export type GenerateMealPlanAiInput = {
  numberOfDays?: Scalars['Int']['input'];
  preferences?: InputMaybe<Scalars['String']['input']>;
  servings?: Scalars['Int']['input'];
  startDate: Scalars['String']['input'];
};

export type GenerateOrdersInput = {
  endDate: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
};

export type GenerateQrCodeInput = {
  /** Date to generate code for. Defaults to today. */
  date?: InputMaybe<Scalars['DateTime']['input']>;
  locationId: Scalars['ID']['input'];
};

export type GenerateSiteSpecInput = {
  businessDescription: Scalars['String']['input'];
  customInstructions?: InputMaybe<Scalars['String']['input']>;
};

export type GenerateTasksFromEmailInput = {
  customInstructions?: InputMaybe<Scalars['String']['input']>;
  emailId: Scalars['String']['input'];
  opportunityId: Scalars['String']['input'];
};

export type GenerateTasksResult = {
  __typename?: 'GenerateTasksResult';
  aiNotes?: Maybe<Scalars['String']['output']>;
  tasks: Array<GeneratedTaskPreview>;
};

export type GeneratedAdpForm = {
  __typename?: 'GeneratedAdpForm';
  filename: Scalars['String']['output'];
  /** Base64 PDF — decode and download client-side. Never persisted server-side. */
  pdfBase64: Scalars['String']['output'];
};

export type GeneratedDailyAllocationOds = {
  __typename?: 'GeneratedDailyAllocationOds';
  base64: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
  mimeType: Scalars['String']['output'];
};

export type GeneratedMealPlanEntry = {
  __typename?: 'GeneratedMealPlanEntry';
  date: Scalars['String']['output'];
  mealType: MealType;
  recipeId: Scalars['ID']['output'];
  recipeName: Scalars['String']['output'];
};

export type GeneratedMealPlanResult = {
  __typename?: 'GeneratedMealPlanResult';
  aiNotes?: Maybe<Scalars['String']['output']>;
  entries: Array<GeneratedMealPlanEntry>;
};

export type GeneratedOrder = {
  __typename?: 'GeneratedOrder';
  itemCount: Scalars['Float']['output'];
  order: SupplierOrder;
  totalAmount: Scalars['Float']['output'];
};

export type GeneratedRosterXlsx = {
  __typename?: 'GeneratedRosterXlsx';
  base64: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
  mimeType: Scalars['String']['output'];
};

export type GeneratedSubtaskPreview = {
  __typename?: 'GeneratedSubtaskPreview';
  order: Scalars['Int']['output'];
  title: Scalars['String']['output'];
};

export type GeneratedTaskPreview = {
  __typename?: 'GeneratedTaskPreview';
  description: Scalars['String']['output'];
  priority: Scalars['String']['output'];
  subtasks: Array<GeneratedSubtaskPreview>;
  title: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type GeoCoordinates = {
  __typename?: 'GeoCoordinates';
  accuracy?: Maybe<Scalars['Float']['output']>;
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
};

export type GeoCoordinatesInput = {
  accuracy?: InputMaybe<Scalars['Float']['input']>;
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
};

export type GeoPoint = {
  __typename?: 'GeoPoint';
  address?: Maybe<Scalars['String']['output']>;
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
  postcode?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  suburb?: Maybe<Scalars['String']['output']>;
};

export type GeoPolygon = {
  __typename?: 'GeoPolygon';
  /** Polygon rings: outer ring first then holes; each point is [lng, lat] */
  coordinates: Array<Array<Array<Scalars['Float']['output']>>>;
  /** Always "Polygon" for parcel geometry */
  type: Scalars['String']['output'];
};

export type GhlOpportunitiesResult = {
  __typename?: 'GhlOpportunitiesResult';
  configured: Scalars['Boolean']['output'];
  count: Scalars['Int']['output'];
  error?: Maybe<Scalars['String']['output']>;
  locationId?: Maybe<Scalars['String']['output']>;
  opportunities: Array<GhlOpportunitySummary>;
  pipelines: Array<GhlPipelineCount>;
};

export type GhlOpportunitySummary = {
  __typename?: 'GhlOpportunitySummary';
  contactEmail?: Maybe<Scalars['String']['output']>;
  contactId?: Maybe<Scalars['String']['output']>;
  contactName?: Maybe<Scalars['String']['output']>;
  contactPhone?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  monetaryValue?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  pipelineId?: Maybe<Scalars['String']['output']>;
  pipelineName?: Maybe<Scalars['String']['output']>;
  stageName?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  xeroDue?: Maybe<Scalars['Float']['output']>;
  xeroPaid?: Maybe<Scalars['Float']['output']>;
  xeroTotal?: Maybe<Scalars['Float']['output']>;
};

export type GhlPipelineCount = {
  __typename?: 'GhlPipelineCount';
  count: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type GhlPipelineResult = {
  __typename?: 'GhlPipelineResult';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  stages: Array<GhlStageResult>;
};

export type GhlStageResult = {
  __typename?: 'GhlStageResult';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type GlasgowComaScaleOption = {
  __typename?: 'GlasgowComaScaleOption';
  description: Scalars['String']['output'];
  response: Scalars['String']['output'];
  score: Scalars['Int']['output'];
};

export type GlasgowComaScaleOptions = {
  __typename?: 'GlasgowComaScaleOptions';
  eye: Array<GlasgowComaScaleOption>;
  motor: Array<GlasgowComaScaleOption>;
  verbal: Array<GlasgowComaScaleOption>;
};

export type GoalAction = {
  __typename?: 'GoalAction';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  completionNotes?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['DateTime']['output']>;
  goalId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  order: Scalars['Int']['output'];
  status: ActionStatus;
  tenantId: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** Categories for goals */
export enum GoalCategory {
  Customer = 'CUSTOMER',
  Finance = 'FINANCE',
  Growth = 'GROWTH',
  Marketing = 'MARKETING',
  Operations = 'OPERATIONS',
  Other = 'OTHER',
  Personal = 'PERSONAL',
  Product = 'PRODUCT',
  Team = 'TEAM'
}

export type GoalFilterInput = {
  aspectId?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  snapshotId?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<AccountabilityGoalStatus>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type GoalMilestone = {
  __typename?: 'GoalMilestone';
  completedBy?: Maybe<Scalars['String']['output']>;
  completedDate?: Maybe<Scalars['DateTime']['output']>;
  description: Scalars['String']['output'];
  isCompleted: Scalars['Boolean']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Float']['output']>;
  targetDate?: Maybe<Scalars['DateTime']['output']>;
};

export type GoalMonthComparison = {
  __typename?: 'GoalMonthComparison';
  current: GoalMonthStats;
  previous: GoalMonthStats;
};

export type GoalMonthGoalRow = {
  __typename?: 'GoalMonthGoalRow';
  id: Scalars['String']['output'];
  progressPercentage: Scalars['Float']['output'];
  status: GoalStatus;
  title: Scalars['String']['output'];
};

export type GoalMonthPersonStat = {
  __typename?: 'GoalMonthPersonStat';
  avgProgress: Scalars['Float']['output'];
  clientId: Scalars['String']['output'];
  completedGoals: Scalars['Float']['output'];
  goals: Scalars['Float']['output'];
  tasksDone: Scalars['Float']['output'];
  tasksTotal: Scalars['Float']['output'];
};

export type GoalMonthStats = {
  __typename?: 'GoalMonthStats';
  atRiskGoals: Scalars['Float']['output'];
  avgGoalProgress: Scalars['Float']['output'];
  completedGoals: Scalars['Float']['output'];
  goals: Array<GoalMonthGoalRow>;
  inProgressGoals: Scalars['Float']['output'];
  month: Scalars['String']['output'];
  perPerson: Array<GoalMonthPersonStat>;
  taskCompletionPct: Scalars['Float']['output'];
  tasksDone: Scalars['Float']['output'];
  tasksTotal: Scalars['Float']['output'];
  totalGoals: Scalars['Float']['output'];
};

/** Time period for goals */
export enum GoalPeriod {
  Custom = 'CUSTOM',
  Daily = 'DAILY',
  Monthly = 'MONTHLY',
  Quarterly = 'QUARTERLY',
  Weekly = 'WEEKLY',
  Yearly = 'YEARLY'
}

export type GoalReviewOutcome = {
  __typename?: 'GoalReviewOutcome';
  goalDescription?: Maybe<Scalars['String']['output']>;
  goalIndex: Scalars['Float']['output'];
  modified: Scalars['Boolean']['output'];
  newStatus?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  previousStatus?: Maybe<Scalars['String']['output']>;
  progress?: Maybe<Scalars['String']['output']>;
};

export type GoalReviewOutcomeInput = {
  goalIndex: Scalars['Float']['input'];
  modified?: InputMaybe<Scalars['Boolean']['input']>;
  newStatus?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  progress?: InputMaybe<Scalars['String']['input']>;
};

export type GoalReward = {
  __typename?: 'GoalReward';
  aspectColor?: Maybe<Scalars['String']['output']>;
  aspectName?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  earnedAt: Scalars['DateTime']['output'];
  goalId?: Maybe<Scalars['ID']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  tenantId: Scalars['String']['output'];
  title: Scalars['String']['output'];
  type: GoalRewardType;
  updatedAt: Scalars['DateTime']['output'];
  userId: Scalars['ID']['output'];
};

/** Type of goal reward */
export enum GoalRewardType {
  Completion = 'COMPLETION',
  Milestone = 'MILESTONE',
  Streak = 'STREAK'
}

export type GoalStats = {
  __typename?: 'GoalStats';
  abandoned: Scalars['Int']['output'];
  achieved: Scalars['Int']['output'];
  active: Scalars['Int']['output'];
  paused: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

/** Status of the goal */
export enum GoalStatus {
  AtRisk = 'AT_RISK',
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS',
  NotStarted = 'NOT_STARTED',
  OnHold = 'ON_HOLD'
}

export type GovAccessInfo = {
  __typename?: 'GovAccessInfo';
  canView: Scalars['Boolean']['output'];
  isMember: Scalars['Boolean']['output'];
  level?: Maybe<GovParticipationLevel>;
  membership?: Maybe<GovMember>;
  participation?: Maybe<GovParticipation>;
};

/** What kind of account this is */
export enum GovAccountKind {
  Bank = 'BANK',
  Cash = 'CASH',
  Points = 'POINTS',
  Safe = 'SAFE'
}

export type GovActivity = {
  __typename?: 'GovActivity';
  actorClientId?: Maybe<Scalars['ID']['output']>;
  actorName?: Maybe<Scalars['String']['output']>;
  attachments?: Maybe<Array<GovFile>>;
  createdAt: Scalars['DateTime']['output'];
  detailJson?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  kind: GovActivityKind;
  mentions?: Maybe<Array<GovMention>>;
  organisationId: Scalars['ID']['output'];
  subjectId?: Maybe<Scalars['ID']['output']>;
  subjectType?: Maybe<Scalars['String']['output']>;
  summary: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type GovActivityComment = {
  __typename?: 'GovActivityComment';
  activityId: Scalars['ID']['output'];
  attachments?: Maybe<Array<GovFile>>;
  authorClientId?: Maybe<Scalars['ID']['output']>;
  authorMemberId?: Maybe<Scalars['ID']['output']>;
  authorName?: Maybe<Scalars['String']['output']>;
  body?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  mentions?: Maybe<Array<GovMention>>;
  organisationId: Scalars['ID']['output'];
  retractedAt?: Maybe<Scalars['DateTime']['output']>;
  retractedById?: Maybe<Scalars['ID']['output']>;
  retractedByName?: Maybe<Scalars['String']['output']>;
  subjectId?: Maybe<Scalars['String']['output']>;
  subjectType?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** What happened */
export enum GovActivityKind {
  ApplicationDecided = 'APPLICATION_DECIDED',
  ApplicationSponsored = 'APPLICATION_SPONSORED',
  ApplicationSubmitted = 'APPLICATION_SUBMITTED',
  ChecklistItemDone = 'CHECKLIST_ITEM_DONE',
  ChecklistShared = 'CHECKLIST_SHARED',
  DelegateVoted = 'DELEGATE_VOTED',
  DelegationCleared = 'DELEGATION_CLEARED',
  DelegationSet = 'DELEGATION_SET',
  FileAttached = 'FILE_ATTACHED',
  InviteAccepted = 'INVITE_ACCEPTED',
  InviteDeclined = 'INVITE_DECLINED',
  InviteResent = 'INVITE_RESENT',
  InviteRevoked = 'INVITE_REVOKED',
  InviteSent = 'INVITE_SENT',
  JobspecAdopted = 'JOBSPEC_ADOPTED',
  JobspecDrafted = 'JOBSPEC_DRAFTED',
  JobspecProposed = 'JOBSPEC_PROPOSED',
  JobspecRetired = 'JOBSPEC_RETIRED',
  JobspecRevised = 'JOBSPEC_REVISED',
  JobspecUpdated = 'JOBSPEC_UPDATED',
  MembershipBillIssued = 'MEMBERSHIP_BILL_ISSUED',
  MembershipLapsed = 'MEMBERSHIP_LAPSED',
  MembershipPaid = 'MEMBERSHIP_PAID',
  MembershipPlanSet = 'MEMBERSHIP_PLAN_SET',
  MembershipReminderSent = 'MEMBERSHIP_REMINDER_SENT',
  MemberJoined = 'MEMBER_JOINED',
  MemberUpdated = 'MEMBER_UPDATED',
  Mentioned = 'MENTIONED',
  NoteAdded = 'NOTE_ADDED',
  NotificationRuleRemoved = 'NOTIFICATION_RULE_REMOVED',
  NotificationRuleSet = 'NOTIFICATION_RULE_SET',
  OrganisationCreated = 'ORGANISATION_CREATED',
  OrganisationUpdated = 'ORGANISATION_UPDATED',
  ParticipationSet = 'PARTICIPATION_SET',
  ProofReviewed = 'PROOF_REVIEWED',
  ProofSubmitted = 'PROOF_SUBMITTED',
  ProposalClosed = 'PROPOSAL_CLOSED',
  ProposalCreated = 'PROPOSAL_CREATED',
  ProposalOpened = 'PROPOSAL_OPENED',
  ProposalReput = 'PROPOSAL_REPUT',
  TokensGranted = 'TOKENS_GRANTED',
  TreasuryAccountAdded = 'TREASURY_ACCOUNT_ADDED',
  TreasuryBalanceRestated = 'TREASURY_BALANCE_RESTATED',
  TreasuryMoved = 'TREASURY_MOVED',
  VoteCast = 'VOTE_CAST',
  VoteChanged = 'VOTE_CHANGED',
  WorkCancelled = 'WORK_CANCELLED',
  WorkClaimed = 'WORK_CLAIMED',
  WorkCreated = 'WORK_CREATED',
  WorkReleased = 'WORK_RELEASED'
}

export type GovActivityPage = {
  __typename?: 'GovActivityPage';
  cap: Scalars['Int']['output'];
  rows: Array<GovActivity>;
  total: Scalars['Int']['output'];
};

/** Where a membership application sits */
export enum GovApplicationStatus {
  Accepted = 'ACCEPTED',
  Declined = 'DECLINED',
  Pending = 'PENDING',
  Ready = 'READY',
  Withdrawn = 'WITHDRAWN'
}

/** Where the balance figure came from */
export enum GovBalanceSource {
  Basiq = 'BASIQ',
  Chain = 'CHAIN',
  Manual = 'MANUAL'
}

export type GovBriefTranscript = {
  __typename?: 'GovBriefTranscript';
  model?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  text: Scalars['String']['output'];
};

export type GovChangedSection = {
  __typename?: 'GovChangedSection';
  added: Scalars['Int']['output'];
  heading: Scalars['String']['output'];
  removed: Scalars['Int']['output'];
};

export type GovChecklist = {
  __typename?: 'GovChecklist';
  copiedFromChecklistId?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdById?: Maybe<Scalars['ID']['output']>;
  createdByName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isTemplate: Scalars['Boolean']['output'];
  lastActivityAt: Scalars['DateTime']['output'];
  organisationId: Scalars['ID']['output'];
  subjectId?: Maybe<Scalars['ID']['output']>;
  subjectType?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  visibility: GovChecklistVisibility;
};

export type GovChecklistItem = {
  __typename?: 'GovChecklistItem';
  checklistId: Scalars['ID']['output'];
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  completedById?: Maybe<Scalars['ID']['output']>;
  completedByName?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  done: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** Who can see a checklist */
export enum GovChecklistVisibility {
  Hidden = 'HIDDEN',
  Private = 'PRIVATE',
  Published = 'PUBLISHED'
}

export type GovChoiceTally = {
  __typename?: 'GovChoiceTally';
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  percentOfCast: Scalars['Float']['output'];
  votes: Scalars['Int']['output'];
  weight: Scalars['Float']['output'];
};

/** Whether a claim on a work item is still live */
export enum GovClaimStatus {
  Active = 'ACTIVE',
  Completed = 'COMPLETED',
  Released = 'RELEASED'
}

export type GovDecision = {
  __typename?: 'GovDecision';
  createdAt: Scalars['DateTime']['output'];
  decidedAt: Scalars['DateTime']['output'];
  executionNote?: Maybe<Scalars['String']['output']>;
  executionTxHash?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  organisationId: Scalars['ID']['output'];
  outcome: GovProposalStatus;
  proposalId: Scalars['ID']['output'];
  sopEpisodeId?: Maybe<Scalars['ID']['output']>;
  tallyJson?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  title: Scalars['String']['output'];
  totalVotesCast: Scalars['Int']['output'];
  totalWeightCast: Scalars['Float']['output'];
  updatedAt: Scalars['DateTime']['output'];
  winningChoiceKey?: Maybe<Scalars['String']['output']>;
};

export type GovDelegationCount = {
  __typename?: 'GovDelegationCount';
  count: Scalars['Int']['output'];
  memberId: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type GovDelegationSnapshot = {
  __typename?: 'GovDelegationSnapshot';
  fromMemberId: Scalars['ID']['output'];
  toMemberId: Scalars['ID']['output'];
};

export type GovDiffHunk = {
  __typename?: 'GovDiffHunk';
  fromStart: Scalars['Int']['output'];
  lines: Array<GovDiffLine>;
  toStart: Scalars['Int']['output'];
};

export type GovDiffLine = {
  __typename?: 'GovDiffLine';
  fromLine?: Maybe<Scalars['Int']['output']>;
  kind: Scalars['String']['output'];
  text: Scalars['String']['output'];
  toLine?: Maybe<Scalars['Int']['output']>;
};

/** How often a person gets the written report of what happened */
export enum GovDigestFrequency {
  Fortnightly = 'FORTNIGHTLY',
  None = 'NONE',
  Weekly = 'WEEKLY'
}

export type GovDigestRunResult = {
  __typename?: 'GovDigestRunResult';
  candidates: Scalars['Int']['output'];
  dryRun: Scalars['Boolean']['output'];
  failed: Scalars['Int']['output'];
  sent: Scalars['Int']['output'];
  skipped: Scalars['Int']['output'];
  summary: Scalars['String']['output'];
};

export type GovEntryMember = {
  __typename?: 'GovEntryMember';
  delegationsHeld: Scalars['Int']['output'];
  memberId: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  role: Scalars['String']['output'];
};

export type GovFile = {
  __typename?: 'GovFile';
  cid: Scalars['String']['output'];
  fileId?: Maybe<Scalars['String']['output']>;
  fileName?: Maybe<Scalars['String']['output']>;
  mimeType?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['Float']['output']>;
  uploadedAt?: Maybe<Scalars['DateTime']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type GovFileInput = {
  cid: Scalars['String']['input'];
  fileName?: InputMaybe<Scalars['String']['input']>;
  mimeType?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
};

export type GovInvite = {
  __typename?: 'GovInvite';
  applicationId?: Maybe<Scalars['ID']['output']>;
  clientId?: Maybe<Scalars['ID']['output']>;
  countsAsSponsorship: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  customMessage?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  emailSentAt?: Maybe<Scalars['DateTime']['output']>;
  expiresAt: Scalars['DateTime']['output'];
  fName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  invitedByClientId?: Maybe<Scalars['ID']['output']>;
  invitedByMemberId?: Maybe<Scalars['ID']['output']>;
  invitedByName?: Maybe<Scalars['String']['output']>;
  joinedAt?: Maybe<Scalars['DateTime']['output']>;
  lName?: Maybe<Scalars['String']['output']>;
  memberId?: Maybe<Scalars['ID']['output']>;
  organisationId: Scalars['ID']['output'];
  phoneNumber?: Maybe<Scalars['String']['output']>;
  respondedAt?: Maybe<Scalars['DateTime']['output']>;
  sendError?: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  status: GovInviteStatus;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  viewedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type GovInviteAcceptResult = {
  __typename?: 'GovInviteAcceptResult';
  applicationId?: Maybe<Scalars['ID']['output']>;
  message: Scalars['String']['output'];
  ok: Scalars['Boolean']['output'];
  sponsorsStillNeeded: Scalars['Float']['output'];
};

export type GovInviteGraphNode = {
  __typename?: 'GovInviteGraphNode';
  id: Scalars['ID']['output'];
  invitedByMemberId?: Maybe<Scalars['ID']['output']>;
  invitedByName?: Maybe<Scalars['String']['output']>;
  joinedAt?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  status: GovInviteStatus;
};

/** Where an invitation to join an organisation has got to */
export enum GovInviteStatus {
  Applied = 'APPLIED',
  Declined = 'DECLINED',
  Expired = 'EXPIRED',
  Joined = 'JOINED',
  Pending = 'PENDING',
  Revoked = 'REVOKED',
  Viewed = 'VIEWED'
}

export type GovJobSpec = {
  __typename?: 'GovJobSpec';
  adoptedAt?: Maybe<Scalars['DateTime']['output']>;
  adoptedById?: Maybe<Scalars['ID']['output']>;
  adoptedByProposalId?: Maybe<Scalars['ID']['output']>;
  authoredByMemberId?: Maybe<Scalars['ID']['output']>;
  authoredByName?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  doneLooksLike?: Maybe<Scalars['String']['output']>;
  estimatedHours?: Maybe<Scalars['Float']['output']>;
  evidenceRequired?: Maybe<Scalars['String']['output']>;
  familyId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  organisationId: Scalars['ID']['output'];
  priceTokens: Scalars['Float']['output'];
  publicListed: Scalars['Boolean']['output'];
  retiredAt?: Maybe<Scalars['DateTime']['output']>;
  sopEpisodeId?: Maybe<Scalars['ID']['output']>;
  status: GovJobSpecStatus;
  steps?: Maybe<Scalars['String']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
  supersedesId?: Maybe<Scalars['ID']['output']>;
  tenantId: Scalars['String']['output'];
  timesStarted: Scalars['Int']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  version: Scalars['Int']['output'];
};

/** How a job specification gets adopted by an organisation */
export enum GovJobSpecAdoption {
  Admin = 'ADMIN',
  Vote = 'VOTE'
}

/** Where a job specification sits between drafted and adopted */
export enum GovJobSpecStatus {
  Adopted = 'ADOPTED',
  Draft = 'DRAFT',
  Proposed = 'PROPOSED',
  Retired = 'RETIRED'
}

export type GovJoinOptions = {
  __typename?: 'GovJoinOptions';
  admitsWithoutApproval: Scalars['Boolean']['output'];
  plans: Array<GovMembershipPlan>;
  requireAbn: Scalars['Boolean']['output'];
  requireBusinessName: Scalars['Boolean']['output'];
  requirePhone: Scalars['Boolean']['output'];
};

/** The legal entity the organisation operates through, if any */
export enum GovLegalWrapper {
  Company = 'COMPANY',
  IncAssocQld = 'INC_ASSOC_QLD',
  None = 'NONE',
  Other = 'OTHER',
  Trust = 'TRUST'
}

/** How much of a motion a forwarded link shows someone who is not in the group */
export enum GovLinkTeaserLevel {
  Full = 'FULL',
  None = 'NONE',
  Teaser = 'TEASER'
}

export type GovListCaps = {
  __typename?: 'GovListCaps';
  decisions: Scalars['Int']['output'];
  proposals: Scalars['Int']['output'];
};

export type GovMember = {
  __typename?: 'GovMember';
  abn?: Maybe<Scalars['String']['output']>;
  businessName?: Maybe<Scalars['String']['output']>;
  clientId: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  displayName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  joinedAt: Scalars['DateTime']['output'];
  openMembershipBillId?: Maybe<Scalars['ID']['output']>;
  organisationId: Scalars['ID']['output'];
  paidThrough?: Maybe<Scalars['DateTime']['output']>;
  planId?: Maybe<Scalars['ID']['output']>;
  role: GovMemberRole;
  sponsoredByMemberId?: Maybe<Scalars['ID']['output']>;
  status: GovMemberStatus;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  votingWeight: Scalars['Float']['output'];
  walletAddress?: Maybe<Scalars['String']['output']>;
};

/** A member's role in the organisation. Not an app permission. */
export enum GovMemberRole {
  Committee = 'COMMITTEE',
  Member = 'MEMBER',
  President = 'PRESIDENT',
  Secretary = 'SECRETARY',
  Treasurer = 'TREASURER'
}

/** Whether a member currently counts toward quorum and may vote */
export enum GovMemberStatus {
  Active = 'ACTIVE',
  Resigned = 'RESIGNED',
  Suspended = 'SUSPENDED'
}

export type GovMembershipApplication = {
  __typename?: 'GovMembershipApplication';
  abn?: Maybe<Scalars['String']['output']>;
  applicantEmail?: Maybe<Scalars['String']['output']>;
  applicantName: Scalars['String']['output'];
  billId?: Maybe<Scalars['ID']['output']>;
  billProblem?: Maybe<Scalars['String']['output']>;
  businessName?: Maybe<Scalars['String']['output']>;
  clientId?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['DateTime']['output'];
  decidedAt?: Maybe<Scalars['DateTime']['output']>;
  decidedById?: Maybe<Scalars['ID']['output']>;
  decisionNote?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  memberId?: Maybe<Scalars['ID']['output']>;
  organisationId: Scalars['ID']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  planId?: Maybe<Scalars['ID']['output']>;
  sponsorMemberIds: Array<Scalars['String']['output']>;
  sponsorsRequired: Scalars['Int']['output'];
  statement?: Maybe<Scalars['String']['output']>;
  status: GovApplicationStatus;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type GovMembershipBatchResult = {
  __typename?: 'GovMembershipBatchResult';
  failed: Scalars['Int']['output'];
  outcomes: Array<GovMembershipOutcome>;
  skipped: Scalars['Int']['output'];
  succeeded: Scalars['Int']['output'];
};

export type GovMembershipCounts = {
  __typename?: 'GovMembershipCounts';
  active: Scalars['Int']['output'];
  dueSoon: Scalars['Int']['output'];
  lapsed: Scalars['Int']['output'];
  overdue: Scalars['Int']['output'];
  pendingPayment: Scalars['Int']['output'];
  resigned: Scalars['Int']['output'];
  suspended: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type GovMembershipOutcome = {
  __typename?: 'GovMembershipOutcome';
  amount?: Maybe<Scalars['Float']['output']>;
  billId?: Maybe<Scalars['ID']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  memberId: Scalars['ID']['output'];
  message?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  outcome: Scalars['String']['output'];
};

export type GovMembershipPlan = {
  __typename?: 'GovMembershipPlan';
  active: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  gstInclusive: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  interval: GovPlanInterval;
  name: Scalars['String']['output'];
  organisationId: Scalars['ID']['output'];
  priceCents: Scalars['Int']['output'];
  sortOrder: Scalars['Int']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type GovMembershipRegister = {
  __typename?: 'GovMembershipRegister';
  canOpenBills: Scalars['Boolean']['output'];
  counts: GovMembershipCounts;
  graceDays: Scalars['Int']['output'];
  lapsesNotified: Scalars['Int']['output'];
  paymentsApplied: Scalars['Int']['output'];
  rows: Array<GovMembershipRegisterRow>;
  timezone: Scalars['String']['output'];
  today: Scalars['String']['output'];
};

export type GovMembershipRegisterRow = {
  __typename?: 'GovMembershipRegisterRow';
  abn?: Maybe<Scalars['String']['output']>;
  businessName?: Maybe<Scalars['String']['output']>;
  clientId: Scalars['ID']['output'];
  daysToRenewal?: Maybe<Scalars['Int']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  graceEndsOn?: Maybe<Scalars['String']['output']>;
  joinedAt: Scalars['DateTime']['output'];
  memberId: Scalars['ID']['output'];
  membershipStatus: GovMembershipStatus;
  name: Scalars['String']['output'];
  openBillAmount?: Maybe<Scalars['Float']['output']>;
  openBillId?: Maybe<Scalars['ID']['output']>;
  openBillOverdue: Scalars['Boolean']['output'];
  paidThrough?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  planId?: Maybe<Scalars['ID']['output']>;
  planInterval?: Maybe<GovPlanInterval>;
  planName?: Maybe<Scalars['String']['output']>;
  renewal: GovRenewalState;
  role: Scalars['String']['output'];
  rollStatus: Scalars['String']['output'];
};

/** Whether a member is paid up — derived from paidThrough, never stored */
export enum GovMembershipStatus {
  Active = 'ACTIVE',
  Lapsed = 'LAPSED',
  PendingPayment = 'PENDING_PAYMENT',
  Resigned = 'RESIGNED',
  Suspended = 'SUSPENDED'
}

export type GovMention = {
  __typename?: 'GovMention';
  clientId: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  notifiedAt?: Maybe<Scalars['DateTime']['output']>;
  notifiedEmail?: Maybe<Scalars['Boolean']['output']>;
  notifiedSms?: Maybe<Scalars['Boolean']['output']>;
  source: GovMentionSource;
};

export type GovMentionInput = {
  clientId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  source: GovMentionSource;
};

export type GovMentionNotifyChoiceInput = {
  clientId: Scalars['ID']['input'];
  email: Scalars['Boolean']['input'];
  sms: Scalars['Boolean']['input'];
};

export type GovMentionNotifyResult = {
  __typename?: 'GovMentionNotifyResult';
  rows: Array<GovMentionNotifyRow>;
  summary?: Maybe<Scalars['String']['output']>;
};

export type GovMentionNotifyRow = {
  __typename?: 'GovMentionNotifyRow';
  clientId: Scalars['ID']['output'];
  emailSent: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  overrodePreference: Scalars['Boolean']['output'];
  problem?: Maybe<Scalars['String']['output']>;
  smsSent: Scalars['Boolean']['output'];
};

/** Where a tagged person was found — and therefore what they can see */
export enum GovMentionSource {
  Client = 'CLIENT',
  Employee = 'EMPLOYEE',
  Member = 'MEMBER'
}

export type GovMentionablePerson = {
  __typename?: 'GovMentionablePerson';
  clientId: Scalars['ID']['output'];
  hasEmail: Scalars['Boolean']['output'];
  hasPhone: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  roleLabel?: Maybe<Scalars['String']['output']>;
  source: GovMentionSource;
};

/** Money in or out */
export enum GovMovementDirection {
  In = 'IN',
  Out = 'OUT'
}

export type GovMyMembershipStanding = {
  __typename?: 'GovMyMembershipStanding';
  daysToRenewal?: Maybe<Scalars['Int']['output']>;
  graceEndsOn?: Maybe<Scalars['String']['output']>;
  isMember: Scalars['Boolean']['output'];
  membershipStatus?: Maybe<GovMembershipStatus>;
  openBillAmount?: Maybe<Scalars['Float']['output']>;
  openBillId?: Maybe<Scalars['ID']['output']>;
  paidThrough?: Maybe<Scalars['String']['output']>;
  planInterval?: Maybe<GovPlanInterval>;
  planName?: Maybe<Scalars['String']['output']>;
  planPriceCents?: Maybe<Scalars['Int']['output']>;
  renewal?: Maybe<GovRenewalState>;
  today: Scalars['String']['output'];
};

/** How the message is delivered. IN_APP is deprecated and delivers nothing. */
export enum GovNotificationChannel {
  Email = 'EMAIL',
  InApp = 'IN_APP',
  Sms = 'SMS'
}

/** Who a rule reaches */
export enum GovNotificationRecipientType {
  AllMembers = 'ALL_MEMBERS',
  Committee = 'COMMITTEE',
  Followers = 'FOLLOWERS',
  MembersYetToVote = 'MEMBERS_YET_TO_VOTE',
  Specific = 'SPECIFIC',
  Subject = 'SUBJECT'
}

export type GovNotificationRule = {
  __typename?: 'GovNotificationRule';
  channels: Array<GovNotificationChannel>;
  createdAt: Scalars['DateTime']['output'];
  customMessage?: Maybe<Scalars['String']['output']>;
  hoursBefore?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  lastFiredAt?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  organisationId: Scalars['ID']['output'];
  recipientEmails: Array<Scalars['String']['output']>;
  recipientType: GovNotificationRecipientType;
  tenantId: Scalars['String']['output'];
  timesFired: Scalars['Int']['output'];
  trigger: GovNotificationTrigger;
  updatedAt: Scalars['DateTime']['output'];
};

export type GovNotificationScheduleRow = {
  __typename?: 'GovNotificationScheduleRow';
  description: Scalars['String']['output'];
  email: Scalars['Boolean']['output'];
  field: Scalars['String']['output'];
  frequencyLabel: Scalars['String']['output'];
  kind: Scalars['String']['output'];
  label: Scalars['String']['output'];
  on: Scalars['Boolean']['output'];
  orgOff: Scalars['Boolean']['output'];
  sms: Scalars['Boolean']['output'];
};

/** What happened that might be worth telling someone about */
export enum GovNotificationTrigger {
  ApplicationDecided = 'APPLICATION_DECIDED',
  ApplicationSubmitted = 'APPLICATION_SUBMITTED',
  MembershipBillIssued = 'MEMBERSHIP_BILL_ISSUED',
  MembershipLapsed = 'MEMBERSHIP_LAPSED',
  MembershipPaymentReceived = 'MEMBERSHIP_PAYMENT_RECEIVED',
  MemberJoined = 'MEMBER_JOINED',
  ProofReviewed = 'PROOF_REVIEWED',
  ProofSubmitted = 'PROOF_SUBMITTED',
  ProposalClosed = 'PROPOSAL_CLOSED',
  ProposalOpened = 'PROPOSAL_OPENED',
  TokensGranted = 'TOKENS_GRANTED',
  TreasuryMoved = 'TREASURY_MOVED',
  VoteClosingSoon = 'VOTE_CLOSING_SOON',
  WorkOpened = 'WORK_OPENED'
}

export type GovOrganisation = {
  __typename?: 'GovOrganisation';
  admitWithoutApproval: Scalars['Boolean']['output'];
  chainId?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['DateTime']['output'];
  defaultPassThresholdPercent: Scalars['Int']['output'];
  defaultQuorumPercent: Scalars['Int']['output'];
  defaultVotingHours: Scalars['Int']['output'];
  digestDayOfWeek: Scalars['Int']['output'];
  draftModel?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  jobSpecAdoption: GovJobSpecAdoption;
  joinRequireAbn: Scalars['Boolean']['output'];
  joinRequireBusinessName: Scalars['Boolean']['output'];
  joinRequirePhone: Scalars['Boolean']['output'];
  legalWrapper: GovLegalWrapper;
  linkTeaserLevel?: Maybe<GovLinkTeaserLevel>;
  linkTeasersEnabled: Scalars['Boolean']['output'];
  membershipGraceDays?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  participationDefaults?: Maybe<GovParticipationDefaults>;
  publicMemberList: Scalars['Boolean']['output'];
  publicPageEnabled: Scalars['Boolean']['output'];
  publicProof: Scalars['Boolean']['output'];
  purpose?: Maybe<Scalars['String']['output']>;
  registrationNumber?: Maybe<Scalars['String']['output']>;
  requireSignedBallots: Scalars['Boolean']['output'];
  rulesMarkdown?: Maybe<Scalars['String']['output']>;
  rulesVersion?: Maybe<Scalars['Int']['output']>;
  safeAddress?: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  snapshotSpaceEns?: Maybe<Scalars['String']['output']>;
  sponsorsRequired: Scalars['Int']['output'];
  status: GovOrganisationStatus;
  tenantId: Scalars['String']['output'];
  timezone?: Maybe<Scalars['String']['output']>;
  tokenJourneyMarkdown?: Maybe<Scalars['String']['output']>;
  tokenKind: GovTokenKind;
  tokenSymbol?: Maybe<Scalars['String']['output']>;
  treasuryPolicyMarkdown?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type GovOrganisationDeleteCheck = {
  __typename?: 'GovOrganisationDeleteCheck';
  blockers: Array<Scalars['String']['output']>;
  deletable: Scalars['Boolean']['output'];
  removes: Array<Scalars['String']['output']>;
};

export type GovOrganisationEntry = {
  __typename?: 'GovOrganisationEntry';
  access: GovAccessInfo;
  id: Scalars['ID']['output'];
  legalWrapper: Scalars['String']['output'];
  memberCount: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  openProposalCount: Scalars['Int']['output'];
  purpose?: Maybe<Scalars['String']['output']>;
  roster: Array<GovEntryMember>;
  rulesChangedAt?: Maybe<Scalars['DateTime']['output']>;
  rulesMarkdown?: Maybe<Scalars['String']['output']>;
  rulesVersion?: Maybe<Scalars['Int']['output']>;
  slug: Scalars['String']['output'];
  sponsorsRequired: Scalars['Int']['output'];
  timezone: Scalars['String']['output'];
};

export type GovOrganisationRevision = {
  __typename?: 'GovOrganisationRevision';
  changeNote?: Maybe<Scalars['String']['output']>;
  changedById?: Maybe<Scalars['ID']['output']>;
  changedByName?: Maybe<Scalars['String']['output']>;
  changedFields: Array<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  isStartingPoint: Scalars['Boolean']['output'];
  organisationId: Scalars['ID']['output'];
  snapshot: GovRuleSnapshot;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  version: Scalars['Int']['output'];
};

/** Lifecycle of an organisation */
export enum GovOrganisationStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
  Draft = 'DRAFT'
}

export type GovParticipation = {
  __typename?: 'GovParticipation';
  adminOverrodeAt?: Maybe<Scalars['DateTime']['output']>;
  clientId: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  delegateMemberId?: Maybe<Scalars['ID']['output']>;
  delegatedAt?: Maybe<Scalars['DateTime']['output']>;
  digestFrequency: GovDigestFrequency;
  displayName?: Maybe<Scalars['String']['output']>;
  emailEnabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  lastDigestSentAt?: Maybe<Scalars['DateTime']['output']>;
  lastUpdatedBySelf: Scalars['Boolean']['output'];
  level: GovParticipationLevel;
  notifyOnClosingSoon: Scalars['Boolean']['output'];
  notifyOnDelegateVoted: Scalars['Boolean']['output'];
  notifyOnMemberJoined: Scalars['Boolean']['output'];
  notifyOnProposalClosed: Scalars['Boolean']['output'];
  notifyOnProposalOpened: Scalars['Boolean']['output'];
  notifyOnWorkOpened: Scalars['Boolean']['output'];
  organisationId: Scalars['ID']['output'];
  selfSetAt?: Maybe<Scalars['DateTime']['output']>;
  selfSetSnapshot?: Maybe<Scalars['String']['output']>;
  smsEnabled: Scalars['Boolean']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type GovParticipationDefaults = {
  __typename?: 'GovParticipationDefaults';
  digestFrequency: GovDigestFrequency;
  emailEnabled: Scalars['Boolean']['output'];
  notifyOnClosingSoon: Scalars['Boolean']['output'];
  notifyOnDelegateVoted: Scalars['Boolean']['output'];
  notifyOnMemberJoined: Scalars['Boolean']['output'];
  notifyOnProposalClosed: Scalars['Boolean']['output'];
  notifyOnProposalOpened: Scalars['Boolean']['output'];
  notifyOnWorkOpened: Scalars['Boolean']['output'];
  smsEnabled: Scalars['Boolean']['output'];
};

export type GovParticipationDefaultsInput = {
  digestFrequency?: InputMaybe<GovDigestFrequency>;
  emailEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  notifyOnClosingSoon?: InputMaybe<Scalars['Boolean']['input']>;
  notifyOnDelegateVoted?: InputMaybe<Scalars['Boolean']['input']>;
  notifyOnMemberJoined?: InputMaybe<Scalars['Boolean']['input']>;
  notifyOnProposalClosed?: InputMaybe<Scalars['Boolean']['input']>;
  notifyOnProposalOpened?: InputMaybe<Scalars['Boolean']['input']>;
  notifyOnWorkOpened?: InputMaybe<Scalars['Boolean']['input']>;
  smsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

/** How a person takes part in one organisation */
export enum GovParticipationLevel {
  Delegate = 'DELEGATE',
  Follow = 'FOLLOW',
  Vote = 'VOTE'
}

/** How long one payment on a membership plan lasts */
export enum GovPlanInterval {
  Month = 'MONTH',
  Year = 'YEAR'
}

export type GovProofFile = {
  __typename?: 'GovProofFile';
  cid: Scalars['String']['output'];
  fileName?: Maybe<Scalars['String']['output']>;
  mimeType?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['Float']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type GovProofFileInput = {
  cid: Scalars['String']['input'];
  fileName?: InputMaybe<Scalars['String']['input']>;
  mimeType?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
};

/** Whether submitted proof has been reviewed */
export enum GovProofStatus {
  Accepted = 'ACCEPTED',
  Rejected = 'REJECTED',
  Submitted = 'SUBMITTED'
}

export type GovProposal = {
  __typename?: 'GovProposal';
  amount?: Maybe<Scalars['Float']['output']>;
  amountUnit?: Maybe<Scalars['String']['output']>;
  attachments?: Maybe<Array<GovFile>>;
  body?: Maybe<Scalars['String']['output']>;
  choices: Array<GovProposalChoice>;
  citedActivityIds?: Maybe<Array<Scalars['String']['output']>>;
  closedAt?: Maybe<Scalars['DateTime']['output']>;
  closesAt?: Maybe<Scalars['DateTime']['output']>;
  closingSoonFiredRuleIds: Array<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  delegationsAtOpen: Array<GovDelegationSnapshot>;
  eligibleCountAtOpen: Scalars['Int']['output'];
  eligibleWeightAtOpen: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  jobSpecId?: Maybe<Scalars['ID']['output']>;
  opensAt?: Maybe<Scalars['DateTime']['output']>;
  organisationId: Scalars['ID']['output'];
  passThresholdPercent: Scalars['Int']['output'];
  proposedByMemberId?: Maybe<Scalars['ID']['output']>;
  proposedByName?: Maybe<Scalars['String']['output']>;
  quorumPercent: Scalars['Int']['output'];
  snapshotProposalId?: Maybe<Scalars['String']['output']>;
  sopEpisodeId?: Maybe<Scalars['ID']['output']>;
  status: GovProposalStatus;
  supersededByProposalId?: Maybe<Scalars['ID']['output']>;
  supersedesProposalId?: Maybe<Scalars['ID']['output']>;
  tenantId: Scalars['String']['output'];
  title: Scalars['String']['output'];
  type: GovProposalType;
  updatedAt: Scalars['DateTime']['output'];
  votingSystem: GovVotingSystem;
};

export type GovProposalChoice = {
  __typename?: 'GovProposalChoice';
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

export type GovProposalChoiceInput = {
  key: Scalars['String']['input'];
  label: Scalars['String']['input'];
};

export type GovProposalDraftChoice = {
  __typename?: 'GovProposalDraftChoice';
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

export type GovProposalDraftResult = {
  __typename?: 'GovProposalDraftResult';
  amount?: Maybe<Scalars['Float']['output']>;
  bodyMarkdown: Scalars['String']['output'];
  choices: Array<GovProposalDraftChoice>;
  decisionStatement: Scalars['String']['output'];
  model: Scalars['String']['output'];
  openQuestions: Array<Scalars['String']['output']>;
  suggestedType: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type GovProposalRevision = {
  __typename?: 'GovProposalRevision';
  attachments?: Maybe<Array<GovFile>>;
  body?: Maybe<Scalars['String']['output']>;
  changeNote?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  editedById?: Maybe<Scalars['ID']['output']>;
  editedByName?: Maybe<Scalars['String']['output']>;
  editedDuringVoting: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  organisationId: Scalars['ID']['output'];
  proposalId: Scalars['ID']['output'];
  proposalStatusAtEdit: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  version: Scalars['Int']['output'];
  votesCastBefore: Scalars['Int']['output'];
};

/** Where a proposal sits */
export enum GovProposalStatus {
  Cancelled = 'CANCELLED',
  Draft = 'DRAFT',
  Open = 'OPEN',
  Passed = 'PASSED',
  QuorumNotMet = 'QUORUM_NOT_MET',
  Rejected = 'REJECTED'
}

/** What kind of decision this proposal makes */
export enum GovProposalType {
  AdoptJobSpec = 'ADOPT_JOB_SPEC',
  Membership = 'MEMBERSHIP',
  Resolution = 'RESOLUTION',
  RuleChange = 'RULE_CHANGE',
  TokenGrant = 'TOKEN_GRANT',
  Treasury = 'TREASURY'
}

/** Where a member's renewal stands */
export enum GovRenewalState {
  Current = 'CURRENT',
  DueSoon = 'DUE_SOON',
  Lapsed = 'LAPSED',
  NotApplicable = 'NOT_APPLICABLE',
  NotPaidYet = 'NOT_PAID_YET',
  NoFee = 'NO_FEE',
  Overdue = 'OVERDUE'
}

export type GovRuleSnapshot = {
  __typename?: 'GovRuleSnapshot';
  defaultPassThresholdPercent: Scalars['Int']['output'];
  defaultQuorumPercent: Scalars['Int']['output'];
  defaultVotingHours: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  purpose?: Maybe<Scalars['String']['output']>;
  rulesMarkdown?: Maybe<Scalars['String']['output']>;
  sponsorsRequired: Scalars['Int']['output'];
  tokenSymbol?: Maybe<Scalars['String']['output']>;
};

export type GovRulesDiff = {
  __typename?: 'GovRulesDiff';
  added: Scalars['Int']['output'];
  changedSections: Array<GovChangedSection>;
  fieldChanges: Array<Scalars['String']['output']>;
  fromVersion?: Maybe<Scalars['Int']['output']>;
  hunks: Array<GovDiffHunk>;
  identical: Scalars['Boolean']['output'];
  removed: Scalars['Int']['output'];
  toVersion?: Maybe<Scalars['Int']['output']>;
};

export type GovRulesDraftInput = {
  defaultPassThresholdPercent?: InputMaybe<Scalars['Float']['input']>;
  defaultQuorumPercent?: InputMaybe<Scalars['Float']['input']>;
  defaultVotingHours?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  purpose?: InputMaybe<Scalars['String']['input']>;
  rulesMarkdown?: InputMaybe<Scalars['String']['input']>;
  sponsorsRequired?: InputMaybe<Scalars['Float']['input']>;
  tokenSymbol?: InputMaybe<Scalars['String']['input']>;
};

export type GovTallyResult = {
  __typename?: 'GovTallyResult';
  choices: Array<GovChoiceTally>;
  leadingChoiceKey?: Maybe<Scalars['String']['output']>;
  provisional: Scalars['Boolean']['output'];
  provisionalOutcome: GovProposalStatus;
  quorumMet: Scalars['Boolean']['output'];
  tied: Scalars['Boolean']['output'];
  totalVotesCast: Scalars['Int']['output'];
  totalWeightCast: Scalars['Float']['output'];
  turnoutPercent: Scalars['Float']['output'];
};

export type GovTokenGrant = {
  __typename?: 'GovTokenGrant';
  amount: Scalars['Float']['output'];
  createdAt: Scalars['DateTime']['output'];
  decisionId?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  issuedById?: Maybe<Scalars['ID']['output']>;
  memberId: Scalars['ID']['output'];
  memberName?: Maybe<Scalars['String']['output']>;
  organisationId: Scalars['ID']['output'];
  proofId?: Maybe<Scalars['ID']['output']>;
  reason: Scalars['String']['output'];
  rewardTokenId?: Maybe<Scalars['ID']['output']>;
  tenantId: Scalars['String']['output'];
  txHash?: Maybe<Scalars['String']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  workItemId?: Maybe<Scalars['ID']['output']>;
};

/** What an organisation's token represents */
export enum GovTokenKind {
  Crypto = 'CRYPTO',
  Fiat = 'FIAT',
  Points = 'POINTS'
}

export type GovTreasuryAccount = {
  __typename?: 'GovTreasuryAccount';
  balance: Scalars['Float']['output'];
  balanceAsAt?: Maybe<Scalars['DateTime']['output']>;
  balanceSource: GovBalanceSource;
  createdAt: Scalars['DateTime']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  identifier?: Maybe<Scalars['String']['output']>;
  isActive: Scalars['Boolean']['output'];
  kind: GovAccountKind;
  label: Scalars['String']['output'];
  organisationId: Scalars['ID']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type GovTreasuryMovement = {
  __typename?: 'GovTreasuryMovement';
  accountId: Scalars['ID']['output'];
  amount: Scalars['Float']['output'];
  createdAt: Scalars['DateTime']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  decisionId?: Maybe<Scalars['ID']['output']>;
  description: Scalars['String']['output'];
  direction: GovMovementDirection;
  id: Scalars['ID']['output'];
  memberId?: Maybe<Scalars['ID']['output']>;
  occurredAt: Scalars['DateTime']['output'];
  organisationId: Scalars['ID']['output'];
  recordedById?: Maybe<Scalars['ID']['output']>;
  tenantId: Scalars['String']['output'];
  txHash?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  workItemId?: Maybe<Scalars['ID']['output']>;
};

export type GovVote = {
  __typename?: 'GovVote';
  castAt: Scalars['DateTime']['output'];
  castByMemberId?: Maybe<Scalars['ID']['output']>;
  choiceKeys: Array<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  memberId: Scalars['ID']['output'];
  memberName?: Maybe<Scalars['String']['output']>;
  organisationId: Scalars['ID']['output'];
  proposalId: Scalars['ID']['output'];
  reason?: Maybe<Scalars['String']['output']>;
  signature?: Maybe<Scalars['String']['output']>;
  signedStatementJson?: Maybe<Scalars['String']['output']>;
  signerAddress?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  viaDelegation: Scalars['Boolean']['output'];
  weight: Scalars['Float']['output'];
};

export type GovVoteReminderSweepResult = {
  __typename?: 'GovVoteReminderSweepResult';
  failed: Scalars['Int']['output'];
  proposalsChecked: Scalars['Int']['output'];
  remindersFired: Scalars['Int']['output'];
  sent: Scalars['Int']['output'];
  summary: Scalars['String']['output'];
};

/** How votes are cast and counted */
export enum GovVotingSystem {
  Approval = 'APPROVAL',
  SingleChoice = 'SINGLE_CHOICE'
}

export type GovWorkClaim = {
  __typename?: 'GovWorkClaim';
  claimedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  memberId: Scalars['ID']['output'];
  memberName?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  organisationId: Scalars['ID']['output'];
  releasedAt?: Maybe<Scalars['DateTime']['output']>;
  status: GovClaimStatus;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  workItemId: Scalars['ID']['output'];
};

export type GovWorkItem = {
  __typename?: 'GovWorkItem';
  brief?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdByMemberId?: Maybe<Scalars['ID']['output']>;
  decisionId?: Maybe<Scalars['ID']['output']>;
  dueDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  jobSpecId?: Maybe<Scalars['ID']['output']>;
  jobSpecVersion?: Maybe<Scalars['Int']['output']>;
  maxClaimants: Scalars['Int']['output'];
  organisationId: Scalars['ID']['output'];
  proposalId?: Maybe<Scalars['ID']['output']>;
  rewardAmount: Scalars['Float']['output'];
  rewardUnit?: Maybe<Scalars['String']['output']>;
  status: GovWorkStatus;
  tenantId: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type GovWorkProof = {
  __typename?: 'GovWorkProof';
  createdAt: Scalars['DateTime']['output'];
  files: Array<GovProofFile>;
  id: Scalars['ID']['output'];
  memberId: Scalars['ID']['output'];
  memberName?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  organisationId: Scalars['ID']['output'];
  reportedAtEpisodeId?: Maybe<Scalars['ID']['output']>;
  reviewNote?: Maybe<Scalars['String']['output']>;
  reviewedAt?: Maybe<Scalars['DateTime']['output']>;
  reviewedById?: Maybe<Scalars['ID']['output']>;
  status: GovProofStatus;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  workItemId: Scalars['ID']['output'];
};

/** Where a body of work sits, from open to paid */
export enum GovWorkStatus {
  Accepted = 'ACCEPTED',
  Cancelled = 'CANCELLED',
  Claimed = 'CLAIMED',
  Open = 'OPEN',
  Paid = 'PAID',
  Submitted = 'SUBMITTED'
}

export type GrantMedicalAccessInput = {
  accessLevel: MedicalAccessLevel;
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  patientId?: InputMaybe<Scalars['ID']['input']>;
  purpose?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['ID']['input'];
};

export type GraphDataPoint = {
  __typename?: 'GraphDataPoint';
  date: Scalars['DateTime']['output'];
  value: Scalars['Float']['output'];
};

export type GraphDataset = {
  __typename?: 'GraphDataset';
  data: Array<GraphDataPoint>;
  residentId: Scalars['ID']['output'];
  residentName: Scalars['String']['output'];
};

export type GraphExtractInput = {
  baseId?: InputMaybe<Scalars['ID']['input']>;
  model: Scalars['String']['input'];
  scope?: InputMaybe<Scalars['String']['input']>;
};

export type GraphExtractJob = {
  __typename?: 'GraphExtractJob';
  avgLatencyMs?: Maybe<Scalars['Int']['output']>;
  baseId?: Maybe<Scalars['ID']['output']>;
  batchId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  currentVideo?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  failedClips: Scalars['Int']['output'];
  finishedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  model: Scalars['String']['output'];
  outputDir?: Maybe<Scalars['String']['output']>;
  ownerId?: Maybe<Scalars['String']['output']>;
  peopleFound: Scalars['Int']['output'];
  progressLog: Array<Scalars['String']['output']>;
  relationshipsFound: Scalars['Int']['output'];
  scope: Scalars['String']['output'];
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  status: GraphExtractStatus;
  tenantId: Scalars['String']['output'];
  topicsFound: Scalars['Int']['output'];
  totalTokens?: Maybe<Scalars['Int']['output']>;
  truncatedClips: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
  videosProcessed: Scalars['Int']['output'];
  videosTotal: Scalars['Int']['output'];
};

/** Knowledge-graph extraction job status */
export enum GraphExtractStatus {
  Cancelled = 'CANCELLED',
  Done = 'DONE',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Running = 'RUNNING'
}

export type GraphFilterInput = {
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  residentId?: InputMaybe<Scalars['ID']['input']>;
  residentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  scope?: InputMaybe<GraphScope>;
  timeframe?: InputMaybe<GraphTimeframe>;
  wing?: InputMaybe<Scalars['String']['input']>;
};

/** Scope of observation graph data */
export enum GraphScope {
  AllResidents = 'ALL_RESIDENTS',
  ThisResident = 'THIS_RESIDENT'
}

/** Timeframe for observation graph aggregation */
export enum GraphTimeframe {
  AllReadings = 'ALL_READINGS',
  AverageMonthly = 'AVERAGE_MONTHLY'
}

/** Channel used to send a motivation message */
export enum GrowthCommunicationChannel {
  Email = 'EMAIL',
  Sms = 'SMS'
}

/** Status of a sent motivation message */
export enum GrowthCommunicationStatus {
  Failed = 'FAILED',
  Pending = 'PENDING',
  Sent = 'SENT'
}

export type GrowthEngineCommunication = {
  __typename?: 'GrowthEngineCommunication';
  automationRunId?: Maybe<Scalars['String']['output']>;
  calendarEventId?: Maybe<Scalars['String']['output']>;
  channel: GrowthCommunicationChannel;
  content: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  deepLink?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  opportunityId?: Maybe<Scalars['String']['output']>;
  opportunityTitle?: Maybe<Scalars['String']['output']>;
  recipientEmail?: Maybe<Scalars['String']['output']>;
  recipientId: Scalars['String']['output'];
  recipientName: Scalars['String']['output'];
  recipientPhone?: Maybe<Scalars['String']['output']>;
  sentAt?: Maybe<Scalars['DateTime']['output']>;
  status: GrowthCommunicationStatus;
  subject?: Maybe<Scalars['String']['output']>;
  taskId?: Maybe<Scalars['String']['output']>;
  taskTitle?: Maybe<Scalars['String']['output']>;
  templateId?: Maybe<Scalars['String']['output']>;
  templateName?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type GrowthEngineConfig = {
  __typename?: 'GrowthEngineConfig';
  createdAt: Scalars['DateTime']['output'];
  defaultChannel?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isEnabled: Scalars['Boolean']['output'];
  targetTag?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type GuestClub52TokenInput = {
  displayName: Scalars['String']['input'];
  inviteToken?: InputMaybe<Scalars['String']['input']>;
  roomName: Scalars['String']['input'];
};

export type GuestMeetTokenInput = {
  displayName: Scalars['String']['input'];
  roomName: Scalars['String']['input'];
};

/** Sub-type of harassment incident */
export enum HarassmentSubType {
  Bullying = 'BULLYING',
  Discrimination = 'DISCRIMINATION',
  Other = 'OTHER',
  Physical = 'PHYSICAL',
  Sexual = 'SEXUAL',
  Verbal = 'VERBAL'
}

export type HarvestFailureGroup = {
  __typename?: 'HarvestFailureGroup';
  count: Scalars['Int']['output'];
  lastAt?: Maybe<Scalars['DateTime']['output']>;
  reason: Scalars['String']['output'];
  sampleTitles: Array<Scalars['String']['output']>;
  sampleYoutubeIds: Array<Scalars['String']['output']>;
  skipped: Scalars['Boolean']['output'];
};

export type HarvestSource = {
  __typename?: 'HarvestSource';
  channelId?: Maybe<Scalars['String']['output']>;
  channelShortsCount: Scalars['Float']['output'];
  channelStreamsCount: Scalars['Float']['output'];
  channelTitle?: Maybe<Scalars['String']['output']>;
  channelVideoCount: Scalars['Float']['output'];
  channelVideosCount: Scalars['Float']['output'];
  checkIntervalHours: Scalars['Float']['output'];
  contentType: ChannelContent;
  createdAt: Scalars['DateTime']['output'];
  errorMessage?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  ingestedCount: Scalars['Float']['output'];
  lastCheckError?: Maybe<Scalars['String']['output']>;
  lastCheckedAt?: Maybe<Scalars['DateTime']['output']>;
  maxHeight: Scalars['Float']['output'];
  maxShorts: Scalars['Float']['output'];
  maxStreams: Scalars['Float']['output'];
  maxVideos: Scalars['Float']['output'];
  owner: Client;
  platform: SourcePlatform;
  playlistTitle?: Maybe<Scalars['String']['output']>;
  researchBaseId?: Maybe<Scalars['ID']['output']>;
  sourceType: SourceType;
  sourceUrl: Scalars['String']['output'];
  status: SourceStatus;
  statusBreakdown: SourceStatusBreakdown;
  tenantId: Scalars['String']['output'];
  thumbnailCid?: Maybe<Scalars['String']['output']>;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  transcribedCount: Scalars['Float']['output'];
  updatedAt: Scalars['DateTime']['output'];
  videoCount: Scalars['Float']['output'];
  watchEnabled: Scalars['Boolean']['output'];
};

export type HarvestedVideo = {
  __typename?: 'HarvestedVideo';
  archiveStatus?: Maybe<Scalars['String']['output']>;
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  archivedUrl?: Maybe<Scalars['String']['output']>;
  audioCid?: Maybe<Scalars['String']['output']>;
  audioFileSize?: Maybe<Scalars['Float']['output']>;
  audioUrl?: Maybe<Scalars['String']['output']>;
  channelTitle?: Maybe<Scalars['String']['output']>;
  confidence?: Maybe<Scalars['Float']['output']>;
  contentKind?: Maybe<ChannelContent>;
  contentKindConfirmed: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  descriptionText?: Maybe<Scalars['String']['output']>;
  detectedLanguage?: Maybe<Scalars['String']['output']>;
  diarizedSegments?: Maybe<Array<HarvestedVideoSegment>>;
  durationSeconds?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  ingestAttempts: Scalars['Float']['output'];
  ingestError?: Maybe<Scalars['String']['output']>;
  ingestStatus: IngestStatus;
  ipfsPublic: Scalars['Boolean']['output'];
  maxHeight?: Maybe<Scalars['Float']['output']>;
  modelUsed?: Maybe<Scalars['String']['output']>;
  owner: Client;
  platform: SourcePlatform;
  processingTime?: Maybe<Scalars['Float']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  resolution?: Maybe<Scalars['String']['output']>;
  sourceId: Scalars['ID']['output'];
  speakers?: Maybe<Array<HarvestedVideoSpeaker>>;
  tenantId: Scalars['String']['output'];
  thumbnailCid?: Maybe<Scalars['String']['output']>;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  transcript?: Maybe<Scalars['String']['output']>;
  transcriptAttempts: Scalars['Float']['output'];
  transcriptError?: Maybe<Scalars['String']['output']>;
  transcriptStatus: TranscriptStatus;
  updatedAt: Scalars['DateTime']['output'];
  videoArchiveSkipped?: Maybe<Scalars['String']['output']>;
  videoCid?: Maybe<Scalars['String']['output']>;
  videoFileSize?: Maybe<Scalars['Float']['output']>;
  videoFormat?: Maybe<Scalars['String']['output']>;
  videoUrl?: Maybe<Scalars['String']['output']>;
  wikiPath?: Maybe<Scalars['String']['output']>;
  wikiWrittenAt?: Maybe<Scalars['DateTime']['output']>;
  youtubeId: Scalars['String']['output'];
  youtubeUrl: Scalars['String']['output'];
};

export type HarvestedVideoSegment = {
  __typename?: 'HarvestedVideoSegment';
  end?: Maybe<Scalars['Float']['output']>;
  speakerLabel?: Maybe<Scalars['String']['output']>;
  start?: Maybe<Scalars['Float']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type HarvestedVideoSpeaker = {
  __typename?: 'HarvestedVideoSpeaker';
  label: Scalars['String']['output'];
};

export type HealthFundDetails = {
  __typename?: 'HealthFundDetails';
  fundName?: Maybe<Scalars['String']['output']>;
  level?: Maybe<Scalars['String']['output']>;
  memberNumber?: Maybe<Scalars['String']['output']>;
};

export type HealthFundDetailsInput = {
  fundName?: InputMaybe<Scalars['String']['input']>;
  level?: InputMaybe<Scalars['String']['input']>;
  memberNumber?: InputMaybe<Scalars['String']['input']>;
};

export type HeightObservation = {
  __typename?: 'HeightObservation';
  autoProgressNote: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  height: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  progressNoteId?: Maybe<Scalars['ID']['output']>;
  residentId: Scalars['ID']['output'];
  residentName?: Maybe<Scalars['String']['output']>;
  residentRoom?: Maybe<Scalars['String']['output']>;
  residentWing?: Maybe<Scalars['String']['output']>;
  sourceAuthor?: Maybe<Scalars['String']['output']>;
  sourceBackupDate?: Maybe<Scalars['DateTime']['output']>;
  sourceHash?: Maybe<Scalars['String']['output']>;
  sourceId?: Maybe<Scalars['String']['output']>;
  sourceMethod?: Maybe<Scalars['String']['output']>;
  sourceSystem?: Maybe<Scalars['String']['output']>;
  takenAt: Scalars['DateTime']['output'];
  takenBy: Scalars['ID']['output'];
  takenByName?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type HeightObservationFilterInput = {
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  residentId?: InputMaybe<Scalars['ID']['input']>;
  wing?: InputMaybe<Scalars['String']['input']>;
};

export type HeightObservationsResponse = {
  __typename?: 'HeightObservationsResponse';
  limit: Scalars['Int']['output'];
  observations: Array<HeightObservation>;
  offset: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type HelpAnswer = {
  __typename?: 'HelpAnswer';
  answer?: Maybe<Scalars['String']['output']>;
  latencyMs?: Maybe<Scalars['Int']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
  pageIds: Array<Scalars['String']['output']>;
};

export type HelpAskInput = {
  pages: Array<HelpPageInput>;
  question: Scalars['String']['input'];
};

export type HelpAssistantStatus = {
  __typename?: 'HelpAssistantStatus';
  aiAvailable: Scalars['Boolean']['output'];
  model?: Maybe<Scalars['String']['output']>;
};

export type HelpPageInput = {
  how?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type HistoricalAssessment = {
  __typename?: 'HistoricalAssessment';
  /** Who completed it, in the source’s words */
  assessedByName?: Maybe<Scalars['String']['output']>;
  /** Date of the assessment (date only, stored T00:00:00Z) */
  assessmentDate: Scalars['DateTime']['output'];
  canViewResident?: Maybe<Scalars['Boolean']['output']>;
  /** When the source marked it complete; null = not completed in the source */
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  /** Instrument code from the catalogue (HISTORICAL_INSTRUMENTS), e.g. MMSE */
  instrumentCode: Scalars['String']['output'];
  /** Instrument name as shown to staff */
  instrumentName: Scalars['String']['output'];
  /** History from an earlier system — read-only, never current work */
  isHistoricalRecord: Scalars['Boolean']['output'];
  items: Array<HistoricalAssessmentItem>;
  recordedBy?: Maybe<Scalars['ID']['output']>;
  recordedByName?: Maybe<Scalars['String']['output']>;
  residentDetailUrl?: Maybe<Scalars['String']['output']>;
  residentId: Scalars['ID']['output'];
  residentName?: Maybe<Scalars['String']['output']>;
  residentRoom?: Maybe<Scalars['String']['output']>;
  residentWing?: Maybe<Scalars['String']['output']>;
  /** The source’s own result words (e.g. "Severe cognitive impairment") */
  resultText?: Maybe<Scalars['String']['output']>;
  reviews: Array<HistoricalAssessmentReview>;
  sourceAuthor?: Maybe<Scalars['String']['output']>;
  sourceBackupDate?: Maybe<Scalars['DateTime']['output']>;
  /** The next-due date the source had set. History only — PLCC never acts on it */
  sourceDueOn?: Maybe<Scalars['DateTime']['output']>;
  /** Every original column of the assessment row, as text */
  sourceFields: Array<HistoricalAssessmentSourceField>;
  sourceId?: Maybe<Scalars['String']['output']>;
  sourceSystem?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  /** Total exactly as the source recorded it (null when it recorded none) */
  totalScore?: Maybe<Scalars['Float']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

/** One question and the answer SarahCare recorded for it */
export type HistoricalAssessmentItem = {
  __typename?: 'HistoricalAssessmentItem';
  /** The answer exactly as recorded */
  answer?: Maybe<Scalars['String']['output']>;
  comments?: Maybe<Scalars['String']['output']>;
  /** Other original columns of this answer row */
  fields: Array<HistoricalAssessmentSourceField>;
  /** Text SarahCare generated from the answer (e.g. for its care plan) */
  output?: Maybe<Scalars['String']['output']>;
  /** Question wording from the backup; null when the definition is missing */
  question?: Maybe<Scalars['String']['output']>;
  /** SarahCare question id (questionnaire tools only) */
  questionId?: Maybe<Scalars['String']['output']>;
  /** True when the question wording was not in the backup (the answer is still kept) */
  questionMissing: Scalars['Boolean']['output'];
  /** Item score, only when the source stored a number for this item */
  score?: Maybe<Scalars['Float']['output']>;
  /** Section or heading the question sits under, when the source has one */
  section?: Maybe<Scalars['String']['output']>;
  /** SarahCare answer/row id */
  sourceId?: Maybe<Scalars['String']['output']>;
};

export type HistoricalAssessmentPage = {
  __typename?: 'HistoricalAssessmentPage';
  records: Array<HistoricalAssessment>;
  total: Scalars['Int']['output'];
};

/** A follow-up review date the source set for this assessment, and whether it was recorded done */
export type HistoricalAssessmentReview = {
  __typename?: 'HistoricalAssessmentReview';
  comments?: Maybe<Scalars['String']['output']>;
  completedOn?: Maybe<Scalars['DateTime']['output']>;
  dueOn?: Maybe<Scalars['DateTime']['output']>;
  /** Review type in the source’s words */
  reviewType?: Maybe<Scalars['String']['output']>;
  sourceId?: Maybe<Scalars['String']['output']>;
};

/** One original SarahCare column, as text (dates as ISO text, bits as "true"/"false") */
export type HistoricalAssessmentSourceField = {
  __typename?: 'HistoricalAssessmentSourceField';
  /** SarahCare table and column, e.g. `ResMMSE.Q1Score` */
  column: Scalars['String']['output'];
  /** Original value as text; null when SarahCare held no value */
  value?: Maybe<Scalars['String']['output']>;
};

/** One instrument in the catalogue, with how many records are on file */
export type HistoricalInstrumentSummary = {
  __typename?: 'HistoricalInstrumentSummary';
  code: Scalars['String']['output'];
  /** What the instrument is for, in plain words */
  description: Scalars['String']['output'];
  name: Scalars['String']['output'];
  newest?: Maybe<Scalars['DateTime']['output']>;
  /** Another PLCC module whose topic this is (for linking), if any */
  relatedModule?: Maybe<Scalars['String']['output']>;
  total: Scalars['Int']['output'];
};

/** Type of hoist required for transfers */
export enum HoistType {
  CeilingHoist = 'CEILING_HOIST',
  FullHoist = 'FULL_HOIST',
  None = 'NONE',
  StandingHoist = 'STANDING_HOIST'
}

export type HolidayPayRate = {
  __typename?: 'HolidayPayRate';
  awardClassificationId?: Maybe<Scalars['String']['output']>;
  awardClassificationName?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  penaltyMultiplier: Scalars['Float']['output'];
  roleId?: Maybe<Scalars['String']['output']>;
  roleName?: Maybe<Scalars['String']['output']>;
};

export type HolidayPayRateInput = {
  awardClassificationId?: InputMaybe<Scalars['String']['input']>;
  awardClassificationName?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  penaltyMultiplier: Scalars['Float']['input'];
  roleId?: InputMaybe<Scalars['String']['input']>;
  roleName?: InputMaybe<Scalars['String']['input']>;
};

export type HolisticSnapshot = {
  __typename?: 'HolisticSnapshot';
  averageScore?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  ratings: Array<SnapshotRating>;
  tenantId: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<SnapshotUser>;
  userId: Scalars['ID']['output'];
};

export type HospitalPreference = {
  __typename?: 'HospitalPreference';
  address?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
};

export type HospitalPreferenceInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type HostingAccessLinkResult = {
  __typename?: 'HostingAccessLinkResult';
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
  token?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type HostingAffiliate = {
  __typename?: 'HostingAffiliate';
  clientId: Scalars['ID']['output'];
  code: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  defaultPercent: Scalars['Float']['output'];
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type HostingBuild = {
  __typename?: 'HostingBuild';
  branch?: Maybe<Scalars['String']['output']>;
  commitAuthor?: Maybe<Scalars['String']['output']>;
  commitMessage?: Maybe<Scalars['String']['output']>;
  commitSha?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deploymentId: Scalars['ID']['output'];
  inspectorUrl?: Maybe<Scalars['String']['output']>;
  readyAt?: Maybe<Scalars['DateTime']['output']>;
  state: HostingBuildState;
  target?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type HostingBuildLog = {
  __typename?: 'HostingBuildLog';
  lines: Array<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  truncated: Scalars['Boolean']['output'];
  unavailable?: Maybe<HostingBuildUnavailableReason>;
};

/** What a website build is doing right now. */
export enum HostingBuildState {
  Building = 'BUILDING',
  Cancelled = 'CANCELLED',
  Failed = 'FAILED',
  Queued = 'QUEUED',
  Ready = 'READY',
  Unknown = 'UNKNOWN'
}

/** Why the hosting provider could not be asked about builds. */
export enum HostingBuildUnavailableReason {
  NoProject = 'NO_PROJECT',
  NoToken = 'NO_TOKEN',
  TokenRejected = 'TOKEN_REJECTED',
  UpstreamError = 'UPSTREAM_ERROR'
}

export type HostingBuildsResult = {
  __typename?: 'HostingBuildsResult';
  builds: Array<HostingBuild>;
  message?: Maybe<Scalars['String']['output']>;
  unavailable?: Maybe<HostingBuildUnavailableReason>;
};

export type HostingCommissionPayment = {
  __typename?: 'HostingCommissionPayment';
  amount: Scalars['Float']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  note?: Maybe<Scalars['String']['output']>;
  paidAt: Scalars['DateTime']['output'];
  paidById?: Maybe<Scalars['ID']['output']>;
  paidByName?: Maybe<Scalars['String']['output']>;
  periodMonth: Scalars['String']['output'];
  referralId: Scalars['ID']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type HostingDeployRun = {
  __typename?: 'HostingDeployRun';
  createdAt: Scalars['DateTime']['output'];
  hookResponseOk: Scalars['Boolean']['output'];
  hookResponseStatus?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  note?: Maybe<Scalars['String']['output']>;
  siteId: Scalars['ID']['output'];
  tenantId: Scalars['String']['output'];
  triggeredById?: Maybe<Scalars['ID']['output']>;
  triggeredByName?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type HostingLinkAuthResult = {
  __typename?: 'HostingLinkAuthResult';
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
  token?: Maybe<Scalars['String']['output']>;
};

export type HostingOffer = {
  __typename?: 'HostingOffer';
  createdAt: Scalars['DateTime']['output'];
  currency: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  monthlyPrice: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  subscriptionProductId?: Maybe<Scalars['ID']['output']>;
  subscriptionProductSlug?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type HostingReferral = {
  __typename?: 'HostingReferral';
  affiliateId: Scalars['ID']['output'];
  confirmedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  monthlyAmount: Scalars['Float']['output'];
  monthlyCommission: Scalars['Float']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  offerId: Scalars['ID']['output'];
  percent: Scalars['Float']['output'];
  referredEmail?: Maybe<Scalars['String']['output']>;
  referredName: Scalars['String']['output'];
  source: HostingReferralSource;
  status: HostingReferralStatus;
  subscriptionId?: Maybe<Scalars['ID']['output']>;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** MANUAL = manager attributed it; LINK = came in via a public ?ref= landing page */
export enum HostingReferralSource {
  Link = 'LINK',
  Manual = 'MANUAL'
}

/** PENDING until a manager confirms; CONFIRMED rows accrue commission */
export enum HostingReferralStatus {
  Cancelled = 'CANCELLED',
  Confirmed = 'CONFIRMED',
  Pending = 'PENDING'
}

export type HostingSite = {
  __typename?: 'HostingSite';
  branch?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  disabledReason?: Maybe<Scalars['String']['output']>;
  hasBuildStatus: Scalars['Boolean']['output'];
  hasDeployHook: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isEnabled: Scalars['Boolean']['output'];
  lastBuildAt?: Maybe<Scalars['DateTime']['output']>;
  liveUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  ownerClientId?: Maybe<Scalars['ID']['output']>;
  repoUrl?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  vercelProjectId?: Maybe<Scalars['String']['output']>;
  vercelTeamId?: Maybe<Scalars['String']['output']>;
  viewerClientIds: Array<Scalars['ID']['output']>;
  viewers: Array<HostingSiteViewer>;
};

export type HostingSiteViewer = {
  __typename?: 'HostingSiteViewer';
  clientId: Scalars['ID']['output'];
  email?: Maybe<Scalars['String']['output']>;
  isOwner: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

/** Period that the employee's min/max contract hours are calculated over. WEEKLY = per 7-day week (Mon-Sun). FORTNIGHTLY = per 14-day pay fortnight. */
export enum HoursBasis {
  Fortnightly = 'FORTNIGHTLY',
  Weekly = 'WEEKLY'
}

export enum HttpMethod {
  Delete = 'DELETE',
  Get = 'GET',
  Patch = 'PATCH',
  Post = 'POST',
  Put = 'PUT'
}

export type IpfsgcResult = {
  __typename?: 'IPFSGCResult';
  objectsRemoved: Scalars['Float']['output'];
  repoAfter: IpfsRepoStats;
};

export type IpfsOrphanScanResult = {
  __typename?: 'IPFSOrphanScanResult';
  orphanedBytes: Scalars['Float']['output'];
  orphanedCIDs: Scalars['Float']['output'];
  pins: Array<IpfsPinStatus>;
  sizesLoaded: Scalars['Boolean']['output'];
  totalPinnedCIDs: Scalars['Float']['output'];
  trackedCIDs: Scalars['Float']['output'];
};

export type IpfsPinStatus = {
  __typename?: 'IPFSPinStatus';
  cid: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  fileSize?: Maybe<Scalars['Float']['output']>;
  filename?: Maybe<Scalars['String']['output']>;
  isTracked: Scalars['Boolean']['output'];
  mimeType?: Maybe<Scalars['String']['output']>;
  pinType: Scalars['String']['output'];
  tenantId?: Maybe<Scalars['String']['output']>;
  tenantName?: Maybe<Scalars['String']['output']>;
  trackedIn?: Maybe<Scalars['String']['output']>;
};

export type IpfsRepoStats = {
  __typename?: 'IPFSRepoStats';
  numObjects: Scalars['Float']['output'];
  pinnedCIDs: Scalars['Float']['output'];
  repoSize: Scalars['Float']['output'];
  storageMax: Scalars['Float']['output'];
};

export type IpfsUnpinResult = {
  __typename?: 'IPFSUnpinResult';
  attempted: Scalars['Float']['output'];
  errors: Array<Scalars['String']['output']>;
  failed: Scalars['Float']['output'];
  gcObjectsRemoved?: Maybe<Scalars['Float']['output']>;
  succeeded: Scalars['Float']['output'];
};

export type ImageSearchResult = {
  __typename?: 'ImageSearchResult';
  results: Array<SearchImage>;
  total: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type ImageUploadResult = {
  __typename?: 'ImageUploadResult';
  filename: Scalars['String']['output'];
  hash: Scalars['String']['output'];
  size: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type ImageUrls = {
  __typename?: 'ImageUrls';
  full: Scalars['String']['output'];
  raw: Scalars['String']['output'];
  regular: Scalars['String']['output'];
  small: Scalars['String']['output'];
  thumb: Scalars['String']['output'];
};

export type ImageUser = {
  __typename?: 'ImageUser';
  name: Scalars['String']['output'];
  username: Scalars['String']['output'];
};

/** Impact level of an event */
export enum ImpactLevel {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM'
}

export type ImportCellcastHistoryInput = {
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  fromDate?: InputMaybe<Scalars['String']['input']>;
  maxPages?: InputMaybe<Scalars['Int']['input']>;
  requestName?: InputMaybe<Scalars['String']['input']>;
  senders?: InputMaybe<Array<Scalars['String']['input']>>;
  toDate?: InputMaybe<Scalars['String']['input']>;
};

export type ImportDuplicateGroup = {
  __typename?: 'ImportDuplicateGroup';
  clientName?: Maybe<Scalars['String']['output']>;
  importRowKey: Scalars['String']['output'];
  tabs: Array<Scalars['String']['output']>;
};

export type ImportLaunchedSiteInput = {
  linkedTenantId: Scalars['String']['input'];
  monthlyFee?: InputMaybe<Scalars['Float']['input']>;
  setupFee?: InputMaybe<Scalars['Float']['input']>;
};

export type ImportPolicyMarkdownInput = {
  filename: Scalars['String']['input'];
  markdown: Scalars['String']['input'];
  publish?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ImportRowProblem = {
  __typename?: 'ImportRowProblem';
  clientName?: Maybe<Scalars['String']['output']>;
  problems: Array<Scalars['String']['output']>;
  row: Scalars['Int']['output'];
  tab: Scalars['String']['output'];
};

export type ImportSarahMedicalFileInput = {
  contentBase64: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  documentType: MedicalDocumentType;
  expectedStorageNodeId: Scalars['String']['input'];
  facilityId?: InputMaybe<Scalars['ID']['input']>;
  mimeType: Scalars['String']['input'];
  originalFileName: Scalars['String']['input'];
  patientId: Scalars['ID']['input'];
  sourceArchived?: InputMaybe<Scalars['Boolean']['input']>;
  sourceBackupDate?: InputMaybe<Scalars['DateTime']['input']>;
  sourceDocId?: InputMaybe<Scalars['String']['input']>;
  sourceDocumentDate?: InputMaybe<Scalars['DateTime']['input']>;
  sourceMetadataJson?: InputMaybe<Scalars['String']['input']>;
  sourceResidentId?: InputMaybe<Scalars['String']['input']>;
  sourceSha256?: InputMaybe<Scalars['String']['input']>;
  sourceSystem?: InputMaybe<Scalars['String']['input']>;
};

export type ImportTabSummary = {
  __typename?: 'ImportTabSummary';
  dealsFound: Scalars['Int']['output'];
  expectedTotal: Scalars['Float']['output'];
  kind: Scalars['String']['output'];
  rowsRead: Scalars['Int']['output'];
  sheet: Scalars['String']['output'];
  skipped?: Maybe<Scalars['String']['output']>;
};

export type ImportTotals = {
  __typename?: 'ImportTotals';
  expected: Scalars['Float']['output'];
  owed: Scalars['Float']['output'];
  received: Scalars['Float']['output'];
};

export type ImportUnknownValue = {
  __typename?: 'ImportUnknownValue';
  count: Scalars['Int']['output'];
  list: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type ImprovMxAliasInfo = {
  __typename?: 'ImprovMXAliasInfo';
  alias: Scalars['String']['output'];
  assignedClients: Array<AssignedClientInfo>;
  createdAt: Scalars['DateTime']['output'];
  databaseId?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  forwardTo: Scalars['String']['output'];
  isInDatabase: Scalars['Boolean']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type InAppNotification = {
  __typename?: 'InAppNotification';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  isRead: Scalars['Boolean']['output'];
  message: Scalars['String']['output'];
  readAt?: Maybe<Scalars['DateTime']['output']>;
  recipientClientId: Scalars['String']['output'];
  recipientEmployeeId?: Maybe<Scalars['String']['output']>;
  recipientName?: Maybe<Scalars['String']['output']>;
  referenceId?: Maybe<Scalars['String']['output']>;
  referenceType?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  title: Scalars['String']['output'];
  type: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type InboundEmail = {
  __typename?: 'InboundEmail';
  aiClassification?: Maybe<Scalars['String']['output']>;
  aiProcessingLogId?: Maybe<Scalars['String']['output']>;
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  assignedClients: Array<Scalars['String']['output']>;
  attachments: Array<EmailAttachment>;
  bcc: Array<Scalars['String']['output']>;
  bccFull: Array<Scalars['String']['output']>;
  calendarEventId?: Maybe<Scalars['String']['output']>;
  calendarId?: Maybe<Scalars['String']['output']>;
  cc: Array<Scalars['String']['output']>;
  ccFull: Array<Scalars['String']['output']>;
  conversationKey?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  date: Scalars['DateTime']['output'];
  deliveredTo?: Maybe<Scalars['String']['output']>;
  filed?: Maybe<EmailFiledStatus>;
  folder?: Maybe<Scalars['String']['output']>;
  from: Scalars['String']['output'];
  fromFull: Scalars['String']['output'];
  fromName?: Maybe<Scalars['String']['output']>;
  headers: Array<EmailHeader>;
  htmlBody?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  inReplyTo?: Maybe<Scalars['String']['output']>;
  isArchived: Scalars['Boolean']['output'];
  isAssigned: Scalars['Boolean']['output'];
  isRead: Scalars['Boolean']['output'];
  isSpam: Scalars['Boolean']['output'];
  isStarred: Scalars['Boolean']['output'];
  labels: Array<Scalars['String']['output']>;
  linkedOpportunityIds: Array<Scalars['String']['output']>;
  mailboxHash?: Maybe<Scalars['String']['output']>;
  messageId: Scalars['String']['output'];
  originalRecipient?: Maybe<Scalars['String']['output']>;
  piiScrubReason?: Maybe<Scalars['String']['output']>;
  piiScrubbed?: Maybe<Scalars['Boolean']['output']>;
  piiScrubbedAt?: Maybe<Scalars['DateTime']['output']>;
  preview?: Maybe<Scalars['String']['output']>;
  rawEmail?: Maybe<Scalars['String']['output']>;
  readAt?: Maybe<Scalars['DateTime']['output']>;
  references: Array<Scalars['String']['output']>;
  repliedAt?: Maybe<Scalars['DateTime']['output']>;
  repliedBy?: Maybe<Scalars['String']['output']>;
  replyEmailId?: Maybe<Scalars['String']['output']>;
  replyTo?: Maybe<Scalars['String']['output']>;
  spamScore?: Maybe<Scalars['Float']['output']>;
  strippedTextReply?: Maybe<Scalars['String']['output']>;
  subject: Scalars['String']['output'];
  tag?: Maybe<Scalars['String']['output']>;
  tasks?: Maybe<Array<CommunicationTask>>;
  tenantId: Scalars['String']['output'];
  textBody?: Maybe<Scalars['String']['output']>;
  threadId?: Maybe<Scalars['String']['output']>;
  to: Array<Scalars['String']['output']>;
  toFull: Array<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

/** Per-id outcome of a bulk move. Nothing here is optimistic: `moved` is re-read from the database after the write. */
export type InboundEmailBulkMoveResult = {
  __typename?: 'InboundEmailBulkMoveResult';
  /** Were already in the target folder — nothing changed. */
  alreadyThere: Array<InboundEmailMoveRow>;
  /** The write was attempted but the re-read did not show the target folder. Rare; report it, never hide it. */
  failed: Array<InboundEmailMoveRow>;
  /** Folder the emails were moved to. */
  folder: Scalars['String']['output'];
  /** Confirmed in the target folder after the write. */
  moved: Array<InboundEmailMoveRow>;
  /** Exists in the tenant but is not in one of the caller's own mailboxes — refused, unchanged. */
  notAccessible: Array<Scalars['ID']['output']>;
  /** No received email with this id exists in this tenant (or the id is malformed). */
  notFound: Array<Scalars['ID']['output']>;
  /** Ids the caller asked about (from the list or the token). */
  requested: Scalars['Int']['output'];
};

/** Which received emails a bulk move would touch. The preview resolves this to an exact id set and a signed token. */
export type InboundEmailMoveFilterInput = {
  /** Folder to select FROM: Inbox (default), Archived or Trash. */
  folder?: InputMaybe<Scalars['String']['input']>;
  /** Case-insensitive substring of the sender address or display name (matches `from` / `fromFull`). */
  fromEmail?: InputMaybe<Scalars['String']['input']>;
  /** Cap on the selection, 1–500 (default 500). Newest first. */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Only emails dated strictly before this instant (UTC). */
  olderThan?: InputMaybe<Scalars['DateTime']['input']>;
  /** Case-insensitive substring of the subject. */
  subjectContains?: InputMaybe<Scalars['String']['input']>;
  /** Folder to move TO: Inbox, Archived or Trash. */
  targetFolder: Scalars['String']['input'];
};

/** The exact set a bulk move would touch, plus the token that authorises moving exactly that set. */
export type InboundEmailMovePreview = {
  __typename?: 'InboundEmailMovePreview';
  /** When the token stops working (UTC). */
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  /** Plain-language restatement of the filter that was applied — echo it to the user. */
  filterDescription: Scalars['String']['output'];
  /** Folder the selection was taken from. */
  folderFrom: Scalars['String']['output'];
  /** Folder the token authorises moving to. */
  folderTo: Scalars['String']['output'];
  limit: Scalars['Int']['output'];
  /** How many emails match the filter in the caller's own mailboxes (before the cap). */
  matched: Scalars['Int']['output'];
  /** Up to 20 of the selected emails, newest first, so the user can recognise the set. */
  sample: Array<InboundEmailMoveRow>;
  /** How many ids the token carries (matched, capped at `limit`). */
  selected: Scalars['Int']['output'];
  /** Signed selection token — null when nothing matched. Pass it unchanged to moveInboundEmailsToFolder. */
  selectionToken?: Maybe<Scalars['String']['output']>;
  /** true when `matched` exceeded `limit`, so the token covers only the newest `selected` emails. */
  truncated: Scalars['Boolean']['output'];
};

/** One received email as the preview / receipt names it. */
export type InboundEmailMoveRow = {
  __typename?: 'InboundEmailMoveRow';
  date?: Maybe<Scalars['DateTime']['output']>;
  /** The folder the email was in when this row was produced. */
  folder?: Maybe<Scalars['String']['output']>;
  from?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  subject?: Maybe<Scalars['String']['output']>;
};

export type InboundSearchBreakdown = {
  __typename?: 'InboundSearchBreakdown';
  folders: Array<SearchFolderCount>;
  knownSenders: Array<SearchKnownSender>;
  labels: Array<SearchLabelCount>;
  total: Scalars['Int']['output'];
};

export type InboxEvent = {
  __typename?: 'InboxEvent';
  at: Scalars['DateTime']['output'];
  emailId?: Maybe<Scalars['String']['output']>;
  folderFrom?: Maybe<Scalars['String']['output']>;
  folderTo?: Maybe<Scalars['String']['output']>;
  kind: InboxEventKind;
  label?: Maybe<Scalars['String']['output']>;
  senderEmail?: Maybe<Scalars['String']['output']>;
};

/** Type of inbox event for live count + list updates. */
export enum InboxEventKind {
  EmailAiProcessed = 'EMAIL_AI_PROCESSED',
  EmailDeleted = 'EMAIL_DELETED',
  EmailFolderChanged = 'EMAIL_FOLDER_CHANGED',
  EmailLabelChanged = 'EMAIL_LABEL_CHANGED',
  EmailRead = 'EMAIL_READ',
  EmailReceived = 'EMAIL_RECEIVED',
  EmailStarred = 'EMAIL_STARRED'
}

export type InboxFolderCount = {
  __typename?: 'InboxFolderCount';
  folder: Scalars['String']['output'];
  total: Scalars['Int']['output'];
  unread: Scalars['Int']['output'];
};

export type InboxStats = {
  __typename?: 'InboxStats';
  archived: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  unassigned: Scalars['Int']['output'];
  unread: Scalars['Int']['output'];
};

export type InboxSummary = {
  __typename?: 'InboxSummary';
  actionsNeededEmailIds: Array<Scalars['String']['output']>;
  byCategory: Array<InboxSummaryBucket>;
  byFolder: Array<InboxSummaryBucket>;
  byLabel: Array<InboxSummaryBucket>;
  calendarEventId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  escalatedToSmsEmailIds: Array<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  period: InboxSummaryPeriod;
  periodEnd: Scalars['DateTime']['output'];
  periodStart: Scalars['DateTime']['output'];
  repliedAutomaticallyEmailIds: Array<Scalars['String']['output']>;
  sentAt?: Maybe<Scalars['DateTime']['output']>;
  sentToEmail?: Maybe<Scalars['String']['output']>;
  sentToSms?: Maybe<Scalars['String']['output']>;
  summaryMarkdown?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  totalEmails: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
  userId?: Maybe<Scalars['String']['output']>;
};

export type InboxSummaryBucket = {
  __typename?: 'InboxSummaryBucket';
  count: Scalars['Int']['output'];
  key: Scalars['String']['output'];
};

export type InboxSummaryFilterInput = {
  period?: InputMaybe<InboxSummaryPeriod>;
};

export enum InboxSummaryFrequency {
  Daily = 'DAILY',
  Monthly = 'MONTHLY',
  Off = 'OFF',
  Weekly = 'WEEKLY'
}

export enum InboxSummaryPeriod {
  AdHoc = 'AD_HOC',
  Daily = 'DAILY',
  Last_30Days = 'LAST_30_DAYS',
  Monthly = 'MONTHLY',
  Weekly = 'WEEKLY',
  Yearly = 'YEARLY'
}

export type InboxSummaryPreference = {
  __typename?: 'InboxSummaryPreference';
  createdAt: Scalars['DateTime']['output'];
  frequency: InboxSummaryFrequency;
  id: Scalars['ID']['output'];
  lastRunAt?: Maybe<Scalars['DateTime']['output']>;
  nextRunAt?: Maybe<Scalars['DateTime']['output']>;
  routeToEmployeeWorkEmailFirst: Scalars['Boolean']['output'];
  sendViaEmail: Scalars['Boolean']['output'];
  sendViaSms: Scalars['Boolean']['output'];
  tenantId: Scalars['String']['output'];
  timeOfDay?: Maybe<Scalars['String']['output']>;
  timezone?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  userId: Scalars['String']['output'];
};

export type Incident = {
  __typename?: 'Incident';
  autoProgressNote: Scalars['Boolean']['output'];
  /** Answer to the follow-up step "Care plan updated?"; empty = not answered yet */
  carePlanCheck?: Maybe<IncidentCarePlanCheck>;
  carePlanCheckNote?: Maybe<Scalars['String']['output']>;
  carePlanCheckedAt?: Maybe<Scalars['DateTime']['output']>;
  carePlanCheckedByName?: Maybe<Scalars['String']['output']>;
  closeDate?: Maybe<Scalars['DateTime']['output']>;
  closeReason?: Maybe<Scalars['String']['output']>;
  closedBy?: Maybe<Scalars['ID']['output']>;
  closedByName?: Maybe<Scalars['String']['output']>;
  comments: Scalars['String']['output'];
  contributingFactorId?: Maybe<Scalars['ID']['output']>;
  contributingFactorName?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  hasInjury: Scalars['Boolean']['output'];
  hospitalDetails?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  incidentNumber: Scalars['Int']['output'];
  incidentTypeId: Scalars['ID']['output'];
  incidentTypeName?: Maybe<Scalars['String']['output']>;
  injuryDescription?: Maybe<Scalars['String']['output']>;
  /** True when this is a fall logged in the portal (raises a review after a change in Care reviews) */
  isFall: Scalars['Boolean']['output'];
  locationId?: Maybe<Scalars['ID']['output']>;
  locationName?: Maybe<Scalars['String']['output']>;
  logDate: Scalars['DateTime']['output'];
  logTime: Scalars['String']['output'];
  progressNoteId?: Maybe<Scalars['ID']['output']>;
  reportedBy: Scalars['ID']['output'];
  reportedByName?: Maybe<Scalars['String']['output']>;
  residentId: Scalars['ID']['output'];
  residentName?: Maybe<Scalars['String']['output']>;
  residentPhotoUrl?: Maybe<Scalars['String']['output']>;
  residentRoom?: Maybe<Scalars['String']['output']>;
  residentWing?: Maybe<Scalars['String']['output']>;
  riskAssessmentComplete: Scalars['Boolean']['output'];
  riskAssessmentId?: Maybe<Scalars['ID']['output']>;
  sourceAuthor?: Maybe<Scalars['String']['output']>;
  sourceBackupDate?: Maybe<Scalars['DateTime']['output']>;
  sourceFields?: Maybe<SarahIncidentSourceFields>;
  sourceHash?: Maybe<Scalars['String']['output']>;
  sourceId?: Maybe<Scalars['String']['output']>;
  sourceIncidentNumber?: Maybe<Scalars['Int']['output']>;
  sourceSystem?: Maybe<Scalars['String']['output']>;
  status: IncidentStatus;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  wasHospitalized: Scalars['Boolean']['output'];
  wing?: Maybe<Scalars['String']['output']>;
};

export type IncidentAlert = {
  __typename?: 'IncidentAlert';
  alertType: IncidentAlertType;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  incidentId: Scalars['ID']['output'];
  incidentNumber?: Maybe<Scalars['Int']['output']>;
  incidentTypeName?: Maybe<Scalars['String']['output']>;
  isRead: Scalars['Boolean']['output'];
  message: Scalars['String']['output'];
  readAt?: Maybe<Scalars['DateTime']['output']>;
  readBy?: Maybe<Scalars['ID']['output']>;
  readByName?: Maybe<Scalars['String']['output']>;
  residentId?: Maybe<Scalars['ID']['output']>;
  residentName?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** Type of incident alert notification */
export enum IncidentAlertType {
  FollowUpDue = 'FOLLOW_UP_DUE',
  HighRiskIncident = 'HIGH_RISK_INCIDENT',
  IncidentOpenTooLong = 'INCIDENT_OPEN_TOO_LONG',
  NewIncident = 'NEW_INCIDENT',
  RiskAssessmentRequired = 'RISK_ASSESSMENT_REQUIRED'
}

/** Answer to the incident follow-up step "Care plan updated?" */
export enum IncidentCarePlanCheck {
  NoChangeNeeded = 'NO_CHANGE_NEEDED',
  Updated = 'UPDATED'
}

export type IncidentCarePlanCheckInput = {
  answer: IncidentCarePlanCheck;
  /** What changed in the care plan, or why no change was needed */
  note?: InputMaybe<Scalars['String']['input']>;
};

/** Category grouping for incident types */
export enum IncidentCategory {
  Behavioral = 'BEHAVIORAL',
  Environmental = 'ENVIRONMENTAL',
  Falls = 'FALLS',
  Medical = 'MEDICAL',
  Other = 'OTHER',
  Physical = 'PHYSICAL'
}

export type IncidentCustomAnswer = {
  __typename?: 'IncidentCustomAnswer';
  answer?: Maybe<Scalars['String']['output']>;
  answeredAt: Scalars['DateTime']['output'];
  answeredBy: Scalars['ID']['output'];
  answeredByName?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  customQuestionId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  incidentId: Scalars['ID']['output'];
  multipleAnswers?: Maybe<Array<Scalars['String']['output']>>;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type IncidentCustomQuestion = {
  __typename?: 'IncidentCustomQuestion';
  createdAt: Scalars['DateTime']['output'];
  helpText?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  incidentTypeId: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  isRequired: Scalars['Boolean']['output'];
  options?: Maybe<Array<Scalars['String']['output']>>;
  order: Scalars['Int']['output'];
  question: Scalars['String']['output'];
  questionType: CustomQuestionType;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type IncidentDocument = {
  __typename?: 'IncidentDocument';
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  documentType: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
  fileSize: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  incidentId: Scalars['ID']['output'];
  ipfsCid: Scalars['String']['output'];
  mimeType: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  uploadedAt: Scalars['DateTime']['output'];
  uploadedBy: Scalars['ID']['output'];
  uploadedByName?: Maybe<Scalars['String']['output']>;
};

export type IncidentFilterInput = {
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  hasInjury?: InputMaybe<Scalars['Boolean']['input']>;
  incidentTypeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  residentId?: InputMaybe<Scalars['ID']['input']>;
  riskAssessmentComplete?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sourceSystem?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<IncidentStatus>>;
  wasHospitalized?: InputMaybe<Scalars['Boolean']['input']>;
  wing?: InputMaybe<Scalars['String']['input']>;
};

export type IncidentFollowUp = {
  __typename?: 'IncidentFollowUp';
  assignedTo?: Maybe<Scalars['ID']['output']>;
  assignedToName?: Maybe<Scalars['String']['output']>;
  completedBy?: Maybe<Scalars['ID']['output']>;
  completedByName?: Maybe<Scalars['String']['output']>;
  completedDate?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  followUpType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  incidentId: Scalars['ID']['output'];
  incidentNumber?: Maybe<Scalars['Int']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  residentId?: Maybe<Scalars['ID']['output']>;
  residentName?: Maybe<Scalars['String']['output']>;
  riskAssessmentId?: Maybe<Scalars['ID']['output']>;
  scheduledDate: Scalars['DateTime']['output'];
  sourceAuthor?: Maybe<Scalars['String']['output']>;
  sourceBackupDate?: Maybe<Scalars['DateTime']['output']>;
  sourceFields?: Maybe<SarahIncidentFollowUpSourceFields>;
  sourceHash?: Maybe<Scalars['String']['output']>;
  sourceId?: Maybe<Scalars['String']['output']>;
  sourceSystem?: Maybe<Scalars['String']['output']>;
  status: FollowUpStatus;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type IncidentInjury = {
  __typename?: 'IncidentInjury';
  bodyPart?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  iadType?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  incidentId: Scalars['ID']['output'];
  injuryType?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  pressureAreaStage?: Maybe<Scalars['String']['output']>;
  recordedBy?: Maybe<Scalars['ID']['output']>;
  recordedByName?: Maybe<Scalars['String']['output']>;
  residentId?: Maybe<Scalars['ID']['output']>;
  side?: Maybe<Scalars['String']['output']>;
  skinTearLength?: Maybe<Scalars['Int']['output']>;
  skinTearType?: Maybe<Scalars['Int']['output']>;
  skinTearWidth?: Maybe<Scalars['Int']['output']>;
  sourceAuthor?: Maybe<Scalars['String']['output']>;
  sourceBackupDate?: Maybe<Scalars['DateTime']['output']>;
  sourceFields?: Maybe<SarahIncidentInjurySourceFields>;
  sourceHash?: Maybe<Scalars['String']['output']>;
  sourceId?: Maybe<Scalars['String']['output']>;
  sourceSystem?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type IncidentLocation = {
  __typename?: 'IncidentLocation';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  wing?: Maybe<Scalars['String']['output']>;
};

export type IncidentLocationFilterInput = {
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  wing?: InputMaybe<Scalars['String']['input']>;
};

export type IncidentRiskAssessment = {
  __typename?: 'IncidentRiskAssessment';
  assessedAt: Scalars['DateTime']['output'];
  assessedBy: Scalars['ID']['output'];
  assessedByName?: Maybe<Scalars['String']['output']>;
  comments?: Maybe<Scalars['String']['output']>;
  consequences: RiskConsequences;
  controlMeasuresTaken?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  exposure: RiskExposure;
  followUpNotes?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  incidentId: Scalars['ID']['output'];
  numberOfPersonsAffected: Scalars['Int']['output'];
  probability: RiskProbability;
  residentId: Scalars['ID']['output'];
  riskScore: Scalars['Float']['output'];
  riskScoreCategory: RiskScoreCategory;
  sentToFollowUp: Scalars['Boolean']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** Status of an incident record */
export enum IncidentStatus {
  Closed = 'CLOSED',
  HistoricalOpen = 'HISTORICAL_OPEN',
  Open = 'OPEN',
  PendingReview = 'PENDING_REVIEW',
  PendingRiskAssessment = 'PENDING_RISK_ASSESSMENT'
}

export type IncidentSummary = {
  __typename?: 'IncidentSummary';
  byStatus: Array<IncidentSummaryByStatus>;
  byType: Array<IncidentSummaryByType>;
  totalClosed: Scalars['Int']['output'];
  totalHospitalized: Scalars['Int']['output'];
  totalOpen: Scalars['Int']['output'];
  totalPendingRiskAssessment: Scalars['Int']['output'];
  totalWithInjury: Scalars['Int']['output'];
};

export type IncidentSummaryByStatus = {
  __typename?: 'IncidentSummaryByStatus';
  count: Scalars['Int']['output'];
  status: IncidentStatus;
};

export type IncidentSummaryByType = {
  __typename?: 'IncidentSummaryByType';
  count: Scalars['Int']['output'];
  typeId: Scalars['ID']['output'];
  typeName: Scalars['String']['output'];
};

export type IncidentTreatmentPlan = {
  __typename?: 'IncidentTreatmentPlan';
  administeredAt: Scalars['DateTime']['output'];
  administeredBy: Scalars['ID']['output'];
  administeredByName?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  followUpDate?: Maybe<Scalars['DateTime']['output']>;
  followUpRequired: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  incidentId: Scalars['ID']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  residentId: Scalars['ID']['output'];
  tenantId: Scalars['String']['output'];
  treatmentDescription: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type IncidentTrendByType = {
  __typename?: 'IncidentTrendByType';
  count: Scalars['Int']['output'];
  typeName: Scalars['String']['output'];
};

export type IncidentType = {
  __typename?: 'IncidentType';
  category?: Maybe<IncidentCategory>;
  createdAt: Scalars['DateTime']['output'];
  defaultContributingFactorIds?: Maybe<Array<Scalars['ID']['output']>>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  requiresRiskAssessment: Scalars['Boolean']['output'];
  sourceAuthor?: Maybe<Scalars['String']['output']>;
  sourceBackupDate?: Maybe<Scalars['DateTime']['output']>;
  sourceHash?: Maybe<Scalars['String']['output']>;
  sourceId?: Maybe<Scalars['String']['output']>;
  sourceSystem?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type IncidentTypeFilterInput = {
  category?: InputMaybe<IncidentCategory>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type IncidentWitness = {
  __typename?: 'IncidentWitness';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  incidentId: Scalars['ID']['output'];
  recordedBy?: Maybe<Scalars['ID']['output']>;
  recordedByName?: Maybe<Scalars['String']['output']>;
  signedOff: Scalars['Boolean']['output'];
  signedOffBy?: Maybe<Scalars['ID']['output']>;
  signedOffByName?: Maybe<Scalars['String']['output']>;
  signedOffDate?: Maybe<Scalars['DateTime']['output']>;
  sourceAuthor?: Maybe<Scalars['String']['output']>;
  sourceBackupDate?: Maybe<Scalars['DateTime']['output']>;
  sourceFields?: Maybe<SarahIncidentWitnessSourceFields>;
  sourceHash?: Maybe<Scalars['String']['output']>;
  sourceId?: Maybe<Scalars['String']['output']>;
  sourceSystem?: Maybe<Scalars['String']['output']>;
  statement?: Maybe<Scalars['String']['output']>;
  statementDate?: Maybe<Scalars['DateTime']['output']>;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  witnessContact?: Maybe<Scalars['String']['output']>;
  witnessName: Scalars['String']['output'];
  witnessType: WitnessType;
};

export type IncidentsResponse = {
  __typename?: 'IncidentsResponse';
  incidents: Array<Incident>;
  total: Scalars['Int']['output'];
};

/** STP Phase 2 income type codes */
export enum IncomeType {
  Chp = 'CHP',
  Fei = 'FEI',
  Iaa = 'IAA',
  Jpd = 'JPD',
  Saw = 'SAW',
  Swp = 'SWP',
  Whm = 'WHM'
}

export type IncomingDeliveryTemperature = {
  __typename?: 'IncomingDeliveryTemperature';
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  foodType: DeliveryFoodType;
  id: Scalars['ID']['output'];
  isOutOfRange: Scalars['Boolean']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  photos: Array<MealMedia>;
  recordedAt: Scalars['DateTime']['output'];
  recordedBy: Scalars['String']['output'];
  recordedByName?: Maybe<Scalars['String']['output']>;
  supplier?: Maybe<Supplier>;
  supplierId: Scalars['ID']['output'];
  temperature: Scalars['Float']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** Category of sphere of influence */
export enum InfluenceCategory {
  Habit = 'HABIT',
  Media = 'MEDIA',
  Other = 'OTHER',
  Person = 'PERSON',
  Place = 'PLACE',
  System = 'SYSTEM'
}

export type InfluenceSummary = {
  __typename?: 'InfluenceSummary';
  draining: Scalars['Int']['output'];
  neutral: Scalars['Int']['output'];
  supportive: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

/** Whether an influence is supportive, neutral, or draining */
export enum InfluenceType {
  Draining = 'DRAINING',
  Neutral = 'NEUTRAL',
  Supportive = 'SUPPORTIVE'
}

export type Influencer = {
  __typename?: 'Influencer';
  acceptingCampaigns: Scalars['Boolean']['output'];
  achievements: Array<Scalars['String']['output']>;
  billingAddresses: Array<ClientShippingDetails>;
  bio?: Maybe<Scalars['String']['output']>;
  businessName?: Maybe<Scalars['String']['output']>;
  businessRegistrationNumber?: Maybe<Scalars['String']['output']>;
  cellcastId?: Maybe<Scalars['String']['output']>;
  contentSamples: Array<Scalars['String']['output']>;
  countries: Array<Scalars['String']['output']>;
  coverImage?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  digitalManagerId?: Maybe<Scalars['ID']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  encryptedSignatureIpfsUrl?: Maybe<Scalars['String']['output']>;
  fName?: Maybe<Scalars['String']['output']>;
  hasPasskey: Scalars['Boolean']['output'];
  hasUsernamePassword: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isDigitalManager?: Maybe<Scalars['Boolean']['output']>;
  isVerifiedSeller?: Maybe<Scalars['Boolean']['output']>;
  knowledgeSlug?: Maybe<Scalars['String']['output']>;
  lName?: Maybe<Scalars['String']['output']>;
  languages: Array<Scalars['String']['output']>;
  lastLoginAt?: Maybe<Scalars['DateTime']['output']>;
  lastLoginMethod?: Maybe<Scalars['String']['output']>;
  lastPasskeyUsedAt?: Maybe<Scalars['DateTime']['output']>;
  loginBlockedAt?: Maybe<Scalars['DateTime']['output']>;
  loginBlockedByClientId?: Maybe<Scalars['String']['output']>;
  loginBlockedNote?: Maybe<Scalars['String']['output']>;
  loginBlockedReason?: Maybe<ClientLoginBlockReason>;
  mergedAt?: Maybe<Scalars['DateTime']['output']>;
  mergedIntoClientId?: Maybe<Scalars['ID']['output']>;
  metrics: InfluencerMetrics;
  minimumRate?: Maybe<Scalars['Float']['output']>;
  niches: Array<ContentNiche>;
  notes?: Maybe<Scalars['String']['output']>;
  opportunityCount?: Maybe<Scalars['Float']['output']>;
  passwordChangedAt?: Maybe<Scalars['DateTime']['output']>;
  paymentReceivingDetails?: Maybe<PaymentReceivingDetails>;
  permissions?: Maybe<Array<ClientPermission>>;
  personalCalendarId?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  preferences?: Maybe<ClientPreferences>;
  preferredContactMethod?: Maybe<Scalars['String']['output']>;
  profileImage?: Maybe<Scalars['String']['output']>;
  profilePhoto?: Maybe<Scalars['String']['output']>;
  role?: Maybe<ClientRole>;
  shippingAddresses: Array<ClientShippingDetails>;
  socialAccounts: Array<SocialMediaAccount>;
  specializations: Array<Scalars['String']['output']>;
  status: InfluencerStatus;
  stripeCustomerId?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  tenantId: Scalars['String']['output'];
  totalOpportunityValue?: Maybe<Scalars['Float']['output']>;
  twoFactorEnabledAt?: Maybe<Scalars['DateTime']['output']>;
  twoFactorRecoveryIssuedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  username?: Maybe<Scalars['String']['output']>;
  verified: Scalars['Boolean']['output'];
  verifiedAt?: Maybe<Scalars['DateTime']['output']>;
  websiteUrl?: Maybe<Scalars['String']['output']>;
  websites?: Maybe<Array<Scalars['String']['output']>>;
};

export type InfluencerBooking = {
  __typename?: 'InfluencerBooking';
  additionalNotes?: Maybe<Scalars['String']['output']>;
  bookingType: BookingType;
  budgetRange?: Maybe<Scalars['String']['output']>;
  contactEmail: Scalars['String']['output'];
  contactName: Scalars['String']['output'];
  contactPhone?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  expectedDeliverables?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  influencerId: Scalars['String']['output'];
  organization?: Maybe<Scalars['String']['output']>;
  projectDescription: Scalars['String']['output'];
  projectTitle: Scalars['String']['output'];
  status: InfluencerBookingStatus;
  targetAudience?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  timeline?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  urgency: UrgencyLevel;
};

/** Status of influencer booking */
export enum InfluencerBookingStatus {
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Confirmed = 'CONFIRMED',
  InProgress = 'IN_PROGRESS',
  Pending = 'PENDING'
}

export type InfluencerInput = {
  acceptingCampaigns?: InputMaybe<Scalars['Boolean']['input']>;
  achievements?: InputMaybe<Array<Scalars['String']['input']>>;
  bio?: InputMaybe<Scalars['String']['input']>;
  contentSamples?: InputMaybe<Array<Scalars['String']['input']>>;
  countries?: InputMaybe<Array<Scalars['String']['input']>>;
  coverImage?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  fName?: InputMaybe<Scalars['String']['input']>;
  lName?: InputMaybe<Scalars['String']['input']>;
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
  metrics?: InputMaybe<InfluencerMetricsInput>;
  minimumRate?: InputMaybe<Scalars['Float']['input']>;
  niches?: InputMaybe<Array<ContentNiche>>;
  notes?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  preferredContactMethod?: InputMaybe<Scalars['String']['input']>;
  profileImage?: InputMaybe<Scalars['String']['input']>;
  socialAccounts?: InputMaybe<Array<SocialMediaAccountInput>>;
  specializations?: InputMaybe<Array<Scalars['String']['input']>>;
  status?: InputMaybe<InfluencerStatus>;
  websiteUrl?: InputMaybe<Scalars['String']['input']>;
};

export type InfluencerMetrics = {
  __typename?: 'InfluencerMetrics';
  averageEngagementRate: Scalars['Float']['output'];
  averageRating?: Maybe<Scalars['Float']['output']>;
  campaignsCompleted: Scalars['Int']['output'];
  totalFollowers: Scalars['Int']['output'];
  totalPosts: Scalars['Int']['output'];
  totalReviews: Scalars['Int']['output'];
};

export type InfluencerMetricsInput = {
  averageEngagementRate: Scalars['Float']['input'];
  averageRating?: InputMaybe<Scalars['Float']['input']>;
  campaignsCompleted: Scalars['Int']['input'];
  totalFollowers: Scalars['Int']['input'];
  totalPosts: Scalars['Int']['input'];
  totalReviews: Scalars['Int']['input'];
};

/** The status of the influencer account */
export enum InfluencerStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  Pending = 'PENDING',
  Suspended = 'SUSPENDED'
}

export type IngestMicrosoftEmailInput = {
  attachments?: InputMaybe<Array<MicrosoftEmailAttachmentInput>>;
  bodyHtml?: InputMaybe<Scalars['String']['input']>;
  bodyText?: InputMaybe<Scalars['String']['input']>;
  cc?: InputMaybe<Array<Scalars['String']['input']>>;
  direction?: InputMaybe<MicrosoftEmailDirection>;
  from?: InputMaybe<Scalars['String']['input']>;
  fromName?: InputMaybe<Scalars['String']['input']>;
  m365MessageId: Scalars['String']['input'];
  mailbox: Scalars['String']['input'];
  receivedAt?: InputMaybe<Scalars['DateTime']['input']>;
  sentAt?: InputMaybe<Scalars['DateTime']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  to?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Video ingest (download+archive) status */
export enum IngestStatus {
  Downloading = 'DOWNLOADING',
  Failed = 'FAILED',
  Ingested = 'INGESTED',
  Queued = 'QUEUED',
  Skipped = 'SKIPPED'
}

export type IngestTrainingReplyInput = {
  replyBody: Scalars['String']['input'];
  summaryId: Scalars['ID']['input'];
};

export type IngestTrainingReplyOutput = {
  __typename?: 'IngestTrainingReplyOutput';
  acknowledgment: Scalars['String']['output'];
  memoryId?: Maybe<Scalars['String']['output']>;
  proposedBody: Scalars['String']['output'];
  proposedTitle: Scalars['String']['output'];
};

export type IngestVoipCallInput = {
  audioIpfsCid?: InputMaybe<Scalars['String']['input']>;
  contactName?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<VoipCallDirection>;
  durationSeconds?: InputMaybe<Scalars['Int']['input']>;
  externalCallId: Scalars['String']['input'];
  fromNumber?: InputMaybe<Scalars['String']['input']>;
  missed?: InputMaybe<Scalars['Boolean']['input']>;
  ownNumber: Scalars['String']['input'];
  rawData?: InputMaybe<Scalars['String']['input']>;
  recordingUrl?: InputMaybe<Scalars['String']['input']>;
  startedAt?: InputMaybe<Scalars['DateTime']['input']>;
  summary?: InputMaybe<Scalars['String']['input']>;
  toNumber?: InputMaybe<Scalars['String']['input']>;
  transcript?: InputMaybe<Scalars['String']['input']>;
};

export type IngestionRun = {
  __typename?: 'IngestionRun';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  errors: Array<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  rowsProcessed: Scalars['Int']['output'];
  source: IngestionSource;
  startedAt: Scalars['DateTime']['output'];
  /** Suburb scope for this run (null = statewide) */
  suburb?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** Property-intel ingestion source (one per CC-BY dataset) */
export enum IngestionSource {
  AbsCensus = 'ABS_CENSUS',
  BccAddresses = 'BCC_ADDRESSES',
  Cadastre = 'CADASTRE',
  CrimeStats = 'CRIME_STATS',
  Valuations = 'VALUATIONS'
}

export type Ingredient = {
  __typename?: 'Ingredient';
  category: IngredientCategory;
  conversions: Array<IngredientConversion>;
  createdAt: Scalars['DateTime']['output'];
  defaultUnit: UnitType;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  minOrderQty?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  priceHistory: Array<IngredientPriceHistoryEntry>;
  purchaseUnitsPerRecipeUnit?: Maybe<Scalars['Float']['output']>;
  purchasedUnit?: Maybe<UnitType>;
  shelfLifeDays?: Maybe<Scalars['Float']['output']>;
  storageInstructions?: Maybe<Scalars['String']['output']>;
  supplier?: Maybe<Supplier>;
  supplierId?: Maybe<Scalars['ID']['output']>;
  supplierSku?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  unitCost?: Maybe<Scalars['Float']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

/** Categories for organizing ingredients */
export enum IngredientCategory {
  Bakery = 'BAKERY',
  Beverages = 'BEVERAGES',
  Condiments = 'CONDIMENTS',
  Dairy = 'DAIRY',
  DryGoods = 'DRY_GOODS',
  Frozen = 'FROZEN',
  Meat = 'MEAT',
  Produce = 'PRODUCE',
  Seafood = 'SEAFOOD',
  Spices = 'SPICES'
}

export type IngredientConversion = {
  __typename?: 'IngredientConversion';
  fromUnit: UnitType;
  fromValue: Scalars['Float']['output'];
  note?: Maybe<Scalars['String']['output']>;
  toUnit: UnitType;
  toValue: Scalars['Float']['output'];
};

export type IngredientConversionInput = {
  fromUnit: UnitType;
  fromValue?: InputMaybe<Scalars['Float']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  toUnit: UnitType;
  toValue: Scalars['Float']['input'];
};

export type IngredientPriceHistoryEntry = {
  __typename?: 'IngredientPriceHistoryEntry';
  date: Scalars['DateTime']['output'];
  invoiceId?: Maybe<Scalars['ID']['output']>;
  newPrice?: Maybe<Scalars['Float']['output']>;
  oldPrice?: Maybe<Scalars['Float']['output']>;
  source?: Maybe<Scalars['String']['output']>;
};

/** Channel through which an inquiry first reached the facility */
export enum InquirySource {
  Email = 'EMAIL',
  Other = 'OTHER',
  Phone = 'PHONE',
  Referral = 'REFERRAL',
  WalkIn = 'WALK_IN',
  Website = 'WEBSITE'
}

export type InquirySourceCount = {
  __typename?: 'InquirySourceCount';
  count: Scalars['Int']['output'];
  /** null bucket = entries with no inquirySource recorded */
  source?: Maybe<InquirySource>;
};

export type IntegrationStatus = {
  __typename?: 'IntegrationStatus';
  configured: Scalars['Boolean']['output'];
  detail?: Maybe<Scalars['String']['output']>;
  system: Scalars['String']['output'];
};

/** Interaction cadence for a relationship (load weighting: daily 5 → rarely 1, fortnightly 3.5) */
export enum InteractionFrequency {
  Daily = 'DAILY',
  Fortnightly = 'FORTNIGHTLY',
  Monthly = 'MONTHLY',
  Quarterly = 'QUARTERLY',
  Rarely = 'RARELY',
  Weekly = 'WEEKLY'
}

export type InterpreterDetails = {
  __typename?: 'InterpreterDetails';
  contactAddress?: Maybe<Scalars['String']['output']>;
  contactName?: Maybe<Scalars['String']['output']>;
  contactPhone?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  required: Scalars['Boolean']['output'];
};

export type InterpreterDetailsInput = {
  contactAddress?: InputMaybe<Scalars['String']['input']>;
  contactName?: InputMaybe<Scalars['String']['input']>;
  contactPhone?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InterventionCompletion = {
  __typename?: 'InterventionCompletion';
  completedAt: Scalars['DateTime']['output'];
  completedBy: Scalars['ID']['output'];
  completedByName?: Maybe<Scalars['String']['output']>;
  durationMinutes?: Maybe<Scalars['Float']['output']>;
  missedReason?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  scheduledTime?: Maybe<Scalars['String']['output']>;
  wasMissed: Scalars['Boolean']['output'];
};

export type InterventionComplianceStats = {
  __typename?: 'InterventionComplianceStats';
  complianceRate: Scalars['Float']['output'];
  frequency: Scalars['String']['output'];
  interventionDescription: Scalars['String']['output'];
  interventionIndex: Scalars['Int']['output'];
  lastCompletedAt?: Maybe<Scalars['DateTime']['output']>;
  totalCompleted: Scalars['Int']['output'];
  totalExpected: Scalars['Int']['output'];
  totalMissed: Scalars['Int']['output'];
};

/** Frequency of intervention execution */
export enum InterventionFrequency {
  AsNeeded = 'AS_NEEDED',
  Daily = 'DAILY',
  Every_2Hours = 'EVERY_2_HOURS',
  Every_4Hours = 'EVERY_4_HOURS',
  EveryShift = 'EVERY_SHIFT',
  FourTimesDaily = 'FOUR_TIMES_DAILY',
  Hourly = 'HOURLY',
  Monthly = 'MONTHLY',
  Prn = 'PRN',
  ThreeTimesDaily = 'THREE_TIMES_DAILY',
  TwiceDaily = 'TWICE_DAILY',
  TwiceWeekly = 'TWICE_WEEKLY',
  Weekly = 'WEEKLY'
}

export type InterviewNote = {
  __typename?: 'InterviewNote';
  date: Scalars['DateTime']['output'];
  feedback?: Maybe<Scalars['String']['output']>;
  interviewerId?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Scalars['Float']['output']>;
};

export type InvestmentProject = {
  __typename?: 'InvestmentProject';
  businessModel?: Maybe<Scalars['String']['output']>;
  capitalRaised?: Maybe<Scalars['Float']['output']>;
  capitalRequired?: Maybe<Scalars['Float']['output']>;
  companyRegistration?: Maybe<Scalars['String']['output']>;
  coverImageUrl?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  documents?: Maybe<Array<ProjectDocument>>;
  galleryImageUrls?: Maybe<Array<Scalars['String']['output']>>;
  hasEmploymentContracts?: Maybe<Scalars['Boolean']['output']>;
  hasFullTimeEmployees?: Maybe<Scalars['Boolean']['output']>;
  hasPhysicalOffice?: Maybe<Scalars['Boolean']['output']>;
  highlights?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['ID']['output'];
  investmentCommitteeRole?: Maybe<Scalars['Boolean']['output']>;
  isPublic: Scalars['Boolean']['output'];
  location?: Maybe<Scalars['String']['output']>;
  minimumInvestment?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  passiveInvestmentMinimum?: Maybe<Scalars['Float']['output']>;
  risks?: Maybe<Array<Scalars['String']['output']>>;
  sector: ProjectSector;
  shortDescription?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  stage: ProjectStage;
  status: ProjectStatus;
  subSector?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  targetReturn?: Maybe<Scalars['String']['output']>;
  teamMembers?: Maybe<Array<ProjectTeamMember>>;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  visaSuitable?: Maybe<Scalars['Boolean']['output']>;
};

export type InvestmentProjectFilterInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sector?: InputMaybe<ProjectSector>;
  stage?: InputMaybe<ProjectStage>;
  status?: InputMaybe<ProjectStatus>;
  visaSuitable?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Investor = {
  __typename?: 'Investor';
  amlDocumentsReady?: Maybe<Scalars['Boolean']['output']>;
  assignedTo?: Maybe<Scalars['String']['output']>;
  clientId?: Maybe<Scalars['String']['output']>;
  countryOfOrigin?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  currentLocation?: Maybe<Scalars['String']['output']>;
  cvFileUrl?: Maybe<Scalars['String']['output']>;
  documents?: Maybe<Array<InvestorDocument>>;
  email?: Maybe<Scalars['String']['output']>;
  entrepreneurialExperience?: Maybe<Scalars['String']['output']>;
  fullName: Scalars['String']['output'];
  fundsAvailableLocally?: Maybe<Scalars['Boolean']['output']>;
  fundsTransferMethod?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  intentions?: Maybe<Scalars['String']['output']>;
  investmentBudgetMax?: Maybe<Scalars['Float']['output']>;
  investmentBudgetMin?: Maybe<Scalars['Float']['output']>;
  investorType: InvestorType;
  isActive: Scalars['Boolean']['output'];
  matchedProjectIds?: Maybe<Array<Scalars['String']['output']>>;
  notes?: Maybe<Array<InvestorNote>>;
  phone?: Maybe<Scalars['String']['output']>;
  priority: InvestorPriority;
  professionalBackground?: Maybe<Scalars['String']['output']>;
  riskTolerance?: Maybe<RiskTolerance>;
  sectorInterests?: Maybe<Array<Scalars['String']['output']>>;
  sourceOfFunds?: Maybe<Scalars['String']['output']>;
  sourceOfFundsVerified?: Maybe<Scalars['Boolean']['output']>;
  stage: InvestorStage;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  visaExpiryDate?: Maybe<Scalars['DateTime']['output']>;
  visaStatus?: Maybe<VisaStatus>;
  visaSubclass?: Maybe<Scalars['String']['output']>;
};

export type InvestorDocument = {
  __typename?: 'InvestorDocument';
  fileUrl: Scalars['String']['output'];
  name: Scalars['String']['output'];
  type: InvestorDocumentType;
  uploadedAt: Scalars['DateTime']['output'];
  verified: Scalars['Boolean']['output'];
};

/** Type of investor document */
export enum InvestorDocumentType {
  BusinessPlan = 'BUSINESS_PLAN',
  Cv = 'CV',
  FinancialStatement = 'FINANCIAL_STATEMENT',
  Other = 'OTHER',
  Passport = 'PASSPORT',
  SourceOfFunds = 'SOURCE_OF_FUNDS'
}

export type InvestorFilterInput = {
  fundsAvailableLocally?: InputMaybe<Scalars['Boolean']['input']>;
  investorType?: InputMaybe<InvestorType>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  priority?: InputMaybe<InvestorPriority>;
  search?: InputMaybe<Scalars['String']['input']>;
  stage?: InputMaybe<InvestorStage>;
};

export type InvestorNote = {
  __typename?: 'InvestorNote';
  content: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  type: InvestorNoteType;
};

/** Type of investor note/activity */
export enum InvestorNoteType {
  Call = 'CALL',
  Email = 'EMAIL',
  Meeting = 'MEETING',
  Note = 'NOTE'
}

export type InvestorPipelineCount = {
  __typename?: 'InvestorPipelineCount';
  count: Scalars['Int']['output'];
  stage: Scalars['String']['output'];
};

/** Investor priority level */
export enum InvestorPriority {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM',
  Urgent = 'URGENT'
}

/** Investor pipeline stage */
export enum InvestorStage {
  AmlCheck = 'AML_CHECK',
  Completed = 'COMPLETED',
  DueDiligence = 'DUE_DILIGENCE',
  FundsVerified = 'FUNDS_VERIFIED',
  InitialContact = 'INITIAL_CONTACT',
  InvestmentCommitted = 'INVESTMENT_COMMITTED',
  Matched = 'MATCHED',
  ProfileReceived = 'PROFILE_RECEIVED',
  VisaGranted = 'VISA_GRANTED',
  VisaLodged = 'VISA_LODGED'
}

/** Type of investor */
export enum InvestorType {
  MigrationVisa = 'MIGRATION_VISA',
  SophisticatedInvestor = 'SOPHISTICATED_INVESTOR',
  StrategicPartner = 'STRATEGIC_PARTNER'
}

/** Status of calendar invitation */
export enum InvitationStatus {
  Accepted = 'ACCEPTED',
  Declined = 'DECLINED',
  Expired = 'EXPIRED',
  Pending = 'PENDING'
}

/** Type of invitation sent */
export enum InvitationType {
  Email = 'EMAIL',
  Link = 'LINK',
  Sms = 'SMS'
}

export type InviteBuildClientInput = {
  dealId: Scalars['ID']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  sendEmail?: InputMaybe<Scalars['Boolean']['input']>;
  sendSms?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InviteBuildClientResult = {
  __typename?: 'InviteBuildClientResult';
  access: BuildAccessView;
  matchedExisting: Scalars['Boolean']['output'];
  outcome: BuildNotifyOutcome;
};

/** Which channels to send a candidate invite through */
export enum InviteChannel {
  Email = 'EMAIL',
  Sms = 'SMS'
}

export type InviteProgramMemberInput = {
  channel: ProgramChannel;
  email?: InputMaybe<Scalars['String']['input']>;
  fName?: InputMaybe<Scalars['String']['input']>;
  lName?: InputMaybe<Scalars['String']['input']>;
  leadId?: InputMaybe<Scalars['ID']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type Invoice = {
  __typename?: 'Invoice';
  billingAddress?: Maybe<Scalars['String']['output']>;
  billingEmail?: Maybe<Scalars['String']['output']>;
  client: Client;
  createdAt: Scalars['DateTime']['output'];
  currency: Scalars['String']['output'];
  discountAmount: Scalars['Float']['output'];
  dueDate: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  invoiceNumber: Scalars['String']['output'];
  lineItems: Array<InvoiceLine>;
  notes?: Maybe<Scalars['String']['output']>;
  paidAt?: Maybe<Scalars['DateTime']['output']>;
  pdfUrl?: Maybe<Scalars['String']['output']>;
  status: InvoiceStatus;
  stripeInvoiceId?: Maybe<Scalars['String']['output']>;
  stripePaymentIntentId?: Maybe<Scalars['String']['output']>;
  subscription?: Maybe<BillingSubscription>;
  subtotal: Scalars['Float']['output'];
  taxAmount: Scalars['Float']['output'];
  tenantId: Scalars['String']['output'];
  total: Scalars['Float']['output'];
  type: InvoiceType;
  updatedAt: Scalars['DateTime']['output'];
  voidedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type InvoiceInput = {
  billingAddress?: InputMaybe<Scalars['String']['input']>;
  billingEmail?: InputMaybe<Scalars['String']['input']>;
  clientId: Scalars['ID']['input'];
  currency: Scalars['String']['input'];
  discountAmount?: InputMaybe<Scalars['Float']['input']>;
  dueDate: Scalars['String']['input'];
  lineItems: Array<InvoiceLineInput>;
  notes?: InputMaybe<Scalars['String']['input']>;
  subscriptionId?: InputMaybe<Scalars['ID']['input']>;
  subtotal: Scalars['Float']['input'];
  taxAmount?: InputMaybe<Scalars['Float']['input']>;
  total: Scalars['Float']['input'];
  type: InvoiceType;
};

export type InvoiceLine = {
  __typename?: 'InvoiceLine';
  amount: Scalars['Float']['output'];
  description: Scalars['String']['output'];
  metadata?: Maybe<Scalars['String']['output']>;
  quantity: Scalars['Float']['output'];
  unitPrice: Scalars['Float']['output'];
};

export type InvoiceLineInput = {
  amount: Scalars['Float']['input'];
  description: Scalars['String']['input'];
  metadata?: InputMaybe<Scalars['String']['input']>;
  quantity: Scalars['Float']['input'];
  unitPrice: Scalars['Float']['input'];
};

/** Whether an invoice line item mapped to an existing ingredient */
export enum InvoiceLineItemMatchStatus {
  ManualMap = 'MANUAL_MAP',
  Matched = 'MATCHED',
  Unmatched = 'UNMATCHED'
}

export enum InvoiceStatus {
  Draft = 'DRAFT',
  Open = 'OPEN',
  Paid = 'PAID',
  Uncollectible = 'UNCOLLECTIBLE',
  Void = 'VOID'
}

export enum InvoiceType {
  Manual = 'MANUAL',
  OneTime = 'ONE_TIME',
  Subscription = 'SUBSCRIPTION',
  Usage = 'USAGE'
}

export type IpfsNode = {
  __typename?: 'IpfsNode';
  apiBase: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  gatewayUrl: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isPrimary: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
  lastStat?: Maybe<IpfsRepoStat>;
  location?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  role: IpfsNodeRole;
  tailscaleUrl?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type IpfsNodeInput = {
  apiBase: Scalars['String']['input'];
  gatewayUrl: Scalars['String']['input'];
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>;
  label: Scalars['String']['input'];
  location?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<IpfsNodeRole>;
  tailscaleUrl?: InputMaybe<Scalars['String']['input']>;
};

/** Role of an IPFS node in the fleet */
export enum IpfsNodeRole {
  Medical = 'MEDICAL',
  Primary = 'PRIMARY',
  Replica = 'REPLICA'
}

export type IpfsRepoStat = {
  __typename?: 'IpfsRepoStat';
  checkedAt?: Maybe<Scalars['DateTime']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  numObjects?: Maybe<Scalars['Float']['output']>;
  numPins?: Maybe<Scalars['Float']['output']>;
  online?: Maybe<Scalars['Boolean']['output']>;
  repoSize?: Maybe<Scalars['Float']['output']>;
  storageMax?: Maybe<Scalars['Float']['output']>;
};

export type IssuePreorderInvoicesResult = {
  __typename?: 'IssuePreorderInvoicesResult';
  errors: Array<Scalars['String']['output']>;
  invoicesCreated: Scalars['Int']['output'];
  skipped: Scalars['Int']['output'];
};

export type IssueRewardTokenInput = {
  clientId: Scalars['ID']['input'];
  issueDetails?: InputMaybe<Scalars['String']['input']>;
  issueReason: Scalars['String']['input'];
  payableToBank?: InputMaybe<Scalars['Boolean']['input']>;
  referredClientId?: InputMaybe<Scalars['ID']['input']>;
  sendEmail?: InputMaybe<Scalars['Boolean']['input']>;
  sendSms?: InputMaybe<Scalars['Boolean']['input']>;
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type Job = {
  __typename?: 'Job';
  allowedRoleIds?: Maybe<Array<Scalars['String']['output']>>;
  area?: Maybe<Scalars['String']['output']>;
  category: JobCategory;
  checklist?: Maybe<Array<JobChecklistItem>>;
  color?: Maybe<Scalars['String']['output']>;
  complianceCode?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  dayOfMonth?: Maybe<Scalars['Float']['output']>;
  daysOfWeek?: Maybe<Array<DayOfWeek>>;
  departmentId?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  effectiveFrom?: Maybe<Scalars['DateTime']['output']>;
  effectiveUntil?: Maybe<Scalars['DateTime']['output']>;
  estimatedDurationMinutes: Scalars['Float']['output'];
  frequency: JobFrequency;
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  instructions?: Maybe<Scalars['String']['output']>;
  isActive: Scalars['Boolean']['output'];
  lastModifiedBy?: Maybe<Scalars['String']['output']>;
  locationId?: Maybe<Scalars['String']['output']>;
  locationName?: Maybe<Scalars['String']['output']>;
  metadata?: Maybe<Scalars['JSONObject']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  priority: JobPriority;
  requiredCertifications?: Maybe<Array<Scalars['String']['output']>>;
  requiredEquipment?: Maybe<Array<Scalars['String']['output']>>;
  requiredSkills?: Maybe<Array<Scalars['String']['output']>>;
  requiredStaffCount: Scalars['Float']['output'];
  requiredSupplies?: Maybe<Array<Scalars['String']['output']>>;
  requiresDocumentation: Scalars['Boolean']['output'];
  requiresSignOff: Scalars['Boolean']['output'];
  safetyNotes?: Maybe<Array<Scalars['String']['output']>>;
  status: JobStatus;
  steps?: Maybe<Array<Scalars['String']['output']>>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  tenantId: Scalars['String']['output'];
  timeWindow?: Maybe<TimeWindow>;
  timezone?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** Type of activity in job progress notes */
export enum JobActivityType {
  ChecklistItemCompleted = 'CHECKLIST_ITEM_COMPLETED',
  CustomerNotified = 'CUSTOMER_NOTIFIED',
  FinancialActivity = 'FINANCIAL_ACTIVITY',
  MechanicAssigned = 'MECHANIC_ASSIGNED',
  NoteAdded = 'NOTE_ADDED',
  PartsOrdered = 'PARTS_ORDERED',
  PartsReceived = 'PARTS_RECEIVED',
  PhotoAdded = 'PHOTO_ADDED',
  StatusChange = 'STATUS_CHANGE',
  VideoAdded = 'VIDEO_ADDED',
  WorkCompleted = 'WORK_COMPLETED',
  WorkStarted = 'WORK_STARTED'
}

/** Category of job */
export enum JobCategory {
  Activities = 'ACTIVITIES',
  Admin = 'ADMIN',
  Care = 'CARE',
  Cleaning = 'CLEANING',
  Kitchen = 'KITCHEN',
  Laundry = 'LAUNDRY',
  Maintenance = 'MAINTENANCE',
  Medication = 'MEDICATION',
  Other = 'OTHER',
  Safety = 'SAFETY',
  Transport = 'TRANSPORT'
}

export type JobChecklist = {
  __typename?: 'JobChecklist';
  category?: Maybe<Scalars['String']['output']>;
  completed: Scalars['Boolean']['output'];
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  completedBy?: Maybe<Scalars['String']['output']>;
  completedByPhone?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  order: Scalars['Float']['output'];
  text: Scalars['String']['output'];
};

export type JobChecklistItem = {
  __typename?: 'JobChecklistItem';
  description?: Maybe<Scalars['String']['output']>;
  isRequired: Scalars['Boolean']['output'];
  order: Scalars['Float']['output'];
  title: Scalars['String']['output'];
};

export type JobChecklistItemInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  isRequired: Scalars['Boolean']['input'];
  order: Scalars['Float']['input'];
  title: Scalars['String']['input'];
};

/** How often a job needs to be done */
export enum JobFrequency {
  AsNeeded = 'AS_NEEDED',
  Daily = 'DAILY',
  Fortnightly = 'FORTNIGHTLY',
  Monthly = 'MONTHLY',
  Once = 'ONCE',
  Quarterly = 'QUARTERLY',
  Weekly = 'WEEKLY',
  Yearly = 'YEARLY'
}

export type JobInput = {
  allowedRoleIds?: InputMaybe<Array<Scalars['String']['input']>>;
  area?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<JobCategory>;
  checklist?: InputMaybe<Array<JobChecklistItemInput>>;
  color?: InputMaybe<Scalars['String']['input']>;
  complianceCode?: InputMaybe<Scalars['String']['input']>;
  dayOfMonth?: InputMaybe<Scalars['Float']['input']>;
  daysOfWeek?: InputMaybe<Array<DayOfWeek>>;
  departmentId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  effectiveFrom?: InputMaybe<Scalars['DateTime']['input']>;
  effectiveUntil?: InputMaybe<Scalars['DateTime']['input']>;
  estimatedDurationMinutes?: InputMaybe<Scalars['Float']['input']>;
  frequency?: InputMaybe<JobFrequency>;
  icon?: InputMaybe<Scalars['String']['input']>;
  instructions?: InputMaybe<Scalars['String']['input']>;
  locationId?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['JSONObject']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<JobPriority>;
  requiredCertifications?: InputMaybe<Array<Scalars['String']['input']>>;
  requiredEquipment?: InputMaybe<Array<Scalars['String']['input']>>;
  requiredSkills?: InputMaybe<Array<Scalars['String']['input']>>;
  requiredStaffCount?: InputMaybe<Scalars['Float']['input']>;
  requiredSupplies?: InputMaybe<Array<Scalars['String']['input']>>;
  requiresDocumentation?: InputMaybe<Scalars['Boolean']['input']>;
  requiresSignOff?: InputMaybe<Scalars['Boolean']['input']>;
  safetyNotes?: InputMaybe<Array<Scalars['String']['input']>>;
  steps?: InputMaybe<Array<Scalars['String']['input']>>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  timeWindow?: InputMaybe<TimeWindowInput>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export type JobMedia = {
  __typename?: 'JobMedia';
  activityType?: Maybe<MediaActivityType>;
  cid?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isAutoPlay: Scalars['Boolean']['output'];
  mimeType?: Maybe<Scalars['String']['output']>;
  thumbnailCid?: Maybe<Scalars['String']['output']>;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  uploadedAt: Scalars['DateTime']['output'];
  uploadedBy?: Maybe<Scalars['ID']['output']>;
  uploadedByName?: Maybe<Scalars['String']['output']>;
  uploadedByPhone?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

export type JobMediaInput = {
  activityType?: InputMaybe<MediaActivityType>;
  cid?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isAutoPlay?: InputMaybe<Scalars['Boolean']['input']>;
  mimeType?: InputMaybe<Scalars['String']['input']>;
  thumbnailCid?: InputMaybe<Scalars['String']['input']>;
  thumbnailUrl?: InputMaybe<Scalars['String']['input']>;
  url: Scalars['String']['input'];
};

/** Priority level of a job */
export enum JobPriority {
  Critical = 'CRITICAL',
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM'
}

export type JobProgressNote = {
  __typename?: 'JobProgressNote';
  action: Scalars['String']['output'];
  activityType: JobActivityType;
  attachments?: Maybe<Array<JobMedia>>;
  details?: Maybe<Scalars['String']['output']>;
  financialAmount?: Maybe<Scalars['Float']['output']>;
  financialCategory?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isFinancialActivity: Scalars['Boolean']['output'];
  newValue?: Maybe<Scalars['String']['output']>;
  performedAt: Scalars['DateTime']['output'];
  performedBy: Scalars['String']['output'];
  performedById?: Maybe<Scalars['ID']['output']>;
  performedByPhone?: Maybe<Scalars['String']['output']>;
  previousValue?: Maybe<Scalars['String']['output']>;
};

export type JobReportFilterInput = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  mechanicPhone?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<MechanicJobStatus>;
  supplierId?: InputMaybe<Scalars['ID']['input']>;
};

/** Status of a job definition */
export enum JobStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
  Draft = 'DRAFT',
  Paused = 'PAUSED'
}

export type JobVehicle = {
  __typename?: 'JobVehicle';
  color?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<Scalars['ID']['output']>;
  createdByName?: Maybe<Scalars['String']['output']>;
  currentOdometer?: Maybe<Scalars['Float']['output']>;
  engineCode?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isDeleted: Scalars['Boolean']['output'];
  make: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  ownerEmail?: Maybe<Scalars['String']['output']>;
  ownerName?: Maybe<Scalars['String']['output']>;
  ownerPhone?: Maybe<Scalars['String']['output']>;
  photoCid?: Maybe<Scalars['String']['output']>;
  photoUrl?: Maybe<Scalars['String']['output']>;
  registration?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  transmissionType?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  variant?: Maybe<Scalars['String']['output']>;
  vehicleModel: Scalars['String']['output'];
  vehicleNumber?: Maybe<Scalars['Float']['output']>;
  vehicleType: VehicleType;
  vin?: Maybe<Scalars['String']['output']>;
  year?: Maybe<Scalars['String']['output']>;
};

export type JobVehicleFilterInput = {
  make?: InputMaybe<Scalars['String']['input']>;
  ownerName?: InputMaybe<Scalars['String']['input']>;
  ownerPhone?: InputMaybe<Scalars['String']['input']>;
  registration?: InputMaybe<Scalars['String']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  vehicleModel?: InputMaybe<Scalars['String']['input']>;
  vehicleType?: InputMaybe<VehicleType>;
};

export type JobVehicleRef = {
  __typename?: 'JobVehicleRef';
  make: Scalars['String']['output'];
  photoCid?: Maybe<Scalars['String']['output']>;
  photoUrl?: Maybe<Scalars['String']['output']>;
  registration?: Maybe<Scalars['String']['output']>;
  variant?: Maybe<Scalars['String']['output']>;
  vehicleId: Scalars['ID']['output'];
  vehicleModel: Scalars['String']['output'];
  year?: Maybe<Scalars['String']['output']>;
};

export type JobVehicleRefInput = {
  make: Scalars['String']['input'];
  photoCid?: InputMaybe<Scalars['String']['input']>;
  photoUrl?: InputMaybe<Scalars['String']['input']>;
  registration?: InputMaybe<Scalars['String']['input']>;
  variant?: InputMaybe<Scalars['String']['input']>;
  vehicleId: Scalars['ID']['input'];
  vehicleModel: Scalars['String']['input'];
  year?: InputMaybe<Scalars['String']['input']>;
};

export type JoinChatRoomResponse = {
  __typename?: 'JoinChatRoomResponse';
  anonToken?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  participantId: Scalars['String']['output'];
  participantType: SenderType;
  roomId: Scalars['String']['output'];
};

export type JoinWaitlistInput = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  source?: InputMaybe<Scalars['String']['input']>;
  tag?: InputMaybe<Scalars['String']['input']>;
};

export type JoinWaitlistResult = {
  __typename?: 'JoinWaitlistResult';
  alreadyJoined?: Maybe<Scalars['Boolean']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type JourneyContext = {
  __typename?: 'JourneyContext';
  chasePromptTemplate?: Maybe<Scalars['String']['output']>;
  clientGoal?: Maybe<Scalars['String']['output']>;
  currentMilestoneDescription?: Maybe<Scalars['String']['output']>;
  currentMilestoneId?: Maybe<Scalars['String']['output']>;
  currentMilestoneLabel?: Maybe<Scalars['String']['output']>;
  isTracked: Scalars['Boolean']['output'];
  journeyName?: Maybe<Scalars['String']['output']>;
  nextActionLabel?: Maybe<Scalars['String']['output']>;
  nextActionUrl?: Maybe<Scalars['String']['output']>;
  trackedClientId?: Maybe<Scalars['String']['output']>;
};

export type JourneyMilestone = {
  __typename?: 'JourneyMilestone';
  chasePromptTemplate?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  detectionQuery?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
  nextActionLabel?: Maybe<Scalars['String']['output']>;
  nextActionUrl?: Maybe<Scalars['String']['output']>;
};

export type JourneyMilestoneInput = {
  chasePromptTemplate?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  detectionQuery?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  label: Scalars['String']['input'];
  nextActionLabel?: InputMaybe<Scalars['String']['input']>;
  nextActionUrl?: InputMaybe<Scalars['String']['input']>;
};

export type JourneyTemplate = {
  __typename?: 'JourneyTemplate';
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  milestones: Array<JourneyMilestone>;
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type KeyValueAnswer = {
  __typename?: 'KeyValueAnswer';
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type KeyValueAnswerInput = {
  key: Scalars['String']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
};

export type Kitchen = {
  __typename?: 'Kitchen';
  captureCount: Scalars['Float']['output'];
  captureCountMonth?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  isPersonalShelf: Scalars['Boolean']['output'];
  logoCid?: Maybe<Scalars['String']['output']>;
  logoUrl?: Maybe<Scalars['String']['output']>;
  memberCount: Scalars['Float']['output'];
  members: Array<KitchenMember>;
  name: Scalars['String']['output'];
  ownerClientId: Scalars['ID']['output'];
  tenantId: Scalars['String']['output'];
  tier: KitchenTier;
  timezone?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type KitchenMember = {
  __typename?: 'KitchenMember';
  clientId: Scalars['ID']['output'];
  displayName?: Maybe<Scalars['String']['output']>;
  joinedAt?: Maybe<Scalars['DateTime']['output']>;
  role: KitchenMemberRole;
  sections?: Maybe<Array<Scalars['String']['output']>>;
};

export type KitchenMemberInput = {
  clientId: Scalars['ID']['input'];
  role?: InputMaybe<KitchenMemberRole>;
  sections?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** A person's role within one kitchen */
export enum KitchenMemberRole {
  Chef = 'CHEF',
  Owner = 'OWNER',
  Staff = 'STAFF'
}

/** Whether this kitchen is on the free recipe book or the paid Shelv Pro tier */
export enum KitchenTier {
  Free = 'FREE',
  Pro = 'PRO'
}

/** Which machine serves the knowledge folder a research base is written to */
export enum KnowledgeHost {
  Custom = 'CUSTOM',
  Local = 'LOCAL',
  Macstudio = 'MACSTUDIO'
}

export type KnowledgeRootInfo = {
  __typename?: 'KnowledgeRootInfo';
  base: Scalars['String']['output'];
  exists: Scalars['Boolean']['output'];
  roots: Array<Scalars['String']['output']>;
  tenantsOnRoot: Scalars['Int']['output'];
};

export type LmCertificate = {
  __typename?: 'LMCertificate';
  certificateSlug: Scalars['String']['output'];
  completedAt: Scalars['DateTime']['output'];
  courseId: Scalars['ID']['output'];
  courseName: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  credentialId?: Maybe<Scalars['String']['output']>;
  enrollmentId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  instructorName?: Maybe<Scalars['String']['output']>;
  studentName: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  userId: Scalars['ID']['output'];
};

export type LmCourse = {
  __typename?: 'LMCourse';
  authorClientIds: Array<Scalars['ID']['output']>;
  authors: Array<LmCourseAuthor>;
  canEdit: Scalars['Boolean']['output'];
  categorySlug?: Maybe<Scalars['String']['output']>;
  completionRate?: Maybe<Scalars['Float']['output']>;
  courseSlug?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdById: Scalars['ID']['output'];
  dailyRemindersEnabled: Scalars['Boolean']['output'];
  description?: Maybe<Scalars['String']['output']>;
  enrollmentCount?: Maybe<Scalars['Float']['output']>;
  estimatedDuration?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  instructorName?: Maybe<Scalars['String']['output']>;
  isPublic: Scalars['Boolean']['output'];
  isPublished: Scalars['Boolean']['output'];
  moduleIds: Array<Scalars['String']['output']>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  tenantId: Scalars['String']['output'];
  thumbnailCid?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type LmCourseAnalytics = {
  __typename?: 'LMCourseAnalytics';
  activeEnrollments: Scalars['Float']['output'];
  averageProgress: Scalars['Float']['output'];
  certificatesIssued: Scalars['Float']['output'];
  completedEnrollments: Scalars['Float']['output'];
  courseId: Scalars['ID']['output'];
  courseTitle: Scalars['String']['output'];
  totalEnrollments: Scalars['Float']['output'];
};

export type LmCourseAuthor = {
  __typename?: 'LMCourseAuthor';
  clientId: Scalars['ID']['output'];
  email?: Maybe<Scalars['String']['output']>;
  isCreator: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export type LmCourseInput = {
  authorClientIds?: InputMaybe<Array<Scalars['String']['input']>>;
  categorySlug?: InputMaybe<Scalars['String']['input']>;
  courseSlug?: InputMaybe<Scalars['String']['input']>;
  dailyRemindersEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  instructorName?: InputMaybe<Scalars['String']['input']>;
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  thumbnailCid?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export type LmCourseSubscriptionLink = {
  __typename?: 'LMCourseSubscriptionLink';
  courseId: Scalars['String']['output'];
  salesPageUrl?: Maybe<Scalars['String']['output']>;
  subscriptionAmount: Scalars['Float']['output'];
  subscriptionId: Scalars['String']['output'];
  subscriptionName: Scalars['String']['output'];
  subscriptionSlug: Scalars['String']['output'];
};

export type LmEnrollment = {
  __typename?: 'LMEnrollment';
  certificateGenerated: Scalars['Boolean']['output'];
  certificateId?: Maybe<Scalars['String']['output']>;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  completedLessonIds: Array<Scalars['String']['output']>;
  courseId: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  enrolledAt: Scalars['DateTime']['output'];
  enrollmentSource?: Maybe<LmEnrollmentSource>;
  id: Scalars['ID']['output'];
  lastAccessedAt?: Maybe<Scalars['DateTime']['output']>;
  lastAccessedLessonId?: Maybe<Scalars['String']['output']>;
  lastReminderSentAt?: Maybe<Scalars['DateTime']['output']>;
  progressPercentage: Scalars['Float']['output'];
  remindersOptedOut: Scalars['Boolean']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  userId: Scalars['ID']['output'];
};

/** How the enrollment was created */
export enum LmEnrollmentSource {
  Admin = 'ADMIN',
  EmployeeAssignment = 'EMPLOYEE_ASSIGNMENT',
  Self = 'SELF',
  Subscription = 'SUBSCRIPTION'
}

export type LmGenerateLessonContentInput = {
  brandAccent?: InputMaybe<Scalars['String']['input']>;
  brandPrimary?: InputMaybe<Scalars['String']['input']>;
  brandSecondary?: InputMaybe<Scalars['String']['input']>;
  contentType?: InputMaybe<Scalars['String']['input']>;
  courseDescription?: InputMaybe<Scalars['String']['input']>;
  courseTitle: Scalars['String']['input'];
  currentContent?: InputMaybe<Scalars['String']['input']>;
  customInstructions: Scalars['String']['input'];
  lessonDescription?: InputMaybe<Scalars['String']['input']>;
  lessonTitle: Scalars['String']['input'];
  moduleTitle: Scalars['String']['input'];
};

export type LmGenerateLessonContentResult = {
  __typename?: 'LMGenerateLessonContentResult';
  aiNotes?: Maybe<Scalars['String']['output']>;
  contentMarkdown: Scalars['String']['output'];
};

export type LmLesson = {
  __typename?: 'LMLesson';
  attachments?: Maybe<Array<LmLessonAttachment>>;
  contentMarkdown?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  isPreview: Scalars['Boolean']['output'];
  moduleId: Scalars['ID']['output'];
  orderIndex: Scalars['Int']['output'];
  references?: Maybe<Array<LmReference>>;
  stickyVideos?: Maybe<Array<LmStickyVideo>>;
  tenantId: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  videoCid?: Maybe<Scalars['String']['output']>;
  videoFileSize?: Maybe<Scalars['Float']['output']>;
  videoMimeType?: Maybe<Scalars['String']['output']>;
  videoSticky?: Maybe<Scalars['Boolean']['output']>;
};

export type LmLessonAttachment = {
  __typename?: 'LMLessonAttachment';
  cid?: Maybe<Scalars['String']['output']>;
  fileSize?: Maybe<Scalars['Int']['output']>;
  mimeType: Scalars['String']['output'];
  name: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type LmLessonAttachmentInput = {
  cid?: InputMaybe<Scalars['String']['input']>;
  fileSize?: InputMaybe<Scalars['Int']['input']>;
  mimeType: Scalars['String']['input'];
  name: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export type LmLessonInput = {
  attachments?: InputMaybe<Array<LmLessonAttachmentInput>>;
  contentMarkdown?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['Float']['input']>;
  isPreview?: InputMaybe<Scalars['Boolean']['input']>;
  references?: InputMaybe<Array<LmReferenceInput>>;
  stickyVideos?: InputMaybe<Array<LmStickyVideoInput>>;
  title: Scalars['String']['input'];
  videoCid?: InputMaybe<Scalars['String']['input']>;
  videoFileSize?: InputMaybe<Scalars['Float']['input']>;
  videoMimeType?: InputMaybe<Scalars['String']['input']>;
  videoSticky?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LmModule = {
  __typename?: 'LMModule';
  courseId: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  estimatedDuration?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  lessonIds: Array<Scalars['String']['output']>;
  orderIndex: Scalars['Int']['output'];
  tenantId: Scalars['String']['output'];
  thumbnailCid?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type LmModuleInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  thumbnailCid?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export type LmOverallAnalytics = {
  __typename?: 'LMOverallAnalytics';
  activeEnrollments: Scalars['Float']['output'];
  averageCompletionRate: Scalars['Float']['output'];
  certificatesIssued: Scalars['Float']['output'];
  completedEnrollments: Scalars['Float']['output'];
  courseBreakdown: Array<LmCourseAnalytics>;
  publishedCourses: Scalars['Float']['output'];
  totalCourses: Scalars['Float']['output'];
  totalEnrollments: Scalars['Float']['output'];
};

export type LmReference = {
  __typename?: 'LMReference';
  label: Scalars['String']['output'];
  note?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type LmReferenceInput = {
  label: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type LmSettings = {
  __typename?: 'LMSettings';
  autoMarkOnNext: Scalars['Boolean']['output'];
  autoMarkOnView: Scalars['Boolean']['output'];
  autoMarkScrollThreshold: Scalars['Float']['output'];
  autoMarkTimeThresholdMs: Scalars['Float']['output'];
  autoMarkVideoThreshold: Scalars['Float']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  showMarkCompleteButton: Scalars['Boolean']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type LmStickyVideo = {
  __typename?: 'LMStickyVideo';
  corner?: Maybe<Scalars['String']['output']>;
  headingText: Scalars['String']['output'];
  url?: Maybe<Scalars['String']['output']>;
  videoCid?: Maybe<Scalars['String']['output']>;
  videoMimeType?: Maybe<Scalars['String']['output']>;
};

export type LmStickyVideoInput = {
  corner?: InputMaybe<Scalars['String']['input']>;
  headingText: Scalars['String']['input'];
  videoCid?: InputMaybe<Scalars['String']['input']>;
  videoMimeType?: InputMaybe<Scalars['String']['input']>;
};

/** Method for recording level of consciousness */
export enum LocMethod {
  CustomList = 'CUSTOM_LIST',
  GlasgowComaScale = 'GLASGOW_COMA_SCALE',
  PredefinedList = 'PREDEFINED_LIST'
}

export type LandValuation = {
  __typename?: 'LandValuation';
  createdAt: Scalars['DateTime']['output'];
  effectiveDate: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  parcelId: Scalars['ID']['output'];
  /** Statutory site value in AUD */
  siteValueAud: Scalars['Float']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  valuationSource: ValuationSource;
};

/** Language proficiency level */
export enum LanguageProficiency {
  Conversational = 'CONVERSATIONAL',
  Fluent = 'FLUENT',
  Native = 'NATIVE',
  Professional = 'PROFESSIONAL'
}

export type LaunchedSite = {
  __typename?: 'LaunchedSite';
  accentColor?: Maybe<Scalars['String']['output']>;
  adminEmails?: Maybe<Array<Scalars['String']['output']>>;
  adminPhoneNumbers?: Maybe<Array<Scalars['String']['output']>>;
  businessName?: Maybe<Scalars['String']['output']>;
  businessType?: Maybe<Scalars['String']['output']>;
  clientId?: Maybe<Scalars['String']['output']>;
  contactEmail?: Maybe<Scalars['String']['output']>;
  contactName?: Maybe<Scalars['String']['output']>;
  contactPhone?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  domain?: Maybe<Scalars['String']['output']>;
  enabledModules?: Maybe<Array<Scalars['String']['output']>>;
  githubCollaborators?: Maybe<Array<Scalars['String']['output']>>;
  githubOwner?: Maybe<Scalars['String']['output']>;
  githubRepo?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  industry?: Maybe<Scalars['String']['output']>;
  linkedTenantId: Scalars['String']['output'];
  logoEmoji?: Maybe<Scalars['String']['output']>;
  monthlyFee?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  opportunityId?: Maybe<Scalars['String']['output']>;
  postmarkSenderSignatureId?: Maybe<Scalars['Float']['output']>;
  postmarkServerId?: Maybe<Scalars['String']['output']>;
  primaryColor?: Maybe<Scalars['String']['output']>;
  provisioningError?: Maybe<Scalars['String']['output']>;
  provisioningLog?: Maybe<Array<ProvisioningLogEntry>>;
  provisioningStatus: ProvisioningStatus;
  provisioningStep: Scalars['Float']['output'];
  resellerId?: Maybe<Scalars['String']['output']>;
  resellerName?: Maybe<Scalars['String']['output']>;
  secondaryColor?: Maybe<Scalars['String']['output']>;
  setupFee?: Maybe<Scalars['Float']['output']>;
  siteName?: Maybe<Scalars['String']['output']>;
  siteSpec?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  tagline?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  vercelProjectId?: Maybe<Scalars['String']['output']>;
  vercelTeamId?: Maybe<Scalars['String']['output']>;
  vercelUrl?: Maybe<Scalars['String']['output']>;
};

export type Lead = {
  __typename?: 'Lead';
  convertedAt?: Maybe<Scalars['DateTime']['output']>;
  convertedToClientId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  customFields?: Maybe<Scalars['JSON']['output']>;
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  formId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  ipAddress?: Maybe<Scalars['String']['output']>;
  isArchived: Scalars['Boolean']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  source: LeadSource;
  stageId?: Maybe<Scalars['String']['output']>;
  stageName?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  tenantId: Scalars['String']['output'];
  tokenName?: Maybe<Scalars['String']['output']>;
  tokensAwarded?: Maybe<Scalars['Float']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  userAgent?: Maybe<Scalars['String']['output']>;
};

export type LeadFlowAction = {
  __typename?: 'LeadFlowAction';
  body: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  isHtml: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  subject?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  type: LeadFlowActionType;
  updatedAt: Scalars['DateTime']['output'];
};

export type LeadFlowActionLog = {
  __typename?: 'LeadFlowActionLog';
  actionId?: Maybe<Scalars['String']['output']>;
  body?: Maybe<Scalars['String']['output']>;
  channel: LeadFlowActionType;
  createdAt: Scalars['DateTime']['output'];
  errorMessage?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  leadId: Scalars['String']['output'];
  sentAt: Scalars['DateTime']['output'];
  status: LeadFlowActionLogStatus;
  subject?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** Status of a sent action */
export enum LeadFlowActionLogStatus {
  Failed = 'FAILED',
  Sent = 'SENT'
}

/** Type of action to send to a lead */
export enum LeadFlowActionType {
  Email = 'EMAIL',
  Sms = 'SMS'
}

export type LeadFlowEmailBranding = {
  __typename?: 'LeadFlowEmailBranding';
  accentColor?: Maybe<Scalars['String']['output']>;
  bannerImageCid?: Maybe<Scalars['String']['output']>;
  bannerImageUrl?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  ctaButtonStyle?: Maybe<CtaButtonStyle>;
  ctaButtonText?: Maybe<Scalars['String']['output']>;
  ctaButtonUrl?: Maybe<Scalars['String']['output']>;
  emailFont?: Maybe<EmailFont>;
  emailFooterText?: Maybe<Scalars['String']['output']>;
  emailStyle?: Maybe<EmailStyle>;
  hideSiteName?: Maybe<Scalars['Boolean']['output']>;
  hideTagline?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  penName?: Maybe<Scalars['String']['output']>;
  previewSampleBody?: Maybe<Scalars['String']['output']>;
  primaryColor?: Maybe<Scalars['String']['output']>;
  profilePhotoCid?: Maybe<Scalars['String']['output']>;
  profilePhotoSize?: Maybe<Scalars['Int']['output']>;
  profilePhotoUrl?: Maybe<Scalars['String']['output']>;
  secondaryColor?: Maybe<Scalars['String']['output']>;
  signatureImageCid?: Maybe<Scalars['String']['output']>;
  signatureImageUrl?: Maybe<Scalars['String']['output']>;
  socialIconStyle?: Maybe<SocialIconStyle>;
  socialLinks?: Maybe<TenantSocialLinks>;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type LeadFlowEmailBrandingInput = {
  accentColor?: InputMaybe<Scalars['String']['input']>;
  bannerImageCid?: InputMaybe<Scalars['String']['input']>;
  ctaButtonStyle?: InputMaybe<CtaButtonStyle>;
  ctaButtonText?: InputMaybe<Scalars['String']['input']>;
  ctaButtonUrl?: InputMaybe<Scalars['String']['input']>;
  emailFont?: InputMaybe<EmailFont>;
  emailFooterText?: InputMaybe<Scalars['String']['input']>;
  emailStyle?: InputMaybe<EmailStyle>;
  hideSiteName?: InputMaybe<Scalars['Boolean']['input']>;
  hideTagline?: InputMaybe<Scalars['Boolean']['input']>;
  penName?: InputMaybe<Scalars['String']['input']>;
  previewSampleBody?: InputMaybe<Scalars['String']['input']>;
  primaryColor?: InputMaybe<Scalars['String']['input']>;
  profilePhotoCid?: InputMaybe<Scalars['String']['input']>;
  profilePhotoSize?: InputMaybe<Scalars['Int']['input']>;
  secondaryColor?: InputMaybe<Scalars['String']['input']>;
  signatureImageCid?: InputMaybe<Scalars['String']['input']>;
  socialIconStyle?: InputMaybe<SocialIconStyle>;
  socialLinks?: InputMaybe<TenantSocialLinksInput>;
};

export type LeadFlowEnrolment = {
  __typename?: 'LeadFlowEnrolment';
  cancelReason?: Maybe<Scalars['String']['output']>;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  enrolledAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  leadId: Scalars['ID']['output'];
  nextRunAt?: Maybe<Scalars['DateTime']['output']>;
  sentStepIds: Array<Scalars['String']['output']>;
  sequenceId: Scalars['ID']['output'];
  status: LeadFlowEnrolmentStatus;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export enum LeadFlowEnrolmentStatus {
  Active = 'ACTIVE',
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED'
}

export type LeadFlowForm = {
  __typename?: 'LeadFlowForm';
  createdAt: Scalars['DateTime']['output'];
  displayStyle: LeadFlowFormDisplayStyle;
  fields: Array<LeadFlowFormField>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  notificationEmails?: Maybe<Array<Scalars['String']['output']>>;
  redirectUrl?: Maybe<Scalars['String']['output']>;
  rewardTokensOnSubmit?: Maybe<Scalars['Int']['output']>;
  slug: Scalars['String']['output'];
  stats: LeadFlowFormStats;
  submissionCount: Scalars['Float']['output'];
  tenantId: Scalars['String']['output'];
  thankYouMessage?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

/** Public presentation style for a LeadFlow form */
export enum LeadFlowFormDisplayStyle {
  EasyRead = 'EASY_READ',
  Generic = 'GENERIC'
}

export type LeadFlowFormField = {
  __typename?: 'LeadFlowFormField';
  label: Scalars['String']['output'];
  name: Scalars['String']['output'];
  options?: Maybe<Array<Scalars['String']['output']>>;
  order: Scalars['Float']['output'];
  placeholder?: Maybe<Scalars['String']['output']>;
  required: Scalars['Boolean']['output'];
  type: Scalars['String']['output'];
};

export type LeadFlowFormFieldInput = {
  label: Scalars['String']['input'];
  name: Scalars['String']['input'];
  options?: InputMaybe<Array<Scalars['String']['input']>>;
  order?: InputMaybe<Scalars['Float']['input']>;
  placeholder?: InputMaybe<Scalars['String']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  type: Scalars['String']['input'];
};

export type LeadFlowFormStats = {
  __typename?: 'LeadFlowFormStats';
  convertedCount: Scalars['Float']['output'];
  customFieldTallies?: Maybe<Scalars['JSON']['output']>;
  signupCount: Scalars['Float']['output'];
};

/** How to resolve the notification recipient(s) */
export enum LeadFlowNotificationRecipientType {
  AllLeadflowAdmins = 'ALL_LEADFLOW_ADMINS',
  Role = 'ROLE',
  SpecificClient = 'SPECIFIC_CLIENT',
  SpecificEmployee = 'SPECIFIC_EMPLOYEE'
}

export type LeadFlowNotificationRule = {
  __typename?: 'LeadFlowNotificationRule';
  channels: Array<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  isEnabled: Scalars['Boolean']['output'];
  messageTemplate?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  recipientIds?: Maybe<Array<Scalars['String']['output']>>;
  recipientRole?: Maybe<Scalars['String']['output']>;
  recipientType: LeadFlowNotificationRecipientType;
  tenantId: Scalars['String']['output'];
  timing: LeadFlowNotificationTiming;
  timingMinutes?: Maybe<Scalars['Float']['output']>;
  trigger: LeadFlowNotificationTrigger;
  updatedAt: Scalars['DateTime']['output'];
};

/** When to send the notification relative to the trigger */
export enum LeadFlowNotificationTiming {
  Immediate = 'IMMEDIATE',
  MinutesAfter = 'MINUTES_AFTER'
}

/** Event that triggers the leadflow notification */
export enum LeadFlowNotificationTrigger {
  ActionSent = 'ACTION_SENT',
  FormSubmitted = 'FORM_SUBMITTED',
  LeadArchived = 'LEAD_ARCHIVED',
  LeadConverted = 'LEAD_CONVERTED',
  LeadCreated = 'LEAD_CREATED',
  LeadStageChanged = 'LEAD_STAGE_CHANGED',
  PledgeCreated = 'PLEDGE_CREATED',
  PledgeTierApproaching = 'PLEDGE_TIER_APPROACHING',
  PledgeTierUnlocked = 'PLEDGE_TIER_UNLOCKED'
}

export type LeadFlowSequence = {
  __typename?: 'LeadFlowSequence';
  brandingId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  steps: Array<LeadFlowSequenceStep>;
  tenantId: Scalars['String']['output'];
  trigger: LeadFlowSequenceTrigger;
  triggerStageId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type LeadFlowSequenceRunResult = {
  __typename?: 'LeadFlowSequenceRunResult';
  completed: Scalars['Int']['output'];
  due: Scalars['Int']['output'];
  errors: Array<Scalars['String']['output']>;
  failed: Scalars['Int']['output'];
  sent: Scalars['Int']['output'];
};

export type LeadFlowSequenceStep = {
  __typename?: 'LeadFlowSequenceStep';
  body: Scalars['String']['output'];
  delayHours: Scalars['Int']['output'];
  isHtml: Scalars['Boolean']['output'];
  order: Scalars['Int']['output'];
  stepId: Scalars['String']['output'];
  subject?: Maybe<Scalars['String']['output']>;
  type: LeadFlowActionType;
};

export type LeadFlowSequenceStepInput = {
  body: Scalars['String']['input'];
  delayHours: Scalars['Int']['input'];
  isHtml?: InputMaybe<Scalars['Boolean']['input']>;
  order: Scalars['Int']['input'];
  stepId?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  type: LeadFlowActionType;
};

/** What starts a sequence enrolment */
export enum LeadFlowSequenceTrigger {
  Dormant = 'DORMANT',
  LeadCreated = 'LEAD_CREATED',
  Manual = 'MANUAL',
  PaymentFailed = 'PAYMENT_FAILED',
  StageEntered = 'STAGE_ENTERED'
}

export type LeadFlowStage = {
  __typename?: 'LeadFlowStage';
  color?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  isDefault: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Float']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** How the lead was captured */
export enum LeadSource {
  Form = 'FORM',
  Import = 'IMPORT',
  Manual = 'MANUAL',
  Other = 'OTHER',
  Referral = 'REFERRAL'
}

export type LeadStats = {
  __typename?: 'LeadStats';
  archived: Scalars['Float']['output'];
  byStage?: Maybe<Scalars['JSON']['output']>;
  converted: Scalars['Float']['output'];
  customFieldTallies?: Maybe<Scalars['JSON']['output']>;
  thisMonth: Scalars['Float']['output'];
  thisWeek: Scalars['Float']['output'];
  total: Scalars['Float']['output'];
};

export type LeaveAffectedShift = {
  __typename?: 'LeaveAffectedShift';
  departmentIds?: Maybe<Array<Scalars['String']['output']>>;
  endTime: Scalars['DateTime']['output'];
  shiftId: Scalars['ID']['output'];
  startTime: Scalars['DateTime']['output'];
  status: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type LeaveAvailabilityDay = {
  __typename?: 'LeaveAvailabilityDay';
  /** Brisbane calendar day, yyyy-MM-dd */
  date: Scalars['String']['output'];
  /** How many different people asked for this day. Managers only; null for everyone else. */
  requests?: Maybe<Scalars['Int']['output']>;
  /** True when the leave limit for this day has been reached — staff cannot ask for it */
  unavailable: Scalars['Boolean']['output'];
};

export type LeaveBalance = {
  __typename?: 'LeaveBalance';
  /** Cumulative hours accrued since employment start (or last balance reset) */
  accruedHours: Scalars['Float']['output'];
  /** Available = accruedHours - takenHours - pendingHours */
  availableHours: Scalars['Float']['output'];
  createdAt: Scalars['DateTime']['output'];
  employeeId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  /** Last time the accrual cron added to this row */
  lastAccruedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Last time a leave request adjusted takenHours / pendingHours */
  lastAdjustedAt?: Maybe<Scalars['DateTime']['output']>;
  /** ANNUAL_LEAVE | PERSONAL_LEAVE | SICK_LEAVE | LONG_SERVICE_LEAVE | COMPASSIONATE_LEAVE | STUDY_LEAVE */
  leaveType: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  /** Hours sitting in PENDING LeaveRequests (informational — not yet consumed) */
  pendingHours: Scalars['Float']['output'];
  /** Cumulative hours taken via APPROVED LeaveRequests */
  takenHours: Scalars['Float']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** One leave balance (annual, personal/sick or long service), in hours */
export type LeaveBalanceLine = {
  __typename?: 'LeaveBalanceLine';
  /** Accrued since the ADP date */
  accruedHours: Scalars['Float']['output'];
  /** opening + accrued − taken; null without an ADP starting point */
  availableHours?: Maybe<Scalars['Float']['output']>;
  /** Approved leave on future shifts, not yet taken (0 on the pay-run view) */
  bookedHours: Scalars['Float']['output'];
  /** ANNUAL | PERSONAL | LONG_SERVICE */
  bucket: Scalars['String']['output'];
  /** Full-time hours a year; null = does not accrue here (casual, long service) */
  entitlementHoursPerYear?: Maybe<Scalars['Float']['output']>;
  financialYearTakenHours: Scalars['Float']['output'];
  /** available − booked − pending (current view only) */
  freeHours?: Maybe<Scalars['Float']['output']>;
  label: Scalars['String']['output'];
  /** ADP opening balance; null = no ADP starting point */
  openingHours?: Maybe<Scalars['Float']['output']>;
  /** The employee's pending requests (0 on the pay-run view) */
  pendingHours: Scalars['Float']['output'];
  /** Leave recorded on shifts since the ADP date */
  takenHours: Scalars['Float']['output'];
};

/** How one employee's leave balance is worked out, pay run by pay run */
export type LeaveBalanceWorkingResult = {
  __typename?: 'LeaveBalanceWorkingResult';
  employeeId: Scalars['ID']['output'];
  employeeName?: Maybe<Scalars['String']['output']>;
  notes: Array<Scalars['String']['output']>;
  opening: Array<LeaveWorkingOpening>;
  /** ADP as-at date, yyyy-MM-dd */
  openingAsAt?: Maybe<Scalars['String']['output']>;
  /** Oldest first */
  periods: Array<LeaveWorkingPeriod>;
  rule: Scalars['String']['output'];
  /** The pay run the working stops at (yyyy-MM-dd); null = today */
  upTo?: Maybe<Scalars['String']['output']>;
};

export type LeaveConflictDay = {
  __typename?: 'LeaveConflictDay';
  approvedLeaveCount: Scalars['Float']['output'];
  approvedLeaveEmployees: Array<Scalars['String']['output']>;
  availableStaffCount: Scalars['Float']['output'];
  coverageLevel: CoverageLevel;
  date: Scalars['DateTime']['output'];
  requesterShiftCount: Scalars['Float']['output'];
  scheduledShiftCount: Scalars['Float']['output'];
  totalStaffCount: Scalars['Float']['output'];
};

export type LeaveCoverageAnalysis = {
  __typename?: 'LeaveCoverageAnalysis';
  /** Paid hours since the ADP date that leave accrued on (≤38/week) */
  accrualBaseHours: Scalars['Float']['output'];
  balances: Array<LeaveCoverageBalance>;
  /** The balance this request draws from; null = none (compassionate, unpaid study) */
  drawsFrom?: Maybe<Scalars['String']['output']>;
  employeeId: Scalars['ID']['output'];
  employeeName?: Maybe<Scalars['String']['output']>;
  financialYearStart: Scalars['DateTime']['output'];
  hasOpeningBalance: Scalars['Boolean']['output'];
  isCasual: Scalars['Boolean']['output'];
  leaveRequestId: Scalars['ID']['output'];
  leaveType: ShiftLeaveType;
  /** Plain-words caveats to show under the panel */
  notes: Array<Scalars['String']['output']>;
  /** The ADP as-at date (date-only) */
  openingAsAt?: Maybe<Scalars['DateTime']['output']>;
  requestDays: Array<LeaveCoverageDay>;
  requestHours: Scalars['Float']['output'];
  /** True when no rostered shifts were found and the hours are a days × daily-hours estimate */
  requestHoursEstimated: Scalars['Boolean']['output'];
};

export type LeaveCoverageBalance = {
  __typename?: 'LeaveCoverageBalance';
  accruedHours: Scalars['Float']['output'];
  /** opening + accrued − taken; null without an ADP starting point */
  availableHours?: Maybe<Scalars['Float']['output']>;
  /** Approved leave on future shifts, not yet taken */
  bookedHours: Scalars['Float']['output'];
  /** ANNUAL | PERSONAL | LONG_SERVICE */
  bucket: Scalars['String']['output'];
  /** Full-time hours per year; null = does not accrue here (casual, long service) */
  entitlementHoursPerYear?: Maybe<Scalars['Float']['output']>;
  financialYearTakenHours: Scalars['Float']['output'];
  label: Scalars['String']['output'];
  /** ADP opening balance; null = no ADP starting point set */
  openingHours?: Maybe<Scalars['Float']['output']>;
  /** The employee's OTHER pending requests */
  pendingHours: Scalars['Float']['output'];
  /** Only on the balance this request draws from */
  remainingAfterHours?: Maybe<Scalars['Float']['output']>;
  takenHours: Scalars['Float']['output'];
};

export type LeaveCoverageDay = {
  __typename?: 'LeaveCoverageDay';
  /** Brisbane calendar day, yyyy-MM-dd */
  date: Scalars['String']['output'];
  hours: Scalars['Float']['output'];
  shiftTitle?: Maybe<Scalars['String']['output']>;
};

/** A pay run a leave balance can be shown as at (Abby + Tom, 14 Oct 2026) */
export type LeavePayRunChoice = {
  __typename?: 'LeavePayRunChoice';
  /** Last day of the pay run, yyyy-MM-dd (date-only) */
  end: Scalars['String']['output'];
  /** The ADP opening date — the balance there IS the ADP figure */
  isAdpOpening: Scalars['Boolean']['output'];
  /** The most recent pay run that has fully passed (the default) */
  isLatest: Scalars['Boolean']['output'];
};

export type LeaveRequest = {
  __typename?: 'LeaveRequest';
  attachments?: Maybe<Array<Scalars['String']['output']>>;
  cancellationReason?: Maybe<Scalars['String']['output']>;
  cancelledAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  /** This request's page (/shifts/leave/:id) — only for viewers allowed to open it */
  detailUrl?: Maybe<Scalars['String']['output']>;
  employeeId: Scalars['String']['output'];
  employeeName: Scalars['String']['output'];
  endDate: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  leaveType: ShiftLeaveType;
  partialDayType: PartialDayType;
  reason?: Maybe<Scalars['String']['output']>;
  reviewComment?: Maybe<Scalars['String']['output']>;
  reviewedAt?: Maybe<Scalars['DateTime']['output']>;
  reviewedBy?: Maybe<Scalars['String']['output']>;
  reviewedByName?: Maybe<Scalars['String']['output']>;
  sourceShiftId?: Maybe<Scalars['String']['output']>;
  startDate: Scalars['DateTime']['output'];
  status: LeaveRequestStatus;
  tenantId: Scalars['String']['output'];
  totalDays: Scalars['Float']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** Current status of the leave request */
export enum LeaveRequestStatus {
  Approved = 'APPROVED',
  Cancelled = 'CANCELLED',
  Denied = 'DENIED',
  Pending = 'PENDING'
}

export type LeaveStatistics = {
  __typename?: 'LeaveStatistics';
  hospitalLeave: Scalars['Int']['output'];
  overdueReturns: Scalars['Int']['output'];
  socialLeave: Scalars['Int']['output'];
  totalOnLeave: Scalars['Int']['output'];
};

/** Status of a leave record */
export enum LeaveStatus {
  Active = 'ACTIVE',
  Cancelled = 'CANCELLED',
  Extended = 'EXTENDED',
  Returned = 'RETURNED'
}

/** Type of leave from the facility */
export enum LeaveType {
  Emergency = 'EMERGENCY',
  Hospital = 'HOSPITAL',
  Social = 'SOCIAL',
  TransitionCare = 'TRANSITION_CARE'
}

/** One balance in one pay run of the working */
export type LeaveWorkingLine = {
  __typename?: 'LeaveWorkingLine';
  accruedHours: Scalars['Float']['output'];
  /** Balance at the end of this pay run */
  balanceHours?: Maybe<Scalars['Float']['output']>;
  /** ANNUAL | PERSONAL | LONG_SERVICE */
  bucket: Scalars['String']['output'];
  label: Scalars['String']['output'];
  takenHours: Scalars['Float']['output'];
};

/** One opening balance from ADP */
export type LeaveWorkingOpening = {
  __typename?: 'LeaveWorkingOpening';
  bucket: Scalars['String']['output'];
  /** Full-time hours a year */
  entitlementHoursPerYear?: Maybe<Scalars['Float']['output']>;
  hours?: Maybe<Scalars['Float']['output']>;
  label: Scalars['String']['output'];
};

/** One fortnightly pay run of the working */
export type LeaveWorkingPeriod = {
  __typename?: 'LeaveWorkingPeriod';
  /** yyyy-MM-dd */
  firstDay: Scalars['String']['output'];
  /** The pay run still in progress (only when the working runs to today) */
  inProgress: Scalars['Boolean']['output'];
  /** yyyy-MM-dd */
  lastDay: Scalars['String']['output'];
  lines: Array<LeaveWorkingLine>;
  /** paid − overtime: the hours leave is earned on */
  ordinaryHours: Scalars['Float']['output'];
  /** Overtime — earns no leave */
  overtimeHours: Scalars['Float']['output'];
  paidHours: Scalars['Float']['output'];
  shifts: Array<LeaveWorkingShift>;
};

/** One shift inside a pay run of the working */
export type LeaveWorkingShift = {
  __typename?: 'LeaveWorkingShift';
  /** Brisbane day, yyyy-MM-dd */
  day: Scalars['String']['output'];
  /** Rostered hours, net of breaks */
  hours: Scalars['Float']['output'];
  /** Leave recorded on the shift, in words */
  leave: Array<Scalars['String']['output']>;
  /** Hours counted as paid */
  paidHours: Scalars['Float']['output'];
  shiftId: Scalars['ID']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type LedgerAccount = {
  __typename?: 'LedgerAccount';
  code: Scalars['String']['output'];
  companyId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdByClientId?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  isClinical: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  source: LedgerAccountSource;
  taxType: LedgerTaxType;
  tenantId: Scalars['String']['output'];
  type: LedgerAccountType;
  updatedAt: Scalars['DateTime']['output'];
  updatedByClientId?: Maybe<Scalars['String']['output']>;
  xeroTaxCode?: Maybe<Scalars['String']['output']>;
  xeroType?: Maybe<Scalars['String']['output']>;
};

/** Imported from a Xero chart of accounts, or typed in */
export enum LedgerAccountSource {
  Manual = 'MANUAL',
  XeroImport = 'XERO_IMPORT'
}

/** Asset, liability, equity, revenue or expense */
export enum LedgerAccountType {
  Asset = 'ASSET',
  Equity = 'EQUITY',
  Expense = 'EXPENSE',
  Liability = 'LIABILITY',
  Revenue = 'REVENUE'
}

export type LedgerImportResult = {
  __typename?: 'LedgerImportResult';
  changedKeptCount: Scalars['Int']['output'];
  committed: Scalars['Boolean']['output'];
  errorCount: Scalars['Int']['output'];
  insertedCount: Scalars['Int']['output'];
  newCount: Scalars['Int']['output'];
  rows: Array<LedgerImportRow>;
  sameCount: Scalars['Int']['output'];
  updateCount: Scalars['Int']['output'];
  updatedCount: Scalars['Int']['output'];
};

export type LedgerImportRow = {
  __typename?: 'LedgerImportRow';
  action: AccountingImportAction;
  code: Scalars['String']['output'];
  line: Scalars['Int']['output'];
  message?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  taxType?: Maybe<LedgerTaxType>;
  type?: Maybe<LedgerAccountType>;
  xeroTaxCode?: Maybe<Scalars['String']['output']>;
  xeroType?: Maybe<Scalars['String']['output']>;
};

/** GST, GST free, BAS excluded or input taxed */
export enum LedgerTaxType {
  BasExcluded = 'BAS_EXCLUDED',
  Gst = 'GST',
  GstFree = 'GST_FREE',
  InputTaxed = 'INPUT_TAXED'
}

/** Where a care-planning requirement comes from — the law, or the provider's own practice */
export enum LegalBasis {
  Act = 'ACT',
  FundingRule = 'FUNDING_RULE',
  ProviderPractice = 'PROVIDER_PRACTICE',
  QualityStandard = 'QUALITY_STANDARD',
  Rules = 'RULES'
}

export type LengthOfStayStats = {
  __typename?: 'LengthOfStayStats';
  averageDays: Scalars['Int']['output'];
  currentResidentsAverage: Scalars['Int']['output'];
  dischargedResidentsAverage: Scalars['Int']['output'];
  longestStay: Scalars['Int']['output'];
  shortestStay: Scalars['Int']['output'];
};

export type LifeAspect = {
  __typename?: 'LifeAspect';
  color?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  isDefault: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** Whether a person is living — a WEB fact, never derived from a transcript */
export enum LifeStatus {
  Deceased = 'DECEASED',
  Living = 'LIVING',
  Unknown = 'UNKNOWN'
}

export type LineItem = {
  __typename?: 'LineItem';
  amount: Scalars['Float']['output'];
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type LineItemInput = {
  amount: Scalars['Float']['input'];
  description: Scalars['String']['input'];
};

export type LinkEmpowermentTranscriptionInput = {
  catchUpId: Scalars['ID']['input'];
  transcriptionId?: InputMaybe<Scalars['ID']['input']>;
};

export type LinkFeedbackOutcomeInput = {
  feedbackId: Scalars['ID']['input'];
  kind: FeedbackOutcomeKind;
  note?: InputMaybe<Scalars['String']['input']>;
  targetId: Scalars['ID']['input'];
};

export type LinkMaintenanceRequestInput = {
  linkReason?: InputMaybe<Scalars['String']['input']>;
  maintenanceRequestId: Scalars['ID']['input'];
  maintenanceRequestNumber: Scalars['Float']['input'];
};

export type LinkMaintenanceToCiInitiativeInput = {
  initiativeId: Scalars['ID']['input'];
  initiativeNumber: Scalars['Float']['input'];
  linkReason?: InputMaybe<Scalars['String']['input']>;
};

export type LinkMaintenanceToCiIssueInput = {
  issueId: Scalars['ID']['input'];
  issueNumber: Scalars['Float']['input'];
  linkReason?: InputMaybe<Scalars['String']['input']>;
};

export type LinkMaintenanceToCiStandardInput = {
  linkReason?: InputMaybe<Scalars['String']['input']>;
  standard: CiQualityStandard;
};

export type LinkSubmissionToClientInput = {
  clientId: Scalars['ID']['input'];
  submissionId: Scalars['ID']['input'];
};

export type LinkedCalendar = {
  __typename?: 'LinkedCalendar';
  calendarId: Scalars['String']['output'];
  permissions: Array<LinkedCalendarPermission>;
};

export type LinkedCalendarInput = {
  calendarId: Scalars['String']['input'];
  permissions: Array<LinkedCalendarPermission>;
};

/** Permission levels for linked calendars on an email address */
export enum LinkedCalendarPermission {
  Admin = 'ADMIN',
  Create = 'CREATE',
  Delete = 'DELETE',
  Edit = 'EDIT',
  View = 'VIEW'
}

export type LinkedOpportunitySummary = {
  __typename?: 'LinkedOpportunitySummary';
  clientName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  stage: Scalars['String']['output'];
  status: Scalars['String']['output'];
  title: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};

/** A single chat-style query a user sent to the local-AI endpoint (Mac Studio M3 Ultra) plus the response that came back. */
export type LocalAiQuery = {
  __typename?: 'LocalAiQuery';
  createdAt: Scalars['DateTime']['output'];
  /** Verbatim error message if `success: false` */
  errorMessage?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Prompt-side token count reported by the upstream model */
  inputTokens?: Maybe<Scalars['Int']['output']>;
  /** Round-trip latency in milliseconds, including ngrok hop */
  latencyMs?: Maybe<Scalars['Int']['output']>;
  /** Friendly model name from LiteLLM, e.g. 'qwen3.6-35b' */
  model: Scalars['String']['output'];
  /** Completion-side token count reported by the upstream model */
  outputTokens?: Maybe<Scalars['Int']['output']>;
  /** Raw user prompt as sent to the model */
  prompt: Scalars['String']['output'];
  /** Model response text. Empty string if the call failed — check `success`. */
  response: Scalars['String']['output'];
  /** True if the upstream returned a parsed response; false if the call errored */
  success: Scalars['Boolean']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  /** The Client._id of the user who issued the query */
  userId: Scalars['String']['output'];
};

export type LocalAiRuntime = {
  __typename?: 'LocalAiRuntime';
  defaultModel?: Maybe<Scalars['String']['output']>;
  endpointHost?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  models: Array<LocalAiRuntimeModel>;
  ok: Scalars['Boolean']['output'];
  source: Scalars['String']['output'];
};

export type LocalAiRuntimeModel = {
  __typename?: 'LocalAiRuntimeModel';
  id: Scalars['String']['output'];
  role?: Maybe<Scalars['String']['output']>;
  slots?: Maybe<Scalars['Int']['output']>;
};

export type LocalFileInfo = {
  __typename?: 'LocalFileInfo';
  filename: Scalars['String']['output'];
  size: Scalars['Float']['output'];
  status: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type LocalSessionInfo = {
  __typename?: 'LocalSessionInfo';
  droneSerial: Scalars['String']['output'];
  files: Array<LocalFileInfo>;
  imageCount: Scalars['Float']['output'];
  localPath: Scalars['String']['output'];
  safeToFormat: Scalars['Boolean']['output'];
  sessionDate: Scalars['String']['output'];
  sessionId: Scalars['String']['output'];
  status: Scalars['String']['output'];
  totalBytes: Scalars['Float']['output'];
  totalFiles: Scalars['Float']['output'];
  uploadedBytes: Scalars['Float']['output'];
  uploadedFiles: Scalars['Float']['output'];
  videoCount: Scalars['Float']['output'];
};

export type Location = {
  __typename?: 'Location';
  address?: Maybe<Scalars['String']['output']>;
  building?: Maybe<Scalars['String']['output']>;
  capacity?: Maybe<Scalars['Float']['output']>;
  children?: Maybe<Array<Location>>;
  code?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  currentQRCode?: Maybe<Scalars['String']['output']>;
  defaultTaskTemplateIds?: Maybe<Array<Scalars['String']['output']>>;
  departmentIds?: Maybe<Array<Scalars['String']['output']>>;
  description?: Maybe<Scalars['String']['output']>;
  floor?: Maybe<Scalars['String']['output']>;
  geoCoordinates?: Maybe<GeoCoordinates>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  lastCleanedAt?: Maybe<Scalars['DateTime']['output']>;
  lastInspectedAt?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  parent?: Maybe<Location>;
  parentLocationId?: Maybe<Scalars['ID']['output']>;
  qrCheckInEnabled: Scalars['Boolean']['output'];
  qrCodeGeneratedAt?: Maybe<Scalars['DateTime']['output']>;
  sortOrder: Scalars['Float']['output'];
  status: LocationStatus;
  tenantId: Scalars['String']['output'];
  type: LocationType;
  updatedAt: Scalars['DateTime']['output'];
};

export type LocationInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  building?: InputMaybe<Scalars['String']['input']>;
  capacity?: InputMaybe<Scalars['Float']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  defaultTaskTemplateIds?: InputMaybe<Array<Scalars['String']['input']>>;
  departmentIds?: InputMaybe<Array<Scalars['String']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  floor?: InputMaybe<Scalars['String']['input']>;
  geoCoordinates?: InputMaybe<GeoCoordinatesInput>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  parentLocationId?: InputMaybe<Scalars['ID']['input']>;
  qrCheckInEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  sortOrder?: InputMaybe<Scalars['Float']['input']>;
  status?: InputMaybe<LocationStatus>;
  type: LocationType;
};

/** Status of a location */
export enum LocationStatus {
  Active = 'ACTIVE',
  Closed = 'CLOSED',
  Inactive = 'INACTIVE',
  Maintenance = 'MAINTENANCE'
}

/** Types of physical locations */
export enum LocationType {
  Bathroom = 'BATHROOM',
  Bedroom = 'BEDROOM',
  Building = 'BUILDING',
  ClientHome = 'CLIENT_HOME',
  CommonArea = 'COMMON_AREA',
  Dining = 'DINING',
  Entrance = 'ENTRANCE',
  Facility = 'FACILITY',
  Floor = 'FLOOR',
  Garden = 'GARDEN',
  Kitchen = 'KITCHEN',
  Laundry = 'LAUNDRY',
  LivingArea = 'LIVING_AREA',
  Maintenance = 'MAINTENANCE',
  MedicationRoom = 'MEDICATION_ROOM',
  NursesStation = 'NURSES_STATION',
  Office = 'OFFICE',
  Other = 'OTHER',
  Parking = 'PARKING',
  Reception = 'RECEPTION',
  Storage = 'STORAGE',
  TreatmentRoom = 'TREATMENT_ROOM',
  Wing = 'WING'
}

export type LocationWingTrend = {
  __typename?: 'LocationWingTrend';
  count: Scalars['Int']['output'];
  location?: Maybe<Scalars['String']['output']>;
  wing?: Maybe<Scalars['String']['output']>;
};

export type LodgeStpInput = {
  eventType?: InputMaybe<StpEventType>;
  payRunId: Scalars['ID']['input'];
};

export type LogEntry = {
  __typename?: 'LogEntry';
  message: Scalars['String']['output'];
  raw: Scalars['String']['output'];
  timestamp?: Maybe<Scalars['String']['output']>;
};

export type LogWaitingListCheckInInput = {
  /** When the contact happened (default now; never in the future) */
  contactedAt?: InputMaybe<Scalars['DateTime']['input']>;
  method: WaitingListCheckInMethod;
  note?: InputMaybe<Scalars['String']['input']>;
};

export type LoginActivity = {
  __typename?: 'LoginActivity';
  action: LoginActivityAction;
  clientId: Scalars['String']['output'];
  details?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  ipAddress?: Maybe<Scalars['String']['output']>;
  method?: Maybe<Scalars['String']['output']>;
  performedById?: Maybe<Scalars['String']['output']>;
  performedByName?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  timestamp: Scalars['DateTime']['output'];
  userAgent?: Maybe<Scalars['String']['output']>;
};

/** Types of login-related activities */
export enum LoginActivityAction {
  CredentialsSent = 'CREDENTIALS_SENT',
  CredentialGenerated = 'CREDENTIAL_GENERATED',
  FailedLogin = 'FAILED_LOGIN',
  Login = 'LOGIN',
  Logout = 'LOGOUT',
  PasswordChanged = 'PASSWORD_CHANGED',
  PasswordReset = 'PASSWORD_RESET',
  RecoveryCodesRegenerated = 'RECOVERY_CODES_REGENERATED',
  RecoveryCodeUsed = 'RECOVERY_CODE_USED',
  SignedOutDevice = 'SIGNED_OUT_DEVICE',
  SignedOutEverywhere = 'SIGNED_OUT_EVERYWHERE',
  StepUp = 'STEP_UP',
  TwoFactorDisabled = 'TWO_FACTOR_DISABLED',
  TwoFactorEnabled = 'TWO_FACTOR_ENABLED',
  UsernameChanged = 'USERNAME_CHANGED'
}

export type LoginWithUsernameInput = {
  password: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

export type M365SetupStatus = {
  __typename?: 'M365SetupStatus';
  automationAttempted: Scalars['Boolean']['output'];
  automationErrors: Array<Scalars['String']['output']>;
  sharedMailboxLikely: Scalars['Boolean']['output'];
  transportRuleLikely: Scalars['Boolean']['output'];
};

export type MailboxAccount = {
  __typename?: 'MailboxAccount';
  accountEnabled: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  displayName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isShared: Scalars['Boolean']['output'];
  lastSyncedAt?: Maybe<Scalars['DateTime']['output']>;
  licensed: Scalars['Boolean']['output'];
  licenses: Array<Scalars['String']['output']>;
  mailboxType?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  upn: Scalars['String']['output'];
};

export type MailboxDirectionCount = {
  __typename?: 'MailboxDirectionCount';
  inbound: Scalars['Int']['output'];
  mailbox: Scalars['String']['output'];
  outbound: Scalars['Int']['output'];
};

export type MaintenanceActivity = {
  __typename?: 'MaintenanceActivity';
  activityType: Scalars['String']['output'];
  actorId?: Maybe<Scalars['ID']['output']>;
  actorName?: Maybe<Scalars['String']['output']>;
  attachments?: Maybe<Array<MaintenanceActivityAttachment>>;
  createdAt: Scalars['DateTime']['output'];
  detailJson?: Maybe<Scalars['String']['output']>;
  details?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isDeleted: Scalars['Boolean']['output'];
  occurredAt: Scalars['DateTime']['output'];
  referenceId?: Maybe<Scalars['String']['output']>;
  referenceType?: Maybe<Scalars['String']['output']>;
  requestId: Scalars['ID']['output'];
  tenantId: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type MaintenanceActivityAttachment = {
  __typename?: 'MaintenanceActivityAttachment';
  cid: Scalars['String']['output'];
  fileName?: Maybe<Scalars['String']['output']>;
  fileSize?: Maybe<Scalars['Int']['output']>;
  mimeType?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

export type MaintenanceActivityAttachmentInput = {
  cid: Scalars['String']['input'];
  fileName?: InputMaybe<Scalars['String']['input']>;
  fileSize?: InputMaybe<Scalars['Int']['input']>;
  mimeType?: InputMaybe<Scalars['String']['input']>;
};

export type MaintenanceActivityPage = {
  __typename?: 'MaintenanceActivityPage';
  cap: Scalars['Int']['output'];
  rows: Array<MaintenanceActivity>;
  total: Scalars['Int']['output'];
};

/** Categories of maintenance requests */
export enum MaintenanceCategory {
  Carpentry = 'CARPENTRY',
  Cleaning = 'CLEANING',
  Electrical = 'ELECTRICAL',
  GeneralMaintenance = 'GENERAL_MAINTENANCE',
  Hazard = 'HAZARD',
  Hvac = 'HVAC',
  It = 'IT',
  Landscaping = 'LANDSCAPING',
  Other = 'OTHER',
  Painting = 'PAINTING',
  Plumbing = 'PLUMBING'
}

export type MaintenanceCategoryCount = {
  __typename?: 'MaintenanceCategoryCount';
  category: MaintenanceCategory;
  count: Scalars['Int']['output'];
};

export type MaintenanceChecklistItem = {
  __typename?: 'MaintenanceChecklistItem';
  completed: Scalars['Boolean']['output'];
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  completedBy?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  order: Scalars['Float']['output'];
  text: Scalars['String']['output'];
};

export type MaintenanceLocationCount = {
  __typename?: 'MaintenanceLocationCount';
  count: Scalars['Int']['output'];
  locationId?: Maybe<Scalars['ID']['output']>;
  locationName?: Maybe<Scalars['String']['output']>;
};

export type MaintenanceMedia = {
  __typename?: 'MaintenanceMedia';
  cid?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  mimeType?: Maybe<Scalars['String']['output']>;
  uploadedAt?: Maybe<Scalars['DateTime']['output']>;
  uploadedBy?: Maybe<Scalars['ID']['output']>;
  url: Scalars['String']['output'];
};

export type MaintenanceMediaInput = {
  cid?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  mimeType?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/** How to resolve the maintenance notification recipient(s) */
export enum MaintenanceNotificationRecipientType {
  AllMaintenanceManagers = 'ALL_MAINTENANCE_MANAGERS',
  AssignedPerson = 'ASSIGNED_PERSON',
  Role = 'ROLE',
  SpecificEmployee = 'SPECIFIC_EMPLOYEE',
  Submitter = 'SUBMITTER'
}

export type MaintenanceNotificationRule = {
  __typename?: 'MaintenanceNotificationRule';
  channels: Array<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  filterCategory?: Maybe<Scalars['String']['output']>;
  filterLocation?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isEnabled: Scalars['Boolean']['output'];
  messageTemplate?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  recipientIds?: Maybe<Array<Scalars['String']['output']>>;
  recipientRole?: Maybe<Scalars['String']['output']>;
  recipientType: MaintenanceNotificationRecipientType;
  scheduledDay?: Maybe<MaintenanceScheduleDay>;
  scheduledHour?: Maybe<Scalars['Float']['output']>;
  tenantId: Scalars['String']['output'];
  /** Deprecated: only IMMEDIATE is honoured; other values behave as IMMEDIATE. */
  timing: MaintenanceNotificationTiming;
  /** Deprecated: not read by any send path. */
  timingMinutes?: Maybe<Scalars['Float']['output']>;
  trigger: MaintenanceNotificationTrigger;
  updatedAt: Scalars['DateTime']['output'];
};

/** When to send the notification relative to the trigger */
export enum MaintenanceNotificationTiming {
  Immediate = 'IMMEDIATE',
  MinutesAfter = 'MINUTES_AFTER',
  MinutesBefore = 'MINUTES_BEFORE'
}

/** Event that triggers the maintenance notification */
export enum MaintenanceNotificationTrigger {
  AllEvents = 'ALL_EVENTS',
  ChecklistUpdated = 'CHECKLIST_UPDATED',
  DailyReport = 'DAILY_REPORT',
  PhotoAdded = 'PHOTO_ADDED',
  ProgressNoteAdded = 'PROGRESS_NOTE_ADDED',
  PublicRequestSubmitted = 'PUBLIC_REQUEST_SUBMITTED',
  RequestAssigned = 'REQUEST_ASSIGNED',
  RequestCompleted = 'REQUEST_COMPLETED',
  RequestCreated = 'REQUEST_CREATED',
  RequestOverdue = 'REQUEST_OVERDUE',
  StatusChanged = 'STATUS_CHANGED',
  WeeklyReport = 'WEEKLY_REPORT'
}

export type MaintenanceOverdueCheckResult = {
  __typename?: 'MaintenanceOverdueCheckResult';
  newlyOverdue: Scalars['Int']['output'];
  reason?: Maybe<Scalars['String']['output']>;
  scanned: Scalars['Int']['output'];
  skipped: Scalars['Boolean']['output'];
};

export type MaintenanceOverdueSummary = {
  __typename?: 'MaintenanceOverdueSummary';
  assignedToName?: Maybe<Scalars['String']['output']>;
  details: Scalars['String']['output'];
  estimatedCompletionDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  priority?: Maybe<MaintenancePriority>;
  requestNumber: Scalars['Int']['output'];
  status: MaintenanceStatus;
};

export type MaintenancePeriodSummary = {
  __typename?: 'MaintenancePeriodSummary';
  avgCompletionHours?: Maybe<Scalars['Float']['output']>;
  byCategory: Array<MaintenanceCategoryCount>;
  byLocation: Array<MaintenanceLocationCount>;
  byLocationCap: Scalars['Int']['output'];
  byLocationTotal: Scalars['Int']['output'];
  byStatus: Array<MaintenanceStatusCount>;
  cancelled: Scalars['Int']['output'];
  completed: Scalars['Int']['output'];
  created: Scalars['Int']['output'];
  endDate: Scalars['DateTime']['output'];
  openAtEnd: Scalars['Int']['output'];
  overdueNow: Scalars['Int']['output'];
  recentActivity: Array<MaintenanceActivity>;
  recentActivityCap: Scalars['Int']['output'];
  startDate: Scalars['DateTime']['output'];
};

/** Priority level of a maintenance request */
export enum MaintenancePriority {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM',
  Urgent = 'URGENT'
}

export type MaintenanceProgressNote = {
  __typename?: 'MaintenanceProgressNote';
  action?: Maybe<Scalars['String']['output']>;
  attachments?: Maybe<Array<MaintenanceMedia>>;
  details?: Maybe<Scalars['String']['output']>;
  newValue?: Maybe<Scalars['String']['output']>;
  performedAt?: Maybe<Scalars['DateTime']['output']>;
  performedBy?: Maybe<Scalars['String']['output']>;
  performedById?: Maybe<Scalars['ID']['output']>;
  previousValue?: Maybe<Scalars['String']['output']>;
};

export type MaintenanceRequest = {
  __typename?: 'MaintenanceRequest';
  assignedAt?: Maybe<Scalars['DateTime']['output']>;
  assignedTo?: Maybe<Scalars['ID']['output']>;
  assignedToName?: Maybe<Scalars['String']['output']>;
  blockedBy?: Maybe<Scalars['ID']['output']>;
  blockedByRequestNumber?: Maybe<Scalars['Float']['output']>;
  cancelledAt?: Maybe<Scalars['DateTime']['output']>;
  category: MaintenanceCategory;
  checklist?: Maybe<Array<MaintenanceChecklistItem>>;
  checklistProgress: Scalars['Float']['output'];
  ciLinkReason?: Maybe<Scalars['String']['output']>;
  ciLinkedAt?: Maybe<Scalars['DateTime']['output']>;
  ciLinkedBy?: Maybe<Scalars['String']['output']>;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  completedBy?: Maybe<Scalars['ID']['output']>;
  completedByName?: Maybe<Scalars['String']['output']>;
  completionNotes?: Maybe<Scalars['String']['output']>;
  completionPhotos?: Maybe<Array<MaintenanceMedia>>;
  createdAt: Scalars['DateTime']['output'];
  details: Scalars['String']['output'];
  estimatedCompletionDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  isDeleted: Scalars['Boolean']['output'];
  linkedCIInitiativeId?: Maybe<Scalars['ID']['output']>;
  linkedCIInitiativeNumber?: Maybe<Scalars['Float']['output']>;
  linkedCIIssueId?: Maybe<Scalars['ID']['output']>;
  linkedCIIssueNumber?: Maybe<Scalars['Float']['output']>;
  linkedCIStandard?: Maybe<CiQualityStandard>;
  locationId?: Maybe<Scalars['ID']['output']>;
  logDate: Scalars['DateTime']['output'];
  logTime: Scalars['String']['output'];
  loggedBy?: Maybe<Scalars['ID']['output']>;
  loggedByEmail?: Maybe<Scalars['String']['output']>;
  loggedByName?: Maybe<Scalars['String']['output']>;
  maintenanceItem?: Maybe<Scalars['String']['output']>;
  monthlyCheckId?: Maybe<Scalars['ID']['output']>;
  occupantPresent: Scalars['Boolean']['output'];
  onHoldReason?: Maybe<Scalars['String']['output']>;
  overdueNotifiedAt?: Maybe<Scalars['DateTime']['output']>;
  photos?: Maybe<Array<MaintenanceMedia>>;
  priority?: Maybe<MaintenancePriority>;
  progressNotes?: Maybe<Array<MaintenanceProgressNote>>;
  requestNumber: Scalars['Float']['output'];
  requestedBy: RequestedByType;
  room?: Maybe<Scalars['String']['output']>;
  status: MaintenanceStatus;
  statusNotes?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  wing?: Maybe<Scalars['String']['output']>;
};

export type MaintenanceRequestPage = {
  __typename?: 'MaintenanceRequestPage';
  rows: Array<MaintenanceRequest>;
  total: Scalars['Int']['output'];
};

export type MaintenanceRequestStats = {
  __typename?: 'MaintenanceRequestStats';
  assigned: Scalars['Float']['output'];
  avgCompletionTimeHours?: Maybe<Scalars['Float']['output']>;
  cancelled: Scalars['Float']['output'];
  completed: Scalars['Float']['output'];
  completedThisWeek: Scalars['Float']['output'];
  inProgress: Scalars['Float']['output'];
  new: Scalars['Float']['output'];
  onHold: Scalars['Float']['output'];
  total: Scalars['Float']['output'];
};

/** Day of the week for scheduled report rules */
export enum MaintenanceScheduleDay {
  Friday = 'FRIDAY',
  Monday = 'MONDAY',
  Saturday = 'SATURDAY',
  Sunday = 'SUNDAY',
  Thursday = 'THURSDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY'
}

/** Status of a maintenance request */
export enum MaintenanceStatus {
  Assigned = 'ASSIGNED',
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS',
  New = 'NEW',
  OnHold = 'ON_HOLD'
}

export type MaintenanceStatusCount = {
  __typename?: 'MaintenanceStatusCount';
  count: Scalars['Int']['output'];
  status: MaintenanceStatus;
};

export type MaintenanceTrendBucket = {
  __typename?: 'MaintenanceTrendBucket';
  avgCompletionHours?: Maybe<Scalars['Float']['output']>;
  cancelled: Scalars['Int']['output'];
  completed: Scalars['Int']['output'];
  created: Scalars['Int']['output'];
  deltaCompleted?: Maybe<Scalars['Int']['output']>;
  deltaCreated?: Maybe<Scalars['Int']['output']>;
  isPartial: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
  netChange: Scalars['Int']['output'];
  openAtEnd: Scalars['Int']['output'];
  periodEnd: Scalars['DateTime']['output'];
  periodStart: Scalars['DateTime']['output'];
};

/** Bucket size for maintenanceTrends: Brisbane weeks (Monday) or calendar months */
export enum MaintenanceTrendGranularity {
  Month = 'MONTH',
  Week = 'WEEK'
}

export type MaintenanceTrends = {
  __typename?: 'MaintenanceTrends';
  buckets: Array<MaintenanceTrendBucket>;
  granularity: MaintenanceTrendGranularity;
  periodsCap: Scalars['Int']['output'];
};

export type MaintenanceWeekOverview = {
  __typename?: 'MaintenanceWeekOverview';
  byCategory: Array<MaintenanceCategoryCount>;
  byLocation: Array<MaintenanceLocationCount>;
  byLocationCap: Scalars['Int']['output'];
  byLocationTotal: Scalars['Int']['output'];
  completedThisWeek: Scalars['Int']['output'];
  createdThisWeek: Scalars['Int']['output'];
  openByStatus: Array<MaintenanceStatusCount>;
  openTotal: Scalars['Int']['output'];
  overdue: Array<MaintenanceOverdueSummary>;
  overdueCap: Scalars['Int']['output'];
  overdueCount: Scalars['Int']['output'];
  recentActivity: Array<MaintenanceActivity>;
  recentActivityCap: Scalars['Int']['output'];
  weekEnd: Scalars['DateTime']['output'];
  weekStart: Scalars['DateTime']['output'];
};

export type ManualHandlingReportEntry = {
  __typename?: 'ManualHandlingReportEntry';
  assistanceRequired?: Maybe<Scalars['Float']['output']>;
  manualHandlingNotes?: Maybe<Scalars['String']['output']>;
  mobilityAids: Array<Scalars['String']['output']>;
  mobilityLevel?: Maybe<MedicationMobilityLevel>;
  residentId: Scalars['ID']['output'];
  residentName: Scalars['String']['output'];
  roomNumber?: Maybe<Scalars['String']['output']>;
  wing?: Maybe<Scalars['String']['output']>;
};

export type MapMeetVoiceSignatureInput = {
  id: Scalars['ID']['input'];
  mappedClientId?: InputMaybe<Scalars['ID']['input']>;
  mappedName?: InputMaybe<Scalars['String']['input']>;
};

export type MapVoiceSignatureInput = {
  id: Scalars['ID']['input'];
  mappedClientId?: InputMaybe<Scalars['ID']['input']>;
  mappedName?: InputMaybe<Scalars['String']['input']>;
};

/** Marital status of the resident */
export enum MaritalStatus {
  DeFacto = 'DE_FACTO',
  Divorced = 'DIVORCED',
  Married = 'MARRIED',
  Other = 'OTHER',
  Separated = 'SEPARATED',
  Single = 'SINGLE',
  Widowed = 'WIDOWED'
}

export type MarkAgentJobsReviewedInput = {
  ids: Array<Scalars['ID']['input']>;
  reviewed: Scalars['Boolean']['input'];
};

export type MarkDeliveredInput = {
  deliveredAt?: InputMaybe<Scalars['DateTime']['input']>;
  deliveryNotes?: InputMaybe<Scalars['String']['input']>;
  discrepancyNotes?: InputMaybe<Scalars['String']['input']>;
  hasDiscrepancies?: InputMaybe<Scalars['Boolean']['input']>;
  orderId: Scalars['ID']['input'];
};

export type MarkMonthlyRoomCheckCompletedInput = {
  notes?: InputMaybe<Scalars['String']['input']>;
  photos?: InputMaybe<Array<MaintenanceMediaInput>>;
};

export type MarkRespiteUsedInput = {
  actualCheckOutDate?: InputMaybe<Scalars['DateTime']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
};

export type MarkRewardPayoutPaidInput = {
  paymentRef?: InputMaybe<Scalars['String']['input']>;
  requestId: Scalars['ID']['input'];
};

export type MarkUpgradeAppliedInput = {
  notes?: InputMaybe<Scalars['String']['input']>;
  status: UpgradeStatus;
  tenantId: Scalars['ID']['input'];
  upgradeId: Scalars['ID']['input'];
};

export type MasterMediaFile = {
  __typename?: 'MasterMediaFile';
  createdAt: Scalars['DateTime']['output'];
  fileSize: Scalars['Float']['output'];
  fileType: Scalars['String']['output'];
  filename: Scalars['String']['output'];
  id: Scalars['String']['output'];
  ipfsHash?: Maybe<Scalars['String']['output']>;
  mimeType: Scalars['String']['output'];
  sessionId?: Maybe<Scalars['String']['output']>;
  source: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  tenantName: Scalars['String']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type MasterMediaFilters = {
  fileType?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Float']['input']>;
  offset?: InputMaybe<Scalars['Float']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
};

export type MasterStorageStats = {
  __typename?: 'MasterStorageStats';
  byTenant: Array<TenantStorageStats>;
  totalBytes: Scalars['Float']['output'];
  totalDroneBytes: Scalars['Float']['output'];
  totalDroneFiles: Scalars['Float']['output'];
  totalFiles: Scalars['Float']['output'];
  totalMediaBytes: Scalars['Float']['output'];
  totalMediaItems: Scalars['Float']['output'];
};

export type MasterTwinStatus = {
  __typename?: 'MasterTwinStatus';
  shiftId: Scalars['ID']['output'];
  twinId?: Maybe<Scalars['ID']['output']>;
};

export type MatchCandidateType = {
  __typename?: 'MatchCandidateType';
  archived?: Maybe<Scalars['Boolean']['output']>;
  builder?: Maybe<Scalars['String']['output']>;
  clientName?: Maybe<Scalars['String']['output']>;
  confidence: Scalars['Float']['output'];
  dealNumber?: Maybe<Scalars['String']['output']>;
  evidence: Array<MatchEvidenceType>;
  expected?: Maybe<Scalars['Float']['output']>;
  owed?: Maybe<Scalars['Float']['output']>;
  projectId: Scalars['String']['output'];
  propertyAddress?: Maybe<Scalars['String']['output']>;
  reason: Scalars['String']['output'];
  status?: Maybe<Scalars['String']['output']>;
};

export type MatchEvidenceMark = {
  __typename?: 'MatchEvidenceMark';
  end: Scalars['Int']['output'];
  start: Scalars['Int']['output'];
  weak?: Maybe<Scalars['Boolean']['output']>;
};

export type MatchEvidenceText = {
  __typename?: 'MatchEvidenceText';
  field: Scalars['String']['output'];
  label: Scalars['String']['output'];
  marks: Array<MatchEvidenceMark>;
  text: Scalars['String']['output'];
};

export type MatchEvidenceType = {
  __typename?: 'MatchEvidenceType';
  caution?: Maybe<Scalars['String']['output']>;
  confidence: Scalars['Float']['output'];
  counted: Scalars['Boolean']['output'];
  deal: Array<MatchEvidenceText>;
  invoice: Array<MatchEvidenceText>;
  kind: Scalars['String']['output'];
  label: Scalars['String']['output'];
  sharedByDeals?: Maybe<Scalars['Int']['output']>;
  strength: Scalars['String']['output'];
};

export type MatchedPayment = {
  __typename?: 'MatchedPayment';
  amount?: Maybe<Scalars['Float']['output']>;
  date?: Maybe<Scalars['String']['output']>;
  instalmentIndex?: Maybe<Scalars['Int']['output']>;
  invoiceNumber?: Maybe<Scalars['String']['output']>;
  linkedAt?: Maybe<Scalars['String']['output']>;
  linkedBy?: Maybe<Scalars['String']['output']>;
  xeroPaymentId: Scalars['String']['output'];
};

export type MealAccompaniment = {
  __typename?: 'MealAccompaniment';
  name: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  type: AccompanimentType;
};

export type MealAccompanimentInput = {
  name: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  type: AccompanimentType;
};

export type MealCalendarIssueReportInput = {
  note?: InputMaybe<Scalars['String']['input']>;
  report: Scalars['String']['input'];
};

export type MealFeedback = {
  __typename?: 'MealFeedback';
  comments?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  feedbackType: FeedbackType;
  id: Scalars['ID']['output'];
  isResolved: Scalars['Boolean']['output'];
  mealPlan?: Maybe<MealPlan>;
  mealPlanId?: Maybe<Scalars['ID']['output']>;
  photos?: Maybe<Array<MealMedia>>;
  rating: Scalars['Float']['output'];
  reportedBy?: Maybe<Scalars['String']['output']>;
  resolutionNotes?: Maybe<Scalars['String']['output']>;
  resolvedAt?: Maybe<Scalars['DateTime']['output']>;
  resolvedBy?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type MealMedia = {
  __typename?: 'MealMedia';
  cid?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  mimeType?: Maybe<Scalars['String']['output']>;
  uploadedAt: Scalars['DateTime']['output'];
  uploadedBy?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

export type MealMediaInput = {
  cid?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  mimeType?: InputMaybe<Scalars['String']['input']>;
  url: Scalars['String']['input'];
};

export type MealPlan = {
  __typename?: 'MealPlan';
  accompaniments?: Maybe<Array<MealAccompaniment>>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  isTemplate: Scalars['Boolean']['output'];
  mealDate: Scalars['DateTime']['output'];
  mealType: MealType;
  quickDescription?: Maybe<Scalars['String']['output']>;
  recipe?: Maybe<Recipe>;
  recipeId?: Maybe<Scalars['ID']['output']>;
  servicePhotoUploadedAt?: Maybe<Scalars['DateTime']['output']>;
  servicePhotoUploadedBy?: Maybe<Scalars['String']['output']>;
  servicePhotos?: Maybe<Array<MealMedia>>;
  servings: Scalars['Float']['output'];
  shift?: Maybe<Shift>;
  shiftId?: Maybe<Scalars['ID']['output']>;
  sortOrder: Scalars['Float']['output'];
  specialNotes?: Maybe<Scalars['String']['output']>;
  templateName?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type MealPlanInAppNotification = {
  __typename?: 'MealPlanInAppNotification';
  actionUrl?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  isRead: Scalars['Boolean']['output'];
  message: Scalars['String']['output'];
  readAt?: Maybe<Scalars['DateTime']['output']>;
  recipientClientId: Scalars['String']['output'];
  referenceId?: Maybe<Scalars['String']['output']>;
  referenceType?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  title: Scalars['String']['output'];
  type: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type MealPlanItemInput = {
  mealType: MealType;
  recipeId: Scalars['ID']['input'];
  servings: Scalars['Float']['input'];
  specialNotes?: InputMaybe<Scalars['String']['input']>;
};

/** How to resolve meal planning notification recipients */
export enum MealPlanNotificationRecipientType {
  AllManagers = 'ALL_MANAGERS',
  Role = 'ROLE',
  SpecificEmployee = 'SPECIFIC_EMPLOYEE'
}

export type MealPlanNotificationRule = {
  __typename?: 'MealPlanNotificationRule';
  channels: Array<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  isEnabled: Scalars['Boolean']['output'];
  messageTemplate?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  recipientClientIds: Array<Scalars['String']['output']>;
  recipientRole?: Maybe<Scalars['String']['output']>;
  recipientType: MealPlanNotificationRecipientType;
  tenantId: Scalars['String']['output'];
  trigger: MealPlanNotificationTrigger;
  updatedAt: Scalars['DateTime']['output'];
};

/** Event in the meal planning module that fires a notification */
export enum MealPlanNotificationTrigger {
  AllEvents = 'ALL_EVENTS',
  FeedbackResolved = 'FEEDBACK_RESOLVED',
  FeedbackSubmitted = 'FEEDBACK_SUBMITTED',
  InvoiceOrderMismatch = 'INVOICE_ORDER_MISMATCH',
  LowRatedFeedback = 'LOW_RATED_FEEDBACK',
  MealPlanCreated = 'MEAL_PLAN_CREATED',
  MealPlanDeleted = 'MEAL_PLAN_DELETED',
  MealPlanUpdated = 'MEAL_PLAN_UPDATED',
  RecipeCreated = 'RECIPE_CREATED',
  RecipeUpdated = 'RECIPE_UPDATED',
  ServicePhotoUploaded = 'SERVICE_PHOTO_UPLOADED',
  SupplierOrderCreated = 'SUPPLIER_ORDER_CREATED',
  SupplierOrderDelivered = 'SUPPLIER_ORDER_DELIVERED',
  SupplierOrderSubmitted = 'SUPPLIER_ORDER_SUBMITTED',
  TemperatureEscalated = 'TEMPERATURE_ESCALATED',
  TemperatureFlagged = 'TEMPERATURE_FLAGGED',
  TemperatureNotRecorded = 'TEMPERATURE_NOT_RECORDED',
  TemperatureOutOfRange = 'TEMPERATURE_OUT_OF_RANGE',
  TemperatureRecorded = 'TEMPERATURE_RECORDED',
  UnknownIngredientOnInvoice = 'UNKNOWN_INGREDIENT_ON_INVOICE'
}

export type MealPlanPhotoSummary = {
  __typename?: 'MealPlanPhotoSummary';
  mealPlanId: Scalars['ID']['output'];
  servicePhotos: Array<MealMedia>;
};

export type MealPlanningSettings = {
  __typename?: 'MealPlanningSettings';
  createdAt: Scalars['DateTime']['output'];
  cycleAnchorDate: Scalars['DateTime']['output'];
  cycleWeeks: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** Types of meals served during the day */
export enum MealType {
  AfternoonTea = 'AFTERNOON_TEA',
  Breakfast = 'BREAKFAST',
  Dinner = 'DINNER',
  Lunch = 'LUNCH',
  MorningTea = 'MORNING_TEA',
  Snack = 'SNACK',
  Supper = 'SUPPER'
}

export type MechanicJob = {
  __typename?: 'MechanicJob';
  actualEndTime?: Maybe<Scalars['DateTime']['output']>;
  actualStartTime?: Maybe<Scalars['DateTime']['output']>;
  checklist?: Maybe<Array<JobChecklist>>;
  checklistProgress: Scalars['Float']['output'];
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  completedBy?: Maybe<Scalars['ID']['output']>;
  completedByName?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<Scalars['ID']['output']>;
  createdByName?: Maybe<Scalars['String']['output']>;
  customerAddress?: Maybe<Scalars['String']['output']>;
  customerEmail?: Maybe<Scalars['String']['output']>;
  customerName?: Maybe<Scalars['String']['output']>;
  customerPhone?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  estimatedDuration?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  invoiceNumber?: Maybe<Scalars['String']['output']>;
  isDeleted: Scalars['Boolean']['output'];
  isPaid: Scalars['Boolean']['output'];
  jobNumber: Scalars['Float']['output'];
  laborCost: Scalars['Float']['output'];
  mechanicAssignedAt?: Maybe<Scalars['DateTime']['output']>;
  mechanicId?: Maybe<Scalars['ID']['output']>;
  mechanicName?: Maybe<Scalars['String']['output']>;
  mechanicNotes?: Maybe<Scalars['String']['output']>;
  mechanicPhone?: Maybe<Scalars['String']['output']>;
  paidAt?: Maybe<Scalars['DateTime']['output']>;
  partsOrderIds?: Maybe<Array<Scalars['ID']['output']>>;
  paymentMethod?: Maybe<Scalars['String']['output']>;
  photos?: Maybe<Array<JobMedia>>;
  priority: MechanicJobPriority;
  progressNotes?: Maybe<Array<JobProgressNote>>;
  publicAccessToken?: Maybe<Scalars['String']['output']>;
  scheduledDate?: Maybe<Scalars['DateTime']['output']>;
  scheduledTime?: Maybe<Scalars['String']['output']>;
  status: MechanicJobStatus;
  tenantId: Scalars['String']['output'];
  title: Scalars['String']['output'];
  totalCost: Scalars['Float']['output'];
  totalPartsCost: Scalars['Float']['output'];
  updatedAt: Scalars['DateTime']['output'];
  vehicles?: Maybe<Array<JobVehicleRef>>;
  videos?: Maybe<Array<JobMedia>>;
};

export type MechanicJobFilterInput = {
  customerName?: InputMaybe<Scalars['String']['input']>;
  customerPhone?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  limit?: InputMaybe<Scalars['Float']['input']>;
  mechanicPhone?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Float']['input']>;
  priority?: InputMaybe<MechanicJobPriority>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<MechanicJobStatus>;
  vehicleId?: InputMaybe<Scalars['String']['input']>;
};

/** Priority level of a mechanic job */
export enum MechanicJobPriority {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM',
  Urgent = 'URGENT'
}

export type MechanicJobStats = {
  __typename?: 'MechanicJobStats';
  avgCompletionTimeHours?: Maybe<Scalars['Float']['output']>;
  awaitingParts: Scalars['Float']['output'];
  completed: Scalars['Float']['output'];
  completedThisMonth: Scalars['Float']['output'];
  draft: Scalars['Float']['output'];
  inProgress: Scalars['Float']['output'];
  scheduled: Scalars['Float']['output'];
  total: Scalars['Float']['output'];
  totalPartsCostThisMonth: Scalars['Float']['output'];
};

/** Status of a mechanic job */
export enum MechanicJobStatus {
  AwaitingParts = 'AWAITING_PARTS',
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Draft = 'DRAFT',
  Invoiced = 'INVOICED',
  InProgress = 'IN_PROGRESS',
  Paid = 'PAID',
  ReadyToSchedule = 'READY_TO_SCHEDULE',
  Scheduled = 'SCHEDULED'
}

/** Delivery channel for a mechanic-jobs notification */
export enum MechanicNotificationChannel {
  Email = 'EMAIL',
  InApp = 'IN_APP',
  Sms = 'SMS'
}

export type MechanicNotificationLog = {
  __typename?: 'MechanicNotificationLog';
  channel: MechanicNotificationChannel;
  createdAt: Scalars['DateTime']['output'];
  error?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  jobId?: Maybe<Scalars['ID']['output']>;
  jobNumber?: Maybe<Scalars['Float']['output']>;
  outcome: MechanicNotificationOutcome;
  recipientAddress?: Maybe<Scalars['String']['output']>;
  recipientName: Scalars['String']['output'];
  ruleId?: Maybe<Scalars['ID']['output']>;
  ruleName?: Maybe<Scalars['String']['output']>;
  sentAt: Scalars['DateTime']['output'];
  summary?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  trigger: MechanicNotificationTrigger;
  updatedAt: Scalars['DateTime']['output'];
};

/** What actually happened to a single mechanic-jobs notification attempt */
export enum MechanicNotificationOutcome {
  Failed = 'FAILED',
  Sent = 'SENT',
  SkippedDailyCap = 'SKIPPED_DAILY_CAP',
  SkippedDryRun = 'SKIPPED_DRY_RUN',
  SkippedLowSmsBalance = 'SKIPPED_LOW_SMS_BALANCE',
  SkippedNoContact = 'SKIPPED_NO_CONTACT'
}

export type MechanicNotificationRecipient = {
  __typename?: 'MechanicNotificationRecipient';
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
};

/** How to resolve who receives a mechanic-jobs notification */
export enum MechanicNotificationRecipientType {
  AssignedMechanic = 'ASSIGNED_MECHANIC',
  JobCreator = 'JOB_CREATOR',
  SpecificClient = 'SPECIFIC_CLIENT'
}

export type MechanicNotificationRule = {
  __typename?: 'MechanicNotificationRule';
  channels: Array<MechanicNotificationChannel>;
  createdAt: Scalars['DateTime']['output'];
  dailyCap: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  isArmed: Scalars['Boolean']['output'];
  isEnabled: Scalars['Boolean']['output'];
  messageTemplate?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  recipientClientIds?: Maybe<Array<Scalars['String']['output']>>;
  recipientType: MechanicNotificationRecipientType;
  tenantId: Scalars['String']['output'];
  trigger: MechanicNotificationTrigger;
  updatedAt: Scalars['DateTime']['output'];
};

/** Job event that fires a mechanic-jobs notification */
export enum MechanicNotificationTrigger {
  AllEvents = 'ALL_EVENTS',
  ChecklistItemCompleted = 'CHECKLIST_ITEM_COMPLETED',
  JobCompleted = 'JOB_COMPLETED',
  JobCreated = 'JOB_CREATED',
  MechanicAssigned = 'MECHANIC_ASSIGNED',
  PartsOrderCreated = 'PARTS_ORDER_CREATED',
  PartsOrderDelivered = 'PARTS_ORDER_DELIVERED',
  PhotoAdded = 'PHOTO_ADDED',
  ProgressNoteAdded = 'PROGRESS_NOTE_ADDED',
  StatusChanged = 'STATUS_CHANGED'
}

/** Type/category of uploaded media */
export enum MediaActivityType {
  After = 'AFTER',
  Before = 'BEFORE',
  Document = 'DOCUMENT',
  During = 'DURING',
  Other = 'OTHER',
  Receipt = 'RECEIPT'
}

export type MediaCdnStats = {
  __typename?: 'MediaCDNStats';
  audioCount: Scalars['Float']['output'];
  documentCount: Scalars['Float']['output'];
  imageCount: Scalars['Float']['output'];
  otherCount: Scalars['Float']['output'];
  totalFiles: Scalars['Float']['output'];
  totalFolders: Scalars['Float']['output'];
  totalStorageBytes: Scalars['Float']['output'];
  videoCount: Scalars['Float']['output'];
};

export type MediaCdnUploadResult = {
  __typename?: 'MediaCDNUploadResult';
  fileName: Scalars['String']['output'];
  fileSize: Scalars['Float']['output'];
  ipfsHash: Scalars['String']['output'];
  mimeType: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

/** Type of media file */
export enum MediaFileType {
  Audio = 'AUDIO',
  Document = 'DOCUMENT',
  Image = 'IMAGE',
  Other = 'OTHER',
  Video = 'VIDEO'
}

export type MediaFolder = {
  __typename?: 'MediaFolder';
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  itemCount: Scalars['Float']['output'];
  lastEditedBy?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  parentId?: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  totalStorageBytes: Scalars['Float']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type MediaItem = {
  __typename?: 'MediaItem';
  altText?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  fileExtension?: Maybe<Scalars['String']['output']>;
  fileSize: Scalars['Float']['output'];
  fileType: Scalars['String']['output'];
  folderId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  ipfsHash: Scalars['String']['output'];
  isPublic: Scalars['Boolean']['output'];
  lastEditedBy?: Maybe<Scalars['String']['output']>;
  metadata?: Maybe<Scalars['String']['output']>;
  mimeType: Scalars['String']['output'];
  name: Scalars['String']['output'];
  originalFilename: Scalars['String']['output'];
  tags?: Maybe<Array<Scalars['String']['output']>>;
  tenantId: Scalars['String']['output'];
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  uploadedBy: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type MediaItemFilters = {
  fileType?: InputMaybe<MediaFileType>;
  folderId?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Float']['input']>;
  offset?: InputMaybe<Scalars['Float']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type MediaItemListResult = {
  __typename?: 'MediaItemListResult';
  hasMore: Scalars['Boolean']['output'];
  limit: Scalars['Float']['output'];
  offset: Scalars['Float']['output'];
  total: Scalars['Float']['output'];
};

export type MediaUploadData = {
  fileSize: Scalars['Float']['input'];
  ipfsHash: Scalars['String']['input'];
  mimeType: Scalars['String']['input'];
  originalFilename: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

/** Access levels for medical record permissions */
export enum MedicalAccessLevel {
  Admin = 'ADMIN',
  Download = 'DOWNLOAD',
  Full = 'FULL',
  None = 'NONE',
  Upload = 'UPLOAD',
  ViewContent = 'VIEW_CONTENT',
  ViewMetadata = 'VIEW_METADATA'
}

export type MedicalAuditLog = {
  __typename?: 'MedicalAuditLog';
  action: AuditAction;
  createdAt: Scalars['DateTime']['output'];
  errorMessage?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  ipAddress?: Maybe<Scalars['String']['output']>;
  isEmergencyAccess: Scalars['Boolean']['output'];
  isSuspicious: Scalars['Boolean']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
  outcome: AuditOutcome;
  patientId?: Maybe<Scalars['ID']['output']>;
  purpose?: Maybe<Scalars['String']['output']>;
  resourceId?: Maybe<Scalars['ID']['output']>;
  resourceType: Scalars['String']['output'];
  sessionId?: Maybe<Scalars['String']['output']>;
  suspiciousReason?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  timestamp: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  userAgent?: Maybe<Scalars['String']['output']>;
  userEmail: Scalars['String']['output'];
  userId: Scalars['ID']['output'];
  userName: Scalars['String']['output'];
  userRole?: Maybe<Scalars['String']['output']>;
};

/** Types of medical documents */
export enum MedicalDocumentType {
  CarePlan = 'CARE_PLAN',
  ConsentForm = 'CONSENT_FORM',
  ConsultationNotes = 'CONSULTATION_NOTES',
  DischargeSummary = 'DISCHARGE_SUMMARY',
  ImagingCt = 'IMAGING_CT',
  ImagingMri = 'IMAGING_MRI',
  ImagingXray = 'IMAGING_XRAY',
  IncidentReport = 'INCIDENT_REPORT',
  MedicationChart = 'MEDICATION_CHART',
  Other = 'OTHER',
  PathologyResults = 'PATHOLOGY_RESULTS',
  ProgressNotes = 'PROGRESS_NOTES',
  ReferralLetter = 'REFERRAL_LETTER',
  ResidentPhoto = 'RESIDENT_PHOTO',
  SpecialistReport = 'SPECIALIST_REPORT'
}

export type MedicalRecord = {
  __typename?: 'MedicalRecord';
  canOpen: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  deleteReason?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  deletedBy?: Maybe<Scalars['ID']['output']>;
  documentType: MedicalDocumentType;
  encryptionKeyId: Scalars['ID']['output'];
  facilityId?: Maybe<Scalars['ID']['output']>;
  fileName: Scalars['String']['output'];
  fileSize: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
  mimeType: Scalars['String']['output'];
  originalFileName: Scalars['String']['output'];
  patientId: Scalars['ID']['output'];
  secureUrl?: Maybe<Scalars['String']['output']>;
  sourceArchived?: Maybe<Scalars['Boolean']['output']>;
  sourceDocId?: Maybe<Scalars['String']['output']>;
  sourceDocumentDate?: Maybe<Scalars['DateTime']['output']>;
  sourceFields?: Maybe<SarahMedicalSourceFields>;
  sourceMetadataBackupDate?: Maybe<Scalars['DateTime']['output']>;
  sourceMetadataImportedAt?: Maybe<Scalars['DateTime']['output']>;
  sourceResidentId?: Maybe<Scalars['String']['output']>;
  sourceSha256?: Maybe<Scalars['String']['output']>;
  sourceSystem?: Maybe<Scalars['String']['output']>;
  status: MedicalRecordStatus;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  uploadedAt: Scalars['DateTime']['output'];
  uploadedBy: Scalars['ID']['output'];
  uploadedByName: Scalars['String']['output'];
};

export type MedicalRecordAccessDecisionResult = {
  __typename?: 'MedicalRecordAccessDecisionResult';
  grant?: Maybe<MedicalRecordPermission>;
  message: Scalars['String']['output'];
  notifications: Array<MedicalRecordNotificationOutcome>;
  request: MedicalRecordAccessRequest;
  requesterCanOpenNow: Scalars['Boolean']['output'];
};

/** What a staff member asked to be able to do with a resident's medical files */
export enum MedicalRecordAccessNeed {
  List = 'LIST',
  Open = 'OPEN'
}

export type MedicalRecordAccessRequest = {
  __typename?: 'MedicalRecordAccessRequest';
  cancelledAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  decidedAt?: Maybe<Scalars['DateTime']['output']>;
  decidedById?: Maybe<Scalars['String']['output']>;
  decidedByName?: Maybe<Scalars['String']['output']>;
  decisionNote?: Maybe<Scalars['String']['output']>;
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  grantId?: Maybe<Scalars['String']['output']>;
  grantedLevel?: Maybe<MedicalAccessLevel>;
  grantedScope?: Maybe<MedicalRecordAccessScope>;
  hasResidentAccessNow?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  loginMissingPermissionWords?: Maybe<Array<Scalars['String']['output']>>;
  loginMissingPermissions?: Maybe<Array<Scalars['String']['output']>>;
  loginPermissionsUrl?: Maybe<Scalars['String']['output']>;
  loginPermissionsWhere?: Maybe<Scalars['String']['output']>;
  missingPermissions: Array<Scalars['String']['output']>;
  missingResidentGrant: Scalars['Boolean']['output'];
  missingRolePermission: Scalars['Boolean']['output'];
  needs: MedicalRecordAccessNeed;
  patientId: Scalars['String']['output'];
  reason?: Maybe<Scalars['String']['output']>;
  requesterId: Scalars['String']['output'];
  requesterName: Scalars['String']['output'];
  residentName: Scalars['String']['output'];
  status: MedicalRecordAccessRequestStatus;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type MedicalRecordAccessRequestPage = {
  __typename?: 'MedicalRecordAccessRequestPage';
  items: Array<MedicalRecordAccessRequest>;
  pendingCount: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type MedicalRecordAccessRequestResult = {
  __typename?: 'MedicalRecordAccessRequestResult';
  alreadyPending: Scalars['Boolean']['output'];
  notifications: Array<MedicalRecordNotificationOutcome>;
  request: MedicalRecordAccessRequest;
};

/** Where a medical-records access request is up to */
export enum MedicalRecordAccessRequestStatus {
  Approved = 'APPROVED',
  Cancelled = 'CANCELLED',
  Declined = 'DECLINED',
  Pending = 'PENDING'
}

/** Whether an approved access request covers one resident or every resident */
export enum MedicalRecordAccessScope {
  AllResidents = 'ALL_RESIDENTS',
  ThisResident = 'THIS_RESIDENT'
}

export type MedicalRecordAccessSummary = {
  __typename?: 'MedicalRecordAccessSummary';
  canList: Scalars['Boolean']['output'];
  canManageAccess: Scalars['Boolean']['output'];
  canOpen: Scalars['Boolean']['output'];
  canUpload: Scalars['Boolean']['output'];
  howToGetAccess?: Maybe<Scalars['String']['output']>;
  latestRequest?: Maybe<MedicalRecordAccessRequest>;
  listBlockedReason?: Maybe<Scalars['String']['output']>;
  missingPermissionWords: Array<Scalars['String']['output']>;
  missingPermissions: Array<Scalars['String']['output']>;
  missingResidentGrant: Scalars['Boolean']['output'];
  openBlockedReason?: Maybe<Scalars['String']['output']>;
  whoCanGiveAccess?: Maybe<Scalars['String']['output']>;
};

export type MedicalRecordFilterInput = {
  documentType?: InputMaybe<MedicalDocumentType>;
  facilityId?: InputMaybe<Scalars['ID']['input']>;
  patientId?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  uploadedAfter?: InputMaybe<Scalars['DateTime']['input']>;
  uploadedBefore?: InputMaybe<Scalars['DateTime']['input']>;
  uploadedBy?: InputMaybe<Scalars['ID']['input']>;
};

export type MedicalRecordNotificationOutcome = {
  __typename?: 'MedicalRecordNotificationOutcome';
  delivered: Scalars['Boolean']['output'];
  detail: Scalars['String']['output'];
  recipientName: Scalars['String']['output'];
};

export type MedicalRecordPermission = {
  __typename?: 'MedicalRecordPermission';
  accessLevel: MedicalAccessLevel;
  createdAt: Scalars['DateTime']['output'];
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  grantedAt: Scalars['DateTime']['output'];
  grantedBy: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  isRevoked: Scalars['Boolean']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  patientId?: Maybe<Scalars['ID']['output']>;
  purpose?: Maybe<Scalars['String']['output']>;
  revokeReason?: Maybe<Scalars['String']['output']>;
  revokedAt?: Maybe<Scalars['DateTime']['output']>;
  revokedBy?: Maybe<Scalars['ID']['output']>;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  userId: Scalars['ID']['output'];
};

/** Status of a medical record */
export enum MedicalRecordStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
  Deleted = 'DELETED',
  LegalHold = 'LEGAL_HOLD'
}

export type MedicalRecordsExemptOption = {
  __typename?: 'MedicalRecordsExemptOption';
  means: Scalars['String']['output'];
  permission: Scalars['String']['output'];
  words: Scalars['String']['output'];
};

export type MedicalRecordsShiftRule = {
  __typename?: 'MedicalRecordsShiftRule';
  exemptOptions: Array<MedicalRecordsExemptOption>;
  exemptPermissions: Array<Scalars['String']['output']>;
  graceHours: Scalars['Int']['output'];
  isDefault: Scalars['Boolean']['output'];
  requireOnShift: Scalars['Boolean']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedByName?: Maybe<Scalars['String']['output']>;
};

export type MedicalRecordsShiftStatus = {
  __typename?: 'MedicalRecordsShiftStatus';
  canOpenNow: Scalars['Boolean']['output'];
  exempt: Scalars['Boolean']['output'];
  message: Scalars['String']['output'];
  onShiftNow: Scalars['Boolean']['output'];
  onShiftUntil?: Maybe<Scalars['DateTime']['output']>;
  ruleOn: Scalars['Boolean']['output'];
};

export type MedicareDetails = {
  __typename?: 'MedicareDetails';
  expiryDate?: Maybe<Scalars['DateTime']['output']>;
  /** Line number on Medicare card (1-9) */
  lineNumber?: Maybe<Scalars['Int']['output']>;
  number?: Maybe<Scalars['String']['output']>;
};

export type MedicareDetailsInput = {
  expiryDate?: InputMaybe<Scalars['DateTime']['input']>;
  lineNumber?: InputMaybe<Scalars['Int']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
};

/** Medicare levy variation per TFN declaration */
export enum MedicareVariation {
  FullExemption = 'FULL_EXEMPTION',
  HalfExemption = 'HALF_EXEMPTION',
  None = 'NONE',
  Reduction = 'REDUCTION'
}

export type Medication = {
  __typename?: 'Medication';
  administrationTimes: Array<Scalars['String']['output']>;
  ceaseReason?: Maybe<Scalars['String']['output']>;
  ceasedBy?: Maybe<Scalars['ID']['output']>;
  ceasedByName?: Maybe<Scalars['String']['output']>;
  ceasedDate?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['ID']['output'];
  createdByName: Scalars['String']['output'];
  crushable: Scalars['Boolean']['output'];
  dosage: Scalars['String']['output'];
  drugSchedule: DrugSchedule;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  form: MedicationForm;
  frequency: Scalars['String']['output'];
  genericName?: Maybe<Scalars['String']['output']>;
  highAlertMedication: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isLocked: Scalars['Boolean']['output'];
  lastEditedAt?: Maybe<Scalars['DateTime']['output']>;
  lastEditedBy?: Maybe<Scalars['ID']['output']>;
  lastEditedByName?: Maybe<Scalars['String']['output']>;
  medicationName: Scalars['String']['output'];
  medicationType: MedicationType;
  prescriberId: Scalars['ID']['output'];
  prescriberName: Scalars['String']['output'];
  prescriptionDate: Scalars['DateTime']['output'];
  prescriptionNumber?: Maybe<Scalars['String']['output']>;
  reactivatedAt?: Maybe<Scalars['DateTime']['output']>;
  reactivatedBy?: Maybe<Scalars['ID']['output']>;
  reactivatedByName?: Maybe<Scalars['String']['output']>;
  reactivationReason?: Maybe<Scalars['String']['output']>;
  residentId: Scalars['ID']['output'];
  route: AdministrationRoute;
  s8Controlled: Scalars['Boolean']['output'];
  selfAdministered: Scalars['Boolean']['output'];
  specialInstructions?: Maybe<Scalars['String']['output']>;
  startDate: Scalars['DateTime']['output'];
  status: MedicationStatus;
  strength: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type MedicationAdministration = {
  __typename?: 'MedicationAdministration';
  administeredBy?: Maybe<Scalars['ID']['output']>;
  administeredByName?: Maybe<Scalars['String']['output']>;
  administeredDate?: Maybe<Scalars['DateTime']['output']>;
  administeredTime?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  dosage?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  linkedObservationId?: Maybe<Scalars['ID']['output']>;
  medicationId: Scalars['ID']['output'];
  medicationName?: Maybe<Scalars['String']['output']>;
  missedReason?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  refusedReason?: Maybe<Scalars['String']['output']>;
  residentId: Scalars['ID']['output'];
  roundId?: Maybe<Scalars['ID']['output']>;
  scheduledDate: Scalars['DateTime']['output'];
  scheduledTime: Scalars['String']['output'];
  status: AdministrationStatus;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  vitalSignsTaken: Scalars['Boolean']['output'];
  withholdReason?: Maybe<WithholdReason>;
  withholdReasonText?: Maybe<Scalars['String']['output']>;
  witnessedBy?: Maybe<Scalars['ID']['output']>;
  witnessedByName?: Maybe<Scalars['String']['output']>;
};

export type MedicationAlert = {
  __typename?: 'MedicationAlert';
  acknowledgedAt?: Maybe<Scalars['DateTime']['output']>;
  acknowledgedBy?: Maybe<Scalars['ID']['output']>;
  acknowledgedByName?: Maybe<Scalars['String']['output']>;
  acknowledgementNotes?: Maybe<Scalars['String']['output']>;
  administrationId?: Maybe<Scalars['ID']['output']>;
  alertType: MedicationAlertType;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  isAcknowledged: Scalars['Boolean']['output'];
  isRead: Scalars['Boolean']['output'];
  medicationId?: Maybe<Scalars['ID']['output']>;
  medicationName?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  readAt?: Maybe<Scalars['DateTime']['output']>;
  readBy?: Maybe<Scalars['ID']['output']>;
  readByName?: Maybe<Scalars['String']['output']>;
  residentId?: Maybe<Scalars['ID']['output']>;
  residentName?: Maybe<Scalars['String']['output']>;
  severity?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** Type of medication alert */
export enum MedicationAlertType {
  AllergyWarning = 'ALLERGY_WARNING',
  CeaseDateApproaching = 'CEASE_DATE_APPROACHING',
  InteractionWarning = 'INTERACTION_WARNING',
  LowStock = 'LOW_STOCK',
  MedicationReviewDue = 'MEDICATION_REVIEW_DUE',
  MissedDose = 'MISSED_DOSE',
  S8Discrepancy = 'S8_DISCREPANCY'
}

export type MedicationAllergy = {
  __typename?: 'MedicationAllergy';
  allergen: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  deactivatedAt?: Maybe<Scalars['DateTime']['output']>;
  deactivatedBy?: Maybe<Scalars['ID']['output']>;
  deactivatedByName?: Maybe<Scalars['String']['output']>;
  discoveredDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  reactionSeverity?: Maybe<AllergySeverity>;
  reactionType?: Maybe<Scalars['String']['output']>;
  reportedBy?: Maybe<Scalars['String']['output']>;
  residentId: Scalars['ID']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type MedicationChart = {
  __typename?: 'MedicationChart';
  allergies: Array<Scalars['String']['output']>;
  generatedAt: Scalars['DateTime']['output'];
  generatedBy: Scalars['String']['output'];
  medications: Array<MedicationChartEntry>;
  residentId: Scalars['ID']['output'];
  residentName: Scalars['String']['output'];
  roomNumber?: Maybe<Scalars['String']['output']>;
  wing?: Maybe<Scalars['String']['output']>;
};

export type MedicationChartEntry = {
  __typename?: 'MedicationChartEntry';
  administrationTimes: Array<Scalars['String']['output']>;
  crushable: Scalars['Boolean']['output'];
  dosage: Scalars['String']['output'];
  frequency: Scalars['String']['output'];
  medicationId: Scalars['ID']['output'];
  medicationName: Scalars['String']['output'];
  s8Controlled: Scalars['Boolean']['output'];
  specialInstructions?: Maybe<Scalars['String']['output']>;
  strength: Scalars['String']['output'];
};

export type MedicationFilterInput = {
  limit?: InputMaybe<Scalars['Float']['input']>;
  medicationType?: InputMaybe<MedicationType>;
  offset?: InputMaybe<Scalars['Float']['input']>;
  residentId?: InputMaybe<Scalars['ID']['input']>;
  s8Only?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<MedicationStatus>;
  wing?: InputMaybe<Scalars['String']['input']>;
};

/** Physical form of the medication */
export enum MedicationForm {
  Capsule = 'CAPSULE',
  Cream = 'CREAM',
  Drops = 'DROPS',
  Inhaler = 'INHALER',
  Injection = 'INJECTION',
  Liquid = 'LIQUID',
  Nebulizer = 'NEBULIZER',
  Ointment = 'OINTMENT',
  Patch = 'PATCH',
  Powder = 'POWDER',
  Spray = 'SPRAY',
  Suppository = 'SUPPOSITORY',
  Tablet = 'TABLET'
}

/** Level of mobility assistance required (for medication mobility/aids) */
export enum MedicationMobilityLevel {
  Dependent = 'DEPENDENT',
  Independent = 'INDEPENDENT',
  MaximumAssist = 'MAXIMUM_ASSIST',
  MinimalAssist = 'MINIMAL_ASSIST',
  ModerateAssist = 'MODERATE_ASSIST',
  Supervision = 'SUPERVISION'
}

export type MedicationPrescriber = {
  __typename?: 'MedicationPrescriber';
  address?: Maybe<Scalars['String']['output']>;
  clinic?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  email?: Maybe<Scalars['String']['output']>;
  fax?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  providerNumber: Scalars['String']['output'];
  specialty?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type MedicationRound = {
  __typename?: 'MedicationRound';
  calendarEventId?: Maybe<Scalars['ID']['output']>;
  cancelReason?: Maybe<Scalars['String']['output']>;
  conductedBy?: Maybe<Scalars['ID']['output']>;
  conductedByName?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  endTime?: Maybe<Scalars['String']['output']>;
  givenCount: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  missedCount: Scalars['Float']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  refusedCount: Scalars['Float']['output'];
  roundDate: Scalars['DateTime']['output'];
  roundName: Scalars['String']['output'];
  roundTime: Scalars['String']['output'];
  startTime?: Maybe<Scalars['String']['output']>;
  status: RoundStatus;
  tenantId: Scalars['String']['output'];
  totalMedications: Scalars['Float']['output'];
  updatedAt: Scalars['DateTime']['output'];
  wing?: Maybe<Scalars['String']['output']>;
  withheldCount: Scalars['Float']['output'];
};

/** Status of a medication prescription */
export enum MedicationStatus {
  Active = 'ACTIVE',
  Ceased = 'CEASED',
  Completed = 'COMPLETED',
  Suspended = 'SUSPENDED'
}

/** Type of medication schedule */
export enum MedicationType {
  Prn = 'PRN',
  Regular = 'REGULAR',
  ShortTerm = 'SHORT_TERM',
  Stat = 'STAT'
}

export type MedicationsResponse = {
  __typename?: 'MedicationsResponse';
  medications: Array<Medication>;
  total: Scalars['Float']['output'];
};

/** Reach a participant on their personal (Client) or work (Employee) contact */
export enum MeetContactPreference {
  Personal = 'PERSONAL',
  Work = 'WORK'
}

export type MeetDiarizedSegment = {
  __typename?: 'MeetDiarizedSegment';
  displayName?: Maybe<Scalars['String']['output']>;
  end?: Maybe<Scalars['Float']['output']>;
  speakerLabel?: Maybe<Scalars['String']['output']>;
  start?: Maybe<Scalars['Float']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

/** Send a meeting message via SMS or email */
export enum MeetMessageChannel {
  Email = 'EMAIL',
  Sms = 'SMS'
}

/** Join-link, reminder, or a custom free-typed message */
export enum MeetMessageKind {
  Custom = 'CUSTOM',
  JoinLink = 'JOIN_LINK',
  Reminder = 'REMINDER'
}

export type MeetMessageLog = {
  __typename?: 'MeetMessageLog';
  body: Scalars['String']['output'];
  channel: MeetMessageChannel;
  createdAt: Scalars['DateTime']['output'];
  errorMessage?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  kind: MeetMessageKind;
  recipientName?: Maybe<Scalars['String']['output']>;
  roomName: Scalars['String']['output'];
  subject?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  tenantId: Scalars['String']['output'];
  to: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type MeetParticipantInput = {
  clientId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type MeetRecording = {
  __typename?: 'MeetRecording';
  audioCid?: Maybe<Scalars['String']['output']>;
  confidence?: Maybe<Scalars['Float']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  detectedLanguage?: Maybe<Scalars['String']['output']>;
  diarizedSegments?: Maybe<Array<MeetDiarizedSegment>>;
  durationSec?: Maybe<Scalars['Float']['output']>;
  egressId?: Maybe<Scalars['String']['output']>;
  endedAt?: Maybe<Scalars['DateTime']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  fileName?: Maybe<Scalars['String']['output']>;
  fileSize?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  minioKey?: Maybe<Scalars['String']['output']>;
  modelUsed?: Maybe<Scalars['String']['output']>;
  processed: Scalars['Boolean']['output'];
  processingTimeMs?: Maybe<Scalars['Float']['output']>;
  recordingStatus: MeetRecordingStatus;
  recordingUrl?: Maybe<Scalars['String']['output']>;
  speakers?: Maybe<Array<MeetSpeakerRef>>;
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  summaryGeneratedAt?: Maybe<Scalars['DateTime']['output']>;
  transcriptSummary?: Maybe<Scalars['String']['output']>;
  transcriptWarning?: Maybe<Scalars['String']['output']>;
  transcription?: Maybe<Scalars['String']['output']>;
};

/** State of the auto-record → in-house transcription pipeline */
export enum MeetRecordingStatus {
  Done = 'DONE',
  Failed = 'FAILED',
  None = 'NONE',
  Processing = 'PROCESSING',
  Recording = 'RECORDING'
}

export type MeetSpeakerContact = {
  __typename?: 'MeetSpeakerContact';
  canViewClient: Scalars['Boolean']['output'];
  canViewEmployee: Scalars['Boolean']['output'];
  clientId?: Maybe<Scalars['ID']['output']>;
  clientName?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  employeeId?: Maybe<Scalars['ID']['output']>;
  isEmployee: Scalars['Boolean']['output'];
  isRecord: Scalars['Boolean']['output'];
  localLabel: Scalars['String']['output'];
  personalEmail?: Maybe<Scalars['String']['output']>;
  personalPhone?: Maybe<Scalars['String']['output']>;
  voiceSignatureId?: Maybe<Scalars['ID']['output']>;
  workEmail?: Maybe<Scalars['String']['output']>;
  workPhone?: Maybe<Scalars['String']['output']>;
};

export type MeetSpeakerRef = {
  __typename?: 'MeetSpeakerRef';
  displayName?: Maybe<Scalars['String']['output']>;
  localLabel: Scalars['String']['output'];
  signatureLabel?: Maybe<Scalars['String']['output']>;
  voiceSignatureId?: Maybe<Scalars['ID']['output']>;
};

/** Lifecycle state of a meeting room */
export enum MeetStatus {
  Active = 'ACTIVE',
  Cancelled = 'CANCELLED',
  Ended = 'ENDED',
  Scheduled = 'SCHEDULED'
}

export type MeetTokenResult = {
  __typename?: 'MeetTokenResult';
  canPublish: Scalars['Boolean']['output'];
  displayName: Scalars['String']['output'];
  identity: Scalars['String']['output'];
  meetingTitle?: Maybe<Scalars['String']['output']>;
  roomName: Scalars['String']['output'];
  token: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type MeetTranscriptionModelsInfo = {
  __typename?: 'MeetTranscriptionModelsInfo';
  available: Array<Scalars['String']['output']>;
  default: Scalars['String']['output'];
};

export type MeetVoiceSignature = {
  __typename?: 'MeetVoiceSignature';
  createdAt: Scalars['DateTime']['output'];
  displayName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  lastSeenAt?: Maybe<Scalars['DateTime']['output']>;
  mappedClientId?: Maybe<Scalars['ID']['output']>;
  mappedName?: Maybe<Scalars['String']['output']>;
  recordings?: Maybe<Array<MeetVoiceSignatureRecordingRef>>;
  sampleCount: Scalars['Float']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type MeetVoiceSignatureRecordingRef = {
  __typename?: 'MeetVoiceSignatureRecordingRef';
  date?: Maybe<Scalars['DateTime']['output']>;
  localLabel?: Maybe<Scalars['String']['output']>;
  recordingId: Scalars['ID']['output'];
  roomName: Scalars['String']['output'];
  status?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type Meeting = {
  __typename?: 'Meeting';
  calendarEventId?: Maybe<Scalars['String']['output']>;
  calendarId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  egressId?: Maybe<Scalars['String']['output']>;
  endedAt?: Maybe<Scalars['DateTime']['output']>;
  hostClientId?: Maybe<Scalars['String']['output']>;
  hostName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastStartedAt?: Maybe<Scalars['DateTime']['output']>;
  participants: Array<MeetingParticipant>;
  recordingAudioCid?: Maybe<Scalars['String']['output']>;
  recordingEnabled: Scalars['Boolean']['output'];
  recordingStatus: MeetRecordingStatus;
  recordingUrl?: Maybe<Scalars['String']['output']>;
  recordings: Array<MeetRecording>;
  roomName: Scalars['String']['output'];
  scheduledEnd?: Maybe<Scalars['DateTime']['output']>;
  scheduledStart?: Maybe<Scalars['DateTime']['output']>;
  sentMessages: Array<MeetMessageLog>;
  status: MeetStatus;
  tenantId: Scalars['String']['output'];
  title: Scalars['String']['output'];
  transcriptId?: Maybe<Scalars['String']['output']>;
  transcriptSummary?: Maybe<Scalars['String']['output']>;
  transcriptText?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type MeetingAgendaItem = {
  __typename?: 'MeetingAgendaItem';
  completed: Scalars['Boolean']['output'];
  duration?: Maybe<Scalars['Float']['output']>;
  presenter?: Maybe<Scalars['String']['output']>;
  topic: Scalars['String']['output'];
};

export type MeetingAgendaItemInput = {
  duration?: InputMaybe<Scalars['Float']['input']>;
  presenter?: InputMaybe<Scalars['String']['input']>;
  topic: Scalars['String']['input'];
};

export type MeetingAttendee = {
  __typename?: 'MeetingAttendee';
  attended: Scalars['Boolean']['output'];
  company?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  isInternal: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
};

export type MeetingAttendeeInput = {
  company?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  isInternal?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
};

/** Format of the meeting */
export enum MeetingFormat {
  Hybrid = 'HYBRID',
  InPerson = 'IN_PERSON',
  PhoneCall = 'PHONE_CALL',
  VideoCall = 'VIDEO_CALL'
}

export type MeetingParticipant = {
  __typename?: 'MeetingParticipant';
  clientId?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  hasEmployeeRecord: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  personalEmail?: Maybe<Scalars['String']['output']>;
  personalPhone?: Maybe<Scalars['String']['output']>;
  rsvpStatus?: Maybe<Scalars['String']['output']>;
  workEmail?: Maybe<Scalars['String']['output']>;
  workPhone?: Maybe<Scalars['String']['output']>;
};

/** Status of the meeting */
export enum MeetingStatus {
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS',
  NoShow = 'NO_SHOW',
  Rescheduled = 'RESCHEDULED',
  Scheduled = 'SCHEDULED'
}

/** Type of meeting */
export enum MeetingType {
  CheckIn = 'CHECK_IN',
  Closing = 'CLOSING',
  Demo = 'DEMO',
  Discovery = 'DISCOVERY',
  InitialCall = 'INITIAL_CALL',
  Negotiation = 'NEGOTIATION',
  Other = 'OTHER',
  ProposalPresentation = 'PROPOSAL_PRESENTATION',
  Review = 'REVIEW'
}

export type MemberSplit = {
  __typename?: 'MemberSplit';
  amount?: Maybe<Scalars['Float']['output']>;
  clientId: Scalars['String']['output'];
  clientName?: Maybe<Scalars['String']['output']>;
  paidOutDate?: Maybe<Scalars['DateTime']['output']>;
  payoutDate?: Maybe<Scalars['DateTime']['output']>;
  payoutDelayDays?: Maybe<Scalars['Int']['output']>;
  payoutNotes?: Maybe<Scalars['String']['output']>;
  payoutStatus?: Maybe<PayoutStatus>;
  percentage: Scalars['Float']['output'];
  transactionId?: Maybe<Scalars['String']['output']>;
};

export type MemberSplitInput = {
  clientId: Scalars['String']['input'];
  payoutDate?: InputMaybe<Scalars['DateTime']['input']>;
  payoutDelayDays?: InputMaybe<Scalars['Int']['input']>;
  payoutNotes?: InputMaybe<Scalars['String']['input']>;
  payoutStatus?: InputMaybe<PayoutStatus>;
  percentage: Scalars['Float']['input'];
};

export type MergeHistoryItem = {
  __typename?: 'MergeHistoryItem';
  branchName: Scalars['String']['output'];
  changedFiles: Array<Scalars['String']['output']>;
  commitsMerged?: Maybe<Scalars['Float']['output']>;
  duration?: Maybe<Scalars['Float']['output']>;
  filesChanged: Scalars['Float']['output'];
  mergeId: Scalars['String']['output'];
  mergedAt: Scalars['String']['output'];
  mergedBy: Scalars['String']['output'];
  siteId: Scalars['String']['output'];
};

export type MergeHistoryResult = {
  __typename?: 'MergeHistoryResult';
  error?: Maybe<Scalars['String']['output']>;
  history: Array<MergeHistoryItem>;
  siteId: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
  total: Scalars['Float']['output'];
};

export type MergeToMainResult = {
  __typename?: 'MergeToMainResult';
  changedFiles?: Maybe<Array<Scalars['String']['output']>>;
  duration?: Maybe<Scalars['Float']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  filesChanged?: Maybe<Scalars['Float']['output']>;
  mergeId?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Type of message content */
export enum MessageContentType {
  Image = 'IMAGE',
  Link = 'LINK',
  System = 'SYSTEM',
  Text = 'TEXT'
}

export type MetricTile = {
  __typename?: 'MetricTile';
  available: Scalars['Boolean']['output'];
  changePct?: Maybe<Scalars['Float']['output']>;
  comparisonLabel?: Maybe<Scalars['String']['output']>;
  format: Scalars['String']['output'];
  hint?: Maybe<Scalars['String']['output']>;
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  linkTo?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  periodLabel?: Maybe<Scalars['String']['output']>;
  previousValue?: Maybe<Scalars['Float']['output']>;
  source: Scalars['String']['output'];
  value?: Maybe<Scalars['Float']['output']>;
};

export type MicrosoftEmail = {
  __typename?: 'MicrosoftEmail';
  aiSummary?: Maybe<Scalars['String']['output']>;
  attachments: Array<MicrosoftEmailAttachment>;
  bodyHtml?: Maybe<Scalars['String']['output']>;
  bodyText?: Maybe<Scalars['String']['output']>;
  cc: Array<Scalars['String']['output']>;
  classifiedAt?: Maybe<Scalars['DateTime']['output']>;
  classifiedBy?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  direction: MicrosoftEmailDirection;
  from?: Maybe<Scalars['String']['output']>;
  fromName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isRoomEnquiry?: Maybe<Scalars['Boolean']['output']>;
  m365MessageId?: Maybe<Scalars['String']['output']>;
  mailbox: Scalars['String']['output'];
  receivedAt?: Maybe<Scalars['DateTime']['output']>;
  sentAt?: Maybe<Scalars['DateTime']['output']>;
  sourceInboundEmailId?: Maybe<Scalars['String']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
  tags: Array<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  threadKey?: Maybe<Scalars['String']['output']>;
  to: Array<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type MicrosoftEmailAttachment = {
  __typename?: 'MicrosoftEmailAttachment';
  ipfsCid?: Maybe<Scalars['String']['output']>;
  ipfsUrl?: Maybe<Scalars['String']['output']>;
  mimeType?: Maybe<Scalars['String']['output']>;
  originalName: Scalars['String']['output'];
  size?: Maybe<Scalars['Int']['output']>;
};

export type MicrosoftEmailAttachmentInput = {
  ipfsCid?: InputMaybe<Scalars['String']['input']>;
  mimeType?: InputMaybe<Scalars['String']['input']>;
  originalName: Scalars['String']['input'];
  size?: InputMaybe<Scalars['Int']['input']>;
};

export enum MicrosoftEmailDirection {
  Inbound = 'INBOUND',
  Outbound = 'OUTBOUND'
}

export type MicrosoftEmailFilterInput = {
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  mailbox?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  tag?: InputMaybe<Scalars['String']['input']>;
};

/** An observable + reversible record of a data-migration import. Created by Chloe's parse_sarahcare_export tool; committed by import_residents_from_migration after user confirmation. */
export type MigrationBatch = {
  __typename?: 'MigrationBatch';
  /** Number of residents actually created on commit (only set when status=COMMITTED) */
  committedRowCount: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  /** Resident _ids created by this batch — used for rollback */
  createdResidentIds: Array<Scalars['String']['output']>;
  /** JSON-serialized array of {row, error} for rows that failed to commit */
  failedRowsJson: Scalars['String']['output'];
  /** Original filename as uploaded */
  filename: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** Client._id of the user who initiated the migration */
  initiatedBy: Scalars['String']['output'];
  /** TTL — when the parsed-rows cache expires (Mongo auto-deletes the doc when this passes) */
  parseExpiresAt: Scalars['DateTime']['output'];
  /** Ephemeral token the model must echo back on the commit call — proof the same parse session is being committed */
  parseToken: Scalars['String']['output'];
  /** Number of resident rows the parser extracted */
  parsedRowCount: Scalars['Int']['output'];
  /** JSON-serialized array of parsed rows {firstName,lastName,dateOfBirth,roomNumber,gender?}. Cleared once committed. */
  parsedRowsJson: Scalars['String']['output'];
  /** Parser used — 'mdb-export' | 'pdfplumber' | 'csv' | 'xlsx' */
  parserUsed: Scalars['String']['output'];
  source: MigrationBatchSource;
  status: MigrationBatchStatus;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  /** IPFS CID of the source file uploaded via media-cdn */
  uploadedFileCid: Scalars['String']['output'];
  /** JSON-serialized array of parser warnings (column-detection issues, skipped rows, etc.) */
  warningsJson: Scalars['String']['output'];
};

/** Which external system / flow this batch came from */
export enum MigrationBatchSource {
  SarahcareChloe = 'SARAHCARE_CHLOE'
}

/** Lifecycle status of a migration batch */
export enum MigrationBatchStatus {
  Committed = 'COMMITTED',
  Expired = 'EXPIRED',
  Failed = 'FAILED',
  Parsed = 'PARSED',
  RolledBack = 'ROLLED_BACK'
}

export type MilestoneEvent = {
  __typename?: 'MilestoneEvent';
  completedAt: Scalars['DateTime']['output'];
  detectedVia?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  milestoneId: Scalars['String']['output'];
};

export type MilestoneInput = {
  description: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  targetDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type MissedMedicationEntry = {
  __typename?: 'MissedMedicationEntry';
  medicationName: Scalars['String']['output'];
  missedReason?: Maybe<Scalars['String']['output']>;
  residentId: Scalars['ID']['output'];
  residentName: Scalars['String']['output'];
  scheduledDate: Scalars['DateTime']['output'];
  scheduledTime: Scalars['String']['output'];
};

export type MissedMedicationsReport = {
  __typename?: 'MissedMedicationsReport';
  endDate: Scalars['DateTime']['output'];
  entries: Array<MissedMedicationEntry>;
  startDate: Scalars['DateTime']['output'];
  totalMissed: Scalars['Float']['output'];
};

export type MobilityAids = {
  __typename?: 'MobilityAids';
  assistanceRequired?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['DateTime']['output'];
  dentureNotes?: Maybe<Scalars['String']['output']>;
  dentureType?: Maybe<Scalars['String']['output']>;
  dentures: Scalars['Boolean']['output'];
  fireEvacAssistance?: Maybe<Scalars['Float']['output']>;
  fireEvacMobility?: Maybe<Scalars['String']['output']>;
  fireEvacSensory?: Maybe<Scalars['String']['output']>;
  glasses: Scalars['Boolean']['output'];
  glassesNotes?: Maybe<Scalars['String']['output']>;
  glassesType?: Maybe<Scalars['String']['output']>;
  hearingAid: Scalars['Boolean']['output'];
  hearingAidNotes?: Maybe<Scalars['String']['output']>;
  hearingAidType?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isHistoricalRecord?: Maybe<Scalars['Boolean']['output']>;
  lastUpdatedBy?: Maybe<Scalars['ID']['output']>;
  lastUpdatedByName?: Maybe<Scalars['String']['output']>;
  manualHandlingNotes?: Maybe<Scalars['String']['output']>;
  mobilityAids: Array<Scalars['String']['output']>;
  mobilityLevel?: Maybe<MedicationMobilityLevel>;
  otherAids: Array<Scalars['String']['output']>;
  otherAidsUsed?: Maybe<Scalars['String']['output']>;
  pacemaker: Scalars['Boolean']['output'];
  pacemakerInsertDate?: Maybe<Scalars['DateTime']['output']>;
  pacemakerNotes?: Maybe<Scalars['String']['output']>;
  pacemakerType?: Maybe<Scalars['String']['output']>;
  residentId: Scalars['ID']['output'];
  selfMedicates: Scalars['Boolean']['output'];
  selfMedicatesNotes?: Maybe<Scalars['String']['output']>;
  sensoryHearing?: Maybe<Scalars['String']['output']>;
  sensoryVision?: Maybe<Scalars['String']['output']>;
  sourceAuthor?: Maybe<Scalars['String']['output']>;
  sourceBackupDate?: Maybe<Scalars['DateTime']['output']>;
  sourceFields?: Maybe<Array<SarahSourceFieldValue>>;
  sourceId?: Maybe<Scalars['String']['output']>;
  sourceSystem?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type MobilityAssessment = {
  __typename?: 'MobilityAssessment';
  assessedBy: Scalars['ID']['output'];
  assessedByName?: Maybe<Scalars['String']['output']>;
  assessmentDate: Scalars['DateTime']['output'];
  autoProgressNote: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  fallsRiskFactors: Array<Scalars['String']['output']>;
  fallsRiskLevel?: Maybe<AssessmentFallsRiskLevel>;
  gaitObservation?: Maybe<GaitObservation>;
  id: Scalars['ID']['output'];
  mobilityLevel: AssessmentMobilityLevel;
  notes?: Maybe<Scalars['String']['output']>;
  progressNoteId?: Maybe<Scalars['ID']['output']>;
  residentId: Scalars['ID']['output'];
  residentName?: Maybe<Scalars['String']['output']>;
  residentRoom?: Maybe<Scalars['String']['output']>;
  residentWing?: Maybe<Scalars['String']['output']>;
  sourceAuthor?: Maybe<Scalars['String']['output']>;
  sourceBackupDate?: Maybe<Scalars['DateTime']['output']>;
  sourceFields?: Maybe<SarahMobilityChangeSourceFields>;
  sourceId?: Maybe<Scalars['String']['output']>;
  sourceSystem?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  transferNotes?: Maybe<Scalars['String']['output']>;
  transferType?: Maybe<TransferType>;
  updatedAt: Scalars['DateTime']['output'];
};

export type MobilityAssessmentFilterInput = {
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  fallsRiskLevel?: InputMaybe<AssessmentFallsRiskLevel>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  mobilityLevel?: InputMaybe<AssessmentMobilityLevel>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  residentId?: InputMaybe<Scalars['ID']['input']>;
  sarahHistory?: InputMaybe<Scalars['Boolean']['input']>;
  wing?: InputMaybe<Scalars['String']['input']>;
};

export type MobilityAssessmentsResponse = {
  __typename?: 'MobilityAssessmentsResponse';
  assessments: Array<MobilityAssessment>;
  limit: Scalars['Int']['output'];
  offset: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

/** Mobility level of the resident */
export enum MobilityLevel {
  BedBound = 'BED_BOUND',
  Independent = 'INDEPENDENT',
  WalksWithAid = 'WALKS_WITH_AID',
  Wheelchair = 'WHEELCHAIR'
}

export type MobilityProfile = {
  __typename?: 'MobilityProfile';
  bathTransfer?: Maybe<TransferAssistance>;
  bedToChairTransfer?: Maybe<TransferAssistance>;
  fallsInLast12Months?: Maybe<Scalars['Float']['output']>;
  fallsRiskFactors?: Maybe<Array<Scalars['String']['output']>>;
  fallsRiskLevel?: Maybe<FallsRiskLevel>;
  hoistType?: Maybe<HoistType>;
  level?: Maybe<MobilityLevel>;
  mobilityNotes?: Maybe<Scalars['String']['output']>;
  otherAids?: Maybe<Array<Scalars['String']['output']>>;
  preventionStrategies?: Maybe<Array<Scalars['String']['output']>>;
  toiletTransfer?: Maybe<TransferAssistance>;
  walkingAid?: Maybe<WalkingAidType>;
};

export type MobilityProfileInput = {
  bathTransfer?: InputMaybe<TransferAssistance>;
  bedToChairTransfer?: InputMaybe<TransferAssistance>;
  fallsInLast12Months?: InputMaybe<Scalars['Float']['input']>;
  fallsRiskFactors?: InputMaybe<Array<Scalars['String']['input']>>;
  fallsRiskLevel?: InputMaybe<FallsRiskLevel>;
  hoistType?: InputMaybe<HoistType>;
  level?: InputMaybe<MobilityLevel>;
  mobilityNotes?: InputMaybe<Scalars['String']['input']>;
  otherAids?: InputMaybe<Array<Scalars['String']['input']>>;
  preventionStrategies?: InputMaybe<Array<Scalars['String']['input']>>;
  toiletTransfer?: InputMaybe<TransferAssistance>;
  walkingAid?: InputMaybe<WalkingAidType>;
};

export type MobilityUpdateInput = {
  fallsRisk?: InputMaybe<Scalars['Boolean']['input']>;
  fallsRiskFactors?: InputMaybe<Array<Scalars['String']['input']>>;
  hoistType?: InputMaybe<Scalars['String']['input']>;
  level?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  transferAssistance?: InputMaybe<Scalars['String']['input']>;
  walkingAids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ModelProbeResult = {
  __typename?: 'ModelProbeResult';
  advice: Scalars['String']['output'];
  finishReason?: Maybe<Scalars['String']['output']>;
  jsonlRecords: Scalars['Int']['output'];
  latencyMs: Scalars['Int']['output'];
  model: Scalars['String']['output'];
  ok: Scalars['Boolean']['output'];
  outputTokens: Scalars['Int']['output'];
  reasoningChars: Scalars['Int']['output'];
  sample: Scalars['String']['output'];
};

export type ModerateSopCommentInput = {
  status: Scalars['String']['input'];
};

/** Audit entry for a single module */
export type ModuleAuditEntry = {
  __typename?: 'ModuleAuditEntry';
  /** Permission levels defined (view, create, edit, delete, ...) */
  levels: Array<Scalars['String']['output']>;
  moduleId: Scalars['String']['output'];
  /** All unique permission names used across all levels */
  permissionsUsed: Array<Scalars['String']['output']>;
};

export enum ModuleCellState {
  Absent = 'ABSENT',
  DeclaredNotInRepo = 'DECLARED_NOT_IN_REPO',
  DeployedNotDeclared = 'DEPLOYED_NOT_DECLARED',
  Drifted = 'DRIFTED',
  Error = 'ERROR',
  InSync = 'IN_SYNC',
  NoRepo = 'NO_REPO',
  RepoMissing = 'REPO_MISSING'
}

export type ModuleDeploymentResult = {
  __typename?: 'ModuleDeploymentResult';
  commitSha?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  tenantId: Scalars['String']['output'];
  tenantName: Scalars['String']['output'];
};

export type ModuleDoctorBriefHistoryEntry = {
  __typename?: 'ModuleDoctorBriefHistoryEntry';
  allowPaths: Array<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  moduleId: Scalars['String']['output'];
  objective: Scalars['String']['output'];
  successCriterion?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  tenantName: Scalars['String']['output'];
  verdictSuccess: Scalars['Boolean']['output'];
  verdictSummary?: Maybe<Scalars['String']['output']>;
};

export type ModuleDoctorBriefInput = {
  allowPaths?: InputMaybe<Array<Scalars['String']['input']>>;
  objective: Scalars['String']['input'];
  successCriterion?: InputMaybe<Scalars['String']['input']>;
};

export type ModuleDoctorJobBrief = {
  __typename?: 'ModuleDoctorJobBrief';
  allowPaths: Array<Scalars['String']['output']>;
  objective: Scalars['String']['output'];
  successCriterion?: Maybe<Scalars['String']['output']>;
};

export type ModuleDriftReport = {
  __typename?: 'ModuleDriftReport';
  cellState: ModuleCellState;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  drifted: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  inModuleConfig: Scalars['Boolean']['output'];
  lastCheckedAt: Scalars['DateTime']['output'];
  lastDeployCheckedAt?: Maybe<Scalars['DateTime']['output']>;
  lastDeployState?: Maybe<Scalars['String']['output']>;
  lastDeployUrl?: Maybe<Scalars['String']['output']>;
  lastUpgradeError?: Maybe<Scalars['String']['output']>;
  lastUpgradeTscErrors: Array<Scalars['String']['output']>;
  lastUpgradeWarnings: Array<Scalars['String']['output']>;
  lastUpgradedAt?: Maybe<Scalars['DateTime']['output']>;
  leadingCommitDate?: Maybe<Scalars['DateTime']['output']>;
  leadingTreeSha?: Maybe<Scalars['String']['output']>;
  leadingVersion?: Maybe<Scalars['String']['output']>;
  linearIssueUrl?: Maybe<Scalars['String']['output']>;
  moduleId: Scalars['String']['output'];
  repoMissing: Scalars['Boolean']['output'];
  scanHost?: Maybe<Scalars['String']['output']>;
  tenantCommitDate?: Maybe<Scalars['DateTime']['output']>;
  tenantDirty?: Maybe<Scalars['Boolean']['output']>;
  tenantFolderExists: Scalars['Boolean']['output'];
  tenantId: Scalars['ID']['output'];
  tenantTreeSha?: Maybe<Scalars['String']['output']>;
  tenantVersion?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ModuleInfo = {
  __typename?: 'ModuleInfo';
  billingMode: Scalars['String']['output'];
  category?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  icon: Scalars['String']['output'];
  id: Scalars['String']['output'];
  monthlyPrice: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  requiredTier: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

/** Permission configuration for a single module */
export type ModulePermissionConfig = {
  __typename?: 'ModulePermissionConfig';
  /** Permissions for address book access (emails module) */
  addressBook?: Maybe<Array<Scalars['String']['output']>>;
  /** Permissions for admin operations (emails module) */
  admin?: Maybe<Array<Scalars['String']['output']>>;
  /** Permissions for Anthropic-based independent pay audit (pay module — Tom-only) */
  aiAudit?: Maybe<Array<Scalars['String']['output']>>;
  /** Permissions for approving/signing off (pay module) */
  approve?: Maybe<Array<Scalars['String']['output']>>;
  /** Permissions for configuration (incidents module) */
  config?: Maybe<Array<Scalars['String']['output']>>;
  /** Permissions for the free second-parent seat (separation module) */
  coparent?: Maybe<Array<Scalars['String']['output']>>;
  /** Permissions that grant create access */
  create: Array<Scalars['String']['output']>;
  /** Permissions that grant delete access */
  delete: Array<Scalars['String']['output']>;
  /** Permissions that grant edit access */
  edit: Array<Scalars['String']['output']>;
  /** Permissions for handling everyone's payroll enquiries (pay module, 2026-10-14) */
  enquiries?: Maybe<Array<Scalars['String']['output']>>;
  /** Permissions for meal feedback submission (meal-planning module) */
  feedback?: Maybe<Array<Scalars['String']['output']>>;
  /** Permissions that grant financial access (module-specific) */
  financial?: Maybe<Array<Scalars['String']['output']>>;
  /** Permissions for floor supervision (shifts module — approve pick-ups, mark attendance; the RN-in-charge role) */
  floor?: Maybe<Array<Scalars['String']['output']>>;
  /** Permissions for ATO STP lodgement + ABA EFT generation (pay module) */
  lodge?: Maybe<Array<Scalars['String']['output']>>;
  /** Permissions for editing the master roster (shifts module — MASTER-mode shifts) */
  master?: Maybe<Array<Scalars['String']['output']>>;
  /** Permissions for merging duplicate client records (clients module) */
  merge?: Maybe<Array<Scalars['String']['output']>>;
  /** Module ID - matches the frontend moduleConfig.id */
  moduleId: Scalars['String']['output'];
  /** Permissions for managing client permissions (clients module) */
  permissions?: Maybe<Array<Scalars['String']['output']>>;
  /** Permissions that grant publish/unpublish access (company knowledge module) */
  publish?: Maybe<Array<Scalars['String']['output']>>;
  /** Permissions for running reports (incidents module) */
  reports?: Maybe<Array<Scalars['String']['output']>>;
  /** Permissions that grant review/approve access (module-specific) */
  review?: Maybe<Array<Scalars['String']['output']>>;
  /** Permissions for risk assessment (incidents module) */
  risk?: Maybe<Array<Scalars['String']['output']>>;
  /** Permissions for S8 controlled substances (medications module) */
  s8?: Maybe<Array<Scalars['String']['output']>>;
  /** Permissions for self-service access (own record only) */
  self?: Maybe<Array<Scalars['String']['output']>>;
  /** Permissions for sending emails (emails module) */
  send?: Maybe<Array<Scalars['String']['output']>>;
  /** Permissions for sharing calendars and managing invitations (calendar module) */
  share?: Maybe<Array<Scalars['String']['output']>>;
  /** Permissions unlocked by purchase (separation module paywall) */
  toolkit?: Maybe<Array<Scalars['String']['output']>>;
  /** Permissions that grant read access */
  view: Array<Scalars['String']['output']>;
};

export type ModuleSource = {
  __typename?: 'ModuleSource';
  autoUpgrade: Scalars['Boolean']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  leadingRepo: Scalars['String']['output'];
  moduleId: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  sourcePath: Scalars['String']['output'];
  tier?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ModuleSourceInput = {
  autoUpgrade?: InputMaybe<Scalars['Boolean']['input']>;
  leadingRepo: Scalars['String']['input'];
  moduleId: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  sourcePath: Scalars['String']['input'];
  tier?: InputMaybe<Scalars['String']['input']>;
};

export type ModuleTestResult = {
  __typename?: 'ModuleTestResult';
  bugReportId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  moduleId: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  passed: Scalars['Boolean']['output'];
  tenantId: Scalars['String']['output'];
  testItemKey: Scalars['String']['output'];
  testTier: TestTier;
  testedAt: Scalars['DateTime']['output'];
  testedBy: Scalars['ID']['output'];
  testedByName?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type ModuleTestResultFilterInput = {
  moduleId?: InputMaybe<Scalars['String']['input']>;
};

export type ModuleTestingSummaryItem = {
  __typename?: 'ModuleTestingSummaryItem';
  moduleId: Scalars['String']['output'];
  passedTests: Scalars['Int']['output'];
  totalTests: Scalars['Int']['output'];
};

export type ModuleUpgradeEnqueueResult = {
  __typename?: 'ModuleUpgradeEnqueueResult';
  created: Array<ModuleUpgradeQueueJob>;
  refused: Array<ModuleUpgradeRefusedJob>;
  warnings: Array<ModuleUpgradeRefusedJob>;
};

export type ModuleUpgradeQueueJob = {
  __typename?: 'ModuleUpgradeQueueJob';
  batchId?: Maybe<Scalars['String']['output']>;
  brief?: Maybe<ModuleDoctorJobBrief>;
  briefHistoryId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deployCheckedAt?: Maybe<Scalars['DateTime']['output']>;
  deployLogTail?: Maybe<Scalars['String']['output']>;
  deployState?: Maybe<Scalars['String']['output']>;
  deployUrl?: Maybe<Scalars['String']['output']>;
  enqueueBatchKey?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  finishedAt?: Maybe<Scalars['DateTime']['output']>;
  fullBuild: Scalars['Boolean']['output'];
  githubRepo?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  kind: ModuleUpgradeQueueJobKind;
  moduleId: Scalars['String']['output'];
  newVersion?: Maybe<Scalars['String']['output']>;
  pinnedLeadingTreeSha?: Maybe<Scalars['String']['output']>;
  pushedSha?: Maybe<Scalars['String']['output']>;
  retriedAsJobId?: Maybe<Scalars['String']['output']>;
  retryCount: Scalars['Float']['output'];
  retryOfJobId?: Maybe<Scalars['String']['output']>;
  sourceJobId?: Maybe<Scalars['String']['output']>;
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  status: ModuleUpgradeQueueJobStatus;
  tenantId: Scalars['String']['output'];
  tenantName: Scalars['String']['output'];
  testPolicy?: Maybe<DoctorTestPolicy>;
  triggeredDoctorJobId?: Maybe<Scalars['String']['output']>;
  triggeringFailure?: Maybe<Scalars['String']['output']>;
  useWorkspace: Scalars['Boolean']['output'];
  workerHost?: Maybe<Scalars['String']['output']>;
};

export type ModuleUpgradeQueueJobInput = {
  fullBuild?: InputMaybe<Scalars['Boolean']['input']>;
  kind: ModuleUpgradeQueueJobKind;
  moduleId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
  useWorkspace?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ModuleUpgradeQueueJobKind {
  Add = 'ADD',
  Doctor = 'DOCTOR',
  Sync = 'SYNC'
}

export enum ModuleUpgradeQueueJobStatus {
  Cancelled = 'CANCELLED',
  Done = 'DONE',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Running = 'RUNNING'
}

export type ModuleUpgradeRefusedJob = {
  __typename?: 'ModuleUpgradeRefusedJob';
  moduleId: Scalars['String']['output'];
  reason: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  tenantName: Scalars['String']['output'];
};

export type ModuleUpgradeRescan = {
  __typename?: 'ModuleUpgradeRescan';
  lastFullScanAt?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
};

export type ModuleUpgradeServiceLease = {
  __typename?: 'ModuleUpgradeServiceLease';
  acquiredAt: Scalars['String']['output'];
  jobId: Scalars['String']['output'];
  leaseId: Scalars['String']['output'];
  moduleId: Scalars['String']['output'];
  repoName: Scalars['String']['output'];
  returnReason?: Maybe<Scalars['String']['output']>;
  returnedAt?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  tenantName: Scalars['String']['output'];
  worktreePath: Scalars['String']['output'];
};

export type ModuleUpgradeServiceStatus = {
  __typename?: 'ModuleUpgradeServiceStatus';
  concurrency: Scalars['Int']['output'];
  eligible: Scalars['Boolean']['output'];
  hasPlatformVercelToken?: Maybe<Scalars['Boolean']['output']>;
  lastFullScanAt?: Maybe<Scalars['String']['output']>;
  paused: Scalars['Boolean']['output'];
  queuePending: Scalars['Int']['output'];
  queueRunning: Scalars['Int']['output'];
  scanning?: Maybe<Scalars['Boolean']['output']>;
};

export type MonitorEvidence = {
  __typename?: 'MonitorEvidence';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  incidentId: Scalars['String']['output'];
  kind: MonitorEvidenceKind;
  recordId?: Maybe<Scalars['String']['output']>;
  snapshotJson: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export enum MonitorEvidenceKind {
  AiUsageLog = 'AI_USAGE_LOG',
  AudioFile = 'AUDIO_FILE',
  CalendarEvent = 'CALENDAR_EVENT',
  DmSession = 'DM_SESSION',
  Email = 'EMAIL'
}

export type MonitorIncident = {
  __typename?: 'MonitorIncident';
  createdAt: Scalars['DateTime']['output'];
  detailJson?: Maybe<Scalars['String']['output']>;
  evidenceIds: Array<Scalars['String']['output']>;
  firedAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  label?: Maybe<MonitorIncidentLabel>;
  proposedFixJson?: Maybe<Scalars['String']['output']>;
  reviewedAt?: Maybe<Scalars['DateTime']['output']>;
  reviewedByUserId?: Maybe<Scalars['String']['output']>;
  ruleId: Scalars['String']['output'];
  severity: MonitorIncidentSeverity;
  state: MonitorIncidentState;
  summary: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export enum MonitorIncidentLabel {
  FalsePositive = 'FALSE_POSITIVE',
  TruePositive = 'TRUE_POSITIVE'
}

export enum MonitorIncidentSeverity {
  Critical = 'CRITICAL',
  Info = 'INFO',
  Warn = 'WARN'
}

export enum MonitorIncidentState {
  Ignored = 'IGNORED',
  New = 'NEW',
  Resolved = 'RESOLVED',
  Reviewed = 'REVIEWED'
}

export type MonitorRule = {
  __typename?: 'MonitorRule';
  confidence: Scalars['Float']['output'];
  createdAt: Scalars['DateTime']['output'];
  defaultSeverity: MonitorIncidentSeverity;
  enabled: Scalars['Boolean']['output'];
  falsePositiveCount: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  lastEvaluatedAt?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  ruleType: MonitorRuleType;
  tenantId: Scalars['String']['output'];
  thresholdJson?: Maybe<Scalars['String']['output']>;
  truePositiveCount: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export enum MonitorRuleType {
  AiCostSpike = 'AI_COST_SPIKE',
  AudioInboxStale = 'AUDIO_INBOX_STALE',
  Custom = 'CUSTOM',
  DmSessionError = 'DM_SESSION_ERROR'
}

export type MonthlyChecklistSettings = {
  __typename?: 'MonthlyChecklistSettings';
  createdAt: Scalars['DateTime']['output'];
  cutoffDayOfMonth: Scalars['Float']['output'];
  enabledLocationTypes: Array<LocationType>;
  id: Scalars['ID']['output'];
  /** Deprecated: no reminder is sent whatever this is set to. Kept for an older frontend query. */
  remindersEnabled: Scalars['Boolean']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type MonthlyRoomCheck = {
  __typename?: 'MonthlyRoomCheck';
  checked: Scalars['Boolean']['output'];
  checkedAt?: Maybe<Scalars['DateTime']['output']>;
  checkedBy?: Maybe<Scalars['ID']['output']>;
  checkedByName?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  isDeleted: Scalars['Boolean']['output'];
  isOverdue?: Maybe<Scalars['Boolean']['output']>;
  linkedIssues: Array<MaintenanceRequest>;
  locationId: Scalars['ID']['output'];
  month: Scalars['Float']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  photos?: Maybe<Array<MaintenanceMedia>>;
  progressNotes?: Maybe<Array<MaintenanceProgressNote>>;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  year: Scalars['Float']['output'];
};

export type MonthlyTrend = {
  __typename?: 'MonthlyTrend';
  created: Scalars['Int']['output'];
  lost: Scalars['Int']['output'];
  month: Scalars['String']['output'];
  value: Scalars['Float']['output'];
  won: Scalars['Int']['output'];
};

export type MonthlyTrendDataPoint = {
  __typename?: 'MonthlyTrendDataPoint';
  byType: Array<IncidentTrendByType>;
  month: Scalars['String']['output'];
};

export type MoodEntry = {
  __typename?: 'MoodEntry';
  createdAt: Scalars['DateTime']['output'];
  emotionZone?: Maybe<EmotionZone>;
  energyLevel?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  moodLabel?: Maybe<Scalars['String']['output']>;
  moodScore: Scalars['Int']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  selectedEmotions?: Maybe<Array<Scalars['String']['output']>>;
  stressLevel?: Maybe<Scalars['Int']['output']>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<SnapshotUser>;
  userId: Scalars['ID']['output'];
};

export type MoodFilterInput = {
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type MoodTrend = {
  __typename?: 'MoodTrend';
  averageEnergy?: Maybe<Scalars['Float']['output']>;
  averageMood: Scalars['Float']['output'];
  averageStress?: Maybe<Scalars['Float']['output']>;
  entryCount: Scalars['Int']['output'];
  periodEnd?: Maybe<Scalars['DateTime']['output']>;
  periodStart?: Maybe<Scalars['DateTime']['output']>;
};

/** Target channel for motivation messages */
export enum MotivationChannel {
  Both = 'BOTH',
  Email = 'EMAIL',
  Sms = 'SMS'
}

export type MotivationPromptTemplate = {
  __typename?: 'MotivationPromptTemplate';
  channel: MotivationChannel;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  createdByName?: Maybe<Scalars['String']['output']>;
  exampleOutput?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  isGlobal: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  situation: MotivationSituation;
  systemPrompt: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type MotivationPromptTemplateInput = {
  channel: MotivationChannel;
  exampleOutput?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isGlobal?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  situation: MotivationSituation;
  systemPrompt: Scalars['String']['input'];
};

export type MotivationPromptTemplateUpdateInput = {
  channel?: InputMaybe<MotivationChannel>;
  exampleOutput?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isGlobal?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  situation?: InputMaybe<MotivationSituation>;
  systemPrompt?: InputMaybe<Scalars['String']['input']>;
};

/** The situation that triggers this prompt template */
export enum MotivationSituation {
  Custom = 'CUSTOM',
  DealWon = 'DEAL_WON',
  OverdueTask = 'OVERDUE_TASK',
  PaymentDue = 'PAYMENT_DUE',
  ProposalUnsigned = 'PROPOSAL_UNSIGNED',
  StaleDeal = 'STALE_DEAL',
  WeeklyUpdate = 'WEEKLY_UPDATE'
}

export type MoveEmployeeOnChartInput = {
  employeeId: Scalars['ID']['input'];
  /** Peer-snap path — server looks up the peer's reportsToEmployeeId and writes it onto this employee, dropping them as a sibling. Mutually exclusive with newReportsToEmployeeId. */
  insertAsPeerOfEmployeeId?: InputMaybe<Scalars['ID']['input']>;
  /** Place the employee directly under a Company / Department / Advisory Body group node. Sets Employee.parentPlacementId and clears reportsToEmployeeId. Mutually exclusive with the other parent inputs. */
  newParentPlacementId?: InputMaybe<Scalars['ID']['input']>;
  /** Standard 'make child of target' path. Sets reportsToEmployeeId directly. */
  newReportsToEmployeeId?: InputMaybe<Scalars['ID']['input']>;
};

/** Apply a bulk move: EITHER an explicit id list OR the token a preview minted — never a filter. */
export type MoveInboundEmailsInput = {
  /** Folder to move TO: Inbox, Archived or Trash. Must equal the folder the token was minted for. */
  folder: Scalars['String']['input'];
  /** Explicit received-email ids (max 500). */
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The `selectionToken` from previewInboundEmailMove. Bound to this tenant, this user and the target folder; expires 15 minutes after minting. */
  selectionToken?: InputMaybe<Scalars['String']['input']>;
};

export type MoveOrgChartPlacementInput = {
  displayOrder?: InputMaybe<Scalars['Int']['input']>;
  parentEmployeeId?: InputMaybe<Scalars['ID']['input']>;
  parentPlacementId?: InputMaybe<Scalars['ID']['input']>;
  placementId: Scalars['ID']['input'];
};

export type MultiResidentNoteResponse = {
  __typename?: 'MultiResidentNoteResponse';
  createdCount: Scalars['Int']['output'];
  noteIds: Array<Scalars['ID']['output']>;
};

export type MultipleObservationsResponse = {
  __typename?: 'MultipleObservationsResponse';
  alertsTriggered: Array<Scalars['String']['output']>;
  bpId?: Maybe<Scalars['ID']['output']>;
  bslId?: Maybe<Scalars['ID']['output']>;
  heightId?: Maybe<Scalars['ID']['output']>;
  o2Id?: Maybe<Scalars['ID']['output']>;
  observationsCreated: Scalars['Int']['output'];
  progressNoteId?: Maybe<Scalars['ID']['output']>;
  pulseId?: Maybe<Scalars['ID']['output']>;
  respirationId?: Maybe<Scalars['ID']['output']>;
  temperatureId?: Maybe<Scalars['ID']['output']>;
  weightId?: Maybe<Scalars['ID']['output']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Admin: accept this account's balance as right (optionally a stated balance at a stated time) — the gap is measured from here on. Logged. */
  acceptBankingBalance: BankingAccount;
  acceptCalendarInvitation: BusinessCalendar;
  acceptCommunityInvite: CommunityInviteClaimResult;
  acceptEmailReplyDraft: Scalars['ID']['output'];
  acceptGovInvite: GovInviteAcceptResult;
  acceptProgramMemberInvite: ProgramMemberAuthResult;
  acceptSeparationInvite: SeparationInviteClaimResult;
  acceptShelvInvite: ShelvInviteClaimResult;
  acceptShiftSwap: ShiftSwapRequest;
  acceptSopEpisodeDraft?: Maybe<SopEpisode>;
  acceptVisionBoardInvite: VisionBoardInviteClaimResult;
  acceptWalletContactInvite: WalletInviteAcceptResult;
  acknowledgeAllAlerts: Scalars['Boolean']['output'];
  acknowledgeObservationAlert: ObservationAlert;
  acknowledgePolicy: PolicyAcknowledgement;
  acknowledgeReferral: Referral;
  acknowledgeShift: CheckIn;
  acknowledgeWaitingListFamilyResponse: WaitingListEntry;
  activateCarePlan?: Maybe<CarePlan>;
  activateJob?: Maybe<Job>;
  activateTemplate?: Maybe<CarePlanTemplate>;
  addAllergy: MedicationAllergy;
  /** Admin: add a cash movement to the Cash wallet (back-dating allowed) */
  addBankingCashEntry: BankingCashWrite;
  /** Say something about a transaction (markdown + receipt CIDs). Writes a comment; the transaction itself is untouched beyond its counts. */
  addBankingTransactionComment: BankingTransactionComment;
  addBlockedDate: BusinessCalendarAvailability;
  /** Public mutation to add or update a reaction (anonymous, no auth) */
  addBlogReaction: BlogReaction;
  addCIActionEvidence?: Maybe<CiImprovementInitiative>;
  addCIAgendaItem?: Maybe<CiGovernanceMeeting>;
  addCIInitiativeActivity?: Maybe<CiImprovementInitiative>;
  addCIInitiativeActivityNote?: Maybe<CiImprovementInitiative>;
  addCIInitiativeDocument?: Maybe<CiImprovementInitiative>;
  addCIInitiativePhoto?: Maybe<CiImprovementInitiative>;
  addCIInitiativeToMeeting?: Maybe<CiImprovementInitiative>;
  addCIIssueActivityNote?: Maybe<CiIssueReport>;
  addCIIssuePhoto?: Maybe<CiIssueReport>;
  addCIMeetingNote?: Maybe<CiGovernanceMeeting>;
  addCalendarEventTaskChecklistItem: CalendarEventTask;
  /** Add a free-text note to the candidate timeline */
  addCandidateNote: CandidateActivity;
  addChaseRecipient?: Maybe<ClientChaseConfig>;
  addChecklistItem?: Maybe<MechanicJob>;
  addClientPermission?: Maybe<Client>;
  addClientShippingAddress: Client;
  addClientTag?: Maybe<Client>;
  addCompletionPhoto?: Maybe<MaintenanceRequest>;
  addDomainDnsRecord: DomainDnsRecord;
  addEmailLabel: Email;
  addEmployeeActivityComment: EmployeeActivityComment;
  addEmployeeChecklistItem: EmployeeChecklistItem;
  addEmployeeToCompany?: Maybe<Company>;
  addEmpowermentOneOffQuestion: EmpowermentQuestion;
  addFeedbackItemNote: FeedbackItem;
  addGithubCollaborator: Scalars['Boolean']['output'];
  addGoalCheckpoint: CalendarGoal;
  addGoalToCarePlan?: Maybe<CarePlan>;
  addGovActivityComment: GovActivityComment;
  addGovActivityNote: GovActivity;
  addGovChecklistItem: GovChecklistItem;
  addGovMember: GovMember;
  addInboundEmailLabel: InboundEmail;
  addInterventionToCarePlan?: Maybe<CarePlan>;
  addInvestorDocument?: Maybe<Investor>;
  addInvestorNote?: Maybe<Investor>;
  addItemsToMeetingReview?: Maybe<CiGovernanceMeeting>;
  addJobMedia?: Maybe<MechanicJob>;
  addJobProgressNote?: Maybe<MechanicJob>;
  addKitchenMember: Kitchen;
  addLabelToInboundEmail: InboundEmail;
  addLaunchSiteDomain: Scalars['Boolean']['output'];
  addLeaveAttachments?: Maybe<LeaveRequest>;
  addLineItem: Bill;
  addMaintenanceActivityNote: MaintenanceActivity;
  addMaintenanceChecklistItem?: Maybe<MaintenanceRequest>;
  addMaintenancePhoto?: Maybe<MaintenanceRequest>;
  addMaintenanceProgressNote?: Maybe<MaintenanceRequest>;
  addMealServicePhotos?: Maybe<MealPlan>;
  addMilestoneToGoal?: Maybe<CarePlan>;
  addMonthlyRoomCheckPhoto?: Maybe<MonthlyRoomCheck>;
  addMonthlyRoomCheckProgressNote?: Maybe<MonthlyRoomCheck>;
  addOpportunityMember: OpportunityMember;
  addOpportunityProgressNote: Opportunity;
  addPProposalChecklistItem: PProposal;
  addPolicyNote: PolicyActivity;
  addProjectDocument?: Maybe<InvestmentProject>;
  addProjectTeamMember?: Maybe<InvestmentProject>;
  addRecipeIngredient: RecipeIngredient;
  addReviewActionItem?: Maybe<CarePlanReview>;
  addReviewAttendee?: Maybe<CarePlanReview>;
  addSarahCareContactAsContact: ResidentContact;
  addSopComment: Scalars['Boolean']['output'];
  addSovereigntyAdjustment: SovereigntyAdjustment;
  addSovereigntyStep: SovereigntyStep;
  addSubSubTask: OpportunityTask;
  addSubTask: OpportunityTask;
  addToWaitingList: WaitingListEntry;
  /** Add a plain-text comment to a recording the caller can open. */
  addTranscriptionComment: TranscriptionComment;
  addVideosToSource: HarvestSource;
  /** Public mutation: add or update a reaction (anonymous, no auth) */
  addVlogReaction: VlogReaction;
  addWaitingListChecklistItem?: Maybe<WaitingListEntry>;
  addWaitingListNote: Scalars['Boolean']['output'];
  addWitness: IncidentWitness;
  /** @deprecated Retired 6 Oct 2026 — leave balances come from the shifts module (employeeLeaveBalances). */
  adjustLeaveBalance: LeaveBalance;
  adminAddCompetitionEntry: AdminAddCompetitionEntryResult;
  /** Admin: approve (the claimant becomes the owner) or turn down a claim. */
  adminDecideBusinessListingClaim: BusinessListing;
  /** Admin: delete a listing and its history for good. */
  adminDeleteBusinessListing: Scalars['Boolean']['output'];
  adminRelinkWalletKey: WalletKey;
  adminResetPassword: Scalars['Boolean']['output'];
  /** Admin: hide a listing from the directory (with a reason), or restore it. */
  adminSetBusinessListingHidden: BusinessListing;
  /** Admin: edit any listing, including featured, member-since and source. v1.1 fields are present-only. */
  adminUpdateBusinessListing: BusinessListing;
  administerPRN: PrnAdministration;
  adoptGovJobSpec: GovJobSpec;
  /** Move between recruitment steps even with outstanding information. Employer handover and placement use their dedicated actions. */
  advanceCandidateStage: Candidate;
  aiOpsCancelRequest: AiOpsCancelResult;
  aiOpsDeleteKey: Scalars['Boolean']['output'];
  aiOpsMintKey: AiOpsKeyMintResult;
  aiOpsReplaceKey: AiOpsKeyMintResult;
  aiOpsSetCapturePolicy: Scalars['Boolean']['output'];
  aiOpsSetKeyConcurrency: Scalars['Int']['output'];
  aiOpsSetKeyPaused: AiOpsKeyActionResult;
  aiOpsUpdateKey: AiOpsKeyActionResult;
  announceCompetitionWinners: CompetitionAnnounceResult;
  announceOpenShift: AnnounceOpenShiftResult;
  answerChecklistItem?: Maybe<AdmissionChecklist>;
  answerDigitalManagerOQ: DigitalManagerOutstandingQuestion;
  answerOutstandingQuestion: EmailAiOutstandingQuestion;
  answerWaitingListConfirmation: PublicConfirmationAnswerResult;
  /** Create API category */
  apiHubCreateCategory: ApiCategory;
  /** Create API endpoint */
  apiHubCreateEndpoint: ApiEndpoint;
  /** Generate a new API key. The full key is only shown once. */
  apiHubCreateKey: ApiKeyWithSecret;
  /** Create API listing */
  apiHubCreateListing: ApiListing;
  /** Delete API category */
  apiHubDeleteCategory: Scalars['Boolean']['output'];
  /** Delete API endpoint */
  apiHubDeleteEndpoint: Scalars['Boolean']['output'];
  /** Delete API listing */
  apiHubDeleteListing: Scalars['Boolean']['output'];
  /** Execute an API call through the proxy */
  apiHubExecute: ApiHubResponse;
  /** Revoke an API key */
  apiHubRevokeKey: Scalars['Boolean']['output'];
  /** Subscribe to an API */
  apiHubSubscribe: ApiSubscription;
  /** Unsubscribe from an API */
  apiHubUnsubscribe: Scalars['Boolean']['output'];
  /** Update API category */
  apiHubUpdateCategory?: Maybe<ApiCategory>;
  /** Update API endpoint */
  apiHubUpdateEndpoint?: Maybe<ApiEndpoint>;
  /** Update API listing */
  apiHubUpdateListing?: Maybe<ApiListing>;
  /** Append additional tasks from markdown without deleting existing tasks */
  appendTasksFromMarkdown: Project;
  /** Accounting: run the rules over every UNCODED transaction of an entity now — matches become SUGGESTED. Coded and excluded rows are never touched. */
  applyCodingRules: AccountingRuleRun;
  applyEmpowermentScheduleToUpcoming: EmpowermentSchedulePreview;
  applyEmpowermentStartDateChange: EmpowermentJourney;
  applyTemplateToResident: CarePlan;
  approveCarePlan?: Maybe<CarePlan>;
  approveDigitalManagerProposal: DigitalManagerOutstandingQuestion;
  approveEmailLoginBrowser: Scalars['Boolean']['output'];
  approveGuaranteeClaim: SeparationGuaranteeClaim;
  approveLeaveRequest: LeaveRequest;
  approveMedicalRecordAccessRequest: MedicalRecordAccessDecisionResult;
  approvePayRun: PayRun;
  approveReview?: Maybe<CarePlanReview>;
  approveShiftPickup: Shift;
  approveShiftSwap: ShiftSwapRequest;
  approveSiteUpdate?: Maybe<SiteUpdate>;
  approveSmsLoginBrowser: Scalars['Boolean']['output'];
  approveWithdrawal: WithdrawalRequest;
  approveWorkerTimeEntry?: Maybe<WorkerTimeEntry>;
  archiveAward: Scalars['Boolean']['output'];
  archiveCalendarGoal: CalendarGoal;
  archiveCarePlan?: Maybe<CarePlan>;
  archiveCustomTestDefinition: Scalars['Boolean']['output'];
  archiveEmail: Email;
  archiveJob?: Maybe<Job>;
  archiveLead: Lead;
  archiveMultipleInboundEmails: Scalars['Int']['output'];
  archivePolicy: Policy;
  archiveTomConversation: Scalars['Boolean']['output'];
  archiveWaitingListEntry: WaitingListEntry;
  askCareMinutes: CareMinutesChatAnswer;
  /** Record the police-certificate assessment (New Staff Form questions). REJECTED or precluded also rejects the candidate. */
  assessPoliceCheck: Candidate;
  assignCIIssueReport?: Maybe<CiIssueReport>;
  assignEmailToClient: EmailAddress;
  assignEmailToClients: Email;
  assignEmployeeToShift?: Maybe<Shift>;
  assignEmployeeTraining: EmployeeTrainingAssignment;
  assignFeedbackItem: FeedbackItem;
  assignMaintenanceRequest?: Maybe<MaintenanceRequest>;
  assignMechanic?: Maybe<MechanicJob>;
  assignPhoneNumberToClient: TwilioPhoneNumber;
  assignSourcesToBase: Scalars['Int']['output'];
  attachDailyAllocationVersion: DailyAllocationSheet;
  attachGovFileToActivity: GovActivity;
  attachInboundEmailToOpportunity: InboundEmail;
  authenticateCommunityInvite: CommunityInviteClaimResult;
  authenticateCommunityNotificationLink: CommunityNotificationLinkAuthResult;
  authenticateEmailLoginCode: EmailLoginLinkResult;
  authenticateEmailLoginLink: EmailLoginLinkResult;
  /** Exchange a staff email link token (?k=) for a normal login JWT — seamless sign-in from onboarding/roster emails. */
  authenticateEmployeeLoginLink: EmployeeLinkAuthResult;
  authenticateHostingLink: HostingLinkAuthResult;
  authenticateProgramMember: ProgramMemberAuthResult;
  authenticateSeparationLink: SeparationLinkAuthResult;
  authenticateShiftSwapLink: SwapLinkAuthResult;
  authenticateSiteOwnerLink: SiteOwnerLinkAuthResult;
  authenticateSmsLoginCode: SmsLoginResult;
  authenticateSmsLoginLink: SmsLoginResult;
  authenticateVisionBoardInvite: VisionBoardInviteClaimResult;
  autoDistributeSplits: Opportunity;
  /** Backfill history for the enabled accounts (months defaults to the tenant's backfillMonths); never fires alerts */
  backfillBankingNow: BankingRunSummary;
  /** Backfill ImprovMX config: registers domain with ImprovMX API and saves to tenant */
  backfillImprovMXConfig: BackfillConfigResult;
  banChatParticipant: Scalars['Boolean']['output'];
  batchRecordAdministration: BatchAdministrationResponse;
  /** Heartbeat for an active voice lease (every ~15 s). false = the lease is gone; the call continues without priority. */
  beatVoiceLease: Scalars['Boolean']['output'];
  beginRosterBulkOp: RosterBulkOpLog;
  bookEmpowermentCatchUp: EmpowermentCatchUp;
  bookWaitingListTour: WaitingListEntry;
  buildPortalAddStageNote: BuildProjectEntryView;
  buildPortalAddStagePhotos: Array<BuildProjectEntryView>;
  buildPortalCompleteStage: Scalars['String']['output'];
  buildPortalEditUpdate: PostBuildUpdateResult;
  buildPortalInviteClient: InviteBuildClientResult;
  buildPortalMarkMessagesSeen: Scalars['Int']['output'];
  buildPortalMarkRead: Scalars['Int']['output'];
  buildPortalPostUpdate: PostBuildUpdateResult;
  buildPortalRemoveAccess: Scalars['Boolean']['output'];
  buildPortalRemoveStagePhoto: Scalars['Boolean']['output'];
  buildPortalRequestPhotos: BuildSendResult;
  buildPortalResetEmailTemplate: BuildEmailTemplateView;
  buildPortalSaveEmailTemplate: BuildEmailTemplateView;
  buildPortalSaveProject: Scalars['Boolean']['output'];
  buildPortalSaveSettings: BuildPortalSettings;
  buildPortalSaveTeamProfile: BuildTeamProfile;
  buildPortalSeedTeamProfiles: Scalars['Int']['output'];
  buildPortalSendBuilderEmail: BuildSendResult;
  buildPortalSendClientProgress: BuildSendResult;
  buildPortalSendMessage: SendBuildMessageResult;
  buildPortalSendTeamOverview: BuildSendResult;
  buildPortalSetPhotoForClient: BuildProjectEntryView;
  buildPortalSetStage: Scalars['String']['output'];
  buildResearchBase: ResearchBase;
  /** Build the STP2 end-of-FY Finalisation declaration. Aggregates YTD per-employee across all pay runs in the FY. */
  buildStpFinalisation: StpBuildResult;
  /** Build the STP Phase 2 payload XML from this PayRun (does NOT lodge with ATO) */
  buildStpPayload: StpBuildResult;
  bulkCreateMealPlans: Array<MealPlan>;
  bulkCreateP2Charge: Array<P2Charge>;
  bulkCreateP2DeliveryUpdate: Array<P2DeliveryUpdate>;
  bulkDeleteMediaItems: Scalars['Float']['output'];
  /** Admin: add these people to the grant list of these accounts (existing grants kept). Each person is told once, listing the accounts. */
  bulkGrantBankingViewers: Array<BankingAccount>;
  bulkImportIngredients: Array<Ingredient>;
  bulkImportSEOMetadata: BulkImportResult;
  bulkReplaceRecipeIngredients: BulkReplaceRecipeIngredientsResult;
  bulkUpdateJobStatus: Scalars['Float']['output'];
  bulkUpsertIngredients: BulkUpsertResult;
  calculateRespitePayment: RespiteCalculationResult;
  cancelBooking: Scalars['JSONObject']['output'];
  cancelClub52Game: Club52Game;
  cancelCommunityCampaign: CommunityCampaignDetail;
  cancelEvent: Scalars['Boolean']['output'];
  cancelGovProposal?: Maybe<GovProposal>;
  cancelGovWorkItem?: Maybe<GovWorkItem>;
  cancelGraphExtract: Scalars['Boolean']['output'];
  cancelHostingReferral?: Maybe<HostingReferral>;
  cancelInboxBacklogJob: EmailBacklogJob;
  cancelLeadFlowEnrolment: Scalars['Boolean']['output'];
  cancelLeave: ResidentLeave;
  cancelLeaveRequest: LeaveRequest;
  cancelMedicalRecordAccessRequest: MedicalRecordAccessRequest;
  /** Withdraw my unpaid payout request */
  cancelMyRewardPayout: RewardPayoutRequest;
  cancelOrder?: Maybe<SupplierOrder>;
  cancelP2PledgeCampaign: P2PledgeCampaign;
  cancelPublicBooking: Scalars['Boolean']['output'];
  cancelReferral: Referral;
  cancelRespiteBooking: RespiteCareBooking;
  cancelReview?: Maybe<CarePlanReview>;
  /** Admin: cancel an unpaid payout request (no money moved) */
  cancelRewardPayout: RewardPayoutRequest;
  cancelRewardToken: RewardToken;
  cancelRollup: Scalars['Boolean']['output'];
  cancelRound: MedicationRound;
  cancelScheduledCandidateMessage: CandidateMessage;
  cancelScheduledChase: ClientChaseLog;
  cancelSeparationCareBlock: SeparationCareBlock;
  cancelSession: Session;
  cancelShift?: Maybe<Shift>;
  cancelShiftSwap: ShiftSwapRequest;
  cancelSubscription: BillingSubscription;
  cancelWaitingListTour: WaitingListEntry;
  cancelWalletContactInvite: Scalars['Boolean']['output'];
  cancelWithdrawal: WithdrawalRequest;
  captureClub52WalletAddress: Club52Game;
  castCompetitionVote: CompetitionVoteResult;
  castGovVote: GovVote;
  ceaseMedication: Medication;
  certifyCoach?: Maybe<Coach>;
  changeAbsence?: Maybe<Shift>;
  changeBillClient: Scalars['Boolean']['output'];
  /** Change the login username on an employee's linked account. Returns the saved username. Optionally emails the employee their new username (never the password). */
  changeEmployeeUsername: Scalars['String']['output'];
  changeMyPassword: SessionsRevokedResult;
  /** Legacy (kept for tenant sites not yet ported): changes the password but does NOT sign out other devices. New code uses changeMyPassword. */
  changePassword: Scalars['Boolean']['output'];
  chargeOutstandingBills: BillingActionResult;
  chargePaymentMethod: Scalars['String']['output'];
  chargeSubscriptionBill: Scalars['Boolean']['output'];
  chargeUnpaidSubscriptionBills: SubscriptionBillActionResult;
  chaseShelvInvite: ShelvInvite;
  checkIn: CheckIn;
  checkInRespite: RespiteCareBooking;
  checkMaintenanceOverdue: MaintenanceOverdueCheckResult;
  checkOut: CheckIn;
  checkOutRespite: RespiteCareBooking;
  chloeArchiveSession: ChloeSession;
  chloeConfirmAction: ChloePendingAction;
  chloeSendMessage: ChloeMessage;
  chloeStartSession: ChloeSession;
  /** A signed-in member asks to claim an imported (unclaimed) listing as theirs. An admin approves. */
  claimBusinessListing: BusinessListing;
  claimCommunityFreeInvite: CommunityInviteClaimResult;
  claimCommunityQrSignup: CommunityInviteClaimResult;
  claimGovWork: GovWorkClaim;
  claimSeparationInvite: SeparationInviteClaimResult;
  claimSeparationSignup: SeparationInviteClaimResult;
  claimShelvInvite: ShelvInviteClaimResult;
  claimVisionBoardFreeInvite: VisionBoardInviteClaimResult;
  classifyMicrosoftEmails: Scalars['Int']['output'];
  clearAbsence?: Maybe<Shift>;
  clearBillsEmailBrandingPhoto: BillsEmailBranding;
  clearCheckIn?: Maybe<Shift>;
  clearLeadFlowEmailBrandingPhoto: LeadFlowEmailBranding;
  clearMealPlanDateRange: Scalars['Int']['output'];
  clearMealPlanDay: Scalars['Int']['output'];
  clearMySiteCommandHistory: Scalars['Boolean']['output'];
  clearPProposalSignatures: Scalars['Boolean']['output'];
  clearPickupRejection: Shift;
  clearProposalSignatures: Scalars['Boolean']['output'];
  clearRewardsEmailBrandingPhoto: RewardsEmailBranding;
  clearSettledModuleUpgradeJobs: Scalars['Float']['output'];
  cloneCandidateForm: CandidateForm;
  cloneClub52Game: Club52Game;
  /** Admin: close the month — freeze the money, fetch the start/end prices, work out Simon's tilt. Re-closing recomputes and keeps the decision. */
  closeBankingMonth: BankingCloseResult;
  closeGovProposal?: Maybe<GovDecision>;
  closeIncident: Incident;
  /** Accounting: a person codes a transaction — CODED (confirm an account), EXCLUDED (not part of the books) or UNCODED (undo); status omitted = only the note / resident link change. */
  codeAccountingTransaction: AccountingTransaction;
  commandAddActivityComment: CommandActivityComment;
  commandAddActivityNote: CommissionDealActivity;
  commandAddCommissionDealNote: Scalars['Boolean']['output'];
  commandAddOffXeroReceipt: CommissionDeal;
  commandApplyAddressSplit: AddressSplitResult;
  commandAttachActivityFiles: CommissionDealActivity;
  commandCheckUnlinkedDeals: PipedriveCheckBatch;
  commandCommitCommissionImport: CommissionImportResult;
  commandCreateCommissionDeal: CommissionDeal;
  commandCreateCommissionOption: Scalars['Boolean']['output'];
  commandCreateFromPipedrive: PipedrivePlaceRow;
  commandCreateNotificationRule: CommandNotificationRule;
  commandDeleteCommissionOption: Scalars['Boolean']['output'];
  commandDeleteNotificationRule: Scalars['Boolean']['output'];
  commandExtractDealFromDocument: CommandDealExtraction;
  commandGrantModuleAccess: Array<Scalars['String']['output']>;
  commandImportFromPipedrive: PipedriveImportReport;
  commandLinkOptionToClient: Scalars['Boolean']['output'];
  commandLinkPaymentToProject: CommissionProject;
  commandLinkPipedriveDeal: PipedrivePullResult;
  commandLinkReadyDeals: Array<PipedriveReadyLinkResult>;
  commandMarkTagDone: Scalars['Boolean']['output'];
  commandNotifyMentions: CommandMentionNotifyResult;
  commandNotifyReply: CommandMentionNotifyResult;
  commandPreviewCommissionImport: CommissionImportPreview;
  commandPullFromPipedrive?: Maybe<PipedrivePullResult>;
  commandRemoveOffXeroReceipt: CommissionDeal;
  commandReorderCommissionOptions: Scalars['Boolean']['output'];
  commandRetractActivityComment: CommandActivityComment;
  commandSeedCommissionOptions: Scalars['Int']['output'];
  commandSendTagChasePreview: CommandTagChaseSendResult;
  commandSendTestNotification: Scalars['String']['output'];
  commandSetCommissionDealArchived: CommissionDeal;
  commandSetCommissionOptionActive: Scalars['Boolean']['output'];
  commandSetDealPrivacy: CommandDealAccess;
  commandSetPipedriveCreateDeals: PipedriveSyncSummary;
  commandSetTagChase: CommandTagChase;
  commandShareDeal: CommandDealAccess;
  commandSyncCommissionSheet: CommissionSyncResultType;
  commandUnlinkPayment: Scalars['Boolean']['output'];
  commandUnlinkPipedriveDeal: Scalars['Boolean']['output'];
  commandUpdateCommissionDeal: CommissionDeal;
  commandUpdateCommissionOption: Scalars['Boolean']['output'];
  commandUpdateNotificationRule: CommandNotificationRule;
  commandXeroConnect: Scalars['String']['output'];
  commandXeroDisconnect: Scalars['Boolean']['output'];
  /** Accounting: import a bank CSV into the coding table — new rows only, never a duplicate; coding rules pre-fill suggestions. */
  commitBankCsvImport: BankImportResult;
  /** Accounting: import the chart of accounts read live from a connected Xero organisation into one entity — new codes only (never a duplicate), existing ones updated only when asked; archived Xero accounts arrive switched off. */
  commitXeroChartFromXero: LedgerImportResult;
  /** Accounting: import a Xero chart-of-accounts CSV — adds new codes (never a duplicate code), updates existing ones only when asked. */
  commitXeroChartImport: LedgerImportResult;
  /** Accounting: import transactions from a connected Xero organisation into this entity's bank accounts — never a duplicate (Xero's id is the key); rows Xero coded to one account arrive SUGGESTED to it; a person confirms. */
  commitXeroTransactionImport: XeroTransactionImportResult;
  communityCallToken: CommunityCallToken;
  completeAction?: Maybe<GoalAction>;
  completeAuthProfile: Client;
  /** Admin: tick a job done. Pass a linked transaction or landed:true to also record that the money moved — otherwise it is done but NOT landed. */
  completeBankingMonthJob: BankingMonthJob;
  completeBooking: Booking;
  completeCIInitiative?: Maybe<CiImprovementInitiative>;
  completeCarePlanReview?: Maybe<CarePlanReview>;
  completeCareReview: CareReview;
  completeChecklistItem?: Maybe<AdmissionChecklist>;
  completeClinicalTask: ClinicalTask;
  completeCommunitySignup: CommunityInviteClaimResult;
  completeDressing: DressingSchedule;
  completeEmailLinkSignup: EmailLoginLinkResult;
  completeEmpowermentCheckIn: EmpowermentCheckIn;
  completeFollowUp: IncidentFollowUp;
  /** Interview happened: store feedback/rating/summary as an InterviewNote and move to INTERVIEW_DONE */
  completeInterview: Candidate;
  completeMaintenanceRequest?: Maybe<MaintenanceRequest>;
  completeMilestone?: Maybe<CarePlan>;
  completeP2Invite: Scalars['Boolean']['output'];
  completePProposalChecklistItem: PProposal;
  /** Record the phone pre-screen. PASS → PRE_SCREEN complete; FAIL → REJECTED with reason. */
  completePreScreen: Candidate;
  completeReferral: Referral;
  completeRound: MedicationRound;
  completeSeparationSignup: SeparationInviteClaimResult;
  completeShift?: Maybe<Shift>;
  composeChaseSmsForLog?: Maybe<ClientChaseLog>;
  configureDailyCareHeadings: DailyCareHeadingConfig;
  configureDomainEmail: DomainHealthStatus;
  configureObservationAlerts: ObservationAlertConfig;
  /** Accounting: a person confirms SUGGESTED codings as they stand (each becomes CODED, signed by them). Rows no longer SUGGESTED are left alone and not returned. */
  confirmAccountingSuggestions: Array<AccountingTransaction>;
  confirmBankTransferPayment: Scalars['Boolean']['output'];
  confirmEventRegistration: EventRegistrationResponse;
  confirmGeneratedMealPlan: Array<MealPlan>;
  confirmGeneratedTasks: Array<OpportunityTask>;
  confirmHostingReferral?: Maybe<HostingReferral>;
  confirmInvoice: FoodInvoice;
  confirmOrder?: Maybe<SupplierOrder>;
  confirmP2Pledge: P2Pledge;
  confirmP2QuickOrder: P2Order;
  confirmPersonEvents: Array<PersonEvent>;
  confirmProposalDraft: Scalars['String']['output'];
  confirmResidentSourceFields?: Maybe<Resident>;
  confirmSeparationCareBlock: SeparationCareLogEntry;
  confirmSiteSpec: LaunchedSite;
  confirmTomAction: TomActionResult;
  /** Accounting admin: connect a Redbark API key (checked against Redbark first, stored server-side, never returned). Discovered bank accounts arrive switched OFF under the named entity. */
  connectAccountingRedbark: AccountingSettingsView;
  /** Accounting admin: finish the Xero connection with the code Xero returned (exchanged server-side). Stores the refresh token and every authorised organisation. */
  connectAccountingXero: AccountingSettingsView;
  /** Verify a Redbark API key against /v2/me, store it server-side (never returned) and discover accounts */
  connectRedbark: BankingSettingsView;
  convertLeadToClient: Lead;
  convertProfileType?: Maybe<DailyCareProfile>;
  convertTranscriptionIntoMeetingNotes: Scalars['String']['output'];
  copyMealPlanDateRange: Array<MealPlan>;
  copyMealPlanWeek: Array<MealPlan>;
  correctSeparationCareLogEntry: SeparationCareLogEntry;
  createACFIAssessment: AcfiAssessment;
  createAbbeyPainAssessment: AbbeyPainAssessment;
  createAccountabilityGoal: AccountabilityGoal;
  /** Accounting: add a bank account that has no live feed — its transactions come in by CSV import. */
  createAccountingBankAccount: AccountingBankAccount;
  createAdmissionNotificationRule: AdmissionNotificationRule;
  createAdvisoryBody: AdvisoryBody;
  createAgencyEmployee: Employee;
  createAnalyticsNotificationRule: AnalyticsNotificationRule;
  createApprovedLeaveRequest: LeaveRequest;
  createArtSession: ArtSessionChangeResult;
  createArtifact: Artifact;
  createArtifactComment: ArtifactComment;
  createAssessmentCustomField: AssessmentCustomField;
  createAssessmentDomain: AssessmentDomain;
  createAssessmentNotificationRule: AssessmentNotificationRule;
  createAssessmentSnapshot: AssessmentSnapshot;
  createAvailability: Availability;
  createAward: AwardEntity;
  createAwardClassification: AwardClassification;
  createAwardRate: AwardRateTable;
  /** Admin: create the Cash wallet (once — a second call returns the same one) */
  createBankingCashWallet: BankingAccount;
  createBdayGuest: BdayGuest;
  createBill: Bill;
  createBillNotificationRule: BillNotificationRule;
  createBillPayment: BillPaymentResponse;
  createBladderRecord: BladderRecord;
  createBlogCategory: BlogCategory;
  createBlogNotificationRule: BlogNotificationRule;
  createBlogPost: BlogPost;
  createBloodPressureObservation: BloodPressureObservation;
  createBloodSugarObservation: BloodSugarObservation;
  createBond: Bond;
  createBookableEventType: BusinessCalendarBookableEventType;
  createBooking: Booking;
  createBowelRecord: BowelRecord;
  createBradenAssessment: BradenAssessment;
  createBulkRDTimeEntries: Array<RdTimeEntry>;
  createBusinessCalendar: BusinessCalendar;
  createBusinessCalendarAvailability: BusinessCalendarAvailability;
  createBusinessDirectoryNotificationRule: BusinessDirectoryNotificationRule;
  createCIGovernanceMeeting: CiGovernanceMeeting;
  createCIImprovementInitiative: CiImprovementInitiative;
  createCIInitiativeFromIssue?: Maybe<CiImprovementInitiative>;
  createCIIssueReport: CiIssueReport;
  createCINotificationRule: CiNotificationRule;
  createCalendar: BusinessCalendar;
  createCalendarEventTask: CalendarEventTask;
  createCalendarGoal: CalendarGoal;
  createCandidate: Candidate;
  createCandidateForm: CandidateForm;
  createCandidateInvite: CandidateInviteSendResult;
  /** Add a home by hand (one the government list doesn't have). */
  createCareHome: CareHome;
  createCarePlan: CarePlan;
  createCarePlanTemplate: CarePlanTemplate;
  createCareReview: CareReview;
  createChaseNotificationRule: ChaseNotificationRule;
  createChatRoom: ChatRoom;
  createClient: Client;
  createClientActivity: ClientActivity;
  createClientChaseConfig: ClientChaseConfig;
  createClientNotificationRule: ClientNotificationRule;
  createClinicalTask: ClinicalTask;
  createClub52Game: Club52Game;
  createClub52Goal: Club52Goal;
  createClub52Table: Club52Game;
  createCoach: Coach;
  createCoachAgreement: CoachAgreement;
  /** Accounting: add a rule — 'description contains X → account Y'. It suggests; it never codes. */
  createCodingRule: CodingRule;
  createCommunicationTask: CommunicationTask;
  createCommunityCampaign: CommunityCampaignDetail;
  createCommunityEntry: CommunityEntry;
  createCommunityEntryReply: CommunityEntryReplyView;
  createCommunityInvite: CommunityInvite;
  createCommunityMemberInvite: CommunityInvite;
  createCommunityPost: CommunityPostResult;
  createCommunityPostComment: CommunityPostCommentResult;
  createCompany: Company;
  createCompanyKnowledgeArticle: CompanyKnowledge;
  createCompetition: Competition;
  createCompetitionSchool: CompetitionSchool;
  createCompetitionSponsor: CompetitionSponsor;
  createConstructionSite: ConstructionSite;
  createContributingFactor: ContributingFactor;
  createCoupon: Coupon;
  createCryptoVault: CryptoVault;
  createCustomQuestion: IncidentCustomQuestion;
  createCustomTestDefinition: CustomTestDefinition;
  createDailyCareProfile: DailyCareProfile;
  createDayBookEntry: DayBookEntry;
  createDedicatedProgramCalendar: ProgramConfig;
  createDepartment: Department;
  createDigitalManagerMemory: DigitalManagerMemory;
  createDigitalManagerNotificationRule: DigitalManagerNotificationRule;
  createDigitalManagerRule: DigitalManagerRule;
  createDigitalManagerTemplate: DigitalManagerTemplate;
  createDirectBooking: Booking;
  createDraftBillWithTasks: Bill;
  /** Build a draft PayRun for a period; replaces any existing draft for the same period */
  createDraftPayRun: PayRunBuildResult;
  createDressingSchedule: DressingSchedule;
  createDroneSession: DroneSession;
  createEmail: Email;
  createEmailAddress: EmailAddress;
  /** Admin: Create a new email address with ImprovMX forwarding */
  createEmailAddressWithAlias: EmailAddress;
  createEmailAiMemory: EmailAiMemory;
  createEmailAiRule: EmailAiRule;
  createEmailAiRuleFromEmail: EmailAiRule;
  createEmployee: Employee;
  createEmployeeActivity: EmployeeActivity;
  createEmployeeChecklist: EmployeeChecklistWithItems;
  createEmployeeContractTemplate: EmployeeContractTemplate;
  createEmployeeIncidentNotificationRule: EmployeeIncidentNotificationRule;
  createEmployeeInvite: EmployeeInvite;
  createEmployeeNotificationRule: EmployeeNotificationRule;
  createEmployeePosition: EmployeePosition;
  createEmployeeRole: EmployeeRole;
  createEmployeeStatusOption: EmployeeStatusOption;
  createEmployeeTrainingCategory: EmployeeTrainingCategory;
  /** Create an employee with login credentials directly (admin/manager) */
  createEmployeeWithCredentials: OnboardingResult;
  createEmpowermentExtraCheckIn: EmpowermentCheckIn;
  createEmpowermentGoal: EmpowermentGoal;
  createEmpowermentQuestion: EmpowermentQuestion;
  createEnergyTrackerNotificationRule: EnergyTrackerNotificationRule;
  createEvent: CalendarEvent;
  createExpressionOfInterest: ExpressionOfInterest;
  createFarmer: Farmer;
  createFeedbackNotificationRule: FeedbackNotificationRule;
  createFileTransfer: FileTransfer;
  createFileTransferBatch: Array<FileTransfer>;
  createFollowUp: IncidentFollowUp;
  createFrontendUpgrade: FrontendUpgrade;
  createFuelReading: FuelReading;
  createGoalAction: GoalAction;
  createGoalReward: GoalReward;
  createGovApplication: GovMembershipApplication;
  createGovChecklist: GovChecklist;
  createGovInvite: GovInvite;
  createGovJobSpec: GovJobSpec;
  createGovMembershipPlan: GovMembershipPlan;
  createGovNotificationRule: GovNotificationRule;
  createGovOrganisation: GovOrganisation;
  createGovProposal: GovProposal;
  createGovTreasuryAccount: GovTreasuryAccount;
  createGovWorkItem: GovWorkItem;
  createHarvestSource: HarvestSource;
  createHeightObservation: HeightObservation;
  createHolisticSnapshot: HolisticSnapshot;
  createHostingAccessLink: HostingAccessLinkResult;
  createHostingAffiliate: HostingAffiliate;
  createHostingOffer: HostingOffer;
  createHostingReferral: HostingReferral;
  createHostingSite: HostingSite;
  createIncident: Incident;
  createIncidentLocation: IncidentLocation;
  createIncidentType: IncidentType;
  createInfluencer: Influencer;
  createInfluencerBooking: InfluencerBooking;
  createIngredient: Ingredient;
  createInvestmentProject: InvestmentProject;
  createInvestor: Investor;
  createInvoice: Invoice;
  createJob: Job;
  createJobVehicle: JobVehicle;
  createJourneyTemplate: JourneyTemplate;
  createKitchen: Kitchen;
  createLaunchedSite: LaunchedSite;
  createLeadFlowAction: LeadFlowAction;
  createLeadFlowForm: LeadFlowForm;
  createLeadFlowNotificationRule: LeadFlowNotificationRule;
  createLeadFlowSequence: LeadFlowSequence;
  createLeadFlowStage: LeadFlowStage;
  createLeaveRequest: LeaveRequest;
  /** Accounting: add one account to an entity's chart (the code must be new on that entity). */
  createLedgerAccount: LedgerAccount;
  createLifeAspect: LifeAspect;
  createLocalSubscription: SubscriptionActivationResult;
  createLocation: Location;
  createMaintenanceNotificationRule: MaintenanceNotificationRule;
  createMaintenanceRequest: MaintenanceRequest;
  createManualCharge: Scalars['String']['output'];
  createManualCheckIn: CheckIn;
  createMealFeedback: MealFeedback;
  createMealPlan: MealPlan;
  createMealPlanNotificationRule: MealPlanNotificationRule;
  createMechanicJob: MechanicJob;
  createMechanicNotificationRule: MechanicNotificationRule;
  createMediaFolder: MediaFolder;
  createMediaItem: MediaItem;
  createMedication: Medication;
  createMeeting: Meeting;
  createMeetingFromRecording: Scalars['String']['output'];
  createMobilityAids: MobilityAids;
  createMobilityAssessment: MobilityAssessment;
  createModuleEvent: CalendarEvent;
  createMoodEntry: MoodEntry;
  createMotivationTemplate: MotivationPromptTemplate;
  createMultiResidentNote: MultiResidentNoteResponse;
  createMultipleObservations: MultipleObservationsResponse;
  createNeurologicalObservation: NeurologicalObservation;
  createNeurologicalPeriod: NeurologicalObservationPeriod;
  createOpportunity: Opportunity;
  createOpportunityMeeting: OpportunityMeeting;
  createOpportunityNote: OpportunityNote;
  createOpportunityStage: OpportunityStage;
  createOpportunityTask: OpportunityTask;
  createOpportunityType: OpportunityType;
  createOrderWithItems: SupplierOrder;
  createOrgChartPlacement: OrgChartPlacement;
  createOxygenSaturationObservation: OxygenSaturationObservation;
  createP2Action: P2Action;
  createP2CampaignMessage: P2CampaignMessage;
  createP2Charge: P2Charge;
  createP2DeliveryUpdate: P2DeliveryUpdate;
  createP2Invite: P2Invite;
  createP2NotificationRule: P2NotificationRule;
  createP2Order: P2Order;
  createP2PaymentIntent: Scalars['String']['output'];
  createP2Pledge: P2PledgeResult;
  createP2PledgeCampaign: P2PledgeCampaign;
  createP2Product: P2Product;
  createP2QuickOrder: P2QuickOrderResult;
  createP2Refund: P2Refund;
  createP2Supplier: P2Supplier;
  createPProposal: PProposal;
  createPartsOrder: PartsOrder;
  createPassword: Password;
  createPaymentIntent: Scalars['String']['output'];
  createPaymentMethod: PaymentMethod;
  createPenaltyRateRule: PenaltyRateRule;
  createPersonEvent: PersonEvent;
  /** Create a personal email alias for the current user */
  createPersonalEmail: Scalars['String']['output'];
  createPledgeCampaign: PledgeCampaign;
  createPolicy: Policy;
  createPrescriber: MedicationPrescriber;
  createProgramActivity: ProgramActivity;
  createProgramApplication: ProgramApplication;
  createProgramApplicationPackBill: Bill;
  createProgramCallNote: ProgramCallNote;
  createProgramCommission: ProgramCommission;
  createProgramMember: ProgramMember;
  createProgressNote: ProgressNote;
  createProject: Project;
  createProposal: Proposal;
  createProspectingNotificationRule: ProspectingNotificationRule;
  createPublicBooking: PublicBookingResult;
  createPublicHoliday: PublicHoliday;
  createPublicHostingReferral: Scalars['Boolean']['output'];
  createPulseObservation: PulseObservation;
  createQuickSplitInvoice: FoodInvoice;
  createQuote: Quote;
  createQuoteTemplate: QuoteTemplate;
  createRDActivity: RdActivity;
  createRDCommunicationLog: RdCommunicationLog;
  createRDProject: RdProject;
  createRDTimeEntry: RdTimeEntry;
  createRecipe: Recipe;
  createRecipeWithIngredients: Recipe;
  createRecurringAvailability: Array<Availability>;
  createReferralFromNote: CreateReferralResponse;
  createResearchBase: ResearchBase;
  createResident: Resident;
  createResidentContact: ResidentContact;
  createResidentLeave: ResidentLeave;
  createResidentRiskAssessment: ResidentRiskAssessment;
  createRespirationObservation: RespirationObservation;
  createRespiteBooking: RespiteCareBooking;
  createRestraintCheck: RestraintCheck;
  createRestraintRecord: RestraintRecord;
  createRiskAssessment: IncidentRiskAssessment;
  createRound: MedicationRound;
  createSEOMetadata: SeoMetadata;
  createSellerProfile: SellerProfile;
  createSeparationAdhocBlock: SeparationCareBlock;
  createSeparationAffiliate: SeparationAffiliate;
  createSeparationCase: SeparationCase;
  createSeparationChild: SeparationChild;
  createSeparationInvite: SeparationInvite;
  createSeparationSchedule: SeparationParentingSchedule;
  createSeparationSponsorshipContribution: SeparationSponsorshipContribution;
  createSession: Session;
  createSessionType: SessionType;
  createSetupIntent: Scalars['String']['output'];
  createShelvInvite: ShelvInvite;
  createShelvMemberInvite: ShelvInvite;
  createShift: Shift;
  createShiftNotificationRule: ShiftNotificationRule;
  createShiftTemplate: ShiftTemplate;
  createShiftType: ShiftType;
  createShiftsFromTemplates: BulkShiftResult;
  createSiteEditorSite: SiteEditorSite;
  createSleepCheck: SleepCheck;
  createSmsNotificationRule: SmsNotificationRule;
  createSopAgendaItem: SopAgendaItem;
  createSopEpisode: SopEpisode;
  createSopTopic: SopTopic;
  createSphereOfInfluence: SphereOfInfluence;
  createSubscription: BillingSubscription;
  createSubscriptionProduct: SubscriptionProduct;
  createSupplier: Supplier;
  createSupplierOrder: SupplierOrder;
  createTask: Task;
  createTeam: Team;
  createTemperatureAlarm: TemperatureAlarm;
  createTemperatureObservation: TemperatureObservation;
  createTenant: Tenant;
  createTimesheet: TimesheetEntity;
  createTomConversation: TomConversation;
  createTrackedCompetition: TrackedCompetition;
  createTranscription: Transcription;
  createTreatmentPlan: IncidentTreatmentPlan;
  createTrustPerson: TrustPerson;
  createUrinalysisObservation: UrinalysisObservation;
  createVaccination: Vaccination;
  createVaultInsightRule: VaultInsightRule;
  createVisionBoardInvite: VisionBoardInvite;
  createVisionBoardItem: VisionBoardItem;
  createVisionBoardMemberInvite: VisionBoardInvite;
  createVisionBoardNotificationRule: VisionBoardNotificationRule;
  createVlogCategory: VlogCategory;
  createVlogNotificationRule: VlogNotificationRule;
  createVlogPost: VlogPost;
  createVlogSeries: VlogSeries;
  createWalletContactInvite: WalletInviteSendResult;
  createWaterlowAssessment: WaterlowAssessment;
  createWeightObservation: WeightObservation;
  createWithdrawalRequest: WithdrawalRequest;
  createWorker: Worker;
  createWorkerTimeEntry: WorkerTimeEntry;
  createWound: Wound;
  createWoundAssessment: WoundAssessment;
  customizeLeadFlowAction: CustomizedLeadFlowAction;
  customizeP2Action: CustomizedP2Action;
  dashboardDeleteTodo: ClientDashboard;
  dashboardReorderTodos: ClientDashboard;
  dashboardSetShortAssessment: ClientDashboard;
  dashboardSetSurgery: ClientDashboard;
  dashboardToggleTodo: ClientDashboard;
  dashboardUpsertTodo: ClientDashboard;
  deactivateAllergy: MedicationAllergy;
  deactivateCoupon: Scalars['Boolean']['output'];
  deactivatePassword: Scalars['Boolean']['output'];
  deactivateTemplate?: Maybe<CarePlanTemplate>;
  deactivateUnit: UnitRetireResult;
  /** Admin: record what was done with the surplus (bought gold / bitcoin / both / skipped). Writes holdings; never places an order. */
  decideBankingMonth: BankingMonthClose;
  decideGovApplication?: Maybe<GovMembershipApplication>;
  /** Decline a received recommendation with a reason. The recruiting partner is told through the decision event. */
  declineEmployeeRecommendation: EmployeeRecommendation;
  declineGovInvite: Scalars['Boolean']['output'];
  declineGuaranteeClaim: SeparationGuaranteeClaim;
  declineMedicalRecordAccessRequest: MedicalRecordAccessDecisionResult;
  declineSeparationInvite: Scalars['Boolean']['output'];
  declineShiftSwap: ShiftSwapRequest;
  declineSponsoredSeparationAccess: SeparationSponsoredRequest;
  declineWaitingListEntry?: Maybe<WaitingListEntry>;
  deferAuthProfile: Scalars['Boolean']['output'];
  deleteACFIAssessment: Scalars['Boolean']['output'];
  deleteAbbeyPainAssessment: Scalars['Boolean']['output'];
  deleteAccountabilityGoal: Scalars['Boolean']['output'];
  deleteAdmissionNotificationRule: Scalars['Boolean']['output'];
  deleteAnalyticsNotificationRule: Scalars['Boolean']['output'];
  deleteArtSession: Scalars['Boolean']['output'];
  deleteArtifact: Scalars['Boolean']['output'];
  deleteArtifactComment: Scalars['Boolean']['output'];
  deleteAssessmentCustomField: Scalars['Boolean']['output'];
  deleteAssessmentDomain: Scalars['Boolean']['output'];
  deleteAssessmentNotificationRule: Scalars['Boolean']['output'];
  deleteAssessmentSnapshot: Scalars['Boolean']['output'];
  deleteAvailability: Scalars['Boolean']['output'];
  deleteAward: Scalars['Boolean']['output'];
  deleteAwardClassification: Scalars['Boolean']['output'];
  deleteAwardRate: Scalars['Boolean']['output'];
  /** Delete one of the caller's alert rules */
  deleteBankingAlertRule: Scalars['Boolean']['output'];
  /** Admin: remove a cash movement (refused while it has comments or files) */
  deleteBankingCashEntry: BankingCashRemoval;
  /** Admin: delete a gold / bitcoin movement */
  deleteBankingHolding: Scalars['Boolean']['output'];
  /** Admin: delete an income rule */
  deleteBankingIncomeRule: Scalars['Boolean']['output'];
  /** Admin: delete a job */
  deleteBankingMonthJob: Scalars['Boolean']['output'];
  /** Admin: delete a standing money move. Its open occurrences from today on go with it; done ones stay. Returns how many jobs were removed. */
  deleteBankingStandingMove: Scalars['Int']['output'];
  deleteBdayGuest: Scalars['Boolean']['output'];
  deleteBill: Scalars['Boolean']['output'];
  deleteBillNotificationRule: Scalars['Boolean']['output'];
  deleteBladderRecord: Scalars['Boolean']['output'];
  deleteBlogCategory: Scalars['Boolean']['output'];
  deleteBlogNotificationRule: Scalars['Boolean']['output'];
  deleteBlogPost: Scalars['Boolean']['output'];
  deleteBond: Scalars['Boolean']['output'];
  deleteBookableEventType: Scalars['Boolean']['output'];
  deleteBowelRecord: Scalars['Boolean']['output'];
  deleteBradenAssessment: Scalars['Boolean']['output'];
  deleteBusinessCalendarAvailability: Scalars['Boolean']['output'];
  deleteBusinessDirectoryNotificationRule: Scalars['Boolean']['output'];
  deleteBusinessSnapshot: Scalars['Boolean']['output'];
  deleteCIGovernanceMeeting: Scalars['Boolean']['output'];
  deleteCIImprovementInitiative: Scalars['Boolean']['output'];
  deleteCIIssueReport: Scalars['Boolean']['output'];
  deleteCINotificationRule: Scalars['Boolean']['output'];
  deleteCalculatorSubmission: Scalars['Boolean']['output'];
  deleteCalendar: Scalars['Boolean']['output'];
  deleteCalendarEventTask: Scalars['Boolean']['output'];
  deleteCalendarGoal: Scalars['Boolean']['output'];
  deleteCalendarTag: Scalars['Boolean']['output'];
  deleteCandidate: Scalars['Boolean']['output'];
  deleteCandidateDraft: Scalars['Boolean']['output'];
  deleteCandidateForm: Scalars['Boolean']['output'];
  /** Remove a home and its history for good. */
  deleteCareHome: Scalars['Boolean']['output'];
  deleteCarePlan: Scalars['Boolean']['output'];
  deleteCarePlanReview: Scalars['Boolean']['output'];
  deleteCarePlanTemplate: Scalars['Boolean']['output'];
  deleteCareReview: Scalars['Boolean']['output'];
  deleteChaseNotificationRule: Scalars['Boolean']['output'];
  deleteChatMessage: Scalars['Boolean']['output'];
  deleteChatRoom: Scalars['Boolean']['output'];
  deleteChecklistItem?: Maybe<MechanicJob>;
  deleteClient: Scalars['Boolean']['output'];
  deleteClientActivity: Scalars['Boolean']['output'];
  deleteClientChaseConfig: Scalars['Boolean']['output'];
  deleteClientCrossTenant: ClientDeleteResult;
  deleteClientNotificationRule: Scalars['Boolean']['output'];
  deleteClinicalTask: Scalars['Boolean']['output'];
  deleteClub52Game: Scalars['Boolean']['output'];
  deleteCoach: Scalars['Boolean']['output'];
  deleteCoachAgreement: Scalars['Boolean']['output'];
  /** Accounting: delete a rule. Suggestions it already made stay until a person deals with them. */
  deleteCodingRule: Scalars['Boolean']['output'];
  deleteCommunicationTask: Scalars['Boolean']['output'];
  deleteCommunityEntry: Scalars['Boolean']['output'];
  deleteCommunityEntryReply: Scalars['Boolean']['output'];
  deleteCommunityInvite: Scalars['Boolean']['output'];
  deleteCommunityPost: Scalars['Boolean']['output'];
  deleteCommunityPostComment: Scalars['Boolean']['output'];
  deleteCompany: Scalars['Boolean']['output'];
  deleteCompanyKnowledgeArticle: Scalars['Boolean']['output'];
  deleteCompetition: Scalars['Boolean']['output'];
  deleteCompetitionPrintPayout: Scalars['Boolean']['output'];
  deleteCompetitionSchool: Scalars['Boolean']['output'];
  deleteCompetitionSponsor: Scalars['Boolean']['output'];
  deleteConstructionSite: Scalars['Boolean']['output'];
  deleteCustomQuestion: Scalars['Boolean']['output'];
  deleteDailyAllocationVersion?: Maybe<DailyAllocationSheet>;
  deleteDailyCareProfile: Scalars['Boolean']['output'];
  deleteDayBookEntry: Scalars['Boolean']['output'];
  deleteDepartment: Scalars['Boolean']['output'];
  deleteDigitalManagerMemory: Scalars['Boolean']['output'];
  deleteDigitalManagerNotificationRule: Scalars['Boolean']['output'];
  deleteDigitalManagerRule: Scalars['Boolean']['output'];
  deleteDigitalManagerTemplate: Scalars['Boolean']['output'];
  deleteDomain: Scalars['Boolean']['output'];
  deleteDroneSession: Scalars['Boolean']['output'];
  deleteDuplicateEmployees: Scalars['Boolean']['output'];
  deleteEmail: Scalars['Boolean']['output'];
  deleteEmailAddress: Scalars['Boolean']['output'];
  deleteEmailAiMemory: Scalars['Boolean']['output'];
  deleteEmailAiRule: Scalars['Boolean']['output'];
  deleteEmailHealthProbe: Scalars['Boolean']['output'];
  deleteEmployee: Scalars['Boolean']['output'];
  deleteEmployeeActivity: Scalars['Boolean']['output'];
  deleteEmployeeActivityTag: Scalars['Boolean']['output'];
  /** Delete a checklist and its items. */
  deleteEmployeeChecklist: Scalars['Boolean']['output'];
  deleteEmployeeChecklistItem: Scalars['Boolean']['output'];
  deleteEmployeeContractTemplate: Scalars['Boolean']['output'];
  deleteEmployeeIncidentNotificationRule: Scalars['Boolean']['output'];
  deleteEmployeeInvite: Scalars['Boolean']['output'];
  deleteEmployeeNotificationRule: Scalars['Boolean']['output'];
  deleteEmployeePosition: Scalars['Boolean']['output'];
  deleteEmployeeRole: Scalars['Boolean']['output'];
  deleteEmployeeStatusOption: Scalars['Boolean']['output'];
  deleteEmployeeTrainingAssignment: Scalars['Boolean']['output'];
  deleteEmployeeTrainingCategory: Scalars['Boolean']['output'];
  deleteEnergyTrackerNotificationRule: Scalars['Boolean']['output'];
  deleteEvent: DeleteEventResponse;
  deleteEventRegistration: Scalars['Boolean']['output'];
  deleteFarmer: Scalars['Boolean']['output'];
  deleteFeedbackItem: Scalars['Boolean']['output'];
  deleteFeedbackNotificationRule: Scalars['Boolean']['output'];
  deleteFrontendUpgrade: Scalars['Boolean']['output'];
  deleteGoalAction: Scalars['Boolean']['output'];
  deleteGoalReward: Scalars['Boolean']['output'];
  deleteGovMembershipPlan: Scalars['Boolean']['output'];
  deleteGovNotificationRule: Scalars['Boolean']['output'];
  deleteGovOrganisation: GovOrganisationDeleteCheck;
  deleteHarvestSource: Scalars['Boolean']['output'];
  deleteHarvestedVideo: Scalars['Boolean']['output'];
  deleteHolisticSnapshot: Scalars['Boolean']['output'];
  deleteHostingAffiliate: Scalars['Boolean']['output'];
  deleteHostingCommissionPayment: Scalars['Boolean']['output'];
  deleteHostingOffer: Scalars['Boolean']['output'];
  deleteHostingReferral: Scalars['Boolean']['output'];
  deleteHostingSite: Scalars['Boolean']['output'];
  /** Delete an ImprovMX alias */
  deleteImprovMXAlias: Scalars['Boolean']['output'];
  deleteInboundEmail: Scalars['Boolean']['output'];
  deleteIncident: Scalars['Boolean']['output'];
  deleteIncidentAlert: Scalars['Boolean']['output'];
  deleteIncidentDocument: Scalars['Boolean']['output'];
  deleteIncomingDeliveryTemperature?: Maybe<IncomingDeliveryTemperature>;
  deleteInfluencer: Scalars['Boolean']['output'];
  deleteIngredient: Scalars['Boolean']['output'];
  deleteInvestmentProject: Scalars['Boolean']['output'];
  deleteInvestor: Scalars['Boolean']['output'];
  deleteInvoice: Scalars['Boolean']['output'];
  deleteIpfsNode: Scalars['Boolean']['output'];
  deleteJob: Scalars['Boolean']['output'];
  deleteJobMedia?: Maybe<MechanicJob>;
  deleteJobProgressNote?: Maybe<MechanicJob>;
  deleteJobVehicle: Scalars['Boolean']['output'];
  deleteJourneyTemplate: Scalars['Boolean']['output'];
  deleteKitchen: Scalars['Boolean']['output'];
  deleteLaunchedSite: Scalars['Boolean']['output'];
  deleteLeadFlowForm: Scalars['Boolean']['output'];
  deleteLeadFlowNotificationRule: Scalars['Boolean']['output'];
  deleteLeadFlowStage: Scalars['Boolean']['output'];
  deleteLifeAspect: Scalars['Boolean']['output'];
  deleteLineItem: Bill;
  deleteLocation: Scalars['Boolean']['output'];
  deleteMaintenanceActivity: Scalars['Boolean']['output'];
  deleteMaintenanceChecklistItem?: Maybe<MaintenanceRequest>;
  deleteMaintenanceNotificationRule: Scalars['Boolean']['output'];
  deleteMaintenanceProgressNote?: Maybe<MaintenanceRequest>;
  deleteMaintenanceRequest: Scalars['Boolean']['output'];
  deleteMealFeedback: Scalars['Boolean']['output'];
  deleteMealPlan: Scalars['Boolean']['output'];
  deleteMealPlanNotificationRule?: Maybe<MealPlanNotificationRule>;
  deleteMechanicJob: Scalars['Boolean']['output'];
  deleteMechanicNotificationRule: Scalars['Boolean']['output'];
  deleteMediaFolder: Scalars['Boolean']['output'];
  deleteMediaItem: Scalars['Boolean']['output'];
  deleteMedicalRecord: MedicalRecord;
  deleteMeetVoiceSignature: Scalars['Boolean']['output'];
  deleteMeeting: Scalars['Boolean']['output'];
  deleteMobilityAssessment: Scalars['Boolean']['output'];
  deleteMoodEntry: Scalars['Boolean']['output'];
  deleteMotivationTemplate: Scalars['Boolean']['output'];
  /** Delete the signed-in member's own listing and its history. */
  deleteMyBusinessListing: Scalars['Boolean']['output'];
  deleteMyCommunityData: CommunityErasureSummary;
  deleteOpportunity: Scalars['Boolean']['output'];
  deleteOpportunityMeeting: Scalars['Boolean']['output'];
  deleteOpportunityNote: Scalars['Boolean']['output'];
  deleteOpportunityProgressNote: Opportunity;
  deleteOpportunityTask: Scalars['Boolean']['output'];
  deleteOpportunityType: Scalars['Boolean']['output'];
  deleteOrgChartPlacement: Scalars['Boolean']['output'];
  deleteP2CampaignMessage: Scalars['Boolean']['output'];
  deleteP2Invite: Scalars['Boolean']['output'];
  deleteP2NotificationRule: Scalars['Boolean']['output'];
  deleteP2Product: Scalars['Boolean']['output'];
  deleteP2Supplier: Scalars['Boolean']['output'];
  deletePProposal: Scalars['Boolean']['output'];
  deletePProposalActivity: PProposal;
  deletePartsOrder: Scalars['Boolean']['output'];
  deletePasskey: Scalars['Boolean']['output'];
  deletePaymentMethod: Scalars['Boolean']['output'];
  deletePenaltyRateRule: Scalars['Boolean']['output'];
  deletePledgeCampaign: Scalars['Boolean']['output'];
  deleteProgramActivity: Scalars['Boolean']['output'];
  deleteProgramApplication: Scalars['Boolean']['output'];
  deleteProgramCallNote: Scalars['Boolean']['output'];
  deleteProgramCommission: Scalars['Boolean']['output'];
  deleteProgramMember: Scalars['Boolean']['output'];
  deleteProject: Scalars['Boolean']['output'];
  deleteProposal: Scalars['Boolean']['output'];
  deleteProspectingNotificationRule: Scalars['Boolean']['output'];
  deletePublicHoliday: Scalars['Boolean']['output'];
  deleteRDActivity: Scalars['Boolean']['output'];
  deleteRDEvidence: Scalars['Boolean']['output'];
  deleteRDProject: Scalars['Boolean']['output'];
  deleteRDTimeEntry: Scalars['Boolean']['output'];
  deleteReadIncidentAlerts: Scalars['Int']['output'];
  deleteRecipe: Scalars['Boolean']['output'];
  deleteRecording: Scalars['Boolean']['output'];
  deleteResearchBase: Scalars['Boolean']['output'];
  deleteResident: Scalars['Boolean']['output'];
  deleteResidentContact: Scalars['Boolean']['output'];
  deleteResidentLeave: Scalars['Boolean']['output'];
  deleteResidentRiskAssessment: Scalars['Boolean']['output'];
  deleteRespiteBooking: Scalars['Boolean']['output'];
  deleteRestraintRecord: Scalars['Boolean']['output'];
  deleteRollup: Scalars['Boolean']['output'];
  deleteSEOMetadata: Scalars['Boolean']['output'];
  deleteSellerProfile: Scalars['Boolean']['output'];
  deleteSeparationChild: Scalars['Boolean']['output'];
  deleteSessionType: Scalars['Boolean']['output'];
  deleteShelvInvite: Scalars['Boolean']['output'];
  deleteShift: Scalars['Boolean']['output'];
  deleteShiftNotificationRule: Scalars['Boolean']['output'];
  deleteShiftTemplate: Scalars['Boolean']['output'];
  deleteShiftType: Scalars['Boolean']['output'];
  deleteShifts: Scalars['Int']['output'];
  deleteShiftsByDateRange: Scalars['Int']['output'];
  deleteSiteEditorSite: Scalars['Boolean']['output'];
  deleteSiteUpdate: Scalars['Boolean']['output'];
  deleteSleepCheck: Scalars['Boolean']['output'];
  deleteSmsNotificationRule: Scalars['Boolean']['output'];
  deleteSopAgendaItem: Scalars['Boolean']['output'];
  deleteSopComment: Scalars['Boolean']['output'];
  deleteSopEpisode: Scalars['Boolean']['output'];
  deleteSopTopic: Scalars['Boolean']['output'];
  deleteSphereOfInfluence: Scalars['Boolean']['output'];
  deleteSubSubTask: OpportunityTask;
  deleteSubTask: OpportunityTask;
  deleteSubscriptionProduct: Scalars['Boolean']['output'];
  deleteSupplier: Scalars['Boolean']['output'];
  deleteSupplierOrder: Scalars['Boolean']['output'];
  deleteTask: Scalars['Boolean']['output'];
  deleteTaskMedia: Scalars['Boolean']['output'];
  deleteTeam: Scalars['Boolean']['output'];
  deleteTemperatureAlarm?: Maybe<TemperatureAlarm>;
  deleteTemperatureLog?: Maybe<TemperatureLog>;
  deleteTenant: Scalars['Boolean']['output'];
  deleteTestResult: Scalars['Boolean']['output'];
  deleteTimesheet: Scalars['Boolean']['output'];
  deleteTomConversation: Scalars['Boolean']['output'];
  deleteTrackedCompetition: Scalars['Boolean']['output'];
  deleteTranscription: Scalars['Boolean']['output'];
  /** Delete a comment: your own, or any comment if you are TRANSCRIPTION_ADMIN. */
  deleteTranscriptionComment: Scalars['Boolean']['output'];
  deleteVaccination: Scalars['Boolean']['output'];
  deleteVaultInsightRule: Scalars['Boolean']['output'];
  deleteVisionBoardInvite: Scalars['Boolean']['output'];
  deleteVisionBoardItem: Scalars['Boolean']['output'];
  deleteVisionBoardNotificationRule: Scalars['Boolean']['output'];
  deleteVlogCategory: Scalars['Boolean']['output'];
  deleteVlogNotificationRule: Scalars['Boolean']['output'];
  deleteVlogPost: Scalars['Boolean']['output'];
  deleteVlogSeries: Scalars['Boolean']['output'];
  deleteVoiceContact: Scalars['Boolean']['output'];
  deleteVoiceSignature: Scalars['Boolean']['output'];
  deleteVoipSnapshot: Scalars['Boolean']['output'];
  deleteWaitingListChecklistItem?: Maybe<WaitingListEntry>;
  deleteWaitingListEntry: Scalars['Boolean']['output'];
  deleteWalletContact: Scalars['Boolean']['output'];
  deleteWaterlowAssessment: Scalars['Boolean']['output'];
  deleteWorker: Scalars['Boolean']['output'];
  deleteWorkerTimeEntry: Scalars['Boolean']['output'];
  deleteWound: Scalars['Boolean']['output'];
  denyLeaveRequest: LeaveRequest;
  denyShiftSwap: ShiftSwapRequest;
  deployLatestModules: DeploymentSummary;
  deployModuleToAllClients: BulkDeploymentResult;
  deployModuleToTenant: ModuleDeploymentResult;
  deployModuleUpdate: Scalars['Boolean']['output'];
  deploySpecificModule: Array<ModuleDeploymentResult>;
  deregisterValidator: CustodyValidator;
  detachInboundEmailFromOpportunity: InboundEmail;
  /** Disable call forwarding for a phone number */
  disableCallForwarding: TwilioPhoneNumber;
  disableContactPortalAccess: ResidentContact;
  disableModuleForTenant: Tenant;
  disableTwoFactor: StepUpResult;
  discardInvoice: FoodInvoice;
  discardPolicyDraft: Policy;
  discardRecipeCapture: Scalars['Boolean']['output'];
  /** Accounting admin: forget the Redbark key. Bank accounts and every transaction already read are kept. */
  disconnectAccountingRedbark: AccountingSettingsView;
  /** Accounting admin: drop the Xero connection (the app credentials stay, so reconnecting is one click). Accounts already imported are kept. */
  disconnectAccountingXero: AccountingSettingsView;
  /** Forget the key and secrets, best-effort delete our Redbark objects; accounts and transactions are kept */
  disconnectRedbark: BankingSettingsView;
  dismissClub52Goal: Scalars['Boolean']['output'];
  dismissDigitalManagerChase: DigitalManagerChaseItem;
  dismissDigitalManagerOQ: DigitalManagerOutstandingQuestion;
  dismissFailedIngests: Scalars['Int']['output'];
  dismissOutstandingQuestion: EmailAiOutstandingQuestion;
  dismissSmsHeldReply: SmsHeldRepliesResult;
  downloadRecordingUrl: Scalars['String']['output'];
  draftBroadcastContent: BroadcastDraft;
  draftCandidateMessage: CandidateMessage;
  draftGovProposal: GovProposalDraftResult;
  draftReplyForEmail: EmailReplyDraftOutput;
  draftSopEpisodeCopy?: Maybe<SopEpisode>;
  draftSopEpisodeFromBrief: SopEpisode;
  draftUnsubscribeDemand: Scalars['ID']['output'];
  duplicateBillWithPercentage: Bill;
  duplicateEmail: Email;
  duplicateJob: Job;
  duplicateP2Campaign: P2PledgeCampaign;
  duplicateRecipe: Recipe;
  duplicateShift: Shift;
  duplicateTemplate: CarePlanTemplate;
  editCheckInTimes?: Maybe<Shift>;
  /** Email every employee in this PayRun their payslip (bulk) */
  emailAllPayslips: PayslipDeliveryResult;
  emailLoginBrowserApproval?: Maybe<Scalars['String']['output']>;
  employeeCancelUpload: Scalars['Boolean']['output'];
  employeeCompleteUpload: EmployeeUploadResult;
  employeeGetUploadProgress: Scalars['String']['output'];
  employeeInitiateUpload: Scalars['String']['output'];
  employeeUploadChunk: Scalars['Boolean']['output'];
  enableContactPortalAccess: ResidentContact;
  enableModuleForTenant: Tenant;
  enableTwoFactor: TwoFactorEnableResult;
  endClub52Game: Club52Game;
  endMeeting: Meeting;
  endNeurologicalPeriod: NeurologicalObservationPeriod;
  endRestraint: RestraintRecord;
  /** Release the voice lease when the call ends. Records the call as a voice session in the tenant's AI usage. */
  endVoiceLease: Scalars['Boolean']['output'];
  enqueueDigitalManagerOQ: DigitalManagerOutstandingQuestion;
  enqueueEmailAiQuestion: EmailAiOutstandingQuestion;
  enqueueGraphExtract: GraphExtractJob;
  enqueueModuleUpgrades: ModuleUpgradeEnqueueResult;
  enqueueRollup: Rollup;
  enrichPeople: Scalars['Int']['output'];
  enrichSarahCareNoteSourceFields: SarahNoteSourceFieldsResult;
  enrichSarahCareObservationContext: SarahObservationContextResult;
  enrolEmpowermentPerson: EmpowermentJourney;
  enrolLeadInSequence: Scalars['Boolean']['output'];
  ensureCandidateChatRoom: CandidateChatRoomInfo;
  ensureChatRoom: ChatRoom;
  ensureMyShelf: Kitchen;
  ensureSarahCareIncidentTypes: Array<SarahIncidentTypeMatch>;
  ensureSeparationHorizon: SeparationGenerateResult;
  enterCompetition: MyCompetitionEntry;
  executeProposalTask: ProposalDraftPreview;
  executeWithdrawal: WithdrawalRequest;
  exportCIPDF: Scalars['String']['output'];
  exportCIStandardSummaryPDF: Scalars['String']['output'];
  exportCarePlanToPDF: CarePlanPdfExport;
  exportClub52Wallet: Club52GeneratedWallet;
  exportGoalsSummaryToPDF: CarePlanPdfExport;
  extendLeave: ResidentLeave;
  extendRewardTokenExpiry: RewardToken;
  extractActionItemsFromTranscription: Scalars['String']['output'];
  /** Suggest candidate details from document text using the tenant's Qwen service. Saves no candidate and verifies no credentials. */
  extractCandidateFromDocument: CandidateExtraction;
  finishRosterBulkOp?: Maybe<RosterBulkOpLog>;
  fireVaultInsightRuleNow: FireVaultInsightRuleResult;
  fixBookingMetadata: Scalars['JSONObject']['output'];
  flagSarahCareWeightSourceReview: SarahObservationContextResult;
  followCompetition: MyCompetitionFollow;
  forceRetryMeetTranscription: Meeting;
  forceRetryTranscription: Transcription;
  fundClub52Player: Club52FundResult;
  generateAccountSnapshot: BusinessSnapshot;
  generateAllLocationQRCodes: Scalars['Boolean']['output'];
  /** Take (or retake) the snapshot for one complete Brisbane week. Idempotent per week. Refuses a week that is not over yet. */
  generateBillsWeeklySnapshot: BillsWeeklySnapshot;
  generateClub52Wallet: Club52GeneratedWallet;
  generateDailyCareCalendarEvents: DailyCareCalendarResult;
  generateDroneSessionShareLink?: Maybe<ShareLinkResult>;
  generateEmployeeCredentials: OnboardingResult;
  generateHeroImage: Scalars['String']['output'];
  generateInboxSummaryNow: InboxSummary;
  generateInvoiceFromPProposal: PProposal;
  generateLocationQRCode: Location;
  generateMealPlanAI: GeneratedMealPlanResult;
  generateMeetRecordingSummary: Meeting;
  generateOrdersFromMealPlans: Array<GeneratedOrder>;
  generatePasskeyAuthenticationOptions: Scalars['String']['output'];
  generatePasskeyRegistrationOptions: Scalars['String']['output'];
  generatePasswordLink: Scalars['String']['output'];
  generateProgramDownpaymentBill: Bill;
  generateQRCode: DailyQrCode;
  generateRollupSnapshot: BusinessSnapshot;
  generateSeparationCareBlocks: SeparationGenerateResult;
  generateShareToken: CompanyKnowledge;
  generateSiteSpec: SiteSpecResult;
  generateTasksFromEmail: GenerateTasksResult;
  generateTranscriptionPlan: Scalars['String']['output'];
  generateTranscriptionSummary: Transcription;
  /** Generate a temporary access token for Vapi web calls */
  generateVapiAccessToken: VapiAccessToken;
  generateVideoThumbnail: ThumbnailResult;
  generateVoipSnapshot: VoipSnapshot;
  getClub52Token: Club52TokenResult;
  getGuestClub52Token: Club52TokenResult;
  getGuestMeetToken: MeetTokenResult;
  getMeetToken: MeetTokenResult;
  getOrCreatePersonalCalendar: BusinessCalendar;
  grantGovTokens: GovTokenGrant;
  grantMedicalAccess: MedicalRecordPermission;
  grantSponsoredSeparationAccess: SeparationSponsoredRequest;
  /** Admin: import listings (idempotent on sourceUrl, else slug; descriptions verbatim). Per-row outcome. Use options.dryRun first. */
  importBusinessListings: BusinessListingImportResult;
  importCellcastHistory: CellcastImportSummary;
  importLaunchedSite: LaunchedSite;
  /** Import line items from markdown format */
  importLineItemsFromMarkdown: Bill;
  importPolicyDocument: PolicyImportResult;
  importPolicyMarkdown: PolicyImportResult;
  /** Import QLD public holidays from data.gov.au into the shift PublicHoliday collection (idempotent) */
  importQldPublicHolidays: PublicHolidayImportResult;
  importSarahCareAbbeyPain: SarahHistoricalImportResult;
  importSarahCareAcfiAssessments: SarahHistoricalImportResult;
  importSarahCareAdmissionSnapshots: SarahHistoricalImportResult;
  importSarahCareAnaccClassifications: SarahHistoricalImportResult;
  importSarahCareBonds: SarahHistoricalImportResult;
  importSarahCareBowelRecords: SarahHistoricalImportResult;
  importSarahCareBraden: SarahHistoricalImportResult;
  importSarahCareCarePlanHistory: SarahHistoricalImportResult;
  importSarahCareContactCalls: SarahHistoricalImportResult;
  importSarahCareContactHistory: SarahHistoricalImportResult;
  importSarahCareDailyCareHistory: SarahHistoricalImportResult;
  importSarahCareFallsRisk: SarahHistoricalImportResult;
  importSarahCareFluidBalance: SarahHistoricalImportResult;
  importSarahCareFoodIntake: SarahHistoricalImportResult;
  importSarahCareHistoricalAssessments: SarahHistoricalImportResult;
  importSarahCareIncidents: SarahIncidentImportResult;
  importSarahCareLeave: SarahHistoricalImportResult;
  importSarahCareMedicalAssessments: SarahHistoricalImportResult;
  importSarahCareMedicalFile: MedicalRecord;
  importSarahCareMobilityAids: SarahHistoricalImportResult;
  importSarahCareMobilityChanges: SarahHistoricalImportResult;
  importSarahCareNoteFollowups: SarahHistoricalImportResult;
  importSarahCareObservations: SarahHistoricalImportResult;
  importSarahCarePainChart: SarahHistoricalImportResult;
  importSarahCarePainChartPeriods: SarahHistoricalImportResult;
  importSarahCareProgressNotes: SarahHistoricalImportResult;
  importSarahCareReferralTasks: SarahHistoricalImportResult;
  importSarahCareRepositioningChecks: SarahHistoricalImportResult;
  importSarahCareResidentPhotoPointers: SarahCareResidentPhotoPointerResult;
  importSarahCareResidents: SarahResidentImportResult;
  importSarahCareRespiteStays: SarahHistoricalImportResult;
  importSarahCareRestraintChecks: SarahHistoricalImportResult;
  importSarahCareRestraints: SarahHistoricalImportResult;
  importSarahCareReviewHistory: SarahHistoricalImportResult;
  importSarahCareSleepChecks: SarahHistoricalImportResult;
  importSarahCareVaccinations: SarahHistoricalImportResult;
  importSarahCareVoidedNotes: SarahHistoricalImportResult;
  importSarahCareWaitingList: SarahHistoricalImportResult;
  importSarahCareWoundAssessments: SarahHistoricalImportResult;
  importSarahCareWounds: SarahHistoricalImportResult;
  /** Import tasks from markdown format to project */
  importTasksFromMarkdown: Project;
  importTrackedCompetitions: TrackedCompetitionImportResult;
  improveDescription: Scalars['String']['output'];
  improveOutgoingEmail: Scalars['String']['output'];
  improveTagline: Scalars['String']['output'];
  improveText: Scalars['String']['output'];
  /** Public mutation to increment view count and record view */
  incrementPostView?: Maybe<BlogPost>;
  incrementSopEpisodeView: Scalars['Boolean']['output'];
  /** Public mutation: increment view count and record view */
  incrementVlogPostView?: Maybe<VlogPost>;
  ingestMicrosoftEmail: MicrosoftEmail;
  ingestSummaryTrainingReply: IngestTrainingReplyOutput;
  ingestVoipCall: VoipCall;
  initializeAdmissionChecklist: AdmissionChecklist;
  inviteCoParent: SeparationInvite;
  inviteCommunityMemberToMeet: Scalars['Boolean']['output'];
  inviteFromRecommendation: EmployeeInvite;
  inviteProgramMember: ProgramMember;
  inviteSiteOwner: SiteOwnerLinkResult;
  inviteToSopEpisode: SopInviteResult;
  issueGovMembershipBills: GovMembershipBatchResult;
  issueMonthlyBills: BillingActionResult;
  issuePreorderInvoicesForCampaign: IssuePreorderInvoicesResult;
  issueProRataBill: Bill;
  issueRewardToken: RewardToken;
  issueSingleSubscriptionBill: Bill;
  issueSubscriptionBills: SubscriptionBillActionResult;
  joinChatRoom: JoinChatRoomResponse;
  joinWaitlist: JoinWaitlistResult;
  labelMonitorIncident: MonitorIncident;
  linkAnonymousChatIdentity: Scalars['Boolean']['output'];
  linkBillToEvent: CalendarEvent;
  linkCIIssueToInitiative?: Maybe<CiIssueReport>;
  linkCIIssueToMeeting?: Maybe<CiIssueReport>;
  linkCalculatorSubmissionToClient?: Maybe<CalculatorSubmission>;
  linkCommsSmsApp: CommsIsolationView;
  linkDailyCareProfileToCarePlan?: Maybe<CarePlan>;
  linkEmailToAccount?: Maybe<Client>;
  linkEmpowermentTranscription: EmpowermentCatchUp;
  linkFeedbackOutcome: FeedbackItem;
  linkInitiativeToIssue?: Maybe<CiImprovementInitiative>;
  linkInitiativeToMaintenance?: Maybe<CiImprovementInitiative>;
  linkInitiativeToMeeting?: Maybe<CiImprovementInitiative>;
  linkInvoiceToOrder: FoodInvoice;
  linkMaintenanceToCIInitiative?: Maybe<MaintenanceRequest>;
  linkMaintenanceToCIIssue?: Maybe<MaintenanceRequest>;
  linkMaintenanceToCIStandard?: Maybe<MaintenanceRequest>;
  linkPProposalToOpportunity: Scalars['Boolean']['output'];
  linkPhoneToAccount?: Maybe<Client>;
  linkSarahCareContactHistory: SarahContactLinkResult;
  linkTrustPersonCalendar: TrustPerson;
  linkWalletKey: WalletKey;
  lmAdminEnrollUser: LmEnrollment;
  lmAdminUnenrollUser: Scalars['Boolean']['output'];
  lmCreateCourse: LmCourse;
  lmCreateLesson: LmLesson;
  lmCreateModule: LmModule;
  lmDeleteCourse: Scalars['Boolean']['output'];
  lmDeleteLesson: Scalars['Boolean']['output'];
  lmDeleteModule: Scalars['Boolean']['output'];
  lmEnrollUser: LmEnrollment;
  lmGenerateCertificate: LmCertificate;
  lmGenerateLessonContent: LmGenerateLessonContentResult;
  lmMarkLessonComplete: LmEnrollment;
  lmMarkLessonIncomplete: LmEnrollment;
  lmReorderLessons: Array<LmLesson>;
  lmReorderModules: Array<LmModule>;
  lmSetCourseAuthors: LmCourse;
  lmSetSkinPreference: Scalars['String']['output'];
  lmToggleReminderOptOut: LmEnrollment;
  lmUnenrollUser: Scalars['Boolean']['output'];
  lmUpdateCourse: LmCourse;
  lmUpdateLesson: LmLesson;
  lmUpdateModule: LmModule;
  /** Submit an already-built STP payload to the ATO via the configured provider */
  lodgeStpPayload: StpLodgement;
  /** Log a contact (call, email, meeting…). Keeps 'last contacted' in step, and can move the stage. */
  logCareHomeContact: CareHome;
  logWaitingListCheckIn: WaitingListEntry;
  loginWithUsername?: Maybe<AuthResponse>;
  makeOutboundCall: Scalars['String']['output'];
  /** Admin: this token is money owed — never expires, payable to the holder's bank */
  makeRewardTokenPayable: RewardToken;
  managerCreateShiftSwap: ShiftSwapRequest;
  mapInvoiceLineToIngredient: FoodInvoice;
  mapMeetVoiceSignature: MeetVoiceSignature;
  mapVoiceSignature: VoiceSignature;
  markAgentJobsReviewed: Array<AgentJob>;
  markAllInboundEmailsAsRead: Scalars['Boolean']['output'];
  markAllIncidentAlertsRead: Scalars['Int']['output'];
  markAllMealPlanNotificationsRead: Scalars['Int']['output'];
  markAllNotificationsRead: Scalars['Boolean']['output'];
  markBdayInviteSent?: Maybe<BdayGuest>;
  markBillAsSent: Bill;
  markCalculatorSubmissionSentToPipedrive?: Maybe<CalculatorSubmission>;
  markCheckInReviewed: CheckIn;
  markCommunityPinnedVideoSeen: CommunityPinnedVideoViews;
  markEmailAsRead: Email;
  markEmailAsSpam: SpamBlockResult;
  markFileUploaded?: Maybe<FileTransfer>;
  markFileVerified?: Maybe<FileTransfer>;
  markInboundEmailAsRead: InboundEmail;
  markInboundEmailsRead: Scalars['Int']['output'];
  markIncidentAlertRead: IncidentAlert;
  markLocalDeleted?: Maybe<FileTransfer>;
  markLocationCleaned?: Maybe<Location>;
  markLocationInspected?: Maybe<Location>;
  markMealPlanNotificationRead?: Maybe<MealPlanInAppNotification>;
  markMilestoneComplete: ClientChaseConfig;
  markMonthlyRoomCheckCompleted?: Maybe<MonthlyRoomCheck>;
  markNotAttending: Shift;
  markNotificationRead: InAppNotification;
  markOrderDelivered?: Maybe<SupplierOrder>;
  /** @deprecated Use completePreScreen(id, input). This records notes and moves APPLIED → PRE_SCREEN; advanceToShortlist is ignored because SUITABLE is gated on references + credentials. */
  markPhoneScreeningComplete: Candidate;
  markProgramWowPageViewed: ProgramMember;
  markPublicHolidayNotWorked: BulkHolidayNotWorkedResult;
  markRespiteUsed?: Maybe<RespiteBooking>;
  /** Admin: I've paid this to their bank. Marks the request paid, redeems its tokens and tells the holder. */
  markRewardPayoutPaid: RewardPayoutSettled;
  markStayedTillEnd?: Maybe<EventRegistration>;
  markUpgradeApplied: FrontendUpgrade;
  markWaitingListEntryAdmitted: WaitingListEntry;
  masterBulkDeleteMediaFiles: Scalars['Float']['output'];
  masterDeleteMediaFile: DeleteResult;
  masterRunIPFSGarbageCollection: IpfsgcResult;
  masterUnpinOrphanedFiles: IpfsUnpinResult;
  mediaCDNCancelUpload: Scalars['Boolean']['output'];
  mediaCDNCompleteUpload: MediaCdnUploadResult;
  mediaCDNGetUploadProgress: Scalars['String']['output'];
  mediaCDNInitiateUpload: Scalars['String']['output'];
  mediaCDNUploadChunk: Scalars['Boolean']['output'];
  mergeClientAccounts: Client;
  mergeClients: Client;
  mergeMySiteToMain: MergeToMainResult;
  migrateSeparationJourneyProgress: SeparationJourneyProgress;
  moderateSopComment?: Maybe<SopComment>;
  moveEmployeeOnChart: Employee;
  moveGoalToMonth: CalendarGoal;
  moveInboundEmailToFolder: InboundEmail;
  moveInboundEmailsToFolder: InboundEmailBulkMoveResult;
  moveMediaItem?: Maybe<MediaItem>;
  moveOpportunityStage: Opportunity;
  moveOrgChartPlacement: OrgChartPlacement;
  moveWaitingListEntryStage: WaitingListStageMoveResult;
  notifyClientActivityMentions: ClientMentionNotifyResult;
  notifyGovMentions: GovMentionNotifyResult;
  notifyTranscriptionEmail: Scalars['Boolean']['output'];
  offerCompetitionPrints: CompetitionPrintOfferResult;
  onboardClient: OnboardClientResult;
  openEmpowermentCheckInNow: EmpowermentCheckIn;
  openGovProposal?: Maybe<GovProposal>;
  p2AddToCart: P2Cart;
  p2ClearCart: Scalars['Boolean']['output'];
  p2CreateSetupIntent: Scalars['String']['output'];
  p2RemoveFromCart: P2Cart;
  p2RemoveSavedCard: Scalars['Boolean']['output'];
  p2SavePaymentMethod: P2SavedCard;
  pauseDigitalManager: DigitalManager;
  pauseJob?: Maybe<Job>;
  pauseModuleUpgradeService: ModuleUpgradeServiceStatus;
  pauseSubscription: BillingSubscription;
  payBillOnTheHouse: Scalars['Boolean']['output'];
  paySeparationCommission: SeparationCommissionPayment;
  permanentlyDeleteRecipe: Scalars['Boolean']['output'];
  permanentlyDeleteResidentContact: Scalars['Boolean']['output'];
  pinCalendar: CalendarUserPreference;
  /** Ask Redbark to deliver a signed test event to our webhook. Returns Redbark's event id; the delivery shows up in Activity and moves 'last webhook'. */
  pingBankingWebhook: Scalars['String']['output'];
  placeEmployeeAsSiblingOfEmployeeOnChart: Employee;
  /** Run the 15-minute poll now for this tenant */
  pollBankingNow: BankingRunSummary;
  pollCrazytelNow: CrazytelPollResult;
  pollEmailLoginBrowser: EmailLoginBrowserResult;
  pollSmsLoginBrowser: SmsLoginResult;
  postBondRetention?: Maybe<Bond>;
  prettyUpEventCopy: EventCopyDraft;
  probeExtractionModel: ModelProbeResult;
  processAdmission: AdmissionResult;
  processBondPayout?: Maybe<Bond>;
  processDischarge: AdmissionResult;
  processGuaranteeRefund: SeparationRefundResult;
  processInboundEmailWithAi: EmailAiProcessingLog;
  promoteFromWaitingList: AdmissionResult;
  promoteSarahCareResidentFields: SarahResidentPromotionResult;
  promoteShiftsToMaster: Scalars['Int']['output'];
  proposeEmailAiAction: EmailAiActionProposal;
  proposeGovJobSpec: GovJobSpec;
  provisionCoachCalendar?: Maybe<Coach>;
  provisionDigitalManager: ProvisionDigitalManagerResult;
  provisionEmployeeWorkEmail: ProvisionEmployeeWorkEmailResult;
  provisionSite: Scalars['Boolean']['output'];
  provisionSiteEditorSite: ProvisionResult;
  publicFeedbackMediaCompleteUpload: MediaCdnUploadResult;
  publicFeedbackMediaInitiateUpload: Scalars['String']['output'];
  publicFeedbackMediaUploadChunk: Scalars['Boolean']['output'];
  publicMaintenanceMediaCompleteUpload: MediaCdnUploadResult;
  publicMaintenanceMediaInitiateUpload: Scalars['String']['output'];
  publicMaintenanceMediaUploadChunk: Scalars['Boolean']['output'];
  publicMealMediaCompleteUpload: MediaCdnUploadResult;
  publicMealMediaInitiateUpload: Scalars['String']['output'];
  publicMealMediaUploadChunk: Scalars['Boolean']['output'];
  publicMediaCDNCompleteUpload: MediaCdnUploadResult;
  publicMediaCDNInitiateUpload: Scalars['String']['output'];
  publicMediaCDNUploadChunk: Scalars['Boolean']['output'];
  publicSiteTrackerMediaCompleteUpload: MediaCdnUploadResult;
  publicSiteTrackerMediaInitiateUpload: Scalars['String']['output'];
  publicSiteTrackerMediaUploadChunk: Scalars['Boolean']['output'];
  publicSubmitBankTransferPayment: Scalars['Boolean']['output'];
  publishArtifactVersion: Artifact;
  publishBlogPost?: Maybe<BlogPost>;
  publishCompanyKnowledgeArticle: CompanyKnowledge;
  publishPolicy: Policy;
  publishSEOMetadata: SeoMetadata;
  publishShift?: Maybe<Shift>;
  publishSopEpisode?: Maybe<SopEpisode>;
  publishVlogPost?: Maybe<VlogPost>;
  purchasePhoneNumber: TwilioPhoneNumber;
  pushCalculatorSubmissionToGHL: CrmSyncResult;
  /** Cross-tenant hand-over: snapshot a SUITABLE candidate's vetting record + document CIDs into an EmployeeRecommendation on the employer tenant and move the candidate to PUT_FORWARD. Refused unless the company is linked to that tenant AND the employer lists this tenant as an active recruitment partner. Already PUT_FORWARD → the snapshot is refreshed. */
  putForwardCandidate: CandidatePutForwardResult;
  /** Create common email aliases for a launched site */
  quickEmailSetup: QuickEmailResult;
  raiseFeedbackOutcome: FeedbackItem;
  raiseSopCommentToAgenda?: Maybe<SopAgendaItem>;
  rateTomMessage: Scalars['Boolean']['output'];
  reactivateMedication: Medication;
  reactivateUnit: UnitConfig;
  readmitResident: AdmissionResult;
  rebuildPolicyChatIndex: PolicyChatIndexStats;
  recheckModuleDeploy: Scalars['String']['output'];
  /** @deprecated Retired 6 Oct 2026 — leave balances come from the shifts module (employeeLeaveBalances). */
  reconcileLeaveBalances: Scalars['String']['output'];
  reconcileModuleConfig: Tenant;
  reconcileSarahCareWeightKeys: SarahWeightKeyResult;
  recordAbsence?: Maybe<Shift>;
  recordAdministration: MedicationAdministration;
  recordAiAuditDecision: AiPayAudit;
  /** Admin: record gold or bitcoin bought or sold (what you did at the dealer — nothing is traded here) */
  recordBankingHolding: BankingHolding;
  /** Admin: this money was borrowed from a person. Issues them a BB Token for the same dollars. */
  recordBankingLoanDrawdown: BankingLoanWrite;
  /** Admin: this money paid a loan back. Settles the lender's IOU tokens oldest first. */
  recordBankingLoanRepayment: BankingLoanWrite;
  /** Admin: enter a price by hand for a day (stored as MANUAL, overwriting that day's row) */
  recordBankingPrice: BankingPrice;
  recordBondPayment?: Maybe<Bond>;
  recordCIMeetingMinutes?: Maybe<CiGovernanceMeeting>;
  /** Record that a copy or summary of this plan was given to someone */
  recordCarePlanCopyGiven: CarePlan;
  recordChecklistGridEntry?: Maybe<AdmissionChecklist>;
  recordCompetitionPrintPayout: CompetitionPrintPayout;
  /** Record that the logged-in employee viewed an onboarding form/document (activity-log audit; coalesced per form per day). */
  recordEmployeeFormViewed: Scalars['Boolean']['output'];
  recordGovExecution?: Maybe<GovDecision>;
  recordGovMovement: GovTreasuryMovement;
  recordHostingCommissionPayment: HostingCommissionPayment;
  recordIncidentCarePlanCheck: Incident;
  recordIncomingDeliveryTemperature: IncomingDeliveryTemperature;
  recordInterventionCompletion?: Maybe<CarePlan>;
  recordMySiteEditCommand: EditCommandResult;
  recordPRNEffectiveness: PrnAdministration;
  /** Record a reference taken over the phone */
  recordPhoneReference: CandidateReference;
  recordRespiteCheckIn?: Maybe<RespiteBooking>;
  recordReturn: ResidentLeave;
  /** Record or update a resident's choice with risk on this risk assessment */
  recordRiskChoice: ResidentRiskAssessment;
  recordS8Transaction: S8Register;
  recordSuitabilityAssessment?: Maybe<WaitingListEntry>;
  recordTemperature: TemperatureLog;
  recordTestResult: ModuleTestResult;
  recordTrustActivity: TrustActivity;
  recordWaitingListTourDone: WaitingListEntry;
  recordWaitingListTourFeedback: WaitingListEntry;
  recordWaitingListTourNotPossible: WaitingListEntry;
  recoverMeetRecording: Meeting;
  redeemRewardToken: RewardToken;
  redeemTokensForBill: TokenRedemptionResult;
  /** Admin: ask Redbark for the current connections and accounts again (new ones arrive disabled with no viewers; existing settings are kept). Returns every account. */
  rediscoverBankingAccounts: Array<BankingAccount>;
  refineBroadcastContent: BroadcastDraft;
  refineCandidateMessage: CandidateMessage;
  refineChaseEmailDraft?: Maybe<ClientChaseLog>;
  refineChaseSmsDraft?: Maybe<ClientChaseLog>;
  refineEmailReplyDraft: EmailReplyDraftOutput;
  refineGeneratedTask: GeneratedTaskPreview;
  refineSiteSpec: SiteSpecResult;
  /** Re-check /v2/me and connections: plan, scopes, consent; raises FEED_HEALTH when something is wrong */
  refreshBankingFeedHealth: BankingSettingsView;
  /** Admin: fetch today's gold, bitcoin and AUD/USD prices now and store them (writes today's price rows) */
  refreshBankingPrices: BankingPriceCapture;
  refreshIpfsNodeStats: Array<IpfsNode>;
  refreshMySmsBalance: MySmsBalance;
  regeneratePublicAccessToken?: Maybe<MechanicJob>;
  regenerateRecoveryCodes: RecoveryCodesResult;
  regenerateRollup: Rollup;
  /** Create the Redbark webhook destination + sync + event destination (needs the write scopes; names the missing ones otherwise) */
  registerBankingWebhook: BankingSettingsView;
  registerDomain: RegisteredDomain;
  registerForEvent: EventRegistrationResponse;
  registerIpfsNode: IpfsNode;
  registerP2Interest: P2Interest;
  registerValidator: CustodyValidator;
  registerWithVerifiedEmail?: Maybe<AuthResponse>;
  registerWithVerifiedPhone?: Maybe<AuthResponse>;
  reharvestSource: HarvestSource;
  rejectCandidate: Candidate;
  rejectDigitalManagerProposal: DigitalManagerOutstandingQuestion;
  rejectShiftPickup: Shift;
  rejectSiteUpdate?: Maybe<SiteUpdate>;
  rejectTomAction: Scalars['Boolean']['output'];
  releaseEmpowermentReflections: EmpowermentCheckIn;
  releaseGovWorkClaim: Scalars['Boolean']['output'];
  releasePhoneNumber: Scalars['Boolean']['output'];
  releaseSmsHeldReply: SmsHeldRepliesResult;
  releaseStuckVideos: Scalars['Int']['output'];
  removeBlockedDate: BusinessCalendarAvailability;
  removeCIAgendaItem?: Maybe<CiGovernanceMeeting>;
  removeCalendarEventTaskChecklistItem: CalendarEventTask;
  removeChaseRecipient?: Maybe<ClientChaseConfig>;
  removeClientPermission?: Maybe<Client>;
  removeClientTag?: Maybe<Client>;
  removeCommunityMember: Scalars['Boolean']['output'];
  removeDailyCareCalendarEvents: Scalars['Int']['output'];
  removeDigitalManagerFromOrgChart: Scalars['Boolean']['output'];
  removeDomain: Scalars['Boolean']['output'];
  removeDomainDnsRecord: Scalars['Boolean']['output'];
  removeEmployeeFromCompany?: Maybe<Company>;
  removeEmployeeFromOrgChart: OrgChartRemoveReport;
  removeEmployeeFromShift?: Maybe<Shift>;
  removeFromWaitingList?: Maybe<WaitingListEntry>;
  removeGithubCollaborator: Scalars['Boolean']['output'];
  removeGoal?: Maybe<CarePlan>;
  removeGoalCheckpoint: CalendarGoal;
  removeGovChecklist: Scalars['Boolean']['output'];
  removeInboundEmailLabel: InboundEmail;
  removeIntervention?: Maybe<CarePlan>;
  removeKitchenMember: Kitchen;
  removeLabelFromInboundEmail: InboundEmail;
  removeLaunchSiteDomain: Scalars['Boolean']['output'];
  removeMilestone?: Maybe<CarePlan>;
  removeOpportunityMember: Scalars['Boolean']['output'];
  removePlacementFromOrgChart: OrgChartRemoveReport;
  removeQueuedModuleUpgrade: Scalars['Boolean']['output'];
  removeRecipeIngredient: Scalars['Boolean']['output'];
  removeWitness: Scalars['Boolean']['output'];
  renameMeetVoiceSignature: MeetVoiceSignature;
  renamePasskey: WebAuthnCredential;
  renameVoiceSignature: VoiceSignature;
  renewDomain: Domain;
  renewEmployeeInvite: EmployeeInvite;
  reopenArtifactComment: ArtifactComment;
  /** Admin: reopen a job (clears done, landed and the linked transaction) */
  reopenBankingMonthJob: BankingMonthJob;
  reopenIncident: Incident;
  reorderActions: Array<GoalAction>;
  /** Admin: save your own order for the month's open jobs. From then on the page shows 'your order' until Reset. */
  reorderBankingMonthJobs: BankingMonthJobsPage;
  reorderBookableEventTypes: Scalars['Boolean']['output'];
  reorderChecklist?: Maybe<MechanicJob>;
  reorderCommunicationTasks: Array<CommunicationTask>;
  reorderCustomQuestions: Scalars['Boolean']['output'];
  reorderDigitalManagerRules: Array<DigitalManagerRule>;
  reorderEmailAiRules: Array<EmailAiRule>;
  reorderEmployeeAmongSiblings: Scalars['Boolean']['output'];
  reorderLeadFlowStages: Scalars['Boolean']['output'];
  reorderMaintenanceChecklist?: Maybe<MaintenanceRequest>;
  reorderMealPlans: Array<MealPlan>;
  reorderP2CampaignMessages: Array<P2CampaignMessage>;
  reorderSubscriptionProducts: Scalars['Boolean']['output'];
  replaceEmployeeOnShift?: Maybe<Shift>;
  /** Reply on an enquiry — the person who raised it, or payroll */
  replyToPayrollEnquiry: PayrollEnquiryWriteResult;
  /** Upserts a runner's slot snapshot and changed jobs; returns how many jobs were written. */
  reportAgentBoard: Scalars['Int']['output'];
  reportClub52Issue: Scalars['Boolean']['output'];
  reportMealCalendarIssue: Scalars['String']['output'];
  reportStalledRosterBulkOp?: Maybe<RosterBulkOpLog>;
  reputGovProposal?: Maybe<GovProposal>;
  requestArtSession: ArtSessionRequestResult;
  /** Lender: ask for an IOU back in dollars. Puts 'Pay back <you>' on the admin's month; landing it settles the token. */
  requestBankingIouPayout: BankingPayoutRequest;
  requestEmailChange: Scalars['Boolean']['output'];
  requestEmailLoginLink: EmailLoginLinkRequestResult;
  requestEmailSignupPhoneCode: EmailLoginLinkRequestResult;
  requestMedicalRecordAccess: MedicalRecordAccessRequestResult;
  requestPProposalEmailVerification: Scalars['String']['output'];
  requestPasswordReset: Scalars['Boolean']['output'];
  requestPhoneChange: Scalars['Boolean']['output'];
  requestProposalEmailVerification: Scalars['String']['output'];
  /** Create a reference request. method EMAIL also emails the referee their personal link; LINK returns it for you to send; PHONE records that you will ring them. */
  requestReference: RequestReferenceResult;
  /** Ask for my payable rewards to be paid to my bank. Puts 'Pay <me>' on the admin's banking month; nothing moves money. */
  requestRewardPayout: RewardPayoutRequestResult;
  requestShiftSwap: ShiftSwapRequest;
  requestSmsLoginLink: SmsLoginLinkRequestResult;
  requestSmsNumber: SmsNumberRequest;
  requestSponsoredSeparationAccess: Scalars['Boolean']['output'];
  requestWalletLinkNonce: WalletLinkChallenge;
  requestWalletUnlock: WalletUnlockRequestResult;
  rescanModuleDrift: ModuleUpgradeRescan;
  rescheduleClub52Game: Club52Game;
  reschedulePublicBooking: PublicBookingResult;
  resendCommunityInvite: CommunityInvite;
  resendGovInvite: GovInvite;
  resendProgramInvite: Scalars['Boolean']['output'];
  resendVisionBoardInvite: VisionBoardInvite;
  resetAlertConfigToDefaults: Scalars['Boolean']['output'];
  resetAssignment?: Maybe<Shift>;
  /** Admin: back to due day then A–Z */
  resetBankingMonthJobOrder: BankingMonthJobsPage;
  resetBdayRsvp?: Maybe<BdayGuest>;
  /** Remove the tenant's copy: a built-in row goes back to the standard wording; a tenant-only row is removed */
  resetCareLegalRequirement: Scalars['Boolean']['output'];
  resetClientCredentials: OnboardClientResult;
  resetDailyCareHeadings: Scalars['Boolean']['output'];
  resetPassword: Scalars['Boolean']['output'];
  resetPaymentEvent: Scalars['Boolean']['output'];
  resolveArtifactComment: ArtifactComment;
  resolveCIIssueReport?: Maybe<CiIssueReport>;
  resolveDigitalManagerChase: DigitalManagerChaseItem;
  resolveDuplicate: Scalars['Boolean']['output'];
  resolveFeedback?: Maybe<MealFeedback>;
  resolveFeedbackItem: FeedbackResolveResult;
  resolveOrphanedAssignment: Scalars['Boolean']['output'];
  respondToEvent: CalendarEvent;
  restoreDeletedEmail: Email;
  restorePolicy: Policy;
  restoreWaitingListEntry: WaitingListEntry;
  resumeDigitalManager: DigitalManager;
  resumeEmailLinkSignup?: Maybe<EmailLoginLinkResult>;
  resumeModuleUpgradeService: ModuleUpgradeServiceStatus;
  resumeSubscription: BillingSubscription;
  retireDigitalManager: DigitalManager;
  retireGovJobSpec: Scalars['Boolean']['output'];
  /** Withdraw a comment (your own, or any as a banking admin). The row stays; its body stops being served. */
  retractBankingTransactionComment: BankingTransactionComment;
  /** Retract a comment (own, or an admin). Body is nulled; the row stays as provenance. */
  retractEmployeeActivityComment: Scalars['Boolean']['output'];
  retractGovActivityComment: Scalars['Boolean']['output'];
  retryFailedIngests: Scalars['Int']['output'];
  retryInvoiceExtraction: FoodInvoice;
  retryMeetTranscription: Meeting;
  retryRecipeCapture: ShelvCaptureJob;
  retryTranscription: Transcription;
  retryVideoIngest: HarvestedVideo;
  retryVideoTranscript: HarvestedVideo;
  revertPayRunToDraft: PayRun;
  revertToWaitingList: AdmissionResult;
  reviewCIInitiative?: Maybe<CiImprovementInitiative>;
  reviewEmpowermentGoal: EmpowermentGoal;
  reviewGovProof?: Maybe<GovWorkProof>;
  reviseEmpowermentQuestion: EmpowermentQuestion;
  reviseGovJobSpec: GovJobSpec;
  revokeDroneSessionSharing: Scalars['Boolean']['output'];
  revokeEmailLoginLinks: Scalars['Int']['output'];
  revokeGovInvite: Scalars['Boolean']['output'];
  revokeHostingAccessLinks: Scalars['Boolean']['output'];
  revokeMedicalAccess: Scalars['Boolean']['output'];
  revokeMySession: RevokedSignInSession;
  revokeSeparationAccessLinks: Scalars['Int']['output'];
  revokeSiteOwnerLinks: Scalars['Boolean']['output'];
  revokeVisionBoardShare: Scalars['Boolean']['output'];
  revokeWalletKey: Scalars['Boolean']['output'];
  /** Admin: move the month's OPEN jobs to the next month (done ones stay) */
  rolloverBankingMonthJobs: BankingRolloverResult;
  rolloverIncompleteGoals: Array<CalendarGoal>;
  rotateArtifactShareToken: Scalars['String']['output'];
  rsvpClub52Game: PublicClub52GameInfo;
  runAiPayAudit: AiPayAudit;
  runDigitalManagerNow: DigitalManagerSession;
  runDigitalManagerStandupNow: DigitalManagerStandup;
  runEmailAiRuleNow: RunEmailAiRuleNowResult;
  runEmailHealthAddressProbes: Array<EmailHealthProbe>;
  runEmailHealthProbe: EmailHealthProbe;
  runEmpowermentReconcile: EmpowermentReconcileSummary;
  runLeadFlowSequences: LeadFlowSequenceRunResult;
  /** @deprecated Retired 6 Oct 2026 — leave balances come from the shifts module (employeeLeaveBalances). */
  runLeaveAccrualNow: Scalars['String']['output'];
  runModuleDoctor: ModuleUpgradeQueueJob;
  s8Discrepancy: S8Register;
  /** Accounting admin: save the Xero app's Client ID (and secret — never returned). Writes the module's own settings. */
  saveAccountingXeroApp: AccountingSettingsView;
  /** Start or update the resident's advance care plan; every save adds a history line */
  saveAdvanceCarePlan: AdvanceCarePlan;
  /** Admin: replace the category list. Saved A–Z; an empty list goes back to the defaults. */
  saveBusinessDirectoryCategories: Array<Scalars['String']['output']>;
  saveCapturedRecipe: Scalars['ID']['output'];
  /** Save the tenant's own wording of a requirement */
  saveCareLegalRequirement: CareLegalRequirement;
  saveCrazytelSettings: CrazytelSetupStatus;
  saveCustomAnswers: Scalars['Boolean']['output'];
  saveEmpowermentReflection: EmpowermentReflection;
  /** Save ImprovMX config to tenant record only (no ImprovMX API call). Use when ImprovMX is already set up. */
  saveImprovMXConfigToTenant: BackfillConfigResult;
  /** Create or update the signed-in member's own listing. Free. */
  saveMyBusinessListing: BusinessListing;
  saveMyQuickLinks?: Maybe<ClientPreferences>;
  savePhoneLine: PhoneLine;
  savePolicyDraft: Policy;
  saveSeparationCovenantAnswer: SeparationCovenantAnswer;
  saveSovereigntyJourney: SovereigntyJourney;
  saveVoiceContact: VoiceContact;
  saveWalletContact: WalletContact;
  scanEmailAndGenerateProjectProposal: ProjectProposal;
  scheduleCandidateInterview: ScheduleInterviewResult;
  scheduleCandidateMessage: CandidateMessage;
  scheduleCarePlanReview: CarePlanReview;
  scheduleChaseDelivery: ClientChaseLog;
  scheduleIntervention?: Maybe<CarePlan>;
  scheduleProgramCall: ProgramCallNote;
  searchPersonEvents: SearchPersonEventsResultGql;
  seedCareHouseRooms: Array<Location>;
  seedCarePlanRoles: Array<Scalars['ID']['output']>;
  seedDefaultAssessmentDomains: Array<AssessmentDomain>;
  seedDefaultLifeAspects: Array<LifeAspect>;
  seedPublicHolidays: Scalars['Int']['output'];
  seedShiftTemplates: Scalars['Int']['output'];
  seedStationsFromOverpass: SeedResult;
  seedTestDefinitions: Scalars['Boolean']['output'];
  selfAssignToShift?: Maybe<Shift>;
  sendBdayEveReminderSms?: Maybe<BdayGuest>;
  sendBdayFollowUpSms?: Maybe<BdayGuest>;
  sendBdayInviteSms?: Maybe<BdayGuest>;
  sendBookingReminder: Scalars['Boolean']['output'];
  sendBulkSms: Scalars['Boolean']['output'];
  /** Public: send the enquiry the chat agent prepared (channel AGENT). Same delivery path as the form. */
  sendBusinessChatEnquiry: BusinessEnquiryReceipt;
  /** Public: one turn with the directory's 'Talk to my agent' helper. Omit sessionToken to start. */
  sendBusinessChatMessage: BusinessChatReply;
  sendCandidateMessageNow: CandidateMessage;
  sendChaseSms?: Maybe<ClientChaseLog>;
  sendChaseSuggestion?: Maybe<ClientChaseLog>;
  sendChatMessage: ChatMessage;
  sendClub52Message: SendClub52MessageResult;
  sendCommsSummaryNow: CommsSummarySendView;
  sendCommunityCampaignTest: CommunityCampaignTestResult;
  sendCommunityDailyEmailNow: CommunityDailyEmailScheduleResult;
  sendCommunityDailyReminderNow: CommunityReminderScheduleResult;
  sendCommunityLapsedNudgeNow: CommunityReminderScheduleResult;
  sendCommunityLapsedNudgeToOneMember: Scalars['Boolean']['output'];
  sendCommunityLeaderboardEmailNow: CommunityReminderScheduleResult;
  sendCommunityReminderToOneMember: Scalars['Boolean']['output'];
  sendCommunityWeeklyEmailNow: CommunityDailyEmailScheduleResult;
  sendCompetitionNotification: CompetitionNotificationReport;
  sendContactInvite: ResidentContact;
  sendEmail: Email;
  sendEmailCode: Scalars['Boolean']['output'];
  /** Manually send an onboarding chase email listing outstanding sections/forms (no cron — page-driven per platform rule). */
  sendEmployeeInviteReminder: EmployeeInvite;
  /** Send an SMS/email message to an employee */
  sendEmployeeMessage: Scalars['Boolean']['output'];
  /** Email an EXISTING employee their outstanding onboarding items (profile fields + unsigned forms). Work email preferred, personal email fallback. */
  sendEmployeeOnboardingReminder: EmployeeOnboardingProgress;
  sendEmpowermentReminder: EmpowermentSendResult;
  sendEventReminders: Scalars['Int']['output'];
  sendGovDueReports: GovDigestRunResult;
  sendGovMembershipReminders: GovMembershipBatchResult;
  sendLeadFlowAction: LeadFlowActionLog;
  sendLeadFlowActionToMany: BulkSendResult;
  sendLocalAiQuery: LocalAiQuery;
  sendMeetRecordingTranscript: Scalars['Boolean']['output'];
  sendMeetingMessage: SendMeetingMessageResult;
  /** Send the caller a sample digest for a cadence right now (no claim is written). Returns what each channel did. */
  sendMyBankingDigestNow: Array<BankingNotificationOutcome>;
  sendMySiteEditCommand: EditCommandResult;
  sendP2Action: P2ActionLog;
  sendP2CampaignMessage: P2SendResult;
  sendP2QuickMessage: P2SendResult;
  sendPProposal: PProposal;
  sendPolicyBroadcast: PolicyNotification;
  sendProgramReminderEmail: Scalars['Boolean']['output'];
  sendProposal: Proposal;
  sendRSVPResponse: RsvpResponse;
  sendSeparationInviteChase: SeparationInvite;
  sendSingleMotivationMessage: GrowthEngineCommunication;
  sendSiteEditCommand: EditCommandResult;
  sendSms: Scalars['Boolean']['output'];
  sendSmsBroadcast: SmsBroadcastResult;
  sendSmsCode: Scalars['Boolean']['output'];
  sendStepUpCode: Scalars['Boolean']['output'];
  sendTestBillsEmail: Scalars['Boolean']['output'];
  sendTestBookingUrl: Scalars['Boolean']['output'];
  sendTestEmail: EmailResponse;
  sendTestEmailWithTenant: EmailResponse;
  sendTestLeadFlowEmail: Scalars['Boolean']['output'];
  sendTestMechanicNotification: Scalars['String']['output'];
  sendTestRewardsEmail: Scalars['Boolean']['output'];
  sendTestSms: Scalars['Boolean']['output'];
  sendTomMessage: TomMessageResponse;
  sendUpdatedEventInvite: CalendarEvent;
  sendWaitingListFamilyMessage: WaitingListFamilyMessageResult;
  sendWaitingListTourMessage: Array<WaitingListMessageOutcome>;
  /** Admin: replace the grant list for one account. Newly added people are told. */
  setBankingAccountViewers: BankingAccount;
  /** Admin: say what a transaction is (e.g. an ATM withdrawal = a move to my Cash wallet). null = the income rules decide. */
  setBankingTransactionShape: BankingTransaction;
  setBillCompany: Bill;
  /** Set one bill's payment terms and/or due date. paymentTerms: words = this bill's own terms; "" = use the billing settings again. dueDate: YYYY-MM-DD = due that day; "" = no date of its own. Omit a field to leave it. */
  setBillTerms: Bill;
  setBillToCompany: Bill;
  /** Mark an enquiry replied / closed (or back to sent). A directory admin, or the listing's owner. */
  setBusinessEnquiryStatus: BusinessEnquiry;
  /** Partial merge into candidate.credentials. Only the fields you send change. */
  setCandidateCredential: Candidate;
  /** @deprecated Use setCandidateCredential(id, { policeCheck: { cid } }). */
  setCandidatePoliceCheck: Candidate;
  /** Replace the list of people who took part in writing this plan */
  setCarePlanParticipants: CarePlan;
  setChaseDraftSendAs?: Maybe<ClientChaseLog>;
  /** Switch sign-in off (MANUAL block) or back on for a client account. Cannot lift an EMPLOYEE_TERMINATED block, cannot block the tenant owner or a master admin. */
  setClientLoginBlock?: Maybe<Client>;
  setClientPermissions?: Maybe<Client>;
  setClientTags?: Maybe<Client>;
  setCompetitionEntryStatus: CompetitionEntry;
  setCompetitionStatus: CompetitionStatusChangeResult;
  setDefaultPaymentMethod: Scalars['Boolean']['output'];
  setDigitalManagerNotificationRuleEnabled: DigitalManagerNotificationRule;
  setDigitalManagerReportsTo: Scalars['Boolean']['output'];
  setDigitalManagerRuleEnabled: DigitalManagerRule;
  setDroneSessionPassword?: Maybe<DroneSession>;
  setEmailAiRuleEnabled: EmailAiRule;
  /** Tick/untick an item. Ticking writes a CHECKLIST_ITEM_DONE feed entry and bumps the checklist to the top. */
  setEmployeeChecklistItemDone: EmployeeChecklistItem;
  /** Publish/hide a template for others. Module-admin action (edit permission). */
  setEmployeeChecklistVisibility: EmployeeChecklist;
  /** Turn one form's signing prompt on/off for an employee (per-employee, per-form; nothing is prompted by default). Returns the refreshed checklist. */
  setEmployeeFormsPrompt: EmployeeOnboardingProgress;
  setEmpowermentGoalStep: EmpowermentGoal;
  setEmpowermentJourneyStatus: EmpowermentJourney;
  setEmpowermentQuestionActive: EmpowermentQuestion;
  setGovAccountBalance?: Maybe<GovTreasuryAccount>;
  setGovChecklistItemDone?: Maybe<GovChecklistItem>;
  setGovChecklistVisibility?: Maybe<GovChecklist>;
  setGovDelegate: GovParticipation;
  setGovOrganisationLinkTeaserLevel?: Maybe<GovOrganisation>;
  setGovOrganisationLinkTeasers?: Maybe<GovOrganisation>;
  setGovOrganisationPublicPage?: Maybe<GovOrganisation>;
  setMainCalendar: CalendarUserPreference;
  setModuleUpgradeServiceConcurrency: ModuleUpgradeServiceStatus;
  /** The owner's own show/hide switch. Cannot undo an admin hide. */
  setMyBusinessListingPublished: BusinessListing;
  /** Save the bank account my rewards are paid to (two-step verification required) */
  setMyRewardPayoutBankDetails: RewardPayoutBankDetailsView;
  setOrgChartDesignatedRoot: OrgChartConfig;
  setOrgChartDesignatedRootPlacement: OrgChartConfig;
  setPassword: Scalars['Boolean']['output'];
  /** Payroll moves an enquiry to another status without writing a reply */
  setPayrollEnquiryStatus: PayrollEnquiryWriteResult;
  setPhoneLineActive: PhoneLine;
  setPrimaryIpfsNode: IpfsNode;
  /** Site admins: require two-step verification for sensitive data on this site. Needs your own fresh two-step verification. */
  setRequireTwoFactorForSensitiveData: TenantSecuritySettings;
  setSeparationJourneyStep: SeparationJourneyProgress;
  setSourceContent: HarvestSource;
  setSourceLimits: HarvestSource;
  setSourceMaxVideos: HarvestSource;
  setSourceQuality: HarvestSource;
  setSourceWatch: HarvestSource;
  setTenantIpfsNode: Scalars['Boolean']['output'];
  setUpTenantEmail: TenantEmailSetupResult;
  setVoipCallFlag: VoipCall;
  setWaitingListResponsible: WaitingListResponsibleResult;
  setWalletDiscoverable: Scalars['Boolean']['output'];
  /** Setup call forwarding for a phone number */
  setupCallForwarding: TwilioPhoneNumber;
  setupDomainWithVercel: DomainHealthStatus;
  setupTenantIpfsSubdomain: TenantIpfsHealth;
  shareCalendar: CalendarInvitation;
  shareCalendarWithAudience: BusinessCalendar;
  shareCalendarWithAudiences: BusinessCalendar;
  shareCalendarWithClients: BusinessCalendar;
  shareMyVisionBoard: Array<VisionBoardShareResult>;
  sharePassword: Password;
  shelvAddMealServicePhotos?: Maybe<ShelvMealPlan>;
  shelvAddRecipeIngredient: ShelvRecipeIngredient;
  shelvBulkCreateMealPlans: Array<ShelvMealPlan>;
  shelvBulkImportIngredients: Array<ShelvIngredient>;
  shelvBulkReplaceRecipeIngredients: ShelvBulkReplaceRecipeIngredientsResult;
  shelvBulkUpsertIngredients: ShelvBulkUpsertResult;
  shelvCancelOrder?: Maybe<ShelvSupplierOrder>;
  shelvClearMealPlanDateRange: Scalars['Int']['output'];
  shelvClearMealPlanDay: Scalars['Int']['output'];
  shelvConfirmGeneratedMealPlan: Array<ShelvMealPlan>;
  shelvConfirmInvoice: ShelvFoodInvoice;
  shelvConfirmOrder?: Maybe<ShelvSupplierOrder>;
  shelvCopyMealPlanDateRange: Array<ShelvMealPlan>;
  shelvCopyMealPlanWeek: Array<ShelvMealPlan>;
  shelvCreateIngredient: ShelvIngredient;
  shelvCreateMealFeedback: ShelvMealFeedback;
  shelvCreateMealPlan: ShelvMealPlan;
  shelvCreateMealPlanNotificationRule: ShelvMealPlanNotificationRule;
  shelvCreateOrderWithItems: ShelvSupplierOrder;
  shelvCreateQuickSplitInvoice: ShelvFoodInvoice;
  shelvCreateRecipe: ShelvRecipe;
  shelvCreateRecipeWithIngredients: ShelvRecipe;
  shelvCreateSupplier: ShelvSupplier;
  shelvCreateSupplierOrder: ShelvSupplierOrder;
  shelvDeactivateUnit: ShelvUnitRetireResult;
  shelvDeleteIngredient: Scalars['Boolean']['output'];
  shelvDeleteInvoice: Scalars['Boolean']['output'];
  shelvDeleteMealFeedback: Scalars['Boolean']['output'];
  shelvDeleteMealPlan: Scalars['Boolean']['output'];
  shelvDeleteMealPlanNotificationRule?: Maybe<ShelvMealPlanNotificationRule>;
  shelvDeleteRecipe: Scalars['Boolean']['output'];
  shelvDeleteSupplier: Scalars['Boolean']['output'];
  shelvDeleteSupplierOrder: Scalars['Boolean']['output'];
  shelvDiscardInvoice: ShelvFoodInvoice;
  shelvDuplicateRecipe: ShelvRecipe;
  shelvForkRecipe: ShelvRecipe;
  shelvGenerateMealPlanAI: ShelvGeneratedMealPlanResult;
  shelvGenerateOrdersFromMealPlans: Array<ShelvGeneratedOrder>;
  shelvLinkInvoiceToOrder: ShelvFoodInvoice;
  shelvMapInvoiceLineToIngredient: ShelvFoodInvoice;
  shelvMarkAllMealPlanNotificationsRead: Scalars['Int']['output'];
  shelvMarkCooked: ShelvMarkCookedResult;
  shelvMarkMealPlanNotificationRead?: Maybe<ShelvMealPlanInAppNotification>;
  shelvMarkOrderDelivered?: Maybe<ShelvSupplierOrder>;
  shelvPermanentlyDeleteRecipe: Scalars['Boolean']['output'];
  shelvPublicMealMediaCompleteUpload: MediaCdnUploadResult;
  shelvPublicMealMediaInitiateUpload: Scalars['String']['output'];
  shelvPublicMealMediaUploadChunk: Scalars['Boolean']['output'];
  shelvReactivateUnit: ShelvUnitConfig;
  shelvRemoveRecipeIngredient: Scalars['Boolean']['output'];
  shelvReorderMealPlans: Array<ShelvMealPlan>;
  shelvReportMealCalendarIssue: Scalars['String']['output'];
  shelvResolveFeedback?: Maybe<ShelvMealFeedback>;
  shelvRetryInvoiceExtraction: ShelvFoodInvoice;
  shelvRollUpInferredTags: Scalars['Int']['output'];
  shelvShareRecipe: ShelvShareRecipeResult;
  shelvSubmitOrder?: Maybe<ShelvSupplierOrder>;
  shelvSubmitPublicMealFeedback: ShelvMealFeedback;
  shelvToggleMealPlanAllEventsSubscription: Scalars['Boolean']['output'];
  shelvToggleMealPlanNotificationRule?: Maybe<ShelvMealPlanNotificationRule>;
  shelvToggleRecipeActive?: Maybe<ShelvRecipe>;
  shelvUpdateFoodBudget: ShelvFoodBudget;
  shelvUpdateIngredient?: Maybe<ShelvUpdateIngredientResult>;
  shelvUpdateMealFeedback?: Maybe<ShelvMealFeedback>;
  shelvUpdateMealPlan?: Maybe<ShelvMealPlan>;
  shelvUpdateMealPlanNotificationRule?: Maybe<ShelvMealPlanNotificationRule>;
  shelvUpdateMealPlanningSettings: ShelvSettings;
  shelvUpdateRecipe?: Maybe<ShelvRecipe>;
  shelvUpdateRecipeIngredient?: Maybe<ShelvUpdateRecipeIngredientResult>;
  shelvUpdateSupplier?: Maybe<ShelvSupplier>;
  shelvUpdateSupplierOrder?: Maybe<ShelvSupplierOrder>;
  shelvUploadInvoice: ShelvFoodInvoice;
  /** Contract-first onboarding: the invitee signs the contract from the invite link. Single-use; refused once signed, expired or completed. Unlocks the details form. Creates no account and no session. */
  signInviteContract: PublicEmployeeInviteContract;
  /** Sign an onboarding form as the logged-in employee. Snapshot is server-derived and locked. */
  signMyEmployeeForm: EmployeeSignedForm;
  signOffDayBook: DayBookSignOff;
  signOffProgressNote: ProgressNote;
  signOutEverywhere: SessionsRevokedResult;
  signPProposal: PProposalSignature;
  signProgramAgreement: ProgramSignedAgreement;
  signProposal: ProposalSignature;
  signupP2BuyerWithEmailCode: P2BuyerSignupResponse;
  signupWithUsername?: Maybe<AuthResponse>;
  skipChaseSuggestion?: Maybe<ClientChaseLog>;
  skipEmpowermentCheckIn: EmpowermentCheckIn;
  smsLoginBrowserApproval?: Maybe<Scalars['String']['output']>;
  snoozeProactiveChaser: EmailAiProactiveSettings;
  sponsorGovApplication?: Maybe<GovMembershipApplication>;
  starInboundEmail: InboundEmail;
  startAction?: Maybe<GoalAction>;
  startCandidateChat: CandidateChatInviteResult;
  startGovJobSpecInstance: GovWorkItem;
  startInboxBacklogJob: EmailBacklogJob;
  startRecipeCapture: ShelvCaptureJob;
  startReview?: Maybe<CarePlanReview>;
  startRound: MedicationRound;
  startShift?: Maybe<Shift>;
  /** Claim the Studio for a voice-agent call. While held, every other model call is refused with a voice-call message. One at a time. */
  startVoiceLease: VoiceLeaseTicket;
  stepUpPasskeyOptions: Scalars['String']['output'];
  stepUpWithCode: StepUpResult;
  stepUpWithPasskey: StepUpResult;
  stepUpWithPassword: StepUpResult;
  stepUpWithRecoveryCode: StepUpResult;
  submitACFIAssessment: AcfiAssessment;
  submitAlphaIdToCellcast: AcmaRegistration;
  submitBankTransferPayment: Scalars['Boolean']['output'];
  submitBdayRsvp?: Maybe<BdayGuest>;
  /** Public: 'Contact this business'. Saved, emailed to the business (or the admins when it has no email). Words only — no ids. */
  submitBusinessEnquiry: BusinessEnquiryReceipt;
  submitCalculator: CalculatorSubmission;
  submitCandidateFormViaSlug: CandidateFormSubmitResult;
  submitClub52WalletAddress: Scalars['Boolean']['output'];
  submitContactForm: ContactFormSubmission;
  submitEmployeeOnboarding: OnboardingResult;
  submitEmpowermentReflection: EmpowermentCheckIn;
  submitFeedbackItem: FeedbackItem;
  submitGovProof: GovWorkProof;
  submitGuaranteeClaim: SeparationGuaranteeClaim;
  submitLead: Lead;
  submitMyEmployeeIncident: EmployeeIncident;
  submitOrder?: Maybe<SupplierOrder>;
  /** A staff member raises a payroll enquiry about their own pay */
  submitPayrollEnquiry: PayrollEnquiryWriteResult;
  submitPledge: Pledge;
  submitProgramApplication: ProgramApplication;
  submitPublicFeedbackItem: PublicFeedbackReceipt;
  submitPublicInquiry: PublicInquiryResult;
  submitPublicMaintenanceRequest: MaintenanceRequest;
  submitPublicMealFeedback: MealFeedback;
  /** PUBLIC. One submission per token; refused after 30 days. */
  submitReferenceByToken: SubmitReferenceResult;
  /** Upload one scan record from the laptop scanner. Scanner sign-in only; returns what changed, never any finding. */
  submitSecurityScan: SecurityScanSubmitResult;
  submitShelvInviteFeedback: Scalars['Boolean']['output'];
  submitSiteUpdate: SiteUpdate;
  submitVisionBoardFeedback: Scalars['Boolean']['output'];
  submitWorkerTimeEntries: Scalars['Boolean']['output'];
  suggestClientGoal: Scalars['String']['output'];
  suspendValidator: CustodyValidator;
  sweepGovVoteReminders: GovVoteReminderSweepResult;
  /** Accounting: read new transactions from Redbark now for every switched-on feed account (optionally one entity's). Writes new rows; never changes a coding. */
  syncAccountingBankFeed: AccountingSyncResult;
  /** Sync call recordings from Twilio for all phone numbers */
  syncCallRecordings: Scalars['Int']['output'];
  /** Re-apply the terminated-staff sign-in policy to one employee and report the action taken. */
  syncEmployeeLoginAccess: EmployeeLoginAccessSyncResult;
  /** Sync ImprovMX aliases to database (create missing records) */
  syncImprovMXAliases: Scalars['Int']['output'];
  syncMailboxAccounts: Scalars['Int']['output'];
  syncSmsResponses: Scalars['Int']['output'];
  syncSopEpisodeRecording: SopRecordingSyncResult;
  syncTwilioNumbers: Array<TwilioPhoneNumber>;
  testAdmissionNotificationRule: Scalars['Boolean']['output'];
  testAiService: Scalars['String']['output'];
  /** Send a sample alert for this rule to the CALLER only, using the most recent matching transaction (or a synthetic one). Returns what each channel did. */
  testBankingAlertRule: Array<BankingNotificationOutcome>;
  testDigitalManagerNotificationRule: Scalars['Boolean']['output'];
  testShiftNotificationRule: Scalars['Boolean']['output'];
  testSmsNotificationRule: Scalars['Boolean']['output'];
  testTenantIpfsGateway: TenantIpfsGatewayTestResult;
  toggleAdmissionNotificationRule: AdmissionNotificationRule;
  toggleAnalyticsNotificationRule: AnalyticsNotificationRule;
  toggleAssessmentCustomField?: Maybe<AssessmentCustomField>;
  toggleAssessmentDomain?: Maybe<AssessmentDomain>;
  toggleAssessmentNotificationRule: AssessmentNotificationRule;
  toggleBillDraftStatus: Bill;
  toggleBillNotificationRule: BillNotificationRule;
  toggleBillPaymentStatus: Bill;
  toggleBlogNotificationRule?: Maybe<BlogNotificationRule>;
  toggleBookableEventTypeStatus: BusinessCalendarBookableEventType;
  toggleCIActionComplete?: Maybe<CiImprovementInitiative>;
  toggleCINotificationRule: CiNotificationRule;
  toggleCalendarEventTaskCompletion: CalendarEventTask;
  toggleClientNotificationRule: ClientNotificationRule;
  toggleCommunicationTaskStatus: CommunicationTask;
  toggleCommunityLike: CommunityLikeResult;
  toggleCompetitionHeart: CompetitionHeartResult;
  toggleContributingFactorActive: ContributingFactor;
  toggleEmployeeIncidentNotificationRule: EmployeeIncidentNotificationRule;
  toggleEmployeeNotificationRule: EmployeeNotificationRule;
  toggleEnergyTrackerNotificationRule: EnergyTrackerNotificationRule;
  toggleIncidentLocationActive: IncidentLocation;
  toggleIncidentTypeActive: IncidentType;
  toggleLeadFlowNotificationRule: LeadFlowNotificationRule;
  toggleLifeAspect?: Maybe<LifeAspect>;
  toggleMaintenanceAllEventsSubscription: Scalars['Boolean']['output'];
  toggleMaintenanceNotificationRule: MaintenanceNotificationRule;
  toggleMealPlanAllEventsSubscription: Scalars['Boolean']['output'];
  toggleMealPlanNotificationRule?: Maybe<MealPlanNotificationRule>;
  toggleP2NotificationRule: P2NotificationRule;
  togglePinCompanyKnowledgeArticle: CompanyKnowledge;
  toggleProspectingAllEventsSubscription: Scalars['Boolean']['output'];
  toggleRecipeActive?: Maybe<Recipe>;
  toggleShiftNotificationRule: ShiftNotificationRule;
  toggleSiteEditorSiteActive: SiteEditorSite;
  toggleSmsNotificationRule: SmsNotificationRule;
  toggleVaultInsightRule: VaultInsightRule;
  toggleVlogNotificationRule?: Maybe<VlogNotificationRule>;
  touchWalletContact: Scalars['Boolean']['output'];
  trackEvent: AnalyticsEvent;
  trackPageView: PageView;
  trackSeparationReferralClick: Scalars['Boolean']['output'];
  trackSopCtaClick: Scalars['Boolean']['output'];
  /** Public mutation: count a CTA button click on a published vlog */
  trackVlogCtaClick: Scalars['Boolean']['output'];
  /** Transcribe all recordings that haven't been transcribed yet */
  transcribeAllRecordings: Scalars['Int']['output'];
  transcribeAudio: Transcription;
  transcribeGovBrief: GovBriefTranscript;
  transcribeRecording: CallRecording;
  transcribeSopBrief: SopBriefTranscript;
  transcribeYouTubeVideo: HarvestedVideo;
  transferCalendarOwnership: BusinessCalendar;
  transferDomain: Domain;
  transferPhoneNumberToTenant: TwilioPhoneNumber;
  transferResident: AdmissionResult;
  triggerClientChase?: Maybe<ClientChaseLog>;
  triggerHostingDeploy: HostingDeployRun;
  triggerIngestion: IngestionRun;
  triggerRebuild: Scalars['Boolean']['output'];
  triggerTenantAutomation: TenantAutomationRun;
  unarchiveMultipleInboundEmails: Scalars['Int']['output'];
  unassignEmailFromClient: EmailAddress;
  unassignPhoneNumberFromClient: TwilioPhoneNumber;
  unfollowCompetition: MyCompetitionFollow;
  unfollowCompetitionByToken: CompetitionUnfollowResult;
  unlinkCIIssueFromInitiative?: Maybe<CiIssueReport>;
  unlinkCIIssueFromMeeting?: Maybe<CiIssueReport>;
  unlinkCommsSmsApp: CommsIsolationView;
  unlinkFeedbackOutcome: FeedbackItem;
  unlinkInitiativeFromMeeting?: Maybe<CiImprovementInitiative>;
  unlinkIssueFromInitiative?: Maybe<CiImprovementInitiative>;
  unlinkMaintenanceFromCI?: Maybe<MaintenanceRequest>;
  unlinkMaintenanceFromInitiative?: Maybe<CiImprovementInitiative>;
  unlockWalletKeystore: WalletKeystorePayload;
  unmarkBdayInviteSent?: Maybe<BdayGuest>;
  unmarkEmailAsSpam: Scalars['Boolean']['output'];
  unpinCalendar: CalendarUserPreference;
  unpublishCompanyKnowledgeArticle: CompanyKnowledge;
  unpublishSEOMetadata: SeoMetadata;
  unpublishShift?: Maybe<Shift>;
  unpublishSopEpisode?: Maybe<SopEpisode>;
  unregisterP2Interest: Scalars['Boolean']['output'];
  unshareCalendar: BusinessCalendar;
  unshareCalendarAudience: BusinessCalendar;
  updateACFIAssessment: AcfiAssessment;
  updateAccountabilityGoal?: Maybe<AccountabilityGoal>;
  updateAccountabilityGoalStatus?: Maybe<AccountabilityGoal>;
  /** Accounting: change a bank account (only the fields sent): name, purpose, entity, its chart account, feed on/off. */
  updateAccountingBankAccount: AccountingBankAccount;
  updateActivities?: Maybe<DailyCareProfile>;
  updateAdmissionChecklistTemplate?: Maybe<AdmissionChecklistTemplate>;
  updateAdmissionNotificationRule: AdmissionNotificationRule;
  updateAdmissionsSettings: AdmissionsSettings;
  updateAdvisoryBody: AdvisoryBody;
  updateAllergy: MedicationAllergy;
  updateAnalyticsNotificationRule: AnalyticsNotificationRule;
  updateArtSession: ArtSessionChangeResult;
  updateArtifactSharing: Artifact;
  updateAssessmentCustomField?: Maybe<AssessmentCustomField>;
  updateAssessmentDomain?: Maybe<AssessmentDomain>;
  updateAssessmentNotificationRule: AssessmentNotificationRule;
  updateAssessmentSnapshot?: Maybe<AssessmentSnapshot>;
  updateAssignmentDepartments?: Maybe<Shift>;
  updateAssignmentStatus?: Maybe<Shift>;
  updateAvailabilityStatus: Availability;
  updateAward: AwardEntity;
  updateAwardClassification?: Maybe<AwardClassification>;
  updateAwardRate: AwardRateTable;
  /** Admin: enable/disable, nickname, liability and position flags. Enabling/disabling updates the Redbark sync when one exists. */
  updateBankingAccount: BankingAccount;
  /** Admin: change a cash movement (day, amount, what it was) */
  updateBankingCashEntry: BankingCashWrite;
  /** Admin: set the month's knobs (tax rate, GST, save level, tax account, expected income). Creates the plan row when missing. */
  updateBankingMonthPlan: BankingMonthPlan;
  /** Poll on/off and backfill depth for this tenant */
  updateBankingSettings: BankingSettingsView;
  updateBdayGuest?: Maybe<BdayGuest>;
  updateBehavioral?: Maybe<DailyCareProfile>;
  updateBill: Bill;
  updateBillNotificationRule: BillNotificationRule;
  updateBillPaymentStatus: Bill;
  updateBillStatus: Bill;
  updateBillStatusWithoutNotifications: Bill;
  updateBillsReportingSettings: BillsReportingSettings;
  /** Save the billing defaults. Applies to every UNSENT bill at once; sent bills keep what they were sent with. */
  updateBillsSettings: BillsSettings;
  updateBlogCategory?: Maybe<BlogCategory>;
  updateBlogNotificationRule?: Maybe<BlogNotificationRule>;
  updateBlogPost?: Maybe<BlogPost>;
  updateBookableEventType: BusinessCalendarBookableEventType;
  updateBookingPayment: Booking;
  updateBusinessCalendarAvailability: BusinessCalendarAvailability;
  updateBusinessDirectoryNotificationRule: BusinessDirectoryNotificationRule;
  updateCIAgendaItem?: Maybe<CiGovernanceMeeting>;
  updateCIGovernanceMeeting?: Maybe<CiGovernanceMeeting>;
  updateCIImprovementInitiative?: Maybe<CiImprovementInitiative>;
  updateCIInitiativeAction?: Maybe<CiImprovementInitiative>;
  updateCIInitiativeStatus?: Maybe<CiImprovementInitiative>;
  updateCIIssueReport?: Maybe<CiIssueReport>;
  updateCIIssueStatus?: Maybe<CiIssueReport>;
  updateCIMeetingActionStatus?: Maybe<CiGovernanceMeeting>;
  updateCIMeetingStatus?: Maybe<CiGovernanceMeeting>;
  updateCINotificationRule: CiNotificationRule;
  updateCalculatorSubmissionStatus?: Maybe<CalculatorSubmission>;
  updateCalendar: BusinessCalendar;
  updateCalendarEventTask: CalendarEventTask;
  updateCalendarEventTaskChecklistItem: CalendarEventTask;
  updateCalendarGoal: CalendarGoal;
  updateCandidate: Candidate;
  updateCandidateForm: CandidateForm;
  /** Edit a form's position facts and pre-screen questions */
  updateCandidateFormPosition: CandidateForm;
  /** Save one section of a home: only the fields sent change. Logged with a field-by-field diff. */
  updateCareHome: CareHome;
  updateCarePlan?: Maybe<CarePlan>;
  updateCarePlanTemplate?: Maybe<CarePlanTemplate>;
  updateCareReview: CareReview;
  /** Change the care review cycles. Refused when a value is outside its rule. */
  updateCareReviewCycleSettings: CareReviewCycleSettingsView;
  updateChaseNotificationRule?: Maybe<ChaseNotificationRule>;
  updateChatRoom?: Maybe<ChatRoom>;
  updateChecklistItem?: Maybe<MechanicJob>;
  updateClient?: Maybe<Client>;
  updateClientActivity?: Maybe<ClientActivity>;
  updateClientChaseConfig?: Maybe<ClientChaseConfig>;
  updateClientContactCrossTenant?: Maybe<Client>;
  updateClientNotificationRule: ClientNotificationRule;
  updateClinicalTask: ClinicalTask;
  updateClub52GamePlayers: Club52Game;
  updateClub52Player: Club52Player;
  updateClub52Settings: Club52Settings;
  updateCoach?: Maybe<Coach>;
  updateCoachAgreement?: Maybe<CoachAgreement>;
  /** Accounting: change a rule (only the fields sent). */
  updateCodingRule: CodingRule;
  updateCommandIntegrationConfig: CommandIntegrationConfig;
  updateCommsHealthSettings: CommsHealthSettings;
  updateCommsLogSettings: CommsLogSettingsView;
  updateCommunication?: Maybe<DailyCareProfile>;
  updateCommunicationTask: CommunicationTask;
  updateCommunityCampaign: CommunityCampaignDetail;
  updateCommunityConfig: CommunityConfig;
  updateCommunityEntry: CommunityEntry;
  updateCommunityMemberSettingsAsAdmin: CommunityMemberSettings;
  updateCompany?: Maybe<Company>;
  updateCompanyKnowledgeArticle: CompanyKnowledge;
  updateCompetition: Competition;
  updateCompetitionPrintOffer: CompetitionPrintOffer;
  updateCompetitionSchool: CompetitionSchool;
  updateCompetitionSponsor: CompetitionSponsor;
  updateConstructionSite?: Maybe<ConstructionSite>;
  updateContributingFactor: ContributingFactor;
  updateCoupon: Coupon;
  updateCryptoVault: CryptoVault;
  updateCustomQuestion: IncidentCustomQuestion;
  updateCustomTestDefinition?: Maybe<CustomTestDefinition>;
  updateDailyCareProfile?: Maybe<DailyCareProfile>;
  updateDepartment?: Maybe<Department>;
  updateDigitalManager: DigitalManager;
  updateDigitalManagerMemory: DigitalManagerMemory;
  updateDigitalManagerNotificationRule: DigitalManagerNotificationRule;
  updateDigitalManagerRule: DigitalManagerRule;
  updateDigitalManagerTemplate: DigitalManagerTemplate;
  updateDroneSession?: Maybe<DroneSession>;
  updateEOIStatus?: Maybe<ExpressionOfInterest>;
  updateEmail: Email;
  updateEmailAddress: EmailAddress;
  updateEmailAiMemory: EmailAiMemory;
  updateEmailAiProactiveSettings: EmailAiProactiveSettings;
  updateEmailAiRule: EmailAiRule;
  updateEmployee?: Maybe<Employee>;
  updateEmployeeActivity?: Maybe<EmployeeActivity>;
  updateEmployeeActivityTag?: Maybe<EmployeeActivityTag>;
  updateEmployeeContractTemplate: EmployeeContractTemplate;
  updateEmployeeFormSetting: EmployeeFormSetting;
  updateEmployeeIncident: EmployeeIncident;
  updateEmployeeIncidentNotificationRule: EmployeeIncidentNotificationRule;
  /** Set this site's employees-module settings (employer company). */
  updateEmployeeModuleSettings: EmployeeModuleSetting;
  updateEmployeeNotificationRule: EmployeeNotificationRule;
  updateEmployeePosition?: Maybe<EmployeePosition>;
  updateEmployeeReportsTo: Employee;
  updateEmployeeRole?: Maybe<EmployeeRole>;
  updateEmployeeStatusOption?: Maybe<EmployeeStatusOption>;
  updateEmployeeTrainingAssignment?: Maybe<EmployeeTrainingAssignment>;
  updateEmployeeTrainingCategory?: Maybe<EmployeeTrainingCategory>;
  updateEmployeeWithPersonal?: Maybe<Employee>;
  updateEmpowermentCatchUp: EmpowermentCatchUp;
  updateEmpowermentGoal: EmpowermentGoal;
  updateEmpowermentJourney: EmpowermentJourney;
  updateEmpowermentSettings: EmpowermentSettings;
  updateEnergyTrackerNotificationRule: EnergyTrackerNotificationRule;
  updateEvent: CalendarEvent;
  updateFarmer: Farmer;
  updateFeedbackItem: FeedbackItem;
  updateFeedbackItemStatus: FeedbackItem;
  updateFeedbackNotificationRule: FeedbackNotificationRule;
  updateFeedbackSettings: FeedbackSettings;
  updateFileTransfer?: Maybe<FileTransfer>;
  updateFileTransferState?: Maybe<FileTransfer>;
  updateFoodBudget: FoodBudget;
  updateFrontendUpgrade: FrontendUpgrade;
  updateFuelStation: FuelStation;
  updateGoal?: Maybe<CarePlan>;
  updateGoalAction?: Maybe<GoalAction>;
  updateGoalCheckpoint: CalendarGoal;
  updateGoalProgress?: Maybe<CarePlan>;
  updateGovJobSpec?: Maybe<GovJobSpec>;
  updateGovMember?: Maybe<GovMember>;
  updateGovMembershipPlan?: Maybe<GovMembershipPlan>;
  updateGovNotificationRule?: Maybe<GovNotificationRule>;
  updateGovOrganisation?: Maybe<GovOrganisation>;
  updateGovParticipationAsAdmin: GovParticipation;
  updateGovProposal?: Maybe<GovProposal>;
  updateGrowthEngineConfig: GrowthEngineConfig;
  updateHarvestedVideo: HarvestedVideo;
  updateHolidayPayRates?: Maybe<PublicHoliday>;
  updateHolisticSnapshot?: Maybe<HolisticSnapshot>;
  updateHostingAffiliate?: Maybe<HostingAffiliate>;
  updateHostingOffer?: Maybe<HostingOffer>;
  updateHostingReferral?: Maybe<HostingReferral>;
  updateHostingSite?: Maybe<HostingSite>;
  updateInboxSummaryPreference: InboxSummaryPreference;
  updateIncident: Incident;
  updateIncidentLocation: IncidentLocation;
  updateIncidentType: IncidentType;
  updateInfluencer: Influencer;
  updateInfluencerBookingStatus: InfluencerBooking;
  updateInfluencerMetrics: Influencer;
  updateIngredient?: Maybe<UpdateIngredientResult>;
  updateIntervention?: Maybe<CarePlan>;
  updateInvestmentProject?: Maybe<InvestmentProject>;
  updateInvestor?: Maybe<Investor>;
  updateInvestorStage?: Maybe<Investor>;
  updateInvoice?: Maybe<Invoice>;
  updateIpfsNode: IpfsNode;
  updateJob?: Maybe<Job>;
  updateJobVehicle?: Maybe<JobVehicle>;
  updateJourneyTemplate?: Maybe<JourneyTemplate>;
  updateKitchen?: Maybe<Kitchen>;
  updateKitchenMember: Kitchen;
  updateLMSettings: LmSettings;
  updateLastSeen: Scalars['Boolean']['output'];
  updateLead: Lead;
  updateLeadFlowAction: LeadFlowAction;
  updateLeadFlowForm: LeadFlowForm;
  updateLeadFlowNotificationRule: LeadFlowNotificationRule;
  updateLeadFlowSequence: LeadFlowSequence;
  updateLeadFlowStage: LeadFlowStage;
  /** Accounting: change an account (only the fields sent). Accounts are never deleted — switch one off instead. */
  updateLedgerAccount: LedgerAccount;
  updateLifeAspect?: Maybe<LifeAspect>;
  updateLineItem: Bill;
  updateLocation?: Maybe<Location>;
  updateMaintenanceChecklistItem?: Maybe<MaintenanceRequest>;
  updateMaintenanceNotificationRule: MaintenanceNotificationRule;
  updateMaintenanceRequest?: Maybe<MaintenanceRequest>;
  updateMaintenanceStatus?: Maybe<MaintenanceRequest>;
  updateMealFeedback?: Maybe<MealFeedback>;
  updateMealPlan?: Maybe<MealPlan>;
  updateMealPlanNotificationRule?: Maybe<MealPlanNotificationRule>;
  updateMealPlanningSettings: MealPlanningSettings;
  updateMechanicJob?: Maybe<MechanicJob>;
  updateMechanicJobStatus?: Maybe<MechanicJob>;
  updateMechanicNotificationRule?: Maybe<MechanicNotificationRule>;
  updateMediaFolder?: Maybe<MediaFolder>;
  updateMediaItem?: Maybe<MediaItem>;
  updateMedicalRecordsShiftRule: MedicalRecordsShiftRule;
  updateMedication: Medication;
  updateMeetRecording: Meeting;
  updateMeetingParticipants: Meeting;
  updateMilestone?: Maybe<CarePlan>;
  updateMobility?: Maybe<DailyCareProfile>;
  updateMobilityAids: MobilityAids;
  updateMonthlyChecklistSettings: MonthlyChecklistSettings;
  updateMoodEntry?: Maybe<MoodEntry>;
  updateMotivationTemplate?: Maybe<MotivationPromptTemplate>;
  /** Update the caller's digest preference. Per-account rows must name accounts the caller can see. */
  updateMyBankingDigestPreference: BankingDigestPreference;
  updateMyCommunityMemberSettings: CommunityMemberSettings;
  updateMyDomainName: CommunityMemberSettings;
  /** Update the current user's own employee profile (self-service fields only) */
  updateMyEmployeeProfile?: Maybe<Employee>;
  updateMyGovParticipation: GovParticipation;
  updateMySmsAcmaRegistration: AcmaRegistration;
  updateMyVoicePreferences: VoicePreferences;
  updateMyWebsite: Tenant;
  updateNameservers: Domain;
  updateNeurologicalPeriod: NeurologicalObservationPeriod;
  updateNotificationContacts: CryptoVault;
  updateNutrition?: Maybe<DailyCareProfile>;
  updateOpportunity: Opportunity;
  updateOpportunityMeeting: OpportunityMeeting;
  updateOpportunityMember: OpportunityMember;
  updateOpportunityNote: OpportunityNote;
  updateOpportunityPaymentStatus: Opportunity;
  updateOpportunityStage: OpportunityStage;
  updateOpportunityTask: OpportunityTask;
  updateOpportunityType: OpportunityType;
  updateOrgChartConfig: OrgChartConfig;
  updateP2Action: P2Action;
  updateP2CampaignMessage: P2CampaignMessage;
  updateP2CampaignStatus: P2PledgeCampaign;
  updateP2DailyChaseSettings: P2DailyChaseConfig;
  updateP2NotificationRule: P2NotificationRule;
  updateP2OrderPayment: P2Order;
  updateP2OrderStatus: P2Order;
  updateP2OrderTracking: P2Order;
  updateP2Product: P2Product;
  updateP2Settings: P2Settings;
  updateP2Supplier: P2Supplier;
  updatePProposal: PProposal;
  updatePProposalStatus: PProposal;
  updatePageView?: Maybe<PageView>;
  updatePain?: Maybe<DailyCareProfile>;
  updatePartsOrder?: Maybe<PartsOrder>;
  updatePartsOrderStatus?: Maybe<PartsOrder>;
  updatePassword: Password;
  updatePaymentStatus: Opportunity;
  updatePayoutStatus: Opportunity;
  /** Choose who is told when a payroll enquiry comes in, and how */
  updatePayrollEnquirySettings: PayrollEnquirySettings;
  updatePenaltyRateRule: PenaltyRateRule;
  updatePersonalCare?: Maybe<DailyCareProfile>;
  updatePhoneNumber: TwilioPhoneNumber;
  updatePledgeCampaign: PledgeCampaign;
  updatePolicyMetadata: Policy;
  updatePolicySettings: PolicySettings;
  updatePrescriber: MedicationPrescriber;
  updatePressureCare?: Maybe<DailyCareProfile>;
  updateProgramActivity?: Maybe<ProgramActivity>;
  updateProgramApplication?: Maybe<ProgramApplication>;
  updateProgramCallNote?: Maybe<ProgramCallNote>;
  updateProgramCommission?: Maybe<ProgramCommission>;
  updateProgramConfig: ProgramConfig;
  updateProgramMember?: Maybe<ProgramMember>;
  updateProgressNoteCarePlans?: Maybe<ProgressNote>;
  updateProject: Project;
  updateProjectProgress: Project;
  updateProposal: Proposal;
  updateProposalSignedPdf: Proposal;
  updateProspectingNotificationRule: ProspectingNotificationRule;
  updatePublicHoliday?: Maybe<PublicHoliday>;
  updateQuoteStatus: Quote;
  updateRDActivity: RdActivity;
  updateRDProject: RdProject;
  updateRDTimeEntry: RdTimeEntry;
  updateRecipe?: Maybe<Recipe>;
  updateRecipeIngredient?: Maybe<UpdateRecipeIngredientResult>;
  updateRegistrationStatus?: Maybe<EventRegistration>;
  updateResearchBase: ResearchBase;
  updateResident?: Maybe<Resident>;
  updateResidentContact?: Maybe<ResidentContact>;
  updateResidentLeave: ResidentLeave;
  updateResidentPhoto?: Maybe<Resident>;
  updateResidentRiskAssessment: ResidentRiskAssessment;
  updateRespiteBooking: RespiteCareBooking;
  updateRestraintRecord: RestraintRecord;
  updateRewardTokenConfig: RewardTokenConfig;
  updateRiskAssessment: IncidentRiskAssessment;
  updateRound: MedicationRound;
  updateSEOMetadata: SeoMetadata;
  /** Mark a finding open, fixed or accepted, with a reason (two-step verification required) */
  updateSecurityFindingStatus: SecurityFinding;
  /** Change how often a site is meant to be scanned, or switch it off (two-step verification required) */
  updateSecurityTarget: SecurityTarget;
  updateSellerProfile?: Maybe<SellerProfile>;
  updateSellerProfileStatus?: Maybe<SellerProfile>;
  updateSeparationAffiliate: SeparationAffiliate;
  updateSeparationCase: SeparationCase;
  updateSeparationChild: SeparationChild;
  updateSeparationConfig: SeparationConfig;
  updateSeparationSchedule: SeparationParentingSchedule;
  updateSession: Session;
  updateSessionType: SessionType;
  updateShelvAiSettings: ShelvAiSettings;
  updateShift?: Maybe<Shift>;
  updateShiftNotificationRule: ShiftNotificationRule;
  updateShiftSettings: ShiftSettings;
  updateShiftTemplate?: Maybe<ShiftTemplate>;
  updateShiftType: ShiftType;
  updateSiteAdmins: LaunchedSite;
  updateSiteEditorSite: SiteEditorSite;
  updateSleep?: Maybe<DailyCareProfile>;
  updateSmsNotificationRule: SmsNotificationRule;
  updateSopAgendaItem?: Maybe<SopAgendaItem>;
  updateSopEpisode?: Maybe<SopEpisode>;
  updateSopSettings: SopSettings;
  updateSopTopic?: Maybe<SopTopic>;
  updateSphereOfInfluence?: Maybe<SphereOfInfluence>;
  updateSubSubTask: OpportunityTask;
  updateSubTask: OpportunityTask;
  updateSubscription?: Maybe<BillingSubscription>;
  updateSubscriptionProduct: SubscriptionProduct;
  updateSupplier?: Maybe<Supplier>;
  updateSupplierOrder?: Maybe<SupplierOrder>;
  updateTask: Task;
  updateTaskOrder: Task;
  updateTaskStatus: Task;
  updateTeam?: Maybe<Team>;
  updateTemperatureAlarm?: Maybe<TemperatureAlarm>;
  updateTenant: Tenant;
  updateTenantCompanyDetails: Tenant;
  updateTenantEmailDomain: Tenant;
  updateTenantPaymentDetails: Tenant;
  updateTimesheetCompliance: TimesheetEntity;
  updateTimesheetDigitizedData: TimesheetEntity;
  updateTimesheetStatus: TimesheetEntity;
  updateTomSettings: TomSettings;
  updateTrackedCompetition: TrackedCompetition;
  updateTranscription: Transcription;
  updateTreatmentPlan: IncidentTreatmentPlan;
  updateTrustPerson: TrustPerson;
  updateTypingStatus: Scalars['Boolean']['output'];
  updateVaccination: Vaccination;
  updateVaultInsightRule: VaultInsightRule;
  updateVisionBoardConfig: VisionBoardConfig;
  updateVisionBoardItem?: Maybe<VisionBoardItem>;
  updateVisionBoardNotificationRule?: Maybe<VisionBoardNotificationRule>;
  updateVlogCategory?: Maybe<VlogCategory>;
  updateVlogNotificationRule?: Maybe<VlogNotificationRule>;
  updateVlogPost?: Maybe<VlogPost>;
  updateVlogSeries?: Maybe<VlogSeries>;
  updateWaitingListChecklistItem?: Maybe<WaitingListEntry>;
  updateWaitingListChecklistTemplate: WaitingListChecklistTemplate;
  updateWaitingListEntry?: Maybe<WaitingListEntry>;
  updateWaitingListPriority?: Maybe<WaitingListEntry>;
  updateWitness: IncidentWitness;
  updateWorker?: Maybe<Worker>;
  updateWorkerTimeEntry?: Maybe<WorkerTimeEntry>;
  updateWoundStatus: Wound;
  uploadAwardVersion: AwardEntity;
  uploadBillsEmailBrandingPhoto: BillsEmailBranding;
  uploadCalendarProfilePhoto: BusinessCalendar;
  uploadGovBriefAudio: Scalars['String']['output'];
  uploadIncidentDocument: IncidentDocument;
  uploadInvoice: FoodInvoice;
  uploadLeadFlowEmailBrandingPhoto: LeadFlowEmailBranding;
  /** Upload a local session to the cloud (development only) */
  uploadLocalSession: UploadProgressResult;
  uploadMedicalRecord: MedicalRecord;
  uploadOrderReceipt?: Maybe<PartsOrder>;
  uploadP2ProductImage: P2ImageUploadResult;
  uploadRDEvidence: RdEvidence;
  uploadRewardsEmailBrandingPhoto: RewardsEmailBranding;
  uploadSEOImage: ImageUploadResult;
  uploadSopBriefAudio: Scalars['String']['output'];
  uploadSopVoiceNote: Scalars['String']['output'];
  uploadTaskMedia: TaskMedia;
  uploadTenantBrandingImage: Tenant;
  uploadTimesheet: TimesheetEntity;
  uploadWaitingListFile: WaitingListFile;
  /** Create or update one of the caller's alert rules. Accounts must be ones the caller can see. */
  upsertBankingAlertRule: BankingAlertRule;
  /** Admin: create or update an income rule. The FIRST save copies the shipped defaults in so nothing silently disappears. */
  upsertBankingIncomeRule: BankingIncomeRule;
  /** Admin: create or edit a money move */
  upsertBankingMonthJob: BankingMonthJob;
  /** Admin: create or edit a standing money move. Open occurrences from today on take the new title and amount. */
  upsertBankingStandingMove: BankingStandingMove;
  upsertBillsEmailBranding: BillsEmailBranding;
  upsertBusinessSnapshot: BusinessSnapshot;
  upsertCalendarTag: CalendarTag;
  upsertCareDayRecord: CareDayRecord;
  upsertCareQuarterTarget: CareQuarterTarget;
  upsertCommandDeal: CommandDeal;
  upsertEmployeeActivityTag: EmployeeActivityTag;
  upsertLeadFlowEmailBranding: LeadFlowEmailBranding;
  upsertMobilityAids: MobilityAids;
  upsertModuleSource: ModuleSource;
  upsertPaySettings: PaySettings;
  upsertPersonEnrichment: PersonEnrichment;
  upsertRewardsEmailBranding: RewardsEmailBranding;
  upsertVoipNumber: VoipNumber;
  upsertVoipSnapshot: VoipSnapshot;
  useGovChecklistTemplate: GovChecklist;
  validateMemberSplits: Scalars['Boolean']['output'];
  verifyDomain: RegisteredDomain;
  verifyEmailChange: Scalars['Boolean']['output'];
  verifyEmailCode?: Maybe<AuthResponse>;
  verifyInfluencer: Influencer;
  verifyPProposalEmail: Scalars['Boolean']['output'];
  verifyPasskeyAuthentication: AuthResponse;
  verifyPasskeyRegistration: WebAuthnCredential;
  verifyPasswordResetCode?: Maybe<Scalars['String']['output']>;
  verifyPhoneChange: Scalars['Boolean']['output'];
  verifyProposalEmail: Scalars['Boolean']['output'];
  verifySmsCode?: Maybe<AuthResponse>;
  wipeSarahCareAbbeyPain: SarahHistoricalWipeResult;
  wipeSarahCareAcfiAssessments: SarahHistoricalWipeResult;
  wipeSarahCareAdmissionSnapshots: SarahHistoricalWipeResult;
  wipeSarahCareAllergyPromotions: SarahResidentPromotionWipeResult;
  wipeSarahCareAnaccClassifications: SarahHistoricalWipeResult;
  wipeSarahCareBonds: SarahHistoricalWipeResult;
  wipeSarahCareBowelRecords: SarahHistoricalWipeResult;
  wipeSarahCareBraden: SarahHistoricalWipeResult;
  wipeSarahCareCarePlanHistory: SarahHistoricalWipeResult;
  wipeSarahCareContactCalls: SarahHistoricalWipeResult;
  wipeSarahCareContactHistory: SarahHistoricalWipeResult;
  wipeSarahCareContactLinks: SarahHistoricalWipeResult;
  wipeSarahCareDailyCareHistory: SarahHistoricalWipeResult;
  wipeSarahCareFallsRisk: SarahHistoricalWipeResult;
  wipeSarahCareFluidBalance: SarahHistoricalWipeResult;
  wipeSarahCareFoodIntake: SarahHistoricalWipeResult;
  wipeSarahCareHistoricalAssessments: SarahHistoricalWipeResult;
  wipeSarahCareIncidents: Array<SarahHistoricalWipeResult>;
  wipeSarahCareLeave: SarahHistoricalWipeResult;
  wipeSarahCareMedicalAssessments: SarahHistoricalWipeResult;
  wipeSarahCareMedicalFiles: SarahHistoricalWipeResult;
  wipeSarahCareMobilityAids: SarahHistoricalWipeResult;
  wipeSarahCareMobilityHistory: SarahHistoricalWipeResult;
  wipeSarahCareNoteFollowups: SarahHistoricalWipeResult;
  wipeSarahCareObservations: SarahHistoricalWipeResult;
  wipeSarahCarePainChart: SarahHistoricalWipeResult;
  wipeSarahCareProgressNotes: SarahHistoricalWipeResult;
  wipeSarahCareReferralTasks: SarahHistoricalWipeResult;
  wipeSarahCareRepositioningChecks: SarahHistoricalWipeResult;
  wipeSarahCareResidentFieldPromotions: SarahResidentPromotionWipeResult;
  wipeSarahCareResidentPhotoPointers: SarahHistoricalWipeResult;
  wipeSarahCareRespiteStays: SarahHistoricalWipeResult;
  wipeSarahCareRestraints: SarahHistoricalWipeResult;
  wipeSarahCareReviewHistory: SarahHistoricalWipeResult;
  wipeSarahCareSleepChecks: SarahHistoricalWipeResult;
  wipeSarahCareVaccinations: SarahHistoricalWipeResult;
  wipeSarahCareVoidedNotes: SarahHistoricalWipeResult;
  wipeSarahCareWaitingList: SarahHistoricalWipeResult;
  wipeSarahCareWoundHistory: SarahHistoricalWipeResult;
  withdrawCoachCertification?: Maybe<Coach>;
  withdrawMyEntry: MyCompetitionEntry;
  zkEnroll: ZkCredential;
  zkRequestChallenge: ZkChallenge;
  zkRevokeCredential: Scalars['Boolean']['output'];
  zkVerifyAuth?: Maybe<ZkAuthResponse>;
};


export type MutationAcceptBankingBalanceArgs = {
  input: AcceptBankingBalanceInput;
};


export type MutationAcceptCalendarInvitationArgs = {
  token: Scalars['String']['input'];
};


export type MutationAcceptCommunityInviteArgs = {
  slug: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};


export type MutationAcceptEmailReplyDraftArgs = {
  input: AcceptEmailReplyDraftInput;
};


export type MutationAcceptGovInviteArgs = {
  input: AcceptGovInviteInput;
};


export type MutationAcceptProgramMemberInviteArgs = {
  memberId: Scalars['ID']['input'];
  token: Scalars['String']['input'];
};


export type MutationAcceptSeparationInviteArgs = {
  slug: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};


export type MutationAcceptShelvInviteArgs = {
  slug: Scalars['String']['input'];
};


export type MutationAcceptShiftSwapArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAcceptSopEpisodeDraftArgs = {
  fields?: InputMaybe<Array<Scalars['String']['input']>>;
  id: Scalars['ID']['input'];
};


export type MutationAcceptVisionBoardInviteArgs = {
  slug: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};


export type MutationAcceptWalletContactInviteArgs = {
  address: Scalars['String']['input'];
  signature: Scalars['String']['input'];
  slug: Scalars['String']['input'];
};


export type MutationAcknowledgeObservationAlertArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAcknowledgePolicyArgs = {
  policyId: Scalars['ID']['input'];
};


export type MutationAcknowledgeReferralArgs = {
  input: AcknowledgeReferralInput;
};


export type MutationAcknowledgeShiftArgs = {
  employeeId: Scalars['ID']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  shiftId: Scalars['ID']['input'];
};


export type MutationAcknowledgeWaitingListFamilyResponseArgs = {
  id: Scalars['ID']['input'];
};


export type MutationActivateCarePlanArgs = {
  id: Scalars['ID']['input'];
};


export type MutationActivateJobArgs = {
  id: Scalars['ID']['input'];
};


export type MutationActivateTemplateArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAddAllergyArgs = {
  input: AddAllergyInput;
};


export type MutationAddBankingCashEntryArgs = {
  input: AddBankingCashEntryInput;
};


export type MutationAddBankingTransactionCommentArgs = {
  input: AddBankingTransactionCommentInput;
};


export type MutationAddBlockedDateArgs = {
  calendarId: Scalars['String']['input'];
  date: Scalars['DateTime']['input'];
};


export type MutationAddBlogReactionArgs = {
  input: BlogReactionInput;
};


export type MutationAddCiActionEvidenceArgs = {
  actionIndex: Scalars['Int']['input'];
  document: CiDocumentAttachmentInput;
  initiativeId: Scalars['ID']['input'];
};


export type MutationAddCiAgendaItemArgs = {
  input: AddCiAgendaItemInput;
  meetingId: Scalars['ID']['input'];
};


export type MutationAddCiInitiativeActivityArgs = {
  action: Scalars['String']['input'];
  details?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};


export type MutationAddCiInitiativeActivityNoteArgs = {
  id: Scalars['ID']['input'];
  input: AddCiActivityNoteInput;
};


export type MutationAddCiInitiativeDocumentArgs = {
  document: CiDocumentAttachmentInput;
  id: Scalars['ID']['input'];
};


export type MutationAddCiInitiativePhotoArgs = {
  id: Scalars['ID']['input'];
  photo: CiMediaAttachmentInitiativeInput;
};


export type MutationAddCiInitiativeToMeetingArgs = {
  initiativeId: Scalars['ID']['input'];
  meetingId: Scalars['ID']['input'];
};


export type MutationAddCiIssueActivityNoteArgs = {
  id: Scalars['ID']['input'];
  input: AddCiActivityNoteInput;
};


export type MutationAddCiIssuePhotoArgs = {
  id: Scalars['ID']['input'];
  photo: CiMediaAttachmentInitiativeInput;
};


export type MutationAddCiMeetingNoteArgs = {
  input: AddCiMeetingNoteInput;
  meetingId: Scalars['ID']['input'];
};


export type MutationAddCalendarEventTaskChecklistItemArgs = {
  item: CalendarEventTaskChecklistItemInput;
  taskId: Scalars['String']['input'];
};


export type MutationAddCandidateNoteArgs = {
  candidateId: Scalars['ID']['input'];
  note: Scalars['String']['input'];
};


export type MutationAddChaseRecipientArgs = {
  configId: Scalars['String']['input'];
  recipient: ChaseRecipientInput;
};


export type MutationAddChecklistItemArgs = {
  input: AddJobChecklistItemInput;
  jobId: Scalars['ID']['input'];
};


export type MutationAddClientPermissionArgs = {
  clientId: Scalars['ID']['input'];
  permission: ClientPermission;
};


export type MutationAddClientShippingAddressArgs = {
  input: ClientShippingDetailsInput;
};


export type MutationAddClientTagArgs = {
  clientId: Scalars['ID']['input'];
  tag: Scalars['String']['input'];
};


export type MutationAddCompletionPhotoArgs = {
  id: Scalars['ID']['input'];
  photo: MaintenanceMediaInput;
};


export type MutationAddDomainDnsRecordArgs = {
  domain: Scalars['String']['input'];
  launchedSiteId: Scalars['ID']['input'];
  record: DnsRecordInput;
};


export type MutationAddEmailLabelArgs = {
  emailId: Scalars['String']['input'];
  label: Scalars['String']['input'];
};


export type MutationAddEmployeeActivityCommentArgs = {
  input: AddEmployeeActivityCommentInput;
};


export type MutationAddEmployeeChecklistItemArgs = {
  input: AddEmployeeChecklistItemInput;
};


export type MutationAddEmployeeToCompanyArgs = {
  clientId: Scalars['ID']['input'];
  companyId: Scalars['ID']['input'];
};


export type MutationAddEmpowermentOneOffQuestionArgs = {
  input: AddEmpowermentOneOffQuestionInput;
};


export type MutationAddFeedbackItemNoteArgs = {
  input: AddFeedbackNoteInput;
};


export type MutationAddGithubCollaboratorArgs = {
  launchedSiteId: Scalars['ID']['input'];
  username: Scalars['String']['input'];
};


export type MutationAddGoalCheckpointArgs = {
  checkpoint: CalendarGoalCheckpointInput;
  goalId: Scalars['String']['input'];
};


export type MutationAddGoalToCarePlanArgs = {
  carePlanId: Scalars['ID']['input'];
  input: CarePlanGoalInput;
};


export type MutationAddGovActivityCommentArgs = {
  input: AddGovActivityCommentInput;
};


export type MutationAddGovActivityNoteArgs = {
  input: AddGovActivityNoteInput;
};


export type MutationAddGovChecklistItemArgs = {
  input: AddGovChecklistItemInput;
};


export type MutationAddGovMemberArgs = {
  input: CreateGovMemberInput;
};


export type MutationAddInboundEmailLabelArgs = {
  emailId: Scalars['String']['input'];
  label: Scalars['String']['input'];
};


export type MutationAddInterventionToCarePlanArgs = {
  carePlanId: Scalars['ID']['input'];
  input: CarePlanInterventionInput;
};


export type MutationAddInvestorDocumentArgs = {
  id: Scalars['ID']['input'];
  input: AddInvestorDocumentInput;
};


export type MutationAddInvestorNoteArgs = {
  id: Scalars['ID']['input'];
  input: AddInvestorNoteInput;
};


export type MutationAddItemsToMeetingReviewArgs = {
  initiativeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  issueIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  meetingId: Scalars['ID']['input'];
};


export type MutationAddJobMediaArgs = {
  input: AddJobMediaInput;
  jobId: Scalars['ID']['input'];
};


export type MutationAddJobProgressNoteArgs = {
  input: AddJobProgressNoteInput;
  jobId: Scalars['ID']['input'];
};


export type MutationAddKitchenMemberArgs = {
  input: KitchenMemberInput;
  kitchenId: Scalars['ID']['input'];
};


export type MutationAddLabelToInboundEmailArgs = {
  id: Scalars['ID']['input'];
  label: Scalars['String']['input'];
};


export type MutationAddLaunchSiteDomainArgs = {
  domain: Scalars['String']['input'];
  launchedSiteId: Scalars['ID']['input'];
};


export type MutationAddLeaveAttachmentsArgs = {
  attachments: Array<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};


export type MutationAddLineItemArgs = {
  billId: Scalars['ID']['input'];
  input: LineItemInput;
};


export type MutationAddMaintenanceActivityNoteArgs = {
  input: AddMaintenanceActivityNoteInput;
};


export type MutationAddMaintenanceChecklistItemArgs = {
  id: Scalars['ID']['input'];
  input: AddChecklistItemInput;
};


export type MutationAddMaintenancePhotoArgs = {
  id: Scalars['ID']['input'];
  photo: MaintenanceMediaInput;
};


export type MutationAddMaintenanceProgressNoteArgs = {
  id: Scalars['ID']['input'];
  input: AddProgressNoteInput;
};


export type MutationAddMealServicePhotosArgs = {
  mealPlanId: Scalars['ID']['input'];
  photos: Array<MealMediaInput>;
};


export type MutationAddMilestoneToGoalArgs = {
  carePlanId: Scalars['ID']['input'];
  goalIndex: Scalars['Int']['input'];
  input: MilestoneInput;
};


export type MutationAddMonthlyRoomCheckPhotoArgs = {
  id: Scalars['ID']['input'];
  photo: MaintenanceMediaInput;
};


export type MutationAddMonthlyRoomCheckProgressNoteArgs = {
  id: Scalars['ID']['input'];
  input: AddMonthlyRoomCheckProgressNoteInput;
};


export type MutationAddOpportunityMemberArgs = {
  input: OpportunityMemberInput;
  opportunityId: Scalars['String']['input'];
};


export type MutationAddOpportunityProgressNoteArgs = {
  id: Scalars['String']['input'];
  input: AddOpportunityProgressNoteInput;
};


export type MutationAddPProposalChecklistItemArgs = {
  id: Scalars['ID']['input'];
  title: Scalars['String']['input'];
};


export type MutationAddPolicyNoteArgs = {
  input: AddPolicyNoteInput;
  policyId: Scalars['ID']['input'];
};


export type MutationAddProjectDocumentArgs = {
  input: AddProjectDocumentInput;
  projectId: Scalars['ID']['input'];
};


export type MutationAddProjectTeamMemberArgs = {
  input: AddProjectTeamMemberInput;
  projectId: Scalars['ID']['input'];
};


export type MutationAddRecipeIngredientArgs = {
  input: CreateRecipeIngredientInput;
};


export type MutationAddReviewActionItemArgs = {
  assignedTo?: InputMaybe<Scalars['ID']['input']>;
  description: Scalars['String']['input'];
  dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  reviewId: Scalars['ID']['input'];
};


export type MutationAddReviewAttendeeArgs = {
  name: Scalars['String']['input'];
  relationship?: InputMaybe<Scalars['String']['input']>;
  reviewId: Scalars['ID']['input'];
  role?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAddSarahCareContactAsContactArgs = {
  contactHistoryId: Scalars['ID']['input'];
};


export type MutationAddSopCommentArgs = {
  input: CreateSopCommentInput;
  tenantId: Scalars['String']['input'];
};


export type MutationAddSovereigntyAdjustmentArgs = {
  input: AddSovereigntyAdjustmentInput;
};


export type MutationAddSovereigntyStepArgs = {
  input: AddSovereigntyStepInput;
};


export type MutationAddSubSubTaskArgs = {
  input: SubSubTaskInput;
  subtaskId: Scalars['String']['input'];
  taskId: Scalars['String']['input'];
};


export type MutationAddSubTaskArgs = {
  input: SubTaskInput;
  taskId: Scalars['String']['input'];
};


export type MutationAddToWaitingListArgs = {
  input: CreateWaitingListEntryInput;
};


export type MutationAddTranscriptionCommentArgs = {
  input: TranscriptionCommentInput;
};


export type MutationAddVideosToSourceArgs = {
  input: AddVideosInput;
};


export type MutationAddVlogReactionArgs = {
  input: VlogReactionInput;
};


export type MutationAddWaitingListChecklistItemArgs = {
  id: Scalars['ID']['input'];
  input: AddWaitingListChecklistItemInput;
};


export type MutationAddWaitingListNoteArgs = {
  id: Scalars['ID']['input'];
  input: AddWaitingListNoteInput;
};


export type MutationAddWitnessArgs = {
  incidentId: Scalars['ID']['input'];
  input: AddWitnessInput;
};


export type MutationAdjustLeaveBalanceArgs = {
  input: AdjustLeaveBalanceInput;
};


export type MutationAdminAddCompetitionEntryArgs = {
  input: AdminAddCompetitionEntryInput;
};


export type MutationAdminDecideBusinessListingClaimArgs = {
  approve: Scalars['Boolean']['input'];
  listingId: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAdminDeleteBusinessListingArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAdminRelinkWalletKeyArgs = {
  address: Scalars['String']['input'];
  clientId: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
  scope?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAdminResetPasswordArgs = {
  input: AdminResetPasswordInput;
};


export type MutationAdminSetBusinessListingHiddenArgs = {
  hidden: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAdminUpdateBusinessListingArgs = {
  id: Scalars['ID']['input'];
  input: AdminBusinessListingInput;
};


export type MutationAdministerPrnArgs = {
  input: AdministerPrnInput;
};


export type MutationAdoptGovJobSpecArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAdvanceCandidateStageArgs = {
  id: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
  stage: CandidateStage;
};


export type MutationAiOpsCancelRequestArgs = {
  model: Scalars['String']['input'];
  requestId: Scalars['String']['input'];
};


export type MutationAiOpsDeleteKeyArgs = {
  token: Scalars['String']['input'];
};


export type MutationAiOpsMintKeyArgs = {
  input: AiOpsMintKeyInput;
};


export type MutationAiOpsReplaceKeyArgs = {
  token: Scalars['String']['input'];
};


export type MutationAiOpsSetCapturePolicyArgs = {
  input: AiOpsCapturePolicyInput;
};


export type MutationAiOpsSetKeyConcurrencyArgs = {
  maxParallelRequests: Scalars['Int']['input'];
  token: Scalars['String']['input'];
};


export type MutationAiOpsSetKeyPausedArgs = {
  paused: Scalars['Boolean']['input'];
  token: Scalars['String']['input'];
};


export type MutationAiOpsUpdateKeyArgs = {
  input: AiOpsKeySettingsInput;
  token: Scalars['String']['input'];
};


export type MutationAnnounceCompetitionWinnersArgs = {
  allowNoJudgedWinners?: InputMaybe<Scalars['Boolean']['input']>;
  competitionId: Scalars['ID']['input'];
  notifyEntrants?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationAnnounceOpenShiftArgs = {
  channels: Array<Scalars['String']['input']>;
  employeeIds: Array<Scalars['String']['input']>;
  shiftId: Scalars['ID']['input'];
};


export type MutationAnswerChecklistItemArgs = {
  checklistId: Scalars['ID']['input'];
  input: AnswerChecklistItemInput;
  taskId: Scalars['String']['input'];
};


export type MutationAnswerDigitalManagerOqArgs = {
  input: AnswerDigitalManagerOqInput;
};


export type MutationAnswerOutstandingQuestionArgs = {
  input: AnswerEmailAiQuestionInput;
};


export type MutationAnswerWaitingListConfirmationArgs = {
  input: AnswerWaitingListConfirmationInput;
};


export type MutationApiHubCreateCategoryArgs = {
  input: CreateApiCategoryInput;
};


export type MutationApiHubCreateEndpointArgs = {
  input: CreateApiEndpointInput;
};


export type MutationApiHubCreateKeyArgs = {
  input: CreateApiKeyInput;
};


export type MutationApiHubCreateListingArgs = {
  input: CreateApiListingInput;
};


export type MutationApiHubDeleteCategoryArgs = {
  id: Scalars['ID']['input'];
};


export type MutationApiHubDeleteEndpointArgs = {
  id: Scalars['ID']['input'];
};


export type MutationApiHubDeleteListingArgs = {
  id: Scalars['ID']['input'];
};


export type MutationApiHubExecuteArgs = {
  apiSlug: Scalars['String']['input'];
  endpointSlug: Scalars['String']['input'];
  params?: InputMaybe<Scalars['JSON']['input']>;
};


export type MutationApiHubRevokeKeyArgs = {
  keyId: Scalars['String']['input'];
};


export type MutationApiHubSubscribeArgs = {
  input: SubscribeToApiInput;
};


export type MutationApiHubUnsubscribeArgs = {
  subscriptionId: Scalars['String']['input'];
};


export type MutationApiHubUpdateCategoryArgs = {
  id: Scalars['ID']['input'];
  input: UpdateApiCategoryInput;
};


export type MutationApiHubUpdateEndpointArgs = {
  id: Scalars['ID']['input'];
  input: UpdateApiEndpointInput;
};


export type MutationApiHubUpdateListingArgs = {
  id: Scalars['ID']['input'];
  input: UpdateApiListingInput;
};


export type MutationAppendTasksFromMarkdownArgs = {
  markdown: Scalars['String']['input'];
  projectId: Scalars['ID']['input'];
};


export type MutationApplyCodingRulesArgs = {
  companyId: Scalars['ID']['input'];
};


export type MutationApplyEmpowermentStartDateChangeArgs = {
  journeyId: Scalars['ID']['input'];
};


export type MutationApplyTemplateToResidentArgs = {
  planName?: InputMaybe<Scalars['String']['input']>;
  residentId: Scalars['ID']['input'];
  templateId: Scalars['ID']['input'];
};


export type MutationApproveCarePlanArgs = {
  id: Scalars['ID']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
};


export type MutationApproveDigitalManagerProposalArgs = {
  oqId: Scalars['ID']['input'];
};


export type MutationApproveEmailLoginBrowserArgs = {
  label: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


export type MutationApproveGuaranteeClaimArgs = {
  input: SeparationClaimReviewInput;
};


export type MutationApproveLeaveRequestArgs = {
  input: ReviewLeaveRequestInput;
};


export type MutationApproveMedicalRecordAccessRequestArgs = {
  input: ApproveMedicalRecordAccessRequestInput;
};


export type MutationApprovePayRunArgs = {
  id: Scalars['ID']['input'];
};


export type MutationApproveReviewArgs = {
  notes?: InputMaybe<Scalars['String']['input']>;
  reviewId: Scalars['ID']['input'];
};


export type MutationApproveShiftPickupArgs = {
  comment?: InputMaybe<Scalars['String']['input']>;
  employeeId: Scalars['ID']['input'];
  shiftId: Scalars['ID']['input'];
};


export type MutationApproveShiftSwapArgs = {
  id: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};


export type MutationApproveSiteUpdateArgs = {
  id: Scalars['ID']['input'];
};


export type MutationApproveSmsLoginBrowserArgs = {
  label: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


export type MutationApproveWithdrawalArgs = {
  input: ApproveWithdrawalInput;
};


export type MutationApproveWorkerTimeEntryArgs = {
  id: Scalars['ID']['input'];
};


export type MutationArchiveAwardArgs = {
  id: Scalars['String']['input'];
};


export type MutationArchiveCalendarGoalArgs = {
  id: Scalars['String']['input'];
};


export type MutationArchiveCarePlanArgs = {
  id: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};


export type MutationArchiveCustomTestDefinitionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationArchiveEmailArgs = {
  emailId: Scalars['String']['input'];
};


export type MutationArchiveJobArgs = {
  id: Scalars['ID']['input'];
};


export type MutationArchiveLeadArgs = {
  id: Scalars['ID']['input'];
};


export type MutationArchiveMultipleInboundEmailsArgs = {
  ids: Array<Scalars['String']['input']>;
};


export type MutationArchivePolicyArgs = {
  id: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};


export type MutationArchiveTomConversationArgs = {
  id: Scalars['String']['input'];
};


export type MutationArchiveWaitingListEntryArgs = {
  id: Scalars['ID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  reason: WaitingListArchiveReason;
};


export type MutationAskCareMinutesArgs = {
  input: CareMinutesChatInput;
};


export type MutationAssessPoliceCheckArgs = {
  id: Scalars['ID']['input'];
  input: PoliceCheckAssessmentInput;
};


export type MutationAssignCiIssueReportArgs = {
  id: Scalars['ID']['input'];
  input: AssignCiIssueReportInput;
};


export type MutationAssignEmailToClientArgs = {
  clientId: Scalars['String']['input'];
  emailId: Scalars['String']['input'];
};


export type MutationAssignEmailToClientsArgs = {
  clientIds: Array<Scalars['String']['input']>;
  emailId: Scalars['String']['input'];
};


export type MutationAssignEmployeeToShiftArgs = {
  input: AssignEmployeeInput;
};


export type MutationAssignEmployeeTrainingArgs = {
  input: EmployeeTrainingAssignmentInput;
};


export type MutationAssignFeedbackItemArgs = {
  input: AssignFeedbackInput;
};


export type MutationAssignMaintenanceRequestArgs = {
  id: Scalars['ID']['input'];
  input: AssignMaintenanceRequestInput;
};


export type MutationAssignMechanicArgs = {
  id: Scalars['ID']['input'];
  input: AssignMechanicInput;
};


export type MutationAssignPhoneNumberToClientArgs = {
  clientId: Scalars['ID']['input'];
  phoneNumberId: Scalars['ID']['input'];
};


export type MutationAssignSourcesToBaseArgs = {
  input: AssignSourcesInput;
};


export type MutationAttachDailyAllocationVersionArgs = {
  input: AttachDailyAllocationVersionInput;
};


export type MutationAttachGovFileToActivityArgs = {
  input: AttachGovFileInput;
};


export type MutationAttachInboundEmailToOpportunityArgs = {
  inboundEmailId: Scalars['ID']['input'];
  opportunityId: Scalars['ID']['input'];
};


export type MutationAuthenticateCommunityInviteArgs = {
  slug: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};


export type MutationAuthenticateCommunityNotificationLinkArgs = {
  memberSettingsId: Scalars['ID']['input'];
  tenantId: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


export type MutationAuthenticateEmailLoginCodeArgs = {
  browserToken: Scalars['String']['input'];
  code: Scalars['String']['input'];
};


export type MutationAuthenticateEmailLoginLinkArgs = {
  next?: InputMaybe<Scalars['String']['input']>;
  token: Scalars['String']['input'];
};


export type MutationAuthenticateEmployeeLoginLinkArgs = {
  tenantId: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


export type MutationAuthenticateHostingLinkArgs = {
  tenantId: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


export type MutationAuthenticateProgramMemberArgs = {
  memberId: Scalars['ID']['input'];
  token: Scalars['String']['input'];
};


export type MutationAuthenticateSeparationLinkArgs = {
  tenantId: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


export type MutationAuthenticateShiftSwapLinkArgs = {
  swapId: Scalars['ID']['input'];
  tenantId: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


export type MutationAuthenticateSiteOwnerLinkArgs = {
  tenantId: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


export type MutationAuthenticateSmsLoginCodeArgs = {
  browserToken: Scalars['String']['input'];
  code: Scalars['String']['input'];
};


export type MutationAuthenticateSmsLoginLinkArgs = {
  token: Scalars['String']['input'];
};


export type MutationAuthenticateVisionBoardInviteArgs = {
  slug: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};


export type MutationAutoDistributeSplitsArgs = {
  opportunityId: Scalars['String']['input'];
};


export type MutationBackfillBankingNowArgs = {
  months?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationBackfillImprovMxConfigArgs = {
  launchedSiteId: Scalars['ID']['input'];
};


export type MutationBanChatParticipantArgs = {
  participantId: Scalars['String']['input'];
  roomId: Scalars['ID']['input'];
};


export type MutationBatchRecordAdministrationArgs = {
  input: Array<RecordAdministrationInput>;
};


export type MutationBeatVoiceLeaseArgs = {
  leaseId: Scalars['String']['input'];
  turns?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationBeginRosterBulkOpArgs = {
  input: BeginRosterBulkOpInput;
};


export type MutationBookEmpowermentCatchUpArgs = {
  input: BookEmpowermentCatchUpInput;
};


export type MutationBookWaitingListTourArgs = {
  id: Scalars['ID']['input'];
  input: BookWaitingListTourInput;
};


export type MutationBuildPortalAddStageNoteArgs = {
  input: AddStageNoteInput;
};


export type MutationBuildPortalAddStagePhotosArgs = {
  input: AddStagePhotosInput;
};


export type MutationBuildPortalCompleteStageArgs = {
  dealId: Scalars['ID']['input'];
};


export type MutationBuildPortalEditUpdateArgs = {
  input: EditBuildUpdateInput;
};


export type MutationBuildPortalInviteClientArgs = {
  input: InviteBuildClientInput;
};


export type MutationBuildPortalMarkMessagesSeenArgs = {
  dealId: Scalars['ID']['input'];
};


export type MutationBuildPortalMarkReadArgs = {
  updateIds: Array<Scalars['ID']['input']>;
};


export type MutationBuildPortalPostUpdateArgs = {
  input: PostBuildUpdateInput;
};


export type MutationBuildPortalRemoveAccessArgs = {
  accessId: Scalars['ID']['input'];
};


export type MutationBuildPortalRemoveStagePhotoArgs = {
  entryId: Scalars['ID']['input'];
};


export type MutationBuildPortalRequestPhotosArgs = {
  dealId: Scalars['ID']['input'];
};


export type MutationBuildPortalResetEmailTemplateArgs = {
  input: ResetEmailTemplateInput;
};


export type MutationBuildPortalSaveEmailTemplateArgs = {
  input: SaveEmailTemplateInput;
};


export type MutationBuildPortalSaveProjectArgs = {
  input: SaveBuildProjectInput;
};


export type MutationBuildPortalSaveSettingsArgs = {
  input: BuildPortalSettingsInput;
};


export type MutationBuildPortalSaveTeamProfileArgs = {
  input: BuildTeamProfileInput;
};


export type MutationBuildPortalSendBuilderEmailArgs = {
  input: SendBuildEmailInput;
};


export type MutationBuildPortalSendClientProgressArgs = {
  input: SendClientProgressInput;
};


export type MutationBuildPortalSendMessageArgs = {
  input: SendBuildMessageInput;
};


export type MutationBuildPortalSendTeamOverviewArgs = {
  input: SendTeamOverviewInput;
};


export type MutationBuildPortalSetPhotoForClientArgs = {
  entryId: Scalars['ID']['input'];
  sendToClient: Scalars['Boolean']['input'];
};


export type MutationBuildPortalSetStageArgs = {
  dealId: Scalars['ID']['input'];
  stageKey: Scalars['String']['input'];
};


export type MutationBuildResearchBaseArgs = {
  input: BuildResearchBaseInput;
};


export type MutationBuildStpFinalisationArgs = {
  financialYearEnd: Scalars['Int']['input'];
};


export type MutationBuildStpPayloadArgs = {
  eventType?: StpEventType;
  payRunId: Scalars['ID']['input'];
};


export type MutationBulkCreateMealPlansArgs = {
  input: BulkCreateMealPlanInput;
};


export type MutationBulkCreateP2ChargeArgs = {
  input: BulkCreateP2ChargeInput;
};


export type MutationBulkCreateP2DeliveryUpdateArgs = {
  input: BulkCreateP2DeliveryUpdateInput;
};


export type MutationBulkDeleteMediaItemsArgs = {
  ids: Array<Scalars['String']['input']>;
};


export type MutationBulkGrantBankingViewersArgs = {
  input: BulkGrantBankingViewersInput;
};


export type MutationBulkImportIngredientsArgs = {
  ingredients: Array<BulkIngredientInput>;
};


export type MutationBulkImportSeoMetadataArgs = {
  data: Array<CreateSeoMetadataInput>;
};


export type MutationBulkReplaceRecipeIngredientsArgs = {
  recipeId: Scalars['ID']['input'];
  rows: Array<BulkReplaceRecipeIngredientInput>;
};


export type MutationBulkUpdateJobStatusArgs = {
  ids: Array<Scalars['ID']['input']>;
  status: JobStatus;
};


export type MutationBulkUpsertIngredientsArgs = {
  rows: Array<BulkUpsertIngredientInput>;
};


export type MutationCalculateRespitePaymentArgs = {
  dailyFee: Scalars['Float']['input'];
  endDate: Scalars['DateTime']['input'];
  lessDeposit?: InputMaybe<Scalars['Float']['input']>;
  otherCharges?: InputMaybe<Scalars['Float']['input']>;
  startDate: Scalars['DateTime']['input'];
  telephoneAdvance?: InputMaybe<Scalars['Float']['input']>;
};


export type MutationCancelBookingArgs = {
  reason: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


export type MutationCancelClub52GameArgs = {
  roomName: Scalars['String']['input'];
};


export type MutationCancelCommunityCampaignArgs = {
  id: Scalars['ID']['input'];
};


export type MutationCancelEventArgs = {
  cancelAll?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['String']['input'];
  notifyAttendees?: InputMaybe<Scalars['Boolean']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCancelGovProposalArgs = {
  id: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCancelGovWorkItemArgs = {
  id: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCancelGraphExtractArgs = {
  batchId: Scalars['String']['input'];
};


export type MutationCancelHostingReferralArgs = {
  id: Scalars['ID']['input'];
};


export type MutationCancelInboxBacklogJobArgs = {
  id: Scalars['ID']['input'];
};


export type MutationCancelLeadFlowEnrolmentArgs = {
  enrolmentId: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
};


export type MutationCancelLeaveArgs = {
  id: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCancelLeaveRequestArgs = {
  id: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCancelMedicalRecordAccessRequestArgs = {
  id: Scalars['ID']['input'];
};


export type MutationCancelMyRewardPayoutArgs = {
  requestId: Scalars['ID']['input'];
};


export type MutationCancelOrderArgs = {
  input: CancelOrderInput;
};


export type MutationCancelP2PledgeCampaignArgs = {
  id: Scalars['ID']['input'];
};


export type MutationCancelPublicBookingArgs = {
  reason?: InputMaybe<Scalars['String']['input']>;
  token: Scalars['String']['input'];
};


export type MutationCancelReferralArgs = {
  input: CancelReferralInput;
};


export type MutationCancelRespiteBookingArgs = {
  id: Scalars['ID']['input'];
};


export type MutationCancelReviewArgs = {
  id: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCancelRewardPayoutArgs = {
  requestId: Scalars['ID']['input'];
};


export type MutationCancelRewardTokenArgs = {
  input: CancelRewardTokenInput;
};


export type MutationCancelRollupArgs = {
  id: Scalars['ID']['input'];
};


export type MutationCancelRoundArgs = {
  id: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
};


export type MutationCancelScheduledCandidateMessageArgs = {
  draftId: Scalars['ID']['input'];
};


export type MutationCancelScheduledChaseArgs = {
  logId: Scalars['String']['input'];
};


export type MutationCancelSeparationCareBlockArgs = {
  careBlockId: Scalars['ID']['input'];
};


export type MutationCancelSessionArgs = {
  id: Scalars['String']['input'];
  reason: Scalars['String']['input'];
};


export type MutationCancelShiftArgs = {
  id: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCancelShiftSwapArgs = {
  id: Scalars['ID']['input'];
};


export type MutationCancelSubscriptionArgs = {
  reason?: InputMaybe<Scalars['String']['input']>;
  subscriptionId: Scalars['ID']['input'];
};


export type MutationCancelWaitingListTourArgs = {
  id: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCancelWalletContactInviteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationCancelWithdrawalArgs = {
  reason?: InputMaybe<Scalars['String']['input']>;
  requestId: Scalars['ID']['input'];
};


export type MutationCaptureClub52WalletAddressArgs = {
  input: CaptureClub52WalletAddressInput;
};


export type MutationCastCompetitionVoteArgs = {
  entryId: Scalars['ID']['input'];
};


export type MutationCastGovVoteArgs = {
  input: CastGovVoteInput;
};


export type MutationCeaseMedicationArgs = {
  id: Scalars['ID']['input'];
  input: CeaseMedicationInput;
};


export type MutationCertifyCoachArgs = {
  id: Scalars['ID']['input'];
  input?: InputMaybe<CertifyCoachInput>;
};


export type MutationChangeAbsenceArgs = {
  employeeId: Scalars['ID']['input'];
  fromReason: AbsenceReason;
  isPaidLeave?: InputMaybe<Scalars['Boolean']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  shiftId: Scalars['ID']['input'];
  toReason: AbsenceReason;
};


export type MutationChangeBillClientArgs = {
  alsoUpdateProject?: InputMaybe<Scalars['Boolean']['input']>;
  billId: Scalars['ID']['input'];
  newClientId: Scalars['ID']['input'];
};


export type MutationChangeEmployeeUsernameArgs = {
  employeeId: Scalars['ID']['input'];
  notifyEmail?: InputMaybe<Scalars['Boolean']['input']>;
  username: Scalars['String']['input'];
};


export type MutationChangeMyPasswordArgs = {
  input: ChangePasswordInput;
};


export type MutationChangePasswordArgs = {
  input: ChangePasswordInput;
};


export type MutationChargeOutstandingBillsArgs = {
  billingPeriod?: InputMaybe<Scalars['String']['input']>;
};


export type MutationChargePaymentMethodArgs = {
  amount: Scalars['Float']['input'];
  clientId: Scalars['ID']['input'];
  currency?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  paymentMethodId: Scalars['ID']['input'];
};


export type MutationChargeSubscriptionBillArgs = {
  billId: Scalars['ID']['input'];
};


export type MutationChargeUnpaidSubscriptionBillsArgs = {
  billingPeriod?: InputMaybe<Scalars['String']['input']>;
};


export type MutationChaseShelvInviteArgs = {
  id: Scalars['ID']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCheckInArgs = {
  input: CheckInInput;
};


export type MutationCheckInRespiteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationCheckOutArgs = {
  input: CheckOutInput;
};


export type MutationCheckOutRespiteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationChloeArchiveSessionArgs = {
  sessionId: Scalars['String']['input'];
};


export type MutationChloeConfirmActionArgs = {
  actionId: Scalars['String']['input'];
  confirm: Scalars['Boolean']['input'];
};


export type MutationChloeSendMessageArgs = {
  input: ChloeSendMessageInput;
};


export type MutationChloeStartSessionArgs = {
  input: ChloeStartSessionInput;
};


export type MutationClaimBusinessListingArgs = {
  listingId: Scalars['ID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
};


export type MutationClaimCommunityFreeInviteArgs = {
  slug: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};


export type MutationClaimCommunityQrSignupArgs = {
  input: CommunityQrSignupInput;
  tenantId: Scalars['String']['input'];
};


export type MutationClaimGovWorkArgs = {
  note?: InputMaybe<Scalars['String']['input']>;
  workItemId: Scalars['ID']['input'];
};


export type MutationClaimSeparationInviteArgs = {
  slug: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};


export type MutationClaimSeparationSignupArgs = {
  input: SeparationSignupInput;
  tenantId: Scalars['String']['input'];
};


export type MutationClaimShelvInviteArgs = {
  fName?: InputMaybe<Scalars['String']['input']>;
  lName?: InputMaybe<Scalars['String']['input']>;
  slug: Scalars['String']['input'];
};


export type MutationClaimVisionBoardFreeInviteArgs = {
  slug: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};


export type MutationClassifyMicrosoftEmailsArgs = {
  inputs: Array<ClassifyMicrosoftEmailInput>;
};


export type MutationClearAbsenceArgs = {
  coveringLeaveAction?: InputMaybe<Scalars['String']['input']>;
  employeeId: Scalars['ID']['input'];
  reason?: InputMaybe<AbsenceReason>;
  shiftId: Scalars['ID']['input'];
};


export type MutationClearBillsEmailBrandingPhotoArgs = {
  field: BillsBrandingPhotoField;
};


export type MutationClearCheckInArgs = {
  employeeId: Scalars['ID']['input'];
  shiftId: Scalars['ID']['input'];
};


export type MutationClearLeadFlowEmailBrandingPhotoArgs = {
  field: BrandingPhotoField;
};


export type MutationClearMealPlanDateRangeArgs = {
  endDate: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
};


export type MutationClearMealPlanDayArgs = {
  date: Scalars['String']['input'];
};


export type MutationClearPProposalSignaturesArgs = {
  proposalId: Scalars['ID']['input'];
};


export type MutationClearPickupRejectionArgs = {
  comment?: InputMaybe<Scalars['String']['input']>;
  employeeId: Scalars['ID']['input'];
  shiftId: Scalars['ID']['input'];
};


export type MutationClearProposalSignaturesArgs = {
  proposalId: Scalars['ID']['input'];
};


export type MutationClearRewardsEmailBrandingPhotoArgs = {
  field: RewardsBrandingPhotoField;
};


export type MutationCloneCandidateFormArgs = {
  newName: Scalars['String']['input'];
  sourceId: Scalars['ID']['input'];
};


export type MutationCloneClub52GameArgs = {
  roomName: Scalars['String']['input'];
};


export type MutationCloseBankingMonthArgs = {
  month: Scalars['String']['input'];
};


export type MutationCloseGovProposalArgs = {
  id: Scalars['ID']['input'];
};


export type MutationCloseIncidentArgs = {
  id: Scalars['ID']['input'];
  input?: InputMaybe<CloseIncidentInput>;
};


export type MutationCodeAccountingTransactionArgs = {
  input: CodeAccountingTransactionInput;
};


export type MutationCommandAddActivityCommentArgs = {
  input: CommandAddActivityCommentInput;
};


export type MutationCommandAddActivityNoteArgs = {
  input: CommandAddActivityNoteInput;
};


export type MutationCommandAddCommissionDealNoteArgs = {
  id: Scalars['String']['input'];
  note: Scalars['String']['input'];
};


export type MutationCommandAddOffXeroReceiptArgs = {
  dealId: Scalars['String']['input'];
  input: OffXeroReceiptInput;
};


export type MutationCommandApplyAddressSplitArgs = {
  dealIds: Array<Scalars['ID']['input']>;
};


export type MutationCommandAttachActivityFilesArgs = {
  input: CommandAttachActivityFilesInput;
};


export type MutationCommandCheckUnlinkedDealsArgs = {
  since?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCommandCommitCommissionImportArgs = {
  fileBase64: Scalars['String']['input'];
};


export type MutationCommandCreateCommissionDealArgs = {
  input: CommissionDealInput;
  isPrivate?: InputMaybe<Scalars['Boolean']['input']>;
  visibleToClientIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type MutationCommandCreateCommissionOptionArgs = {
  input: CommissionOptionInput;
  kind: Scalars['String']['input'];
};


export type MutationCommandCreateFromPipedriveArgs = {
  pipedriveDealId: Scalars['String']['input'];
};


export type MutationCommandCreateNotificationRuleArgs = {
  input: CommandNotificationRuleInput;
};


export type MutationCommandDeleteCommissionOptionArgs = {
  id: Scalars['String']['input'];
  kind: Scalars['String']['input'];
};


export type MutationCommandDeleteNotificationRuleArgs = {
  id: Scalars['String']['input'];
};


export type MutationCommandExtractDealFromDocumentArgs = {
  input: CommandDealExtractionInput;
};


export type MutationCommandGrantModuleAccessArgs = {
  clientId: Scalars['String']['input'];
};


export type MutationCommandImportFromPipedriveArgs = {
  dryRun: Scalars['Boolean']['input'];
};


export type MutationCommandLinkOptionToClientArgs = {
  clientId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  kind: Scalars['String']['input'];
};


export type MutationCommandLinkPaymentToProjectArgs = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  paymentId: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
};


export type MutationCommandLinkPipedriveDealArgs = {
  dealId: Scalars['ID']['input'];
  matchedByName?: InputMaybe<Scalars['Boolean']['input']>;
  pipedriveDealId: Scalars['String']['input'];
};


export type MutationCommandLinkReadyDealsArgs = {
  dealIds: Array<Scalars['ID']['input']>;
};


export type MutationCommandMarkTagDoneArgs = {
  commentId?: InputMaybe<Scalars['ID']['input']>;
  entryId: Scalars['ID']['input'];
  mentionId: Scalars['ID']['input'];
  source: Scalars['String']['input'];
};


export type MutationCommandNotifyMentionsArgs = {
  choices: Array<CommandMentionNotifyChoiceInput>;
  commentId?: InputMaybe<Scalars['ID']['input']>;
  entryId: Scalars['ID']['input'];
};


export type MutationCommandNotifyReplyArgs = {
  choices: Array<CommandReplyNoticeChoiceInput>;
  commentId: Scalars['ID']['input'];
};


export type MutationCommandPreviewCommissionImportArgs = {
  fileBase64: Scalars['String']['input'];
};


export type MutationCommandPullFromPipedriveArgs = {
  dealId: Scalars['ID']['input'];
  onlyIfStale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCommandRemoveOffXeroReceiptArgs = {
  dealId: Scalars['String']['input'];
  receiptId: Scalars['String']['input'];
};


export type MutationCommandReorderCommissionOptionsArgs = {
  kind: Scalars['String']['input'];
  orderedIds: Array<Scalars['String']['input']>;
};


export type MutationCommandRetractActivityCommentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationCommandSendTagChasePreviewArgs = {
  kind?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCommandSendTestNotificationArgs = {
  eventKey: Scalars['String']['input'];
  toEmail: Scalars['String']['input'];
};


export type MutationCommandSetCommissionDealArchivedArgs = {
  archived: Scalars['Boolean']['input'];
  id: Scalars['String']['input'];
};


export type MutationCommandSetCommissionOptionActiveArgs = {
  id: Scalars['String']['input'];
  isActive: Scalars['Boolean']['input'];
  kind: Scalars['String']['input'];
};


export type MutationCommandSetDealPrivacyArgs = {
  clientIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  dealId: Scalars['ID']['input'];
  isPrivate: Scalars['Boolean']['input'];
};


export type MutationCommandSetPipedriveCreateDealsArgs = {
  on: Scalars['Boolean']['input'];
};


export type MutationCommandSetTagChaseArgs = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  ownerSummaryEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCommandShareDealArgs = {
  clientIds: Array<Scalars['ID']['input']>;
  dealId: Scalars['ID']['input'];
};


export type MutationCommandUnlinkPaymentArgs = {
  paymentId: Scalars['String']['input'];
};


export type MutationCommandUnlinkPipedriveDealArgs = {
  dealId: Scalars['ID']['input'];
};


export type MutationCommandUpdateCommissionDealArgs = {
  id: Scalars['String']['input'];
  input: CommissionDealInput;
};


export type MutationCommandUpdateCommissionOptionArgs = {
  id: Scalars['String']['input'];
  input: CommissionOptionInput;
  kind: Scalars['String']['input'];
};


export type MutationCommandUpdateNotificationRuleArgs = {
  id: Scalars['String']['input'];
  input: CommandNotificationRuleInput;
};


export type MutationCommandXeroConnectArgs = {
  code: Scalars['String']['input'];
  redirectUri: Scalars['String']['input'];
  state: Scalars['String']['input'];
};


export type MutationCommitBankCsvImportArgs = {
  input: BankCsvImportInput;
};


export type MutationCommitXeroChartFromXeroArgs = {
  input: XeroApiChartImportInput;
};


export type MutationCommitXeroChartImportArgs = {
  input: XeroChartImportInput;
};


export type MutationCommitXeroTransactionImportArgs = {
  input: XeroTransactionImportInput;
};


export type MutationCompleteActionArgs = {
  id: Scalars['ID']['input'];
  input?: InputMaybe<CompleteActionInput>;
};


export type MutationCompleteAuthProfileArgs = {
  input: AuthProfileInput;
};


export type MutationCompleteBankingMonthJobArgs = {
  input: CompleteBankingMonthJobInput;
};


export type MutationCompleteBookingArgs = {
  bookingId: Scalars['String']['input'];
};


export type MutationCompleteCiInitiativeArgs = {
  id: Scalars['ID']['input'];
  isSuccessful?: InputMaybe<Scalars['Boolean']['input']>;
  isSustainable?: InputMaybe<Scalars['Boolean']['input']>;
  measurementDetails?: InputMaybe<Scalars['String']['input']>;
  outcomes: Scalars['String']['input'];
};


export type MutationCompleteCarePlanReviewArgs = {
  id: Scalars['ID']['input'];
  input: CompleteCarePlanReviewInput;
};


export type MutationCompleteCareReviewArgs = {
  id: Scalars['ID']['input'];
};


export type MutationCompleteChecklistItemArgs = {
  checklistId: Scalars['ID']['input'];
  input?: InputMaybe<CompleteChecklistItemInput>;
  taskId: Scalars['String']['input'];
};


export type MutationCompleteClinicalTaskArgs = {
  id: Scalars['ID']['input'];
};


export type MutationCompleteDressingArgs = {
  scheduleId: Scalars['ID']['input'];
};


export type MutationCompleteEmailLinkSignupArgs = {
  input: CompleteEmailLinkSignupInput;
};


export type MutationCompleteEmpowermentCheckInArgs = {
  input: CompleteEmpowermentCheckInInput;
};


export type MutationCompleteFollowUpArgs = {
  id: Scalars['ID']['input'];
  notes: Scalars['String']['input'];
};


export type MutationCompleteInterviewArgs = {
  id: Scalars['ID']['input'];
  input: CompleteInterviewInput;
};


export type MutationCompleteMaintenanceRequestArgs = {
  id: Scalars['ID']['input'];
  input: CompleteMaintenanceRequestInput;
};


export type MutationCompleteMilestoneArgs = {
  carePlanId: Scalars['ID']['input'];
  goalIndex: Scalars['Int']['input'];
  milestoneIndex: Scalars['Int']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCompleteP2InviteArgs = {
  password: Scalars['String']['input'];
  slug: Scalars['String']['input'];
  username: Scalars['String']['input'];
};


export type MutationCompletePProposalChecklistItemArgs = {
  checklistItemId: Scalars['String']['input'];
  completed?: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
};


export type MutationCompletePreScreenArgs = {
  id: Scalars['ID']['input'];
  input: CompletePreScreenInput;
};


export type MutationCompleteReferralArgs = {
  input: CompleteReferralInput;
};


export type MutationCompleteRoundArgs = {
  id: Scalars['ID']['input'];
};


export type MutationCompleteSeparationSignupArgs = {
  input: SeparationSignupInput;
};


export type MutationCompleteShiftArgs = {
  id: Scalars['ID']['input'];
};


export type MutationComposeChaseSmsForLogArgs = {
  logId: Scalars['String']['input'];
};


export type MutationConfigureDailyCareHeadingsArgs = {
  headings: DailyCareHeadingsInput;
  profileType: ProfileType;
};


export type MutationConfigureDomainEmailArgs = {
  domain: Scalars['String']['input'];
  launchedSiteId: Scalars['ID']['input'];
};


export type MutationConfigureObservationAlertsArgs = {
  config: AlertConfigInput;
};


export type MutationConfirmAccountingSuggestionsArgs = {
  input: ConfirmAccountingSuggestionsInput;
};


export type MutationConfirmBankTransferPaymentArgs = {
  billId: Scalars['ID']['input'];
  paymentEventIndex: Scalars['Int']['input'];
};


export type MutationConfirmEventRegistrationArgs = {
  token: Scalars['String']['input'];
};


export type MutationConfirmGeneratedMealPlanArgs = {
  entries: Array<ConfirmMealPlanEntryInput>;
  servings?: Scalars['Int']['input'];
};


export type MutationConfirmGeneratedTasksArgs = {
  input: ConfirmGeneratedTasksInput;
};


export type MutationConfirmHostingReferralArgs = {
  id: Scalars['ID']['input'];
};


export type MutationConfirmInvoiceArgs = {
  edits: FoodInvoiceEditInput;
  id: Scalars['ID']['input'];
};


export type MutationConfirmOrderArgs = {
  orderId: Scalars['ID']['input'];
  supplierOrderNumber?: InputMaybe<Scalars['String']['input']>;
};


export type MutationConfirmP2PledgeArgs = {
  paymentMethodId: Scalars['String']['input'];
  pledgeId: Scalars['ID']['input'];
};


export type MutationConfirmP2QuickOrderArgs = {
  orderId: Scalars['ID']['input'];
  paymentIntentId: Scalars['String']['input'];
};


export type MutationConfirmPersonEventsArgs = {
  events: Array<CreatePersonEventInput>;
};


export type MutationConfirmProposalDraftArgs = {
  input: ConfirmProposalDraftInput;
};


export type MutationConfirmResidentSourceFieldsArgs = {
  paths?: InputMaybe<Array<Scalars['String']['input']>>;
  residentId: Scalars['ID']['input'];
};


export type MutationConfirmSeparationCareBlockArgs = {
  input: SeparationConfirmBlockInput;
};


export type MutationConfirmSiteSpecArgs = {
  launchedSiteId: Scalars['ID']['input'];
  siteSpec: ConfirmSiteSpecInput;
};


export type MutationConfirmTomActionArgs = {
  actionId: Scalars['String']['input'];
  conversationId: Scalars['String']['input'];
};


export type MutationConnectAccountingRedbarkArgs = {
  input: ConnectAccountingRedbarkInput;
};


export type MutationConnectAccountingXeroArgs = {
  input: ConnectAccountingXeroInput;
};


export type MutationConnectRedbarkArgs = {
  input: ConnectRedbarkInput;
};


export type MutationConvertLeadToClientArgs = {
  id: Scalars['ID']['input'];
};


export type MutationConvertProfileTypeArgs = {
  newType: ProfileType;
  profileId: Scalars['ID']['input'];
};


export type MutationConvertTranscriptionIntoMeetingNotesArgs = {
  transcription: Scalars['String']['input'];
};


export type MutationCopyMealPlanDateRangeArgs = {
  replace?: InputMaybe<Scalars['Boolean']['input']>;
  sourceEndDate: Scalars['String']['input'];
  sourceStartDate: Scalars['String']['input'];
  targetStartDate: Scalars['String']['input'];
};


export type MutationCopyMealPlanWeekArgs = {
  replace?: InputMaybe<Scalars['Boolean']['input']>;
  sourceStartDate: Scalars['String']['input'];
  targetStartDate: Scalars['String']['input'];
};


export type MutationCorrectSeparationCareLogEntryArgs = {
  input: SeparationCorrectEntryInput;
};


export type MutationCreateAcfiAssessmentArgs = {
  input: CreateAcfiAssessmentInput;
};


export type MutationCreateAbbeyPainAssessmentArgs = {
  input: CreateAbbeyPainAssessmentInput;
};


export type MutationCreateAccountabilityGoalArgs = {
  input: CreateAccountabilityGoalInput;
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationCreateAccountingBankAccountArgs = {
  input: CreateAccountingBankAccountInput;
};


export type MutationCreateAdmissionNotificationRuleArgs = {
  input: CreateAdmissionNotificationRuleInput;
};


export type MutationCreateAdvisoryBodyArgs = {
  input: CreateAdvisoryBodyInput;
};


export type MutationCreateAgencyEmployeeArgs = {
  agencyCompany: Scalars['String']['input'];
  defaultRoleId?: InputMaybe<Scalars['ID']['input']>;
  displayName: Scalars['String']['input'];
};


export type MutationCreateAnalyticsNotificationRuleArgs = {
  input: CreateAnalyticsNotificationRuleInput;
};


export type MutationCreateApprovedLeaveRequestArgs = {
  input: CreateLeaveRequestInput;
  notifyStaff?: InputMaybe<Scalars['Boolean']['input']>;
  openShifts?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCreateArtSessionArgs = {
  input: ArtSessionInput;
};


export type MutationCreateArtifactArgs = {
  input: CreateArtifactInput;
};


export type MutationCreateArtifactCommentArgs = {
  input: CreateArtifactCommentInput;
  tenantId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateAssessmentCustomFieldArgs = {
  input: CreateAssessmentCustomFieldInput;
};


export type MutationCreateAssessmentDomainArgs = {
  input: CreateAssessmentDomainInput;
};


export type MutationCreateAssessmentNotificationRuleArgs = {
  input: CreateAssessmentNotificationRuleInput;
};


export type MutationCreateAssessmentSnapshotArgs = {
  input: CreateAssessmentSnapshotInput;
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationCreateAvailabilityArgs = {
  input: AvailabilityInput;
};


export type MutationCreateAwardArgs = {
  input: CreateAwardInput;
};


export type MutationCreateAwardClassificationArgs = {
  input: AwardClassificationInput;
};


export type MutationCreateAwardRateArgs = {
  input: CreateAwardRateInput;
};


export type MutationCreateBdayGuestArgs = {
  input: BdayGuestInput;
};


export type MutationCreateBillArgs = {
  input: BillInput;
};


export type MutationCreateBillNotificationRuleArgs = {
  input: CreateBillNotificationRuleInput;
};


export type MutationCreateBillPaymentArgs = {
  billId: Scalars['ID']['input'];
  paymentMethodId: Scalars['String']['input'];
};


export type MutationCreateBladderRecordArgs = {
  input: CreateBladderRecordInput;
};


export type MutationCreateBlogCategoryArgs = {
  input: CreateBlogCategoryInput;
};


export type MutationCreateBlogNotificationRuleArgs = {
  input: CreateBlogNotificationRuleInput;
};


export type MutationCreateBlogPostArgs = {
  input: CreateBlogPostInput;
};


export type MutationCreateBloodPressureObservationArgs = {
  input: CreateBloodPressureObservationInput;
};


export type MutationCreateBloodSugarObservationArgs = {
  input: CreateBloodSugarObservationInput;
};


export type MutationCreateBondArgs = {
  input: CreateBondInput;
};


export type MutationCreateBookableEventTypeArgs = {
  input: CreateBusinessCalendarBookableEventTypeInput;
};


export type MutationCreateBookingArgs = {
  input: BookingInput;
};


export type MutationCreateBowelRecordArgs = {
  input: CreateBowelRecordInput;
};


export type MutationCreateBradenAssessmentArgs = {
  input: CreateBradenAssessmentInput;
};


export type MutationCreateBulkRdTimeEntriesArgs = {
  entries: Array<RdTimeEntryInput>;
};


export type MutationCreateBusinessCalendarArgs = {
  input: BusinessCalendarInput;
};


export type MutationCreateBusinessCalendarAvailabilityArgs = {
  input: CreateBusinessCalendarAvailabilityInput;
};


export type MutationCreateBusinessDirectoryNotificationRuleArgs = {
  input: BusinessDirectoryNotificationRuleInput;
};


export type MutationCreateCiGovernanceMeetingArgs = {
  input: CreateCiGovernanceMeetingInput;
};


export type MutationCreateCiImprovementInitiativeArgs = {
  input: CreateCiImprovementInitiativeInput;
};


export type MutationCreateCiInitiativeFromIssueArgs = {
  issueId: Scalars['ID']['input'];
};


export type MutationCreateCiIssueReportArgs = {
  input: CreateCiIssueReportInput;
};


export type MutationCreateCiNotificationRuleArgs = {
  input: CreateCiNotificationRuleInput;
};


export type MutationCreateCalendarArgs = {
  input: BusinessCalendarInput;
};


export type MutationCreateCalendarEventTaskArgs = {
  input: CalendarEventTaskInput;
};


export type MutationCreateCalendarGoalArgs = {
  input: CalendarGoalInput;
};


export type MutationCreateCandidateArgs = {
  input: CreateCandidateInput;
};


export type MutationCreateCandidateFormArgs = {
  input: CreateCandidateFormInput;
};


export type MutationCreateCandidateInviteArgs = {
  input: CreateCandidateInviteInput;
};


export type MutationCreateCareHomeArgs = {
  input: CareHomeUpdateInput;
};


export type MutationCreateCarePlanArgs = {
  input: CreateCarePlanInput;
};


export type MutationCreateCarePlanTemplateArgs = {
  input: CreateCarePlanTemplateInput;
};


export type MutationCreateCareReviewArgs = {
  input: CreateCareReviewInput;
};


export type MutationCreateChaseNotificationRuleArgs = {
  input: CreateChaseNotificationRuleInput;
};


export type MutationCreateChatRoomArgs = {
  input: ChatRoomInput;
};


export type MutationCreateClientArgs = {
  input: ClientInput;
};


export type MutationCreateClientActivityArgs = {
  clientId: Scalars['ID']['input'];
  input: CreateClientActivityInput;
};


export type MutationCreateClientChaseConfigArgs = {
  input: CreateClientChaseConfigInput;
};


export type MutationCreateClientNotificationRuleArgs = {
  input: CreateClientNotificationRuleInput;
};


export type MutationCreateClinicalTaskArgs = {
  input: CreateClinicalTaskInput;
};


export type MutationCreateClub52GameArgs = {
  input: CreateClub52GameInput;
};


export type MutationCreateClub52GoalArgs = {
  input: CreateClub52GoalInput;
};


export type MutationCreateClub52TableArgs = {
  input: CreateClub52TableInput;
};


export type MutationCreateCoachArgs = {
  input: CreateCoachInput;
};


export type MutationCreateCoachAgreementArgs = {
  input: CreateCoachAgreementInput;
};


export type MutationCreateCodingRuleArgs = {
  input: CreateCodingRuleInput;
};


export type MutationCreateCommunicationTaskArgs = {
  input: CommunicationTaskInput;
};


export type MutationCreateCommunityCampaignArgs = {
  input: CommunityCampaignInput;
};


export type MutationCreateCommunityEntryArgs = {
  input: CreateCommunityEntryInput;
};


export type MutationCreateCommunityEntryReplyArgs = {
  input: CreateCommunityEntryReplyInput;
};


export type MutationCreateCommunityInviteArgs = {
  input: CreateCommunityInviteInput;
};


export type MutationCreateCommunityMemberInviteArgs = {
  input: CreateCommunityMemberInviteInput;
};


export type MutationCreateCommunityPostArgs = {
  input: CreateCommunityPostInput;
};


export type MutationCreateCommunityPostCommentArgs = {
  input: CreateCommunityPostCommentInput;
  localDate: Scalars['String']['input'];
};


export type MutationCreateCompanyArgs = {
  input: CompanyInput;
};


export type MutationCreateCompanyKnowledgeArticleArgs = {
  input: CompanyKnowledgeInput;
};


export type MutationCreateCompetitionArgs = {
  input: CreateCompetitionInput;
};


export type MutationCreateCompetitionSchoolArgs = {
  input: CompetitionSchoolInput;
};


export type MutationCreateCompetitionSponsorArgs = {
  input: CompetitionSponsorInput;
};


export type MutationCreateConstructionSiteArgs = {
  input: CreateConstructionSiteInput;
};


export type MutationCreateContributingFactorArgs = {
  input: CreateContributingFactorInput;
};


export type MutationCreateCouponArgs = {
  input: CreateCouponInput;
};


export type MutationCreateCryptoVaultArgs = {
  input: CreateVaultInput;
};


export type MutationCreateCustomQuestionArgs = {
  input: CreateCustomQuestionInput;
};


export type MutationCreateCustomTestDefinitionArgs = {
  input: CreateCustomTestDefinitionInput;
};


export type MutationCreateDailyCareProfileArgs = {
  input: CreateDailyCareProfileInput;
};


export type MutationCreateDayBookEntryArgs = {
  input: CreateDayBookEntryInput;
};


export type MutationCreateDepartmentArgs = {
  input: DepartmentInput;
};


export type MutationCreateDigitalManagerMemoryArgs = {
  input: CreateDigitalManagerMemoryInput;
};


export type MutationCreateDigitalManagerNotificationRuleArgs = {
  input: CreateDigitalManagerNotificationRuleInput;
};


export type MutationCreateDigitalManagerRuleArgs = {
  input: CreateDigitalManagerRuleInput;
};


export type MutationCreateDigitalManagerTemplateArgs = {
  input: CreateDigitalManagerTemplateInput;
};


export type MutationCreateDirectBookingArgs = {
  input: BookingInput;
};


export type MutationCreateDraftBillWithTasksArgs = {
  projectId: Scalars['ID']['input'];
};


export type MutationCreateDraftPayRunArgs = {
  input: CreateDraftPayRunInput;
};


export type MutationCreateDressingScheduleArgs = {
  input: CreateDressingScheduleInput;
};


export type MutationCreateDroneSessionArgs = {
  input: CreateDroneSessionInput;
};


export type MutationCreateEmailArgs = {
  input: EmailComposeInput;
};


export type MutationCreateEmailAddressArgs = {
  input: EmailAddressInput;
};


export type MutationCreateEmailAddressWithAliasArgs = {
  input: CreateEmailAddressWithAliasInput;
};


export type MutationCreateEmailAiMemoryArgs = {
  input: CreateEmailAiMemoryInput;
};


export type MutationCreateEmailAiRuleArgs = {
  input: CreateEmailAiRuleInput;
};


export type MutationCreateEmailAiRuleFromEmailArgs = {
  inboundEmailId: Scalars['ID']['input'];
  preset: EmailAiRulePreset;
};


export type MutationCreateEmployeeArgs = {
  input: EmployeeInput;
};


export type MutationCreateEmployeeActivityArgs = {
  employeeId: Scalars['ID']['input'];
  input: EmployeeActivityInput;
};


export type MutationCreateEmployeeChecklistArgs = {
  input: CreateEmployeeChecklistInput;
};


export type MutationCreateEmployeeContractTemplateArgs = {
  input: EmployeeContractTemplateInput;
};


export type MutationCreateEmployeeIncidentNotificationRuleArgs = {
  input: CreateEmployeeIncidentNotificationRuleInput;
};


export type MutationCreateEmployeeInviteArgs = {
  input: CreateEmployeeInviteInput;
};


export type MutationCreateEmployeeNotificationRuleArgs = {
  input: CreateEmployeeNotificationRuleInput;
};


export type MutationCreateEmployeePositionArgs = {
  input: EmployeePositionInput;
};


export type MutationCreateEmployeeRoleArgs = {
  input: EmployeeRoleInput;
};


export type MutationCreateEmployeeStatusOptionArgs = {
  input: EmployeeStatusOptionInput;
};


export type MutationCreateEmployeeTrainingCategoryArgs = {
  input: EmployeeTrainingCategoryInput;
};


export type MutationCreateEmployeeWithCredentialsArgs = {
  input: CreateEmployeeWithCredentialsInput;
};


export type MutationCreateEmpowermentExtraCheckInArgs = {
  input: CreateEmpowermentExtraCheckInInput;
};


export type MutationCreateEmpowermentGoalArgs = {
  input: CreateEmpowermentGoalInput;
};


export type MutationCreateEmpowermentQuestionArgs = {
  input: CreateEmpowermentQuestionInput;
};


export type MutationCreateEnergyTrackerNotificationRuleArgs = {
  input: CreateEnergyTrackerNotificationRuleInput;
};


export type MutationCreateEventArgs = {
  input: CalendarEventInput;
  sendInvites?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCreateExpressionOfInterestArgs = {
  input: CreateEoiInput;
};


export type MutationCreateFarmerArgs = {
  input: CreateFarmerInput;
};


export type MutationCreateFeedbackNotificationRuleArgs = {
  input: CreateFeedbackNotificationRuleInput;
};


export type MutationCreateFileTransferArgs = {
  input: CreateFileTransferInput;
};


export type MutationCreateFileTransferBatchArgs = {
  files: Array<FileInput>;
  sessionId: Scalars['String']['input'];
};


export type MutationCreateFollowUpArgs = {
  input: CreateFollowUpInput;
};


export type MutationCreateFrontendUpgradeArgs = {
  input: CreateFrontendUpgradeInput;
};


export type MutationCreateFuelReadingArgs = {
  input: CreateFuelReadingInput;
};


export type MutationCreateGoalActionArgs = {
  input: CreateGoalActionInput;
};


export type MutationCreateGoalRewardArgs = {
  input: CreateGoalRewardInput;
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationCreateGovApplicationArgs = {
  input: CreateGovApplicationInput;
};


export type MutationCreateGovChecklistArgs = {
  input: CreateGovChecklistInput;
};


export type MutationCreateGovInviteArgs = {
  input: CreateGovInviteInput;
};


export type MutationCreateGovJobSpecArgs = {
  input: CreateGovJobSpecInput;
};


export type MutationCreateGovMembershipPlanArgs = {
  input: CreateGovMembershipPlanInput;
};


export type MutationCreateGovNotificationRuleArgs = {
  input: CreateGovNotificationRuleInput;
};


export type MutationCreateGovOrganisationArgs = {
  input: CreateGovOrganisationInput;
};


export type MutationCreateGovProposalArgs = {
  input: CreateGovProposalInput;
};


export type MutationCreateGovTreasuryAccountArgs = {
  input: CreateGovAccountInput;
};


export type MutationCreateGovWorkItemArgs = {
  input: CreateGovWorkItemInput;
};


export type MutationCreateHarvestSourceArgs = {
  input: CreateHarvestSourceInput;
};


export type MutationCreateHeightObservationArgs = {
  input: CreateHeightObservationInput;
};


export type MutationCreateHolisticSnapshotArgs = {
  input: CreateHolisticSnapshotInput;
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationCreateHostingAccessLinkArgs = {
  clientId: Scalars['ID']['input'];
};


export type MutationCreateHostingAffiliateArgs = {
  input: CreateHostingAffiliateInput;
};


export type MutationCreateHostingOfferArgs = {
  input: CreateHostingOfferInput;
};


export type MutationCreateHostingReferralArgs = {
  input: CreateHostingReferralInput;
};


export type MutationCreateHostingSiteArgs = {
  input: CreateHostingSiteInput;
  targetTenantId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationCreateIncidentArgs = {
  input: CreateIncidentInput;
};


export type MutationCreateIncidentLocationArgs = {
  input: CreateIncidentLocationInput;
};


export type MutationCreateIncidentTypeArgs = {
  input: CreateIncidentTypeInput;
};


export type MutationCreateInfluencerArgs = {
  input: InfluencerInput;
};


export type MutationCreateInfluencerBookingArgs = {
  input: CreateInfluencerBookingInput;
};


export type MutationCreateIngredientArgs = {
  input: CreateIngredientInput;
};


export type MutationCreateInvestmentProjectArgs = {
  input: CreateInvestmentProjectInput;
};


export type MutationCreateInvestorArgs = {
  input: CreateInvestorInput;
};


export type MutationCreateInvoiceArgs = {
  input: InvoiceInput;
};


export type MutationCreateJobArgs = {
  input: JobInput;
};


export type MutationCreateJobVehicleArgs = {
  input: CreateJobVehicleInput;
};


export type MutationCreateJourneyTemplateArgs = {
  input: CreateJourneyTemplateInput;
};


export type MutationCreateKitchenArgs = {
  input: ShelvCreateKitchenInput;
};


export type MutationCreateLaunchedSiteArgs = {
  input: CreateLaunchedSiteInput;
};


export type MutationCreateLeadFlowActionArgs = {
  input: CreateLeadFlowActionInput;
};


export type MutationCreateLeadFlowFormArgs = {
  input: CreateLeadFlowFormInput;
};


export type MutationCreateLeadFlowNotificationRuleArgs = {
  input: CreateLeadFlowNotificationRuleInput;
};


export type MutationCreateLeadFlowSequenceArgs = {
  input: CreateLeadFlowSequenceInput;
};


export type MutationCreateLeadFlowStageArgs = {
  input: CreateLeadFlowStageInput;
};


export type MutationCreateLeaveRequestArgs = {
  input: CreateLeaveRequestInput;
};


export type MutationCreateLedgerAccountArgs = {
  input: CreateLedgerAccountInput;
};


export type MutationCreateLifeAspectArgs = {
  input: CreateLifeAspectInput;
};


export type MutationCreateLocalSubscriptionArgs = {
  amountOverride?: InputMaybe<Scalars['Float']['input']>;
  couponCode?: InputMaybe<Scalars['String']['input']>;
  subscriptionProductId: Scalars['ID']['input'];
  tokenCount?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationCreateLocationArgs = {
  input: LocationInput;
};


export type MutationCreateMaintenanceNotificationRuleArgs = {
  input: CreateMaintenanceNotificationRuleInput;
};


export type MutationCreateMaintenanceRequestArgs = {
  input: CreateMaintenanceRequestInput;
};


export type MutationCreateManualChargeArgs = {
  amount: Scalars['Float']['input'];
  clientId: Scalars['ID']['input'];
  currency?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  paymentMethodId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationCreateManualCheckInArgs = {
  checkInTime: Scalars['DateTime']['input'];
  checkOutTime?: InputMaybe<Scalars['DateTime']['input']>;
  input: CheckInInput;
};


export type MutationCreateMealFeedbackArgs = {
  input: CreateMealFeedbackInput;
};


export type MutationCreateMealPlanArgs = {
  input: CreateMealPlanInput;
};


export type MutationCreateMealPlanNotificationRuleArgs = {
  input: CreateMealPlanNotificationRuleInput;
};


export type MutationCreateMechanicJobArgs = {
  input: CreateMechanicJobInput;
};


export type MutationCreateMechanicNotificationRuleArgs = {
  input: CreateMechanicNotificationRuleInput;
};


export type MutationCreateMediaFolderArgs = {
  input: CreateMediaFolderInput;
};


export type MutationCreateMediaItemArgs = {
  input: CreateMediaItemInput;
  uploadData: MediaUploadData;
};


export type MutationCreateMedicationArgs = {
  input: CreateMedicationInput;
};


export type MutationCreateMeetingArgs = {
  input: CreateMeetingInput;
};


export type MutationCreateMeetingFromRecordingArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  recordingSid: Scalars['String']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateMobilityAidsArgs = {
  input: CreateMobilityAidsInput;
};


export type MutationCreateMobilityAssessmentArgs = {
  input: CreateMobilityAssessmentInput;
};


export type MutationCreateModuleEventArgs = {
  calendarId: Scalars['String']['input'];
  input: CalendarEventInput;
  moduleRefId: Scalars['String']['input'];
  moduleType: Scalars['String']['input'];
};


export type MutationCreateMoodEntryArgs = {
  input: CreateMoodEntryInput;
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationCreateMotivationTemplateArgs = {
  input: MotivationPromptTemplateInput;
};


export type MutationCreateMultiResidentNoteArgs = {
  input: CreateMultiResidentNoteInput;
};


export type MutationCreateMultipleObservationsArgs = {
  input: CreateMultipleObservationsInput;
};


export type MutationCreateNeurologicalObservationArgs = {
  input: CreateNeurologicalObservationInput;
};


export type MutationCreateNeurologicalPeriodArgs = {
  input: CreateNeurologicalPeriodInput;
};


export type MutationCreateOpportunityArgs = {
  input: OpportunityInput;
};


export type MutationCreateOpportunityMeetingArgs = {
  input: OpportunityMeetingInput;
};


export type MutationCreateOpportunityNoteArgs = {
  input: OpportunityNoteInput;
};


export type MutationCreateOpportunityStageArgs = {
  input: OpportunityStageInput;
};


export type MutationCreateOpportunityTaskArgs = {
  input: OpportunityTaskInput;
};


export type MutationCreateOpportunityTypeArgs = {
  input: OpportunityTypeInput;
};


export type MutationCreateOrderWithItemsArgs = {
  input: CreateSupplierOrderInput;
  items: Array<SupplierOrderItemInput>;
};


export type MutationCreateOrgChartPlacementArgs = {
  input: CreateOrgChartPlacementInput;
};


export type MutationCreateOxygenSaturationObservationArgs = {
  input: CreateOxygenSaturationInput;
};


export type MutationCreateP2ActionArgs = {
  input: CreateP2ActionInput;
};


export type MutationCreateP2CampaignMessageArgs = {
  input: CreateP2CampaignMessageInput;
};


export type MutationCreateP2ChargeArgs = {
  input: CreateP2ChargeInput;
};


export type MutationCreateP2DeliveryUpdateArgs = {
  input: CreateP2DeliveryUpdateInput;
};


export type MutationCreateP2InviteArgs = {
  input: CreateP2InviteInput;
};


export type MutationCreateP2NotificationRuleArgs = {
  input: CreateP2NotificationRuleInput;
};


export type MutationCreateP2OrderArgs = {
  input: P2OrderInput;
};


export type MutationCreateP2PaymentIntentArgs = {
  orderId: Scalars['String']['input'];
};


export type MutationCreateP2PledgeArgs = {
  campaignId: Scalars['ID']['input'];
  referralCode?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateP2PledgeCampaignArgs = {
  input: CreateP2PledgeCampaignInput;
};


export type MutationCreateP2ProductArgs = {
  input: P2ProductInput;
};


export type MutationCreateP2QuickOrderArgs = {
  input: P2QuickOrderInput;
};


export type MutationCreateP2RefundArgs = {
  input: CreateP2RefundInput;
};


export type MutationCreateP2SupplierArgs = {
  input: CreateP2SupplierInput;
};


export type MutationCreatePProposalArgs = {
  input: CreatePProposalInput;
};


export type MutationCreatePartsOrderArgs = {
  input: CreatePartsOrderInput;
  jobId: Scalars['ID']['input'];
};


export type MutationCreatePasswordArgs = {
  input: PasswordInput;
};


export type MutationCreatePaymentIntentArgs = {
  invoiceId: Scalars['String']['input'];
};


export type MutationCreatePaymentMethodArgs = {
  input: PaymentMethodInput;
};


export type MutationCreatePenaltyRateRuleArgs = {
  input: CreatePenaltyRateRuleInput;
};


export type MutationCreatePersonEventArgs = {
  input: CreatePersonEventInput;
};


export type MutationCreatePersonalEmailArgs = {
  input: CreatePersonalEmailInput;
};


export type MutationCreatePledgeCampaignArgs = {
  input: CreatePledgeCampaignInput;
};


export type MutationCreatePolicyArgs = {
  input: CreatePolicyInput;
};


export type MutationCreatePrescriberArgs = {
  input: CreatePrescriberInput;
};


export type MutationCreateProgramActivityArgs = {
  input: CreateProgramActivityInput;
};


export type MutationCreateProgramApplicationArgs = {
  input: CreateProgramApplicationInput;
};


export type MutationCreateProgramCallNoteArgs = {
  input: CreateProgramCallNoteInput;
};


export type MutationCreateProgramCommissionArgs = {
  input: CreateProgramCommissionInput;
};


export type MutationCreateProgramMemberArgs = {
  input: CreateProgramMemberInput;
};


export type MutationCreateProgressNoteArgs = {
  input: CreateProgressNoteInput;
};


export type MutationCreateProjectArgs = {
  input: ProjectInput;
};


export type MutationCreateProposalArgs = {
  input: CreateProposalInput;
};


export type MutationCreateProspectingNotificationRuleArgs = {
  input: CreateProspectingNotificationRuleInput;
};


export type MutationCreatePublicBookingArgs = {
  input: CreatePublicBookingInput;
};


export type MutationCreatePublicHolidayArgs = {
  input: PublicHolidayInput;
};


export type MutationCreatePublicHostingReferralArgs = {
  input: PublicHostingReferralInput;
};


export type MutationCreatePulseObservationArgs = {
  input: CreatePulseObservationInput;
};


export type MutationCreateQuickSplitInvoiceArgs = {
  input: QuickSplitInvoiceInput;
};


export type MutationCreateQuoteArgs = {
  input: QuoteInput;
};


export type MutationCreateQuoteTemplateArgs = {
  input: QuoteTemplateInput;
};


export type MutationCreateRdActivityArgs = {
  input: RdActivityInput;
};


export type MutationCreateRdCommunicationLogArgs = {
  communicationType: Scalars['String']['input'];
  content?: InputMaybe<Scalars['String']['input']>;
  createTimeEntry?: Scalars['Boolean']['input'];
  duration?: InputMaybe<Scalars['Float']['input']>;
  participants?: InputMaybe<Scalars['String']['input']>;
  projectId: Scalars['String']['input'];
  subject?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateRdProjectArgs = {
  input: RdProjectInput;
};


export type MutationCreateRdTimeEntryArgs = {
  input: RdTimeEntryInput;
};


export type MutationCreateRecipeArgs = {
  input: CreateRecipeInput;
};


export type MutationCreateRecipeWithIngredientsArgs = {
  ingredients: Array<RecipeIngredientItemInput>;
  input: CreateRecipeInput;
};


export type MutationCreateRecurringAvailabilityArgs = {
  input: AvailabilityInput;
  until: Scalars['DateTime']['input'];
};


export type MutationCreateReferralFromNoteArgs = {
  input: CreateReferralInput;
};


export type MutationCreateResearchBaseArgs = {
  input: CreateResearchBaseInput;
};


export type MutationCreateResidentArgs = {
  input: CreateResidentInput;
};


export type MutationCreateResidentContactArgs = {
  input: CreateResidentContactInput;
};


export type MutationCreateResidentLeaveArgs = {
  input: CreateResidentLeaveInput;
};


export type MutationCreateResidentRiskAssessmentArgs = {
  input: CreateResidentRiskAssessmentInput;
};


export type MutationCreateRespirationObservationArgs = {
  input: CreateRespirationObservationInput;
};


export type MutationCreateRespiteBookingArgs = {
  input: CreateRespiteCareBookingInput;
};


export type MutationCreateRestraintCheckArgs = {
  input: CreateRestraintCheckInput;
};


export type MutationCreateRestraintRecordArgs = {
  input: CreateRestraintRecordInput;
};


export type MutationCreateRiskAssessmentArgs = {
  incidentId: Scalars['ID']['input'];
  input: CreateRiskAssessmentInput;
};


export type MutationCreateRoundArgs = {
  input: CreateRoundInput;
};


export type MutationCreateSeoMetadataArgs = {
  input: CreateSeoMetadataInput;
};


export type MutationCreateSellerProfileArgs = {
  input: SellerProfileInput;
};


export type MutationCreateSeparationAdhocBlockArgs = {
  input: SeparationAdhocBlockInput;
};


export type MutationCreateSeparationAffiliateArgs = {
  input: CreateSeparationAffiliateInput;
};


export type MutationCreateSeparationCaseArgs = {
  input: SeparationCaseInput;
};


export type MutationCreateSeparationChildArgs = {
  input: SeparationChildInput;
};


export type MutationCreateSeparationInviteArgs = {
  input: CreateSeparationInviteInput;
};


export type MutationCreateSeparationScheduleArgs = {
  input: SeparationParentingScheduleInput;
};


export type MutationCreateSeparationSponsorshipContributionArgs = {
  amount: Scalars['Float']['input'];
  isAnonymous?: Scalars['Boolean']['input'];
  subscriptionId: Scalars['ID']['input'];
};


export type MutationCreateSessionArgs = {
  input: SessionInput;
};


export type MutationCreateSessionTypeArgs = {
  input: SessionTypeInput;
};


export type MutationCreateSetupIntentArgs = {
  clientId: Scalars['String']['input'];
};


export type MutationCreateShelvInviteArgs = {
  input: CreateShelvInviteInput;
};


export type MutationCreateShelvMemberInviteArgs = {
  input: CreateShelvMemberInviteInput;
};


export type MutationCreateShiftArgs = {
  input: ShiftInput;
};


export type MutationCreateShiftNotificationRuleArgs = {
  input: CreateShiftNotificationRuleInput;
};


export type MutationCreateShiftTemplateArgs = {
  input: CreateShiftTemplateInput;
};


export type MutationCreateShiftTypeArgs = {
  input: ShiftTypeInput;
};


export type MutationCreateShiftsFromTemplatesArgs = {
  input: CreateShiftsFromTemplatesInput;
};


export type MutationCreateSiteEditorSiteArgs = {
  input: CreateSiteEditorSiteInput;
};


export type MutationCreateSleepCheckArgs = {
  input: CreateSleepCheckInput;
};


export type MutationCreateSmsNotificationRuleArgs = {
  input: CreateSmsNotificationRuleInput;
};


export type MutationCreateSopAgendaItemArgs = {
  input: CreateSopAgendaItemInput;
};


export type MutationCreateSopEpisodeArgs = {
  input: CreateSopEpisodeInput;
};


export type MutationCreateSopTopicArgs = {
  input: CreateSopTopicInput;
};


export type MutationCreateSphereOfInfluenceArgs = {
  input: CreateSphereOfInfluenceInput;
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationCreateSubscriptionArgs = {
  input: SubscriptionInput;
};


export type MutationCreateSubscriptionProductArgs = {
  input: SubscriptionProductInput;
};


export type MutationCreateSupplierArgs = {
  input: CreateSupplierInput;
};


export type MutationCreateSupplierOrderArgs = {
  input: CreateSupplierOrderInput;
};


export type MutationCreateTaskArgs = {
  input: TaskInput;
};


export type MutationCreateTeamArgs = {
  input: TeamInput;
};


export type MutationCreateTemperatureAlarmArgs = {
  input: CreateTemperatureAlarmInput;
};


export type MutationCreateTemperatureObservationArgs = {
  input: CreateTemperatureObservationInput;
};


export type MutationCreateTenantArgs = {
  input: TenantInput;
};


export type MutationCreateTimesheetArgs = {
  input: CreateTimesheetInput;
};


export type MutationCreateTomConversationArgs = {
  input: CreateTomConversationInput;
};


export type MutationCreateTrackedCompetitionArgs = {
  input: TrackedCompetitionInput;
};


export type MutationCreateTranscriptionArgs = {
  input: TranscriptionInput;
};


export type MutationCreateTreatmentPlanArgs = {
  incidentId: Scalars['ID']['input'];
  input: CreateTreatmentPlanInput;
};


export type MutationCreateTrustPersonArgs = {
  input: CreateTrustPersonInput;
};


export type MutationCreateUrinalysisObservationArgs = {
  input: CreateUrinalysisObservationInput;
};


export type MutationCreateVaccinationArgs = {
  input: CreateVaccinationInput;
};


export type MutationCreateVaultInsightRuleArgs = {
  input: CreateVaultInsightRuleInput;
};


export type MutationCreateVisionBoardInviteArgs = {
  input: CreateVisionBoardInviteInput;
};


export type MutationCreateVisionBoardItemArgs = {
  input: CreateVisionBoardItemInput;
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationCreateVisionBoardMemberInviteArgs = {
  input: CreateVisionBoardMemberInviteInput;
};


export type MutationCreateVisionBoardNotificationRuleArgs = {
  input: CreateVisionBoardNotificationRuleInput;
};


export type MutationCreateVlogCategoryArgs = {
  input: CreateVlogCategoryInput;
};


export type MutationCreateVlogNotificationRuleArgs = {
  input: CreateVlogNotificationRuleInput;
};


export type MutationCreateVlogPostArgs = {
  input: CreateVlogPostInput;
};


export type MutationCreateVlogSeriesArgs = {
  input: CreateVlogSeriesInput;
};


export type MutationCreateWalletContactInviteArgs = {
  inviteeEmail?: InputMaybe<Scalars['String']['input']>;
  inviteeName: Scalars['String']['input'];
};


export type MutationCreateWaterlowAssessmentArgs = {
  input: CreateWaterlowAssessmentInput;
};


export type MutationCreateWeightObservationArgs = {
  input: CreateWeightObservationInput;
};


export type MutationCreateWithdrawalRequestArgs = {
  input: CreateWithdrawalRequestInput;
};


export type MutationCreateWorkerArgs = {
  input: CreateWorkerInput;
};


export type MutationCreateWorkerTimeEntryArgs = {
  input: CreateWorkerTimeEntryInput;
};


export type MutationCreateWoundArgs = {
  input: CreateWoundInput;
};


export type MutationCreateWoundAssessmentArgs = {
  input: CreateWoundAssessmentInput;
};


export type MutationCustomizeLeadFlowActionArgs = {
  input: CustomizeLeadFlowActionInput;
};


export type MutationCustomizeP2ActionArgs = {
  input: CustomizeP2ActionInput;
};


export type MutationDashboardDeleteTodoArgs = {
  id: Scalars['String']['input'];
};


export type MutationDashboardReorderTodosArgs = {
  orderedIds: Array<Scalars['String']['input']>;
};


export type MutationDashboardSetShortAssessmentArgs = {
  input: DashboardShortAssessmentInput;
};


export type MutationDashboardSetSurgeryArgs = {
  input: DashboardSurgeryInput;
};


export type MutationDashboardToggleTodoArgs = {
  id: Scalars['String']['input'];
};


export type MutationDashboardUpsertTodoArgs = {
  input: DashboardTodoInput;
};


export type MutationDeactivateAllergyArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeactivateCouponArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeactivatePasswordArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeactivateTemplateArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeactivateUnitArgs = {
  migrateTo?: InputMaybe<UnitType>;
  unit: UnitType;
};


export type MutationDecideBankingMonthArgs = {
  input: DecideBankingMonthInput;
};


export type MutationDecideGovApplicationArgs = {
  accept: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
};


export type MutationDeclineEmployeeRecommendationArgs = {
  id: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
};


export type MutationDeclineGovInviteArgs = {
  slug: Scalars['String']['input'];
};


export type MutationDeclineGuaranteeClaimArgs = {
  input: SeparationClaimReviewInput;
};


export type MutationDeclineMedicalRecordAccessRequestArgs = {
  input: DeclineMedicalRecordAccessRequestInput;
};


export type MutationDeclineSeparationInviteArgs = {
  slug: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};


export type MutationDeclineShiftSwapArgs = {
  id: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};


export type MutationDeclineSponsoredSeparationAccessArgs = {
  reason: Scalars['String']['input'];
  requestId: Scalars['ID']['input'];
};


export type MutationDeclineWaitingListEntryArgs = {
  id: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};


export type MutationDeleteAcfiAssessmentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteAbbeyPainAssessmentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteAccountabilityGoalArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteAdmissionNotificationRuleArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteAnalyticsNotificationRuleArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteArtSessionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteArtifactArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteArtifactCommentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteAssessmentCustomFieldArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteAssessmentDomainArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteAssessmentNotificationRuleArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteAssessmentSnapshotArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteAvailabilityArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteAwardArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteAwardClassificationArgs = {
  hardDelete?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
};


export type MutationDeleteAwardRateArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteBankingAlertRuleArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteBankingCashEntryArgs = {
  transactionId: Scalars['ID']['input'];
};


export type MutationDeleteBankingHoldingArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteBankingIncomeRuleArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteBankingMonthJobArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteBankingStandingMoveArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteBdayGuestArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteBillArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteBillNotificationRuleArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteBladderRecordArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteBlogCategoryArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteBlogNotificationRuleArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteBlogPostArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteBondArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteBookableEventTypeArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteBowelRecordArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteBradenAssessmentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteBusinessCalendarAvailabilityArgs = {
  calendarId: Scalars['String']['input'];
};


export type MutationDeleteBusinessDirectoryNotificationRuleArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteBusinessSnapshotArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteCiGovernanceMeetingArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteCiImprovementInitiativeArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteCiIssueReportArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteCiNotificationRuleArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteCalculatorSubmissionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteCalendarArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteCalendarEventTaskArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteCalendarGoalArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteCalendarTagArgs = {
  tagId: Scalars['String']['input'];
};


export type MutationDeleteCandidateArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteCandidateDraftArgs = {
  draftId: Scalars['ID']['input'];
};


export type MutationDeleteCandidateFormArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteCareHomeArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteCarePlanArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteCarePlanReviewArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteCarePlanTemplateArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteCareReviewArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteChaseNotificationRuleArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteChatMessageArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteChatRoomArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteChecklistItemArgs = {
  itemId: Scalars['String']['input'];
  jobId: Scalars['ID']['input'];
};


export type MutationDeleteClientArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteClientActivityArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteClientChaseConfigArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteClientCrossTenantArgs = {
  clientId: Scalars['String']['input'];
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  targetTenantId: Scalars['String']['input'];
};


export type MutationDeleteClientNotificationRuleArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteClinicalTaskArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteClub52GameArgs = {
  roomName: Scalars['String']['input'];
};


export type MutationDeleteCoachArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteCoachAgreementArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteCodingRuleArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteCommunicationTaskArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteCommunityEntryArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteCommunityEntryReplyArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteCommunityInviteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteCommunityPostArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteCommunityPostCommentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteCompanyArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteCompanyKnowledgeArticleArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteCompetitionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteCompetitionPrintPayoutArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteCompetitionSchoolArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteCompetitionSponsorArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteConstructionSiteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteCustomQuestionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteDailyAllocationVersionArgs = {
  date: Scalars['DateTime']['input'];
  version: Scalars['Int']['input'];
};


export type MutationDeleteDailyCareProfileArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteDayBookEntryArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteDepartmentArgs = {
  hardDelete?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
};


export type MutationDeleteDigitalManagerMemoryArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteDigitalManagerNotificationRuleArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteDigitalManagerRuleArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteDigitalManagerTemplateArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteDomainArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteDroneSessionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteDuplicateEmployeesArgs = {
  deleteIds: Array<Scalars['ID']['input']>;
  keepId: Scalars['ID']['input'];
};


export type MutationDeleteEmailArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteEmailAddressArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteEmailAiMemoryArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteEmailAiRuleArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteEmailHealthProbeArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteEmployeeArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteEmployeeActivityArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteEmployeeActivityTagArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteEmployeeChecklistArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteEmployeeChecklistItemArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteEmployeeContractTemplateArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteEmployeeIncidentNotificationRuleArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteEmployeeInviteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteEmployeeNotificationRuleArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteEmployeePositionArgs = {
  hardDelete?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
};


export type MutationDeleteEmployeeRoleArgs = {
  hardDelete?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
};


export type MutationDeleteEmployeeStatusOptionArgs = {
  hardDelete?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
};


export type MutationDeleteEmployeeTrainingAssignmentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteEmployeeTrainingCategoryArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteEnergyTrackerNotificationRuleArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteEventArgs = {
  id: Scalars['String']['input'];
  notifyAttendees?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationDeleteEventRegistrationArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteFarmerArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteFeedbackItemArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteFeedbackNotificationRuleArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteFrontendUpgradeArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteGoalActionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteGoalRewardArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteGovMembershipPlanArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteGovNotificationRuleArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteGovOrganisationArgs = {
  confirmName: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};


export type MutationDeleteHarvestSourceArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteHarvestedVideoArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteHolisticSnapshotArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteHostingAffiliateArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteHostingCommissionPaymentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteHostingOfferArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteHostingReferralArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteHostingSiteArgs = {
  id: Scalars['ID']['input'];
  targetTenantId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationDeleteImprovMxAliasArgs = {
  alias: Scalars['String']['input'];
};


export type MutationDeleteInboundEmailArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteIncidentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteIncidentAlertArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteIncidentDocumentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteIncomingDeliveryTemperatureArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteInfluencerArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteIngredientArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteInvestmentProjectArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteInvestorArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteInvoiceArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteIpfsNodeArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteJobArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteJobMediaArgs = {
  jobId: Scalars['ID']['input'];
  mediaId: Scalars['String']['input'];
};


export type MutationDeleteJobProgressNoteArgs = {
  jobId: Scalars['ID']['input'];
  noteIndex: Scalars['Int']['input'];
};


export type MutationDeleteJobVehicleArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteJourneyTemplateArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteKitchenArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteLaunchedSiteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteLeadFlowFormArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteLeadFlowNotificationRuleArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteLeadFlowStageArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteLifeAspectArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteLineItemArgs = {
  billId: Scalars['ID']['input'];
  lineItemId: Scalars['ID']['input'];
};


export type MutationDeleteLocationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteMaintenanceActivityArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteMaintenanceChecklistItemArgs = {
  id: Scalars['ID']['input'];
  itemId: Scalars['String']['input'];
};


export type MutationDeleteMaintenanceNotificationRuleArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteMaintenanceProgressNoteArgs = {
  id: Scalars['ID']['input'];
  noteIndex: Scalars['Float']['input'];
};


export type MutationDeleteMaintenanceRequestArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteMealFeedbackArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteMealPlanArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteMealPlanNotificationRuleArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteMechanicJobArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteMechanicNotificationRuleArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteMediaFolderArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteMediaItemArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteMedicalRecordArgs = {
  input: DeleteMedicalRecordInput;
};


export type MutationDeleteMeetVoiceSignatureArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteMeetingArgs = {
  roomName: Scalars['String']['input'];
};


export type MutationDeleteMobilityAssessmentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteMoodEntryArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteMotivationTemplateArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteMyCommunityDataArgs = {
  input: DeleteMyCommunityDataInput;
};


export type MutationDeleteOpportunityArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteOpportunityMeetingArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteOpportunityNoteArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteOpportunityProgressNoteArgs = {
  id: Scalars['String']['input'];
  noteIndex: Scalars['Float']['input'];
};


export type MutationDeleteOpportunityTaskArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteOpportunityTypeArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteOrgChartPlacementArgs = {
  placementId: Scalars['ID']['input'];
};


export type MutationDeleteP2CampaignMessageArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteP2InviteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteP2NotificationRuleArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteP2ProductArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteP2SupplierArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeletePProposalArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeletePProposalActivityArgs = {
  activityIndex: Scalars['Int']['input'];
  proposalId: Scalars['ID']['input'];
};


export type MutationDeletePartsOrderArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeletePasskeyArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeletePaymentMethodArgs = {
  id: Scalars['ID']['input'];
  notifyClient?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationDeletePenaltyRateRuleArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeletePledgeCampaignArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteProgramActivityArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteProgramApplicationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteProgramCallNoteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteProgramCommissionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteProgramMemberArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteProjectArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteProposalArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteProspectingNotificationRuleArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeletePublicHolidayArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteRdActivityArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteRdEvidenceArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteRdProjectArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteRdTimeEntryArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteRecipeArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteRecordingArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteResearchBaseArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteResidentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteResidentContactArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteResidentLeaveArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteResidentRiskAssessmentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteRespiteBookingArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteRestraintRecordArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteRollupArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteSeoMetadataArgs = {
  pagePath: Scalars['String']['input'];
};


export type MutationDeleteSellerProfileArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteSeparationChildArgs = {
  childId: Scalars['ID']['input'];
};


export type MutationDeleteSessionTypeArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteShelvInviteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteShiftArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteShiftNotificationRuleArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteShiftTemplateArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteShiftTypeArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteShiftsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationDeleteShiftsByDateRangeArgs = {
  endDate: Scalars['DateTime']['input'];
  startDate: Scalars['DateTime']['input'];
};


export type MutationDeleteSiteEditorSiteArgs = {
  siteId: Scalars['String']['input'];
};


export type MutationDeleteSiteUpdateArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteSleepCheckArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteSmsNotificationRuleArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteSopAgendaItemArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteSopCommentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteSopEpisodeArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteSopTopicArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteSphereOfInfluenceArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteSubSubTaskArgs = {
  subSubTaskId: Scalars['String']['input'];
  subtaskId: Scalars['String']['input'];
  taskId: Scalars['String']['input'];
};


export type MutationDeleteSubTaskArgs = {
  subtaskId: Scalars['String']['input'];
  taskId: Scalars['String']['input'];
};


export type MutationDeleteSubscriptionProductArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteSupplierArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteSupplierOrderArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteTaskArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteTaskMediaArgs = {
  photoUrl: Scalars['String']['input'];
  taskId: Scalars['ID']['input'];
};


export type MutationDeleteTeamArgs = {
  hardDelete?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
};


export type MutationDeleteTemperatureAlarmArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteTemperatureLogArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteTenantArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteTestResultArgs = {
  moduleId: Scalars['String']['input'];
  testItemKey: Scalars['String']['input'];
};


export type MutationDeleteTimesheetArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteTomConversationArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteTrackedCompetitionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteTranscriptionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteTranscriptionCommentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteVaccinationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteVaultInsightRuleArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteVisionBoardInviteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteVisionBoardItemArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteVisionBoardNotificationRuleArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteVlogCategoryArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteVlogNotificationRuleArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteVlogPostArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteVlogSeriesArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteVoiceContactArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteVoiceSignatureArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteVoipSnapshotArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteWaitingListChecklistItemArgs = {
  id: Scalars['ID']['input'];
  itemId: Scalars['String']['input'];
};


export type MutationDeleteWaitingListEntryArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteWalletContactArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteWaterlowAssessmentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteWorkerArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteWorkerTimeEntryArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteWoundArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDenyLeaveRequestArgs = {
  input: ReviewLeaveRequestInput;
};


export type MutationDenyShiftSwapArgs = {
  id: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};


export type MutationDeployModuleToAllClientsArgs = {
  moduleId: Scalars['String']['input'];
};


export type MutationDeployModuleToTenantArgs = {
  moduleId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};


export type MutationDeployModuleUpdateArgs = {
  moduleId: Scalars['String']['input'];
  tenantIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  version: Scalars['String']['input'];
};


export type MutationDeploySpecificModuleArgs = {
  moduleId: Scalars['String']['input'];
};


export type MutationDeregisterValidatorArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDetachInboundEmailFromOpportunityArgs = {
  inboundEmailId: Scalars['ID']['input'];
  opportunityId: Scalars['ID']['input'];
};


export type MutationDisableCallForwardingArgs = {
  phoneNumberId: Scalars['ID']['input'];
};


export type MutationDisableContactPortalAccessArgs = {
  contactId: Scalars['ID']['input'];
};


export type MutationDisableModuleForTenantArgs = {
  moduleId: Scalars['String']['input'];
  tenantId: Scalars['ID']['input'];
};


export type MutationDiscardInvoiceArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDiscardPolicyDraftArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDiscardRecipeCaptureArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDismissClub52GoalArgs = {
  goalId: Scalars['String']['input'];
};


export type MutationDismissDigitalManagerChaseArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDismissDigitalManagerOqArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDismissFailedIngestsArgs = {
  reasonContains?: InputMaybe<Scalars['String']['input']>;
  sourceId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationDismissOutstandingQuestionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDismissSmsHeldReplyArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDownloadRecordingUrlArgs = {
  recordingSid: Scalars['String']['input'];
};


export type MutationDraftBroadcastContentArgs = {
  input: DraftBroadcastInput;
};


export type MutationDraftCandidateMessageArgs = {
  input: DraftCandidateMessageInput;
};


export type MutationDraftGovProposalArgs = {
  input: DraftGovProposalInput;
};


export type MutationDraftReplyForEmailArgs = {
  input: DraftReplyForEmailInput;
};


export type MutationDraftSopEpisodeCopyArgs = {
  id: Scalars['ID']['input'];
  instruction?: InputMaybe<Scalars['String']['input']>;
};


export type MutationDraftSopEpisodeFromBriefArgs = {
  brief: Scalars['String']['input'];
  episodeId?: InputMaybe<Scalars['ID']['input']>;
  instruction?: InputMaybe<Scalars['String']['input']>;
};


export type MutationDraftUnsubscribeDemandArgs = {
  emailId: Scalars['ID']['input'];
};


export type MutationDuplicateBillWithPercentageArgs = {
  id: Scalars['ID']['input'];
  paymentTerms?: InputMaybe<Scalars['String']['input']>;
  percentage: Scalars['Float']['input'];
};


export type MutationDuplicateEmailArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDuplicateJobArgs = {
  id: Scalars['ID']['input'];
  newTitle?: InputMaybe<Scalars['String']['input']>;
};


export type MutationDuplicateP2CampaignArgs = {
  campaignId: Scalars['ID']['input'];
};


export type MutationDuplicateRecipeArgs = {
  id: Scalars['ID']['input'];
  newName?: InputMaybe<Scalars['String']['input']>;
};


export type MutationDuplicateShiftArgs = {
  id: Scalars['ID']['input'];
  newStartTime: Scalars['DateTime']['input'];
};


export type MutationDuplicateTemplateArgs = {
  newName: Scalars['String']['input'];
  templateId: Scalars['ID']['input'];
};


export type MutationEditCheckInTimesArgs = {
  checkInTime?: InputMaybe<Scalars['DateTime']['input']>;
  checkOutTime?: InputMaybe<Scalars['DateTime']['input']>;
  employeeId: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
  shiftId: Scalars['ID']['input'];
};


export type MutationEmailAllPayslipsArgs = {
  payRunId: Scalars['ID']['input'];
};


export type MutationEmailLoginBrowserApprovalArgs = {
  token: Scalars['String']['input'];
};


export type MutationEmployeeCancelUploadArgs = {
  uploadId: Scalars['String']['input'];
};


export type MutationEmployeeCompleteUploadArgs = {
  uploadId: Scalars['String']['input'];
};


export type MutationEmployeeGetUploadProgressArgs = {
  uploadId: Scalars['String']['input'];
};


export type MutationEmployeeInitiateUploadArgs = {
  fileName: Scalars['String']['input'];
  fileSize: Scalars['Float']['input'];
  totalChunks: Scalars['Float']['input'];
};


export type MutationEmployeeUploadChunkArgs = {
  chunk: Scalars['Upload']['input'];
  chunkNumber: Scalars['Float']['input'];
  uploadId: Scalars['String']['input'];
};


export type MutationEnableContactPortalAccessArgs = {
  input: EnablePortalAccessInput;
};


export type MutationEnableModuleForTenantArgs = {
  moduleId: Scalars['String']['input'];
  tenantId: Scalars['ID']['input'];
  version?: Scalars['String']['input'];
};


export type MutationEndClub52GameArgs = {
  roomName: Scalars['String']['input'];
};


export type MutationEndMeetingArgs = {
  roomName: Scalars['String']['input'];
};


export type MutationEndNeurologicalPeriodArgs = {
  id: Scalars['ID']['input'];
};


export type MutationEndRestraintArgs = {
  id: Scalars['ID']['input'];
};


export type MutationEndVoiceLeaseArgs = {
  agentKey?: InputMaybe<Scalars['String']['input']>;
  durationSec?: InputMaybe<Scalars['Int']['input']>;
  leaseId: Scalars['String']['input'];
  turns?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationEnqueueDigitalManagerOqArgs = {
  input: EnqueueDigitalManagerOqInput;
};


export type MutationEnqueueEmailAiQuestionArgs = {
  input: EnqueueEmailAiQuestionInput;
};


export type MutationEnqueueGraphExtractArgs = {
  input: GraphExtractInput;
};


export type MutationEnqueueModuleUpgradesArgs = {
  jobs: Array<ModuleUpgradeQueueJobInput>;
};


export type MutationEnqueueRollupArgs = {
  input: EnqueueRollupInput;
};


export type MutationEnrichPeopleArgs = {
  baseId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationEnrichSarahCareNoteSourceFieldsArgs = {
  apply?: Scalars['Boolean']['input'];
  rows: Array<SarahHistoricalRowInput>;
};


export type MutationEnrichSarahCareObservationContextArgs = {
  apply?: Scalars['Boolean']['input'];
  kind: Scalars['String']['input'];
  rows: Array<SarahHistoricalRowInput>;
};


export type MutationEnrolEmpowermentPersonArgs = {
  input: EnrolEmpowermentPersonInput;
};


export type MutationEnrolLeadInSequenceArgs = {
  leadId: Scalars['ID']['input'];
  sequenceId: Scalars['ID']['input'];
};


export type MutationEnsureCandidateChatRoomArgs = {
  candidateId: Scalars['ID']['input'];
};


export type MutationEnsureChatRoomArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  slug: Scalars['String']['input'];
  title: Scalars['String']['input'];
};


export type MutationEnsureSarahCareIncidentTypesArgs = {
  apply?: Scalars['Boolean']['input'];
  names: Array<Scalars['String']['input']>;
  sourceBackupDate: Scalars['DateTime']['input'];
};


export type MutationEnsureSeparationHorizonArgs = {
  caseId?: InputMaybe<Scalars['ID']['input']>;
  days?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationEnterCompetitionArgs = {
  input: EnterCompetitionInput;
};


export type MutationExecuteProposalTaskArgs = {
  input: ExecuteProposalTaskInput;
};


export type MutationExecuteWithdrawalArgs = {
  requestId: Scalars['ID']['input'];
  transactionHash?: InputMaybe<Scalars['String']['input']>;
};


export type MutationExportCipdfArgs = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
  standards?: InputMaybe<Array<CiQualityStandard>>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  statuses?: InputMaybe<Array<CiInitiativeStatus>>;
};


export type MutationExportCiStandardSummaryPdfArgs = {
  standard: CiQualityStandard;
};


export type MutationExportCarePlanToPdfArgs = {
  carePlanId: Scalars['ID']['input'];
  includeActivityLog?: InputMaybe<Scalars['Boolean']['input']>;
  residentName: Scalars['String']['input'];
};


export type MutationExportClub52WalletArgs = {
  target: Club52WalletTarget;
};


export type MutationExportGoalsSummaryToPdfArgs = {
  residentId: Scalars['ID']['input'];
  residentName: Scalars['String']['input'];
};


export type MutationExtendLeaveArgs = {
  id: Scalars['ID']['input'];
  input: ExtendLeaveInput;
};


export type MutationExtendRewardTokenExpiryArgs = {
  input: ExtendRewardTokenExpiryInput;
};


export type MutationExtractActionItemsFromTranscriptionArgs = {
  attendees?: InputMaybe<Array<Scalars['String']['input']>>;
  transcription: Scalars['String']['input'];
};


export type MutationExtractCandidateFromDocumentArgs = {
  input: CandidateExtractionInput;
};


export type MutationFinishRosterBulkOpArgs = {
  input: FinishRosterBulkOpInput;
};


export type MutationFireVaultInsightRuleNowArgs = {
  id: Scalars['ID']['input'];
};


export type MutationFixBookingMetadataArgs = {
  token: Scalars['String']['input'];
};


export type MutationFlagSarahCareWeightSourceReviewArgs = {
  apply?: Scalars['Boolean']['input'];
  rows: Array<SarahHistoricalRowInput>;
};


export type MutationFollowCompetitionArgs = {
  competitionId: Scalars['ID']['input'];
};


export type MutationForceRetryMeetTranscriptionArgs = {
  recordingId: Scalars['ID']['input'];
  roomName: Scalars['String']['input'];
};


export type MutationForceRetryTranscriptionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationFundClub52PlayerArgs = {
  input: FundClub52PlayerInput;
};


export type MutationGenerateAccountSnapshotArgs = {
  dateFrom?: InputMaybe<Scalars['String']['input']>;
  dateTo?: InputMaybe<Scalars['String']['input']>;
  days?: Scalars['Int']['input'];
  mailbox: Scalars['String']['input'];
  period?: SnapshotPeriod;
};


export type MutationGenerateBillsWeeklySnapshotArgs = {
  weekStartDay?: InputMaybe<Scalars['String']['input']>;
};


export type MutationGenerateClub52WalletArgs = {
  target: Club52WalletTarget;
};


export type MutationGenerateDailyCareCalendarEventsArgs = {
  calendarId: Scalars['String']['input'];
  residentId: Scalars['ID']['input'];
  residentName: Scalars['String']['input'];
};


export type MutationGenerateDroneSessionShareLinkArgs = {
  expiresInDays?: InputMaybe<Scalars['Float']['input']>;
  sessionId: Scalars['ID']['input'];
};


export type MutationGenerateEmployeeCredentialsArgs = {
  employeeId: Scalars['ID']['input'];
  sendSms?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationGenerateHeroImageArgs = {
  prompt: Scalars['String']['input'];
  style?: InputMaybe<Scalars['String']['input']>;
};


export type MutationGenerateInboxSummaryNowArgs = {
  input: GenerateInboxSummaryInput;
};


export type MutationGenerateInvoiceFromPProposalArgs = {
  id: Scalars['ID']['input'];
  paymentIndex: Scalars['Int']['input'];
};


export type MutationGenerateLocationQrCodeArgs = {
  id: Scalars['ID']['input'];
};


export type MutationGenerateMealPlanAiArgs = {
  input: GenerateMealPlanAiInput;
};


export type MutationGenerateMeetRecordingSummaryArgs = {
  model?: InputMaybe<Scalars['String']['input']>;
  recordingId: Scalars['ID']['input'];
  roomName: Scalars['String']['input'];
};


export type MutationGenerateOrdersFromMealPlansArgs = {
  input: GenerateOrdersInput;
};


export type MutationGeneratePasswordLinkArgs = {
  expiresInHours?: Scalars['Float']['input'];
  passwordId: Scalars['ID']['input'];
};


export type MutationGenerateProgramDownpaymentBillArgs = {
  downpaymentAmountCents: Scalars['Int']['input'];
  introducerContactId?: InputMaybe<Scalars['ID']['input']>;
  memberId: Scalars['ID']['input'];
};


export type MutationGenerateQrCodeArgs = {
  input: GenerateQrCodeInput;
};


export type MutationGenerateRollupSnapshotArgs = {
  dateFrom: Scalars['String']['input'];
  dateTo: Scalars['String']['input'];
  mailboxes?: InputMaybe<Array<Scalars['String']['input']>>;
  period?: SnapshotPeriod;
  scope: SnapshotScope;
  subjectKey?: InputMaybe<Scalars['String']['input']>;
  subjectLabel?: InputMaybe<Scalars['String']['input']>;
};


export type MutationGenerateSeparationCareBlocksArgs = {
  caseId?: InputMaybe<Scalars['ID']['input']>;
  fromDayKey: Scalars['String']['input'];
  toDayKey: Scalars['String']['input'];
};


export type MutationGenerateShareTokenArgs = {
  id: Scalars['ID']['input'];
};


export type MutationGenerateSiteSpecArgs = {
  input: GenerateSiteSpecInput;
};


export type MutationGenerateTasksFromEmailArgs = {
  input: GenerateTasksFromEmailInput;
};


export type MutationGenerateTranscriptionPlanArgs = {
  clientSlugs: Array<Scalars['String']['input']>;
  knownTenantSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  moduleCodebases: Array<Scalars['String']['input']>;
  projectSlugs: Array<Scalars['String']['input']>;
  transcriptionId: Scalars['ID']['input'];
};


export type MutationGenerateTranscriptionSummaryArgs = {
  id: Scalars['ID']['input'];
  model?: InputMaybe<Scalars['String']['input']>;
};


export type MutationGenerateVideoThumbnailArgs = {
  id: Scalars['String']['input'];
  timestamp?: InputMaybe<Scalars['Float']['input']>;
};


export type MutationGenerateVoipSnapshotArgs = {
  days?: Scalars['Int']['input'];
  number?: InputMaybe<Scalars['String']['input']>;
  period?: VoipSnapshotPeriod;
};


export type MutationGetClub52TokenArgs = {
  roomName: Scalars['String']['input'];
};


export type MutationGetGuestClub52TokenArgs = {
  input: GuestClub52TokenInput;
};


export type MutationGetGuestMeetTokenArgs = {
  input: GuestMeetTokenInput;
};


export type MutationGetMeetTokenArgs = {
  roomName: Scalars['String']['input'];
};


export type MutationGrantGovTokensArgs = {
  amount: Scalars['Float']['input'];
  memberId: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
  workItemId: Scalars['ID']['input'];
};


export type MutationGrantMedicalAccessArgs = {
  input: GrantMedicalAccessInput;
};


export type MutationGrantSponsoredSeparationAccessArgs = {
  input: SeparationAllocateInput;
};


export type MutationImportBusinessListingsArgs = {
  input: Array<BusinessListingImportRow>;
  options?: InputMaybe<BusinessListingImportOptions>;
};


export type MutationImportCellcastHistoryArgs = {
  input?: InputMaybe<ImportCellcastHistoryInput>;
};


export type MutationImportLaunchedSiteArgs = {
  input: ImportLaunchedSiteInput;
};


export type MutationImportLineItemsFromMarkdownArgs = {
  billId: Scalars['ID']['input'];
  markdown: Scalars['String']['input'];
};


export type MutationImportPolicyDocumentArgs = {
  file: Scalars['Upload']['input'];
  publish?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationImportPolicyMarkdownArgs = {
  input: ImportPolicyMarkdownInput;
};


export type MutationImportQldPublicHolidaysArgs = {
  csvUrl?: InputMaybe<Scalars['String']['input']>;
  years: Array<Scalars['Int']['input']>;
};


export type MutationImportSarahCareAbbeyPainArgs = {
  apply?: Scalars['Boolean']['input'];
  rows: Array<SarahHistoricalRowInput>;
};


export type MutationImportSarahCareAcfiAssessmentsArgs = {
  apply?: Scalars['Boolean']['input'];
  rows: Array<SarahHistoricalRowInput>;
};


export type MutationImportSarahCareAdmissionSnapshotsArgs = {
  apply?: Scalars['Boolean']['input'];
  kind: SarahAdmissionSnapshotKind;
  rows: Array<SarahHistoricalRowInput>;
};


export type MutationImportSarahCareAnaccClassificationsArgs = {
  apply?: Scalars['Boolean']['input'];
  rows: Array<SarahHistoricalRowInput>;
  table: Scalars['String']['input'];
};


export type MutationImportSarahCareBondsArgs = {
  apply?: Scalars['Boolean']['input'];
  rows: Array<SarahHistoricalRowInput>;
};


export type MutationImportSarahCareBowelRecordsArgs = {
  apply?: Scalars['Boolean']['input'];
  rows: Array<SarahHistoricalRowInput>;
};


export type MutationImportSarahCareBradenArgs = {
  apply?: Scalars['Boolean']['input'];
  rows: Array<SarahHistoricalRowInput>;
};


export type MutationImportSarahCareCarePlanHistoryArgs = {
  apply?: Scalars['Boolean']['input'];
  rows: Array<SarahHistoricalRowInput>;
  table: Scalars['String']['input'];
};


export type MutationImportSarahCareContactCallsArgs = {
  apply?: Scalars['Boolean']['input'];
  rows: Array<SarahHistoricalRowInput>;
};


export type MutationImportSarahCareContactHistoryArgs = {
  apply?: Scalars['Boolean']['input'];
  overrideHeldSourceIds?: InputMaybe<Array<Scalars['String']['input']>>;
  rows: Array<SarahHistoricalRowInput>;
};


export type MutationImportSarahCareDailyCareHistoryArgs = {
  apply?: Scalars['Boolean']['input'];
  rows: Array<SarahHistoricalRowInput>;
  table: Scalars['String']['input'];
};


export type MutationImportSarahCareFallsRiskArgs = {
  apply?: Scalars['Boolean']['input'];
  rows: Array<SarahHistoricalRowInput>;
};


export type MutationImportSarahCareFluidBalanceArgs = {
  apply?: Scalars['Boolean']['input'];
  rows: Array<SarahHistoricalRowInput>;
};


export type MutationImportSarahCareFoodIntakeArgs = {
  apply?: Scalars['Boolean']['input'];
  rows: Array<SarahHistoricalRowInput>;
};


export type MutationImportSarahCareHistoricalAssessmentsArgs = {
  apply?: Scalars['Boolean']['input'];
  rows: Array<SarahHistoricalRowInput>;
  table: Scalars['String']['input'];
};


export type MutationImportSarahCareIncidentsArgs = {
  apply?: Scalars['Boolean']['input'];
  rows: Array<SarahHistoricalRowInput>;
  table: Scalars['String']['input'];
};


export type MutationImportSarahCareLeaveArgs = {
  apply?: Scalars['Boolean']['input'];
  rows: Array<SarahHistoricalRowInput>;
};


export type MutationImportSarahCareMedicalAssessmentsArgs = {
  apply?: Scalars['Boolean']['input'];
  rows: Array<SarahHistoricalRowInput>;
};


export type MutationImportSarahCareMedicalFileArgs = {
  input: ImportSarahMedicalFileInput;
};


export type MutationImportSarahCareMobilityAidsArgs = {
  apply?: Scalars['Boolean']['input'];
  rows: Array<SarahHistoricalRowInput>;
};


export type MutationImportSarahCareMobilityChangesArgs = {
  apply?: Scalars['Boolean']['input'];
  rows: Array<SarahHistoricalRowInput>;
};


export type MutationImportSarahCareNoteFollowupsArgs = {
  apply?: Scalars['Boolean']['input'];
  rows: Array<SarahHistoricalRowInput>;
};


export type MutationImportSarahCareObservationsArgs = {
  apply?: Scalars['Boolean']['input'];
  kind: Scalars['String']['input'];
  rows: Array<SarahHistoricalRowInput>;
};


export type MutationImportSarahCarePainChartArgs = {
  apply?: Scalars['Boolean']['input'];
  rows: Array<SarahHistoricalRowInput>;
};


export type MutationImportSarahCarePainChartPeriodsArgs = {
  apply?: Scalars['Boolean']['input'];
  rows: Array<SarahHistoricalRowInput>;
};


export type MutationImportSarahCareProgressNotesArgs = {
  apply?: Scalars['Boolean']['input'];
  rows: Array<SarahHistoricalRowInput>;
};


export type MutationImportSarahCareReferralTasksArgs = {
  apply?: Scalars['Boolean']['input'];
  rows: Array<SarahHistoricalRowInput>;
};


export type MutationImportSarahCareRepositioningChecksArgs = {
  apply?: Scalars['Boolean']['input'];
  rows: Array<SarahHistoricalRowInput>;
};


export type MutationImportSarahCareResidentPhotoPointersArgs = {
  apply?: Scalars['Boolean']['input'];
  rows: Array<SarahCareResidentPhotoPointerInput>;
};


export type MutationImportSarahCareResidentsArgs = {
  apply?: Scalars['Boolean']['input'];
  rows: Array<SarahResidentCreateRowInput>;
};


export type MutationImportSarahCareRespiteStaysArgs = {
  apply?: Scalars['Boolean']['input'];
  rows: Array<SarahHistoricalRowInput>;
};


export type MutationImportSarahCareRestraintChecksArgs = {
  apply?: Scalars['Boolean']['input'];
  rows: Array<SarahHistoricalRowInput>;
};


export type MutationImportSarahCareRestraintsArgs = {
  apply?: Scalars['Boolean']['input'];
  rows: Array<SarahHistoricalRowInput>;
};


export type MutationImportSarahCareReviewHistoryArgs = {
  apply?: Scalars['Boolean']['input'];
  rows: Array<SarahHistoricalRowInput>;
};


export type MutationImportSarahCareSleepChecksArgs = {
  apply?: Scalars['Boolean']['input'];
  rows: Array<SarahHistoricalRowInput>;
};


export type MutationImportSarahCareVaccinationsArgs = {
  apply?: Scalars['Boolean']['input'];
  rows: Array<SarahHistoricalRowInput>;
  table: Scalars['String']['input'];
};


export type MutationImportSarahCareVoidedNotesArgs = {
  apply?: Scalars['Boolean']['input'];
  rows: Array<SarahHistoricalRowInput>;
};


export type MutationImportSarahCareWaitingListArgs = {
  apply?: Scalars['Boolean']['input'];
  rows: Array<SarahWaitingListRowInput>;
};


export type MutationImportSarahCareWoundAssessmentsArgs = {
  apply?: Scalars['Boolean']['input'];
  rows: Array<SarahHistoricalRowInput>;
};


export type MutationImportSarahCareWoundsArgs = {
  apply?: Scalars['Boolean']['input'];
  rows: Array<SarahHistoricalRowInput>;
};


export type MutationImportTasksFromMarkdownArgs = {
  markdown: Scalars['String']['input'];
  projectId: Scalars['ID']['input'];
};


export type MutationImportTrackedCompetitionsArgs = {
  json: Scalars['String']['input'];
};


export type MutationImproveDescriptionArgs = {
  context?: InputMaybe<Scalars['String']['input']>;
  text: Scalars['String']['input'];
};


export type MutationImproveOutgoingEmailArgs = {
  emailContent: Scalars['String']['input'];
  subject?: InputMaybe<Scalars['String']['input']>;
};


export type MutationImproveTaglineArgs = {
  context?: InputMaybe<Scalars['String']['input']>;
  text: Scalars['String']['input'];
};


export type MutationImproveTextArgs = {
  context?: InputMaybe<Scalars['String']['input']>;
  text: Scalars['String']['input'];
  type: Scalars['String']['input'];
};


export type MutationIncrementPostViewArgs = {
  postId: Scalars['ID']['input'];
  sessionId: Scalars['String']['input'];
};


export type MutationIncrementSopEpisodeViewArgs = {
  slug: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};


export type MutationIncrementVlogPostViewArgs = {
  postId: Scalars['ID']['input'];
  sessionId: Scalars['String']['input'];
};


export type MutationIngestMicrosoftEmailArgs = {
  input: IngestMicrosoftEmailInput;
};


export type MutationIngestSummaryTrainingReplyArgs = {
  input: IngestTrainingReplyInput;
};


export type MutationIngestVoipCallArgs = {
  input: IngestVoipCallInput;
};


export type MutationInitializeAdmissionChecklistArgs = {
  residentId: Scalars['ID']['input'];
};


export type MutationInviteCoParentArgs = {
  input: CreateCoParentInviteInput;
};


export type MutationInviteCommunityMemberToMeetArgs = {
  memberClientId: Scalars['ID']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};


export type MutationInviteFromRecommendationArgs = {
  id: Scalars['ID']['input'];
  input: CreateEmployeeInviteInput;
};


export type MutationInviteProgramMemberArgs = {
  input: InviteProgramMemberInput;
};


export type MutationInviteSiteOwnerArgs = {
  siteId: Scalars['ID']['input'];
};


export type MutationInviteToSopEpisodeArgs = {
  clientIds: Array<Scalars['ID']['input']>;
  episodeId: Scalars['ID']['input'];
};


export type MutationIssueGovMembershipBillsArgs = {
  memberIds: Array<Scalars['ID']['input']>;
  organisationId: Scalars['ID']['input'];
};


export type MutationIssueMonthlyBillsArgs = {
  billingPeriod?: InputMaybe<Scalars['String']['input']>;
};


export type MutationIssuePreorderInvoicesForCampaignArgs = {
  campaignId: Scalars['ID']['input'];
  tierIndex: Scalars['Int']['input'];
};


export type MutationIssueProRataBillArgs = {
  endDate: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
  subscriptionId: Scalars['ID']['input'];
};


export type MutationIssueRewardTokenArgs = {
  input: IssueRewardTokenInput;
};


export type MutationIssueSingleSubscriptionBillArgs = {
  allowDuplicate?: InputMaybe<Scalars['Boolean']['input']>;
  asDraft?: InputMaybe<Scalars['Boolean']['input']>;
  billingPeriod?: InputMaybe<Scalars['String']['input']>;
  subscriptionId: Scalars['ID']['input'];
};


export type MutationIssueSubscriptionBillsArgs = {
  billingPeriod?: InputMaybe<Scalars['String']['input']>;
};


export type MutationJoinChatRoomArgs = {
  anonToken?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  roomId: Scalars['ID']['input'];
};


export type MutationJoinWaitlistArgs = {
  input: JoinWaitlistInput;
};


export type MutationLabelMonitorIncidentArgs = {
  id: Scalars['String']['input'];
  label: MonitorIncidentLabel;
};


export type MutationLinkAnonymousChatIdentityArgs = {
  anonToken: Scalars['String']['input'];
};


export type MutationLinkBillToEventArgs = {
  billId?: InputMaybe<Scalars['ID']['input']>;
  eventId: Scalars['ID']['input'];
};


export type MutationLinkCiIssueToInitiativeArgs = {
  initiativeId: Scalars['ID']['input'];
  issueId: Scalars['ID']['input'];
};


export type MutationLinkCiIssueToMeetingArgs = {
  issueId: Scalars['ID']['input'];
  meetingId: Scalars['ID']['input'];
};


export type MutationLinkCalculatorSubmissionToClientArgs = {
  input: LinkSubmissionToClientInput;
};


export type MutationLinkCommsSmsAppArgs = {
  appName: Scalars['String']['input'];
};


export type MutationLinkDailyCareProfileToCarePlanArgs = {
  carePlanId: Scalars['ID']['input'];
  profileId: Scalars['ID']['input'];
};


export type MutationLinkEmailToAccountArgs = {
  code: Scalars['String']['input'];
  email: Scalars['String']['input'];
};


export type MutationLinkEmpowermentTranscriptionArgs = {
  input: LinkEmpowermentTranscriptionInput;
};


export type MutationLinkFeedbackOutcomeArgs = {
  input: LinkFeedbackOutcomeInput;
};


export type MutationLinkInitiativeToIssueArgs = {
  initiativeId: Scalars['ID']['input'];
  issueId: Scalars['ID']['input'];
};


export type MutationLinkInitiativeToMaintenanceArgs = {
  initiativeId: Scalars['ID']['input'];
  input: LinkMaintenanceRequestInput;
};


export type MutationLinkInitiativeToMeetingArgs = {
  initiativeId: Scalars['ID']['input'];
  meetingId: Scalars['ID']['input'];
};


export type MutationLinkInvoiceToOrderArgs = {
  id: Scalars['ID']['input'];
  orderId: Scalars['ID']['input'];
};


export type MutationLinkMaintenanceToCiInitiativeArgs = {
  id: Scalars['ID']['input'];
  input: LinkMaintenanceToCiInitiativeInput;
};


export type MutationLinkMaintenanceToCiIssueArgs = {
  id: Scalars['ID']['input'];
  input: LinkMaintenanceToCiIssueInput;
};


export type MutationLinkMaintenanceToCiStandardArgs = {
  id: Scalars['ID']['input'];
  input: LinkMaintenanceToCiStandardInput;
};


export type MutationLinkPProposalToOpportunityArgs = {
  opportunityId: Scalars['ID']['input'];
  proposalId: Scalars['ID']['input'];
};


export type MutationLinkPhoneToAccountArgs = {
  code: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
};


export type MutationLinkSarahCareContactHistoryArgs = {
  apply?: Scalars['Boolean']['input'];
  residentIds: Array<Scalars['ID']['input']>;
};


export type MutationLinkTrustPersonCalendarArgs = {
  calendarId: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};


export type MutationLinkWalletKeyArgs = {
  input: EnrolWalletKeyInput;
};


export type MutationLmAdminEnrollUserArgs = {
  courseId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type MutationLmAdminUnenrollUserArgs = {
  enrollmentId: Scalars['ID']['input'];
};


export type MutationLmCreateCourseArgs = {
  input: LmCourseInput;
};


export type MutationLmCreateLessonArgs = {
  input: LmLessonInput;
  moduleId: Scalars['ID']['input'];
};


export type MutationLmCreateModuleArgs = {
  courseId: Scalars['ID']['input'];
  input: LmModuleInput;
};


export type MutationLmDeleteCourseArgs = {
  courseId: Scalars['ID']['input'];
};


export type MutationLmDeleteLessonArgs = {
  lessonId: Scalars['ID']['input'];
};


export type MutationLmDeleteModuleArgs = {
  moduleId: Scalars['ID']['input'];
};


export type MutationLmEnrollUserArgs = {
  courseId: Scalars['ID']['input'];
};


export type MutationLmGenerateCertificateArgs = {
  courseId: Scalars['ID']['input'];
};


export type MutationLmGenerateLessonContentArgs = {
  input: LmGenerateLessonContentInput;
};


export type MutationLmMarkLessonCompleteArgs = {
  lessonId: Scalars['ID']['input'];
};


export type MutationLmMarkLessonIncompleteArgs = {
  lessonId: Scalars['ID']['input'];
};


export type MutationLmReorderLessonsArgs = {
  lessonIds: Array<Scalars['ID']['input']>;
  moduleId: Scalars['ID']['input'];
};


export type MutationLmReorderModulesArgs = {
  courseId: Scalars['ID']['input'];
  moduleIds: Array<Scalars['ID']['input']>;
};


export type MutationLmSetCourseAuthorsArgs = {
  clientIds: Array<Scalars['ID']['input']>;
  courseId: Scalars['ID']['input'];
};


export type MutationLmSetSkinPreferenceArgs = {
  skinId: Scalars['String']['input'];
};


export type MutationLmToggleReminderOptOutArgs = {
  courseId: Scalars['ID']['input'];
  optOut: Scalars['Boolean']['input'];
};


export type MutationLmUnenrollUserArgs = {
  courseId: Scalars['ID']['input'];
};


export type MutationLmUpdateCourseArgs = {
  courseId: Scalars['ID']['input'];
  input: LmCourseInput;
};


export type MutationLmUpdateLessonArgs = {
  input: LmLessonInput;
  lessonId: Scalars['ID']['input'];
};


export type MutationLmUpdateModuleArgs = {
  input: LmModuleInput;
  moduleId: Scalars['ID']['input'];
};


export type MutationLodgeStpPayloadArgs = {
  input: LodgeStpInput;
};


export type MutationLogCareHomeContactArgs = {
  input: CareHomeContactInput;
};


export type MutationLogWaitingListCheckInArgs = {
  id: Scalars['ID']['input'];
  input: LogWaitingListCheckInInput;
};


export type MutationLoginWithUsernameArgs = {
  input: LoginWithUsernameInput;
};


export type MutationMakeOutboundCallArgs = {
  from?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
};


export type MutationMakeRewardTokenPayableArgs = {
  tokenId: Scalars['ID']['input'];
};


export type MutationManagerCreateShiftSwapArgs = {
  employeeAId: Scalars['ID']['input'];
  input: RequestShiftSwapInput;
};


export type MutationMapInvoiceLineToIngredientArgs = {
  ingredientId: Scalars['ID']['input'];
  invoiceId: Scalars['ID']['input'];
  lineIndex: Scalars['Int']['input'];
};


export type MutationMapMeetVoiceSignatureArgs = {
  input: MapMeetVoiceSignatureInput;
};


export type MutationMapVoiceSignatureArgs = {
  input: MapVoiceSignatureInput;
};


export type MutationMarkAgentJobsReviewedArgs = {
  input: MarkAgentJobsReviewedInput;
};


export type MutationMarkAllInboundEmailsAsReadArgs = {
  folder?: InputMaybe<Scalars['String']['input']>;
};


export type MutationMarkBdayInviteSentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationMarkBillAsSentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationMarkCalculatorSubmissionSentToPipedriveArgs = {
  pipedriveId: Scalars['String']['input'];
  submissionId: Scalars['ID']['input'];
};


export type MutationMarkCheckInReviewedArgs = {
  checkInId: Scalars['ID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
};


export type MutationMarkCommunityPinnedVideoSeenArgs = {
  videoKey: Scalars['String']['input'];
};


export type MutationMarkEmailAsReadArgs = {
  emailId: Scalars['String']['input'];
};


export type MutationMarkEmailAsSpamArgs = {
  emailId: Scalars['ID']['input'];
  scope?: InputMaybe<Scalars['String']['input']>;
};


export type MutationMarkFileUploadedArgs = {
  cloudUrl: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  ipfsHash: Scalars['String']['input'];
  mediaItemId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationMarkFileVerifiedArgs = {
  id: Scalars['ID']['input'];
};


export type MutationMarkInboundEmailAsReadArgs = {
  id: Scalars['ID']['input'];
  isRead: Scalars['Boolean']['input'];
};


export type MutationMarkInboundEmailsReadArgs = {
  ids: Array<Scalars['ID']['input']>;
  isRead?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationMarkIncidentAlertReadArgs = {
  id: Scalars['ID']['input'];
};


export type MutationMarkLocalDeletedArgs = {
  id: Scalars['ID']['input'];
};


export type MutationMarkLocationCleanedArgs = {
  id: Scalars['ID']['input'];
};


export type MutationMarkLocationInspectedArgs = {
  id: Scalars['ID']['input'];
};


export type MutationMarkMealPlanNotificationReadArgs = {
  id: Scalars['ID']['input'];
};


export type MutationMarkMilestoneCompleteArgs = {
  configId: Scalars['String']['input'];
  milestoneId: Scalars['String']['input'];
};


export type MutationMarkMonthlyRoomCheckCompletedArgs = {
  id: Scalars['ID']['input'];
  input?: InputMaybe<MarkMonthlyRoomCheckCompletedInput>;
};


export type MutationMarkNotAttendingArgs = {
  announce?: InputMaybe<Scalars['Boolean']['input']>;
  announceChannels?: InputMaybe<Array<Scalars['String']['input']>>;
  reason?: InputMaybe<Scalars['String']['input']>;
  shiftId: Scalars['ID']['input'];
};


export type MutationMarkNotificationReadArgs = {
  id: Scalars['ID']['input'];
};


export type MutationMarkOrderDeliveredArgs = {
  input: MarkDeliveredInput;
};


export type MutationMarkPhoneScreeningCompleteArgs = {
  advanceToShortlist?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
};


export type MutationMarkPublicHolidayNotWorkedArgs = {
  date: Scalars['DateTime']['input'];
  departmentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  employeeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  onlyNonShiftWorkers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationMarkRespiteUsedArgs = {
  id: Scalars['ID']['input'];
  input?: InputMaybe<MarkRespiteUsedInput>;
};


export type MutationMarkRewardPayoutPaidArgs = {
  input: MarkRewardPayoutPaidInput;
};


export type MutationMarkStayedTillEndArgs = {
  id: Scalars['ID']['input'];
};


export type MutationMarkUpgradeAppliedArgs = {
  input: MarkUpgradeAppliedInput;
};


export type MutationMarkWaitingListEntryAdmittedArgs = {
  entryId: Scalars['ID']['input'];
  residentId: Scalars['ID']['input'];
};


export type MutationMasterBulkDeleteMediaFilesArgs = {
  ids: Array<Scalars['String']['input']>;
  source: Scalars['String']['input'];
  unpinFromIPFS?: Scalars['Boolean']['input'];
};


export type MutationMasterDeleteMediaFileArgs = {
  id: Scalars['String']['input'];
  source: Scalars['String']['input'];
  unpinFromIPFS?: Scalars['Boolean']['input'];
};


export type MutationMasterUnpinOrphanedFilesArgs = {
  cids: Array<Scalars['String']['input']>;
};


export type MutationMediaCdnCancelUploadArgs = {
  uploadId: Scalars['String']['input'];
};


export type MutationMediaCdnCompleteUploadArgs = {
  uploadId: Scalars['String']['input'];
};


export type MutationMediaCdnGetUploadProgressArgs = {
  uploadId: Scalars['String']['input'];
};


export type MutationMediaCdnInitiateUploadArgs = {
  fileName: Scalars['String']['input'];
  fileSize: Scalars['Float']['input'];
  totalChunks: Scalars['Float']['input'];
};


export type MutationMediaCdnUploadChunkArgs = {
  chunk: Scalars['Upload']['input'];
  chunkNumber: Scalars['Float']['input'];
  uploadId: Scalars['String']['input'];
};


export type MutationMergeClientAccountsArgs = {
  hardDelete?: InputMaybe<Scalars['Boolean']['input']>;
  keepClientId: Scalars['ID']['input'];
  mergeClientIds: Array<Scalars['ID']['input']>;
};


export type MutationMergeClientsArgs = {
  keepClientId: Scalars['ID']['input'];
  mergeClientIds: Array<Scalars['ID']['input']>;
};


export type MutationMergeMySiteToMainArgs = {
  commitMessage?: InputMaybe<Scalars['String']['input']>;
};


export type MutationMigrateSeparationJourneyProgressArgs = {
  input: SeparationJourneyMigrateInput;
};


export type MutationModerateSopCommentArgs = {
  id: Scalars['ID']['input'];
  input: ModerateSopCommentInput;
};


export type MutationMoveEmployeeOnChartArgs = {
  input: MoveEmployeeOnChartInput;
};


export type MutationMoveGoalToMonthArgs = {
  id: Scalars['String']['input'];
  month: Scalars['String']['input'];
};


export type MutationMoveInboundEmailToFolderArgs = {
  folder: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};


export type MutationMoveInboundEmailsToFolderArgs = {
  input: MoveInboundEmailsInput;
};


export type MutationMoveMediaItemArgs = {
  folderId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
};


export type MutationMoveOpportunityStageArgs = {
  id: Scalars['String']['input'];
  newStage: Scalars['String']['input'];
};


export type MutationMoveOrgChartPlacementArgs = {
  input: MoveOrgChartPlacementInput;
};


export type MutationMoveWaitingListEntryStageArgs = {
  id: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
  stage: WaitingListStage;
};


export type MutationNotifyClientActivityMentionsArgs = {
  input: ClientMentionNotifyInput;
};


export type MutationNotifyGovMentionsArgs = {
  choices: Array<GovMentionNotifyChoiceInput>;
  commentId?: InputMaybe<Scalars['ID']['input']>;
  entryId: Scalars['ID']['input'];
};


export type MutationNotifyTranscriptionEmailArgs = {
  recipientEmail: Scalars['String']['input'];
  transcriptionId: Scalars['ID']['input'];
};


export type MutationOfferCompetitionPrintsArgs = {
  entryId: Scalars['ID']['input'];
  input: OfferCompetitionPrintsInput;
};


export type MutationOnboardClientArgs = {
  input: OnboardClientInput;
};


export type MutationOpenEmpowermentCheckInNowArgs = {
  checkInId: Scalars['ID']['input'];
};


export type MutationOpenGovProposalArgs = {
  closesAt?: InputMaybe<Scalars['DateTime']['input']>;
  id: Scalars['ID']['input'];
};


export type MutationP2AddToCartArgs = {
  input: P2CartItemInput;
};


export type MutationP2ClearCartArgs = {
  cartId: Scalars['ID']['input'];
};


export type MutationP2CreateSetupIntentArgs = {
  clientId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationP2RemoveFromCartArgs = {
  cartId: Scalars['ID']['input'];
  itemId: Scalars['ID']['input'];
};


export type MutationP2RemoveSavedCardArgs = {
  id: Scalars['ID']['input'];
};


export type MutationP2SavePaymentMethodArgs = {
  input: P2SavePaymentMethodInput;
};


export type MutationPauseDigitalManagerArgs = {
  id: Scalars['ID']['input'];
};


export type MutationPauseJobArgs = {
  id: Scalars['ID']['input'];
};


export type MutationPauseSubscriptionArgs = {
  subscriptionId: Scalars['ID']['input'];
};


export type MutationPayBillOnTheHouseArgs = {
  billId: Scalars['ID']['input'];
};


export type MutationPaySeparationCommissionArgs = {
  affiliateId: Scalars['ID']['input'];
  amount: Scalars['Float']['input'];
  reference?: InputMaybe<Scalars['String']['input']>;
  referralIds: Array<Scalars['ID']['input']>;
};


export type MutationPermanentlyDeleteRecipeArgs = {
  id: Scalars['ID']['input'];
};


export type MutationPermanentlyDeleteResidentContactArgs = {
  id: Scalars['ID']['input'];
};


export type MutationPinCalendarArgs = {
  calendarId: Scalars['String']['input'];
};


export type MutationPlaceEmployeeAsSiblingOfEmployeeOnChartArgs = {
  input: PlaceEmployeeAsSiblingInput;
};


export type MutationPollEmailLoginBrowserArgs = {
  token: Scalars['String']['input'];
};


export type MutationPollSmsLoginBrowserArgs = {
  token: Scalars['String']['input'];
};


export type MutationPostBondRetentionArgs = {
  amount: Scalars['Float']['input'];
  bondId: Scalars['ID']['input'];
  transactionRef?: InputMaybe<Scalars['String']['input']>;
};


export type MutationPrettyUpEventCopyArgs = {
  input: PrettyUpEventCopyInput;
};


export type MutationProbeExtractionModelArgs = {
  model: Scalars['String']['input'];
};


export type MutationProcessAdmissionArgs = {
  input: AdmitResidentInput;
  residentId: Scalars['ID']['input'];
};


export type MutationProcessBondPayoutArgs = {
  bondId: Scalars['ID']['input'];
  input: BondPayoutInput;
};


export type MutationProcessDischargeArgs = {
  input: DischargeResidentInput;
  residentId: Scalars['ID']['input'];
};


export type MutationProcessGuaranteeRefundArgs = {
  claimId: Scalars['ID']['input'];
};


export type MutationProcessInboundEmailWithAiArgs = {
  inboundEmailId: Scalars['ID']['input'];
};


export type MutationPromoteFromWaitingListArgs = {
  input: PromoteFromWaitingListInput;
};


export type MutationPromoteSarahCareResidentFieldsArgs = {
  apply?: Scalars['Boolean']['input'];
  rows: Array<SarahResidentPromotionRowInput>;
};


export type MutationPromoteShiftsToMasterArgs = {
  endDate: Scalars['DateTime']['input'];
  startDate: Scalars['DateTime']['input'];
};


export type MutationProposeEmailAiActionArgs = {
  inboundEmailId: Scalars['ID']['input'];
  instruction: Scalars['String']['input'];
  scopeHints?: InputMaybe<ProposeEmailAiActionScopeHintsInput>;
};


export type MutationProposeGovJobSpecArgs = {
  id: Scalars['ID']['input'];
};


export type MutationProvisionCoachCalendarArgs = {
  id: Scalars['ID']['input'];
};


export type MutationProvisionDigitalManagerArgs = {
  input: ProvisionDigitalManagerInput;
};


export type MutationProvisionEmployeeWorkEmailArgs = {
  employeeId: Scalars['String']['input'];
  mailNickname: Scalars['String']['input'];
};


export type MutationProvisionSiteArgs = {
  launchedSiteId: Scalars['ID']['input'];
};


export type MutationProvisionSiteEditorSiteArgs = {
  siteId: Scalars['String']['input'];
};


export type MutationPublicFeedbackMediaCompleteUploadArgs = {
  uploadId: Scalars['String']['input'];
};


export type MutationPublicFeedbackMediaInitiateUploadArgs = {
  fileName: Scalars['String']['input'];
  fileSize: Scalars['Float']['input'];
  totalChunks: Scalars['Float']['input'];
};


export type MutationPublicFeedbackMediaUploadChunkArgs = {
  chunk: Scalars['Upload']['input'];
  chunkNumber: Scalars['Float']['input'];
  uploadId: Scalars['String']['input'];
};


export type MutationPublicMaintenanceMediaCompleteUploadArgs = {
  uploadId: Scalars['String']['input'];
};


export type MutationPublicMaintenanceMediaInitiateUploadArgs = {
  fileName: Scalars['String']['input'];
  fileSize: Scalars['Float']['input'];
  totalChunks: Scalars['Float']['input'];
};


export type MutationPublicMaintenanceMediaUploadChunkArgs = {
  chunk: Scalars['Upload']['input'];
  chunkNumber: Scalars['Float']['input'];
  uploadId: Scalars['String']['input'];
};


export type MutationPublicMealMediaCompleteUploadArgs = {
  uploadId: Scalars['String']['input'];
};


export type MutationPublicMealMediaInitiateUploadArgs = {
  fileName: Scalars['String']['input'];
  fileSize: Scalars['Float']['input'];
  totalChunks: Scalars['Float']['input'];
};


export type MutationPublicMealMediaUploadChunkArgs = {
  chunk: Scalars['Upload']['input'];
  chunkNumber: Scalars['Float']['input'];
  uploadId: Scalars['String']['input'];
};


export type MutationPublicMediaCdnCompleteUploadArgs = {
  uploadId: Scalars['String']['input'];
};


export type MutationPublicMediaCdnInitiateUploadArgs = {
  fileName: Scalars['String']['input'];
  fileSize: Scalars['Float']['input'];
  formSlug: Scalars['String']['input'];
  totalChunks: Scalars['Float']['input'];
};


export type MutationPublicMediaCdnUploadChunkArgs = {
  chunk: Scalars['Upload']['input'];
  chunkNumber: Scalars['Float']['input'];
  uploadId: Scalars['String']['input'];
};


export type MutationPublicSiteTrackerMediaCompleteUploadArgs = {
  uploadId: Scalars['String']['input'];
};


export type MutationPublicSiteTrackerMediaInitiateUploadArgs = {
  fileName: Scalars['String']['input'];
  fileSize: Scalars['Float']['input'];
  totalChunks: Scalars['Float']['input'];
};


export type MutationPublicSiteTrackerMediaUploadChunkArgs = {
  chunk: Scalars['Upload']['input'];
  chunkNumber: Scalars['Float']['input'];
  uploadId: Scalars['String']['input'];
};


export type MutationPublicSubmitBankTransferPaymentArgs = {
  amount: Scalars['Float']['input'];
  billId: Scalars['ID']['input'];
  screenshotUrl?: InputMaybe<Scalars['String']['input']>;
};


export type MutationPublishArtifactVersionArgs = {
  input: PublishArtifactVersionInput;
};


export type MutationPublishBlogPostArgs = {
  id: Scalars['ID']['input'];
};


export type MutationPublishCompanyKnowledgeArticleArgs = {
  id: Scalars['ID']['input'];
};


export type MutationPublishPolicyArgs = {
  changeNote?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};


export type MutationPublishSeoMetadataArgs = {
  pagePath: Scalars['String']['input'];
};


export type MutationPublishShiftArgs = {
  id: Scalars['ID']['input'];
};


export type MutationPublishSopEpisodeArgs = {
  id: Scalars['ID']['input'];
};


export type MutationPublishVlogPostArgs = {
  id: Scalars['ID']['input'];
};


export type MutationPurchasePhoneNumberArgs = {
  input: PurchasePhoneNumberInput;
};


export type MutationPushCalculatorSubmissionToGhlArgs = {
  submissionId: Scalars['ID']['input'];
};


export type MutationPutForwardCandidateArgs = {
  companyId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
};


export type MutationQuickEmailSetupArgs = {
  aliases: Array<Scalars['String']['input']>;
  launchedSiteId: Scalars['ID']['input'];
};


export type MutationRaiseFeedbackOutcomeArgs = {
  input: RaiseFeedbackOutcomeInput;
};


export type MutationRaiseSopCommentToAgendaArgs = {
  id: Scalars['ID']['input'];
  targetEpisodeId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationRateTomMessageArgs = {
  feedback: Scalars['String']['input'];
  messageId: Scalars['String']['input'];
};


export type MutationReactivateMedicationArgs = {
  id: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
};


export type MutationReactivateUnitArgs = {
  unit: UnitType;
};


export type MutationReadmitResidentArgs = {
  input: AdmitResidentInput;
  residentId: Scalars['ID']['input'];
};


export type MutationRebuildPolicyChatIndexArgs = {
  withSummaries?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationRecheckModuleDeployArgs = {
  jobId: Scalars['ID']['input'];
};


export type MutationReconcileModuleConfigArgs = {
  moduleId: Scalars['String']['input'];
  tenantId: Scalars['ID']['input'];
};


export type MutationReconcileSarahCareWeightKeysArgs = {
  apply?: Scalars['Boolean']['input'];
  rows: Array<SarahHistoricalRowInput>;
};


export type MutationRecordAbsenceArgs = {
  input: RecordAbsenceInput;
};


export type MutationRecordAdministrationArgs = {
  input: RecordAdministrationInput;
};


export type MutationRecordAiAuditDecisionArgs = {
  input: RecordAiAuditDecisionInput;
};


export type MutationRecordBankingHoldingArgs = {
  input: RecordBankingHoldingInput;
};


export type MutationRecordBankingLoanDrawdownArgs = {
  input: RecordBankingLoanDrawdownInput;
};


export type MutationRecordBankingLoanRepaymentArgs = {
  input: RecordBankingLoanRepaymentInput;
};


export type MutationRecordBankingPriceArgs = {
  input: RecordBankingPriceInput;
};


export type MutationRecordBondPaymentArgs = {
  bondId: Scalars['ID']['input'];
  input: BondPaymentInput;
};


export type MutationRecordCiMeetingMinutesArgs = {
  id: Scalars['ID']['input'];
  input: RecordCiMeetingMinutesInput;
};


export type MutationRecordCarePlanCopyGivenArgs = {
  carePlanId: Scalars['ID']['input'];
  input: RecordCarePlanCopyInput;
};


export type MutationRecordChecklistGridEntryArgs = {
  checklistId: Scalars['ID']['input'];
  input: RecordGridEntryInput;
  taskId: Scalars['String']['input'];
};


export type MutationRecordCompetitionPrintPayoutArgs = {
  input: RecordCompetitionPrintPayoutInput;
};


export type MutationRecordEmployeeFormViewedArgs = {
  formType: EmployeeFormType;
  signedFormId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationRecordGovExecutionArgs = {
  decisionId: Scalars['ID']['input'];
  executionNote: Scalars['String']['input'];
  executionTxHash?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRecordGovMovementArgs = {
  input: RecordGovMovementInput;
};


export type MutationRecordHostingCommissionPaymentArgs = {
  input: RecordHostingCommissionPaymentInput;
};


export type MutationRecordIncidentCarePlanCheckArgs = {
  id: Scalars['ID']['input'];
  input: IncidentCarePlanCheckInput;
};


export type MutationRecordIncomingDeliveryTemperatureArgs = {
  input: CreateIncomingDeliveryTemperatureInput;
};


export type MutationRecordInterventionCompletionArgs = {
  carePlanId: Scalars['ID']['input'];
  input?: InputMaybe<RecordInterventionCompletionInput>;
  interventionIndex: Scalars['Int']['input'];
};


export type MutationRecordMySiteEditCommandArgs = {
  duration?: InputMaybe<Scalars['Float']['input']>;
  filesChanged?: InputMaybe<Scalars['Float']['input']>;
  output: Scalars['String']['input'];
  prompt: Scalars['String']['input'];
  sessionId?: InputMaybe<Scalars['String']['input']>;
  success?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationRecordPrnEffectivenessArgs = {
  id: Scalars['ID']['input'];
  input: PrnEffectivenessInput;
};


export type MutationRecordPhoneReferenceArgs = {
  id: Scalars['ID']['input'];
  input: ReferenceAnswersInput;
};


export type MutationRecordRespiteCheckInArgs = {
  checkInDate?: InputMaybe<Scalars['DateTime']['input']>;
  id: Scalars['ID']['input'];
};


export type MutationRecordReturnArgs = {
  id: Scalars['ID']['input'];
  input: RecordReturnInput;
};


export type MutationRecordRiskChoiceArgs = {
  input: RiskChoiceInput;
  riskAssessmentId: Scalars['ID']['input'];
};


export type MutationRecordS8TransactionArgs = {
  input: S8TransactionInput;
};


export type MutationRecordSuitabilityAssessmentArgs = {
  input: SuitabilityAssessmentInput;
  waitingListEntryId: Scalars['ID']['input'];
};


export type MutationRecordTemperatureArgs = {
  input: CreateTemperatureLogInput;
};


export type MutationRecordTestResultArgs = {
  input: RecordTestResultInput;
};


export type MutationRecordTrustActivityArgs = {
  input: RecordTrustActivityInput;
};


export type MutationRecordWaitingListTourDoneArgs = {
  id: Scalars['ID']['input'];
  input: RecordWaitingListTourDoneInput;
};


export type MutationRecordWaitingListTourFeedbackArgs = {
  feedback: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};


export type MutationRecordWaitingListTourNotPossibleArgs = {
  id: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
};


export type MutationRecoverMeetRecordingArgs = {
  recordingId?: InputMaybe<Scalars['ID']['input']>;
  roomName: Scalars['String']['input'];
};


export type MutationRedeemRewardTokenArgs = {
  input: RedeemRewardTokenInput;
};


export type MutationRedeemTokensForBillArgs = {
  billId: Scalars['ID']['input'];
  tokenCount: Scalars['Int']['input'];
};


export type MutationRefineBroadcastContentArgs = {
  input: RefineBroadcastInput;
};


export type MutationRefineCandidateMessageArgs = {
  input: RefineCandidateMessageInput;
};


export type MutationRefineChaseEmailDraftArgs = {
  feedback: Scalars['String']['input'];
  logId: Scalars['String']['input'];
};


export type MutationRefineChaseSmsDraftArgs = {
  feedback: Scalars['String']['input'];
  logId: Scalars['String']['input'];
};


export type MutationRefineEmailReplyDraftArgs = {
  input: RefineEmailReplyInput;
};


export type MutationRefineGeneratedTaskArgs = {
  input: RefineGeneratedTaskInput;
};


export type MutationRefineSiteSpecArgs = {
  input: RefineSiteSpecInput;
};


export type MutationRegeneratePublicAccessTokenArgs = {
  jobId: Scalars['ID']['input'];
};


export type MutationRegenerateRollupArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRegisterDomainArgs = {
  input: RegisterDomainInput;
};


export type MutationRegisterForEventArgs = {
  input: RegisterForEventInput;
};


export type MutationRegisterIpfsNodeArgs = {
  input: IpfsNodeInput;
};


export type MutationRegisterP2InterestArgs = {
  input: P2InterestInput;
};


export type MutationRegisterValidatorArgs = {
  input: RegisterValidatorInput;
};


export type MutationRegisterWithVerifiedEmailArgs = {
  input: RegisterWithVerifiedEmailInput;
};


export type MutationRegisterWithVerifiedPhoneArgs = {
  input: RegisterWithVerifiedPhoneInput;
};


export type MutationReharvestSourceArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRejectCandidateArgs = {
  id: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRejectDigitalManagerProposalArgs = {
  oqId: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRejectShiftPickupArgs = {
  announce?: InputMaybe<Scalars['Boolean']['input']>;
  announceChannels?: InputMaybe<Array<Scalars['String']['input']>>;
  comment?: InputMaybe<Scalars['String']['input']>;
  employeeId: Scalars['ID']['input'];
  shiftId: Scalars['ID']['input'];
};


export type MutationRejectSiteUpdateArgs = {
  id: Scalars['ID']['input'];
  reviewNote?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRejectTomActionArgs = {
  actionId: Scalars['String']['input'];
  conversationId: Scalars['String']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};


export type MutationReleaseEmpowermentReflectionsArgs = {
  checkInId: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};


export type MutationReleaseGovWorkClaimArgs = {
  claimId: Scalars['ID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
};


export type MutationReleasePhoneNumberArgs = {
  id: Scalars['ID']['input'];
};


export type MutationReleaseSmsHeldReplyArgs = {
  id: Scalars['ID']['input'];
  tenantId: Scalars['String']['input'];
};


export type MutationReleaseStuckVideosArgs = {
  olderThanMinutes: Scalars['Int']['input'];
};


export type MutationRemoveBlockedDateArgs = {
  calendarId: Scalars['String']['input'];
  date: Scalars['DateTime']['input'];
};


export type MutationRemoveCiAgendaItemArgs = {
  itemIndex: Scalars['Float']['input'];
  meetingId: Scalars['ID']['input'];
};


export type MutationRemoveCalendarEventTaskChecklistItemArgs = {
  checklistItemId: Scalars['String']['input'];
  taskId: Scalars['String']['input'];
};


export type MutationRemoveChaseRecipientArgs = {
  clientId: Scalars['String']['input'];
  configId: Scalars['String']['input'];
};


export type MutationRemoveClientPermissionArgs = {
  clientId: Scalars['ID']['input'];
  permission: ClientPermission;
};


export type MutationRemoveClientTagArgs = {
  clientId: Scalars['ID']['input'];
  tag: Scalars['String']['input'];
};


export type MutationRemoveCommunityMemberArgs = {
  clientId: Scalars['ID']['input'];
};


export type MutationRemoveDailyCareCalendarEventsArgs = {
  calendarId: Scalars['String']['input'];
  residentId: Scalars['ID']['input'];
};


export type MutationRemoveDigitalManagerFromOrgChartArgs = {
  digitalManagerId: Scalars['ID']['input'];
};


export type MutationRemoveDomainArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveDomainDnsRecordArgs = {
  domain: Scalars['String']['input'];
  launchedSiteId: Scalars['ID']['input'];
  recordId: Scalars['String']['input'];
};


export type MutationRemoveEmployeeFromCompanyArgs = {
  clientId: Scalars['ID']['input'];
  companyId: Scalars['ID']['input'];
};


export type MutationRemoveEmployeeFromOrgChartArgs = {
  employeeId: Scalars['ID']['input'];
};


export type MutationRemoveEmployeeFromShiftArgs = {
  announce?: InputMaybe<Scalars['Boolean']['input']>;
  announceChannels?: InputMaybe<Array<Scalars['String']['input']>>;
  employeeId: Scalars['ID']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  shiftId: Scalars['ID']['input'];
};


export type MutationRemoveFromWaitingListArgs = {
  id: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRemoveGithubCollaboratorArgs = {
  launchedSiteId: Scalars['ID']['input'];
  username: Scalars['String']['input'];
};


export type MutationRemoveGoalArgs = {
  carePlanId: Scalars['ID']['input'];
  goalIndex: Scalars['Int']['input'];
};


export type MutationRemoveGoalCheckpointArgs = {
  checkpointId: Scalars['String']['input'];
  goalId: Scalars['String']['input'];
};


export type MutationRemoveGovChecklistArgs = {
  checklistId: Scalars['ID']['input'];
};


export type MutationRemoveInboundEmailLabelArgs = {
  emailId: Scalars['String']['input'];
  label: Scalars['String']['input'];
};


export type MutationRemoveInterventionArgs = {
  carePlanId: Scalars['ID']['input'];
  interventionIndex: Scalars['Int']['input'];
};


export type MutationRemoveKitchenMemberArgs = {
  clientId: Scalars['ID']['input'];
  kitchenId: Scalars['ID']['input'];
};


export type MutationRemoveLabelFromInboundEmailArgs = {
  id: Scalars['ID']['input'];
  label: Scalars['String']['input'];
};


export type MutationRemoveLaunchSiteDomainArgs = {
  domain: Scalars['String']['input'];
  launchedSiteId: Scalars['ID']['input'];
};


export type MutationRemoveMilestoneArgs = {
  carePlanId: Scalars['ID']['input'];
  goalIndex: Scalars['Int']['input'];
  milestoneIndex: Scalars['Int']['input'];
};


export type MutationRemoveOpportunityMemberArgs = {
  id: Scalars['String']['input'];
};


export type MutationRemovePlacementFromOrgChartArgs = {
  placementId: Scalars['ID']['input'];
};


export type MutationRemoveQueuedModuleUpgradeArgs = {
  jobId: Scalars['ID']['input'];
};


export type MutationRemoveRecipeIngredientArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveWitnessArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRenameMeetVoiceSignatureArgs = {
  id: Scalars['ID']['input'];
  label: Scalars['String']['input'];
};


export type MutationRenamePasskeyArgs = {
  input: RenamePasskeyInput;
};


export type MutationRenameVoiceSignatureArgs = {
  id: Scalars['ID']['input'];
  label: Scalars['String']['input'];
};


export type MutationRenewDomainArgs = {
  input: DomainRenewInput;
};


export type MutationRenewEmployeeInviteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationReopenArtifactCommentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationReopenBankingMonthJobArgs = {
  id: Scalars['ID']['input'];
};


export type MutationReopenIncidentArgs = {
  id: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
};


export type MutationReorderActionsArgs = {
  input: ReorderActionsInput;
};


export type MutationReorderBankingMonthJobsArgs = {
  input: ReorderBankingMonthJobsInput;
};


export type MutationReorderBookableEventTypesArgs = {
  eventTypeIds: Array<Scalars['String']['input']>;
};


export type MutationReorderChecklistArgs = {
  itemIds: Array<Scalars['String']['input']>;
  jobId: Scalars['ID']['input'];
};


export type MutationReorderCommunicationTasksArgs = {
  taskIds: Array<Scalars['ID']['input']>;
};


export type MutationReorderCustomQuestionsArgs = {
  incidentTypeId: Scalars['ID']['input'];
  questionIds: Array<Scalars['ID']['input']>;
};


export type MutationReorderDigitalManagerRulesArgs = {
  orderedIds: Array<Scalars['ID']['input']>;
};


export type MutationReorderEmailAiRulesArgs = {
  orderedIds: Array<Scalars['ID']['input']>;
};


export type MutationReorderEmployeeAmongSiblingsArgs = {
  direction: OrgChartReorderDirection;
  employeeId: Scalars['ID']['input'];
};


export type MutationReorderLeadFlowStagesArgs = {
  input: ReorderLeadFlowStagesInput;
};


export type MutationReorderMaintenanceChecklistArgs = {
  id: Scalars['ID']['input'];
  itemIds: Array<Scalars['String']['input']>;
};


export type MutationReorderMealPlansArgs = {
  mealType: MealType;
  orderedIds: Array<Scalars['ID']['input']>;
  slotDate: Scalars['String']['input'];
};


export type MutationReorderP2CampaignMessagesArgs = {
  campaignId: Scalars['ID']['input'];
  messageIds: Array<Scalars['ID']['input']>;
};


export type MutationReorderSubscriptionProductsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationReplaceEmployeeOnShiftArgs = {
  input: ReplaceEmployeeOnShiftInput;
};


export type MutationReplyToPayrollEnquiryArgs = {
  input: ReplyToPayrollEnquiryInput;
};


export type MutationReportAgentBoardArgs = {
  input: AgentRunnerReportInput;
};


export type MutationReportClub52IssueArgs = {
  input: ReportClub52IssueInput;
};


export type MutationReportMealCalendarIssueArgs = {
  input: MealCalendarIssueReportInput;
};


export type MutationReportStalledRosterBulkOpArgs = {
  id: Scalars['ID']['input'];
};


export type MutationReputGovProposalArgs = {
  id: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRequestArtSessionArgs = {
  input: RequestArtSessionInput;
};


export type MutationRequestBankingIouPayoutArgs = {
  rewardTokenId: Scalars['ID']['input'];
};


export type MutationRequestEmailChangeArgs = {
  input: RequestEmailChangeInput;
};


export type MutationRequestEmailLoginLinkArgs = {
  input: RequestEmailLoginLinkInput;
};


export type MutationRequestEmailSignupPhoneCodeArgs = {
  phoneNumber: Scalars['String']['input'];
  proof: Scalars['String']['input'];
};


export type MutationRequestMedicalRecordAccessArgs = {
  input: RequestMedicalRecordAccessInput;
};


export type MutationRequestPProposalEmailVerificationArgs = {
  input: RequestPProposalEmailVerificationInput;
};


export type MutationRequestPasswordResetArgs = {
  input: RequestPasswordResetInput;
};


export type MutationRequestPhoneChangeArgs = {
  input: RequestPhoneChangeInput;
};


export type MutationRequestProposalEmailVerificationArgs = {
  input: RequestProposalEmailVerificationInput;
};


export type MutationRequestReferenceArgs = {
  input: RequestReferenceInput;
};


export type MutationRequestShiftSwapArgs = {
  input: RequestShiftSwapInput;
};


export type MutationRequestSmsLoginLinkArgs = {
  input: RequestSmsLoginLinkInput;
};


export type MutationRequestSmsNumberArgs = {
  note?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRequestSponsoredSeparationAccessArgs = {
  input: SeparationSponsoredRequestInput;
  tenantId: Scalars['String']['input'];
};


export type MutationRequestWalletLinkNonceArgs = {
  address: Scalars['String']['input'];
  scope?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRescanModuleDriftArgs = {
  moduleIds?: InputMaybe<Array<Scalars['String']['input']>>;
  tenantIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type MutationRescheduleClub52GameArgs = {
  input: RescheduleClub52GameInput;
};


export type MutationReschedulePublicBookingArgs = {
  newStartTime: Scalars['DateTime']['input'];
  token: Scalars['String']['input'];
};


export type MutationResendCommunityInviteArgs = {
  input: SendCommunityInviteChaseInput;
};


export type MutationResendGovInviteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationResendProgramInviteArgs = {
  channel: ProgramChannel;
  memberId: Scalars['ID']['input'];
};


export type MutationResendVisionBoardInviteArgs = {
  input: SendVisionBoardInviteChaseInput;
};


export type MutationResetAlertConfigToDefaultsArgs = {
  observationType: ObservationType;
};


export type MutationResetAssignmentArgs = {
  employeeId: Scalars['ID']['input'];
  shiftId: Scalars['ID']['input'];
};


export type MutationResetBankingMonthJobOrderArgs = {
  month: Scalars['String']['input'];
};


export type MutationResetBdayRsvpArgs = {
  id: Scalars['ID']['input'];
};


export type MutationResetCareLegalRequirementArgs = {
  key: Scalars['String']['input'];
};


export type MutationResetClientCredentialsArgs = {
  clientId: Scalars['ID']['input'];
  sendVia?: InputMaybe<Scalars['String']['input']>;
};


export type MutationResetDailyCareHeadingsArgs = {
  profileType: ProfileType;
};


export type MutationResetPasswordArgs = {
  input: ResetPasswordInput;
};


export type MutationResetPaymentEventArgs = {
  billId: Scalars['ID']['input'];
  paymentEventIndex: Scalars['Int']['input'];
};


export type MutationResolveArtifactCommentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationResolveCiIssueReportArgs = {
  id: Scalars['ID']['input'];
  input: ResolveCiIssueReportInput;
};


export type MutationResolveDigitalManagerChaseArgs = {
  id: Scalars['ID']['input'];
};


export type MutationResolveDuplicateArgs = {
  input: ResolveDuplicateInput;
};


export type MutationResolveFeedbackArgs = {
  id: Scalars['ID']['input'];
  resolutionNotes?: InputMaybe<Scalars['String']['input']>;
};


export type MutationResolveFeedbackItemArgs = {
  input: ResolveFeedbackInput;
};


export type MutationResolveOrphanedAssignmentArgs = {
  absenceReason?: InputMaybe<AbsenceReason>;
  checkInId?: InputMaybe<Scalars['ID']['input']>;
  employeeId: Scalars['ID']['input'];
  mode: OrphanResolutionMode;
  notes?: InputMaybe<Scalars['String']['input']>;
  shiftId: Scalars['ID']['input'];
};


export type MutationRespondToEventArgs = {
  comment?: InputMaybe<Scalars['String']['input']>;
  eventId: Scalars['String']['input'];
  status: AttendeeStatus;
};


export type MutationRestoreDeletedEmailArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRestorePolicyArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRestoreWaitingListEntryArgs = {
  id: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
};


export type MutationResumeDigitalManagerArgs = {
  id: Scalars['ID']['input'];
};


export type MutationResumeEmailLinkSignupArgs = {
  proof: Scalars['String']['input'];
};


export type MutationResumeSubscriptionArgs = {
  subscriptionId: Scalars['ID']['input'];
};


export type MutationRetireDigitalManagerArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRetireGovJobSpecArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRetractBankingTransactionCommentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRetractEmployeeActivityCommentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRetractGovActivityCommentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRetryFailedIngestsArgs = {
  sourceId: Scalars['ID']['input'];
};


export type MutationRetryInvoiceExtractionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRetryMeetTranscriptionArgs = {
  recordingId: Scalars['ID']['input'];
  roomName: Scalars['String']['input'];
};


export type MutationRetryRecipeCaptureArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRetryTranscriptionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRetryVideoIngestArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRetryVideoTranscriptArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRevertPayRunToDraftArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRevertToWaitingListArgs = {
  reason: Scalars['String']['input'];
  residentId: Scalars['ID']['input'];
};


export type MutationReviewCiInitiativeArgs = {
  id: Scalars['ID']['input'];
  input: ReviewCiInitiativeInput;
};


export type MutationReviewEmpowermentGoalArgs = {
  input: ReviewEmpowermentGoalInput;
};


export type MutationReviewGovProofArgs = {
  input: ReviewGovProofInput;
  proofId: Scalars['ID']['input'];
};


export type MutationReviseEmpowermentQuestionArgs = {
  input: ReviseEmpowermentQuestionInput;
};


export type MutationReviseGovJobSpecArgs = {
  id: Scalars['ID']['input'];
  input: UpdateGovJobSpecInput;
};


export type MutationRevokeDroneSessionSharingArgs = {
  sessionId: Scalars['ID']['input'];
};


export type MutationRevokeEmailLoginLinksArgs = {
  clientId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationRevokeGovInviteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRevokeHostingAccessLinksArgs = {
  clientId: Scalars['ID']['input'];
};


export type MutationRevokeMedicalAccessArgs = {
  input: RevokeMedicalAccessInput;
};


export type MutationRevokeMySessionArgs = {
  id: Scalars['String']['input'];
};


export type MutationRevokeSeparationAccessLinksArgs = {
  clientId: Scalars['String']['input'];
};


export type MutationRevokeSiteOwnerLinksArgs = {
  clientId: Scalars['ID']['input'];
};


export type MutationRevokeVisionBoardShareArgs = {
  clientId: Scalars['ID']['input'];
};


export type MutationRevokeWalletKeyArgs = {
  id: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
};


export type MutationRolloverBankingMonthJobsArgs = {
  month: Scalars['String']['input'];
};


export type MutationRolloverIncompleteGoalsArgs = {
  calendarId: Scalars['String']['input'];
  fromMonth: Scalars['String']['input'];
};


export type MutationRotateArtifactShareTokenArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRsvpClub52GameArgs = {
  input: Club52RsvpInput;
};


export type MutationRunAiPayAuditArgs = {
  input: RunAiPayAuditInput;
};


export type MutationRunDigitalManagerNowArgs = {
  contextNote?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};


export type MutationRunDigitalManagerStandupNowArgs = {
  managerId: Scalars['ID']['input'];
};


export type MutationRunEmailAiRuleNowArgs = {
  input?: InputMaybe<RunEmailAiRuleNowInput>;
  ruleId: Scalars['ID']['input'];
};


export type MutationRunEmailHealthProbeArgs = {
  triggeredBy?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRunEmpowermentReconcileArgs = {
  force?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationRunLeadFlowSequencesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationRunModuleDoctorArgs = {
  brief?: InputMaybe<ModuleDoctorBriefInput>;
  moduleId: Scalars['String']['input'];
  tenantId: Scalars['ID']['input'];
  testPolicy?: InputMaybe<DoctorTestPolicy>;
};


export type MutationS8DiscrepancyArgs = {
  input: S8DiscrepancyInput;
  medicationId: Scalars['ID']['input'];
};


export type MutationSaveAccountingXeroAppArgs = {
  input: SaveAccountingXeroAppInput;
};


export type MutationSaveAdvanceCarePlanArgs = {
  input: SaveAdvanceCarePlanInput;
};


export type MutationSaveBusinessDirectoryCategoriesArgs = {
  names: Array<Scalars['String']['input']>;
};


export type MutationSaveCapturedRecipeArgs = {
  input: ShelvSaveCapturedRecipeInput;
};


export type MutationSaveCareLegalRequirementArgs = {
  input: SaveCareLegalRequirementInput;
};


export type MutationSaveCrazytelSettingsArgs = {
  input: CrazytelSettingsInput;
};

export type MutationSaveCustomAnswersArgs = {
  answers: Array<CustomAnswerInput>;
  incidentId: Scalars['ID']['input'];
};


export type MutationSaveEmpowermentReflectionArgs = {
  input: SaveEmpowermentReflectionInput;
};


export type MutationSaveImprovMxConfigToTenantArgs = {
  launchedSiteId: Scalars['ID']['input'];
};


export type MutationSaveMyBusinessListingArgs = {
  input: BusinessListingInput;
};


export type MutationSaveMyQuickLinksArgs = {
  hidden: Array<Scalars['String']['input']>;
  order: Array<Scalars['String']['input']>;
};


export type MutationSavePhoneLineArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  input: PhoneLineInput;
};

export type MutationSavePolicyDraftArgs = {
  expectedDraftUpdatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  force?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  markdown: Scalars['String']['input'];
};


export type MutationSaveSeparationCovenantAnswerArgs = {
  input: SeparationCovenantAnswerInput;
};


export type MutationSaveSovereigntyJourneyArgs = {
  input: SaveSovereigntyJourneyInput;
};


export type MutationSaveVoiceContactArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  input: VoiceContactInput;
};


export type MutationSaveWalletContactArgs = {
  input: SaveWalletContactInput;
};


export type MutationScanEmailAndGenerateProjectProposalArgs = {
  emailContent: Scalars['String']['input'];
  emailSubject?: InputMaybe<Scalars['String']['input']>;
  senderEmail?: InputMaybe<Scalars['String']['input']>;
  senderName?: InputMaybe<Scalars['String']['input']>;
};


export type MutationScheduleCandidateInterviewArgs = {
  input: ScheduleInterviewInput;
};


export type MutationScheduleCandidateMessageArgs = {
  draftId: Scalars['ID']['input'];
  scheduledAt: Scalars['String']['input'];
};


export type MutationScheduleCarePlanReviewArgs = {
  input: CreateCarePlanReviewInput;
};


export type MutationScheduleChaseDeliveryArgs = {
  calendarId: Scalars['String']['input'];
  logId: Scalars['String']['input'];
  sendAt: Scalars['DateTime']['input'];
};


export type MutationScheduleInterventionArgs = {
  carePlanId: Scalars['ID']['input'];
  input: ScheduleInterventionInput;
  interventionIndex: Scalars['Int']['input'];
};


export type MutationScheduleProgramCallArgs = {
  callNumber: Scalars['Int']['input'];
  endTime: Scalars['DateTime']['input'];
  memberId: Scalars['ID']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  startTime: Scalars['DateTime']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSearchPersonEventsArgs = {
  personId: Scalars['ID']['input'];
  query?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSeedPublicHolidaysArgs = {
  region?: InputMaybe<Scalars['String']['input']>;
  year: Scalars['Int']['input'];
};


export type MutationSeedStationsFromOverpassArgs = {
  state: Scalars['String']['input'];
};


export type MutationSelfAssignToShiftArgs = {
  employeeId?: InputMaybe<Scalars['ID']['input']>;
  employeeName?: InputMaybe<Scalars['String']['input']>;
  shiftId: Scalars['ID']['input'];
};


export type MutationSendBdayEveReminderSmsArgs = {
  input: SendBdayEveReminderSmsInput;
};


export type MutationSendBdayFollowUpSmsArgs = {
  input: SendBdayFollowUpSmsInput;
};


export type MutationSendBdayInviteSmsArgs = {
  input: SendBdayInviteSmsInput;
};


export type MutationSendBookingReminderArgs = {
  bookingId: Scalars['String']['input'];
  customMessage?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSendBulkSmsArgs = {
  brand?: InputMaybe<Scalars['String']['input']>;
  contacts: Array<ContactInput>;
  forceAlphaId?: InputMaybe<Scalars['Boolean']['input']>;
  list?: InputMaybe<Array<Scalars['String']['input']>>;
  message: Scalars['String']['input'];
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationSendBusinessChatEnquiryArgs = {
  input: BusinessChatEnquiryInput;
};


export type MutationSendBusinessChatMessageArgs = {
  input: BusinessChatMessageInput;
};


export type MutationSendCandidateMessageNowArgs = {
  draftId: Scalars['ID']['input'];
};


export type MutationSendChaseSmsArgs = {
  logId: Scalars['String']['input'];
};


export type MutationSendChaseSuggestionArgs = {
  logId: Scalars['String']['input'];
};


export type MutationSendChatMessageArgs = {
  anonToken?: InputMaybe<Scalars['String']['input']>;
  input: SendMessageInput;
};


export type MutationSendClub52MessageArgs = {
  input: SendClub52MessageInput;
};


export type MutationSendCommsSummaryNowArgs = {
  period: CommsSummaryPeriod;
  recipientOverride?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSendCommunityCampaignTestArgs = {
  input: CommunityCampaignTestInput;
};


export type MutationSendCommunityLapsedNudgeToOneMemberArgs = {
  clientId: Scalars['ID']['input'];
};


export type MutationSendCommunityLeaderboardEmailNowArgs = {
  onlyMe?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSendCommunityReminderToOneMemberArgs = {
  clientId: Scalars['ID']['input'];
};


export type MutationSendCompetitionNotificationArgs = {
  competitionId: Scalars['ID']['input'];
  kind: CompetitionNotificationKind;
};


export type MutationSendContactInviteArgs = {
  contactId: Scalars['ID']['input'];
  method: Scalars['String']['input'];
};


export type MutationSendEmailArgs = {
  id: Scalars['ID']['input'];
};


export type MutationSendEmailCodeArgs = {
  email: Scalars['String']['input'];
};


export type MutationSendEmployeeInviteReminderArgs = {
  customMessage?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};


export type MutationSendEmployeeMessageArgs = {
  channel: Scalars['String']['input'];
  employeeId: Scalars['ID']['input'];
  message: Scalars['String']['input'];
  subject?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSendEmployeeOnboardingReminderArgs = {
  customMessage?: InputMaybe<Scalars['String']['input']>;
  employeeId: Scalars['ID']['input'];
};


export type MutationSendEmpowermentReminderArgs = {
  input: SendEmpowermentReminderInput;
};


export type MutationSendEventRemindersArgs = {
  eventId: Scalars['String']['input'];
};


export type MutationSendGovDueReportsArgs = {
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  organisationId: Scalars['ID']['input'];
};


export type MutationSendGovMembershipRemindersArgs = {
  memberIds: Array<Scalars['ID']['input']>;
  organisationId: Scalars['ID']['input'];
};


export type MutationSendLeadFlowActionArgs = {
  input: SendLeadFlowActionInput;
};


export type MutationSendLeadFlowActionToManyArgs = {
  input: SendLeadFlowActionToManyInput;
};


export type MutationSendLocalAiQueryArgs = {
  input: SendLocalAiQueryInput;
};


export type MutationSendMeetRecordingTranscriptArgs = {
  input: SendMeetTranscriptInput;
};


export type MutationSendMeetingMessageArgs = {
  input: SendMeetingMessageInput;
};


export type MutationSendMyBankingDigestNowArgs = {
  frequency: BankingDigestFrequency;
};


export type MutationSendMySiteEditCommandArgs = {
  prompt: Scalars['String']['input'];
  sessionId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSendP2ActionArgs = {
  input: SendP2ActionInput;
};


export type MutationSendP2CampaignMessageArgs = {
  messageId: Scalars['ID']['input'];
  recipientIds?: InputMaybe<Array<Scalars['String']['input']>>;
  recipientType: Scalars['String']['input'];
};


export type MutationSendP2QuickMessageArgs = {
  body: Scalars['String']['input'];
  campaignId: Scalars['ID']['input'];
  channel: Scalars['String']['input'];
  recipientIds?: InputMaybe<Array<Scalars['String']['input']>>;
  recipientType?: Scalars['String']['input'];
  subject?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSendPProposalArgs = {
  id: Scalars['ID']['input'];
  recipientEmail?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSendPolicyBroadcastArgs = {
  input: SendPolicyBroadcastInput;
};


export type MutationSendProgramReminderEmailArgs = {
  bodyOverride?: InputMaybe<Scalars['String']['input']>;
  memberId: Scalars['ID']['input'];
  reminderType: ProgramReminderType;
  subjectOverride?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSendProposalArgs = {
  id: Scalars['ID']['input'];
};


export type MutationSendRsvpResponseArgs = {
  eventId: Scalars['String']['input'];
  fromEmail?: InputMaybe<Scalars['String']['input']>;
  response: Scalars['String']['input'];
};


export type MutationSendSeparationInviteChaseArgs = {
  input: SendSeparationInviteChaseInput;
};


export type MutationSendSingleMotivationMessageArgs = {
  input: SendMotivationInput;
};


export type MutationSendSiteEditCommandArgs = {
  input: SendEditCommandInput;
};


export type MutationSendSmsArgs = {
  brand?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  forceAlphaId?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  list?: InputMaybe<Array<Scalars['String']['input']>>;
  message: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationSendSmsBroadcastArgs = {
  input: SendSmsBroadcastInput;
};


export type MutationSendSmsCodeArgs = {
  phoneNumber: Scalars['String']['input'];
};


export type MutationSendStepUpCodeArgs = {
  channel: Scalars['String']['input'];
};


export type MutationSendTestBillsEmailArgs = {
  html: Scalars['String']['input'];
  subject?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSendTestBookingUrlArgs = {
  brand?: InputMaybe<Scalars['String']['input']>;
  phoneNumber: Scalars['String']['input'];
};


export type MutationSendTestEmailArgs = {
  input: EmailInput;
};


export type MutationSendTestEmailWithTenantArgs = {
  tenantId?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
};


export type MutationSendTestLeadFlowEmailArgs = {
  html: Scalars['String']['input'];
  subject?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSendTestMechanicNotificationArgs = {
  channel: MechanicNotificationChannel;
};


export type MutationSendTestRewardsEmailArgs = {
  html: Scalars['String']['input'];
  subject?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSendTestSmsArgs = {
  phoneNumber: Scalars['String']['input'];
  tenantId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSendTomMessageArgs = {
  input: SendTomMessageInput;
};


export type MutationSendUpdatedEventInviteArgs = {
  email: Scalars['String']['input'];
  expectedUpdatedAt: Scalars['String']['input'];
  id: Scalars['String']['input'];
  restoreAttendee: Scalars['Boolean']['input'];
};


export type MutationSendWaitingListFamilyMessageArgs = {
  entryId: Scalars['ID']['input'];
  kind: WaitingListFamilyMessageKind;
};


export type MutationSendWaitingListTourMessageArgs = {
  input: SendWaitingListTourMessageInput;
};


export type MutationSetBankingAccountViewersArgs = {
  input: SetBankingAccountViewersInput;
};


export type MutationSetBankingTransactionShapeArgs = {
  input: SetBankingTransactionShapeInput;
};


export type MutationSetBillCompanyArgs = {
  billId: Scalars['ID']['input'];
  companyId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationSetBillTermsArgs = {
  dueDate?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  paymentTerms?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSetBillToCompanyArgs = {
  billId: Scalars['ID']['input'];
  companyId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationSetBusinessEnquiryStatusArgs = {
  id: Scalars['ID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  status: BusinessEnquiryStatus;
};


export type MutationSetCandidateCredentialArgs = {
  id: Scalars['ID']['input'];
  input: CandidateCredentialInput;
};


export type MutationSetCandidatePoliceCheckArgs = {
  fileId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
};


export type MutationSetCarePlanParticipantsArgs = {
  carePlanId: Scalars['ID']['input'];
  participants: Array<CarePlanParticipantInput>;
};


export type MutationSetChaseDraftSendAsArgs = {
  logId: Scalars['String']['input'];
  sendAsTenantId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSetClientLoginBlockArgs = {
  id: Scalars['ID']['input'];
  input: SetClientLoginBlockInput;
};


export type MutationSetClientPermissionsArgs = {
  clientId: Scalars['ID']['input'];
  permissions: Array<ClientPermission>;
};


export type MutationSetClientTagsArgs = {
  clientId: Scalars['ID']['input'];
  tags: Array<Scalars['String']['input']>;
};


export type MutationSetCompetitionEntryStatusArgs = {
  input: SetCompetitionEntryStatusInput;
};


export type MutationSetCompetitionStatusArgs = {
  id: Scalars['ID']['input'];
  notifyEntrants?: InputMaybe<Scalars['Boolean']['input']>;
  status: CompetitionStatus;
};


export type MutationSetDefaultPaymentMethodArgs = {
  id: Scalars['ID']['input'];
};


export type MutationSetDigitalManagerNotificationRuleEnabledArgs = {
  id: Scalars['ID']['input'];
  isEnabled: Scalars['Boolean']['input'];
};


export type MutationSetDigitalManagerReportsToArgs = {
  digitalManagerId: Scalars['ID']['input'];
  employeeId: Scalars['ID']['input'];
};


export type MutationSetDigitalManagerRuleEnabledArgs = {
  enabled: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
};


export type MutationSetDroneSessionPasswordArgs = {
  password?: InputMaybe<Scalars['String']['input']>;
  sessionId: Scalars['ID']['input'];
};


export type MutationSetEmailAiRuleEnabledArgs = {
  enabled: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
};


export type MutationSetEmployeeChecklistItemDoneArgs = {
  done: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
};


export type MutationSetEmployeeChecklistVisibilityArgs = {
  id: Scalars['ID']['input'];
  visibility: EmployeeChecklistVisibility;
};


export type MutationSetEmployeeFormsPromptArgs = {
  employeeId: Scalars['ID']['input'];
  enabled: Scalars['Boolean']['input'];
  formType: EmployeeFormType;
};


export type MutationSetEmpowermentGoalStepArgs = {
  input: SetEmpowermentGoalStepInput;
};


export type MutationSetEmpowermentJourneyStatusArgs = {
  input: SetEmpowermentJourneyStatusInput;
};


export type MutationSetEmpowermentQuestionActiveArgs = {
  active: Scalars['Boolean']['input'];
  questionId: Scalars['ID']['input'];
};


export type MutationSetGovAccountBalanceArgs = {
  accountId: Scalars['ID']['input'];
  asAt?: InputMaybe<Scalars['DateTime']['input']>;
  balance: Scalars['Float']['input'];
};


export type MutationSetGovChecklistItemDoneArgs = {
  done: Scalars['Boolean']['input'];
  itemId: Scalars['ID']['input'];
};


export type MutationSetGovChecklistVisibilityArgs = {
  input: SetGovChecklistVisibilityInput;
};


export type MutationSetGovDelegateArgs = {
  delegateMemberId?: InputMaybe<Scalars['ID']['input']>;
  organisationId: Scalars['ID']['input'];
};


export type MutationSetGovOrganisationLinkTeaserLevelArgs = {
  id: Scalars['ID']['input'];
  level: GovLinkTeaserLevel;
};


export type MutationSetGovOrganisationLinkTeasersArgs = {
  enabled: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
};


export type MutationSetGovOrganisationPublicPageArgs = {
  enabled: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
  publicMemberList?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSetMainCalendarArgs = {
  calendarId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSetModuleUpgradeServiceConcurrencyArgs = {
  concurrency: Scalars['Int']['input'];
};


export type MutationSetMyBusinessListingPublishedArgs = {
  published: Scalars['Boolean']['input'];
};


export type MutationSetMyRewardPayoutBankDetailsArgs = {
  input: SetRewardPayoutBankDetailsInput;
};


export type MutationSetOrgChartDesignatedRootArgs = {
  employeeId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationSetOrgChartDesignatedRootPlacementArgs = {
  placementId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationSetPasswordArgs = {
  input: SetPasswordInput;
};


export type MutationSetPayrollEnquiryStatusArgs = {
  enquiryId: Scalars['ID']['input'];
  status: PayrollEnquiryStatus;
};


export type MutationSetPhoneLineActiveArgs = {
  active: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
};

export type MutationSetPrimaryIpfsNodeArgs = {
  id: Scalars['ID']['input'];
};


export type MutationSetRequireTwoFactorForSensitiveDataArgs = {
  enabled: Scalars['Boolean']['input'];
};


export type MutationSetSeparationJourneyStepArgs = {
  input: SeparationJourneyStepInput;
};


export type MutationSetSourceContentArgs = {
  contentType: ChannelContent;
  id: Scalars['ID']['input'];
};


export type MutationSetSourceLimitsArgs = {
  id: Scalars['ID']['input'];
  maxShorts?: InputMaybe<Scalars['Int']['input']>;
  maxStreams?: InputMaybe<Scalars['Int']['input']>;
  maxVideos?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationSetSourceMaxVideosArgs = {
  id: Scalars['ID']['input'];
  maxVideos: Scalars['Int']['input'];
};


export type MutationSetSourceQualityArgs = {
  id: Scalars['ID']['input'];
  maxHeight: Scalars['Int']['input'];
};


export type MutationSetSourceWatchArgs = {
  checkIntervalHours?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['ID']['input'];
  watchEnabled: Scalars['Boolean']['input'];
};


export type MutationSetTenantIpfsNodeArgs = {
  nodeId: Scalars['ID']['input'];
  targetTenantId: Scalars['String']['input'];
};


export type MutationSetUpTenantEmailArgs = {
  tenantId: Scalars['ID']['input'];
};


export type MutationSetVoipCallFlagArgs = {
  flagReason?: InputMaybe<Scalars['String']['input']>;
  flagged: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
};


export type MutationSetWaitingListResponsibleArgs = {
  id: Scalars['ID']['input'];
  input: SetWaitingListResponsibleInput;
};


export type MutationSetWalletDiscoverableArgs = {
  discoverable: Scalars['Boolean']['input'];
  scope?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSetupCallForwardingArgs = {
  forwardToNumber: Scalars['String']['input'];
  phoneNumberId: Scalars['ID']['input'];
  recordCalls?: Scalars['Boolean']['input'];
};


export type MutationSetupDomainWithVercelArgs = {
  domain: Scalars['String']['input'];
  launchedSiteId: Scalars['ID']['input'];
};


export type MutationSetupTenantIpfsSubdomainArgs = {
  launchedSiteId: Scalars['ID']['input'];
};


export type MutationShareCalendarArgs = {
  id: Scalars['String']['input'];
  permissions: Array<CalendarPermission>;
  sharedWithEmail: Scalars['String']['input'];
};


export type MutationShareCalendarWithAudienceArgs = {
  calendarId: Scalars['String']['input'];
  kind: CalendarAudienceKind;
  permission: CalendarPermission;
  value: Scalars['String']['input'];
};


export type MutationShareCalendarWithAudiencesArgs = {
  calendarId: Scalars['String']['input'];
  permission: CalendarPermission;
  targets: Array<CalendarAudienceTargetInput>;
};


export type MutationShareCalendarWithClientsArgs = {
  calendarId: Scalars['String']['input'];
  shares: Array<CalendarShareInput>;
};


export type MutationShareMyVisionBoardArgs = {
  clientIds: Array<Scalars['ID']['input']>;
};


export type MutationSharePasswordArgs = {
  clientIds: Array<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
};


export type MutationShelvAddMealServicePhotosArgs = {
  mealPlanId: Scalars['ID']['input'];
  photos: Array<ShelvMealMediaInput>;
};


export type MutationShelvAddRecipeIngredientArgs = {
  input: ShelvCreateRecipeIngredientInput;
};


export type MutationShelvBulkCreateMealPlansArgs = {
  input: ShelvBulkCreateMealPlanInput;
};


export type MutationShelvBulkImportIngredientsArgs = {
  ingredients: Array<ShelvBulkIngredientInput>;
};


export type MutationShelvBulkReplaceRecipeIngredientsArgs = {
  recipeId: Scalars['ID']['input'];
  rows: Array<ShelvBulkReplaceRecipeIngredientInput>;
};


export type MutationShelvBulkUpsertIngredientsArgs = {
  rows: Array<ShelvBulkUpsertIngredientInput>;
};


export type MutationShelvCancelOrderArgs = {
  input: ShelvCancelOrderInput;
};


export type MutationShelvClearMealPlanDateRangeArgs = {
  endDate: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
};


export type MutationShelvClearMealPlanDayArgs = {
  date: Scalars['String']['input'];
};


export type MutationShelvConfirmGeneratedMealPlanArgs = {
  entries: Array<ShelvConfirmMealPlanEntryInput>;
  servings?: Scalars['Int']['input'];
};


export type MutationShelvConfirmInvoiceArgs = {
  edits: ShelvFoodInvoiceEditInput;
  id: Scalars['ID']['input'];
};


export type MutationShelvConfirmOrderArgs = {
  orderId: Scalars['ID']['input'];
  supplierOrderNumber?: InputMaybe<Scalars['String']['input']>;
};


export type MutationShelvCopyMealPlanDateRangeArgs = {
  replace?: InputMaybe<Scalars['Boolean']['input']>;
  sourceEndDate: Scalars['String']['input'];
  sourceStartDate: Scalars['String']['input'];
  targetStartDate: Scalars['String']['input'];
};


export type MutationShelvCopyMealPlanWeekArgs = {
  replace?: InputMaybe<Scalars['Boolean']['input']>;
  sourceStartDate: Scalars['String']['input'];
  targetStartDate: Scalars['String']['input'];
};


export type MutationShelvCreateIngredientArgs = {
  input: ShelvCreateIngredientInput;
};


export type MutationShelvCreateMealFeedbackArgs = {
  input: ShelvCreateMealFeedbackInput;
};


export type MutationShelvCreateMealPlanArgs = {
  input: ShelvCreateMealPlanInput;
};


export type MutationShelvCreateMealPlanNotificationRuleArgs = {
  input: ShelvCreateMealPlanNotificationRuleInput;
};


export type MutationShelvCreateOrderWithItemsArgs = {
  input: ShelvCreateSupplierOrderInput;
  items: Array<ShelvSupplierOrderItemInput>;
};


export type MutationShelvCreateQuickSplitInvoiceArgs = {
  input: ShelvQuickSplitInvoiceInput;
};


export type MutationShelvCreateRecipeArgs = {
  input: ShelvCreateRecipeInput;
};


export type MutationShelvCreateRecipeWithIngredientsArgs = {
  ingredients: Array<ShelvRecipeIngredientItemInput>;
  input: ShelvCreateRecipeInput;
};


export type MutationShelvCreateSupplierArgs = {
  input: ShelvCreateSupplierInput;
};


export type MutationShelvCreateSupplierOrderArgs = {
  input: ShelvCreateSupplierOrderInput;
};


export type MutationShelvDeactivateUnitArgs = {
  migrateTo?: InputMaybe<ShelvUnitType>;
  unit: ShelvUnitType;
};


export type MutationShelvDeleteIngredientArgs = {
  id: Scalars['ID']['input'];
};


export type MutationShelvDeleteInvoiceArgs = {
  id: Scalars['ID']['input'];
};


export type MutationShelvDeleteMealFeedbackArgs = {
  id: Scalars['ID']['input'];
};


export type MutationShelvDeleteMealPlanArgs = {
  id: Scalars['ID']['input'];
};


export type MutationShelvDeleteMealPlanNotificationRuleArgs = {
  id: Scalars['ID']['input'];
};


export type MutationShelvDeleteRecipeArgs = {
  id: Scalars['ID']['input'];
};


export type MutationShelvDeleteSupplierArgs = {
  id: Scalars['ID']['input'];
};


export type MutationShelvDeleteSupplierOrderArgs = {
  id: Scalars['ID']['input'];
};


export type MutationShelvDiscardInvoiceArgs = {
  id: Scalars['ID']['input'];
};


export type MutationShelvDuplicateRecipeArgs = {
  id: Scalars['ID']['input'];
  newName?: InputMaybe<Scalars['String']['input']>;
};


export type MutationShelvForkRecipeArgs = {
  id: Scalars['ID']['input'];
  kitchenId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationShelvGenerateMealPlanAiArgs = {
  input: ShelvGenerateMealPlanAiInput;
};


export type MutationShelvGenerateOrdersFromMealPlansArgs = {
  input: ShelvGenerateOrdersInput;
};


export type MutationShelvLinkInvoiceToOrderArgs = {
  id: Scalars['ID']['input'];
  orderId: Scalars['ID']['input'];
};


export type MutationShelvMapInvoiceLineToIngredientArgs = {
  ingredientId: Scalars['ID']['input'];
  invoiceId: Scalars['ID']['input'];
  lineIndex: Scalars['Int']['input'];
};


export type MutationShelvMarkCookedArgs = {
  dwellSeconds?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['ID']['input'];
  source?: InputMaybe<ShelvCookSource>;
};


export type MutationShelvMarkMealPlanNotificationReadArgs = {
  id: Scalars['ID']['input'];
};


export type MutationShelvMarkOrderDeliveredArgs = {
  input: ShelvMarkDeliveredInput;
};


export type MutationShelvPermanentlyDeleteRecipeArgs = {
  id: Scalars['ID']['input'];
};


export type MutationShelvPublicMealMediaCompleteUploadArgs = {
  uploadId: Scalars['String']['input'];
};


export type MutationShelvPublicMealMediaInitiateUploadArgs = {
  fileName: Scalars['String']['input'];
  fileSize: Scalars['Float']['input'];
  totalChunks: Scalars['Float']['input'];
};


export type MutationShelvPublicMealMediaUploadChunkArgs = {
  chunk: Scalars['Upload']['input'];
  chunkNumber: Scalars['Float']['input'];
  uploadId: Scalars['String']['input'];
};


export type MutationShelvReactivateUnitArgs = {
  unit: ShelvUnitType;
};


export type MutationShelvRemoveRecipeIngredientArgs = {
  id: Scalars['ID']['input'];
};


export type MutationShelvReorderMealPlansArgs = {
  mealType: ShelvMealType;
  orderedIds: Array<Scalars['ID']['input']>;
  slotDate: Scalars['String']['input'];
};


export type MutationShelvReportMealCalendarIssueArgs = {
  input: ShelvMealCalendarIssueReportInput;
};


export type MutationShelvResolveFeedbackArgs = {
  id: Scalars['ID']['input'];
  resolutionNotes?: InputMaybe<Scalars['String']['input']>;
};


export type MutationShelvRetryInvoiceExtractionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationShelvRollUpInferredTagsArgs = {
  kitchenId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationShelvShareRecipeArgs = {
  email: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
};


export type MutationShelvSubmitOrderArgs = {
  input: ShelvSubmitOrderInput;
};


export type MutationShelvSubmitPublicMealFeedbackArgs = {
  input: ShelvSubmitPublicMealFeedbackInput;
};


export type MutationShelvToggleMealPlanAllEventsSubscriptionArgs = {
  enabled: Scalars['Boolean']['input'];
};


export type MutationShelvToggleMealPlanNotificationRuleArgs = {
  id: Scalars['ID']['input'];
};


export type MutationShelvToggleRecipeActiveArgs = {
  id: Scalars['ID']['input'];
};


export type MutationShelvUpdateFoodBudgetArgs = {
  input: ShelvUpdateFoodBudgetInput;
};


export type MutationShelvUpdateIngredientArgs = {
  id: Scalars['ID']['input'];
  input: ShelvUpdateIngredientInput;
};


export type MutationShelvUpdateMealFeedbackArgs = {
  id: Scalars['ID']['input'];
  input: ShelvUpdateMealFeedbackInput;
};


export type MutationShelvUpdateMealPlanArgs = {
  id: Scalars['ID']['input'];
  input: ShelvUpdateMealPlanInput;
};


export type MutationShelvUpdateMealPlanNotificationRuleArgs = {
  id: Scalars['ID']['input'];
  input: ShelvUpdateMealPlanNotificationRuleInput;
};


export type MutationShelvUpdateMealPlanningSettingsArgs = {
  input: ShelvUpdateMealPlanningSettingsInput;
};


export type MutationShelvUpdateRecipeArgs = {
  id: Scalars['ID']['input'];
  input: ShelvUpdateRecipeInput;
};


export type MutationShelvUpdateRecipeIngredientArgs = {
  id: Scalars['ID']['input'];
  input: ShelvUpdateRecipeIngredientInput;
};


export type MutationShelvUpdateSupplierArgs = {
  id: Scalars['ID']['input'];
  input: ShelvUpdateSupplierInput;
};


export type MutationShelvUpdateSupplierOrderArgs = {
  id: Scalars['ID']['input'];
  input: ShelvUpdateSupplierOrderInput;
};


export type MutationShelvUploadInvoiceArgs = {
  input: ShelvUploadInvoiceInput;
};


export type MutationSignInviteContractArgs = {
  input: SignInviteContractInput;
};


export type MutationSignMyEmployeeFormArgs = {
  input: SignMyEmployeeFormInput;
};


export type MutationSignOffProgressNoteArgs = {
  noteId: Scalars['ID']['input'];
};


export type MutationSignOutEverywhereArgs = {
  keepThisDevice?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSignPProposalArgs = {
  clientId?: InputMaybe<Scalars['ID']['input']>;
  emailVerificationCode?: InputMaybe<Scalars['String']['input']>;
  phoneVerificationCode?: InputMaybe<Scalars['String']['input']>;
  postmarkMessageId?: InputMaybe<Scalars['String']['input']>;
  proposalId: Scalars['ID']['input'];
  signatureImage: Scalars['String']['input'];
  signerEmail: Scalars['String']['input'];
  signerName: Scalars['String']['input'];
  signerPhone?: InputMaybe<Scalars['String']['input']>;
  signerRole?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSignProgramAgreementArgs = {
  input: SignProgramAgreementInput;
};


export type MutationSignProposalArgs = {
  clientId?: InputMaybe<Scalars['ID']['input']>;
  emailVerificationCode?: InputMaybe<Scalars['String']['input']>;
  phoneVerificationCode?: InputMaybe<Scalars['String']['input']>;
  postmarkMessageId?: InputMaybe<Scalars['String']['input']>;
  proposalId: Scalars['ID']['input'];
  signatureImage: Scalars['String']['input'];
  signerEmail: Scalars['String']['input'];
  signerName: Scalars['String']['input'];
  signerPhone?: InputMaybe<Scalars['String']['input']>;
  signerRole?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSignupP2BuyerWithEmailCodeArgs = {
  input: P2BuyerSignupInput;
};


export type MutationSignupWithUsernameArgs = {
  input: SignupWithUsernameInput;
};


export type MutationSkipChaseSuggestionArgs = {
  logId: Scalars['String']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSkipEmpowermentCheckInArgs = {
  input: SkipEmpowermentCheckInInput;
};


export type MutationSmsLoginBrowserApprovalArgs = {
  token: Scalars['String']['input'];
};


export type MutationSnoozeProactiveChaserArgs = {
  hours: Scalars['Int']['input'];
};


export type MutationSponsorGovApplicationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationStarInboundEmailArgs = {
  id: Scalars['ID']['input'];
  isStarred: Scalars['Boolean']['input'];
};


export type MutationStartActionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationStartCandidateChatArgs = {
  candidateId: Scalars['ID']['input'];
  customMessage?: InputMaybe<Scalars['String']['input']>;
  sendEmail?: InputMaybe<Scalars['Boolean']['input']>;
  sendSms?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationStartGovJobSpecInstanceArgs = {
  input: StartGovJobSpecInstanceInput;
};


export type MutationStartInboxBacklogJobArgs = {
  input?: InputMaybe<StartEmailBacklogJobInput>;
};


export type MutationStartRecipeCaptureArgs = {
  input: StartRecipeCaptureInput;
};


export type MutationStartReviewArgs = {
  id: Scalars['ID']['input'];
};


export type MutationStartRoundArgs = {
  id: Scalars['ID']['input'];
};


export type MutationStartShiftArgs = {
  id: Scalars['ID']['input'];
};


export type MutationStartVoiceLeaseArgs = {
  agentKey?: InputMaybe<Scalars['String']['input']>;
  sessionId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationStepUpWithCodeArgs = {
  channel: Scalars['String']['input'];
  code: Scalars['String']['input'];
};


export type MutationStepUpWithPasskeyArgs = {
  response: Scalars['String']['input'];
};


export type MutationStepUpWithPasswordArgs = {
  password: Scalars['String']['input'];
};


export type MutationStepUpWithRecoveryCodeArgs = {
  code: Scalars['String']['input'];
};


export type MutationSubmitAcfiAssessmentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationSubmitBankTransferPaymentArgs = {
  amount: Scalars['Float']['input'];
  billId: Scalars['ID']['input'];
  screenshotUrl?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSubmitBdayRsvpArgs = {
  input: RsvpInput;
  slug: Scalars['String']['input'];
};


export type MutationSubmitBusinessEnquiryArgs = {
  input: BusinessEnquiryInput;
};


export type MutationSubmitCalculatorArgs = {
  input: SubmitCalculatorInput;
};


export type MutationSubmitCandidateFormViaSlugArgs = {
  input: SubmitCandidateFormViaSlugInput;
};


export type MutationSubmitClub52WalletAddressArgs = {
  input: SubmitClub52WalletAddressInput;
};


export type MutationSubmitContactFormArgs = {
  input: SubmitContactFormInput;
};


export type MutationSubmitEmployeeOnboardingArgs = {
  input: SubmitEmployeeOnboardingInput;
};


export type MutationSubmitEmpowermentReflectionArgs = {
  checkInId: Scalars['ID']['input'];
};


export type MutationSubmitFeedbackItemArgs = {
  input: SubmitFeedbackInput;
};


export type MutationSubmitGovProofArgs = {
  input: SubmitGovProofInput;
};


export type MutationSubmitGuaranteeClaimArgs = {
  input: SeparationGuaranteeClaimInput;
};


export type MutationSubmitLeadArgs = {
  input: SubmitLeadInput;
};


export type MutationSubmitMyEmployeeIncidentArgs = {
  input: SubmitEmployeeIncidentInput;
};


export type MutationSubmitOrderArgs = {
  input: SubmitOrderInput;
};


export type MutationSubmitPayrollEnquiryArgs = {
  input: SubmitPayrollEnquiryInput;
};


export type MutationSubmitPledgeArgs = {
  input: SubmitPledgeInput;
};


export type MutationSubmitProgramApplicationArgs = {
  input: SubmitProgramApplicationInput;
};


export type MutationSubmitPublicFeedbackItemArgs = {
  input: SubmitFeedbackInput;
};


export type MutationSubmitPublicInquiryArgs = {
  input: SubmitPublicInquiryInput;
};


export type MutationSubmitPublicMaintenanceRequestArgs = {
  input: SubmitPublicMaintenanceRequestInput;
};


export type MutationSubmitPublicMealFeedbackArgs = {
  input: SubmitPublicMealFeedbackInput;
};


export type MutationSubmitReferenceByTokenArgs = {
  input: ReferenceAnswersInput;
  token: Scalars['String']['input'];
};


export type MutationSubmitSecurityScanArgs = {
  input: SubmitSecurityScanInput;
};


export type MutationSubmitShelvInviteFeedbackArgs = {
  input: SubmitShelvFeedbackInput;
};


export type MutationSubmitSiteUpdateArgs = {
  input: SubmitSiteUpdateInput;
};


export type MutationSubmitVisionBoardFeedbackArgs = {
  input: SubmitVisionBoardFeedbackInput;
};


export type MutationSubmitWorkerTimeEntriesArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationSuggestClientGoalArgs = {
  clientName: Scalars['String']['input'];
  context?: InputMaybe<Scalars['String']['input']>;
  targetTenantId?: InputMaybe<Scalars['String']['input']>;
  tenantName: Scalars['String']['input'];
};


export type MutationSuspendValidatorArgs = {
  id: Scalars['ID']['input'];
};


export type MutationSweepGovVoteRemindersArgs = {
  organisationId: Scalars['ID']['input'];
};


export type MutationSyncAccountingBankFeedArgs = {
  companyId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationSyncCallRecordingsArgs = {
  days?: Scalars['Int']['input'];
  phoneNumberId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationSyncEmployeeLoginAccessArgs = {
  employeeId: Scalars['ID']['input'];
};


export type MutationSyncSmsResponsesArgs = {
  pages?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationSyncSopEpisodeRecordingArgs = {
  id: Scalars['ID']['input'];
};


export type MutationTestAdmissionNotificationRuleArgs = {
  id: Scalars['ID']['input'];
};


export type MutationTestAiServiceArgs = {
  testText?: InputMaybe<Scalars['String']['input']>;
};


export type MutationTestBankingAlertRuleArgs = {
  id: Scalars['ID']['input'];
};


export type MutationTestDigitalManagerNotificationRuleArgs = {
  id: Scalars['ID']['input'];
};


export type MutationTestShiftNotificationRuleArgs = {
  id: Scalars['ID']['input'];
};


export type MutationTestSmsNotificationRuleArgs = {
  id: Scalars['ID']['input'];
};


export type MutationTestTenantIpfsGatewayArgs = {
  backup?: InputMaybe<Scalars['Boolean']['input']>;
  tenantId: Scalars['ID']['input'];
};


export type MutationToggleAdmissionNotificationRuleArgs = {
  id: Scalars['ID']['input'];
};


export type MutationToggleAnalyticsNotificationRuleArgs = {
  id: Scalars['ID']['input'];
};


export type MutationToggleAssessmentCustomFieldArgs = {
  id: Scalars['ID']['input'];
  isActive: Scalars['Boolean']['input'];
};


export type MutationToggleAssessmentDomainArgs = {
  id: Scalars['ID']['input'];
  isActive: Scalars['Boolean']['input'];
};


export type MutationToggleAssessmentNotificationRuleArgs = {
  id: Scalars['ID']['input'];
};


export type MutationToggleBillDraftStatusArgs = {
  id: Scalars['ID']['input'];
};


export type MutationToggleBillNotificationRuleArgs = {
  id: Scalars['ID']['input'];
};


export type MutationToggleBillPaymentStatusArgs = {
  id: Scalars['ID']['input'];
};


export type MutationToggleBlogNotificationRuleArgs = {
  id: Scalars['ID']['input'];
};


export type MutationToggleBookableEventTypeStatusArgs = {
  id: Scalars['String']['input'];
};


export type MutationToggleCiActionCompleteArgs = {
  actionIndex: Scalars['Int']['input'];
  initiativeId: Scalars['ID']['input'];
};


export type MutationToggleCiNotificationRuleArgs = {
  id: Scalars['ID']['input'];
};


export type MutationToggleCalendarEventTaskCompletionArgs = {
  id: Scalars['String']['input'];
};


export type MutationToggleClientNotificationRuleArgs = {
  id: Scalars['ID']['input'];
};


export type MutationToggleCommunicationTaskStatusArgs = {
  id: Scalars['ID']['input'];
};


export type MutationToggleCommunityLikeArgs = {
  input: ToggleCommunityLikeInput;
};


export type MutationToggleCompetitionHeartArgs = {
  entryId: Scalars['ID']['input'];
};


export type MutationToggleContributingFactorActiveArgs = {
  id: Scalars['ID']['input'];
};


export type MutationToggleEmployeeIncidentNotificationRuleArgs = {
  id: Scalars['ID']['input'];
};


export type MutationToggleEmployeeNotificationRuleArgs = {
  id: Scalars['ID']['input'];
};


export type MutationToggleEnergyTrackerNotificationRuleArgs = {
  id: Scalars['ID']['input'];
};


export type MutationToggleIncidentLocationActiveArgs = {
  id: Scalars['ID']['input'];
};


export type MutationToggleIncidentTypeActiveArgs = {
  id: Scalars['ID']['input'];
};


export type MutationToggleLeadFlowNotificationRuleArgs = {
  id: Scalars['ID']['input'];
};


export type MutationToggleLifeAspectArgs = {
  id: Scalars['ID']['input'];
  isActive: Scalars['Boolean']['input'];
};


export type MutationToggleMaintenanceAllEventsSubscriptionArgs = {
  enabled: Scalars['Boolean']['input'];
};


export type MutationToggleMaintenanceNotificationRuleArgs = {
  id: Scalars['ID']['input'];
};


export type MutationToggleMealPlanAllEventsSubscriptionArgs = {
  enabled: Scalars['Boolean']['input'];
};


export type MutationToggleMealPlanNotificationRuleArgs = {
  id: Scalars['ID']['input'];
};


export type MutationToggleP2NotificationRuleArgs = {
  id: Scalars['ID']['input'];
};


export type MutationTogglePinCompanyKnowledgeArticleArgs = {
  id: Scalars['ID']['input'];
};


export type MutationToggleProspectingAllEventsSubscriptionArgs = {
  enabled: Scalars['Boolean']['input'];
};


export type MutationToggleRecipeActiveArgs = {
  id: Scalars['ID']['input'];
};


export type MutationToggleShiftNotificationRuleArgs = {
  id: Scalars['ID']['input'];
};


export type MutationToggleSiteEditorSiteActiveArgs = {
  siteId: Scalars['String']['input'];
};


export type MutationToggleSmsNotificationRuleArgs = {
  id: Scalars['ID']['input'];
};


export type MutationToggleVaultInsightRuleArgs = {
  id: Scalars['ID']['input'];
};


export type MutationToggleVlogNotificationRuleArgs = {
  id: Scalars['ID']['input'];
};


export type MutationTouchWalletContactArgs = {
  id: Scalars['ID']['input'];
};


export type MutationTrackEventArgs = {
  input: TrackEventInput;
};


export type MutationTrackPageViewArgs = {
  input: TrackPageViewInput;
};


export type MutationTrackSeparationReferralClickArgs = {
  input: SeparationTrackReferralInput;
  tenantId: Scalars['String']['input'];
};


export type MutationTrackSopCtaClickArgs = {
  slug: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};


export type MutationTrackVlogCtaClickArgs = {
  postId: Scalars['ID']['input'];
};


export type MutationTranscribeAudioArgs = {
  input: TranscriptionUploadInput;
};


export type MutationTranscribeGovBriefArgs = {
  audioCid: Scalars['String']['input'];
};


export type MutationTranscribeRecordingArgs = {
  recordingSid: Scalars['String']['input'];
};


export type MutationTranscribeSopBriefArgs = {
  audioCid: Scalars['String']['input'];
};


export type MutationTranscribeYouTubeVideoArgs = {
  input: TranscribeYouTubeVideoInput;
};


export type MutationTransferCalendarOwnershipArgs = {
  calendarId: Scalars['String']['input'];
  newOwnerId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationTransferDomainArgs = {
  input: DomainTransferInput;
};


export type MutationTransferPhoneNumberToTenantArgs = {
  id: Scalars['ID']['input'];
  input: TransferPhoneNumberInput;
};


export type MutationTransferResidentArgs = {
  input: TransferResidentInput;
  residentId: Scalars['ID']['input'];
};


export type MutationTriggerClientChaseArgs = {
  configId: Scalars['String']['input'];
};


export type MutationTriggerHostingDeployArgs = {
  siteId: Scalars['ID']['input'];
};


export type MutationTriggerIngestionArgs = {
  source: IngestionSource;
  suburb?: InputMaybe<Scalars['String']['input']>;
};


export type MutationTriggerRebuildArgs = {
  launchedSiteId: Scalars['ID']['input'];
};


export type MutationTriggerTenantAutomationArgs = {
  input: TriggerAutomationInput;
};


export type MutationUnarchiveMultipleInboundEmailsArgs = {
  ids: Array<Scalars['String']['input']>;
};


export type MutationUnassignEmailFromClientArgs = {
  clientId: Scalars['String']['input'];
  emailId: Scalars['String']['input'];
};


export type MutationUnassignPhoneNumberFromClientArgs = {
  clientId: Scalars['ID']['input'];
  phoneNumberId: Scalars['ID']['input'];
};


export type MutationUnfollowCompetitionArgs = {
  competitionId: Scalars['ID']['input'];
};


export type MutationUnfollowCompetitionByTokenArgs = {
  token: Scalars['String']['input'];
};


export type MutationUnlinkCiIssueFromInitiativeArgs = {
  issueId: Scalars['ID']['input'];
};


export type MutationUnlinkCiIssueFromMeetingArgs = {
  issueId: Scalars['ID']['input'];
  meetingId: Scalars['ID']['input'];
};


export type MutationUnlinkCommsSmsAppArgs = {
  appName: Scalars['String']['input'];
};


export type MutationUnlinkFeedbackOutcomeArgs = {
  feedbackId: Scalars['ID']['input'];
  kind: FeedbackOutcomeKind;
  targetId: Scalars['ID']['input'];
};


export type MutationUnlinkInitiativeFromMeetingArgs = {
  initiativeId: Scalars['ID']['input'];
  meetingId: Scalars['ID']['input'];
};


export type MutationUnlinkIssueFromInitiativeArgs = {
  initiativeId: Scalars['ID']['input'];
  issueId: Scalars['ID']['input'];
};


export type MutationUnlinkMaintenanceFromCiArgs = {
  id: Scalars['ID']['input'];
};


export type MutationUnlinkMaintenanceFromInitiativeArgs = {
  initiativeId: Scalars['ID']['input'];
};


export type MutationUnlockWalletKeystoreArgs = {
  address: Scalars['String']['input'];
  code: Scalars['String']['input'];
};


export type MutationUnmarkBdayInviteSentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationUnmarkEmailAsSpamArgs = {
  ruleId: Scalars['ID']['input'];
};


export type MutationUnpinCalendarArgs = {
  calendarId: Scalars['String']['input'];
};


export type MutationUnpublishCompanyKnowledgeArticleArgs = {
  id: Scalars['ID']['input'];
};


export type MutationUnpublishSeoMetadataArgs = {
  pagePath: Scalars['String']['input'];
};


export type MutationUnpublishShiftArgs = {
  id: Scalars['ID']['input'];
};


export type MutationUnpublishSopEpisodeArgs = {
  id: Scalars['ID']['input'];
};


export type MutationUnregisterP2InterestArgs = {
  id: Scalars['ID']['input'];
};


export type MutationUnshareCalendarArgs = {
  calendarId: Scalars['String']['input'];
  clientId: Scalars['String']['input'];
};


export type MutationUnshareCalendarAudienceArgs = {
  calendarId: Scalars['String']['input'];
  kind: CalendarAudienceKind;
  value: Scalars['String']['input'];
};


export type MutationUpdateAcfiAssessmentArgs = {
  id: Scalars['ID']['input'];
  input: UpdateAcfiAssessmentInput;
};


export type MutationUpdateAccountabilityGoalArgs = {
  id: Scalars['ID']['input'];
  input: UpdateAccountabilityGoalInput;
};


export type MutationUpdateAccountabilityGoalStatusArgs = {
  id: Scalars['ID']['input'];
  status: AccountabilityGoalStatus;
};


export type MutationUpdateAccountingBankAccountArgs = {
  input: UpdateAccountingBankAccountInput;
};


export type MutationUpdateActivitiesArgs = {
  input: ActivitiesUpdateInput;
  profileId: Scalars['ID']['input'];
};


export type MutationUpdateAdmissionChecklistTemplateArgs = {
  input: UpdateChecklistTemplateInput;
  templateId: Scalars['ID']['input'];
};


export type MutationUpdateAdmissionNotificationRuleArgs = {
  input: UpdateAdmissionNotificationRuleInput;
};


export type MutationUpdateAdmissionsSettingsArgs = {
  input: UpdateAdmissionsSettingsInput;
};


export type MutationUpdateAdvisoryBodyArgs = {
  id: Scalars['ID']['input'];
  input: UpdateAdvisoryBodyInput;
};


export type MutationUpdateAllergyArgs = {
  id: Scalars['ID']['input'];
  input: UpdateAllergyInput;
};


export type MutationUpdateAnalyticsNotificationRuleArgs = {
  input: UpdateAnalyticsNotificationRuleInput;
};


export type MutationUpdateArtSessionArgs = {
  id: Scalars['ID']['input'];
  input: UpdateArtSessionInput;
};


export type MutationUpdateArtifactSharingArgs = {
  input: UpdateArtifactSharingInput;
};


export type MutationUpdateAssessmentCustomFieldArgs = {
  id: Scalars['ID']['input'];
  input: UpdateAssessmentCustomFieldInput;
};


export type MutationUpdateAssessmentDomainArgs = {
  id: Scalars['ID']['input'];
  input: UpdateAssessmentDomainInput;
};


export type MutationUpdateAssessmentNotificationRuleArgs = {
  input: UpdateAssessmentNotificationRuleInput;
};


export type MutationUpdateAssessmentSnapshotArgs = {
  id: Scalars['ID']['input'];
  input: UpdateAssessmentSnapshotInput;
};


export type MutationUpdateAssignmentDepartmentsArgs = {
  departmentIds: Array<Scalars['String']['input']>;
  employeeId: Scalars['ID']['input'];
  shiftId: Scalars['ID']['input'];
};


export type MutationUpdateAssignmentStatusArgs = {
  employeeId: Scalars['ID']['input'];
  shiftId: Scalars['ID']['input'];
  status: AssignmentStatus;
};


export type MutationUpdateAvailabilityStatusArgs = {
  id: Scalars['ID']['input'];
  status: AvailabilityStatus;
};


export type MutationUpdateAwardArgs = {
  input: UpdateAwardInput;
};


export type MutationUpdateAwardClassificationArgs = {
  id: Scalars['ID']['input'];
  input: UpdateAwardClassificationInput;
};


export type MutationUpdateAwardRateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateAwardRateInput;
};


export type MutationUpdateBankingAccountArgs = {
  input: UpdateBankingAccountInput;
};


export type MutationUpdateBankingCashEntryArgs = {
  input: UpdateBankingCashEntryInput;
};


export type MutationUpdateBankingMonthPlanArgs = {
  input: UpdateBankingMonthPlanInput;
};


export type MutationUpdateBankingSettingsArgs = {
  input: UpdateBankingSettingsInput;
};


export type MutationUpdateBdayGuestArgs = {
  id: Scalars['ID']['input'];
  input: UpdateBdayGuestInput;
};


export type MutationUpdateBehavioralArgs = {
  input: BehavioralUpdateInput;
  profileId: Scalars['ID']['input'];
};


export type MutationUpdateBillArgs = {
  id: Scalars['ID']['input'];
  input: BillInput;
};


export type MutationUpdateBillNotificationRuleArgs = {
  input: UpdateBillNotificationRuleInput;
};


export type MutationUpdateBillPaymentStatusArgs = {
  id: Scalars['ID']['input'];
  isPaid: Scalars['Boolean']['input'];
};


export type MutationUpdateBillStatusArgs = {
  id: Scalars['ID']['input'];
  status: BillStatus;
};


export type MutationUpdateBillStatusWithoutNotificationsArgs = {
  cancellationReason?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  status: BillStatus;
};


export type MutationUpdateBillsReportingSettingsArgs = {
  input: BillsReportingSettingsInput;
};


export type MutationUpdateBillsSettingsArgs = {
  input: BillsSettingsInput;
};


export type MutationUpdateBlogCategoryArgs = {
  id: Scalars['ID']['input'];
  input: UpdateBlogCategoryInput;
};


export type MutationUpdateBlogNotificationRuleArgs = {
  input: UpdateBlogNotificationRuleInput;
};


export type MutationUpdateBlogPostArgs = {
  id: Scalars['ID']['input'];
  input: UpdateBlogPostInput;
};


export type MutationUpdateBookableEventTypeArgs = {
  id: Scalars['String']['input'];
  input: UpdateBusinessCalendarBookableEventTypeInput;
};


export type MutationUpdateBookingPaymentArgs = {
  bookingId: Scalars['String']['input'];
  paymentDetails?: InputMaybe<Scalars['String']['input']>;
  paymentStatus: BookingPaymentStatus;
};


export type MutationUpdateBusinessCalendarAvailabilityArgs = {
  calendarId: Scalars['String']['input'];
  input: UpdateBusinessCalendarAvailabilityInput;
};


export type MutationUpdateBusinessDirectoryNotificationRuleArgs = {
  input: UpdateBusinessDirectoryNotificationRuleInput;
};


export type MutationUpdateCiAgendaItemArgs = {
  input: UpdateCiAgendaItemInput;
  meetingId: Scalars['ID']['input'];
};


export type MutationUpdateCiGovernanceMeetingArgs = {
  id: Scalars['ID']['input'];
  input: UpdateCiGovernanceMeetingInput;
};


export type MutationUpdateCiImprovementInitiativeArgs = {
  id: Scalars['ID']['input'];
  input: UpdateCiImprovementInitiativeInput;
};


export type MutationUpdateCiInitiativeActionArgs = {
  actionIndex: Scalars['Int']['input'];
  initiativeId: Scalars['ID']['input'];
  input: UpdateCiActionInput;
};


export type MutationUpdateCiInitiativeStatusArgs = {
  id: Scalars['ID']['input'];
  status: CiInitiativeStatus;
};


export type MutationUpdateCiIssueReportArgs = {
  id: Scalars['ID']['input'];
  input: UpdateCiIssueReportInput;
};


export type MutationUpdateCiIssueStatusArgs = {
  id: Scalars['ID']['input'];
  status: CiIssueStatus;
};


export type MutationUpdateCiMeetingActionStatusArgs = {
  actionIndex: Scalars['Float']['input'];
  meetingId: Scalars['ID']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  status: CiDecisionActionStatus;
};


export type MutationUpdateCiMeetingStatusArgs = {
  id: Scalars['ID']['input'];
  status: CiMeetingStatus;
};


export type MutationUpdateCiNotificationRuleArgs = {
  input: UpdateCiNotificationRuleInput;
};


export type MutationUpdateCalculatorSubmissionStatusArgs = {
  input: UpdateSubmissionStatusInput;
};


export type MutationUpdateCalendarArgs = {
  id: Scalars['String']['input'];
  input: UpdateBusinessCalendarInput;
};


export type MutationUpdateCalendarEventTaskArgs = {
  id: Scalars['String']['input'];
  input: CalendarEventTaskInput;
};


export type MutationUpdateCalendarEventTaskChecklistItemArgs = {
  input: UpdateCalendarEventTaskChecklistInput;
};


export type MutationUpdateCalendarGoalArgs = {
  id: Scalars['String']['input'];
  input: CalendarGoalInput;
};


export type MutationUpdateCandidateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateCandidateInput;
};


export type MutationUpdateCandidateFormArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  employerBrandColor?: InputMaybe<Scalars['String']['input']>;
  employerLogoUrl?: InputMaybe<Scalars['String']['input']>;
  employerName?: InputMaybe<Scalars['String']['input']>;
  fields?: InputMaybe<Array<CandidateFormFieldInput>>;
  id: Scalars['ID']['input'];
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateCandidateFormPositionArgs = {
  id: Scalars['ID']['input'];
  input: UpdateCandidateFormPositionInput;
};


export type MutationUpdateCareHomeArgs = {
  id: Scalars['ID']['input'];
  input: CareHomeUpdateInput;
};


export type MutationUpdateCarePlanArgs = {
  id: Scalars['ID']['input'];
  input: UpdateCarePlanInput;
};


export type MutationUpdateCarePlanTemplateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateCarePlanTemplateInput;
};


export type MutationUpdateCareReviewArgs = {
  id: Scalars['ID']['input'];
  input: UpdateCareReviewInput;
};


export type MutationUpdateCareReviewCycleSettingsArgs = {
  input: UpdateCareReviewCycleSettingsInput;
};


export type MutationUpdateChaseNotificationRuleArgs = {
  id: Scalars['ID']['input'];
  input: UpdateChaseNotificationRuleInput;
};


export type MutationUpdateChatRoomArgs = {
  id: Scalars['ID']['input'];
  input: ChatRoomUpdateInput;
};


export type MutationUpdateChecklistItemArgs = {
  completed: Scalars['Boolean']['input'];
  itemId: Scalars['String']['input'];
  jobId: Scalars['ID']['input'];
  mechanicPhone?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateClientArgs = {
  id: Scalars['ID']['input'];
  input: UpdateClientInput;
};


export type MutationUpdateClientActivityArgs = {
  id: Scalars['ID']['input'];
  input: UpdateClientActivityInput;
};


export type MutationUpdateClientChaseConfigArgs = {
  id: Scalars['String']['input'];
  input: UpdateClientChaseConfigInput;
};


export type MutationUpdateClientContactCrossTenantArgs = {
  clientId: Scalars['String']['input'];
  fName?: InputMaybe<Scalars['String']['input']>;
  lName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  targetTenantId: Scalars['String']['input'];
};


export type MutationUpdateClientNotificationRuleArgs = {
  input: UpdateClientNotificationRuleInput;
};


export type MutationUpdateClinicalTaskArgs = {
  id: Scalars['ID']['input'];
  input: UpdateClinicalTaskInput;
};


export type MutationUpdateClub52GamePlayersArgs = {
  invitees: Array<Club52InviteeInput>;
  roomName: Scalars['String']['input'];
};


export type MutationUpdateClub52PlayerArgs = {
  input: UpdateClub52PlayerInput;
  playerId: Scalars['String']['input'];
};


export type MutationUpdateClub52SettingsArgs = {
  input: UpdateClub52SettingsInput;
};


export type MutationUpdateCoachArgs = {
  id: Scalars['ID']['input'];
  input: UpdateCoachInput;
};


export type MutationUpdateCoachAgreementArgs = {
  id: Scalars['ID']['input'];
  input: UpdateCoachAgreementInput;
};


export type MutationUpdateCodingRuleArgs = {
  input: UpdateCodingRuleInput;
};


export type MutationUpdateCommandIntegrationConfigArgs = {
  input: UpdateCommandIntegrationConfigInput;
};


export type MutationUpdateCommsHealthSettingsArgs = {
  input: UpdateCommsHealthSettingsInput;
};


export type MutationUpdateCommsLogSettingsArgs = {
  input: UpdateCommsLogSettingsInput;
};


export type MutationUpdateCommunicationArgs = {
  input: CommunicationUpdateInput;
  profileId: Scalars['ID']['input'];
};


export type MutationUpdateCommunicationTaskArgs = {
  id: Scalars['ID']['input'];
  input: UpdateCommunicationTaskInput;
};


export type MutationUpdateCommunityCampaignArgs = {
  id: Scalars['ID']['input'];
  input: UpdateCommunityCampaignInput;
};


export type MutationUpdateCommunityConfigArgs = {
  input: UpdateCommunityConfigInput;
};


export type MutationUpdateCommunityEntryArgs = {
  input: UpdateCommunityEntryInput;
};


export type MutationUpdateCommunityMemberSettingsAsAdminArgs = {
  clientId: Scalars['ID']['input'];
  input: UpdateCommunityMemberSettingsInput;
  overrideSelfSet?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationUpdateCompanyArgs = {
  id: Scalars['ID']['input'];
  input: UpdateCompanyInput;
};


export type MutationUpdateCompanyKnowledgeArticleArgs = {
  id: Scalars['ID']['input'];
  input: UpdateCompanyKnowledgeInput;
};


export type MutationUpdateCompetitionArgs = {
  id: Scalars['ID']['input'];
  input: UpdateCompetitionInput;
};


export type MutationUpdateCompetitionPrintOfferArgs = {
  id: Scalars['ID']['input'];
  input: UpdateCompetitionPrintOfferInput;
};


export type MutationUpdateCompetitionSchoolArgs = {
  id: Scalars['ID']['input'];
  input: UpdateCompetitionSchoolInput;
};


export type MutationUpdateCompetitionSponsorArgs = {
  id: Scalars['ID']['input'];
  input: UpdateCompetitionSponsorInput;
};


export type MutationUpdateConstructionSiteArgs = {
  id: Scalars['ID']['input'];
  input: UpdateConstructionSiteInput;
};


export type MutationUpdateContributingFactorArgs = {
  id: Scalars['ID']['input'];
  input: UpdateContributingFactorInput;
};


export type MutationUpdateCouponArgs = {
  id: Scalars['ID']['input'];
  input: UpdateCouponInput;
};


export type MutationUpdateCryptoVaultArgs = {
  id: Scalars['ID']['input'];
  input: UpdateVaultInput;
};


export type MutationUpdateCustomQuestionArgs = {
  id: Scalars['ID']['input'];
  input: UpdateCustomQuestionInput;
};


export type MutationUpdateCustomTestDefinitionArgs = {
  id: Scalars['ID']['input'];
  input: UpdateCustomTestDefinitionInput;
};


export type MutationUpdateDailyCareProfileArgs = {
  id: Scalars['ID']['input'];
  input: UpdateDailyCareProfileInput;
};


export type MutationUpdateDepartmentArgs = {
  id: Scalars['ID']['input'];
  input: UpdateDepartmentInput;
};


export type MutationUpdateDigitalManagerArgs = {
  id: Scalars['ID']['input'];
  input: UpdateDigitalManagerInput;
};


export type MutationUpdateDigitalManagerMemoryArgs = {
  id: Scalars['ID']['input'];
  input: UpdateDigitalManagerMemoryInput;
};


export type MutationUpdateDigitalManagerNotificationRuleArgs = {
  id: Scalars['ID']['input'];
  input: UpdateDigitalManagerNotificationRuleInput;
};


export type MutationUpdateDigitalManagerRuleArgs = {
  id: Scalars['ID']['input'];
  input: UpdateDigitalManagerRuleInput;
};


export type MutationUpdateDigitalManagerTemplateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateDigitalManagerTemplateInput;
};


export type MutationUpdateDroneSessionArgs = {
  id: Scalars['ID']['input'];
  input: UpdateDroneSessionInput;
};


export type MutationUpdateEoiStatusArgs = {
  id: Scalars['ID']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  status: EoiStatus;
};


export type MutationUpdateEmailArgs = {
  id: Scalars['ID']['input'];
  input: EmailUpdateInput;
};


export type MutationUpdateEmailAddressArgs = {
  id: Scalars['String']['input'];
  input: EmailAddressUpdateInput;
};


export type MutationUpdateEmailAiMemoryArgs = {
  id: Scalars['ID']['input'];
  input: UpdateEmailAiMemoryInput;
};


export type MutationUpdateEmailAiProactiveSettingsArgs = {
  input: UpdateEmailAiProactiveSettingsInput;
};


export type MutationUpdateEmailAiRuleArgs = {
  id: Scalars['ID']['input'];
  input: UpdateEmailAiRuleInput;
};


export type MutationUpdateEmployeeArgs = {
  id: Scalars['ID']['input'];
  input: UpdateEmployeeInput;
};


export type MutationUpdateEmployeeActivityArgs = {
  id: Scalars['ID']['input'];
  input: UpdateEmployeeActivityInput;
};


export type MutationUpdateEmployeeActivityTagArgs = {
  id: Scalars['ID']['input'];
  input: UpdateEmployeeActivityTagInput;
};


export type MutationUpdateEmployeeContractTemplateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateEmployeeContractTemplateInput;
};


export type MutationUpdateEmployeeFormSettingArgs = {
  input: UpdateEmployeeFormSettingInput;
};


export type MutationUpdateEmployeeIncidentArgs = {
  id: Scalars['ID']['input'];
  input: UpdateEmployeeIncidentInput;
};


export type MutationUpdateEmployeeIncidentNotificationRuleArgs = {
  input: UpdateEmployeeIncidentNotificationRuleInput;
};


export type MutationUpdateEmployeeModuleSettingsArgs = {
  input: UpdateEmployeeModuleSettingInput;
};


export type MutationUpdateEmployeeNotificationRuleArgs = {
  input: UpdateEmployeeNotificationRuleInput;
};


export type MutationUpdateEmployeePositionArgs = {
  id: Scalars['ID']['input'];
  input: UpdateEmployeePositionInput;
};


export type MutationUpdateEmployeeReportsToArgs = {
  input: UpdateEmployeeReportsToInput;
};


export type MutationUpdateEmployeeRoleArgs = {
  id: Scalars['ID']['input'];
  input: UpdateEmployeeRoleInput;
};


export type MutationUpdateEmployeeStatusOptionArgs = {
  id: Scalars['ID']['input'];
  input: UpdateEmployeeStatusOptionInput;
};


export type MutationUpdateEmployeeTrainingAssignmentArgs = {
  id: Scalars['ID']['input'];
  input: UpdateEmployeeTrainingAssignmentInput;
};


export type MutationUpdateEmployeeTrainingCategoryArgs = {
  id: Scalars['ID']['input'];
  input: UpdateEmployeeTrainingCategoryInput;
};


export type MutationUpdateEmployeeWithPersonalArgs = {
  clientPersonal?: InputMaybe<UpdateEmployeeClientPersonalInput>;
  id: Scalars['ID']['input'];
  input: UpdateEmployeeInput;
};


export type MutationUpdateEmpowermentCatchUpArgs = {
  input: UpdateEmpowermentCatchUpInput;
};


export type MutationUpdateEmpowermentGoalArgs = {
  input: UpdateEmpowermentGoalInput;
};


export type MutationUpdateEmpowermentJourneyArgs = {
  input: UpdateEmpowermentJourneyInput;
};


export type MutationUpdateEmpowermentSettingsArgs = {
  input: UpdateEmpowermentSettingsInput;
};


export type MutationUpdateEnergyTrackerNotificationRuleArgs = {
  input: UpdateEnergyTrackerNotificationRuleInput;
};


export type MutationUpdateEventArgs = {
  id: Scalars['String']['input'];
  input: CalendarEventInput;
  notifyAttendees?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationUpdateFarmerArgs = {
  id: Scalars['ID']['input'];
  input: UpdateFarmerInput;
};


export type MutationUpdateFeedbackItemArgs = {
  id: Scalars['ID']['input'];
  input: UpdateFeedbackInput;
};


export type MutationUpdateFeedbackItemStatusArgs = {
  id: Scalars['ID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  status: FeedbackStatus;
};


export type MutationUpdateFeedbackNotificationRuleArgs = {
  input: UpdateFeedbackNotificationRuleInput;
};


export type MutationUpdateFeedbackSettingsArgs = {
  input: UpdateFeedbackSettingsInput;
};


export type MutationUpdateFileTransferArgs = {
  id: Scalars['ID']['input'];
  input: UpdateFileTransferInput;
};


export type MutationUpdateFileTransferStateArgs = {
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  state: FileTransferState;
};


export type MutationUpdateFoodBudgetArgs = {
  input: UpdateFoodBudgetInput;
};


export type MutationUpdateFrontendUpgradeArgs = {
  id: Scalars['ID']['input'];
  input: UpdateFrontendUpgradeInput;
};


export type MutationUpdateFuelStationArgs = {
  input: UpdateFuelStationInput;
};


export type MutationUpdateGoalArgs = {
  carePlanId: Scalars['ID']['input'];
  goalIndex: Scalars['Int']['input'];
  input: CarePlanGoalInput;
};


export type MutationUpdateGoalActionArgs = {
  id: Scalars['ID']['input'];
  input: UpdateGoalActionInput;
};


export type MutationUpdateGoalCheckpointArgs = {
  input: UpdateGoalCheckpointInput;
};


export type MutationUpdateGoalProgressArgs = {
  carePlanId: Scalars['ID']['input'];
  goalIndex: Scalars['Int']['input'];
  input: UpdateGoalProgressInput;
};


export type MutationUpdateGovJobSpecArgs = {
  id: Scalars['ID']['input'];
  input: UpdateGovJobSpecInput;
};


export type MutationUpdateGovMemberArgs = {
  id: Scalars['ID']['input'];
  input: UpdateGovMemberInput;
};


export type MutationUpdateGovMembershipPlanArgs = {
  id: Scalars['ID']['input'];
  input: UpdateGovMembershipPlanInput;
};


export type MutationUpdateGovNotificationRuleArgs = {
  id: Scalars['ID']['input'];
  input: UpdateGovNotificationRuleInput;
};


export type MutationUpdateGovOrganisationArgs = {
  changeNote?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  input: UpdateGovOrganisationInput;
};


export type MutationUpdateGovParticipationAsAdminArgs = {
  clientId: Scalars['ID']['input'];
  input: UpdateGovParticipationInput;
  organisationId: Scalars['ID']['input'];
  overrideSelfSet?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationUpdateGovProposalArgs = {
  id: Scalars['ID']['input'];
  input: UpdateGovProposalInput;
};


export type MutationUpdateGrowthEngineConfigArgs = {
  defaultChannel?: InputMaybe<Scalars['String']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  targetTag?: InputMaybe<Scalars['String']['input']>;
  tenantId: Scalars['String']['input'];
};


export type MutationUpdateHarvestedVideoArgs = {
  id: Scalars['ID']['input'];
  input: UpdateHarvestedVideoInput;
};


export type MutationUpdateHolidayPayRatesArgs = {
  holidayId: Scalars['ID']['input'];
  payRates: Array<HolidayPayRateInput>;
};


export type MutationUpdateHolisticSnapshotArgs = {
  id: Scalars['ID']['input'];
  input: UpdateHolisticSnapshotInput;
};


export type MutationUpdateHostingAffiliateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateHostingAffiliateInput;
};


export type MutationUpdateHostingOfferArgs = {
  id: Scalars['ID']['input'];
  input: UpdateHostingOfferInput;
};


export type MutationUpdateHostingReferralArgs = {
  id: Scalars['ID']['input'];
  input: UpdateHostingReferralInput;
};


export type MutationUpdateHostingSiteArgs = {
  id: Scalars['ID']['input'];
  input: UpdateHostingSiteInput;
};


export type MutationUpdateInboxSummaryPreferenceArgs = {
  input: UpdateInboxSummaryPreferenceInput;
};


export type MutationUpdateIncidentArgs = {
  id: Scalars['ID']['input'];
  input: UpdateIncidentInput;
};


export type MutationUpdateIncidentLocationArgs = {
  id: Scalars['ID']['input'];
  input: UpdateIncidentLocationInput;
};


export type MutationUpdateIncidentTypeArgs = {
  id: Scalars['ID']['input'];
  input: UpdateIncidentTypeInput;
};


export type MutationUpdateInfluencerArgs = {
  id: Scalars['ID']['input'];
  input: UpdateInfluencerInput;
};


export type MutationUpdateInfluencerBookingStatusArgs = {
  id: Scalars['ID']['input'];
  status: InfluencerBookingStatus;
};


export type MutationUpdateInfluencerMetricsArgs = {
  id: Scalars['ID']['input'];
};


export type MutationUpdateIngredientArgs = {
  id: Scalars['ID']['input'];
  input: UpdateIngredientInput;
};


export type MutationUpdateInterventionArgs = {
  carePlanId: Scalars['ID']['input'];
  input: CarePlanInterventionInput;
  interventionIndex: Scalars['Int']['input'];
};


export type MutationUpdateInvestmentProjectArgs = {
  id: Scalars['ID']['input'];
  input: UpdateInvestmentProjectInput;
};


export type MutationUpdateInvestorArgs = {
  id: Scalars['ID']['input'];
  input: UpdateInvestorInput;
};


export type MutationUpdateInvestorStageArgs = {
  id: Scalars['ID']['input'];
  stage: InvestorStage;
};


export type MutationUpdateInvoiceArgs = {
  id: Scalars['ID']['input'];
  input: UpdateInvoiceInput;
};


export type MutationUpdateIpfsNodeArgs = {
  id: Scalars['ID']['input'];
  input: IpfsNodeInput;
};


export type MutationUpdateJobArgs = {
  id: Scalars['ID']['input'];
  input: UpdateJobInput;
};


export type MutationUpdateJobVehicleArgs = {
  id: Scalars['ID']['input'];
  input: UpdateJobVehicleInput;
};


export type MutationUpdateJourneyTemplateArgs = {
  id: Scalars['ID']['input'];
  milestones: Array<JourneyMilestoneInput>;
};


export type MutationUpdateKitchenArgs = {
  id: Scalars['ID']['input'];
  input: ShelvUpdateKitchenInput;
};


export type MutationUpdateKitchenMemberArgs = {
  input: KitchenMemberInput;
  kitchenId: Scalars['ID']['input'];
};


export type MutationUpdateLmSettingsArgs = {
  input: UpdateLmSettingsInput;
};


export type MutationUpdateLastSeenArgs = {
  anonToken?: InputMaybe<Scalars['String']['input']>;
  roomId: Scalars['ID']['input'];
};


export type MutationUpdateLeadArgs = {
  input: UpdateLeadInput;
};


export type MutationUpdateLeadFlowActionArgs = {
  input: UpdateLeadFlowActionInput;
};


export type MutationUpdateLeadFlowFormArgs = {
  input: UpdateLeadFlowFormInput;
};


export type MutationUpdateLeadFlowNotificationRuleArgs = {
  input: UpdateLeadFlowNotificationRuleInput;
};


export type MutationUpdateLeadFlowSequenceArgs = {
  input: UpdateLeadFlowSequenceInput;
};


export type MutationUpdateLeadFlowStageArgs = {
  input: UpdateLeadFlowStageInput;
};


export type MutationUpdateLedgerAccountArgs = {
  input: UpdateLedgerAccountInput;
};


export type MutationUpdateLifeAspectArgs = {
  id: Scalars['ID']['input'];
  input: UpdateLifeAspectInput;
};


export type MutationUpdateLineItemArgs = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  billId: Scalars['ID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  lineItemId: Scalars['ID']['input'];
};


export type MutationUpdateLocationArgs = {
  id: Scalars['ID']['input'];
  input: UpdateLocationInput;
};


export type MutationUpdateMaintenanceChecklistItemArgs = {
  id: Scalars['ID']['input'];
  input: UpdateChecklistItemInput;
};


export type MutationUpdateMaintenanceNotificationRuleArgs = {
  input: UpdateMaintenanceNotificationRuleInput;
};


export type MutationUpdateMaintenanceRequestArgs = {
  id: Scalars['ID']['input'];
  input: UpdateMaintenanceRequestInput;
};


export type MutationUpdateMaintenanceStatusArgs = {
  blockedById?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  onHoldReason?: InputMaybe<Scalars['String']['input']>;
  status: MaintenanceStatus;
};


export type MutationUpdateMealFeedbackArgs = {
  id: Scalars['ID']['input'];
  input: UpdateMealFeedbackInput;
};


export type MutationUpdateMealPlanArgs = {
  id: Scalars['ID']['input'];
  input: UpdateMealPlanInput;
};


export type MutationUpdateMealPlanNotificationRuleArgs = {
  id: Scalars['ID']['input'];
  input: UpdateMealPlanNotificationRuleInput;
};


export type MutationUpdateMealPlanningSettingsArgs = {
  input: UpdateMealPlanningSettingsInput;
};


export type MutationUpdateMechanicJobArgs = {
  id: Scalars['ID']['input'];
  input: UpdateMechanicJobInput;
};


export type MutationUpdateMechanicJobStatusArgs = {
  id: Scalars['ID']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  status: MechanicJobStatus;
};


export type MutationUpdateMechanicNotificationRuleArgs = {
  id: Scalars['ID']['input'];
  input: UpdateMechanicNotificationRuleInput;
};


export type MutationUpdateMediaFolderArgs = {
  id: Scalars['String']['input'];
  input: UpdateMediaFolderInput;
};


export type MutationUpdateMediaItemArgs = {
  id: Scalars['String']['input'];
  input: UpdateMediaItemInput;
};


export type MutationUpdateMedicalRecordsShiftRuleArgs = {
  input: UpdateMedicalRecordsShiftRuleInput;
};


export type MutationUpdateMedicationArgs = {
  id: Scalars['ID']['input'];
  input: UpdateMedicationInput;
};


export type MutationUpdateMeetRecordingArgs = {
  input: UpdateMeetRecordingInput;
  recordingId: Scalars['ID']['input'];
  roomName: Scalars['String']['input'];
};


export type MutationUpdateMeetingParticipantsArgs = {
  participants: Array<MeetParticipantInput>;
  roomName: Scalars['String']['input'];
};


export type MutationUpdateMilestoneArgs = {
  carePlanId: Scalars['ID']['input'];
  goalIndex: Scalars['Int']['input'];
  input: UpdateMilestoneInput;
  milestoneIndex: Scalars['Int']['input'];
};


export type MutationUpdateMobilityArgs = {
  input: MobilityUpdateInput;
  profileId: Scalars['ID']['input'];
};


export type MutationUpdateMobilityAidsArgs = {
  id: Scalars['ID']['input'];
  input: UpdateMobilityAidsInput;
};


export type MutationUpdateMonthlyChecklistSettingsArgs = {
  input: UpdateMonthlyChecklistSettingsInput;
};


export type MutationUpdateMoodEntryArgs = {
  id: Scalars['ID']['input'];
  input: UpdateMoodEntryInput;
};


export type MutationUpdateMotivationTemplateArgs = {
  id: Scalars['String']['input'];
  input: MotivationPromptTemplateUpdateInput;
};


export type MutationUpdateMyBankingDigestPreferenceArgs = {
  input: UpdateBankingDigestPreferenceInput;
};


export type MutationUpdateMyCommunityMemberSettingsArgs = {
  input: UpdateCommunityMemberSettingsInput;
};


export type MutationUpdateMyDomainNameArgs = {
  domainName: Scalars['String']['input'];
};


export type MutationUpdateMyEmployeeProfileArgs = {
  clientInput?: InputMaybe<UpdateMyClientProfileInput>;
  employeeInput: UpdateMyEmployeeProfileInput;
};


export type MutationUpdateMyGovParticipationArgs = {
  input: UpdateGovParticipationInput;
  organisationId: Scalars['ID']['input'];
};


export type MutationUpdateMySmsAcmaRegistrationArgs = {
  input: AcmaRegistrationInput;
};


export type MutationUpdateMyVoicePreferencesArgs = {
  input: VoicePreferencesInput;
};


export type MutationUpdateMyWebsiteArgs = {
  input: UpdateTenantInput;
};


export type MutationUpdateNameserversArgs = {
  input: UpdateNameserversInput;
};


export type MutationUpdateNeurologicalPeriodArgs = {
  id: Scalars['ID']['input'];
  input: UpdateNeurologicalPeriodInput;
};


export type MutationUpdateNotificationContactsArgs = {
  input: UpdateNotificationContactsInput;
  vaultId: Scalars['ID']['input'];
};


export type MutationUpdateNutritionArgs = {
  input: NutritionUpdateInput;
  profileId: Scalars['ID']['input'];
};


export type MutationUpdateOpportunityArgs = {
  id: Scalars['String']['input'];
  input: OpportunityUpdateInput;
};


export type MutationUpdateOpportunityMeetingArgs = {
  id: Scalars['String']['input'];
  input: OpportunityMeetingUpdateInput;
};


export type MutationUpdateOpportunityMemberArgs = {
  id: Scalars['String']['input'];
  input: OpportunityMemberUpdateInput;
};


export type MutationUpdateOpportunityNoteArgs = {
  id: Scalars['String']['input'];
  input: OpportunityNoteUpdateInput;
};


export type MutationUpdateOpportunityPaymentStatusArgs = {
  opportunityId: Scalars['String']['input'];
  paymentIndex: Scalars['Float']['input'];
  status: PaymentScheduleStatus;
};


export type MutationUpdateOpportunityStageArgs = {
  id: Scalars['String']['input'];
  input: OpportunityStageUpdateInput;
};


export type MutationUpdateOpportunityTaskArgs = {
  id: Scalars['String']['input'];
  input: OpportunityTaskUpdateInput;
};


export type MutationUpdateOpportunityTypeArgs = {
  id: Scalars['String']['input'];
  input: OpportunityTypeUpdateInput;
};


export type MutationUpdateOrgChartConfigArgs = {
  input: UpdateOrgChartConfigInput;
};


export type MutationUpdateP2ActionArgs = {
  input: UpdateP2ActionInput;
};


export type MutationUpdateP2CampaignMessageArgs = {
  input: UpdateP2CampaignMessageInput;
};


export type MutationUpdateP2CampaignStatusArgs = {
  id: Scalars['ID']['input'];
  status: Scalars['String']['input'];
};


export type MutationUpdateP2DailyChaseSettingsArgs = {
  input: UpdateP2DailyChaseConfigInput;
};


export type MutationUpdateP2NotificationRuleArgs = {
  input: UpdateP2NotificationRuleInput;
};


export type MutationUpdateP2OrderPaymentArgs = {
  orderId: Scalars['ID']['input'];
  paymentMethodId?: InputMaybe<Scalars['String']['input']>;
  status: Scalars['String']['input'];
  stripePaymentIntentId: Scalars['String']['input'];
};


export type MutationUpdateP2OrderStatusArgs = {
  orderId: Scalars['ID']['input'];
  status: P2OrderStatus;
};


export type MutationUpdateP2OrderTrackingArgs = {
  orderId: Scalars['ID']['input'];
  trackingNumber: Scalars['String']['input'];
};


export type MutationUpdateP2ProductArgs = {
  id: Scalars['ID']['input'];
  input: P2ProductInput;
};


export type MutationUpdateP2SettingsArgs = {
  input: P2SettingsInput;
};


export type MutationUpdateP2SupplierArgs = {
  input: UpdateP2SupplierInput;
};


export type MutationUpdatePProposalArgs = {
  id: Scalars['ID']['input'];
  input: UpdatePProposalInput;
};


export type MutationUpdatePProposalStatusArgs = {
  id: Scalars['ID']['input'];
  status: PProposalStatus;
};


export type MutationUpdatePageViewArgs = {
  input: UpdatePageViewInput;
};


export type MutationUpdatePainArgs = {
  input: PainUpdateInput;
  profileId: Scalars['ID']['input'];
};


export type MutationUpdatePartsOrderArgs = {
  id: Scalars['ID']['input'];
  input: UpdatePartsOrderInput;
};


export type MutationUpdatePartsOrderStatusArgs = {
  id: Scalars['ID']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  status: PartsOrderStatus;
};


export type MutationUpdatePasswordArgs = {
  id: Scalars['ID']['input'];
  input: PasswordUpdateInput;
};


export type MutationUpdatePaymentStatusArgs = {
  opportunityId: Scalars['String']['input'];
  paymentType: Scalars['String']['input'];
  receivedDate?: InputMaybe<Scalars['String']['input']>;
  status: OpportunityPaymentStatus;
};


export type MutationUpdatePayoutStatusArgs = {
  clientId: Scalars['String']['input'];
  opportunityId: Scalars['String']['input'];
  paidOutDate?: InputMaybe<Scalars['String']['input']>;
  paymentType: Scalars['String']['input'];
  status: Scalars['String']['input'];
  transactionId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdatePayrollEnquirySettingsArgs = {
  input: UpdatePayrollEnquirySettingsInput;
};


export type MutationUpdatePenaltyRateRuleArgs = {
  id: Scalars['ID']['input'];
  input: UpdatePenaltyRateRuleInput;
};


export type MutationUpdatePersonalCareArgs = {
  input: PersonalCareUpdateInput;
  profileId: Scalars['ID']['input'];
};


export type MutationUpdatePhoneNumberArgs = {
  id: Scalars['ID']['input'];
  input: TwilioPhoneNumberInput;
};


export type MutationUpdatePledgeCampaignArgs = {
  input: UpdatePledgeCampaignInput;
};


export type MutationUpdatePolicyMetadataArgs = {
  id: Scalars['ID']['input'];
  input: PolicyMetadataInput;
};


export type MutationUpdatePolicySettingsArgs = {
  input: UpdatePolicySettingsInput;
};


export type MutationUpdatePrescriberArgs = {
  id: Scalars['ID']['input'];
  input: UpdatePrescriberInput;
};


export type MutationUpdatePressureCareArgs = {
  input: PressureCareUpdateInput;
  profileId: Scalars['ID']['input'];
};


export type MutationUpdateProgramActivityArgs = {
  id: Scalars['ID']['input'];
  input: UpdateProgramActivityInput;
};


export type MutationUpdateProgramApplicationArgs = {
  id: Scalars['ID']['input'];
  input: UpdateProgramApplicationInput;
};


export type MutationUpdateProgramCallNoteArgs = {
  id: Scalars['ID']['input'];
  input: UpdateProgramCallNoteInput;
};


export type MutationUpdateProgramCommissionArgs = {
  id: Scalars['ID']['input'];
  input: UpdateProgramCommissionInput;
};


export type MutationUpdateProgramConfigArgs = {
  input: UpdateProgramConfigInput;
};


export type MutationUpdateProgramMemberArgs = {
  id: Scalars['ID']['input'];
  input: UpdateProgramMemberInput;
};


export type MutationUpdateProgressNoteCarePlansArgs = {
  input: UpdateProgressNoteCarePlansInput;
  noteId: Scalars['ID']['input'];
};


export type MutationUpdateProjectArgs = {
  id: Scalars['ID']['input'];
  input: ProjectUpdateInput;
};


export type MutationUpdateProjectProgressArgs = {
  id: Scalars['ID']['input'];
  input: UpdateProjectProgressInput;
};


export type MutationUpdateProposalArgs = {
  id: Scalars['ID']['input'];
  input: UpdateProposalInput;
};


export type MutationUpdateProposalSignedPdfArgs = {
  id: Scalars['ID']['input'];
  pdfCid: Scalars['String']['input'];
  pdfUrl: Scalars['String']['input'];
};


export type MutationUpdateProspectingNotificationRuleArgs = {
  id: Scalars['ID']['input'];
  input: UpdateProspectingNotificationRuleInput;
};


export type MutationUpdatePublicHolidayArgs = {
  id: Scalars['ID']['input'];
  input: UpdatePublicHolidayInput;
};


export type MutationUpdateQuoteStatusArgs = {
  id: Scalars['ID']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  status: QuoteStatus;
};


export type MutationUpdateRdActivityArgs = {
  id: Scalars['String']['input'];
  input: RdActivityInput;
};


export type MutationUpdateRdProjectArgs = {
  id: Scalars['String']['input'];
  input: RdProjectInput;
};


export type MutationUpdateRdTimeEntryArgs = {
  id: Scalars['String']['input'];
  input: RdTimeEntryInput;
};


export type MutationUpdateRecipeArgs = {
  id: Scalars['ID']['input'];
  input: UpdateRecipeInput;
};


export type MutationUpdateRecipeIngredientArgs = {
  id: Scalars['ID']['input'];
  input: UpdateRecipeIngredientInput;
};


export type MutationUpdateRegistrationStatusArgs = {
  input: UpdateRegistrationStatusInput;
};


export type MutationUpdateResearchBaseArgs = {
  id: Scalars['ID']['input'];
  input: UpdateResearchBaseInput;
};


export type MutationUpdateResidentArgs = {
  id: Scalars['ID']['input'];
  input: UpdateResidentInput;
};


export type MutationUpdateResidentContactArgs = {
  id: Scalars['ID']['input'];
  input: UpdateResidentContactInput;
};


export type MutationUpdateResidentLeaveArgs = {
  id: Scalars['ID']['input'];
  input: UpdateResidentLeaveInput;
};


export type MutationUpdateResidentPhotoArgs = {
  id: Scalars['ID']['input'];
  photoRecordId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationUpdateResidentRiskAssessmentArgs = {
  id: Scalars['ID']['input'];
  input: UpdateResidentRiskAssessmentInput;
};


export type MutationUpdateRespiteBookingArgs = {
  id: Scalars['ID']['input'];
  input: UpdateRespiteCareBookingInput;
};


export type MutationUpdateRestraintRecordArgs = {
  id: Scalars['ID']['input'];
  input: UpdateRestraintRecordInput;
};


export type MutationUpdateRewardTokenConfigArgs = {
  input: UpdateRewardTokenConfigInput;
};


export type MutationUpdateRiskAssessmentArgs = {
  id: Scalars['ID']['input'];
  input: UpdateRiskAssessmentInput;
};


export type MutationUpdateRoundArgs = {
  id: Scalars['ID']['input'];
  input: UpdateRoundInput;
};


export type MutationUpdateSeoMetadataArgs = {
  input: UpdateSeoMetadataInput;
  pagePath: Scalars['String']['input'];
};


export type MutationUpdateSecurityFindingStatusArgs = {
  input: UpdateSecurityFindingStatusInput;
};


export type MutationUpdateSecurityTargetArgs = {
  input: UpdateSecurityTargetInput;
};


export type MutationUpdateSellerProfileArgs = {
  id: Scalars['ID']['input'];
  input: UpdateSellerProfileInput;
};


export type MutationUpdateSellerProfileStatusArgs = {
  id: Scalars['ID']['input'];
  status: SellerProfileStatus;
};


export type MutationUpdateSeparationAffiliateArgs = {
  affiliateId: Scalars['ID']['input'];
  input: UpdateSeparationAffiliateInput;
};


export type MutationUpdateSeparationCaseArgs = {
  caseId: Scalars['ID']['input'];
  input: SeparationCaseUpdateInput;
};


export type MutationUpdateSeparationChildArgs = {
  childId: Scalars['ID']['input'];
  input: SeparationChildUpdateInput;
};


export type MutationUpdateSeparationConfigArgs = {
  input: SeparationConfigInput;
};


export type MutationUpdateSeparationScheduleArgs = {
  input: SeparationScheduleUpdateInput;
  scheduleId: Scalars['ID']['input'];
};


export type MutationUpdateSessionArgs = {
  id: Scalars['String']['input'];
  input: SessionInput;
};


export type MutationUpdateSessionTypeArgs = {
  id: Scalars['ID']['input'];
  input: SessionTypeInput;
};


export type MutationUpdateShelvAiSettingsArgs = {
  input: UpdateShelvAiSettingsInput;
};


export type MutationUpdateShiftArgs = {
  id: Scalars['ID']['input'];
  input: UpdateShiftInput;
};


export type MutationUpdateShiftNotificationRuleArgs = {
  input: UpdateShiftNotificationRuleInput;
};


export type MutationUpdateShiftSettingsArgs = {
  input: UpdateShiftSettingsInput;
};


export type MutationUpdateShiftTemplateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateShiftTemplateInput;
};


export type MutationUpdateShiftTypeArgs = {
  id: Scalars['ID']['input'];
  input: UpdateShiftTypeInput;
};


export type MutationUpdateSiteAdminsArgs = {
  emails: Array<Scalars['String']['input']>;
  launchedSiteId: Scalars['ID']['input'];
  phoneNumbers: Array<Scalars['String']['input']>;
};


export type MutationUpdateSiteEditorSiteArgs = {
  input: UpdateSiteEditorSiteInput;
  siteId: Scalars['String']['input'];
};


export type MutationUpdateSleepArgs = {
  input: SleepUpdateInput;
  profileId: Scalars['ID']['input'];
};


export type MutationUpdateSmsNotificationRuleArgs = {
  input: UpdateSmsNotificationRuleInput;
};


export type MutationUpdateSopAgendaItemArgs = {
  id: Scalars['ID']['input'];
  input: UpdateSopAgendaItemInput;
};


export type MutationUpdateSopEpisodeArgs = {
  id: Scalars['ID']['input'];
  input: UpdateSopEpisodeInput;
};


export type MutationUpdateSopSettingsArgs = {
  input: UpdateSopSettingsInput;
};


export type MutationUpdateSopTopicArgs = {
  id: Scalars['ID']['input'];
  input: UpdateSopTopicInput;
};


export type MutationUpdateSphereOfInfluenceArgs = {
  id: Scalars['ID']['input'];
  input: UpdateSphereOfInfluenceInput;
};


export type MutationUpdateSubSubTaskArgs = {
  input: SubSubTaskUpdateInput;
  subtaskId: Scalars['String']['input'];
  taskId: Scalars['String']['input'];
};


export type MutationUpdateSubTaskArgs = {
  input: SubTaskUpdateInput;
  taskId: Scalars['String']['input'];
};


export type MutationUpdateSubscriptionArgs = {
  id: Scalars['ID']['input'];
  input: UpdateSubscriptionInput;
};


export type MutationUpdateSubscriptionProductArgs = {
  id: Scalars['ID']['input'];
  input: UpdateSubscriptionProductInput;
};


export type MutationUpdateSupplierArgs = {
  id: Scalars['ID']['input'];
  input: UpdateSupplierInput;
};


export type MutationUpdateSupplierOrderArgs = {
  id: Scalars['ID']['input'];
  input: UpdateSupplierOrderInput;
};


export type MutationUpdateTaskArgs = {
  id: Scalars['ID']['input'];
  input: TaskInput;
};


export type MutationUpdateTaskOrderArgs = {
  order: Scalars['Int']['input'];
  taskId: Scalars['ID']['input'];
};


export type MutationUpdateTaskStatusArgs = {
  status: TaskStatus;
  taskId: Scalars['ID']['input'];
};


export type MutationUpdateTeamArgs = {
  id: Scalars['ID']['input'];
  input: UpdateTeamInput;
};


export type MutationUpdateTemperatureAlarmArgs = {
  id: Scalars['ID']['input'];
  input: UpdateTemperatureAlarmInput;
};


export type MutationUpdateTenantArgs = {
  id: Scalars['ID']['input'];
  input: UpdateTenantInput;
};


export type MutationUpdateTenantCompanyDetailsArgs = {
  companyDetails: TenantCompanyDetailsInput;
};


export type MutationUpdateTenantEmailDomainArgs = {
  emailDomain: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};


export type MutationUpdateTenantPaymentDetailsArgs = {
  paymentDetails: PaymentReceivingDetailsInput;
};


export type MutationUpdateTimesheetComplianceArgs = {
  input: UpdateTimesheetComplianceInput;
};


export type MutationUpdateTimesheetDigitizedDataArgs = {
  input: UpdateTimesheetDigitizedDataInput;
};


export type MutationUpdateTimesheetStatusArgs = {
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  status: TimesheetStatus;
};


export type MutationUpdateTomSettingsArgs = {
  input: UpdateTomSettingsInput;
};


export type MutationUpdateTrackedCompetitionArgs = {
  id: Scalars['ID']['input'];
  input: UpdateTrackedCompetitionInput;
};


export type MutationUpdateTranscriptionArgs = {
  id: Scalars['ID']['input'];
  input: TranscriptionUpdateInput;
};


export type MutationUpdateTreatmentPlanArgs = {
  id: Scalars['ID']['input'];
  input: UpdateTreatmentPlanInput;
};


export type MutationUpdateTrustPersonArgs = {
  id: Scalars['ID']['input'];
  input: UpdateTrustPersonInput;
};


export type MutationUpdateTypingStatusArgs = {
  anonToken?: InputMaybe<Scalars['String']['input']>;
  isTyping: Scalars['Boolean']['input'];
  roomId: Scalars['ID']['input'];
};


export type MutationUpdateVaccinationArgs = {
  id: Scalars['ID']['input'];
  input: UpdateVaccinationInput;
};


export type MutationUpdateVaultInsightRuleArgs = {
  input: UpdateVaultInsightRuleInput;
};


export type MutationUpdateVisionBoardConfigArgs = {
  input: UpdateVisionBoardConfigInput;
};


export type MutationUpdateVisionBoardItemArgs = {
  id: Scalars['ID']['input'];
  input: UpdateVisionBoardItemInput;
};


export type MutationUpdateVisionBoardNotificationRuleArgs = {
  input: UpdateVisionBoardNotificationRuleInput;
};


export type MutationUpdateVlogCategoryArgs = {
  id: Scalars['ID']['input'];
  input: UpdateVlogCategoryInput;
};


export type MutationUpdateVlogNotificationRuleArgs = {
  input: UpdateVlogNotificationRuleInput;
};


export type MutationUpdateVlogPostArgs = {
  id: Scalars['ID']['input'];
  input: UpdateVlogPostInput;
};


export type MutationUpdateVlogSeriesArgs = {
  id: Scalars['ID']['input'];
  input: UpdateVlogSeriesInput;
};


export type MutationUpdateWaitingListChecklistItemArgs = {
  id: Scalars['ID']['input'];
  input: UpdateWaitingListChecklistItemInput;
};


export type MutationUpdateWaitingListChecklistTemplateArgs = {
  input: UpdateWaitingListChecklistTemplateInput;
};


export type MutationUpdateWaitingListEntryArgs = {
  id: Scalars['ID']['input'];
  input: UpdateWaitingListEntryInput;
};


export type MutationUpdateWaitingListPriorityArgs = {
  id: Scalars['ID']['input'];
  priority: WaitingListPriority;
  reason?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateWitnessArgs = {
  id: Scalars['ID']['input'];
  input: UpdateWitnessInput;
};


export type MutationUpdateWorkerArgs = {
  id: Scalars['ID']['input'];
  input: UpdateWorkerInput;
};


export type MutationUpdateWorkerTimeEntryArgs = {
  id: Scalars['ID']['input'];
  input: UpdateWorkerTimeEntryInput;
};


export type MutationUpdateWoundStatusArgs = {
  id: Scalars['ID']['input'];
  status: WoundStatus;
};


export type MutationUploadAwardVersionArgs = {
  file: Scalars['Upload']['input'];
  input: AddAwardVersionInput;
};


export type MutationUploadBillsEmailBrandingPhotoArgs = {
  field: BillsBrandingPhotoField;
  file: Scalars['Upload']['input'];
};


export type MutationUploadCalendarProfilePhotoArgs = {
  calendarId: Scalars['String']['input'];
  file: Scalars['Upload']['input'];
};


export type MutationUploadGovBriefAudioArgs = {
  base64: Scalars['String']['input'];
  mimeType: Scalars['String']['input'];
};


export type MutationUploadIncidentDocumentArgs = {
  incidentId: Scalars['ID']['input'];
  input: UploadDocumentInput;
};


export type MutationUploadInvoiceArgs = {
  input: UploadInvoiceInput;
};


export type MutationUploadLeadFlowEmailBrandingPhotoArgs = {
  field: BrandingPhotoField;
  file: Scalars['Upload']['input'];
};


export type MutationUploadLocalSessionArgs = {
  sessionId: Scalars['String']['input'];
};


export type MutationUploadMedicalRecordArgs = {
  file: Scalars['Upload']['input'];
  input: UploadMedicalRecordInput;
};


export type MutationUploadOrderReceiptArgs = {
  id: Scalars['ID']['input'];
  mediaType?: InputMaybe<Scalars['String']['input']>;
  receiptUrl: Scalars['String']['input'];
};


export type MutationUploadP2ProductImageArgs = {
  file: Scalars['Upload']['input'];
};


export type MutationUploadRdEvidenceArgs = {
  activityId?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  evidenceType: Scalars['String']['input'];
  fileBase64?: InputMaybe<Scalars['String']['input']>;
  fileName?: InputMaybe<Scalars['String']['input']>;
  fileUrl?: InputMaybe<Scalars['String']['input']>;
  participants?: InputMaybe<Scalars['String']['input']>;
  projectId: Scalars['String']['input'];
  source?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUploadRewardsEmailBrandingPhotoArgs = {
  field: RewardsBrandingPhotoField;
  file: Scalars['Upload']['input'];
};


export type MutationUploadSeoImageArgs = {
  file: Scalars['Upload']['input'];
};


export type MutationUploadSopBriefAudioArgs = {
  base64: Scalars['String']['input'];
  mimeType: Scalars['String']['input'];
};


export type MutationUploadSopVoiceNoteArgs = {
  base64: Scalars['String']['input'];
  mimeType: Scalars['String']['input'];
  slug: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};


export type MutationUploadTaskMediaArgs = {
  file: Scalars['Upload']['input'];
};


export type MutationUploadTenantBrandingImageArgs = {
  field: TenantBrandingImageField;
  file: Scalars['Upload']['input'];
  tenantId: Scalars['ID']['input'];
};


export type MutationUploadTimesheetArgs = {
  file: Scalars['Upload']['input'];
  matterId: Scalars['String']['input'];
};


export type MutationUploadWaitingListFileArgs = {
  file: Scalars['Upload']['input'];
  input: UploadWaitingListFileInput;
};


export type MutationUpsertBankingAlertRuleArgs = {
  input: UpsertBankingAlertRuleInput;
};


export type MutationUpsertBankingIncomeRuleArgs = {
  input: UpsertBankingIncomeRuleInput;
};


export type MutationUpsertBankingMonthJobArgs = {
  input: UpsertBankingMonthJobInput;
};


export type MutationUpsertBankingStandingMoveArgs = {
  input: UpsertBankingStandingMoveInput;
};


export type MutationUpsertBillsEmailBrandingArgs = {
  input: BillsEmailBrandingInput;
};


export type MutationUpsertBusinessSnapshotArgs = {
  input: UpsertBusinessSnapshotInput;
};


export type MutationUpsertCalendarTagArgs = {
  calendarId: Scalars['String']['input'];
  input: CalendarTagInput;
};


export type MutationUpsertCareDayRecordArgs = {
  input: UpsertCareDayRecordInput;
};


export type MutationUpsertCareQuarterTargetArgs = {
  input: UpsertCareQuarterTargetInput;
};


export type MutationUpsertCommandDealArgs = {
  input: UpsertCommandDealInput;
};


export type MutationUpsertEmployeeActivityTagArgs = {
  input: EmployeeActivityTagInput;
};


export type MutationUpsertLeadFlowEmailBrandingArgs = {
  input: LeadFlowEmailBrandingInput;
};


export type MutationUpsertMobilityAidsArgs = {
  input: UpdateMobilityAidsInput;
  residentId: Scalars['ID']['input'];
};


export type MutationUpsertModuleSourceArgs = {
  input: ModuleSourceInput;
};


export type MutationUpsertPaySettingsArgs = {
  input: UpdatePaySettingsInput;
};


export type MutationUpsertPersonEnrichmentArgs = {
  input: UpsertPersonEnrichmentInput;
};


export type MutationUpsertRewardsEmailBrandingArgs = {
  input: RewardsEmailBrandingInput;
};


export type MutationUpsertVoipNumberArgs = {
  input: UpsertVoipNumberInput;
};


export type MutationUpsertVoipSnapshotArgs = {
  input: UpsertVoipSnapshotInput;
};


export type MutationUseGovChecklistTemplateArgs = {
  subjectId?: InputMaybe<Scalars['ID']['input']>;
  subjectType?: InputMaybe<Scalars['String']['input']>;
  templateId: Scalars['ID']['input'];
};


export type MutationValidateMemberSplitsArgs = {
  opportunityId: Scalars['String']['input'];
};


export type MutationVerifyDomainArgs = {
  input: VerifyDomainInput;
};


export type MutationVerifyEmailChangeArgs = {
  input: VerifyEmailChangeInput;
};


export type MutationVerifyEmailCodeArgs = {
  code: Scalars['String']['input'];
  email: Scalars['String']['input'];
};


export type MutationVerifyInfluencerArgs = {
  id: Scalars['ID']['input'];
};


export type MutationVerifyPProposalEmailArgs = {
  input: VerifyPProposalEmailInput;
};


export type MutationVerifyPasskeyAuthenticationArgs = {
  input: VerifyPasskeyAuthenticationInput;
};


export type MutationVerifyPasskeyRegistrationArgs = {
  input: VerifyPasskeyRegistrationInput;
};


export type MutationVerifyPasswordResetCodeArgs = {
  input: VerifyPasswordResetCodeInput;
};


export type MutationVerifyPhoneChangeArgs = {
  input: VerifyPhoneChangeInput;
};


export type MutationVerifyProposalEmailArgs = {
  input: VerifyProposalEmailInput;
};


export type MutationVerifySmsCodeArgs = {
  code: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
};


export type MutationWipeSarahCareAbbeyPainArgs = {
  apply?: Scalars['Boolean']['input'];
  expectedCount?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationWipeSarahCareAcfiAssessmentsArgs = {
  apply?: Scalars['Boolean']['input'];
  expectedCount?: InputMaybe<Scalars['Int']['input']>;
  table: Scalars['String']['input'];
};


export type MutationWipeSarahCareAdmissionSnapshotsArgs = {
  apply?: Scalars['Boolean']['input'];
  expectedCount?: InputMaybe<Scalars['Int']['input']>;
  kind: SarahAdmissionSnapshotKind;
};


export type MutationWipeSarahCareAllergyPromotionsArgs = {
  apply?: Scalars['Boolean']['input'];
  expectedCount?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationWipeSarahCareAnaccClassificationsArgs = {
  apply?: Scalars['Boolean']['input'];
  expectedCount?: InputMaybe<Scalars['Int']['input']>;
  table: Scalars['String']['input'];
};


export type MutationWipeSarahCareBondsArgs = {
  apply?: Scalars['Boolean']['input'];
  expectedCount?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationWipeSarahCareBowelRecordsArgs = {
  apply?: Scalars['Boolean']['input'];
  expectedCount?: InputMaybe<Scalars['Int']['input']>;
  table: Scalars['String']['input'];
};


export type MutationWipeSarahCareBradenArgs = {
  apply?: Scalars['Boolean']['input'];
  expectedCount?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationWipeSarahCareCarePlanHistoryArgs = {
  apply?: Scalars['Boolean']['input'];
  expectedCount?: InputMaybe<Scalars['Int']['input']>;
  table: Scalars['String']['input'];
};


export type MutationWipeSarahCareContactCallsArgs = {
  apply?: Scalars['Boolean']['input'];
  expectedCount?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationWipeSarahCareContactHistoryArgs = {
  apply?: Scalars['Boolean']['input'];
  expectedCount?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationWipeSarahCareContactLinksArgs = {
  apply?: Scalars['Boolean']['input'];
  expectedCount?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationWipeSarahCareDailyCareHistoryArgs = {
  apply?: Scalars['Boolean']['input'];
  expectedCount?: InputMaybe<Scalars['Int']['input']>;
  table: Scalars['String']['input'];
};


export type MutationWipeSarahCareFallsRiskArgs = {
  apply?: Scalars['Boolean']['input'];
  expectedCount?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationWipeSarahCareFluidBalanceArgs = {
  apply?: Scalars['Boolean']['input'];
  expectedCount?: InputMaybe<Scalars['Int']['input']>;
  table: Scalars['String']['input'];
};


export type MutationWipeSarahCareFoodIntakeArgs = {
  apply?: Scalars['Boolean']['input'];
  expectedCount?: InputMaybe<Scalars['Int']['input']>;
  table: Scalars['String']['input'];
};


export type MutationWipeSarahCareHistoricalAssessmentsArgs = {
  apply?: Scalars['Boolean']['input'];
  expectedCount?: InputMaybe<Scalars['Int']['input']>;
  table: Scalars['String']['input'];
};


export type MutationWipeSarahCareIncidentsArgs = {
  apply?: Scalars['Boolean']['input'];
  expectedCount?: InputMaybe<Scalars['Int']['input']>;
  table: Scalars['String']['input'];
};


export type MutationWipeSarahCareLeaveArgs = {
  apply?: Scalars['Boolean']['input'];
  expectedCount?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationWipeSarahCareMedicalAssessmentsArgs = {
  apply?: Scalars['Boolean']['input'];
  expectedCount?: InputMaybe<Scalars['Int']['input']>;
  table: Scalars['String']['input'];
};


export type MutationWipeSarahCareMedicalFilesArgs = {
  apply?: Scalars['Boolean']['input'];
  expectedCount?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationWipeSarahCareMobilityAidsArgs = {
  apply?: Scalars['Boolean']['input'];
  expectedCount?: InputMaybe<Scalars['Int']['input']>;
  table: Scalars['String']['input'];
};


export type MutationWipeSarahCareMobilityHistoryArgs = {
  apply?: Scalars['Boolean']['input'];
  expectedCount?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationWipeSarahCareNoteFollowupsArgs = {
  apply?: Scalars['Boolean']['input'];
  expectedCount?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationWipeSarahCareObservationsArgs = {
  apply?: Scalars['Boolean']['input'];
  expectedCount?: InputMaybe<Scalars['Int']['input']>;
  kind: Scalars['String']['input'];
};


export type MutationWipeSarahCarePainChartArgs = {
  apply?: Scalars['Boolean']['input'];
  expectedCount?: InputMaybe<Scalars['Int']['input']>;
  table: Scalars['String']['input'];
};


export type MutationWipeSarahCareProgressNotesArgs = {
  apply?: Scalars['Boolean']['input'];
  expectedCount?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationWipeSarahCareReferralTasksArgs = {
  apply?: Scalars['Boolean']['input'];
  expectedCount?: InputMaybe<Scalars['Int']['input']>;
  table: Scalars['String']['input'];
};


export type MutationWipeSarahCareRepositioningChecksArgs = {
  apply?: Scalars['Boolean']['input'];
  expectedCount?: InputMaybe<Scalars['Int']['input']>;
  table: Scalars['String']['input'];
};


export type MutationWipeSarahCareResidentFieldPromotionsArgs = {
  apply?: Scalars['Boolean']['input'];
  expectedCount?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationWipeSarahCareResidentPhotoPointersArgs = {
  apply?: Scalars['Boolean']['input'];
  expectedCount?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationWipeSarahCareRespiteStaysArgs = {
  apply?: Scalars['Boolean']['input'];
  expectedCount?: InputMaybe<Scalars['Int']['input']>;
  table: Scalars['String']['input'];
};


export type MutationWipeSarahCareRestraintsArgs = {
  apply?: Scalars['Boolean']['input'];
  expectedCount?: InputMaybe<Scalars['Int']['input']>;
  table: Scalars['String']['input'];
};


export type MutationWipeSarahCareReviewHistoryArgs = {
  apply?: Scalars['Boolean']['input'];
  expectedCount?: InputMaybe<Scalars['Int']['input']>;
  table: Scalars['String']['input'];
};


export type MutationWipeSarahCareSleepChecksArgs = {
  apply?: Scalars['Boolean']['input'];
  expectedCount?: InputMaybe<Scalars['Int']['input']>;
  table: Scalars['String']['input'];
};


export type MutationWipeSarahCareVaccinationsArgs = {
  apply?: Scalars['Boolean']['input'];
  expectedCount?: InputMaybe<Scalars['Int']['input']>;
  table: Scalars['String']['input'];
};


export type MutationWipeSarahCareVoidedNotesArgs = {
  apply?: Scalars['Boolean']['input'];
  expectedCount?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationWipeSarahCareWaitingListArgs = {
  apply?: Scalars['Boolean']['input'];
  expectedCount?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationWipeSarahCareWoundHistoryArgs = {
  apply?: Scalars['Boolean']['input'];
  expectedCount?: InputMaybe<Scalars['Int']['input']>;
  table: Scalars['String']['input'];
};


export type MutationWithdrawCoachCertificationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationWithdrawMyEntryArgs = {
  entryId: Scalars['ID']['input'];
};


export type MutationZkEnrollArgs = {
  input: ZkEnrollInput;
};


export type MutationZkRequestChallengeArgs = {
  publicKey?: InputMaybe<Scalars['String']['input']>;
};


export type MutationZkRevokeCredentialArgs = {
  credentialId: Scalars['ID']['input'];
};


export type MutationZkVerifyAuthArgs = {
  input: ZkVerifyInput;
};

export type MyCompetitionEntry = {
  __typename?: 'MyCompetitionEntry';
  ageBand: CompetitionAgeBand;
  canWithdraw: Scalars['Boolean']['output'];
  competitionId: Scalars['ID']['output'];
  competitionSlug: Scalars['String']['output'];
  competitionStatus: CompetitionStatus;
  competitionTitle: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  enteredForName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  imageCid: Scalars['String']['output'];
  peoplesChoice?: Maybe<Scalars['Boolean']['output']>;
  placement?: Maybe<Scalars['Int']['output']>;
  printConsent: Scalars['Boolean']['output'];
  shareSlug: Scalars['String']['output'];
  statement?: Maybe<Scalars['String']['output']>;
  status: CompetitionEntryStatus;
  thumbnailCid?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  voteCount?: Maybe<Scalars['Int']['output']>;
};

export type MyCompetitionFollow = {
  __typename?: 'MyCompetitionFollow';
  competitionId: Scalars['ID']['output'];
  following: Scalars['Boolean']['output'];
  since?: Maybe<Scalars['DateTime']['output']>;
};

export type MyCompetitionVote = {
  __typename?: 'MyCompetitionVote';
  castAt: Scalars['DateTime']['output'];
  competitionId: Scalars['ID']['output'];
  entryId: Scalars['ID']['output'];
};

/** One onboarding form's status for the logged-in employee — pending or signed. */
export type MyEmployeeFormStatus = {
  __typename?: 'MyEmployeeFormStatus';
  declarationText: Scalars['String']['output'];
  formType: EmployeeFormType;
  formVersion: Scalars['String']['output'];
  mandatory: Scalars['Boolean']['output'];
  /** Human-readable list of required answers still missing — must be empty before signing is allowed. */
  missingFields: Array<Scalars['String']['output']>;
  /** JSON of the pre-filled answers the employee will be signing (server-derived). */
  prefillJson: Scalars['String']['output'];
  signed: Scalars['Boolean']['output'];
  signedAt?: Maybe<Scalars['DateTime']['output']>;
  signedFormId?: Maybe<Scalars['ID']['output']>;
  /** Gateway URL of the signed PDF (present once signed). */
  signedPdfUrl?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

/** The signed-in staff member's own leave balance, when the site shows it */
export type MyLeaveBalance = {
  __typename?: 'MyLeaveBalance';
  balance?: Maybe<EmployeeLeaveBalance>;
  hiddenReason?: Maybe<Scalars['String']['output']>;
  /** False = do not show a balance; hiddenReason says why */
  visible: Scalars['Boolean']['output'];
};

export type MyPolicyAcknowledgement = {
  __typename?: 'MyPolicyAcknowledgement';
  acknowledgedAt?: Maybe<Scalars['DateTime']['output']>;
  acknowledgedVersion?: Maybe<Scalars['Int']['output']>;
  policyId: Scalars['ID']['output'];
};

export type MyRewardPayouts = {
  __typename?: 'MyRewardPayouts';
  availableMinor: Scalars['Int']['output'];
  availableTokenCount: Scalars['Int']['output'];
  bankDetails: RewardPayoutBankDetailsView;
  requests: Array<RewardPayoutRequest>;
};

export type MySmsBalance = {
  __typename?: 'MySmsBalance';
  criticalThreshold: Scalars['Int']['output'];
  snapshot?: Maybe<SmsBalanceSnapshot>;
  warnThreshold: Scalars['Int']['output'];
};

export type MySmsContactRow = {
  __typename?: 'MySmsContactRow';
  clientName?: Maybe<Scalars['String']['output']>;
  counterpartNumber: Scalars['String']['output'];
  outboundCount: Scalars['Int']['output'];
  totalCostCents: Scalars['Float']['output'];
  totalSegments: Scalars['Int']['output'];
};

export type MySmsMonthRow = {
  __typename?: 'MySmsMonthRow';
  month: Scalars['String']['output'];
  outboundCount: Scalars['Int']['output'];
  totalCostCents: Scalars['Float']['output'];
  totalSegments: Scalars['Int']['output'];
};

export type MySmsSettings = {
  __typename?: 'MySmsSettings';
  acmaRegistration?: Maybe<AcmaRegistration>;
  alphaId?: Maybe<Scalars['String']['output']>;
  apiKeyLast3?: Maybe<Scalars['String']['output']>;
  dedicatedNumber?: Maybe<Scalars['String']['output']>;
  hasApiKey: Scalars['Boolean']['output'];
  smsNumber?: Maybe<Scalars['String']['output']>;
  useAlphaId: Scalars['Boolean']['output'];
};

export type MySmsUsage = {
  __typename?: 'MySmsUsage';
  byContact: Array<MySmsContactRow>;
  byMonth: Array<MySmsMonthRow>;
  overall: MySmsUsageOverall;
};

export type MySmsUsageFilter = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type MySmsUsageOverall = {
  __typename?: 'MySmsUsageOverall';
  totalCostCents: Scalars['Float']['output'];
  totalInbound: Scalars['Int']['output'];
  totalOutbound: Scalars['Int']['output'];
  totalSegments: Scalars['Int']['output'];
};

export type NeurologicalObservation = {
  __typename?: 'NeurologicalObservation';
  autoProgressNote: Scalars['Boolean']['output'];
  bpDiastolic?: Maybe<Scalars['Int']['output']>;
  bpPosition?: Maybe<BpPosition>;
  bpSystolic?: Maybe<Scalars['Int']['output']>;
  bsl?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  locGlasgowEye?: Maybe<Scalars['Int']['output']>;
  locGlasgowMotor?: Maybe<Scalars['Int']['output']>;
  locGlasgowTotal?: Maybe<Scalars['Int']['output']>;
  locGlasgowVerbal?: Maybe<Scalars['Int']['output']>;
  locLevel?: Maybe<Scalars['String']['output']>;
  locMethod?: Maybe<LocMethod>;
  periodId: Scalars['ID']['output'];
  progressNoteId?: Maybe<Scalars['ID']['output']>;
  pulse?: Maybe<Scalars['Int']['output']>;
  pupillaryAssessment?: Maybe<PupillaryAssessment>;
  residentId: Scalars['ID']['output'];
  residentName?: Maybe<Scalars['String']['output']>;
  residentRoom?: Maybe<Scalars['String']['output']>;
  residentWing?: Maybe<Scalars['String']['output']>;
  respirations?: Maybe<Scalars['Int']['output']>;
  takenAt: Scalars['DateTime']['output'];
  takenBy: Scalars['ID']['output'];
  takenByName?: Maybe<Scalars['String']['output']>;
  temperature?: Maybe<Scalars['Float']['output']>;
  temperatureMethod?: Maybe<TemperatureMethod>;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  weight?: Maybe<Scalars['Float']['output']>;
};

export type NeurologicalObservationPeriod = {
  __typename?: 'NeurologicalObservationPeriod';
  autoProgressNote: Scalars['Boolean']['output'];
  comments?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['ID']['output'];
  createdByName?: Maybe<Scalars['String']['output']>;
  editedAt?: Maybe<Scalars['DateTime']['output']>;
  editedBy?: Maybe<Scalars['ID']['output']>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  frequencyHours: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  progressNoteId?: Maybe<Scalars['ID']['output']>;
  residentId: Scalars['ID']['output'];
  residentName?: Maybe<Scalars['String']['output']>;
  residentRoom?: Maybe<Scalars['String']['output']>;
  residentWing?: Maybe<Scalars['String']['output']>;
  startDate: Scalars['DateTime']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type NeurologicalObservationsResponse = {
  __typename?: 'NeurologicalObservationsResponse';
  observations: Array<NeurologicalObservation>;
  total: Scalars['Int']['output'];
};

export type NeurologicalPeriodFilterInput = {
  activeOnly?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  residentId?: InputMaybe<Scalars['ID']['input']>;
  wing?: InputMaybe<Scalars['String']['input']>;
};

export type NeurologicalPeriodsResponse = {
  __typename?: 'NeurologicalPeriodsResponse';
  periods: Array<NeurologicalObservationPeriod>;
  total: Scalars['Int']['output'];
};

/** Source type of a person event */
export enum NewsSourceType {
  AiClassified = 'AI_CLASSIFIED',
  Manual = 'MANUAL',
  NewsArticle = 'NEWS_ARTICLE',
  PressRelease = 'PRESS_RELEASE',
  Tweet = 'TWEET'
}

export type NoteAttachment = {
  __typename?: 'NoteAttachment';
  fileSize?: Maybe<Scalars['Float']['output']>;
  fileType?: Maybe<Scalars['String']['output']>;
  filename: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type NoteAttachmentInput = {
  fileSize?: InputMaybe<Scalars['Float']['input']>;
  fileType?: InputMaybe<Scalars['String']['input']>;
  filename: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

/** Priority level of the note */
export enum NotePriority {
  Critical = 'CRITICAL',
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM'
}

/** Module that created the progress note */
export enum NoteSourceModule {
  Assessment = 'ASSESSMENT',
  DiversionalTherapy = 'DIVERSIONAL_THERAPY',
  DoctorVisit = 'DOCTOR_VISIT',
  Incident = 'INCIDENT',
  Leave = 'LEAVE',
  Manual = 'MANUAL',
  Physiotherapy = 'PHYSIOTHERAPY'
}

/** Type of note */
export enum NoteType {
  CallNotes = 'CALL_NOTES',
  CompetitorIntel = 'COMPETITOR_INTEL',
  CustomerFeedback = 'CUSTOMER_FEEDBACK',
  DecisionCriteria = 'DECISION_CRITERIA',
  EmailSummary = 'EMAIL_SUMMARY',
  General = 'GENERAL',
  Internal = 'INTERNAL',
  MeetingNotes = 'MEETING_NOTES',
  Other = 'OTHER',
  PricingDiscussion = 'PRICING_DISCUSSION',
  RiskAssessment = 'RISK_ASSESSMENT',
  TechnicalRequirements = 'TECHNICAL_REQUIREMENTS',
  WinLossAnalysis = 'WIN_LOSS_ANALYSIS'
}

/** Visibility level of the note */
export enum NoteVisibility {
  Internal = 'INTERNAL',
  Private = 'PRIVATE',
  Public = 'PUBLIC',
  Restricted = 'RESTRICTED'
}

export type NotificationContact = {
  __typename?: 'NotificationContact';
  email?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  relationship?: Maybe<Scalars['String']['output']>;
};

export type NotificationContactInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  relationship?: InputMaybe<Scalars['String']['input']>;
};

export type NotificationRecipientPreview = {
  __typename?: 'NotificationRecipientPreview';
  clientId: Scalars['String']['output'];
  email?: Maybe<Scalars['String']['output']>;
  employeeId?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
};

export type NotificationRecipientPreviewResult = {
  __typename?: 'NotificationRecipientPreviewResult';
  managerPermissions: Array<Scalars['String']['output']>;
  recipients: Array<NotificationRecipientPreview>;
};

export type NutritionProfile = {
  __typename?: 'NutritionProfile';
  allergies?: Maybe<Array<Scalars['String']['output']>>;
  dietTypes?: Maybe<Array<DietType>>;
  dislikes?: Maybe<Array<Scalars['String']['output']>>;
  feedingAssistance?: Maybe<CareLevel>;
  fluidRestrictions?: Maybe<Scalars['String']['output']>;
  intolerances?: Maybe<Array<Scalars['String']['output']>>;
  likes?: Maybe<Array<Scalars['String']['output']>>;
  nutritionNotes?: Maybe<Scalars['String']['output']>;
  requiresThickenedFluids?: Maybe<Scalars['Boolean']['output']>;
  targetFluidIntake?: Maybe<Scalars['String']['output']>;
  textureModification?: Maybe<Scalars['String']['output']>;
  thickenedFluidLevel?: Maybe<Scalars['String']['output']>;
};

export type NutritionProfileInput = {
  allergies?: InputMaybe<Array<Scalars['String']['input']>>;
  dietTypes?: InputMaybe<Array<DietType>>;
  dislikes?: InputMaybe<Array<Scalars['String']['input']>>;
  feedingAssistance?: InputMaybe<CareLevel>;
  fluidRestrictions?: InputMaybe<Scalars['String']['input']>;
  intolerances?: InputMaybe<Array<Scalars['String']['input']>>;
  likes?: InputMaybe<Array<Scalars['String']['input']>>;
  nutritionNotes?: InputMaybe<Scalars['String']['input']>;
  requiresThickenedFluids?: InputMaybe<Scalars['Boolean']['input']>;
  targetFluidIntake?: InputMaybe<Scalars['String']['input']>;
  textureModification?: InputMaybe<Scalars['String']['input']>;
  thickenedFluidLevel?: InputMaybe<Scalars['String']['input']>;
};

export type NutritionUpdateInput = {
  allergies?: InputMaybe<Array<Scalars['String']['input']>>;
  dietType?: InputMaybe<Scalars['String']['input']>;
  dislikes?: InputMaybe<Array<Scalars['String']['input']>>;
  feedingAssistance?: InputMaybe<Scalars['String']['input']>;
  fluidConsistency?: InputMaybe<Scalars['String']['input']>;
  intolerances?: InputMaybe<Array<Scalars['String']['input']>>;
  likes?: InputMaybe<Array<Scalars['String']['input']>>;
  notes?: InputMaybe<Scalars['String']['input']>;
  textureModification?: InputMaybe<Scalars['String']['input']>;
};

export type ObservationAlert = {
  __typename?: 'ObservationAlert';
  acknowledged: Scalars['Boolean']['output'];
  acknowledgedAt?: Maybe<Scalars['DateTime']['output']>;
  acknowledgedBy?: Maybe<Scalars['ID']['output']>;
  acknowledgedByName?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  message: Scalars['String']['output'];
  normalRange?: Maybe<Scalars['String']['output']>;
  observationId?: Maybe<Scalars['ID']['output']>;
  previousValue?: Maybe<Scalars['Float']['output']>;
  residentId: Scalars['ID']['output'];
  residentName?: Maybe<Scalars['String']['output']>;
  residentRoom?: Maybe<Scalars['String']['output']>;
  residentWing?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  threshold?: Maybe<Scalars['Float']['output']>;
  type: ObservationAlertType;
  updatedAt: Scalars['DateTime']['output'];
  value?: Maybe<Scalars['Float']['output']>;
};

export type ObservationAlertConfig = {
  __typename?: 'ObservationAlertConfig';
  bslHigh?: Maybe<Scalars['Float']['output']>;
  bslLow?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['DateTime']['output'];
  diastolicHigh?: Maybe<Scalars['Int']['output']>;
  diastolicLow?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  o2SaturationMin?: Maybe<Scalars['Float']['output']>;
  observationType: ObservationType;
  systolicHigh?: Maybe<Scalars['Int']['output']>;
  systolicLow?: Maybe<Scalars['Int']['output']>;
  temperatureRanges?: Maybe<Array<TemperatureRangeConfig>>;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  weightChangeThreshold?: Maybe<Scalars['Float']['output']>;
};

export type ObservationAlertFilterInput = {
  acknowledged?: InputMaybe<Scalars['Boolean']['input']>;
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  residentId?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<ObservationAlertType>;
  wing?: InputMaybe<Scalars['String']['input']>;
};

/** Type of observation alert */
export enum ObservationAlertType {
  BpOutOfRange = 'BP_OUT_OF_RANGE',
  BslOutOfRange = 'BSL_OUT_OF_RANGE',
  NeurologicalOverdue = 'NEUROLOGICAL_OVERDUE',
  TemperatureOutOfRange = 'TEMPERATURE_OUT_OF_RANGE',
  WeightChange = 'WEIGHT_CHANGE'
}

export type ObservationAlertsResponse = {
  __typename?: 'ObservationAlertsResponse';
  alerts: Array<ObservationAlert>;
  total: Scalars['Int']['output'];
  unacknowledgedCount: Scalars['Int']['output'];
};

export type ObservationChartSourceField = {
  __typename?: 'ObservationChartSourceField';
  /** SarahCare table and column, e.g. `ResFluidInOut.InputVol` */
  column: Scalars['String']['output'];
  /** The original value as text */
  value?: Maybe<Scalars['String']['output']>;
};

export type ObservationGraphData = {
  __typename?: 'ObservationGraphData';
  datasets: Array<GraphDataset>;
  dateFrom?: Maybe<Scalars['DateTime']['output']>;
  dateTo?: Maybe<Scalars['DateTime']['output']>;
  type: ObservationType;
  unit: Scalars['String']['output'];
};

/** Type of clinical observation */
export enum ObservationType {
  BloodPressure = 'BLOOD_PRESSURE',
  BloodSugar = 'BLOOD_SUGAR',
  Height = 'HEIGHT',
  Neurological = 'NEUROLOGICAL',
  OxygenSaturation = 'OXYGEN_SATURATION',
  Pulse = 'PULSE',
  Respiration = 'RESPIRATION',
  Temperature = 'TEMPERATURE',
  Urinalysis = 'URINALYSIS',
  Weight = 'WEIGHT'
}

export type OccupancyStats = {
  __typename?: 'OccupancyStats';
  currentResidents: Scalars['Int']['output'];
  deceasedResidents: Scalars['Int']['output'];
  pastResidents: Scalars['Int']['output'];
  permanentResidents: Scalars['Int']['output'];
  respiteResidents: Scalars['Int']['output'];
  totalResidents: Scalars['Int']['output'];
  waitingList: Scalars['Int']['output'];
};

export type OffXeroReceipt = {
  __typename?: 'OffXeroReceipt';
  amount: Scalars['Float']['output'];
  note?: Maybe<Scalars['String']['output']>;
  receiptId: Scalars['String']['output'];
  receivedDate?: Maybe<Scalars['String']['output']>;
  recordedAt?: Maybe<Scalars['String']['output']>;
  recordedById?: Maybe<Scalars['String']['output']>;
  recordedByName?: Maybe<Scalars['String']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
};

export type OffXeroReceiptInput = {
  amount: Scalars['Float']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  receivedDate?: InputMaybe<Scalars['String']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
};

export type OfferCompetitionPrintsInput = {
  artistSharePercent?: InputMaybe<Scalars['Int']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  printCost: Scalars['Float']['input'];
  size?: InputMaybe<Scalars['String']['input']>;
  stockLevel?: InputMaybe<Scalars['Int']['input']>;
};

export type OnboardClientInput = {
  companyName?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  fName?: InputMaybe<Scalars['String']['input']>;
  issueCredentials?: InputMaybe<Scalars['Boolean']['input']>;
  lName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  sendVia?: InputMaybe<Scalars['String']['input']>;
};

export type OnboardClientResult = {
  __typename?: 'OnboardClientResult';
  clientId: Scalars['ID']['output'];
  created: Scalars['Boolean']['output'];
  deliveredVia: Array<Scalars['String']['output']>;
  matchedExisting: Scalars['Boolean']['output'];
  success: Scalars['Boolean']['output'];
  temporaryPassword?: Maybe<Scalars['String']['output']>;
  username?: Maybe<Scalars['String']['output']>;
};

export type OnboardedClientSummary = {
  __typename?: 'OnboardedClientSummary';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  fName?: Maybe<Scalars['String']['output']>;
  hasPassword: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  lName?: Maybe<Scalars['String']['output']>;
  lastLoginAt?: Maybe<Scalars['DateTime']['output']>;
  lastLoginMethod?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  state: Scalars['String']['output'];
  username?: Maybe<Scalars['String']['output']>;
};

/** One tracked onboarding section for an invitee — drives the invites-page progress bar. */
export type OnboardingProgressSection = {
  __typename?: 'OnboardingProgressSection';
  complete: Scalars['Boolean']['output'];
  /** When this section completed, where known (signed forms carry real timestamps). */
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Who can fix this section: 'SELF' (the employee, via My Details) or 'HR' (a manager, e.g. pay rate / hours). Self-service surfaces show only SELF sections. */
  fixedBy: Scalars['String']['output'];
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  /** Field labels still outstanding — safe to display, names only (e.g. "No current pay rate for Food Service Assistant"). Empty when complete. */
  missing: Array<Scalars['String']['output']>;
};

export type OnboardingResult = {
  __typename?: 'OnboardingResult';
  companyName?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  /** True when login details were emailed. False when the address already had an account (its password is unchanged, so nothing was sent). */
  emailedCredentials: Scalars['Boolean']['output'];
  success: Scalars['Boolean']['output'];
  temporaryPassword?: Maybe<Scalars['String']['output']>;
  username: Scalars['String']['output'];
};

export type Opportunity = {
  __typename?: 'Opportunity';
  activities?: Maybe<Array<OpportunityActivity>>;
  actualCloseDate?: Maybe<Scalars['DateTime']['output']>;
  additionalContacts?: Maybe<Array<OpportunityContact>>;
  assignedTo?: Maybe<Scalars['String']['output']>;
  assignedToName?: Maybe<Scalars['String']['output']>;
  callCount: Scalars['Int']['output'];
  campaign?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  clientEmail?: Maybe<Scalars['String']['output']>;
  clientId?: Maybe<Scalars['String']['output']>;
  clientName?: Maybe<Scalars['String']['output']>;
  clientPhone?: Maybe<Scalars['String']['output']>;
  competitorNotes?: Maybe<Scalars['String']['output']>;
  competitors?: Maybe<Array<Scalars['String']['output']>>;
  completedTaskCount: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  createdByName?: Maybe<Scalars['String']['output']>;
  customFields?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  emailCount: Scalars['Int']['output'];
  expectedCloseDate?: Maybe<Scalars['DateTime']['output']>;
  expectedRevenue?: Maybe<Scalars['Float']['output']>;
  finalValue?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  internalNotes?: Maybe<Scalars['String']['output']>;
  lastActivityDate?: Maybe<Scalars['DateTime']['output']>;
  lossNotes?: Maybe<Scalars['String']['output']>;
  lossReason?: Maybe<Scalars['String']['output']>;
  media?: Maybe<Array<OpportunityMedia>>;
  meetingCount: Scalars['Int']['output'];
  memberCount: Scalars['Int']['output'];
  members?: Maybe<Array<Scalars['String']['output']>>;
  nextFollowUpDate?: Maybe<Scalars['DateTime']['output']>;
  noteCount: Scalars['Int']['output'];
  opportunityTypeId?: Maybe<Scalars['String']['output']>;
  opportunityTypeName?: Maybe<Scalars['String']['output']>;
  paymentSchedule?: Maybe<Array<PaymentScheduleItem>>;
  priority: OpportunityPriority;
  probability: Scalars['Float']['output'];
  products?: Maybe<Array<Scalars['String']['output']>>;
  progressNotes?: Maybe<Array<OpportunityProgressNote>>;
  projectedTotalValue?: Maybe<Scalars['Float']['output']>;
  /** Linked Proposals v2 proposal ID */
  proposalId?: Maybe<Scalars['String']['output']>;
  recurringPayment?: Maybe<RecurringPayment>;
  referralSource?: Maybe<Scalars['String']['output']>;
  referringClientId?: Maybe<Scalars['String']['output']>;
  services?: Maybe<Array<Scalars['String']['output']>>;
  source?: Maybe<Scalars['String']['output']>;
  stage: Scalars['String']['output'];
  status: OpportunityStatus;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  taskCount: Scalars['Int']['output'];
  tenantId: Scalars['String']['output'];
  title: Scalars['String']['output'];
  totalPaidAmount?: Maybe<Scalars['Float']['output']>;
  totalScheduledAmount?: Maybe<Scalars['Float']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  value: Scalars['Float']['output'];
  valueMemberSplits?: Maybe<Array<MemberSplit>>;
  valuePaymentStatus?: Maybe<OpportunityPaymentStatus>;
  valueReceivedDate?: Maybe<Scalars['DateTime']['output']>;
  /** Multiple value streams for tracking cash, crypto, and equity */
  valueStreams?: Maybe<Array<ValueStream>>;
  winNotes?: Maybe<Scalars['String']['output']>;
};

export type OpportunityActivity = {
  __typename?: 'OpportunityActivity';
  createdBy?: Maybe<Scalars['String']['output']>;
  date: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  outcome?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export type OpportunityContact = {
  __typename?: 'OpportunityContact';
  email?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
};

export type OpportunityEmailSummary = {
  __typename?: 'OpportunityEmailSummary';
  date: Scalars['DateTime']['output'];
  direction: Scalars['String']['output'];
  folder?: Maybe<Scalars['String']['output']>;
  from: Scalars['String']['output'];
  fromName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isRead: Scalars['Boolean']['output'];
  subject: Scalars['String']['output'];
};

export type OpportunityEmailsResult = {
  __typename?: 'OpportunityEmailsResult';
  available: Scalars['Boolean']['output'];
  emails: Array<OpportunityEmailSummary>;
  totalCount: Scalars['Int']['output'];
};

export type OpportunityInput = {
  assignedTo?: InputMaybe<Scalars['String']['input']>;
  campaign?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  clientId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  expectedCloseDate?: InputMaybe<Scalars['DateTime']['input']>;
  internalNotes?: InputMaybe<Scalars['String']['input']>;
  media?: InputMaybe<Array<OpportunityMediaInput>>;
  opportunityTypeId?: InputMaybe<Scalars['String']['input']>;
  paymentSchedule?: InputMaybe<Array<PaymentScheduleItemInput>>;
  priority?: InputMaybe<OpportunityPriority>;
  probability?: InputMaybe<Scalars['Float']['input']>;
  products?: InputMaybe<Array<Scalars['String']['input']>>;
  recurringPayment?: InputMaybe<RecurringPaymentInput>;
  referringClientId?: InputMaybe<Scalars['String']['input']>;
  services?: InputMaybe<Array<Scalars['String']['input']>>;
  source?: InputMaybe<Scalars['String']['input']>;
  stage?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<OpportunityStatus>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  title?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['Float']['input']>;
  valueMemberSplits?: InputMaybe<Array<MemberSplitInput>>;
  valueStreams?: InputMaybe<Array<ValueStreamInput>>;
};

export type OpportunityMedia = {
  __typename?: 'OpportunityMedia';
  description?: Maybe<Scalars['String']['output']>;
  ipfsCid?: Maybe<Scalars['String']['output']>;
  mimeType?: Maybe<Scalars['String']['output']>;
  uploadedAt?: Maybe<Scalars['DateTime']['output']>;
  uploadedBy?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

export type OpportunityMediaInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  ipfsCid?: InputMaybe<Scalars['String']['input']>;
  mimeType?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type OpportunityMeeting = {
  __typename?: 'OpportunityMeeting';
  actionItems?: Maybe<Scalars['String']['output']>;
  actualEndTime?: Maybe<Scalars['DateTime']['output']>;
  actualStartTime?: Maybe<Scalars['DateTime']['output']>;
  address?: Maybe<Scalars['String']['output']>;
  agenda?: Maybe<Array<MeetingAgendaItem>>;
  attachmentUrls?: Maybe<Array<Scalars['String']['output']>>;
  attendees?: Maybe<Array<MeetingAttendee>>;
  cancelledAt?: Maybe<Scalars['DateTime']['output']>;
  cancelledBy?: Maybe<Scalars['String']['output']>;
  cancelledReason?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  createdByName?: Maybe<Scalars['String']['output']>;
  decisions?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dialInNumber?: Maybe<Scalars['String']['output']>;
  documentIds?: Maybe<Array<Scalars['String']['output']>>;
  duration: Scalars['Int']['output'];
  followUpCompleted: Scalars['Boolean']['output'];
  followUpDate?: Maybe<Scalars['DateTime']['output']>;
  format: MeetingFormat;
  id: Scalars['ID']['output'];
  keyTakeaways?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  meetingId?: Maybe<Scalars['String']['output']>;
  meetingUrl?: Maybe<Scalars['String']['output']>;
  nextSteps?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  objectives?: Maybe<Scalars['String']['output']>;
  opportunityId: Scalars['String']['output'];
  opportunityTitle?: Maybe<Scalars['String']['output']>;
  organizerId?: Maybe<Scalars['String']['output']>;
  organizerName?: Maybe<Scalars['String']['output']>;
  outcome?: Maybe<Scalars['String']['output']>;
  passcode?: Maybe<Scalars['String']['output']>;
  preparationNotes?: Maybe<Scalars['String']['output']>;
  questionsToAsk?: Maybe<Array<Scalars['String']['output']>>;
  recordingUrl?: Maybe<Scalars['String']['output']>;
  relatedProposalId?: Maybe<Scalars['String']['output']>;
  relatedQuoteId?: Maybe<Scalars['String']['output']>;
  relatedTaskId?: Maybe<Scalars['String']['output']>;
  reminderDate?: Maybe<Scalars['DateTime']['output']>;
  reminderEnabled: Scalars['Boolean']['output'];
  reminderSent: Scalars['Boolean']['output'];
  rescheduledFrom?: Maybe<Scalars['String']['output']>;
  rescheduledTo?: Maybe<Scalars['String']['output']>;
  scheduledDate: Scalars['DateTime']['output'];
  status: MeetingStatus;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  talkingPoints?: Maybe<Array<Scalars['String']['output']>>;
  tenantId: Scalars['String']['output'];
  title: Scalars['String']['output'];
  transcriptUrl?: Maybe<Scalars['String']['output']>;
  type: MeetingType;
  updatedAt: Scalars['DateTime']['output'];
};

export type OpportunityMeetingInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  agenda?: InputMaybe<Array<MeetingAgendaItemInput>>;
  attendees?: InputMaybe<Array<MeetingAttendeeInput>>;
  description?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  format?: InputMaybe<MeetingFormat>;
  location?: InputMaybe<Scalars['String']['input']>;
  meetingUrl?: InputMaybe<Scalars['String']['input']>;
  objectives?: InputMaybe<Scalars['String']['input']>;
  opportunityId: Scalars['String']['input'];
  preparationNotes?: InputMaybe<Scalars['String']['input']>;
  questionsToAsk?: InputMaybe<Array<Scalars['String']['input']>>;
  reminderDate?: InputMaybe<Scalars['DateTime']['input']>;
  reminderEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  scheduledDate: Scalars['DateTime']['input'];
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  talkingPoints?: InputMaybe<Array<Scalars['String']['input']>>;
  title: Scalars['String']['input'];
  type?: InputMaybe<MeetingType>;
};

export type OpportunityMeetingUpdateInput = {
  actionItems?: InputMaybe<Scalars['String']['input']>;
  actualEndTime?: InputMaybe<Scalars['DateTime']['input']>;
  actualStartTime?: InputMaybe<Scalars['DateTime']['input']>;
  agenda?: InputMaybe<Array<MeetingAgendaItemInput>>;
  attendees?: InputMaybe<Array<MeetingAttendeeInput>>;
  cancelledReason?: InputMaybe<Scalars['String']['input']>;
  decisions?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  followUpDate?: InputMaybe<Scalars['DateTime']['input']>;
  format?: InputMaybe<MeetingFormat>;
  keyTakeaways?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  meetingUrl?: InputMaybe<Scalars['String']['input']>;
  nextSteps?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  outcome?: InputMaybe<Scalars['String']['input']>;
  recordingUrl?: InputMaybe<Scalars['String']['input']>;
  scheduledDate?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<MeetingStatus>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<MeetingType>;
};

export type OpportunityMember = {
  __typename?: 'OpportunityMember';
  clientEmail?: Maybe<Scalars['String']['output']>;
  clientId: Scalars['String']['output'];
  clientName?: Maybe<Scalars['String']['output']>;
  commissionSplits?: Maybe<Array<CommissionSplit>>;
  createdAt: Scalars['DateTime']['output'];
  defaultPayoutDelayDays?: Maybe<Scalars['Int']['output']>;
  defaultSplitPercentage: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  opportunityId: Scalars['String']['output'];
  role?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  totalEarned?: Maybe<Scalars['Float']['output']>;
  totalPending?: Maybe<Scalars['Float']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type OpportunityMemberInput = {
  clientId: Scalars['String']['input'];
  commissionSplits?: InputMaybe<Array<CommissionSplitInput>>;
  defaultPayoutDelayDays?: InputMaybe<Scalars['Int']['input']>;
  defaultSplitPercentage?: InputMaybe<Scalars['Float']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
};

export type OpportunityMemberUpdateInput = {
  commissionSplits?: InputMaybe<Array<CommissionSplitInput>>;
  defaultPayoutDelayDays?: InputMaybe<Scalars['Int']['input']>;
  defaultSplitPercentage?: InputMaybe<Scalars['Float']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
};

export type OpportunityNote = {
  __typename?: 'OpportunityNote';
  actionItems?: Maybe<Array<Scalars['String']['output']>>;
  allowedRoles?: Maybe<Array<Scalars['String']['output']>>;
  allowedUserIds?: Maybe<Array<Scalars['String']['output']>>;
  attachments?: Maybe<Array<NoteAttachment>>;
  category?: Maybe<Scalars['String']['output']>;
  confidenceLevel?: Maybe<Scalars['String']['output']>;
  contactCompany?: Maybe<Scalars['String']['output']>;
  contactEmail?: Maybe<Scalars['String']['output']>;
  contactPerson?: Maybe<Scalars['String']['output']>;
  contactPhone?: Maybe<Scalars['String']['output']>;
  content: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  createdByName?: Maybe<Scalars['String']['output']>;
  followUpAction?: Maybe<Scalars['String']['output']>;
  followUpCompleted: Scalars['Boolean']['output'];
  followUpDate?: Maybe<Scalars['DateTime']['output']>;
  followUpRequired?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  isActionable: Scalars['Boolean']['output'];
  isDecisionFactor: Scalars['Boolean']['output'];
  isOpportunity: Scalars['Boolean']['output'];
  isPinned: Scalars['Boolean']['output'];
  isRisk: Scalars['Boolean']['output'];
  keyPoints?: Maybe<Array<Scalars['String']['output']>>;
  lastEditedAt?: Maybe<Scalars['DateTime']['output']>;
  lastEditedBy?: Maybe<Scalars['String']['output']>;
  lastEditedByName?: Maybe<Scalars['String']['output']>;
  mentionedCompetitors?: Maybe<Array<Scalars['String']['output']>>;
  mentionedProducts?: Maybe<Array<Scalars['String']['output']>>;
  mentionedUserIds?: Maybe<Array<Scalars['String']['output']>>;
  opportunityId: Scalars['String']['output'];
  opportunityTitle?: Maybe<Scalars['String']['output']>;
  previousVersion?: Maybe<Scalars['String']['output']>;
  priority: NotePriority;
  relatedCallId?: Maybe<Scalars['String']['output']>;
  relatedEmailId?: Maybe<Scalars['String']['output']>;
  relatedMeetingId?: Maybe<Scalars['String']['output']>;
  relatedQuoteId?: Maybe<Scalars['String']['output']>;
  relatedTaskId?: Maybe<Scalars['String']['output']>;
  sentiment?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  sourceDate?: Maybe<Scalars['DateTime']['output']>;
  sourceUrl?: Maybe<Scalars['String']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  tenantId: Scalars['String']['output'];
  title: Scalars['String']['output'];
  type: NoteType;
  updatedAt: Scalars['DateTime']['output'];
  version?: Maybe<Scalars['Float']['output']>;
  visibility: NoteVisibility;
};

export type OpportunityNoteInput = {
  actionItems?: InputMaybe<Array<Scalars['String']['input']>>;
  allowedUserIds?: InputMaybe<Array<Scalars['String']['input']>>;
  attachments?: InputMaybe<Array<NoteAttachmentInput>>;
  category?: InputMaybe<Scalars['String']['input']>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactPerson?: InputMaybe<Scalars['String']['input']>;
  content: Scalars['String']['input'];
  followUpAction?: InputMaybe<Scalars['String']['input']>;
  followUpDate?: InputMaybe<Scalars['DateTime']['input']>;
  followUpRequired?: InputMaybe<Scalars['Boolean']['input']>;
  isActionable?: InputMaybe<Scalars['Boolean']['input']>;
  isDecisionFactor?: InputMaybe<Scalars['Boolean']['input']>;
  isOpportunity?: InputMaybe<Scalars['Boolean']['input']>;
  isPinned?: InputMaybe<Scalars['Boolean']['input']>;
  isRisk?: InputMaybe<Scalars['Boolean']['input']>;
  keyPoints?: InputMaybe<Array<Scalars['String']['input']>>;
  mentionedCompetitors?: InputMaybe<Array<Scalars['String']['input']>>;
  mentionedProducts?: InputMaybe<Array<Scalars['String']['input']>>;
  opportunityId: Scalars['String']['input'];
  priority?: InputMaybe<NotePriority>;
  relatedMeetingId?: InputMaybe<Scalars['String']['input']>;
  relatedTaskId?: InputMaybe<Scalars['String']['input']>;
  sentiment?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  summary?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  title: Scalars['String']['input'];
  type?: InputMaybe<NoteType>;
  visibility?: InputMaybe<NoteVisibility>;
};

export type OpportunityNoteUpdateInput = {
  actionItems?: InputMaybe<Array<Scalars['String']['input']>>;
  allowedUserIds?: InputMaybe<Array<Scalars['String']['input']>>;
  attachments?: InputMaybe<Array<NoteAttachmentInput>>;
  category?: InputMaybe<Scalars['String']['input']>;
  contactPerson?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  followUpAction?: InputMaybe<Scalars['String']['input']>;
  followUpCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  followUpDate?: InputMaybe<Scalars['DateTime']['input']>;
  followUpRequired?: InputMaybe<Scalars['Boolean']['input']>;
  isActionable?: InputMaybe<Scalars['Boolean']['input']>;
  isDecisionFactor?: InputMaybe<Scalars['Boolean']['input']>;
  isOpportunity?: InputMaybe<Scalars['Boolean']['input']>;
  isPinned?: InputMaybe<Scalars['Boolean']['input']>;
  isRisk?: InputMaybe<Scalars['Boolean']['input']>;
  keyPoints?: InputMaybe<Array<Scalars['String']['input']>>;
  priority?: InputMaybe<NotePriority>;
  sentiment?: InputMaybe<Scalars['String']['input']>;
  summary?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<NoteType>;
  visibility?: InputMaybe<NoteVisibility>;
};

/** Status of payment processing for opportunities */
export enum OpportunityPaymentStatus {
  Cancelled = 'CANCELLED',
  Distributed = 'DISTRIBUTED',
  Pending = 'PENDING',
  Received = 'RECEIVED'
}

/** Priority level of the opportunity */
export enum OpportunityPriority {
  Critical = 'CRITICAL',
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM'
}

export type OpportunityProgressNote = {
  __typename?: 'OpportunityProgressNote';
  action: Scalars['String']['output'];
  attachments?: Maybe<Array<ProgressNoteAttachment>>;
  details?: Maybe<Scalars['String']['output']>;
  newValue?: Maybe<Scalars['String']['output']>;
  performedAt: Scalars['DateTime']['output'];
  performedBy: Scalars['String']['output'];
  performedById?: Maybe<Scalars['String']['output']>;
  previousValue?: Maybe<Scalars['String']['output']>;
};

export type OpportunityStage = {
  __typename?: 'OpportunityStage';
  autoMoveDays?: Maybe<Scalars['Int']['output']>;
  autoMoveEnabled: Scalars['Boolean']['output'];
  averageDaysInStage: Scalars['Float']['output'];
  code: Scalars['String']['output'];
  color: Scalars['String']['output'];
  conversionRate: Scalars['Float']['output'];
  createdAt: Scalars['DateTime']['output'];
  currentOpportunities: Scalars['Int']['output'];
  defaultProbability: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  documentTemplates?: Maybe<Array<Scalars['String']['output']>>;
  emailTemplate?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  isDefault: Scalars['Boolean']['output'];
  isFinalStage: Scalars['Boolean']['output'];
  isLostStage: Scalars['Boolean']['output'];
  isWonStage: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  nextStageCode?: Maybe<Scalars['String']['output']>;
  notifyOnEntry: Scalars['Boolean']['output'];
  notifyOnExit: Scalars['Boolean']['output'];
  notifyUsers?: Maybe<Array<Scalars['String']['output']>>;
  order: Scalars['Int']['output'];
  requiredFields?: Maybe<Array<Scalars['String']['output']>>;
  requiredTasks?: Maybe<Array<Scalars['String']['output']>>;
  taskTemplates?: Maybe<Array<Scalars['String']['output']>>;
  tenantId: Scalars['String']['output'];
  totalOpportunities: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type OpportunityStageInput = {
  autoMoveDays?: InputMaybe<Scalars['Int']['input']>;
  autoMoveEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  code: Scalars['String']['input'];
  color: Scalars['String']['input'];
  defaultProbability?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  isFinalStage?: InputMaybe<Scalars['Boolean']['input']>;
  isLostStage?: InputMaybe<Scalars['Boolean']['input']>;
  isWonStage?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  nextStageCode?: InputMaybe<Scalars['String']['input']>;
  notifyOnEntry?: InputMaybe<Scalars['Boolean']['input']>;
  notifyOnExit?: InputMaybe<Scalars['Boolean']['input']>;
  order: Scalars['Int']['input'];
};

export type OpportunityStageUpdateInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  defaultProbability?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
};

/** Status of the opportunity */
export enum OpportunityStatus {
  Active = 'ACTIVE',
  Cancelled = 'CANCELLED',
  Lost = 'LOST',
  OnHold = 'ON_HOLD',
  Won = 'WON'
}

export type OpportunityTask = {
  __typename?: 'OpportunityTask';
  actualHours?: Maybe<Scalars['Float']['output']>;
  assignedTo?: Maybe<Scalars['String']['output']>;
  assignedToName?: Maybe<Scalars['String']['output']>;
  checklistCompleted?: Maybe<Array<Scalars['Boolean']['output']>>;
  checklistItems?: Maybe<Array<Scalars['String']['output']>>;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  completedBy?: Maybe<Scalars['String']['output']>;
  completedByName?: Maybe<Scalars['String']['output']>;
  contactEmail?: Maybe<Scalars['String']['output']>;
  contactPerson?: Maybe<Scalars['String']['output']>;
  contactPhone?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  createdByName?: Maybe<Scalars['String']['output']>;
  dependsOn?: Maybe<Array<Scalars['String']['output']>>;
  description?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['DateTime']['output']>;
  estimatedHours?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  isBlocking: Scalars['Boolean']['output'];
  location?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  opportunityId: Scalars['String']['output'];
  opportunityTitle?: Maybe<Scalars['String']['output']>;
  outcome?: Maybe<Scalars['String']['output']>;
  priority: OpportunityTaskPriority;
  relatedDocumentId?: Maybe<Scalars['String']['output']>;
  relatedEmailId?: Maybe<Scalars['String']['output']>;
  relatedMeetingId?: Maybe<Scalars['String']['output']>;
  reminderDate?: Maybe<Scalars['DateTime']['output']>;
  reminderEnabled: Scalars['Boolean']['output'];
  reminderSent: Scalars['Boolean']['output'];
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  status: OpportunityTaskStatus;
  subtaskCompletedCount?: Maybe<Scalars['Float']['output']>;
  subtaskCount?: Maybe<Scalars['Float']['output']>;
  subtasks?: Maybe<Array<SubTask>>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  /** File path to a .md task specification on disk */
  taskSpecificationLocation?: Maybe<Scalars['String']['output']>;
  /** Inline markdown task specification content */
  taskSpecificationMD?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  title: Scalars['String']['output'];
  type: OpportunityTaskType;
  updatedAt: Scalars['DateTime']['output'];
};

export type OpportunityTaskInput = {
  assignedTo?: InputMaybe<Scalars['String']['input']>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactPerson?: InputMaybe<Scalars['String']['input']>;
  contactPhone?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  isBlocking?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  opportunityId: Scalars['String']['input'];
  priority?: InputMaybe<OpportunityTaskPriority>;
  reminderDate?: InputMaybe<Scalars['DateTime']['input']>;
  reminderEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  taskSpecificationLocation?: InputMaybe<Scalars['String']['input']>;
  taskSpecificationMD?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  type?: InputMaybe<OpportunityTaskType>;
};

/** Priority level of the task */
export enum OpportunityTaskPriority {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM',
  Urgent = 'URGENT'
}

/** Status of the task */
export enum OpportunityTaskStatus {
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Deferred = 'DEFERRED',
  InProgress = 'IN_PROGRESS',
  Pending = 'PENDING',
  Todo = 'TODO'
}

/** Type of opportunity task */
export enum OpportunityTaskType {
  Call = 'CALL',
  Demo = 'DEMO',
  Document = 'DOCUMENT',
  Email = 'EMAIL',
  FollowUp = 'FOLLOW_UP',
  Internal = 'INTERNAL',
  Meeting = 'MEETING',
  Other = 'OTHER',
  Proposal = 'PROPOSAL',
  Research = 'RESEARCH'
}

export type OpportunityTaskUpdateInput = {
  actualHours?: InputMaybe<Scalars['Float']['input']>;
  assignedTo?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  outcome?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<OpportunityTaskPriority>;
  status?: InputMaybe<OpportunityTaskStatus>;
  taskSpecificationLocation?: InputMaybe<Scalars['String']['input']>;
  taskSpecificationMD?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<OpportunityTaskType>;
};

export type OpportunityType = {
  __typename?: 'OpportunityType';
  color?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Float']['output'];
  targetCount?: Maybe<Scalars['Float']['output']>;
  targetValue?: Maybe<Scalars['Float']['output']>;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type OpportunityTypeInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  order?: InputMaybe<Scalars['Float']['input']>;
  targetCount?: InputMaybe<Scalars['Float']['input']>;
  targetValue?: InputMaybe<Scalars['Float']['input']>;
};

export type OpportunityTypeUpdateInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Float']['input']>;
  targetCount?: InputMaybe<Scalars['Float']['input']>;
  targetValue?: InputMaybe<Scalars['Float']['input']>;
};

export type OpportunityUpdateInput = {
  assignedTo?: InputMaybe<Scalars['String']['input']>;
  campaign?: InputMaybe<Scalars['String']['input']>;
  clientId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  expectedCloseDate?: InputMaybe<Scalars['DateTime']['input']>;
  finalValue?: InputMaybe<Scalars['Float']['input']>;
  internalNotes?: InputMaybe<Scalars['String']['input']>;
  lossNotes?: InputMaybe<Scalars['String']['input']>;
  lossReason?: InputMaybe<Scalars['String']['input']>;
  media?: InputMaybe<Array<OpportunityMediaInput>>;
  nextFollowUpDate?: InputMaybe<Scalars['DateTime']['input']>;
  opportunityTypeId?: InputMaybe<Scalars['String']['input']>;
  paymentSchedule?: InputMaybe<Array<PaymentScheduleItemInput>>;
  priority?: InputMaybe<OpportunityPriority>;
  probability?: InputMaybe<Scalars['Float']['input']>;
  recurringPayment?: InputMaybe<RecurringPaymentInput>;
  referringClientId?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  stage?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<OpportunityStatus>;
  title?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['Float']['input']>;
  valueMemberSplits?: InputMaybe<Array<MemberSplitInput>>;
  valueStreams?: InputMaybe<Array<ValueStreamInput>>;
  winNotes?: InputMaybe<Scalars['String']['input']>;
};

export type OrderOption = {
  __typename?: 'OrderOption';
  id: Scalars['ID']['output'];
  orderDate: Scalars['DateTime']['output'];
  orderNumber: Scalars['String']['output'];
  status: Scalars['String']['output'];
  totalAmount: Scalars['Float']['output'];
};

export type OrderPdfResult = {
  __typename?: 'OrderPDFResult';
  base64Content: Scalars['String']['output'];
  filename: Scalars['String']['output'];
  mimeType: Scalars['String']['output'];
};

export type OrgChartConfig = {
  __typename?: 'OrgChartConfig';
  createdAt: Scalars['DateTime']['output'];
  /** Default zoom level when the canvas first renders. 1.0 = native scale. */
  defaultZoom: Scalars['Float']['output'];
  /** Map of departmentId → hex colour override. Empty/missing = use Department.color from the employees module. */
  departmentColorOverrides?: Maybe<Scalars['JSONObject']['output']>;
  /** Bare Employee id of the person designated as the top/anchor of the org chart. When set, the canvas only shows this person + their direct + indirect reports (everyone else is in the Unassigned sidebar). When null, every unassigned person appears as a root (legacy multi-root behaviour). Mutually exclusive with designatedRootPlacementId. */
  designatedRootEmployeeId?: Maybe<Scalars['String']['output']>;
  /** OrgChartPlacement id designated as the top/anchor of the org chart (typically a Company). When set, the canvas anchors on that placement and includes its descendant subtree. Mutually exclusive with designatedRootEmployeeId. */
  designatedRootPlacementId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Default layout direction when the canvas first renders. Users can flip at runtime via LayoutControls. */
  layoutDirection: OrgChartLayoutDirection;
  /** If false, the org chart filters out DigitalManager nodes (humans only). Default true. */
  showDigitalManagers: Scalars['Boolean']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type OrgChartEdge = {
  __typename?: 'OrgChartEdge';
  id: Scalars['ID']['output'];
  kind: OrgChartEdgeKind;
  source: Scalars['String']['output'];
  target: Scalars['String']['output'];
};

export enum OrgChartEdgeKind {
  DepartmentMembership = 'DEPARTMENT_MEMBERSHIP',
  DmReportsTo = 'DM_REPORTS_TO',
  PlacementReportsTo = 'PLACEMENT_REPORTS_TO',
  ReportsTo = 'REPORTS_TO'
}

export type OrgChartGraph = {
  __typename?: 'OrgChartGraph';
  config: OrgChartConfig;
  departments: Array<Department>;
  edges: Array<OrgChartEdge>;
  nodes: Array<OrgChartNode>;
};

/** Hierarchical layout direction for the org chart canvas. */
export enum OrgChartLayoutDirection {
  LeftRight = 'LEFT_RIGHT',
  TopBottom = 'TOP_BOTTOM'
}

export type OrgChartNode = {
  __typename?: 'OrgChartNode';
  /** Border / chip-tint color for placement nodes (from Department.color / AdvisoryBody.color). */
  accentColor?: Maybe<Scalars['String']['output']>;
  advisoryBodyId?: Maybe<Scalars['ID']['output']>;
  avatarCid?: Maybe<Scalars['String']['output']>;
  /** Direct URL to the employee's profile photo (from Employee.profilePhoto or Client.profilePhoto). Distinct from avatarCid which is reserved for IPFS-CID storage. */
  avatarUrl?: Maybe<Scalars['String']['output']>;
  /** Server-computed: does the requesting user hold the relevant module's view permission? */
  canViewDetail: Scalars['Boolean']['output'];
  /** Left-to-right ordering hint among siblings on the chart. Lower = further left. Unset = dagre auto. */
  chartDisplayOrder?: Maybe<Scalars['Float']['output']>;
  companyId?: Maybe<Scalars['ID']['output']>;
  departmentId?: Maybe<Scalars['ID']['output']>;
  departmentIds: Array<Scalars['String']['output']>;
  /** Detail-page URL — only populated when canViewDetail is true. */
  detailUrl?: Maybe<Scalars['String']['output']>;
  digitalManagerId?: Maybe<Scalars['ID']['output']>;
  displayName: Scalars['String']['output'];
  employeeId?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  /** True when this node represents the requesting user's own employee record (Employee.clientId === ctx.user.id). The drawer allows self-edit of responsibilities for this card without org-chart edit perms. */
  isCurrentUserNode?: Maybe<Scalars['Boolean']['output']>;
  /** True if this node has a manager edge OR is the designated root. */
  isPositioned: Scalars['Boolean']['output'];
  kind: OrgChartNodeKind;
  /** Client ids of the people listed inside this node (Company.employees, AdvisoryBody.memberClientIds). Empty for non-group kinds. */
  memberClientIds: Array<Scalars['String']['output']>;
  /** Server-resolved display names matching memberClientIds (index-aligned). 'Unknown' if a client record can't be loaded. */
  memberDisplayNames: Array<Scalars['String']['output']>;
  /** OrgChartPlacement id of this employee's parent group (Company / Department / Advisory). Drawer reads this to show 'Parent: <group name>'. */
  parentPlacementId?: Maybe<Scalars['ID']['output']>;
  placementId?: Maybe<Scalars['ID']['output']>;
  /** DEPRECATED legacy free-text title (Employee.position). Read positionNames instead. */
  position?: Maybe<Scalars['String']['output']>;
  /** Job titles in the company (EmployeePosition names from Employee.positionIds; the legacy free-text position only when the person has none). Not everyone has one. Empty for non-person kinds. */
  positionNames: Array<Scalars['String']['output']>;
  /** Bare Employee id of this node's manager (humans only). Drawer's Manager picker reads this to default the Select. */
  reportsToEmployeeId?: Maybe<Scalars['ID']['output']>;
  responsibilitiesMarkdown?: Maybe<Scalars['String']['output']>;
  /** Shift roles (EmployeeRole names from Employee.roleIds) — the work someone does on a shift, tied to award, pay and qualification. Primary role first. Empty for non-person kinds. */
  roleNames: Array<Scalars['String']['output']>;
  /** For COMPANY placements only — the trading / doing-business-as name, if the Company record has one. */
  tradingName?: Maybe<Scalars['String']['output']>;
};

export enum OrgChartNodeKind {
  AdvisoryBody = 'ADVISORY_BODY',
  Company = 'COMPANY',
  Department = 'DEPARTMENT',
  DigitalManager = 'DIGITAL_MANAGER',
  Employee = 'EMPLOYEE'
}

export type OrgChartPlacement = {
  __typename?: 'OrgChartPlacement';
  createdAt: Scalars['DateTime']['output'];
  /** Sibling ordering hint — peer-insertion writes this. */
  displayOrder?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  kind: OrgChartPlacementKind;
  parentEmployeeId?: Maybe<Scalars['ID']['output']>;
  parentPlacementId?: Maybe<Scalars['ID']['output']>;
  /** FK to Company / Department / AdvisoryBody depending on `kind`. */
  refId: Scalars['ID']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export enum OrgChartPlacementKind {
  AdvisoryBody = 'ADVISORY_BODY',
  Company = 'COMPANY',
  Department = 'DEPARTMENT'
}

export type OrgChartRemoveReport = {
  __typename?: 'OrgChartRemoveReport';
  /** True if the removed root was the designated chart root and that designation was cleared. */
  designatedRootCleared: Scalars['Boolean']['output'];
  /** Number of Digital Managers whose reportTo[] was cleared because their manager-employee was removed (they're now in the Unassigned Digital Managers sidebar). */
  digitalManagersCleared: Scalars['Float']['output'];
  /** Number of employees whose chart parentage was cleared (they're now in the Unassigned sidebar). */
  employeesCleared: Scalars['Float']['output'];
  /** Number of placement records soft-deleted (they're now back in the Drag-onto-chart panel). */
  placementsDeleted: Scalars['Float']['output'];
};

export enum OrgChartReorderDirection {
  Left = 'LEFT',
  Right = 'RIGHT'
}

export enum OrgChartSiblingPosition {
  After = 'AFTER',
  Before = 'BEFORE'
}

export type OrgChartUnassignedDigitalManager = {
  __typename?: 'OrgChartUnassignedDigitalManager';
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  responsibilitiesMarkdown?: Maybe<Scalars['String']['output']>;
};

export type OrgChartUnassignedEmployee = {
  __typename?: 'OrgChartUnassignedEmployee';
  /** Direct URL to the employee's profile photo (Employee.profilePhoto fallback Client.profilePhoto). */
  avatarUrl?: Maybe<Scalars['String']['output']>;
  departmentIds: Array<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  position?: Maybe<Scalars['String']['output']>;
  /** Job titles (EmployeePosition names; legacy position only when none). */
  positionNames: Array<Scalars['String']['output']>;
  responsibilitiesMarkdown?: Maybe<Scalars['String']['output']>;
  /** Shift roles (EmployeeRole names), primary first. */
  roleNames: Array<Scalars['String']['output']>;
};

export type OrphanResolutionLog = {
  __typename?: 'OrphanResolutionLog';
  createdAt: Scalars['DateTime']['output'];
  employeeId: Scalars['ID']['output'];
  employeeName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  mode: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  resolvedAt: Scalars['DateTime']['output'];
  resolvedBy?: Maybe<Scalars['String']['output']>;
  resolvedByName: Scalars['String']['output'];
  shiftEndTime: Scalars['DateTime']['output'];
  shiftId: Scalars['ID']['output'];
  shiftStartTime: Scalars['DateTime']['output'];
  shiftTitle: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** How to resolve an orphaned (stuck) check-in */
export enum OrphanResolutionMode {
  CheckOutAtEnd = 'CHECK_OUT_AT_END',
  CheckOutNow = 'CHECK_OUT_NOW',
  MarkAcknowledged = 'MARK_ACKNOWLEDGED',
  MarkNoShow = 'MARK_NO_SHOW',
  RecordAbsence = 'RECORD_ABSENCE'
}

/** What kind of orphan this is — missed checkout vs missed acknowledgement */
export enum OrphanType {
  MissedAcknowledgement = 'MISSED_ACKNOWLEDGEMENT',
  MissedCheckout = 'MISSED_CHECKOUT'
}

export type OrphanedAssignment = {
  __typename?: 'OrphanedAssignment';
  checkInId?: Maybe<Scalars['ID']['output']>;
  checkInMethod?: Maybe<Scalars['String']['output']>;
  checkInTime?: Maybe<Scalars['DateTime']['output']>;
  clockOutReminderSent: Scalars['Boolean']['output'];
  employeeId: Scalars['ID']['output'];
  employeeName: Scalars['String']['output'];
  hoursStuck: Scalars['Float']['output'];
  isShiftWorker: Scalars['Boolean']['output'];
  likelyReason: Scalars['String']['output'];
  orphanType: OrphanType;
  shiftEndTime: Scalars['DateTime']['output'];
  shiftId: Scalars['ID']['output'];
  shiftStartTime: Scalars['DateTime']['output'];
  shiftTitle: Scalars['String']['output'];
};

export type OrphanedRecord = {
  __typename?: 'OrphanedRecord';
  currentQuantity?: Maybe<Scalars['Float']['output']>;
  currentUnit: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  ingredientId?: Maybe<Scalars['ID']['output']>;
  ingredientName?: Maybe<Scalars['String']['output']>;
  kind: Scalars['String']['output'];
  reason: Scalars['String']['output'];
  recipeId?: Maybe<Scalars['ID']['output']>;
  recipeName?: Maybe<Scalars['String']['output']>;
  suggestedAction: Scalars['String']['output'];
};

export type OutboundEmailAttachment = {
  __typename?: 'OutboundEmailAttachment';
  content?: Maybe<Scalars['String']['output']>;
  contentId?: Maybe<Scalars['String']['output']>;
  contentLength: Scalars['Float']['output'];
  contentType: Scalars['String']['output'];
  ipfsCid?: Maybe<Scalars['String']['output']>;
  ipfsUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  originalName?: Maybe<Scalars['String']['output']>;
};

export type OutboundEmailAttachmentInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  contentId?: InputMaybe<Scalars['String']['input']>;
  contentLength?: InputMaybe<Scalars['Float']['input']>;
  contentType: Scalars['String']['input'];
  ipfsCid?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type OutboundEmailFilterInput = {
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  excludeLabels?: InputMaybe<Array<Scalars['String']['input']>>;
  fromEmail?: InputMaybe<Scalars['String']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<EmailStatus>;
};

export type OutgoingComm = {
  __typename?: 'OutgoingComm';
  channel: CommsChannel;
  credits?: Maybe<Scalars['Float']['output']>;
  matchedBy: CommsMatchBasis;
  messageId?: Maybe<Scalars['String']['output']>;
  provider: Scalars['String']['output'];
  segments?: Maybe<Scalars['Int']['output']>;
  sender?: Maybe<Scalars['String']['output']>;
  sentAt: Scalars['DateTime']['output'];
  status: Scalars['String']['output'];
  summary: Scalars['String']['output'];
  tag?: Maybe<Scalars['String']['output']>;
  to: Scalars['String']['output'];
};

export type OutgoingCommsInput = {
  channel?: InputMaybe<CommsChannel>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type OutgoingCommsResult = {
  __typename?: 'OutgoingCommsResult';
  emailCount: Scalars['Int']['output'];
  failedCount: Scalars['Int']['output'];
  fetchedAt: Scalars['DateTime']['output'];
  notes: Array<Scalars['String']['output']>;
  /** A provider could not be read — counts leave its messages out. */
  partial: Scalars['Boolean']['output'];
  rows: Array<OutgoingComm>;
  smsCount: Scalars['Int']['output'];
  smsCredits: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
};

export type OutgoingEmailBody = {
  __typename?: 'OutgoingEmailBody';
  cc?: Maybe<Scalars['String']['output']>;
  from?: Maybe<Scalars['String']['output']>;
  htmlBody?: Maybe<Scalars['String']['output']>;
  messageId: Scalars['String']['output'];
  sentAt: Scalars['DateTime']['output'];
  status: Scalars['String']['output'];
  subject: Scalars['String']['output'];
  textBody?: Maybe<Scalars['String']['output']>;
  to: Scalars['String']['output'];
};

export type OverdueChecklistItem = {
  __typename?: 'OverdueChecklistItem';
  /** Role(s) responsible, verbatim from the source form */
  assignedRole?: Maybe<Scalars['String']['output']>;
  /** Named staff member allocated to this assessment */
  assignedToName?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  checklistId: Scalars['ID']['output'];
  daysOverdue: Scalars['Int']['output'];
  dueDay: Scalars['Int']['output'];
  /** End of the due window for ranged items ("Day 8-21") */
  dueDayEnd?: Maybe<Scalars['Int']['output']>;
  label: Scalars['String']['output'];
  residentId: Scalars['ID']['output'];
  residentName?: Maybe<Scalars['String']['output']>;
  taskId: Scalars['String']['output'];
};

export type OverdueNeurologicalAlert = {
  __typename?: 'OverdueNeurologicalAlert';
  frequencyHours: Scalars['Int']['output'];
  isOverdue: Scalars['Boolean']['output'];
  lastReading?: Maybe<Scalars['DateTime']['output']>;
  minutesSinceLast: Scalars['Int']['output'];
  minutesUntilNext: Scalars['Int']['output'];
  periodId: Scalars['ID']['output'];
  residentId: Scalars['ID']['output'];
  residentName: Scalars['String']['output'];
  residentRoom?: Maybe<Scalars['String']['output']>;
  residentWing?: Maybe<Scalars['String']['output']>;
};

export type OverdueNeurologicalAlertsResponse = {
  __typename?: 'OverdueNeurologicalAlertsResponse';
  alerts: Array<OverdueNeurologicalAlert>;
  overdueCount: Scalars['Int']['output'];
  totalActivePeriods: Scalars['Int']['output'];
};

export type OverdueNoteAlert = {
  __typename?: 'OverdueNoteAlert';
  daysSinceLastNote: Scalars['Int']['output'];
  lastNoteDate?: Maybe<Scalars['DateTime']['output']>;
  residentId: Scalars['ID']['output'];
  residentName: Scalars['String']['output'];
  residentRoom?: Maybe<Scalars['String']['output']>;
  residentWing?: Maybe<Scalars['String']['output']>;
};

export type OxygenSaturationFilterInput = {
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  residentId?: InputMaybe<Scalars['ID']['input']>;
  wing?: InputMaybe<Scalars['String']['input']>;
};

export type OxygenSaturationObservation = {
  __typename?: 'OxygenSaturationObservation';
  autoProgressNote: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  percentage: Scalars['Float']['output'];
  progressNoteId?: Maybe<Scalars['ID']['output']>;
  residentId: Scalars['ID']['output'];
  residentName?: Maybe<Scalars['String']['output']>;
  residentRoom?: Maybe<Scalars['String']['output']>;
  residentWing?: Maybe<Scalars['String']['output']>;
  sourceAuthor?: Maybe<Scalars['String']['output']>;
  sourceBackupDate?: Maybe<Scalars['DateTime']['output']>;
  sourceHash?: Maybe<Scalars['String']['output']>;
  sourceId?: Maybe<Scalars['String']['output']>;
  sourceOxygenDelivery?: Maybe<Scalars['String']['output']>;
  sourceSystem?: Maybe<Scalars['String']['output']>;
  takenAt: Scalars['DateTime']['output'];
  takenBy: Scalars['ID']['output'];
  takenByName?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type OxygenSaturationObservationsResponse = {
  __typename?: 'OxygenSaturationObservationsResponse';
  limit: Scalars['Int']['output'];
  observations: Array<OxygenSaturationObservation>;
  offset: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type P2Action = {
  __typename?: 'P2Action';
  body: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  isHtml: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  subject?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  type: P2ActionType;
  updatedAt: Scalars['DateTime']['output'];
};

export type P2ActionLog = {
  __typename?: 'P2ActionLog';
  actionId?: Maybe<Scalars['String']['output']>;
  body?: Maybe<Scalars['String']['output']>;
  channel: P2ActionType;
  createdAt: Scalars['DateTime']['output'];
  errorMessage?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  orderId: Scalars['String']['output'];
  sentAt: Scalars['DateTime']['output'];
  status: P2ActionLogStatus;
  subject?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** Status of a sent P2 action */
export enum P2ActionLogStatus {
  Failed = 'FAILED',
  Sent = 'SENT'
}

/** Type of action to send to a P2 order buyer */
export enum P2ActionType {
  Email = 'EMAIL',
  Sms = 'SMS'
}

export type P2BuyerSignupInput = {
  code: Scalars['String']['input'];
  email: Scalars['String']['input'];
};

export type P2BuyerSignupResponse = {
  __typename?: 'P2BuyerSignupResponse';
  client: Client;
  token: Scalars['String']['output'];
};

export type P2CampaignMessage = {
  __typename?: 'P2CampaignMessage';
  body: Scalars['String']['output'];
  campaign: Scalars['ID']['output'];
  channel: P2MessageChannel;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Float']['output'];
  sentAt?: Maybe<Scalars['DateTime']['output']>;
  sentCount?: Maybe<Scalars['Float']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** Status of a pledge/group buy campaign */
export enum P2CampaignStatus {
  Active = 'ACTIVE',
  Cancelled = 'CANCELLED',
  Delivered = 'DELIVERED',
  Delivering = 'DELIVERING',
  Draft = 'DRAFT',
  Failed = 'FAILED',
  Succeeded = 'SUCCEEDED'
}

export type P2Cart = {
  __typename?: 'P2Cart';
  client: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  items: Array<P2CartItem>;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type P2CartItem = {
  __typename?: 'P2CartItem';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  product?: Maybe<P2Product>;
  quantity: Scalars['Float']['output'];
  selectedVariantId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type P2CartItemInput = {
  productId: Scalars['ID']['input'];
  quantity: Scalars['Float']['input'];
  selectedVariantId?: InputMaybe<Scalars['String']['input']>;
};

export type P2Charge = {
  __typename?: 'P2Charge';
  amount: Scalars['Float']['output'];
  campaign?: Maybe<Scalars['ID']['output']>;
  chargeType: P2ChargeType;
  client: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  currency: Scalars['String']['output'];
  description: Scalars['String']['output'];
  failedAt?: Maybe<Scalars['DateTime']['output']>;
  failureReason?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  paidAt?: Maybe<Scalars['DateTime']['output']>;
  pledge?: Maybe<Scalars['ID']['output']>;
  savedCard: Scalars['ID']['output'];
  status: P2PaymentStatus;
  stripePaymentIntentId?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** Type of charge against a saved card */
export enum P2ChargeType {
  CampaignPledge = 'CAMPAIGN_PLEDGE',
  ManualAdditional = 'MANUAL_ADDITIONAL',
  RegularOrder = 'REGULAR_ORDER'
}

export type P2DailyChaseConfig = {
  __typename?: 'P2DailyChaseConfig';
  campaignIds: Array<Scalars['String']['output']>;
  client: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  isEnabled: Scalars['Boolean']['output'];
  lastChaseSentAt?: Maybe<Scalars['DateTime']['output']>;
  preferredTime: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** Delivery progress status for pledged products */
export enum P2DeliveryStatus {
  Customs = 'CUSTOMS',
  Delivered = 'DELIVERED',
  InTransit = 'IN_TRANSIT',
  LocalDepot = 'LOCAL_DEPOT',
  Ordered = 'ORDERED',
  OutForDelivery = 'OUT_FOR_DELIVERY',
  Shipped = 'SHIPPED'
}

export type P2DeliveryUpdate = {
  __typename?: 'P2DeliveryUpdate';
  campaign: Scalars['ID']['output'];
  client: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  note?: Maybe<Scalars['String']['output']>;
  pledge: Scalars['ID']['output'];
  status: P2DeliveryStatus;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['ID']['output'];
};

export type P2ImageUploadResult = {
  __typename?: 'P2ImageUploadResult';
  filename: Scalars['String']['output'];
  hash: Scalars['String']['output'];
  size: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type P2Interest = {
  __typename?: 'P2Interest';
  campaign?: Maybe<Scalars['ID']['output']>;
  client?: Maybe<Scalars['ID']['output']>;
  convertedAt?: Maybe<Scalars['DateTime']['output']>;
  convertedToPledge: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  email?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  preferredChannel: P2InterestChannel;
  product: Scalars['ID']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** Preferred notification channel for waiting list signups */
export enum P2InterestChannel {
  Both = 'BOTH',
  Email = 'EMAIL',
  Sms = 'SMS'
}

export type P2InterestInput = {
  campaignId?: InputMaybe<Scalars['ID']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  preferredChannel?: InputMaybe<P2InterestChannel>;
  productId: Scalars['ID']['input'];
};

export type P2InternationalRate = {
  __typename?: 'P2InternationalRate';
  cost?: Maybe<Scalars['Float']['output']>;
  countryCode: Scalars['String']['output'];
  countryName: Scalars['String']['output'];
};

export type P2InternationalRateInput = {
  cost?: InputMaybe<Scalars['Float']['input']>;
  countryCode: Scalars['String']['input'];
  countryName: Scalars['String']['input'];
};

export type P2Invite = {
  __typename?: 'P2Invite';
  completedClient?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  expiresAt: Scalars['DateTime']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  invitedBy: Scalars['ID']['output'];
  lastName: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  status: P2InviteStatus;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** Status of a campaign manager invite */
export enum P2InviteStatus {
  Completed = 'COMPLETED',
  Expired = 'EXPIRED',
  Pending = 'PENDING'
}

/** Channel for campaign messages */
export enum P2MessageChannel {
  Email = 'EMAIL',
  Sms = 'SMS'
}

export type P2MessageLog = {
  __typename?: 'P2MessageLog';
  campaign: Scalars['ID']['output'];
  channel: P2MessageChannel;
  client?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['DateTime']['output'];
  errorMessage?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  interpolatedBody: Scalars['String']['output'];
  message?: Maybe<Scalars['ID']['output']>;
  recipientEmail?: Maybe<Scalars['String']['output']>;
  recipientName?: Maybe<Scalars['String']['output']>;
  recipientPhone?: Maybe<Scalars['String']['output']>;
  recipientType: Scalars['String']['output'];
  sentAt: Scalars['DateTime']['output'];
  status: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** How to resolve notification recipients */
export enum P2NotificationRecipientType {
  AllAdmins = 'ALL_ADMINS',
  AllPledgers = 'ALL_PLEDGERS',
  AllWaitlist = 'ALL_WAITLIST',
  PledgersAndWaitlist = 'PLEDGERS_AND_WAITLIST',
  SpecificClients = 'SPECIFIC_CLIENTS'
}

export type P2NotificationRule = {
  __typename?: 'P2NotificationRule';
  channels: Array<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  isEnabled: Scalars['Boolean']['output'];
  messageTemplate?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  recipientIds?: Maybe<Array<Scalars['String']['output']>>;
  recipientType: P2NotificationRecipientType;
  tenantId: Scalars['String']['output'];
  timing: P2NotificationTiming;
  timingMinutes?: Maybe<Scalars['Float']['output']>;
  trigger: P2NotificationTrigger;
  updatedAt: Scalars['DateTime']['output'];
};

/** When to send the notification relative to the trigger */
export enum P2NotificationTiming {
  Immediate = 'IMMEDIATE',
  MinutesAfter = 'MINUTES_AFTER'
}

/** Events that can trigger automated notifications in the p2 module */
export enum P2NotificationTrigger {
  ActionSent = 'ACTION_SENT',
  AllEvents = 'ALL_EVENTS',
  CampaignCreated = 'CAMPAIGN_CREATED',
  CampaignMessageSent = 'CAMPAIGN_MESSAGE_SENT',
  DeliveryStatusUpdated = 'DELIVERY_STATUS_UPDATED',
  InterestRegistered = 'INTEREST_REGISTERED',
  ManualChargeCompleted = 'MANUAL_CHARGE_COMPLETED',
  OrderPaid = 'ORDER_PAID',
  OrderPlaced = 'ORDER_PLACED',
  PledgeCampaignExpired = 'PLEDGE_CAMPAIGN_EXPIRED',
  PledgeReceived = 'PLEDGE_RECEIVED',
  PledgeTargetReached = 'PLEDGE_TARGET_REACHED',
  ProductCreated = 'PRODUCT_CREATED',
  ProductLowStock = 'PRODUCT_LOW_STOCK',
  ProductUpdated = 'PRODUCT_UPDATED',
  ReferralPledge = 'REFERRAL_PLEDGE',
  RefundIssued = 'REFUND_ISSUED',
  TomAiConversation = 'TOM_AI_CONVERSATION'
}

export type P2Order = {
  __typename?: 'P2Order';
  client: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  customerEmail?: Maybe<Scalars['String']['output']>;
  customerFirstName?: Maybe<Scalars['String']['output']>;
  customerLastName?: Maybe<Scalars['String']['output']>;
  customerPhone?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  items: Array<P2OrderItem>;
  packagingCost?: Maybe<Scalars['Float']['output']>;
  payment: P2PaymentDetails;
  pickupOptionLabel?: Maybe<Scalars['String']['output']>;
  quickCheckout: Scalars['Boolean']['output'];
  savedCardId?: Maybe<Scalars['String']['output']>;
  shippingAddress?: Maybe<P2ShippingAddress>;
  shippingCost?: Maybe<Scalars['Float']['output']>;
  shippingMethod?: Maybe<P2ShippingMethod>;
  status: P2OrderStatus;
  tenantId: Scalars['String']['output'];
  totalAmount: Scalars['Float']['output'];
  trackingNumber?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type P2OrderInput = {
  items: Array<P2OrderItemInput>;
};

export type P2OrderItem = {
  __typename?: 'P2OrderItem';
  priceAtTime: Scalars['Float']['output'];
  product: Scalars['ID']['output'];
  quantity: Scalars['Float']['output'];
  selectedVariantId?: Maybe<Scalars['String']['output']>;
};

export type P2OrderItemInput = {
  productId: Scalars['ID']['input'];
  quantity: Scalars['Float']['input'];
  selectedVariantId?: InputMaybe<Scalars['String']['input']>;
};

/** Status of a regular (non-pledge) purchase order */
export enum P2OrderStatus {
  Cancelled = 'CANCELLED',
  Delivered = 'DELIVERED',
  Paid = 'PAID',
  Pending = 'PENDING',
  Processing = 'PROCESSING',
  Shipped = 'SHIPPED'
}

export type P2PaymentDetails = {
  __typename?: 'P2PaymentDetails';
  amountPaid?: Maybe<Scalars['Float']['output']>;
  method: P2PaymentMethodType;
  paidAt?: Maybe<Scalars['DateTime']['output']>;
  status: P2PaymentStatus;
  stripePaymentIntentId?: Maybe<Scalars['String']['output']>;
  transactionId?: Maybe<Scalars['String']['output']>;
};

/** Status of a saved payment method */
export enum P2PaymentMethodStatus {
  Active = 'ACTIVE',
  Expired = 'EXPIRED',
  Inactive = 'INACTIVE'
}

/** Payment method type */
export enum P2PaymentMethodType {
  BankTransfer = 'BANK_TRANSFER',
  Other = 'OTHER',
  Stripe = 'STRIPE'
}

/** Payment status for orders and charges */
export enum P2PaymentStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Refunded = 'REFUNDED'
}

export type P2PickupOption = {
  __typename?: 'P2PickupOption';
  label: Scalars['String']['output'];
};

export type P2PickupOptionInput = {
  label: Scalars['String']['input'];
};

export type P2Pledge = {
  __typename?: 'P2Pledge';
  amount: Scalars['Float']['output'];
  campaign: Scalars['ID']['output'];
  chargedAt?: Maybe<Scalars['DateTime']['output']>;
  client: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  deliveryNotes?: Maybe<Scalars['String']['output']>;
  deliveryStatus: P2DeliveryStatus;
  deliveryUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  failedAt?: Maybe<Scalars['DateTime']['output']>;
  failureReason?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  product: Scalars['ID']['output'];
  referralCode?: Maybe<Scalars['String']['output']>;
  referredByReferralId?: Maybe<Scalars['String']['output']>;
  savedCardId?: Maybe<Scalars['String']['output']>;
  status: P2PledgeStatus;
  stripePaymentIntentId?: Maybe<Scalars['String']['output']>;
  stripePaymentMethodId?: Maybe<Scalars['String']['output']>;
  stripeSetupIntentId: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type P2PledgeCampaign = {
  __typename?: 'P2PledgeCampaign';
  chatEnabled: Scalars['Boolean']['output'];
  chatNotifyOnMessage: Scalars['Boolean']['output'];
  chatRoomSlug?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['ID']['output'];
  currentPledgerCount: Scalars['Float']['output'];
  deliveryNotes?: Maybe<Scalars['String']['output']>;
  endDate: Scalars['DateTime']['output'];
  estimatedDeliveryDate?: Maybe<Scalars['DateTime']['output']>;
  failedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  minimumPledgers: Scalars['Float']['output'];
  pledgePrice: Scalars['Float']['output'];
  product: Scalars['ID']['output'];
  referralEnabled: Scalars['Boolean']['output'];
  referralRewardAmount?: Maybe<Scalars['Float']['output']>;
  regularPrice: Scalars['Float']['output'];
  slug: Scalars['String']['output'];
  startDate: Scalars['DateTime']['output'];
  status: P2CampaignStatus;
  succeededAt?: Maybe<Scalars['DateTime']['output']>;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type P2PledgeResult = {
  __typename?: 'P2PledgeResult';
  pledge: P2Pledge;
  setupIntentClientSecret: Scalars['String']['output'];
};

/** Status of an individual pledge */
export enum P2PledgeStatus {
  Authorized = 'AUTHORIZED',
  Cancelled = 'CANCELLED',
  Charged = 'CHARGED',
  Expired = 'EXPIRED',
  Failed = 'FAILED',
  Pending = 'PENDING'
}

export type P2Product = {
  __typename?: 'P2Product';
  categories: Array<Scalars['String']['output']>;
  compareAtPrice?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  enableQuickCheckout: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  imageCids?: Maybe<Array<Scalars['String']['output']>>;
  isActive: Scalars['Boolean']['output'];
  isFeatured: Scalars['Boolean']['output'];
  lowStockThreshold?: Maybe<Scalars['Float']['output']>;
  maxPerCustomer?: Maybe<Scalars['Float']['output']>;
  memberPrice?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  pledgeDurationDays?: Maybe<Scalars['Float']['output']>;
  pledgeEnabled: Scalars['Boolean']['output'];
  pledgeMinimum?: Maybe<Scalars['Float']['output']>;
  pledgePrice?: Maybe<Scalars['Float']['output']>;
  price: Scalars['Float']['output'];
  purchaseConfirmationEmail?: Maybe<P2PurchaseConfirmationEmail>;
  seller: Scalars['ID']['output'];
  sellerProfileId?: Maybe<Scalars['String']['output']>;
  shipping?: Maybe<P2ShippingDetails>;
  shippingConfig?: Maybe<P2ShippingConfig>;
  showSku: Scalars['Boolean']['output'];
  sku: Scalars['String']['output'];
  specifications?: Maybe<Array<P2ProductSpec>>;
  stockLevel: Scalars['Float']['output'];
  tags: Array<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  type: P2ProductType;
  updatedAt: Scalars['DateTime']['output'];
  variants?: Maybe<Array<P2ProductVariant>>;
  waitlistEnabled: Scalars['Boolean']['output'];
};

export type P2ProductInput = {
  categories?: InputMaybe<Array<Scalars['String']['input']>>;
  compareAtPrice?: InputMaybe<Scalars['Float']['input']>;
  description: Scalars['String']['input'];
  enableQuickCheckout?: InputMaybe<Scalars['Boolean']['input']>;
  imageCids?: InputMaybe<Array<Scalars['String']['input']>>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isFeatured?: InputMaybe<Scalars['Boolean']['input']>;
  lowStockThreshold?: InputMaybe<Scalars['Float']['input']>;
  maxPerCustomer?: InputMaybe<Scalars['Float']['input']>;
  memberPrice?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  pledgeDurationDays?: InputMaybe<Scalars['Float']['input']>;
  pledgeEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  pledgeMinimum?: InputMaybe<Scalars['Float']['input']>;
  pledgePrice?: InputMaybe<Scalars['Float']['input']>;
  price: Scalars['Float']['input'];
  purchaseConfirmationEmail?: InputMaybe<P2PurchaseConfirmationEmailInput>;
  sellerProfileId?: InputMaybe<Scalars['String']['input']>;
  shipping?: InputMaybe<P2ShippingDetailsInput>;
  shippingConfig?: InputMaybe<P2ShippingConfigInput>;
  showSku?: InputMaybe<Scalars['Boolean']['input']>;
  sku: Scalars['String']['input'];
  specifications?: InputMaybe<Array<P2ProductSpecInput>>;
  stockLevel?: InputMaybe<Scalars['Float']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  type?: InputMaybe<P2ProductType>;
  variants?: InputMaybe<Array<P2ProductVariantInput>>;
  waitlistEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type P2ProductSpec = {
  __typename?: 'P2ProductSpec';
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type P2ProductSpecInput = {
  label: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

/** Type of product in the p2 marketplace */
export enum P2ProductType {
  Digital = 'DIGITAL',
  Physical = 'PHYSICAL',
  Service = 'SERVICE'
}

export type P2ProductVariant = {
  __typename?: 'P2ProductVariant';
  price: Scalars['Float']['output'];
  sku?: Maybe<Scalars['String']['output']>;
  stockLevel?: Maybe<Scalars['Float']['output']>;
  title: Scalars['String']['output'];
  variantId: Scalars['String']['output'];
};

export type P2ProductVariantInput = {
  price: Scalars['Float']['input'];
  sku?: InputMaybe<Scalars['String']['input']>;
  stockLevel?: InputMaybe<Scalars['Float']['input']>;
  title: Scalars['String']['input'];
  variantId: Scalars['String']['input'];
};

export type P2PublicStripeConfig = {
  __typename?: 'P2PublicStripeConfig';
  currency: Scalars['String']['output'];
  isConfigured: Scalars['Boolean']['output'];
  stripePublishableKey?: Maybe<Scalars['String']['output']>;
  useCart: Scalars['Boolean']['output'];
};

export type P2PurchaseConfirmationEmail = {
  __typename?: 'P2PurchaseConfirmationEmail';
  body?: Maybe<Scalars['String']['output']>;
  enabled: Scalars['Boolean']['output'];
  isHtml?: Maybe<Scalars['Boolean']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
};

export type P2PurchaseConfirmationEmailInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  isHtml?: InputMaybe<Scalars['Boolean']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
};

export type P2QuickOrderInput = {
  countryCode: Scalars['String']['input'];
  customerEmail: Scalars['String']['input'];
  customerFirstName: Scalars['String']['input'];
  customerLastName: Scalars['String']['input'];
  customerPhone?: InputMaybe<Scalars['String']['input']>;
  pickupOptionLabel?: InputMaybe<Scalars['String']['input']>;
  productId: Scalars['ID']['input'];
  quantity: Scalars['Float']['input'];
  shippingAddress?: InputMaybe<P2ShippingAddressInput>;
  shippingMethod: P2ShippingMethod;
  variantId?: InputMaybe<Scalars['String']['input']>;
};

export type P2QuickOrderResult = {
  __typename?: 'P2QuickOrderResult';
  clientSecret: Scalars['String']['output'];
  order: P2Order;
};

export type P2Referral = {
  __typename?: 'P2Referral';
  campaign: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  referralCode: Scalars['String']['output'];
  referralCount: Scalars['Float']['output'];
  referralUrl: Scalars['String']['output'];
  referredPledgeIds: Array<Scalars['String']['output']>;
  referrer: Scalars['ID']['output'];
  referrerPledge: Scalars['ID']['output'];
  rewardAmount?: Maybe<Scalars['Float']['output']>;
  rewardRedeemed: Scalars['Boolean']['output'];
  tenantId: Scalars['String']['output'];
  totalRewardEarned: Scalars['Float']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type P2Refund = {
  __typename?: 'P2Refund';
  amount: Scalars['Float']['output'];
  chargeId?: Maybe<Scalars['String']['output']>;
  client: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  currency: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  orderId?: Maybe<Scalars['String']['output']>;
  pledgeId?: Maybe<Scalars['String']['output']>;
  reason: Scalars['String']['output'];
  refundedAt?: Maybe<Scalars['DateTime']['output']>;
  refundedBy: Scalars['ID']['output'];
  status: P2RefundStatus;
  stripeRefundId?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** Status of a refund */
export enum P2RefundStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Pending = 'PENDING'
}

export type P2SavePaymentMethodInput = {
  cardBrand?: InputMaybe<Scalars['String']['input']>;
  cardExpMonth?: InputMaybe<Scalars['Float']['input']>;
  cardExpYear?: InputMaybe<Scalars['Float']['input']>;
  cardLast4?: InputMaybe<Scalars['String']['input']>;
  clientId?: InputMaybe<Scalars['String']['input']>;
  stripeCustomerId: Scalars['String']['input'];
  stripePaymentMethodId: Scalars['String']['input'];
};

export type P2SavedCard = {
  __typename?: 'P2SavedCard';
  cardBrand?: Maybe<Scalars['String']['output']>;
  cardExpMonth?: Maybe<Scalars['Float']['output']>;
  cardExpYear?: Maybe<Scalars['Float']['output']>;
  cardLast4?: Maybe<Scalars['String']['output']>;
  client: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  isDefault: Scalars['Boolean']['output'];
  lastUsedAt?: Maybe<Scalars['DateTime']['output']>;
  status: P2PaymentMethodStatus;
  stripeCustomerId: Scalars['String']['output'];
  stripePaymentMethodId: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type P2SendResult = {
  __typename?: 'P2SendResult';
  failed: Scalars['Float']['output'];
  sent: Scalars['Float']['output'];
};

export type P2Settings = {
  __typename?: 'P2Settings';
  activeCampaignTarget: Scalars['Float']['output'];
  campaignGoalSetAt?: Maybe<Scalars['DateTime']['output']>;
  configuredAt?: Maybe<Scalars['DateTime']['output']>;
  configuredBy?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  currency: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isConfigured: Scalars['Boolean']['output'];
  stripeApiVersion?: Maybe<Scalars['String']['output']>;
  stripePublicKey: Scalars['String']['output'];
  stripeSecretKey: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  useCart: Scalars['Boolean']['output'];
  webhookSecret?: Maybe<Scalars['String']['output']>;
};

export type P2SettingsInput = {
  activeCampaignTarget?: InputMaybe<Scalars['Float']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  stripeApiVersion?: InputMaybe<Scalars['String']['input']>;
  stripePublicKey: Scalars['String']['input'];
  stripeSecretKey: Scalars['String']['input'];
  useCart?: InputMaybe<Scalars['Boolean']['input']>;
  webhookSecret?: InputMaybe<Scalars['String']['input']>;
};

export type P2ShippingAddress = {
  __typename?: 'P2ShippingAddress';
  city: Scalars['String']['output'];
  countryCode: Scalars['String']['output'];
  countryName?: Maybe<Scalars['String']['output']>;
  postcode: Scalars['String']['output'];
  state?: Maybe<Scalars['String']['output']>;
  street: Scalars['String']['output'];
  street2?: Maybe<Scalars['String']['output']>;
};

export type P2ShippingAddressInput = {
  city: Scalars['String']['input'];
  countryCode: Scalars['String']['input'];
  countryName?: InputMaybe<Scalars['String']['input']>;
  postcode: Scalars['String']['input'];
  state?: InputMaybe<Scalars['String']['input']>;
  street: Scalars['String']['input'];
  street2?: InputMaybe<Scalars['String']['input']>;
};

export type P2ShippingConfig = {
  __typename?: 'P2ShippingConfig';
  auExpressCost?: Maybe<Scalars['Float']['output']>;
  auStandardCost?: Maybe<Scalars['Float']['output']>;
  internationalRates?: Maybe<Array<P2InternationalRate>>;
  packagingCost?: Maybe<Scalars['Float']['output']>;
  pickupOptions?: Maybe<Array<P2PickupOption>>;
};

export type P2ShippingConfigInput = {
  auExpressCost?: InputMaybe<Scalars['Float']['input']>;
  auStandardCost?: InputMaybe<Scalars['Float']['input']>;
  internationalRates?: InputMaybe<Array<P2InternationalRateInput>>;
  packagingCost?: InputMaybe<Scalars['Float']['input']>;
  pickupOptions?: InputMaybe<Array<P2PickupOptionInput>>;
};

export type P2ShippingDetails = {
  __typename?: 'P2ShippingDetails';
  availableShippingMethods?: Maybe<Array<Scalars['String']['output']>>;
  height?: Maybe<Scalars['Float']['output']>;
  length?: Maybe<Scalars['Float']['output']>;
  requiresSpecialHandling?: Maybe<Scalars['Boolean']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
  width?: Maybe<Scalars['Float']['output']>;
};

export type P2ShippingDetailsInput = {
  availableShippingMethods?: InputMaybe<Array<Scalars['String']['input']>>;
  height?: InputMaybe<Scalars['Float']['input']>;
  length?: InputMaybe<Scalars['Float']['input']>;
  requiresSpecialHandling?: InputMaybe<Scalars['Boolean']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
  width?: InputMaybe<Scalars['Float']['input']>;
};

/** Available shipping methods for p2 products */
export enum P2ShippingMethod {
  Express = 'EXPRESS',
  International = 'INTERNATIONAL',
  LocalPickup = 'LOCAL_PICKUP',
  Standard = 'STANDARD'
}

export type P2Supplier = {
  __typename?: 'P2Supplier';
  campaign: Scalars['ID']['output'];
  confirmedAt?: Maybe<Scalars['DateTime']['output']>;
  contactEmail?: Maybe<Scalars['String']['output']>;
  contactName?: Maybe<Scalars['String']['output']>;
  contactPhone?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  currency: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isPublic: Scalars['Boolean']['output'];
  leadTimeDays?: Maybe<Scalars['Float']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  moq: Scalars['Float']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  product: Scalars['ID']['output'];
  quotedAt?: Maybe<Scalars['DateTime']['output']>;
  shippingCostEstimate?: Maybe<Scalars['Float']['output']>;
  status: P2SupplierStatus;
  supplierName: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  unitCost: Scalars['Float']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** Status of a supplier in the procurement process */
export enum P2SupplierStatus {
  Confirmed = 'CONFIRMED',
  Contacted = 'CONTACTED',
  Ordered = 'ORDERED',
  Quoted = 'QUOTED',
  Received = 'RECEIVED',
  Researching = 'RESEARCHING'
}

export type PdfResult = {
  __typename?: 'PDFResult';
  base64Content: Scalars['String']['output'];
  filename: Scalars['String']['output'];
  mimeType: Scalars['String']['output'];
};

/** Status of a proposal line item */
export enum PLineItemStatus {
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS',
  Pending = 'PENDING'
}

/** Status of a proposal payment schedule item */
export enum PPaymentScheduleStatus {
  Cancelled = 'CANCELLED',
  Invoiced = 'INVOICED',
  Overdue = 'OVERDUE',
  Paid = 'PAID',
  Pending = 'PENDING'
}

export type PProposal = {
  __typename?: 'PProposal';
  acceptedAt?: Maybe<Scalars['DateTime']['output']>;
  activities?: Maybe<Array<PProposalActivity>>;
  agreementMarkdown: Scalars['String']['output'];
  checklist?: Maybe<Array<PProposalChecklistItem>>;
  clientEmail?: Maybe<Scalars['String']['output']>;
  clientId?: Maybe<Scalars['ID']['output']>;
  clientName?: Maybe<Scalars['String']['output']>;
  clientPhone?: Maybe<Scalars['String']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  createdByName?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  deliveredAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  firstViewedAt?: Maybe<Scalars['DateTime']['output']>;
  fullySignedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  isDeleted: Scalars['Boolean']['output'];
  lineItems?: Maybe<Array<PProposalLineItem>>;
  notes?: Maybe<Scalars['String']['output']>;
  notifyEmails?: Maybe<Array<Scalars['String']['output']>>;
  notifyOnSign: Scalars['Boolean']['output'];
  notifyOnView: Scalars['Boolean']['output'];
  opportunityId?: Maybe<Scalars['ID']['output']>;
  opportunityTitle?: Maybe<Scalars['String']['output']>;
  paymentSchedule?: Maybe<Array<PProposalPaymentScheduleItem>>;
  priority: PProposalPriority;
  proposalType: PProposalType;
  requiredSignerCount: Scalars['Int']['output'];
  sentAt?: Maybe<Scalars['DateTime']['output']>;
  signedAt?: Maybe<Scalars['DateTime']['output']>;
  signedPdfCid?: Maybe<Scalars['String']['output']>;
  signedPdfUrl?: Maybe<Scalars['String']['output']>;
  signerInstructions?: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  source?: Maybe<Scalars['String']['output']>;
  status: PProposalStatus;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  tenantId: Scalars['String']['output'];
  title: Scalars['String']['output'];
  totalValue?: Maybe<Scalars['Float']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  viewedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type PProposalActivity = {
  __typename?: 'PProposalActivity';
  description: Scalars['String']['output'];
  performedAt: Scalars['DateTime']['output'];
  performedBy?: Maybe<Scalars['String']['output']>;
  performedByName?: Maybe<Scalars['String']['output']>;
  type: PProposalActivityType;
};

/** Types of proposal activity events */
export enum PProposalActivityType {
  Commented = 'COMMENTED',
  Created = 'CREATED',
  InvoiceGenerated = 'INVOICE_GENERATED',
  PaymentReceived = 'PAYMENT_RECEIVED',
  Sent = 'SENT',
  Signed = 'SIGNED',
  StatusChanged = 'STATUS_CHANGED',
  Updated = 'UPDATED',
  Viewed = 'VIEWED'
}

export type PProposalChecklistItem = {
  __typename?: 'PProposalChecklistItem';
  completed: Scalars['Boolean']['output'];
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  completedBy?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  title: Scalars['String']['output'];
};

export type PProposalFilterInput = {
  clientId?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  opportunityId?: InputMaybe<Scalars['ID']['input']>;
  proposalType?: InputMaybe<PProposalType>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<PProposalStatus>;
};

export type PProposalLineItem = {
  __typename?: 'PProposalLineItem';
  amount: Scalars['Float']['output'];
  assignedTo?: Maybe<Scalars['String']['output']>;
  billable: Scalars['Boolean']['output'];
  description: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  status: PLineItemStatus;
};

export type PProposalLineItemInput = {
  amount: Scalars['Float']['input'];
  assignedTo?: InputMaybe<Scalars['String']['input']>;
  billable?: InputMaybe<Scalars['Boolean']['input']>;
  description: Scalars['String']['input'];
  order?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<PLineItemStatus>;
};

export type PProposalPaymentScheduleItem = {
  __typename?: 'PProposalPaymentScheduleItem';
  amount: Scalars['Float']['output'];
  billId?: Maybe<Scalars['ID']['output']>;
  description: Scalars['String']['output'];
  dueDate?: Maybe<Scalars['DateTime']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  paidDate?: Maybe<Scalars['DateTime']['output']>;
  status: PPaymentScheduleStatus;
};

export type PProposalPaymentScheduleItemInput = {
  amount: Scalars['Float']['input'];
  description: Scalars['String']['input'];
  dueDate?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<PPaymentScheduleStatus>;
};

/** The priority level of a proposal */
export enum PProposalPriority {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM',
  Urgent = 'URGENT'
}

export type PProposalSignature = {
  __typename?: 'PProposalSignature';
  clientId?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['DateTime']['output'];
  /** @deprecated One-time codes are no longer stored on signatures. Use emailVerificationId for verification provenance. */
  emailVerificationCode?: Maybe<Scalars['String']['output']>;
  emailVerificationId?: Maybe<Scalars['String']['output']>;
  emailVerified: Scalars['Boolean']['output'];
  emailVerifiedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  ipAddress?: Maybe<Scalars['String']['output']>;
  /** @deprecated No SMS verification flow exists for proposals; this was never checked. */
  phoneVerificationCode?: Maybe<Scalars['String']['output']>;
  phoneVerified: Scalars['Boolean']['output'];
  postmarkMessageId?: Maybe<Scalars['String']['output']>;
  proposalId: Scalars['ID']['output'];
  signatureImage: Scalars['String']['output'];
  signatureImageCid?: Maybe<Scalars['String']['output']>;
  signatureImageUrl?: Maybe<Scalars['String']['output']>;
  signedAt: Scalars['DateTime']['output'];
  signedPdfSentAt?: Maybe<Scalars['DateTime']['output']>;
  signedPdfSentTo: Scalars['Boolean']['output'];
  signerEmail: Scalars['String']['output'];
  signerName: Scalars['String']['output'];
  signerPhone?: Maybe<Scalars['String']['output']>;
  signerRole?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  userAgent?: Maybe<Scalars['String']['output']>;
};

export type PProposalStatsResponse = {
  __typename?: 'PProposalStatsResponse';
  delivered: Scalars['Int']['output'];
  draft: Scalars['Int']['output'];
  sent: Scalars['Int']['output'];
  signed: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  totalValue: Scalars['Float']['output'];
  viewed: Scalars['Int']['output'];
};

/** The lifecycle status of a proposal */
export enum PProposalStatus {
  Accepted = 'ACCEPTED',
  Cancelled = 'CANCELLED',
  Declined = 'DECLINED',
  Delivered = 'DELIVERED',
  Draft = 'DRAFT',
  Expired = 'EXPIRED',
  FullySigned = 'FULLY_SIGNED',
  Sent = 'SENT',
  Signed = 'SIGNED',
  Viewed = 'VIEWED'
}

/** The type of proposal */
export enum PProposalType {
  Partnership = 'PARTNERSHIP',
  Standard = 'STANDARD'
}

export type PrHistoryItem = {
  __typename?: 'PRHistoryItem';
  branchName: Scalars['String']['output'];
  closedAt?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  merged: Scalars['Boolean']['output'];
  mergedAt?: Maybe<Scalars['String']['output']>;
  number: Scalars['Float']['output'];
  state: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
  user: Scalars['String']['output'];
};

export type PrHistoryResult = {
  __typename?: 'PRHistoryResult';
  error?: Maybe<Scalars['String']['output']>;
  prs: Array<PrHistoryItem>;
  repository?: Maybe<Scalars['String']['output']>;
  siteId: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
  total: Scalars['Float']['output'];
};

export type PrnAdministration = {
  __typename?: 'PRNAdministration';
  administeredBy: Scalars['ID']['output'];
  administeredByName: Scalars['String']['output'];
  administeredDate: Scalars['DateTime']['output'];
  administeredTime: Scalars['String']['output'];
  checkTime?: Maybe<Scalars['String']['output']>;
  checkedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  dosageGiven: Scalars['String']['output'];
  effectivenessCheck: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  indication: Scalars['String']['output'];
  linkedProgressNoteId?: Maybe<Scalars['ID']['output']>;
  medicationId: Scalars['ID']['output'];
  medicationName?: Maybe<Scalars['String']['output']>;
  outcome?: Maybe<PrnOutcome>;
  outcomeNotes?: Maybe<Scalars['String']['output']>;
  postSeverity?: Maybe<Scalars['Float']['output']>;
  requestedBy?: Maybe<Scalars['String']['output']>;
  residentId: Scalars['ID']['output'];
  scheduledCheckAt?: Maybe<Scalars['DateTime']['output']>;
  severity?: Maybe<Scalars['Float']['output']>;
  severityDescription?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  witnessedBy?: Maybe<Scalars['ID']['output']>;
  witnessedByName?: Maybe<Scalars['String']['output']>;
};

export type PrnAdministrationsResponse = {
  __typename?: 'PRNAdministrationsResponse';
  administrations: Array<PrnAdministration>;
  total: Scalars['Float']['output'];
};

export type PrnEffectivenessInput = {
  outcome: PrnOutcome;
  outcomeNotes?: InputMaybe<Scalars['String']['input']>;
  postSeverity?: InputMaybe<Scalars['Float']['input']>;
};

export type PrnFilterInput = {
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  limit?: InputMaybe<Scalars['Float']['input']>;
  medicationId?: InputMaybe<Scalars['ID']['input']>;
  offset?: InputMaybe<Scalars['Float']['input']>;
  outcome?: InputMaybe<PrnOutcome>;
  pendingFollowUp?: InputMaybe<Scalars['Boolean']['input']>;
  residentId?: InputMaybe<Scalars['ID']['input']>;
};

/** Outcome of PRN medication effectiveness */
export enum PrnOutcome {
  AdverseReaction = 'ADVERSE_REACTION',
  Effective = 'EFFECTIVE',
  NotEffective = 'NOT_EFFECTIVE',
  PartiallyEffective = 'PARTIALLY_EFFECTIVE'
}

export type PrnUsageReport = {
  __typename?: 'PRNUsageReport';
  adverseReactionCount: Scalars['Float']['output'];
  averageSeverityAfter: Scalars['Float']['output'];
  averageSeverityBefore: Scalars['Float']['output'];
  effectiveCount: Scalars['Float']['output'];
  medicationId: Scalars['ID']['output'];
  medicationName: Scalars['String']['output'];
  notEffectiveCount: Scalars['Float']['output'];
  partiallyEffectiveCount: Scalars['Float']['output'];
  residentId: Scalars['ID']['output'];
  residentName: Scalars['String']['output'];
  totalAdministrations: Scalars['Float']['output'];
};

export type PacemakerReportEntry = {
  __typename?: 'PacemakerReportEntry';
  pacemakerInsertDate?: Maybe<Scalars['DateTime']['output']>;
  pacemakerNotes?: Maybe<Scalars['String']['output']>;
  pacemakerType?: Maybe<Scalars['String']['output']>;
  residentId: Scalars['ID']['output'];
  residentName: Scalars['String']['output'];
  roomNumber?: Maybe<Scalars['String']['output']>;
  wing?: Maybe<Scalars['String']['output']>;
};

/** Type of continence pad */
export enum PadType {
  Heavy = 'HEAVY',
  Light = 'LIGHT',
  Moderate = 'MODERATE',
  None = 'NONE',
  PullUp = 'PULL_UP',
  Slip = 'SLIP'
}

export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type PageView = {
  __typename?: 'PageView';
  browser?: Maybe<Scalars['String']['output']>;
  browserVersion?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deviceType?: Maybe<Scalars['String']['output']>;
  doNotTrack: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  ipHash?: Maybe<Scalars['String']['output']>;
  os?: Maybe<Scalars['String']['output']>;
  osVersion?: Maybe<Scalars['String']['output']>;
  pagePath: Scalars['String']['output'];
  pageTitle?: Maybe<Scalars['String']['output']>;
  referrer?: Maybe<Scalars['String']['output']>;
  referrerDomain?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  screenHeight?: Maybe<Scalars['Int']['output']>;
  screenWidth?: Maybe<Scalars['Int']['output']>;
  scrollDepth?: Maybe<Scalars['Float']['output']>;
  sessionId: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  timeOnPage?: Maybe<Scalars['Int']['output']>;
  timestamp: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  userAgent?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
  utmCampaign?: Maybe<Scalars['String']['output']>;
  utmContent?: Maybe<Scalars['String']['output']>;
  utmMedium?: Maybe<Scalars['String']['output']>;
  utmSource?: Maybe<Scalars['String']['output']>;
  utmTerm?: Maybe<Scalars['String']['output']>;
  visitorId: Scalars['String']['output'];
};

export type PaginatedEmails = {
  __typename?: 'PaginatedEmails';
  currentPage: Scalars['Int']['output'];
  emails: Array<Email>;
  hasMore: Scalars['Boolean']['output'];
  matchedTerms: Array<Scalars['String']['output']>;
  searchDescription?: Maybe<Scalars['String']['output']>;
  searchMatches: Array<EmailSearchMatch>;
  totalCount: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
  unknownSearchOperators: Array<Scalars['String']['output']>;
};

export type PaginatedEmployeesResponse = {
  __typename?: 'PaginatedEmployeesResponse';
  employees: Array<Employee>;
  hasMore: Scalars['Boolean']['output'];
  page: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type PaginatedInboundEmails = {
  __typename?: 'PaginatedInboundEmails';
  conversations: Array<EmailConversation>;
  currentPage: Scalars['Int']['output'];
  emails: Array<InboundEmail>;
  groupBy: EmailListGroupBy;
  hasMore: Scalars['Boolean']['output'];
  matchedTerms: Array<Scalars['String']['output']>;
  searchDescription?: Maybe<Scalars['String']['output']>;
  searchMatches: Array<EmailSearchMatch>;
  totalCount: Scalars['Int']['output'];
  totalMessageCount: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
  unknownSearchOperators: Array<Scalars['String']['output']>;
};

export type PaginatedMicrosoftEmails = {
  __typename?: 'PaginatedMicrosoftEmails';
  currentPage: Scalars['Int']['output'];
  emails: Array<MicrosoftEmail>;
  hasMore: Scalars['Boolean']['output'];
  totalCount: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type PaginatedTranscriptions = {
  __typename?: 'PaginatedTranscriptions';
  /** True when offset + items.length < totalCount */
  hasMore: Scalars['Boolean']['output'];
  items: Array<Transcription>;
  /** Total rows matching the scope + filters (not just this page) */
  totalCount: Scalars['Int']['output'];
};

export type PaginatedVoipCalls = {
  __typename?: 'PaginatedVoipCalls';
  calls: Array<VoipCall>;
  currentPage: Scalars['Int']['output'];
  hasMore: Scalars['Boolean']['output'];
  totalCount: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

/** A scored pain-scale assessment this observation points at, and whether it is on file here */
export type PainChartAssessmentLink = {
  __typename?: 'PainChartAssessmentLink';
  assessmentDate?: Maybe<Scalars['DateTime']['output']>;
  /** The imported assessment, when it is on file here (null = not imported) */
  assessmentId?: Maybe<Scalars['ID']['output']>;
  /** ABBEY, PAINAD or VERBAL_PAIN — named by the SarahCare column that holds the link */
  kind: Scalars['String']['output'];
  /** RATING (the observation) or REVIEW (its review) */
  role: Scalars['String']['output'];
  sourceId: Scalars['String']['output'];
  sourceTable: Scalars['String']['output'];
  /** Total of that assessment as stored here */
  totalScore?: Maybe<Scalars['Int']['output']>;
};

/** One SarahCare pain-chart code and the words SarahCare's own list gives it (null when the list names none) */
export type PainChartCode = {
  __typename?: 'PainChartCode';
  code: Scalars['String']['output'];
  words?: Maybe<Scalars['String']['output']>;
};

export type PainChartFilterInput = {
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  residentId?: InputMaybe<Scalars['ID']['input']>;
  /** true = only SarahCare history; false = only records made here */
  sarahHistory?: InputMaybe<Scalars['Boolean']['input']>;
};

/** A timed intervention charted against one pain observation */
export type PainChartIntervention = {
  __typename?: 'PainChartIntervention';
  /** SarahCare user who charted it */
  addedBy?: Maybe<Scalars['String']['output']>;
  at?: Maybe<Scalars['DateTime']['output']>;
  intervention?: Maybe<Scalars['String']['output']>;
  sourceId?: Maybe<Scalars['String']['output']>;
};

export type PainChartObservation = {
  __typename?: 'PainChartObservation';
  activity: Array<PainChartCode>;
  /** SarahCare's raw AssmtTool number — no lookup exists, so it is never named */
  assessmentToolCode?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['DateTime']['output'];
  evaluation?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  interventions: Array<PainChartIntervention>;
  isHistoricalRecord?: Maybe<Scalars['Boolean']['output']>;
  linkedAssessments: Array<PainChartAssessmentLink>;
  location?: Maybe<Scalars['String']['output']>;
  nonVerbalIndicators: Array<PainChartCode>;
  /** When it was charted (UTC instant; SarahCare wall clock was Brisbane) */
  observedAt: Scalars['DateTime']['output'];
  /** SarahCare Intervention column (its painmanagement list) */
  painManagement: Array<PainChartCode>;
  /** Pain rating exactly as charted (its scale is whatever tool SarahCare used) */
  painRating: Scalars['Int']['output'];
  recordedBy: Scalars['ID']['output'];
  recordedByName?: Maybe<Scalars['String']['output']>;
  residentId: Scalars['ID']['output'];
  residentName?: Maybe<Scalars['String']['output']>;
  residentRoom?: Maybe<Scalars['String']['output']>;
  residentWing?: Maybe<Scalars['String']['output']>;
  review?: Maybe<PainChartReview>;
  /** The SarahCare user who charted it */
  sourceAuthor?: Maybe<Scalars['String']['output']>;
  sourceBackupDate?: Maybe<Scalars['DateTime']['output']>;
  /** Original SarahCare columns (provenance only) */
  sourceFields?: Maybe<Array<HistoricalAssessmentSourceField>>;
  sourceId?: Maybe<Scalars['String']['output']>;
  sourceSystem?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type PainChartObservationsResponse = {
  __typename?: 'PainChartObservationsResponse';
  limit: Scalars['Int']['output'];
  offset: Scalars['Int']['output'];
  records: Array<PainChartObservation>;
  total: Scalars['Int']['output'];
};

export type PainChartPeriod = {
  __typename?: 'PainChartPeriod';
  createdAt: Scalars['DateTime']['output'];
  /** Chart end (date-only, T00:00:00.000Z) */
  endDate: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  isHistoricalRecord?: Maybe<Scalars['Boolean']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  recordedBy: Scalars['ID']['output'];
  recordedByName?: Maybe<Scalars['String']['output']>;
  residentId: Scalars['ID']['output'];
  residentName?: Maybe<Scalars['String']['output']>;
  residentRoom?: Maybe<Scalars['String']['output']>;
  residentWing?: Maybe<Scalars['String']['output']>;
  sourceAuthor?: Maybe<Scalars['String']['output']>;
  sourceBackupDate?: Maybe<Scalars['DateTime']['output']>;
  sourceFields?: Maybe<Array<HistoricalAssessmentSourceField>>;
  sourceId?: Maybe<Scalars['String']['output']>;
  sourceSystem?: Maybe<Scalars['String']['output']>;
  /** Chart start (date-only, T00:00:00.000Z) */
  startDate: Scalars['DateTime']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type PainChartPeriodsResponse = {
  __typename?: 'PainChartPeriodsResponse';
  limit: Scalars['Int']['output'];
  offset: Scalars['Int']['output'];
  records: Array<PainChartPeriod>;
  total: Scalars['Int']['output'];
};

/** The follow-up review SarahCare recorded on a pain observation */
export type PainChartReview = {
  __typename?: 'PainChartReview';
  /** SarahCare's raw review tool number (no lookup in the backup) */
  assessmentToolCode?: Maybe<Scalars['Int']['output']>;
  comments?: Maybe<Scalars['String']['output']>;
  reviewedAt?: Maybe<Scalars['DateTime']['output']>;
  reviewedBy?: Maybe<Scalars['String']['output']>;
  /** Review score as SarahCare recorded it */
  score?: Maybe<Scalars['Int']['output']>;
};

export type PainProfile = {
  __typename?: 'PainProfile';
  hasChronicPain?: Maybe<Scalars['Boolean']['output']>;
  nonPharmacologicalStrategies?: Maybe<Array<Scalars['String']['output']>>;
  notes?: Maybe<Scalars['String']['output']>;
  painLocations?: Maybe<Array<Scalars['String']['output']>>;
  painManagementPlan?: Maybe<Scalars['String']['output']>;
};

export type PainProfileInput = {
  hasChronicPain?: InputMaybe<Scalars['Boolean']['input']>;
  nonPharmacologicalStrategies?: InputMaybe<Array<Scalars['String']['input']>>;
  notes?: InputMaybe<Scalars['String']['input']>;
  painLocations?: InputMaybe<Array<Scalars['String']['input']>>;
  painManagementPlan?: InputMaybe<Scalars['String']['input']>;
};

export type PainUpdateInput = {
  hasChronicPain?: InputMaybe<Scalars['Boolean']['input']>;
  nonPharmacologicalStrategies?: InputMaybe<Array<Scalars['String']['input']>>;
  notes?: InputMaybe<Scalars['String']['input']>;
  painLocations?: InputMaybe<Array<Scalars['String']['input']>>;
  painManagementPlan?: InputMaybe<Scalars['String']['input']>;
};

export enum ParamLocation {
  Body = 'BODY',
  Header = 'HEADER',
  Path = 'PATH',
  Query = 'QUERY'
}

export enum ParamType {
  Array = 'ARRAY',
  Boolean = 'BOOLEAN',
  Number = 'NUMBER',
  Object = 'OBJECT',
  String = 'STRING'
}

export type Parcel = {
  __typename?: 'Parcel';
  /** Parcel area in square metres */
  areaSqm: Scalars['Float']['output'];
  createdAt: Scalars['DateTime']['output'];
  /** GeoJSON Polygon — 2dsphere indexed for spatial queries */
  geometry: GeoPolygon;
  id: Scalars['ID']['output'];
  latestValuation?: Maybe<LandValuation>;
  lga: Scalars['String']['output'];
  /** Lot + plan identifier (e.g. "12 RP123456") */
  lotPlan: Scalars['String']['output'];
  pricePerSqm?: Maybe<Scalars['Float']['output']>;
  suburb: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  zoning?: Maybe<Scalars['String']['output']>;
};

export type ParcelFilterInput = {
  /** [minLng, minLat, maxLng, maxLat] */
  bbox?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** Maximum $/sqm based on latest valuation */
  maxPricePerSqm?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum parcel area in square metres */
  minAreaSqm?: InputMaybe<Scalars['Float']['input']>;
  suburb?: InputMaybe<Scalars['String']['input']>;
};

/** Whether the leave covers a full day or partial day */
export enum PartialDayType {
  AfternoonOnly = 'AFTERNOON_ONLY',
  FullDay = 'FULL_DAY',
  MorningOnly = 'MORNING_ONLY'
}

/** Role of chat participant */
export enum ParticipantRole {
  Admin = 'ADMIN',
  Member = 'MEMBER',
  Moderator = 'MODERATOR'
}

export type PartsOrder = {
  __typename?: 'PartsOrder';
  createdAt: Scalars['DateTime']['output'];
  currency: Scalars['String']['output'];
  deliveredAt?: Maybe<Scalars['DateTime']['output']>;
  discountAmount: Scalars['Float']['output'];
  discountCode?: Maybe<Scalars['String']['output']>;
  expectedDeliveryDate?: Maybe<Scalars['DateTime']['output']>;
  financialCategory?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  invoiceUrl?: Maybe<Scalars['String']['output']>;
  isDeleted: Scalars['Boolean']['output'];
  isFinancialActivity: Scalars['Boolean']['output'];
  items: Array<PartsOrderItem>;
  jobId: Scalars['ID']['output'];
  jobNumber?: Maybe<Scalars['Float']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  orderId?: Maybe<Scalars['String']['output']>;
  orderedAt?: Maybe<Scalars['DateTime']['output']>;
  receiptCid?: Maybe<Scalars['String']['output']>;
  receiptMediaType?: Maybe<Scalars['String']['output']>;
  receiptUrl?: Maybe<Scalars['String']['output']>;
  receipts?: Maybe<Array<ReceiptAttachment>>;
  shippedAt?: Maybe<Scalars['DateTime']['output']>;
  shippingCost: Scalars['Float']['output'];
  status: PartsOrderStatus;
  subtotal: Scalars['Float']['output'];
  supplierId?: Maybe<Scalars['ID']['output']>;
  supplierName?: Maybe<Scalars['String']['output']>;
  supplierOrderImageUrl?: Maybe<Scalars['String']['output']>;
  supplierOrderUrl?: Maybe<Scalars['String']['output']>;
  taxAmount: Scalars['Float']['output'];
  tenantId: Scalars['String']['output'];
  total: Scalars['Float']['output'];
  trackingNumber?: Maybe<Scalars['String']['output']>;
  trackingUrl?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type PartsOrderFilterInput = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  isFinancialActivity?: InputMaybe<Scalars['Boolean']['input']>;
  jobId?: InputMaybe<Scalars['ID']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<PartsOrderStatus>;
  supplierId?: InputMaybe<Scalars['ID']['input']>;
  supplierName?: InputMaybe<Scalars['String']['input']>;
};

export type PartsOrderItem = {
  __typename?: 'PartsOrderItem';
  partId?: Maybe<Scalars['ID']['output']>;
  partName: Scalars['String']['output'];
  quantity: Scalars['Float']['output'];
  sku?: Maybe<Scalars['String']['output']>;
  totalPrice: Scalars['Float']['output'];
  unitPrice: Scalars['Float']['output'];
};

export type PartsOrderItemInput = {
  partId?: InputMaybe<Scalars['ID']['input']>;
  partName: Scalars['String']['input'];
  quantity: Scalars['Float']['input'];
  sku?: InputMaybe<Scalars['String']['input']>;
  totalPrice: Scalars['Float']['input'];
  unitPrice: Scalars['Float']['input'];
};

/** Status of a parts order */
export enum PartsOrderStatus {
  Cancelled = 'CANCELLED',
  Delivered = 'DELIVERED',
  Ordered = 'ORDERED',
  Pending = 'PENDING',
  Shipped = 'SHIPPED'
}

export type PasskeyReadinessRow = {
  __typename?: 'PasskeyReadinessRow';
  department?: Maybe<Scalars['String']['output']>;
  employeeId: Scalars['ID']['output'];
  employeeNumber?: Maybe<Scalars['String']['output']>;
  hasLogin: Scalars['Boolean']['output'];
  hasPasskey: Scalars['Boolean']['output'];
  lastLoginAt?: Maybe<Scalars['DateTime']['output']>;
  lastLoginMethod?: Maybe<Scalars['String']['output']>;
  lastPasskeyUsedAt?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  passkeyCount: Scalars['Int']['output'];
  status?: Maybe<Scalars['String']['output']>;
};

export type Password = {
  __typename?: 'Password';
  accessLogs?: Maybe<Array<PasswordAccessLog>>;
  company?: Maybe<Company>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Client;
  dashboardUrl?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  loginUrl?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  password: Scalars['String']['output'];
  serviceName: Scalars['String']['output'];
  sharedWithEmployees: Array<Scalars['String']['output']>;
  sharedWithExternal: Array<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  twoFactorBackupCodes?: Maybe<Scalars['String']['output']>;
  twoFactorSecret?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  username?: Maybe<Scalars['String']['output']>;
};

export type PasswordAccessLog = {
  __typename?: 'PasswordAccessLog';
  accessedAt: Scalars['DateTime']['output'];
  accessedBy: Client;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  ipAddress?: Maybe<Scalars['String']['output']>;
  passwordId: Scalars['ID']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  userAgent?: Maybe<Scalars['String']['output']>;
};

export type PasswordInput = {
  company?: InputMaybe<Scalars['ID']['input']>;
  dashboardUrl?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  loginUrl?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  serviceName: Scalars['String']['input'];
  sharedWithEmployees?: InputMaybe<Array<Scalars['ID']['input']>>;
  sharedWithExternal?: InputMaybe<Array<Scalars['ID']['input']>>;
  twoFactorBackupCodes?: InputMaybe<Scalars['String']['input']>;
  twoFactorSecret?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type PasswordUpdateInput = {
  company?: InputMaybe<Scalars['ID']['input']>;
  dashboardUrl?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  loginUrl?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  serviceName?: InputMaybe<Scalars['String']['input']>;
  sharedWithEmployees?: InputMaybe<Array<Scalars['ID']['input']>>;
  sharedWithExternal?: InputMaybe<Array<Scalars['ID']['input']>>;
  twoFactorBackupCodes?: InputMaybe<Scalars['String']['input']>;
  twoFactorSecret?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

/** Whether clock records or rostered times price worked shifts */
export enum PayBasis {
  Clock = 'CLOCK',
  Roster = 'ROSTER'
}

/** Day of week (matches Date.getUTCDay() — 0=Sunday) */
export enum PayDayOfWeek {
  Friday = 'FRIDAY',
  Monday = 'MONDAY',
  Saturday = 'SATURDAY',
  Sunday = 'SUNDAY',
  Thursday = 'THURSDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY'
}

export type PayElement = {
  __typename?: 'PayElement';
  /** STP2 allowance code if category=ALLOWANCE */
  allowanceTypeCode?: Maybe<AllowanceTypeCode>;
  /** Final amount: hours × rate */
  amount: Scalars['Float']['output'];
  category: PayElementCategory;
  /** Pay element code (e.g. "01" Normal, "22" UNI/LDRY, mirrors ADP codes) */
  code: Scalars['String']['output'];
  /** STP2 deduction code if category=DEDUCTION */
  deductionTypeCode?: Maybe<DeductionTypeCode>;
  description: Scalars['String']['output'];
  /** Effective date of this rate (for rate-history audit) */
  effectiveDate?: Maybe<Scalars['DateTime']['output']>;
  /** Hours (or units for non-hourly elements like allowances) */
  hours: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  /** Multiplier applied (1.0 ordinary, 1.5 Sat, 1.75 Sun, 2.5 PH, etc.) */
  multiplier?: Maybe<Scalars['Float']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  /** Originating CheckIn._id when this element came from a specific shift */
  originatingCheckInId?: Maybe<Scalars['ID']['output']>;
  /** For shift-derived elements, the date of the originating CheckIn */
  originatingDate?: Maybe<Scalars['DateTime']['output']>;
  /** Per-hour rate (or per-unit amount for allowances) */
  rate: Scalars['Float']['output'];
  /** Free-text sub-description (e.g. "Laundry allowance — Aged Care Award cl 26.3") */
  subDescription?: Maybe<Scalars['String']['output']>;
};

/** STP2-aligned category for a PayElement line item */
export enum PayElementCategory {
  AfternoonLoading = 'AFTERNOON_LOADING',
  Allowance = 'ALLOWANCE',
  Bonus = 'BONUS',
  BrokenShift = 'BROKEN_SHIFT',
  CasualLoading = 'CASUAL_LOADING',
  Deduction = 'DEDUCTION',
  NightLoading = 'NIGHT_LOADING',
  Ordinary = 'ORDINARY',
  Overtime = 'OVERTIME',
  PaidLeaveAnnual = 'PAID_LEAVE_ANNUAL',
  PaidLeaveLsl = 'PAID_LEAVE_LSL',
  PaidLeaveOther = 'PAID_LEAVE_OTHER',
  PaidLeavePersonal = 'PAID_LEAVE_PERSONAL',
  PaidLeaveStudy = 'PAID_LEAVE_STUDY',
  PublicHoliday = 'PUBLIC_HOLIDAY',
  PublicHolidayNotWorked = 'PUBLIC_HOLIDAY_NOT_WORKED',
  SaturdayLoading = 'SATURDAY_LOADING',
  Sleepover = 'SLEEPOVER',
  SundayLoading = 'SUNDAY_LOADING',
  SuperGuarantee = 'SUPER_GUARANTEE',
  SuperSalarySacrifice = 'SUPER_SALARY_SACRIFICE',
  Weekend = 'WEEKEND'
}

/** How often the tenant runs payroll */
export enum PayFrequency {
  Fortnightly = 'FORTNIGHTLY',
  Monthly = 'MONTHLY',
  Weekly = 'WEEKLY'
}

export type PayRun = {
  __typename?: 'PayRun';
  /** ABAFile._id (M5) */
  abaFileId?: Maybe<Scalars['ID']['output']>;
  /** Client.id of the user who locked the run */
  approvedBy?: Maybe<Scalars['ID']['output']>;
  /** StpLodgementPayload._id (M6) */
  atoLodgementId?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['DateTime']['output'];
  /** Client.id of the user who created the draft */
  createdBy?: Maybe<Scalars['ID']['output']>;
  /** Number of PayRunLine rows (employees paid) */
  headcount: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  /** When run was last (re)built — newer than updatedAt means stale FE cache */
  lastBuiltAt?: Maybe<Scalars['DateTime']['output']>;
  /** Lines flagged with at least one PayRunLineErrorCode */
  linesWithErrors: Scalars['Int']['output'];
  lockedAt?: Maybe<Scalars['DateTime']['output']>;
  lodgedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Client.id of the user who lodged the run (ATO STP) */
  lodgedBy?: Maybe<Scalars['ID']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  /** When ABA was submitted to bank */
  paidAt?: Maybe<Scalars['DateTime']['output']>;
  /** Payment date, UTC midnight */
  paymentDate: Scalars['DateTime']['output'];
  /** Pay period end, UTC midnight */
  periodEnd: Scalars['DateTime']['output'];
  /** Pay period start, UTC midnight */
  periodStart: Scalars['DateTime']['output'];
  runNumber: Scalars['String']['output'];
  status: PayRunStatus;
  tenantId: Scalars['String']['output'];
  /** Sum of PayRunLine.allowancesTotal */
  totalAllowances: Scalars['Float']['output'];
  /** Sum of PayRunLine.deductionsTotal */
  totalDeductions: Scalars['Float']['output'];
  /** Sum of PayRunLine.grossGross across the run */
  totalGross: Scalars['Float']['output'];
  /** Sum of PayRunLine.netPay (gross - tax - post-tax deductions) */
  totalNet: Scalars['Float']['output'];
  /** Sum of PayRunLine.superGuarantee + superSalarySac */
  totalSuper: Scalars['Float']['output'];
  /** Sum of PayRunLine.paygWithheld */
  totalTax: Scalars['Float']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type PayRunBuildResult = {
  __typename?: 'PayRunBuildResult';
  employeesPaid: Scalars['Int']['output'];
  leaveDaysProcessed: Scalars['Int']['output'];
  linesWithErrors: Scalars['Int']['output'];
  payRun: PayRun;
  shiftsProcessed: Scalars['Int']['output'];
  totalGross: Scalars['Float']['output'];
  totalNet: Scalars['Float']['output'];
};

export type PayRunFilterInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Only runs whose periodEnd <= this */
  periodEndTo?: InputMaybe<Scalars['DateTime']['input']>;
  /** Only runs whose periodStart >= this */
  periodStartFrom?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<PayRunStatus>;
};

export type PayRunLine = {
  __typename?: 'PayRunLine';
  allowancesTotal: Scalars['Float']['output'];
  awardClassificationIdSnapshot?: Maybe<Scalars['ID']['output']>;
  awardClassificationNameSnapshot?: Maybe<Scalars['String']['output']>;
  /** Award FLOOR (compliance minimum) for this classification at build time, from AwardClassification — reference only, NOT the pay rate */
  awardFloorSnapshot?: Maybe<Scalars['Float']['output']>;
  awardLevelSnapshot?: Maybe<Scalars['Int']['output']>;
  /** Award name (Aged Care Award 2010, Nurses Award 2020, etc.) */
  awardNameSnapshot?: Maybe<Scalars['String']['output']>;
  /** Base hourly rate used by the engine for this run (audit) */
  baseHourlyRateSnapshot?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deductionsTotal: Scalars['Float']['output'];
  employeeId: Scalars['ID']['output'];
  employeeNameSnapshot: Scalars['String']['output'];
  /** Employment type snapshot: FULL_TIME / PART_TIME / CASUAL / CONTRACT / AGENCY */
  employmentTypeSnapshot?: Maybe<Scalars['String']['output']>;
  /** Free-text error / warning messages */
  errorMessages: Array<Scalars['String']['output']>;
  /** Afternoon shift loading $ */
  grossAfternoon: Scalars['Float']['output'];
  grossBonusesCommissions: Scalars['Float']['output'];
  grossDirectorsFees: Scalars['Float']['output'];
  /** Sum of all gross amounts before tax + super + deductions */
  grossGross: Scalars['Float']['output'];
  /** Laundry allowance $ (subset of allowancesTotal, surfaced for the pay pages) */
  grossLaundry: Scalars['Float']['output'];
  /** Night shift loading $ */
  grossNight: Scalars['Float']['output'];
  /** Legacy aggregate = afternoon + night loading $ */
  grossNightLoading: Scalars['Float']['output'];
  grossOrdinary: Scalars['Float']['output'];
  grossOvertime: Scalars['Float']['output'];
  grossPaidLeave: Scalars['Float']['output'];
  /** Public holiday WORKED loading $ */
  grossPublicHoliday: Scalars['Float']['output'];
  /** Public holiday NOT worked entitlement $ */
  grossPublicHolidayNotWorked: Scalars['Float']['output'];
  /** Saturday loading $ (on top of Normal) */
  grossSaturday: Scalars['Float']['output'];
  /** Sunday loading $ (on top of Normal) */
  grossSunday: Scalars['Float']['output'];
  /** Legacy aggregate = Saturday + Sunday loadings */
  grossWeekend: Scalars['Float']['output'];
  /** True if any field was manually overridden after the last engine rebuild */
  hasManualOverride: Scalars['Boolean']['output'];
  /** Afternoon shift hours (Nurses, 12:30–18:00 start) */
  hoursAfternoon: Scalars['Float']['output'];
  /** Night shift hours (Nurses, 18:00–06:00 start) */
  hoursNight: Scalars['Float']['output'];
  /** Legacy aggregate = afternoon + night hours */
  hoursNightShift: Scalars['Float']['output'];
  hoursOrdinary: Scalars['Float']['output'];
  hoursOvertime: Scalars['Float']['output'];
  /** Total paid leave hours (sum of buckets below) */
  hoursPaidLeave: Scalars['Float']['output'];
  hoursPaidLeaveAnnual: Scalars['Float']['output'];
  /** Bereavement / compassionate leave hours (BRVE) */
  hoursPaidLeaveBereavement: Scalars['Float']['output'];
  hoursPaidLeaveLsl: Scalars['Float']['output'];
  hoursPaidLeaveOther: Scalars['Float']['output'];
  hoursPaidLeavePersonal: Scalars['Float']['output'];
  /** Study / education leave hours (EDU) */
  hoursPaidLeaveStudy: Scalars['Float']['output'];
  /** Workcover hours (WKCR) */
  hoursPaidLeaveWorkersComp: Scalars['Float']['output'];
  /** Public holiday hours WORKED (×2.5) */
  hoursPublicHoliday: Scalars['Float']['output'];
  /** Public holiday hours NOT worked but paid (entitlement) */
  hoursPublicHolidayNotWorked: Scalars['Float']['output'];
  hoursSaturday: Scalars['Float']['output'];
  hoursSunday: Scalars['Float']['output'];
  /** Sum of all hours above — useful for the FE total cell */
  hoursTotal: Scalars['Float']['output'];
  /** Legacy aggregate = Saturday + Sunday hours */
  hoursWeekend: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  /** Employee income type at run time */
  incomeType: IncomeType;
  /** When this line was last (re)built by the engine */
  lastBuiltAt?: Maybe<Scalars['DateTime']['output']>;
  lineErrors: Array<PayRunLineErrorCode>;
  /** Net = grossGross + allowances - deductions - paygWithheld - superSalarySac */
  netPay: Scalars['Float']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  /** CheckIn._id values this line aggregated from */
  originatingCheckInIds: Array<Scalars['ID']['output']>;
  /** LeaveRequest._id values this line consumed */
  originatingLeaveRequestIds: Array<Scalars['ID']['output']>;
  /** Shift._id values this line was paid from under the roster-baseline model */
  originatingShiftIds: Array<Scalars['ID']['output']>;
  overriddenAt?: Maybe<Scalars['DateTime']['output']>;
  overriddenBy?: Maybe<Scalars['ID']['output']>;
  overrideReason?: Maybe<Scalars['String']['output']>;
  /** Itemised lines that drove the totals — populated by awardEngine */
  payElements: Array<PayElement>;
  payRunId: Scalars['ID']['output'];
  payRunPeriodEnd?: Maybe<Scalars['DateTime']['output']>;
  /** Cached PayRun.periodStart for fast queries by date range */
  payRunPeriodStart?: Maybe<Scalars['DateTime']['output']>;
  /** PAYG tax withheld (M1 = 0 placeholder; M3+ real calc) */
  paygWithheld: Scalars['Float']['output'];
  /** Super Guarantee = SG% × OTE (M1 = 0 placeholder) */
  superGuarantee: Scalars['Float']['output'];
  /** Salary-sacrifice into super (pre-tax) */
  superSalarySac: Scalars['Float']['output'];
  /** 6-char Tax Treatment Code for this run */
  taxTreatmentCode?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** Error / warning codes attached to a PayRunLine */
export enum PayRunLineErrorCode {
  ErrorAwardClassUnsupported = 'ERROR_AWARD_CLASS_UNSUPPORTED',
  ErrorHoursExceedRoster = 'ERROR_HOURS_EXCEED_ROSTER',
  ErrorMissingAward = 'ERROR_MISSING_AWARD',
  ErrorMissingCheckin = 'ERROR_MISSING_CHECKIN',
  ErrorMissingCheckout = 'ERROR_MISSING_CHECKOUT',
  ErrorMissingRate = 'ERROR_MISSING_RATE',
  ErrorMissingRoleRate = 'ERROR_MISSING_ROLE_RATE',
  ErrorNegativeHours = 'ERROR_NEGATIVE_HOURS',
  ErrorUnreasonableHours = 'ERROR_UNREASONABLE_HOURS',
  WarningDualRate = 'WARNING_DUAL_RATE',
  WarningRoleRateFallback = 'WARNING_ROLE_RATE_FALLBACK'
}

export type PayRunLineFilterInput = {
  employeeId?: InputMaybe<Scalars['ID']['input']>;
  hasErrorsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  payRunId?: InputMaybe<Scalars['ID']['input']>;
};

/** State machine for a fortnightly pay run */
export enum PayRunStatus {
  Draft = 'DRAFT',
  Locked = 'LOCKED',
  Lodged = 'LODGED',
  Paid = 'PAID',
  Reversed = 'REVERSED'
}

export type PaySettings = {
  __typename?: 'PaySettings';
  /** Anthropic model for the AI Pay Auditor (claude-opus-4-7 for accuracy, claude-sonnet-4-6 for 5× cheaper). Defaults to opus when null. */
  aiAuditModel?: Maybe<Scalars['String']['output']>;
  /** Variance % above which the AI Auditor flags a line for Tom investigation (default 0.5 = 0.5%) */
  aiAuditTolerancePct: Scalars['Float']['output'];
  /** ATO Software ID (per Access Manager registration) */
  atoSoftwareId?: Maybe<Scalars['String']['output']>;
  /** BMS ID (Business Management Software ID) — STP2 reporting party */
  bmsId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  /** Default SG rate when EmployeePayProfile.superContributionPct is missing (12.0% from 1 July 2025) */
  defaultSuperContributionPct: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  /** Laundry allowance paid per worked hour to every (non-salaried) employee, e.g. 0.16 = $0.16/h. Set 0 to disable. Not OTE (no super). */
  laundryAllowancePerHour: Scalars['Float']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  /** What prices a worked shift: CLOCK (check-ins override roster — legacy default) or ROSTER (rostered times always price; clocks are attendance-only). PLCC = ROSTER. */
  payBasis: PayBasis;
  payrollCalendar: PayrollCalendar;
  /** When true, the lodge mutation actually submits to ATO. Default false until M6 wire-up. */
  stpLodgementEnabled: Scalars['Boolean']['output'];
  /** STP2 lodgement provider: SPHERE, PAYROO, DIRECT_AS4, or null */
  stpProvider?: Maybe<Scalars['String']['output']>;
  /** Default super clearing-house provider (CLICKSUPER, NAB, OTHER) */
  superClearingHouse?: Maybe<Scalars['String']['output']>;
  /** Tenant ABN for ABA file + STP reports */
  tenantAbn?: Maybe<Scalars['String']['output']>;
  /** Bank account name for ABA descriptive record */
  tenantBankAccountName?: Maybe<Scalars['String']['output']>;
  /** Bank account number for ABA file */
  tenantBankAccountNumber?: Maybe<Scalars['String']['output']>;
  /** Bank BSB for ABA file */
  tenantBankBsb?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type PaymentEvent = {
  __typename?: 'PaymentEvent';
  amount: Scalars['Float']['output'];
  confirmedAt?: Maybe<Scalars['DateTime']['output']>;
  confirmedBy?: Maybe<Scalars['String']['output']>;
  details?: Maybe<Scalars['String']['output']>;
  method: PaymentProvider;
  paidAt: Scalars['DateTime']['output'];
  reference?: Maybe<Scalars['String']['output']>;
  screenshotUrl?: Maybe<Scalars['String']['output']>;
  status: BillPaymentStatus;
  stripeDashboardUrl?: Maybe<Scalars['String']['output']>;
};

export type PaymentMethod = {
  __typename?: 'PaymentMethod';
  billingEmail?: Maybe<Scalars['String']['output']>;
  cardDetails?: Maybe<CardDetails>;
  client: Client;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isDefault: Scalars['Boolean']['output'];
  lastUsedAt?: Maybe<Scalars['DateTime']['output']>;
  status: PaymentMethodStatus;
  stripeCustomerId: Scalars['String']['output'];
  stripePaymentMethodId: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  type: PaymentMethodType;
  updatedAt: Scalars['DateTime']['output'];
};

export type PaymentMethodInput = {
  billingEmail?: InputMaybe<Scalars['String']['input']>;
  cardDetails?: InputMaybe<CardDetailsInput>;
  clientId: Scalars['ID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
  stripePaymentMethodId: Scalars['String']['input'];
  type: PaymentMethodType;
};

export enum PaymentMethodStatus {
  Active = 'ACTIVE',
  Expired = 'EXPIRED',
  Inactive = 'INACTIVE',
  RequiresConfirmation = 'REQUIRES_CONFIRMATION'
}

export enum PaymentMethodType {
  BankAccount = 'BANK_ACCOUNT',
  Card = 'CARD',
  Other = 'OTHER',
  Paypal = 'PAYPAL'
}

/** The provider/method used for payment */
export enum PaymentProvider {
  AudTransfer = 'AUD_TRANSFER',
  BankTransfer = 'BANK_TRANSFER',
  BbToken = 'BB_TOKEN',
  Cash = 'CASH',
  Crypto = 'CRYPTO',
  Other = 'OTHER',
  Stripe = 'STRIPE'
}

export type PaymentReceivingDetails = {
  __typename?: 'PaymentReceivingDetails';
  acceptTokenPayment?: Maybe<Scalars['Boolean']['output']>;
  acceptedMethods: Array<PaymentReceivingMethod>;
  bankAccount?: Maybe<BankAccountDetails>;
  bankAccounts?: Maybe<Array<BankAccountDetails>>;
  cryptoDiscountPercentage?: Maybe<Scalars['Float']['output']>;
  cryptoWallets?: Maybe<Array<CryptoWalletDetails>>;
  defaultBankAccountId?: Maybe<Scalars['String']['output']>;
  isVerified?: Maybe<Scalars['Boolean']['output']>;
  paypalEmail?: Maybe<Scalars['String']['output']>;
  stripeConnect?: Maybe<StripeConnectDetails>;
};

export type PaymentReceivingDetailsInput = {
  acceptTokenPayment?: InputMaybe<Scalars['Boolean']['input']>;
  acceptedMethods: Array<PaymentReceivingMethod>;
  bankAccount?: InputMaybe<BankAccountDetailsInput>;
  bankAccounts?: InputMaybe<Array<BankAccountDetailsInput>>;
  cryptoDiscountPercentage?: InputMaybe<Scalars['Float']['input']>;
  cryptoWallets?: InputMaybe<Array<CryptoWalletDetailsInput>>;
  defaultBankAccountId?: InputMaybe<Scalars['String']['input']>;
  isVerified?: InputMaybe<Scalars['Boolean']['input']>;
  paypalEmail?: InputMaybe<Scalars['String']['input']>;
  stripeConnect?: InputMaybe<StripeConnectDetailsInput>;
};

/** Methods through which a client can receive payments */
export enum PaymentReceivingMethod {
  BankTransfer = 'BANK_TRANSFER',
  Crypto = 'CRYPTO',
  Paypal = 'PAYPAL',
  Stripe = 'STRIPE'
}

export type PaymentScheduleItem = {
  __typename?: 'PaymentScheduleItem';
  amount: Scalars['Float']['output'];
  description: Scalars['String']['output'];
  dueDate: Scalars['DateTime']['output'];
  memberSplits?: Maybe<Array<MemberSplit>>;
  notes?: Maybe<Scalars['String']['output']>;
  paidDate?: Maybe<Scalars['DateTime']['output']>;
  paymentStatus?: Maybe<OpportunityPaymentStatus>;
  receivedDate?: Maybe<Scalars['DateTime']['output']>;
  status: PaymentScheduleStatus;
};

export type PaymentScheduleItemInput = {
  amount: Scalars['Float']['input'];
  description: Scalars['String']['input'];
  dueDate: Scalars['DateTime']['input'];
  memberSplits?: InputMaybe<Array<MemberSplitInput>>;
  notes?: InputMaybe<Scalars['String']['input']>;
  paidDate?: InputMaybe<Scalars['DateTime']['input']>;
  paymentStatus?: InputMaybe<OpportunityPaymentStatus>;
  status?: InputMaybe<PaymentScheduleStatus>;
};

/** Status of scheduled payment */
export enum PaymentScheduleStatus {
  Cancelled = 'CANCELLED',
  Overdue = 'OVERDUE',
  Paid = 'PAID',
  Pending = 'PENDING'
}

/** How the employee is paid — ADP Employee Detail Form "Payment Type". Added 2026-08-21; previously only inferable from hourlyRate vs annualSalary. */
export enum PaymentType {
  Hourly = 'HOURLY',
  Salary = 'SALARY'
}

/** Status of individual member payout */
export enum PayoutStatus {
  Cancelled = 'CANCELLED',
  Failed = 'FAILED',
  Paid = 'PAID',
  Pending = 'PENDING',
  Processing = 'PROCESSING',
  Scheduled = 'SCHEDULED'
}

/** Pay cycle anchor + payment date offset */
export type PayrollCalendar = {
  __typename?: 'PayrollCalendar';
  /** UTC midnight — canonical anchor for cycle math */
  fortnightAnchorStartDate: Scalars['DateTime']['output'];
  payFrequency: PayFrequency;
  paymentDateOffsetDays: Scalars['Int']['output'];
  /** Tenant timezone (IANA) — display + audit only, storage is UTC */
  timezone?: Maybe<Scalars['String']['output']>;
};

export type PayrollCalendarInput = {
  fortnightAnchorStartDate: Scalars['DateTime']['input'];
  payFrequency?: InputMaybe<PayFrequency>;
  paymentDateOffsetDays?: InputMaybe<Scalars['Int']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type PayrollCostForecast = {
  __typename?: 'PayrollCostForecast';
  anchor: Scalars['String']['output'];
  assumptions: Array<Scalars['String']['output']>;
  fortnights: Array<PayrollForecastFortnight>;
  /** ROSTER or CLOCK — what prices a shift on this site */
  payBasis: Scalars['String']['output'];
};

/** A payroll enquiry: one staff member's question about their pay, and the replies */
export type PayrollEnquiry = {
  __typename?: 'PayrollEnquiry';
  category: PayrollEnquiryCategory;
  createdAt: Scalars['DateTime']['output'];
  /** Their Employee record on this site, when they have one */
  employeeId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** When anyone last wrote or changed the status */
  lastActivityAt: Scalars['DateTime']['output'];
  /** Oldest first — the question, then each reply */
  messages: Array<PayrollEnquiryMessage>;
  /** Per site, from 1 — shown as PE-12 */
  number: Scalars['Int']['output'];
  /** Which pay it's about, in the staff member's words (e.g. 'pay on 16 Oct') */
  payPeriod?: Maybe<Scalars['String']['output']>;
  resolvedAt?: Maybe<Scalars['DateTime']['output']>;
  resolvedByName?: Maybe<Scalars['String']['output']>;
  status: PayrollEnquiryStatus;
  /** A short line saying what it's about */
  subject: Scalars['String']['output'];
  /** The Client id of the staff member who raised it — they see it, nobody else on staff does */
  submittedByClientId: Scalars['String']['output'];
  submittedByName: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** What a payroll enquiry is about */
export enum PayrollEnquiryCategory {
  Adjustment = 'ADJUSTMENT',
  Leave = 'LEAVE',
  MissingHours = 'MISSING_HOURS',
  Other = 'OTHER',
  Overtime = 'OVERTIME',
  PayslipOrBank = 'PAYSLIP_OR_BANK',
  PayRate = 'PAY_RATE',
  SickLeave = 'SICK_LEAVE',
  TaxOrSuper = 'TAX_OR_SUPER'
}

/** Counts for the enquiries page header */
export type PayrollEnquiryCounts = {
  __typename?: 'PayrollEnquiryCounts';
  inProgress: Scalars['Int']['output'];
  new: Scalars['Int']['output'];
  resolved: Scalars['Int']['output'];
  waitingOnStaff: Scalars['Int']['output'];
};

/** A live change to payroll enquiries — kind and id only, never content */
export type PayrollEnquiryEvent = {
  __typename?: 'PayrollEnquiryEvent';
  at: Scalars['DateTime']['output'];
  /** Who made the change — a page ignores its own echo */
  byClientId?: Maybe<Scalars['ID']['output']>;
  enquiryId?: Maybe<Scalars['ID']['output']>;
  /** CREATED | REPLIED | STATUS_CHANGED | SETTINGS_CHANGED */
  kind: Scalars['String']['output'];
};

/** One message in a payroll enquiry — the question, or a reply */
export type PayrollEnquiryMessage = {
  __typename?: 'PayrollEnquiryMessage';
  /** The Client id of whoever wrote it */
  authorClientId: Scalars['String']['output'];
  authorName: Scalars['String']['output'];
  body: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  /** True = written by payroll; false = by the staff member */
  fromPayroll: Scalars['Boolean']['output'];
  messageId: Scalars['ID']['output'];
};

/** One notification sent (or not) after a payroll enquiry write */
export type PayrollEnquiryNotifyOutcome = {
  __typename?: 'PayrollEnquiryNotifyOutcome';
  /** IN_APP | EMAIL | SMS */
  channel: Scalars['String']['output'];
  detail?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
  who: Scalars['String']['output'];
};

/** A person told when a payroll enquiry comes in, and how */
export type PayrollEnquiryRecipient = {
  __typename?: 'PayrollEnquiryRecipient';
  clientId: Scalars['ID']['output'];
  email: Scalars['Boolean']['output'];
  /** The bell in the app */
  inApp: Scalars['Boolean']['output'];
  /** Name at the time it was saved (the page re-reads current names) */
  name: Scalars['String']['output'];
  sms: Scalars['Boolean']['output'];
};

/** Someone who can be picked to be told about payroll enquiries */
export type PayrollEnquiryRecipientCandidate = {
  __typename?: 'PayrollEnquiryRecipientCandidate';
  clientId: Scalars['ID']['output'];
  /** Has an email address we can use */
  hasEmail: Scalars['Boolean']['output'];
  /** Has a mobile number we can text */
  hasMobile: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export type PayrollEnquiryRecipientInput = {
  clientId: Scalars['ID']['input'];
  email: Scalars['Boolean']['input'];
  inApp: Scalars['Boolean']['input'];
  sms: Scalars['Boolean']['input'];
};

/** Who is told when a payroll enquiry comes in — one row per site */
export type PayrollEnquirySettings = {
  __typename?: 'PayrollEnquirySettings';
  createdAt: Scalars['DateTime']['output'];
  /** Shared inboxes also emailed (e.g. the accounts team's address) */
  extraEmails: Array<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Also tell them when the staff member replies (not only when a new enquiry arrives) */
  notifyOnStaffReply: Scalars['Boolean']['output'];
  recipients: Array<PayrollEnquiryRecipient>;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedByName?: Maybe<Scalars['String']['output']>;
};

/** Where a payroll enquiry is up to */
export enum PayrollEnquiryStatus {
  InProgress = 'IN_PROGRESS',
  New = 'NEW',
  Resolved = 'RESOLVED',
  WaitingOnStaff = 'WAITING_ON_STAFF'
}

/** The enquiry after a write, and exactly who was told */
export type PayrollEnquiryWriteResult = {
  __typename?: 'PayrollEnquiryWriteResult';
  enquiry: PayrollEnquiry;
  notified: Array<PayrollEnquiryNotifyOutcome>;
  /** The same, in one plain sentence (empty when nobody was due to be told) */
  notifiedSummary: Scalars['String']['output'];
};

/** One pay fortnight priced from the roster as it stands — the pay engine, dry run (nothing written) */
export type PayrollForecastFortnight = {
  __typename?: 'PayrollForecastFortnight';
  allowances: Scalars['Float']['output'];
  /** Shifts in the period still in draft (not published) — priced like the rest */
  draftShifts: Scalars['Int']['output'];
  /** Gross + super guarantee */
  employerCost: Scalars['Float']['output'];
  gross: Scalars['Float']['output'];
  headcount: Scalars['Int']['output'];
  hoursOrdinary: Scalars['Float']['output'];
  hoursOvertime: Scalars['Float']['output'];
  hoursPaidLeave: Scalars['Float']['output'];
  isCurrent: Scalars['Boolean']['output'];
  /** Employees whose line the engine flagged (missing rate, role rate fallback…) */
  linesWithErrors: Scalars['Int']['output'];
  openSlotHours: Scalars['Float']['output'];
  /** Slots no one covers yet (required − covering staff) — NOT priced */
  openSlots: Scalars['Int']['output'];
  ordinary: Scalars['Float']['output'];
  overtime: Scalars['Float']['output'];
  paidLeave: Scalars['Float']['output'];
  paygWithheld: Scalars['Float']['output'];
  paymentDate: Scalars['String']['output'];
  /** Weekend + public holiday + afternoon / night / casual loadings */
  penalties: Scalars['Float']['output'];
  periodEnd: Scalars['String']['output'];
  periodStart: Scalars['String']['output'];
  shiftsPriced: Scalars['Int']['output'];
  superGuarantee: Scalars['Float']['output'];
};

export type PayslipDeliveryResult = {
  __typename?: 'PayslipDeliveryResult';
  /** Failed (Postmark errored, IPFS errored, etc.) */
  failed: Scalars['Int']['output'];
  /** Successfully emailed */
  sent: Scalars['Int']['output'];
  /** Skipped (no email address on file) */
  skipped: Scalars['Int']['output'];
  warnings: Array<Scalars['String']['output']>;
};

export type PenaltyRateRule = {
  __typename?: 'PenaltyRateRule';
  /** Additional flat-rate hourly amount (some awards add $ + %) */
  additionalRate?: Maybe<Scalars['Float']['output']>;
  /** Award name this rule belongs to, e.g. "Aged Care Award 2010" */
  awardName: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  /** For WEEKEND / NIGHT / AFTERNOON rules — day this applies to (0=Sun, 6=Sat) */
  dayOfWeek?: Maybe<PayDayOfWeek>;
  /** Rule effective from this date — UTC midnight */
  effectiveFromDate?: Maybe<Scalars['DateTime']['output']>;
  /** Rule effective until this date (inclusive) — UTC midnight */
  effectiveToDate?: Maybe<Scalars['DateTime']['output']>;
  /** Restrict to employment types: FULL_TIME, PART_TIME, CASUAL, CONTRACT, AGENCY */
  employmentTypes?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  /** Multiplier applied to base rate (1.5 = 50% loading) */
  multiplier: Scalars['Float']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  ruleType: PenaltyRateRuleType;
  tenantId: Scalars['String']['output'];
  /** Time-window end, minutes after midnight */
  timeEndMinutes?: Maybe<Scalars['Int']['output']>;
  /** Time-window start, minutes after midnight (e.g. 22*60 = 1320 for 22:00) */
  timeStartMinutes?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

/** Type of penalty / loading rule in PenaltyRateRule */
export enum PenaltyRateRuleType {
  AfternoonShift = 'AFTERNOON_SHIFT',
  BrokenShift = 'BROKEN_SHIFT',
  CasualLoading = 'CASUAL_LOADING',
  NightShift = 'NIGHT_SHIFT',
  Overtime = 'OVERTIME',
  PublicHoliday = 'PUBLIC_HOLIDAY',
  Saturday = 'SATURDAY',
  Sleepover = 'SLEEPOVER',
  Sunday = 'SUNDAY',
  Weekend = 'WEEKEND'
}

export type PendingShiftPickup = {
  __typename?: 'PendingShiftPickup';
  departmentId?: Maybe<Scalars['String']['output']>;
  employeeId: Scalars['ID']['output'];
  employeeName?: Maybe<Scalars['String']['output']>;
  endTime: Scalars['DateTime']['output'];
  fortnightHoursAfter: Scalars['Float']['output'];
  fortnightHoursBefore: Scalars['Float']['output'];
  locationNames?: Maybe<Array<Scalars['String']['output']>>;
  requestedAt?: Maybe<Scalars['DateTime']['output']>;
  restGapHours?: Maybe<Scalars['Float']['output']>;
  restGapWarning: Scalars['Boolean']['output'];
  shiftHours: Scalars['Float']['output'];
  shiftId: Scalars['ID']['output'];
  shiftTitle: Scalars['String']['output'];
  shiftType?: Maybe<Scalars['String']['output']>;
  startTime: Scalars['DateTime']['output'];
  weekHoursAfter: Scalars['Float']['output'];
  weekHoursBefore: Scalars['Float']['output'];
};

export type PensionDetails = {
  __typename?: 'PensionDetails';
  expiryDate?: Maybe<Scalars['DateTime']['output']>;
  /** Has Pensioner Health Benefit Card */
  healthBenefitCard?: Maybe<Scalars['Boolean']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  status?: Maybe<PensionerStatus>;
  type?: Maybe<PensionType>;
};

export type PensionDetailsInput = {
  expiryDate?: InputMaybe<Scalars['DateTime']['input']>;
  healthBenefitCard?: InputMaybe<Scalars['Boolean']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<PensionerStatus>;
  type?: InputMaybe<PensionType>;
};

/** Type of pension the resident receives */
export enum PensionType {
  Age = 'AGE',
  Carer = 'CARER',
  Disability = 'DISABILITY',
  Dva = 'DVA',
  None = 'NONE',
  Other = 'OTHER',
  WarWidow = 'WAR_WIDOW'
}

/** Pensioner status for government funding */
export enum PensionerStatus {
  Full = 'FULL',
  None = 'NONE',
  Part = 'PART'
}

/** Audit entry for a single permission */
export type PermissionAuditEntry = {
  __typename?: 'PermissionAuditEntry';
  /** system | umbrella | module | field-level | role */
  category: Scalars['String']['output'];
  description: Scalars['String']['output'];
  /** True only for module-category permissions not in any permissions.ts. System/umbrella/role permissions are never orphaned. */
  isOrphan: Scalars['Boolean']['output'];
  moduleCount: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  usedInModules: Array<PermissionModuleUsage>;
};

/** Which module a permission appears in, and at what levels */
export type PermissionModuleUsage = {
  __typename?: 'PermissionModuleUsage';
  levels: Array<Scalars['String']['output']>;
  moduleId: Scalars['String']['output'];
};

/** Complete permissions audit result */
export type PermissionsAuditResult = {
  __typename?: 'PermissionsAuditResult';
  modules: Array<ModuleAuditEntry>;
  orphanCount: Scalars['Int']['output'];
  permissions: Array<PermissionAuditEntry>;
  totalModules: Scalars['Int']['output'];
  totalPermissions: Scalars['Int']['output'];
};

export type PersonEnrichment = {
  __typename?: 'PersonEnrichment';
  affiliation?: Maybe<Scalars['String']['output']>;
  baseId: Scalars['ID']['output'];
  birthYear?: Maybe<Scalars['Int']['output']>;
  checkedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deathYear?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  lifeStatus: LifeStatus;
  manual: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  note?: Maybe<Scalars['String']['output']>;
  oneLiner?: Maybe<Scalars['String']['output']>;
  personSlug: Scalars['String']['output'];
  sourceTitle?: Maybe<Scalars['String']['output']>;
  sourceUrl?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type PersonEvent = {
  __typename?: 'PersonEvent';
  autoClassified: Scalars['Boolean']['output'];
  classification: EventClassification;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  eventDate: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  impact: ImpactLevel;
  location?: Maybe<GeoPoint>;
  personId: Scalars['String']['output'];
  source?: Maybe<Scalars['String']['output']>;
  sourceType: NewsSourceType;
  tenantId: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type PersonEventFiltersInput = {
  classification?: InputMaybe<EventClassification>;
  from?: InputMaybe<Scalars['DateTime']['input']>;
  impact?: InputMaybe<ImpactLevel>;
  personId?: InputMaybe<Scalars['String']['input']>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PersonEventPreviewGql = {
  __typename?: 'PersonEventPreviewGql';
  classification: Scalars['String']['output'];
  description: Scalars['String']['output'];
  eventDate: Scalars['String']['output'];
  impact: Scalars['String']['output'];
  isDuplicate: Scalars['Boolean']['output'];
  latitude?: Maybe<Scalars['Float']['output']>;
  locationState?: Maybe<Scalars['String']['output']>;
  locationSuburb?: Maybe<Scalars['String']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  sourceType: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type PersonOfInterest = {
  __typename?: 'PersonOfInterest';
  country: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  entityType: EntityOfInterestType;
  id: Scalars['ID']['output'];
  initials?: Maybe<Scalars['String']['output']>;
  isActive: Scalars['Boolean']['output'];
  keyPositions: Array<Scalars['String']['output']>;
  linkedLocationIds: Array<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  organisation: Scalars['String']['output'];
  photoUrl?: Maybe<Scalars['String']['output']>;
  primaryLocation?: Maybe<GeoPoint>;
  relevance?: Maybe<Scalars['String']['output']>;
  role: Scalars['String']['output'];
  tags: Array<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type PersonOfInterestFiltersInput = {
  country?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<EntityOfInterestType>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type PersonalCare = {
  __typename?: 'PersonalCare';
  bathingAssistance?: Maybe<CareLevel>;
  bathingFrequency?: Maybe<BathingFrequency>;
  bathingPreferences?: Maybe<Scalars['String']['output']>;
  continenceAids?: Maybe<Array<ContinenceAidType>>;
  continenceNotes?: Maybe<Scalars['String']['output']>;
  continenceType?: Maybe<ContinenceType>;
  dentureDetails?: Maybe<Scalars['String']['output']>;
  dressingAssistance?: Maybe<CareLevel>;
  dressingPreferences?: Maybe<Scalars['String']['output']>;
  groomingAssistance?: Maybe<CareLevel>;
  groomingPreferences?: Maybe<Scalars['String']['output']>;
  hasDentures?: Maybe<Scalars['Boolean']['output']>;
  oralCareAssistance?: Maybe<CareLevel>;
  preferredBathTime?: Maybe<Scalars['String']['output']>;
  prefersBath?: Maybe<Scalars['Boolean']['output']>;
  prefersShower?: Maybe<Scalars['Boolean']['output']>;
  toiletingSchedule?: Maybe<Scalars['String']['output']>;
};

export type PersonalCareInput = {
  bathingAssistance?: InputMaybe<CareLevel>;
  bathingFrequency?: InputMaybe<BathingFrequency>;
  bathingPreferences?: InputMaybe<Scalars['String']['input']>;
  continenceAids?: InputMaybe<Array<ContinenceAidType>>;
  continenceNotes?: InputMaybe<Scalars['String']['input']>;
  continenceType?: InputMaybe<ContinenceType>;
  dentureDetails?: InputMaybe<Scalars['String']['input']>;
  dressingAssistance?: InputMaybe<CareLevel>;
  dressingPreferences?: InputMaybe<Scalars['String']['input']>;
  groomingAssistance?: InputMaybe<CareLevel>;
  groomingPreferences?: InputMaybe<Scalars['String']['input']>;
  hasDentures?: InputMaybe<Scalars['Boolean']['input']>;
  oralCareAssistance?: InputMaybe<CareLevel>;
  preferredBathTime?: InputMaybe<Scalars['String']['input']>;
  prefersBath?: InputMaybe<Scalars['Boolean']['input']>;
  prefersShower?: InputMaybe<Scalars['Boolean']['input']>;
  toiletingSchedule?: InputMaybe<Scalars['String']['input']>;
};

export type PersonalCareUpdateInput = {
  bathingAssistance?: InputMaybe<Scalars['String']['input']>;
  bathingFrequency?: InputMaybe<Scalars['String']['input']>;
  bathingPreferences?: InputMaybe<Scalars['String']['input']>;
  bathingTime?: InputMaybe<Scalars['String']['input']>;
  continenceAids?: InputMaybe<Array<Scalars['String']['input']>>;
  continenceType?: InputMaybe<Scalars['String']['input']>;
  denturesCare?: InputMaybe<Scalars['String']['input']>;
  dressingAssistance?: InputMaybe<Scalars['String']['input']>;
  dressingPreferences?: InputMaybe<Scalars['String']['input']>;
  groomingAssistance?: InputMaybe<Scalars['String']['input']>;
  hasDentures?: InputMaybe<Scalars['Boolean']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  oralCareAssistance?: InputMaybe<Scalars['String']['input']>;
  toiletingSchedule?: InputMaybe<Scalars['String']['input']>;
};

export type PersonalizationOption = {
  __typename?: 'PersonalizationOption';
  contentVariant?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  label: Scalars['String']['output'];
};

export type PersonalizationOptionInput = {
  contentVariant?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  label: Scalars['String']['input'];
};

/** The capabilities of the phone number */
export enum PhoneCapability {
  Fax = 'FAX',
  Mms = 'MMS',
  Sms = 'SMS',
  Voice = 'VOICE'
}

export type PhoneLine = {
  __typename?: 'PhoneLine';
  associatedClients: Array<Scalars['String']['output']>;
  autoTranscribe: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  deviceMac?: Maybe<Scalars['String']['output']>;
  deviceSerial?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  lastRecordingAt?: Maybe<Scalars['DateTime']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  provider: PhoneProvider;
  providerLineId: Scalars['String']['output'];
  recordingExpected: Scalars['Boolean']['output'];
  status: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type PhoneLineInput = {
  associatedClients?: InputMaybe<Array<Scalars['ID']['input']>>;
  autoTranscribe?: InputMaybe<Scalars['Boolean']['input']>;
  deviceMac?: InputMaybe<Scalars['String']['input']>;
  deviceSerial?: InputMaybe<Scalars['String']['input']>;
  label: Scalars['String']['input'];
  location?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  provider?: InputMaybe<Scalars['String']['input']>;
  providerLineId: Scalars['String']['input'];
  recordingExpected?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The status of the phone number */
export enum PhoneNumberStatus {
  Active = 'ACTIVE',
  Failed = 'FAILED',
  Inactive = 'INACTIVE',
  Pending = 'PENDING'
}

/** The phone provider that carried the call */
export enum PhoneProvider {
  Crazytel = 'CRAZYTEL',
  Twilio = 'TWILIO'
}

export type PickupDecision = {
  __typename?: 'PickupDecision';
  action: Scalars['String']['output'];
  comment?: Maybe<Scalars['String']['output']>;
  decidedAt?: Maybe<Scalars['DateTime']['output']>;
  decidedBy?: Maybe<Scalars['String']['output']>;
  employeeId?: Maybe<Scalars['String']['output']>;
  employeeName?: Maybe<Scalars['String']['output']>;
  shiftId: Scalars['ID']['output'];
  shiftTitle: Scalars['String']['output'];
  startTime: Scalars['DateTime']['output'];
};

export type PickupDecisionEmailPreview = {
  __typename?: 'PickupDecisionEmailPreview';
  employeeId: Scalars['ID']['output'];
  employeeName?: Maybe<Scalars['String']['output']>;
  html: Scalars['String']['output'];
  kind: Scalars['String']['output'];
  subject: Scalars['String']['output'];
};

export type PickupRejectionGuidance = {
  __typename?: 'PickupRejectionGuidance';
  paragraphs: Array<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type PipedriveCandidateItem = {
  __typename?: 'PipedriveCandidateItem';
  dealId: Scalars['String']['output'];
  dealUrl: Scalars['String']['output'];
  onBoard?: Maybe<Scalars['Boolean']['output']>;
  ownerName?: Maybe<Scalars['String']['output']>;
  personId?: Maybe<Scalars['String']['output']>;
  personName?: Maybe<Scalars['String']['output']>;
  stageName?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  value?: Maybe<Scalars['Float']['output']>;
};

export type PipedriveCheck = {
  __typename?: 'PipedriveCheck';
  checkedAt: Scalars['DateTime']['output'];
  detail: Scalars['String']['output'];
  looseReason?: Maybe<Scalars['String']['output']>;
  matchPoints?: Maybe<Array<PipedriveMatchPoint>>;
  pipedriveDealId?: Maybe<Scalars['String']['output']>;
  pipedriveStage?: Maybe<Scalars['String']['output']>;
  pipedriveTitle?: Maybe<Scalars['String']['output']>;
  strongMatch?: Maybe<Scalars['Boolean']['output']>;
  verdict: Scalars['String']['output'];
};

export type PipedriveCheckBatch = {
  __typename?: 'PipedriveCheckBatch';
  checked: Scalars['Int']['output'];
  refused: Scalars['Int']['output'];
  remaining: Scalars['Int']['output'];
};

export type PipedriveConflictItem = {
  __typename?: 'PipedriveConflictItem';
  field: Scalars['String']['output'];
  label: Scalars['String']['output'];
  ours: Scalars['String']['output'];
  pipedrive: Scalars['String']['output'];
};

export type PipedriveDifference = {
  __typename?: 'PipedriveDifference';
  field: Scalars['String']['output'];
  label: Scalars['String']['output'];
  ours?: Maybe<Scalars['String']['output']>;
  pipedrive: Scalars['String']['output'];
};

export type PipedriveImportReport = {
  __typename?: 'PipedriveImportReport';
  dryRun: Scalars['Boolean']['output'];
  open: Scalars['Int']['output'];
  rows: Array<PipedrivePlaceRow>;
  scanned: Scalars['Int']['output'];
  won: Scalars['Int']['output'];
};

export type PipedriveMatchPoint = {
  __typename?: 'PipedriveMatchPoint';
  field: Scalars['String']['output'];
  verdict: Scalars['String']['output'];
  words: Scalars['String']['output'];
};

export type PipedrivePanel = {
  __typename?: 'PipedrivePanel';
  candidates: Array<PipedriveCandidateItem>;
  configured: Scalars['Boolean']['output'];
  dealUrl?: Maybe<Scalars['String']['output']>;
  entryStageName: Scalars['String']['output'];
  linked: Scalars['Boolean']['output'];
  message?: Maybe<Scalars['String']['output']>;
  personUrl?: Maybe<Scalars['String']['output']>;
  pipelineName: Scalars['String']['output'];
};

export type PipedrivePlaceRow = {
  __typename?: 'PipedrivePlaceRow';
  dealNumber?: Maybe<Scalars['String']['output']>;
  dealUrl?: Maybe<Scalars['String']['output']>;
  detail: Scalars['String']['output'];
  outcome: Scalars['String']['output'];
  personName?: Maybe<Scalars['String']['output']>;
  pipedriveDealId: Scalars['String']['output'];
  stageName?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type PipedrivePullResult = {
  __typename?: 'PipedrivePullResult';
  changed: Array<Scalars['String']['output']>;
  conflicts: Array<PipedriveConflictItem>;
  message: Scalars['String']['output'];
  problems: Array<Scalars['String']['output']>;
  pulled: Scalars['Boolean']['output'];
};

export type PipedriveReadyLinkResult = {
  __typename?: 'PipedriveReadyLinkResult';
  dealId: Scalars['ID']['output'];
  dealNumber?: Maybe<Scalars['String']['output']>;
  linked: Scalars['Boolean']['output'];
  problem?: Maybe<Scalars['String']['output']>;
};

export type PipedriveReasonCount = {
  __typename?: 'PipedriveReasonCount';
  count: Scalars['Int']['output'];
  verdict: Scalars['String']['output'];
};

export type PipedriveSyncSummary = {
  __typename?: 'PipedriveSyncSummary';
  connected: Scalars['Boolean']['output'];
  createDeals?: Maybe<Scalars['Boolean']['output']>;
  createDealsChangedAt?: Maybe<Scalars['DateTime']['output']>;
  createDealsChangedBy?: Maybe<Scalars['String']['output']>;
  domain?: Maybe<Scalars['String']['output']>;
  lastPulledAt?: Maybe<Scalars['String']['output']>;
  linked: Scalars['Int']['output'];
  liveDeals: Scalars['Int']['output'];
  needsLook: Scalars['Int']['output'];
  notLinked: Scalars['Int']['output'];
  reasons: Array<PipedriveReasonCount>;
  reasonsCheckedSince?: Maybe<Scalars['DateTime']['output']>;
};

export type PipelineMetrics = {
  __typename?: 'PipelineMetrics';
  averageDealSize: Scalars['Float']['output'];
  averageSalesCycle: Scalars['Float']['output'];
  conversionRate: Scalars['Float']['output'];
  expectedRevenue: Scalars['Float']['output'];
  healthScore: Scalars['Float']['output'];
  monthlyTrend: Array<MonthlyTrend>;
  stageMetrics: Array<StageMetric>;
  suggestedActions: Array<SuggestedAction>;
  totalOpportunities: Scalars['Int']['output'];
  totalValue: Scalars['Float']['output'];
};

export type PipelineStageRow = {
  __typename?: 'PipelineStageRow';
  count: Scalars['Int']['output'];
  stage: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};

export type PlaceEmployeeAsSiblingInput = {
  /** Employee whose sibling position the moved employee will be placed relative to. The moved employee adopts this anchor's parent. */
  anchorEmployeeId: Scalars['ID']['input'];
  /** Employee being moved on the chart. */
  employeeId: Scalars['ID']['input'];
  /** Drop BEFORE (to the left of) the anchor, or AFTER (to the right of) the anchor. */
  position: OrgChartSiblingPosition;
};

export type Pledge = {
  __typename?: 'Pledge';
  campaignId: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  giftReason?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  invoiceBillId?: Maybe<Scalars['ID']['output']>;
  ipAddress?: Maybe<Scalars['String']['output']>;
  leadId: Scalars['ID']['output'];
  notificationPreference: PledgeNotificationPreference;
  quantity: Scalars['Int']['output'];
  referralCode: Scalars['String']['output'];
  referredByPledgeId?: Maybe<Scalars['ID']['output']>;
  status: PledgeStatus;
  tenantId: Scalars['String']['output'];
  tokenName?: Maybe<Scalars['String']['output']>;
  tokensAwarded?: Maybe<Scalars['Float']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  userAgent?: Maybe<Scalars['String']['output']>;
};

export type PledgeCampaign = {
  __typename?: 'PledgeCampaign';
  coverImageUrl?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  currentUnlockedTierIndex?: Maybe<Scalars['Int']['output']>;
  deadlineAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  heroHeadline?: Maybe<Scalars['String']['output']>;
  heroSubhead?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isReferralEnabled: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  productName: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  status: PledgeCampaignStatus;
  tenantId: Scalars['String']['output'];
  tiers: Array<PledgeCampaignTier>;
  updatedAt: Scalars['DateTime']['output'];
};

export type PledgeCampaignProgress = {
  __typename?: 'PledgeCampaignProgress';
  currentPledgeCount: Scalars['Int']['output'];
  currentTierIndex?: Maybe<Scalars['Int']['output']>;
  nextTierGap?: Maybe<Scalars['Int']['output']>;
  nextTierThreshold?: Maybe<Scalars['Int']['output']>;
  recentPledgerFirstNames: Array<Scalars['String']['output']>;
};

/** Lifecycle state of a pledge campaign */
export enum PledgeCampaignStatus {
  Active = 'ACTIVE',
  Closed = 'CLOSED',
  Draft = 'DRAFT',
  Unlocked = 'UNLOCKED'
}

export type PledgeCampaignTier = {
  __typename?: 'PledgeCampaignTier';
  label: Scalars['String']['output'];
  minQuantity: Scalars['Int']['output'];
  pricePerUnit: Scalars['Float']['output'];
  shippingCost?: Maybe<Scalars['Float']['output']>;
};

export type PledgeCampaignTierInput = {
  label: Scalars['String']['input'];
  minQuantity: Scalars['Int']['input'];
  pricePerUnit: Scalars['Float']['input'];
  shippingCost?: InputMaybe<Scalars['Float']['input']>;
};

/** How often the pledger wants updates */
export enum PledgeNotificationPreference {
  All = 'ALL',
  MilestonesOnly = 'MILESTONES_ONLY',
  Off = 'OFF'
}

/** Lifecycle state of a single pledge */
export enum PledgeStatus {
  Cancelled = 'CANCELLED',
  Invoiced = 'INVOICED',
  Paid = 'PAID',
  Soft = 'SOFT'
}

export type PledgeWithLead = {
  __typename?: 'PledgeWithLead';
  campaignId: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  giftReason?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  invoiceBillId?: Maybe<Scalars['ID']['output']>;
  leadEmail: Scalars['String']['output'];
  leadFirstName: Scalars['String']['output'];
  leadId: Scalars['ID']['output'];
  leadLastName?: Maybe<Scalars['String']['output']>;
  leadPhone?: Maybe<Scalars['String']['output']>;
  notificationPreference: PledgeNotificationPreference;
  quantity: Scalars['Int']['output'];
  referralCode: Scalars['String']['output'];
  referredByPledgeId?: Maybe<Scalars['ID']['output']>;
  status: PledgeStatus;
};

export type PoliceCheckAssessmentInput = {
  disclosedConvictions: Scalars['Boolean']['input'];
  outcome: PoliceCheckOutcome;
  precluded: Scalars['Boolean']['input'];
  /** Reason recorded on the candidate when the assessment rejects them */
  reason?: InputMaybe<Scalars['String']['input']>;
  requiresFurtherAssessment: Scalars['Boolean']['input'];
};

export enum PoliceCheckOutcome {
  Accepted = 'ACCEPTED',
  NotAssessed = 'NOT_ASSESSED',
  Rejected = 'REJECTED'
}

export type Policy = {
  __typename?: 'Policy';
  applicableRoles: Array<Scalars['String']['output']>;
  approvedBy?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  chatKeywords?: Maybe<Array<Scalars['String']['output']>>;
  chatSummary?: Maybe<Scalars['String']['output']>;
  chatSummaryVersion?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdById?: Maybe<Scalars['String']['output']>;
  createdByName?: Maybe<Scalars['String']['output']>;
  currentVersion: Scalars['Int']['output'];
  docId: Scalars['String']['output'];
  draftMarkdown?: Maybe<Scalars['String']['output']>;
  draftUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  draftUpdatedById?: Maybe<Scalars['String']['output']>;
  draftUpdatedByName?: Maybe<Scalars['String']['output']>;
  hasDraft: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  importedFrom?: Maybe<Scalars['String']['output']>;
  issueDate?: Maybe<Scalars['DateTime']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  publishedMarkdown?: Maybe<Scalars['String']['output']>;
  regulatoryReference?: Maybe<Scalars['String']['output']>;
  reviewDate?: Maybe<Scalars['DateTime']['output']>;
  status: PolicyStatus;
  statusNote?: Maybe<Scalars['String']['output']>;
  subtitle?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type PolicyAcknowledgement = {
  __typename?: 'PolicyAcknowledgement';
  acknowledgedAt: Scalars['DateTime']['output'];
  clientId: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  employeeId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  policyId: Scalars['ID']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  versionNumber: Scalars['Int']['output'];
};

export type PolicyAcknowledgementReport = {
  __typename?: 'PolicyAcknowledgementReport';
  acknowledgedCount: Scalars['Int']['output'];
  currentVersion: Scalars['Int']['output'];
  outstandingCount: Scalars['Int']['output'];
  policyId: Scalars['ID']['output'];
  rows: Array<PolicyAcknowledgementRow>;
  totalCount: Scalars['Int']['output'];
};

export type PolicyAcknowledgementRow = {
  __typename?: 'PolicyAcknowledgementRow';
  acknowledgedAt?: Maybe<Scalars['DateTime']['output']>;
  acknowledgedVersion?: Maybe<Scalars['Int']['output']>;
  clientId?: Maybe<Scalars['ID']['output']>;
  current: Scalars['Boolean']['output'];
  employeeId: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  primaryRole?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type PolicyActivity = {
  __typename?: 'PolicyActivity';
  activityType: Scalars['String']['output'];
  actorClientId?: Maybe<Scalars['String']['output']>;
  actorEmployeeId?: Maybe<Scalars['String']['output']>;
  actorName?: Maybe<Scalars['String']['output']>;
  changes: Array<PolicyFieldChange>;
  createdAt: Scalars['DateTime']['output'];
  details?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  notificationId?: Maybe<Scalars['ID']['output']>;
  policyDocId?: Maybe<Scalars['String']['output']>;
  policyId?: Maybe<Scalars['ID']['output']>;
  policyTitle?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  versionNumber?: Maybe<Scalars['Int']['output']>;
};

export type PolicyAssignablePerson = {
  __typename?: 'PolicyAssignablePerson';
  clientId: Scalars['ID']['output'];
  employeeId: Scalars['ID']['output'];
  fName?: Maybe<Scalars['String']['output']>;
  lName?: Maybe<Scalars['String']['output']>;
  preferredName?: Maybe<Scalars['String']['output']>;
  primaryRole?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type PolicyBroadcastAudience = {
  __typename?: 'PolicyBroadcastAudience';
  recipients: Array<PolicyBroadcastRecipient>;
  sendableCount: Scalars['Int']['output'];
  skippedCount: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
};

export type PolicyBroadcastPreview = {
  __typename?: 'PolicyBroadcastPreview';
  bodyMarkdown: Scalars['String']['output'];
  html: Scalars['String']['output'];
  subject: Scalars['String']['output'];
  text: Scalars['String']['output'];
  versionNumber: Scalars['Int']['output'];
};

export type PolicyBroadcastPreviewInput = {
  extraNote?: InputMaybe<Scalars['String']['input']>;
  policyId: Scalars['ID']['input'];
  versionNumber?: InputMaybe<Scalars['Int']['input']>;
};

export type PolicyBroadcastRecipient = {
  __typename?: 'PolicyBroadcastRecipient';
  clientId?: Maybe<Scalars['ID']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  employeeId: Scalars['ID']['output'];
  hasEmail: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  primaryRole?: Maybe<Scalars['String']['output']>;
  source: PolicyEmailSource;
  status?: Maybe<Scalars['String']['output']>;
};

export type PolicyChangedSection = {
  __typename?: 'PolicyChangedSection';
  added: Scalars['Int']['output'];
  heading: Scalars['String']['output'];
  headingSlug?: Maybe<Scalars['String']['output']>;
  removed: Scalars['Int']['output'];
};

export type PolicyChatIndexStats = {
  __typename?: 'PolicyChatIndexStats';
  indexTokens: Scalars['Int']['output'];
  policies: Scalars['Int']['output'];
  sections: Scalars['Int']['output'];
  summaries: Scalars['Int']['output'];
};

export type PolicyChatModel = {
  __typename?: 'PolicyChatModel';
  id: Scalars['String']['output'];
  isDefault: Scalars['Boolean']['output'];
};

export type PolicyDiffHunk = {
  __typename?: 'PolicyDiffHunk';
  fromCount: Scalars['Int']['output'];
  fromStart: Scalars['Int']['output'];
  lines: Array<PolicyDiffLine>;
  toCount: Scalars['Int']['output'];
  toStart: Scalars['Int']['output'];
};

export type PolicyDiffLine = {
  __typename?: 'PolicyDiffLine';
  fromLine?: Maybe<Scalars['Int']['output']>;
  kind: PolicyDiffLineKind;
  text: Scalars['String']['output'];
  toLine?: Maybe<Scalars['Int']['output']>;
};

export enum PolicyDiffLineKind {
  Added = 'ADDED',
  Context = 'CONTEXT',
  Removed = 'REMOVED'
}

export type PolicyDiffResult = {
  __typename?: 'PolicyDiffResult';
  added: Scalars['Int']['output'];
  changedSections: Array<PolicyChangedSection>;
  fromVersion: Scalars['Int']['output'];
  hunks: Array<PolicyDiffHunk>;
  identical: Scalars['Boolean']['output'];
  removed: Scalars['Int']['output'];
  summaryMarkdown: Scalars['String']['output'];
  toVersion: Scalars['Int']['output'];
};

export type PolicyEditor = {
  __typename?: 'PolicyEditor';
  active: Scalars['Boolean']['output'];
  clientId: Scalars['ID']['output'];
  employeeId?: Maybe<Scalars['ID']['output']>;
  name: Scalars['String']['output'];
  primaryRole?: Maybe<Scalars['String']['output']>;
};

export enum PolicyEmailSource {
  None = 'NONE',
  Personal = 'PERSONAL',
  Work = 'WORK'
}

export type PolicyFieldChange = {
  __typename?: 'PolicyFieldChange';
  field: Scalars['String']['output'];
  from?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  to?: Maybe<Scalars['String']['output']>;
};

export type PolicyFilterInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<PolicyStatus>;
};

export type PolicyImportResult = {
  __typename?: 'PolicyImportResult';
  docId: Scalars['String']['output'];
  policyId: Scalars['ID']['output'];
  published: Scalars['Boolean']['output'];
  title: Scalars['String']['output'];
  warnings: Array<Scalars['String']['output']>;
};

export type PolicyMetadataInput = {
  applicableRoles?: InputMaybe<Array<Scalars['String']['input']>>;
  approvedBy?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  docId?: InputMaybe<Scalars['String']['input']>;
  issueDate?: InputMaybe<Scalars['String']['input']>;
  regulatoryReference?: InputMaybe<Scalars['String']['input']>;
  reviewDate?: InputMaybe<Scalars['String']['input']>;
  statusNote?: InputMaybe<Scalars['String']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type PolicyMetadataSnapshot = {
  __typename?: 'PolicyMetadataSnapshot';
  applicableRoles: Array<Scalars['String']['output']>;
  approvedBy?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  docId: Scalars['String']['output'];
  issueDate?: Maybe<Scalars['DateTime']['output']>;
  regulatoryReference?: Maybe<Scalars['String']['output']>;
  reviewDate?: Maybe<Scalars['DateTime']['output']>;
  statusNote?: Maybe<Scalars['String']['output']>;
  subtitle?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type PolicyMyAccess = {
  __typename?: 'PolicyMyAccess';
  canAdmin: Scalars['Boolean']['output'];
  canEdit: Scalars['Boolean']['output'];
  clientId?: Maybe<Scalars['ID']['output']>;
  employeeId?: Maybe<Scalars['ID']['output']>;
};

export type PolicyNotification = {
  __typename?: 'PolicyNotification';
  bodyMarkdown: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  failedCount: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  policyId: Scalars['ID']['output'];
  recipients: Array<PolicyNotificationRecipient>;
  sentAt: Scalars['DateTime']['output'];
  sentById?: Maybe<Scalars['String']['output']>;
  sentByName?: Maybe<Scalars['String']['output']>;
  sentCount: Scalars['Int']['output'];
  skippedCount: Scalars['Int']['output'];
  subject: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  versionNumber: Scalars['Int']['output'];
};

export type PolicyNotificationRecipient = {
  __typename?: 'PolicyNotificationRecipient';
  clientId?: Maybe<Scalars['ID']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  employeeId: Scalars['ID']['output'];
  error?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  source: PolicyEmailSource;
  status: PolicyRecipientStatus;
};

export enum PolicyRecipientStatus {
  Failed = 'FAILED',
  Sent = 'SENT',
  SkippedNoEmail = 'SKIPPED_NO_EMAIL'
}

export type PolicySearchHit = {
  __typename?: 'PolicySearchHit';
  category?: Maybe<Scalars['String']['output']>;
  docId: Scalars['String']['output'];
  heading?: Maybe<Scalars['String']['output']>;
  headingSlug?: Maybe<Scalars['String']['output']>;
  lineEnd: Scalars['Int']['output'];
  lineStart: Scalars['Int']['output'];
  policyId: Scalars['ID']['output'];
  score: Scalars['Float']['output'];
  snippet: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type PolicySettings = {
  __typename?: 'PolicySettings';
  chatEnabled: Scalars['Boolean']['output'];
  chatIndexBuiltAt?: Maybe<Scalars['DateTime']['output']>;
  chatIndexStats?: Maybe<PolicyChatIndexStats>;
  chatModel?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  docIdPrefix: Scalars['String']['output'];
  editorClientIds: Array<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  notifyByDefault: Scalars['Boolean']['output'];
  requireChangeNote: Scalars['Boolean']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** Lifecycle of a policy document */
export enum PolicyStatus {
  Archived = 'ARCHIVED',
  Draft = 'DRAFT',
  Published = 'PUBLISHED'
}

export type PolicyVersion = {
  __typename?: 'PolicyVersion';
  changeNote?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  markdown: Scalars['String']['output'];
  metadata: PolicyMetadataSnapshot;
  notificationId?: Maybe<Scalars['ID']['output']>;
  policyId: Scalars['ID']['output'];
  publishedAt: Scalars['DateTime']['output'];
  publishedById?: Maybe<Scalars['String']['output']>;
  publishedByName?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  version: Scalars['Int']['output'];
};

export type PollOption = {
  __typename?: 'PollOption';
  count: Scalars['Int']['output'];
  label: Scalars['String']['output'];
};

export type PollOptionInput = {
  count?: InputMaybe<Scalars['Int']['input']>;
  label: Scalars['String']['input'];
};

export type PostBuildUpdateInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  dealId: Scalars['ID']['input'];
  moveDealStage?: InputMaybe<Scalars['Boolean']['input']>;
  photos?: InputMaybe<Array<BuildUpdateFileInput>>;
  report?: InputMaybe<BuildUpdateFileInput>;
  sendEmail?: InputMaybe<Scalars['Boolean']['input']>;
  sendSms?: InputMaybe<Scalars['Boolean']['input']>;
  stageKey?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export type PostBuildUpdateResult = {
  __typename?: 'PostBuildUpdateResult';
  outcomes: Array<BuildNotifyOutcome>;
  summary: Scalars['String']['output'];
  update: BuildUpdateView;
};

export type PotentialDuplicateGroup = {
  __typename?: 'PotentialDuplicateGroup';
  clients: Array<ClientWithEmployee>;
  count: Scalars['Float']['output'];
  groupId: Scalars['String']['output'];
  matchValue: Scalars['String']['output'];
  reason: DuplicateReason;
};

export type PowerOfAttorneyDetails = {
  __typename?: 'PowerOfAttorneyDetails';
  /** POA document date */
  documentDate?: Maybe<Scalars['DateTime']['output']>;
  /** Reference to POA document in medical records */
  documentId?: Maybe<Scalars['ID']['output']>;
  /** Expiry date if applicable */
  expiryDate?: Maybe<Scalars['DateTime']['output']>;
  isEnduring: Scalars['Boolean']['output'];
  isFinancialPOA: Scalars['Boolean']['output'];
  isMedicalPOA: Scalars['Boolean']['output'];
  types?: Maybe<Array<PowerOfAttorneyType>>;
};

export type PowerOfAttorneyDetailsInput = {
  documentDate?: InputMaybe<Scalars['DateTime']['input']>;
  documentId?: InputMaybe<Scalars['ID']['input']>;
  expiryDate?: InputMaybe<Scalars['DateTime']['input']>;
  isEnduring?: InputMaybe<Scalars['Boolean']['input']>;
  isFinancialPOA?: InputMaybe<Scalars['Boolean']['input']>;
  isMedicalPOA?: InputMaybe<Scalars['Boolean']['input']>;
  types?: InputMaybe<Array<PowerOfAttorneyType>>;
};

/** Type of Power of Attorney */
export enum PowerOfAttorneyType {
  Enduring = 'ENDURING',
  Financial = 'FINANCIAL',
  General = 'GENERAL',
  Medical = 'MEDICAL'
}

export type PracticalCompletionChecklist = {
  __typename?: 'PracticalCompletionChecklist';
  binsDelivered?: Maybe<Scalars['Boolean']['output']>;
  buildClean?: Maybe<Scalars['Boolean']['output']>;
  inspectionBookedDate?: Maybe<Scalars['String']['output']>;
  inspector?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  occupancyCertificate?: Maybe<Scalars['Boolean']['output']>;
  onboarded?: Maybe<Scalars['Boolean']['output']>;
  photosReceived?: Maybe<Scalars['Boolean']['output']>;
  propertyManager?: Maybe<Scalars['String']['output']>;
  supplier?: Maybe<Scalars['String']['output']>;
  taxDepreciationOrdered?: Maybe<Scalars['Boolean']['output']>;
};

export type PracticalCompletionInput = {
  binsDelivered?: InputMaybe<Scalars['Boolean']['input']>;
  buildClean?: InputMaybe<Scalars['Boolean']['input']>;
  inspectionBookedDate?: InputMaybe<Scalars['String']['input']>;
  inspector?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  occupancyCertificate?: InputMaybe<Scalars['Boolean']['input']>;
  onboarded?: InputMaybe<Scalars['Boolean']['input']>;
  photosReceived?: InputMaybe<Scalars['Boolean']['input']>;
  propertyManager?: InputMaybe<Scalars['String']['input']>;
  supplier?: InputMaybe<Scalars['String']['input']>;
  taxDepreciationOrdered?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum PreScreenOutcome {
  Fail = 'FAIL',
  Pass = 'PASS'
}

export type PreScreenQuestion = {
  __typename?: 'PreScreenQuestion';
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  order?: Maybe<Scalars['Float']['output']>;
  type: PreScreenQuestionType;
};

export type PreScreenQuestionInput = {
  key: Scalars['String']['input'];
  label: Scalars['String']['input'];
  order?: InputMaybe<Scalars['Float']['input']>;
  type: PreScreenQuestionType;
};

export enum PreScreenQuestionType {
  Text = 'TEXT',
  YesNo = 'YES_NO'
}

export type PressureCareProfile = {
  __typename?: 'PressureCareProfile';
  equipmentInUse?: Maybe<Array<Scalars['String']['output']>>;
  notes?: Maybe<Scalars['String']['output']>;
  pressureAreas?: Maybe<Array<Scalars['String']['output']>>;
  repositioningFrequency?: Maybe<Scalars['String']['output']>;
  riskLevel?: Maybe<Scalars['String']['output']>;
};

export type PressureCareProfileInput = {
  equipmentInUse?: InputMaybe<Array<Scalars['String']['input']>>;
  notes?: InputMaybe<Scalars['String']['input']>;
  pressureAreas?: InputMaybe<Array<Scalars['String']['input']>>;
  repositioningFrequency?: InputMaybe<Scalars['String']['input']>;
  riskLevel?: InputMaybe<Scalars['String']['input']>;
};

export type PressureCareUpdateInput = {
  equipmentInUse?: InputMaybe<Array<Scalars['String']['input']>>;
  notes?: InputMaybe<Scalars['String']['input']>;
  pressureAreas?: InputMaybe<Array<Scalars['String']['input']>>;
  repositioningFrequency?: InputMaybe<Scalars['String']['input']>;
  riskLevel?: InputMaybe<Scalars['String']['input']>;
};

/** Pressure injury staging */
export enum PressureInjuryStage {
  DeepTissue = 'DEEP_TISSUE',
  NotApplicable = 'NOT_APPLICABLE',
  Stage_1 = 'STAGE_1',
  Stage_2 = 'STAGE_2',
  Stage_3 = 'STAGE_3',
  Stage_4 = 'STAGE_4',
  Unstageable = 'UNSTAGEABLE'
}

export type PrettyUpEventCopyInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  eventKind: Scalars['String']['input'];
  instruction?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export type ProRataPreview = {
  __typename?: 'ProRataPreview';
  dailyRate: Scalars['Float']['output'];
  daysInMonth: Scalars['Float']['output'];
  endDate: Scalars['DateTime']['output'];
  planAmount: Scalars['Float']['output'];
  planName: Scalars['String']['output'];
  proRataDays: Scalars['Float']['output'];
  startDate: Scalars['DateTime']['output'];
  subtotal: Scalars['Float']['output'];
  taxAmount: Scalars['Float']['output'];
  taxPercentage: Scalars['Float']['output'];
  totalAmount: Scalars['Float']['output'];
};

/** Type of daily care profile - Extended or Short */
export enum ProfileType {
  Extended = 'EXTENDED',
  Short = 'SHORT'
}

export type ProgramActivity = {
  __typename?: 'ProgramActivity';
  activityDate: Scalars['DateTime']['output'];
  activityType: Scalars['String']['output'];
  attachments: Array<ProgramActivityAttachment>;
  createdAt: Scalars['DateTime']['output'];
  createdById?: Maybe<Scalars['String']['output']>;
  createdByName: Scalars['String']['output'];
  details?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isDeleted: Scalars['Boolean']['output'];
  isPrivate: Scalars['Boolean']['output'];
  memberId: Scalars['ID']['output'];
  referenceId?: Maybe<Scalars['String']['output']>;
  referenceType?: Maybe<Scalars['String']['output']>;
  tags: Array<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type ProgramActivityAttachment = {
  __typename?: 'ProgramActivityAttachment';
  cid?: Maybe<Scalars['String']['output']>;
  fileName: Scalars['String']['output'];
  fileSize: Scalars['Float']['output'];
  mimeType?: Maybe<Scalars['String']['output']>;
  uploadedAt: Scalars['DateTime']['output'];
  url: Scalars['String']['output'];
};

export type ProgramActivityAttachmentInput = {
  cid?: InputMaybe<Scalars['String']['input']>;
  fileName: Scalars['String']['input'];
  fileSize: Scalars['Float']['input'];
  mimeType?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type ProgramApplication = {
  __typename?: 'ProgramApplication';
  billId?: Maybe<Scalars['String']['output']>;
  businessDescription: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  financialCapacityAnswer: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  memberId: Scalars['ID']['output'];
  proofOfAssetsCids: Array<Scalars['String']['output']>;
  submittedAt?: Maybe<Scalars['DateTime']['output']>;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  willingnessScore: Scalars['Int']['output'];
};

export type ProgramCalendarOption = {
  __typename?: 'ProgramCalendarOption';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type ProgramCallNote = {
  __typename?: 'ProgramCallNote';
  calendarEventId?: Maybe<Scalars['String']['output']>;
  callNumber: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  meetJoinUrl?: Maybe<Scalars['String']['output']>;
  meetSessionId?: Maybe<Scalars['String']['output']>;
  memberId: Scalars['ID']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  outcome?: Maybe<Scalars['String']['output']>;
  scheduledFor?: Maybe<Scalars['DateTime']['output']>;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** Default outreach channel for Program invites/chases */
export enum ProgramChannel {
  Both = 'BOTH',
  Email = 'EMAIL',
  Sms = 'SMS'
}

export type ProgramCommission = {
  __typename?: 'ProgramCommission';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  introducerContactId: Scalars['ID']['output'];
  level: Scalars['Int']['output'];
  ongoingPct: Scalars['Float']['output'];
  paidAt?: Maybe<Scalars['DateTime']['output']>;
  programMemberId: Scalars['ID']['output'];
  saleAmountCents: Scalars['Int']['output'];
  status: ProgramCommissionStatus;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  upfrontPct: Scalars['Float']['output'];
};

/** Whether a commission row has actually been paid out */
export enum ProgramCommissionStatus {
  Paid = 'PAID',
  Pending = 'PENDING'
}

export type ProgramConfig = {
  __typename?: 'ProgramConfig';
  applicationPackPriceCents: Scalars['Int']['output'];
  callSlaHours: Scalars['Int']['output'];
  chaseWindowDays: Scalars['Int']['output'];
  chatEmbedEnabled: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  defaultChannel: ProgramChannel;
  displayName: Scalars['String']['output'];
  fromEmail?: Maybe<Scalars['String']['output']>;
  guaranteesMarkdown?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  leadFlowStageIds?: Maybe<Array<Scalars['String']['output']>>;
  logoCid?: Maybe<Scalars['String']['output']>;
  sharedCalendarId?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  tenantOwnerWowPageContent?: Maybe<Scalars['String']['output']>;
  termsUrl?: Maybe<Scalars['String']['output']>;
  tiers: Array<ProgramTier>;
  tomWowPageContent?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type ProgramMember = {
  __typename?: 'ProgramMember';
  callSlaDeadline?: Maybe<Scalars['DateTime']['output']>;
  clientId?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['DateTime']['output'];
  currentStage: ProgramMemberStage;
  downpaymentBillId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isOverdueForCall: Scalars['Boolean']['output'];
  leadId: Scalars['ID']['output'];
  linkTokenExpiresAt: Scalars['DateTime']['output'];
  pProposalId?: Maybe<Scalars['String']['output']>;
  selectedTierId?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type ProgramMemberAuthResult = {
  __typename?: 'ProgramMemberAuthResult';
  hadExistingAccount: Scalars['Boolean']['output'];
  message: Scalars['String']['output'];
  requiresLogin: Scalars['Boolean']['output'];
  success: Scalars['Boolean']['output'];
  token?: Maybe<Scalars['String']['output']>;
};

export type ProgramMemberFacingConfig = {
  __typename?: 'ProgramMemberFacingConfig';
  applicationPackPriceCents: Scalars['Int']['output'];
  displayName: Scalars['String']['output'];
  guaranteesMarkdown?: Maybe<Scalars['String']['output']>;
  tenantOwnerWowPageContent?: Maybe<Scalars['String']['output']>;
  termsUrl?: Maybe<Scalars['String']['output']>;
  tiers: Array<ProgramTier>;
  tomWowPageContent?: Maybe<Scalars['String']['output']>;
};

/** Where a Program member sits in the invite -> onboarded -> mentor-track funnel */
export enum ProgramMemberStage {
  ApplicationPaid = 'APPLICATION_PAID',
  Call1Done = 'CALL1_DONE',
  Call1Scheduled = 'CALL1_SCHEDULED',
  Call2Done = 'CALL2_DONE',
  Call2Scheduled = 'CALL2_SCHEDULED',
  DownpaymentPaid = 'DOWNPAYMENT_PAID',
  Invited = 'INVITED',
  MentorTrack = 'MENTOR_TRACK',
  OfferSent = 'OFFER_SENT',
  Onboarded = 'ONBOARDED',
  QualifyingSubmitted = 'QUALIFYING_SUBMITTED',
  VisionViewed = 'VISION_VIEWED',
  WowViewed = 'WOW_VIEWED'
}

export type ProgramReminderEmailPreview = {
  __typename?: 'ProgramReminderEmailPreview';
  html: Scalars['String']['output'];
  subject: Scalars['String']['output'];
};

/** Which per-stage nudge email to preview/send for a Program member — see TheProgramMemberDetails.tsx's next-action button. */
export enum ProgramReminderType {
  ApplicationPackReminder = 'APPLICATION_PACK_REMINDER',
  QualifyingReminder = 'QUALIFYING_REMINDER',
  ResendInvite = 'RESEND_INVITE',
  WowPageLink = 'WOW_PAGE_LINK'
}

export type ProgramSignedAgreement = {
  __typename?: 'ProgramSignedAgreement';
  createdAt: Scalars['DateTime']['output'];
  /** Declaration/terms wording shown to the signer, verbatim. */
  declarationText: Scalars['String']['output'];
  /** SHA-256 over pricingSnapshot + declarationText — proves what was signed. */
  formPayloadHash: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  ipAddress?: Maybe<Scalars['String']['output']>;
  memberId: Scalars['ID']['output'];
  pricingSnapshot: Scalars['String']['output'];
  signatureImage: Scalars['String']['output'];
  signatureImageCid?: Maybe<Scalars['String']['output']>;
  signedAt: Scalars['DateTime']['output'];
  signedPdfCid?: Maybe<Scalars['String']['output']>;
  /** Gateway URL of the signed PDF, rebuilt from the CID against the current tenant gateway. */
  signedPdfUrl?: Maybe<Scalars['String']['output']>;
  signerName: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  tierId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  userAgent?: Maybe<Scalars['String']['output']>;
};

export type ProgramTier = {
  __typename?: 'ProgramTier';
  consultingDayRateCents?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  exitRung?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  includesExport: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  priceCents: Scalars['Int']['output'];
  splitPercentWithTenantOwner?: Maybe<Scalars['Int']['output']>;
};

export type ProgramTierInput = {
  consultingDayRateCents?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  exitRung?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  includesExport?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  priceCents: Scalars['Int']['input'];
  splitPercentWithTenantOwner?: InputMaybe<Scalars['Int']['input']>;
};

export type ProgressNote = {
  __typename?: 'ProgressNote';
  content: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['ID']['output'];
  createdByName?: Maybe<Scalars['String']['output']>;
  exceptionEndDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  includeInException: Scalars['Boolean']['output'];
  isSignedOff: Scalars['Boolean']['output'];
  noteDate: Scalars['DateTime']['output'];
  noteTime?: Maybe<Scalars['String']['output']>;
  relatedAssessmentId?: Maybe<Scalars['ID']['output']>;
  relatedCarePlanCategories: Array<ProgressNoteCategory>;
  relatedDoctorVisitId?: Maybe<Scalars['ID']['output']>;
  relatedIncidentId?: Maybe<Scalars['ID']['output']>;
  repeatExceptionDays: Scalars['Int']['output'];
  residentId: Scalars['ID']['output'];
  residentName?: Maybe<Scalars['String']['output']>;
  residentRoom?: Maybe<Scalars['String']['output']>;
  residentWing?: Maybe<Scalars['String']['output']>;
  signedOffAt?: Maybe<Scalars['DateTime']['output']>;
  signedOffBy?: Maybe<Scalars['ID']['output']>;
  signedOffByName?: Maybe<Scalars['String']['output']>;
  sourceAuthor?: Maybe<Scalars['String']['output']>;
  sourceBackupDate?: Maybe<Scalars['DateTime']['output']>;
  sourceFields?: Maybe<SarahProgressNoteSourceFields>;
  sourceFieldsBackupDate?: Maybe<Scalars['DateTime']['output']>;
  sourceFieldsImportedAt?: Maybe<Scalars['DateTime']['output']>;
  sourceHash?: Maybe<Scalars['String']['output']>;
  sourceId?: Maybe<Scalars['String']['output']>;
  sourceModule: NoteSourceModule;
  sourceSystem?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type ProgressNoteAlertsResponse = {
  __typename?: 'ProgressNoteAlertsResponse';
  overdueDays: Scalars['Int']['output'];
  residentsWithOverdueNotes: Array<OverdueNoteAlert>;
};

export type ProgressNoteAttachment = {
  __typename?: 'ProgressNoteAttachment';
  description?: Maybe<Scalars['String']['output']>;
  ipfsCid?: Maybe<Scalars['String']['output']>;
  mimeType?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

export type ProgressNoteAttachmentInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  ipfsCid?: InputMaybe<Scalars['String']['input']>;
  mimeType?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/** Progress note care plan link categories (SARAH standard - 24 categories) */
export enum ProgressNoteCategory {
  AdvancedCare = 'ADVANCED_CARE',
  BladderManagement = 'BLADDER_MANAGEMENT',
  BowelManagement = 'BOWEL_MANAGEMENT',
  Communication = 'COMMUNICATION',
  DangerToSelfOthers = 'DANGER_TO_SELF_OTHERS',
  EmotionalDependence = 'EMOTIONAL_DEPENDENCE',
  MealsAndDrinks = 'MEALS_AND_DRINKS',
  Medications = 'MEDICATIONS',
  Mobility = 'MOBILITY',
  OtherBehaviour = 'OTHER_BEHAVIOUR',
  OtherServices = 'OTHER_SERVICES',
  PainDiscomfort = 'PAIN_DISCOMFORT',
  PalliativeCare = 'PALLIATIVE_CARE',
  PersonalHygiene = 'PERSONAL_HYGIENE',
  PhysicallyAggressive = 'PHYSICALLY_AGGRESSIVE',
  ProblemWanderingIntrusive = 'PROBLEM_WANDERING_INTRUSIVE',
  Sleeping = 'SLEEPING',
  SocialDiversionalTherapy = 'SOCIAL_DIVERSIONAL_THERAPY',
  SocialEmotionalSupport = 'SOCIAL_EMOTIONAL_SUPPORT',
  TechnicalComplexNursing = 'TECHNICAL_COMPLEX_NURSING',
  Therapy = 'THERAPY',
  Toileting = 'TOILETING',
  UnderstandingLivingActivities = 'UNDERSTANDING_LIVING_ACTIVITIES',
  VerballyDisruptiveNoisy = 'VERBALLY_DISRUPTIVE_NOISY'
}

export type ProgressNoteFilterInput = {
  carePlanCategory?: InputMaybe<ProgressNoteCategory>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  includeInException?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  residentId?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sourceModule?: InputMaybe<NoteSourceModule>;
  wing?: InputMaybe<Scalars['String']['input']>;
};

export type ProgressNotesResponse = {
  __typename?: 'ProgressNotesResponse';
  limit: Scalars['Int']['output'];
  notes: Array<ProgressNote>;
  offset: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type Project = {
  __typename?: 'Project';
  billingClient: Client;
  bills?: Maybe<Array<Bill>>;
  clientEmail?: Maybe<Scalars['String']['output']>;
  clientPhone?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deliverables?: Maybe<Array<Scalars['String']['output']>>;
  deliveryTimeline?: Maybe<Scalars['String']['output']>;
  finalPayment?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  members: Array<Client>;
  progress?: Maybe<Scalars['Float']['output']>;
  projectDescription?: Maybe<Scalars['String']['output']>;
  projectGoal: Scalars['String']['output'];
  projectName: Scalars['String']['output'];
  proposalAcceptedDate?: Maybe<Scalars['DateTime']['output']>;
  proposalId?: Maybe<Scalars['ID']['output']>;
  proposalSentDate?: Maybe<Scalars['DateTime']['output']>;
  proposalStatus?: Maybe<Scalars['String']['output']>;
  sourceEmailId?: Maybe<Scalars['String']['output']>;
  specialRequirements?: Maybe<Scalars['String']['output']>;
  suggestedPrice?: Maybe<Scalars['Float']['output']>;
  tasks?: Maybe<Array<Task>>;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  upfrontPayment?: Maybe<Scalars['Float']['output']>;
};

export type ProjectDocument = {
  __typename?: 'ProjectDocument';
  fileUrl: Scalars['String']['output'];
  isConfidential: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  type: ProjectDocumentType;
  uploadedAt: Scalars['DateTime']['output'];
};

/** Type of project document */
export enum ProjectDocumentType {
  BusinessPlan = 'BUSINESS_PLAN',
  Compliance = 'COMPLIANCE',
  FinancialProjections = 'FINANCIAL_PROJECTIONS',
  Legal = 'LEGAL',
  Other = 'OTHER',
  PitchDeck = 'PITCH_DECK'
}

export type ProjectInput = {
  billingClient: Scalars['ID']['input'];
  clientEmail?: InputMaybe<Scalars['String']['input']>;
  clientPhone?: InputMaybe<Scalars['String']['input']>;
  deliverables?: InputMaybe<Array<Scalars['String']['input']>>;
  deliveryTimeline?: InputMaybe<Scalars['String']['input']>;
  finalPayment?: InputMaybe<Scalars['Float']['input']>;
  members?: InputMaybe<Array<Scalars['ID']['input']>>;
  projectDescription?: InputMaybe<Scalars['String']['input']>;
  projectGoal: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
  sourceEmailId?: InputMaybe<Scalars['String']['input']>;
  specialRequirements?: InputMaybe<Scalars['String']['input']>;
  suggestedPrice?: InputMaybe<Scalars['Float']['input']>;
  upfrontPayment?: InputMaybe<Scalars['Float']['input']>;
};

export type ProjectProposal = {
  __typename?: 'ProjectProposal';
  clientEmail?: Maybe<Scalars['String']['output']>;
  clientName: Scalars['String']['output'];
  clientPhone?: Maybe<Scalars['String']['output']>;
  deliverables: Array<Scalars['String']['output']>;
  deliveryTimeline: Scalars['String']['output'];
  finalPayment: Scalars['Float']['output'];
  projectName: Scalars['String']['output'];
  projectSummary: Scalars['String']['output'];
  sourceEmailId?: Maybe<Scalars['String']['output']>;
  specialRequirements?: Maybe<Scalars['String']['output']>;
  suggestedPrice: Scalars['Float']['output'];
  tasks: Array<ProjectTask>;
  upfrontPayment: Scalars['Float']['output'];
};

/** Business sector */
export enum ProjectSector {
  Agriculture = 'AGRICULTURE',
  Education = 'EDUCATION',
  Finance = 'FINANCE',
  Healthcare = 'HEALTHCARE',
  Hospitality = 'HOSPITALITY',
  Other = 'OTHER',
  Property = 'PROPERTY',
  SupplyChain = 'SUPPLY_CHAIN',
  Technology = 'TECHNOLOGY'
}

/** Project lifecycle stage */
export enum ProjectStage {
  Active = 'ACTIVE',
  Concept = 'CONCEPT',
  Exited = 'EXITED',
  FullyFunded = 'FULLY_FUNDED',
  InvestmentReady = 'INVESTMENT_READY',
  Operating = 'OPERATING',
  PartiallyFunded = 'PARTIALLY_FUNDED',
  Planning = 'PLANNING'
}

/** Project visibility status */
export enum ProjectStatus {
  Archived = 'ARCHIVED',
  Draft = 'DRAFT',
  Published = 'PUBLISHED'
}

export type ProjectTask = {
  __typename?: 'ProjectTask';
  category?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  estimatedHours: Scalars['Float']['output'];
  order: Scalars['Float']['output'];
  title: Scalars['String']['output'];
};

export type ProjectTeamMember = {
  __typename?: 'ProjectTeamMember';
  bio?: Maybe<Scalars['String']['output']>;
  clientId?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  photoUrl?: Maybe<Scalars['String']['output']>;
  role: Scalars['String']['output'];
};

export type ProjectUpdateInput = {
  billingClient?: InputMaybe<Scalars['ID']['input']>;
  clientEmail?: InputMaybe<Scalars['String']['input']>;
  clientPhone?: InputMaybe<Scalars['String']['input']>;
  deliverables?: InputMaybe<Array<Scalars['String']['input']>>;
  deliveryTimeline?: InputMaybe<Scalars['String']['input']>;
  finalPayment?: InputMaybe<Scalars['Float']['input']>;
  members?: InputMaybe<Array<Scalars['ID']['input']>>;
  projectDescription?: InputMaybe<Scalars['String']['input']>;
  projectGoal?: InputMaybe<Scalars['String']['input']>;
  projectName?: InputMaybe<Scalars['String']['input']>;
  proposalStatus?: InputMaybe<Scalars['String']['input']>;
  sourceEmailId?: InputMaybe<Scalars['String']['input']>;
  specialRequirements?: InputMaybe<Scalars['String']['input']>;
  suggestedPrice?: InputMaybe<Scalars['Float']['input']>;
  upfrontPayment?: InputMaybe<Scalars['Float']['input']>;
};

export type PromoteFromWaitingListInput = {
  admissionDetails: AdmitResidentInput;
  waitingListEntryId: Scalars['ID']['input'];
};

export type PropertyAddressParts = {
  __typename?: 'PropertyAddressParts';
  country?: Maybe<Scalars['String']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  needsCheck?: Maybe<Scalars['Boolean']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  streetNumber?: Maybe<Scalars['String']['output']>;
  suburb?: Maybe<Scalars['String']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
};

export type PropertyAddressPartsInput = {
  country?: InputMaybe<Scalars['String']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  streetNumber?: InputMaybe<Scalars['String']['input']>;
  suburb?: InputMaybe<Scalars['String']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
};

export type Proposal = {
  __typename?: 'Proposal';
  agreementMarkdown: Scalars['String']['output'];
  billId?: Maybe<Scalars['ID']['output']>;
  companyName: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  customPagePath?: Maybe<Scalars['String']['output']>;
  draftBillId?: Maybe<Scalars['ID']['output']>;
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  fullySignedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  projectId?: Maybe<Scalars['ID']['output']>;
  scheduledPayments?: Maybe<Array<ScheduledPayment>>;
  sentAt?: Maybe<Scalars['DateTime']['output']>;
  signedPdfCid?: Maybe<Scalars['String']['output']>;
  signedPdfUrl?: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  status: ProposalStatus;
  tenantId: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type ProposalDraftPreview = {
  __typename?: 'ProposalDraftPreview';
  agreementMarkdown: Scalars['String']['output'];
  aiNotes?: Maybe<Scalars['String']['output']>;
  companyName: Scalars['String']['output'];
  paymentSchedule: Array<ProposalPaymentPreview>;
  slug: Scalars['String']['output'];
  title: Scalars['String']['output'];
  totalValue: Scalars['Float']['output'];
};

export type ProposalPaymentInput = {
  amount: Scalars['Float']['input'];
  description: Scalars['String']['input'];
};

export type ProposalPaymentPreview = {
  __typename?: 'ProposalPaymentPreview';
  amount: Scalars['Float']['output'];
  description: Scalars['String']['output'];
};

export type ProposalSignature = {
  __typename?: 'ProposalSignature';
  clientId?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['DateTime']['output'];
  emailVerificationCode?: Maybe<Scalars['String']['output']>;
  emailVerified: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  ipAddress?: Maybe<Scalars['String']['output']>;
  phoneVerificationCode?: Maybe<Scalars['String']['output']>;
  phoneVerified: Scalars['Boolean']['output'];
  postmarkMessageId?: Maybe<Scalars['String']['output']>;
  proposalId: Scalars['ID']['output'];
  signatureImage: Scalars['String']['output'];
  signatureImageCid?: Maybe<Scalars['String']['output']>;
  signatureImageUrl?: Maybe<Scalars['String']['output']>;
  signedAt: Scalars['DateTime']['output'];
  signerEmail: Scalars['String']['output'];
  signerName: Scalars['String']['output'];
  signerPhone?: Maybe<Scalars['String']['output']>;
  signerRole?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  userAgent?: Maybe<Scalars['String']['output']>;
};

/** The status of a proposal */
export enum ProposalStatus {
  Accepted = 'ACCEPTED',
  Cancelled = 'CANCELLED',
  Declined = 'DECLINED',
  Draft = 'DRAFT',
  Expired = 'EXPIRED',
  FullySigned = 'FULLY_SIGNED',
  PartiallySigned = 'PARTIALLY_SIGNED',
  Sent = 'SENT'
}

export type ProposeEmailAiActionScopeHintsInput = {
  bodyContains?: InputMaybe<Array<Scalars['String']['input']>>;
  domainContains?: InputMaybe<Array<Scalars['String']['input']>>;
  subjectTokens?: InputMaybe<Array<Scalars['String']['input']>>;
  useDomain?: InputMaybe<Scalars['Boolean']['input']>;
  useSender?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProposedEmailAiMemory = {
  __typename?: 'ProposedEmailAiMemory';
  body: Scalars['String']['output'];
  scope: EmailAiMemoryScope;
  scopeValue?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type ProposedEmailAiRule = {
  __typename?: 'ProposedEmailAiRule';
  actions: Array<ProposedEmailAiRuleAction>;
  conditionCombinator: EmailAiRuleCombinator;
  conditions: Array<ProposedEmailAiRuleCondition>;
  name: Scalars['String']['output'];
};

export type ProposedEmailAiRuleAction = {
  __typename?: 'ProposedEmailAiRuleAction';
  type: EmailAiRuleActionType;
  value?: Maybe<Scalars['String']['output']>;
};

export type ProposedEmailAiRuleCondition = {
  __typename?: 'ProposedEmailAiRuleCondition';
  type: EmailAiRuleConditionType;
  value: Scalars['String']['output'];
};

export enum ProspectingNotificationChannel {
  Email = 'EMAIL',
  InApp = 'IN_APP',
  Sms = 'SMS'
}

export enum ProspectingNotificationRecipientType {
  AllHrManagers = 'ALL_HR_MANAGERS',
  AllProspectAdmins = 'ALL_PROSPECT_ADMINS',
  Role = 'ROLE',
  SpecificUser = 'SPECIFIC_USER'
}

export type ProspectingNotificationRule = {
  __typename?: 'ProspectingNotificationRule';
  channels: Array<ProspectingNotificationChannel>;
  chatRecipientCooldownMinutes?: Maybe<Scalars['Float']['output']>;
  chatSessionGapMinutes?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdByUserId?: Maybe<Scalars['ID']['output']>;
  filterDepartmentId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isEnabled: Scalars['Boolean']['output'];
  messageTemplate?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  recipientIds: Array<Scalars['String']['output']>;
  recipientType: ProspectingNotificationRecipientType;
  tenantId: Scalars['String']['output'];
  trigger: ProspectingNotificationTrigger;
  updatedAt: Scalars['DateTime']['output'];
};

export enum ProspectingNotificationTrigger {
  AllEvents = 'ALL_EVENTS',
  CandidateCreated = 'CANDIDATE_CREATED',
  CandidateHired = 'CANDIDATE_HIRED',
  CandidatePlaced = 'CANDIDATE_PLACED',
  CandidatePutForward = 'CANDIDATE_PUT_FORWARD',
  CandidateRejected = 'CANDIDATE_REJECTED',
  CandidateStageChanged = 'CANDIDATE_STAGE_CHANGED',
  CandidateSuitable = 'CANDIDATE_SUITABLE',
  ChatMessageReceived = 'CHAT_MESSAGE_RECEIVED',
  DocumentAccepted = 'DOCUMENT_ACCEPTED',
  DocumentUploaded = 'DOCUMENT_UPLOADED',
  FormSubmitted = 'FORM_SUBMITTED',
  InterviewCompleted = 'INTERVIEW_COMPLETED',
  InterviewScheduled = 'INTERVIEW_SCHEDULED',
  InviteSent = 'INVITE_SENT',
  MessageSent = 'MESSAGE_SENT',
  OfferMade = 'OFFER_MADE',
  ReferenceReceived = 'REFERENCE_RECEIVED'
}

export type ProvisionDigitalManagerInput = {
  avatarCid?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['ID']['input'];
  modelOverride?: InputMaybe<Scalars['String']['input']>;
  personaName: Scalars['String']['input'];
  proactiveChasingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  reportTo?: InputMaybe<Array<DigitalManagerReportToContactInput>>;
  responsibilitiesMarkdown: Scalars['String']['input'];
  scheduleCron?: InputMaybe<Scalars['String']['input']>;
  scopeToolIds?: InputMaybe<Array<Scalars['String']['input']>>;
  standupCron?: InputMaybe<Scalars['String']['input']>;
  standupEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  template?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  workEmailLocalPart?: InputMaybe<Scalars['String']['input']>;
};

export type ProvisionDigitalManagerResult = {
  __typename?: 'ProvisionDigitalManagerResult';
  m365SetupStatus: DigitalManagerM365SetupStatusType;
  manager: DigitalManager;
};

export type ProvisionEmployeeWorkEmailResult = {
  __typename?: 'ProvisionEmployeeWorkEmailResult';
  calendar: BusinessCalendar;
  emailAddress: EmailAddress;
  employee: Employee;
  m365SetupStatus: M365SetupStatus;
};

export type ProvisionResult = {
  __typename?: 'ProvisionResult';
  error?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  provisionId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type ProvisionResultDetails = {
  __typename?: 'ProvisionResultDetails';
  directUrl: Scalars['String']['output'];
  path: Scalars['String']['output'];
  port: Scalars['Float']['output'];
  serviceUrl: Scalars['String']['output'];
  siteId: Scalars['String']['output'];
  subdomain: Scalars['String']['output'];
};

export type ProvisionStatusResult = {
  __typename?: 'ProvisionStatusResult';
  completedAt?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  result?: Maybe<ProvisionResultDetails>;
  siteId: Scalars['String']['output'];
  status: Scalars['String']['output'];
  steps: Array<ProvisionStep>;
  success: Scalars['Boolean']['output'];
};

export type ProvisionStep = {
  __typename?: 'ProvisionStep';
  details: Scalars['String']['output'];
  status: Scalars['String']['output'];
  step: Scalars['String']['output'];
  timestamp: Scalars['String']['output'];
};

export type ProvisioningLogEntry = {
  __typename?: 'ProvisioningLogEntry';
  error?: Maybe<Scalars['String']['output']>;
  label: Scalars['String']['output'];
  status: Scalars['String']['output'];
  stepId: Scalars['String']['output'];
  timestamp: Scalars['DateTime']['output'];
};

export enum ProvisioningStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Idle = 'IDLE',
  InProgress = 'IN_PROGRESS'
}

export type ProvisioningStatusResult = {
  __typename?: 'ProvisioningStatusResult';
  error?: Maybe<Scalars['String']['output']>;
  log: Array<ProvisioningLogEntry>;
  status: Scalars['String']['output'];
  step: Scalars['Float']['output'];
  vercelUrl?: Maybe<Scalars['String']['output']>;
};

export type PublicArtifactView = {
  __typename?: 'PublicArtifactView';
  body?: Maybe<Scalars['String']['output']>;
  commentsEnabled: Scalars['Boolean']['output'];
  createdByName?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  emoji?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  slug: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  version: Scalars['Float']['output'];
  visibility: ArtifactVisibility;
};

export type PublicBookingResult = {
  __typename?: 'PublicBookingResult';
  booking: CalendarEvent;
  bookingToken: Scalars['String']['output'];
  paymentAmount: Scalars['Float']['output'];
  paymentCurrency: Scalars['String']['output'];
  requiresPayment: Scalars['Boolean']['output'];
  stripeCheckoutUrl?: Maybe<Scalars['String']['output']>;
};

export type PublicCandidateInviteInfo = {
  __typename?: 'PublicCandidateInviteInfo';
  candidateId?: Maybe<Scalars['ID']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  formId?: Maybe<Scalars['ID']['output']>;
  inviteId?: Maybe<Scalars['ID']['output']>;
  isOpenForm: Scalars['Boolean']['output'];
  jobTitle?: Maybe<Scalars['String']['output']>;
  status: CandidateInviteStatus;
  type: CandidateInviteType;
};

export type PublicClub52GameInfo = {
  __typename?: 'PublicClub52GameInfo';
  appAccessInstructions?: Maybe<Scalars['String']['output']>;
  exists: Scalars['Boolean']['output'];
  explorerBaseUrl?: Maybe<Scalars['String']['output']>;
  invitees: Array<Scalars['String']['output']>;
  organizer?: Maybe<Scalars['String']['output']>;
  roomName: Scalars['String']['output'];
  scheduledStart?: Maybe<Scalars['DateTime']['output']>;
  status: Club52GameStatus;
  tableUrl?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  walletPageUrl?: Maybe<Scalars['String']['output']>;
};

export type PublicCommunityInfo = {
  __typename?: 'PublicCommunityInfo';
  displayName: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
};

export type PublicCommunityInviteInfo = {
  __typename?: 'PublicCommunityInviteInfo';
  accessMode: CommunityInviteAccessMode;
  couponCode?: Maybe<Scalars['String']['output']>;
  fName?: Maybe<Scalars['String']['output']>;
  status: CommunityInviteStatus;
};

export type PublicCompetition = {
  __typename?: 'PublicCompetition';
  acceptingEntries: Scalars['Boolean']['output'];
  ageBands: Array<CompetitionAgeBand>;
  aiPolicy?: Maybe<Scalars['String']['output']>;
  announceWinnersAt?: Maybe<Scalars['DateTime']['output']>;
  announceWinnersAtLabel: Scalars['String']['output'];
  briefMd?: Maybe<Scalars['String']['output']>;
  closesAt?: Maybe<Scalars['DateTime']['output']>;
  closesAtLabel: Scalars['String']['output'];
  entryCount: Scalars['Int']['output'];
  heroImageCid?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  maxEntriesPerPerson: Scalars['Int']['output'];
  opensAt?: Maybe<Scalars['DateTime']['output']>;
  opensAtLabel: Scalars['String']['output'];
  prizes: Array<PublicCompetitionPrize>;
  rightsTermsMd?: Maybe<Scalars['String']['output']>;
  rulesMd?: Maybe<Scalars['String']['output']>;
  shortlistRequired: Scalars['Boolean']['output'];
  slug: Scalars['String']['output'];
  sponsors: Array<PublicCompetitionSponsor>;
  status: CompetitionStatus;
  theme?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  visibility: CompetitionVisibility;
  votingClosesAt?: Maybe<Scalars['DateTime']['output']>;
  votingClosesAtLabel: Scalars['String']['output'];
  votingMode: CompetitionVotingMode;
  votingOpen: Scalars['Boolean']['output'];
  votingOpensAt?: Maybe<Scalars['DateTime']['output']>;
  votingOpensAtLabel: Scalars['String']['output'];
  winnersAnnounced: Scalars['Boolean']['output'];
  winnersAnnouncedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type PublicCompetitionEntry = {
  __typename?: 'PublicCompetitionEntry';
  ageBand: CompetitionAgeBand;
  competitionId: Scalars['ID']['output'];
  enteredForName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  imageCid: Scalars['String']['output'];
  peoplesChoice?: Maybe<Scalars['Boolean']['output']>;
  placement?: Maybe<Scalars['Int']['output']>;
  printPrice?: Maybe<Scalars['Float']['output']>;
  printProductId?: Maybe<Scalars['ID']['output']>;
  printSize?: Maybe<Scalars['String']['output']>;
  printsAvailable: Scalars['Boolean']['output'];
  shareSlug: Scalars['String']['output'];
  statement?: Maybe<Scalars['String']['output']>;
  status?: Maybe<CompetitionEntryStatus>;
  thumbnailCid?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  votable: Scalars['Boolean']['output'];
  voteCount?: Maybe<Scalars['Int']['output']>;
};

export type PublicCompetitionEntryView = {
  __typename?: 'PublicCompetitionEntryView';
  competition: PublicCompetition;
  entry: PublicCompetitionEntry;
};

export type PublicCompetitionPrize = {
  __typename?: 'PublicCompetitionPrize';
  ageBand?: Maybe<CompetitionAgeBand>;
  description: Scalars['String']['output'];
  place: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type PublicCompetitionSchool = {
  __typename?: 'PublicCompetitionSchool';
  entryCount: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  suburb?: Maybe<Scalars['String']['output']>;
};

export type PublicCompetitionSponsor = {
  __typename?: 'PublicCompetitionSponsor';
  blurb?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  logoCid?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type PublicConfirmationAnswerResult = {
  __typename?: 'PublicConfirmationAnswerResult';
  message: Scalars['String']['output'];
  ok: Scalars['Boolean']['output'];
};

export type PublicEmployeeInviteContract = {
  __typename?: 'PublicEmployeeInviteContract';
  awardName?: Maybe<Scalars['String']['output']>;
  declarationText: Scalars['String']['output'];
  letterhead: EmployeeContractLetterhead;
  /** The agreement (markdown). Before signing, the address reads "[Employee address]" until they type it. */
  markdown: Scalars['String']['output'];
  signed: Scalars['Boolean']['output'];
  signedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Gateway URL of the signed PDF (after signing). */
  signedPdfUrl?: Maybe<Scalars['String']['output']>;
  signerName?: Maybe<Scalars['String']['output']>;
  /** Name to pre-fill the signer box with (from the offer). */
  suggestedSignerName?: Maybe<Scalars['String']['output']>;
  templateName: Scalars['String']['output'];
};

export type PublicEmployeeInviteInfo = {
  __typename?: 'PublicEmployeeInviteInfo';
  companyName?: Maybe<Scalars['String']['output']>;
  /** True when the contract is signed on this page BEFORE the details form (contract-first). */
  contractFirst: Scalars['Boolean']['output'];
  /** When the contract was signed from this link (contract-first only). */
  contractSignedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Name of the attached contract template, when there is one. */
  contractTemplateName?: Maybe<Scalars['String']['output']>;
  departmentName?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  /** When this link stops working. */
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  fName?: Maybe<Scalars['String']['output']>;
  /** True when an employment contract will be presented for e-signature after sign-up. */
  hasContract: Scalars['Boolean']['output'];
  lName?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['String']['output']>;
  /** Job named in the letter — the position title, else the primary role name. */
  positionTitle?: Maybe<Scalars['String']['output']>;
  /** Offered start date (date-only, UTC midnight). */
  startDate?: Maybe<Scalars['DateTime']['output']>;
  status: EmployeeInviteStatus;
};

export type PublicFeedbackReceipt = {
  __typename?: 'PublicFeedbackReceipt';
  feedbackNumber: Scalars['Int']['output'];
  followToken: Scalars['String']['output'];
};

export type PublicFeedbackStatus = {
  __typename?: 'PublicFeedbackStatus';
  acknowledgedAt?: Maybe<Scalars['DateTime']['output']>;
  details: Scalars['String']['output'];
  feedbackNumber: Scalars['Int']['output'];
  kind: FeedbackKind;
  receivedAt: Scalars['DateTime']['output'];
  resolvedAt?: Maybe<Scalars['DateTime']['output']>;
  response?: Maybe<Scalars['String']['output']>;
  status: FeedbackStatus;
};

export type PublicGovActivityTeaser = {
  __typename?: 'PublicGovActivityTeaser';
  membersCount: Scalars['Int']['output'];
  organisationId: Scalars['ID']['output'];
  organisationName: Scalars['String']['output'];
  organisationSlug: Scalars['String']['output'];
  what: Scalars['String']['output'];
  whenLabel?: Maybe<Scalars['String']['output']>;
};

export type PublicGovDecision = {
  __typename?: 'PublicGovDecision';
  decidedAt: Scalars['DateTime']['output'];
  decidedAtLabel: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  outcome: GovProposalStatus;
  title: Scalars['String']['output'];
  totalVotesCast: Scalars['Int']['output'];
  totalWeightCast: Scalars['Float']['output'];
  winningChoiceLabel?: Maybe<Scalars['String']['output']>;
};

export type PublicGovInviteInfo = {
  __typename?: 'PublicGovInviteInfo';
  closedReason?: Maybe<Scalars['String']['output']>;
  countsAsSponsorship: Scalars['Boolean']['output'];
  customMessage?: Maybe<Scalars['String']['output']>;
  expiresAt: Scalars['DateTime']['output'];
  invitedByName?: Maybe<Scalars['String']['output']>;
  inviteeFName?: Maybe<Scalars['String']['output']>;
  organisationName: Scalars['String']['output'];
  organisationPurpose?: Maybe<Scalars['String']['output']>;
  organisationRules?: Maybe<Scalars['String']['output']>;
  rulesChangedAt?: Maybe<Scalars['DateTime']['output']>;
  rulesVersion?: Maybe<Scalars['Int']['output']>;
  slug: Scalars['String']['output'];
  sponsorsRequired: Scalars['Float']['output'];
  status: GovInviteStatus;
};

export type PublicGovMember = {
  __typename?: 'PublicGovMember';
  name: Scalars['String']['output'];
  role: GovMemberRole;
};

export type PublicGovMotion = {
  __typename?: 'PublicGovMotion';
  body?: Maybe<Scalars['String']['output']>;
  choices: Array<PublicGovMotionChoice>;
  closesAtLabel?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  membersCount: Scalars['Int']['output'];
  organisationId: Scalars['ID']['output'];
  organisationName: Scalars['String']['output'];
  organisationPurpose?: Maybe<Scalars['String']['output']>;
  organisationSlug: Scalars['String']['output'];
  passRule: Scalars['String']['output'];
  publicPageEnabled: Scalars['Boolean']['output'];
  quorumMet: Scalars['Boolean']['output'];
  status: Scalars['String']['output'];
  statusWords: Scalars['String']['output'];
  title: Scalars['String']['output'];
  totalVotesCast: Scalars['Int']['output'];
  turnoutPercent: Scalars['Float']['output'];
};

export type PublicGovMotionChoice = {
  __typename?: 'PublicGovMotionChoice';
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  percentOfCast: Scalars['Float']['output'];
  votes: Scalars['Int']['output'];
};

export type PublicGovOrganisation = {
  __typename?: 'PublicGovOrganisation';
  decisions: Array<PublicGovDecision>;
  decisionsCap: Scalars['Int']['output'];
  decisionsTotal: Scalars['Int']['output'];
  legalWrapper: GovLegalWrapper;
  memberCount: Scalars['Int']['output'];
  memberListPublished: Scalars['Boolean']['output'];
  members: Array<PublicGovMember>;
  name: Scalars['String']['output'];
  openProposalCount: Scalars['Int']['output'];
  purpose?: Maybe<Scalars['String']['output']>;
  registrationNumber?: Maybe<Scalars['String']['output']>;
  rulesChangedAt?: Maybe<Scalars['DateTime']['output']>;
  rulesMarkdown?: Maybe<Scalars['String']['output']>;
  rulesVersion?: Maybe<Scalars['Int']['output']>;
  slug: Scalars['String']['output'];
  timezone: Scalars['String']['output'];
  tokenSymbol?: Maybe<Scalars['String']['output']>;
};

export type PublicGovProposalTeaser = {
  __typename?: 'PublicGovProposalTeaser';
  closesAtLabel?: Maybe<Scalars['String']['output']>;
  excerpt: Scalars['String']['output'];
  membersCount: Scalars['Int']['output'];
  organisationId: Scalars['ID']['output'];
  organisationName: Scalars['String']['output'];
  organisationSlug: Scalars['String']['output'];
  status: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type PublicHoliday = {
  __typename?: 'PublicHoliday';
  createdAt: Scalars['DateTime']['output'];
  date: Scalars['DateTime']['output'];
  defaultPenaltyMultiplier: Scalars['Float']['output'];
  holidayType: PublicHolidayType;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  observedDate?: Maybe<Scalars['DateTime']['output']>;
  payRates?: Maybe<Array<HolidayPayRate>>;
  region?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  year: Scalars['Int']['output'];
};

export type PublicHolidayImportResult = {
  __typename?: 'PublicHolidayImportResult';
  inserted: Scalars['Int']['output'];
  skipped: Scalars['Int']['output'];
  warnings: Array<Scalars['String']['output']>;
  yearsImported: Array<Scalars['Int']['output']>;
};

export type PublicHolidayInput = {
  date: Scalars['DateTime']['input'];
  defaultPenaltyMultiplier: Scalars['Float']['input'];
  holidayType: PublicHolidayType;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  observedDate?: InputMaybe<Scalars['DateTime']['input']>;
  payRates?: InputMaybe<Array<HolidayPayRateInput>>;
  region?: InputMaybe<Scalars['String']['input']>;
  year: Scalars['Int']['input'];
};

/** Type of public holiday */
export enum PublicHolidayType {
  Custom = 'CUSTOM',
  National = 'NATIONAL',
  Regional = 'REGIONAL',
  State = 'STATE'
}

export type PublicHostingOffer = {
  __typename?: 'PublicHostingOffer';
  currency: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  monthlyPrice: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  subscriptionProductSlug?: Maybe<Scalars['String']['output']>;
};

export type PublicHostingReferralInput = {
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  offerSlug: Scalars['String']['input'];
  refCode: Scalars['String']['input'];
};

export type PublicInquiryFormToken = {
  __typename?: 'PublicInquiryFormToken';
  /** The site's name for the form's wording */
  facilityName: Scalars['String']['output'];
  /** Signed render time — the form must be open ≥ 3 s before it is sent */
  token: Scalars['String']['output'];
};

export type PublicInquiryResult = {
  __typename?: 'PublicInquiryResult';
  ok: Scalars['Boolean']['output'];
  /** A short reference to quote — never the record id */
  reference: Scalars['String']['output'];
};

export type PublicMeetingInfo = {
  __typename?: 'PublicMeetingInfo';
  exists: Scalars['Boolean']['output'];
  invitees: Array<Scalars['String']['output']>;
  organizer?: Maybe<Scalars['String']['output']>;
  recordingEnabled: Scalars['Boolean']['output'];
  roomName: Scalars['String']['output'];
  scheduledStart?: Maybe<Scalars['DateTime']['output']>;
  status: MeetStatus;
  title: Scalars['String']['output'];
};

export type PublicP2Product = {
  __typename?: 'PublicP2Product';
  categories: Array<Scalars['String']['output']>;
  compareAtPrice?: Maybe<Scalars['Float']['output']>;
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  imageCids: Array<Scalars['String']['output']>;
  isFeatured: Scalars['Boolean']['output'];
  memberPrice?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  price: Scalars['Float']['output'];
  sku?: Maybe<Scalars['String']['output']>;
  specifications: Array<P2ProductSpec>;
  stockLevel: Scalars['Float']['output'];
  tags: Array<Scalars['String']['output']>;
  type: P2ProductType;
  variants: Array<PublicP2ProductVariant>;
  waitlistEnabled: Scalars['Boolean']['output'];
};

export type PublicP2ProductVariant = {
  __typename?: 'PublicP2ProductVariant';
  price: Scalars['Float']['output'];
  stockLevel?: Maybe<Scalars['Float']['output']>;
  title: Scalars['String']['output'];
  variantId: Scalars['String']['output'];
};

export type PublicPasswordAccessInput = {
  mobileNumber: Scalars['String']['input'];
  passwordId: Scalars['String']['input'];
  verificationCode: Scalars['String']['input'];
};

export type PublicReferenceInfo = {
  __typename?: 'PublicReferenceInfo';
  alreadySubmitted: Scalars['Boolean']['output'];
  candidateName: Scalars['String']['output'];
  companyName?: Maybe<Scalars['String']['output']>;
  expired: Scalars['Boolean']['output'];
  expiresAt: Scalars['DateTime']['output'];
  positionTitle?: Maybe<Scalars['String']['output']>;
  refereeName: Scalars['String']['output'];
  status: CandidateReferenceStatus;
};

export type PublicSeparationInviteInfo = {
  __typename?: 'PublicSeparationInviteInfo';
  accessMode: SeparationInviteAccessMode;
  caseTitle?: Maybe<Scalars['String']['output']>;
  childFirstNames: Array<Scalars['String']['output']>;
  couponCode?: Maybe<Scalars['String']['output']>;
  customMessage?: Maybe<Scalars['String']['output']>;
  fName?: Maybe<Scalars['String']['output']>;
  invitedByDisplayName?: Maybe<Scalars['String']['output']>;
  status: SeparationInviteStatus;
};

export type PublicSessionInfo = {
  __typename?: 'PublicSessionInfo';
  imageCount: Scalars['Float']['output'];
  sessionDate: Scalars['DateTime']['output'];
  sessionId: Scalars['String']['output'];
  totalBytes: Scalars['Float']['output'];
  totalFiles: Scalars['Float']['output'];
  videoCount: Scalars['Float']['output'];
};

export type PublicShelvInviteInfo = {
  __typename?: 'PublicShelvInviteInfo';
  accessMode: ShelvInviteAccessMode;
  fName?: Maybe<Scalars['String']['output']>;
  invitedByName?: Maybe<Scalars['String']['output']>;
  isExpired: Scalars['Boolean']['output'];
  kitchenName?: Maybe<Scalars['String']['output']>;
  sharedRecipeName?: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  status: ShelvInviteStatus;
};

export type PublicVisionBoardInviteInfo = {
  __typename?: 'PublicVisionBoardInviteInfo';
  accessMode: VisionBoardInviteAccessMode;
  couponCode?: Maybe<Scalars['String']['output']>;
  fName?: Maybe<Scalars['String']['output']>;
  status: VisionBoardInviteStatus;
};

export type PublicWaitingListConfirmation = {
  __typename?: 'PublicWaitingListConfirmation';
  contactEmail?: Maybe<Scalars['String']['output']>;
  contactName?: Maybe<Scalars['String']['output']>;
  contactPhone?: Maybe<Scalars['String']['output']>;
  facilityName?: Maybe<Scalars['String']['output']>;
  /** The person's FIRST name only */
  firstName?: Maybe<Scalars['String']['output']>;
  /** Why the link cannot be used, in words */
  reason?: Maybe<Scalars['String']['output']>;
  valid: Scalars['Boolean']['output'];
};

export type PublicWalletInvite = {
  __typename?: 'PublicWalletInvite';
  acceptedAddress?: Maybe<Scalars['String']['output']>;
  expired: Scalars['Boolean']['output'];
  expiresAt: Scalars['DateTime']['output'];
  inviteeName: Scalars['String']['output'];
  inviterName: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  status: WalletInviteStatus;
  tenantName?: Maybe<Scalars['String']['output']>;
};

export type PublishArtifactVersionInput = {
  artifactId: Scalars['ID']['input'];
  body: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  emoji?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type PulseObservation = {
  __typename?: 'PulseObservation';
  autoProgressNote: Scalars['Boolean']['output'];
  bpm: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  progressNoteId?: Maybe<Scalars['ID']['output']>;
  residentId: Scalars['ID']['output'];
  residentName?: Maybe<Scalars['String']['output']>;
  residentRoom?: Maybe<Scalars['String']['output']>;
  residentWing?: Maybe<Scalars['String']['output']>;
  sourceAuthor?: Maybe<Scalars['String']['output']>;
  sourceBackupDate?: Maybe<Scalars['DateTime']['output']>;
  sourceContext?: Maybe<SarahObservationSourceContext>;
  sourceContextBackupDate?: Maybe<Scalars['DateTime']['output']>;
  sourceContextImportedAt?: Maybe<Scalars['DateTime']['output']>;
  sourceHash?: Maybe<Scalars['String']['output']>;
  sourceId?: Maybe<Scalars['String']['output']>;
  sourceSystem?: Maybe<Scalars['String']['output']>;
  takenAt: Scalars['DateTime']['output'];
  takenBy: Scalars['ID']['output'];
  takenByName?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type PulseObservationFilterInput = {
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  residentId?: InputMaybe<Scalars['ID']['input']>;
  wing?: InputMaybe<Scalars['String']['input']>;
};

export type PulseObservationsResponse = {
  __typename?: 'PulseObservationsResponse';
  limit: Scalars['Int']['output'];
  observations: Array<PulseObservation>;
  offset: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type PupillaryAssessment = {
  __typename?: 'PupillaryAssessment';
  leftReaction?: Maybe<Scalars['String']['output']>;
  leftShape?: Maybe<Scalars['String']['output']>;
  leftSize?: Maybe<Scalars['Float']['output']>;
  rightReaction?: Maybe<Scalars['String']['output']>;
  rightShape?: Maybe<Scalars['String']['output']>;
  rightSize?: Maybe<Scalars['Float']['output']>;
};

export type PupillaryAssessmentInput = {
  leftReaction?: InputMaybe<Scalars['String']['input']>;
  leftShape?: InputMaybe<Scalars['String']['input']>;
  leftSize?: InputMaybe<Scalars['Float']['input']>;
  rightReaction?: InputMaybe<Scalars['String']['input']>;
  rightShape?: InputMaybe<Scalars['String']['input']>;
  rightSize?: InputMaybe<Scalars['Float']['input']>;
};

export type PurchasePhoneNumberInput = {
  autoTranscribe?: InputMaybe<Scalars['Boolean']['input']>;
  forwardToNumber?: InputMaybe<Scalars['String']['input']>;
  friendlyName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber: Scalars['String']['input'];
  recordCalls?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Query = {
  __typename?: 'Query';
  abbeyPainAssessments: AbbeyPainAssessmentsResponse;
  accountabilityGoal?: Maybe<AccountabilityGoal>;
  accountabilityGoals: Array<AccountabilityGoal>;
  /** Accounting: one entity's bank accounts (day-to-day, government claims, payroll, other). */
  accountingBankAccounts: Array<AccountingBankAccount>;
  /** Accounting: each of this entity's bank accounts' balance at the end of today (Brisbane), read live from Xero's bank summary. Writes nothing. */
  accountingBankBalances: AccountingBankBalances;
  /** Accounting: 13-week cash-flow forecast for one entity — today's Xero bank balance, then week by week the money expected in and out, projected from the last 13 weeks of this entity's own bank history (recurring payees on their rhythm, the rest as a weekly average; transfers between own accounts left out). Read-only. */
  accountingCashForecast: AccountingCashForecast;
  /** Accounting: the business entities on this site (companies module), A–Z. Each keeps its own books. */
  accountingCompanies: Array<AccountingCompany>;
  /** Accounting: one entity at a glance — unexplained count, bank accounts by purpose, this Brisbane month's cash P&L. */
  accountingDashboard: AccountingDashboard;
  /** Accounting: cash-basis profit & loss for one entity, by Brisbane month, from CODED transactions only (ex-GST). At most 24 months. */
  accountingProfitLoss: AccountingProfitLoss;
  /** Accounting: residents to link a receipt to (admitted, current or past), A–Z by name. Read-only over admissions. */
  accountingResidents: Array<AccountingResidentOption>;
  /** Accounting admin: the module's own Redbark connection — never the key itself. */
  accountingSettings: AccountingSettingsView;
  /** Accounting: one transaction (null when it is not on this site). */
  accountingTransaction?: Maybe<AccountingTransaction>;
  /** Accounting: one entity's bank transactions, newest first, 20 at a time (max 100). `unexplainedOnly` = uncoded + suggested. */
  accountingTransactions: AccountingTransactionPage;
  /** Accounting admin: the Xero consent-screen address to send the browser to. Reads only — builds a link with a 10-minute signed state. */
  accountingXeroAuthorizeUrl: Scalars['String']['output'];
  /** Accounting: the Xero organisations this site's connection can read (names only), A–Z — empty when Xero isn't connected. Lets anyone who imports pick an organisation without seeing the settings. */
  accountingXeroOrgs: Array<AccountingXeroOrg>;
  acfiAssessments: AcfiAssessmentsResponse;
  acfiFundingSummary: AcfiFundingSummaryResponse;
  acmaEvidencePack: Scalars['String']['output'];
  activeBookableEventTypes: Array<BusinessCalendarBookableEventType>;
  activeCheckIn?: Maybe<CheckIn>;
  activeContributingFactors: Array<ContributingFactor>;
  activeGoals: Array<AccountabilityGoal>;
  activeIncidentLocations: Array<IncidentLocation>;
  activeIncidentTypes: Array<IncidentType>;
  activeIngredients: Array<Ingredient>;
  activeJobs: Array<Job>;
  activeNeurologicalPeriods: Array<NeurologicalObservationPeriod>;
  activeRecipes: Array<Recipe>;
  activeRestraints: Array<RestraintRecord>;
  activeSeparationSchedule?: Maybe<SeparationParentingSchedule>;
  activeSuppliers: Array<Supplier>;
  activeTemplates: Array<CarePlanTemplate>;
  activeUnitOptions: Array<ActiveUnitOption>;
  activeWorkers: Array<Worker>;
  /** Admin: every listing, A–Z, including hidden and unpublished ones. */
  adminBusinessListings: Array<BusinessListing>;
  administrationComplianceReport: AdministrationComplianceReport;
  administrationHistory: AdministrationHistoryResponse;
  admissionChecklist?: Maybe<AdmissionChecklist>;
  admissionChecklistProgress: ChecklistProgress;
  admissionChecklistTemplates: Array<AdmissionChecklistTemplate>;
  admissionDischargeStats: AdmissionDischargeStats;
  admissionNotificationRules: Array<AdmissionNotificationRule>;
  admissionsSettings: AdmissionsSettings;
  admissionsStatistics: AdmissionsStatistics;
  /** The resident's advance care plan; null when none has been started */
  advanceCarePlan?: Maybe<AdvanceCarePlan>;
  advisoryBodies: Array<AdvisoryBody>;
  agencyCompanies: Array<Scalars['String']['output']>;
  agentBoard: AgentBoard;
  aggregatedIngredientsForDateRange: Array<AggregatedIngredient>;
  aiOpsCapacity: AiOpsCapacity;
  aiOpsContent: AiOpsSessionContent;
  aiOpsHardware: Array<AiOpsHardwareSample>;
  aiOpsHardwareNow: AiOpsHardwareSample;
  aiOpsHidden: AiOpsHiddenCounts;
  aiOpsKeyEventList: AiOpsKeyEventList;
  /** @deprecated Use aiOpsKeyEventList. Kept until both AI Ops frontends are deployed on it. */
  aiOpsKeyEvents: AiOpsKeyEventPage;
  aiOpsKeyList: AiOpsKeyList;
  /** @deprecated Use aiOpsKeyList (paged, sorted, searchable). Kept until both AI Ops frontends are deployed on it. */
  aiOpsKeys: Array<AiOpsVirtualKey>;
  aiOpsLive: AiOpsLive;
  aiOpsModelRuns: Array<AiOpsModelRun>;
  aiOpsModels: Array<AiOpsServedModel>;
  aiOpsRecentRequests: Array<AiOpsUsageRecord>;
  aiOpsServiceStatus: AiOpsServiceStatus;
  aiOpsSessions: Array<AiOpsSession>;
  aiOpsUsage: Array<AiOpsUsageBucket>;
  aiOpsVoiceCallList: AiOpsVoiceCallList;
  /** @deprecated Use aiOpsVoiceCallList. Kept until both AI Ops frontends are deployed on it. */
  aiOpsVoiceCalls: AiOpsVoiceCallPage;
  aiOpsVoiceStats: AiOpsVoiceStats;
  aiPayAudit?: Maybe<AiPayAudit>;
  aiPayAudits: Array<AiPayAudit>;
  aiRoute: AiRoute;
  aiUsageLogs: Array<AiUsageLog>;
  aiUsageStats: AiUsageStats;
  allAlertConfigs: Array<ObservationAlertConfig>;
  allCalendarEvents: Array<CalendarEvent>;
  allClientAssessmentSnapshots: Array<AssessmentSnapshot>;
  allClientMoodEntries: Array<MoodEntry>;
  allClientSnapshots: Array<HolisticSnapshot>;
  allClientTags: Array<Scalars['String']['output']>;
  allClientVisionBoards: Array<VisionBoardItem>;
  allExpressionsOfInterest: Array<ExpressionOfInterest>;
  allMobilityAids: Array<MobilityAids>;
  allOpportunityTasks: Array<OpportunityTask>;
  allSEOMetadata: Array<SeoMetadata>;
  allShelvKitchens: Array<Kitchen>;
  anaccClassifications: AnaccClassificationsResponse;
  analyticsEvents: Array<AnalyticsEvent>;
  analyticsNotificationRule?: Maybe<AnalyticsNotificationRule>;
  analyticsNotificationRules: Array<AnalyticsNotificationRule>;
  analyticsOverview: AnalyticsOverview;
  analyticsSessions: Array<AnalyticsSession>;
  analyticsTimeSeries: Array<TimeSeriesPoint>;
  /** Admin: all API listings (including drafts) */
  apiHubAdminListings: Array<ApiListing>;
  /** List my API keys */
  apiHubMyKeys: Array<ApiKey>;
  /** My active API subscriptions */
  apiHubMySubscriptions: Array<ApiSubscription>;
  /** Recent usage logs */
  apiHubUsageLogs: Array<ApiUsageLog>;
  /** Usage stats for current month */
  apiHubUsageStats: ApiHubUsageStats;
  /** Daily usage summaries for charts */
  apiHubUsageTimeline: Array<ApiUsageSummary>;
  artSession?: Maybe<ArtSession>;
  artSessions: Array<ArtSession>;
  artifact?: Maybe<Artifact>;
  artifactComments: Array<ArtifactComment>;
  artifactVersions: Array<ArtifactVersion>;
  artifacts: Array<Artifact>;
  askHelp: HelpAnswer;
  assessmentCustomField?: Maybe<AssessmentCustomField>;
  assessmentCustomFields: Array<AssessmentCustomField>;
  assessmentDomain?: Maybe<AssessmentDomain>;
  assessmentDomains: Array<AssessmentDomain>;
  assessmentNotificationRules: Array<AssessmentNotificationRule>;
  assessmentSnapshot?: Maybe<AssessmentSnapshot>;
  assessmentSnapshotCount: Scalars['Float']['output'];
  assessmentSnapshots: Array<AssessmentSnapshot>;
  authProfileStatus: AuthProfileStatus;
  availableBeds: Array<Scalars['Int']['output']>;
  availableClientsForEmployee: Array<Client>;
  availableInboundEmailLabels: Array<Scalars['String']['output']>;
  availableLocalAiModels: Array<AvailableLocalAiModel>;
  availableModules: Array<ModuleInfo>;
  availableRooms: Array<RoomWithOccupancy>;
  availableSessions: Array<Session>;
  availableShifts: Array<Shift>;
  availableTimeSlots: Array<AvailableTimeSlot>;
  award?: Maybe<AwardEntity>;
  awardClassification?: Maybe<AwardClassification>;
  awardClassifications: Array<AwardClassification>;
  awardNames: Array<Scalars['String']['output']>;
  awardRateTable?: Maybe<AwardRateTable>;
  awardRateTables: Array<AwardRateTable>;
  awards: Array<AwardEntity>;
  /** One account the caller can see — not found otherwise */
  bankingAccount: BankingAccount;
  /** Viewer: feed events whose detail.accountIds names an account the caller can see, newest first */
  bankingAccountActivity: BankingActivityPage;
  /** Admin: who is on this account's grant list */
  bankingAccountViewers: Array<BankingViewer>;
  /** Admin: every discovered account, enabled or not */
  bankingAccounts: Array<BankingAccount>;
  /** Admin: the feed's audit trail, newest first, optionally one kind. limit ≤ 200. */
  bankingActivity: BankingActivityPage;
  /** Admin: one feed event (its page is /banking/activity/:id) */
  bankingActivityEvent: BankingFeedEvent;
  /** Admin: bank accounts whose balance the transactions don't yet explain, biggest first */
  bankingBalanceGaps: Array<BankingBalanceGap>;
  /** Admin: the site's Cash wallet, or null when it has not been created */
  bankingCashWallet?: Maybe<BankingAccount>;
  /** Admin: can this month be closed now? (from the 25th, or any past month) */
  bankingCloseGate: BankingCloseGate;
  /** The rules that ship with the module, used until the site saves its own */
  bankingDefaultIncomeRules: Array<BankingIncomeRule>;
  /** Admin: every gold / bitcoin movement, newest first */
  bankingHoldings: Array<BankingHolding>;
  /** Admin: the site's income rules in rank order (empty = the shipped defaults are in force; see bankingDefaultIncomeRules) */
  bankingIncomeRules: Array<BankingIncomeRule>;
  /** Admin: the loan a transaction sits on, if any */
  bankingLoanForTransaction?: Maybe<BankingLoanView>;
  /** Admin: every IOU, open first, with movements and balances */
  bankingLoans: Array<BankingLoanView>;
  /** Admin: the month's buckets, safe-to-spend and trajectory. Defaults to the current Brisbane month. */
  bankingMonth: BankingMonth;
  /** Admin: this month against the most recent earlier close — did I go forward or backward? */
  bankingMonthComparison: BankingMonthComparison;
  /** Admin: the 12-month strip ending at a month — each month's arrows against the close before it */
  bankingMonthHistory: Array<BankingMonthHistoryRow>;
  /** Admin: the month's money moves in the stated order, with today's one thing */
  bankingMonthJobs: BankingMonthJobsPage;
  /** Admin: every banking notification on the tenant, filterable */
  bankingNotificationLog: BankingNotificationLogPage;
  /** Admin: bills sent and unpaid (owed to you) and drafts not yet sent, largest first. Read-only; marking paid happens in the bills module. */
  bankingOwedToYou: BankingOwedToYou;
  /** Admin: stored prices for one asset over the last N days (max 400), oldest first */
  bankingPrices: Array<BankingPrice>;
  /** Money in / out / net, categories, merchants and a daily series for a Brisbane period over the accounts the caller can see */
  bankingSnapshot: BankingSnapshot;
  /** Admin: money moves that come round on a schedule (rent every Monday), A–Z by title */
  bankingStandingMoves: Array<BankingStandingMove>;
  /** One transaction — not found unless the caller can see its account */
  bankingTransaction: BankingTransaction;
  /** Comments on a transaction, oldest first; withdrawn ones keep their place with no body */
  bankingTransactionComments: Array<BankingTransactionComment>;
  /** Transactions on the accounts the caller can see, newest first (localDate, then transactionAt). limit ≤ 200. */
  bankingTransactions: BankingTransactionPage;
  /** CSV of the transactions the caller can see that match the filter (paging ignored), newest first — the same columns as the platform export. Capped at 5,000 rows with `truncated` set. Each download is recorded in the banking activity log. */
  bankingTransactionsCsv: BankingCsvExport;
  /** Admin: what I have — cash, gold, bitcoin, less what is owed to people — in AUD, USD and gold ounces */
  bankingWealth: BankingWealth;
  bdayGuest?: Maybe<BdayGuest>;
  bdayGuestBySlug?: Maybe<BdayGuest>;
  bdayGuests: Array<BdayGuest>;
  bdayStats: BdayStats;
  bill?: Maybe<Bill>;
  billNotificationRules: Array<BillNotificationRule>;
  billPdf?: Maybe<BillPdfDocumentPayload>;
  bills: Array<Bill>;
  billsEmailBranding?: Maybe<BillsEmailBranding>;
  /** Bills activity over a Brisbane calendar period. Every metric declares the stored fields it came from; a metric the data cannot support returns available=false with a reason rather than a zero. */
  billsReport: BillsReport;
  billsReportingSettings: BillsReportingSettings;
  /** This site's billing defaults (payment terms, due N days after sending). */
  billsSettings: BillsSettings;
  /** Stored weekly snapshots, newest first. Reading this runs the demand-driven catch-up first, so any complete week that has no row yet is written before the list is returned — there is no cron. */
  billsWeeklySnapshots: Array<BillsWeeklySnapshot>;
  bladderRecords: BladderRecordsResponse;
  blogCategories: Array<BlogCategory>;
  blogNotificationRules: Array<BlogNotificationRule>;
  blogPost?: Maybe<BlogPost>;
  /** Public query to get a published blog post by slug */
  blogPostBySlug?: Maybe<BlogPost>;
  /** Public query to get reaction counts for a post */
  blogPostReactions: BlogReactionCounts;
  blogPosts: Array<BlogPost>;
  bloodPressureObservations: BloodPressureObservationsResponse;
  bloodSugarObservations: BloodSugarObservationsResponse;
  bmiHistory: BmiHistoryResponse;
  bond?: Maybe<Bond>;
  bondPayments: Array<BondPayment>;
  bondRegister: BondRegister;
  bookableEventType?: Maybe<BusinessCalendarBookableEventType>;
  bookableEventTypeStats: BookableEventTypeStats;
  bookableEventTypes: Array<BusinessCalendarBookableEventType>;
  bookingById?: Maybe<Booking>;
  bookings: Array<Booking>;
  bookingsByClientId: Array<Booking>;
  bookingsBySession: Array<Booking>;
  bowelRecords: BowelRecordsResponse;
  bpAlertRanges: BpAlertRanges;
  bradenAssessments: BradenAssessmentsResponse;
  browserStats: Array<BrowserStats>;
  bslAlertRanges: BslAlertRanges;
  buildPortalAccess: Array<BuildAccessView>;
  buildPortalBuild: BuildView;
  buildPortalBuilds: Array<BuildListItem>;
  buildPortalEmailTemplates: Array<BuildEmailTemplateView>;
  buildPortalMessages: Array<BuildMessageView>;
  buildPortalPreviewEmailTemplate: BuildEmailTemplatePreview;
  buildPortalProject: BuildProjectView;
  buildPortalSettings: BuildPortalSettings;
  buildPortalTeamOverview: TeamOverviewPreview;
  buildPortalTeamProfile: BuildTeamProfile;
  buildPortalTeamProfiles: Array<BuildTeamProfile>;
  /** Admin: recent chat sessions, newest first (up to `limit`, max 100). */
  businessChatSessions: Array<BusinessChatSession>;
  /** Public: the category list, A–Z (the tenant's own list, else the defaults). */
  businessDirectoryCategories: Array<Scalars['String']['output']>;
  /** Admin: enquiries per (Brisbane) week by channel, chat sessions, hand-offs, per-listing counts, listings missing email/logo. */
  businessDirectoryDashboard: BusinessDirectoryDashboard;
  /** Admin: the directory's notification rules, A–Z by name. */
  businessDirectoryNotificationRules: Array<BusinessDirectoryNotificationRule>;
  /** Admin: enquiries, newest first (paged — see businessEnquiryCount for the total). */
  businessEnquiries: Array<BusinessEnquiry>;
  /** Admin: how many enquiries match the filter (every one, not just a page). */
  businessEnquiryCount: Scalars['Int']['output'];
  /** A listing's history, newest first. Its owner or a directory admin. */
  businessListingActivity: Array<BusinessDirectoryActivity>;
  /** Cross-module: a member's business as another module may show it (logo chip + link). Null when they have none or it is not visible. */
  businessListingForClient?: Maybe<BusinessListingLink>;
  businessSnapshot?: Maybe<BusinessSnapshot>;
  businessSnapshots: Array<BusinessSnapshot>;
  calculateBondInterest: BondInterestResult;
  calculatorStats: CalculatorSubmissionStats;
  calculatorStatsByType: Array<CalculatorTypeStats>;
  calculatorSubmission?: Maybe<CalculatorSubmission>;
  calculatorSubmissions: Array<CalculatorSubmission>;
  calculatorSubmissionsByDay: Array<SubmissionsByDay>;
  calendar?: Maybe<BusinessCalendar>;
  calendarAudienceOptions: CalendarAudienceOptions;
  calendarAudienceShares: Array<CalendarAudienceShareInfo>;
  calendarAvailability?: Maybe<BusinessCalendarAvailability>;
  calendarEvent?: Maybe<CalendarEvent>;
  calendarEventTask?: Maybe<CalendarEventTask>;
  calendarEventTasks: Array<CalendarEventTask>;
  calendarEvents: Array<CalendarEvent>;
  calendarGoal?: Maybe<CalendarGoal>;
  calendarGoals: Array<CalendarGoal>;
  calendarHasAvailability: Scalars['Boolean']['output'];
  calendarInvitations: Array<CalendarInvitation>;
  calendarSearchPeople: Array<CalendarPersonInfo>;
  calendarShares: Array<CalendarShareInfo>;
  calendarTags: Array<CalendarTag>;
  calendars: Array<BusinessCalendar>;
  calendarsOnTenant: Array<BusinessCalendar>;
  callRecording?: Maybe<CallRecording>;
  callRecordings: CallRecordingConnection;
  canInviteCommunityMembersToMeet: Scalars['Boolean']['output'];
  candidate?: Maybe<Candidate>;
  /** Timeline for one candidate, newest first */
  candidateActivity: Array<CandidateActivity>;
  candidateFormById?: Maybe<CandidateForm>;
  candidateFormBySlug?: Maybe<CandidateForm>;
  candidateFormSubmissions: Array<CandidateFormSubmission>;
  candidateForms: Array<CandidateForm>;
  candidateInviteBySlug?: Maybe<PublicCandidateInviteInfo>;
  candidateInvites: Array<CandidateInvite>;
  candidateMessages: Array<CandidateMessage>;
  candidateReferences: Array<CandidateReference>;
  candidates: Array<Candidate>;
  careDayRecords: Array<CareDayRecord>;
  /** One home, or null if it isn't on this site. */
  careHome?: Maybe<CareHome>;
  /** A home's history and contact log, newest first (up to 200). */
  careHomeActivity: Array<CareHomeActivity>;
  /** The states and regions that have homes, A–Z, for the filters. */
  careHomeFilterOptions: CareHomeFilterOptions;
  /** Counts for the dashboard — the same filter as the list, so a count agrees with its rows. */
  careHomeStats: CareHomeStats;
  /** The homes, filtered and sorted, a page at a time. `total` counts every match. */
  careHomes: CareHomePage;
  /** Care-planning requirements: which are law and which are practice, with citation and source link */
  careLegalRequirements: Array<CareLegalRequirement>;
  careMinutesStatement: CareMinutesStatementResult;
  carePlan?: Maybe<CarePlan>;
  carePlanComplianceReport?: Maybe<CarePlanComplianceReport>;
  carePlanCounts: CarePlanCountsByStatus;
  /** A resident's admissions contacts, A–Z, for naming plan participants and copy recipients */
  carePlanPersonOptions: Array<CarePlanPersonOption>;
  carePlanReview?: Maybe<CarePlanReview>;
  carePlanReviews: CarePlanReviewsResponse;
  carePlanRoles: Array<EmployeeRole>;
  carePlanStatistics: CarePlanStatistics;
  carePlanTemplate?: Maybe<CarePlanTemplate>;
  carePlanTemplates: CarePlanTemplatesResponse;
  carePlans: CarePlansResponse;
  carePlansByResident: Array<CarePlan>;
  carePlansReviewsDue: Array<CarePlan>;
  careQuarterTargets: Array<CareQuarterTarget>;
  /** The tenant's care review cycles (days) and where each timing comes from */
  careReviewCycleSettings: CareReviewCycleSettingsView;
  careReviews: CareReviewsResponse;
  certifiedCoachBySlug?: Maybe<CertifiedCoach>;
  certifiedCoaches: Array<CertifiedCoach>;
  channelContentCounts: ChannelContentCountsType;
  charges: Array<Invoice>;
  chargesByClient: Array<Invoice>;
  chaseDraftSendPreview?: Maybe<ChaseDraftSendPreview>;
  chaseNotificationRule?: Maybe<ChaseNotificationRule>;
  chaseNotificationRules: Array<ChaseNotificationRule>;
  chatMessages: Array<ChatMessage>;
  chatParticipants: Array<ChatParticipant>;
  chatRoom?: Maybe<ChatRoom>;
  chatRoomBySlug?: Maybe<ChatRoom>;
  chatRooms: Array<ChatRoom>;
  checkAccountExists?: Maybe<Client>;
  checkDomainAvailability: DomainAvailabilityResult;
  checkIns: Array<CheckIn>;
  checkUsernameAvailable: Scalars['Boolean']['output'];
  chloeMessages: Array<ChloeMessage>;
  chloePendingActions: Array<ChloePendingAction>;
  ciAssignablePeople: Array<CiAssignablePerson>;
  ciGovernanceMeeting?: Maybe<CiGovernanceMeeting>;
  ciGovernanceMeetingStats: CiGovernanceMeetingStats;
  ciGovernanceMeetings: Array<CiGovernanceMeeting>;
  ciImprovementInitiative?: Maybe<CiImprovementInitiative>;
  ciImprovementInitiativeStats: CiInitiativeStats;
  ciImprovementInitiatives: Array<CiImprovementInitiative>;
  ciInitiativesByMaintenanceRequest: Array<CiImprovementInitiative>;
  ciIssueReport?: Maybe<CiIssueReport>;
  ciIssueReportStats: CiIssueReportStats;
  ciIssueReports: Array<CiIssueReport>;
  ciIssuesByInitiative: Array<CiIssueReport>;
  ciMeetingLinkedInitiatives: Array<CiMeetingLinkedInitiative>;
  ciMeetingLinkedIssues: Array<CiMeetingLinkedIssue>;
  ciNotificationRules: Array<CiNotificationRule>;
  ciQualityStandardsSummary: Array<CiQualityStandardSummary>;
  ciStandardMetadata?: Maybe<StandardMetadata>;
  ciStandardsMetadata: Array<StandardMetadata>;
  ciUpcomingMeetings: Array<CiGovernanceMeeting>;
  client?: Maybe<Client>;
  clientActivities: Array<ClientActivity>;
  clientActivity?: Maybe<ClientActivity>;
  clientActivityTypes: Array<Scalars['String']['output']>;
  clientByEmail?: Maybe<Client>;
  clientByPhone?: Maybe<Client>;
  clientCalculatorSubmissions: Array<CalculatorSubmission>;
  clientChaseConfig?: Maybe<ClientChaseConfig>;
  clientChaseConfigs: Array<ClientChaseConfig>;
  clientChaseLogs: Array<ClientChaseLog>;
  clientMentionablePeople: Array<ClientMentionablePerson>;
  clientNotificationRule?: Maybe<ClientNotificationRule>;
  clientNotificationRules: Array<ClientNotificationRule>;
  clientRewardBalance: ClientRewardBalance;
  clientStats: Array<Scalars['Float']['output']>;
  clientStory?: Maybe<ClientStoryPage>;
  clients: Array<Client>;
  clientsByPermissions: Array<Client>;
  clientsByTag: Array<Client>;
  clientsByTenantId: Array<Client>;
  clinicalTasks: ClinicalTasksResponse;
  club52Earnings: Club52EarningsSummary;
  club52FundingPanel: Club52FundingPanel;
  club52GameByRoom?: Maybe<Club52Game>;
  club52Games: Array<Club52Game>;
  club52Issues: Array<Club52Issue>;
  club52Journey: Club52Journey;
  club52PlayerBalances: Array<Club52PlayerBalance>;
  club52Players: Array<Club52Player>;
  club52Settings: Club52Settings;
  club52SetupStatus: Club52SetupStatus;
  club52Stats: Club52Stats;
  club52TreasuryStatus: Club52TreasuryStatus;
  coach?: Maybe<Coach>;
  coachAgreement?: Maybe<CoachAgreement>;
  coachAgreements: Array<CoachAgreement>;
  coaches: Array<Coach>;
  /** Accounting: one entity's coding rules in the order they run (priority, then the more specific text). */
  codingRules: Array<CodingRule>;
  coldStorageEquipment: Array<ColdStorageEquipment>;
  commandActivityComments: Array<CommandActivityComment>;
  commandActivityEntry?: Maybe<CommissionDealActivity>;
  commandActivityPage: CommandActivityPage;
  commandAddressSplitPreview: Array<AddressSplitRow>;
  commandClients: Array<CommandClient>;
  commandCommissionDeal?: Maybe<CommissionDeal>;
  commandCommissionDealActivity: Array<CommissionDealActivity>;
  commandCommissionDeals: CommissionDealsPage;
  commandCommissionOptions: Array<CommissionOption>;
  commandCommissionProjects: Array<CommissionProject>;
  commandCommissionTrends: CommissionTrends;
  commandDeal?: Maybe<CommandDeal>;
  commandDealAccess: CommandDealAccess;
  commandDeals: Array<CommandDeal>;
  commandExecutiveSummary: ExecutiveSummary;
  commandFetchGhlPipelines: Array<CommandGhlPipeline>;
  commandFetchOnePropertyGhlPipelines: Array<CommandGhlPipeline>;
  commandGhlOpportunities: GhlOpportunitiesResult;
  commandIntegrationConfig?: Maybe<CommandIntegrationConfig>;
  commandIntegrationStatus: CommandIntegrationStatus;
  commandMentionablePeople: Array<CommandMentionablePerson>;
  commandNotificationCatalogue: CommandNotificationCatalogue;
  commandNotificationLog: Array<CommandNotificationLog>;
  commandNotificationRules: Array<CommandNotificationRule>;
  commandOpenTags: CommandOpenTags;
  commandPipedrivePanel: PipedrivePanel;
  commandPipedriveSyncSummary: PipedriveSyncSummary;
  commandPreviewRuleAudience: CommandRuleAudiencePreview;
  commandSearchClientsForOptions: Array<CommandClientMatch>;
  commandSummary: CommandSummary;
  commandTagChase: CommandTagChase;
  commandTagChaseRecipients: CommandTagChaseRecipients;
  commandTestSheetConnection: SheetConnectionTest;
  commandWhoCannotSeeDeal: Array<CommandCannotSeeDeal>;
  commandXeroAuthorizeUrl: Scalars['String']['output'];
  commandXeroInvoice?: Maybe<XeroInvoiceDetail>;
  commandXeroSummary: XeroSummary;
  commandXeroTransaction?: Maybe<XeroTransaction>;
  commandXeroTransactions: XeroTransactionsResult;
  commsIsolation: CommsIsolationView;
  commsLogSettings: CommsLogSettingsView;
  commsSmsApps: CommsSmsAppsResult;
  communicationHistory: Array<GrowthEngineCommunication>;
  communicationTask?: Maybe<CommunicationTask>;
  communicationTaskStats: Scalars['Float']['output'];
  communicationTasks: Array<CommunicationTask>;
  communityCampaign: CommunityCampaignDetail;
  communityCampaigns: CommunityCampaignList;
  communityCheckInStatus: CommunityCheckInStatus;
  communityConfig: CommunityConfig;
  communityDefaultNotificationSchedule: Array<CommunityNotificationScheduleRow>;
  communityEntryById?: Maybe<CommunityFeedEntry>;
  communityEntryReplies: Array<CommunityEntryReplyView>;
  communityErasureLog: Array<CommunityErasureLogView>;
  communityErasureNotTouched: Array<Scalars['String']['output']>;
  communityFeedForDate: Array<CommunityFeedEntry>;
  communityGlobeData: Array<CommunityGlobeCountryPoint>;
  communityInviteGraph: Array<CommunityInviteGraphNode>;
  communityInvites: Array<CommunityInvite>;
  communityLeaderboard: CommunityLeaderboard;
  communityMemberCount: Scalars['Float']['output'];
  communityMembers: Array<CommunityMemberRow>;
  communityMentionablePeople: Array<CommunityMentionablePerson>;
  communityPinnedVideoViews: CommunityPinnedVideoViews;
  communityPostById?: Maybe<CommunityPostView>;
  communityPostComments: Array<CommunityPostCommentView>;
  communityPosts: CommunityPostPage;
  companies: Array<Company>;
  company?: Maybe<Company>;
  companyCalendars: Array<BusinessCalendar>;
  companyKnowledgeArticle?: Maybe<CompanyKnowledge>;
  companyKnowledgeArticles: Array<CompanyKnowledge>;
  companyStats: Array<Scalars['Float']['output']>;
  compareAssessmentSnapshots: Array<AssessmentSnapshot>;
  compareSnapshots: Array<HolisticSnapshot>;
  competition?: Maybe<Competition>;
  competitionActivity: CompetitionActivityPage;
  competitionEntries: Array<CompetitionEntry>;
  competitionPrintLedger: CompetitionPrintLedger;
  competitionPrintOffers: Array<CompetitionPrintOffer>;
  competitionPrintsAvailable: CompetitionPrintsAvailability;
  competitionSchool?: Maybe<CompetitionSchool>;
  competitionSchools: Array<CompetitionSchool>;
  competitionSponsors: Array<CompetitionSponsor>;
  competitions: Array<Competition>;
  comprehensiveMedicalAssessment?: Maybe<ComprehensiveMedicalAssessment>;
  comprehensiveMedicalAssessments: ComprehensiveMedicalAssessmentsResponse;
  constructionSite?: Maybe<ConstructionSite>;
  constructionSites: Array<ConstructionSite>;
  contactFormSubmissions: Array<ContactFormSubmission>;
  contributingFactors: Array<ContributingFactor>;
  coupon?: Maybe<Coupon>;
  coupons: Array<Coupon>;
  crazytelSetupStatus: CrazytelSetupStatus;
  crewSitesByPhone: Array<CrewSiteView>;
  cryptoVault?: Maybe<CryptoVault>;
  cryptoVaults: Array<CryptoVault>;
  currentBMI: CurrentBmi;
  currentFortnight?: Maybe<FortnightWindow>;
  currentLeaves: ResidentLeaveList;
  currentMedications: Array<Medication>;
  currentMonthGoals: Array<CalendarGoal>;
  currentResidents: Array<Resident>;
  currentRespiteResidents: Array<RespiteCareBooking>;
  currentTenant?: Maybe<Tenant>;
  custodyValidator?: Maybe<CustodyValidator>;
  custodyValidators: Array<CustodyValidator>;
  customQuestions: Array<IncidentCustomQuestion>;
  customTestDefinitions: Array<CustomTestDefinition>;
  dailyAllocationSheet?: Maybe<DailyAllocationSheet>;
  dailyAllocationStalenessForWeek: Array<DailyAllocationStaleness>;
  dailyCareHeadingConfig?: Maybe<DailyCareHeadingConfig>;
  dailyCareHeadings: ResolvedDailyCareHeadings;
  dailyCareProfile?: Maybe<DailyCareProfile>;
  dailyCareProfileById?: Maybe<DailyCareProfile>;
  dailyCareProfiles: DailyCareProfilesResponse;
  dailyCareProfilesByType: Array<DailyCareProfile>;
  dailyJobs: Array<Job>;
  dayBookEntries: DayBookEntriesResponse;
  dayBookEntriesSinceLastSignOff: Array<DayBookEntry>;
  dayBookSignOffHistory: DayBookSignOffHistoryResponse;
  defaultLifeAspects: Array<LifeAspect>;
  department?: Maybe<Department>;
  departmentLeaveRequests: Array<DepartmentLeaveEntry>;
  departments: Array<Department>;
  deviceStats: Array<DeviceStats>;
  digitalManager?: Maybe<DigitalManager>;
  digitalManagerChases: Array<DigitalManagerChaseItem>;
  digitalManagerMemories: Array<DigitalManagerMemory>;
  digitalManagerMemory?: Maybe<DigitalManagerMemory>;
  digitalManagerNotificationRule?: Maybe<DigitalManagerNotificationRule>;
  digitalManagerNotificationRules: Array<DigitalManagerNotificationRule>;
  digitalManagerOQs: Array<DigitalManagerOutstandingQuestion>;
  digitalManagerRule?: Maybe<DigitalManagerRule>;
  digitalManagerRules: Array<DigitalManagerRule>;
  digitalManagerSession?: Maybe<DigitalManagerSession>;
  digitalManagerSessions: Array<DigitalManagerSession>;
  digitalManagerStandups: Array<DigitalManagerStandup>;
  digitalManagerTemplate?: Maybe<DigitalManagerTemplate>;
  digitalManagerTemplateByKey?: Maybe<DigitalManagerTemplate>;
  digitalManagerTemplates: Array<DigitalManagerTemplate>;
  digitalManagers: Array<DigitalManager>;
  distinctSenders: Array<SenderSummary>;
  domain?: Maybe<Domain>;
  domainDnsRecords: Array<DomainDnsRecord>;
  domainHealth: DomainHealthStatus;
  domains: Array<Domain>;
  dressingSchedules: Array<DressingSchedule>;
  droneIncompleteSessions: Array<DroneSession>;
  droneSession?: Maybe<DroneSession>;
  droneSessionBySessionId?: Maybe<DroneSession>;
  droneSessionFiles: Array<FileTransfer>;
  droneSessionProgress?: Maybe<SessionProgress>;
  droneSessions: Array<DroneSession>;
  droneSessionsWithPagination: DroneSessionListResult;
  droneUploadStats: DroneUploadStats;
  duplicateCandidates: Array<DuplicateCandidate>;
  email: Email;
  emailAddress?: Maybe<EmailAddress>;
  emailAddressStats: EmailAddressStats;
  emailAddresses: Array<EmailAddress>;
  emailAiMemories: Array<EmailAiMemory>;
  emailAiMemory?: Maybe<EmailAiMemory>;
  emailAiOutstandingQuestions: Array<EmailAiOutstandingQuestion>;
  emailAiProactiveSettings: EmailAiProactiveSettings;
  emailAiProcessingLog?: Maybe<EmailAiProcessingLog>;
  emailAiProcessingLogs: Array<EmailAiProcessingLog>;
  emailAiRule?: Maybe<EmailAiRule>;
  emailAiRules: Array<EmailAiRule>;
  emailBacklogJob?: Maybe<EmailBacklogJob>;
  emailBacklogJobs: Array<EmailBacklogJob>;
  emailCalendars: Array<BusinessCalendar>;
  emailHealthAllTenants: Array<EmailHealthTenantRow>;
  emailHealthStatus: EmailHealthStatus;
  emailHealthWeeklyReportHtml: Scalars['String']['output'];
  emailInbox: Array<InboundEmail>;
  emailInboxPaginated: PaginatedInboundEmails;
  emailSenders: Array<Scalars['String']['output']>;
  emailThread: Array<EmailThreadMessage>;
  emailTrainingSessionSummary: Array<EmailTrainingSessionSummary>;
  emails: Array<Email>;
  emailsDraft: Array<Email>;
  emailsSent: Array<Email>;
  emergencyContacts: Array<ResidentContact>;
  employee?: Maybe<Employee>;
  employeeActivities: Array<EmployeeActivity>;
  employeeActivity?: Maybe<EmployeeActivity>;
  /** Comments on one activity entry or one attachment (permission-scoped through the employee). */
  employeeActivityComments: Array<EmployeeActivityComment>;
  employeeActivityTags: Array<EmployeeActivityTag>;
  employeeActivityTypes: Array<Scalars['String']['output']>;
  employeeAdpFormStatus?: Maybe<AdpFormStatus>;
  employeeByEmail?: Maybe<Employee>;
  employeeChecklistTemplates: Array<EmployeeChecklistWithItems>;
  employeeChecklists: Array<EmployeeChecklistWithItems>;
  /** JSON object of the contract merge values the offer form can DERIVE from what it already holds (jobTitle, awardClassification, baseHourlyRate, minimumHoursPerWeek, probationMonths, commencementDate, offerDate, employee name/email). The form shows these pre-filled and only asks for the rest. */
  employeeContractDerivedValues: Scalars['String']['output'];
  /** Employer letterhead for contracts — the employer Company (Employees → Onboarding Forms), else the site branding. */
  employeeContractLetterhead: EmployeeContractLetterhead;
  employeeContractTemplate?: Maybe<EmployeeContractTemplate>;
  employeeContractTemplates: Array<EmployeeContractTemplate>;
  /** AHPRA / CPR / first-aid expiries and police-check age (3-year cycle) for every active employee. Returns EXPIRED, EXPIRING (within `withinDays`) and MISSING rows; pass includeOk to also list the OK ones. */
  employeeCredentialExpiries: Array<EmployeeCredentialExpiryRow>;
  /** Per-tenant onboarding form settings (both form types, defaults created on first read). */
  employeeFormSettings: Array<EmployeeFormSetting>;
  employeeIncident?: Maybe<EmployeeIncident>;
  employeeIncidentNotificationRules: Array<EmployeeIncidentNotificationRule>;
  employeeIncidents: EmployeeIncidentsResponse;
  /** One invite's contract as a full page for the manager: the signed text once signed, else the current render (employee address as a placeholder). Null when the invite has no contract. */
  employeeInviteContract?: Maybe<EmployeeInviteContractView>;
  employeeInvites: Array<EmployeeInvite>;
  /** How one employee's leave balance is worked out, pay run by pay run, up to a pay run (yyyy-MM-dd) or today. Null = no such employee on this site. */
  employeeLeaveBalanceWorking?: Maybe<LeaveBalanceWorkingResult>;
  /** Leave balances for these employees, or every current employee when none are named. Sorted A–Z by name. */
  employeeLeaveBalances: Array<EmployeeLeaveBalance>;
  /** This site's employees-module settings. Null when never configured. */
  employeeModuleSettings?: Maybe<EmployeeModuleSetting>;
  employeeNotificationRules: Array<EmployeeNotificationRule>;
  /** Onboarding checklist for an EXISTING employee (profile sections + required sign-forms) — same formulas as invite progress. */
  employeeOnboardingStatus: EmployeeOnboardingProgress;
  employeePosition?: Maybe<EmployeePosition>;
  employeePositions: Array<EmployeePosition>;
  employeeReadiness: Array<EmployeeReadinessRow>;
  employeeRecommendation?: Maybe<EmployeeRecommendation>;
  /** Candidate recommendations received from partner tenants, newest first. */
  employeeRecommendations: Array<EmployeeRecommendation>;
  employeeRole?: Maybe<EmployeeRole>;
  employeeRoles: Array<EmployeeRole>;
  employeeShiftHoursContext: Array<EmployeeShiftHoursContext>;
  /** Signed onboarding forms for an employee (HR-finance gated — records carry TFN data). */
  employeeSignedForms: Array<EmployeeSignedForm>;
  employeeStats: Array<Scalars['Float']['output']>;
  employeeStatusOptions: Array<EmployeeStatusOption>;
  employeeTrainingAssignment?: Maybe<EmployeeTrainingAssignment>;
  employeeTrainingAssignments: Array<EmployeeTrainingAssignment>;
  employeeTrainingCategories: Array<EmployeeTrainingCategory>;
  employeeTrainingDashboard: EmployeeTrainingDashboard;
  employees: Array<Employee>;
  employeesByClient: Array<Employee>;
  employeesPaginated: PaginatedEmployeesResponse;
  empowermentActivity: EmpowermentActivityPage;
  empowermentCapabilities: EmpowermentCapabilities;
  empowermentCatchUps: Array<EmpowermentCatchUp>;
  empowermentCheckIn?: Maybe<EmpowermentCheckIn>;
  empowermentCheckInQuestions: Array<EmpowermentQuestion>;
  empowermentCheckIns: EmpowermentCheckInPage;
  empowermentEmployeeSummary?: Maybe<EmpowermentJourneySummary>;
  empowermentEnrolDefaults: EmpowermentEnrolDefaults;
  empowermentGoals: Array<EmpowermentGoal>;
  empowermentGrowth: EmpowermentGrowth;
  empowermentJourney?: Maybe<EmpowermentJourney>;
  empowermentJourneyCheckIns: Array<EmpowermentCheckIn>;
  empowermentJourneys: EmpowermentJourneyPage;
  empowermentLinkableTranscriptions: Array<EmpowermentTranscriptionOption>;
  empowermentModuleEnabled: Scalars['Boolean']['output'];
  empowermentMyJourney?: Maybe<EmpowermentJourney>;
  empowermentMySummary?: Maybe<EmpowermentJourneySummary>;
  empowermentPeopleFilter: EmpowermentPeopleFilter;
  empowermentPeopleNotOnJourney: Array<EmpowermentPersonGap>;
  empowermentPeopleSearch: Array<EmpowermentPersonOption>;
  empowermentPromptLog: Array<EmpowermentPromptLog>;
  empowermentQuestions: Array<EmpowermentQuestion>;
  empowermentReflections: Array<EmpowermentReflectionView>;
  empowermentSettings: EmpowermentSettings;
  empowermentStartDatePreview: EmpowermentSchedulePreview;
  empowermentTeamInsights: EmpowermentTeamInsights;
  energyTrackerNotificationRules: Array<EnergyTrackerNotificationRule>;
  eventBillSummary?: Maybe<EventBillSummary>;
  eventRegistration?: Maybe<EventRegistration>;
  eventRegistrationStats: EventRegistrationStats;
  eventRegistrations: Array<EventRegistration>;
  eventStats: Array<EventStats>;
  everyoneVisionBoards: Array<VisionBoardSummary>;
  exceptionReport: ExceptionReport;
  exceptionWingCounts: Array<ExceptionWingCount>;
  exportIncidentsCSV: Scalars['String']['output'];
  exportMedicalAuditLogs: Array<MedicalAuditLog>;
  /** Build an ADP-compatible CSV for a PayRun (DETAILED = per-element rows, SUMMARY = per-employee rows) */
  exportPayRunAdpCsv: AdpCsvExportResult;
  /** Export project tasks to unified markdown format */
  exportProjectTasksToMarkdown: Scalars['String']['output'];
  /** Download every registered dataset as CSV, one result per dataset. */
  exportTenantAllCsv: Array<TenantCsvExportResult>;
  /** Download one dataset (by manifest key) as CSV. */
  exportTenantModuleCsv: TenantCsvExportResult;
  expressionsOfInterest: Array<ExpressionOfInterest>;
  /** Extract requested fields from a voice-agent transcript (public). Returns a JSON object string. */
  extractAgentFields: Scalars['String']['output'];
  farmerByTenant?: Maybe<Farmer>;
  farmers: Array<Farmer>;
  farmersByTenant: Array<Farmer>;
  feedbackActivities: FeedbackActivityPage;
  feedbackByMealPlan: Array<MealFeedback>;
  feedbackByRecipe: Array<MealFeedback>;
  feedbackHandlers: Array<FeedbackPerson>;
  feedbackItem?: Maybe<FeedbackItem>;
  feedbackItems: FeedbackPage;
  feedbackLinkCandidates: Array<FeedbackLinkCandidate>;
  feedbackLinkedTo: Array<FeedbackLinkRef>;
  feedbackNotificationRules: Array<FeedbackNotificationRule>;
  feedbackRegisterStats: FeedbackRegisterStats;
  feedbackSettings: FeedbackSettings;
  feedbackStats: FeedbackStats;
  fetchGhlPipelines: Array<GhlPipelineResult>;
  fileTransfer?: Maybe<FileTransfer>;
  fileTransfers: Array<FileTransfer>;
  financialActivities: Array<PartsOrder>;
  financialActivityReport: FinancialActivityReport;
  findDuplicateEmployees: Array<DuplicateEmployeeGroup>;
  findPotentialDuplicateClients: Array<ClientDuplicateGroup>;
  findPotentialDuplicates: Array<PotentialDuplicateGroup>;
  /** Brisbane-day totals of the fluid balance chart, newest day first */
  fluidBalanceDays: FluidBalanceDaysResponse;
  /** Fluid balance chart entries, newest first, with the total stated */
  fluidBalanceEntries: FluidBalanceEntriesResponse;
  foodBudget: FoodBudget;
  foodBudgetSummary: FoodBudgetSummary;
  /** Food intake chart days, newest first, with the total stated */
  foodIntakeDays: FoodIntakeDaysResponse;
  foodSpendByCategory: Array<FoodSpendByCategoryRow>;
  foodSpendBySupplier: Array<FoodSpendBySupplierRow>;
  frontendUpgrade?: Maybe<FrontendUpgrade>;
  frontendUpgradeStats: UpgradeStats;
  frontendUpgrades: Array<FrontendUpgrade>;
  fuelReadings: Array<FuelReading>;
  fuelStation?: Maybe<FuelStation>;
  fuelStations: Array<FuelStation>;
  generateChefCheatSheet: PdfResult;
  generateDailyMenuPDF: PdfResult;
  generateEmployeeAdpForm?: Maybe<GeneratedAdpForm>;
  /** Leave Liability CSV — one row per (employee, leave type) */
  generateLeaveLiabilityCsv: ReportCsvResult;
  /** Leave Liability PDF — accrued × hourly rate per employee + leave type. Point-in-time as at now. */
  generateLeaveLiabilityPdf: ReportPdfResult;
  generateMealPlanRangePDF: PdfResult;
  generateOrderPDF: OrderPdfResult;
  /** Generate the ABA EFT file for this PayRun (requires PaySettings.tenantBank* + each employee bankBSB / bankAccountNumber) */
  generatePayRunAbaFile: AbaFileResult;
  /** Generate the ERC PDF (one or more employees from a PayRun) */
  generatePayRunErcPdf: ErcPdfResultGql;
  generatePaygSummaryCsv: ReportCsvResult;
  /** PAYG Withholding Summary PDF — per-employee + tenant total for a date range. Drives BAS / IAS W1 + W2 labels. Defaults to current calendar month. */
  generatePaygSummaryPdf: ReportPdfResult;
  /** Generate the Payroll Journal PDF — per-employee pay-element lines (Hours × Rate = Value) with This-Pay and Year-to-Date columns, mirroring the ADP Payline PAJ report Abby reconciles against. */
  generatePayrollJournalPdf: ErcPdfResultGql;
  /** Generate the Payroll Register CSV (one row per employee, all fields) */
  generatePayrollRegisterCsv: AdpCsvExportResult;
  /** Generate the Payroll Register PDF (one row per employee, grouped by award) */
  generatePayrollRegisterPdf: ErcPdfResultGql;
  /** Generate a single-employee payslip PDF for a PayRun */
  generatePayslipPdf: ErcPdfResultGql;
  generateSuperLiabilityCsv: ReportCsvResult;
  /** Super Liability PDF — per-fund SG totals for a date range. Defaults to current calendar quarter. */
  generateSuperLiabilityPdf: ReportPdfResult;
  generatedDailyAllocationOds: GeneratedDailyAllocationOds;
  generatedFortnightlyRosterXlsx: GeneratedRosterXlsx;
  generatedWeeklyAllocationXlsx: GeneratedDailyAllocationOds;
  /** Get a named Dograh agent's config for the current tenant (public, tenant-scoped) */
  getAgentConfig: DograhConfig;
  getAllProposalSignatures: Array<ProposalSignature>;
  getAllProposals: Array<Proposal>;
  getAvailabilityByPractitionerId: Array<Availability>;
  getAwardVersionForDate?: Maybe<AwardVersion>;
  getBillCompany?: Maybe<Company>;
  getBillIssuerDetails?: Maybe<Client>;
  getBillToCompany?: Maybe<Company>;
  getBookingByToken?: Maybe<CalendarEvent>;
  getBookingCalendarUrl: Scalars['String']['output'];
  getBookingsByPractitionerId: Array<Booking>;
  getCalendarsByIds: Array<BusinessCalendar>;
  getClientDetailsByBillId?: Maybe<Client>;
  getCoreActivities: Array<RdActivity>;
  /** Get Dograh voice-AI configuration for the current tenant (public, tenant-scoped) */
  getDograhConfig: DograhConfig;
  getEventDetails?: Maybe<CalendarEvent>;
  getExternalCalendars: Array<BusinessCalendar>;
  /** Get curated farm and agriculture images */
  getFarmImages: ImageSearchResult;
  getFarmerById?: Maybe<Farmer>;
  getFile: Scalars['String']['output'];
  getFiles: Array<Scalars['String']['output']>;
  getLinkedEmailForCalendar?: Maybe<Scalars['String']['output']>;
  getLocationQRCode?: Maybe<DailyQrCode>;
  getMyEmployeeIncidents: Array<EmployeeIncident>;
  /** Get optimized image URL with specific dimensions */
  getOptimizedImageUrl: Scalars['String']['output'];
  getProposal?: Maybe<Proposal>;
  getProposalBySlug?: Maybe<Proposal>;
  getProposalSignature?: Maybe<ProposalSignature>;
  getProposalSignatures: Array<ProposalSignature>;
  getRDActivities: Array<RdActivity>;
  getRDActivity?: Maybe<RdActivity>;
  getRDCommunicationLogs: Array<RdCommunicationLog>;
  getRDEvidence: Array<RdEvidence>;
  getRDProject?: Maybe<RdProject>;
  getRDProjectGapAnalysis: RdGapAnalysisResult;
  getRDProjectTotalHours: Scalars['Float']['output'];
  getRDProjects: Array<RdProject>;
  getRDProjectsByStatus: Array<RdProject>;
  getRDTimeEntries: Array<RdTimeEntry>;
  /** Get a random farm/agriculture image */
  getRandomFarmImage?: Maybe<SearchImage>;
  getTenantStripePublicKey?: Maybe<Scalars['String']['output']>;
  getTenantTwilioAccountSid?: Maybe<Scalars['String']['output']>;
  getTenantTwilioAuthToken?: Maybe<Scalars['String']['output']>;
  getTenantUnsplashAccessKey?: Maybe<Scalars['String']['output']>;
  getTenantUnsplashConfig?: Maybe<TenantApiKeys>;
  getTenantUnsplashSecretKey?: Maybe<Scalars['String']['output']>;
  getTenantVapiAssistantId?: Maybe<Scalars['String']['output']>;
  getTenantVapiPrivateApiKey?: Maybe<Scalars['String']['output']>;
  getTenantVapiPublicApiKey?: Maybe<Scalars['String']['output']>;
  /** Get Twilio Access Token for browser calling */
  getTwilioAccessToken: Scalars['String']['output'];
  /** Get a single Vapi call log by ID */
  getVapiCallLog?: Maybe<VapiCallLog>;
  /** Get Vapi call logs */
  getVapiCallLogs: Array<VapiCallLog>;
  /** Get Vapi configuration for the current tenant */
  getVapiConfig: VapiConfig;
  /** Get the current user's Vapi session ID */
  getVapiSessionId?: Maybe<Scalars['String']['output']>;
  /** Get Vapi workflows */
  getVapiWorkflows: Array<VapiWorkflow>;
  githubCollaborators: Array<Scalars['String']['output']>;
  glasgowComaScaleOptions: GlasgowComaScaleOptions;
  goalAction?: Maybe<GoalAction>;
  goalActions: Array<GoalAction>;
  goalMonthComparison: GoalMonthComparison;
  goalReward?: Maybe<GoalReward>;
  goalRewards: Array<GoalReward>;
  goalStatistics: Scalars['String']['output'];
  goalStats: GoalStats;
  goalsBySnapshot: Array<AccountabilityGoal>;
  goalsForMonth: Array<CalendarGoal>;
  govActiveMemberCount: Scalars['Int']['output'];
  govActivity: Array<GovActivity>;
  govActivityComments: Array<GovActivityComment>;
  govActivityEntry?: Maybe<GovActivity>;
  govActivityPage: GovActivityPage;
  govApplications: Array<GovMembershipApplication>;
  govChecklistItems: Array<GovChecklistItem>;
  govChecklists: Array<GovChecklist>;
  govDecisions: Array<GovDecision>;
  govDefaultNotificationSchedule: Array<GovNotificationScheduleRow>;
  govDelegationCounts: Array<GovDelegationCount>;
  govInviteGraph: Array<GovInviteGraphNode>;
  govInvites: Array<GovInvite>;
  govJobMarketplace: Array<GovJobSpec>;
  govJobSpec?: Maybe<GovJobSpec>;
  govJobSpecs: Array<GovJobSpec>;
  govJoinOptions: GovJoinOptions;
  govListCaps: GovListCaps;
  govMembers: Array<GovMember>;
  govMembershipPlans: Array<GovMembershipPlan>;
  govMembershipRegister: GovMembershipRegister;
  govMentionablePeople: Array<GovMentionablePerson>;
  govNotificationRules: Array<GovNotificationRule>;
  govOrganisation?: Maybe<GovOrganisation>;
  govOrganisationDeleteCheck: GovOrganisationDeleteCheck;
  govOrganisationDraftDiff?: Maybe<GovRulesDiff>;
  govOrganisationEntry?: Maybe<GovOrganisationEntry>;
  govOrganisationRevisionDiff?: Maybe<GovRulesDiff>;
  govOrganisationRevisions: Array<GovOrganisationRevision>;
  govOrganisations: Array<GovOrganisation>;
  govParticipants: Array<GovParticipation>;
  govProposal?: Maybe<GovProposal>;
  govProposalRevisions: Array<GovProposalRevision>;
  govProposalTally?: Maybe<GovTallyResult>;
  govProposals: Array<GovProposal>;
  govTokenGrants: Array<GovTokenGrant>;
  govTreasuryAccounts: Array<GovTreasuryAccount>;
  govTreasuryMovements: Array<GovTreasuryMovement>;
  govVotes: Array<GovVote>;
  govWorkClaims: Array<GovWorkClaim>;
  govWorkItem?: Maybe<GovWorkItem>;
  govWorkItems: Array<GovWorkItem>;
  govWorkProofs: Array<GovWorkProof>;
  graphExtractJob?: Maybe<GraphExtractJob>;
  graphExtractJobs: Array<GraphExtractJob>;
  growthEngineClientTags: Array<Scalars['String']['output']>;
  growthEngineConfigs: Array<GrowthEngineConfig>;
  harvestFailures: Array<HarvestFailureGroup>;
  harvestSource?: Maybe<HarvestSource>;
  harvestSources: Array<HarvestSource>;
  harvestedVideo?: Maybe<HarvestedVideo>;
  harvestedVideos: Array<HarvestedVideo>;
  hasAssignedEmailAddress: Scalars['Boolean']['output'];
  heightObservations: HeightObservationsResponse;
  helpAssistantStatus: HelpAssistantStatus;
  historicalAssessmentInstruments: Array<HistoricalInstrumentSummary>;
  historicalAssessments: HistoricalAssessmentPage;
  holisticSnapshot?: Maybe<HolisticSnapshot>;
  holisticSnapshots: Array<HolisticSnapshot>;
  hostingAffiliate?: Maybe<HostingAffiliate>;
  hostingAffiliates: Array<HostingAffiliate>;
  hostingBuildLog: HostingBuildLog;
  hostingCommissionPayments: Array<HostingCommissionPayment>;
  hostingDeployRuns: Array<HostingDeployRun>;
  hostingOffer?: Maybe<HostingOffer>;
  hostingOffers: Array<HostingOffer>;
  hostingReferrals: Array<HostingReferral>;
  hostingSite?: Maybe<HostingSite>;
  hostingSiteBuilds: HostingBuildsResult;
  hostingSites: Array<HostingSite>;
  /** Fetch all ImprovMX aliases with assignment info */
  improvmxAliases: Array<ImprovMxAliasInfo>;
  inboundEmail?: Maybe<InboundEmail>;
  inboundEmailThread: Array<InboundEmail>;
  inboundEmails: Array<InboundEmail>;
  inboundEmailsByCalendarEvent: Array<InboundEmail>;
  inboundEmailsForOpportunity: Array<InboundEmail>;
  inboundSearchBreakdown: InboundSearchBreakdown;
  inboxFolderCounts: Array<InboxFolderCount>;
  inboxStats: InboxStats;
  inboxSummaries: Array<InboxSummary>;
  inboxSummary?: Maybe<InboxSummary>;
  inboxSummaryPreference: InboxSummaryPreference;
  incident?: Maybe<Incident>;
  incidentAlerts: AlertsResponse;
  incidentAlertsSummary: AlertsSummary;
  incidentContributingFactorTrend: Array<ContributingFactorTrend>;
  incidentCustomAnswers: Array<CustomAnswerWithQuestion>;
  incidentDailyTrend: Array<DailyTrendDataPoint>;
  incidentDocuments: DocumentsResponse;
  incidentFollowUps: FollowUpsResponse;
  incidentInjuries: Array<IncidentInjury>;
  incidentLocationTrend: Array<LocationWingTrend>;
  incidentLocations: Array<IncidentLocation>;
  incidentLocationsByWing: Array<IncidentLocation>;
  incidentMonthlyTrend: Array<MonthlyTrendDataPoint>;
  incidentRiskAssessment?: Maybe<IncidentRiskAssessment>;
  incidentSummary: IncidentSummary;
  incidentTreatmentPlan?: Maybe<IncidentTreatmentPlan>;
  incidentTypes: Array<IncidentType>;
  incidentUnreadAlertCount: Scalars['Int']['output'];
  incidentWitnesses: WitnessesResponse;
  incidents: IncidentsResponse;
  incomingDeliveryTemperature?: Maybe<IncomingDeliveryTemperature>;
  incomingDeliveryTemperatures: Array<IncomingDeliveryTemperature>;
  incompleteTasks: Array<CalendarEventTask>;
  influenceSummary: InfluenceSummary;
  influencer?: Maybe<Influencer>;
  influencerBooking?: Maybe<InfluencerBooking>;
  influencerBookings: Array<InfluencerBooking>;
  influencers: Array<Influencer>;
  ingredient?: Maybe<Ingredient>;
  ingredients: Array<Ingredient>;
  ingredientsByCategory: Array<Ingredient>;
  ingredientsBySupplier: Array<Ingredient>;
  investmentProject?: Maybe<InvestmentProject>;
  investmentProjects: Array<InvestmentProject>;
  investor?: Maybe<Investor>;
  investorExpressions: Array<ExpressionOfInterest>;
  investorPipelineCounts: Array<InvestorPipelineCount>;
  investors: Array<Investor>;
  invoice?: Maybe<FoodInvoice>;
  invoices: Array<FoodInvoice>;
  invoicesByClient: Array<Invoice>;
  ipfsNodes: Array<IpfsNode>;
  isAiServiceConfigured: Scalars['Boolean']['output'];
  isFileDuplicate: Scalars['Boolean']['output'];
  job?: Maybe<Job>;
  jobVehicle?: Maybe<JobVehicle>;
  jobVehicleByRego?: Maybe<JobVehicle>;
  jobVehicles: Array<JobVehicle>;
  jobs: Array<Job>;
  jobsAll: Array<MechanicJob>;
  jobsByCategory: Array<Job>;
  jobsByDateRange: Array<MechanicJob>;
  jobsByFrequency: Array<Job>;
  jobsByLocation: Array<Job>;
  jobsByMechanic: Array<MechanicJob>;
  jobsByPriority: Array<Job>;
  jobsByStatus: Array<MechanicJob>;
  jobsForDay: Array<Job>;
  journeyTemplate?: Maybe<JourneyTemplate>;
  journeyTemplates: Array<JourneyTemplate>;
  knowledgeRootInfo: KnowledgeRootInfo;
  latestAssessmentSnapshot?: Maybe<AssessmentSnapshot>;
  latestClientNotes: Array<ClientLatestNote>;
  latestMoodEntry?: Maybe<MoodEntry>;
  latestNeurologicalObservation?: Maybe<NeurologicalObservation>;
  latestSnapshot?: Maybe<HolisticSnapshot>;
  latestTemperatures: Array<TemperatureLog>;
  launchSiteDeployments: Array<DeploymentInfo>;
  launchSiteDomains: Array<VercelDomainInfo>;
  launchedSite?: Maybe<LaunchedSite>;
  launchedSites: Array<LaunchedSite>;
  lead?: Maybe<Lead>;
  leadFlowActionLogs: Array<LeadFlowActionLog>;
  leadFlowActions: Array<LeadFlowAction>;
  leadFlowEmailBranding?: Maybe<LeadFlowEmailBranding>;
  leadFlowEnrolments: Array<LeadFlowEnrolment>;
  leadFlowForm?: Maybe<LeadFlowForm>;
  leadFlowForms: Array<LeadFlowForm>;
  leadFlowNotificationRules: Array<LeadFlowNotificationRule>;
  leadFlowSequences: Array<LeadFlowSequence>;
  leadFlowStages: Array<LeadFlowStage>;
  leadStats: LeadStats;
  leads: Array<Lead>;
  leaveAffectedShifts: Array<LeaveAffectedShift>;
  leaveAvailability: Array<LeaveAvailabilityDay>;
  /** @deprecated Retired 6 Oct 2026 — read employeeLeaveBalances (shifts module, the leave source of truth). */
  leaveBalance?: Maybe<LeaveBalance>;
  /** The pay runs a leave balance can be shown as at — from the ADP opening to the last completed pay run, newest first */
  leaveBalancePayRuns: Array<LeavePayRunChoice>;
  /** @deprecated Retired 6 Oct 2026 — read employeeLeaveBalances (shifts module, the leave source of truth). */
  leaveBalances: Array<LeaveBalance>;
  leaveConflictCheck: Array<LeaveConflictDay>;
  leaveCoverageAnalysis: LeaveCoverageAnalysis;
  leaveRequest?: Maybe<LeaveRequest>;
  leaveRequests: Array<LeaveRequest>;
  leaveRequestsByDateRange: Array<LeaveRequest>;
  leaveStatistics: LeaveStatistics;
  /** Accounting: one entity's chart of accounts, in code order. */
  ledgerAccounts: Array<LedgerAccount>;
  lifeAspect?: Maybe<LifeAspect>;
  lifeAspects: Array<LifeAspect>;
  lifeGoalLinkedCalendarGoals: Array<CalendarGoal>;
  lmGetAllEnrollments: Array<LmEnrollment>;
  lmGetAnalytics: LmOverallAnalytics;
  lmGetCertificate?: Maybe<LmCertificate>;
  lmGetCourse?: Maybe<LmCourse>;
  lmGetCourseByIdentifier?: Maybe<LmCourse>;
  lmGetCourseSubscriptionLinks: Array<LmCourseSubscriptionLink>;
  lmGetCourses: Array<LmCourse>;
  lmGetEnrollment?: Maybe<LmEnrollment>;
  lmGetEnrollmentsByUserId: Array<LmEnrollment>;
  lmGetLesson?: Maybe<LmLesson>;
  lmGetLessons: Array<LmLesson>;
  lmGetModule?: Maybe<LmModule>;
  lmGetModules: Array<LmModule>;
  lmGetMyEnrollments: Array<LmEnrollment>;
  lmGetPublicCourse?: Maybe<LmCourse>;
  lmGetPublicCourses: Array<LmCourse>;
  lmGetSkinPreference: Scalars['String']['output'];
  lmGetUserCertificates: Array<LmCertificate>;
  lmGetUserProgress: Scalars['Float']['output'];
  lmSearchCourseAuthors: Array<LmCourseAuthor>;
  lmSettings: LmSettings;
  localAiRuntime: LocalAiRuntime;
  /** Get a specific local session by ID */
  localDroneSession?: Maybe<LocalSessionInfo>;
  /** Scan local staging folder for sessions (development only) */
  localDroneSessions: Array<LocalSessionInfo>;
  /** Get upload progress for a session */
  localSessionUploadProgress?: Maybe<UploadProgressResult>;
  location?: Maybe<Location>;
  locationByCode?: Maybe<Location>;
  locationChildren: Array<Location>;
  locationStats: Array<Scalars['Float']['output']>;
  locations: Array<Location>;
  locationsByDepartment: Array<Location>;
  locationsByType: Array<Location>;
  loginActivities: Array<LoginActivity>;
  lowRatedFeedback: Array<MealFeedback>;
  mailboxAccounts: Array<MailboxAccount>;
  maintenanceActivities: MaintenanceActivityPage;
  maintenanceNotificationRules: Array<MaintenanceNotificationRule>;
  maintenancePeriodSummary: MaintenancePeriodSummary;
  maintenanceRequest?: Maybe<MaintenanceRequest>;
  maintenanceRequestStats: MaintenanceRequestStats;
  maintenanceRequests: Array<MaintenanceRequest>;
  maintenanceRequestsByStandard: Array<MaintenanceRequest>;
  maintenanceRequestsPaginated: MaintenanceRequestPage;
  maintenanceTrends: MaintenanceTrends;
  maintenanceWeekOverview: MaintenanceWeekOverview;
  manualHandlingReport: Array<ManualHandlingReportEntry>;
  masterIPFSOrphanScan: IpfsOrphanScanResult;
  masterIPFSRepoStats: IpfsRepoStats;
  masterMediaFiles: Array<MasterMediaFile>;
  masterStorageStats: MasterStorageStats;
  masterTwin?: Maybe<Shift>;
  masterTwinStatus: Array<MasterTwinStatus>;
  me?: Maybe<Client>;
  mealFeedback?: Maybe<MealFeedback>;
  mealFeedbacks: Array<MealFeedback>;
  mealPlan?: Maybe<MealPlan>;
  mealPlanNotificationRule?: Maybe<MealPlanNotificationRule>;
  mealPlanNotificationRules: Array<MealPlanNotificationRule>;
  mealPlanPhotoSummaries: Array<MealPlanPhotoSummary>;
  mealPlanningSettings: MealPlanningSettings;
  mealPlans: Array<MealPlan>;
  mealPlansByDate: Array<MealPlan>;
  mealPlansByDateRange: Array<MealPlan>;
  mealPlansByRecipe: Array<MealPlan>;
  mealPlansByShift: Array<MealPlan>;
  mealPlansByShiftIds: Array<MealPlan>;
  mealPlansWithServicePhotos: Array<MealPlan>;
  mechanicJob?: Maybe<MechanicJob>;
  mechanicJobByMechanicPhone?: Maybe<MechanicJob>;
  mechanicJobByNumber?: Maybe<MechanicJob>;
  mechanicJobByPublicToken?: Maybe<MechanicJob>;
  mechanicJobStats: MechanicJobStats;
  mechanicJobs: Array<MechanicJob>;
  mechanicNotificationLog: Array<MechanicNotificationLog>;
  mechanicNotificationRecipients: Array<MechanicNotificationRecipient>;
  mechanicNotificationRules: Array<MechanicNotificationRule>;
  mediaCDNStats: MediaCdnStats;
  mediaFolder?: Maybe<MediaFolder>;
  mediaFolderBySlug?: Maybe<MediaFolder>;
  mediaFolders: Array<MediaFolder>;
  mediaItem?: Maybe<MediaItem>;
  mediaItemByHash?: Maybe<MediaItem>;
  mediaItems: Array<MediaItem>;
  mediaItemsWithPagination: MediaItemListResult;
  medicalAccessGrants: Array<MedicalRecordPermission>;
  medicalAuditLogs: Array<MedicalAuditLog>;
  medicalAuditLogsCount: Scalars['Int']['output'];
  medicalImportStorageNode: Scalars['String']['output'];
  medicalRecord?: Maybe<MedicalRecord>;
  medicalRecordAccessRequests: MedicalRecordAccessRequestPage;
  medicalRecordDownloadUrl: Scalars['String']['output'];
  medicalRecords: Array<MedicalRecord>;
  medicalRecordsShiftRule: MedicalRecordsShiftRule;
  medication?: Maybe<Medication>;
  medicationChart: MedicationChart;
  medicationRound?: Maybe<MedicationRound>;
  medicationRounds: RoundsResponse;
  medications: MedicationsResponse;
  medicationsAll: Array<Medication>;
  medicationsBySchedule: Array<Medication>;
  medicationsByType: Array<Medication>;
  meetSpeakerContacts: Array<MeetSpeakerContact>;
  meetTranscriptionModels: MeetTranscriptionModelsInfo;
  meetTranscriptionSummaryModels: MeetTranscriptionModelsInfo;
  meetVoiceSignatures: Array<MeetVoiceSignature>;
  meetingByRoom?: Maybe<Meeting>;
  microsoftEmail?: Maybe<MicrosoftEmail>;
  microsoftEmailDirectionByMailbox: Array<MailboxDirectionCount>;
  microsoftEmailMailboxes: Array<Scalars['String']['output']>;
  microsoftEmailTagCounts: Array<EmailTagCount>;
  microsoftEmailVolume: Array<EmailVolumeBucket>;
  microsoftEmailVolumeByMailbox: Array<EmailVolumeBucket>;
  microsoftEmails: PaginatedMicrosoftEmails;
  missedMedicationsReport: MissedMedicationsReport;
  mobilityAssessments: MobilityAssessmentsResponse;
  moduleDoctorBriefHistory: Array<ModuleDoctorBriefHistoryEntry>;
  moduleDriftMatrix: Array<ModuleDriftReport>;
  moduleEvents: Array<CalendarEvent>;
  /** Get permission configurations for all modules. Used by the frontend to resolve route permissions from the backend (single source of truth). */
  modulePermissions: Array<ModulePermissionConfig>;
  moduleSources: Array<ModuleSource>;
  moduleTestResults: Array<ModuleTestResult>;
  moduleTestingSummary: Array<ModuleTestingSummaryItem>;
  moduleUpgradeQueue: Array<ModuleUpgradeQueueJob>;
  moduleUpgradeServiceJobLog: Scalars['String']['output'];
  moduleUpgradeServiceLeases: Array<ModuleUpgradeServiceLease>;
  moduleUpgradeServiceStatus: ModuleUpgradeServiceStatus;
  monitorIncident?: Maybe<MonitorIncident>;
  monitorIncidents: Array<MonitorIncident>;
  monthlyChecklistSettings: MonthlyChecklistSettings;
  monthlyRoomCheck?: Maybe<MonthlyRoomCheck>;
  monthlyRoomCheckForLocation: MonthlyRoomCheck;
  monthlyRoomChecks: Array<MonthlyRoomCheck>;
  moodEntries: Array<MoodEntry>;
  moodEntry?: Maybe<MoodEntry>;
  moodTrend: MoodTrend;
  motivationTemplates: Array<MotivationPromptTemplate>;
  multiCalendarEvents: Array<CalendarEvent>;
  myAccessibleEmailAddresses: Array<EmailAddressInfo>;
  myAccessiblePatients: Array<Resident>;
  /** Get phone numbers assigned to the current user */
  myAssignedPhoneNumbers: Array<TwilioPhoneNumber>;
  /** Enabled bank accounts the caller may see */
  myBankingAccounts: Array<BankingAccount>;
  /** The caller's own alert rules */
  myBankingAlertRules: Array<BankingAlertRule>;
  /** The caller's digest preference — created with everything off on first read */
  myBankingDigestPreference: BankingDigestPreference;
  /** What this site owes the signed-in person: their IOU tokens with what is still owed on each */
  myBankingIous: BankingMyIous;
  /** Recent banking notifications sent to the caller (newest first; the total is honest). Pass transactionId for one transaction's notifications. */
  myBankingNotificationLog: BankingNotificationLogPage;
  /** What the caller will receive and when — computed from the same rules the sender uses */
  myBankingNotificationSchedule: Array<BankingNotificationScheduleRow>;
  /** Combined current position over the includeInPosition accounts the caller can see (liabilities negative, one honest as-of) */
  myBankingPosition: BankingPosition;
  /** Redbark connection settings for this tenant — secrets masked */
  myBankingSettings: BankingSettingsView;
  myBookings: Array<Booking>;
  myBuilds: Array<BuildListItem>;
  /** The signed-in member's own listing's enquiries, newest first (up to 200). */
  myBusinessEnquiries: Array<BusinessEnquiry>;
  /** The signed-in member's own listing (null if they have not made one). */
  myBusinessListing?: Maybe<BusinessListing>;
  /** Listings the signed-in member has asked to claim (pending or turned down). */
  myBusinessListingClaims: Array<BusinessListing>;
  myCalendarPreferences?: Maybe<CalendarUserPreference>;
  myCalendars: Array<BusinessCalendar>;
  myCheckIns: Array<CheckIn>;
  myChloeSessions: Array<ChloeSession>;
  myClient?: Maybe<Client>;
  myCoParentInvites: Array<SeparationInvite>;
  myCommunityDomainAccess: CommunityDomainAccess;
  myCommunityEntryForDate?: Maybe<CommunityEntry>;
  myCommunityEntryHistory: Array<CommunityEntry>;
  myCommunityForYou: Array<CommunityForYouItem>;
  myCommunityInvites: Array<CommunityInvite>;
  myCommunityMemberSettings: CommunityMemberSettings;
  myCommunityNotificationForecast: Array<CommunityNotificationForecastItem>;
  myCommunityNotificationSchedule: Array<CommunityNotificationScheduleRow>;
  myCommunityStats: CommunityMemberStats;
  myCompanyKnowledgeArticles: Array<CompanyKnowledge>;
  myCompetitionEntries: Array<MyCompetitionEntry>;
  myCompetitionEntryAllowance: CompetitionEntryAllowance;
  myCompetitionFollow: MyCompetitionFollow;
  myCompetitionHearts: Array<Scalars['ID']['output']>;
  myCompetitionVote?: Maybe<MyCompetitionVote>;
  myDashboard: ClientDashboard;
  myDomains: Array<Domain>;
  myEmailAddresses: Array<EmailAddress>;
  /** Onboarding forms for the logged-in employee: prefill, declaration, blockers, signed status. */
  myEmployeeForms: Array<MyEmployeeFormStatus>;
  /** Get the current user's own employee profile */
  myEmployeeProfile?: Maybe<Employee>;
  myFarmer?: Maybe<Farmer>;
  myFeedbackItems: FeedbackPage;
  myGovAccess: GovAccessInfo;
  myGovMembership?: Maybe<GovMember>;
  myGovMembershipStanding: GovMyMembershipStanding;
  myGovNotificationSchedule: Array<GovNotificationScheduleRow>;
  myGovParticipation?: Maybe<GovParticipation>;
  myGovVote?: Maybe<GovVote>;
  myGuaranteeClaims: Array<SeparationGuaranteeClaim>;
  myGuaranteeEligibility: SeparationGuaranteeEligibility;
  myHostingAffiliate?: Maybe<HostingAffiliate>;
  myHostingCommissionPayments: Array<HostingCommissionPayment>;
  myHostingReferrals: Array<HostingReferral>;
  myInfluencerProfile?: Maybe<Influencer>;
  myKitchens: Array<Kitchen>;
  myLeaveBalance: MyLeaveBalance;
  myLeaveRequests: Array<LeaveRequest>;
  myLocalAiQueries: Array<LocalAiQuery>;
  myMaintenanceAllEventsSubscription: Scalars['Boolean']['output'];
  myMealPlanAllEventsSubscription: Scalars['Boolean']['output'];
  myMealPlanNotifications: Array<MealPlanInAppNotification>;
  myMedicalRecordAccess: MedicalRecordAccessSummary;
  myMedicalRecordsShiftStatus: MedicalRecordsShiftStatus;
  myMeetings: Array<Meeting>;
  myNotifications: Array<InAppNotification>;
  /** The logged-in employee's own onboarding checklist — same formulas as the manager box. Self-service surfaces show only fixedBy === 'SELF' sections. */
  myOnboardingStatus: EmployeeOnboardingProgress;
  myOpportunities: Array<Opportunity>;
  myOpportunityTasks: Array<OpportunityTask>;
  myOwnedSiteActivity: Array<SiteUpdate>;
  myOwnedSites: Array<ConstructionSite>;
  myPasskeys: Array<WebAuthnCredential>;
  myPasswords: Array<Password>;
  myPaymentMethods: Array<PaymentMethod>;
  /** The signed-in staff member's own payroll enquiries, newest first */
  myPayrollEnquiries: Array<PayrollEnquiry>;
  myPendingAgreementText?: Maybe<Scalars['String']['output']>;
  myPolicyAcknowledgements: Array<MyPolicyAcknowledgement>;
  myProgramApplication?: Maybe<ProgramApplication>;
  myProgramMember?: Maybe<ProgramMember>;
  myProspectingAllEventsSubscription: Scalars['Boolean']['output'];
  myReferrals: ReferralsResponse;
  myResidents: Array<Resident>;
  myRewardBalance: ClientRewardBalance;
  /** My Rewards: what can be paid to my bank, my bank details (masked) and my payout requests */
  myRewardPayouts: MyRewardPayouts;
  myRewardTokens: Array<RewardToken>;
  myRewardTransactions: Array<RewardTransaction>;
  mySellerProfiles: Array<SellerProfile>;
  mySeparationAffiliate?: Maybe<SeparationAffiliate>;
  mySeparationAffiliateSummary?: Maybe<SeparationAffiliateSummary>;
  mySeparationReferrals: Array<SeparationReferral>;
  mySessions: Array<SignInSessionView>;
  myShelvInvites: Array<ShelvInvite>;
  myShiftSwaps: Array<ShiftSwapRequest>;
  mySmsBalance: MySmsBalance;
  mySmsNumberRequests: Array<SmsNumberRequest>;
  mySmsSettings: MySmsSettings;
  mySmsUsage: MySmsUsage;
  mySovereigntyProgress?: Maybe<SovereigntyClientProgress>;
  mySubscriptions: Array<BillingSubscription>;
  myTasks: Array<ClinicalTask>;
  /** @deprecated Unpaged and unused by the master frontend. Use transcriptionsPage. */
  myTranscriptions: Array<Transcription>;
  myTwoFactorStatus: TwoFactorStatus;
  myVault?: Maybe<CryptoVault>;
  myVisionBoardInvites: Array<VisionBoardInvite>;
  myVisionBoardShares: Array<VisionBoardShareEntry>;
  myVoicePreferences: VoicePreferences;
  myWalletContacts: Array<WalletContact>;
  myWalletInvites: Array<WalletContactInvite>;
  myWalletKeys: Array<WalletKey>;
  neurologicalObservationPeriod?: Maybe<NeurologicalObservationPeriod>;
  neurologicalObservationPeriods: NeurologicalPeriodsResponse;
  neurologicalObservations: NeurologicalObservationsResponse;
  nextFortnight?: Maybe<FortnightWindow>;
  nextPolicyDocId: Scalars['String']['output'];
  notificationsLog: Array<InAppNotification>;
  observationAlertConfig?: Maybe<ObservationAlertConfig>;
  observationAlerts: ObservationAlertsResponse;
  observationGraphData: ObservationGraphData;
  onboardedClients: Array<OnboardedClientSummary>;
  openDigitalManagerOQs: Array<DigitalManagerOutstandingQuestion>;
  openOutstandingQuestions: Array<EmailAiOutstandingQuestion>;
  openShifts: Array<Shift>;
  opportunities: Array<Opportunity>;
  opportunitiesByEmail: Array<LinkedOpportunitySummary>;
  opportunitiesByStage: Array<Opportunity>;
  opportunity?: Maybe<Opportunity>;
  opportunityCount: Scalars['Int']['output'];
  opportunityEmails: OpportunityEmailsResult;
  opportunityMeeting?: Maybe<OpportunityMeeting>;
  opportunityMeetings: Array<OpportunityMeeting>;
  opportunityMembers: Array<OpportunityMember>;
  opportunityNote?: Maybe<OpportunityNote>;
  opportunityNotes: Array<OpportunityNote>;
  opportunityStages: Array<OpportunityStage>;
  opportunityTasks: Array<OpportunityTask>;
  opportunityType?: Maybe<OpportunityType>;
  opportunityTypes: Array<OpportunityType>;
  ordersByDateRange: Array<SupplierOrder>;
  ordersByStatus: Array<SupplierOrder>;
  ordersBySupplier: Array<SupplierOrder>;
  orgChartConfig: OrgChartConfig;
  orgChartGraph: OrgChartGraph;
  orgChartPlacements: Array<OrgChartPlacement>;
  orphanedCheckOuts: Array<OrphanedAssignment>;
  orphanedRecords: Array<OrphanedRecord>;
  outgoingComms: OutgoingCommsResult;
  outgoingEmailBody: OutgoingEmailBody;
  overdueActions: Array<GoalAction>;
  overdueChecklistItems: Array<OverdueChecklistItem>;
  overdueDressings: Array<DressingSchedule>;
  overdueMaintenanceRequests: Array<MaintenanceRequest>;
  overdueNeurologicalReadings: OverdueNeurologicalAlertsResponse;
  overdueReviews: Array<CarePlanReview>;
  overdueTasks: Array<ClinicalTask>;
  overdueVaccinations: Array<Vaccination>;
  oxygenSaturationObservations: OxygenSaturationObservationsResponse;
  p2ActionLogs: Array<P2ActionLog>;
  p2Actions: Array<P2Action>;
  p2ActiveCart: P2Cart;
  p2CampaignMessages: Array<P2CampaignMessage>;
  p2Charges: Array<P2Charge>;
  p2ChargesByClient: Array<P2Charge>;
  p2DailyChaseSettings: P2DailyChaseConfig;
  p2DeliveryUpdates: Array<P2DeliveryUpdate>;
  p2InterestCount: Scalars['Int']['output'];
  p2Interests: Array<P2Interest>;
  p2InterestsByCampaign: Array<P2Interest>;
  p2Invites: Array<P2Invite>;
  p2MessageLogs: Array<P2MessageLog>;
  p2MyCampaigns: Array<P2PledgeCampaign>;
  p2MyDeliveryUpdates: Array<P2DeliveryUpdate>;
  p2MyOrders: Array<P2Order>;
  p2MyPledges: Array<P2Pledge>;
  p2MyReferral?: Maybe<P2Referral>;
  p2MyRefunds: Array<P2Refund>;
  p2MySavedCards: Array<P2SavedCard>;
  p2NotificationRules: Array<P2NotificationRule>;
  p2Order?: Maybe<P2Order>;
  p2Orders: Array<P2Order>;
  p2PledgeCampaign?: Maybe<P2PledgeCampaign>;
  p2PledgeCampaigns: Array<P2PledgeCampaign>;
  p2Pledges: Array<P2Pledge>;
  p2Product?: Maybe<P2Product>;
  p2Products: Array<P2Product>;
  p2PublicCampaign?: Maybe<P2PledgeCampaign>;
  p2PublicInvite?: Maybe<P2Invite>;
  p2PublicProduct?: Maybe<P2Product>;
  p2PublicStripeConfig: P2PublicStripeConfig;
  p2ReferralByCode?: Maybe<P2Referral>;
  p2Referrals: Array<P2Referral>;
  p2Refunds: Array<P2Refund>;
  p2SavedCards: Array<P2SavedCard>;
  p2Settings?: Maybe<P2Settings>;
  p2StorefrontProducts: Array<P2Product>;
  p2StripeConfigured: Scalars['Boolean']['output'];
  p2Supplier?: Maybe<P2Supplier>;
  p2Suppliers: Array<P2Supplier>;
  phoneLines: Array<PhoneLine>;
  pProposal?: Maybe<PProposal>;
  pProposalBySlug?: Maybe<PProposal>;
  pProposalSignatures: Array<PProposalSignature>;
  pProposalStats: PProposalStatsResponse;
  pProposals: Array<PProposal>;
  pUnlinkedProposals: Array<PProposal>;
  pacemakerReport: Array<PacemakerReportEntry>;
  pageViews: Array<PageView>;
  paginatedEmails: PaginatedEmails;
  paginatedInboundEmails: PaginatedInboundEmails;
  /** Pain chart observations, newest first, with the total stated */
  painChartObservations: PainChartObservationsResponse;
  /** Pain chart periods (when a chart ran, with its notes), newest first */
  painChartPeriods: PainChartPeriodsResponse;
  parcelDetail?: Maybe<Parcel>;
  parcels: Array<Parcel>;
  partsOrder?: Maybe<PartsOrder>;
  partsOrders: Array<PartsOrder>;
  partsOrdersByJob: Array<PartsOrder>;
  partsSpendingBySupplier: SupplierSpendingReport;
  password?: Maybe<Password>;
  passwordAccessLogs: Array<PasswordAccessLog>;
  passwords: Array<Password>;
  pastResidents: Array<Resident>;
  patientAuditLogs: Array<MedicalAuditLog>;
  patientMedicalRecords: Array<MedicalRecord>;
  payRun?: Maybe<PayRun>;
  payRunLine?: Maybe<PayRunLine>;
  /** List PayRunLines (filterable by payRunId / employeeId) */
  payRunLines: Array<PayRunLine>;
  /** List PayRuns for the current tenant */
  payRuns: Array<PayRun>;
  paySettings?: Maybe<PaySettings>;
  paymentMethods: Array<PaymentMethod>;
  paymentMethodsByClient: Array<PaymentMethod>;
  /** Payroll cost forecast — the current and coming pay fortnights (max 4) priced from the roster as it stands by the pay engine itself (dry run: nothing written). Dollar amounts → pay financial level. */
  payrollCostForecast: PayrollCostForecast;
  /** Every payroll enquiry on the site (optionally one status), most recent activity first */
  payrollEnquiries: Array<PayrollEnquiry>;
  /** One payroll enquiry — the person who raised it, or payroll. Null when it doesn't exist or isn't yours to see. */
  payrollEnquiry?: Maybe<PayrollEnquiry>;
  /** How many enquiries are at each status — every one on the site, no cap */
  payrollEnquiryCounts: PayrollEnquiryCounts;
  /** People who can be told — everyone on the site who can open the enquiries page, A–Z */
  payrollEnquiryRecipientCandidates: Array<PayrollEnquiryRecipientCandidate>;
  /** Who is told when a payroll enquiry comes in (an empty list until someone is picked) */
  payrollEnquirySettings: PayrollEnquirySettings;
  penaltyRateRule?: Maybe<PenaltyRateRule>;
  penaltyRateRules: Array<PenaltyRateRule>;
  pendingActions: Array<GoalAction>;
  pendingDeliveries: Array<SupplierOrder>;
  pendingDigitalManagerProposals: Array<DigitalManagerOutstandingQuestion>;
  pendingLeaveRequests: Array<LeaveRequest>;
  pendingPRNFollowUps: Array<PrnAdministration>;
  pendingShiftPickups: Array<PendingShiftPickup>;
  pendingUploads: Array<FileTransfer>;
  /** Comprehensive permissions audit: reverse map, categories, orphan detection. Admin only. */
  permissionsAudit: PermissionsAuditResult;
  personEnrichments: Array<PersonEnrichment>;
  personEvents: Array<PersonEvent>;
  personOfInterest?: Maybe<PersonOfInterest>;
  personsOfInterest: Array<PersonOfInterest>;
  phoneNumber?: Maybe<TwilioPhoneNumber>;
  phoneNumbers: Array<TwilioPhoneNumber>;
  pickupDecisionHistory: Array<PickupDecision>;
  pickupRejectionGuidance: PickupRejectionGuidance;
  pinnedCompanyKnowledgeArticles: Array<CompanyKnowledge>;
  pipelineMetrics: PipelineMetrics;
  pledgeCampaign?: Maybe<PledgeCampaign>;
  pledgeCampaigns: Array<PledgeCampaign>;
  pledgesForCampaign: Array<PledgeWithLead>;
  policies: Array<Policy>;
  policy: Policy;
  policyAcknowledgementReport: PolicyAcknowledgementReport;
  policyActivities: Array<PolicyActivity>;
  policyActivity: PolicyActivity;
  policyAssignablePeople: Array<PolicyAssignablePerson>;
  policyBroadcastAudience: PolicyBroadcastAudience;
  policyBroadcastPreview: PolicyBroadcastPreview;
  policyByDocId?: Maybe<Policy>;
  policyCategories: Array<Scalars['String']['output']>;
  policyChatModels: Array<PolicyChatModel>;
  policyDraftDiff: PolicyDiffResult;
  policyEditors: Array<PolicyEditor>;
  policyMyAccess: PolicyMyAccess;
  policyNotification: PolicyNotification;
  policyNotifications: Array<PolicyNotification>;
  policySettings: PolicySettings;
  policyVersion: PolicyVersion;
  policyVersionDiff: PolicyDiffResult;
  policyVersions: Array<PolicyVersion>;
  potentialDuplicateAccounts: Array<DuplicateAccountCluster>;
  practionerById?: Maybe<Client>;
  practitionerAvailability: Array<Availability>;
  practitionerPublicProfile?: Maybe<Client>;
  prescribers: Array<MedicationPrescriber>;
  /** Accounting: DRY RUN of a bank CSV — which rows are new, already imported, or unreadable. Writes nothing. */
  previewBankCsvImport: BankImportResult;
  previewBillsEmailBranding: Scalars['String']['output'];
  previewCalendarAudience: Array<CalendarPersonInfo>;
  previewCalendarAudiences: Array<CalendarPersonInfo>;
  previewCommunityCampaignAudience: CommunityCampaignAudiencePreview;
  previewCommunityDailyEmail: CommunityDailyEmailPreview;
  previewCommunityDailyReminder: CommunityDailyEmailPreview;
  previewCommunityLapsedNudge: CommunityJobEmailPreview;
  previewCommunityLeaderboardEmail: CommunityJobEmailPreview;
  previewCommunityWeeklyEmail: CommunityDailyEmailPreview;
  previewDeactivateUnit: UnitRetireReport;
  /** Render a template with merge values (JSON) — a preview for the invite form; throws naming any missing required token. With `facts`, the values the offer form already knows (job, classification, rate, dates, name) are derived exactly as createEmployeeInvite does, and the employee's own address/name show as [placeholders]. `highlight` wraps every substituted value in \uE000…\uE001 for a yellow highlight; `keepEmployeeTokens` leaves {{employeeFullName}}/{{employeeGivenName}}/{{employeeAddress}}/{{employeeEmail}} in place (the 'edit contract text' starting point). */
  previewEmployeeContract: Scalars['String']['output'];
  previewEmpowermentScheduleChange: EmpowermentSchedulePreview;
  previewInboundEmailMove: InboundEmailMovePreview;
  previewIngredientUnitChange: UnitSyncReport;
  previewLeadFlowAction: CustomizedLeadFlowAction;
  previewLeadFlowEmailBranding: Scalars['String']['output'];
  previewP2Action: CustomizedP2Action;
  previewPickupDecisionEmails: Array<PickupDecisionEmailPreview>;
  previewProgramReminderEmail: ProgramReminderEmailPreview;
  previewRecipeIngredientUnitChange: UnitSyncReport;
  previewRewardsEmailBranding: Scalars['String']['output'];
  previewShiftNotificationRecipients: NotificationRecipientPreviewResult;
  /** Accounting: DRY RUN of the chart of accounts read live from a connected Xero organisation — what each account would do. Writes nothing. */
  previewXeroChartFromXero: LedgerImportResult;
  /** Accounting: DRY RUN of a Xero chart-of-accounts CSV — what each row would do. Writes nothing. */
  previewXeroChartImport: LedgerImportResult;
  /** Accounting: DRY RUN of the transactions read live from a connected Xero organisation (bank transactions + invoice/bill payments since a date) — which are new, already imported, or have no bank account here. Writes nothing. */
  previewXeroTransactionImport: XeroTransactionImportResult;
  primaryContact?: Maybe<ResidentContact>;
  priorFortnight?: Maybe<FortnightWindow>;
  prnAdministrations: PrnAdministrationsResponse;
  prnMedications: Array<Medication>;
  prnUsageReport: Array<PrnUsageReport>;
  proRataPreview: ProRataPreview;
  programActivities: Array<ProgramActivity>;
  programActivity?: Maybe<ProgramActivity>;
  programApplication?: Maybe<ProgramApplication>;
  programApplications: Array<ProgramApplication>;
  programAvailableCalendars: Array<ProgramCalendarOption>;
  programCallNote?: Maybe<ProgramCallNote>;
  programCallNotes: Array<ProgramCallNote>;
  programCommission?: Maybe<ProgramCommission>;
  programCommissions: Array<ProgramCommission>;
  programConfig: ProgramConfig;
  programMember?: Maybe<ProgramMember>;
  programMembers: Array<ProgramMember>;
  programSignedAgreements: Array<ProgramSignedAgreement>;
  progressNote?: Maybe<ProgressNote>;
  progressNoteAlerts: ProgressNoteAlertsResponse;
  progressNotes: ProgressNotesResponse;
  project: Project;
  projects: Array<Project>;
  projectsByClient: Array<Project>;
  prospectingNotificationRules: Array<ProspectingNotificationRule>;
  provisioningStatus: ProvisioningStatusResult;
  /** Browse API categories */
  publicApiCategories: Array<ApiCategory>;
  /** Get endpoints for an API */
  publicApiEndpoints: Array<ApiEndpoint>;
  /** Get single API detail */
  publicApiListing?: Maybe<ApiListing>;
  /** Browse published API listings */
  publicApiListings: Array<ApiListing>;
  publicArtifactByToken?: Maybe<PublicArtifactView>;
  publicArtifactComments: Array<ArtifactComment>;
  /** Public query to get bill for preview without authentication */
  publicBill?: Maybe<Bill>;
  /** Public query to render a bill's invoice PDF without authentication (bill id is the token) */
  publicBillPdf?: Maybe<BillPdfDocumentPayload>;
  publicBookableEventTypes: Array<BusinessCalendarBookableEventType>;
  publicBooking?: Maybe<CalendarEvent>;
  /** Public: one business page, only while it is visible in the directory. */
  publicBusinessListingBySlug?: Maybe<BusinessListing>;
  /** Public: the directory, A–Z by name, paged. `total` counts every match. */
  publicBusinessListings: BusinessListingPage;
  publicCalendar?: Maybe<BusinessCalendar>;
  publicClub52GameByRoom: PublicClub52GameInfo;
  publicCommunityConfigBySlug?: Maybe<PublicCommunityInfo>;
  publicCommunityInvite?: Maybe<PublicCommunityInviteInfo>;
  publicCommunityStats?: Maybe<CommunityPublicStats>;
  publicCompanyKnowledgeArticle?: Maybe<CompanyKnowledge>;
  publicCompetition?: Maybe<PublicCompetition>;
  publicCompetitionEntries: Array<PublicCompetitionEntry>;
  publicCompetitionEntry?: Maybe<PublicCompetitionEntryView>;
  publicCompetitionSchools: Array<PublicCompetitionSchool>;
  publicCompetitionSponsors: Array<PublicCompetitionSponsor>;
  publicCompetitions: Array<PublicCompetition>;
  publicDroneSession?: Maybe<PublicSessionInfo>;
  publicDroneSessionFiles: Array<FileTransfer>;
  publicEmployeeInvite?: Maybe<PublicEmployeeInviteInfo>;
  /** Contract-first onboarding: the invitee's contract for this invite link (their own document only). Null when the link is unknown, expired, completed or not contract-first. */
  publicEmployeeInviteContract?: Maybe<PublicEmployeeInviteContract>;
  publicFarmerBySlug?: Maybe<Farmer>;
  publicFarmers: Array<Farmer>;
  publicFeedbackStatus?: Maybe<PublicFeedbackStatus>;
  /** Public query to get the issuing company for a bill (bill id is the token) */
  publicGetBillCompany?: Maybe<Company>;
  /** Public query to get issuer details for a bill */
  publicGetBillIssuerDetails?: Maybe<Client>;
  /** Public query to get the recipient (Bill To) company for a bill */
  publicGetBillToCompany?: Maybe<Company>;
  /** Public query to get client details for a bill */
  publicGetClientDetailsByBillId?: Maybe<Client>;
  publicGovActivityTeaser?: Maybe<PublicGovActivityTeaser>;
  publicGovInvite?: Maybe<PublicGovInviteInfo>;
  publicGovMotion?: Maybe<PublicGovMotion>;
  publicGovOrganisation?: Maybe<PublicGovOrganisation>;
  publicGovProposalTeaser?: Maybe<PublicGovProposalTeaser>;
  publicHoliday?: Maybe<PublicHoliday>;
  publicHolidays: Array<PublicHoliday>;
  publicHolidaysByDateRange: Array<PublicHoliday>;
  publicHostingOffer?: Maybe<PublicHostingOffer>;
  publicInquiryFormToken: PublicInquiryFormToken;
  publicLeadFlowForm?: Maybe<LeadFlowForm>;
  publicLocations: Array<Location>;
  publicMeetingByRoom: PublicMeetingInfo;
  publicP2Products: Array<PublicP2Product>;
  publicPProposal?: Maybe<PProposal>;
  publicPartsOrdersByJob: Array<PartsOrder>;
  publicPasswordAccess?: Maybe<Password>;
  publicPledgeCampaign?: Maybe<PledgeCampaign>;
  publicPledgeProgress: PledgeCampaignProgress;
  /** Public (no login) view of a project on the calling site: display-safe fields only */
  publicProject?: Maybe<Project>;
  publicProposal?: Maybe<Proposal>;
  publicRecentMealPlans: Array<MealPlan>;
  /** PUBLIC. What the referee page may know about the request. */
  publicReferenceByToken?: Maybe<PublicReferenceInfo>;
  publicRewardToken?: Maybe<RewardToken>;
  publicRewardTokenConfig: RewardTokenConfig;
  publicSellerProfiles: Array<SellerProfile>;
  publicSeparationInvite?: Maybe<PublicSeparationInviteInfo>;
  publicShelvInvite?: Maybe<PublicShelvInviteInfo>;
  publicSopComments: Array<SopComment>;
  publicSopEpisode?: Maybe<SopEpisode>;
  publicSopEpisodes: Array<SopEpisode>;
  publicSopSettings: SopPublicSettings;
  publicSopTopics: Array<SopTopic>;
  publicSubscriptionProductBySlug?: Maybe<SubscriptionProduct>;
  publicSubscriptionProducts: Array<SubscriptionProduct>;
  publicTenantIpfsGatewayUrl?: Maybe<Scalars['String']['output']>;
  publicVisionBoardInvite?: Maybe<PublicVisionBoardInviteInfo>;
  publicWaitingListConfirmation: PublicWaitingListConfirmation;
  publicWalletInvite?: Maybe<PublicWalletInvite>;
  publishedInvestmentProjects: Array<InvestmentProject>;
  /** Public query: published vlogs catalogue */
  publishedVlogs: Array<VlogPost>;
  pulseObservations: PulseObservationsResponse;
  quoteTemplate?: Maybe<QuoteTemplate>;
  quoteTemplates: Array<QuoteTemplate>;
  quotes: Array<Quote>;
  readBackSarahCareFluidFood: SarahFluidFoodReadBack;
  readBackSarahCarePainChart: SarahPainChartReadBack;
  readBackSarahCareRespiteStays: SarahRespiteStayReadBack;
  readOnlyVisionBoard: VisionBoardReadOnly;
  realTimeStats: RealTimeStats;
  recentAccompaniments: Array<AccompanimentUsage>;
  recentIngestionRuns: Array<IngestionRun>;
  recentOrdersForSupplier: Array<OrderOption>;
  recipe?: Maybe<Recipe>;
  recipeFeedbackSummaries: Array<RecipeFeedbackSummary>;
  recipes: Array<Recipe>;
  recipesByCategory: Array<Recipe>;
  recipesByDietaryTag: Array<Recipe>;
  recipesByDietaryTags: Array<Recipe>;
  recipesByDishType: Array<Recipe>;
  recipesByIngredient: Array<Recipe>;
  recipesBySessionType: Array<Recipe>;
  recipesUsingUnit: Array<Recipe>;
  referralAlerts: ReferralAlertsResponse;
  referrals: ReferralsResponse;
  registeredDomains: Array<RegisteredDomain>;
  /** Public query to get related posts by shared categories/tags */
  relatedBlogPosts: Array<BlogPost>;
  /** Public query: related vlogs by categories/tags/series */
  relatedVlogPosts: Array<VlogPost>;
  repositioningChecks: RepositioningChecksResponse;
  researchBase?: Maybe<ResearchBase>;
  researchBaseCoverage: ResearchBaseCoverage;
  researchBases: Array<ResearchBase>;
  resident?: Maybe<Resident>;
  residentACFIHistory: Array<AcfiAssessment>;
  residentAbbeyPainHistory: Array<AbbeyPainAssessment>;
  residentAdmissionSourceHistory: ResidentAdmissionSourceSnapshotPage;
  residentAllergies: Array<MedicationAllergy>;
  residentBladderHistory: Array<BladderRecord>;
  residentBond?: Maybe<Bond>;
  residentBonds: Array<Bond>;
  residentBowelHistory: Array<BowelRecord>;
  residentBradenHistory: Array<BradenAssessment>;
  residentByNumber?: Maybe<Resident>;
  residentCareReviewHistory: Array<CareReview>;
  /** A resident's care plans (review state) and daily care profile, by resident id */
  residentCareSummary: ResidentCareSummary;
  residentComplianceReports: Array<CarePlanComplianceReport>;
  residentContact?: Maybe<ResidentContact>;
  residentContactCallHistory: ResidentContactCallHistoryPage;
  residentContactHistory: ResidentContactHistoryPage;
  residentContacts: Array<ResidentContact>;
  residentCounts: ResidentCountsByStatus;
  residentIncidents: Array<Incident>;
  residentLeave?: Maybe<ResidentLeave>;
  residentLeaves: ResidentLeaveList;
  residentMedications: Array<Medication>;
  residentMobilityAids?: Maybe<MobilityAids>;
  residentMobilityHistory: Array<MobilityAssessment>;
  residentObservationAlerts: ObservationAlertsResponse;
  /** Accounting: who was in which room in the period, admitted / departed, billable days and an estimate, with the counting rules and a CSV. Read-only over admissions. */
  residentOccupancyReport: ResidentOccupancyReport;
  residentPhotos: Array<ResidentPhoto>;
  residentProgressNotes: ProgressNotesResponse;
  /** One resident's standing on every review cycle */
  residentReviewCycles: ResidentReviewCycles;
  residentRiskAssessments: ResidentRiskAssessmentsResponse;
  residentRiskProfile: Array<ResidentRiskAssessment>;
  residentSleepHistory: Array<SleepCheck>;
  residentVaccinationHistory: Array<Vaccination>;
  residentWaterlowHistory: Array<WaterlowAssessment>;
  residentWeightHistory: Array<WeightObservation>;
  residentWounds: Array<Wound>;
  residents: ResidentsResponse;
  residentsByWing: Array<Resident>;
  resolvedCareTargets: Array<ResolvedCareTargetDay>;
  resolvedOrphans: Array<OrphanResolutionLog>;
  respirationObservations: RespirationObservationsResponse;
  respiteBooking?: Maybe<RespiteBooking>;
  respiteBookings: RespiteCareBookingsResponse;
  respiteCalendar: RespiteCalendar;
  respiteDaysSummary: RespiteDaysSummary;
  /** Past respite stays brought across from SarahCare, newest first, with the total stated */
  respiteStayHistory: RespiteCareBookingsResponse;
  restraintChecks: RestraintChecksResponse;
  restraintRecords: RestraintRecordsResponse;
  retryableTransfers: Array<FileTransfer>;
  /** Admin: the full bank details for one payout request, to make the transfer (two-step verification required) */
  revealRewardPayoutBankDetails: RewardPayoutBankDetailsRevealed;
  revenueTargets: RevenueTargets;
  /** Every current resident with a review overdue or due soon */
  reviewCycleOverview: ReviewCycleOverview;
  reviewsByCarePlan: Array<CarePlanReview>;
  rewardCount: Scalars['Int']['output'];
  rewardLeaderboard: Array<RewardLeaderboardEntry>;
  /** Admin: payout requests, open first then newest */
  rewardPayoutRequests: Array<RewardPayoutRequest>;
  rewardToken?: Maybe<RewardToken>;
  rewardTokenConfig: RewardTokenConfig;
  rewardTokenStats: RewardTokenStats;
  rewardTokens: Array<RewardToken>;
  rewardTokensByClient: Array<RewardToken>;
  rewardTransactions: Array<RewardTransaction>;
  rewardTransactionsByClient: Array<RewardTransaction>;
  rewardTransactionsByToken: Array<RewardTransaction>;
  rewardsEmailBranding?: Maybe<RewardsEmailBranding>;
  riskAssessmentSummary: RiskAssessmentSummary;
  /** A resident's admissions contacts, A–Z, for recording who discussed a choice with risk */
  riskChoicePersonOptions: Array<RiskChoicePersonOption>;
  rollup?: Maybe<Rollup>;
  rollupProposals: Array<RollupProposal>;
  rollups: Array<Rollup>;
  roomsByWing: Array<RoomWithOccupancy>;
  roomsWithOccupancy: Array<RoomWithOccupancy>;
  rosterEmployeeHoursBreakdown: Array<EmployeeHoursBreakdownRow>;
  roundSummary: RoundSummary;
  rulesGoverningEmail: Array<EmailAiRule>;
  s8AuditReport: S8AuditReport;
  s8CurrentStock: Scalars['Float']['output'];
  s8Medications: Array<S8MedicationSummary>;
  s8Register: S8RegisterResponse;
  s8ResidentRegister: S8RegisterResponse;
  sarahNoteFollowupHistory: SarahNoteFollowupHistoryResponse;
  sarahQuestionnaireAnswers: SarahQuestionnaireAnswerPage;
  sarahQuestionnaireHistory: SarahQuestionnaireHistoryPage;
  sarahQuestionnaireReferences: SarahQuestionnaireReferencePage;
  sarahVoidedProgressNotes: SarahVoidedProgressNotesResponse;
  searchAvailablePhoneNumbers: Array<AvailablePhoneNumber>;
  /** Admin: find people on this site to grant an account to — name or email, every word must match. Banking-scoped so a banking admin needs no clients permission. Blocked sign-ins are excluded. At most 25. */
  searchBankingPeople: Array<BankingViewer>;
  searchClients: Array<Client>;
  searchClientsAllTenants: Array<ClientWithTenant>;
  searchClientsOnTenant: Array<Client>;
  searchCompanies: Array<Company>;
  searchDomains: Array<DomainAvailability>;
  /** Search for free images from Unsplash */
  searchImages: ImageSearchResult;
  searchIngredients: Array<Ingredient>;
  searchJobs: Array<Job>;
  searchPolicies: Array<PolicySearchHit>;
  searchRecipes: Array<Recipe>;
  searchResidents: Array<Resident>;
  searchSuppliers: Array<Supplier>;
  /** One finding with its history (two-step verification required) */
  securityFinding: SecurityFinding;
  /** Findings, worst first (two-step verification required) */
  securityFindings: SecurityFindingPage;
  /** Every scanned site with its open findings by severity (two-step verification required) */
  securityOverview: SecurityOverview;
  /** A site's scans, newest first (two-step verification required) */
  securityScans: SecurityScanPage;
  /** One scanned site (two-step verification required) */
  securitySite: SecuritySiteSummary;
  selfMedicatingResidents: Array<MobilityAids>;
  sellerProfile?: Maybe<SellerProfile>;
  sellerProfileStats: Array<Scalars['Float']['output']>;
  sellerProfiles: Array<SellerProfile>;
  sellerProfilesByClient: Array<SellerProfile>;
  seoMetadata?: Maybe<SeoMetadata>;
  seoMetadataAdminPreview?: Maybe<SeoMetadata>;
  seoMetadataByPaths: Array<SeoMetadata>;
  separationAffiliates: Array<SeparationAffiliate>;
  separationBlocksAwaitingMe: Array<SeparationCareBlockView>;
  separationCareBlocks: Array<SeparationCareBlockView>;
  separationCareLog: Array<SeparationCareLogEntry>;
  separationCase?: Maybe<SeparationCase>;
  separationCases: Array<SeparationCase>;
  separationChildren: Array<SeparationChild>;
  separationConfig: SeparationConfig;
  separationCovenantAnswers: Array<SeparationCovenantAnswer>;
  separationGuaranteeClaims: Array<SeparationGuaranteeClaim>;
  separationInviteGraph: Array<SeparationInviteGraphNode>;
  separationInvites: Array<SeparationInvite>;
  separationJourneyProgress: SeparationJourneyProgress;
  separationNightCount: SeparationNightCount;
  separationSchedules: Array<SeparationParentingSchedule>;
  separationSponsoredRequests: Array<SeparationSponsoredRequest>;
  separationSponsorshipContributions: Array<SeparationSponsorshipContribution>;
  separationSponsorshipPool: SeparationSponsorshipPoolSummary;
  sessionTypeById?: Maybe<SessionType>;
  sessionTypes: Array<SessionType>;
  sessionTypesByPractitioner: Array<SessionType>;
  sessions: Array<Session>;
  sharedCompanyKnowledgeArticle?: Maybe<CompanyKnowledge>;
  shelvActiveIngredients: Array<ShelvIngredient>;
  shelvActiveRecipes: Array<ShelvRecipe>;
  shelvActiveSuppliers: Array<ShelvSupplier>;
  shelvActiveUnitOptions: Array<ShelvActiveUnitOption>;
  shelvAggregatedIngredientsForDateRange: Array<ShelvAggregatedIngredient>;
  shelvAiSettings: ShelvAiSettings;
  shelvAiSettingsCheck: Array<ShelvAiEndpointCheck>;
  shelvCaptureAllowance: ShelvCaptureAllowance;
  shelvCaptureJob?: Maybe<ShelvCaptureJob>;
  shelvCaptureJobs: Array<ShelvCaptureJob>;
  shelvFeedbackByMealPlan: Array<ShelvMealFeedback>;
  shelvFeedbackByRecipe: Array<ShelvMealFeedback>;
  shelvFeedbackStats: ShelvFeedbackStats;
  shelvFoodBudget: ShelvFoodBudget;
  shelvFoodBudgetSummary: ShelvFoodBudgetSummary;
  shelvFoodSpendByCategory: Array<ShelvFoodSpendByCategoryRow>;
  shelvFoodSpendBySupplier: Array<ShelvFoodSpendBySupplierRow>;
  shelvGenerateChefCheatSheet: ShelvPdfResult;
  shelvGenerateDailyMenuPDF: ShelvPdfResult;
  shelvGenerateMealPlanRangePDF: ShelvPdfResult;
  shelvGenerateOrderPDF: ShelvOrderPdfResult;
  shelvIngredient?: Maybe<ShelvIngredient>;
  shelvIngredients: Array<ShelvIngredient>;
  shelvIngredientsByCategory: Array<ShelvIngredient>;
  shelvIngredientsBySupplier: Array<ShelvIngredient>;
  shelvInviteGraph: Array<ShelvInviteGraphNode>;
  shelvInvites: Array<ShelvInvite>;
  shelvInvoice?: Maybe<ShelvFoodInvoice>;
  shelvInvoices: Array<ShelvFoodInvoice>;
  shelvKitchen?: Maybe<Kitchen>;
  shelvLowRatedFeedback: Array<ShelvMealFeedback>;
  shelvMealFeedback?: Maybe<ShelvMealFeedback>;
  shelvMealFeedbacks: Array<ShelvMealFeedback>;
  shelvMealPlan?: Maybe<ShelvMealPlan>;
  shelvMealPlanNotificationRule?: Maybe<ShelvMealPlanNotificationRule>;
  shelvMealPlanNotificationRules: Array<ShelvMealPlanNotificationRule>;
  shelvMealPlanPhotoSummaries: Array<ShelvMealPlanPhotoSummary>;
  shelvMealPlanningSettings: ShelvSettings;
  shelvMealPlans: Array<ShelvMealPlan>;
  shelvMealPlansByDate: Array<ShelvMealPlan>;
  shelvMealPlansByDateRange: Array<ShelvMealPlan>;
  shelvMealPlansByRecipe: Array<ShelvMealPlan>;
  shelvMealPlansByShift: Array<ShelvMealPlan>;
  shelvMealPlansByShiftIds: Array<ShelvMealPlan>;
  shelvMealPlansWithServicePhotos: Array<ShelvMealPlan>;
  shelvMyMealPlanAllEventsSubscription: Scalars['Boolean']['output'];
  shelvMyMealPlanNotifications: Array<ShelvMealPlanInAppNotification>;
  shelvOrdersByDateRange: Array<ShelvSupplierOrder>;
  shelvOrdersByStatus: Array<ShelvSupplierOrder>;
  shelvOrdersBySupplier: Array<ShelvSupplierOrder>;
  shelvPendingDeliveries: Array<ShelvSupplierOrder>;
  shelvPreviewDeactivateUnit: ShelvUnitRetireReport;
  shelvPreviewIngredientUnitChange: ShelvUnitSyncReport;
  shelvPreviewRecipeIngredientUnitChange: ShelvUnitSyncReport;
  shelvPublicRecentMealPlans: Array<ShelvMealPlan>;
  shelvRecentAccompaniments: Array<ShelvAccompanimentUsage>;
  shelvRecentOrdersForSupplier: Array<ShelvOrderOption>;
  shelvRecipe?: Maybe<ShelvRecipe>;
  shelvRecipeFeedbackSummaries: Array<ShelvRecipeFeedbackSummary>;
  shelvRecipes: Array<ShelvRecipe>;
  shelvRecipesByCategory: Array<ShelvRecipe>;
  shelvRecipesByDietaryTag: Array<ShelvRecipe>;
  shelvRecipesByDietaryTags: Array<ShelvRecipe>;
  shelvRecipesByDishType: Array<ShelvRecipe>;
  shelvRecipesByIngredient: Array<ShelvRecipe>;
  shelvRecipesBySessionType: Array<ShelvRecipe>;
  shelvRecipesUsingUnit: Array<ShelvRecipe>;
  shelvSearchIngredients: Array<ShelvIngredient>;
  shelvSearchRecipes: Array<ShelvRecipe>;
  shelvSearchSuppliers: Array<ShelvSupplier>;
  shelvSupplier?: Maybe<ShelvSupplier>;
  shelvSupplierOrder?: Maybe<ShelvSupplierOrder>;
  shelvSupplierOrders: Array<ShelvSupplierOrder>;
  shelvSuppliers: Array<ShelvSupplier>;
  shelvUnitConfigs: Array<ShelvUnitConfig>;
  shelvUnitTypeOptions: Array<ShelvEnumOption>;
  shelvUnreadMealPlanNotificationCount: Scalars['Int']['output'];
  shelvUnresolvedFeedback: Array<ShelvMealFeedback>;
  shift?: Maybe<Shift>;
  shiftModeBreakdown: ShiftModeBreakdown;
  shiftNotificationLogs: Array<ShiftNotificationLog>;
  shiftNotificationRules: Array<ShiftNotificationRule>;
  shiftSettings: ShiftSettings;
  shiftSwapRequest?: Maybe<ShiftSwapRequest>;
  shiftSwapRequests: Array<ShiftSwapRequest>;
  shiftTemplate?: Maybe<ShiftTemplate>;
  shiftTemplates: Array<ShiftTemplate>;
  shiftType?: Maybe<ShiftType>;
  shiftTypes: Array<ShiftType>;
  shifts: Array<Shift>;
  shiftsByDateRange: Array<Shift>;
  shiftsByEmployee: Array<Shift>;
  shiftsByLocation: Array<Shift>;
  shiftsByLocations: Array<Shift>;
  shiftsByStatus: Array<Shift>;
  shiftsForResident: Array<Shift>;
  /** Other transactions on the same account with the same merchant (or, failing that, the same description), newest first */
  similarBankingTransactions: Array<BankingTransaction>;
  siteEditCommands: Array<SiteEditCommand>;
  siteEditorMyBuildStatus: BuildStatusResult;
  siteEditorMyCommands: Array<SiteEditCommand>;
  siteEditorMyDevServerLogs: DevServerLogsResult;
  siteEditorMyEditStats: SiteEditStatsResult;
  siteEditorMyMergeHistory: MergeHistoryResult;
  siteEditorMyPRHistory: PrHistoryResult;
  siteEditorMyRelayHealth: RelayHealthResult;
  siteEditorMySite?: Maybe<SiteEditorSite>;
  siteEditorProvisionStatus?: Maybe<ProvisionStatusResult>;
  siteEditorRelayHealth: RelayHealthResult;
  siteEditorSite?: Maybe<SiteEditorSite>;
  siteEditorSites: Array<SiteEditorSite>;
  siteEditorStats: SiteEditorStats;
  siteTrackerDashboard: Array<SiteTrackerDashboardRow>;
  siteUpdates: Array<SiteUpdate>;
  sleepChecks: SleepChecksResponse;
  smsBroadcastAudiencePreview: SmsBroadcastAudiencePreview;
  smsConversations: Array<SmsConversation>;
  smsHeldReplies: SmsHeldRepliesResult;
  smsMessages: Array<SmsMessage>;
  smsNotificationRules: Array<SmsNotificationRule>;
  smsResponses: Array<SmsResponse>;
  smsUsageStats: SmsUsageStats;
  snapshotCount: Scalars['Float']['output'];
  sopAgenda: Array<SopAgendaItem>;
  sopComments: Array<SopComment>;
  sopEpisode?: Maybe<SopEpisode>;
  sopEpisodeGuests: Array<SopEpisodeGuest>;
  sopEpisodes: Array<SopEpisode>;
  sopInviteCandidates: Array<SopInviteCandidate>;
  sopNextEpisode?: Maybe<SopEpisode>;
  sopPendingCommentCount: Scalars['Int']['output'];
  sopSettings: SopSettings;
  sopSuggestedTimes: SopSuggestedTimes;
  sopTopics: Array<SopTopic>;
  sovereigntyJourney?: Maybe<SovereigntyJourneyView>;
  sovereigntyJourneys: Array<SovereigntyJourneyView>;
  spamBlockPreview: SpamBlockPreview;
  spamSenderStatus: SpamSenderStatus;
  sphereOfInfluence?: Maybe<SphereOfInfluence>;
  spheresOfInfluence: Array<SphereOfInfluence>;
  stepUpOptions: Array<Scalars['String']['output']>;
  storageUsageLogs: Array<StorageUsageLog>;
  storageUsageStats: StorageUsageStats;
  stpLodgementsForRun: Array<StpLodgement>;
  stpProviders: Array<Scalars['String']['output']>;
  subscription?: Maybe<BillingSubscription>;
  subscriptionBillingDashboard: SubscriptionBillingDashboard;
  subscriptionDetail?: Maybe<SubscriptionDetail>;
  subscriptionProduct?: Maybe<SubscriptionProduct>;
  subscriptionProducts: Array<SubscriptionProduct>;
  subscriptions: Array<BillingSubscription>;
  subscriptionsByClient: Array<BillingSubscription>;
  suburbStats?: Maybe<SuburbStats>;
  suggestEmployeeActivityTagColors: Array<Scalars['String']['output']>;
  suggestTagColors: Array<Scalars['String']['output']>;
  supplier?: Maybe<Supplier>;
  supplierOrder?: Maybe<SupplierOrder>;
  supplierOrders: Array<SupplierOrder>;
  suppliers: Array<Supplier>;
  supplyAgents: Array<SupplyAgent>;
  suspiciousActivityLogs: Array<MedicalAuditLog>;
  swapRosterShifts: Array<Shift>;
  tasksByProject: Array<Task>;
  team?: Maybe<Team>;
  teamPasskeyReadiness: Array<PasskeyReadinessRow>;
  teams: Array<Team>;
  temperatureAlarm?: Maybe<TemperatureAlarm>;
  temperatureAlarms: Array<TemperatureAlarm>;
  temperatureComplianceForDay: Array<EquipmentDailyCompliance>;
  temperatureLogs: Array<TemperatureLog>;
  temperatureMethods: Array<TemperatureMethodInfo>;
  temperatureObservations: TemperatureObservationsResponse;
  templateUsageStats: Array<TemplateUsageStats>;
  templatesByCategory: Array<CarePlanTemplate>;
  tenant?: Maybe<Tenant>;
  tenantAuthConfig?: Maybe<TenantAuthConfig>;
  tenantAuthenticationSettings: TenantAuthenticationSettings;
  tenantAutomationRun?: Maybe<TenantAutomationRun>;
  tenantAutomationRuns: Array<TenantAutomationRun>;
  tenantBillingOverview: Array<TenantBillingRow>;
  tenantBillingStatuses: Array<TenantBillingStatus>;
  tenantByCurrentClient?: Maybe<Tenant>;
  /** Every dataset this tenant can download as CSV, with live row counts, plus the modules that cannot be exported yet. */
  tenantDataExportManifest: TenantDataExportManifest;
  tenantEmailStatus: TenantEmailSetupResult;
  tenantGrowthSummaries: Array<TenantGrowthSummary>;
  tenantGrowthSummary?: Maybe<TenantGrowthSummary>;
  tenantIpfsHealth: TenantIpfsHealth;
  tenantLocalAiStatus: TenantLocalAiStatus;
  /** This site's security switches, e.g. whether sensitive data asks for two-step verification. */
  tenantSecuritySettings: TenantSecuritySettings;
  /** How many staff on this site have two-step verification turned on. Site admins only. */
  tenantTwoFactorAdoption: TenantTwoFactorAdoption;
  tenants: Array<Tenant>;
  testTranscriptionConnection: Scalars['Boolean']['output'];
  theprogramMemberFacingConfig: ProgramMemberFacingConfig;
  timesheet?: Maybe<TimesheetEntity>;
  timesheets: Array<TimesheetEntity>;
  todaysChaseSuggestions: Array<ClientChaseLog>;
  todaysCheckIns: Array<CheckIn>;
  todaysRounds: Array<MedicationRound>;
  todaysShifts: Array<Shift>;
  tokenEconomicsReport: TokenEconomicsReport;
  tomConversation?: Maybe<TomConversationWithMessages>;
  tomConversations: Array<TomConversation>;
  tomInteractionLogs: Array<TomInteractionLog>;
  tomJourneyContext: JourneyContext;
  tomSettings?: Maybe<TomSettings>;
  topLevelLocations: Array<Location>;
  topPages: Array<TopPage>;
  totalOpportunityValue: Scalars['Float']['output'];
  trackedCompetition?: Maybe<TrackedCompetition>;
  trackedCompetitions: Array<TrackedCompetition>;
  tradeRoutes: Array<TradeRoute>;
  trafficSources: Array<TrafficSourceStats>;
  transcriptMinerStats: TranscriptMinerStats;
  transcription?: Maybe<Transcription>;
  /** Comments on a recording the caller can open, oldest first. */
  transcriptionComments: Array<TranscriptionComment>;
  transcriptionModels: TranscriptionModelsInfo;
  transcriptionSpeakerContacts: Array<TranscriptionSpeakerContact>;
  transcriptionSummaryModels: TranscriptionModelsInfo;
  /** @deprecated Unpaged. Use transcriptionsPage (paged, searchable). Kept only until Paradise is ported. */
  transcriptions: Array<Transcription>;
  /** Paged transcriptions, newest recording first. Default page size 20. */
  transcriptionsPage: PaginatedTranscriptions;
  trustActivities: Array<TrustActivity>;
  trustPeople: Array<TrustPerson>;
  trustPerson?: Maybe<TrustPerson>;
  unacknowledgedAlerts: ObservationAlertsResponse;
  unassignedDigitalManagers: Array<OrgChartUnassignedDigitalManager>;
  unassignedEmails: Array<Email>;
  unassignedEmployees: Array<OrgChartUnassignedEmployee>;
  unfinishedCheckIns: Array<CheckIn>;
  unfinishedRosterBulkOps: Array<RosterBulkOpLog>;
  unitConfigs: Array<UnitConfig>;
  unitTypeOptions: Array<EnumOption>;
  unplacedCompanyIds: Array<Scalars['String']['output']>;
  unreadInboundEmailCount: Scalars['Float']['output'];
  unreadMealPlanNotificationCount: Scalars['Int']['output'];
  unreadNotificationCount: Scalars['Int']['output'];
  unresolvedFeedback: Array<MealFeedback>;
  upcomingActions: Array<GoalAction>;
  upcomingEvents: Array<CalendarEvent>;
  upcomingRespiteBookings: Array<RespiteCareBooking>;
  upcomingReviews: Array<CareReview>;
  upcomingReviewsSummary: UpcomingReviewsSummary;
  upcomingShifts: Array<Shift>;
  urinalysisObservations: UrinalysisObservationsResponse;
  userAssignedPhoneNumbers: Array<TwilioPhoneNumber>;
  userAuditLogs: Array<MedicalAuditLog>;
  vaccinations: VaccinationsResponse;
  validateCoupon: CouponValidationResult;
  validateQRCode: Scalars['Boolean']['output'];
  vaultInsightRule?: Maybe<VaultInsightRule>;
  vaultInsightRules: Array<VaultInsightRule>;
  vaultInsightRun?: Maybe<VaultInsightRun>;
  vaultInsightRuns: Array<VaultInsightRun>;
  verifySarahCareMedicalFile: Scalars['Boolean']['output'];
  visionBoardConfig: VisionBoardConfig;
  visionBoardInviteGraph: Array<VisionBoardInviteGraphNode>;
  visionBoardInvites: Array<VisionBoardInvite>;
  visionBoardItem?: Maybe<VisionBoardItem>;
  visionBoardItems: Array<VisionBoardItem>;
  visionBoardNotificationRules: Array<VisionBoardNotificationRule>;
  visionBoardShareCandidates: Array<VisionBoardPerson>;
  visionBoardsSharedWithMe: Array<VisionBoardSummary>;
  vlogCategories: Array<VlogCategory>;
  vlogNotificationRules: Array<VlogNotificationRule>;
  vlogPost?: Maybe<VlogPost>;
  /** Public query: get a published vlog by slug */
  vlogPostBySlug?: Maybe<VlogPost>;
  /** Public query: get reaction counts for a vlog */
  vlogPostReactions: VlogReactionCounts;
  vlogPosts: Array<VlogPost>;
  /** Public query: published vlogs in a series */
  vlogPostsBySeries: Array<VlogPost>;
  /** Public query: get series by slug */
  vlogSeriesBySlug?: Maybe<VlogSeries>;
  vlogSeriesItem?: Maybe<VlogSeries>;
  /** Public query: list all series for this tenant */
  vlogSeriesList: Array<VlogSeries>;
  voiceContacts: VoiceContactPage;
  voiceSetupStatus: VoiceSetupStatus;
  voiceSignatures: Array<VoiceSignature>;
  voiceUsers: VoiceUserPage;
  voipCall?: Maybe<VoipCall>;
  voipCallNumbers: Array<Scalars['String']['output']>;
  voipCallVolume: Array<CallVolumeBucket>;
  voipCalls: PaginatedVoipCalls;
  voipNumbers: Array<VoipNumber>;
  voipSnapshot?: Maybe<VoipSnapshot>;
  voipSnapshots: Array<VoipSnapshot>;
  waitingList: Array<WaitingListEntry>;
  waitingListActivity: WaitingListActivityPage;
  waitingListAssignablePeople: Array<WaitingListAssignablePerson>;
  waitingListChecklistTemplates: Array<WaitingListChecklistTemplate>;
  waitingListCount: Scalars['Int']['output'];
  waitingListEntry?: Maybe<WaitingListEntry>;
  waitingListFamilyMessagePreview: WaitingListFamilyMessagePreview;
  waitingListFileDownloadUrl: Scalars['String']['output'];
  waitingListFiles: Array<WaitingListFile>;
  waitingListStats: WaitingListStats;
  waitingListTourMessagePreview: WaitingListTourMessagePreview;
  waitingListTourVideoInviteOptions: WaitingListTourVideoInviteOptions;
  waitingListUnsuitableMatches: Array<WaitingListUnsuitableMatch>;
  walletDirectorySuggestions: WalletDirectoryResult;
  walletInviteStatement?: Maybe<Scalars['String']['output']>;
  walletKeysForClient: Array<WalletKey>;
  waterlowAssessments: WaterlowAssessmentsResponse;
  websites: Array<Tenant>;
  websitesByClient: Array<Tenant>;
  websitesByCurrentClient: Array<Tenant>;
  weightObservations: WeightObservationsResponse;
  wingCounts: Array<WingCount>;
  wingsWithRooms: Array<Location>;
  withdrawalRequest?: Maybe<WithdrawalRequest>;
  withdrawalRequests: Array<WithdrawalRequest>;
  worker?: Maybe<Worker>;
  workerTimeEntries: Array<WorkerTimeEntry>;
  workerTimeEntry?: Maybe<WorkerTimeEntry>;
  workers: Array<Worker>;
  wound?: Maybe<Wound>;
  woundAssessments: WoundAssessmentsResponse;
  wounds: WoundsResponse;
  zkGetCredentials: Array<ZkCredential>;
  zkGetHelperData?: Maybe<Scalars['String']['output']>;
  zkGetSalt: Scalars['String']['output'];
};


export type QueryAbbeyPainAssessmentsArgs = {
  filter?: InputMaybe<AbbeyPainAssessmentFilterInput>;
};


export type QueryAccountabilityGoalArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAccountabilityGoalsArgs = {
  filter?: InputMaybe<GoalFilterInput>;
};


export type QueryAccountingBankAccountsArgs = {
  companyId: Scalars['ID']['input'];
};


export type QueryAccountingBankBalancesArgs = {
  companyId: Scalars['ID']['input'];
};


export type QueryAccountingCashForecastArgs = {
  companyId: Scalars['ID']['input'];
};


export type QueryAccountingDashboardArgs = {
  companyId: Scalars['ID']['input'];
};


export type QueryAccountingProfitLossArgs = {
  input: AccountingProfitLossInput;
};


export type QueryAccountingTransactionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAccountingTransactionsArgs = {
  input: AccountingTransactionListInput;
};


export type QueryAccountingXeroAuthorizeUrlArgs = {
  redirectUri: Scalars['String']['input'];
};


export type QueryAcfiAssessmentsArgs = {
  filter?: InputMaybe<AcfiAssessmentFilterInput>;
};


export type QueryAcmaEvidencePackArgs = {
  emailId: Scalars['ID']['input'];
};


export type QueryActiveBookableEventTypesArgs = {
  calendarId: Scalars['String']['input'];
};


export type QueryActiveCheckInArgs = {
  employeeId: Scalars['ID']['input'];
};


export type QueryActiveGoalsArgs = {
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryActiveSeparationScheduleArgs = {
  caseId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryAdminBusinessListingsArgs = {
  claimStatus?: InputMaybe<BusinessListingClaimStatus>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAdministrationComplianceReportArgs = {
  endDate: Scalars['DateTime']['input'];
  startDate: Scalars['DateTime']['input'];
};


export type QueryAdministrationHistoryArgs = {
  filter?: InputMaybe<AdministrationFilterInput>;
};


export type QueryAdmissionChecklistArgs = {
  residentId: Scalars['ID']['input'];
};


export type QueryAdmissionDischargeStatsArgs = {
  endDate: Scalars['DateTime']['input'];
  startDate: Scalars['DateTime']['input'];
};


export type QueryAdmissionNotificationRulesArgs = {
  scope?: InputMaybe<AdmissionNotificationScope>;
};


export type QueryAdvanceCarePlanArgs = {
  residentId: Scalars['ID']['input'];
};


export type QueryAgentBoardArgs = {
  reviewedDays?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAggregatedIngredientsForDateRangeArgs = {
  endDate: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
};


export type QueryAiOpsContentArgs = {
  contentRef: Scalars['String']['input'];
};


export type QueryAiOpsHardwareArgs = {
  window: AiOpsWindow;
};


export type QueryAiOpsHiddenArgs = {
  window: AiOpsWindow;
};


export type QueryAiOpsKeyEventListArgs = {
  input?: InputMaybe<AiOpsKeyEventListInput>;
};


export type QueryAiOpsKeyEventsArgs = {
  limit?: Scalars['Int']['input'];
};


export type QueryAiOpsKeyListArgs = {
  input?: InputMaybe<AiOpsKeyListInput>;
};


export type QueryAiOpsLiveArgs = {
  windowSec?: Scalars['Int']['input'];
};


export type QueryAiOpsModelRunsArgs = {
  limit?: Scalars['Int']['input'];
  window: AiOpsWindow;
};


export type QueryAiOpsRecentRequestsArgs = {
  limit?: Scalars['Int']['input'];
};


export type QueryAiOpsSessionsArgs = {
  limit?: Scalars['Int']['input'];
};


export type QueryAiOpsUsageArgs = {
  groupBy?: Scalars['String']['input'];
  window: AiOpsWindow;
  workOnly?: Scalars['Boolean']['input'];
};


export type QueryAiOpsVoiceCallListArgs = {
  input?: InputMaybe<AiOpsVoiceCallListInput>;
};


export type QueryAiOpsVoiceCallsArgs = {
  limit?: Scalars['Int']['input'];
  window?: AiOpsWindow;
};


export type QueryAiOpsVoiceStatsArgs = {
  window?: AiOpsWindow;
};


export type QueryAiPayAuditArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAiPayAuditsArgs = {
  payRunId: Scalars['ID']['input'];
};


export type QueryAiUsageLogsArgs = {
  filter?: InputMaybe<AiUsageFilter>;
  limit?: Scalars['Int']['input'];
};


export type QueryAiUsageStatsArgs = {
  filter?: InputMaybe<AiUsageFilter>;
};


export type QueryAllCalendarEventsArgs = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryAllClientAssessmentSnapshotsArgs = {
  filter?: InputMaybe<AssessmentSnapshotFilterInput>;
};


export type QueryAllClientMoodEntriesArgs = {
  filter?: InputMaybe<MoodFilterInput>;
};


export type QueryAllClientSnapshotsArgs = {
  filter?: InputMaybe<SnapshotFilterInput>;
};


export type QueryAllSeoMetadataArgs = {
  filters?: InputMaybe<SeoMetadataFilters>;
};


export type QueryAnaccClassificationsArgs = {
  filter?: InputMaybe<AnaccClassificationFilterInput>;
};


export type QueryAnalyticsEventsArgs = {
  filters?: InputMaybe<AnalyticsFilters>;
};


export type QueryAnalyticsNotificationRuleArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAnalyticsOverviewArgs = {
  filters?: InputMaybe<AnalyticsFilters>;
};


export type QueryAnalyticsSessionsArgs = {
  filters?: InputMaybe<AnalyticsFilters>;
};


export type QueryAnalyticsTimeSeriesArgs = {
  filters?: InputMaybe<AnalyticsFilters>;
};


export type QueryApiHubUsageLogsArgs = {
  apiListingId?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Float']['input']>;
};


export type QueryApiHubUsageTimelineArgs = {
  apiListingId?: InputMaybe<Scalars['String']['input']>;
  days?: InputMaybe<Scalars['Float']['input']>;
};


export type QueryArtSessionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryArtSessionsArgs = {
  competitionId?: InputMaybe<Scalars['ID']['input']>;
  schoolId?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<ArtSessionStatus>;
};


export type QueryArtifactArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryArtifactCommentsArgs = {
  artifactId: Scalars['ID']['input'];
};


export type QueryArtifactVersionsArgs = {
  artifactId: Scalars['ID']['input'];
};


export type QueryArtifactsArgs = {
  filter?: InputMaybe<ArtifactFilterInput>;
};


export type QueryAskHelpArgs = {
  input: HelpAskInput;
};


export type QueryAssessmentCustomFieldArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAssessmentCustomFieldsArgs = {
  category?: InputMaybe<Scalars['String']['input']>;
  includeInactive?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryAssessmentDomainArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAssessmentDomainsArgs = {
  includeInactive?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryAssessmentSnapshotArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAssessmentSnapshotCountArgs = {
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryAssessmentSnapshotsArgs = {
  filter?: InputMaybe<AssessmentSnapshotFilterInput>;
};


export type QueryAvailableBedsArgs = {
  roomId: Scalars['ID']['input'];
};


export type QueryAvailableClientsForEmployeeArgs = {
  excludeEmployeeId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryAvailableInboundEmailLabelsArgs = {
  includeSuggested?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryAvailableRoomsArgs = {
  wingId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryAvailableSessionsArgs = {
  endDate: Scalars['DateTime']['input'];
  startDate: Scalars['DateTime']['input'];
};


export type QueryAvailableTimeSlotsArgs = {
  calendarId: Scalars['String']['input'];
  endDate: Scalars['String']['input'];
  eventTypeId: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
};


export type QueryAwardArgs = {
  id: Scalars['String']['input'];
};


export type QueryAwardClassificationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAwardClassificationsArgs = {
  awardName?: InputMaybe<Scalars['String']['input']>;
  includeInactive?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryAwardRateTableArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAwardRateTablesArgs = {
  activeOnly?: Scalars['Boolean']['input'];
  awardClassificationId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryBankingAccountArgs = {
  id: Scalars['ID']['input'];
};


export type QueryBankingAccountActivityArgs = {
  accountId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryBankingAccountViewersArgs = {
  accountId: Scalars['ID']['input'];
};


export type QueryBankingActivityArgs = {
  kind?: InputMaybe<BankingFeedEventKind>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryBankingActivityEventArgs = {
  id: Scalars['ID']['input'];
};


export type QueryBankingCloseGateArgs = {
  month?: InputMaybe<Scalars['String']['input']>;
};


export type QueryBankingLoanForTransactionArgs = {
  transactionId: Scalars['ID']['input'];
};


export type QueryBankingMonthArgs = {
  month?: InputMaybe<Scalars['String']['input']>;
};


export type QueryBankingMonthComparisonArgs = {
  month?: InputMaybe<Scalars['String']['input']>;
};


export type QueryBankingMonthHistoryArgs = {
  endMonth?: InputMaybe<Scalars['String']['input']>;
  months?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryBankingMonthJobsArgs = {
  month?: InputMaybe<Scalars['String']['input']>;
};


export type QueryBankingNotificationLogArgs = {
  filter?: InputMaybe<BankingNotificationLogFilterInput>;
};


export type QueryBankingPricesArgs = {
  asset: BankingPriceAsset;
  days?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryBankingSnapshotArgs = {
  input: BankingSnapshotInput;
};


export type QueryBankingTransactionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryBankingTransactionCommentsArgs = {
  transactionId: Scalars['ID']['input'];
};


export type QueryBankingTransactionsArgs = {
  filter?: InputMaybe<BankingTransactionsFilterInput>;
};


export type QueryBankingTransactionsCsvArgs = {
  filter?: InputMaybe<BankingTransactionsFilterInput>;
};


export type QueryBdayGuestArgs = {
  id: Scalars['ID']['input'];
};


export type QueryBdayGuestBySlugArgs = {
  slug: Scalars['String']['input'];
};


export type QueryBillArgs = {
  id: Scalars['ID']['input'];
};


export type QueryBillPdfArgs = {
  id: Scalars['ID']['input'];
};


export type QueryBillsReportArgs = {
  input: BillsReportInput;
};


export type QueryBillsWeeklySnapshotsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryBladderRecordsArgs = {
  filter?: InputMaybe<BladderRecordFilterInput>;
};


export type QueryBlogPostArgs = {
  id: Scalars['ID']['input'];
};


export type QueryBlogPostBySlugArgs = {
  slug: Scalars['String']['input'];
};


export type QueryBlogPostReactionsArgs = {
  postId: Scalars['ID']['input'];
};


export type QueryBlogPostsArgs = {
  filter?: InputMaybe<BlogPostFilterInput>;
};


export type QueryBloodPressureObservationsArgs = {
  filter?: InputMaybe<BloodPressureFilterInput>;
};


export type QueryBloodSugarObservationsArgs = {
  filter?: InputMaybe<BloodSugarFilterInput>;
};


export type QueryBmiHistoryArgs = {
  residentId: Scalars['ID']['input'];
};


export type QueryBondArgs = {
  id: Scalars['ID']['input'];
};


export type QueryBondPaymentsArgs = {
  bondId: Scalars['ID']['input'];
};


export type QueryBondRegisterArgs = {
  includeSettled?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryBookableEventTypeArgs = {
  id: Scalars['String']['input'];
};


export type QueryBookableEventTypeStatsArgs = {
  id: Scalars['String']['input'];
};


export type QueryBookableEventTypesArgs = {
  calendarId: Scalars['String']['input'];
};


export type QueryBookingByIdArgs = {
  bookingId: Scalars['String']['input'];
};


export type QueryBookingsArgs = {
  endDate: Scalars['DateTime']['input'];
  startDate: Scalars['DateTime']['input'];
};


export type QueryBookingsByClientIdArgs = {
  clientId: Scalars['String']['input'];
};


export type QueryBookingsBySessionArgs = {
  sessionId: Scalars['String']['input'];
};


export type QueryBowelRecordsArgs = {
  filter?: InputMaybe<BowelRecordFilterInput>;
};


export type QueryBradenAssessmentsArgs = {
  filter?: InputMaybe<BradenAssessmentFilterInput>;
};


export type QueryBrowserStatsArgs = {
  filters?: InputMaybe<AnalyticsFilters>;
};


export type QueryBuildPortalAccessArgs = {
  dealId: Scalars['ID']['input'];
};


export type QueryBuildPortalBuildArgs = {
  dealId: Scalars['ID']['input'];
};


export type QueryBuildPortalMessagesArgs = {
  dealId: Scalars['ID']['input'];
};


export type QueryBuildPortalPreviewEmailTemplateArgs = {
  input: SaveEmailTemplateInput;
};


export type QueryBuildPortalProjectArgs = {
  dealId: Scalars['ID']['input'];
};


export type QueryBuildPortalTeamProfileArgs = {
  key: Scalars['String']['input'];
};


export type QueryBusinessChatSessionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryBusinessDirectoryDashboardArgs = {
  weeks?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryBusinessEnquiriesArgs = {
  filter?: InputMaybe<BusinessEnquiryFilterInput>;
};


export type QueryBusinessEnquiryCountArgs = {
  filter?: InputMaybe<BusinessEnquiryFilterInput>;
};


export type QueryBusinessListingActivityArgs = {
  listingId: Scalars['ID']['input'];
};


export type QueryBusinessListingForClientArgs = {
  clientId: Scalars['ID']['input'];
};


export type QueryBusinessSnapshotArgs = {
  id: Scalars['ID']['input'];
};


export type QueryBusinessSnapshotsArgs = {
  filter?: InputMaybe<BusinessSnapshotFilterInput>;
};


export type QueryCalculateBondInterestArgs = {
  asOfDate?: InputMaybe<Scalars['DateTime']['input']>;
  bondId: Scalars['ID']['input'];
};


export type QueryCalculatorSubmissionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCalculatorSubmissionsArgs = {
  filters?: InputMaybe<CalculatorSubmissionFilters>;
};


export type QueryCalculatorSubmissionsByDayArgs = {
  days?: InputMaybe<Scalars['Float']['input']>;
};


export type QueryCalendarArgs = {
  id: Scalars['String']['input'];
};


export type QueryCalendarAudienceSharesArgs = {
  calendarId: Scalars['String']['input'];
};


export type QueryCalendarAvailabilityArgs = {
  calendarId: Scalars['String']['input'];
};


export type QueryCalendarEventArgs = {
  id: Scalars['String']['input'];
};


export type QueryCalendarEventTaskArgs = {
  id: Scalars['String']['input'];
};


export type QueryCalendarEventTasksArgs = {
  calendarEventId: Scalars['String']['input'];
};


export type QueryCalendarEventsArgs = {
  calendarId: Scalars['String']['input'];
  endDate?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCalendarGoalArgs = {
  id: Scalars['String']['input'];
};


export type QueryCalendarGoalsArgs = {
  calendarId: Scalars['String']['input'];
  endDate?: InputMaybe<Scalars['String']['input']>;
  period?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCalendarHasAvailabilityArgs = {
  calendarId: Scalars['String']['input'];
};


export type QueryCalendarInvitationsArgs = {
  calendarId: Scalars['String']['input'];
};


export type QueryCalendarSearchPeopleArgs = {
  search: Scalars['String']['input'];
};


export type QueryCalendarSharesArgs = {
  calendarId: Scalars['String']['input'];
};


export type QueryCalendarTagsArgs = {
  calendarId: Scalars['String']['input'];
};


export type QueryCalendarsArgs = {
  includeShared?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<CalendarType>;
};


export type QueryCalendarsOnTenantArgs = {
  targetTenantId: Scalars['String']['input'];
};


export type QueryCallRecordingArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCallRecordingsArgs = {
  filter?: InputMaybe<CallRecordingFilterInput>;
  limit?: Scalars['Int']['input'];
  page?: Scalars['Int']['input'];
};


export type QueryCandidateArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCandidateActivityArgs = {
  candidateId: Scalars['ID']['input'];
};


export type QueryCandidateFormByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCandidateFormBySlugArgs = {
  formSlug: Scalars['String']['input'];
};


export type QueryCandidateFormSubmissionsArgs = {
  candidateId: Scalars['ID']['input'];
};


export type QueryCandidateInviteBySlugArgs = {
  slug: Scalars['String']['input'];
};


export type QueryCandidateInvitesArgs = {
  candidateId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryCandidateMessagesArgs = {
  candidateId: Scalars['ID']['input'];
};


export type QueryCandidateReferencesArgs = {
  candidateId: Scalars['ID']['input'];
};


export type QueryCareDayRecordsArgs = {
  fromDay: Scalars['String']['input'];
  toDay: Scalars['String']['input'];
};


export type QueryCareHomeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCareHomeActivityArgs = {
  careHomeId: Scalars['ID']['input'];
};


export type QueryCareHomeFilterOptionsArgs = {
  state?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCareHomeStatsArgs = {
  input?: InputMaybe<CareHomeSearchInput>;
};


export type QueryCareHomesArgs = {
  input?: InputMaybe<CareHomeSearchInput>;
};


export type QueryCareLegalRequirementsArgs = {
  filter?: InputMaybe<CareLegalRequirementFilterInput>;
};


export type QueryCareMinutesStatementArgs = {
  asFile?: InputMaybe<Scalars['Boolean']['input']>;
  periods: Array<CareStatementPeriodInput>;
};


export type QueryCarePlanArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCarePlanComplianceReportArgs = {
  carePlanId: Scalars['ID']['input'];
  periodEnd: Scalars['DateTime']['input'];
  periodStart: Scalars['DateTime']['input'];
};


export type QueryCarePlanPersonOptionsArgs = {
  residentId: Scalars['ID']['input'];
};


export type QueryCarePlanReviewArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCarePlanReviewsArgs = {
  filter?: InputMaybe<CarePlanReviewFilterInput>;
};


export type QueryCarePlanTemplateArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCarePlanTemplatesArgs = {
  filter?: InputMaybe<CarePlanTemplateFilterInput>;
};


export type QueryCarePlansArgs = {
  filter?: InputMaybe<CarePlanFilterInput>;
};


export type QueryCarePlansByResidentArgs = {
  activeOnly?: InputMaybe<Scalars['Boolean']['input']>;
  includeSarahHistory?: InputMaybe<Scalars['Boolean']['input']>;
  residentId: Scalars['ID']['input'];
};


export type QueryCarePlansReviewsDueArgs = {
  beforeDate?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryCareQuarterTargetsArgs = {
  fromQuarter?: InputMaybe<Scalars['String']['input']>;
  toQuarter?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCareReviewsArgs = {
  filter?: InputMaybe<CareReviewFilterInput>;
};


export type QueryCertifiedCoachBySlugArgs = {
  slug: Scalars['String']['input'];
};


export type QueryChannelContentCountsArgs = {
  url: Scalars['String']['input'];
};


export type QueryChargesByClientArgs = {
  clientId: Scalars['ID']['input'];
};


export type QueryChaseDraftSendPreviewArgs = {
  logId: Scalars['String']['input'];
};


export type QueryChaseNotificationRuleArgs = {
  id: Scalars['ID']['input'];
};


export type QueryChatMessagesArgs = {
  before?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  roomId: Scalars['ID']['input'];
};


export type QueryChatParticipantsArgs = {
  roomId: Scalars['ID']['input'];
};


export type QueryChatRoomArgs = {
  id: Scalars['ID']['input'];
};


export type QueryChatRoomBySlugArgs = {
  slug: Scalars['String']['input'];
};


export type QueryChatRoomsArgs = {
  status?: InputMaybe<ChatRoomStatus>;
};


export type QueryCheckAccountExistsArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCheckDomainAvailabilityArgs = {
  domain: Scalars['String']['input'];
};


export type QueryCheckInsArgs = {
  filter?: InputMaybe<CheckInFilterInput>;
};


export type QueryCheckUsernameAvailableArgs = {
  username: Scalars['String']['input'];
};


export type QueryChloeMessagesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  sessionId: Scalars['String']['input'];
};


export type QueryChloePendingActionsArgs = {
  sessionId: Scalars['String']['input'];
};


export type QueryCiGovernanceMeetingArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCiGovernanceMeetingsArgs = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<CiMeetingStatus>;
  type?: InputMaybe<CiMeetingType>;
};


export type QueryCiImprovementInitiativeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCiImprovementInitiativesArgs = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  linkedMaintenanceRequestId?: InputMaybe<Scalars['ID']['input']>;
  source?: InputMaybe<CiIssueSource>;
  standardSubClause?: InputMaybe<Scalars['String']['input']>;
  standards?: InputMaybe<Array<CiQualityStandard>>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<CiInitiativeStatus>;
};


export type QueryCiInitiativesByMaintenanceRequestArgs = {
  maintenanceRequestId: Scalars['ID']['input'];
};


export type QueryCiIssueReportArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCiIssueReportsArgs = {
  assignedTo?: InputMaybe<Scalars['ID']['input']>;
  category?: InputMaybe<CiIssueCategory>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  severity?: InputMaybe<CiIssueSeverity>;
  standard?: InputMaybe<CiQualityStandard>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<CiIssueStatus>;
};


export type QueryCiIssuesByInitiativeArgs = {
  initiativeId: Scalars['ID']['input'];
};


export type QueryCiMeetingLinkedInitiativesArgs = {
  meetingId: Scalars['ID']['input'];
};


export type QueryCiMeetingLinkedIssuesArgs = {
  meetingId: Scalars['ID']['input'];
};


export type QueryCiStandardMetadataArgs = {
  standard: CiQualityStandard;
};


export type QueryCiUpcomingMeetingsArgs = {
  limit?: InputMaybe<Scalars['Float']['input']>;
};


export type QueryClientArgs = {
  id: Scalars['ID']['input'];
};


export type QueryClientActivitiesArgs = {
  clientId: Scalars['ID']['input'];
  filters?: InputMaybe<ClientActivityFiltersInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryClientActivityArgs = {
  id: Scalars['ID']['input'];
};


export type QueryClientByEmailArgs = {
  email: Scalars['String']['input'];
};


export type QueryClientByPhoneArgs = {
  phoneNumber: Scalars['String']['input'];
};


export type QueryClientCalculatorSubmissionsArgs = {
  clientId: Scalars['ID']['input'];
};


export type QueryClientChaseConfigArgs = {
  id: Scalars['String']['input'];
};


export type QueryClientChaseLogsArgs = {
  configId?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<ChaseSuggestionStatus>;
};


export type QueryClientMentionablePeopleArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryClientNotificationRuleArgs = {
  id: Scalars['ID']['input'];
};


export type QueryClientRewardBalanceArgs = {
  clientId: Scalars['ID']['input'];
};


export type QueryClientStoryArgs = {
  clientId: Scalars['ID']['input'];
  input?: InputMaybe<ClientStoryInput>;
};


export type QueryClientsByPermissionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  permissions: Array<Scalars['String']['input']>;
};


export type QueryClientsByTagArgs = {
  tag: Scalars['String']['input'];
};


export type QueryClientsByTenantIdArgs = {
  tenantId: Scalars['ID']['input'];
};


export type QueryClinicalTasksArgs = {
  filter?: InputMaybe<ClinicalTaskFilterInput>;
};


export type QueryClub52FundingPanelArgs = {
  roomName: Scalars['String']['input'];
};


export type QueryClub52GameByRoomArgs = {
  roomName: Scalars['String']['input'];
};


export type QueryClub52IssuesArgs = {
  roomName: Scalars['String']['input'];
};


export type QueryClub52PlayerBalancesArgs = {
  roomName: Scalars['String']['input'];
};


export type QueryCoachArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCoachAgreementArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCoachAgreementsArgs = {
  coachId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryCodingRulesArgs = {
  companyId: Scalars['ID']['input'];
};


export type QueryCommandActivityCommentsArgs = {
  activityId?: InputMaybe<Scalars['ID']['input']>;
  dealId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryCommandActivityEntryArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCommandActivityPageArgs = {
  filters?: InputMaybe<CommandActivityFilters>;
};


export type QueryCommandCommissionDealArgs = {
  id: Scalars['String']['input'];
};


export type QueryCommandCommissionDealActivityArgs = {
  dealId: Scalars['String']['input'];
};


export type QueryCommandCommissionDealsArgs = {
  filters?: InputMaybe<CommissionDealFilters>;
};


export type QueryCommandCommissionOptionsArgs = {
  filters: CommissionOptionFilters;
};


export type QueryCommandCommissionProjectsArgs = {
  filters?: InputMaybe<CommissionProjectFilters>;
};


export type QueryCommandCommissionTrendsArgs = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<CommissionDealFilters>;
  granularity: CommissionTrendGranularity;
  periods?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCommandDealArgs = {
  id: Scalars['String']['input'];
};


export type QueryCommandDealAccessArgs = {
  dealId: Scalars['ID']['input'];
};


export type QueryCommandDealsArgs = {
  filters?: InputMaybe<CommandDealFilters>;
};


export type QueryCommandExecutiveSummaryArgs = {
  filters?: InputMaybe<ExecutiveDashboardFilters>;
};


export type QueryCommandMentionablePeopleArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCommandNotificationLogArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCommandPipedrivePanelArgs = {
  dealId: Scalars['ID']['input'];
  searchTerm?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCommandPreviewRuleAudienceArgs = {
  audiences: Array<Scalars['String']['input']>;
  specificClientIds?: InputMaybe<Array<Scalars['String']['input']>>;
  specificOptionIds?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryCommandSearchClientsForOptionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  search: Scalars['String']['input'];
};


export type QueryCommandWhoCannotSeeDealArgs = {
  dealId: Scalars['ID']['input'];
  people: Array<CommandTaggedPersonInput>;
};


export type QueryCommandXeroAuthorizeUrlArgs = {
  redirectUri: Scalars['String']['input'];
};


export type QueryCommandXeroInvoiceArgs = {
  invoiceId: Scalars['String']['input'];
};


export type QueryCommandXeroTransactionArgs = {
  paymentId: Scalars['String']['input'];
};


export type QueryCommandXeroTransactionsArgs = {
  filters?: InputMaybe<TransactionFilters>;
};


export type QueryCommsSmsAppsArgs = {
  days?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCommunicationHistoryArgs = {
  channel?: InputMaybe<GrowthCommunicationChannel>;
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  recipientId?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCommunicationTaskArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCommunicationTaskStatsArgs = {
  communicationId?: InputMaybe<Scalars['ID']['input']>;
  communicationType?: InputMaybe<CommunicationType>;
};


export type QueryCommunicationTasksArgs = {
  communicationId?: InputMaybe<Scalars['ID']['input']>;
  communicationType?: InputMaybe<CommunicationType>;
  status?: InputMaybe<CommunicationTaskStatus>;
};


export type QueryCommunityCampaignArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCommunityCheckInStatusArgs = {
  localDate: Scalars['String']['input'];
};


export type QueryCommunityEntryByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCommunityEntryRepliesArgs = {
  entryId: Scalars['ID']['input'];
};


export type QueryCommunityFeedForDateArgs = {
  localDate: Scalars['String']['input'];
};


export type QueryCommunityLeaderboardArgs = {
  localDate?: InputMaybe<Scalars['String']['input']>;
  period?: InputMaybe<CommunityLeaderboardPeriod>;
};


export type QueryCommunityMentionablePeopleArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCommunityPinnedVideoViewsArgs = {
  videoKey: Scalars['String']['input'];
};


export type QueryCommunityPostByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCommunityPostCommentsArgs = {
  postId: Scalars['ID']['input'];
};


export type QueryCommunityPostsArgs = {
  authorId?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCompanyArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCompanyCalendarsArgs = {
  companyId: Scalars['String']['input'];
};


export type QueryCompanyKnowledgeArticleArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCompanyKnowledgeArticlesArgs = {
  category?: InputMaybe<Scalars['String']['input']>;
  onlyPinned?: InputMaybe<Scalars['Boolean']['input']>;
  onlyPublished?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryCompareAssessmentSnapshotsArgs = {
  snapshotId1: Scalars['ID']['input'];
  snapshotId2: Scalars['ID']['input'];
};


export type QueryCompareSnapshotsArgs = {
  snapshotId1: Scalars['ID']['input'];
  snapshotId2: Scalars['ID']['input'];
};


export type QueryCompetitionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCompetitionActivityArgs = {
  competitionId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCompetitionEntriesArgs = {
  ageBand?: InputMaybe<CompetitionAgeBand>;
  competitionId: Scalars['ID']['input'];
  status?: InputMaybe<CompetitionEntryStatus>;
};


export type QueryCompetitionPrintLedgerArgs = {
  competitionId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryCompetitionPrintOffersArgs = {
  competitionId?: InputMaybe<Scalars['ID']['input']>;
  entryId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryCompetitionSchoolArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCompetitionSchoolsArgs = {
  status?: InputMaybe<CompetitionSchoolStatus>;
};


export type QueryCompetitionsArgs = {
  status?: InputMaybe<CompetitionStatus>;
};


export type QueryComprehensiveMedicalAssessmentArgs = {
  id: Scalars['ID']['input'];
};


export type QueryComprehensiveMedicalAssessmentsArgs = {
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  residentId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryConstructionSiteArgs = {
  id: Scalars['ID']['input'];
};


export type QueryConstructionSitesArgs = {
  status?: InputMaybe<SiteStatus>;
};


export type QueryContactFormSubmissionsArgs = {
  submissionUrl?: InputMaybe<Scalars['String']['input']>;
};


export type QueryContributingFactorsArgs = {
  filter?: InputMaybe<ContributingFactorFilterInput>;
};


export type QueryCouponArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCrewSitesByPhoneArgs = {
  phone: Scalars['String']['input'];
};


export type QueryCryptoVaultArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCurrentBmiArgs = {
  residentId: Scalars['ID']['input'];
};


export type QueryCurrentMedicationsArgs = {
  residentId: Scalars['ID']['input'];
};


export type QueryCurrentMonthGoalsArgs = {
  calendarId: Scalars['String']['input'];
};


export type QueryCurrentResidentsArgs = {
  wing?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCustodyValidatorArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCustomQuestionsArgs = {
  incidentTypeId: Scalars['ID']['input'];
  includeInactive?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCustomTestDefinitionsArgs = {
  moduleId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryDailyAllocationSheetArgs = {
  date: Scalars['DateTime']['input'];
};


export type QueryDailyAllocationStalenessForWeekArgs = {
  weekStart: Scalars['DateTime']['input'];
};


export type QueryDailyCareHeadingConfigArgs = {
  profileType: ProfileType;
};


export type QueryDailyCareHeadingsArgs = {
  profileType: ProfileType;
};


export type QueryDailyCareProfileArgs = {
  residentId: Scalars['ID']['input'];
};


export type QueryDailyCareProfileByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDailyCareProfilesArgs = {
  filter?: InputMaybe<DailyCareProfileFilterInput>;
};


export type QueryDailyCareProfilesByTypeArgs = {
  profileType: ProfileType;
};


export type QueryDayBookEntriesArgs = {
  filter?: InputMaybe<DayBookFilterInput>;
};


export type QueryDayBookSignOffHistoryArgs = {
  filter: SignOffHistoryFilterInput;
};


export type QueryDepartmentArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDepartmentLeaveRequestsArgs = {
  endDate: Scalars['DateTime']['input'];
  startDate: Scalars['DateTime']['input'];
};


export type QueryDepartmentsArgs = {
  includeInactive?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryDeviceStatsArgs = {
  filters?: InputMaybe<AnalyticsFilters>;
};


export type QueryDigitalManagerArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDigitalManagerChasesArgs = {
  filter?: InputMaybe<DigitalManagerChaseFilterInput>;
};


export type QueryDigitalManagerMemoriesArgs = {
  filter: DigitalManagerMemoryFilterInput;
};


export type QueryDigitalManagerMemoryArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDigitalManagerNotificationRuleArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDigitalManagerNotificationRulesArgs = {
  filter?: InputMaybe<DigitalManagerNotificationRuleFilterInput>;
};


export type QueryDigitalManagerOQsArgs = {
  managerId: Scalars['ID']['input'];
};


export type QueryDigitalManagerRuleArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDigitalManagerRulesArgs = {
  filter: DigitalManagerRuleFilterInput;
};


export type QueryDigitalManagerSessionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDigitalManagerSessionsArgs = {
  filter: DigitalManagerSessionFilterInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryDigitalManagerStandupsArgs = {
  filter: DigitalManagerStandupFilterInput;
};


export type QueryDigitalManagerTemplateArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDigitalManagerTemplateByKeyArgs = {
  key: Scalars['String']['input'];
};


export type QueryDigitalManagersArgs = {
  filter?: InputMaybe<DigitalManagerFilterInput>;
};


export type QueryDistinctSendersArgs = {
  filters?: InputMaybe<EmailFilterInput>;
  limit?: Scalars['Int']['input'];
};


export type QueryDomainArgs = {
  id: Scalars['String']['input'];
};


export type QueryDomainDnsRecordsArgs = {
  domain: Scalars['String']['input'];
  launchedSiteId: Scalars['ID']['input'];
};


export type QueryDomainHealthArgs = {
  domain: Scalars['String']['input'];
  launchedSiteId: Scalars['ID']['input'];
};


export type QueryDressingSchedulesArgs = {
  filter?: InputMaybe<DressingScheduleFilterInput>;
};


export type QueryDroneSessionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDroneSessionBySessionIdArgs = {
  sessionId: Scalars['String']['input'];
};


export type QueryDroneSessionFilesArgs = {
  sessionId: Scalars['String']['input'];
};


export type QueryDroneSessionProgressArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDroneSessionsArgs = {
  filters?: InputMaybe<DroneSessionFilters>;
};


export type QueryDroneSessionsWithPaginationArgs = {
  filters?: InputMaybe<DroneSessionFilters>;
};


export type QueryDuplicateCandidatesArgs = {
  baseId: Scalars['ID']['input'];
};


export type QueryEmailArgs = {
  id: Scalars['ID']['input'];
};


export type QueryEmailAddressArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
};


export type QueryEmailAddressesArgs = {
  isBlocked?: InputMaybe<Scalars['Boolean']['input']>;
  isVerified?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: Scalars['Float']['input'];
  offset?: Scalars['Float']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};


export type QueryEmailAiMemoriesArgs = {
  filter?: InputMaybe<EmailAiMemoryFilterInput>;
};


export type QueryEmailAiMemoryArgs = {
  id: Scalars['ID']['input'];
};


export type QueryEmailAiProcessingLogArgs = {
  id: Scalars['ID']['input'];
};


export type QueryEmailAiProcessingLogsArgs = {
  inboundEmailId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryEmailAiRuleArgs = {
  id: Scalars['ID']['input'];
};


export type QueryEmailAiRulesArgs = {
  filter?: InputMaybe<EmailAiRuleFilterInput>;
};


export type QueryEmailBacklogJobArgs = {
  id: Scalars['ID']['input'];
};


export type QueryEmailInboxArgs = {
  clientId?: InputMaybe<Scalars['String']['input']>;
  emailAddress?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  isUnassigned?: InputMaybe<Scalars['Boolean']['input']>;
  isUnread?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
};


export type QueryEmailInboxPaginatedArgs = {
  emailAddress?: InputMaybe<Scalars['String']['input']>;
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
};


export type QueryEmailThreadArgs = {
  emailId: Scalars['ID']['input'];
};


export type QueryEmailsArgs = {
  limit?: InputMaybe<Scalars['Float']['input']>;
  offset?: InputMaybe<Scalars['Float']['input']>;
};


export type QueryEmergencyContactsArgs = {
  residentId: Scalars['ID']['input'];
};


export type QueryEmployeeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryEmployeeActivitiesArgs = {
  employeeId: Scalars['ID']['input'];
  filters?: InputMaybe<EmployeeActivityFiltersInput>;
  limit?: InputMaybe<Scalars['Float']['input']>;
  offset?: InputMaybe<Scalars['Float']['input']>;
};


export type QueryEmployeeActivityArgs = {
  id: Scalars['ID']['input'];
};


export type QueryEmployeeActivityCommentsArgs = {
  employeeId: Scalars['ID']['input'];
  subjectId: Scalars['ID']['input'];
  subjectType: EmployeeActivityCommentSubject;
};


export type QueryEmployeeAdpFormStatusArgs = {
  employeeId: Scalars['ID']['input'];
};


export type QueryEmployeeByEmailArgs = {
  email: Scalars['String']['input'];
};


export type QueryEmployeeChecklistsArgs = {
  employeeId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryEmployeeContractDerivedValuesArgs = {
  facts: EmployeeContractFactsInput;
};


export type QueryEmployeeContractTemplateArgs = {
  id: Scalars['ID']['input'];
};


export type QueryEmployeeContractTemplatesArgs = {
  activeOnly?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryEmployeeCredentialExpiriesArgs = {
  includeOk?: InputMaybe<Scalars['Boolean']['input']>;
  withinDays?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryEmployeeIncidentArgs = {
  id: Scalars['ID']['input'];
};


export type QueryEmployeeIncidentsArgs = {
  filters?: InputMaybe<EmployeeIncidentFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryEmployeeInviteContractArgs = {
  highlight?: InputMaybe<Scalars['Boolean']['input']>;
  inviteId: Scalars['ID']['input'];
};


export type QueryEmployeeLeaveBalanceWorkingArgs = {
  employeeId: Scalars['ID']['input'];
  payRunEnd?: InputMaybe<Scalars['String']['input']>;
};


export type QueryEmployeeLeaveBalancesArgs = {
  employeeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  payRunEnd?: InputMaybe<Scalars['String']['input']>;
};


export type QueryEmployeeOnboardingStatusArgs = {
  employeeId: Scalars['ID']['input'];
};


export type QueryEmployeePositionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryEmployeePositionsArgs = {
  includeInactive?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryEmployeeRecommendationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryEmployeeRecommendationsArgs = {
  status?: InputMaybe<EmployeeRecommendationStatus>;
};


export type QueryEmployeeRoleArgs = {
  id: Scalars['ID']['input'];
};


export type QueryEmployeeRolesArgs = {
  includeInactive?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryEmployeeShiftHoursContextArgs = {
  employeeIds: Array<Scalars['ID']['input']>;
  shiftId: Scalars['ID']['input'];
};


export type QueryEmployeeSignedFormsArgs = {
  employeeId: Scalars['ID']['input'];
};


export type QueryEmployeeStatusOptionsArgs = {
  includeInactive?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryEmployeeTrainingAssignmentArgs = {
  id: Scalars['ID']['input'];
};


export type QueryEmployeeTrainingAssignmentsArgs = {
  employeeId: Scalars['ID']['input'];
};


export type QueryEmployeeTrainingCategoriesArgs = {
  includeInactive?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryEmployeesByClientArgs = {
  clientId: Scalars['ID']['input'];
};


export type QueryEmployeesPaginatedArgs = {
  input?: InputMaybe<EmployeePaginationInput>;
};


export type QueryEmpowermentActivityArgs = {
  journeyId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  subjectId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryEmpowermentCatchUpsArgs = {
  checkInId: Scalars['ID']['input'];
};


export type QueryEmpowermentCheckInArgs = {
  id: Scalars['ID']['input'];
};


export type QueryEmpowermentCheckInQuestionsArgs = {
  checkInId: Scalars['ID']['input'];
};


export type QueryEmpowermentCheckInsArgs = {
  input?: InputMaybe<EmpowermentCheckInListInput>;
};


export type QueryEmpowermentEmployeeSummaryArgs = {
  employeeId: Scalars['ID']['input'];
};


export type QueryEmpowermentEnrolDefaultsArgs = {
  clientId: Scalars['ID']['input'];
};


export type QueryEmpowermentGoalsArgs = {
  journeyId: Scalars['ID']['input'];
};


export type QueryEmpowermentGrowthArgs = {
  journeyId: Scalars['ID']['input'];
};


export type QueryEmpowermentJourneyArgs = {
  id: Scalars['ID']['input'];
};


export type QueryEmpowermentJourneyCheckInsArgs = {
  journeyId: Scalars['ID']['input'];
};


export type QueryEmpowermentJourneysArgs = {
  input?: InputMaybe<EmpowermentJourneyListInput>;
};


export type QueryEmpowermentLinkableTranscriptionsArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryEmpowermentPeopleSearchArgs = {
  search: Scalars['String']['input'];
};


export type QueryEmpowermentPromptLogArgs = {
  checkInId: Scalars['ID']['input'];
};


export type QueryEmpowermentQuestionsArgs = {
  includeRetired?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryEmpowermentReflectionsArgs = {
  checkInId: Scalars['ID']['input'];
};


export type QueryEmpowermentStartDatePreviewArgs = {
  journeyId: Scalars['ID']['input'];
  startDate: Scalars['String']['input'];
};


export type QueryEmpowermentTeamInsightsArgs = {
  months?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryEventBillSummaryArgs = {
  eventId: Scalars['ID']['input'];
};


export type QueryEventRegistrationArgs = {
  id: Scalars['String']['input'];
};


export type QueryEventRegistrationStatsArgs = {
  eventId: Scalars['String']['input'];
};


export type QueryEventRegistrationsArgs = {
  filter?: InputMaybe<EventRegistrationFilterInput>;
};


export type QueryEventStatsArgs = {
  filters?: InputMaybe<AnalyticsFilters>;
};


export type QueryExceptionReportArgs = {
  filter?: InputMaybe<ExceptionReportFilterInput>;
};


export type QueryExportIncidentsCsvArgs = {
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  incidentTypeIds?: InputMaybe<Array<Scalars['String']['input']>>;
  statuses?: InputMaybe<Array<IncidentStatus>>;
};


export type QueryExportMedicalAuditLogsArgs = {
  endDate: Scalars['DateTime']['input'];
  startDate: Scalars['DateTime']['input'];
};


export type QueryExportPayRunAdpCsvArgs = {
  format?: AdpCsvFormat;
  payRunId: Scalars['ID']['input'];
};


export type QueryExportProjectTasksToMarkdownArgs = {
  projectId: Scalars['ID']['input'];
};


export type QueryExportTenantModuleCsvArgs = {
  key: Scalars['String']['input'];
};


export type QueryExpressionsOfInterestArgs = {
  projectId: Scalars['ID']['input'];
};


export type QueryExtractAgentFieldsArgs = {
  fields: Array<Scalars['String']['input']>;
  transcript: Scalars['String']['input'];
};


export type QueryFeedbackActivitiesArgs = {
  feedbackId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryFeedbackByMealPlanArgs = {
  mealPlanId: Scalars['ID']['input'];
};


export type QueryFeedbackByRecipeArgs = {
  recipeId: Scalars['ID']['input'];
};


export type QueryFeedbackItemArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFeedbackItemsArgs = {
  assignedToId?: InputMaybe<Scalars['ID']['input']>;
  kind?: InputMaybe<FeedbackKind>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  openOnly?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<FeedbackStatus>;
  topic?: InputMaybe<FeedbackTopic>;
};


export type QueryFeedbackLinkCandidatesArgs = {
  kind: FeedbackOutcomeKind;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFeedbackLinkedToArgs = {
  kind: FeedbackOutcomeKind;
  targetId: Scalars['ID']['input'];
};


export type QueryFileTransferArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFileTransfersArgs = {
  filters?: InputMaybe<FileTransferFilters>;
};


export type QueryFinancialActivitiesArgs = {
  filter?: InputMaybe<FinancialActivityFilterInput>;
};


export type QueryFinancialActivityReportArgs = {
  endDate: Scalars['DateTime']['input'];
  startDate: Scalars['DateTime']['input'];
};


export type QueryFluidBalanceDaysArgs = {
  filter?: InputMaybe<FluidBalanceFilterInput>;
};


export type QueryFluidBalanceEntriesArgs = {
  filter?: InputMaybe<FluidBalanceFilterInput>;
};


export type QueryFoodBudgetSummaryArgs = {
  anchorDate?: InputMaybe<Scalars['String']['input']>;
  customEnd?: InputMaybe<Scalars['String']['input']>;
  customStart?: InputMaybe<Scalars['String']['input']>;
  period: BudgetPeriod;
};


export type QueryFoodIntakeDaysArgs = {
  filter?: InputMaybe<FoodIntakeFilterInput>;
};


export type QueryFoodSpendByCategoryArgs = {
  anchorDate?: InputMaybe<Scalars['String']['input']>;
  customEnd?: InputMaybe<Scalars['String']['input']>;
  customStart?: InputMaybe<Scalars['String']['input']>;
  period: BudgetPeriod;
};


export type QueryFoodSpendBySupplierArgs = {
  anchorDate?: InputMaybe<Scalars['String']['input']>;
  customEnd?: InputMaybe<Scalars['String']['input']>;
  customStart?: InputMaybe<Scalars['String']['input']>;
  period: BudgetPeriod;
};


export type QueryFrontendUpgradeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFrontendUpgradesArgs = {
  category?: InputMaybe<UpgradeCategory>;
  status?: InputMaybe<UpgradeStatus>;
  tenantId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryFuelReadingsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  stationId: Scalars['ID']['input'];
};


export type QueryFuelStationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFuelStationsArgs = {
  filters?: InputMaybe<FuelStationFiltersInput>;
};


export type QueryGenerateChefCheatSheetArgs = {
  date: Scalars['String']['input'];
};


export type QueryGenerateDailyMenuPdfArgs = {
  date: Scalars['String']['input'];
  pageSize?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGenerateEmployeeAdpFormArgs = {
  employeeId: Scalars['ID']['input'];
};


export type QueryGenerateMealPlanRangePdfArgs = {
  endDate: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
};


export type QueryGenerateOrderPdfArgs = {
  orderId: Scalars['ID']['input'];
};


export type QueryGeneratePayRunAbaFileArgs = {
  payRunId: Scalars['ID']['input'];
};


export type QueryGeneratePayRunErcPdfArgs = {
  employeeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  payRunId: Scalars['ID']['input'];
};


export type QueryGeneratePaygSummaryCsvArgs = {
  periodFrom?: InputMaybe<Scalars['DateTime']['input']>;
  periodTo?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryGeneratePaygSummaryPdfArgs = {
  periodFrom?: InputMaybe<Scalars['DateTime']['input']>;
  periodTo?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryGeneratePayrollJournalPdfArgs = {
  payRunId: Scalars['ID']['input'];
};


export type QueryGeneratePayrollRegisterCsvArgs = {
  payRunId: Scalars['ID']['input'];
};


export type QueryGeneratePayrollRegisterPdfArgs = {
  payRunId: Scalars['ID']['input'];
};


export type QueryGeneratePayslipPdfArgs = {
  employeeId: Scalars['ID']['input'];
  payRunId: Scalars['ID']['input'];
};


export type QueryGenerateSuperLiabilityCsvArgs = {
  periodFrom?: InputMaybe<Scalars['DateTime']['input']>;
  periodTo?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryGenerateSuperLiabilityPdfArgs = {
  periodFrom?: InputMaybe<Scalars['DateTime']['input']>;
  periodTo?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryGeneratedDailyAllocationOdsArgs = {
  date: Scalars['DateTime']['input'];
};


export type QueryGeneratedFortnightlyRosterXlsxArgs = {
  employeeSortMode?: InputMaybe<RosterEmployeeSortMode>;
  numDays?: InputMaybe<Scalars['Int']['input']>;
  scope: RosterExportScope;
  shiftIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  startDate: Scalars['DateTime']['input'];
  statusScope: RosterExportStatusScope;
};


export type QueryGeneratedWeeklyAllocationXlsxArgs = {
  weekStart: Scalars['DateTime']['input'];
};


export type QueryGetAgentConfigArgs = {
  agentKey: Scalars['String']['input'];
};


export type QueryGetAvailabilityByPractitionerIdArgs = {
  endDate: Scalars['String']['input'];
  practitionerId: Scalars['ID']['input'];
  startDate: Scalars['String']['input'];
};


export type QueryGetAwardVersionForDateArgs = {
  awardId: Scalars['String']['input'];
  date: Scalars['DateTime']['input'];
};


export type QueryGetBillCompanyArgs = {
  billId: Scalars['ID']['input'];
};


export type QueryGetBillIssuerDetailsArgs = {
  billId: Scalars['ID']['input'];
};


export type QueryGetBillToCompanyArgs = {
  billId: Scalars['ID']['input'];
};


export type QueryGetBookingByTokenArgs = {
  token: Scalars['String']['input'];
};


export type QueryGetBookingCalendarUrlArgs = {
  brand?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetBookingsByPractitionerIdArgs = {
  practitionerId: Scalars['String']['input'];
};


export type QueryGetCalendarsByIdsArgs = {
  ids: Array<Scalars['String']['input']>;
};


export type QueryGetClientDetailsByBillIdArgs = {
  billId: Scalars['ID']['input'];
};


export type QueryGetCoreActivitiesArgs = {
  projectId: Scalars['String']['input'];
};


export type QueryGetEventDetailsArgs = {
  eventId: Scalars['String']['input'];
};


export type QueryGetFarmImagesArgs = {
  page?: Scalars['Int']['input'];
};


export type QueryGetFarmerByIdArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetFileArgs = {
  hash: Scalars['String']['input'];
};


export type QueryGetFilesArgs = {
  hashes: Array<Scalars['String']['input']>;
};


export type QueryGetLinkedEmailForCalendarArgs = {
  calendarId: Scalars['String']['input'];
  tenantId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetLocationQrCodeArgs = {
  locationId: Scalars['ID']['input'];
};


export type QueryGetOptimizedImageUrlArgs = {
  height?: InputMaybe<Scalars['Int']['input']>;
  imageUrl: Scalars['String']['input'];
  width?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetProposalArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetProposalBySlugArgs = {
  slug: Scalars['String']['input'];
};


export type QueryGetProposalSignatureArgs = {
  proposalId: Scalars['String']['input'];
};


export type QueryGetProposalSignaturesArgs = {
  proposalId: Scalars['ID']['input'];
};


export type QueryGetRdActivitiesArgs = {
  projectId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetRdActivityArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetRdCommunicationLogsArgs = {
  projectId: Scalars['String']['input'];
};


export type QueryGetRdEvidenceArgs = {
  activityId?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetRdProjectArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetRdProjectGapAnalysisArgs = {
  projectId: Scalars['String']['input'];
};


export type QueryGetRdProjectTotalHoursArgs = {
  projectId: Scalars['String']['input'];
};


export type QueryGetRdProjectsByStatusArgs = {
  status: Scalars['String']['input'];
};


export type QueryGetRdTimeEntriesArgs = {
  activityId?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  projectId?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetVapiCallLogArgs = {
  callId: Scalars['String']['input'];
};


export type QueryGithubCollaboratorsArgs = {
  launchedSiteId: Scalars['ID']['input'];
};


export type QueryGoalActionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGoalActionsArgs = {
  filter?: InputMaybe<ActionFilterInput>;
  goalId: Scalars['ID']['input'];
};


export type QueryGoalMonthComparisonArgs = {
  calendarId: Scalars['String']['input'];
  month: Scalars['String']['input'];
};


export type QueryGoalRewardArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGoalRewardsArgs = {
  filter?: InputMaybe<RewardFilterInput>;
};


export type QueryGoalStatisticsArgs = {
  calendarId: Scalars['String']['input'];
  period?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGoalStatsArgs = {
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGoalsBySnapshotArgs = {
  snapshotId: Scalars['ID']['input'];
};


export type QueryGoalsForMonthArgs = {
  calendarId: Scalars['String']['input'];
  month: Scalars['String']['input'];
};


export type QueryGovActiveMemberCountArgs = {
  organisationId: Scalars['ID']['input'];
};


export type QueryGovActivityArgs = {
  kind?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  organisationId: Scalars['ID']['input'];
  subjectId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGovActivityCommentsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  organisationId: Scalars['ID']['input'];
};


export type QueryGovActivityEntryArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGovActivityPageArgs = {
  kind?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organisationId: Scalars['ID']['input'];
  subjectId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGovApplicationsArgs = {
  organisationId: Scalars['ID']['input'];
  status?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGovChecklistItemsArgs = {
  organisationId: Scalars['ID']['input'];
};


export type QueryGovChecklistsArgs = {
  organisationId: Scalars['ID']['input'];
  subjectId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGovDecisionsArgs = {
  organisationId: Scalars['ID']['input'];
};


export type QueryGovDefaultNotificationScheduleArgs = {
  organisationId: Scalars['ID']['input'];
};


export type QueryGovDelegationCountsArgs = {
  organisationId: Scalars['ID']['input'];
};


export type QueryGovInviteGraphArgs = {
  organisationId: Scalars['ID']['input'];
};


export type QueryGovInvitesArgs = {
  organisationId: Scalars['ID']['input'];
};


export type QueryGovJobMarketplaceArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGovJobSpecArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGovJobSpecsArgs = {
  organisationId: Scalars['ID']['input'];
  status?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGovJoinOptionsArgs = {
  organisationId: Scalars['ID']['input'];
};


export type QueryGovMembersArgs = {
  organisationId: Scalars['ID']['input'];
  status?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGovMembershipPlansArgs = {
  includeRetired?: InputMaybe<Scalars['Boolean']['input']>;
  organisationId: Scalars['ID']['input'];
};


export type QueryGovMembershipRegisterArgs = {
  organisationId: Scalars['ID']['input'];
};


export type QueryGovMentionablePeopleArgs = {
  organisationId: Scalars['ID']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGovNotificationRulesArgs = {
  organisationId: Scalars['ID']['input'];
};


export type QueryGovOrganisationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGovOrganisationDeleteCheckArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGovOrganisationDraftDiffArgs = {
  draft: GovRulesDraftInput;
  organisationId: Scalars['ID']['input'];
};


export type QueryGovOrganisationEntryArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGovOrganisationRevisionDiffArgs = {
  fromVersion: Scalars['Int']['input'];
  organisationId: Scalars['ID']['input'];
  toVersion: Scalars['Int']['input'];
};


export type QueryGovOrganisationRevisionsArgs = {
  organisationId: Scalars['ID']['input'];
};


export type QueryGovParticipantsArgs = {
  organisationId: Scalars['ID']['input'];
};


export type QueryGovProposalArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGovProposalRevisionsArgs = {
  proposalId: Scalars['ID']['input'];
};


export type QueryGovProposalTallyArgs = {
  proposalId: Scalars['ID']['input'];
};


export type QueryGovProposalsArgs = {
  organisationId: Scalars['ID']['input'];
  status?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGovTokenGrantsArgs = {
  organisationId: Scalars['ID']['input'];
};


export type QueryGovTreasuryAccountsArgs = {
  organisationId: Scalars['ID']['input'];
};


export type QueryGovTreasuryMovementsArgs = {
  organisationId: Scalars['ID']['input'];
};


export type QueryGovVotesArgs = {
  proposalId: Scalars['ID']['input'];
};


export type QueryGovWorkClaimsArgs = {
  workItemId: Scalars['ID']['input'];
};


export type QueryGovWorkItemArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGovWorkItemsArgs = {
  organisationId: Scalars['ID']['input'];
  status?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGovWorkProofsArgs = {
  workItemId: Scalars['ID']['input'];
};


export type QueryGraphExtractJobArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGraphExtractJobsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryHarvestFailuresArgs = {
  sourceId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryHarvestSourceArgs = {
  id: Scalars['ID']['input'];
};


export type QueryHarvestedVideoArgs = {
  id: Scalars['ID']['input'];
};


export type QueryHarvestedVideosArgs = {
  contentKind?: InputMaybe<ChannelContent>;
  ingestStatus?: InputMaybe<IngestStatus>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<VideoSort>;
  sourceId?: InputMaybe<Scalars['ID']['input']>;
  transcriptStatus?: InputMaybe<TranscriptStatus>;
};


export type QueryHeightObservationsArgs = {
  filter?: InputMaybe<HeightObservationFilterInput>;
};


export type QueryHistoricalAssessmentInstrumentsArgs = {
  residentId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryHistoricalAssessmentsArgs = {
  instrumentCode: Scalars['String']['input'];
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  residentId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryHolisticSnapshotArgs = {
  id: Scalars['ID']['input'];
};


export type QueryHolisticSnapshotsArgs = {
  filter?: InputMaybe<SnapshotFilterInput>;
};


export type QueryHostingAffiliateArgs = {
  id: Scalars['ID']['input'];
};


export type QueryHostingBuildLogArgs = {
  deploymentId: Scalars['String']['input'];
  siteId: Scalars['ID']['input'];
};


export type QueryHostingCommissionPaymentsArgs = {
  referralId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryHostingDeployRunsArgs = {
  siteId: Scalars['ID']['input'];
};


export type QueryHostingOfferArgs = {
  id: Scalars['ID']['input'];
};


export type QueryHostingReferralsArgs = {
  affiliateId?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<HostingReferralStatus>;
};


export type QueryHostingSiteArgs = {
  id: Scalars['ID']['input'];
};


export type QueryHostingSiteBuildsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  siteId: Scalars['ID']['input'];
};


export type QueryInboundEmailArgs = {
  id: Scalars['ID']['input'];
};


export type QueryInboundEmailThreadArgs = {
  threadId: Scalars['String']['input'];
};


export type QueryInboundEmailsArgs = {
  folder?: InputMaybe<Scalars['String']['input']>;
  isRead?: InputMaybe<Scalars['Boolean']['input']>;
  isStarred?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Float']['input']>;
  offset?: InputMaybe<Scalars['Float']['input']>;
  showAllAsAdmin?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryInboundEmailsByCalendarEventArgs = {
  calendarEventId: Scalars['ID']['input'];
};


export type QueryInboundEmailsForOpportunityArgs = {
  opportunityId: Scalars['ID']['input'];
};


export type QueryInboundSearchBreakdownArgs = {
  filters?: InputMaybe<EmailFilterInput>;
};


export type QueryInboxSummariesArgs = {
  filter?: InputMaybe<InboxSummaryFilterInput>;
};


export type QueryInboxSummaryArgs = {
  id: Scalars['ID']['input'];
};


export type QueryIncidentArgs = {
  id: Scalars['ID']['input'];
};


export type QueryIncidentAlertsArgs = {
  filter?: InputMaybe<AlertFilterInput>;
};


export type QueryIncidentContributingFactorTrendArgs = {
  endDate: Scalars['DateTime']['input'];
  startDate: Scalars['DateTime']['input'];
};


export type QueryIncidentCustomAnswersArgs = {
  incidentId: Scalars['ID']['input'];
};


export type QueryIncidentDailyTrendArgs = {
  endDate: Scalars['DateTime']['input'];
  startDate: Scalars['DateTime']['input'];
};


export type QueryIncidentDocumentsArgs = {
  incidentId: Scalars['ID']['input'];
};


export type QueryIncidentFollowUpsArgs = {
  filter?: InputMaybe<FollowUpFilterInput>;
};


export type QueryIncidentInjuriesArgs = {
  incidentId: Scalars['ID']['input'];
};


export type QueryIncidentLocationTrendArgs = {
  endDate: Scalars['DateTime']['input'];
  startDate: Scalars['DateTime']['input'];
};


export type QueryIncidentLocationsArgs = {
  filter?: InputMaybe<IncidentLocationFilterInput>;
};


export type QueryIncidentLocationsByWingArgs = {
  wing: Scalars['String']['input'];
};


export type QueryIncidentMonthlyTrendArgs = {
  year: Scalars['Int']['input'];
};


export type QueryIncidentRiskAssessmentArgs = {
  incidentId: Scalars['ID']['input'];
};


export type QueryIncidentTreatmentPlanArgs = {
  incidentId: Scalars['ID']['input'];
};


export type QueryIncidentTypesArgs = {
  filter?: InputMaybe<IncidentTypeFilterInput>;
};


export type QueryIncidentWitnessesArgs = {
  incidentId: Scalars['ID']['input'];
};


export type QueryIncidentsArgs = {
  filter?: InputMaybe<IncidentFilterInput>;
};


export type QueryIncomingDeliveryTemperatureArgs = {
  id: Scalars['ID']['input'];
};


export type QueryIncomingDeliveryTemperaturesArgs = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  foodType?: InputMaybe<DeliveryFoodType>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  supplierId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryIncompleteTasksArgs = {
  calendarId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryInfluenceSummaryArgs = {
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryInfluencerArgs = {
  id: Scalars['ID']['input'];
};


export type QueryInfluencerBookingArgs = {
  id: Scalars['ID']['input'];
};


export type QueryInfluencerBookingsArgs = {
  influencerId?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<InfluencerBookingStatus>;
};


export type QueryInfluencersArgs = {
  niche?: InputMaybe<ContentNiche>;
  status?: InputMaybe<InfluencerStatus>;
  verified?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryIngredientArgs = {
  id: Scalars['ID']['input'];
};


export type QueryIngredientsByCategoryArgs = {
  category: IngredientCategory;
};


export type QueryIngredientsBySupplierArgs = {
  supplierId: Scalars['ID']['input'];
};


export type QueryInvestmentProjectArgs = {
  id: Scalars['ID']['input'];
};


export type QueryInvestmentProjectsArgs = {
  filter?: InputMaybe<InvestmentProjectFilterInput>;
};


export type QueryInvestorArgs = {
  id: Scalars['ID']['input'];
};


export type QueryInvestorExpressionsArgs = {
  investorId: Scalars['ID']['input'];
};


export type QueryInvestorsArgs = {
  filter?: InputMaybe<InvestorFilterInput>;
};


export type QueryInvoiceArgs = {
  id: Scalars['ID']['input'];
};


export type QueryInvoicesArgs = {
  filter?: InputMaybe<FoodInvoicesFilter>;
};


export type QueryInvoicesByClientArgs = {
  clientId: Scalars['ID']['input'];
};


export type QueryIsFileDuplicateArgs = {
  checksum?: InputMaybe<Scalars['String']['input']>;
  fileSize: Scalars['Float']['input'];
  filename: Scalars['String']['input'];
};


export type QueryJobArgs = {
  id: Scalars['ID']['input'];
};


export type QueryJobVehicleArgs = {
  id: Scalars['ID']['input'];
};


export type QueryJobVehicleByRegoArgs = {
  registration: Scalars['String']['input'];
};


export type QueryJobVehiclesArgs = {
  filter?: InputMaybe<JobVehicleFilterInput>;
};


export type QueryJobsAllArgs = {
  filter?: InputMaybe<JobReportFilterInput>;
};


export type QueryJobsByCategoryArgs = {
  category: JobCategory;
};


export type QueryJobsByDateRangeArgs = {
  endDate: Scalars['DateTime']['input'];
  startDate: Scalars['DateTime']['input'];
};


export type QueryJobsByFrequencyArgs = {
  frequency: JobFrequency;
};


export type QueryJobsByLocationArgs = {
  locationId: Scalars['ID']['input'];
};


export type QueryJobsByMechanicArgs = {
  filter?: InputMaybe<JobReportFilterInput>;
  mechanicPhone: Scalars['String']['input'];
};


export type QueryJobsByPriorityArgs = {
  priority: JobPriority;
};


export type QueryJobsByStatusArgs = {
  filter?: InputMaybe<JobReportFilterInput>;
  status: MechanicJobStatus;
};


export type QueryJobsForDayArgs = {
  dayOfWeek: DayOfWeek;
};


export type QueryJourneyTemplateArgs = {
  id: Scalars['ID']['input'];
};


export type QueryKnowledgeRootInfoArgs = {
  customFsUrl?: InputMaybe<Scalars['String']['input']>;
  host: KnowledgeHost;
  knowledgeRoot?: InputMaybe<Scalars['String']['input']>;
};


export type QueryLatestAssessmentSnapshotArgs = {
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryLatestClientNotesArgs = {
  clientIds: Array<Scalars['ID']['input']>;
};


export type QueryLatestMoodEntryArgs = {
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryLatestNeurologicalObservationArgs = {
  periodId: Scalars['ID']['input'];
};


export type QueryLatestSnapshotArgs = {
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryLaunchSiteDeploymentsArgs = {
  launchedSiteId: Scalars['ID']['input'];
  limit?: Scalars['Float']['input'];
};


export type QueryLaunchSiteDomainsArgs = {
  launchedSiteId: Scalars['ID']['input'];
};


export type QueryLaunchedSiteArgs = {
  id: Scalars['ID']['input'];
};


export type QueryLeadArgs = {
  id: Scalars['ID']['input'];
};


export type QueryLeadFlowActionLogsArgs = {
  leadId: Scalars['ID']['input'];
};


export type QueryLeadFlowEnrolmentsArgs = {
  sequenceId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryLeadFlowFormArgs = {
  id: Scalars['ID']['input'];
};


export type QueryLeadsArgs = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  stageId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryLeaveAffectedShiftsArgs = {
  leaveRequestId: Scalars['ID']['input'];
};


export type QueryLeaveAvailabilityArgs = {
  excludeEmployeeId?: InputMaybe<Scalars['ID']['input']>;
  from: Scalars['DateTime']['input'];
  to: Scalars['DateTime']['input'];
};


export type QueryLeaveBalanceArgs = {
  employeeId: Scalars['ID']['input'];
  leaveType: Scalars['String']['input'];
};


export type QueryLeaveBalancesArgs = {
  employeeId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryLeaveConflictCheckArgs = {
  endDate: Scalars['DateTime']['input'];
  excludeEmployeeId?: InputMaybe<Scalars['ID']['input']>;
  startDate: Scalars['DateTime']['input'];
};


export type QueryLeaveCoverageAnalysisArgs = {
  leaveRequestId: Scalars['ID']['input'];
};


export type QueryLeaveRequestArgs = {
  id: Scalars['ID']['input'];
};


export type QueryLeaveRequestsArgs = {
  employeeId?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};


export type QueryLeaveRequestsByDateRangeArgs = {
  endDate: Scalars['DateTime']['input'];
  startDate: Scalars['DateTime']['input'];
};


export type QueryLedgerAccountsArgs = {
  companyId: Scalars['ID']['input'];
  includeInactive?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryLifeAspectArgs = {
  id: Scalars['ID']['input'];
};


export type QueryLifeAspectsArgs = {
  includeInactive?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryLmGetCertificateArgs = {
  slug: Scalars['String']['input'];
};


export type QueryLmGetCourseArgs = {
  courseId: Scalars['ID']['input'];
};


export type QueryLmGetCourseByIdentifierArgs = {
  identifier: Scalars['String']['input'];
};


export type QueryLmGetEnrollmentArgs = {
  courseId: Scalars['ID']['input'];
};


export type QueryLmGetEnrollmentsByUserIdArgs = {
  userId: Scalars['String']['input'];
};


export type QueryLmGetLessonArgs = {
  lessonId: Scalars['ID']['input'];
};


export type QueryLmGetLessonsArgs = {
  moduleId: Scalars['ID']['input'];
};


export type QueryLmGetModuleArgs = {
  moduleId: Scalars['ID']['input'];
};


export type QueryLmGetModulesArgs = {
  courseId: Scalars['ID']['input'];
};


export type QueryLmGetPublicCourseArgs = {
  slug: Scalars['String']['input'];
};


export type QueryLmGetUserProgressArgs = {
  courseId: Scalars['ID']['input'];
};


export type QueryLmSearchCourseAuthorsArgs = {
  search: Scalars['String']['input'];
};


export type QueryLocalDroneSessionArgs = {
  sessionId: Scalars['String']['input'];
};


export type QueryLocalSessionUploadProgressArgs = {
  sessionId: Scalars['String']['input'];
};


export type QueryLocationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryLocationByCodeArgs = {
  code: Scalars['String']['input'];
};


export type QueryLocationChildrenArgs = {
  parentId: Scalars['ID']['input'];
};


export type QueryLocationsByDepartmentArgs = {
  department: Scalars['String']['input'];
};


export type QueryLocationsByTypeArgs = {
  type: LocationType;
};


export type QueryLoginActivitiesArgs = {
  clientId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMailboxAccountsArgs = {
  licensedOnly?: Scalars['Boolean']['input'];
};


export type QueryMaintenanceActivitiesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  requestId: Scalars['ID']['input'];
};


export type QueryMaintenancePeriodSummaryArgs = {
  endDate: Scalars['DateTime']['input'];
  startDate: Scalars['DateTime']['input'];
};


export type QueryMaintenanceRequestArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMaintenanceRequestsArgs = {
  assignedTo?: InputMaybe<Scalars['ID']['input']>;
  category?: InputMaybe<MaintenanceCategory>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  priority?: InputMaybe<MaintenancePriority>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<MaintenanceStatus>;
};


export type QueryMaintenanceRequestsByStandardArgs = {
  standard: CiQualityStandard;
  status?: InputMaybe<MaintenanceStatus>;
};


export type QueryMaintenanceRequestsPaginatedArgs = {
  assignedTo?: InputMaybe<Scalars['ID']['input']>;
  category?: InputMaybe<MaintenanceCategory>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  priority?: InputMaybe<MaintenancePriority>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<MaintenanceStatus>;
};


export type QueryMaintenanceTrendsArgs = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  granularity: MaintenanceTrendGranularity;
  periods?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMaintenanceWeekOverviewArgs = {
  weekStart?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryManualHandlingReportArgs = {
  wing?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMasterIpfsOrphanScanArgs = {
  fetchSizes?: Scalars['Boolean']['input'];
  orphansOnly?: Scalars['Boolean']['input'];
};


export type QueryMasterMediaFilesArgs = {
  filters?: InputMaybe<MasterMediaFilters>;
};


export type QueryMasterTwinArgs = {
  shiftId: Scalars['ID']['input'];
};


export type QueryMasterTwinStatusArgs = {
  shiftIds: Array<Scalars['ID']['input']>;
};


export type QueryMealFeedbackArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMealPlanArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMealPlanNotificationRuleArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMealPlansByDateArgs = {
  date: Scalars['String']['input'];
};


export type QueryMealPlansByDateRangeArgs = {
  endDate: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
};


export type QueryMealPlansByRecipeArgs = {
  recipeId: Scalars['ID']['input'];
};


export type QueryMealPlansByShiftArgs = {
  shiftId: Scalars['ID']['input'];
};


export type QueryMealPlansByShiftIdsArgs = {
  shiftIds: Array<Scalars['ID']['input']>;
};


export type QueryMealPlansWithServicePhotosArgs = {
  endDate: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
};


export type QueryMechanicJobArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMechanicJobByMechanicPhoneArgs = {
  jobId: Scalars['ID']['input'];
  phone: Scalars['String']['input'];
};


export type QueryMechanicJobByNumberArgs = {
  jobNumber: Scalars['Int']['input'];
};


export type QueryMechanicJobByPublicTokenArgs = {
  token: Scalars['String']['input'];
};


export type QueryMechanicJobsArgs = {
  filter?: InputMaybe<MechanicJobFilterInput>;
};


export type QueryMechanicNotificationLogArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMediaFolderArgs = {
  id: Scalars['String']['input'];
};


export type QueryMediaFolderBySlugArgs = {
  slug: Scalars['String']['input'];
};


export type QueryMediaFoldersArgs = {
  parentId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMediaItemArgs = {
  id: Scalars['String']['input'];
};


export type QueryMediaItemByHashArgs = {
  ipfsHash: Scalars['String']['input'];
};


export type QueryMediaItemsArgs = {
  filters?: InputMaybe<MediaItemFilters>;
};


export type QueryMediaItemsWithPaginationArgs = {
  filters?: InputMaybe<MediaItemFilters>;
};


export type QueryMedicalAuditLogsArgs = {
  filter?: InputMaybe<AuditLogFilterInput>;
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
};


export type QueryMedicalAuditLogsCountArgs = {
  filter?: InputMaybe<AuditLogFilterInput>;
};


export type QueryMedicalRecordArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMedicalRecordAccessRequestsArgs = {
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  status?: InputMaybe<MedicalRecordAccessRequestStatus>;
};


export type QueryMedicalRecordDownloadUrlArgs = {
  purpose: Scalars['String']['input'];
  recordId: Scalars['ID']['input'];
};


export type QueryMedicalRecordsArgs = {
  filter?: InputMaybe<MedicalRecordFilterInput>;
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
};


export type QueryMedicationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMedicationChartArgs = {
  residentId: Scalars['ID']['input'];
};


export type QueryMedicationRoundArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMedicationRoundsArgs = {
  filter?: InputMaybe<RoundFilterInput>;
};


export type QueryMedicationsArgs = {
  filter?: InputMaybe<MedicationFilterInput>;
};


export type QueryMedicationsByScheduleArgs = {
  schedule: DrugSchedule;
};


export type QueryMedicationsByTypeArgs = {
  medicationType: MedicationType;
};


export type QueryMeetSpeakerContactsArgs = {
  recordingId: Scalars['ID']['input'];
  roomName: Scalars['String']['input'];
};


export type QueryMeetingByRoomArgs = {
  roomName: Scalars['String']['input'];
};


export type QueryMicrosoftEmailArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMicrosoftEmailDirectionByMailboxArgs = {
  dateFrom?: InputMaybe<Scalars['String']['input']>;
  dateTo?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMicrosoftEmailTagCountsArgs = {
  dateFrom?: InputMaybe<Scalars['String']['input']>;
  dateTo?: InputMaybe<Scalars['String']['input']>;
  mailbox?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMicrosoftEmailVolumeArgs = {
  bucket?: Scalars['String']['input'];
  dateFrom?: InputMaybe<Scalars['String']['input']>;
  dateTo?: InputMaybe<Scalars['String']['input']>;
  mailbox?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMicrosoftEmailVolumeByMailboxArgs = {
  dateFrom?: InputMaybe<Scalars['String']['input']>;
  dateTo?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMicrosoftEmailsArgs = {
  filter?: InputMaybe<MicrosoftEmailFilterInput>;
  limit?: Scalars['Int']['input'];
  page?: Scalars['Int']['input'];
};


export type QueryMissedMedicationsReportArgs = {
  endDate: Scalars['DateTime']['input'];
  startDate: Scalars['DateTime']['input'];
};


export type QueryMobilityAssessmentsArgs = {
  filter?: InputMaybe<MobilityAssessmentFilterInput>;
};


export type QueryModuleDoctorBriefHistoryArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  moduleId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryModuleEventsArgs = {
  moduleRefId: Scalars['String']['input'];
  moduleType: Scalars['String']['input'];
};


export type QueryModuleTestResultsArgs = {
  filter?: InputMaybe<ModuleTestResultFilterInput>;
};


export type QueryModuleUpgradeServiceJobLogArgs = {
  jobId: Scalars['String']['input'];
};


export type QueryMonitorIncidentArgs = {
  id: Scalars['String']['input'];
};


export type QueryMonitorIncidentsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  state?: InputMaybe<MonitorIncidentState>;
};


export type QueryMonthlyRoomCheckArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMonthlyRoomCheckForLocationArgs = {
  locationId: Scalars['ID']['input'];
  month: Scalars['Int']['input'];
  year: Scalars['Int']['input'];
};


export type QueryMonthlyRoomChecksArgs = {
  locationType?: InputMaybe<LocationType>;
  month: Scalars['Int']['input'];
  year: Scalars['Int']['input'];
};


export type QueryMoodEntriesArgs = {
  filter?: InputMaybe<MoodFilterInput>;
};


export type QueryMoodEntryArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMoodTrendArgs = {
  days?: Scalars['Int']['input'];
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryMotivationTemplatesArgs = {
  tenantId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMultiCalendarEventsArgs = {
  calendarIds: Array<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMyAccessiblePatientsArgs = {
  includeHistorical?: Scalars['Boolean']['input'];
};


export type QueryMyBankingNotificationLogArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  transactionId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryMyCheckInsArgs = {
  employeeId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Float']['input']>;
};


export type QueryMyChloeSessionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMyCoParentInvitesArgs = {
  caseId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryMyCommunityEntryForDateArgs = {
  localDate: Scalars['String']['input'];
};


export type QueryMyCommunityEntryHistoryArgs = {
  daysBack?: Scalars['Float']['input'];
};


export type QueryMyCommunityStatsArgs = {
  localDate: Scalars['String']['input'];
};


export type QueryMyCompetitionEntriesArgs = {
  competitionId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryMyCompetitionEntryAllowanceArgs = {
  competitionId: Scalars['ID']['input'];
};


export type QueryMyCompetitionFollowArgs = {
  competitionId: Scalars['ID']['input'];
};


export type QueryMyCompetitionHeartsArgs = {
  competitionId: Scalars['ID']['input'];
};


export type QueryMyCompetitionVoteArgs = {
  competitionId: Scalars['ID']['input'];
};


export type QueryMyFeedbackItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMyGovAccessArgs = {
  organisationId: Scalars['ID']['input'];
};


export type QueryMyGovMembershipArgs = {
  organisationId: Scalars['ID']['input'];
};


export type QueryMyGovMembershipStandingArgs = {
  organisationId: Scalars['ID']['input'];
};


export type QueryMyGovNotificationScheduleArgs = {
  organisationId: Scalars['ID']['input'];
};


export type QueryMyGovParticipationArgs = {
  organisationId: Scalars['ID']['input'];
};


export type QueryMyGovVoteArgs = {
  proposalId: Scalars['ID']['input'];
};


export type QueryMyLeaveRequestsArgs = {
  employeeId: Scalars['ID']['input'];
};


export type QueryMyLocalAiQueriesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMyMealPlanNotificationsArgs = {
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
};


export type QueryMyMedicalRecordAccessArgs = {
  patientId: Scalars['ID']['input'];
};


export type QueryMyNotificationsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMyOwnedSiteActivityArgs = {
  siteId: Scalars['ID']['input'];
};


export type QueryMyPendingAgreementTextArgs = {
  tierId: Scalars['ID']['input'];
};


export type QueryMyReferralsArgs = {
  filter?: InputMaybe<ReferralFilterInput>;
};


export type QueryMySmsUsageArgs = {
  filter?: InputMaybe<MySmsUsageFilter>;
};


export type QueryMyWalletContactsArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMyWalletInvitesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMyWalletKeysArgs = {
  scope?: InputMaybe<Scalars['String']['input']>;
};


export type QueryNeurologicalObservationPeriodArgs = {
  id: Scalars['ID']['input'];
};


export type QueryNeurologicalObservationPeriodsArgs = {
  filter?: InputMaybe<NeurologicalPeriodFilterInput>;
};


export type QueryNeurologicalObservationsArgs = {
  periodId: Scalars['ID']['input'];
};


export type QueryNotificationsLogArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  recipientClientId?: InputMaybe<Scalars['ID']['input']>;
  since?: InputMaybe<Scalars['DateTime']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};


export type QueryObservationAlertConfigArgs = {
  observationType: ObservationType;
};


export type QueryObservationAlertsArgs = {
  filter?: InputMaybe<ObservationAlertFilterInput>;
};


export type QueryObservationGraphDataArgs = {
  filter: GraphFilterInput;
  type: ObservationType;
};


export type QueryOpenDigitalManagerOQsArgs = {
  managerId: Scalars['ID']['input'];
};


export type QueryOpportunitiesArgs = {
  assignedTo?: InputMaybe<Scalars['String']['input']>;
  clientId?: InputMaybe<Scalars['String']['input']>;
  stage?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<OpportunityStatus>;
};


export type QueryOpportunitiesByEmailArgs = {
  email: Scalars['String']['input'];
};


export type QueryOpportunityArgs = {
  id: Scalars['String']['input'];
};


export type QueryOpportunityCountArgs = {
  status?: InputMaybe<OpportunityStatus>;
};


export type QueryOpportunityEmailsArgs = {
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  opportunityId: Scalars['String']['input'];
};


export type QueryOpportunityMeetingArgs = {
  id: Scalars['String']['input'];
};


export type QueryOpportunityMeetingsArgs = {
  opportunityId: Scalars['String']['input'];
};


export type QueryOpportunityMembersArgs = {
  opportunityId: Scalars['String']['input'];
};


export type QueryOpportunityNoteArgs = {
  id: Scalars['String']['input'];
};


export type QueryOpportunityNotesArgs = {
  opportunityId: Scalars['String']['input'];
};


export type QueryOpportunityTasksArgs = {
  opportunityId: Scalars['String']['input'];
};


export type QueryOpportunityTypeArgs = {
  id: Scalars['String']['input'];
};


export type QueryOrdersByDateRangeArgs = {
  endDate: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
};


export type QueryOrdersByStatusArgs = {
  status: SupplierOrderStatus;
};


export type QueryOrdersBySupplierArgs = {
  supplierId: Scalars['ID']['input'];
};


export type QueryOrphanedRecordsArgs = {
  kinds?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryOutgoingCommsArgs = {
  input?: InputMaybe<OutgoingCommsInput>;
};


export type QueryOutgoingEmailBodyArgs = {
  messageId: Scalars['String']['input'];
};


export type QueryOverdueActionsArgs = {
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryOxygenSaturationObservationsArgs = {
  filter?: InputMaybe<OxygenSaturationFilterInput>;
};


export type QueryP2ActionLogsArgs = {
  orderId: Scalars['ID']['input'];
};


export type QueryP2CampaignMessagesArgs = {
  campaignId: Scalars['ID']['input'];
};


export type QueryP2ChargesArgs = {
  campaignId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryP2ChargesByClientArgs = {
  clientId: Scalars['ID']['input'];
};


export type QueryP2DeliveryUpdatesArgs = {
  campaignId: Scalars['ID']['input'];
  pledgeId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryP2InterestCountArgs = {
  productId: Scalars['ID']['input'];
};


export type QueryP2InterestsArgs = {
  productId: Scalars['ID']['input'];
};


export type QueryP2InterestsByCampaignArgs = {
  campaignId: Scalars['ID']['input'];
};


export type QueryP2MessageLogsArgs = {
  messageId: Scalars['ID']['input'];
};


export type QueryP2MyReferralArgs = {
  campaignId: Scalars['ID']['input'];
};


export type QueryP2OrderArgs = {
  id: Scalars['ID']['input'];
};


export type QueryP2PledgeCampaignArgs = {
  id: Scalars['ID']['input'];
};


export type QueryP2PledgesArgs = {
  campaignId: Scalars['ID']['input'];
};


export type QueryP2ProductArgs = {
  id: Scalars['ID']['input'];
};


export type QueryP2PublicCampaignArgs = {
  slug: Scalars['String']['input'];
};


export type QueryP2PublicInviteArgs = {
  slug: Scalars['String']['input'];
};


export type QueryP2PublicProductArgs = {
  id: Scalars['ID']['input'];
};


export type QueryP2ReferralByCodeArgs = {
  campaignSlug: Scalars['String']['input'];
  code: Scalars['String']['input'];
};


export type QueryP2ReferralsArgs = {
  campaignId: Scalars['ID']['input'];
};


export type QueryP2RefundsArgs = {
  campaignId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryP2SavedCardsArgs = {
  clientId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryP2SupplierArgs = {
  id: Scalars['ID']['input'];
};


export type QueryP2SuppliersArgs = {
  campaignId: Scalars['ID']['input'];
};


export type QueryPProposalArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPProposalBySlugArgs = {
  slug: Scalars['String']['input'];
};


export type QueryPProposalSignaturesArgs = {
  proposalId: Scalars['ID']['input'];
};


export type QueryPProposalsArgs = {
  filter?: InputMaybe<PProposalFilterInput>;
};


export type QueryPageViewsArgs = {
  filters?: InputMaybe<AnalyticsFilters>;
};


export type QueryPaginatedEmailsArgs = {
  filters?: InputMaybe<OutboundEmailFilterInput>;
  limit?: Scalars['Int']['input'];
  page?: Scalars['Int']['input'];
};


export type QueryPaginatedInboundEmailsArgs = {
  filters?: InputMaybe<EmailFilterInput>;
  limit?: Scalars['Int']['input'];
  page?: Scalars['Int']['input'];
};


export type QueryPainChartObservationsArgs = {
  filter?: InputMaybe<PainChartFilterInput>;
};


export type QueryPainChartPeriodsArgs = {
  filter?: InputMaybe<PainChartFilterInput>;
};


export type QueryParcelDetailArgs = {
  id: Scalars['ID']['input'];
};


export type QueryParcelsArgs = {
  filter?: InputMaybe<ParcelFilterInput>;
};


export type QueryPartsOrderArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPartsOrdersArgs = {
  filter?: InputMaybe<PartsOrderFilterInput>;
};


export type QueryPartsOrdersByJobArgs = {
  jobId: Scalars['ID']['input'];
};


export type QueryPartsSpendingBySupplierArgs = {
  endDate: Scalars['DateTime']['input'];
  startDate: Scalars['DateTime']['input'];
};


export type QueryPasswordArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPasswordAccessLogsArgs = {
  passwordId: Scalars['ID']['input'];
};


export type QueryPastResidentsArgs = {
  includeDeceased?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryPatientAuditLogsArgs = {
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  patientId: Scalars['ID']['input'];
};


export type QueryPatientMedicalRecordsArgs = {
  documentType?: InputMaybe<MedicalDocumentType>;
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  patientId: Scalars['ID']['input'];
};


export type QueryPayRunArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPayRunLineArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPayRunLinesArgs = {
  filter: PayRunLineFilterInput;
};


export type QueryPayRunsArgs = {
  filter?: InputMaybe<PayRunFilterInput>;
};


export type QueryPaymentMethodsByClientArgs = {
  clientId: Scalars['ID']['input'];
};


export type QueryPayrollCostForecastArgs = {
  fortnights?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPayrollEnquiriesArgs = {
  status?: InputMaybe<PayrollEnquiryStatus>;
};


export type QueryPayrollEnquiryArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPenaltyRateRuleArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPenaltyRateRulesArgs = {
  activeOnly?: Scalars['Boolean']['input'];
  awardName?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPendingActionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryPendingDigitalManagerProposalsArgs = {
  managerId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryPendingUploadsArgs = {
  sessionId: Scalars['String']['input'];
};


export type QueryPersonEnrichmentsArgs = {
  baseId: Scalars['ID']['input'];
};


export type QueryPersonEventsArgs = {
  filters?: InputMaybe<PersonEventFiltersInput>;
};


export type QueryPersonOfInterestArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPersonsOfInterestArgs = {
  filters?: InputMaybe<PersonOfInterestFiltersInput>;
};


export type QueryPhoneLinesArgs = {
  includeInactive?: Scalars['Boolean']['input'];
};

export type QueryPhoneNumberArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPickupDecisionHistoryArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPledgeCampaignArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPledgesForCampaignArgs = {
  campaignId: Scalars['ID']['input'];
};


export type QueryPoliciesArgs = {
  filter?: InputMaybe<PolicyFilterInput>;
};


export type QueryPolicyArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPolicyAcknowledgementReportArgs = {
  policyId: Scalars['ID']['input'];
};


export type QueryPolicyActivitiesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  policyId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryPolicyActivityArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPolicyBroadcastPreviewArgs = {
  input: PolicyBroadcastPreviewInput;
};


export type QueryPolicyByDocIdArgs = {
  docId: Scalars['String']['input'];
};


export type QueryPolicyDraftDiffArgs = {
  policyId: Scalars['ID']['input'];
};


export type QueryPolicyNotificationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPolicyNotificationsArgs = {
  policyId: Scalars['ID']['input'];
};


export type QueryPolicyVersionArgs = {
  policyId: Scalars['ID']['input'];
  version: Scalars['Int']['input'];
};


export type QueryPolicyVersionDiffArgs = {
  fromVersion: Scalars['Int']['input'];
  policyId: Scalars['ID']['input'];
  toVersion: Scalars['Int']['input'];
};


export type QueryPolicyVersionsArgs = {
  policyId: Scalars['ID']['input'];
};


export type QueryPractionerByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPractitionerAvailabilityArgs = {
  endDate: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
};


export type QueryPractitionerPublicProfileArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPreviewBankCsvImportArgs = {
  input: BankCsvImportInput;
};


export type QueryPreviewBillsEmailBrandingArgs = {
  input: BillsEmailBrandingInput;
  sampleBody?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPreviewCalendarAudienceArgs = {
  kind: CalendarAudienceKind;
  value: Scalars['String']['input'];
};


export type QueryPreviewCalendarAudiencesArgs = {
  targets: Array<CalendarAudienceTargetInput>;
};


export type QueryPreviewCommunityCampaignAudienceArgs = {
  input: CommunityCampaignAudienceInput;
};


export type QueryPreviewDeactivateUnitArgs = {
  migrateTo?: InputMaybe<UnitType>;
  unit: UnitType;
};


export type QueryPreviewEmployeeContractArgs = {
  facts?: InputMaybe<EmployeeContractFactsInput>;
  highlight?: InputMaybe<Scalars['Boolean']['input']>;
  keepEmployeeTokens?: InputMaybe<Scalars['Boolean']['input']>;
  mergeValues?: InputMaybe<Scalars['String']['input']>;
  templateId: Scalars['ID']['input'];
};


export type QueryPreviewEmpowermentScheduleChangeArgs = {
  milestones: Array<EmpowermentMilestoneDefInput>;
};


export type QueryPreviewInboundEmailMoveArgs = {
  filter: InboundEmailMoveFilterInput;
};


export type QueryPreviewIngredientUnitChangeArgs = {
  id: Scalars['ID']['input'];
  newUnit: UnitType;
};


export type QueryPreviewLeadFlowActionArgs = {
  actionId: Scalars['String']['input'];
  leadId: Scalars['String']['input'];
};


export type QueryPreviewLeadFlowEmailBrandingArgs = {
  input: LeadFlowEmailBrandingInput;
  sampleBody?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPreviewP2ActionArgs = {
  actionId: Scalars['String']['input'];
  orderId: Scalars['String']['input'];
};


export type QueryPreviewPickupDecisionEmailsArgs = {
  chosenEmployeeId: Scalars['ID']['input'];
  shiftId: Scalars['ID']['input'];
};


export type QueryPreviewProgramReminderEmailArgs = {
  memberId: Scalars['ID']['input'];
  reminderType: ProgramReminderType;
};


export type QueryPreviewRecipeIngredientUnitChangeArgs = {
  id: Scalars['ID']['input'];
  newUnit: UnitType;
};


export type QueryPreviewRewardsEmailBrandingArgs = {
  input: RewardsEmailBrandingInput;
  sampleBody?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPreviewShiftNotificationRecipientsArgs = {
  departmentIds?: InputMaybe<Array<Scalars['String']['input']>>;
  recipientDepartmentId?: InputMaybe<Scalars['String']['input']>;
  recipientIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  recipientRole?: InputMaybe<Scalars['String']['input']>;
  recipientType: ShiftNotificationRecipientType;
  requiredSkills?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryPreviewXeroChartFromXeroArgs = {
  input: XeroApiChartImportInput;
};


export type QueryPreviewXeroChartImportArgs = {
  input: XeroChartImportInput;
};


export type QueryPreviewXeroTransactionImportArgs = {
  input: XeroTransactionImportInput;
};


export type QueryPrimaryContactArgs = {
  residentId: Scalars['ID']['input'];
};


export type QueryPrnAdministrationsArgs = {
  filter?: InputMaybe<PrnFilterInput>;
};


export type QueryPrnMedicationsArgs = {
  residentId: Scalars['ID']['input'];
};


export type QueryPrnUsageReportArgs = {
  endDate: Scalars['DateTime']['input'];
  residentId: Scalars['ID']['input'];
  startDate: Scalars['DateTime']['input'];
};


export type QueryProRataPreviewArgs = {
  endDate: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
  subscriptionId: Scalars['ID']['input'];
};


export type QueryProgramActivitiesArgs = {
  memberId: Scalars['ID']['input'];
};


export type QueryProgramActivityArgs = {
  id: Scalars['ID']['input'];
};


export type QueryProgramApplicationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryProgramApplicationsArgs = {
  memberId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryProgramCallNoteArgs = {
  id: Scalars['ID']['input'];
};


export type QueryProgramCallNotesArgs = {
  memberId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryProgramCommissionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryProgramCommissionsArgs = {
  programMemberId?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<ProgramCommissionStatus>;
};


export type QueryProgramMemberArgs = {
  id: Scalars['ID']['input'];
};


export type QueryProgramMembersArgs = {
  stage?: InputMaybe<ProgramMemberStage>;
};


export type QueryProgramSignedAgreementsArgs = {
  memberId: Scalars['ID']['input'];
};


export type QueryProgressNoteArgs = {
  id: Scalars['ID']['input'];
};


export type QueryProgressNoteAlertsArgs = {
  overdueDays?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryProgressNotesArgs = {
  filter?: InputMaybe<ProgressNoteFilterInput>;
};


export type QueryProjectArgs = {
  id: Scalars['ID']['input'];
};


export type QueryProjectsByClientArgs = {
  clientId: Scalars['ID']['input'];
};


export type QueryProvisioningStatusArgs = {
  launchedSiteId: Scalars['ID']['input'];
};


export type QueryPublicApiEndpointsArgs = {
  apiListingId: Scalars['String']['input'];
};


export type QueryPublicApiListingArgs = {
  slug: Scalars['String']['input'];
};


export type QueryPublicApiListingsArgs = {
  categoryId?: InputMaybe<Scalars['String']['input']>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  tag?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPublicArtifactByTokenArgs = {
  tenantId: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


export type QueryPublicArtifactCommentsArgs = {
  tenantId: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


export type QueryPublicBillArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPublicBillPdfArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPublicBookableEventTypesArgs = {
  calendarSlug: Scalars['String']['input'];
};


export type QueryPublicBookingArgs = {
  token: Scalars['String']['input'];
};


export type QueryPublicBusinessListingBySlugArgs = {
  slug: Scalars['String']['input'];
};


export type QueryPublicBusinessListingsArgs = {
  input?: InputMaybe<BusinessListingSearchInput>;
};


export type QueryPublicCalendarArgs = {
  slug: Scalars['String']['input'];
};


export type QueryPublicClub52GameByRoomArgs = {
  roomName: Scalars['String']['input'];
};


export type QueryPublicCommunityConfigBySlugArgs = {
  slug: Scalars['String']['input'];
};


export type QueryPublicCommunityInviteArgs = {
  slug: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};


export type QueryPublicCommunityStatsArgs = {
  tenantId: Scalars['String']['input'];
};


export type QueryPublicCompanyKnowledgeArticleArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPublicCompetitionArgs = {
  slug: Scalars['String']['input'];
};


export type QueryPublicCompetitionEntriesArgs = {
  seed?: InputMaybe<Scalars['Int']['input']>;
  slug: Scalars['String']['input'];
  votableOnly?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryPublicCompetitionEntryArgs = {
  shareSlug: Scalars['String']['input'];
};


export type QueryPublicDroneSessionArgs = {
  password?: InputMaybe<Scalars['String']['input']>;
  shareToken: Scalars['String']['input'];
};


export type QueryPublicDroneSessionFilesArgs = {
  password?: InputMaybe<Scalars['String']['input']>;
  shareToken: Scalars['String']['input'];
};


export type QueryPublicEmployeeInviteArgs = {
  slug: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};


export type QueryPublicEmployeeInviteContractArgs = {
  slug: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};


export type QueryPublicFarmerBySlugArgs = {
  tenantId?: InputMaybe<Scalars['ID']['input']>;
  urlSlug: Scalars['String']['input'];
};


export type QueryPublicFarmersArgs = {
  tenantId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryPublicFeedbackStatusArgs = {
  token: Scalars['String']['input'];
};


export type QueryPublicGetBillCompanyArgs = {
  billId: Scalars['ID']['input'];
};


export type QueryPublicGetBillIssuerDetailsArgs = {
  billId: Scalars['ID']['input'];
};


export type QueryPublicGetBillToCompanyArgs = {
  billId: Scalars['ID']['input'];
};


export type QueryPublicGetClientDetailsByBillIdArgs = {
  billId: Scalars['ID']['input'];
};


export type QueryPublicGovActivityTeaserArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPublicGovInviteArgs = {
  slug: Scalars['String']['input'];
};


export type QueryPublicGovMotionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPublicGovOrganisationArgs = {
  slug: Scalars['String']['input'];
};


export type QueryPublicGovProposalTeaserArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPublicHolidayArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPublicHolidaysArgs = {
  year?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPublicHolidaysByDateRangeArgs = {
  endDate: Scalars['DateTime']['input'];
  startDate: Scalars['DateTime']['input'];
};


export type QueryPublicHostingOfferArgs = {
  slug: Scalars['String']['input'];
};


export type QueryPublicLeadFlowFormArgs = {
  slug: Scalars['String']['input'];
};


export type QueryPublicMeetingByRoomArgs = {
  roomName: Scalars['String']['input'];
};


export type QueryPublicPProposalArgs = {
  slug: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};


export type QueryPublicPartsOrdersByJobArgs = {
  jobId: Scalars['ID']['input'];
  mechanicPhone: Scalars['String']['input'];
};


export type QueryPublicPasswordAccessArgs = {
  input: PublicPasswordAccessInput;
};


export type QueryPublicPledgeCampaignArgs = {
  slug: Scalars['String']['input'];
};


export type QueryPublicPledgeProgressArgs = {
  campaignSlug: Scalars['String']['input'];
};


export type QueryPublicProjectArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPublicProposalArgs = {
  slug: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};


export type QueryPublicReferenceByTokenArgs = {
  token: Scalars['String']['input'];
};


export type QueryPublicRewardTokenArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPublicSellerProfilesArgs = {
  tenantId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryPublicSeparationInviteArgs = {
  slug: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};


export type QueryPublicShelvInviteArgs = {
  slug: Scalars['String']['input'];
};


export type QueryPublicSopCommentsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  slug: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};


export type QueryPublicSopEpisodeArgs = {
  slug: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};


export type QueryPublicSopEpisodesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  tenantId: Scalars['String']['input'];
  topicId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryPublicSopSettingsArgs = {
  tenantId: Scalars['String']['input'];
};


export type QueryPublicSopTopicsArgs = {
  tenantId: Scalars['String']['input'];
};


export type QueryPublicSubscriptionProductBySlugArgs = {
  slug: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};


export type QueryPublicSubscriptionProductsArgs = {
  tenantId: Scalars['String']['input'];
};


export type QueryPublicVisionBoardInviteArgs = {
  slug: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};


export type QueryPublicWaitingListConfirmationArgs = {
  token: Scalars['String']['input'];
};


export type QueryPublicWalletInviteArgs = {
  slug: Scalars['String']['input'];
};


export type QueryPublishedInvestmentProjectsArgs = {
  filter?: InputMaybe<InvestmentProjectFilterInput>;
};


export type QueryPublishedVlogsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPulseObservationsArgs = {
  filter?: InputMaybe<PulseObservationFilterInput>;
};


export type QueryQuoteTemplateArgs = {
  id: Scalars['ID']['input'];
};


export type QueryQuotesArgs = {
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  status?: InputMaybe<QuoteStatus>;
};


export type QueryReadBackSarahCareFluidFoodArgs = {
  sourceIds: Array<Scalars['String']['input']>;
  table: Scalars['String']['input'];
};


export type QueryReadBackSarahCarePainChartArgs = {
  sourceIds: Array<Scalars['String']['input']>;
  table: Scalars['String']['input'];
};


export type QueryReadBackSarahCareRespiteStaysArgs = {
  sourceIds: Array<Scalars['String']['input']>;
};


export type QueryReadOnlyVisionBoardArgs = {
  ownerId: Scalars['ID']['input'];
};


export type QueryRecentAccompanimentsArgs = {
  date: Scalars['String']['input'];
  lookbackDays?: Scalars['Int']['input'];
  mealType: MealType;
};


export type QueryRecentIngestionRunsArgs = {
  limit?: Scalars['Int']['input'];
};


export type QueryRecentOrdersForSupplierArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  supplierId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryRecipeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryRecipesByCategoryArgs = {
  category: Scalars['String']['input'];
};


export type QueryRecipesByDietaryTagArgs = {
  tag: DietaryTag;
};


export type QueryRecipesByDietaryTagsArgs = {
  tags: Array<DietaryTag>;
};


export type QueryRecipesByDishTypeArgs = {
  dishType: RecipeDishType;
};


export type QueryRecipesByIngredientArgs = {
  ingredientId: Scalars['ID']['input'];
};


export type QueryRecipesBySessionTypeArgs = {
  sessionType: RecipeSessionType;
};


export type QueryRecipesUsingUnitArgs = {
  unit: UnitType;
};


export type QueryReferralsArgs = {
  filter?: InputMaybe<ReferralFilterInput>;
};


export type QueryRelatedBlogPostsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  postId: Scalars['ID']['input'];
};


export type QueryRelatedVlogPostsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  postId: Scalars['ID']['input'];
};


export type QueryRepositioningChecksArgs = {
  filter?: InputMaybe<RepositioningCheckFilterInput>;
};


export type QueryResearchBaseArgs = {
  id: Scalars['ID']['input'];
};


export type QueryResearchBaseCoverageArgs = {
  id: Scalars['ID']['input'];
};


export type QueryResidentArgs = {
  id: Scalars['ID']['input'];
};


export type QueryResidentAcfiHistoryArgs = {
  residentId: Scalars['ID']['input'];
};


export type QueryResidentAbbeyPainHistoryArgs = {
  residentId: Scalars['ID']['input'];
};


export type QueryResidentAdmissionSourceHistoryArgs = {
  kind?: InputMaybe<SarahAdmissionSnapshotKind>;
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  residentId: Scalars['ID']['input'];
};


export type QueryResidentAllergiesArgs = {
  residentId: Scalars['ID']['input'];
};


export type QueryResidentBladderHistoryArgs = {
  residentId: Scalars['ID']['input'];
};


export type QueryResidentBondArgs = {
  residentId: Scalars['ID']['input'];
};


export type QueryResidentBondsArgs = {
  residentId: Scalars['ID']['input'];
};


export type QueryResidentBowelHistoryArgs = {
  residentId: Scalars['ID']['input'];
};


export type QueryResidentBradenHistoryArgs = {
  residentId: Scalars['ID']['input'];
};


export type QueryResidentByNumberArgs = {
  residentNumber: Scalars['Int']['input'];
};


export type QueryResidentCareReviewHistoryArgs = {
  residentId: Scalars['ID']['input'];
};


export type QueryResidentCareSummaryArgs = {
  residentId: Scalars['ID']['input'];
};


export type QueryResidentComplianceReportsArgs = {
  periodEnd: Scalars['DateTime']['input'];
  periodStart: Scalars['DateTime']['input'];
  residentId: Scalars['ID']['input'];
};


export type QueryResidentContactArgs = {
  id: Scalars['ID']['input'];
};


export type QueryResidentContactCallHistoryArgs = {
  contactHistoryId?: InputMaybe<Scalars['ID']['input']>;
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  residentId: Scalars['ID']['input'];
};


export type QueryResidentContactHistoryArgs = {
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  residentId: Scalars['ID']['input'];
};


export type QueryResidentContactsArgs = {
  residentId: Scalars['ID']['input'];
};


export type QueryResidentIncidentsArgs = {
  residentId: Scalars['ID']['input'];
};


export type QueryResidentLeaveArgs = {
  id: Scalars['ID']['input'];
};


export type QueryResidentLeavesArgs = {
  activeOnly?: InputMaybe<Scalars['Boolean']['input']>;
  residentId: Scalars['ID']['input'];
};


export type QueryResidentMedicationsArgs = {
  residentId: Scalars['ID']['input'];
  status?: InputMaybe<MedicationStatus>;
};


export type QueryResidentMobilityAidsArgs = {
  residentId: Scalars['ID']['input'];
};


export type QueryResidentMobilityHistoryArgs = {
  residentId: Scalars['ID']['input'];
};


export type QueryResidentObservationAlertsArgs = {
  residentId: Scalars['ID']['input'];
};


export type QueryResidentOccupancyReportArgs = {
  input: ResidentOccupancyInput;
};


export type QueryResidentPhotosArgs = {
  residentIds: Array<Scalars['ID']['input']>;
};


export type QueryResidentProgressNotesArgs = {
  filter?: InputMaybe<ProgressNoteFilterInput>;
  residentId: Scalars['ID']['input'];
};


export type QueryResidentReviewCyclesArgs = {
  residentId: Scalars['ID']['input'];
};


export type QueryResidentRiskAssessmentsArgs = {
  filter?: InputMaybe<ResidentRiskAssessmentFilterInput>;
};


export type QueryResidentRiskProfileArgs = {
  residentId: Scalars['ID']['input'];
};


export type QueryResidentSleepHistoryArgs = {
  residentId: Scalars['ID']['input'];
};


export type QueryResidentVaccinationHistoryArgs = {
  residentId: Scalars['ID']['input'];
};


export type QueryResidentWaterlowHistoryArgs = {
  residentId: Scalars['ID']['input'];
};


export type QueryResidentWeightHistoryArgs = {
  residentId: Scalars['ID']['input'];
};


export type QueryResidentWoundsArgs = {
  residentId: Scalars['ID']['input'];
};


export type QueryResidentsArgs = {
  filter?: InputMaybe<ResidentFilterInput>;
};


export type QueryResidentsByWingArgs = {
  wing: Scalars['String']['input'];
};


export type QueryResolvedCareTargetsArgs = {
  fromDay: Scalars['String']['input'];
  toDay: Scalars['String']['input'];
};


export type QueryResolvedOrphansArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryRespirationObservationsArgs = {
  filter?: InputMaybe<RespirationFilterInput>;
};


export type QueryRespiteBookingArgs = {
  id: Scalars['ID']['input'];
};


export type QueryRespiteBookingsArgs = {
  filter?: InputMaybe<RespiteCareBookingFilterInput>;
};


export type QueryRespiteCalendarArgs = {
  endDate: Scalars['DateTime']['input'];
  startDate: Scalars['DateTime']['input'];
};


export type QueryRespiteDaysSummaryArgs = {
  financialYear?: InputMaybe<Scalars['String']['input']>;
};


export type QueryRespiteStayHistoryArgs = {
  filter?: InputMaybe<RespiteStayHistoryFilterInput>;
};


export type QueryRestraintChecksArgs = {
  filter?: InputMaybe<RestraintCheckFilterInput>;
};


export type QueryRestraintRecordsArgs = {
  filter?: InputMaybe<RestraintRecordFilterInput>;
};


export type QueryRetryableTransfersArgs = {
  maxRetries?: InputMaybe<Scalars['Float']['input']>;
};


export type QueryRevealRewardPayoutBankDetailsArgs = {
  requestId: Scalars['ID']['input'];
};


export type QueryReviewsByCarePlanArgs = {
  carePlanId: Scalars['ID']['input'];
};


export type QueryRewardCountArgs = {
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryRewardLeaderboardArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryRewardPayoutRequestsArgs = {
  status?: InputMaybe<RewardPayoutStatus>;
};


export type QueryRewardTokenArgs = {
  id: Scalars['ID']['input'];
};


export type QueryRewardTokensArgs = {
  filter?: InputMaybe<RewardTokenFilterInput>;
};


export type QueryRewardTokensByClientArgs = {
  clientId: Scalars['ID']['input'];
};


export type QueryRewardTransactionsArgs = {
  filter?: InputMaybe<RewardTransactionFilterInput>;
};


export type QueryRewardTransactionsByClientArgs = {
  clientId: Scalars['ID']['input'];
};


export type QueryRewardTransactionsByTokenArgs = {
  tokenId: Scalars['ID']['input'];
};


export type QueryRiskChoicePersonOptionsArgs = {
  residentId: Scalars['ID']['input'];
};


export type QueryRollupArgs = {
  id: Scalars['ID']['input'];
};


export type QueryRollupProposalsArgs = {
  input: RollupProposalsInput;
};


export type QueryRollupsArgs = {
  baseId?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryRoomsByWingArgs = {
  wingId: Scalars['ID']['input'];
};


export type QueryRosterEmployeeHoursBreakdownArgs = {
  numDays?: InputMaybe<Scalars['Int']['input']>;
  scope: RosterExportScope;
  shiftIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  startDate: Scalars['DateTime']['input'];
  statusScope: RosterExportStatusScope;
};


export type QueryRoundSummaryArgs = {
  date: Scalars['DateTime']['input'];
  wing?: InputMaybe<Scalars['String']['input']>;
};


export type QueryRulesGoverningEmailArgs = {
  inboundEmailId: Scalars['ID']['input'];
};


export type QueryS8AuditReportArgs = {
  endDate: Scalars['DateTime']['input'];
  startDate: Scalars['DateTime']['input'];
};


export type QueryS8CurrentStockArgs = {
  medicationId: Scalars['ID']['input'];
};


export type QueryS8RegisterArgs = {
  filter?: InputMaybe<S8RegisterFilterInput>;
  medicationId: Scalars['ID']['input'];
};


export type QueryS8ResidentRegisterArgs = {
  residentId: Scalars['ID']['input'];
};


export type QuerySarahNoteFollowupHistoryArgs = {
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  parentKind?: InputMaybe<Scalars['String']['input']>;
  parentNoteId?: InputMaybe<Scalars['ID']['input']>;
  residentId?: InputMaybe<Scalars['ID']['input']>;
};


export type QuerySarahQuestionnaireAnswersArgs = {
  assessmentHistoryId?: InputMaybe<Scalars['ID']['input']>;
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  residentId?: InputMaybe<Scalars['ID']['input']>;
};


export type QuerySarahQuestionnaireHistoryArgs = {
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  residentId?: InputMaybe<Scalars['ID']['input']>;
};


export type QuerySarahQuestionnaireReferencesArgs = {
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  kind?: InputMaybe<Scalars['String']['input']>;
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
};


export type QuerySarahVoidedProgressNotesArgs = {
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  residentId?: InputMaybe<Scalars['ID']['input']>;
};


export type QuerySearchAvailablePhoneNumbersArgs = {
  areaCode?: InputMaybe<Scalars['String']['input']>;
  capabilities?: InputMaybe<Array<PhoneCapability>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  country?: Scalars['String']['input'];
  limit?: Scalars['Int']['input'];
};


export type QuerySearchBankingPeopleArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  search: Scalars['String']['input'];
};


export type QuerySearchClientsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QuerySearchClientsAllTenantsArgs = {
  limit?: InputMaybe<Scalars['Float']['input']>;
  search: Scalars['String']['input'];
};


export type QuerySearchClientsOnTenantArgs = {
  limit?: InputMaybe<Scalars['Float']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  targetTenantId: Scalars['String']['input'];
};


export type QuerySearchCompaniesArgs = {
  searchTerm: Scalars['String']['input'];
};


export type QuerySearchDomainsArgs = {
  input: DomainSearchInput;
};


export type QuerySearchImagesArgs = {
  page?: Scalars['Int']['input'];
  perPage?: Scalars['Int']['input'];
  query: Scalars['String']['input'];
};


export type QuerySearchIngredientsArgs = {
  searchTerm: Scalars['String']['input'];
};


export type QuerySearchJobsArgs = {
  query: Scalars['String']['input'];
};


export type QuerySearchPoliciesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  query: Scalars['String']['input'];
};


export type QuerySearchRecipesArgs = {
  searchTerm: Scalars['String']['input'];
};


export type QuerySearchResidentsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  query: Scalars['String']['input'];
};


export type QuerySearchSuppliersArgs = {
  searchTerm: Scalars['String']['input'];
};


export type QuerySecurityFindingArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySecurityFindingsArgs = {
  filter?: InputMaybe<SecurityFindingFilterInput>;
};


export type QuerySecurityScansArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  targetId: Scalars['ID']['input'];
};


export type QuerySecuritySiteArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySellerProfileArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySellerProfilesByClientArgs = {
  clientId: Scalars['ID']['input'];
};


export type QuerySeoMetadataArgs = {
  pagePath: Scalars['String']['input'];
};


export type QuerySeoMetadataAdminPreviewArgs = {
  pagePath: Scalars['String']['input'];
};


export type QuerySeoMetadataByPathsArgs = {
  pagePaths: Array<Scalars['String']['input']>;
};


export type QuerySeparationBlocksAwaitingMeArgs = {
  caseId?: InputMaybe<Scalars['ID']['input']>;
};


export type QuerySeparationCareBlocksArgs = {
  input: SeparationCareBlockRangeInput;
};


export type QuerySeparationCareLogArgs = {
  caseId?: InputMaybe<Scalars['ID']['input']>;
  includeSuperseded?: Scalars['Boolean']['input'];
};


export type QuerySeparationCaseArgs = {
  caseId?: InputMaybe<Scalars['ID']['input']>;
};


export type QuerySeparationChildrenArgs = {
  caseId?: InputMaybe<Scalars['ID']['input']>;
};


export type QuerySeparationCovenantAnswersArgs = {
  sectionId?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySeparationGuaranteeClaimsArgs = {
  status?: InputMaybe<SeparationClaimStatus>;
};


export type QuerySeparationNightCountArgs = {
  caseId?: InputMaybe<Scalars['ID']['input']>;
  fromDayKey: Scalars['String']['input'];
  toDayKey: Scalars['String']['input'];
};


export type QuerySeparationSchedulesArgs = {
  caseId?: InputMaybe<Scalars['ID']['input']>;
};


export type QuerySeparationSponsoredRequestsArgs = {
  status?: InputMaybe<SeparationSponsoredRequestStatus>;
};


export type QuerySessionTypeByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySessionTypesByPractitionerArgs = {
  practitionerId: Scalars['ID']['input'];
};


export type QuerySessionsArgs = {
  endDate: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
};


export type QuerySharedCompanyKnowledgeArticleArgs = {
  token: Scalars['String']['input'];
};


export type QueryShelvAggregatedIngredientsForDateRangeArgs = {
  endDate: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
};


export type QueryShelvCaptureAllowanceArgs = {
  kitchenId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryShelvCaptureJobArgs = {
  id: Scalars['ID']['input'];
};


export type QueryShelvCaptureJobsArgs = {
  kitchenId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryShelvFeedbackByMealPlanArgs = {
  mealPlanId: Scalars['ID']['input'];
};


export type QueryShelvFeedbackByRecipeArgs = {
  recipeId: Scalars['ID']['input'];
};


export type QueryShelvFoodBudgetSummaryArgs = {
  anchorDate?: InputMaybe<Scalars['String']['input']>;
  customEnd?: InputMaybe<Scalars['String']['input']>;
  customStart?: InputMaybe<Scalars['String']['input']>;
  period: ShelvBudgetPeriod;
};


export type QueryShelvFoodSpendByCategoryArgs = {
  anchorDate?: InputMaybe<Scalars['String']['input']>;
  customEnd?: InputMaybe<Scalars['String']['input']>;
  customStart?: InputMaybe<Scalars['String']['input']>;
  period: ShelvBudgetPeriod;
};


export type QueryShelvFoodSpendBySupplierArgs = {
  anchorDate?: InputMaybe<Scalars['String']['input']>;
  customEnd?: InputMaybe<Scalars['String']['input']>;
  customStart?: InputMaybe<Scalars['String']['input']>;
  period: ShelvBudgetPeriod;
};


export type QueryShelvGenerateChefCheatSheetArgs = {
  date: Scalars['String']['input'];
};


export type QueryShelvGenerateDailyMenuPdfArgs = {
  date: Scalars['String']['input'];
  pageSize?: InputMaybe<Scalars['String']['input']>;
};


export type QueryShelvGenerateMealPlanRangePdfArgs = {
  endDate: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
};


export type QueryShelvGenerateOrderPdfArgs = {
  orderId: Scalars['ID']['input'];
};


export type QueryShelvIngredientArgs = {
  id: Scalars['ID']['input'];
};


export type QueryShelvIngredientsByCategoryArgs = {
  category: ShelvIngredientCategory;
};


export type QueryShelvIngredientsBySupplierArgs = {
  supplierId: Scalars['ID']['input'];
};


export type QueryShelvInvoiceArgs = {
  id: Scalars['ID']['input'];
};


export type QueryShelvInvoicesArgs = {
  filter?: InputMaybe<ShelvFoodInvoicesFilter>;
};


export type QueryShelvKitchenArgs = {
  id: Scalars['ID']['input'];
};


export type QueryShelvMealFeedbackArgs = {
  id: Scalars['ID']['input'];
};


export type QueryShelvMealPlanArgs = {
  id: Scalars['ID']['input'];
};


export type QueryShelvMealPlanNotificationRuleArgs = {
  id: Scalars['ID']['input'];
};


export type QueryShelvMealPlansByDateArgs = {
  date: Scalars['String']['input'];
};


export type QueryShelvMealPlansByDateRangeArgs = {
  endDate: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
};


export type QueryShelvMealPlansByRecipeArgs = {
  recipeId: Scalars['ID']['input'];
};


export type QueryShelvMealPlansByShiftArgs = {
  shiftId: Scalars['ID']['input'];
};


export type QueryShelvMealPlansByShiftIdsArgs = {
  shiftIds: Array<Scalars['ID']['input']>;
};


export type QueryShelvMealPlansWithServicePhotosArgs = {
  endDate: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
};


export type QueryShelvMyMealPlanNotificationsArgs = {
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
};


export type QueryShelvOrdersByDateRangeArgs = {
  endDate: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
};


export type QueryShelvOrdersByStatusArgs = {
  status: ShelvSupplierOrderStatus;
};


export type QueryShelvOrdersBySupplierArgs = {
  supplierId: Scalars['ID']['input'];
};


export type QueryShelvPreviewDeactivateUnitArgs = {
  migrateTo?: InputMaybe<ShelvUnitType>;
  unit: ShelvUnitType;
};


export type QueryShelvPreviewIngredientUnitChangeArgs = {
  id: Scalars['ID']['input'];
  newUnit: ShelvUnitType;
};


export type QueryShelvPreviewRecipeIngredientUnitChangeArgs = {
  id: Scalars['ID']['input'];
  newUnit: ShelvUnitType;
};


export type QueryShelvRecentAccompanimentsArgs = {
  date: Scalars['String']['input'];
  lookbackDays?: Scalars['Int']['input'];
  mealType: ShelvMealType;
};


export type QueryShelvRecentOrdersForSupplierArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  supplierId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryShelvRecipeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryShelvRecipesByCategoryArgs = {
  category: Scalars['String']['input'];
};


export type QueryShelvRecipesByDietaryTagArgs = {
  tag: ShelvDietaryTag;
};


export type QueryShelvRecipesByDietaryTagsArgs = {
  tags: Array<ShelvDietaryTag>;
};


export type QueryShelvRecipesByDishTypeArgs = {
  dishType: ShelvRecipeDishType;
};


export type QueryShelvRecipesByIngredientArgs = {
  ingredientId: Scalars['ID']['input'];
};


export type QueryShelvRecipesBySessionTypeArgs = {
  sessionType: ShelvRecipeSessionType;
};


export type QueryShelvRecipesUsingUnitArgs = {
  unit: ShelvUnitType;
};


export type QueryShelvSearchIngredientsArgs = {
  searchTerm: Scalars['String']['input'];
};


export type QueryShelvSearchRecipesArgs = {
  searchTerm: Scalars['String']['input'];
};


export type QueryShelvSearchSuppliersArgs = {
  searchTerm: Scalars['String']['input'];
};


export type QueryShelvSupplierArgs = {
  id: Scalars['ID']['input'];
};


export type QueryShelvSupplierOrderArgs = {
  id: Scalars['ID']['input'];
};


export type QueryShiftArgs = {
  id: Scalars['ID']['input'];
};


export type QueryShiftNotificationLogsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  shiftId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryShiftSwapRequestArgs = {
  id: Scalars['ID']['input'];
};


export type QueryShiftSwapRequestsArgs = {
  status?: InputMaybe<ShiftSwapStatus>;
};


export type QueryShiftTemplateArgs = {
  id: Scalars['ID']['input'];
};


export type QueryShiftTypeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryShiftTypesArgs = {
  includeInactive?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryShiftsByDateRangeArgs = {
  endDate: Scalars['DateTime']['input'];
  startDate: Scalars['DateTime']['input'];
};


export type QueryShiftsByEmployeeArgs = {
  employeeId: Scalars['ID']['input'];
};


export type QueryShiftsByLocationArgs = {
  locationId: Scalars['ID']['input'];
};


export type QueryShiftsByLocationsArgs = {
  locationIds: Array<Scalars['ID']['input']>;
};


export type QueryShiftsByStatusArgs = {
  status: ShiftStatus;
};


export type QueryShiftsForResidentArgs = {
  residentId: Scalars['ID']['input'];
};


export type QuerySimilarBankingTransactionsArgs = {
  id: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySiteEditCommandsArgs = {
  filters?: InputMaybe<SiteEditCommandFilters>;
};


export type QuerySiteEditorMyCommandsArgs = {
  limit?: InputMaybe<Scalars['Float']['input']>;
};


export type QuerySiteEditorMyDevServerLogsArgs = {
  lines?: InputMaybe<Scalars['Float']['input']>;
  since?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySiteEditorMyMergeHistoryArgs = {
  limit?: InputMaybe<Scalars['Float']['input']>;
};


export type QuerySiteEditorMyPrHistoryArgs = {
  limit?: InputMaybe<Scalars['Float']['input']>;
};


export type QuerySiteEditorProvisionStatusArgs = {
  provisionId: Scalars['String']['input'];
  siteId: Scalars['String']['input'];
};


export type QuerySiteEditorRelayHealthArgs = {
  siteId: Scalars['String']['input'];
};


export type QuerySiteEditorSiteArgs = {
  siteId: Scalars['String']['input'];
};


export type QuerySiteTrackerDashboardArgs = {
  dayKey?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySiteUpdatesArgs = {
  approvalStatus?: InputMaybe<SiteUpdateApprovalStatus>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  siteId?: InputMaybe<Scalars['ID']['input']>;
};


export type QuerySleepChecksArgs = {
  filter?: InputMaybe<SleepCheckFilterInput>;
};


export type QuerySmsBroadcastAudiencePreviewArgs = {
  input: SmsBroadcastAudienceInput;
};


export type QuerySmsHeldRepliesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySmsMessagesArgs = {
  phoneNumber: Scalars['String']['input'];
};


export type QuerySmsResponsesArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySmsUsageStatsArgs = {
  filter?: InputMaybe<SmsUsageFilter>;
};


export type QuerySnapshotCountArgs = {
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type QuerySopAgendaArgs = {
  status?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySopCommentsArgs = {
  episodeId?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySopEpisodeArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySopEpisodeGuestsArgs = {
  episodeId: Scalars['ID']['input'];
};


export type QuerySopEpisodesArgs = {
  filter?: InputMaybe<SopEpisodeFilterInput>;
};


export type QuerySopSuggestedTimesArgs = {
  calendarIds: Array<Scalars['ID']['input']>;
  count?: InputMaybe<Scalars['Int']['input']>;
  durationMinutes?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySovereigntyJourneyArgs = {
  clientTenantId: Scalars['ID']['input'];
};


export type QuerySpamBlockPreviewArgs = {
  emailId: Scalars['ID']['input'];
  scope?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySpamSenderStatusArgs = {
  emailId: Scalars['ID']['input'];
};


export type QuerySphereOfInfluenceArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySpheresOfInfluenceArgs = {
  filter?: InputMaybe<SphereFilterInput>;
};


export type QueryStorageUsageLogsArgs = {
  filter?: InputMaybe<StorageUsageFilter>;
  limit?: Scalars['Int']['input'];
};


export type QueryStorageUsageStatsArgs = {
  filter?: InputMaybe<StorageUsageFilter>;
};


export type QueryStpLodgementsForRunArgs = {
  payRunId: Scalars['ID']['input'];
};


export type QuerySubscriptionArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySubscriptionBillingDashboardArgs = {
  billingPeriod?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySubscriptionDetailArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySubscriptionProductArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySubscriptionsByClientArgs = {
  clientId: Scalars['ID']['input'];
};


export type QuerySuburbStatsArgs = {
  suburb: Scalars['String']['input'];
};


export type QuerySupplierArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySupplierOrderArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySupplyAgentsArgs = {
  agentType?: InputMaybe<AgentType>;
};


export type QuerySuspiciousActivityLogsArgs = {
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
};


export type QuerySwapRosterShiftsArgs = {
  endDate: Scalars['DateTime']['input'];
  startDate: Scalars['DateTime']['input'];
};


export type QueryTasksByProjectArgs = {
  projectId: Scalars['ID']['input'];
};


export type QueryTeamArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTeamsArgs = {
  includeInactive?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryTemperatureAlarmArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTemperatureComplianceForDayArgs = {
  date: Scalars['String']['input'];
};


export type QueryTemperatureLogsArgs = {
  endDate: Scalars['String']['input'];
  equipmentId?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['String']['input'];
};


export type QueryTemperatureObservationsArgs = {
  filter?: InputMaybe<TemperatureFilterInput>;
};


export type QueryTemplatesByCategoryArgs = {
  category: CarePlanCategory;
};


export type QueryTenantArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTenantAuthenticationSettingsArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTenantAutomationRunArgs = {
  id: Scalars['String']['input'];
};


export type QueryTenantAutomationRunsArgs = {
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  tenantId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTenantBillingOverviewArgs = {
  billingPeriod?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTenantEmailStatusArgs = {
  tenantId: Scalars['ID']['input'];
};


export type QueryTenantGrowthSummaryArgs = {
  tenantId: Scalars['String']['input'];
};


export type QueryTenantIpfsHealthArgs = {
  launchedSiteId: Scalars['ID']['input'];
};


export type QueryTenantLocalAiStatusArgs = {
  tenantId: Scalars['ID']['input'];
};


export type QueryTimesheetArgs = {
  id: Scalars['String']['input'];
};


export type QueryTodaysCheckInsArgs = {
  locationId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryTodaysRoundsArgs = {
  wing?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTomConversationArgs = {
  id: Scalars['String']['input'];
};


export type QueryTomInteractionLogsArgs = {
  limit?: InputMaybe<Scalars['Float']['input']>;
};


export type QueryTomJourneyContextArgs = {
  clientId: Scalars['ID']['input'];
};


export type QueryTopPagesArgs = {
  filters?: InputMaybe<AnalyticsFilters>;
};


export type QueryTotalOpportunityValueArgs = {
  status?: InputMaybe<OpportunityStatus>;
};


export type QueryTrackedCompetitionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTrackedCompetitionsArgs = {
  status?: InputMaybe<TrackedCompetitionStatus>;
};


export type QueryTradeRoutesArgs = {
  filters?: InputMaybe<TradeRouteFiltersInput>;
};


export type QueryTrafficSourcesArgs = {
  filters?: InputMaybe<AnalyticsFilters>;
};


export type QueryTranscriptionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTranscriptionCommentsArgs = {
  transcriptionId: Scalars['ID']['input'];
};


export type QueryTranscriptionSpeakerContactsArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTranscriptionsPageArgs = {
  input?: InputMaybe<TranscriptionListInput>;
};


export type QueryTrustActivitiesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  personId: Scalars['ID']['input'];
};


export type QueryTrustPersonArgs = {
  id: Scalars['String']['input'];
};


export type QueryUnassignedEmailsArgs = {
  limit?: Scalars['Float']['input'];
  offset?: Scalars['Float']['input'];
};


export type QueryUnfinishedCheckInsArgs = {
  employeeId: Scalars['ID']['input'];
};


export type QueryUpcomingActionsArgs = {
  days?: InputMaybe<Scalars['Int']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryUpcomingEventsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryUpcomingShiftsArgs = {
  days?: Scalars['Float']['input'];
};


export type QueryUrinalysisObservationsArgs = {
  filter?: InputMaybe<UrinalysisFilterInput>;
};


export type QueryUserAuditLogsArgs = {
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  userId: Scalars['ID']['input'];
};


export type QueryVaccinationsArgs = {
  filter?: InputMaybe<VaccinationFilterInput>;
};


export type QueryValidateCouponArgs = {
  code: Scalars['String']['input'];
  productId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryValidateQrCodeArgs = {
  input: ValidateQrCodeInput;
};


export type QueryVaultInsightRuleArgs = {
  id: Scalars['ID']['input'];
};


export type QueryVaultInsightRunArgs = {
  id: Scalars['ID']['input'];
};


export type QueryVaultInsightRunsArgs = {
  ruleId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryVerifySarahCareMedicalFileArgs = {
  recordId: Scalars['ID']['input'];
};


export type QueryVisionBoardItemArgs = {
  id: Scalars['ID']['input'];
};


export type QueryVisionBoardItemsArgs = {
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryVlogPostArgs = {
  id: Scalars['ID']['input'];
};


export type QueryVlogPostBySlugArgs = {
  slug: Scalars['String']['input'];
};


export type QueryVlogPostReactionsArgs = {
  postId: Scalars['ID']['input'];
};


export type QueryVlogPostsArgs = {
  filter?: InputMaybe<VlogPostFilterInput>;
};


export type QueryVlogPostsBySeriesArgs = {
  seriesId: Scalars['ID']['input'];
};


export type QueryVlogSeriesBySlugArgs = {
  slug: Scalars['String']['input'];
};


export type QueryVlogSeriesItemArgs = {
  id: Scalars['ID']['input'];
};


export type QueryVoiceContactsArgs = {
  offset?: Scalars['Int']['input'];
  search?: Scalars['String']['input'];
};


export type QueryVoiceUsersArgs = {
  offset?: Scalars['Int']['input'];
  search?: Scalars['String']['input'];
};


export type QueryVoipCallArgs = {
  id: Scalars['ID']['input'];
};


export type QueryVoipCallVolumeArgs = {
  bucket?: Scalars['String']['input'];
  dateFrom?: InputMaybe<Scalars['String']['input']>;
  dateTo?: InputMaybe<Scalars['String']['input']>;
  ownNumber?: InputMaybe<Scalars['String']['input']>;
};


export type QueryVoipCallsArgs = {
  filter?: InputMaybe<VoipCallFilterInput>;
  limit?: Scalars['Int']['input'];
  page?: Scalars['Int']['input'];
};


export type QueryVoipNumbersArgs = {
  activeOnly?: Scalars['Boolean']['input'];
};


export type QueryVoipSnapshotArgs = {
  id: Scalars['ID']['input'];
};


export type QueryVoipSnapshotsArgs = {
  filter?: InputMaybe<VoipSnapshotFilterInput>;
};


export type QueryWaitingListArgs = {
  filter?: InputMaybe<WaitingListFilterInput>;
};


export type QueryWaitingListActivityArgs = {
  entryId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryWaitingListCountArgs = {
  filter?: InputMaybe<WaitingListFilterInput>;
};


export type QueryWaitingListEntryArgs = {
  id: Scalars['ID']['input'];
};


export type QueryWaitingListFamilyMessagePreviewArgs = {
  entryId: Scalars['ID']['input'];
  kind: WaitingListFamilyMessageKind;
};


export type QueryWaitingListFileDownloadUrlArgs = {
  fileId: Scalars['ID']['input'];
  purpose: Scalars['String']['input'];
};


export type QueryWaitingListFilesArgs = {
  entryId: Scalars['ID']['input'];
};


export type QueryWaitingListTourMessagePreviewArgs = {
  createVideoInvite?: InputMaybe<Scalars['Boolean']['input']>;
  entryId: Scalars['ID']['input'];
  scheduledAt?: InputMaybe<Scalars['DateTime']['input']>;
  shownById?: InputMaybe<Scalars['ID']['input']>;
  tourType?: InputMaybe<SiteTourType>;
};


export type QueryWaitingListUnsuitableMatchesArgs = {
  dateOfBirth?: InputMaybe<Scalars['DateTime']['input']>;
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
};


export type QueryWalletDirectorySuggestionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryWalletInviteStatementArgs = {
  address: Scalars['String']['input'];
  slug: Scalars['String']['input'];
};


export type QueryWalletKeysForClientArgs = {
  clientId: Scalars['ID']['input'];
};


export type QueryWaterlowAssessmentsArgs = {
  filter?: InputMaybe<WaterlowAssessmentFilterInput>;
};


export type QueryWebsitesByClientArgs = {
  clientId: Scalars['ID']['input'];
};


export type QueryWeightObservationsArgs = {
  filter?: InputMaybe<WeightObservationFilterInput>;
};


export type QueryWithdrawalRequestArgs = {
  id: Scalars['ID']['input'];
};


export type QueryWithdrawalRequestsArgs = {
  vaultId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryWorkerArgs = {
  id: Scalars['ID']['input'];
};


export type QueryWorkerTimeEntriesArgs = {
  filter?: InputMaybe<WorkerTimeEntryFilterInput>;
};


export type QueryWorkerTimeEntryArgs = {
  id: Scalars['ID']['input'];
};


export type QueryWorkersArgs = {
  filter?: InputMaybe<WorkerFilterInput>;
};


export type QueryWoundArgs = {
  id: Scalars['ID']['input'];
};


export type QueryWoundAssessmentsArgs = {
  filter?: InputMaybe<WoundAssessmentFilterInput>;
};


export type QueryWoundsArgs = {
  filter?: InputMaybe<WoundFilterInput>;
};


export type QueryZkGetHelperDataArgs = {
  publicKey: Scalars['String']['input'];
};

export type QuickEmailResult = {
  __typename?: 'QuickEmailResult';
  created: Array<Scalars['String']['output']>;
  failed: Array<Scalars['String']['output']>;
  skipped: Array<Scalars['String']['output']>;
};

export type QuickSplitCategoryEntry = {
  category: IngredientCategory;
  percent: Scalars['Float']['input'];
};

export type QuickSplitInvoiceInput = {
  categorySplit: Array<QuickSplitCategoryEntry>;
  gst?: InputMaybe<Scalars['Float']['input']>;
  invoiceDate: Scalars['DateTime']['input'];
  invoiceNumber?: InputMaybe<Scalars['String']['input']>;
  linkedOrderId?: InputMaybe<Scalars['ID']['input']>;
  supplierId?: InputMaybe<Scalars['ID']['input']>;
  supplierNameRaw?: InputMaybe<Scalars['String']['input']>;
  total: Scalars['Float']['input'];
};

export type Quote = {
  __typename?: 'Quote';
  createdAt: Scalars['DateTime']['output'];
  formData: Scalars['JSONObject']['output'];
  id: Scalars['ID']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  reviewedAt?: Maybe<Scalars['DateTime']['output']>;
  status: QuoteStatus;
  templateId: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type QuoteField = {
  __typename?: 'QuoteField';
  fieldId: Scalars['String']['output'];
  label: Scalars['String']['output'];
  options?: Maybe<Array<Scalars['String']['output']>>;
  required: Scalars['Boolean']['output'];
  type: Scalars['String']['output'];
};

export type QuoteFieldInput = {
  fieldId: Scalars['String']['input'];
  label: Scalars['String']['input'];
  options?: InputMaybe<Array<Scalars['String']['input']>>;
  required?: Scalars['Boolean']['input'];
  type: Scalars['String']['input'];
};

export type QuoteInput = {
  formData: Scalars['JSONObject']['input'];
  templateId: Scalars['String']['input'];
};

/** The status of the quote request */
export enum QuoteStatus {
  Accepted = 'ACCEPTED',
  Archived = 'ARCHIVED',
  Pending = 'PENDING',
  Rejected = 'REJECTED',
  Reviewed = 'REVIEWED'
}

export type QuoteTemplate = {
  __typename?: 'QuoteTemplate';
  fields: Array<QuoteField>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  notificationEmail?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
};

export type QuoteTemplateInput = {
  fields: Array<QuoteFieldInput>;
  name: Scalars['String']['input'];
  notificationEmail?: InputMaybe<Scalars['String']['input']>;
};

export type RdActivity = {
  __typename?: 'RDActivity';
  activityEvidence: Array<RdEvidence>;
  activityName?: Maybe<Scalars['String']['output']>;
  activityTimeEntries: Array<RdTimeEntry>;
  activityType?: Maybe<Scalars['String']['output']>;
  challenges?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  directRelationshipExplanation?: Maybe<Scalars['String']['output']>;
  documentationStage?: Maybe<Scalars['String']['output']>;
  dominantPurposeJustification?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  evidence?: Maybe<Array<RdEvidence>>;
  expectedOutcomes?: Maybe<Scalars['String']['output']>;
  hypothesis?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  initialObservations?: Maybe<Scalars['String']['output']>;
  knowledgeGapEvidence?: Maybe<Scalars['String']['output']>;
  learnings?: Maybe<Scalars['String']['output']>;
  linkedCoreActivity?: Maybe<RdActivity>;
  linkedCoreActivityId?: Maybe<Scalars['String']['output']>;
  methodology?: Maybe<Scalars['String']['output']>;
  milestones?: Maybe<Scalars['String']['output']>;
  objectives?: Maybe<Scalars['String']['output']>;
  outcomes?: Maybe<Scalars['String']['output']>;
  percentageForRD?: Maybe<Scalars['Float']['output']>;
  proposedDesign?: Maybe<Scalars['String']['output']>;
  quantitativeOutcomes?: Maybe<Scalars['String']['output']>;
  rdProjectId: Scalars['String']['output'];
  resources?: Maybe<Scalars['String']['output']>;
  solutions?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  successCriteria?: Maybe<Scalars['String']['output']>;
  systematicExperimentation?: Maybe<Scalars['String']['output']>;
  technicalUncertainty?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  timeEntries?: Maybe<Array<RdTimeEntry>>;
  timeline?: Maybe<Scalars['String']['output']>;
  trialLocation?: Maybe<Scalars['String']['output']>;
  trialObjective?: Maybe<Scalars['String']['output']>;
  trialScope?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  variablesTested?: Maybe<Scalars['String']['output']>;
};

export type RdActivityGaps = {
  __typename?: 'RDActivityGaps';
  coreCount: Scalars['Float']['output'];
  supportingCount: Scalars['Float']['output'];
  supportingWithoutCore: Array<Scalars['String']['output']>;
};

export type RdActivityInput = {
  activityName?: InputMaybe<Scalars['String']['input']>;
  activityType?: InputMaybe<Scalars['String']['input']>;
  challenges?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  directRelationshipExplanation?: InputMaybe<Scalars['String']['input']>;
  documentationStage?: InputMaybe<Scalars['String']['input']>;
  dominantPurposeJustification?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  expectedOutcomes?: InputMaybe<Scalars['String']['input']>;
  hypothesis?: InputMaybe<Scalars['String']['input']>;
  initialObservations?: InputMaybe<Scalars['String']['input']>;
  knowledgeGapEvidence?: InputMaybe<Scalars['String']['input']>;
  learnings?: InputMaybe<Scalars['String']['input']>;
  linkedCoreActivityId?: InputMaybe<Scalars['String']['input']>;
  methodology?: InputMaybe<Scalars['String']['input']>;
  milestones?: InputMaybe<Scalars['String']['input']>;
  objectives?: InputMaybe<Scalars['String']['input']>;
  outcomes?: InputMaybe<Scalars['String']['input']>;
  percentageForRD?: InputMaybe<Scalars['Float']['input']>;
  proposedDesign?: InputMaybe<Scalars['String']['input']>;
  quantitativeOutcomes?: InputMaybe<Scalars['String']['input']>;
  rdProjectId: Scalars['String']['input'];
  resources?: InputMaybe<Scalars['String']['input']>;
  solutions?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  successCriteria?: InputMaybe<Scalars['String']['input']>;
  systematicExperimentation?: InputMaybe<Scalars['String']['input']>;
  technicalUncertainty?: InputMaybe<Scalars['String']['input']>;
  timeline?: InputMaybe<Scalars['String']['input']>;
  trialLocation?: InputMaybe<Scalars['String']['input']>;
  trialObjective?: InputMaybe<Scalars['String']['input']>;
  trialScope?: InputMaybe<Scalars['String']['input']>;
  variablesTested?: InputMaybe<Scalars['String']['input']>;
};

export type RdCommunicationLog = {
  __typename?: 'RDCommunicationLog';
  attachments?: Maybe<Scalars['String']['output']>;
  autoCreatedTimeEntry: Scalars['Boolean']['output'];
  communicationType: Scalars['String']['output'];
  content?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  date: Scalars['DateTime']['output'];
  duration?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  participants?: Maybe<Scalars['String']['output']>;
  rdProjectId: Scalars['String']['output'];
  subject?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  timeEntryId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type RdEvidence = {
  __typename?: 'RDEvidence';
  captureDate: Scalars['DateTime']['output'];
  content?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  evidenceType: Scalars['String']['output'];
  fileUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  metadata?: Maybe<Scalars['String']['output']>;
  participants?: Maybe<Scalars['String']['output']>;
  rdActivityId?: Maybe<Scalars['String']['output']>;
  rdProjectId: Scalars['String']['output'];
  source?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type RdEvidenceGaps = {
  __typename?: 'RDEvidenceGaps';
  activitiesWithoutEvidence: Array<Scalars['String']['output']>;
  byType: Scalars['String']['output'];
  totalCount: Scalars['Float']['output'];
};

export type RdGapAnalysisResult = {
  __typename?: 'RDGapAnalysisResult';
  activities: RdActivityGaps;
  evidence: RdEvidenceGaps;
  project: RdProjectGaps;
  stages: Scalars['String']['output'];
  timeTracking: RdTimeTrackingGaps;
};

export type RdProject = {
  __typename?: 'RDProject';
  activities?: Maybe<Array<RdActivity>>;
  createdAt: Scalars['DateTime']['output'];
  endDate?: Maybe<Scalars['DateTime']['output']>;
  estimatedValue?: Maybe<Scalars['Float']['output']>;
  evidence?: Maybe<Array<RdEvidence>>;
  executiveSummary?: Maybe<Scalars['String']['output']>;
  financialYear?: Maybe<Scalars['String']['output']>;
  hypothesis?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  industryKnowledge?: Maybe<Scalars['String']['output']>;
  knowledgeLimitations?: Maybe<Scalars['String']['output']>;
  projectCode?: Maybe<Scalars['String']['output']>;
  projectName?: Maybe<Scalars['String']['output']>;
  projectType?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  successCriteria?: Maybe<Scalars['String']['output']>;
  systematicExperimentationApproach?: Maybe<Scalars['String']['output']>;
  technicalObjective?: Maybe<Scalars['String']['output']>;
  technicalUncertainty?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  timeEntries?: Maybe<Array<RdTimeEntry>>;
  totalHours?: Maybe<Scalars['Float']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  variables?: Maybe<Scalars['String']['output']>;
};

export type RdProjectGaps = {
  __typename?: 'RDProjectGaps';
  completeness: Scalars['Float']['output'];
  missingFields: Array<Scalars['String']['output']>;
};

export type RdProjectInput = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  executiveSummary?: InputMaybe<Scalars['String']['input']>;
  financialYear?: InputMaybe<Scalars['String']['input']>;
  hypothesis?: InputMaybe<Scalars['String']['input']>;
  industryKnowledge?: InputMaybe<Scalars['String']['input']>;
  knowledgeLimitations?: InputMaybe<Scalars['String']['input']>;
  projectCode?: InputMaybe<Scalars['String']['input']>;
  projectName?: InputMaybe<Scalars['String']['input']>;
  projectType?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  successCriteria?: InputMaybe<Scalars['String']['input']>;
  systematicExperimentationApproach?: InputMaybe<Scalars['String']['input']>;
  technicalObjective?: InputMaybe<Scalars['String']['input']>;
  technicalUncertainty?: InputMaybe<Scalars['String']['input']>;
  variables?: InputMaybe<Scalars['String']['input']>;
};

export type RdTimeEntry = {
  __typename?: 'RDTimeEntry';
  createdAt: Scalars['DateTime']['output'];
  date: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  hours: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  isUnallocated?: Maybe<Scalars['Boolean']['output']>;
  rdActivityId?: Maybe<Scalars['String']['output']>;
  rdProjectId: Scalars['String']['output'];
  reviewedAt?: Maybe<Scalars['DateTime']['output']>;
  reviewedBy?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  timeType?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  userId: Scalars['String']['output'];
};

export type RdTimeEntryInput = {
  date: Scalars['DateTime']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  hours: Scalars['Float']['input'];
  isUnallocated?: InputMaybe<Scalars['Boolean']['input']>;
  rdActivityId?: InputMaybe<Scalars['String']['input']>;
  rdProjectId?: InputMaybe<Scalars['String']['input']>;
  timeType?: InputMaybe<Scalars['String']['input']>;
};

export type RdTimeTrackingGaps = {
  __typename?: 'RDTimeTrackingGaps';
  activitiesWithoutTime: Array<Scalars['String']['output']>;
  totalHours: Scalars['Float']['output'];
};

export type RsvpResponse = {
  __typename?: 'RSVPResponse';
  event?: Maybe<CalendarEvent>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type RaiseFeedbackOutcomeInput = {
  closeFeedback?: InputMaybe<Scalars['Boolean']['input']>;
  details?: InputMaybe<Scalars['String']['input']>;
  feedbackId: Scalars['ID']['input'];
  kind: FeedbackOutcomeKind;
  rating?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ReadinessSectionRow = {
  __typename?: 'ReadinessSectionRow';
  complete: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  missing: Array<Scalars['String']['output']>;
};

export type RealTimeStats = {
  __typename?: 'RealTimeStats';
  activePages: Array<Scalars['String']['output']>;
  activeVisitors: Scalars['Int']['output'];
  eventsLastHour: Scalars['Int']['output'];
  pageViewsLastHour: Scalars['Int']['output'];
};

export type ReceiptAttachment = {
  __typename?: 'ReceiptAttachment';
  cid?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  mimeType?: Maybe<Scalars['String']['output']>;
  uploadedAt?: Maybe<Scalars['DateTime']['output']>;
  url: Scalars['String']['output'];
};

export type ReceiptAttachmentInput = {
  cid?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  mimeType?: InputMaybe<Scalars['String']['input']>;
  url: Scalars['String']['input'];
};

export type ReceivableBucket = {
  __typename?: 'ReceivableBucket';
  amount: Scalars['Float']['output'];
  count: Scalars['Int']['output'];
  label: Scalars['String']['output'];
};

export type Recipe = {
  __typename?: 'Recipe';
  caloriesPerServing?: Maybe<Scalars['Float']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  cookTime?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  cuisine?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dietaryTags?: Maybe<Array<DietaryTag>>;
  dishType?: Maybe<RecipeDishType>;
  id: Scalars['ID']['output'];
  imageCid?: Maybe<Scalars['String']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  ingredients: Array<RecipeIngredient>;
  instructions?: Maybe<Scalars['String']['output']>;
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  prepTime?: Maybe<Scalars['Float']['output']>;
  servings: Scalars['Float']['output'];
  sessionType?: Maybe<RecipeSessionType>;
  tenantId: Scalars['String']['output'];
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  totalTime?: Maybe<Scalars['Float']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

/** Protein or dish category classification for recipes */
export enum RecipeDishType {
  Beef = 'BEEF',
  Chicken = 'CHICKEN',
  Lamb = 'LAMB',
  Other = 'OTHER',
  Pork = 'PORK',
  Salad = 'SALAD',
  Seafood = 'SEAFOOD',
  Soup = 'SOUP',
  Vegetarian = 'VEGETARIAN'
}

export type RecipeFeedbackSummary = {
  __typename?: 'RecipeFeedbackSummary';
  averageRating: Scalars['Float']['output'];
  lowRatingCount: Scalars['Float']['output'];
  recipeId: Scalars['ID']['output'];
  recipeName: Scalars['String']['output'];
  totalFeedback: Scalars['Float']['output'];
};

export type RecipeIngredient = {
  __typename?: 'RecipeIngredient';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  ingredient?: Maybe<Ingredient>;
  ingredientId: Scalars['ID']['output'];
  isOptional: Scalars['Boolean']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  quantity: Scalars['Float']['output'];
  recipe?: Maybe<Recipe>;
  recipeId: Scalars['ID']['output'];
  sortOrder?: Maybe<Scalars['Float']['output']>;
  tenantId: Scalars['String']['output'];
  unit: UnitType;
  updatedAt: Scalars['DateTime']['output'];
};

export type RecipeIngredientItemInput = {
  ingredientId: Scalars['ID']['input'];
  isOptional?: InputMaybe<Scalars['Boolean']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  quantity: Scalars['Float']['input'];
  sortOrder?: InputMaybe<Scalars['Float']['input']>;
  unit: UnitType;
};

/** When a recipe is typically served */
export enum RecipeSessionType {
  Breakfast = 'BREAKFAST',
  Dessert = 'DESSERT',
  Dinner = 'DINNER',
  Lunch = 'LUNCH',
  Snack = 'SNACK',
  Supper = 'SUPPER'
}

export type RecommendationAttachment = {
  __typename?: 'RecommendationAttachment';
  cid: Scalars['String']['output'];
  contentType?: Maybe<Scalars['String']['output']>;
  label: Scalars['String']['output'];
};

export type RecommendationCredentials = {
  __typename?: 'RecommendationCredentials';
  ahpraCid?: Maybe<Scalars['String']['output']>;
  /** Date-only (T00:00:00.000Z). */
  ahpraExpiry?: Maybe<Scalars['DateTime']['output']>;
  ahpraNumber?: Maybe<Scalars['String']['output']>;
  /** When the Aged Care banning-orders register was checked. */
  bannedRegisterCheckedAt?: Maybe<Scalars['DateTime']['output']>;
  certificates?: Maybe<Array<EmployeeCertificate>>;
  coverLetterCid?: Maybe<Scalars['String']['output']>;
  covidImmunised?: Maybe<Scalars['Boolean']['output']>;
  cprCid?: Maybe<Scalars['String']['output']>;
  /** Date-only (T00:00:00.000Z). */
  cprExpiry?: Maybe<Scalars['DateTime']['output']>;
  firstAidCid?: Maybe<Scalars['String']['output']>;
  /** Date-only (T00:00:00.000Z). */
  firstAidExpiry?: Maybe<Scalars['DateTime']['output']>;
  fluImmunised?: Maybe<Scalars['Boolean']['output']>;
  policeCheck?: Maybe<EmployeePoliceCheck>;
  resumeCid?: Maybe<Scalars['String']['output']>;
  workingRightsCid?: Maybe<Scalars['String']['output']>;
  /** CITIZEN | PERMANENT_RESIDENT | VISA | UNKNOWN */
  workingRightsStatus?: Maybe<Scalars['String']['output']>;
};

export type RecommendationPerson = {
  __typename?: 'RecommendationPerson';
  address?: Maybe<Scalars['String']['output']>;
  addressCountry?: Maybe<Scalars['String']['output']>;
  addressPostcode?: Maybe<Scalars['String']['output']>;
  addressState?: Maybe<Scalars['String']['output']>;
  addressStreetName?: Maybe<Scalars['String']['output']>;
  addressStreetNumber?: Maybe<Scalars['String']['output']>;
  addressSuburb?: Maybe<Scalars['String']['output']>;
  dateOfBirth?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  middleName?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
};

export type RecommendationReference = {
  __typename?: 'RecommendationReference';
  name?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Scalars['Float']['output']>;
  receivedAt?: Maybe<Scalars['DateTime']['output']>;
  relation?: Maybe<Scalars['String']['output']>;
  /** REQUESTED | RECEIVED | DECLINED */
  status?: Maybe<Scalars['String']['output']>;
};

export type RecommendationTimelineEntry = {
  __typename?: 'RecommendationTimelineEntry';
  at: Scalars['DateTime']['output'];
  byName?: Maybe<Scalars['String']['output']>;
  event: Scalars['String']['output'];
};

export type RecordAbsenceInput = {
  employeeId: Scalars['ID']['input'];
  endTime?: InputMaybe<Scalars['DateTime']['input']>;
  fullShift?: InputMaybe<Scalars['Boolean']['input']>;
  hours?: InputMaybe<Scalars['Float']['input']>;
  isPaidLeave?: InputMaybe<Scalars['Boolean']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  reason: AbsenceReason;
  shiftId: Scalars['ID']['input'];
  startTime?: InputMaybe<Scalars['DateTime']['input']>;
};

export type RecordAdministrationInput = {
  administeredDate?: InputMaybe<Scalars['DateTime']['input']>;
  administeredTime?: InputMaybe<Scalars['String']['input']>;
  medicationId: Scalars['ID']['input'];
  missedReason?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  refusedReason?: InputMaybe<Scalars['String']['input']>;
  residentId: Scalars['ID']['input'];
  roundId?: InputMaybe<Scalars['ID']['input']>;
  scheduledDate: Scalars['DateTime']['input'];
  scheduledTime: Scalars['String']['input'];
  status: AdministrationStatus;
  vitalSignsTaken?: InputMaybe<Scalars['Boolean']['input']>;
  withholdReason?: InputMaybe<WithholdReason>;
  withholdReasonText?: InputMaybe<Scalars['String']['input']>;
  witnessedBy?: InputMaybe<Scalars['ID']['input']>;
  witnessedByName?: InputMaybe<Scalars['String']['input']>;
};

export type RecordAiAuditDecisionInput = {
  auditId: Scalars['ID']['input'];
  decision: AiAuditDecision;
  note?: InputMaybe<Scalars['String']['input']>;
  payRunLineId: Scalars['ID']['input'];
};

/** Gold or bitcoin bought or sold, recorded by hand */
export type RecordBankingHoldingInput = {
  asset: BankingHoldingAsset;
  audMinor: Scalars['Int']['input'];
  kind: BankingHoldingKind;
  note?: InputMaybe<Scalars['String']['input']>;
  on: Scalars['String']['input'];
  quantity: Scalars['Float']['input'];
  transactionId?: InputMaybe<Scalars['ID']['input']>;
};

export type RecordBankingLoanDrawdownInput = {
  amountMinor?: InputMaybe<Scalars['Int']['input']>;
  at?: InputMaybe<Scalars['DateTime']['input']>;
  lenderClientId: Scalars['ID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  transactionId?: InputMaybe<Scalars['ID']['input']>;
};

export type RecordBankingLoanRepaymentInput = {
  amountMinor?: InputMaybe<Scalars['Int']['input']>;
  at?: InputMaybe<Scalars['DateTime']['input']>;
  loanId: Scalars['ID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  transactionId?: InputMaybe<Scalars['ID']['input']>;
};

/** An admin's own price for a day (gold has no free history) */
export type RecordBankingPriceInput = {
  asset: BankingPriceAsset;
  aud?: InputMaybe<Scalars['Float']['input']>;
  day: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  usd?: InputMaybe<Scalars['Float']['input']>;
};

export type RecordCiMeetingMinutesInput = {
  decisionsAndActions?: InputMaybe<Array<CiDecisionActionInput>>;
  initiativesReviewed?: InputMaybe<Array<Scalars['ID']['input']>>;
  issuesReviewed?: InputMaybe<Array<Scalars['ID']['input']>>;
  minutes: Scalars['String']['input'];
};

export type RecordCarePlanCopyInput = {
  contactId?: InputMaybe<Scalars['ID']['input']>;
  copyKind: CarePlanCopyKind;
  givenAt?: InputMaybe<Scalars['DateTime']['input']>;
  givenToKind: CarePlanParticipantKind;
  givenToName?: InputMaybe<Scalars['String']['input']>;
  method: CarePlanCopyMethod;
  notes?: InputMaybe<Scalars['String']['input']>;
};

export type RecordCompetitionPrintPayoutInput = {
  amount: Scalars['Float']['input'];
  method?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  offerId: Scalars['ID']['input'];
  paidAt: Scalars['DateTime']['input'];
};

export type RecordGovMovementInput = {
  accountId: Scalars['ID']['input'];
  amount: Scalars['Float']['input'];
  decisionId?: InputMaybe<Scalars['ID']['input']>;
  description: Scalars['String']['input'];
  direction: GovMovementDirection;
  memberId?: InputMaybe<Scalars['ID']['input']>;
  occurredAt?: InputMaybe<Scalars['DateTime']['input']>;
  workItemId?: InputMaybe<Scalars['ID']['input']>;
};

export type RecordGridEntryInput = {
  /** Which grid day (1, 2 or 3) */
  dayOffset: Scalars['Int']['input'];
  /** PCW initials */
  initials?: InputMaybe<Scalars['String']['input']>;
  /** Date-only, as YYYY-MM-DD (Brisbane). Stored at T00:00:00.000Z. Pass null to clear the cell. */
  recordedDate?: InputMaybe<Scalars['String']['input']>;
  shift: ChecklistShift;
};

export type RecordHostingCommissionPaymentInput = {
  amount: Scalars['Float']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  periodMonth: Scalars['String']['input'];
  referralId: Scalars['ID']['input'];
};

export type RecordInterventionCompletionInput = {
  durationMinutes?: InputMaybe<Scalars['Int']['input']>;
  missedReason?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  scheduledTime?: InputMaybe<Scalars['String']['input']>;
  wasMissed?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RecordReturnInput = {
  actualReturnDate: Scalars['DateTime']['input'];
  belongingsReturned?: InputMaybe<Scalars['String']['input']>;
  returnNotes?: InputMaybe<Scalars['String']['input']>;
  returnTime?: InputMaybe<Scalars['String']['input']>;
};

export type RecordTestResultInput = {
  bugReportId?: InputMaybe<Scalars['String']['input']>;
  moduleId: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  passed: Scalars['Boolean']['input'];
  testItemKey: Scalars['String']['input'];
  testTier: TestTier;
};

export type RecordTrustActivityInput = {
  date: Scalars['String']['input'];
  personId: Scalars['ID']['input'];
  sourceId: Scalars['String']['input'];
  sourceName?: InputMaybe<Scalars['String']['input']>;
  sourceUrl: Scalars['String']['input'];
  summary?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  type: TrustActivityType;
};

export type RecordWaitingListTourDoneInput = {
  /** Who came, e.g. "daughter and son" */
  attendees?: InputMaybe<Scalars['String']['input']>;
  /** When it happened (default now; never in the future) */
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Optional tour feedback — saved exactly as recordWaitingListTourFeedback would (activity keeps the old text) */
  feedback?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  /** Login (client) id from waitingListAssignablePeople; omitted = the person recording it */
  shownById?: InputMaybe<Scalars['ID']['input']>;
  tourType: SiteTourType;
};

/** The status of the recording */
export enum RecordingStatus {
  Completed = 'COMPLETED',
  Deleted = 'DELETED',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  Pending = 'PENDING'
}

export type RecoveryCodesResult = {
  __typename?: 'RecoveryCodesResult';
  recoveryCodes: Array<Scalars['String']['output']>;
  token: Scalars['String']['output'];
};

export type RecurrenceRule = {
  __typename?: 'RecurrenceRule';
  byDay?: Maybe<Array<Scalars['String']['output']>>;
  byHour?: Maybe<Array<Scalars['Float']['output']>>;
  byMinute?: Maybe<Array<Scalars['Float']['output']>>;
  byMonth?: Maybe<Array<Scalars['Float']['output']>>;
  byMonthDay?: Maybe<Array<Scalars['Float']['output']>>;
  bySecond?: Maybe<Array<Scalars['Float']['output']>>;
  bySetPos?: Maybe<Array<Scalars['Float']['output']>>;
  byWeekNo?: Maybe<Array<Scalars['Float']['output']>>;
  byYearDay?: Maybe<Array<Scalars['Float']['output']>>;
  count?: Maybe<Scalars['Float']['output']>;
  frequency: Scalars['String']['output'];
  interval?: Maybe<Scalars['Float']['output']>;
  rruleString?: Maybe<Scalars['String']['output']>;
  tzid?: Maybe<Scalars['String']['output']>;
  until?: Maybe<Scalars['DateTime']['output']>;
  wkst?: Maybe<Scalars['String']['output']>;
};

export type RecurrenceRuleInput = {
  byDay?: InputMaybe<Array<Scalars['String']['input']>>;
  byHour?: InputMaybe<Array<Scalars['Float']['input']>>;
  byMinute?: InputMaybe<Array<Scalars['Float']['input']>>;
  byMonth?: InputMaybe<Array<Scalars['Float']['input']>>;
  byMonthDay?: InputMaybe<Array<Scalars['Float']['input']>>;
  bySecond?: InputMaybe<Array<Scalars['Float']['input']>>;
  bySetPos?: InputMaybe<Array<Scalars['Float']['input']>>;
  byWeekNo?: InputMaybe<Array<Scalars['Float']['input']>>;
  byYearDay?: InputMaybe<Array<Scalars['Float']['input']>>;
  count?: InputMaybe<Scalars['Float']['input']>;
  frequency: Scalars['String']['input'];
  interval?: InputMaybe<Scalars['Float']['input']>;
  rruleString?: InputMaybe<Scalars['String']['input']>;
  tzid?: InputMaybe<Scalars['String']['input']>;
  until?: InputMaybe<Scalars['DateTime']['input']>;
  wkst?: InputMaybe<Scalars['String']['input']>;
};

export type RecurringPayment = {
  __typename?: 'RecurringPayment';
  description?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  lastPaymentDate?: Maybe<Scalars['DateTime']['output']>;
  memberSplits?: Maybe<Array<MemberSplit>>;
  monthlyAmount: Scalars['Float']['output'];
  nextPaymentDate?: Maybe<Scalars['DateTime']['output']>;
  paymentStatus?: Maybe<OpportunityPaymentStatus>;
  probability: Scalars['Float']['output'];
  startDate?: Maybe<Scalars['DateTime']['output']>;
};

export type RecurringPaymentInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  memberSplits?: InputMaybe<Array<MemberSplitInput>>;
  monthlyAmount: Scalars['Float']['input'];
  probability?: InputMaybe<Scalars['Float']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type RedeemRewardTokenInput = {
  redeemedFor: Scalars['String']['input'];
  tokenId: Scalars['ID']['input'];
};

export type ReferenceAnswersInput = {
  answers?: InputMaybe<Array<KeyValueAnswerInput>>;
  notes?: InputMaybe<Scalars['String']['input']>;
  /** 1–5 */
  rating?: InputMaybe<Scalars['Int']['input']>;
};

export type ReferenceContact = {
  __typename?: 'ReferenceContact';
  email?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  relation?: Maybe<Scalars['String']['output']>;
};

export type Referral = {
  __typename?: 'Referral';
  acknowledgedAt?: Maybe<Scalars['DateTime']['output']>;
  acknowledgedBy?: Maybe<Scalars['ID']['output']>;
  acknowledgedByName?: Maybe<Scalars['String']['output']>;
  cancellationReason?: Maybe<Scalars['String']['output']>;
  cancelledAt?: Maybe<Scalars['DateTime']['output']>;
  cancelledBy?: Maybe<Scalars['ID']['output']>;
  cancelledByName?: Maybe<Scalars['String']['output']>;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  completedBy?: Maybe<Scalars['ID']['output']>;
  completedByName?: Maybe<Scalars['String']['output']>;
  completionNote?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['ID']['output'];
  createdByName?: Maybe<Scalars['String']['output']>;
  designation?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  note?: Maybe<Scalars['String']['output']>;
  referredTo: Scalars['ID']['output'];
  referredToName?: Maybe<Scalars['String']['output']>;
  residentId: Scalars['ID']['output'];
  residentName?: Maybe<Scalars['String']['output']>;
  sourceNoteId: Scalars['ID']['output'];
  status: ReferralStatus;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type ReferralAlertsResponse = {
  __typename?: 'ReferralAlertsResponse';
  pendingCount: Scalars['Int']['output'];
  pendingReferrals: Array<Referral>;
};

export type ReferralFilterInput = {
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  referredTo?: InputMaybe<Scalars['ID']['input']>;
  residentId?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<ReferralStatus>;
};

/** Status of a referral from a progress note */
export enum ReferralStatus {
  Acknowledged = 'ACKNOWLEDGED',
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Pending = 'PENDING'
}

export type ReferralsResponse = {
  __typename?: 'ReferralsResponse';
  limit: Scalars['Int']['output'];
  offset: Scalars['Int']['output'];
  referrals: Array<Referral>;
  total: Scalars['Int']['output'];
};

export type RefineBroadcastInput = {
  channel: Scalars['String']['input'];
  currentDraft: CurrentDraftInput;
  feedback: Scalars['String']['input'];
  goal: Scalars['String']['input'];
  invoiceLink?: InputMaybe<Scalars['String']['input']>;
  recipientNames?: InputMaybe<Array<Scalars['String']['input']>>;
  refineChannel: Scalars['String']['input'];
  scheduledAt?: InputMaybe<Scalars['String']['input']>;
  senderName?: InputMaybe<Scalars['String']['input']>;
  sourceContext?: InputMaybe<Scalars['String']['input']>;
};

export type RefineCandidateMessageInput = {
  draftId: Scalars['ID']['input'];
  feedback: Scalars['String']['input'];
  refineChannel: Scalars['String']['input'];
};

export type RefineEmailReplyInput = {
  currentBody: Scalars['String']['input'];
  currentSubject: Scalars['String']['input'];
  feedback: Scalars['String']['input'];
  inboundEmailId: Scalars['ID']['input'];
};

export type RefineGeneratedTaskInput = {
  description: Scalars['String']['input'];
  feedback: Scalars['String']['input'];
  priority: Scalars['String']['input'];
  subtasks: Array<RefineTaskSubtaskInput>;
  title: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type RefineSiteSpecInput = {
  currentSpec: Scalars['String']['input'];
  feedback: Scalars['String']['input'];
};

export type RefineTaskSubtaskInput = {
  order: Scalars['Int']['input'];
  title: Scalars['String']['input'];
};

export type RegisterDomainInput = {
  domain: Scalars['String']['input'];
};

export type RegisterForEventInput = {
  email: Scalars['String']['input'];
  eventId: Scalars['String']['input'];
  eventName: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  referredByClientId?: InputMaybe<Scalars['String']['input']>;
  referredByEmail?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<RegistrationSource>;
  utmCampaign?: InputMaybe<Scalars['String']['input']>;
  utmMedium?: InputMaybe<Scalars['String']['input']>;
  utmSource?: InputMaybe<Scalars['String']['input']>;
};

export type RegisterValidatorInput = {
  btcPublicKey?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  stakedAmount: Scalars['Float']['input'];
  walletAddress: Scalars['String']['input'];
};

export type RegisterWithVerifiedEmailInput = {
  code: Scalars['String']['input'];
  email: Scalars['String']['input'];
  fName: Scalars['String']['input'];
  lName: Scalars['String']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type RegisterWithVerifiedPhoneInput = {
  code: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  fName: Scalars['String']['input'];
  lName: Scalars['String']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
  phoneNumber: Scalars['String']['input'];
};

export type RegisteredDomain = {
  __typename?: 'RegisteredDomain';
  corsAllowed: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  domain: Scalars['String']['output'];
  emailSendingEnabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  verificationToken?: Maybe<Scalars['String']['output']>;
  verified: Scalars['Boolean']['output'];
};

/** Source of the registration */
export enum RegistrationSource {
  Admin = 'ADMIN',
  DirectLink = 'DIRECT_LINK',
  Import = 'IMPORT',
  InterestPage = 'INTEREST_PAGE',
  PersonalMessage = 'PERSONAL_MESSAGE',
  RegisterPage = 'REGISTER_PAGE'
}

/** Status of event registration */
export enum RegistrationStatus {
  Attended = 'ATTENDED',
  Cancelled = 'CANCELLED',
  Confirmed = 'CONFIRMED',
  NoShow = 'NO_SHOW',
  Registered = 'REGISTERED',
  Reminded = 'REMINDED'
}

/** Dunbar relationship layer: INNER(5), SUPPORT(15), COMMUNITY(50), NETWORK(150) */
export enum RelationshipLayer {
  Community = 'COMMUNITY',
  Inner = 'INNER',
  Network = 'NETWORK',
  Support = 'SUPPORT'
}

export type RelayHealthResult = {
  __typename?: 'RelayHealthResult';
  availableSites?: Maybe<Array<Scalars['String']['output']>>;
  error?: Maybe<Scalars['String']['output']>;
  healthy: Scalars['Boolean']['output'];
  status: Scalars['String']['output'];
};

export type RenamePasskeyInput = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export type ReorderActionsInput = {
  actionIds: Array<Scalars['ID']['input']>;
  goalId: Scalars['ID']['input'];
};

export type ReorderBankingMonthJobsInput = {
  ids: Array<Scalars['ID']['input']>;
  month: Scalars['String']['input'];
};

export type ReorderLeadFlowStagesInput = {
  stageIds: Array<Scalars['String']['input']>;
};

export type ReplaceEmployeeOnShiftInput = {
  departmentIds?: InputMaybe<Array<Scalars['String']['input']>>;
  notes?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  removeEmployeeId: Scalars['ID']['input'];
  replacementEmployeeId: Scalars['ID']['input'];
  roleId?: InputMaybe<Scalars['String']['input']>;
  shiftId: Scalars['ID']['input'];
};

export type ReplyToPayrollEnquiryInput = {
  body: Scalars['String']['input'];
  enquiryId: Scalars['ID']['input'];
  /** Payroll only: the status after this reply (default: Being looked at) */
  status?: InputMaybe<PayrollEnquiryStatus>;
};

export type ReportClub52IssueInput = {
  handNumber?: InputMaybe<Scalars['Int']['input']>;
  note: Scalars['String']['input'];
  reporterIdentity?: InputMaybe<Scalars['String']['input']>;
  reporterName?: InputMaybe<Scalars['String']['input']>;
  roomName: Scalars['String']['input'];
  seat?: InputMaybe<Scalars['Int']['input']>;
};

export type ReportCsvResult = {
  __typename?: 'ReportCsvResult';
  /** CSV body (RFC 4180) */
  csv: Scalars['String']['output'];
  filename: Scalars['String']['output'];
  headlineAmount?: Maybe<Scalars['Float']['output']>;
  rowCount: Scalars['Int']['output'];
};

export type ReportPdfResult = {
  __typename?: 'ReportPdfResult';
  employeeCount?: Maybe<Scalars['Int']['output']>;
  filename: Scalars['String']['output'];
  /** Headline number for this report (depends on type) */
  headlineAmount?: Maybe<Scalars['Float']['output']>;
  /** Base64-encoded PDF — decode + download via Blob on the FE */
  pdfBase64: Scalars['String']['output'];
  sizeBytes: Scalars['Int']['output'];
};

/** Position a resident was moved from or to on a repositioning chart */
export enum RepositionPosition {
  Back = 'BACK',
  LeftSide = 'LEFT_SIDE',
  RightSide = 'RIGHT_SIDE',
  Sitting = 'SITTING',
  Walking = 'WALKING'
}

export type RepositioningCheck = {
  __typename?: 'RepositioningCheck';
  /** The day that chart ended, if SarahCare closed it */
  chartEndDate?: Maybe<Scalars['DateTime']['output']>;
  /** The day the chart this turn belongs to started */
  chartStartDate?: Maybe<Scalars['DateTime']['output']>;
  /** When the resident was turned (SarahCare charted to the nearest quarter hour) */
  checkTime: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  /** The chart directive at the time (e.g. "2 hourly") */
  directive?: Maybe<Scalars['String']['output']>;
  /** Position moved from; null when the chart did not say */
  fromPosition?: Maybe<RepositionPosition>;
  id: Scalars['ID']['output'];
  isHistoricalRecord?: Maybe<Scalars['Boolean']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  recordedBy: Scalars['ID']['output'];
  recordedByName?: Maybe<Scalars['String']['output']>;
  residentId: Scalars['ID']['output'];
  residentName?: Maybe<Scalars['String']['output']>;
  residentRoom?: Maybe<Scalars['String']['output']>;
  residentWing?: Maybe<Scalars['String']['output']>;
  /** Skin condition seen, in the words of the chart list (e.g. "Red Area") */
  skinCondition?: Maybe<Scalars['String']['output']>;
  skinTemperature?: Maybe<Scalars['String']['output']>;
  sourceAuthor?: Maybe<Scalars['String']['output']>;
  sourceBackupDate?: Maybe<Scalars['DateTime']['output']>;
  sourceFields?: Maybe<Array<SleepChartSourceField>>;
  sourceId?: Maybe<Scalars['String']['output']>;
  sourceSystem?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  /** Position moved to; null when the chart did not say */
  toPosition?: Maybe<RepositionPosition>;
  updatedAt: Scalars['DateTime']['output'];
};

export type RepositioningCheckFilterInput = {
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  /** Page size, 1–1000 (default 50) */
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  residentId?: InputMaybe<Scalars['ID']['input']>;
  /** true = only SarahCare history */
  sarahHistory?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RepositioningChecksResponse = {
  __typename?: 'RepositioningChecksResponse';
  checks: Array<RepositioningCheck>;
  limit: Scalars['Int']['output'];
  offset: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type RequestArtSessionInput = {
  contactName: Scalars['String']['input'];
  email: Scalars['String']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  preferredAgeBands?: InputMaybe<Array<CompetitionAgeBand>>;
  preferredTimes?: InputMaybe<Scalars['String']['input']>;
  schoolName: Scalars['String']['input'];
  suburb?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type RequestEmailChangeInput = {
  clientId: Scalars['String']['input'];
  newEmail: Scalars['String']['input'];
};

export type RequestEmailLoginLinkInput = {
  email: Scalars['String']['input'];
  flow: Scalars['String']['input'];
  returnPath: Scalars['String']['input'];
};

export type RequestMapping = {
  __typename?: 'RequestMapping';
  bodyTemplate?: Maybe<Scalars['JSON']['output']>;
  headerMapping?: Maybe<Scalars['JSON']['output']>;
  queryMapping?: Maybe<Scalars['JSON']['output']>;
};

export type RequestMedicalRecordAccessInput = {
  needs: MedicalRecordAccessNeed;
  patientId: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type RequestPProposalEmailVerificationInput = {
  email: Scalars['String']['input'];
  proposalId: Scalars['String']['input'];
};

export type RequestPasswordResetInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type RequestPhoneChangeInput = {
  clientId: Scalars['String']['input'];
  newPhoneNumber: Scalars['String']['input'];
};

export type RequestProposalEmailVerificationInput = {
  email: Scalars['String']['input'];
  proposalId: Scalars['String']['input'];
};

export type RequestReferenceInput = {
  candidateId: Scalars['ID']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  method: CandidateReferenceMethod;
  name: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  relation?: InputMaybe<Scalars['String']['input']>;
};

export type RequestReferenceResult = {
  __typename?: 'RequestReferenceResult';
  emailSent: Scalars['Boolean']['output'];
  publicUrl: Scalars['String']['output'];
  reference: CandidateReference;
  warning?: Maybe<Scalars['String']['output']>;
};

export type RequestShiftSwapInput = {
  employeeBId: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  shiftAId: Scalars['String']['input'];
  shiftBId: Scalars['String']['input'];
};

export type RequestSmsLoginLinkInput = {
  phoneNumber: Scalars['String']['input'];
  returnPath: Scalars['String']['input'];
};

/** Who requested the maintenance */
export enum RequestedByType {
  Family = 'FAMILY',
  Other = 'OTHER',
  Resident = 'RESIDENT',
  Staff = 'STAFF',
  Visitor = 'VISITOR'
}

export type RequiredOpportunities = {
  __typename?: 'RequiredOpportunities';
  monthly: Scalars['Int']['output'];
  quarterly: Scalars['Int']['output'];
  yearly: Scalars['Int']['output'];
};

export type RescheduleClub52GameInput = {
  note?: InputMaybe<Scalars['String']['input']>;
  roomName: Scalars['String']['input'];
  scheduledEnd?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledStart: Scalars['DateTime']['input'];
};

export type ResearchBase = {
  __typename?: 'ResearchBase';
  basePath: Scalars['String']['output'];
  coverage: ResearchBaseCoverage;
  createdAt: Scalars['DateTime']['output'];
  customFsUrl?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  explorerUrl: Scalars['String']['output'];
  extractModel: Scalars['String']['output'];
  host: KnowledgeHost;
  id: Scalars['ID']['output'];
  knowledgeRoot: Scalars['String']['output'];
  lastBuiltAt?: Maybe<Scalars['DateTime']['output']>;
  lastCoverageAt?: Maybe<Scalars['DateTime']['output']>;
  lastError?: Maybe<Scalars['String']['output']>;
  lastRollupAt?: Maybe<Scalars['DateTime']['output']>;
  ownerId?: Maybe<Scalars['String']['output']>;
  proseModel: Scalars['String']['output'];
  rollupCount: Scalars['Int']['output'];
  sharedRootAcknowledged: Scalars['Boolean']['output'];
  slug: Scalars['String']['output'];
  staleFiles: Array<Scalars['String']['output']>;
  taxonomySeeded: Scalars['Boolean']['output'];
  tenantId: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  videosInRollup: Scalars['Int']['output'];
  videosTotal: Scalars['Int']['output'];
  videosTranscribed: Scalars['Int']['output'];
  videosWithPage: Scalars['Int']['output'];
  writerHost: KnowledgeHost;
};

export type ResearchBaseCoverage = {
  __typename?: 'ResearchBaseCoverage';
  rollupCount: Scalars['Int']['output'];
  sourceCount: Scalars['Int']['output'];
  videosInRollup: Scalars['Int']['output'];
  videosTotal: Scalars['Int']['output'];
  videosTranscribed: Scalars['Int']['output'];
  videosUncovered: Scalars['Int']['output'];
  videosWithPage: Scalars['Int']['output'];
};

export type ResetEmailTemplateInput = {
  kind: Scalars['String']['input'];
  stageKey: Scalars['String']['input'];
};

export type ResetPasswordInput = {
  newPassword: Scalars['String']['input'];
  resetToken: Scalars['String']['input'];
};

export type Resident = {
  __typename?: 'Resident';
  acfi?: Maybe<AcfiDetails>;
  activityLog?: Maybe<Array<ResidentActivityLog>>;
  admissionDate?: Maybe<Scalars['DateTime']['output']>;
  /** Where admitted from (e.g., home, hospital) */
  admittedFrom?: Maybe<Scalars['String']['output']>;
  /** Age in years */
  age?: Maybe<Scalars['Int']['output']>;
  allergies?: Maybe<Array<Scalars['String']['output']>>;
  ambulanceFundNumber?: Maybe<Scalars['String']['output']>;
  bedNumber?: Maybe<Scalars['String']['output']>;
  /** Behavior status for care planning */
  behaviorStatus?: Maybe<Scalars['String']['output']>;
  careType?: Maybe<CareType>;
  centrelinkNumber?: Maybe<Scalars['String']['output']>;
  /** Cognition level for care planning */
  cognitionLevel?: Maybe<Scalars['String']['output']>;
  /** Communication level for care planning */
  communicationLevel?: Maybe<Scalars['String']['output']>;
  /** Continence status for care planning */
  continenceStatus?: Maybe<Scalars['String']['output']>;
  /** Contract signed flag */
  contractSigned?: Maybe<Scalars['Boolean']['output']>;
  contractSignedDate?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<Scalars['ID']['output']>;
  culturalOrigin?: Maybe<Scalars['String']['output']>;
  /** Reference to active bond */
  currentBondId?: Maybe<Scalars['ID']['output']>;
  /** Will link to Care Plan module */
  currentCarePlanId?: Maybe<Scalars['ID']['output']>;
  dateOfBirth: Scalars['DateTime']['output'];
  diagnoses?: Maybe<Array<Scalars['String']['output']>>;
  /** Dietary requirements for meal planning */
  dietaryRequirements?: Maybe<Array<Scalars['String']['output']>>;
  discharge?: Maybe<DischargeInfo>;
  /** Display name (preferred or first) */
  displayName: Scalars['String']['output'];
  dva?: Maybe<DvaDetails>;
  email?: Maybe<Scalars['String']['output']>;
  entryType?: Maybe<EntryType>;
  /** External patient ID from a source system (e.g. SarahCare). Set on PII-free shell records imported by Digital Manager. */
  externalPatientId?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  /** Full name (first + last) */
  fullName: Scalars['String']['output'];
  gender: Gender;
  /** Has advanced health directive */
  hasHealthDirective?: Maybe<Scalars['Boolean']['output']>;
  hasPacemaker?: Maybe<Scalars['Boolean']['output']>;
  /** Reference to health directive document */
  healthDirectiveDocumentId?: Maybe<Scalars['ID']['output']>;
  healthFund?: Maybe<HealthFundDetails>;
  hospitalPreference?: Maybe<HospitalPreference>;
  id: Scalars['ID']['output'];
  interpreter?: Maybe<InterpreterDetails>;
  /** True if this Resident is a PII-free shell record. firstName/lastName/dateOfBirth/gender are placeholders; only externalPatientId + roomId are meaningful. */
  isShellRecord?: Maybe<Scalars['Boolean']['output']>;
  /** Primary language spoken */
  language?: Maybe<Scalars['String']['output']>;
  lastName: Scalars['String']['output'];
  /** Length of stay in days */
  lengthOfStay?: Maybe<Scalars['Int']['output']>;
  /** Linked Client ID for resident portal access */
  linkedClientId?: Maybe<Scalars['ID']['output']>;
  maritalStatus?: Maybe<MaritalStatus>;
  medicare?: Maybe<MedicareDetails>;
  middleName?: Maybe<Scalars['String']['output']>;
  /** Mobility level for care planning */
  mobilityLevel?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  /** Nutrition status for meal planning */
  nutritionStatus?: Maybe<Scalars['String']['output']>;
  /** Pain level for care planning */
  painLevel?: Maybe<Scalars['String']['output']>;
  /** Preferred payment method */
  paymentMethod?: Maybe<Scalars['String']['output']>;
  pension?: Maybe<PensionDetails>;
  pharmaceuticalSafetyNetNumber?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  /** The profile photo: an encrypted RESIDENT_PHOTO medical record of this resident (read it through residentPhotos) */
  photoRecordId?: Maybe<Scalars['ID']['output']>;
  /** Who set the profile photo: SARAHCARE (import) or STAFF (a person in PLCC; also when staff removed it) */
  photoSource?: Maybe<ResidentPhotoSource>;
  /** SarahCare ResID.ResIDID of the photo when photoSource = SARAHCARE (an id only) */
  photoSourceId?: Maybe<Scalars['String']['output']>;
  /**
   * LEGACY, no longer written. Use photoRecordId + the residentPhotos query.
   * @deprecated No longer written (2026-10-11). The photo is photoRecordId, read through residentPhotos.
   */
  photoUrl?: Maybe<Scalars['String']['output']>;
  preAdmissionDate?: Maybe<Scalars['DateTime']['output']>;
  preferredName?: Maybe<Scalars['String']['output']>;
  /** Address before admission */
  previousAddress?: Maybe<ResidentAddress>;
  /** Primary diagnoses for clinical modules */
  primaryDiagnoses?: Maybe<Array<Scalars['String']['output']>>;
  primaryDiagnosis?: Maybe<Scalars['String']['output']>;
  religion?: Maybe<Scalars['String']['output']>;
  /** Auto-incrementing resident number per tenant */
  residentNumber: Scalars['Int']['output'];
  /** Expected departure date (for respite) */
  respiteDueOutDate?: Maybe<Scalars['DateTime']['output']>;
  /** Reference to room/location */
  roomId?: Maybe<Scalars['ID']['output']>;
  roomNumber?: Maybe<Scalars['String']['output']>;
  /** SarahCare Customer Number (Customers.[Customer Number] / ResDocuments.CustID). Populated by the SarahCare sync so document + clinical migrations join on it directly instead of name+DOB. */
  sarahCareId?: Maybe<Scalars['String']['output']>;
  seniorCard?: Maybe<SeniorCardDetails>;
  /** Skin integrity status for wound management */
  skinIntegrity?: Maybe<Scalars['String']['output']>;
  /** Social status for care planning */
  socialStatus?: Maybe<Scalars['String']['output']>;
  /** Where each SarahCare-filled value came from (kept after confirmation as provenance). */
  sourceFieldPromotions?: Maybe<Array<ResidentSourceFieldPromotion>>;
  /** When SarahCare-filled values were last confirmed */
  sourceFieldsConfirmedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Who last confirmed SarahCare-filled values on this record */
  sourceFieldsConfirmedBy?: Maybe<Scalars['ID']['output']>;
  sourceFieldsConfirmedByName?: Maybe<Scalars['String']['output']>;
  status: ResidentStatus;
  tenantId: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
  treatingDoctor?: Maybe<TreatingDoctorDetails>;
  /** Field paths filled from a SarahCare snapshot that staff have not yet confirmed or edited. Each shows a "From SarahCare — please confirm" pill. */
  unconfirmedSourceFields?: Maybe<Array<Scalars['String']['output']>>;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy?: Maybe<Scalars['ID']['output']>;
  wing?: Maybe<Scalars['String']['output']>;
};

/** Types of actions logged for resident activity */
export enum ResidentActivityAction {
  Admitted = 'ADMITTED',
  BondPayment = 'BOND_PAYMENT',
  BondPayout = 'BOND_PAYOUT',
  ContactAdded = 'CONTACT_ADDED',
  ContactRemoved = 'CONTACT_REMOVED',
  ContactUpdated = 'CONTACT_UPDATED',
  Created = 'CREATED',
  Discharged = 'DISCHARGED',
  DocumentUploaded = 'DOCUMENT_UPLOADED',
  DocumentViewed = 'DOCUMENT_VIEWED',
  LeaveReturned = 'LEAVE_RETURNED',
  LeaveStarted = 'LEAVE_STARTED',
  NoteAdded = 'NOTE_ADDED',
  PhotoUpdated = 'PHOTO_UPDATED',
  RoomTransfer = 'ROOM_TRANSFER',
  StatusChange = 'STATUS_CHANGE',
  Updated = 'UPDATED'
}

export type ResidentActivityLog = {
  __typename?: 'ResidentActivityLog';
  action: ResidentActivityAction;
  /** JSON string of changed fields */
  changes?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  performedBy: Scalars['ID']['output'];
  performedByName?: Maybe<Scalars['String']['output']>;
  /** Reference to related document/meeting/etc */
  relatedEntityId?: Maybe<Scalars['ID']['output']>;
  relatedEntityType?: Maybe<Scalars['String']['output']>;
  timestamp: Scalars['DateTime']['output'];
};

export type ResidentAddress = {
  __typename?: 'ResidentAddress';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  suburb?: Maybe<Scalars['String']['output']>;
};

export type ResidentAddressInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  suburb?: InputMaybe<Scalars['String']['input']>;
};

export type ResidentAdmissionSourceSnapshot = {
  __typename?: 'ResidentAdmissionSourceSnapshot';
  admission?: Maybe<SarahCareAdmissionDetails>;
  createdAt: Scalars['DateTime']['output'];
  funding?: Maybe<SarahCareFundingDetails>;
  id: Scalars['ID']['output'];
  kind: SarahAdmissionSnapshotKind;
  residentId: Scalars['ID']['output'];
  separation?: Maybe<SarahCareSeparationDetails>;
  sourceAuthor: Scalars['String']['output'];
  sourceBackupDate: Scalars['DateTime']['output'];
  sourceId: Scalars['String']['output'];
  sourceSystem: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type ResidentAdmissionSourceSnapshotPage = {
  __typename?: 'ResidentAdmissionSourceSnapshotPage';
  records: Array<ResidentAdmissionSourceSnapshot>;
  total: Scalars['Int']['output'];
};

/** One at-a-glance daily care fact, already in plain words */
export type ResidentCareFact = {
  __typename?: 'ResidentCareFact';
  label: Scalars['String']['output'];
  /** Personal care / Mobility / Nutrition */
  section: Scalars['String']['output'];
  /** Null = not recorded */
  value?: Maybe<Scalars['String']['output']>;
};

export type ResidentCarePlanLine = {
  __typename?: 'ResidentCarePlanLine';
  canViewDetail: Scalars['Boolean']['output'];
  category: CarePlanCategory;
  /** Days past the review date (positive) or until it (negative), Brisbane days */
  daysOverdue?: Maybe<Scalars['Int']['output']>;
  detailUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastReviewDate?: Maybe<Scalars['DateTime']['output']>;
  /** Date-only (T00:00:00.000Z) */
  nextReviewDate?: Maybe<Scalars['DateTime']['output']>;
  planName: Scalars['String']['output'];
  reviewState: CarePlanReviewState;
  status: CarePlanStatus;
};

/** A resident's care plans and daily care profile, read from the care-plan module by resident id */
export type ResidentCareSummary = {
  __typename?: 'ResidentCareSummary';
  dailyCare: ResidentDailyCareLine;
  dueSoonCount: Scalars['Int']['output'];
  /** The "due soon" window used, in days */
  dueSoonDays: Scalars['Int']['output'];
  /** The legal requirements that govern care plans and their reviews */
  legalRequirements: Array<CareLegalRequirement>;
  /** Start a care plan for this resident — absent when the viewer may not */
  newPlanUrl?: Maybe<Scalars['String']['output']>;
  overdueCount: Scalars['Int']['output'];
  /** Plans not archived (no SarahCare history), soonest review first */
  plans: Array<ResidentCarePlanLine>;
  /** True when the viewer may not see care plans — `plans` is then empty, not "none" */
  plansHidden: Scalars['Boolean']['output'];
  /** All of this resident's plans — absent when the viewer may not */
  plansListUrl?: Maybe<Scalars['String']['output']>;
  residentId: Scalars['ID']['output'];
};

export type ResidentContact = {
  __typename?: 'ResidentContact';
  /** Best time to contact */
  bestTimeToContact?: Maybe<Scalars['String']['output']>;
  /** Can make decisions on behalf of resident */
  canMakeDecisions?: Maybe<Scalars['Boolean']['output']>;
  /** Can receive updates about resident */
  canReceiveUpdates?: Maybe<Scalars['Boolean']['output']>;
  /** Whether this contact can chat about this resident */
  chatEnabled: Scalars['Boolean']['output'];
  country?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<Scalars['ID']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  /** Order for emergency contacts (1 = first to call) */
  emergencyContactOrder?: Maybe<Scalars['Int']['output']>;
  firstName: Scalars['String']['output'];
  /** Full name */
  fullName: Scalars['String']['output'];
  /** Whether this contact has portal access to view resident data */
  hasPortalAccess: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  /** How they were invited: SMS or EMAIL */
  inviteMethod?: Maybe<Scalars['String']['output']>;
  /** When SMS/email invite was sent */
  inviteSentAt?: Maybe<Scalars['DateTime']['output']>;
  isActive: Scalars['Boolean']['output'];
  isEmergencyContact: Scalars['Boolean']['output'];
  isGuardian: Scalars['Boolean']['output'];
  isNextOfKin: Scalars['Boolean']['output'];
  isPrimaryContact: Scalars['Boolean']['output'];
  lastName: Scalars['String']['output'];
  /** Linked Client record for portal login */
  linkedClientId?: Maybe<Scalars['ID']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  /** Home phone */
  phoneHome?: Maybe<Scalars['String']['output']>;
  /** Mobile phone */
  phoneMobile?: Maybe<Scalars['String']['output']>;
  /** Work phone */
  phoneWork?: Maybe<Scalars['String']['output']>;
  /** Portal permission level: REPRESENTATIVE or FAMILY_VIEW */
  portalPermissionLevel?: Maybe<Scalars['String']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  powerOfAttorney?: Maybe<PowerOfAttorneyDetails>;
  /** Preferred contact method */
  preferredContactMethod?: Maybe<Scalars['String']['output']>;
  /** Best phone number to call */
  primaryPhone?: Maybe<Scalars['String']['output']>;
  relationship: ContactRelationship;
  /** If relationship is OTHER, specify here */
  relationshipOther?: Maybe<Scalars['String']['output']>;
  residentId: Scalars['ID']['output'];
  state?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  suburb?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy?: Maybe<Scalars['ID']['output']>;
};

export type ResidentContactCallHistory = {
  __typename?: 'ResidentContactCallHistory';
  contactHistoryId: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  details: SarahCareContactCallDetails;
  id: Scalars['ID']['output'];
  residentId: Scalars['ID']['output'];
  sourceAuthor: Scalars['String']['output'];
  sourceBackupDate: Scalars['DateTime']['output'];
  sourceId: Scalars['String']['output'];
  sourceSystem: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type ResidentContactCallHistoryPage = {
  __typename?: 'ResidentContactCallHistoryPage';
  records: Array<ResidentContactCallHistory>;
  total: Scalars['Int']['output'];
};

export type ResidentContactHistory = {
  __typename?: 'ResidentContactHistory';
  createdAt: Scalars['DateTime']['output'];
  details: SarahCareContactDetails;
  id: Scalars['ID']['output'];
  /** How the link was made */
  linkMethod?: Maybe<SarahContactLinkMethod>;
  linkedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Real contact this SarahCare row was matched or added to */
  linkedContactId?: Maybe<Scalars['ID']['output']>;
  residentId: Scalars['ID']['output'];
  sourceAuthor: Scalars['String']['output'];
  sourceBackupDate: Scalars['DateTime']['output'];
  sourceId: Scalars['String']['output'];
  sourceSystem: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type ResidentContactHistoryPage = {
  __typename?: 'ResidentContactHistoryPage';
  records: Array<ResidentContactHistory>;
  total: Scalars['Int']['output'];
};

export type ResidentCountsByStatus = {
  __typename?: 'ResidentCountsByStatus';
  current: Scalars['Int']['output'];
  deceased: Scalars['Int']['output'];
  past: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  waiting: Scalars['Int']['output'];
};

export type ResidentDailyCareLine = {
  __typename?: 'ResidentDailyCareLine';
  canViewDetail: Scalars['Boolean']['output'];
  /** The daily care profile page, or creating one — absent when the viewer may not */
  detailUrl?: Maybe<Scalars['String']['output']>;
  exists: Scalars['Boolean']['output'];
  /** Bathing, mobility, falls risk, diet, help with eating — empty when the viewer may not open the profile */
  facts: Array<ResidentCareFact>;
  lastUpdatedByName?: Maybe<Scalars['String']['output']>;
  profileType?: Maybe<ProfileType>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ResidentFilterInput = {
  /** Filter by care level (LOW / HIGH / DEMENTIA / PALLIATIVE) */
  careType?: InputMaybe<CareType>;
  /** Filter by entry type (PERMANENT / RESPITE) */
  entryType?: InputMaybe<EntryType>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  roomNumber?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  /** Sort field */
  sortBy?: InputMaybe<Scalars['String']['input']>;
  /** Sort direction: asc or desc */
  sortDirection?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<ResidentStatus>>;
  /** Filter for residents without a room assignment */
  unassigned?: InputMaybe<Scalars['Boolean']['input']>;
  wing?: InputMaybe<Scalars['String']['input']>;
};

export type ResidentLeave = {
  __typename?: 'ResidentLeave';
  /** Leave code for ACFI reporting */
  acfiLeaveCode?: Maybe<Scalars['String']['output']>;
  acfiSubmissionDate?: Maybe<Scalars['DateTime']['output']>;
  /** Has leave event been submitted to ACFI */
  acfiSubmitted?: Maybe<Scalars['Boolean']['output']>;
  actualReturnDate?: Maybe<Scalars['DateTime']['output']>;
  /** Items returned with resident */
  belongingsReturned?: Maybe<Scalars['String']['output']>;
  /** Items taken with resident */
  belongingsTaken?: Maybe<Scalars['String']['output']>;
  /** Were family/contacts notified */
  contactsNotified?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<Scalars['ID']['output']>;
  /** Days on leave */
  daysOnLeave?: Maybe<Scalars['Int']['output']>;
  departureDate: Scalars['DateTime']['output'];
  /** Time of departure */
  departureTime?: Maybe<Scalars['String']['output']>;
  /** Hospital name, family address, etc. */
  destination?: Maybe<Scalars['String']['output']>;
  /** Contact person at destination */
  destinationContact?: Maybe<Scalars['String']['output']>;
  /** Contact phone at destination */
  destinationPhone?: Maybe<Scalars['String']['output']>;
  expectedReturnDate?: Maybe<Scalars['DateTime']['output']>;
  /** Reason for extension */
  extensionReason?: Maybe<Scalars['String']['output']>;
  /** Hospital bed number */
  hospitalBed?: Maybe<Scalars['String']['output']>;
  /** Diagnosis/reason for hospitalization */
  hospitalDiagnosis?: Maybe<Scalars['String']['output']>;
  /** Treating doctor at hospital */
  hospitalDoctor?: Maybe<Scalars['String']['output']>;
  /** Hospital ward */
  hospitalWard?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Is currently on leave */
  isCurrentlyOnLeave: Scalars['Boolean']['output'];
  /** Is overdue to return */
  isOverdue?: Maybe<Scalars['Boolean']['output']>;
  leaveType: LeaveType;
  notes?: Maybe<Scalars['String']['output']>;
  notificationDate?: Maybe<Scalars['DateTime']['output']>;
  /** Who was notified */
  notifiedPersons?: Maybe<Scalars['String']['output']>;
  /** Original expected return date (if extended) */
  originalExpectedReturnDate?: Maybe<Scalars['DateTime']['output']>;
  /** Reason for leave */
  reason?: Maybe<Scalars['String']['output']>;
  /** Staff who recorded departure */
  recordedDepartureBy?: Maybe<Scalars['ID']['output']>;
  /** Staff who recorded return */
  recordedReturnBy?: Maybe<Scalars['ID']['output']>;
  residentId: Scalars['ID']['output'];
  /** Notes on return */
  returnNotes?: Maybe<Scalars['String']['output']>;
  /** Time of return */
  returnTime?: Maybe<Scalars['String']['output']>;
  sourceAuthor?: Maybe<Scalars['String']['output']>;
  sourceBackupDate?: Maybe<Scalars['DateTime']['output']>;
  sourceHash?: Maybe<Scalars['String']['output']>;
  sourceId?: Maybe<Scalars['String']['output']>;
  sourceSystem?: Maybe<Scalars['String']['output']>;
  status: LeaveStatus;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy?: Maybe<Scalars['ID']['output']>;
  /** Was leave extended */
  wasExtended?: Maybe<Scalars['Boolean']['output']>;
};

export type ResidentLeaveList = {
  __typename?: 'ResidentLeaveList';
  leaves: Array<ResidentLeave>;
  total: Scalars['Int']['output'];
};

export type ResidentOccupancyInput = {
  companyId: Scalars['ID']['input'];
  dailyPriceCents?: InputMaybe<Scalars['Int']['input']>;
  entryFeeCents?: InputMaybe<Scalars['Int']['input']>;
  fromDay: Scalars['String']['input'];
  toDay: Scalars['String']['input'];
};

export type ResidentOccupancyReport = {
  __typename?: 'ResidentOccupancyReport';
  billableDaysTotal: Scalars['Int']['output'];
  csv: Scalars['String']['output'];
  dailyPriceCents: Scalars['Int']['output'];
  entryFeeCents: Scalars['Int']['output'];
  entryFeeCount: Scalars['Int']['output'];
  estimateTotalCents: Scalars['Float']['output'];
  fromDay: Scalars['String']['output'];
  periodDays: Scalars['Int']['output'];
  residentCount: Scalars['Int']['output'];
  rows: Array<ResidentOccupancyRow>;
  rules: Array<Scalars['String']['output']>;
  toDay: Scalars['String']['output'];
};

export type ResidentOccupancyRow = {
  __typename?: 'ResidentOccupancyRow';
  admittedDay?: Maybe<Scalars['String']['output']>;
  billableDays: Scalars['Int']['output'];
  dailyPriceCents: Scalars['Int']['output'];
  departedDay?: Maybe<Scalars['String']['output']>;
  entryFeeApplies: Scalars['Boolean']['output'];
  entryType?: Maybe<Scalars['String']['output']>;
  estimateCents: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  note?: Maybe<Scalars['String']['output']>;
  residentId: Scalars['ID']['output'];
  residentNumber?: Maybe<Scalars['Int']['output']>;
  room?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  wing?: Maybe<Scalars['String']['output']>;
};

export type ResidentPhoto = {
  __typename?: 'ResidentPhoto';
  /** data:<mime>;base64,… — only when status is READY. Never cached by URL; never a link. */
  dataUrl?: Maybe<Scalars['String']['output']>;
  mimeType?: Maybe<Scalars['String']['output']>;
  /** The RESIDENT_PHOTO medical record the image came from */
  photoRecordId?: Maybe<Scalars['ID']['output']>;
  residentId: Scalars['ID']['output'];
  status: ResidentPhotoStatus;
};

/** SARAHCARE = profile photo pointer set by the SarahCare import; STAFF = set or removed by a person in PLCC (never overwritten by an import) */
export enum ResidentPhotoSource {
  Sarahcare = 'SARAHCARE',
  Staff = 'STAFF'
}

/** READY = image included; NO_PHOTO = none recorded; OFF_SHIFT = the site shows medical files only during a shift; TOO_LARGE = too big for an avatar (open it in Medical Records); UNAVAILABLE = the photo record is missing or could not be read */
export enum ResidentPhotoStatus {
  NoPhoto = 'NO_PHOTO',
  OffShift = 'OFF_SHIFT',
  Ready = 'READY',
  TooLarge = 'TOO_LARGE',
  Unavailable = 'UNAVAILABLE'
}

export type ResidentRespiteDays = {
  __typename?: 'ResidentRespiteDays';
  fundedDays: Scalars['Int']['output'];
  residentId: Scalars['ID']['output'];
  residentName: Scalars['String']['output'];
  totalDays: Scalars['Int']['output'];
  unfundedDays: Scalars['Int']['output'];
};

/** A resident's standing on one review cycle */
export type ResidentReviewCycleItem = {
  __typename?: 'ResidentReviewCycleItem';
  /** Days overdue (positive) or days left (negative) */
  daysOverdue?: Maybe<Scalars['Int']['output']>;
  dueDate?: Maybe<Scalars['DateTime']['output']>;
  /** Link to that incident; empty when the viewer may not open incidents */
  incidentDetailUrl?: Maybe<Scalars['String']['output']>;
  /** The fall incident behind the first waiting change review, when it is one */
  incidentId?: Maybe<Scalars['String']['output']>;
  /** That incident's number on this site */
  incidentNumber?: Maybe<Scalars['Int']['output']>;
  key: ReviewCycleKey;
  label: Scalars['String']['output'];
  /** When this cycle was last done, if ever */
  lastDoneDate?: Maybe<Scalars['DateTime']['output']>;
  /** Plain words: why this state */
  reason: Scalars['String']['output'];
  state: ReviewCycleState;
};

/** One resident's standing on every review cycle */
export type ResidentReviewCycles = {
  __typename?: 'ResidentReviewCycles';
  admissionDate?: Maybe<Scalars['DateTime']['output']>;
  items: Array<ResidentReviewCycleItem>;
  residentId: Scalars['String']['output'];
  residentName: Scalars['String']['output'];
  roomNumber?: Maybe<Scalars['String']['output']>;
  /** The worst state across the cycles */
  worstState: ReviewCycleState;
};

export type ResidentRiskAssessment = {
  __typename?: 'ResidentRiskAssessment';
  assessedBy: Scalars['ID']['output'];
  assessedByName?: Maybe<Scalars['String']['output']>;
  assessmentDate: Scalars['DateTime']['output'];
  autoProgressNote: Scalars['Boolean']['output'];
  choiceWithRisk?: Maybe<RiskChoice>;
  /** Plain words and the named contacts for the choice with risk */
  choiceWithRiskSummary?: Maybe<RiskChoiceSummary>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  mitigationStrategies: Array<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  progressNoteId?: Maybe<Scalars['ID']['output']>;
  residentId: Scalars['ID']['output'];
  residentName?: Maybe<Scalars['String']['output']>;
  residentRoom?: Maybe<Scalars['String']['output']>;
  residentWing?: Maybe<Scalars['String']['output']>;
  reviewDate?: Maybe<Scalars['DateTime']['output']>;
  riskFactors: Array<Scalars['String']['output']>;
  riskLevel: ResidentRiskLevel;
  riskType: ResidentRiskType;
  sourceAuthor?: Maybe<Scalars['String']['output']>;
  sourceBackupDate?: Maybe<Scalars['DateTime']['output']>;
  sourceFields?: Maybe<Array<RiskAssessmentSourceField>>;
  sourceId?: Maybe<Scalars['String']['output']>;
  sourceSystem?: Maybe<Scalars['String']['output']>;
  status: ResidentRiskStatus;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type ResidentRiskAssessmentFilterInput = {
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  residentId?: InputMaybe<Scalars['ID']['input']>;
  riskLevel?: InputMaybe<ResidentRiskLevel>;
  riskType?: InputMaybe<ResidentRiskType>;
  status?: InputMaybe<ResidentRiskStatus>;
  wing?: InputMaybe<Scalars['String']['input']>;
};

export type ResidentRiskAssessmentsResponse = {
  __typename?: 'ResidentRiskAssessmentsResponse';
  assessments: Array<ResidentRiskAssessment>;
  limit: Scalars['Int']['output'];
  offset: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

/** Severity level of the assessed risk */
export enum ResidentRiskLevel {
  High = 'HIGH',
  Low = 'LOW',
  Moderate = 'MODERATE',
  VeryHigh = 'VERY_HIGH'
}

/** Current status of the risk assessment */
export enum ResidentRiskStatus {
  Active = 'ACTIVE',
  Historical = 'HISTORICAL',
  Mitigated = 'MITIGATED',
  Monitoring = 'MONITORING',
  Resolved = 'RESOLVED'
}

/** Type of clinical risk being assessed for a resident */
export enum ResidentRiskType {
  Choking = 'CHOKING',
  Falls = 'FALLS',
  Nutrition = 'NUTRITION',
  PressureInjury = 'PRESSURE_INJURY',
  SkinIntegrity = 'SKIN_INTEGRITY',
  Wandering = 'WANDERING'
}

export type ResidentSourceFieldPromotion = {
  __typename?: 'ResidentSourceFieldPromotion';
  /** Dotted field path on the resident, e.g. treatingDoctor.name */
  path: Scalars['String']['output'];
  promotedAt: Scalars['DateTime']['output'];
  /** Date of the SarahCare backup the value was read from */
  sourceBackupDate: Scalars['DateTime']['output'];
  /** Original SarahCare row id the value came from */
  sourceId: Scalars['String']['output'];
  /** Original SarahCare table the value came from */
  sourceTable: Scalars['String']['output'];
};

/** Status of a resident in the facility */
export enum ResidentStatus {
  Current = 'CURRENT',
  Deceased = 'DECEASED',
  Past = 'PAST',
  Waiting = 'WAITING'
}

export type ResidentsResponse = {
  __typename?: 'ResidentsResponse';
  limit: Scalars['Int']['output'];
  offset: Scalars['Int']['output'];
  residents: Array<Resident>;
  total: Scalars['Int']['output'];
};

export type ResolveCiIssueReportInput = {
  resolutionDetails: Scalars['String']['input'];
};

export type ResolveDuplicateInput = {
  aliasSlug: Scalars['String']['input'];
  baseId: Scalars['ID']['input'];
  canonicalSlug: Scalars['String']['input'];
  kind: Scalars['String']['input'];
  same: Scalars['Boolean']['input'];
};

export type ResolveFeedbackInput = {
  feedbackId: Scalars['ID']['input'];
  response: Scalars['String']['input'];
  sendToSubmitter?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ResolvedCareTargetDay = {
  __typename?: 'ResolvedCareTargetDay';
  dayKey: Scalars['String']['output'];
  rnMinutesPerResident: Scalars['Float']['output'];
  source: Scalars['String']['output'];
  sourceLabel: Scalars['String']['output'];
  totalMinutesPerResident: Scalars['Float']['output'];
};

/** Resolved section headings with defaults applied */
export type ResolvedDailyCareHeadings = {
  __typename?: 'ResolvedDailyCareHeadings';
  behavior: Scalars['String']['output'];
  careImplemented: Scalars['String']['output'];
  careNeeds: Scalars['String']['output'];
  communication: Scalars['String']['output'];
  delegateTo: Scalars['String']['output'];
  elimination: Scalars['String']['output'];
  hygiene: Scalars['String']['output'];
  leisure: Scalars['String']['output'];
  mobility: Scalars['String']['output'];
  nutrition: Scalars['String']['output'];
  pain: Scalars['String']['output'];
  physioTherapy: Scalars['String']['output'];
  pressureCare: Scalars['String']['output'];
  restraint: Scalars['String']['output'];
  skinIntegrity: Scalars['String']['output'];
  sleep: Scalars['String']['output'];
  special: Scalars['String']['output'];
  supportingEvidence: Scalars['String']['output'];
};

export type RespirationFilterInput = {
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  residentId?: InputMaybe<Scalars['ID']['input']>;
  wing?: InputMaybe<Scalars['String']['input']>;
};

export type RespirationObservation = {
  __typename?: 'RespirationObservation';
  autoProgressNote: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  progressNoteId?: Maybe<Scalars['ID']['output']>;
  residentId: Scalars['ID']['output'];
  residentName?: Maybe<Scalars['String']['output']>;
  residentRoom?: Maybe<Scalars['String']['output']>;
  residentWing?: Maybe<Scalars['String']['output']>;
  respirationsPerMinute: Scalars['Int']['output'];
  sourceAuthor?: Maybe<Scalars['String']['output']>;
  sourceBackupDate?: Maybe<Scalars['DateTime']['output']>;
  sourceHash?: Maybe<Scalars['String']['output']>;
  sourceId?: Maybe<Scalars['String']['output']>;
  sourceSystem?: Maybe<Scalars['String']['output']>;
  takenAt: Scalars['DateTime']['output'];
  takenBy: Scalars['ID']['output'];
  takenByName?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type RespirationObservationsResponse = {
  __typename?: 'RespirationObservationsResponse';
  limit: Scalars['Int']['output'];
  observations: Array<RespirationObservation>;
  offset: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type RespiteBooking = {
  __typename?: 'RespiteBooking';
  actualCheckInDate?: Maybe<Scalars['DateTime']['output']>;
  actualCheckOutDate?: Maybe<Scalars['DateTime']['output']>;
  /** Number of bed days for this booking */
  bedDays: Scalars['Int']['output'];
  calculation?: Maybe<RespiteCalculation>;
  /** Reason for cancellation (if cancelled) */
  cancellationReason?: Maybe<Scalars['String']['output']>;
  /** Staff who checked in the resident */
  checkedInBy?: Maybe<Scalars['ID']['output']>;
  /** Staff who checked out the resident */
  checkedOutBy?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<Scalars['ID']['output']>;
  /** Daily fee charged */
  dailyFee?: Maybe<Scalars['Float']['output']>;
  deposit?: Maybe<RespiteDeposit>;
  /** Duration in days */
  duration: Scalars['Int']['output'];
  endDate: Scalars['DateTime']['output'];
  /** Financial year (e.g., 2025-26) */
  financialYear?: Maybe<Scalars['String']['output']>;
  /** Funded bed days used */
  fundedDaysUsed?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  /** Is currently in progress */
  isActive: Scalars['Boolean']['output'];
  /** Is this respite funded by government */
  isFunded: Scalars['Boolean']['output'];
  /** Is in the future */
  isFuture: Scalars['Boolean']['output'];
  /** Has payment been received */
  isPaid?: Maybe<Scalars['Boolean']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  paidDate?: Maybe<Scalars['DateTime']['output']>;
  paymentReceiptNumber?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  /** Reference to resident (if in system) */
  residentId?: Maybe<Scalars['ID']['output']>;
  /** Resident name (for quick reference) */
  residentName: Scalars['String']['output'];
  /** Reference to room */
  roomId?: Maybe<Scalars['ID']['output']>;
  roomNumber: Scalars['String']['output'];
  startDate: Scalars['DateTime']['output'];
  status: RespiteBookingStatus;
  /** When status was last changed */
  statusChangedDate?: Maybe<Scalars['DateTime']['output']>;
  tenantId: Scalars['String']['output'];
  /** Total amount charged */
  totalAmount?: Maybe<Scalars['Float']['output']>;
  /** Unfunded (private) bed days */
  unfundedDays?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy?: Maybe<Scalars['ID']['output']>;
  wing?: Maybe<Scalars['String']['output']>;
};

/** Status of a respite booking */
export enum RespiteBookingStatus {
  Cancelled = 'CANCELLED',
  Confirmed = 'CONFIRMED',
  NoShow = 'NO_SHOW',
  Pending = 'PENDING',
  Used = 'USED'
}

export type RespiteCalculation = {
  __typename?: 'RespiteCalculation';
  calculationDate?: Maybe<Scalars['DateTime']['output']>;
  calculationId?: Maybe<Scalars['String']['output']>;
  dailyFee: Scalars['Float']['output'];
  lessDeposit?: Maybe<Scalars['Float']['output']>;
  otherCharges?: Maybe<Scalars['Float']['output']>;
  respiteAmount: Scalars['Float']['output'];
  subTotal: Scalars['Float']['output'];
  telephoneAdvance?: Maybe<Scalars['Float']['output']>;
  totalDays: Scalars['Int']['output'];
  totalPayable: Scalars['Float']['output'];
};

export type RespiteCalculationResult = {
  __typename?: 'RespiteCalculationResult';
  dailyFee: Scalars['Float']['output'];
  lessDeposit?: Maybe<Scalars['Float']['output']>;
  otherCharges?: Maybe<Scalars['Float']['output']>;
  respiteAmount: Scalars['Float']['output'];
  subTotal: Scalars['Float']['output'];
  telephoneAdvance?: Maybe<Scalars['Float']['output']>;
  totalDays: Scalars['Int']['output'];
  totalPayable: Scalars['Float']['output'];
};

export type RespiteCalendar = {
  __typename?: 'RespiteCalendar';
  days: Array<RespiteCalendarDay>;
  endDate: Scalars['DateTime']['output'];
  startDate: Scalars['DateTime']['output'];
};

export type RespiteCalendarDay = {
  __typename?: 'RespiteCalendarDay';
  bookings: Array<RespiteBooking>;
  date: Scalars['DateTime']['output'];
  totalBooked: Scalars['Int']['output'];
};

export type RespiteCareBooking = {
  __typename?: 'RespiteCareBooking';
  actualCheckInDate?: Maybe<Scalars['DateTime']['output']>;
  actualCheckOutDate?: Maybe<Scalars['DateTime']['output']>;
  bedNumber?: Maybe<Scalars['String']['output']>;
  bookedBy: Scalars['ID']['output'];
  bookedByName?: Maybe<Scalars['String']['output']>;
  bookingType: RespiteCareBookingType;
  clientDateOfBirth?: Maybe<Scalars['DateTime']['output']>;
  clientEmail?: Maybe<Scalars['String']['output']>;
  clientName: Scalars['String']['output'];
  clientPhone?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  dailyRate?: Maybe<Scalars['Float']['output']>;
  dietaryNeeds?: Maybe<Scalars['String']['output']>;
  emergencyContactName?: Maybe<Scalars['String']['output']>;
  emergencyContactPhone?: Maybe<Scalars['String']['output']>;
  emergencyContactRelation?: Maybe<Scalars['String']['output']>;
  endDate: Scalars['DateTime']['output'];
  /** SarahCare's funding words for the stay, exactly as recorded (history only) */
  fundingNote?: Maybe<Scalars['String']['output']>;
  fundingSource: RespiteFundingSource;
  gpName?: Maybe<Scalars['String']['output']>;
  gpPhone?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** True for SarahCare history: read-only, never current work */
  isHistoricalRecord?: Maybe<Scalars['Boolean']['output']>;
  medicationNotes?: Maybe<Scalars['String']['output']>;
  mobilityNotes?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  residentId?: Maybe<Scalars['ID']['output']>;
  /** Resident snapshot at import (history only) */
  residentName?: Maybe<Scalars['String']['output']>;
  residentRoom?: Maybe<Scalars['String']['output']>;
  residentWing?: Maybe<Scalars['String']['output']>;
  roomNumber?: Maybe<Scalars['String']['output']>;
  sourceAuthor?: Maybe<Scalars['String']['output']>;
  sourceBackupDate?: Maybe<Scalars['DateTime']['output']>;
  /** Original SarahCare columns (provenance only) */
  sourceFields?: Maybe<Array<RespiteCareSourceField>>;
  sourceId?: Maybe<Scalars['String']['output']>;
  /** SARAHCARE for imported history; null for bookings made here */
  sourceSystem?: Maybe<Scalars['String']['output']>;
  specialRequirements?: Maybe<Scalars['String']['output']>;
  startDate: Scalars['DateTime']['output'];
  status: RespiteCareBookingStatus;
  tenantId: Scalars['String']['output'];
  totalEstimatedCost?: Maybe<Scalars['Float']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  wing?: Maybe<Scalars['String']['output']>;
};

export type RespiteCareBookingFilterInput = {
  bookingType?: InputMaybe<RespiteCareBookingType>;
  clientName?: InputMaybe<Scalars['String']['input']>;
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  fundingSource?: InputMaybe<RespiteFundingSource>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<RespiteCareBookingStatus>;
  wing?: InputMaybe<Scalars['String']['input']>;
};

/** Status of a respite care booking (standalone module) */
export enum RespiteCareBookingStatus {
  Cancelled = 'CANCELLED',
  CheckedIn = 'CHECKED_IN',
  CheckedOut = 'CHECKED_OUT',
  Confirmed = 'CONFIRMED',
  Enquiry = 'ENQUIRY'
}

/** Type of respite care booking (standalone module) */
export enum RespiteCareBookingType {
  Emergency = 'EMERGENCY',
  NotRecorded = 'NOT_RECORDED',
  Planned = 'PLANNED',
  Transitional = 'TRANSITIONAL'
}

export type RespiteCareBookingsResponse = {
  __typename?: 'RespiteCareBookingsResponse';
  bookings: Array<RespiteCareBooking>;
  limit: Scalars['Int']['output'];
  offset: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type RespiteCareSourceField = {
  __typename?: 'RespiteCareSourceField';
  /** SarahCare table and column, e.g. `ResAccomHistory.EntryDate` */
  column: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type RespiteDaysSummary = {
  __typename?: 'RespiteDaysSummary';
  byResident?: Maybe<Array<ResidentRespiteDays>>;
  financialYear: Scalars['String']['output'];
  totalDays: Scalars['Int']['output'];
  totalFundedDays: Scalars['Int']['output'];
  totalUnfundedDays: Scalars['Int']['output'];
};

export type RespiteDeposit = {
  __typename?: 'RespiteDeposit';
  amount: Scalars['Float']['output'];
  dateReceived: Scalars['DateTime']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  paymentMethod?: Maybe<Scalars['String']['output']>;
  receiptNumber?: Maybe<Scalars['String']['output']>;
};

/** Funding source for respite care */
export enum RespiteFundingSource {
  Dva = 'DVA',
  GovernmentFunded = 'GOVERNMENT_FUNDED',
  Mixed = 'MIXED',
  NotRecorded = 'NOT_RECORDED',
  Other = 'OTHER',
  Private = 'PRIVATE'
}

export type RespiteStayHistoryFilterInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  residentId?: InputMaybe<Scalars['ID']['input']>;
};

export type ResponseMapping = {
  __typename?: 'ResponseMapping';
  errorPath?: Maybe<Scalars['String']['output']>;
  successPath?: Maybe<Scalars['String']['output']>;
};

/** Staff role responsible for intervention */
export enum ResponsibleRole {
  Ain = 'AIN',
  AlliedHealth = 'ALLIED_HEALTH',
  Any = 'ANY',
  Dietitian = 'DIETITIAN',
  En = 'EN',
  Lifestyle = 'LIFESTYLE',
  Ot = 'OT',
  Pca = 'PCA',
  Physio = 'PHYSIO',
  Rn = 'RN',
  Speech = 'SPEECH'
}

export type RestraintCheck = {
  __typename?: 'RestraintCheck';
  checkTime: Scalars['DateTime']['output'];
  checkedBy: Scalars['ID']['output'];
  checkedByName?: Maybe<Scalars['String']['output']>;
  circulationOk?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['DateTime']['output'];
  fluidOffered?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  outcome: RestraintCheckOutcome;
  releaseOffered?: Maybe<Scalars['Boolean']['output']>;
  repositioned?: Maybe<Scalars['Boolean']['output']>;
  residentId: Scalars['ID']['output'];
  residentName?: Maybe<Scalars['String']['output']>;
  residentRoom?: Maybe<Scalars['String']['output']>;
  residentWing?: Maybe<Scalars['String']['output']>;
  restraintRecordId: Scalars['ID']['output'];
  skinCondition?: Maybe<Scalars['String']['output']>;
  sourceAuthor?: Maybe<Scalars['String']['output']>;
  sourceBackupDate?: Maybe<Scalars['DateTime']['output']>;
  sourceFields?: Maybe<SarahRestraintCheckSourceFields>;
  sourceHash?: Maybe<Scalars['String']['output']>;
  sourceId?: Maybe<Scalars['String']['output']>;
  sourceSystem?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  toiletingOffered?: Maybe<Scalars['Boolean']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type RestraintCheckFilterInput = {
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  residentId?: InputMaybe<Scalars['ID']['input']>;
  restraintRecordId?: InputMaybe<Scalars['ID']['input']>;
  sourceSystem?: InputMaybe<Scalars['String']['input']>;
};

/** Outcome observed during a restraint monitoring check */
export enum RestraintCheckOutcome {
  Absent = 'ABSENT',
  Agitated = 'AGITATED',
  Calm = 'CALM',
  CheckedOk = 'CHECKED_OK',
  Distressed = 'DISTRESSED',
  Released = 'RELEASED',
  Repositioned = 'REPOSITIONED',
  Sleeping = 'SLEEPING',
  Toileted = 'TOILETED'
}

export type RestraintChecksResponse = {
  __typename?: 'RestraintChecksResponse';
  checks: Array<RestraintCheck>;
  limit: Scalars['Int']['output'];
  offset: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

/** Consent status for the restraint order */
export enum RestraintConsentStatus {
  Emergency = 'EMERGENCY',
  GuardianConsented = 'GUARDIAN_CONSENTED',
  NotRecorded = 'NOT_RECORDED',
  Obtained = 'OBTAINED',
  Refused = 'REFUSED',
  UnableToConsent = 'UNABLE_TO_CONSENT'
}

/** Reason for applying the restraint */
export enum RestraintReason {
  AggressionManagement = 'AGGRESSION_MANAGEMENT',
  FallPrevention = 'FALL_PREVENTION',
  MedicalTreatment = 'MEDICAL_TREATMENT',
  NotRecorded = 'NOT_RECORDED',
  Other = 'OTHER',
  SelfHarmPrevention = 'SELF_HARM_PREVENTION',
  WanderingPrevention = 'WANDERING_PREVENTION'
}

export type RestraintRecord = {
  __typename?: 'RestraintRecord';
  authorisedBy?: Maybe<Scalars['ID']['output']>;
  authorisedByName?: Maybe<Scalars['String']['output']>;
  consentDate?: Maybe<Scalars['DateTime']['output']>;
  consentStatus: RestraintConsentStatus;
  consentedBy?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  reason: RestraintReason;
  residentId: Scalars['ID']['output'];
  residentName?: Maybe<Scalars['String']['output']>;
  residentRoom?: Maybe<Scalars['String']['output']>;
  residentWing?: Maybe<Scalars['String']['output']>;
  restraintType: RestraintType;
  reviewDate?: Maybe<Scalars['DateTime']['output']>;
  reviewFrequencyDays?: Maybe<Scalars['Int']['output']>;
  sourceAuthor?: Maybe<Scalars['String']['output']>;
  sourceBackupDate?: Maybe<Scalars['DateTime']['output']>;
  sourceFields?: Maybe<SarahRestraintSourceFields>;
  sourceHash?: Maybe<Scalars['String']['output']>;
  sourceId?: Maybe<Scalars['String']['output']>;
  sourceSystem?: Maybe<Scalars['String']['output']>;
  startDate: Scalars['DateTime']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type RestraintRecordFilterInput = {
  consentStatus?: InputMaybe<RestraintConsentStatus>;
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  residentId?: InputMaybe<Scalars['ID']['input']>;
  restraintType?: InputMaybe<RestraintType>;
  sourceSystem?: InputMaybe<Scalars['String']['input']>;
  wing?: InputMaybe<Scalars['String']['input']>;
};

export type RestraintRecordsResponse = {
  __typename?: 'RestraintRecordsResponse';
  limit: Scalars['Int']['output'];
  offset: Scalars['Int']['output'];
  records: Array<RestraintRecord>;
  total: Scalars['Int']['output'];
};

/** Type of restraint applied to resident */
export enum RestraintType {
  Chemical = 'CHEMICAL',
  Environmental = 'ENVIRONMENTAL',
  LocationMonitoring = 'LOCATION_MONITORING',
  Mechanical = 'MECHANICAL',
  Physical = 'PHYSICAL'
}

/** The resident's documented resuscitation wish */
export enum ResuscitationWish {
  ForResuscitation = 'FOR_RESUSCITATION',
  LimitedTreatment = 'LIMITED_TREATMENT',
  NotDiscussed = 'NOT_DISCUSSED',
  NotForResuscitation = 'NOT_FOR_RESUSCITATION'
}

export type RevenueTargets = {
  __typename?: 'RevenueTargets';
  currentMonthProgress: Scalars['Float']['output'];
  currentQuarterProgress: Scalars['Float']['output'];
  currentYearProgress: Scalars['Float']['output'];
  monthly: Scalars['Float']['output'];
  quarterly: Scalars['Float']['output'];
  requiredOpportunities: RequiredOpportunities;
  yearly: Scalars['Float']['output'];
};

export type RevenueTrendPoint = {
  __typename?: 'RevenueTrendPoint';
  finance?: Maybe<Scalars['Float']['output']>;
  month: Scalars['String']['output'];
  property?: Maybe<Scalars['Float']['output']>;
  solar?: Maybe<Scalars['Float']['output']>;
  total: Scalars['Float']['output'];
};

export type ReviewActionItem = {
  __typename?: 'ReviewActionItem';
  assignedTo?: Maybe<Scalars['ID']['output']>;
  assignedToName?: Maybe<Scalars['String']['output']>;
  completed: Scalars['Boolean']['output'];
  completedDate?: Maybe<Scalars['DateTime']['output']>;
  description: Scalars['String']['output'];
  dueDate?: Maybe<Scalars['DateTime']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
};

export type ReviewActionItemInput = {
  assignedTo?: InputMaybe<Scalars['ID']['input']>;
  description: Scalars['String']['input'];
  dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
};

export type ReviewAttendee = {
  __typename?: 'ReviewAttendee';
  attended: Scalars['Boolean']['output'];
  clientId?: Maybe<Scalars['ID']['output']>;
  name: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  relationship?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
};

export type ReviewAttendeeInput = {
  attended?: InputMaybe<Scalars['Boolean']['input']>;
  clientId?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  relationship?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
};

export type ReviewCiInitiativeInput = {
  reviewEvidence?: InputMaybe<Array<CiDocumentAttachmentInput>>;
  reviewNotes?: InputMaybe<Scalars['String']['input']>;
  reviewedByName?: InputMaybe<Scalars['String']['input']>;
};

/** Where a review cycle timing comes from */
export enum ReviewCycleBasis {
  Law = 'LAW',
  ProviderPractice = 'PROVIDER_PRACTICE',
  QualityStandard = 'QUALITY_STANDARD'
}

/** A configurable care review cycle */
export enum ReviewCycleKey {
  AdmissionWindow = 'ADMISSION_WINDOW',
  CarePlanReview = 'CARE_PLAN_REVIEW',
  ChangeTriggered = 'CHANGE_TRIGGERED',
  InitialPlan = 'INITIAL_PLAN',
  Reassessment = 'REASSESSMENT'
}

/** Every current resident with a review due soon or overdue */
export type ReviewCycleOverview = {
  __typename?: 'ReviewCycleOverview';
  currentResidents: Scalars['Int']['output'];
  dueSoonResidents: Scalars['Int']['output'];
  overdueResidents: Scalars['Int']['output'];
  /** Only residents with something overdue or due soon; overdue first */
  residents: Array<ResidentReviewCycles>;
};

/** Where one review cycle comes from and the limits it may be set within */
export type ReviewCycleRule = {
  __typename?: 'ReviewCycleRule';
  basis: ReviewCycleBasis;
  /** The default number of days (this provider’s practice unless the basis is LAW) */
  defaultDays: Scalars['Int']['output'];
  /** Plain-words reason: what the law says and what is practice */
  explanation: Scalars['String']['output'];
  key: ReviewCycleKey;
  label: Scalars['String']['output'];
  /** The longest the cycle may be set to. When `maxIsLegal`, the law fixes it and it cannot be relaxed. */
  maxDays: Scalars['Int']['output'];
  maxIsLegal: Scalars['Boolean']['output'];
  minDays: Scalars['Int']['output'];
  source: Scalars['String']['output'];
  sourceUrl?: Maybe<Scalars['String']['output']>;
};

/** A resident's standing on one review cycle */
export enum ReviewCycleState {
  DueSoon = 'DUE_SOON',
  NotApplicable = 'NOT_APPLICABLE',
  Overdue = 'OVERDUE',
  UpToDate = 'UP_TO_DATE'
}

export type ReviewEmpowermentGoalInput = {
  checkInId?: InputMaybe<Scalars['ID']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  feeling?: InputMaybe<Scalars['Int']['input']>;
  goalId: Scalars['ID']['input'];
  outcome: EmpowermentGoalOutcome;
};

/** Frequency of care plan reviews */
export enum ReviewFrequency {
  Annually = 'ANNUALLY',
  Fortnightly = 'FORTNIGHTLY',
  Monthly = 'MONTHLY',
  Quarterly = 'QUARTERLY',
  SixMonthly = 'SIX_MONTHLY',
  Weekly = 'WEEKLY'
}

export type ReviewGovProofInput = {
  reviewNote?: InputMaybe<Scalars['String']['input']>;
  status: Scalars['String']['input'];
};

export type ReviewLeaveRequestInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  leaveRequestId: Scalars['ID']['input'];
  notifyStaff?: InputMaybe<Scalars['Boolean']['input']>;
  openShifts?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Status of a care plan review */
export enum ReviewStatus {
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS',
  Scheduled = 'SCHEDULED'
}

export type ReviseEmpowermentQuestionInput = {
  helpText?: InputMaybe<Scalars['String']['input']>;
  managerText?: InputMaybe<Scalars['String']['input']>;
  milestoneKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  order?: InputMaybe<Scalars['Int']['input']>;
  questionId: Scalars['ID']['input'];
  selfText?: InputMaybe<Scalars['String']['input']>;
  themeLabel?: InputMaybe<Scalars['String']['input']>;
};

export type RevokeMedicalAccessInput = {
  patientId?: InputMaybe<Scalars['ID']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['ID']['input'];
};

export type RevokedSignInSession = {
  __typename?: 'RevokedSignInSession';
  id: Scalars['ID']['output'];
  /** The server time this sign-in stopped working. */
  revokedAt: Scalars['DateTime']['output'];
  /** It was the sign-in making this request — this device is now signed out. */
  wasThisDevice: Scalars['Boolean']['output'];
};

export type RewardFilterInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<GoalRewardType>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type RewardLeaderboardEntry = {
  __typename?: 'RewardLeaderboardEntry';
  activeTokens: Scalars['Int']['output'];
  clientId: Scalars['String']['output'];
  clientName: Scalars['String']['output'];
  rank: Scalars['Int']['output'];
  redeemedTokens: Scalars['Int']['output'];
  totalEarned: Scalars['Int']['output'];
  totalValue: Scalars['Float']['output'];
};

export type RewardPayoutBankDetailsRevealed = {
  __typename?: 'RewardPayoutBankDetailsRevealed';
  accountName: Scalars['String']['output'];
  accountNumber: Scalars['String']['output'];
  bsb: Scalars['String']['output'];
};

export type RewardPayoutBankDetailsView = {
  __typename?: 'RewardPayoutBankDetailsView';
  accountLast4?: Maybe<Scalars['String']['output']>;
  accountName?: Maybe<Scalars['String']['output']>;
  bsbMasked?: Maybe<Scalars['String']['output']>;
  onFile: Scalars['Boolean']['output'];
};

export type RewardPayoutRequest = {
  __typename?: 'RewardPayoutRequest';
  amountMinor: Scalars['Int']['output'];
  cancelledAt?: Maybe<Scalars['DateTime']['output']>;
  clientId: Scalars['ID']['output'];
  clientName: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  maskedAccount: Scalars['String']['output'];
  monthJobId?: Maybe<Scalars['ID']['output']>;
  paidAt?: Maybe<Scalars['DateTime']['output']>;
  paidByName?: Maybe<Scalars['String']['output']>;
  paymentRef?: Maybe<Scalars['String']['output']>;
  requestedAt: Scalars['DateTime']['output'];
  status: RewardPayoutStatus;
  tenantId: Scalars['String']['output'];
  tokenIds: Array<Scalars['ID']['output']>;
  tokenNumbers: Array<Scalars['Int']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type RewardPayoutRequestResult = {
  __typename?: 'RewardPayoutRequestResult';
  alreadyRequested: Scalars['Boolean']['output'];
  request: RewardPayoutRequest;
};

export type RewardPayoutSettled = {
  __typename?: 'RewardPayoutSettled';
  request: RewardPayoutRequest;
  shortfallTokenNumbers: Array<Scalars['Int']['output']>;
};

/** Status of a request to pay reward tokens out to a bank account */
export enum RewardPayoutStatus {
  Cancelled = 'CANCELLED',
  Paid = 'PAID',
  Requested = 'REQUESTED'
}

export type RewardToken = {
  __typename?: 'RewardToken';
  cancelledAt?: Maybe<Scalars['DateTime']['output']>;
  cancelledBy?: Maybe<Scalars['ID']['output']>;
  cancelledByName?: Maybe<Scalars['String']['output']>;
  cancelledReason?: Maybe<Scalars['String']['output']>;
  clientEmail?: Maybe<Scalars['String']['output']>;
  clientId: Scalars['ID']['output'];
  clientName: Scalars['String']['output'];
  clientPhone?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  emailSent: Scalars['Boolean']['output'];
  emailSentAt?: Maybe<Scalars['DateTime']['output']>;
  expiresAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  isDeleted: Scalars['Boolean']['output'];
  issueDetails?: Maybe<Scalars['String']['output']>;
  issueReason: Scalars['String']['output'];
  issuedAt: Scalars['DateTime']['output'];
  issuedBy: Scalars['ID']['output'];
  issuedByName: Scalars['String']['output'];
  payableToBank?: Maybe<Scalars['Boolean']['output']>;
  redeemedAt?: Maybe<Scalars['DateTime']['output']>;
  redeemedBy?: Maybe<Scalars['ID']['output']>;
  redeemedByName?: Maybe<Scalars['String']['output']>;
  redeemedFor?: Maybe<Scalars['String']['output']>;
  referredClientId?: Maybe<Scalars['ID']['output']>;
  referredClientName?: Maybe<Scalars['String']['output']>;
  smsSent: Scalars['Boolean']['output'];
  smsSentAt?: Maybe<Scalars['DateTime']['output']>;
  status: RewardTokenStatus;
  tenantId: Scalars['String']['output'];
  tokenNumber: Scalars['Float']['output'];
  updatedAt: Scalars['DateTime']['output'];
  value: Scalars['Float']['output'];
};

export type RewardTokenConfig = {
  __typename?: 'RewardTokenConfig';
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  createdByName?: Maybe<Scalars['String']['output']>;
  defaultExpiryMonths: Scalars['Float']['output'];
  emailNotificationEnabled: Scalars['Boolean']['output'];
  emailTemplateId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  smsNotificationEnabled: Scalars['Boolean']['output'];
  smsTemplateId?: Maybe<Scalars['String']['output']>;
  subscriptionTokenDripEnabled: Scalars['Boolean']['output'];
  tenantId: Scalars['String']['output'];
  tokenColor: Scalars['String']['output'];
  tokenIcon: Scalars['String']['output'];
  tokenName: Scalars['String']['output'];
  tokenNamePlural: Scalars['String']['output'];
  tokenValue: Scalars['Float']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy?: Maybe<Scalars['String']['output']>;
  updatedByName?: Maybe<Scalars['String']['output']>;
};

export type RewardTokenFilterInput = {
  clientId?: InputMaybe<Scalars['ID']['input']>;
  expiresAfter?: InputMaybe<Scalars['DateTime']['input']>;
  expiresBefore?: InputMaybe<Scalars['DateTime']['input']>;
  issuedAfter?: InputMaybe<Scalars['DateTime']['input']>;
  issuedBefore?: InputMaybe<Scalars['DateTime']['input']>;
  limit?: InputMaybe<Scalars['Float']['input']>;
  offset?: InputMaybe<Scalars['Float']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<RewardTokenStatus>;
};

export type RewardTokenStats = {
  __typename?: 'RewardTokenStats';
  expiringThisMonth: Scalars['Float']['output'];
  issuedThisMonth: Scalars['Float']['output'];
  redeemedThisMonth: Scalars['Float']['output'];
  totalActive: Scalars['Float']['output'];
  totalCancelled: Scalars['Float']['output'];
  totalExpired: Scalars['Float']['output'];
  totalIssued: Scalars['Float']['output'];
  totalRedeemed: Scalars['Float']['output'];
};

/** Status of a reward token */
export enum RewardTokenStatus {
  Active = 'ACTIVE',
  Cancelled = 'CANCELLED',
  Expired = 'EXPIRED',
  Redeemed = 'REDEEMED'
}

export type RewardTransaction = {
  __typename?: 'RewardTransaction';
  clientId: Scalars['ID']['output'];
  clientName: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  details?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  metadata?: Maybe<Scalars['String']['output']>;
  newStatus: RewardTokenStatus;
  performedAt: Scalars['DateTime']['output'];
  performedBy: Scalars['ID']['output'];
  performedByName: Scalars['String']['output'];
  previousStatus?: Maybe<RewardTokenStatus>;
  reason: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  tokenId: Scalars['ID']['output'];
  tokenNumber: Scalars['Float']['output'];
  transactionType: RewardTransactionType;
  updatedAt: Scalars['DateTime']['output'];
};

export type RewardTransactionFilterInput = {
  clientId?: InputMaybe<Scalars['ID']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  limit?: InputMaybe<Scalars['Float']['input']>;
  offset?: InputMaybe<Scalars['Float']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  tokenId?: InputMaybe<Scalars['ID']['input']>;
  transactionType?: InputMaybe<RewardTransactionType>;
};

/** Type of reward transaction */
export enum RewardTransactionType {
  Adjusted = 'ADJUSTED',
  Cancelled = 'CANCELLED',
  Expired = 'EXPIRED',
  Issued = 'ISSUED',
  Redeemed = 'REDEEMED'
}

/** Which IPFS-stored image slot to upload into for Rewards emails */
export enum RewardsBrandingPhotoField {
  Banner = 'BANNER',
  Profile = 'PROFILE',
  Signature = 'SIGNATURE'
}

export type RewardsEmailBranding = {
  __typename?: 'RewardsEmailBranding';
  accentColor?: Maybe<Scalars['String']['output']>;
  bannerImageCid?: Maybe<Scalars['String']['output']>;
  bannerImageUrl?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  ctaButtonStyle?: Maybe<CtaButtonStyle>;
  ctaButtonText?: Maybe<Scalars['String']['output']>;
  ctaButtonUrl?: Maybe<Scalars['String']['output']>;
  emailFont?: Maybe<EmailFont>;
  emailFooterText?: Maybe<Scalars['String']['output']>;
  emailStyle?: Maybe<EmailStyle>;
  hideSiteName?: Maybe<Scalars['Boolean']['output']>;
  hideTagline?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  penName?: Maybe<Scalars['String']['output']>;
  previewSampleBody?: Maybe<Scalars['String']['output']>;
  primaryColor?: Maybe<Scalars['String']['output']>;
  profilePhotoCid?: Maybe<Scalars['String']['output']>;
  profilePhotoSize?: Maybe<Scalars['Int']['output']>;
  profilePhotoUrl?: Maybe<Scalars['String']['output']>;
  secondaryColor?: Maybe<Scalars['String']['output']>;
  signatureImageCid?: Maybe<Scalars['String']['output']>;
  signatureImageUrl?: Maybe<Scalars['String']['output']>;
  socialIconStyle?: Maybe<SocialIconStyle>;
  socialLinks?: Maybe<TenantSocialLinks>;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type RewardsEmailBrandingInput = {
  accentColor?: InputMaybe<Scalars['String']['input']>;
  bannerImageCid?: InputMaybe<Scalars['String']['input']>;
  ctaButtonStyle?: InputMaybe<CtaButtonStyle>;
  ctaButtonText?: InputMaybe<Scalars['String']['input']>;
  ctaButtonUrl?: InputMaybe<Scalars['String']['input']>;
  emailFont?: InputMaybe<EmailFont>;
  emailFooterText?: InputMaybe<Scalars['String']['input']>;
  emailStyle?: InputMaybe<EmailStyle>;
  hideSiteName?: InputMaybe<Scalars['Boolean']['input']>;
  hideTagline?: InputMaybe<Scalars['Boolean']['input']>;
  penName?: InputMaybe<Scalars['String']['input']>;
  previewSampleBody?: InputMaybe<Scalars['String']['input']>;
  primaryColor?: InputMaybe<Scalars['String']['input']>;
  profilePhotoCid?: InputMaybe<Scalars['String']['input']>;
  profilePhotoSize?: InputMaybe<Scalars['Int']['input']>;
  secondaryColor?: InputMaybe<Scalars['String']['input']>;
  signatureImageCid?: InputMaybe<Scalars['String']['input']>;
  socialIconStyle?: InputMaybe<SocialIconStyle>;
  socialLinks?: InputMaybe<TenantSocialLinksInput>;
};

export type RiskAssessmentSourceField = {
  __typename?: 'RiskAssessmentSourceField';
  /** SarahCare table and column, e.g. `FRAT.RecentFalls` */
  column: Scalars['String']['output'];
  /** Original value as text; null when SarahCare held no value */
  value?: Maybe<Scalars['String']['output']>;
};

export type RiskAssessmentSummary = {
  __typename?: 'RiskAssessmentSummary';
  averageScore: Scalars['Float']['output'];
  byCategory: Array<RiskSummaryByCategory>;
  highRiskCount: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type RiskChoice = {
  __typename?: 'RiskChoice';
  agreedAt?: Maybe<Scalars['DateTime']['output']>;
  agreedStrategies: Array<Scalars['String']['output']>;
  choice: Scalars['String']['output'];
  discussedWithContactIds: Array<Scalars['ID']['output']>;
  discussedWithOthers: Array<Scalars['String']['output']>;
  discussion?: Maybe<Scalars['String']['output']>;
  recordedAt: Scalars['DateTime']['output'];
  recordedByName?: Maybe<Scalars['String']['output']>;
  residentAgreement: RiskChoiceAgreement;
  reviewDate?: Maybe<Scalars['DateTime']['output']>;
  risksExplained?: Maybe<Scalars['String']['output']>;
};

/** The resident's agreement to a choice-with-risk plan */
export enum RiskChoiceAgreement {
  Agreed = 'AGREED',
  AgreedWithChanges = 'AGREED_WITH_CHANGES',
  DidNotAgree = 'DID_NOT_AGREE',
  NotYetAsked = 'NOT_YET_ASKED'
}

export type RiskChoiceInput = {
  agreedStrategies?: InputMaybe<Array<Scalars['String']['input']>>;
  choice: Scalars['String']['input'];
  discussedWithContactIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  discussedWithOthers?: InputMaybe<Array<Scalars['String']['input']>>;
  discussion?: InputMaybe<Scalars['String']['input']>;
  residentAgreement: RiskChoiceAgreement;
  reviewDate?: InputMaybe<Scalars['DateTime']['input']>;
  risksExplained?: InputMaybe<Scalars['String']['input']>;
};

export type RiskChoicePersonOption = {
  __typename?: 'RiskChoicePersonOption';
  contactId: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  relationship: Scalars['String']['output'];
};

export type RiskChoiceSummary = {
  __typename?: 'RiskChoiceSummary';
  agreementWords: Scalars['String']['output'];
  discussedWithContacts: Array<RiskChoicePersonOption>;
};

/** Consequence severity (C in P×E×C calculation) */
export enum RiskConsequences {
  Catastrophe = 'CATASTROPHE',
  Disaster = 'DISASTER',
  Minor = 'MINOR',
  Serious = 'SERIOUS',
  Substantial = 'SUBSTANTIAL',
  VerySerious = 'VERY_SERIOUS'
}

/** Exposure frequency (E in P×E×C calculation) */
export enum RiskExposure {
  Continuous = 'CONTINUOUS',
  Frequent = 'FREQUENT',
  Infrequent = 'INFREQUENT',
  Occasional = 'OCCASIONAL',
  Rare = 'RARE',
  VeryRare = 'VERY_RARE'
}

/** Risk level assessment */
export enum RiskLevel {
  Critical = 'CRITICAL',
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM',
  None = 'NONE'
}

/** Probability of risk recurrence (P in P×E×C calculation) */
export enum RiskProbability {
  AlmostCertain = 'ALMOST_CERTAIN',
  Conceivable = 'CONCEIVABLE',
  PracticallyImpossible = 'PRACTICALLY_IMPOSSIBLE',
  QuitePossible = 'QUITE_POSSIBLE',
  RemotelyPossible = 'REMOTELY_POSSIBLE',
  UnusualButPossible = 'UNUSUAL_BUT_POSSIBLE'
}

/** Risk score category based on P×E×C calculation */
export enum RiskScoreCategory {
  High = 'HIGH',
  Moderate = 'MODERATE',
  NilOrNegligible = 'NIL_OR_NEGLIGIBLE',
  RiskPerhapsAcceptable = 'RISK_PERHAPS_ACCEPTABLE',
  Substantial = 'SUBSTANTIAL',
  VeryHigh = 'VERY_HIGH'
}

export type RiskSummaryByCategory = {
  __typename?: 'RiskSummaryByCategory';
  category: RiskScoreCategory;
  color: Scalars['String']['output'];
  count: Scalars['Int']['output'];
  label: Scalars['String']['output'];
};

/** Investor risk tolerance level */
export enum RiskTolerance {
  High = 'HIGH',
  Low = 'LOW',
  Moderate = 'MODERATE',
  VeryHigh = 'VERY_HIGH'
}

/** Aged-care role family a position belongs to; drives the credential checklist */
export enum RoleCategory {
  AdminMaintenance = 'ADMIN_MAINTENANCE',
  CleanerLaundry = 'CLEANER_LAUNDRY',
  CookFsa = 'COOK_FSA',
  En = 'EN',
  Pc = 'PC',
  Rn = 'RN'
}

export type Rollup = {
  __typename?: 'Rollup';
  baseId: Scalars['ID']['output'];
  batchId?: Maybe<Scalars['String']['output']>;
  claimsFound: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  currentVideo?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  extractModel?: Maybe<Scalars['String']['output']>;
  finishedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  inputTokens?: Maybe<Scalars['Int']['output']>;
  latencyMs?: Maybe<Scalars['Int']['output']>;
  outputPath?: Maybe<Scalars['String']['output']>;
  outputTokens?: Maybe<Scalars['Int']['output']>;
  ownerId?: Maybe<Scalars['String']['output']>;
  peopleFound: Scalars['Int']['output'];
  progressLog: Array<Scalars['String']['output']>;
  proseModel?: Maybe<Scalars['String']['output']>;
  rationale?: Maybe<Scalars['String']['output']>;
  scopeKind: RollupScopeKind;
  scopeValue?: Maybe<Scalars['String']['output']>;
  similarTo: Array<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  status: RollupStatus;
  supersedesId?: Maybe<Scalars['ID']['output']>;
  tenantId: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  videoIds: Array<Scalars['ID']['output']>;
  videosProcessed: Scalars['Int']['output'];
};

export type RollupProposal = {
  __typename?: 'RollupProposal';
  estTokens: Scalars['Int']['output'];
  rationale: Scalars['String']['output'];
  scopeKind: RollupScopeKind;
  scopeValue?: Maybe<Scalars['String']['output']>;
  score: Scalars['Int']['output'];
  similarExisting: Array<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  uncoveredCount: Scalars['Int']['output'];
  videoCount: Scalars['Int']['output'];
  videoIds: Array<Scalars['ID']['output']>;
  wasSplit: Scalars['Boolean']['output'];
};

export type RollupProposalsInput = {
  baseId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
};

/** What a rollup's transcript set was selected by */
export enum RollupScopeKind {
  Channel = 'CHANNEL',
  DateRange = 'DATE_RANGE',
  Manual = 'MANUAL',
  Person = 'PERSON',
  Search = 'SEARCH',
  Topic = 'TOPIC'
}

/** Lifecycle of a rollup synthesis */
export enum RollupStatus {
  Cancelled = 'CANCELLED',
  Done = 'DONE',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Running = 'RUNNING',
  Superseded = 'SUPERSEDED'
}

export type RoomPreferences = {
  __typename?: 'RoomPreferences';
  /** Must be ground floor */
  groundFloorRequired?: Maybe<Scalars['Boolean']['output']>;
  /** Near nursing station */
  nearNursingStation?: Maybe<Scalars['Boolean']['output']>;
  preferredRoomTypes?: Maybe<Array<RoomType>>;
  /** Preferred wings */
  preferredWings?: Maybe<Array<Scalars['String']['output']>>;
  /** Specific room requests */
  specificRequests?: Maybe<Scalars['String']['output']>;
  /** Prefers window view */
  windowPreferred?: Maybe<Scalars['Boolean']['output']>;
};

export type RoomPreferencesInput = {
  groundFloorRequired?: InputMaybe<Scalars['Boolean']['input']>;
  nearNursingStation?: InputMaybe<Scalars['Boolean']['input']>;
  preferredRoomTypes?: InputMaybe<Array<RoomType>>;
  preferredWings?: InputMaybe<Array<Scalars['String']['input']>>;
  specificRequests?: InputMaybe<Scalars['String']['input']>;
  windowPreferred?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Type of room in the facility */
export enum RoomType {
  Respite = 'RESPITE',
  Secure = 'SECURE',
  Shared = 'SHARED',
  Single = 'SINGLE',
  Suite = 'SUITE'
}

export type RoomWithOccupancy = {
  __typename?: 'RoomWithOccupancy';
  availableBeds: Scalars['Int']['output'];
  building?: Maybe<Scalars['String']['output']>;
  capacity: Scalars['Int']['output'];
  code?: Maybe<Scalars['String']['output']>;
  currentOccupants: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isAvailable: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  /** Occupied bed numbers */
  occupiedBeds?: Maybe<Array<Scalars['Int']['output']>>;
  parentLocationId?: Maybe<Scalars['ID']['output']>;
  parentName?: Maybe<Scalars['String']['output']>;
  /** Names of current residents */
  residentNames?: Maybe<Array<Scalars['String']['output']>>;
  status: LocationStatus;
};

export enum RosterBulkOpKind {
  RosterBulkPublish = 'ROSTER_BULK_PUBLISH',
  RosterCopyPaste = 'ROSTER_COPY_PASTE'
}

export type RosterBulkOpLog = {
  __typename?: 'RosterBulkOpLog';
  createdAt: Scalars['DateTime']['output'];
  createdCount: Scalars['Int']['output'];
  deletedCount: Scalars['Int']['output'];
  description: Scalars['String']['output'];
  errors: Array<Scalars['String']['output']>;
  expectedCount: Scalars['Int']['output'];
  failedCount: Scalars['Int']['output'];
  finishedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  kind: RosterBulkOpKind;
  operatorName?: Maybe<Scalars['String']['output']>;
  operatorUserId: Scalars['String']['output'];
  stalledReportedAt?: Maybe<Scalars['DateTime']['output']>;
  status: RosterBulkOpStatus;
  updatedAt: Scalars['DateTime']['output'];
};

export enum RosterBulkOpStatus {
  Completed = 'COMPLETED',
  CompletedWithErrors = 'COMPLETED_WITH_ERRORS',
  Running = 'RUNNING',
  Stalled = 'STALLED'
}

/** Order the employee rows in the roster export alphabetically, or grouped by department then alphabetically */
export enum RosterEmployeeSortMode {
  Alphabetical = 'ALPHABETICAL',
  Department = 'DEPARTMENT'
}

/** Whether the roster export covers the visible (filtered) shifts or every shift in the fortnight block */
export enum RosterExportScope {
  AllInBlock = 'ALL_IN_BLOCK',
  Visible = 'VISIBLE'
}

/** Filter the roster export to published (live) shifts, draft shifts, or all */
export enum RosterExportStatusScope {
  All = 'ALL',
  Draft = 'DRAFT',
  Published = 'PUBLISHED'
}

/** Whether a shift is a normal LIVE shift or a protected MASTER template */
export enum RosterMode {
  Live = 'LIVE',
  Master = 'MASTER'
}

export type RoundFilterInput = {
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  limit?: InputMaybe<Scalars['Float']['input']>;
  offset?: InputMaybe<Scalars['Float']['input']>;
  status?: InputMaybe<RoundStatus>;
  wing?: InputMaybe<Scalars['String']['input']>;
};

/** Status of a medication round */
export enum RoundStatus {
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS',
  Scheduled = 'SCHEDULED'
}

export type RoundSummary = {
  __typename?: 'RoundSummary';
  completedRounds: Scalars['Float']['output'];
  complianceRate: Scalars['Float']['output'];
  inProgressRounds: Scalars['Float']['output'];
  scheduledRounds: Scalars['Float']['output'];
  totalGiven: Scalars['Float']['output'];
  totalMedications: Scalars['Float']['output'];
  totalMissed: Scalars['Float']['output'];
  totalRefused: Scalars['Float']['output'];
  totalRounds: Scalars['Float']['output'];
  totalWithheld: Scalars['Float']['output'];
};

export type RoundsResponse = {
  __typename?: 'RoundsResponse';
  rounds: Array<MedicationRound>;
  total: Scalars['Float']['output'];
};

/** Current status of a trade route */
export enum RouteStatus {
  Active = 'ACTIVE',
  Alternative = 'ALTERNATIVE',
  Blocked = 'BLOCKED',
  Disrupted = 'DISRUPTED'
}

/** Type of energy supply route */
export enum RouteType {
  DomesticDistribution = 'DOMESTIC_DISTRIBUTION',
  GasPipeline = 'GAS_PIPELINE',
  InternationalShipping = 'INTERNATIONAL_SHIPPING'
}

export type RsvpInput = {
  dietaryRequirements?: InputMaybe<Scalars['String']['input']>;
  plusOneNames?: InputMaybe<Array<Scalars['String']['input']>>;
  plusOnes?: InputMaybe<Scalars['Float']['input']>;
  rsvpStatus: RsvpStatus;
};

/** The RSVP status of the guest */
export enum RsvpStatus {
  Attending = 'ATTENDING',
  Maybe = 'MAYBE',
  NotAttending = 'NOT_ATTENDING',
  Pending = 'PENDING'
}

export type RunAiPayAuditInput = {
  /** Email the report to this address (defaults to Tom) */
  emailReportTo?: InputMaybe<Scalars['String']['input']>;
  employeeId?: InputMaybe<Scalars['ID']['input']>;
  /** Override the model from PaySettings.aiAuditModel */
  modelName?: InputMaybe<Scalars['String']['input']>;
  payRunId: Scalars['ID']['input'];
  scope: AiAuditScope;
  shiftDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type RunEmailAiRuleNowInput = {
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  scopeFolder?: InputMaybe<Scalars['String']['input']>;
};

export type RunEmailAiRuleNowResult = {
  __typename?: 'RunEmailAiRuleNowResult';
  actionsApplied: Scalars['Int']['output'];
  actionsFailed: Scalars['Int']['output'];
  dryRun: Scalars['Boolean']['output'];
  matched: Scalars['Int']['output'];
  ruleId: Scalars['ID']['output'];
  sample: Array<RunEmailAiRuleNowSampleEmail>;
  scanned: Scalars['Int']['output'];
  skippedAiConditions: Scalars['Boolean']['output'];
};

export type RunEmailAiRuleNowSampleEmail = {
  __typename?: 'RunEmailAiRuleNowSampleEmail';
  date?: Maybe<Scalars['DateTime']['output']>;
  from?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  subject?: Maybe<Scalars['String']['output']>;
};

export type S8AuditReport = {
  __typename?: 'S8AuditReport';
  discrepancyCount: Scalars['Float']['output'];
  endDate: Scalars['DateTime']['output'];
  entries: Array<S8AuditReportEntry>;
  generatedAt: Scalars['DateTime']['output'];
  generatedBy: Scalars['String']['output'];
  startDate: Scalars['DateTime']['output'];
  totalAdjustments: Scalars['Float']['output'];
  totalAdministered: Scalars['Float']['output'];
  totalDestroyed: Scalars['Float']['output'];
  totalReceived: Scalars['Float']['output'];
};

export type S8AuditReportEntry = {
  __typename?: 'S8AuditReportEntry';
  balanceAfter: Scalars['Float']['output'];
  balanceBefore: Scalars['Float']['output'];
  discrepancyExplanation?: Maybe<Scalars['String']['output']>;
  medicationName: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  quantity: Scalars['Float']['output'];
  recordedByName: Scalars['String']['output'];
  residentName: Scalars['String']['output'];
  transactionDate: Scalars['DateTime']['output'];
  transactionTime: Scalars['String']['output'];
  transactionType: S8TransactionType;
  witnessedByName: Scalars['String']['output'];
};

export type S8DiscrepancyInput = {
  actualBalance: Scalars['Float']['input'];
  discrepancyExplanation: Scalars['String']['input'];
  expectedBalance: Scalars['Float']['input'];
  witnessedBy: Scalars['ID']['input'];
  witnessedByName: Scalars['String']['input'];
};

export type S8MedicationSummary = {
  __typename?: 'S8MedicationSummary';
  currentBalance: Scalars['Float']['output'];
  hasDiscrepancy: Scalars['Boolean']['output'];
  lastTransaction?: Maybe<Scalars['DateTime']['output']>;
  medicationId: Scalars['ID']['output'];
  medicationName: Scalars['String']['output'];
  residentId: Scalars['ID']['output'];
  residentName: Scalars['String']['output'];
};

export type S8Register = {
  __typename?: 'S8Register';
  administrationId?: Maybe<Scalars['ID']['output']>;
  balanceAfter: Scalars['Float']['output'];
  balanceBefore: Scalars['Float']['output'];
  batchNumber?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  discrepancyExplanation?: Maybe<Scalars['String']['output']>;
  dosageGiven?: Maybe<Scalars['String']['output']>;
  expiryDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  medicationId: Scalars['ID']['output'];
  medicationName?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  quantity: Scalars['Float']['output'];
  recordedBy: Scalars['ID']['output'];
  recordedByName: Scalars['String']['output'];
  residentId: Scalars['ID']['output'];
  supplierName?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  transactionDate: Scalars['DateTime']['output'];
  transactionTime: Scalars['String']['output'];
  transactionType: S8TransactionType;
  updatedAt: Scalars['DateTime']['output'];
  witnessedBy: Scalars['ID']['output'];
  witnessedByName: Scalars['String']['output'];
};

export type S8RegisterFilterInput = {
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  limit?: InputMaybe<Scalars['Float']['input']>;
  medicationId?: InputMaybe<Scalars['ID']['input']>;
  offset?: InputMaybe<Scalars['Float']['input']>;
  residentId?: InputMaybe<Scalars['ID']['input']>;
  transactionType?: InputMaybe<S8TransactionType>;
};

export type S8RegisterResponse = {
  __typename?: 'S8RegisterResponse';
  currentBalance: Scalars['Float']['output'];
  transactions: Array<S8Register>;
};

export type S8TransactionInput = {
  administrationId?: InputMaybe<Scalars['ID']['input']>;
  batchNumber?: InputMaybe<Scalars['String']['input']>;
  discrepancyExplanation?: InputMaybe<Scalars['String']['input']>;
  dosageGiven?: InputMaybe<Scalars['String']['input']>;
  expiryDate?: InputMaybe<Scalars['DateTime']['input']>;
  medicationId: Scalars['ID']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  quantity: Scalars['Float']['input'];
  residentId: Scalars['ID']['input'];
  supplierName?: InputMaybe<Scalars['String']['input']>;
  transactionDate: Scalars['DateTime']['input'];
  transactionTime: Scalars['String']['input'];
  transactionType: S8TransactionType;
  witnessedBy: Scalars['ID']['input'];
  witnessedByName: Scalars['String']['input'];
};

/** Type of S8 register transaction */
export enum S8TransactionType {
  Adjustment = 'ADJUSTMENT',
  Administered = 'ADMINISTERED',
  Destroyed = 'DESTROYED',
  Received = 'RECEIVED',
  Transferred = 'TRANSFERRED'
}

export type SeoMetadata = {
  __typename?: 'SEOMetadata';
  canonicalUrl?: Maybe<Scalars['String']['output']>;
  conversionGoal?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  lastEditedBy?: Maybe<Scalars['String']['output']>;
  linkedInDescription?: Maybe<Scalars['String']['output']>;
  linkedInImage?: Maybe<Scalars['String']['output']>;
  linkedInImageCid?: Maybe<Scalars['String']['output']>;
  linkedInTitle?: Maybe<Scalars['String']['output']>;
  metaDescription: Scalars['String']['output'];
  metaKeywords?: Maybe<Array<Scalars['String']['output']>>;
  metaTitle: Scalars['String']['output'];
  ogDescription?: Maybe<Scalars['String']['output']>;
  ogImage?: Maybe<Scalars['String']['output']>;
  ogImageCid?: Maybe<Scalars['String']['output']>;
  ogTitle?: Maybe<Scalars['String']['output']>;
  ogType?: Maybe<Scalars['String']['output']>;
  pagePath: Scalars['String']['output'];
  pageTitle: Scalars['String']['output'];
  pinterestDescription?: Maybe<Scalars['String']['output']>;
  pinterestImage?: Maybe<Scalars['String']['output']>;
  pinterestImageCid?: Maybe<Scalars['String']['output']>;
  pinterestTitle?: Maybe<Scalars['String']['output']>;
  published: Scalars['Boolean']['output'];
  robots: Scalars['String']['output'];
  structuredData?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  trackPageViews: Scalars['Boolean']['output'];
  twitterCard?: Maybe<Scalars['String']['output']>;
  twitterDescription?: Maybe<Scalars['String']['output']>;
  twitterImage?: Maybe<Scalars['String']['output']>;
  twitterImageCid?: Maybe<Scalars['String']['output']>;
  twitterTitle?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type SeoMetadataFilters = {
  limit?: InputMaybe<Scalars['Float']['input']>;
  offset?: InputMaybe<Scalars['Float']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export enum SarahAdmissionSnapshotKind {
  Admission = 'ADMISSION',
  Funding = 'FUNDING',
  Separation = 'SEPARATION'
}

export type SarahBondPaymentSourceFields = {
  __typename?: 'SarahBondPaymentSourceFields';
  /** Original SarahCare Bond Payments AmtPaid */
  amtPaid?: Maybe<Scalars['Float']['output']>;
  /** Original SarahCare Bond Payments BankCode */
  bankCode?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare Bond Payments BSBno */
  bsbNo?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare Bond Payments Cheque */
  cheque?: Maybe<Scalars['Boolean']['output']>;
  /** Original SarahCare Bond Payments ChqNo */
  chqNo?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare Bond Payments Cleared */
  cleared?: Maybe<Scalars['Boolean']['output']>;
  /** Original SarahCare Bond Payments CustID */
  custId?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare Bond Payments DatePaid (source timestamp text) */
  datePaidText?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare Bond Payments Drawer */
  drawer?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare Bond Payments _InsertedBy */
  insertedBy?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare Bond Payments _InsertedDate (source timestamp text) */
  insertedDateText?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare Bond Payments IntOwing */
  intOwing?: Maybe<Scalars['Float']['output']>;
  /** Original SarahCare Bond Payments NewBalance */
  newBalance?: Maybe<Scalars['Float']['output']>;
  /** Original SarahCare Bond Payments PaymentID */
  paymentId?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare Bond Payments ReceiptID */
  receiptId?: Maybe<Scalars['String']['output']>;
};

export type SarahBondSourceFields = {
  __typename?: 'SarahBondSourceFields';
  /** Original SarahCare Bond Residents BankCode */
  bankCode?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare Bond Residents Bond */
  bond?: Maybe<Scalars['Float']['output']>;
  /** Original SarahCare Bond Residents BondFromPreviousFacility */
  bondFromPreviousFacility?: Maybe<Scalars['Boolean']['output']>;
  /** Original SarahCare Bond Residents BondThreshhold */
  bondThreshhold?: Maybe<Scalars['Float']['output']>;
  /** Original SarahCare Bond Residents BSBNo */
  bsbNo?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare Bond Residents Cheque */
  cheque?: Maybe<Scalars['Boolean']['output']>;
  /** Original SarahCare Bond Residents ChqNo */
  chqNo?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare Bond Residents CurrentBalance */
  currentBalance?: Maybe<Scalars['Float']['output']>;
  /** Original SarahCare Bond Residents CustID */
  custId?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare Bond Residents Deposit */
  deposit?: Maybe<Scalars['Float']['output']>;
  /** Original SarahCare Bond Residents DepositReceiptNo */
  depositReceiptNo?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare Bond Residents Drawer */
  drawer?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare Bond Residents Enddate (source timestamp text) */
  enddateText?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare Bond Residents _InsertedBy */
  insertedBy?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare Bond Residents _InsertedDate (source timestamp text) */
  insertedDateText?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare Bond Residents InterestRate */
  interestRate?: Maybe<Scalars['Float']['output']>;
  /** Original SarahCare Bond Residents MonthlyRetention */
  monthlyRetention?: Maybe<Scalars['Float']['output']>;
  /** Original SarahCare Bond Residents PaidOut */
  paidOut?: Maybe<Scalars['Boolean']['output']>;
  /** Original SarahCare Bond Residents PayOutChqAuth */
  payOutChqAuth?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare Bond Residents PayOutChqNo */
  payOutChqNo?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare Bond Residents PayOutDate (source timestamp text) */
  payOutDateText?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare Bond Residents PayOutRefundAmt */
  payOutRefundAmt?: Maybe<Scalars['Float']['output']>;
  /** Original SarahCare Bond Residents PeriodicPaymentAmt */
  periodicPaymentAmt?: Maybe<Scalars['Float']['output']>;
  /** Original SarahCare Bond Residents PeriodicPaymentInterest */
  periodicPaymentInterest?: Maybe<Scalars['Float']['output']>;
  /** Original SarahCare Bond Residents PeriodicPaymentRetention */
  periodicPaymentRetention?: Maybe<Scalars['Float']['output']>;
  /** Original SarahCare Bond Residents PeriodicPaymentTakeFromLS */
  periodicPaymentTakeFromLs?: Maybe<Scalars['Boolean']['output']>;
  /** Original SarahCare Bond Residents PeriodicPayments */
  periodicPayments?: Maybe<Scalars['Boolean']['output']>;
  /** Original SarahCare Bond Residents RetentionMethod */
  retentionMethod?: Maybe<Scalars['Boolean']['output']>;
  /** Original SarahCare Bond Residents StartDate (source timestamp text) */
  startDateText?: Maybe<Scalars['String']['output']>;
};

export type SarahCareAdmissionDetails = {
  __typename?: 'SarahCareAdmissionDetails';
  /** Original SarahCare Admission Date (source timestamp text) */
  admissionDateText?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare Admitted From */
  admittedFrom?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare Allergies */
  allergies?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare Art */
  art?: Maybe<Scalars['Boolean']['output']>;
  /** Original SarahCare CareTypeOnAdmission */
  careTypeOnAdmission?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare Case Mgr */
  caseMgr?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare ClothingLabel */
  clothingLabel?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare Current RCS */
  currentRcs?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare Date Current RCS (source timestamp text) */
  dateCurrentRcsText?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare DateReturnToLowCare (source timestamp text) */
  dateReturnToLowCareText?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare Diagnosis */
  diagnosis?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare DOB */
  dob?: Maybe<Scalars['Boolean']['output']>;
  /** Original SarahCare Dr Fax No */
  drFaxNo?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare Dr Mobile No */
  drMobileNo?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare Dr Ph Number */
  drPhNumber?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare HomlessIndiginousStatus */
  homlessIndiginousStatus?: Maybe<Scalars['Int']['output']>;
  /** Original SarahCare Hospital of Choice */
  hospitalOfChoice?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare Hospital Phone No */
  hospitalPhoneNo?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare ILU Entry Date (source timestamp text) */
  iluEntryDateText?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare inApprovedCareUnfundedB4Entry (source timestamp text) */
  inApprovedCareUnfundedB4EntryText?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare inCareB4July2014 */
  inCareB4July2014?: Maybe<Scalars['Boolean']['output']>;
  /** Original SarahCare Initial Case conference Due (source timestamp text) */
  initialCaseConferenceDueText?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare Initial RCS Applied For */
  initialRcsAppliedFor?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare Initial RCS Due (source timestamp text) */
  initialRcsDueText?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare Initial RCS Sent (source timestamp text) */
  initialRcsSentText?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare _InsertedBy */
  insertedBy?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare _InsertedDate (source timestamp text) */
  insertedDateText?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare NDIS */
  ndis?: Maybe<Scalars['Boolean']['output']>;
  /** Original SarahCare NDISCoordinator */
  ndisCoordinator?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare NDISNumber */
  ndisNumber?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare NDISPlanDateEnd (source timestamp text) */
  ndisPlanDateEndText?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare NDISPlanDateStart (source timestamp text) */
  ndisPlanDateStartText?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare NSAFBeenSighted */
  nsafBeenSighted?: Maybe<Scalars['Boolean']['output']>;
  /** Original SarahCare P/Code */
  pCode?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare PalliativeCare */
  palliativeCare?: Maybe<Scalars['Boolean']['output']>;
  /** Original SarahCare Ph Number */
  phNumber?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare Photo */
  photo?: Maybe<Scalars['Boolean']['output']>;
  /** Original SarahCare Pre Admission Date (source timestamp text) */
  preAdmissionDateText?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare PreviousFacility */
  previousFacility?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare PriorCareOptIn */
  priorCareOptIn?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare Private Address Before Admission */
  privateAddressBeforeAdmission?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare PrognosisUnder3Months */
  prognosisUnder3Months?: Maybe<Scalars['Boolean']['output']>;
  /** Original SarahCare Relatives Attended */
  relativesAttended?: Maybe<Scalars['Boolean']['output']>;
  /** Original SarahCare Control Number */
  residentSourceId?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare Respite */
  respite?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare Respite Days */
  respiteDays?: Maybe<Scalars['Int']['output']>;
  /** Original SarahCare Respite Due Out date (source timestamp text) */
  respiteDueOutDateText?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare sync (source timestamp text) */
  syncText?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare Treating Doctor */
  treatingDoctor?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare Treating Doctor Given Name */
  treatingDoctorGivenName?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare UseName */
  useName?: Maybe<Scalars['Boolean']['output']>;
  /** Original SarahCare Volunteer2Transport */
  volunteer2Transport?: Maybe<Scalars['Boolean']['output']>;
};

export type SarahCareContactCallDetails = {
  __typename?: 'SarahCareContactCallDetails';
  addedAtText?: Maybe<Scalars['String']['output']>;
  addedBy?: Maybe<Scalars['String']['output']>;
  callSourceId?: Maybe<Scalars['String']['output']>;
  contactAtText?: Maybe<Scalars['String']['output']>;
  contactBy?: Maybe<Scalars['String']['output']>;
  contactSourceId?: Maybe<Scalars['String']['output']>;
  detailsOfContact?: Maybe<Scalars['String']['output']>;
  method?: Maybe<Scalars['String']['output']>;
};

export type SarahCareContactDetails = {
  __typename?: 'SarahCareContactDetails';
  /** Original SarahCare Address */
  address?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare AdultGuardianID */
  adultGuardianID?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare Alt Address */
  altAddress?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare Alt Email */
  altEmail?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare Alt Mobile Number */
  altMobileNumber?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare Alt Post Code */
  altPostCode?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare Alt Relationship */
  altRelationship?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare Alt (H) Ph Number */
  alternateHomePhone?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare Alt Name */
  alternateName?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare Alt (W) Ph Number */
  alternateWorkPhone?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare AwayFrom (source timestamp text, unchanged) */
  awayFromText?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare AwayTo (source timestamp text, unchanged) */
  awayToText?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare CareStatement */
  careStatement?: Maybe<Scalars['Boolean']['output']>;
  /** Original SarahCare ConsentToShareDetails */
  consentToShareDetails?: Maybe<Scalars['Boolean']['output']>;
  /** Original SarahCare ContactOrder */
  contactOrder?: Maybe<Scalars['Int']['output']>;
  /** Original SarahCare ResContactDetailsID */
  contactSourceId?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare ContractSigned */
  contractSigned?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare CovidVaxCompleted */
  covidVaxCompleted?: Maybe<Scalars['Boolean']['output']>;
  /** Original SarahCare CovidVaxCompletedDate (source timestamp text, unchanged) */
  covidVaxCompletedDateText?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare CovidVaxDoc */
  covidVaxDoc?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare CovidVaxNotReq */
  covidVaxNotReq?: Maybe<Scalars['Boolean']['output']>;
  /** Original SarahCare CovidVaxNote */
  covidVaxNote?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare EditDate (source timestamp text, unchanged) */
  editedAtText?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare EditUser */
  editedByText?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare Email */
  email?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare Enduring */
  enduring?: Maybe<Scalars['Boolean']['output']>;
  /** Original SarahCare EnduringFinancial */
  enduringFinancial?: Maybe<Scalars['Boolean']['output']>;
  /** Original SarahCare FLuVaxDoc */
  fLuVaxDoc?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare Financial */
  financial?: Maybe<Scalars['Boolean']['output']>;
  /** Original SarahCare FinancialDetails */
  financialDetails?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare FinancialEffective */
  financialEffective?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare FinancialType */
  financialType?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare FluVaxCertNo */
  fluVaxCertNo?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare FluVaxCompleted */
  fluVaxCompleted?: Maybe<Scalars['Boolean']['output']>;
  /** Original SarahCare FluVaxCompletedDate (source timestamp text, unchanged) */
  fluVaxCompletedDateText?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare FluVaxNotReq */
  fluVaxNotReq?: Maybe<Scalars['Boolean']['output']>;
  /** Original SarahCare Gender */
  gender?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare HoldsWill */
  holdsWill?: Maybe<Scalars['Boolean']['output']>;
  /** Original SarahCare (H) Ph Number */
  homePhone?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare _InsertedDate (source timestamp text, unchanged) */
  insertedAtText?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare _InsertedBy */
  insertedByText?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare isPublicGuardian */
  isPublicGuardian?: Maybe<Scalars['Boolean']['output']>;
  /** Original SarahCare isPublicTrustee */
  isPublicTrustee?: Maybe<Scalars['Boolean']['output']>;
  /** Original SarahCare isResponsible */
  isResponsible?: Maybe<Scalars['Boolean']['output']>;
  /** Original SarahCare Medical */
  medical?: Maybe<Scalars['Boolean']['output']>;
  /** Original SarahCare MedicalDetails */
  medicalDetails?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare MedicalEffective */
  medicalEffective?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare MedicalType */
  medicalType?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare Mobile Number */
  mobileNumber?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare Name */
  name?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare Notes Contact */
  notesContact?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare PettyCash */
  pettyCash?: Maybe<Scalars['Boolean']['output']>;
  /** Original SarahCare Post Code */
  postCode?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare PublicTrusteeID */
  publicTrusteeID?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare ReceiveAccount */
  receiveAccount?: Maybe<Scalars['Boolean']['output']>;
  /** Original SarahCare ReceiveCorrespondence */
  receiveCorrespondence?: Maybe<Scalars['Boolean']['output']>;
  /** Original SarahCare Relation */
  relation?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare Relationship */
  relationship?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare Control Number */
  residentSourceId?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare sync (source timestamp text, unchanged) */
  syncedAtText?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare WebsterRelationShip */
  websterRelationShip?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare (W) Ph Number */
  workPhone?: Maybe<Scalars['String']['output']>;
};

export type SarahCareFundingDetails = {
  __typename?: 'SarahCareFundingDetails';
  /** Original SarahCare ACASReceivedDate (source timestamp text) */
  acasReceivedDateText?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare ACAS Ref No */
  acasRefNo?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare ACATS Expiry (source timestamp text) */
  acatsExpiryText?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare AccomPaymentType */
  accomPaymentType?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare Address for Accounts */
  addressForAccounts?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare Ambulance Fund No */
  ambulanceFundNo?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare Assisted */
  assisted?: Maybe<Scalars['Boolean']['output']>;
  /** Original SarahCare Bulk Pension */
  bulkPension?: Maybe<Scalars['Boolean']['output']>;
  /** Original SarahCare Cheque */
  cheque?: Maybe<Scalars['Boolean']['output']>;
  /** Original SarahCare CityForAccounts */
  cityForAccounts?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare CommunityCareNo */
  communityCareNo?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare Concess */
  concess?: Maybe<Scalars['Boolean']['output']>;
  /** Original SarahCare Contract Signed */
  contractSigned?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare DeptH&AC# */
  deptHAc?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare Diebetic Card No */
  diebeticCardNo?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare Direct Debit */
  directDebit?: Maybe<Scalars['Boolean']['output']>;
  /** Original SarahCare DSS */
  dss?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare DVA */
  dva?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare EmergencyACAS */
  emergencyAcas?: Maybe<Scalars['Boolean']['output']>;
  /** Original SarahCare ExHostelSupp */
  exHostelSupp?: Maybe<Scalars['Boolean']['output']>;
  /** Original SarahCare ExtraServicesCode */
  extraServicesCode?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare Gold */
  gold?: Maybe<Scalars['Int']['output']>;
  /** Original SarahCare Hearing Card No */
  hearingCardNo?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare IHILastUpdatedAt (source timestamp text) */
  ihiLastUpdatedAtText?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare IHIRecordStatus */
  ihiRecordStatus?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare IHIStatus */
  ihiStatus?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare _InsertedBy */
  insertedBy?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare _InsertedDate (source timestamp text) */
  insertedDateText?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare Labels */
  labels?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare LiabilityType */
  liabilityType?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare Medical Fund */
  medicalFund?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare Medical Fund No */
  medicalFundNo?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare Medicare Expiry Date (source timestamp text) */
  medicareExpiryDateText?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare Medicare List */
  medicareList?: Maybe<Scalars['Int']['output']>;
  /** Original SarahCare Medicare No */
  medicareNo?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare MyAgedCareNo */
  myAgedCareNo?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare MyAgedCareRefCodePerm */
  myAgedCareRefCodePerm?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare MyAgedCareRefCodeRespite */
  myAgedCareRefCodeRespite?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare MyAgedCareRefCodeRespiteType */
  myAgedCareRefCodeRespiteType?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare MyHealthRecord */
  myHealthRecord?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare NameForAccounts */
  nameForAccounts?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare Non Concess */
  nonConcess?: Maybe<Scalars['Boolean']['output']>;
  /** Original SarahCare NotElligibleForPensionerSupp */
  notElligibleForPensionerSupp?: Maybe<Scalars['Boolean']['output']>;
  /** Original SarahCare Notes */
  notes?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare OnlineClaimingID */
  onlineClaimingId?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare Payment Method */
  paymentMethod?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare Pension  Expiry Date (source timestamp text) */
  pensionExpiryDateText?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare Pension Full */
  pensionFull?: Maybe<Scalars['Boolean']['output']>;
  /** Original SarahCare Pension Health Benefit Card */
  pensionHealthBenefitCard?: Maybe<Scalars['Boolean']['output']>;
  /** Original SarahCare Pension No */
  pensionNo?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare Pension None */
  pensionNone?: Maybe<Scalars['Boolean']['output']>;
  /** Original SarahCare Pension Part */
  pensionPart?: Maybe<Scalars['Boolean']['output']>;
  /** Original SarahCare Pension Type */
  pensionType?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare Pharmacutical Concession Card No */
  pharmacuticalConcessionCardNo?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare Pharmacutical Safety Net No */
  pharmacuticalSafetyNetNo?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare PostcodeForAccounts */
  postcodeForAccounts?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare Control Number */
  residentSourceId?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare Senior Card Expiry (source timestamp text) */
  seniorCardExpiryText?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare Senior Card No */
  seniorCardNo?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare StateForAccounts */
  stateForAccounts?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare SuburbForAccounts */
  suburbForAccounts?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare TaxiExpiry (source timestamp text) */
  taxiExpiryText?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare TaxiSubsidy */
  taxiSubsidy?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare UseNonPensionerRateForFees */
  useNonPensionerRateForFees?: Maybe<Scalars['Boolean']['output']>;
  /** Original SarahCare White */
  white?: Maybe<Scalars['Int']['output']>;
};

/** Original SarahCare CarePlanEvalHistory row behind an imported evaluation */
export type SarahCarePlanEvaluationSource = {
  __typename?: 'SarahCarePlanEvaluationSource';
  addUser?: Maybe<Scalars['String']['output']>;
  carePlanRowId?: Maybe<Scalars['String']['output']>;
  catNo?: Maybe<Scalars['Int']['output']>;
  dateText?: Maybe<Scalars['String']['output']>;
  evaluation?: Maybe<Scalars['String']['output']>;
  evaluationId?: Maybe<Scalars['String']['output']>;
};

/** Original SarahCare care-plan section row behind an imported care plan version */
export type SarahCarePlanSourceFields = {
  __typename?: 'SarahCarePlanSourceFields';
  archiveBy?: Maybe<Scalars['String']['output']>;
  archiveDateText?: Maybe<Scalars['String']['output']>;
  catNo?: Maybe<Scalars['Int']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  controlNumber?: Maybe<Scalars['String']['output']>;
  cpBy?: Maybe<Scalars['String']['output']>;
  cpDateText?: Maybe<Scalars['String']['output']>;
  cpEditDateText?: Maybe<Scalars['String']['output']>;
  evaluation?: Maybe<Scalars['String']['output']>;
  goals?: Maybe<Scalars['String']['output']>;
  insertedBy?: Maybe<Scalars['String']['output']>;
  insertedDateText?: Maybe<Scalars['String']['output']>;
  interventions?: Maybe<Scalars['String']['output']>;
  /** Last SarahCare archive snapshot that still held this exact version */
  lastArchiveBy?: Maybe<Scalars['String']['output']>;
  lastArchiveDateText?: Maybe<Scalars['String']['output']>;
  /** Archive snapshot just before this version first appeared (when it was written) */
  previousArchiveDateText?: Maybe<Scalars['String']['output']>;
  problems?: Maybe<Scalars['String']['output']>;
  rowId?: Maybe<Scalars['String']['output']>;
  /** How many SarahCare archive snapshots held this exact version */
  snapshotCount?: Maybe<Scalars['Int']['output']>;
  sourceTable?: Maybe<Scalars['String']['output']>;
  uniqueId?: Maybe<Scalars['String']['output']>;
};

export type SarahCareResidentPhotoPointerInput = {
  /** Replace a SarahCare-set pointer when SarahCare now names a different default photo (runner --refresh) */
  refreshIfChanged?: InputMaybe<Scalars['Boolean']['input']>;
  residentId: Scalars['ID']['input'];
  /** 'ResID:' + sourcePhotoId — the medical record's sourceDocId */
  sourceDocId: Scalars['String']['input'];
  /** SarahCare ResID.ResIDID of the resident's default photo */
  sourcePhotoId: Scalars['String']['input'];
  /** SarahCare Customers.[Customer Number] (= Resident.sarahCareId) */
  sourceResidentId: Scalars['String']['input'];
  /** ResID.DateTaken (date only, T00:00:00.000Z). Checked, not stored: the medical record keeps it as sourceDocumentDate. */
  sourceTakenDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SarahCareResidentPhotoPointerResult = {
  __typename?: 'SarahCareResidentPhotoPointerResult';
  /** SarahCare-set pointer, but SarahCare now names a different default photo */
  changed: Scalars['Int']['output'];
  /** Changed pointers that cannot be replaced (the new photo record is not in PLCC yet) */
  changedHeld: Scalars['Int']['output'];
  /** Up to 25 SarahCare ResIDIDs of changed pointers (ids only) */
  changedSourceIds: Array<Scalars['String']['output']>;
  examined: Scalars['Int']['output'];
  /** Resident already points at this SarahCare photo */
  existing: Scalars['Int']['output'];
  /** The encrypted photo record is not in PLCC yet (transfer it first); nothing written */
  fileMissing: Scalars['Int']['output'];
  /** Resident has a photo staff chose (or staff removed it): never overwritten */
  heldStaffPhoto: Scalars['Int']['output'];
  /** Pointers written (apply only) */
  inserted: Scalars['Int']['output'];
  /** Changed pointers replaced (apply + refreshIfChanged) */
  refreshed: Scalars['Int']['output'];
  /** Pointers a real run would write (dry run only) */
  wouldInsert: Scalars['Int']['output'];
  /** Dry run: changed pointers a refresh would replace */
  wouldRefresh: Scalars['Int']['output'];
};

export type SarahCareSeparationDetails = {
  __typename?: 'SarahCareSeparationDetails';
  /** Original SarahCare Burial */
  burial?: Maybe<Scalars['Boolean']['output']>;
  /** Original SarahCare Cremation */
  cremation?: Maybe<Scalars['Boolean']['output']>;
  /** Original SarahCare Deceased Date (source timestamp text) */
  deceasedDateText?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare Deceased Time (source timestamp text) */
  deceasedTimeText?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare DepartureReasonCode */
  departureReasonCode?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare DischargeDate (source timestamp text) */
  dischargeDateText?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare DischargeUser */
  dischargeUser?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare DonateBody */
  donateBody?: Maybe<Scalars['Boolean']['output']>;
  /** Original SarahCare EmailSent */
  emailSent?: Maybe<Scalars['Boolean']['output']>;
  /** Original SarahCare ExcludeFromEmail */
  excludeFromEmail?: Maybe<Scalars['Boolean']['output']>;
  /** Original SarahCare Final Discharge Date (source timestamp text) */
  finalDischargeDateText?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare Funeral Arrangements */
  funeralArrangements?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare FuneralDirector */
  funeralDirector?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare Home */
  home?: Maybe<Scalars['Boolean']['output']>;
  /** Original SarahCare Hospital */
  hospital?: Maybe<Scalars['Boolean']['output']>;
  /** Original SarahCare _InsertedBy */
  insertedBy?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare _InsertedDate (source timestamp text) */
  insertedDateText?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare IsOrganDonor */
  isOrganDonor?: Maybe<Scalars['Boolean']['output']>;
  /** Original SarahCare Nursing Home */
  nursingHome?: Maybe<Scalars['Boolean']['output']>;
  /** Original SarahCare Other */
  other?: Maybe<Scalars['Boolean']['output']>;
  /** Original SarahCare Control Number */
  residentSourceId?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare SympathyCardSent */
  sympathyCardSent?: Maybe<Scalars['Boolean']['output']>;
};

export enum SarahContactLinkMethod {
  AddedByStaff = 'ADDED_BY_STAFF',
  NameAndPhone = 'NAME_AND_PHONE',
  NameAndRelationship = 'NAME_AND_RELATIONSHIP',
  SourceIdNote = 'SOURCE_ID_NOTE'
}

export type SarahContactLinkResult = {
  __typename?: 'SarahContactLinkResult';
  alreadyLinked: Scalars['Int']['output'];
  /** More than one possible match; left for a person */
  ambiguous: Scalars['Int']['output'];
  /** SarahCare contact-row ids that were ambiguous (ids only, no personal data) */
  ambiguousIds: Array<Scalars['ID']['output']>;
  byNameAndPhone: Scalars['Int']['output'];
  byNameAndRelationship: Scalars['Int']['output'];
  bySourceIdNote: Scalars['Int']['output'];
  historyRows: Scalars['Int']['output'];
  /** Links written (apply only) */
  linked: Scalars['Int']['output'];
  residents: Scalars['Int']['output'];
  /** No matching real contact */
  unlinked: Scalars['Int']['output'];
  /** Unlinked rows belonging to CURRENT residents (shown as "not yet added as a contact") */
  unlinkedCurrent: Scalars['Int']['output'];
  /** Links a real run would write (dry run only) */
  wouldLink: Scalars['Int']['output'];
};

/** One SarahCare daily-care heading: the four original columns */
export type SarahDailyCareSection = {
  __typename?: 'SarahDailyCareSection';
  care?: Maybe<Scalars['String']['output']>;
  delegateTo?: Maybe<Scalars['String']['output']>;
  evidence?: Maybe<Scalars['String']['output']>;
  heading: Scalars['String']['output'];
  key: Scalars['String']['output'];
  needs?: Maybe<Scalars['String']['output']>;
};

/** Original SarahCare ResDailyCare row behind an imported daily care profile version */
export type SarahDailyCareSourceFields = {
  __typename?: 'SarahDailyCareSourceFields';
  addDateText?: Maybe<Scalars['String']['output']>;
  addUser?: Maybe<Scalars['String']['output']>;
  alertNote?: Maybe<Scalars['String']['output']>;
  archiveDateTimeText?: Maybe<Scalars['String']['output']>;
  custId?: Maybe<Scalars['String']['output']>;
  dateOfPlanText?: Maybe<Scalars['String']['output']>;
  editDateText?: Maybe<Scalars['String']['output']>;
  editUser?: Maybe<Scalars['String']['output']>;
  initialFpSyncDone?: Maybe<Scalars['Boolean']['output']>;
  insertedBy?: Maybe<Scalars['String']['output']>;
  insertedDateText?: Maybe<Scalars['String']['output']>;
  mgtCharts?: Maybe<Scalars['String']['output']>;
  rnName?: Maybe<Scalars['String']['output']>;
  sections?: Maybe<Array<SarahDailyCareSection>>;
  sourceTable?: Maybe<Scalars['String']['output']>;
  special?: Maybe<Scalars['String']['output']>;
  unlockedBy?: Maybe<Scalars['String']['output']>;
};

export type SarahFluidFoodReadBack = {
  __typename?: 'SarahFluidFoodReadBack';
  /** Source ids asked about */
  examined: Scalars['Int']['output'];
  /** Of those, stored in this tenant */
  found: Scalars['Int']['output'];
  /** Stored rows whose fields re-hash to the hash taken at import */
  matched: Scalars['Int']['output'];
  mismatched: Scalars['Int']['output'];
  /** Up to 25 SarahCare source ids that did not match (ids only) */
  mismatchedSourceIds: Array<Scalars['String']['output']>;
  /** Every SarahCare row of this table in this tenant */
  totalInTenant: Scalars['Int']['output'];
};

export type SarahHistoricalImportResult = {
  __typename?: 'SarahHistoricalImportResult';
  /** Child rows whose parent record is not imported yet or changed and awaits its refresh (not written). Null = importer has no parent check. examined = inserted|wouldInsert + existing + changed + awaitingParent */
  awaitingParent?: Maybe<Scalars['Int']['output']>;
  /** Rows already imported whose source content differs now (never written unless refreshed) */
  changed: Scalars['Int']['output'];
  /** Changed rows that cannot be refreshed in place (edited after import, or table not refreshable) */
  changedHeld: Scalars['Int']['output'];
  /** Up to 25 SarahCare source ids of changed rows (ids only, never content) */
  changedSourceIds: Array<Scalars['String']['output']>;
  examined: Scalars['Int']['output'];
  existing: Scalars['Int']['output'];
  inserted: Scalars['Int']['output'];
  /** Changed rows replaced in place (apply + refreshIfChanged) */
  refreshed: Scalars['Int']['output'];
  wouldInsert: Scalars['Int']['output'];
  /** Dry run: changed rows a refresh would replace in place */
  wouldRefresh: Scalars['Int']['output'];
};

export type SarahHistoricalRowInput = {
  payload: Scalars['String']['input'];
  /** Replace this row in place if its source changed (refreshable history tables only) */
  refreshIfChanged?: InputMaybe<Scalars['Boolean']['input']>;
  residentId: Scalars['ID']['input'];
  sourceAuthor: Scalars['String']['input'];
  sourceBackupDate: Scalars['DateTime']['input'];
  sourceId: Scalars['String']['input'];
  sourceResidentId: Scalars['String']['input'];
};

export type SarahHistoricalWipeResult = {
  __typename?: 'SarahHistoricalWipeResult';
  deleted: Scalars['Int']['output'];
  matched: Scalars['Int']['output'];
  table: Scalars['String']['output'];
};

export type SarahIncidentFollowUpSourceFields = {
  __typename?: 'SarahIncidentFollowUpSourceFields';
  followUpHistoryId?: Maybe<Scalars['String']['output']>;
  mprNo?: Maybe<Scalars['String']['output']>;
  oldFollowUp?: Maybe<Scalars['String']['output']>;
  theDateText?: Maybe<Scalars['String']['output']>;
  theUser?: Maybe<Scalars['String']['output']>;
};

export type SarahIncidentImportResult = {
  __typename?: 'SarahIncidentImportResult';
  /** Child rows not written: their incident is not imported yet, or changed and not refreshed yet */
  awaitingParent: Scalars['Int']['output'];
  /** Rows already imported whose source content differs now (never written unless refreshed) */
  changed: Scalars['Int']['output'];
  /** Changed rows that cannot be refreshed in place (edited after import, or table not refreshable) */
  changedHeld: Scalars['Int']['output'];
  /** Up to 25 SarahCare source ids of changed rows (ids only, never content) */
  changedSourceIds: Array<Scalars['String']['output']>;
  examined: Scalars['Int']['output'];
  existing: Scalars['Int']['output'];
  inserted: Scalars['Int']['output'];
  /** Changed rows replaced in place (apply + refreshIfChanged) */
  refreshed: Scalars['Int']['output'];
  wouldInsert: Scalars['Int']['output'];
  /** Dry run: changed rows a refresh would replace in place */
  wouldRefresh: Scalars['Int']['output'];
};

export type SarahIncidentInjurySourceFields = {
  __typename?: 'SarahIncidentInjurySourceFields';
  injuryId?: Maybe<Scalars['String']['output']>;
  insertedBy?: Maybe<Scalars['String']['output']>;
  insertedDateText?: Maybe<Scalars['String']['output']>;
  mprNo?: Maybe<Scalars['String']['output']>;
  syncText?: Maybe<Scalars['String']['output']>;
};

export type SarahIncidentSourceFields = {
  __typename?: 'SarahIncidentSourceFields';
  accidentIncidentType?: Maybe<Scalars['String']['output']>;
  careplanUpdated?: Maybe<Scalars['Boolean']['output']>;
  closeDateText?: Maybe<Scalars['String']['output']>;
  closedBy?: Maybe<Scalars['String']['output']>;
  contributingFactor?: Maybe<Scalars['String']['output']>;
  controlNumber?: Maybe<Scalars['String']['output']>;
  editedBy?: Maybe<Scalars['String']['output']>;
  editedTimeText?: Maybe<Scalars['String']['output']>;
  empId?: Maybe<Scalars['Int']['output']>;
  enteredBy?: Maybe<Scalars['String']['output']>;
  enteredTimeText?: Maybe<Scalars['String']['output']>;
  familyEmailSent?: Maybe<Scalars['Boolean']['output']>;
  followUp?: Maybe<Scalars['String']['output']>;
  followUpWrittenToProgressNotes?: Maybe<Scalars['Boolean']['output']>;
  gp?: Maybe<Scalars['Boolean']['output']>;
  hospital?: Maybe<Scalars['Boolean']['output']>;
  incId?: Maybe<Scalars['Int']['output']>;
  injury?: Maybe<Scalars['Boolean']['output']>;
  insertedBy?: Maybe<Scalars['String']['output']>;
  insertedDateText?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  logDateText?: Maybe<Scalars['String']['output']>;
  logTimeText?: Maybe<Scalars['String']['output']>;
  loggedBy?: Maybe<Scalars['String']['output']>;
  mprNo?: Maybe<Scalars['String']['output']>;
  neuroObsId?: Maybe<Scalars['String']['output']>;
  nok?: Maybe<Scalars['Boolean']['output']>;
  notifiedPharmacy?: Maybe<Scalars['Boolean']['output']>;
  obsNotes?: Maybe<Scalars['String']['output']>;
  otherResident?: Maybe<Scalars['String']['output']>;
  photoPath?: Maybe<Scalars['String']['output']>;
  physio?: Maybe<Scalars['Boolean']['output']>;
  rn?: Maybe<Scalars['Boolean']['output']>;
  syncText?: Maybe<Scalars['String']['output']>;
  treatmentPlanRequired?: Maybe<Scalars['Boolean']['output']>;
  wing?: Maybe<Scalars['String']['output']>;
};

export type SarahIncidentTypeMatch = {
  __typename?: 'SarahIncidentTypeMatch';
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  outcome: Scalars['String']['output'];
};

export type SarahIncidentWitnessSourceFields = {
  __typename?: 'SarahIncidentWitnessSourceFields';
  addDateText?: Maybe<Scalars['String']['output']>;
  addUser?: Maybe<Scalars['String']['output']>;
  editDateText?: Maybe<Scalars['String']['output']>;
  editUser?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  insertedBy?: Maybe<Scalars['String']['output']>;
  insertedDateText?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  mobile?: Maybe<Scalars['String']['output']>;
  mprNo?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  syncText?: Maybe<Scalars['String']['output']>;
  witnessId?: Maybe<Scalars['String']['output']>;
};

export type SarahMedicalSourceFields = {
  __typename?: 'SarahMedicalSourceFields';
  archiveDateText?: Maybe<Scalars['String']['output']>;
  archived?: Maybe<Scalars['Boolean']['output']>;
  archivedBy?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  documentDateText?: Maybe<Scalars['String']['output']>;
  documentPath?: Maybe<Scalars['String']['output']>;
  documentSourceId?: Maybe<Scalars['String']['output']>;
  documentTypeCode?: Maybe<Scalars['Int']['output']>;
  insertedAtText?: Maybe<Scalars['String']['output']>;
  insertedBy?: Maybe<Scalars['String']['output']>;
  medical?: Maybe<Scalars['Boolean']['output']>;
  residentSourceId?: Maybe<Scalars['String']['output']>;
};

export type SarahMobilityChangeSourceFields = {
  __typename?: 'SarahMobilityChangeSourceFields';
  changeSourceId?: Maybe<Scalars['String']['output']>;
  changedBy?: Maybe<Scalars['String']['output']>;
  dateChangedText?: Maybe<Scalars['String']['output']>;
  newAssist?: Maybe<Scalars['String']['output']>;
  newMobility?: Maybe<Scalars['String']['output']>;
  oldAssist?: Maybe<Scalars['String']['output']>;
  oldMobility?: Maybe<Scalars['String']['output']>;
  residentSourceId?: Maybe<Scalars['String']['output']>;
};

export type SarahNoteFollowupFields = {
  __typename?: 'SarahNoteFollowupFields';
  completedAtText?: Maybe<Scalars['String']['output']>;
  completedByText?: Maybe<Scalars['String']['output']>;
  createdAtText?: Maybe<Scalars['String']['output']>;
  createdByText?: Maybe<Scalars['String']['output']>;
  designationText?: Maybe<Scalars['String']['output']>;
  dueDateText?: Maybe<Scalars['String']['output']>;
  followupSourceId?: Maybe<Scalars['String']['output']>;
  individualText?: Maybe<Scalars['String']['output']>;
  noteText?: Maybe<Scalars['String']['output']>;
  parentNoteSourceId?: Maybe<Scalars['String']['output']>;
};

export type SarahNoteFollowupHistory = {
  __typename?: 'SarahNoteFollowupHistory';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  parentKind: Scalars['String']['output'];
  parentNoteId: Scalars['ID']['output'];
  residentId: Scalars['ID']['output'];
  residentName?: Maybe<Scalars['String']['output']>;
  sourceAuthor: Scalars['String']['output'];
  sourceBackupDate: Scalars['DateTime']['output'];
  sourceFields: SarahNoteFollowupFields;
  sourceId: Scalars['String']['output'];
  sourceSystem: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type SarahNoteFollowupHistoryResponse = {
  __typename?: 'SarahNoteFollowupHistoryResponse';
  records: Array<SarahNoteFollowupHistory>;
  total: Scalars['Int']['output'];
};

export type SarahNoteSourceFieldsResult = {
  __typename?: 'SarahNoteSourceFieldsResult';
  /** Note not imported yet, or its narrative changed and awaits the progress-notes refresh */
  awaitingParent: Scalars['Int']['output'];
  /** Stored original fields differ from this backup (not written unless refreshed) */
  changed: Scalars['Int']['output'];
  /** Always 0 here: original fields are provenance staff never edit */
  changedHeld: Scalars['Int']['output'];
  changedSourceIds: Array<Scalars['String']['output']>;
  examined: Scalars['Int']['output'];
  existing: Scalars['Int']['output'];
  refreshed: Scalars['Int']['output'];
  updated: Scalars['Int']['output'];
  wouldRefresh: Scalars['Int']['output'];
  wouldUpdate: Scalars['Int']['output'];
};

export type SarahObservationContextResult = {
  __typename?: 'SarahObservationContextResult';
  /** Observation not imported yet, or its values changed and await the observations refresh */
  awaitingParent: Scalars['Int']['output'];
  /** Stored source context differs from this backup (not written unless refreshed) */
  changed: Scalars['Int']['output'];
  changedHeld: Scalars['Int']['output'];
  changedSourceIds: Array<Scalars['String']['output']>;
  examined: Scalars['Int']['output'];
  existing: Scalars['Int']['output'];
  refreshed: Scalars['Int']['output'];
  updated: Scalars['Int']['output'];
  wouldRefresh: Scalars['Int']['output'];
  wouldUpdate: Scalars['Int']['output'];
};

export type SarahObservationSourceContext = {
  __typename?: 'SarahObservationSourceContext';
  addedAtText?: Maybe<Scalars['String']['output']>;
  addedBy?: Maybe<Scalars['String']['output']>;
  dateText?: Maybe<Scalars['String']['output']>;
  firstNameText?: Maybe<Scalars['String']['output']>;
  insertedAtText?: Maybe<Scalars['String']['output']>;
  insertedBy?: Maybe<Scalars['String']['output']>;
  irregular?: Maybe<Scalars['Boolean']['output']>;
  lastNameText?: Maybe<Scalars['String']['output']>;
  method?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['String']['output']>;
  residentKey?: Maybe<Scalars['String']['output']>;
  rowId?: Maybe<Scalars['String']['output']>;
  secondaryValue?: Maybe<Scalars['Float']['output']>;
  syncedAtText?: Maybe<Scalars['String']['output']>;
  timeText?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type SarahPainChartReadBack = {
  __typename?: 'SarahPainChartReadBack';
  /** Source ids asked about */
  examined: Scalars['Int']['output'];
  /** Of those, stored in this tenant */
  found: Scalars['Int']['output'];
  /** Stored rows whose fields re-hash to the hash taken at import */
  matched: Scalars['Int']['output'];
  mismatched: Scalars['Int']['output'];
  /** Up to 25 SarahCare source ids that did not match (ids only) */
  mismatchedSourceIds: Array<Scalars['String']['output']>;
  /** Every SarahCare row of this table in this tenant */
  totalInTenant: Scalars['Int']['output'];
};

export type SarahProgressNoteSourceFields = {
  __typename?: 'SarahProgressNoteSourceFields';
  authorFirstName?: Maybe<Scalars['String']['output']>;
  authorLastName?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  colourCode?: Maybe<Scalars['Int']['output']>;
  combinedDateTimeText?: Maybe<Scalars['String']['output']>;
  dateText?: Maybe<Scalars['String']['output']>;
  doctorVisitSourceId?: Maybe<Scalars['String']['output']>;
  exception?: Maybe<Scalars['Boolean']['output']>;
  exceptionDays?: Maybe<Scalars['Int']['output']>;
  insertedAtText?: Maybe<Scalars['String']['output']>;
  insertedBy?: Maybe<Scalars['String']['output']>;
  massNoteId?: Maybe<Scalars['Int']['output']>;
  medicalProgressNote?: Maybe<Scalars['Boolean']['output']>;
  mpr?: Maybe<Scalars['String']['output']>;
  noteSourceId?: Maybe<Scalars['String']['output']>;
  residentSourceId?: Maybe<Scalars['String']['output']>;
  syncedAtText?: Maybe<Scalars['String']['output']>;
  timeText?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  writtenInError?: Maybe<Scalars['Boolean']['output']>;
};

export type SarahPromotionPathCount = {
  __typename?: 'SarahPromotionPathCount';
  alreadyPromoted: Scalars['Int']['output'];
  filled: Scalars['Int']['output'];
  path: Scalars['String']['output'];
  skippedHasValue: Scalars['Int']['output'];
  skippedStatus: Scalars['Int']['output'];
  wouldFill: Scalars['Int']['output'];
};

export type SarahQuestionnaireAnswer = {
  __typename?: 'SarahQuestionnaireAnswer';
  assessmentHistoryId: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  questionDefinitionState: Scalars['String']['output'];
  questionReferenceId?: Maybe<Scalars['ID']['output']>;
  residentId: Scalars['ID']['output'];
  sourceAuthor: Scalars['String']['output'];
  sourceBackupDate: Scalars['DateTime']['output'];
  sourceFields: SarahQuestionnaireAnswerFields;
  sourceHash: Scalars['String']['output'];
  sourceId: Scalars['String']['output'];
  sourceSystem: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type SarahQuestionnaireAnswerFields = {
  __typename?: 'SarahQuestionnaireAnswerFields';
  addDateText?: Maybe<Scalars['String']['output']>;
  addUser?: Maybe<Scalars['String']['output']>;
  answer?: Maybe<Scalars['String']['output']>;
  answerSourceId?: Maybe<Scalars['String']['output']>;
  assessmentSourceId?: Maybe<Scalars['String']['output']>;
  comments?: Maybe<Scalars['String']['output']>;
  editDateText?: Maybe<Scalars['String']['output']>;
  editUser?: Maybe<Scalars['String']['output']>;
  insertedBy?: Maybe<Scalars['String']['output']>;
  insertedDateText?: Maybe<Scalars['String']['output']>;
  output?: Maybe<Scalars['String']['output']>;
  questionID?: Maybe<Scalars['Int']['output']>;
};

export type SarahQuestionnaireAnswerPage = {
  __typename?: 'SarahQuestionnaireAnswerPage';
  records: Array<SarahQuestionnaireAnswer>;
  total: Scalars['Int']['output'];
};

export type SarahQuestionnaireControlFields = {
  __typename?: 'SarahQuestionnaireControlFields';
  controlType?: Maybe<Scalars['String']['output']>;
  example?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  insertedBy?: Maybe<Scalars['String']['output']>;
  insertedDateText?: Maybe<Scalars['String']['output']>;
};

export type SarahQuestionnaireFormFields = {
  __typename?: 'SarahQuestionnaireFormFields';
  assessmentName?: Maybe<Scalars['String']['output']>;
  hideFromList?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  insertedBy?: Maybe<Scalars['String']['output']>;
  insertedDateText?: Maybe<Scalars['String']['output']>;
  interval?: Maybe<Scalars['String']['output']>;
  intervalDays?: Maybe<Scalars['Int']['output']>;
  intervalMonths?: Maybe<Scalars['Int']['output']>;
  intervalYears?: Maybe<Scalars['Int']['output']>;
  showContentsTable?: Maybe<Scalars['Boolean']['output']>;
};

export type SarahQuestionnaireHeaderFields = {
  __typename?: 'SarahQuestionnaireHeaderFields';
  addDateText?: Maybe<Scalars['String']['output']>;
  addUser?: Maybe<Scalars['String']['output']>;
  archiveDateText?: Maybe<Scalars['String']['output']>;
  archivedBy?: Maybe<Scalars['String']['output']>;
  assessmentDateText?: Maybe<Scalars['String']['output']>;
  assessmentID?: Maybe<Scalars['Int']['output']>;
  assessmentSourceId?: Maybe<Scalars['String']['output']>;
  completedDateText?: Maybe<Scalars['String']['output']>;
  dueDateText?: Maybe<Scalars['String']['output']>;
  editDateText?: Maybe<Scalars['String']['output']>;
  editUser?: Maybe<Scalars['String']['output']>;
  insertedBy?: Maybe<Scalars['String']['output']>;
  insertedDateText?: Maybe<Scalars['String']['output']>;
  onBehalfOf?: Maybe<Scalars['String']['output']>;
  residentSourceId?: Maybe<Scalars['String']['output']>;
  valid?: Maybe<Scalars['Boolean']['output']>;
};

export type SarahQuestionnaireHistory = {
  __typename?: 'SarahQuestionnaireHistory';
  canViewResident: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  formDefinitionState: Scalars['String']['output'];
  formReferenceId?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  residentDetailUrl?: Maybe<Scalars['String']['output']>;
  residentId: Scalars['ID']['output'];
  sourceAuthor: Scalars['String']['output'];
  sourceBackupDate: Scalars['DateTime']['output'];
  sourceFields: SarahQuestionnaireHeaderFields;
  sourceHash: Scalars['String']['output'];
  sourceId: Scalars['String']['output'];
  sourceSystem: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type SarahQuestionnaireHistoryPage = {
  __typename?: 'SarahQuestionnaireHistoryPage';
  records: Array<SarahQuestionnaireHistory>;
  total: Scalars['Int']['output'];
};

export type SarahQuestionnaireQuestionFields = {
  __typename?: 'SarahQuestionnaireQuestionFields';
  assessmentID?: Maybe<Scalars['Int']['output']>;
  commentHeading?: Maybe<Scalars['String']['output']>;
  conditions?: Maybe<Scalars['String']['output']>;
  controlTypeID?: Maybe<Scalars['Int']['output']>;
  data?: Maybe<Scalars['String']['output']>;
  dateCreatedText?: Maybe<Scalars['String']['output']>;
  expiryDateText?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  initialise?: Maybe<Scalars['String']['output']>;
  insertedBy?: Maybe<Scalars['String']['output']>;
  insertedDateText?: Maybe<Scalars['String']['output']>;
  output?: Maybe<Scalars['String']['output']>;
  question?: Maybe<Scalars['String']['output']>;
  questionOrder?: Maybe<Scalars['Float']['output']>;
  required?: Maybe<Scalars['Boolean']['output']>;
  validation?: Maybe<Scalars['String']['output']>;
};

export type SarahQuestionnaireReference = {
  __typename?: 'SarahQuestionnaireReference';
  control?: Maybe<SarahQuestionnaireControlFields>;
  createdAt: Scalars['DateTime']['output'];
  form?: Maybe<SarahQuestionnaireFormFields>;
  id: Scalars['ID']['output'];
  kind: Scalars['String']['output'];
  question?: Maybe<SarahQuestionnaireQuestionFields>;
  sourceAuthor: Scalars['String']['output'];
  sourceBackupDate: Scalars['DateTime']['output'];
  sourceHash: Scalars['String']['output'];
  sourceId: Scalars['String']['output'];
  sourceSystem: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type SarahQuestionnaireReferencePage = {
  __typename?: 'SarahQuestionnaireReferencePage';
  records: Array<SarahQuestionnaireReference>;
  total: Scalars['Int']['output'];
};

export type SarahResidentCreateRowInput = {
  /** JSON: identity, status and separation details only */
  payload: Scalars['String']['input'];
  sourceBackupDate: Scalars['DateTime']['input'];
  /** SarahCare Customers.[Customer Number] */
  sourceId: Scalars['String']['input'];
};

export type SarahResidentImportResult = {
  __typename?: 'SarahResidentImportResult';
  examined: Scalars['Int']['output'];
  /** A resident with this sarahCareId already exists (left untouched) */
  existing: Scalars['Int']['output'];
  /** Not created: same name + DOB already in PLCC, or CURRENT from a stale backup */
  held: Scalars['Int']['output'];
  /** Up to 25 "reason:sourceId" entries (ids only) */
  heldSourceIds: Array<Scalars['String']['output']>;
  inserted: Scalars['Int']['output'];
  wouldInsert: Scalars['Int']['output'];
};

export type SarahResidentPromotionResult = {
  __typename?: 'SarahResidentPromotionResult';
  alreadyPromoted: Scalars['Int']['output'];
  byPath: Array<SarahPromotionPathCount>;
  examined: Scalars['Int']['output'];
  /** Field values written (apply only) */
  filled: Scalars['Int']['output'];
  residentsChanged: Scalars['Int']['output'];
  /** Field values skipped because staff already recorded something there */
  skippedHasValue: Scalars['Int']['output'];
  /** Discharge reasons skipped because the resident has not left, or the reason contradicts their status */
  skippedStatus: Scalars['Int']['output'];
  /** Already-filled values whose SarahCare source differs in this (newer) backup. Reported only — a value staff confirm or edit is theirs and is never overwritten. */
  sourceChanged: Scalars['Int']['output'];
  /** Field values a real run would write (dry run only) */
  wouldFill: Scalars['Int']['output'];
};

export type SarahResidentPromotionRowInput = {
  fields: Scalars['String']['input'];
  residentId: Scalars['ID']['input'];
  sourceBackupDate: Scalars['DateTime']['input'];
  sourceId: Scalars['String']['input'];
  sourceResidentId: Scalars['String']['input'];
  sourceTable: Scalars['String']['input'];
};

export type SarahResidentPromotionWipeResult = {
  __typename?: 'SarahResidentPromotionWipeResult';
  /** Copied values staff confirmed or edited — never reverted */
  kept: Scalars['Int']['output'];
  /** Values still unconfirmed AND still equal to what was copied — these are reverted */
  matched: Scalars['Int']['output'];
  residents: Scalars['Int']['output'];
  reverted: Scalars['Int']['output'];
};

export type SarahRespiteStayReadBack = {
  __typename?: 'SarahRespiteStayReadBack';
  /** Source ids asked about */
  examined: Scalars['Int']['output'];
  /** Of those, stored in this tenant */
  found: Scalars['Int']['output'];
  /** Stored rows whose fields re-hash to the hash taken at import */
  matched: Scalars['Int']['output'];
  mismatched: Scalars['Int']['output'];
  /** Up to 25 SarahCare source ids that did not match (ids only) */
  mismatchedSourceIds: Array<Scalars['String']['output']>;
  /** Every SarahCare row of this table in this tenant */
  totalInTenant: Scalars['Int']['output'];
};

export type SarahRestraintCheckSourceFields = {
  __typename?: 'SarahRestraintCheckSourceFields';
  addedAtText?: Maybe<Scalars['String']['output']>;
  addedBy?: Maybe<Scalars['String']['output']>;
  checkedAtText?: Maybe<Scalars['String']['output']>;
  comments?: Maybe<Scalars['String']['output']>;
  restraintKey?: Maybe<Scalars['String']['output']>;
  rowId?: Maybe<Scalars['String']['output']>;
  statusCode?: Maybe<Scalars['String']['output']>;
  statusText?: Maybe<Scalars['String']['output']>;
};

export type SarahRestraintSourceFields = {
  __typename?: 'SarahRestraintSourceFields';
  authorisingDoctorKey?: Maybe<Scalars['String']['output']>;
  authorisingDoctorName?: Maybe<Scalars['String']['output']>;
  comments?: Maybe<Scalars['String']['output']>;
  endText?: Maybe<Scalars['String']['output']>;
  frequencyCount?: Maybe<Scalars['String']['output']>;
  frequencyType?: Maybe<Scalars['String']['output']>;
  insertedAtText?: Maybe<Scalars['String']['output']>;
  insertedBy?: Maybe<Scalars['String']['output']>;
  monitor?: Maybe<Scalars['Boolean']['output']>;
  residentKey?: Maybe<Scalars['String']['output']>;
  restraintTypeKey?: Maybe<Scalars['String']['output']>;
  restraintTypeText?: Maybe<Scalars['String']['output']>;
  reviewText?: Maybe<Scalars['String']['output']>;
  rowId?: Maybe<Scalars['String']['output']>;
  signedByAllParties?: Maybe<Scalars['Boolean']['output']>;
  startText?: Maybe<Scalars['String']['output']>;
};

export type SarahSourceFieldValue = {
  __typename?: 'SarahSourceFieldValue';
  /** SarahCare table and column, e.g. `CMA.ReasonForCMA` */
  column: Scalars['String']['output'];
  /** The original value as text; null when SarahCare held no value */
  value?: Maybe<Scalars['String']['output']>;
};

export type SarahVaccinationSourceFields = {
  __typename?: 'SarahVaccinationSourceFields';
  comments?: Maybe<Scalars['String']['output']>;
  insertedAtText?: Maybe<Scalars['String']['output']>;
  insertedBy?: Maybe<Scalars['String']['output']>;
  massEventComments?: Maybe<Scalars['String']['output']>;
  massEventCopiedToResidents?: Maybe<Scalars['Boolean']['output']>;
  massEventId?: Maybe<Scalars['String']['output']>;
  massEventInsertedAtText?: Maybe<Scalars['String']['output']>;
  massEventInsertedBy?: Maybe<Scalars['String']['output']>;
  nextDueText?: Maybe<Scalars['String']['output']>;
  refused?: Maybe<Scalars['Boolean']['output']>;
  residentKey?: Maybe<Scalars['String']['output']>;
  rowId?: Maybe<Scalars['String']['output']>;
  sourceTable?: Maybe<Scalars['String']['output']>;
  vaccineDateText?: Maybe<Scalars['String']['output']>;
  vaccineText?: Maybe<Scalars['String']['output']>;
};

export type SarahVoidedProgressNote = {
  __typename?: 'SarahVoidedProgressNote';
  content?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  residentId: Scalars['ID']['output'];
  residentName?: Maybe<Scalars['String']['output']>;
  sourceAuthor: Scalars['String']['output'];
  sourceBackupDate: Scalars['DateTime']['output'];
  sourceFields: SarahProgressNoteSourceFields;
  sourceId: Scalars['String']['output'];
  sourceSystem: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type SarahVoidedProgressNotesResponse = {
  __typename?: 'SarahVoidedProgressNotesResponse';
  notes: Array<SarahVoidedProgressNote>;
  total: Scalars['Int']['output'];
};

export type SarahWaitingListRowInput = {
  payload: Scalars['String']['input'];
  /** Replace this entry in place if its source changed (closed history entries only) */
  refreshIfChanged?: InputMaybe<Scalars['Boolean']['input']>;
  residentId?: InputMaybe<Scalars['ID']['input']>;
  sourceAuthor: Scalars['String']['input'];
  sourceBackupDate: Scalars['DateTime']['input'];
  sourceId: Scalars['String']['input'];
  sourceResidentId?: InputMaybe<Scalars['String']['input']>;
};

export type SarahWaitingListSourceFields = {
  __typename?: 'SarahWaitingListSourceFields';
  /** Original SarahCare Waiting list AcatExpiryDate (source timestamp text) */
  acatExpiryDateText?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare Waiting list AdmittedToFacility */
  admittedToFacility?: Maybe<Scalars['Boolean']['output']>;
  /** Original SarahCare Waiting list AHD */
  ahd?: Maybe<Scalars['Boolean']['output']>;
  /** Original SarahCare Waiting list AHDPath */
  ahdPath?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare Waiting list ArchiveDate (source timestamp text) */
  archiveDateText?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare Waiting list Archived */
  archived?: Maybe<Scalars['Boolean']['output']>;
  /** Original SarahCare Waiting list ArchivedBy */
  archivedBy?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare Waiting list AssetAmount */
  assetAmount?: Maybe<Scalars['Float']['output']>;
  /** Original SarahCare Waiting list AssetAssessmentDate (source timestamp text) */
  assetAssessmentDateText?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare Waiting list AssetAssessmentDone */
  assetAssessmentDone?: Maybe<Scalars['Boolean']['output']>;
  /** Original SarahCare Waiting list AssignedCustID */
  assignedCustId?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare Waiting list Care Type */
  careType?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare Waiting list Charge Exempt */
  chargeExempt?: Maybe<Scalars['Boolean']['output']>;
  /** Original SarahCare Waiting list CurrentStatus */
  currentStatus?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare Waiting list Date of Birth (source timestamp text) */
  dateOfBirthText?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare Waiting list DatePlacedOnList (source timestamp text) */
  datePlacedOnListText?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare Waiting list DVANo */
  dvaNo?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare Waiting list Email */
  email?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare Waiting list EmergencyACAS */
  emergencyAcas?: Maybe<Scalars['Boolean']['output']>;
  /** Original SarahCare Waiting list EnquirySource */
  enquirySource?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare Waiting list Entered a home before 1_10_97 */
  enteredAHomeBefore11097?: Maybe<Scalars['Boolean']['output']>;
  /** Original SarahCare Waiting list ExpectedRCS */
  expectedRcs?: Maybe<Scalars['Float']['output']>;
  /** Original SarahCare Waiting list Fax */
  fax?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare Waiting list First Name */
  firstName?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare Waiting list Gender */
  gender?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare Waiting list _InsertedBy */
  insertedBy?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare Waiting list _InsertedDate (source timestamp text) */
  insertedDateText?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare Waiting list Last Name */
  lastName?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare Waiting list Marital Status */
  maritalStatus?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare Waiting list MedicareNo */
  medicareNo?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare Waiting list MobilePhone */
  mobilePhone?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare Waiting list MyAgedCareNo */
  myAgedCareNo?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare Waiting list MyAgedCareRefCodePerm */
  myAgedCareRefCodePerm?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare Waiting list MyAgedCareRefCodeRespite */
  myAgedCareRefCodeRespite?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare Waiting list MyAgedCareRefCodeRespiteType */
  myAgedCareRefCodeRespiteType?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare Waiting list Notes */
  notes?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare Waiting list Other Phone */
  otherPhone?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare Waiting list OwnHome */
  ownHome?: Maybe<Scalars['Boolean']['output']>;
  /** Original SarahCare Waiting list PensionNo */
  pensionNo?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare Waiting list PensionType */
  pensionType?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare Waiting list Phone */
  phone?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare Waiting list PlannedAdmissionDate (source timestamp text) */
  plannedAdmissionDateText?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare Waiting list PlannedDischarge (source timestamp text) */
  plannedDischargeText?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare Waiting list PlannedRespite */
  plannedRespite?: Maybe<Scalars['Boolean']['output']>;
  /** Original SarahCare Waiting list PlannedRoom */
  plannedRoom?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare Waiting list PlannedWing */
  plannedWing?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare Waiting list Postal Address */
  postalAddress?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare Waiting list Power of Attorney */
  powerOfAttorney?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare Waiting list Preferred Name */
  preferredName?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare Waiting list Priority */
  priority?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare Waiting list RADVal */
  radVal?: Maybe<Scalars['Float']['output']>;
  /** Original SarahCare Waiting list RADDAPType */
  raddapType?: Maybe<Scalars['Float']['output']>;
  /** Original SarahCare Waiting list Religion */
  religion?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare Waiting list ResidentType */
  residentType?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare Waiting list Salutation */
  salutation?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare Waiting list SpecialRequest */
  specialRequest?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare Waiting list Unit type */
  unitType?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare Waiting list WaitingID */
  waitingId?: Maybe<Scalars['Float']['output']>;
  /** Original SarahCare Waiting list Wing */
  wing?: Maybe<Scalars['String']['output']>;
};

export type SarahWeightKeyResult = {
  __typename?: 'SarahWeightKeyResult';
  examined: Scalars['Int']['output'];
  existing: Scalars['Int']['output'];
  inserted: Scalars['Int']['output'];
  updated: Scalars['Int']['output'];
  wouldInsert: Scalars['Int']['output'];
  wouldUpdate: Scalars['Int']['output'];
};

export type SarahWoundAssessmentSourceFields = {
  __typename?: 'SarahWoundAssessmentSourceFields';
  addedAtText?: Maybe<Scalars['String']['output']>;
  addedBy?: Maybe<Scalars['String']['output']>;
  assessmentSourceId?: Maybe<Scalars['String']['output']>;
  dateText?: Maybe<Scalars['String']['output']>;
  depth?: Maybe<Scalars['Int']['output']>;
  edgePinkRed?: Maybe<Scalars['Boolean']['output']>;
  edgePurpleBlack?: Maybe<Scalars['Boolean']['output']>;
  edgeRaised?: Maybe<Scalars['Boolean']['output']>;
  edgeRolled?: Maybe<Scalars['Boolean']['output']>;
  epithelialisingPercent?: Maybe<Scalars['Int']['output']>;
  existingConditionOther?: Maybe<Scalars['String']['output']>;
  exudateAmountText?: Maybe<Scalars['String']['output']>;
  exudateTypeText?: Maybe<Scalars['String']['output']>;
  granulatingPercent?: Maybe<Scalars['Int']['output']>;
  greatestCavity?: Maybe<Scalars['Int']['output']>;
  highProteinDiet?: Maybe<Scalars['Boolean']['output']>;
  hypergranulationPercent?: Maybe<Scalars['Int']['output']>;
  insertedAtText?: Maybe<Scalars['String']['output']>;
  insertedBy?: Maybe<Scalars['String']['output']>;
  isWoundImprovingCode?: Maybe<Scalars['Int']['output']>;
  length?: Maybe<Scalars['Int']['output']>;
  necroticPercent?: Maybe<Scalars['Int']['output']>;
  odour?: Maybe<Scalars['String']['output']>;
  otherClinical?: Maybe<Scalars['String']['output']>;
  otherClinicalPercent?: Maybe<Scalars['Int']['output']>;
  otherExudateType?: Maybe<Scalars['String']['output']>;
  otherSkin?: Maybe<Scalars['String']['output']>;
  overallStatusCode?: Maybe<Scalars['Int']['output']>;
  painFrequencyCode?: Maybe<Scalars['Int']['output']>;
  painScore?: Maybe<Scalars['Int']['output']>;
  pictureFile?: Maybe<Scalars['String']['output']>;
  sloughyPercent?: Maybe<Scalars['Int']['output']>;
  surroundingSkinText?: Maybe<Scalars['String']['output']>;
  treatmentSourceId?: Maybe<Scalars['String']['output']>;
  underminedCavity?: Maybe<Scalars['Boolean']['output']>;
  width?: Maybe<Scalars['Int']['output']>;
  woundNotes?: Maybe<Scalars['String']['output']>;
};

export type SarahWoundSourceFields = {
  __typename?: 'SarahWoundSourceFields';
  addedAtText?: Maybe<Scalars['String']['output']>;
  addedBy?: Maybe<Scalars['String']['output']>;
  archived?: Maybe<Scalars['Boolean']['output']>;
  dateEndText?: Maybe<Scalars['String']['output']>;
  dateStartText?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  frequency?: Maybe<Scalars['Int']['output']>;
  insertedAtText?: Maybe<Scalars['String']['output']>;
  insertedBy?: Maybe<Scalars['String']['output']>;
  isMedicalOrder?: Maybe<Scalars['Boolean']['output']>;
  isWound?: Maybe<Scalars['Boolean']['output']>;
  mpr?: Maybe<Scalars['String']['output']>;
  photoRequired?: Maybe<Scalars['Boolean']['output']>;
  realStartDateText?: Maybe<Scalars['String']['output']>;
  residentSourceId?: Maybe<Scalars['String']['output']>;
  timeText?: Maybe<Scalars['String']['output']>;
  treatmentSourceId?: Maybe<Scalars['String']['output']>;
  woundAssessmentFrequency?: Maybe<Scalars['Int']['output']>;
  woundAssessmentRequired?: Maybe<Scalars['Boolean']['output']>;
  woundTypeText?: Maybe<Scalars['String']['output']>;
};

export type SaveAccountingXeroAppInput = {
  clientId: Scalars['String']['input'];
  clientSecret?: InputMaybe<Scalars['String']['input']>;
};

export type SaveAdvanceCarePlanInput = {
  directiveDate?: InputMaybe<Scalars['DateTime']['input']>;
  directiveLocation?: InputMaybe<Scalars['String']['input']>;
  directiveStatus?: InputMaybe<AdvanceCareDirectiveStatus>;
  discussedWith?: InputMaybe<Array<CarePlanParticipantInput>>;
  endOfLifeWishes?: InputMaybe<Scalars['String']['input']>;
  linkedCarePlanIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  markReviewed?: InputMaybe<Scalars['Boolean']['input']>;
  nextReviewDate?: InputMaybe<Scalars['DateTime']['input']>;
  preferredPlaceOfCare?: InputMaybe<Scalars['String']['input']>;
  residentId: Scalars['ID']['input'];
  resuscitationDate?: InputMaybe<Scalars['DateTime']['input']>;
  resuscitationDetails?: InputMaybe<Scalars['String']['input']>;
  resuscitationDocumentedBy?: InputMaybe<Scalars['String']['input']>;
  resuscitationWish?: InputMaybe<ResuscitationWish>;
  spiritualAndCulturalWishes?: InputMaybe<Scalars['String']['input']>;
  substituteDecisionMakerContactIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  substituteDecisionMakerNote?: InputMaybe<Scalars['String']['input']>;
};

export type SaveBuildProjectInput = {
  clearPropertyFile?: InputMaybe<Scalars['Boolean']['input']>;
  dealId: Scalars['ID']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  propertyFile?: InputMaybe<BuildUpdateFileInput>;
};

/** Save the tenant's own wording of a requirement (creates the copy on first save) */
export type SaveCareLegalRequirementInput = {
  appliesTo?: InputMaybe<Array<Scalars['String']['input']>>;
  basis: LegalBasis;
  citation: Scalars['String']['input'];
  daysFixedByLaw?: InputMaybe<Scalars['Int']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  key: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  requirement: Scalars['String']['input'];
  sourceTitle?: InputMaybe<Scalars['String']['input']>;
  sourceUrl?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  verifiedOn?: InputMaybe<Scalars['String']['input']>;
};

export type SaveEmailTemplateInput = {
  body: Scalars['String']['input'];
  kind: Scalars['String']['input'];
  stageKey: Scalars['String']['input'];
  subject: Scalars['String']['input'];
};

export type SaveEmpowermentReflectionInput = {
  answers: Array<EmpowermentAnswerInput>;
  checkInId: Scalars['ID']['input'];
};

export type SaveSovereigntyJourneyInput = {
  accessEntitlementNote?: InputMaybe<Scalars['String']['input']>;
  clientName: Scalars['String']['input'];
  clientTenantId: Scalars['ID']['input'];
  clientVisible?: InputMaybe<Scalars['Boolean']['input']>;
  draftMentorshipCents?: InputMaybe<Scalars['Int']['input']>;
  draftMentorshipMonths?: InputMaybe<Scalars['Int']['input']>;
  draftMilestoneCents?: InputMaybe<Scalars['Int']['input']>;
  hardwareNote?: InputMaybe<Scalars['String']['input']>;
  ownershipEvidenceReference?: InputMaybe<Scalars['String']['input']>;
  ownershipPosition?: InputMaybe<Scalars['String']['input']>;
  termsNote?: InputMaybe<Scalars['String']['input']>;
};

export type SaveWalletContactInput = {
  address: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  isFavourite?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
};

export type ScheduleInterventionInput = {
  calendarId?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  scheduleTimes: Array<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ScheduleInterviewInput = {
  attendeeEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  calendarId?: InputMaybe<Scalars['ID']['input']>;
  candidateId: Scalars['ID']['input'];
  durationMinutes?: Scalars['Int']['input'];
  location?: InputMaybe<Scalars['String']['input']>;
  /** Leave empty to create a Meet room automatically (tenant must have the meet module enabled) */
  meetingUrl?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  scheduledAt: Scalars['String']['input'];
};

export type ScheduleInterviewResult = {
  __typename?: 'ScheduleInterviewResult';
  calendarEventId?: Maybe<Scalars['String']['output']>;
  draftMessage?: Maybe<CandidateMessage>;
  /** true when a Meet room was created for this interview */
  meetRoomCreated?: Maybe<Scalars['Boolean']['output']>;
  /** The join link used — caller-supplied or the auto-created Meet room */
  meetingUrl?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type ScheduledPayment = {
  __typename?: 'ScheduledPayment';
  billId?: Maybe<Scalars['ID']['output']>;
  daysAfterPrevious?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
};

export type ScheduledPaymentInput = {
  billId?: InputMaybe<Scalars['ID']['input']>;
  daysAfterPrevious?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
};

export type SearchFolderCount = {
  __typename?: 'SearchFolderCount';
  folder: Scalars['String']['output'];
  total: Scalars['Int']['output'];
};

export type SearchImage = {
  __typename?: 'SearchImage';
  alt_description?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  height: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  urls: ImageUrls;
  user: ImageUser;
  width: Scalars['Int']['output'];
};

export type SearchKnownSender = {
  __typename?: 'SearchKnownSender';
  email: Scalars['String']['output'];
  emailsSeen: Scalars['Int']['output'];
  inYourMail: Scalars['Int']['output'];
  lastSeenAt?: Maybe<Scalars['DateTime']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type SearchLabelCount = {
  __typename?: 'SearchLabelCount';
  count: Scalars['Int']['output'];
  label: Scalars['String']['output'];
};

export type SearchPersonEventsResultGql = {
  __typename?: 'SearchPersonEventsResultGql';
  aiNotes?: Maybe<Scalars['String']['output']>;
  personName: Scalars['String']['output'];
  previews: Array<PersonEventPreviewGql>;
};

/** How often a site is meant to be scanned */
export enum SecurityCadence {
  Hourly = 'HOURLY',
  Manual = 'MANUAL',
  Weekly = 'WEEKLY'
}

/** The part of the scan a check belongs to */
export enum SecurityCheckPhase {
  Auth = 'AUTH',
  Frontend = 'FRONTEND',
  Unauth = 'UNAUTH'
}

export type SecurityFinding = {
  __typename?: 'SecurityFinding';
  category: SecurityFindingCategory;
  /** The scanner's stable check id */
  code: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  /** What the scanner saw — a shape or a count, never data */
  evidence: Scalars['String']['output'];
  /** What someone could do with it, in plain words */
  exploit: Scalars['String']['output'];
  firstScanId?: Maybe<Scalars['String']['output']>;
  firstSeenAt: Scalars['DateTime']['output'];
  /** How to fix it */
  fix: Scalars['String']['output'];
  fixedAt?: Maybe<Scalars['DateTime']['output']>;
  history: Array<SecurityFindingEvent>;
  id: Scalars['ID']['output'];
  lastScanId?: Maybe<Scalars['String']['output']>;
  lastSeenAt: Scalars['DateTime']['output'];
  phase: SecurityCheckPhase;
  severity: SecuritySeverity;
  status: SecurityFindingStatus;
  /** The reason given with the latest status change by a person */
  statusReason?: Maybe<Scalars['String']['output']>;
  targetCode: Scalars['String']['output'];
  targetId: Scalars['String']['output'];
  targetName: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** What kind of weakness a finding is */
export enum SecurityFindingCategory {
  BrokenAccessControl = 'BROKEN_ACCESS_CONTROL',
  Config = 'CONFIG',
  Idor = 'IDOR',
  InfoDisclosure = 'INFO_DISCLOSURE',
  Injection = 'INJECTION',
  PrivEsc = 'PRIV_ESC'
}

export type SecurityFindingEvent = {
  __typename?: 'SecurityFindingEvent';
  at: Scalars['DateTime']['output'];
  byId?: Maybe<Scalars['String']['output']>;
  byName?: Maybe<Scalars['String']['output']>;
  fromStatus?: Maybe<SecurityFindingStatus>;
  kind: SecurityFindingEventKind;
  reason?: Maybe<Scalars['String']['output']>;
  scanId?: Maybe<Scalars['String']['output']>;
  toStatus?: Maybe<SecurityFindingStatus>;
};

/** What happened to a finding */
export enum SecurityFindingEventKind {
  AutoFixed = 'AUTO_FIXED',
  FirstSeen = 'FIRST_SEEN',
  Regressed = 'REGRESSED',
  StatusChanged = 'STATUS_CHANGED'
}

export type SecurityFindingFilterInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Words to find in the title or check code */
  search?: InputMaybe<Scalars['String']['input']>;
  severities?: InputMaybe<Array<SecuritySeverity>>;
  statuses?: InputMaybe<Array<SecurityFindingStatus>>;
  targetId?: InputMaybe<Scalars['ID']['input']>;
};

export type SecurityFindingPage = {
  __typename?: 'SecurityFindingPage';
  items: Array<SecurityFinding>;
  limit: Scalars['Int']['output'];
  offset: Scalars['Int']['output'];
  /** All findings matching the filter (items may be fewer — see limit/offset) */
  total: Scalars['Int']['output'];
};

/** Where a security finding stands */
export enum SecurityFindingStatus {
  AcceptedRisk = 'ACCEPTED_RISK',
  Fixed = 'FIXED',
  Open = 'OPEN',
  Regressed = 'REGRESSED'
}

export type SecurityOverview = {
  __typename?: 'SecurityOverview';
  acceptedCount: Scalars['Int']['output'];
  lastScanAt?: Maybe<Scalars['DateTime']['output']>;
  openCounts: SecuritySeverityCounts;
  openTotal: Scalars['Int']['output'];
  overdueCount: Scalars['Int']['output'];
  /** Every site, A–Z by name */
  sites: Array<SecuritySiteSummary>;
};

export type SecurityScan = {
  __typename?: 'SecurityScan';
  /** False when an older scan arrived after a newer one — stored, but finding statuses were left alone */
  appliedToFindings: Scalars['Boolean']['output'];
  /** The signed-in (employee) checks ran */
  authRan: Scalars['Boolean']['output'];
  authSkip?: Maybe<Scalars['String']['output']>;
  /** Findings this scan reported, by severity */
  counts: SecuritySeverityCounts;
  createdAt: Scalars['DateTime']['output'];
  /** The scanner's exit code: 1 when a CRITICAL was reported, else 0 */
  exitCode: Scalars['Int']['output'];
  findingCount: Scalars['Int']['output'];
  finishedAt: Scalars['DateTime']['output'];
  /** Findings this scan marked fixed */
  fixedCount: Scalars['Int']['output'];
  frontendNote?: Maybe<Scalars['String']['output']>;
  /** The public-site checks ran completely (bundle found and read) */
  frontendRan: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  /** Findings seen for the first time */
  newCount: Scalars['Int']['output'];
  /** Check codes that ran and found nothing */
  passedCodes: Array<Scalars['String']['output']>;
  /** The scanner's own phase label, e.g. UNAUTH+FRONTEND or FULL */
  phaseLabel: Scalars['String']['output'];
  /** Fixed findings this scan saw again */
  regressedCount: Scalars['Int']['output'];
  runner: SecurityScanRunner;
  startedAt: Scalars['DateTime']['output'];
  submittedById?: Maybe<Scalars['String']['output']>;
  /** Who uploaded it (the scanner's sign-in) */
  submittedByName?: Maybe<Scalars['String']['output']>;
  targetCode: Scalars['String']['output'];
  targetId: Scalars['String']['output'];
  targetName: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type SecurityScanFindingInput = {
  category: SecurityFindingCategory;
  code: Scalars['String']['input'];
  evidence: Scalars['String']['input'];
  exploit: Scalars['String']['input'];
  fix: Scalars['String']['input'];
  phase: SecurityCheckPhase;
  severity: SecuritySeverity;
  title: Scalars['String']['input'];
};

export type SecurityScanPage = {
  __typename?: 'SecurityScanPage';
  items: Array<SecurityScan>;
  total: Scalars['Int']['output'];
};

export type SecurityScanPoint = {
  __typename?: 'SecurityScanPoint';
  counts: SecuritySeverityCounts;
  findingCount: Scalars['Int']['output'];
  finishedAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
};

/** What ran a security scan */
export enum SecurityScanRunner {
  Cli = 'CLI',
  Daemon = 'DAEMON',
  Manual = 'MANUAL'
}

export type SecurityScanSubmitResult = {
  __typename?: 'SecurityScanSubmitResult';
  /** False when this scan is older than the site's latest — stored, statuses left alone */
  appliedToFindings: Scalars['Boolean']['output'];
  /** This exact scan (same site + start time) was already uploaded; nothing changed */
  duplicate: Scalars['Boolean']['output'];
  fixedCount: Scalars['Int']['output'];
  newCount: Scalars['Int']['output'];
  /** Open + regressed findings on the site after this upload */
  openTotal: Scalars['Int']['output'];
  regressedCount: Scalars['Int']['output'];
  scanId: Scalars['String']['output'];
  targetId: Scalars['String']['output'];
};

export type SecurityScanTargetInput = {
  backendUrl?: InputMaybe<Scalars['String']['input']>;
  cadence?: InputMaybe<SecurityCadence>;
  code: Scalars['String']['input'];
  domain?: InputMaybe<Scalars['String']['input']>;
  frontendUrl?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  targetTenantId?: InputMaybe<Scalars['String']['input']>;
  testUserLabel?: InputMaybe<Scalars['String']['input']>;
};

/** How bad a security finding is */
export enum SecuritySeverity {
  Critical = 'CRITICAL',
  High = 'HIGH',
  Info = 'INFO',
  Low = 'LOW',
  Medium = 'MEDIUM'
}

export type SecuritySeverityCounts = {
  __typename?: 'SecuritySeverityCounts';
  critical: Scalars['Int']['output'];
  high: Scalars['Int']['output'];
  info: Scalars['Int']['output'];
  low: Scalars['Int']['output'];
  medium: Scalars['Int']['output'];
};

export type SecuritySiteSummary = {
  __typename?: 'SecuritySiteSummary';
  acceptedCount: Scalars['Int']['output'];
  fixedCount: Scalars['Int']['output'];
  /** Open + regressed findings, by severity */
  openCounts: SecuritySeverityCounts;
  /** Open + regressed findings, all severities */
  openTotal: Scalars['Int']['output'];
  /** Enabled, has a due date, and the due date has passed */
  overdue: Scalars['Boolean']['output'];
  /** Up to the last 10 scans, oldest first */
  recentScans: Array<SecurityScanPoint>;
  target: SecurityTarget;
};

export type SecurityTarget = {
  __typename?: 'SecurityTarget';
  backendUrl?: Maybe<Scalars['String']['output']>;
  cadence: SecurityCadence;
  /** The tenant-gql code for the site, e.g. plcc */
  code: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  domain?: Maybe<Scalars['String']['output']>;
  /** Off = not expected to be scanned; never counted as overdue */
  enabled: Scalars['Boolean']['output'];
  frontendUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Whether the latest scan ran the signed-in (employee) checks */
  lastAuthRan: Scalars['Boolean']['output'];
  /** Why the latest scan skipped the signed-in checks */
  lastAuthSkip?: Maybe<Scalars['String']['output']>;
  lastScanAt?: Maybe<Scalars['DateTime']['output']>;
  lastScanId?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  /** lastScanAt + cadence; empty for MANUAL */
  nextDueAt?: Maybe<Scalars['DateTime']['output']>;
  /** The site's own tenant id (the site under test, not this one) */
  targetTenantId?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  /** Name of the scanner's low-privilege login — a label, never a secret */
  testUserLabel?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type SeedResult = {
  __typename?: 'SeedResult';
  created: Scalars['Int']['output'];
  errors: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  updated: Scalars['Int']['output'];
};

export type SellerProfile = {
  __typename?: 'SellerProfile';
  aboutStory?: Maybe<Scalars['String']['output']>;
  address?: Maybe<SellerProfileAddress>;
  allowedEditors: Array<Client>;
  allowedEditorsClients: Array<Client>;
  averageRating: Scalars['Float']['output'];
  businessHours: Array<SellerProfileBusinessHours>;
  businessName: Scalars['String']['output'];
  businessType: BusinessType;
  categories: Array<Scalars['String']['output']>;
  certifications?: Maybe<Scalars['String']['output']>;
  contactEmail?: Maybe<Scalars['String']['output']>;
  contactPhone?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deliveryRadius?: Maybe<Scalars['Float']['output']>;
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  images: Array<Scalars['String']['output']>;
  isFeatured: Scalars['Boolean']['output'];
  isVerified: Scalars['Boolean']['output'];
  logoImage?: Maybe<Scalars['String']['output']>;
  madeByClient: Client;
  madeByClientId: Client;
  minimumOrderAmount?: Maybe<Scalars['Float']['output']>;
  offersDelivery: Scalars['Boolean']['output'];
  offersPickup: Scalars['Boolean']['output'];
  offersShipping: Scalars['Boolean']['output'];
  reviewCount: Scalars['Float']['output'];
  socialMedia?: Maybe<SellerProfileSocialMedia>;
  specialties: Array<Scalars['String']['output']>;
  status: SellerProfileStatus;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  yearsInBusiness?: Maybe<Scalars['Float']['output']>;
};

export type SellerProfileAddress = {
  __typename?: 'SellerProfileAddress';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
};

export type SellerProfileAddressInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
};

export type SellerProfileBusinessHours = {
  __typename?: 'SellerProfileBusinessHours';
  closeTime?: Maybe<Scalars['String']['output']>;
  day: Scalars['String']['output'];
  isClosed: Scalars['Boolean']['output'];
  openTime?: Maybe<Scalars['String']['output']>;
};

export type SellerProfileBusinessHoursInput = {
  closeTime?: InputMaybe<Scalars['String']['input']>;
  day: Scalars['String']['input'];
  isClosed: Scalars['Boolean']['input'];
  openTime?: InputMaybe<Scalars['String']['input']>;
};

export type SellerProfileInput = {
  aboutStory?: InputMaybe<Scalars['String']['input']>;
  address?: InputMaybe<SellerProfileAddressInput>;
  allowedEditors?: InputMaybe<Array<Scalars['String']['input']>>;
  businessHours?: InputMaybe<Array<SellerProfileBusinessHoursInput>>;
  businessName: Scalars['String']['input'];
  businessType: BusinessType;
  categories?: InputMaybe<Array<Scalars['String']['input']>>;
  certifications?: InputMaybe<Scalars['String']['input']>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactPhone?: InputMaybe<Scalars['String']['input']>;
  deliveryRadius?: InputMaybe<Scalars['Float']['input']>;
  description: Scalars['String']['input'];
  images?: InputMaybe<Array<Scalars['String']['input']>>;
  logoImage?: InputMaybe<Scalars['String']['input']>;
  minimumOrderAmount?: InputMaybe<Scalars['Float']['input']>;
  offersDelivery?: InputMaybe<Scalars['Boolean']['input']>;
  offersPickup?: InputMaybe<Scalars['Boolean']['input']>;
  offersShipping?: InputMaybe<Scalars['Boolean']['input']>;
  socialMedia?: InputMaybe<SellerProfileSocialMediaInput>;
  specialties?: InputMaybe<Array<Scalars['String']['input']>>;
  yearsInBusiness?: InputMaybe<Scalars['Float']['input']>;
};

export type SellerProfileSocialMedia = {
  __typename?: 'SellerProfileSocialMedia';
  facebook?: Maybe<Scalars['String']['output']>;
  instagram?: Maybe<Scalars['String']['output']>;
  linkedin?: Maybe<Scalars['String']['output']>;
  tiktok?: Maybe<Scalars['String']['output']>;
  twitter?: Maybe<Scalars['String']['output']>;
  website?: Maybe<Scalars['String']['output']>;
  youtube?: Maybe<Scalars['String']['output']>;
};

export type SellerProfileSocialMediaInput = {
  facebook?: InputMaybe<Scalars['String']['input']>;
  instagram?: InputMaybe<Scalars['String']['input']>;
  linkedin?: InputMaybe<Scalars['String']['input']>;
  tiktok?: InputMaybe<Scalars['String']['input']>;
  twitter?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
  youtube?: InputMaybe<Scalars['String']['input']>;
};

/** The status of the seller profile */
export enum SellerProfileStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  PendingReview = 'PENDING_REVIEW',
  Suspended = 'SUSPENDED'
}

export type SendBdayEveReminderSmsInput = {
  guestId: Scalars['String']['input'];
  message: Scalars['String']['input'];
};

export type SendBdayFollowUpSmsInput = {
  followUpNumber: Scalars['Float']['input'];
  guestId: Scalars['String']['input'];
  message: Scalars['String']['input'];
};

export type SendBdayInviteSmsInput = {
  customMessage?: InputMaybe<Scalars['String']['input']>;
  guestId: Scalars['String']['input'];
};

export type SendBuildEmailInput = {
  body: Scalars['String']['input'];
  dealId: Scalars['ID']['input'];
  subject: Scalars['String']['input'];
};

export type SendBuildMessageInput = {
  body: Scalars['String']['input'];
  dealId: Scalars['ID']['input'];
};

export type SendBuildMessageResult = {
  __typename?: 'SendBuildMessageResult';
  message: BuildMessageView;
  summary: Scalars['String']['output'];
};

export type SendClientProgressInput = {
  body: Scalars['String']['input'];
  dealId: Scalars['ID']['input'];
  report?: InputMaybe<BuildUpdateFileInput>;
  sendSms?: InputMaybe<Scalars['Boolean']['input']>;
  subject: Scalars['String']['input'];
};

export type SendClub52MessageInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  channel: Club52MessageChannel;
  kind: Club52MessageKind;
  playerEmail: Scalars['String']['input'];
  roomName: Scalars['String']['input'];
  subject?: InputMaybe<Scalars['String']['input']>;
  templateKey?: InputMaybe<Scalars['String']['input']>;
};

export type SendClub52MessageResult = {
  __typename?: 'SendClub52MessageResult';
  channel: Club52MessageChannel;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
  to: Scalars['String']['output'];
};

export type SendCommunityInviteChaseInput = {
  customMessage?: InputMaybe<Scalars['String']['input']>;
  inviteId: Scalars['ID']['input'];
};

export type SendEditCommandInput = {
  prompt: Scalars['String']['input'];
  siteId: Scalars['String']['input'];
};

export type SendEmpowermentReminderInput = {
  channels: Array<Scalars['String']['input']>;
  checkInId: Scalars['ID']['input'];
  to: Scalars['String']['input'];
};

export type SendLeadFlowActionInput = {
  actionId: Scalars['String']['input'];
  bodyOverride?: InputMaybe<Scalars['String']['input']>;
  leadId: Scalars['String']['input'];
  subjectOverride?: InputMaybe<Scalars['String']['input']>;
};

export type SendLeadFlowActionToManyInput = {
  actionId: Scalars['String']['input'];
  bodyOverride?: InputMaybe<Scalars['String']['input']>;
  leadIds: Array<Scalars['String']['input']>;
  subjectOverride?: InputMaybe<Scalars['String']['input']>;
};

export type SendLocalAiQueryInput = {
  /** Friendly model name — must match one of the entries returned by availableLocalAiModels */
  model: Scalars['String']['input'];
  /** User prompt. No system-prompt support in v1 — feature flagged for later. */
  prompt: Scalars['String']['input'];
};

export type SendMeetTranscriptInput = {
  includeFullTranscript?: InputMaybe<Scalars['Boolean']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  recipients: Array<Scalars['String']['input']>;
  recordingId: Scalars['ID']['input'];
  roomName: Scalars['String']['input'];
  subject?: InputMaybe<Scalars['String']['input']>;
};

export type SendMeetingMessageInput = {
  attendeeEmail: Scalars['String']['input'];
  body?: InputMaybe<Scalars['String']['input']>;
  channel: MeetMessageChannel;
  contactPreference: MeetContactPreference;
  kind: MeetMessageKind;
  roomName: Scalars['String']['input'];
  subject?: InputMaybe<Scalars['String']['input']>;
  templateKey?: InputMaybe<Scalars['String']['input']>;
};

export type SendMeetingMessageResult = {
  __typename?: 'SendMeetingMessageResult';
  channel: MeetMessageChannel;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
  to: Scalars['String']['output'];
};

export type SendMessageInput = {
  content: Scalars['String']['input'];
  contentType?: InputMaybe<MessageContentType>;
  replyToId?: InputMaybe<Scalars['String']['input']>;
  roomId: Scalars['String']['input'];
};

export type SendMotivationInput = {
  channel?: InputMaybe<GrowthCommunicationChannel>;
  customContent?: InputMaybe<Scalars['String']['input']>;
  customSubject?: InputMaybe<Scalars['String']['input']>;
  opportunityId?: InputMaybe<Scalars['String']['input']>;
  recipientEmail?: InputMaybe<Scalars['String']['input']>;
  recipientId: Scalars['String']['input'];
  recipientName?: InputMaybe<Scalars['String']['input']>;
  recipientPhone?: InputMaybe<Scalars['String']['input']>;
  templateId?: InputMaybe<Scalars['String']['input']>;
  tenantId: Scalars['String']['input'];
};

export type SendP2ActionInput = {
  actionId: Scalars['String']['input'];
  bodyOverride?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['String']['input'];
  subjectOverride?: InputMaybe<Scalars['String']['input']>;
};

export type SendPolicyBroadcastInput = {
  employeeIds: Array<Scalars['ID']['input']>;
  extraNote?: InputMaybe<Scalars['String']['input']>;
  policyId: Scalars['ID']['input'];
  versionNumber: Scalars['Int']['input'];
};

export type SendSeparationInviteChaseInput = {
  customMessage?: InputMaybe<Scalars['String']['input']>;
  inviteId: Scalars['ID']['input'];
};

export type SendSmsBroadcastInput = {
  employeeIds: Array<Scalars['ID']['input']>;
  forceAlphaId?: InputMaybe<Scalars['Boolean']['input']>;
  message: Scalars['String']['input'];
  phoneMode: SmsPhoneMode;
};

export type SendTeamOverviewInput = {
  includeTom?: InputMaybe<Scalars['Boolean']['input']>;
  profileKeys: Array<Scalars['String']['input']>;
};

export type SendTomMessageInput = {
  attachments?: InputMaybe<Array<TomAttachmentInput>>;
  content: Scalars['String']['input'];
  conversationId: Scalars['String']['input'];
  imageUrls?: InputMaybe<Array<Scalars['String']['input']>>;
  pageContext: TomPageContextInput;
};

export type SendVisionBoardInviteChaseInput = {
  customMessage?: InputMaybe<Scalars['String']['input']>;
  inviteId: Scalars['ID']['input'];
};

export type SendWaitingListTourMessageInput = {
  /** The email text as the person left it */
  emailBody?: InputMaybe<Scalars['String']['input']>;
  entryId: Scalars['ID']['input'];
  sendEmail: Scalars['Boolean']['input'];
  sendSms: Scalars['Boolean']['input'];
  /** The SMS as the person left it (≤ 480 characters) */
  smsBody?: InputMaybe<Scalars['String']['input']>;
  /** The email subject as the person left it */
  subject?: InputMaybe<Scalars['String']['input']>;
};

export type SenderSummary = {
  __typename?: 'SenderSummary';
  conversationCount: Scalars['Int']['output'];
  count: Scalars['Int']['output'];
  from: Scalars['String']['output'];
  fromName?: Maybe<Scalars['String']['output']>;
  lastDate: Scalars['DateTime']['output'];
};

/** Type of message sender */
export enum SenderType {
  Anonymous = 'ANONYMOUS',
  Authenticated = 'AUTHENTICATED',
  System = 'SYSTEM'
}

export type SeniorCardDetails = {
  __typename?: 'SeniorCardDetails';
  expiryDate?: Maybe<Scalars['DateTime']['output']>;
  number?: Maybe<Scalars['String']['output']>;
};

export type SeniorCardDetailsInput = {
  expiryDate?: InputMaybe<Scalars['DateTime']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
};

export type SeparationAdhocBlockInput = {
  carer: SeparationCarer;
  caseId?: InputMaybe<Scalars['ID']['input']>;
  childIds?: Array<Scalars['ID']['input']>;
  endsAt: Scalars['String']['input'];
  label?: InputMaybe<Scalars['String']['input']>;
  startsAt: Scalars['String']['input'];
};

export type SeparationAffiliate = {
  __typename?: 'SeparationAffiliate';
  clientId: Scalars['ID']['output'];
  code: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  defaultPercent: Scalars['Float']['output'];
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type SeparationAffiliateSummary = {
  __typename?: 'SeparationAffiliateSummary';
  affiliateId: Scalars['ID']['output'];
  code: Scalars['String']['output'];
  commissionEarned: Scalars['Float']['output'];
  commissionOwing: Scalars['Float']['output'];
  commissionPaid: Scalars['Float']['output'];
  commissionReversed: Scalars['Float']['output'];
  converted: Scalars['Float']['output'];
  totalReferrals: Scalars['Float']['output'];
};

export type SeparationAllocateInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  requestId: Scalars['ID']['input'];
};

export type SeparationCareBlock = {
  __typename?: 'SeparationCareBlock';
  autoConfirmAt: Scalars['DateTime']['output'];
  cancelledAt?: Maybe<Scalars['DateTime']['output']>;
  carer: SeparationCarer;
  caseDayLabel: Scalars['String']['output'];
  caseId: Scalars['ID']['output'];
  childIds: Array<Scalars['ID']['output']>;
  createdAt: Scalars['DateTime']['output'];
  endsAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  label?: Maybe<Scalars['String']['output']>;
  nights: Scalars['Int']['output'];
  remindedParents: Array<Scalars['String']['output']>;
  scheduleId?: Maybe<Scalars['ID']['output']>;
  source: SeparationCareBlockSource;
  startDayKey: Scalars['String']['output'];
  startsAt: Scalars['DateTime']['output'];
  state: SeparationCareBlockState;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type SeparationCareBlockRangeInput = {
  caseId?: InputMaybe<Scalars['ID']['input']>;
  fromDate: Scalars['String']['input'];
  toDate: Scalars['String']['input'];
};

/** Whether a care block came from the schedule or was added by hand */
export enum SeparationCareBlockSource {
  Adhoc = 'ADHOC',
  Schedule = 'SCHEDULE'
}

/** Lifecycle of a care block. AUTO_CONFIRMED is derived at read time from autoConfirmAt. */
export enum SeparationCareBlockState {
  AutoConfirmed = 'AUTO_CONFIRMED',
  Cancelled = 'CANCELLED',
  Confirmed = 'CONFIRMED',
  Disputed = 'DISPUTED',
  Planned = 'PLANNED'
}

export type SeparationCareBlockView = {
  __typename?: 'SeparationCareBlockView';
  awaitingMyConfirmation: Scalars['Boolean']['output'];
  block: SeparationCareBlock;
  childFirstNames: Array<Scalars['String']['output']>;
  effectiveState: SeparationCareBlockState;
  entry?: Maybe<SeparationCareLogEntry>;
  whenLabel: Scalars['String']['output'];
};

export type SeparationCareLogEntry = {
  __typename?: 'SeparationCareLogEntry';
  actualEndsAt?: Maybe<Scalars['DateTime']['output']>;
  actualStartsAt?: Maybe<Scalars['DateTime']['output']>;
  attachmentCids: Array<Scalars['String']['output']>;
  careBlockId: Scalars['ID']['output'];
  carer: SeparationCarer;
  caseId: Scalars['ID']['output'];
  childIds: Array<Scalars['ID']['output']>;
  confirmations: Array<SeparationConfirmation>;
  correctedByClientId?: Maybe<Scalars['ID']['output']>;
  correctionReason?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  nights: Scalars['Int']['output'];
  note?: Maybe<Scalars['String']['output']>;
  outcome: SeparationLedgerOutcome;
  plannedEndsAt: Scalars['DateTime']['output'];
  plannedStartsAt: Scalars['DateTime']['output'];
  supersededByEntryId?: Maybe<Scalars['ID']['output']>;
  supersedesEntryId?: Maybe<Scalars['ID']['output']>;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  varianceEndMinutes: Scalars['Int']['output'];
  varianceStartMinutes: Scalars['Int']['output'];
};

/** Which parent has care during a block */
export enum SeparationCarer {
  ParentA = 'PARENT_A',
  ParentB = 'PARENT_B'
}

export type SeparationCase = {
  __typename?: 'SeparationCase';
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  parentAClientId: Scalars['ID']['output'];
  parentAName?: Maybe<Scalars['String']['output']>;
  parentBClientId?: Maybe<Scalars['ID']['output']>;
  parentBName?: Maybe<Scalars['String']['output']>;
  status: SeparationCaseStatus;
  tenantId: Scalars['String']['output'];
  timezone: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type SeparationCaseInput = {
  parentAName?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

/** Lifecycle of a co-parenting case */
export enum SeparationCaseStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
  Settled = 'SETTLED'
}

export type SeparationCaseUpdateInput = {
  parentAName?: InputMaybe<Scalars['String']['input']>;
  parentBName?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<SeparationCaseStatus>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type SeparationChild = {
  __typename?: 'SeparationChild';
  caseId: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  dateOfBirth?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  fName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lName?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  sortOrder: Scalars['Int']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type SeparationChildInput = {
  caseId?: InputMaybe<Scalars['ID']['input']>;
  dateOfBirth?: InputMaybe<Scalars['String']['input']>;
  fName: Scalars['String']['input'];
  lName?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
};

export type SeparationChildUpdateInput = {
  dateOfBirth?: InputMaybe<Scalars['String']['input']>;
  fName?: InputMaybe<Scalars['String']['input']>;
  lName?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
};

export type SeparationClaimReviewInput = {
  claimId: Scalars['ID']['input'];
  reviewNote?: InputMaybe<Scalars['String']['input']>;
};

/** Lifecycle of a Better Prepared guarantee claim */
export enum SeparationClaimStatus {
  Approved = 'APPROVED',
  Declined = 'DECLINED',
  Eligible = 'ELIGIBLE',
  Ineligible = 'INELIGIBLE',
  Refunded = 'REFUNDED',
  Refunding = 'REFUNDING',
  Submitted = 'SUBMITTED'
}

export type SeparationCommissionPayment = {
  __typename?: 'SeparationCommissionPayment';
  affiliateId: Scalars['ID']['output'];
  amount: Scalars['Float']['output'];
  createdAt: Scalars['DateTime']['output'];
  currency: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  paidAt: Scalars['DateTime']['output'];
  paidByClientId: Scalars['ID']['output'];
  reference?: Maybe<Scalars['String']['output']>;
  referralIds: Array<Scalars['ID']['output']>;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type SeparationConfig = {
  __typename?: 'SeparationConfig';
  affiliateDefaultPercent: Scalars['Float']['output'];
  affiliateEnabled: Scalars['Boolean']['output'];
  autoConfirmHours: Scalars['Int']['output'];
  chatDailyMessageLimit: Scalars['Int']['output'];
  chatEnabled: Scalars['Boolean']['output'];
  chatFreeTrialMessages: Scalars['Int']['output'];
  chatModel?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  displayName: Scalars['String']['output'];
  fatherAudioCid?: Maybe<Scalars['String']['output']>;
  guaranteeMonths: Scalars['Int']['output'];
  guaranteeRequiredSteps: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  motherAudioCid?: Maybe<Scalars['String']['output']>;
  publicSignupEnabled: Scalars['Boolean']['output'];
  referralRewardEnabled: Scalars['Boolean']['output'];
  sponsorshipEnabled: Scalars['Boolean']['output'];
  sponsorshipMaxGrant: Scalars['Float']['output'];
  tenantId: Scalars['String']['output'];
  toolkitProductSlug?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type SeparationConfigInput = {
  affiliateDefaultPercent?: InputMaybe<Scalars['Float']['input']>;
  affiliateEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  autoConfirmHours?: InputMaybe<Scalars['Int']['input']>;
  chatDailyMessageLimit?: InputMaybe<Scalars['Int']['input']>;
  chatEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  chatFreeTrialMessages?: InputMaybe<Scalars['Int']['input']>;
  chatModel?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  fatherAudioCid?: InputMaybe<Scalars['String']['input']>;
  guaranteeMonths?: InputMaybe<Scalars['Int']['input']>;
  guaranteeRequiredSteps?: InputMaybe<Scalars['Int']['input']>;
  motherAudioCid?: InputMaybe<Scalars['String']['input']>;
  publicSignupEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  referralRewardEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  sponsorshipEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  sponsorshipMaxGrant?: InputMaybe<Scalars['Float']['input']>;
  toolkitProductSlug?: InputMaybe<Scalars['String']['input']>;
};

export type SeparationConfirmBlockInput = {
  actualEndsAt?: InputMaybe<Scalars['String']['input']>;
  actualStartsAt?: InputMaybe<Scalars['String']['input']>;
  agreed: Scalars['Boolean']['input'];
  attachmentCids?: Array<Scalars['String']['input']>;
  careBlockId: Scalars['ID']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
};

/** How a confirmation was given. AUTO means the parent did not answer before the deadline. */
export enum SeparationConfirmMethod {
  Auto = 'AUTO',
  Manual = 'MANUAL'
}

export type SeparationConfirmation = {
  __typename?: 'SeparationConfirmation';
  agreed: Scalars['Boolean']['output'];
  at: Scalars['DateTime']['output'];
  clientId: Scalars['ID']['output'];
  comment?: Maybe<Scalars['String']['output']>;
  method: SeparationConfirmMethod;
  parent: SeparationCarer;
};

export type SeparationCorrectEntryInput = {
  actualEndsAt?: InputMaybe<Scalars['String']['input']>;
  actualStartsAt?: InputMaybe<Scalars['String']['input']>;
  carer?: InputMaybe<SeparationCarer>;
  correctionReason: Scalars['String']['input'];
  entryId: Scalars['ID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
};

export type SeparationCovenantAnswer = {
  __typename?: 'SeparationCovenantAnswer';
  answer: Scalars['String']['output'];
  clientId: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  questionId: Scalars['String']['output'];
  sectionId: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type SeparationCovenantAnswerInput = {
  answer: Scalars['String']['input'];
  questionId: Scalars['String']['input'];
  sectionId: Scalars['String']['input'];
};

export type SeparationGenerateResult = {
  __typename?: 'SeparationGenerateResult';
  created: Scalars['Int']['output'];
  fromDayKey: Scalars['String']['output'];
  skipped: Scalars['Int']['output'];
  toDayKey: Scalars['String']['output'];
};

export type SeparationGuaranteeClaim = {
  __typename?: 'SeparationGuaranteeClaim';
  accessRevoked: Scalars['Boolean']['output'];
  amountPaid: Scalars['Float']['output'];
  clientId: Scalars['ID']['output'];
  clientName?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  eligibleAtClaim: Scalars['Boolean']['output'];
  guaranteeExpiresAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  ineligibleReasons: Array<Scalars['String']['output']>;
  proofCids: Array<Scalars['String']['output']>;
  purchaseDate?: Maybe<Scalars['DateTime']['output']>;
  refundStartedAt?: Maybe<Scalars['DateTime']['output']>;
  refundedAmount?: Maybe<Scalars['Float']['output']>;
  refundedAt?: Maybe<Scalars['DateTime']['output']>;
  reviewNote?: Maybe<Scalars['String']['output']>;
  reviewedAt?: Maybe<Scalars['DateTime']['output']>;
  reviewedByClientId?: Maybe<Scalars['ID']['output']>;
  status: SeparationClaimStatus;
  stepsCompletedAtClaim: Scalars['Int']['output'];
  stepsRequiredAtClaim: Scalars['Int']['output'];
  stripeRefundId?: Maybe<Scalars['String']['output']>;
  subscriptionId: Scalars['ID']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type SeparationGuaranteeClaimInput = {
  description: Scalars['String']['input'];
  proofCids: Array<Scalars['String']['input']>;
};

export type SeparationGuaranteeEligibility = {
  __typename?: 'SeparationGuaranteeEligibility';
  amountPaid: Scalars['Float']['output'];
  claimAlreadyOpen: Scalars['Boolean']['output'];
  eligible: Scalars['Boolean']['output'];
  guaranteeExpiresAt?: Maybe<Scalars['DateTime']['output']>;
  purchaseDate?: Maybe<Scalars['DateTime']['output']>;
  reasons: Array<Scalars['String']['output']>;
  stepsCompleted: Scalars['Int']['output'];
  stepsRequired: Scalars['Int']['output'];
};

export type SeparationInvite = {
  __typename?: 'SeparationInvite';
  accessMode: SeparationInviteAccessMode;
  accessedAt?: Maybe<Scalars['DateTime']['output']>;
  activatedAt?: Maybe<Scalars['DateTime']['output']>;
  caseId?: Maybe<Scalars['ID']['output']>;
  chaseCount: Scalars['Int']['output'];
  chasedAt?: Maybe<Scalars['DateTime']['output']>;
  clientId?: Maybe<Scalars['ID']['output']>;
  couponCode?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdByName?: Maybe<Scalars['String']['output']>;
  customMessage?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  emailSentAt?: Maybe<Scalars['DateTime']['output']>;
  existingClientId?: Maybe<Scalars['ID']['output']>;
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  fName?: Maybe<Scalars['String']['output']>;
  firstCareBlockConfirmedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  invitedByClientId?: Maybe<Scalars['ID']['output']>;
  lName?: Maybe<Scalars['String']['output']>;
  lastSendError?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  status: SeparationInviteStatus;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** How the invitee gets access. CO_PARENT is the free second-parent seat on one case. */
export enum SeparationInviteAccessMode {
  Coupon = 'COUPON',
  CoParent = 'CO_PARENT',
  Free = 'FREE',
  Paid = 'PAID'
}

export type SeparationInviteClaimResult = {
  __typename?: 'SeparationInviteClaimResult';
  caseId?: Maybe<Scalars['ID']['output']>;
  hadExistingAccount: Scalars['Boolean']['output'];
  message: Scalars['String']['output'];
  requiresLogin: Scalars['Boolean']['output'];
  success: Scalars['Boolean']['output'];
  token?: Maybe<Scalars['String']['output']>;
};

export type SeparationInviteGraphNode = {
  __typename?: 'SeparationInviteGraphNode';
  accessMode: SeparationInviteAccessMode;
  activatedAt?: Maybe<Scalars['DateTime']['output']>;
  displayName: Scalars['String']['output'];
  inviteId: Scalars['ID']['output'];
  invitedByClientId?: Maybe<Scalars['ID']['output']>;
  invitedByDisplayName?: Maybe<Scalars['String']['output']>;
  status: SeparationInviteStatus;
};

/** Status of a separation onboarding invite */
export enum SeparationInviteStatus {
  Accessed = 'ACCESSED',
  Active = 'ACTIVE',
  Declined = 'DECLINED',
  Expired = 'EXPIRED',
  Paid = 'PAID',
  Pending = 'PENDING'
}

export type SeparationJourneyMigrateInput = {
  completedStepIds: Array<Scalars['String']['input']>;
};

export type SeparationJourneyProgress = {
  __typename?: 'SeparationJourneyProgress';
  clientId: Scalars['ID']['output'];
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  completedStepIds: Array<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  currentStepId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type SeparationJourneyStepInput = {
  completed?: Scalars['Boolean']['input'];
  stepId: Scalars['String']['input'];
};

/** What the two parents' answers add up to */
export enum SeparationLedgerOutcome {
  Agreed = 'AGREED',
  Disputed = 'DISPUTED',
  Unanswered = 'UNANSWERED'
}

export type SeparationLinkAuthResult = {
  __typename?: 'SeparationLinkAuthResult';
  allowsWrites: Scalars['Boolean']['output'];
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
  token?: Maybe<Scalars['String']['output']>;
};

export type SeparationNightCount = {
  __typename?: 'SeparationNightCount';
  careThreshold128: Scalars['Int']['output'];
  caseId: Scalars['ID']['output'];
  disputedNights: Scalars['Int']['output'];
  fromDayKey: Scalars['String']['output'];
  parentANights: Scalars['Int']['output'];
  parentBNights: Scalars['Int']['output'];
  toDayKey: Scalars['String']['output'];
  totalNights: Scalars['Int']['output'];
  unansweredNights: Scalars['Int']['output'];
  unresolvedNights: Scalars['Int']['output'];
};

export type SeparationParentingSchedule = {
  __typename?: 'SeparationParentingSchedule';
  anchorDayKey: Scalars['String']['output'];
  blocks: Array<SeparationScheduleBlock>;
  caseId: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  cycleLengthDays: Scalars['Int']['output'];
  effectiveFromDayKey: Scalars['String']['output'];
  effectiveToDayKey?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  pattern: SeparationSchedulePattern;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type SeparationParentingScheduleInput = {
  anchorDayKey: Scalars['String']['input'];
  blocks: Array<SeparationScheduleBlockInput>;
  caseId?: InputMaybe<Scalars['ID']['input']>;
  cycleLengthDays: Scalars['Int']['input'];
  effectiveFromDayKey?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  pattern: SeparationSchedulePattern;
};

export type SeparationReferral = {
  __typename?: 'SeparationReferral';
  affiliateId: Scalars['ID']['output'];
  commissionAmount: Scalars['Float']['output'];
  commissionPercent: Scalars['Float']['output'];
  convertedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  referredClientId?: Maybe<Scalars['ID']['output']>;
  referredName?: Maybe<Scalars['String']['output']>;
  reversedAt?: Maybe<Scalars['DateTime']['output']>;
  saleAmount: Scalars['Float']['output'];
  status: SeparationReferralStatus;
  subscriptionId?: Maybe<Scalars['ID']['output']>;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  utmCampaign?: Maybe<Scalars['String']['output']>;
  utmSource?: Maybe<Scalars['String']['output']>;
  variantId?: Maybe<Scalars['String']['output']>;
};

/** Lifecycle of a referred family. REVERSED means the sale was refunded. */
export enum SeparationReferralStatus {
  Clicked = 'CLICKED',
  Converted = 'CONVERTED',
  Paid = 'PAID',
  Reversed = 'REVERSED',
  SignedUp = 'SIGNED_UP'
}

export type SeparationRefundResult = {
  __typename?: 'SeparationRefundResult';
  amountRefunded?: Maybe<Scalars['Float']['output']>;
  message: Scalars['String']['output'];
  stripeRefundId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type SeparationScheduleBlock = {
  __typename?: 'SeparationScheduleBlock';
  carer: SeparationCarer;
  childIds: Array<Scalars['ID']['output']>;
  endDayOffset: Scalars['Int']['output'];
  endTime: Scalars['String']['output'];
  label?: Maybe<Scalars['String']['output']>;
  startDayOffset: Scalars['Int']['output'];
  startTime: Scalars['String']['output'];
};

export type SeparationScheduleBlockInput = {
  carer: SeparationCarer;
  childIds?: Array<Scalars['ID']['input']>;
  endDayOffset: Scalars['Int']['input'];
  endTime: Scalars['String']['input'];
  label?: InputMaybe<Scalars['String']['input']>;
  startDayOffset: Scalars['Int']['input'];
  startTime: Scalars['String']['input'];
};

/** Recurring co-parenting patterns. CUSTOM lets a family build their own cycle. */
export enum SeparationSchedulePattern {
  AlternateWeekends = 'ALTERNATE_WEEKENDS',
  Custom = 'CUSTOM',
  TwoTwoFiveFive = 'TWO_TWO_FIVE_FIVE',
  TwoTwoThree = 'TWO_TWO_THREE',
  WeekAbout = 'WEEK_ABOUT'
}

export type SeparationScheduleUpdateInput = {
  blocks?: InputMaybe<Array<SeparationScheduleBlockInput>>;
  effectiveToDayKey?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type SeparationSignupInput = {
  email: Scalars['String']['input'];
  fName?: InputMaybe<Scalars['String']['input']>;
  lName?: InputMaybe<Scalars['String']['input']>;
  referralCode?: InputMaybe<Scalars['String']['input']>;
  utmCampaign?: InputMaybe<Scalars['String']['input']>;
  utmSource?: InputMaybe<Scalars['String']['input']>;
  variantId?: InputMaybe<Scalars['String']['input']>;
};

export type SeparationSponsoredRequest = {
  __typename?: 'SeparationSponsoredRequest';
  clientId?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['DateTime']['output'];
  declineReason?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  grantedAt?: Maybe<Scalars['DateTime']['output']>;
  grantedByClientId?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  requestedAmount: Scalars['Float']['output'];
  situation?: Maybe<Scalars['String']['output']>;
  status: SeparationSponsoredRequestStatus;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type SeparationSponsoredRequestInput = {
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  situation?: InputMaybe<Scalars['String']['input']>;
};

export enum SeparationSponsoredRequestStatus {
  Declined = 'DECLINED',
  Granted = 'GRANTED',
  Pending = 'PENDING'
}

export type SeparationSponsorshipAllocation = {
  __typename?: 'SeparationSponsorshipAllocation';
  allocatedAt: Scalars['DateTime']['output'];
  allocatedByClientId: Scalars['ID']['output'];
  amount: Scalars['Float']['output'];
  contributionId: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  requestId: Scalars['ID']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type SeparationSponsorshipContribution = {
  __typename?: 'SeparationSponsorshipContribution';
  allocatedAmount: Scalars['Float']['output'];
  amount: Scalars['Float']['output'];
  contributorClientId: Scalars['ID']['output'];
  contributorName?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  currency: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isAnonymous: Scalars['Boolean']['output'];
  status: SeparationSponsorshipStatus;
  subscriptionId?: Maybe<Scalars['ID']['output']>;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type SeparationSponsorshipPoolSummary = {
  __typename?: 'SeparationSponsorshipPoolSummary';
  allocationCount: Scalars['Int']['output'];
  contributionCount: Scalars['Int']['output'];
  familiesFundable: Scalars['Int']['output'];
  pendingRequestCount: Scalars['Int']['output'];
  remainingBalance: Scalars['Float']['output'];
  totalAllocated: Scalars['Float']['output'];
  totalContributed: Scalars['Float']['output'];
};

export enum SeparationSponsorshipStatus {
  Active = 'ACTIVE',
  Depleted = 'DEPLETED',
  Refunded = 'REFUNDED'
}

export type SeparationTrackReferralInput = {
  code: Scalars['String']['input'];
  utmCampaign?: InputMaybe<Scalars['String']['input']>;
  utmSource?: InputMaybe<Scalars['String']['input']>;
  variantId?: InputMaybe<Scalars['String']['input']>;
};

export type Session = {
  __typename?: 'Session';
  availability?: Maybe<Availability>;
  cancellationReason?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  endTime: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  isCancelled: Scalars['Boolean']['output'];
  maxParticipants?: Maybe<Scalars['Float']['output']>;
  meetingLink?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  sendReminders: Scalars['Boolean']['output'];
  startTime: Scalars['DateTime']['output'];
  tenantId: Scalars['String']['output'];
  type: SessionType;
  updatedAt: Scalars['DateTime']['output'];
};

/** Format of the session (individual or group) */
export enum SessionFormat {
  Group = 'GROUP',
  Individual = 'INDIVIDUAL'
}

export type SessionInput = {
  availabilityId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  endTime: Scalars['DateTime']['input'];
  maxParticipants?: InputMaybe<Scalars['Float']['input']>;
  meetingLink?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  sendReminders?: InputMaybe<Scalars['Boolean']['input']>;
  startTime: Scalars['DateTime']['input'];
  typeId: Scalars['String']['input'];
};

export type SessionProgress = {
  __typename?: 'SessionProgress';
  bytesPerSecond: Scalars['Float']['output'];
  completedFiles: Scalars['Float']['output'];
  currentFile?: Maybe<Scalars['String']['output']>;
  estimatedSecondsRemaining: Scalars['Float']['output'];
  failedFiles: Scalars['Float']['output'];
  percentComplete: Scalars['Float']['output'];
  sessionId: Scalars['String']['output'];
  status: DroneSessionStatus;
  totalBytes: Scalars['Float']['output'];
  totalFiles: Scalars['Float']['output'];
  uploadedBytes: Scalars['Float']['output'];
};

export type SessionType = {
  __typename?: 'SessionType';
  availableOnCalendar: Scalars['Boolean']['output'];
  clientId?: Maybe<Scalars['ID']['output']>;
  color?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  duration: Scalars['Float']['output'];
  format: SessionFormat;
  id: Scalars['ID']['output'];
  meetingLink?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  practitionerId?: Maybe<Scalars['ID']['output']>;
  price: Scalars['Float']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type SessionTypeInput = {
  availableOnCalendar?: InputMaybe<Scalars['Boolean']['input']>;
  clientId: Scalars['String']['input'];
  color?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  duration: Scalars['Float']['input'];
  format: SessionFormat;
  meetingLink?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  practitionerId?: InputMaybe<Scalars['ID']['input']>;
  price: Scalars['Float']['input'];
};

export type SessionsRevokedResult = {
  __typename?: 'SessionsRevokedResult';
  /** The server time every older session stopped working. */
  signedOutAt: Scalars['DateTime']['output'];
  /** A fresh session for THIS device (adopt it). Null when this device was signed out too. */
  token?: Maybe<Scalars['String']['output']>;
};

export type SetBankingAccountViewersInput = {
  accountId: Scalars['ID']['input'];
  clientIds: Array<Scalars['ID']['input']>;
};

export type SetBankingTransactionShapeInput = {
  shape?: InputMaybe<BankingIncomeShape>;
  transactionId: Scalars['ID']['input'];
};

export type SetClientLoginBlockInput = {
  blocked: Scalars['Boolean']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
};

export type SetCompetitionEntryStatusInput = {
  adminNote?: InputMaybe<Scalars['String']['input']>;
  clearPlacement?: InputMaybe<Scalars['Boolean']['input']>;
  correctAfterAnnouncement?: InputMaybe<Scalars['Boolean']['input']>;
  entryId: Scalars['ID']['input'];
  placement?: InputMaybe<Scalars['Int']['input']>;
  publicHidden?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<CompetitionEntryStatus>;
};

export type SetEmpowermentGoalStepInput = {
  done?: InputMaybe<Scalars['Boolean']['input']>;
  goalId: Scalars['ID']['input'];
  label?: InputMaybe<Scalars['String']['input']>;
  remove?: InputMaybe<Scalars['Boolean']['input']>;
  stepId: Scalars['String']['input'];
};

export type SetEmpowermentJourneyStatusInput = {
  journeyId: Scalars['ID']['input'];
  pausedUntil?: InputMaybe<Scalars['String']['input']>;
  reason: Scalars['String']['input'];
  status: EmpowermentJourneyStatus;
};

export type SetGovChecklistVisibilityInput = {
  checklistId: Scalars['ID']['input'];
  visibility: GovChecklistVisibility;
};

export type SetPasswordInput = {
  password: Scalars['String']['input'];
  username?: InputMaybe<Scalars['String']['input']>;
};

export type SetRewardPayoutBankDetailsInput = {
  accountName: Scalars['String']['input'];
  accountNumber: Scalars['String']['input'];
  bsb: Scalars['String']['input'];
};

export type SetWaitingListResponsibleInput = {
  /** Login (client) id from waitingListAssignablePeople; null clears it */
  clientId?: InputMaybe<Scalars['ID']['input']>;
  role: WaitingListResponsibleRole;
};

export type ShareLinkResult = {
  __typename?: 'ShareLinkResult';
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  isPasswordProtected: Scalars['Boolean']['output'];
  shareToken: Scalars['String']['output'];
  shareUrl: Scalars['String']['output'];
};

export type SheetConnectionTest = {
  __typename?: 'SheetConnectionTest';
  message: Scalars['String']['output'];
  ok: Scalars['Boolean']['output'];
};

/** Types of meal accompaniments (sides) */
export enum ShelvAccompanimentType {
  Garnish = 'GARNISH',
  Sauce = 'SAUCE',
  Starch = 'STARCH',
  Vegetable = 'VEGETABLE'
}

export type ShelvAccompanimentUsage = {
  __typename?: 'ShelvAccompanimentUsage';
  lastUsedDate: Scalars['String']['output'];
  name: Scalars['String']['output'];
  type: ShelvAccompanimentType;
  usageCount: Scalars['Int']['output'];
};

/** A unit-type option with value + display label (filtered to active). */
export type ShelvActiveUnitOption = {
  __typename?: 'ShelvActiveUnitOption';
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type ShelvAggregatedIngredient = {
  __typename?: 'ShelvAggregatedIngredient';
  estimatedCost?: Maybe<Scalars['Float']['output']>;
  ingredientId: Scalars['ID']['output'];
  ingredientName: Scalars['String']['output'];
  mealPlanCount?: Maybe<Scalars['Float']['output']>;
  sources: Array<ShelvAggregatedIngredientSource>;
  supplierId?: Maybe<Scalars['ID']['output']>;
  supplierName?: Maybe<Scalars['String']['output']>;
  totalQuantity: Scalars['Float']['output'];
  unit: ShelvUnitType;
  unitCost?: Maybe<Scalars['Float']['output']>;
};

export type ShelvAggregatedIngredientSource = {
  __typename?: 'ShelvAggregatedIngredientSource';
  convertedQuantity?: Maybe<Scalars['Float']['output']>;
  destinationUnit: ShelvUnitType;
  lineCost?: Maybe<Scalars['Float']['output']>;
  mealDate: Scalars['DateTime']['output'];
  mealPlanId: Scalars['ID']['output'];
  mealServings: Scalars['Float']['output'];
  mealType: Scalars['String']['output'];
  mismatch: Scalars['Boolean']['output'];
  rawQuantity: Scalars['Float']['output'];
  rawUnit: ShelvUnitType;
  recipeBaseServings: Scalars['Float']['output'];
  recipeId: Scalars['ID']['output'];
  recipeName: Scalars['String']['output'];
  scaledQuantity: Scalars['Float']['output'];
};

export type ShelvAiEndpointCheck = {
  __typename?: 'ShelvAiEndpointCheck';
  configured: Scalars['Boolean']['output'];
  httpStatus?: Maybe<Scalars['Float']['output']>;
  message: Scalars['String']['output'];
  name: Scalars['String']['output'];
  reachable: Scalars['Boolean']['output'];
  source: Scalars['String']['output'];
};

export type ShelvAiEndpointStatus = {
  __typename?: 'ShelvAiEndpointStatus';
  baseUrl?: Maybe<Scalars['String']['output']>;
  configured: Scalars['Boolean']['output'];
  model?: Maybe<Scalars['String']['output']>;
  secretHint?: Maybe<Scalars['String']['output']>;
  source: Scalars['String']['output'];
};

export type ShelvAiSettings = {
  __typename?: 'ShelvAiSettings';
  harness: ShelvAiEndpointStatus;
  knowledgeFs: ShelvAiEndpointStatus;
  localAi: ShelvAiEndpointStatus;
};

/** Time-period selector for food budget spend aggregation */
export enum ShelvBudgetPeriod {
  Custom = 'CUSTOM',
  Day = 'DAY',
  Fy = 'FY',
  Month = 'MONTH',
  Week = 'WEEK'
}

export type ShelvBulkCreateMealPlanInput = {
  meals: Array<ShelvMealPlanItemInput>;
  shiftId: Scalars['ID']['input'];
};

export type ShelvBulkIngredientInput = {
  category: ShelvIngredientCategory;
  defaultUnit?: InputMaybe<ShelvUnitType>;
  minOrderQty?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  supplierName?: InputMaybe<Scalars['String']['input']>;
  supplierSku?: InputMaybe<Scalars['String']['input']>;
  unitCost?: InputMaybe<Scalars['Float']['input']>;
};

export type ShelvBulkReplaceRecipeIngredientInput = {
  ingredientName: Scalars['String']['input'];
  isOptional?: InputMaybe<Scalars['Boolean']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  quantity: Scalars['Float']['input'];
  sortOrder?: InputMaybe<Scalars['Float']['input']>;
  unit: ShelvUnitType;
};

export type ShelvBulkReplaceRecipeIngredientsResult = {
  __typename?: 'ShelvBulkReplaceRecipeIngredientsResult';
  created: Scalars['Float']['output'];
  errors: Array<Scalars['String']['output']>;
  ingredients: Array<ShelvRecipeIngredient>;
  replaced: Scalars['Float']['output'];
  skipped: Scalars['Float']['output'];
};

export type ShelvBulkUpsertIngredientInput = {
  category: ShelvIngredientCategory;
  defaultUnit?: InputMaybe<ShelvUnitType>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  minOrderQty?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  shelfLifeDays?: InputMaybe<Scalars['Int']['input']>;
  storageInstructions?: InputMaybe<Scalars['String']['input']>;
  supplierId?: InputMaybe<Scalars['ID']['input']>;
  supplierSku?: InputMaybe<Scalars['String']['input']>;
  unitCost?: InputMaybe<Scalars['Float']['input']>;
};

export type ShelvBulkUpsertResult = {
  __typename?: 'ShelvBulkUpsertResult';
  created: Scalars['Int']['output'];
  errors: Array<ShelvBulkUpsertRowError>;
  ingredients: Array<ShelvIngredient>;
  skipped: Scalars['Int']['output'];
  updated: Scalars['Int']['output'];
};

export type ShelvBulkUpsertRowError = {
  __typename?: 'ShelvBulkUpsertRowError';
  message: Scalars['String']['output'];
  rowIndex: Scalars['Int']['output'];
  rowName?: Maybe<Scalars['String']['output']>;
};

export type ShelvCancelOrderInput = {
  orderId: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
};

export type ShelvCaptureAllowance = {
  __typename?: 'ShelvCaptureAllowance';
  limit: Scalars['Int']['output'];
  monthKey: Scalars['String']['output'];
  remaining: Scalars['Int']['output'];
  unlimited: Scalars['Boolean']['output'];
  used: Scalars['Int']['output'];
};

export type ShelvCaptureJob = {
  __typename?: 'ShelvCaptureJob';
  adjustments?: Maybe<Array<Scalars['String']['output']>>;
  attempts: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  extractedChars?: Maybe<Scalars['Int']['output']>;
  extractionMethod?: Maybe<Scalars['String']['output']>;
  fileCid?: Maybe<Scalars['String']['output']>;
  fileMimeType?: Maybe<Scalars['String']['output']>;
  fileName?: Maybe<Scalars['String']['output']>;
  finishedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  kitchenId: Scalars['ID']['output'];
  progress: Scalars['Int']['output'];
  proposal?: Maybe<CapturedRecipe>;
  queueLength: Scalars['Int']['output'];
  queuePosition?: Maybe<Scalars['Int']['output']>;
  recipeId?: Maybe<Scalars['ID']['output']>;
  sourceKind: ShelvCaptureSourceKind;
  sourceTitle?: Maybe<Scalars['String']['output']>;
  status: ShelvCaptureJobStatus;
  stepDetail?: Maybe<Scalars['String']['output']>;
  stepStartedAt?: Maybe<Scalars['DateTime']['output']>;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

/** Lifecycle of a recipe capture job */
export enum ShelvCaptureJobStatus {
  ExtractingText = 'EXTRACTING_TEXT',
  Failed = 'FAILED',
  FetchingPage = 'FETCHING_PAGE',
  Queued = 'QUEUED',
  Ready = 'READY',
  Saved = 'SAVED',
  WritingUp = 'WRITING_UP'
}

/** Where a recipe capture came from: pasted text, a web link, or an uploaded photo/PDF */
export enum ShelvCaptureSourceKind {
  File = 'FILE',
  Text = 'TEXT',
  Url = 'URL'
}

export type ShelvConfig = {
  __typename?: 'ShelvConfig';
  createdAt: Scalars['DateTime']['output'];
  defaultInviteExpiryDays: Scalars['Float']['output'];
  /** @deprecated Imports are unlimited; this historical value is not enforced. */
  freeTierMonthlyCaptureLimit: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  maxFreeInvites: Scalars['Float']['output'];
  referralRewardEnabled: Scalars['Boolean']['output'];
  referralRewardValue: Scalars['Float']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  welcomeMessage?: Maybe<Scalars['String']['output']>;
};

export type ShelvConfirmMealPlanEntryInput = {
  date: Scalars['String']['input'];
  mealType: ShelvMealType;
  recipeId: Scalars['ID']['input'];
};

export type ShelvCookEvent = {
  __typename?: 'ShelvCookEvent';
  at: Scalars['DateTime']['output'];
  clientId?: Maybe<Scalars['ID']['output']>;
  source: ShelvCookSource;
};

/** Whether a cook was confirmed by tap or inferred from use */
export enum ShelvCookSource {
  Probable = 'PROBABLE',
  Tap = 'TAP'
}

export type ShelvCreateIngredientInput = {
  category: ShelvIngredientCategory;
  conversions?: InputMaybe<Array<ShelvIngredientConversionInput>>;
  defaultUnit?: InputMaybe<ShelvUnitType>;
  description?: InputMaybe<Scalars['String']['input']>;
  minOrderQty?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  purchaseUnitsPerRecipeUnit?: InputMaybe<Scalars['Float']['input']>;
  purchasedUnit?: InputMaybe<ShelvUnitType>;
  shelfLifeDays?: InputMaybe<Scalars['Float']['input']>;
  storageInstructions?: InputMaybe<Scalars['String']['input']>;
  supplierId?: InputMaybe<Scalars['ID']['input']>;
  supplierSku?: InputMaybe<Scalars['String']['input']>;
  unitCost?: InputMaybe<Scalars['Float']['input']>;
};

export type ShelvCreateKitchenInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  logoCid?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type ShelvCreateMealFeedbackInput = {
  comments?: InputMaybe<Scalars['String']['input']>;
  feedbackType?: InputMaybe<ShelvFeedbackType>;
  mealPlanId: Scalars['ID']['input'];
  photos?: InputMaybe<Array<ShelvMealMediaInput>>;
  rating: Scalars['Float']['input'];
  reportedBy?: InputMaybe<Scalars['String']['input']>;
};

export type ShelvCreateMealPlanInput = {
  accompaniments?: InputMaybe<Array<ShelvMealAccompanimentInput>>;
  mealDate: Scalars['String']['input'];
  mealType: ShelvMealType;
  quickDescription?: InputMaybe<Scalars['String']['input']>;
  recipeId?: InputMaybe<Scalars['ID']['input']>;
  servings: Scalars['Float']['input'];
  shiftId?: InputMaybe<Scalars['ID']['input']>;
  specialNotes?: InputMaybe<Scalars['String']['input']>;
};

export type ShelvCreateMealPlanNotificationRuleInput = {
  channels: Array<Scalars['String']['input']>;
  isEnabled?: Scalars['Boolean']['input'];
  messageTemplate?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  recipientClientIds?: Array<Scalars['String']['input']>;
  recipientRole?: InputMaybe<Scalars['String']['input']>;
  recipientType: ShelvMealPlanNotificationRecipientType;
  trigger: ShelvMealPlanNotificationTrigger;
};

export type ShelvCreateRecipeIngredientInput = {
  ingredientId: Scalars['ID']['input'];
  isOptional?: InputMaybe<Scalars['Boolean']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  quantity: Scalars['Float']['input'];
  recipeId: Scalars['ID']['input'];
  sortOrder?: InputMaybe<Scalars['Float']['input']>;
  unit: ShelvUnitType;
};

export type ShelvCreateRecipeInput = {
  caloriesPerServing?: InputMaybe<Scalars['Float']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  cookTime?: InputMaybe<Scalars['Float']['input']>;
  cuisine?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dietaryTags?: InputMaybe<Array<ShelvDietaryTag>>;
  dishType?: InputMaybe<ShelvRecipeDishType>;
  imageCid?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  instructions?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  prepTime?: InputMaybe<Scalars['Float']['input']>;
  servings: Scalars['Float']['input'];
  sessionType?: InputMaybe<ShelvRecipeSessionType>;
};

export type ShelvCreateSupplierInput = {
  abn?: InputMaybe<Scalars['String']['input']>;
  accountNumber?: InputMaybe<Scalars['String']['input']>;
  address?: InputMaybe<Scalars['String']['input']>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactName?: InputMaybe<Scalars['String']['input']>;
  contactPhone?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  leadTimeDays?: InputMaybe<Scalars['Float']['input']>;
  minimumOrder?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  paymentTerms?: InputMaybe<Scalars['String']['input']>;
  preferredCategories?: InputMaybe<Array<ShelvIngredientCategory>>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type ShelvCreateSupplierOrderInput = {
  expectedDelivery?: InputMaybe<Scalars['DateTime']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  supplierId: Scalars['ID']['input'];
};

/** Dietary restrictions and preferences for recipes */
export enum ShelvDietaryTag {
  DairyFree = 'DAIRY_FREE',
  DiabeticFriendly = 'DIABETIC_FRIENDLY',
  GlutenFree = 'GLUTEN_FREE',
  Halal = 'HALAL',
  Kosher = 'KOSHER',
  LowSodium = 'LOW_SODIUM',
  NutFree = 'NUT_FREE',
  Vegan = 'VEGAN',
  Vegetarian = 'VEGETARIAN'
}

/** A unit type option with value and display label */
export type ShelvEnumOption = {
  __typename?: 'ShelvEnumOption';
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type ShelvFeedbackStats = {
  __typename?: 'ShelvFeedbackStats';
  averageRating: Scalars['Float']['output'];
  feedbackByType: Array<ShelvFeedbackTypeCount>;
  highRatingCount: Scalars['Float']['output'];
  lowRatingCount: Scalars['Float']['output'];
  totalFeedback: Scalars['Float']['output'];
};

/** Types of meal feedback */
export enum ShelvFeedbackType {
  DietaryIssue = 'DIETARY_ISSUE',
  Other = 'OTHER',
  Portion = 'PORTION',
  Presentation = 'PRESENTATION',
  Taste = 'TASTE'
}

export type ShelvFeedbackTypeCount = {
  __typename?: 'ShelvFeedbackTypeCount';
  count: Scalars['Float']['output'];
  type: ShelvFeedbackType;
};

export type ShelvFoodBudget = {
  __typename?: 'ShelvFoodBudget';
  createdAt: Scalars['DateTime']['output'];
  currency: Scalars['String']['output'];
  financialYearStartMonth: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  kitchenId: Scalars['ID']['output'];
  monthlyBudget: Scalars['Float']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type ShelvFoodBudgetSummary = {
  __typename?: 'ShelvFoodBudgetSummary';
  endDate: Scalars['DateTime']['output'];
  estimatedPercentUsed: Scalars['Float']['output'];
  estimatedRemaining: Scalars['Float']['output'];
  estimatedSpend: Scalars['Float']['output'];
  percentUsed: Scalars['Float']['output'];
  period: Scalars['String']['output'];
  periodBudget: Scalars['Float']['output'];
  remaining: Scalars['Float']['output'];
  spent: Scalars['Float']['output'];
  spentFromInvoices: Scalars['Float']['output'];
  spentFromOrders: Scalars['Float']['output'];
  startDate: Scalars['DateTime']['output'];
};

export type ShelvFoodInvoice = {
  __typename?: 'ShelvFoodInvoice';
  confirmedAt?: Maybe<Scalars['DateTime']['output']>;
  confirmedBy?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  dueDate?: Maybe<Scalars['DateTime']['output']>;
  extractionError?: Maybe<Scalars['String']['output']>;
  gst: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  invoiceDate?: Maybe<Scalars['DateTime']['output']>;
  invoiceNumber?: Maybe<Scalars['String']['output']>;
  lineItems: Array<ShelvFoodInvoiceLineItem>;
  linkedOrder?: Maybe<ShelvSupplierOrder>;
  linkedOrderId?: Maybe<Scalars['ID']['output']>;
  mismatchDetails: Array<ShelvFoodInvoiceMismatch>;
  originalFileCid?: Maybe<Scalars['String']['output']>;
  originalFileMimeType?: Maybe<Scalars['String']['output']>;
  originalFileUrl?: Maybe<Scalars['String']['output']>;
  status: ShelvFoodInvoiceStatus;
  subtotal: Scalars['Float']['output'];
  supplier?: Maybe<ShelvSupplier>;
  supplierAbnRaw?: Maybe<Scalars['String']['output']>;
  supplierId?: Maybe<Scalars['ID']['output']>;
  supplierNameRaw?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  total: Scalars['Float']['output'];
  updatedAt: Scalars['DateTime']['output'];
  uploadedBy?: Maybe<Scalars['String']['output']>;
};

export type ShelvFoodInvoiceEditInput = {
  dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  gst?: InputMaybe<Scalars['Float']['input']>;
  invoiceDate?: InputMaybe<Scalars['DateTime']['input']>;
  invoiceNumber?: InputMaybe<Scalars['String']['input']>;
  lineItems?: InputMaybe<Array<ShelvFoodInvoiceLineItemInput>>;
  linkedOrderId?: InputMaybe<Scalars['ID']['input']>;
  subtotal?: InputMaybe<Scalars['Float']['input']>;
  supplierAbnRaw?: InputMaybe<Scalars['String']['input']>;
  supplierId?: InputMaybe<Scalars['ID']['input']>;
  supplierNameRaw?: InputMaybe<Scalars['String']['input']>;
  total?: InputMaybe<Scalars['Float']['input']>;
};

export type ShelvFoodInvoiceLineItem = {
  __typename?: 'ShelvFoodInvoiceLineItem';
  categoryHint?: Maybe<ShelvIngredientCategory>;
  descriptionRaw: Scalars['String']['output'];
  ingredientId?: Maybe<Scalars['ID']['output']>;
  lineTotal: Scalars['Float']['output'];
  matchScore?: Maybe<Scalars['Float']['output']>;
  matchStatus: ShelvInvoiceLineItemMatchStatus;
  quantity: Scalars['Float']['output'];
  unit?: Maybe<Scalars['String']['output']>;
  unitPrice: Scalars['Float']['output'];
};

export type ShelvFoodInvoiceLineItemInput = {
  categoryHint?: InputMaybe<ShelvIngredientCategory>;
  descriptionRaw: Scalars['String']['input'];
  ingredientId?: InputMaybe<Scalars['ID']['input']>;
  lineTotal: Scalars['Float']['input'];
  matchStatus?: InputMaybe<ShelvInvoiceLineItemMatchStatus>;
  quantity: Scalars['Float']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  unitPrice: Scalars['Float']['input'];
};

export type ShelvFoodInvoiceMismatch = {
  __typename?: 'ShelvFoodInvoiceMismatch';
  detail?: Maybe<Scalars['String']['output']>;
  field: Scalars['String']['output'];
  invoiceValue?: Maybe<Scalars['String']['output']>;
  orderValue?: Maybe<Scalars['String']['output']>;
};

/** Lifecycle status of an uploaded food-supplier invoice */
export enum ShelvFoodInvoiceStatus {
  Confirmed = 'CONFIRMED',
  Discarded = 'DISCARDED',
  PendingExtraction = 'PENDING_EXTRACTION',
  PendingReview = 'PENDING_REVIEW'
}

export type ShelvFoodInvoicesFilter = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ShelvFoodInvoiceStatus>;
  supplierId?: InputMaybe<Scalars['ID']['input']>;
};

export type ShelvFoodSpendByCategoryRow = {
  __typename?: 'ShelvFoodSpendByCategoryRow';
  category: Scalars['String']['output'];
  estimated: Scalars['Float']['output'];
  ingredients: Array<ShelvFoodSpendByIngredientRow>;
  percent: Scalars['Float']['output'];
  spent: Scalars['Float']['output'];
};

export type ShelvFoodSpendByIngredientRow = {
  __typename?: 'ShelvFoodSpendByIngredientRow';
  actual: Scalars['Float']['output'];
  actualFormula?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  estimated: Scalars['Float']['output'];
  estimatedFormula?: Maybe<Scalars['String']['output']>;
  ingredientId: Scalars['String']['output'];
  ingredientName: Scalars['String']['output'];
  supplierId?: Maybe<Scalars['String']['output']>;
  supplierName?: Maybe<Scalars['String']['output']>;
  totalQuantity?: Maybe<Scalars['Float']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
  variance: Scalars['Float']['output'];
};

export type ShelvFoodSpendBySupplierRow = {
  __typename?: 'ShelvFoodSpendBySupplierRow';
  estimated: Scalars['Float']['output'];
  ingredients: Array<ShelvFoodSpendByIngredientRow>;
  percent: Scalars['Float']['output'];
  spent: Scalars['Float']['output'];
  supplierId?: Maybe<Scalars['String']['output']>;
  supplierName: Scalars['String']['output'];
};

export type ShelvGenerateMealPlanAiInput = {
  numberOfDays?: Scalars['Int']['input'];
  preferences?: InputMaybe<Scalars['String']['input']>;
  servings?: Scalars['Int']['input'];
  startDate: Scalars['String']['input'];
};

export type ShelvGenerateOrdersInput = {
  endDate: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
};

export type ShelvGeneratedMealPlanEntry = {
  __typename?: 'ShelvGeneratedMealPlanEntry';
  date: Scalars['String']['output'];
  mealType: ShelvMealType;
  recipeId: Scalars['ID']['output'];
  recipeName: Scalars['String']['output'];
};

export type ShelvGeneratedMealPlanResult = {
  __typename?: 'ShelvGeneratedMealPlanResult';
  aiNotes?: Maybe<Scalars['String']['output']>;
  entries: Array<ShelvGeneratedMealPlanEntry>;
};

export type ShelvGeneratedOrder = {
  __typename?: 'ShelvGeneratedOrder';
  itemCount: Scalars['Float']['output'];
  order: ShelvSupplierOrder;
  totalAmount: Scalars['Float']['output'];
};

export type ShelvIngredient = {
  __typename?: 'ShelvIngredient';
  category: ShelvIngredientCategory;
  conversions: Array<ShelvIngredientConversion>;
  createdAt: Scalars['DateTime']['output'];
  defaultUnit: ShelvUnitType;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  kitchenId: Scalars['ID']['output'];
  minOrderQty?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  priceHistory: Array<ShelvIngredientPriceHistoryEntry>;
  purchaseUnitsPerRecipeUnit?: Maybe<Scalars['Float']['output']>;
  purchasedUnit?: Maybe<ShelvUnitType>;
  shelfLifeDays?: Maybe<Scalars['Float']['output']>;
  storageInstructions?: Maybe<Scalars['String']['output']>;
  supplier?: Maybe<ShelvSupplier>;
  supplierId?: Maybe<Scalars['ID']['output']>;
  supplierSku?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  unitCost?: Maybe<Scalars['Float']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

/** Categories for organizing ingredients */
export enum ShelvIngredientCategory {
  Bakery = 'BAKERY',
  Beverages = 'BEVERAGES',
  Condiments = 'CONDIMENTS',
  Dairy = 'DAIRY',
  DryGoods = 'DRY_GOODS',
  Frozen = 'FROZEN',
  Meat = 'MEAT',
  Produce = 'PRODUCE',
  Seafood = 'SEAFOOD',
  Spices = 'SPICES'
}

export type ShelvIngredientConversion = {
  __typename?: 'ShelvIngredientConversion';
  fromUnit: ShelvUnitType;
  fromValue: Scalars['Float']['output'];
  note?: Maybe<Scalars['String']['output']>;
  toUnit: ShelvUnitType;
  toValue: Scalars['Float']['output'];
};

export type ShelvIngredientConversionInput = {
  fromUnit: ShelvUnitType;
  fromValue?: InputMaybe<Scalars['Float']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  toUnit: ShelvUnitType;
  toValue: Scalars['Float']['input'];
};

export type ShelvIngredientPriceHistoryEntry = {
  __typename?: 'ShelvIngredientPriceHistoryEntry';
  date: Scalars['DateTime']['output'];
  invoiceId?: Maybe<Scalars['ID']['output']>;
  newPrice?: Maybe<Scalars['Float']['output']>;
  oldPrice?: Maybe<Scalars['Float']['output']>;
  source?: Maybe<Scalars['String']['output']>;
};

export type ShelvInvite = {
  __typename?: 'ShelvInvite';
  accessMode: ShelvInviteAccessMode;
  accessedAt?: Maybe<Scalars['DateTime']['output']>;
  activatedAt?: Maybe<Scalars['DateTime']['output']>;
  clientId?: Maybe<Scalars['ID']['output']>;
  couponCode?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdByName?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  emailSentAt?: Maybe<Scalars['DateTime']['output']>;
  existingClientId?: Maybe<Scalars['ID']['output']>;
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  expiringSoonNotifiedAt?: Maybe<Scalars['DateTime']['output']>;
  fName?: Maybe<Scalars['String']['output']>;
  feedbackComment?: Maybe<Scalars['String']['output']>;
  feedbackRating?: Maybe<Scalars['Float']['output']>;
  feedbackSubmittedAt?: Maybe<Scalars['DateTime']['output']>;
  firstRecipeAddedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  invitedByClientId?: Maybe<Scalars['ID']['output']>;
  kitchenId?: Maybe<Scalars['ID']['output']>;
  lName?: Maybe<Scalars['String']['output']>;
  lastChasedAt?: Maybe<Scalars['DateTime']['output']>;
  sharedRecipeId?: Maybe<Scalars['ID']['output']>;
  sharedRecipeName?: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  smsSentAt?: Maybe<Scalars['DateTime']['output']>;
  status: ShelvInviteStatus;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** How the invitee is meant to get access to Shelv */
export enum ShelvInviteAccessMode {
  Coupon = 'COUPON',
  Free = 'FREE',
  Paid = 'PAID',
  RewardTokens = 'REWARD_TOKENS'
}

export type ShelvInviteClaimResult = {
  __typename?: 'ShelvInviteClaimResult';
  clientId?: Maybe<Scalars['ID']['output']>;
  kitchenId?: Maybe<Scalars['ID']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  requiresLogin: Scalars['Boolean']['output'];
  success: Scalars['Boolean']['output'];
  token?: Maybe<Scalars['String']['output']>;
};

export type ShelvInviteGraphNode = {
  __typename?: 'ShelvInviteGraphNode';
  canViewDetail: Scalars['Boolean']['output'];
  detailUrl?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  invitedByClientId?: Maybe<Scalars['ID']['output']>;
  invitedByName?: Maybe<Scalars['String']['output']>;
  status: ShelvInviteStatus;
};

/** Status of a Shelv onboarding invite */
export enum ShelvInviteStatus {
  Accessed = 'ACCESSED',
  Active = 'ACTIVE',
  Expired = 'EXPIRED',
  Paid = 'PAID',
  Pending = 'PENDING'
}

/** Whether an invoice line item mapped to an existing ingredient */
export enum ShelvInvoiceLineItemMatchStatus {
  ManualMap = 'MANUAL_MAP',
  Matched = 'MATCHED',
  Unmatched = 'UNMATCHED'
}

export type ShelvMarkCookedResult = {
  __typename?: 'ShelvMarkCookedResult';
  reason?: Maybe<Scalars['String']['output']>;
  recorded: Scalars['Boolean']['output'];
  timesCooked: Scalars['Float']['output'];
};

export type ShelvMarkDeliveredInput = {
  deliveredAt?: InputMaybe<Scalars['DateTime']['input']>;
  deliveryNotes?: InputMaybe<Scalars['String']['input']>;
  discrepancyNotes?: InputMaybe<Scalars['String']['input']>;
  hasDiscrepancies?: InputMaybe<Scalars['Boolean']['input']>;
  orderId: Scalars['ID']['input'];
};

export type ShelvMealAccompaniment = {
  __typename?: 'ShelvMealAccompaniment';
  name: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  type: ShelvAccompanimentType;
};

export type ShelvMealAccompanimentInput = {
  name: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  type: ShelvAccompanimentType;
};

export type ShelvMealCalendarIssueReportInput = {
  note?: InputMaybe<Scalars['String']['input']>;
  report: Scalars['String']['input'];
};

export type ShelvMealFeedback = {
  __typename?: 'ShelvMealFeedback';
  comments?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  feedbackType: ShelvFeedbackType;
  id: Scalars['ID']['output'];
  isResolved: Scalars['Boolean']['output'];
  kitchenId: Scalars['ID']['output'];
  mealPlan?: Maybe<ShelvMealPlan>;
  mealPlanId?: Maybe<Scalars['ID']['output']>;
  photos?: Maybe<Array<ShelvMealMedia>>;
  rating: Scalars['Float']['output'];
  reportedBy?: Maybe<Scalars['String']['output']>;
  resolutionNotes?: Maybe<Scalars['String']['output']>;
  resolvedAt?: Maybe<Scalars['DateTime']['output']>;
  resolvedBy?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type ShelvMealMedia = {
  __typename?: 'ShelvMealMedia';
  cid?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  mimeType?: Maybe<Scalars['String']['output']>;
  uploadedAt: Scalars['DateTime']['output'];
  uploadedBy?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

export type ShelvMealMediaInput = {
  cid?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  mimeType?: InputMaybe<Scalars['String']['input']>;
  url: Scalars['String']['input'];
};

export type ShelvMealPlan = {
  __typename?: 'ShelvMealPlan';
  accompaniments?: Maybe<Array<ShelvMealAccompaniment>>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  isTemplate: Scalars['Boolean']['output'];
  kitchenId: Scalars['ID']['output'];
  mealDate: Scalars['DateTime']['output'];
  mealType: ShelvMealType;
  quickDescription?: Maybe<Scalars['String']['output']>;
  recipe?: Maybe<ShelvRecipe>;
  recipeId?: Maybe<Scalars['ID']['output']>;
  servicePhotoUploadedAt?: Maybe<Scalars['DateTime']['output']>;
  servicePhotoUploadedBy?: Maybe<Scalars['String']['output']>;
  servicePhotos?: Maybe<Array<ShelvMealMedia>>;
  servings: Scalars['Float']['output'];
  shift?: Maybe<Shift>;
  shiftId?: Maybe<Scalars['ID']['output']>;
  sortOrder: Scalars['Float']['output'];
  specialNotes?: Maybe<Scalars['String']['output']>;
  templateName?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type ShelvMealPlanInAppNotification = {
  __typename?: 'ShelvMealPlanInAppNotification';
  actionUrl?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  isRead: Scalars['Boolean']['output'];
  message: Scalars['String']['output'];
  readAt?: Maybe<Scalars['DateTime']['output']>;
  recipientClientId: Scalars['String']['output'];
  referenceId?: Maybe<Scalars['String']['output']>;
  referenceType?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  title: Scalars['String']['output'];
  type: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type ShelvMealPlanItemInput = {
  mealType: ShelvMealType;
  recipeId: Scalars['ID']['input'];
  servings: Scalars['Float']['input'];
  specialNotes?: InputMaybe<Scalars['String']['input']>;
};

/** How to resolve meal planning notification recipients */
export enum ShelvMealPlanNotificationRecipientType {
  AllManagers = 'ALL_MANAGERS',
  Role = 'ROLE',
  SpecificEmployee = 'SPECIFIC_EMPLOYEE'
}

export type ShelvMealPlanNotificationRule = {
  __typename?: 'ShelvMealPlanNotificationRule';
  channels: Array<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  isEnabled: Scalars['Boolean']['output'];
  messageTemplate?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  recipientClientIds: Array<Scalars['String']['output']>;
  recipientRole?: Maybe<Scalars['String']['output']>;
  recipientType: ShelvMealPlanNotificationRecipientType;
  tenantId: Scalars['String']['output'];
  trigger: ShelvMealPlanNotificationTrigger;
  updatedAt: Scalars['DateTime']['output'];
};

/** Event in the meal planning module that fires a notification */
export enum ShelvMealPlanNotificationTrigger {
  AllEvents = 'ALL_EVENTS',
  FeedbackResolved = 'FEEDBACK_RESOLVED',
  FeedbackSubmitted = 'FEEDBACK_SUBMITTED',
  InvoiceOrderMismatch = 'INVOICE_ORDER_MISMATCH',
  LowRatedFeedback = 'LOW_RATED_FEEDBACK',
  MealPlanCreated = 'MEAL_PLAN_CREATED',
  MealPlanDeleted = 'MEAL_PLAN_DELETED',
  MealPlanUpdated = 'MEAL_PLAN_UPDATED',
  RecipeCreated = 'RECIPE_CREATED',
  RecipeUpdated = 'RECIPE_UPDATED',
  ServicePhotoUploaded = 'SERVICE_PHOTO_UPLOADED',
  SupplierOrderCreated = 'SUPPLIER_ORDER_CREATED',
  SupplierOrderDelivered = 'SUPPLIER_ORDER_DELIVERED',
  SupplierOrderSubmitted = 'SUPPLIER_ORDER_SUBMITTED',
  TemperatureEscalated = 'TEMPERATURE_ESCALATED',
  TemperatureFlagged = 'TEMPERATURE_FLAGGED',
  TemperatureNotRecorded = 'TEMPERATURE_NOT_RECORDED',
  TemperatureOutOfRange = 'TEMPERATURE_OUT_OF_RANGE',
  TemperatureRecorded = 'TEMPERATURE_RECORDED',
  UnknownIngredientOnInvoice = 'UNKNOWN_INGREDIENT_ON_INVOICE'
}

export type ShelvMealPlanPhotoSummary = {
  __typename?: 'ShelvMealPlanPhotoSummary';
  mealPlanId: Scalars['ID']['output'];
  servicePhotos: Array<ShelvMealMedia>;
};

/** Types of meals served during the day */
export enum ShelvMealType {
  AfternoonTea = 'AFTERNOON_TEA',
  Breakfast = 'BREAKFAST',
  Dinner = 'DINNER',
  Lunch = 'LUNCH',
  MorningTea = 'MORNING_TEA',
  Snack = 'SNACK',
  Supper = 'SUPPER'
}

export type ShelvOrderOption = {
  __typename?: 'ShelvOrderOption';
  id: Scalars['ID']['output'];
  orderDate: Scalars['DateTime']['output'];
  orderNumber: Scalars['String']['output'];
  status: Scalars['String']['output'];
  totalAmount: Scalars['Float']['output'];
};

export type ShelvOrderPdfResult = {
  __typename?: 'ShelvOrderPDFResult';
  base64Content: Scalars['String']['output'];
  filename: Scalars['String']['output'];
  mimeType: Scalars['String']['output'];
};

export type ShelvPdfResult = {
  __typename?: 'ShelvPDFResult';
  base64Content: Scalars['String']['output'];
  filename: Scalars['String']['output'];
  mimeType: Scalars['String']['output'];
};

export type ShelvQuickSplitCategoryEntry = {
  category: ShelvIngredientCategory;
  percent: Scalars['Float']['input'];
};

export type ShelvQuickSplitInvoiceInput = {
  categorySplit: Array<ShelvQuickSplitCategoryEntry>;
  gst?: InputMaybe<Scalars['Float']['input']>;
  invoiceDate: Scalars['DateTime']['input'];
  invoiceNumber?: InputMaybe<Scalars['String']['input']>;
  linkedOrderId?: InputMaybe<Scalars['ID']['input']>;
  supplierId?: InputMaybe<Scalars['ID']['input']>;
  supplierNameRaw?: InputMaybe<Scalars['String']['input']>;
  total: Scalars['Float']['input'];
};

export type ShelvRecipe = {
  __typename?: 'ShelvRecipe';
  caloriesPerServing?: Maybe<Scalars['Float']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  cookEvents?: Maybe<Array<ShelvCookEvent>>;
  cookTime?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  cuisine?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dietaryTags?: Maybe<Array<ShelvDietaryTag>>;
  dishType?: Maybe<ShelvRecipeDishType>;
  forkGeneration: Scalars['Float']['output'];
  forkedFromRecipeId?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  imageCid?: Maybe<Scalars['String']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  inferredTag?: Maybe<Scalars['String']['output']>;
  inferredTagAt?: Maybe<Scalars['DateTime']['output']>;
  inferredTagIsManual: Scalars['Boolean']['output'];
  ingredients: Array<ShelvRecipeIngredient>;
  instructions?: Maybe<Scalars['String']['output']>;
  isActive: Scalars['Boolean']['output'];
  kitchenId: Scalars['ID']['output'];
  lastCookedAt?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  originalOwnerClientId?: Maybe<Scalars['ID']['output']>;
  originalOwnerName?: Maybe<Scalars['String']['output']>;
  prepTime?: Maybe<Scalars['Float']['output']>;
  provenance?: Maybe<ShelvRecipeProvenance>;
  rootRecipeId?: Maybe<Scalars['ID']['output']>;
  servings: Scalars['Float']['output'];
  sessionType?: Maybe<ShelvRecipeSessionType>;
  tenantId: Scalars['String']['output'];
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  timesCooked: Scalars['Float']['output'];
  totalTime?: Maybe<Scalars['Float']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

/** Protein or dish category classification for recipes */
export enum ShelvRecipeDishType {
  Beef = 'BEEF',
  Chicken = 'CHICKEN',
  Lamb = 'LAMB',
  Other = 'OTHER',
  Pork = 'PORK',
  Salad = 'SALAD',
  Seafood = 'SEAFOOD',
  Soup = 'SOUP',
  Vegetarian = 'VEGETARIAN'
}

export type ShelvRecipeEditIngredientInput = {
  ingredientName: Scalars['String']['input'];
  isOptional?: InputMaybe<Scalars['Boolean']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  quantity: Scalars['Float']['input'];
  unit: ShelvUnitType;
};

export type ShelvRecipeFeedbackSummary = {
  __typename?: 'ShelvRecipeFeedbackSummary';
  averageRating: Scalars['Float']['output'];
  lowRatingCount: Scalars['Float']['output'];
  recipeId: Scalars['ID']['output'];
  recipeName: Scalars['String']['output'];
  totalFeedback: Scalars['Float']['output'];
};

export type ShelvRecipeIngredient = {
  __typename?: 'ShelvRecipeIngredient';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  ingredient?: Maybe<ShelvIngredient>;
  ingredientId: Scalars['ID']['output'];
  isOptional: Scalars['Boolean']['output'];
  kitchenId: Scalars['ID']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  quantity: Scalars['Float']['output'];
  recipe?: Maybe<ShelvRecipe>;
  recipeId: Scalars['ID']['output'];
  sortOrder?: Maybe<Scalars['Float']['output']>;
  tenantId: Scalars['String']['output'];
  unit: ShelvUnitType;
  updatedAt: Scalars['DateTime']['output'];
};

export type ShelvRecipeIngredientItemInput = {
  ingredientId: Scalars['ID']['input'];
  isOptional?: InputMaybe<Scalars['Boolean']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  quantity: Scalars['Float']['input'];
  sortOrder?: InputMaybe<Scalars['Float']['input']>;
  unit: ShelvUnitType;
};

export type ShelvRecipeProvenance = {
  __typename?: 'ShelvRecipeProvenance';
  canViewOriginal: Scalars['Boolean']['output'];
  forkGeneration: Scalars['Float']['output'];
  originalOwnerName?: Maybe<Scalars['String']['output']>;
  rootRecipeId?: Maybe<Scalars['ID']['output']>;
};

/** When a recipe is typically served */
export enum ShelvRecipeSessionType {
  Breakfast = 'BREAKFAST',
  Dessert = 'DESSERT',
  Dinner = 'DINNER',
  Lunch = 'LUNCH',
  Snack = 'SNACK',
  Supper = 'SUPPER'
}

export type ShelvSaveCapturedRecipeInput = {
  cookTime?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dishType?: InputMaybe<Scalars['String']['input']>;
  imageCid?: InputMaybe<Scalars['String']['input']>;
  ingredients?: InputMaybe<Array<CapturedIngredientInput>>;
  instructions?: InputMaybe<Scalars['String']['input']>;
  jobId?: InputMaybe<Scalars['ID']['input']>;
  kitchenId?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  prepTime?: InputMaybe<Scalars['Int']['input']>;
  servings?: InputMaybe<Scalars['Int']['input']>;
  sessionType?: InputMaybe<Scalars['String']['input']>;
};

export type ShelvSettings = {
  __typename?: 'ShelvSettings';
  createdAt: Scalars['DateTime']['output'];
  cycleAnchorDate: Scalars['DateTime']['output'];
  cycleWeeks: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  kitchenId: Scalars['ID']['output'];
  sharingRequiresPro: Scalars['Boolean']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type ShelvShareRecipeResult = {
  __typename?: 'ShelvShareRecipeResult';
  delivered: Scalars['Boolean']['output'];
  forkedRecipeId?: Maybe<Scalars['ID']['output']>;
  invited: Scalars['Boolean']['output'];
  message: Scalars['String']['output'];
};

export type ShelvSubmitOrderInput = {
  notes?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['ID']['input'];
};

export type ShelvSubmitPublicMealFeedbackInput = {
  comments?: InputMaybe<Scalars['String']['input']>;
  feedbackType?: InputMaybe<ShelvFeedbackType>;
  mealPlanId?: InputMaybe<Scalars['ID']['input']>;
  photos?: InputMaybe<Array<ShelvMealMediaInput>>;
  rating: Scalars['Float']['input'];
  submitterEmail?: InputMaybe<Scalars['String']['input']>;
  submitterName: Scalars['String']['input'];
};

export type ShelvSupplier = {
  __typename?: 'ShelvSupplier';
  abn?: Maybe<Scalars['String']['output']>;
  accountNumber?: Maybe<Scalars['String']['output']>;
  address?: Maybe<Scalars['String']['output']>;
  contactEmail?: Maybe<Scalars['String']['output']>;
  contactName?: Maybe<Scalars['String']['output']>;
  contactPhone?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  ingredientCount: Scalars['Float']['output'];
  ingredients: Array<ShelvIngredient>;
  isActive: Scalars['Boolean']['output'];
  kitchenId: Scalars['ID']['output'];
  leadTimeDays: Scalars['Float']['output'];
  minimumOrder?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  orders: Array<ShelvSupplierOrder>;
  paymentTerms?: Maybe<Scalars['String']['output']>;
  preferredCategories?: Maybe<Array<ShelvIngredientCategory>>;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  website?: Maybe<Scalars['String']['output']>;
};

export type ShelvSupplierOrder = {
  __typename?: 'ShelvSupplierOrder';
  actualDelivery?: Maybe<Scalars['DateTime']['output']>;
  cancellationReason?: Maybe<Scalars['String']['output']>;
  cancelledAt?: Maybe<Scalars['DateTime']['output']>;
  cancelledBy?: Maybe<Scalars['String']['output']>;
  confirmedAt?: Maybe<Scalars['DateTime']['output']>;
  confirmedBy?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  deliveredAt?: Maybe<Scalars['DateTime']['output']>;
  deliveryNotes?: Maybe<Scalars['String']['output']>;
  discrepancyNotes?: Maybe<Scalars['String']['output']>;
  expectedDelivery?: Maybe<Scalars['DateTime']['output']>;
  hasDiscrepancies: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  itemCount: Scalars['Float']['output'];
  items: Array<ShelvSupplierOrderItem>;
  kitchenId: Scalars['ID']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  orderDate: Scalars['DateTime']['output'];
  orderNumber?: Maybe<Scalars['String']['output']>;
  status: ShelvSupplierOrderStatus;
  submittedAt?: Maybe<Scalars['DateTime']['output']>;
  submittedBy?: Maybe<Scalars['String']['output']>;
  supplier?: Maybe<ShelvSupplier>;
  supplierId: Scalars['ID']['output'];
  supplierOrderNumber?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  totalAmount: Scalars['Float']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type ShelvSupplierOrderItem = {
  __typename?: 'ShelvSupplierOrderItem';
  createdAt: Scalars['DateTime']['output'];
  hasDiscrepancy: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  ingredient?: Maybe<ShelvIngredient>;
  ingredientId: Scalars['ID']['output'];
  kitchenId: Scalars['ID']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  order?: Maybe<ShelvSupplierOrder>;
  orderId: Scalars['ID']['output'];
  quantity: Scalars['Float']['output'];
  receivedQuantity?: Maybe<Scalars['Float']['output']>;
  tenantId: Scalars['String']['output'];
  totalPrice: Scalars['Float']['output'];
  unit: ShelvUnitType;
  unitPrice: Scalars['Float']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type ShelvSupplierOrderItemInput = {
  ingredientId: Scalars['ID']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  quantity: Scalars['Float']['input'];
  unit: ShelvUnitType;
  unitPrice?: InputMaybe<Scalars['Float']['input']>;
};

/** Status of a supplier order */
export enum ShelvSupplierOrderStatus {
  Cancelled = 'CANCELLED',
  Confirmed = 'CONFIRMED',
  Delivered = 'DELIVERED',
  Draft = 'DRAFT',
  Shipped = 'SHIPPED',
  Submitted = 'SUBMITTED'
}

export type ShelvUnitConfig = {
  __typename?: 'ShelvUnitConfig';
  createdAt: Scalars['DateTime']['output'];
  deactivatedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  displayOrder: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  inUseIngredientsCount?: Maybe<Scalars['Int']['output']>;
  inUseRecipeRowsCount?: Maybe<Scalars['Int']['output']>;
  isActive: Scalars['Boolean']['output'];
  kitchenId: Scalars['ID']['output'];
  migrateTo?: Maybe<ShelvUnitType>;
  tenantId: Scalars['String']['output'];
  unit: ShelvUnitType;
  updatedAt: Scalars['DateTime']['output'];
};

export type ShelvUnitRetireManualItem = {
  __typename?: 'ShelvUnitRetireManualItem';
  currentQuantity?: Maybe<Scalars['Float']['output']>;
  currentUnit: ShelvUnitType;
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  kind: Scalars['String']['output'];
  reason: Scalars['String']['output'];
};

export type ShelvUnitRetireReport = {
  __typename?: 'ShelvUnitRetireReport';
  ingredientsMigrated: Scalars['Int']['output'];
  manualLadder: Array<ShelvUnitRetireManualItem>;
  recipeRowsAutoConverted: Scalars['Int']['output'];
};

export type ShelvUnitRetireResult = {
  __typename?: 'ShelvUnitRetireResult';
  report: ShelvUnitRetireReport;
  unitConfig: ShelvUnitConfig;
};

export type ShelvUnitSyncMismatch = {
  __typename?: 'ShelvUnitSyncMismatch';
  currentQuantity: Scalars['Float']['output'];
  currentUnit: ShelvUnitType;
  recipeId: Scalars['ID']['output'];
  recipeIngredientId: Scalars['ID']['output'];
  recipeName: Scalars['String']['output'];
};

export type ShelvUnitSyncReport = {
  __typename?: 'ShelvUnitSyncReport';
  convertedCount: Scalars['Int']['output'];
  mismatched: Array<ShelvUnitSyncMismatch>;
};

/** Units of measurement for ingredients */
export enum ShelvUnitType {
  Bunches = 'BUNCHES',
  Cans = 'CANS',
  Cups = 'CUPS',
  Dozen = 'DOZEN',
  Grams = 'GRAMS',
  Kilograms = 'KILOGRAMS',
  Liters = 'LITERS',
  Milliliters = 'MILLILITERS',
  Packages = 'PACKAGES',
  Pieces = 'PIECES',
  Slices = 'SLICES',
  Tablespoons = 'TABLESPOONS',
  Teaspoons = 'TEASPOONS',
  Units = 'UNITS',
  Whole = 'WHOLE'
}

export type ShelvUpdateFoodBudgetInput = {
  currency?: InputMaybe<Scalars['String']['input']>;
  financialYearStartMonth?: InputMaybe<Scalars['Int']['input']>;
  monthlyBudget?: InputMaybe<Scalars['Float']['input']>;
};

export type ShelvUpdateIngredientInput = {
  category?: InputMaybe<ShelvIngredientCategory>;
  conversions?: InputMaybe<Array<ShelvIngredientConversionInput>>;
  defaultUnit?: InputMaybe<ShelvUnitType>;
  description?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  minOrderQty?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  purchaseUnitsPerRecipeUnit?: InputMaybe<Scalars['Float']['input']>;
  purchasedUnit?: InputMaybe<ShelvUnitType>;
  shelfLifeDays?: InputMaybe<Scalars['Float']['input']>;
  storageInstructions?: InputMaybe<Scalars['String']['input']>;
  supplierId?: InputMaybe<Scalars['ID']['input']>;
  supplierSku?: InputMaybe<Scalars['String']['input']>;
  unitCost?: InputMaybe<Scalars['Float']['input']>;
};

export type ShelvUpdateIngredientResult = {
  __typename?: 'ShelvUpdateIngredientResult';
  ingredient: ShelvIngredient;
  unitSyncReport: ShelvUnitSyncReport;
};

export type ShelvUpdateKitchenInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  logoCid?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type ShelvUpdateMealFeedbackInput = {
  comments?: InputMaybe<Scalars['String']['input']>;
  feedbackType?: InputMaybe<ShelvFeedbackType>;
  isResolved?: InputMaybe<Scalars['Boolean']['input']>;
  rating?: InputMaybe<Scalars['Float']['input']>;
  resolutionNotes?: InputMaybe<Scalars['String']['input']>;
};

export type ShelvUpdateMealPlanInput = {
  accompaniments?: InputMaybe<Array<ShelvMealAccompanimentInput>>;
  mealDate?: InputMaybe<Scalars['String']['input']>;
  mealType?: InputMaybe<ShelvMealType>;
  quickDescription?: InputMaybe<Scalars['String']['input']>;
  recipeId?: InputMaybe<Scalars['ID']['input']>;
  servings?: InputMaybe<Scalars['Float']['input']>;
  specialNotes?: InputMaybe<Scalars['String']['input']>;
};

export type ShelvUpdateMealPlanNotificationRuleInput = {
  channels?: InputMaybe<Array<Scalars['String']['input']>>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  messageTemplate?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  recipientClientIds?: InputMaybe<Array<Scalars['String']['input']>>;
  recipientRole?: InputMaybe<Scalars['String']['input']>;
  recipientType?: InputMaybe<ShelvMealPlanNotificationRecipientType>;
  trigger?: InputMaybe<ShelvMealPlanNotificationTrigger>;
};

export type ShelvUpdateMealPlanningSettingsInput = {
  cycleAnchorDate: Scalars['String']['input'];
  cycleWeeks?: InputMaybe<Scalars['Int']['input']>;
};

export type ShelvUpdateRecipeIngredientInput = {
  isOptional?: InputMaybe<Scalars['Boolean']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  sortOrder?: InputMaybe<Scalars['Float']['input']>;
  unit?: InputMaybe<ShelvUnitType>;
};

export type ShelvUpdateRecipeIngredientResult = {
  __typename?: 'ShelvUpdateRecipeIngredientResult';
  recipeIngredient: ShelvRecipeIngredient;
  unitSyncReport: ShelvUnitSyncReport;
};

export type ShelvUpdateRecipeInput = {
  caloriesPerServing?: InputMaybe<Scalars['Float']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  cookTime?: InputMaybe<Scalars['Float']['input']>;
  cuisine?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dietaryTags?: InputMaybe<Array<ShelvDietaryTag>>;
  dishType?: InputMaybe<ShelvRecipeDishType>;
  imageCid?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  ingredientRows?: InputMaybe<Array<ShelvRecipeEditIngredientInput>>;
  instructions?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  prepTime?: InputMaybe<Scalars['Float']['input']>;
  servings?: InputMaybe<Scalars['Float']['input']>;
  sessionType?: InputMaybe<ShelvRecipeSessionType>;
  thumbnailUrl?: InputMaybe<Scalars['String']['input']>;
};

export type ShelvUpdateSupplierInput = {
  abn?: InputMaybe<Scalars['String']['input']>;
  accountNumber?: InputMaybe<Scalars['String']['input']>;
  address?: InputMaybe<Scalars['String']['input']>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactName?: InputMaybe<Scalars['String']['input']>;
  contactPhone?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  leadTimeDays?: InputMaybe<Scalars['Float']['input']>;
  minimumOrder?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  paymentTerms?: InputMaybe<Scalars['String']['input']>;
  preferredCategories?: InputMaybe<Array<ShelvIngredientCategory>>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type ShelvUpdateSupplierOrderInput = {
  expectedDelivery?: InputMaybe<Scalars['DateTime']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ShelvSupplierOrderStatus>;
  supplierOrderNumber?: InputMaybe<Scalars['String']['input']>;
};

export type ShelvUploadInvoiceInput = {
  fileCid?: InputMaybe<Scalars['String']['input']>;
  fileName: Scalars['String']['input'];
  fileUrl: Scalars['String']['input'];
  linkedOrderId?: InputMaybe<Scalars['ID']['input']>;
  mimeType: Scalars['String']['input'];
};

export type Shift = {
  __typename?: 'Shift';
  area?: Maybe<Scalars['String']['output']>;
  assignedStaffCount: Scalars['Float']['output'];
  assignments: Array<ShiftAssignment>;
  breaks?: Maybe<Array<BreakPeriod>>;
  calendarEventId?: Maybe<Scalars['String']['output']>;
  calendarId?: Maybe<Scalars['String']['output']>;
  cancellationReason?: Maybe<Scalars['String']['output']>;
  cancelledAt?: Maybe<Scalars['DateTime']['output']>;
  changeLog?: Maybe<Array<ShiftChangeLogEntry>>;
  color?: Maybe<Scalars['String']['output']>;
  coverageGuidance: ShiftCoverageGuidance;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  departmentId?: Maybe<Scalars['String']['output']>;
  departmentIds?: Maybe<Array<Scalars['String']['output']>>;
  departmentName?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  duties?: Maybe<Array<Scalars['String']['output']>>;
  employeeRoleId?: Maybe<Scalars['String']['output']>;
  endTime: Scalars['DateTime']['output'];
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isFloat?: Maybe<Scalars['Boolean']['output']>;
  isRecurring: Scalars['Boolean']['output'];
  jobIds?: Maybe<Array<Scalars['String']['output']>>;
  lastModifiedBy?: Maybe<Scalars['String']['output']>;
  locationCodes?: Maybe<Array<Scalars['String']['output']>>;
  locationIds?: Maybe<Array<Scalars['String']['output']>>;
  locationNames?: Maybe<Array<Scalars['String']['output']>>;
  locations: Array<Location>;
  metadata?: Maybe<Scalars['JSONObject']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  parentShiftId?: Maybe<Scalars['String']['output']>;
  payType?: Maybe<Scalars['String']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  recurringPatternId?: Maybe<Scalars['String']['output']>;
  requiredCertifications?: Maybe<Array<Scalars['String']['output']>>;
  requiredSkills?: Maybe<Array<Scalars['String']['output']>>;
  requiredStaffCount: Scalars['Float']['output'];
  residentIds?: Maybe<Array<Scalars['String']['output']>>;
  residentNames?: Maybe<Array<Scalars['String']['output']>>;
  rosterMode: RosterMode;
  scheduledDurationMinutes: Scalars['Float']['output'];
  shiftType: Scalars['String']['output'];
  startTime: Scalars['DateTime']['output'];
  status: ShiftStatus;
  structuredShiftTitle?: Maybe<Scalars['String']['output']>;
  taskTemplateId?: Maybe<Scalars['String']['output']>;
  team?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  timezone?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  totalBreakMinutes: Scalars['Float']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type ShiftAssignment = {
  __typename?: 'ShiftAssignment';
  absenceEndTime?: Maybe<Scalars['DateTime']['output']>;
  absenceHours?: Maybe<Scalars['Float']['output']>;
  absenceIsPaidLeave?: Maybe<Scalars['Boolean']['output']>;
  absenceMarkedAt?: Maybe<Scalars['DateTime']['output']>;
  absenceMarkedBy?: Maybe<Scalars['String']['output']>;
  absenceNotes?: Maybe<Scalars['String']['output']>;
  absenceReason?: Maybe<AbsenceReason>;
  absenceStartTime?: Maybe<Scalars['DateTime']['output']>;
  absences?: Maybe<Array<AbsenceSegment>>;
  actualHoursWorked?: Maybe<Scalars['Float']['output']>;
  assignedAt?: Maybe<Scalars['DateTime']['output']>;
  checkInTime?: Maybe<Scalars['DateTime']['output']>;
  checkOutTime?: Maybe<Scalars['DateTime']['output']>;
  confirmedAt?: Maybe<Scalars['DateTime']['output']>;
  departmentIds?: Maybe<Array<Scalars['String']['output']>>;
  employeeId: Scalars['String']['output'];
  employeeName?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  pickupPendingApproval?: Maybe<Scalars['Boolean']['output']>;
  pickupRejectedAt?: Maybe<Scalars['DateTime']['output']>;
  pickupRejectedById?: Maybe<Scalars['String']['output']>;
  pickupRejectedByName?: Maybe<Scalars['String']['output']>;
  roleId?: Maybe<Scalars['String']['output']>;
  status: AssignmentStatus;
};

export type ShiftAssignmentInput = {
  absenceEndTime?: InputMaybe<Scalars['DateTime']['input']>;
  absenceHours?: InputMaybe<Scalars['Float']['input']>;
  absenceIsPaidLeave?: InputMaybe<Scalars['Boolean']['input']>;
  absenceMarkedAt?: InputMaybe<Scalars['DateTime']['input']>;
  absenceMarkedBy?: InputMaybe<Scalars['String']['input']>;
  absenceNotes?: InputMaybe<Scalars['String']['input']>;
  absenceReason?: InputMaybe<AbsenceReason>;
  absenceStartTime?: InputMaybe<Scalars['DateTime']['input']>;
  absences?: InputMaybe<Array<AbsenceSegmentInput>>;
  actualHoursWorked?: InputMaybe<Scalars['Float']['input']>;
  assignedAt?: InputMaybe<Scalars['DateTime']['input']>;
  checkInTime?: InputMaybe<Scalars['DateTime']['input']>;
  checkOutTime?: InputMaybe<Scalars['DateTime']['input']>;
  confirmedAt?: InputMaybe<Scalars['DateTime']['input']>;
  departmentIds?: InputMaybe<Array<Scalars['String']['input']>>;
  employeeId: Scalars['String']['input'];
  employeeName?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  pickupPendingApproval?: InputMaybe<Scalars['Boolean']['input']>;
  pickupRejectedAt?: InputMaybe<Scalars['DateTime']['input']>;
  pickupRejectedById?: InputMaybe<Scalars['String']['input']>;
  pickupRejectedByName?: InputMaybe<Scalars['String']['input']>;
  roleId?: InputMaybe<Scalars['String']['input']>;
  status: AssignmentStatus;
};

export type ShiftChangeLogEntry = {
  __typename?: 'ShiftChangeLogEntry';
  action: Scalars['String']['output'];
  changedAt: Scalars['DateTime']['output'];
  changedBy?: Maybe<Scalars['String']['output']>;
  changedById?: Maybe<Scalars['ID']['output']>;
  employeeId?: Maybe<Scalars['String']['output']>;
  employeeName?: Maybe<Scalars['String']['output']>;
  fromStatus?: Maybe<Scalars['String']['output']>;
  newActualHoursWorked?: Maybe<Scalars['Float']['output']>;
  newCheckInTime?: Maybe<Scalars['DateTime']['output']>;
  newCheckOutTime?: Maybe<Scalars['DateTime']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  previousActualHoursWorked?: Maybe<Scalars['Float']['output']>;
  previousCheckInTime?: Maybe<Scalars['DateTime']['output']>;
  previousCheckOutTime?: Maybe<Scalars['DateTime']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  toStatus?: Maybe<Scalars['String']['output']>;
};

export type ShiftCoverageGuidance = {
  __typename?: 'ShiftCoverageGuidance';
  body: Scalars['String']['output'];
  headline: Scalars['String']['output'];
  onLeaveCount: Scalars['Int']['output'];
  requiredStaffCount: Scalars['Int']['output'];
  state: Scalars['String']['output'];
  tone: Scalars['String']['output'];
  workingCount: Scalars['Int']['output'];
};

export type ShiftInput = {
  area?: InputMaybe<Scalars['String']['input']>;
  breaks?: InputMaybe<Array<BreakPeriodInput>>;
  calendarId?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  departmentId?: InputMaybe<Scalars['String']['input']>;
  departmentIds?: InputMaybe<Array<Scalars['String']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  duties?: InputMaybe<Array<Scalars['String']['input']>>;
  employeeRoleId?: InputMaybe<Scalars['String']['input']>;
  endTime: Scalars['DateTime']['input'];
  isFloat?: InputMaybe<Scalars['Boolean']['input']>;
  isRecurring?: InputMaybe<Scalars['Boolean']['input']>;
  jobIds?: InputMaybe<Array<Scalars['String']['input']>>;
  locationIds?: InputMaybe<Array<Scalars['String']['input']>>;
  metadata?: InputMaybe<Scalars['JSONObject']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  payType?: InputMaybe<Scalars['String']['input']>;
  requiredCertifications?: InputMaybe<Array<Scalars['String']['input']>>;
  requiredSkills?: InputMaybe<Array<Scalars['String']['input']>>;
  requiredStaffCount?: InputMaybe<Scalars['Float']['input']>;
  residentIds?: InputMaybe<Array<Scalars['String']['input']>>;
  residentNames?: InputMaybe<Array<Scalars['String']['input']>>;
  rosterMode?: InputMaybe<RosterMode>;
  shiftType?: InputMaybe<Scalars['String']['input']>;
  startTime: Scalars['DateTime']['input'];
  team?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  totalBreakMinutes?: InputMaybe<Scalars['Float']['input']>;
};

/** Type of leave being requested */
export enum ShiftLeaveType {
  AnnualLeave = 'ANNUAL_LEAVE',
  CompassionateLeave = 'COMPASSIONATE_LEAVE',
  LongServiceLeave = 'LONG_SERVICE_LEAVE',
  PersonalLeave = 'PERSONAL_LEAVE',
  SickLeave = 'SICK_LEAVE',
  StudyLeave = 'STUDY_LEAVE'
}

export type ShiftModeBreakdown = {
  __typename?: 'ShiftModeBreakdown';
  draft: Scalars['Float']['output'];
  master: Scalars['Float']['output'];
  public: Scalars['Float']['output'];
  publicByStatus: Array<ShiftStatusCount>;
  total: Scalars['Float']['output'];
};

export type ShiftNotificationLog = {
  __typename?: 'ShiftNotificationLog';
  channels: Array<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  failedCount: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  isTestFire?: Maybe<Scalars['Boolean']['output']>;
  outcomes: Array<ShiftNotificationOutcome>;
  recipientCount: Scalars['Int']['output'];
  ruleId?: Maybe<Scalars['String']['output']>;
  ruleName?: Maybe<Scalars['String']['output']>;
  sentCount: Scalars['Int']['output'];
  shiftId?: Maybe<Scalars['String']['output']>;
  skippedCount: Scalars['Int']['output'];
  swapRequestId?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  trigger: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type ShiftNotificationOutcome = {
  __typename?: 'ShiftNotificationOutcome';
  channel: Scalars['String']['output'];
  clientId: Scalars['String']['output'];
  destination?: Maybe<Scalars['String']['output']>;
  employeeId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  recipientName: Scalars['String']['output'];
  status: ShiftNotificationOutcomeStatus;
};

/** Per-recipient, per-channel result of a shift notification dispatch */
export enum ShiftNotificationOutcomeStatus {
  Failed = 'FAILED',
  Sent = 'SENT',
  Skipped = 'SKIPPED'
}

/** How to resolve the notification recipient(s) */
export enum ShiftNotificationRecipientType {
  AllManagers = 'ALL_MANAGERS',
  AssignedEmployee = 'ASSIGNED_EMPLOYEE',
  Department = 'DEPARTMENT',
  EligibleStaff = 'ELIGIBLE_STAFF',
  Role = 'ROLE',
  SpecificEmployee = 'SPECIFIC_EMPLOYEE',
  Supervisor = 'SUPERVISOR'
}

export type ShiftNotificationRule = {
  __typename?: 'ShiftNotificationRule';
  channels: Array<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  filterDepartmentId?: Maybe<Scalars['String']['output']>;
  filterLocation?: Maybe<Scalars['String']['output']>;
  filterTeam?: Maybe<Scalars['String']['output']>;
  fireCount: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  isEnabled: Scalars['Boolean']['output'];
  lastFiredAt?: Maybe<Scalars['DateTime']['output']>;
  messageTemplate?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  recipientDepartmentId?: Maybe<Scalars['String']['output']>;
  recipientIds?: Maybe<Array<Scalars['String']['output']>>;
  recipientRole?: Maybe<Scalars['String']['output']>;
  recipientType: ShiftNotificationRecipientType;
  tenantId: Scalars['String']['output'];
  timing: ShiftNotificationTiming;
  timingMinutes?: Maybe<Scalars['Float']['output']>;
  trigger: ShiftNotificationTrigger;
  updatedAt: Scalars['DateTime']['output'];
};

/** When to send the notification relative to the trigger */
export enum ShiftNotificationTiming {
  Immediate = 'IMMEDIATE',
  MinutesAfter = 'MINUTES_AFTER',
  MinutesBefore = 'MINUTES_BEFORE'
}

/** Event that triggers the notification */
export enum ShiftNotificationTrigger {
  AbsenceRecorded = 'ABSENCE_RECORDED',
  CheckIn = 'CHECK_IN',
  CheckOut = 'CHECK_OUT',
  LeaveApproved = 'LEAVE_APPROVED',
  LeaveDenied = 'LEAVE_DENIED',
  LeaveRequested = 'LEAVE_REQUESTED',
  NoCheckIn = 'NO_CHECK_IN',
  OpenShiftAvailable = 'OPEN_SHIFT_AVAILABLE',
  PickupApproved = 'PICKUP_APPROVED',
  PickupNotChosen = 'PICKUP_NOT_CHOSEN',
  PickupRejected = 'PICKUP_REJECTED',
  ShiftAssigned = 'SHIFT_ASSIGNED',
  ShiftCancelled = 'SHIFT_CANCELLED',
  ShiftNotAttending = 'SHIFT_NOT_ATTENDING',
  ShiftPickedUp = 'SHIFT_PICKED_UP',
  ShiftSwapApproved = 'SHIFT_SWAP_APPROVED',
  ShiftSwapCancelled = 'SHIFT_SWAP_CANCELLED',
  ShiftSwapChase = 'SHIFT_SWAP_CHASE',
  ShiftSwapCompleted = 'SHIFT_SWAP_COMPLETED',
  ShiftSwapDeclined = 'SHIFT_SWAP_DECLINED',
  ShiftSwapDenied = 'SHIFT_SWAP_DENIED',
  ShiftSwapEscalated = 'SHIFT_SWAP_ESCALATED',
  ShiftSwapExpired = 'SHIFT_SWAP_EXPIRED',
  ShiftSwapRequested = 'SHIFT_SWAP_REQUESTED',
  ShiftTimeChanged = 'SHIFT_TIME_CHANGED',
  ShiftUnassigned = 'SHIFT_UNASSIGNED'
}

/** Who may claim an open shift from the pick-up page */
export enum ShiftPickupPolicy {
  Anyone = 'ANYONE',
  SameDepartment = 'SAME_DEPARTMENT',
  SameRole = 'SAME_ROLE'
}

export type ShiftSettings = {
  __typename?: 'ShiftSettings';
  allowNotAttending: Scalars['Boolean']['output'];
  careMinutesDataStartDate?: Maybe<Scalars['String']['output']>;
  careMinutesTargetPerResident: Scalars['Float']['output'];
  clockInCutoffMinutes: Scalars['Float']['output'];
  clockOutReminderMinutesBefore: Scalars['Float']['output'];
  coverageThresholdPct: Scalars['Float']['output'];
  createdAt: Scalars['DateTime']['output'];
  draftLeadDays: Scalars['Float']['output'];
  earlyCheckInMinutes: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  leadTimeWarningsEnabled: Scalars['Boolean']['output'];
  leaveBlockThreshold: Scalars['Int']['output'];
  masterRosterStartDate?: Maybe<Scalars['DateTime']['output']>;
  maxPickupRequestsPerShift: Scalars['Float']['output'];
  noCheckInAlertMinutes: Scalars['Float']['output'];
  nonShiftWorkerCheckInCutoffMinutes: Scalars['Float']['output'];
  nonShiftWorkerReminderEmail: Scalars['Boolean']['output'];
  nonShiftWorkerReminderInApp: Scalars['Boolean']['output'];
  nonShiftWorkerReminderMinutesBefore: Scalars['Float']['output'];
  nonShiftWorkerReminderSms: Scalars['Boolean']['output'];
  nonShiftWorkerRemindersEnabled: Scalars['Boolean']['output'];
  publishLeadDays: Scalars['Float']['output'];
  reminderEmail: Scalars['Boolean']['output'];
  reminderInApp: Scalars['Boolean']['output'];
  reminderMinutesBefore: Scalars['Float']['output'];
  reminderSms: Scalars['Boolean']['output'];
  remindersEnabled: Scalars['Boolean']['output'];
  requireSickLeaveCertificate: Scalars['Boolean']['output'];
  shiftPickupAutoConfirm: Scalars['Boolean']['output'];
  shiftPickupPolicy: ShiftPickupPolicy;
  showStaffLeaveBalance: Scalars['Boolean']['output'];
  sickLeaveCertReminderDays: Scalars['Float']['output'];
  swapApproverEmployeeIds?: Maybe<Array<Scalars['String']['output']>>;
  swapChaseEmail: Scalars['Boolean']['output'];
  swapChaseEnabled: Scalars['Boolean']['output'];
  swapChaseEscalateHoursBefore: Scalars['Float']['output'];
  swapChaseFrequencyMinutes: Scalars['Float']['output'];
  swapChaseQuietEnd: Scalars['String']['output'];
  swapChaseQuietStart: Scalars['String']['output'];
  swapChaseSms: Scalars['Boolean']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** Status of a shift */
export enum ShiftStatus {
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Draft = 'DRAFT',
  Filled = 'FILLED',
  InProgress = 'IN_PROGRESS',
  Open = 'OPEN',
  PartiallyFilled = 'PARTIALLY_FILLED'
}

export type ShiftStatusCount = {
  __typename?: 'ShiftStatusCount';
  count: Scalars['Float']['output'];
  status: Scalars['String']['output'];
};

export type ShiftSwapRequest = {
  __typename?: 'ShiftSwapRequest';
  chaseCount?: Maybe<Scalars['Float']['output']>;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  decidedAt?: Maybe<Scalars['DateTime']['output']>;
  decidedById?: Maybe<Scalars['String']['output']>;
  decidedByName?: Maybe<Scalars['String']['output']>;
  decisionReason?: Maybe<Scalars['String']['output']>;
  employeeAId: Scalars['String']['output'];
  employeeAName?: Maybe<Scalars['String']['output']>;
  employeeBId: Scalars['String']['output'];
  employeeBName?: Maybe<Scalars['String']['output']>;
  escalatedAt?: Maybe<Scalars['DateTime']['output']>;
  failureReason?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastChaseAt?: Maybe<Scalars['DateTime']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  requestedAt: Scalars['DateTime']['output'];
  requestedByManager: Scalars['Boolean']['output'];
  respondedAt?: Maybe<Scalars['DateTime']['output']>;
  responseReason?: Maybe<Scalars['String']['output']>;
  shiftAEndTime?: Maybe<Scalars['DateTime']['output']>;
  shiftAId: Scalars['String']['output'];
  shiftAStartTime?: Maybe<Scalars['DateTime']['output']>;
  shiftATitle?: Maybe<Scalars['String']['output']>;
  shiftBEndTime?: Maybe<Scalars['DateTime']['output']>;
  shiftBId: Scalars['String']['output'];
  shiftBStartTime?: Maybe<Scalars['DateTime']['output']>;
  shiftBTitle?: Maybe<Scalars['String']['output']>;
  status: ShiftSwapStatus;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  warnings?: Maybe<ShiftSwapWarnings>;
};

/** Where a shift swap request is in its lifecycle */
export enum ShiftSwapStatus {
  AwaitingAcceptance = 'AWAITING_ACCEPTANCE',
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Declined = 'DECLINED',
  Denied = 'DENIED',
  PendingApproval = 'PENDING_APPROVAL'
}

export type ShiftSwapWarnings = {
  __typename?: 'ShiftSwapWarnings';
  overlapForCounterparty: Scalars['Boolean']['output'];
  overlapForInitiator: Scalars['Boolean']['output'];
  roleMismatch: Scalars['Boolean']['output'];
};

export type ShiftTemplate = {
  __typename?: 'ShiftTemplate';
  breakMinutes: Scalars['Float']['output'];
  createdAt: Scalars['DateTime']['output'];
  department: Scalars['String']['output'];
  departmentIds?: Maybe<Array<Scalars['String']['output']>>;
  description?: Maybe<Scalars['String']['output']>;
  employeeRoleId?: Maybe<Scalars['String']['output']>;
  endTime: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  isFloat?: Maybe<Scalars['Boolean']['output']>;
  isOvernight: Scalars['Boolean']['output'];
  locationIds?: Maybe<Array<Scalars['String']['output']>>;
  requiredStaffCount: Scalars['Float']['output'];
  shiftType: Scalars['String']['output'];
  skills?: Maybe<Array<Scalars['String']['output']>>;
  sortOrder: Scalars['Float']['output'];
  startTime: Scalars['String']['output'];
  team?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  weekdaysOnly: Scalars['Boolean']['output'];
};

export type ShiftType = {
  __typename?: 'ShiftType';
  category?: Maybe<ShiftTypeCategory>;
  code: Scalars['String']['output'];
  color?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  displayOrder?: Maybe<Scalars['Float']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  shiftUsageCount: Scalars['Int']['output'];
  templateUsageCount: Scalars['Int']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** Whether a shift type is a normal worked shift, a meeting, or education/training (both paid, counted as education hours) */
export enum ShiftTypeCategory {
  Education = 'EDUCATION',
  Meeting = 'MEETING',
  Standard = 'STANDARD'
}

export type ShiftTypeInput = {
  category?: InputMaybe<ShiftTypeCategory>;
  code: Scalars['String']['input'];
  color?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayOrder?: InputMaybe<Scalars['Float']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
};

export type SignInSessionView = {
  __typename?: 'SignInSessionView';
  /** Assurance level at sign-in: 1 or 2. */
  aal: Scalars['Int']['output'];
  /** How this sign-in was proven (amr): pwd, passkey, email_code, sms_code, recovery, or a link marker. */
  amr: Array<Scalars['String']['output']>;
  /** Two-letter country code, only when the hosting already supplied one. Never looked up. */
  country?: Maybe<Scalars['String']['output']>;
  /** When this sign-in happened. */
  createdAt: Scalars['DateTime']['output'];
  /** Plain words from the browser, e.g. "Chrome on Mac". "Unknown device" until it is first used. */
  deviceLabel: Scalars['String']['output'];
  /** desktop · mobile · tablet · unknown */
  deviceType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** IP address of the last request seen. */
  ipAddress?: Maybe<Scalars['String']['output']>;
  /** This is the sign-in making this request. */
  isCurrent: Scalars['Boolean']['output'];
  /** Last request from this sign-in. Updated at most every few minutes, so it can be up to 5 minutes behind. */
  lastSeenAt: Scalars['DateTime']['output'];
};

export type SignInviteContractInput = {
  /** Home address — the contract names it. */
  address: Scalars['String']['input'];
  /** The invitee ticked the declaration. */
  agreed: Scalars['Boolean']['input'];
  /** Signature as a base64 PNG/JPEG data URL. */
  signatureImage: Scalars['String']['input'];
  /** Full legal name, as it should appear on the contract. */
  signerName: Scalars['String']['input'];
  slug: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

export type SignMyEmployeeFormInput = {
  formType: EmployeeFormType;
  /** PNG data URL of the drawn or typed signature. */
  signatureImage: Scalars['String']['input'];
};

export type SignOffHistoryByDate = {
  __typename?: 'SignOffHistoryByDate';
  signedOffAt: Scalars['DateTime']['output'];
  userId: Scalars['ID']['output'];
  userName: Scalars['String']['output'];
};

export type SignOffHistoryByLogin = {
  __typename?: 'SignOffHistoryByLogin';
  lastSignedOffAt: Scalars['DateTime']['output'];
  userId: Scalars['ID']['output'];
  userName: Scalars['String']['output'];
};

export type SignOffHistoryFilterInput = {
  date?: InputMaybe<Scalars['DateTime']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  type: SignOffHistoryType;
};

/** Type of sign-off history view for day book */
export enum SignOffHistoryType {
  ByDate = 'BY_DATE',
  ByLogin = 'BY_LOGIN'
}

export type SignProgramAgreementInput = {
  /** PNG/JPEG data URL of the drawn or typed signature. */
  signatureImage: Scalars['String']['input'];
  tierId: Scalars['ID']['input'];
};

export type SignupWithUsernameInput = {
  password: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

export type SiteCrewMember = {
  __typename?: 'SiteCrewMember';
  employeeId?: Maybe<Scalars['ID']['output']>;
  name: Scalars['String']['output'];
  phone: Scalars['String']['output'];
};

export type SiteCrewMemberInput = {
  employeeId?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  phone: Scalars['String']['input'];
};

export type SiteEditCommand = {
  __typename?: 'SiteEditCommand';
  commandId: Scalars['String']['output'];
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  duration?: Maybe<Scalars['Float']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  output?: Maybe<Scalars['String']['output']>;
  prompt: Scalars['String']['output'];
  requestedBy: Scalars['String']['output'];
  requestedByName?: Maybe<Scalars['String']['output']>;
  sessionId?: Maybe<Scalars['String']['output']>;
  siteId: Scalars['String']['output'];
  startedAt: Scalars['DateTime']['output'];
  status: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type SiteEditCommandFilters = {
  limit?: InputMaybe<Scalars['Float']['input']>;
  offset?: InputMaybe<Scalars['Float']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  siteId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type SiteEditStatsResult = {
  __typename?: 'SiteEditStatsResult';
  byUser: Array<UserEditStats>;
  error?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  totalEdits: Scalars['Float']['output'];
};

export type SiteEditorSite = {
  __typename?: 'SiteEditorSite';
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  devServerIp?: Maybe<Scalars['String']['output']>;
  devServerPort?: Maybe<Scalars['Float']['output']>;
  githubToken?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  lastEditAt?: Maybe<Scalars['DateTime']['output']>;
  lastEditBy?: Maybe<Scalars['String']['output']>;
  linkedTenantId?: Maybe<Scalars['String']['output']>;
  previewUrl?: Maybe<Scalars['String']['output']>;
  productionUrl?: Maybe<Scalars['String']['output']>;
  relayApiKey: Scalars['String']['output'];
  relayUrl: Scalars['String']['output'];
  repoUrl?: Maybe<Scalars['String']['output']>;
  siteId: Scalars['String']['output'];
  siteName: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  totalEdits: Scalars['Float']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type SiteEditorStats = {
  __typename?: 'SiteEditorStats';
  activeSites: Scalars['Float']['output'];
  failedCommands: Scalars['Float']['output'];
  successfulCommands: Scalars['Float']['output'];
  totalCommands: Scalars['Float']['output'];
  totalSites: Scalars['Float']['output'];
};

export type SiteMedia = {
  __typename?: 'SiteMedia';
  cid: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  kind: SiteMediaKind;
  mimeType?: Maybe<Scalars['String']['output']>;
  thumbnailCid?: Maybe<Scalars['String']['output']>;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  uploadedAt: Scalars['DateTime']['output'];
  uploadedById?: Maybe<Scalars['ID']['output']>;
  uploadedByName?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type SiteMediaInput = {
  cid: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  kind?: InputMaybe<SiteMediaKind>;
  mimeType?: InputMaybe<Scalars['String']['input']>;
  thumbnailCid?: InputMaybe<Scalars['String']['input']>;
};

/** What kind of file a site update attachment is */
export enum SiteMediaKind {
  Document = 'DOCUMENT',
  Photo = 'PHOTO',
  Video = 'VIDEO'
}

export type SiteOwnerLinkAuthResult = {
  __typename?: 'SiteOwnerLinkAuthResult';
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
  token?: Maybe<Scalars['String']['output']>;
};

export type SiteOwnerLinkResult = {
  __typename?: 'SiteOwnerLinkResult';
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
  token?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type SiteSpecResult = {
  __typename?: 'SiteSpecResult';
  accentColor: Scalars['String']['output'];
  aiNotes: Scalars['String']['output'];
  brandIdentifier: Scalars['String']['output'];
  businessName: Scalars['String']['output'];
  businessType: Scalars['String']['output'];
  contactEmail: Scalars['String']['output'];
  contactName: Scalars['String']['output'];
  contactPhone: Scalars['String']['output'];
  description: Scalars['String']['output'];
  enabledModules: Array<Scalars['String']['output']>;
  industry: Scalars['String']['output'];
  logoEmoji: Scalars['String']['output'];
  primaryColor: Scalars['String']['output'];
  secondaryColor: Scalars['String']['output'];
  siteName: Scalars['String']['output'];
  tagline: Scalars['String']['output'];
};

/** Lifecycle status of a construction site */
export enum SiteStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
  Completed = 'COMPLETED',
  OnHold = 'ON_HOLD'
}

/** Site tour: NOT_BOOKED (also when never recorded), BOOKED, DONE, or NOT_POSSIBLE (with a reason) */
export enum SiteTourStatus {
  Booked = 'BOOKED',
  Done = 'DONE',
  NotBooked = 'NOT_BOOKED',
  NotPossible = 'NOT_POSSIBLE'
}

/** IN_PERSON = the person toured; FAMILY_ONLY = family toured without them; VIDEO_CALL = a video tour */
export enum SiteTourType {
  FamilyOnly = 'FAMILY_ONLY',
  InPerson = 'IN_PERSON',
  VideoCall = 'VIDEO_CALL'
}

export type SiteTrackerDashboardRow = {
  __typename?: 'SiteTrackerDashboardRow';
  address: Scalars['String']['output'];
  hasUpdateForDay: Scalars['Boolean']['output'];
  missingCrewNames: Array<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  pendingCount: Scalars['Int']['output'];
  siteId: Scalars['ID']['output'];
  siteNumber: Scalars['Float']['output'];
  submittedByNames: Array<Scalars['String']['output']>;
};

export type SiteUpdate = {
  __typename?: 'SiteUpdate';
  approvalStatus: SiteUpdateApprovalStatus;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  media: Array<SiteMedia>;
  note?: Maybe<Scalars['String']['output']>;
  reviewNote?: Maybe<Scalars['String']['output']>;
  reviewedAt?: Maybe<Scalars['DateTime']['output']>;
  reviewedById?: Maybe<Scalars['ID']['output']>;
  reviewedByName?: Maybe<Scalars['String']['output']>;
  siteId: Scalars['ID']['output'];
  submittedById?: Maybe<Scalars['ID']['output']>;
  submittedByName: Scalars['String']['output'];
  submittedByPhone?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  updateDate: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** Review state of a crew update; APPROVED alone is owner-visible */
export enum SiteUpdateApprovalStatus {
  Approved = 'APPROVED',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export type SkipEmpowermentCheckInInput = {
  checkInId: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
};

export type SleepChartSourceField = {
  __typename?: 'SleepChartSourceField';
  /** SarahCare table and column, e.g. `ResSleepChartData.Code` */
  column: Scalars['String']['output'];
  /** The original value as text */
  value?: Maybe<Scalars['String']['output']>;
};

export type SleepCheck = {
  __typename?: 'SleepCheck';
  alertMessage?: Maybe<Scalars['String']['output']>;
  autoProgressNote: Scalars['Boolean']['output'];
  checkTime: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  disturbance: SleepDisturbance;
  disturbanceNotes?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** True for SarahCare history: read-only, never current work */
  isHistoricalRecord?: Maybe<Scalars['Boolean']['output']>;
  position: SleepPosition;
  progressNoteId?: Maybe<Scalars['ID']['output']>;
  recordedBy: Scalars['ID']['output'];
  recordedByName?: Maybe<Scalars['String']['output']>;
  residentId: Scalars['ID']['output'];
  residentName?: Maybe<Scalars['String']['output']>;
  residentRoom?: Maybe<Scalars['String']['output']>;
  residentWing?: Maybe<Scalars['String']['output']>;
  shiftDate: Scalars['DateTime']['output'];
  /** The SarahCare user who charted it, as SarahCare named them */
  sourceAuthor?: Maybe<Scalars['String']['output']>;
  sourceBackupDate?: Maybe<Scalars['DateTime']['output']>;
  /** The SarahCare chart code exactly as charted (e.g. `A`, `S`, `AW`) */
  sourceCode?: Maybe<Scalars['String']['output']>;
  /** Original SarahCare columns (provenance only) */
  sourceFields?: Maybe<Array<SleepChartSourceField>>;
  /** Source table and row id, e.g. `ResSleepChartData:…` */
  sourceId?: Maybe<Scalars['String']['output']>;
  /** SARAHCARE for imported history; null for checks recorded here */
  sourceSystem?: Maybe<Scalars['String']['output']>;
  status: SleepStatus;
  tenantId: Scalars['String']['output'];
  triggeredAlert: Scalars['Boolean']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type SleepCheckFilterInput = {
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  residentId?: InputMaybe<Scalars['ID']['input']>;
  /** true = only SarahCare history; false = only checks recorded here */
  sarahHistory?: InputMaybe<Scalars['Boolean']['input']>;
  shiftDate?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<SleepStatus>;
  wing?: InputMaybe<Scalars['String']['input']>;
};

export type SleepChecksResponse = {
  __typename?: 'SleepChecksResponse';
  checks: Array<SleepCheck>;
  limit: Scalars['Int']['output'];
  offset: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

/** Type of sleep disturbance */
export enum SleepDisturbance {
  Anxiety = 'ANXIETY',
  CallingOut = 'CALLING_OUT',
  Noise = 'NOISE',
  None = 'NONE',
  NotRecorded = 'NOT_RECORDED',
  Other = 'OTHER',
  Pain = 'PAIN',
  Toileting = 'TOILETING',
  Wandering = 'WANDERING'
}

export type SleepPattern = {
  __typename?: 'SleepPattern';
  daytimeNaps?: Maybe<Scalars['Boolean']['output']>;
  napTimes?: Maybe<Scalars['String']['output']>;
  normalBedtime?: Maybe<Scalars['String']['output']>;
  normalWakeTime?: Maybe<Scalars['String']['output']>;
  sleepAids?: Maybe<Array<Scalars['String']['output']>>;
  sleepDisturbances?: Maybe<Array<Scalars['String']['output']>>;
  sleepNotes?: Maybe<Scalars['String']['output']>;
  sleepPreferences?: Maybe<Scalars['String']['output']>;
};

export type SleepPatternInput = {
  daytimeNaps?: InputMaybe<Scalars['Boolean']['input']>;
  napTimes?: InputMaybe<Scalars['String']['input']>;
  normalBedtime?: InputMaybe<Scalars['String']['input']>;
  normalWakeTime?: InputMaybe<Scalars['String']['input']>;
  sleepAids?: InputMaybe<Array<Scalars['String']['input']>>;
  sleepDisturbances?: InputMaybe<Array<Scalars['String']['input']>>;
  sleepNotes?: InputMaybe<Scalars['String']['input']>;
  sleepPreferences?: InputMaybe<Scalars['String']['input']>;
};

/** Position during sleep check */
export enum SleepPosition {
  Back = 'BACK',
  LeftSide = 'LEFT_SIDE',
  RightSide = 'RIGHT_SIDE',
  Sitting = 'SITTING',
  Standing = 'STANDING',
  Stomach = 'STOMACH',
  Unknown = 'UNKNOWN'
}

/** Sleep status during check */
export enum SleepStatus {
  Awake = 'AWAKE',
  Napping = 'NAPPING',
  OnLeave = 'ON_LEAVE',
  OutOfBed = 'OUT_OF_BED',
  RefusedCheck = 'REFUSED_CHECK',
  Restless = 'RESTLESS',
  SarahcareCode = 'SARAHCARE_CODE',
  Sleeping = 'SLEEPING'
}

export type SleepUpdateInput = {
  daytimeNaps?: InputMaybe<Scalars['Boolean']['input']>;
  napDuration?: InputMaybe<Scalars['String']['input']>;
  normalBedtime?: InputMaybe<Scalars['String']['input']>;
  normalWakeTime?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  preferences?: InputMaybe<Scalars['String']['input']>;
  sleepAids?: InputMaybe<Array<Scalars['String']['input']>>;
  sleepPosition?: InputMaybe<Scalars['String']['input']>;
};

/** Severity band of the remaining prepaid SMS credit balance */
export enum SmsBalanceLevel {
  Critical = 'CRITICAL',
  Depleted = 'DEPLETED',
  Ok = 'OK',
  Warn = 'WARN'
}

export type SmsBalanceSnapshot = {
  __typename?: 'SmsBalanceSnapshot';
  accountFingerprint?: Maybe<Scalars['String']['output']>;
  accountName?: Maybe<Scalars['String']['output']>;
  checkedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  lastAlertedAt?: Maybe<Scalars['DateTime']['output']>;
  lastAlertedLevel?: Maybe<SmsBalanceLevel>;
  lastCheckError?: Maybe<Scalars['String']['output']>;
  lastCheckErrorAt?: Maybe<Scalars['DateTime']['output']>;
  level: SmsBalanceLevel;
  mmsBalance?: Maybe<Scalars['Int']['output']>;
  smsBalance: Scalars['Int']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type SmsBroadcastAudienceInput = {
  departmentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  phoneMode: SmsPhoneMode;
  roleIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type SmsBroadcastAudiencePreview = {
  __typename?: 'SmsBroadcastAudiencePreview';
  recipients: Array<SmsBroadcastRecipient>;
  sendableCount: Scalars['Int']['output'];
  skippedCount: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
};

export type SmsBroadcastRecipient = {
  __typename?: 'SmsBroadcastRecipient';
  employeeId: Scalars['ID']['output'];
  fName: Scalars['String']['output'];
  hasPhone: Scalars['Boolean']['output'];
  lName: Scalars['String']['output'];
  personalEmail?: Maybe<Scalars['String']['output']>;
  personalPhone?: Maybe<Scalars['String']['output']>;
  preferredName?: Maybe<Scalars['String']['output']>;
  targetPhone?: Maybe<Scalars['String']['output']>;
  workPhone?: Maybe<Scalars['String']['output']>;
};

export type SmsBroadcastResult = {
  __typename?: 'SmsBroadcastResult';
  costCents: Scalars['Int']['output'];
  dedupedSharedNumber: Scalars['Int']['output'];
  requested: Scalars['Int']['output'];
  segmentsPerMessage: Scalars['Int']['output'];
  sent: Scalars['Int']['output'];
  skippedNames: Array<Scalars['String']['output']>;
  skippedNoPhone: Scalars['Int']['output'];
};

export type SmsConversation = {
  __typename?: 'SmsConversation';
  clientId?: Maybe<Scalars['ID']['output']>;
  clientName?: Maybe<Scalars['String']['output']>;
  counterpartNumber: Scalars['String']['output'];
  lastAt?: Maybe<Scalars['DateTime']['output']>;
  lastBody: Scalars['String']['output'];
  lastDirection: SmsDirection;
  messageCount: Scalars['Float']['output'];
};

export enum SmsDirection {
  In = 'IN',
  Out = 'OUT'
}

export type SmsHeldRepliesResult = {
  __typename?: 'SmsHeldRepliesResult';
  replies: Array<SmsHeldReplyView>;
  total: Scalars['Int']['output'];
  truncated: Scalars['Boolean']['output'];
};

export type SmsHeldReplySiteView = {
  __typename?: 'SmsHeldReplySiteView';
  siteName: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
};

export type SmsHeldReplyView = {
  __typename?: 'SmsHeldReplyView';
  body: Scalars['String']['output'];
  fromNumber: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  occurredAt: Scalars['DateTime']['output'];
  possibleSites: Array<SmsHeldReplySiteView>;
  reason: Scalars['String']['output'];
  toNumber?: Maybe<Scalars['String']['output']>;
};

export type SmsLoginLinkRequestResult = {
  __typename?: 'SmsLoginLinkRequestResult';
  accepted: Scalars['Boolean']['output'];
  browserLabel: Scalars['String']['output'];
  browserToken: Scalars['String']['output'];
  codeAvailable: Scalars['Boolean']['output'];
  retryAfterSeconds: Scalars['Int']['output'];
};

export type SmsLoginResult = {
  __typename?: 'SmsLoginResult';
  auth?: Maybe<AuthResponse>;
  returnPath?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
};

export type SmsMessage = {
  __typename?: 'SmsMessage';
  body: Scalars['String']['output'];
  cellcastMessageId?: Maybe<Scalars['String']['output']>;
  clientId?: Maybe<Scalars['ID']['output']>;
  clientName?: Maybe<Scalars['String']['output']>;
  costCents?: Maybe<Scalars['Float']['output']>;
  counterpartNumber: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  direction: SmsDirection;
  employeeId?: Maybe<Scalars['ID']['output']>;
  fromNumber?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  imported?: Maybe<Scalars['Boolean']['output']>;
  numberType?: Maybe<Scalars['String']['output']>;
  occurredAt?: Maybe<Scalars['DateTime']['output']>;
  originalMessageId?: Maybe<Scalars['String']['output']>;
  segments?: Maybe<Scalars['Float']['output']>;
  sender?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  toNumber?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

/** How to resolve the notification recipient(s) */
export enum SmsNotificationRecipientType {
  AllManagers = 'ALL_MANAGERS',
  Role = 'ROLE',
  SpecificClient = 'SPECIFIC_CLIENT',
  SpecificEmployee = 'SPECIFIC_EMPLOYEE'
}

export type SmsNotificationRule = {
  __typename?: 'SmsNotificationRule';
  channels: Array<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  filterKeyword?: Maybe<Scalars['String']['output']>;
  fireCount: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  isEnabled: Scalars['Boolean']['output'];
  lastFiredAt?: Maybe<Scalars['DateTime']['output']>;
  messageTemplate?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  recipientIds?: Maybe<Array<Scalars['String']['output']>>;
  recipientRole?: Maybe<Scalars['String']['output']>;
  recipientType: SmsNotificationRecipientType;
  tenantId: Scalars['String']['output'];
  triggers: Array<SmsNotificationTrigger>;
  updatedAt: Scalars['DateTime']['output'];
};

/** Event that can trigger an SMS notification */
export enum SmsNotificationTrigger {
  SmsReceived = 'SMS_RECEIVED',
  SmsSendFailed = 'SMS_SEND_FAILED'
}

export type SmsNumberRequest = {
  __typename?: 'SmsNumberRequest';
  createdAt: Scalars['DateTime']['output'];
  fulfilledNumber?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  note?: Maybe<Scalars['String']['output']>;
  priceMonthlyCents?: Maybe<Scalars['Int']['output']>;
  requestedByClientId?: Maybe<Scalars['String']['output']>;
  status: SmsNumberRequestStatus;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export enum SmsNumberRequestStatus {
  Provisioned = 'PROVISIONED',
  Rejected = 'REJECTED',
  Requested = 'REQUESTED'
}

/** Which number a staff SMS targets: the work number or the personal number. */
export enum SmsPhoneMode {
  Personal = 'PERSONAL',
  Work = 'WORK'
}

export type SmsResponse = {
  __typename?: 'SmsResponse';
  body?: Maybe<Scalars['String']['output']>;
  from?: Maybe<Scalars['String']['output']>;
  messageId?: Maybe<Scalars['String']['output']>;
  originalBody?: Maybe<Scalars['String']['output']>;
  originalMessageId?: Maybe<Scalars['String']['output']>;
  receivedAt?: Maybe<Scalars['String']['output']>;
};

export type SmsUsageContactBreakdown = {
  __typename?: 'SmsUsageContactBreakdown';
  clientName?: Maybe<Scalars['String']['output']>;
  counterpartNumber: Scalars['String']['output'];
  outboundCount: Scalars['Int']['output'];
  tenantId: Scalars['String']['output'];
  tenantName: Scalars['String']['output'];
  totalCostCents: Scalars['Float']['output'];
  totalSegments: Scalars['Int']['output'];
};

export type SmsUsageFilter = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
};

export type SmsUsageOverall = {
  __typename?: 'SmsUsageOverall';
  totalCostCents: Scalars['Float']['output'];
  totalInbound: Scalars['Int']['output'];
  totalOutbound: Scalars['Int']['output'];
  totalSegments: Scalars['Int']['output'];
};

export type SmsUsageStats = {
  __typename?: 'SmsUsageStats';
  byContact: Array<SmsUsageContactBreakdown>;
  byTenant: Array<SmsUsageTenantBreakdown>;
  overall: SmsUsageOverall;
};

export type SmsUsageTenantBreakdown = {
  __typename?: 'SmsUsageTenantBreakdown';
  inboundCount: Scalars['Int']['output'];
  outboundCount: Scalars['Int']['output'];
  tenantId: Scalars['String']['output'];
  tenantName: Scalars['String']['output'];
  totalCostCents: Scalars['Float']['output'];
  totalSegments: Scalars['Int']['output'];
};

export type SnapshotFilterInput = {
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export enum SnapshotPeriod {
  Daily = 'DAILY',
  Monthly = 'MONTHLY',
  Weekly = 'WEEKLY'
}

export type SnapshotRating = {
  __typename?: 'SnapshotRating';
  aspectColor?: Maybe<Scalars['String']['output']>;
  aspectId: Scalars['ID']['output'];
  aspectName: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  rating: Scalars['Int']['output'];
};

export type SnapshotRatingInput = {
  aspectColor?: InputMaybe<Scalars['String']['input']>;
  aspectId: Scalars['ID']['input'];
  aspectName: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  rating: Scalars['Int']['input'];
};

export enum SnapshotScope {
  Department = 'DEPARTMENT',
  Tenant = 'TENANT',
  User = 'USER'
}

export enum SnapshotSource {
  MicrosoftEmail = 'MICROSOFT_EMAIL'
}

export type SnapshotUser = {
  __typename?: 'SnapshotUser';
  email?: Maybe<Scalars['String']['output']>;
  fName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lName?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
};

/** How social-media links render in the email footer */
export enum SocialIconStyle {
  BrandColors = 'BRAND_COLORS',
  Letters = 'LETTERS',
  Monoline = 'MONOLINE',
  Text = 'TEXT'
}

export type SocialMediaAccount = {
  __typename?: 'SocialMediaAccount';
  engagementRate?: Maybe<Scalars['Float']['output']>;
  followerCount?: Maybe<Scalars['Int']['output']>;
  lastUpdated?: Maybe<Scalars['DateTime']['output']>;
  platform: SocialPlatform;
  profileUrl: Scalars['String']['output'];
  username: Scalars['String']['output'];
  verified: Scalars['Boolean']['output'];
};

export type SocialMediaAccountInput = {
  engagementRate?: InputMaybe<Scalars['Float']['input']>;
  followerCount?: InputMaybe<Scalars['Int']['input']>;
  lastUpdated?: InputMaybe<Scalars['DateTime']['input']>;
  platform: SocialPlatform;
  profileUrl: Scalars['String']['input'];
  username: Scalars['String']['input'];
  verified: Scalars['Boolean']['input'];
};

/** Social media platforms */
export enum SocialPlatform {
  Facebook = 'FACEBOOK',
  Instagram = 'INSTAGRAM',
  Linkedin = 'LINKEDIN',
  Other = 'OTHER',
  Substack = 'SUBSTACK',
  Tiktok = 'TIKTOK',
  Twitch = 'TWITCH',
  Twitter = 'TWITTER',
  Youtube = 'YOUTUBE'
}

export type SopAgendaItem = {
  __typename?: 'SopAgendaItem';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  note?: Maybe<Scalars['String']['output']>;
  order: Scalars['Int']['output'];
  raisedBy?: Maybe<Scalars['String']['output']>;
  source: SopAgendaSource;
  sourceCommentId?: Maybe<Scalars['ID']['output']>;
  sourceEpisodeId?: Maybe<Scalars['ID']['output']>;
  status: SopAgendaStatus;
  targetEpisodeId?: Maybe<Scalars['ID']['output']>;
  tenantId: Scalars['String']['output'];
  text: Scalars['String']['output'];
  topicId?: Maybe<Scalars['ID']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

/** Whether this came from a listener or was added by hand */
export enum SopAgendaSource {
  Comment = 'COMMENT',
  Manual = 'MANUAL'
}

/** Where an agenda item sits in the queue */
export enum SopAgendaStatus {
  Covered = 'COVERED',
  Declined = 'DECLINED',
  Open = 'OPEN',
  Planned = 'PLANNED'
}

export type SopBriefTranscript = {
  __typename?: 'SopBriefTranscript';
  model?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  text: Scalars['String']['output'];
};

/** How often episodes are expected */
export enum SopCadence {
  Fortnightly = 'FORTNIGHTLY',
  Monthly = 'MONTHLY',
  None = 'NONE',
  Weekly = 'WEEKLY'
}

export type SopComment = {
  __typename?: 'SopComment';
  audioCid?: Maybe<Scalars['String']['output']>;
  audioUrl?: Maybe<Scalars['String']['output']>;
  authorEmail?: Maybe<Scalars['String']['output']>;
  authorName?: Maybe<Scalars['String']['output']>;
  body?: Maybe<Scalars['String']['output']>;
  clientId?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['DateTime']['output'];
  episodeId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  kind: SopCommentKind;
  moderatedAt?: Maybe<Scalars['DateTime']['output']>;
  moderatedById?: Maybe<Scalars['ID']['output']>;
  raisedToAgenda: Scalars['Boolean']['output'];
  sourceHash?: Maybe<Scalars['String']['output']>;
  status: SopCommentStatus;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** A typed reply or a recorded voice note */
export enum SopCommentKind {
  Text = 'TEXT',
  Voice = 'VOICE'
}

/** Moderation state of a State of Play comment */
export enum SopCommentStatus {
  Approved = 'APPROVED',
  Hidden = 'HIDDEN',
  Pending = 'PENDING'
}

export type SopCta = {
  __typename?: 'SopCta';
  description?: Maybe<Scalars['String']['output']>;
  label: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type SopCtaInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  label: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export type SopEpisode = {
  __typename?: 'SopEpisode';
  aiDraft?: Maybe<SopEpisodeAiDraft>;
  audioCid?: Maybe<Scalars['String']['output']>;
  audioUrl?: Maybe<Scalars['String']['output']>;
  bodyMarkdown?: Maybe<Scalars['String']['output']>;
  briefText?: Maybe<Scalars['String']['output']>;
  bullets: Array<Scalars['String']['output']>;
  calendarEventId?: Maybe<Scalars['ID']['output']>;
  commentCount: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  cta?: Maybe<SopCta>;
  ctaClickCount: Scalars['Int']['output'];
  ctaDisabled: Scalars['Boolean']['output'];
  durationMinutes: Scalars['Int']['output'];
  durationSec?: Maybe<Scalars['Float']['output']>;
  effectiveCta?: Maybe<SopCta>;
  episodeNumber?: Maybe<Scalars['Int']['output']>;
  headline?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  linkedProposalId?: Maybe<Scalars['ID']['output']>;
  meetingId?: Maybe<Scalars['ID']['output']>;
  mermaidSource?: Maybe<Scalars['String']['output']>;
  nextEpisodeHint?: Maybe<Scalars['String']['output']>;
  presenterNotes?: Maybe<Scalars['String']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  recordedAt?: Maybe<Scalars['DateTime']['output']>;
  roomName?: Maybe<Scalars['String']['output']>;
  scheduledEnd?: Maybe<Scalars['DateTime']['output']>;
  scheduledStart?: Maybe<Scalars['DateTime']['output']>;
  skin: SopSkin;
  slug: Scalars['String']['output'];
  socialCopy?: Maybe<Scalars['String']['output']>;
  status: SopEpisodeStatus;
  subtitle?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  timezone: Scalars['String']['output'];
  title: Scalars['String']['output'];
  topicId?: Maybe<Scalars['ID']['output']>;
  transcriptText?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  viewCount: Scalars['Int']['output'];
  visibility: SopVisibility;
};

export type SopEpisodeAiDraft = {
  __typename?: 'SopEpisodeAiDraft';
  bodyMarkdown?: Maybe<Scalars['String']['output']>;
  bullets?: Maybe<Array<Scalars['String']['output']>>;
  generatedAt?: Maybe<Scalars['DateTime']['output']>;
  headline?: Maybe<Scalars['String']['output']>;
  instruction?: Maybe<Scalars['String']['output']>;
  mermaidSource?: Maybe<Scalars['String']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  nextEpisodeHint?: Maybe<Scalars['String']['output']>;
  socialCopy?: Maybe<Scalars['String']['output']>;
  subtitle?: Maybe<Scalars['String']['output']>;
};

export type SopEpisodeFilterInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<SopEpisodeStatus>;
  topicId?: InputMaybe<Scalars['ID']['input']>;
};

export type SopEpisodeGuest = {
  __typename?: 'SopEpisodeGuest';
  clientId?: Maybe<Scalars['ID']['output']>;
  email: Scalars['String']['output'];
  invited: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

/** Lifecycle of a State of Play episode */
export enum SopEpisodeStatus {
  AiDrafted = 'AI_DRAFTED',
  Archived = 'ARCHIVED',
  Draft = 'DRAFT',
  Live = 'LIVE',
  Published = 'PUBLISHED',
  Recorded = 'RECORDED',
  Scheduled = 'SCHEDULED'
}

export type SopInviteCandidate = {
  __typename?: 'SopInviteCandidate';
  email?: Maybe<Scalars['String']['output']>;
  hasEmail: Scalars['Boolean']['output'];
  hasPhone: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  tags: Array<Scalars['String']['output']>;
};

export type SopInviteOutcome = {
  __typename?: 'SopInviteOutcome';
  clientId: Scalars['ID']['output'];
  email?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  reason?: Maybe<Scalars['String']['output']>;
  result: Scalars['String']['output'];
};

export type SopInviteResult = {
  __typename?: 'SopInviteResult';
  failed: Scalars['Int']['output'];
  outcomes: Array<SopInviteOutcome>;
  sent: Scalars['Int']['output'];
  skipped: Scalars['Int']['output'];
};

export type SopPublicSettings = {
  __typename?: 'SopPublicSettings';
  displayName?: Maybe<Scalars['String']['output']>;
  tagline?: Maybe<Scalars['String']['output']>;
};

export type SopRecordingSyncResult = {
  __typename?: 'SopRecordingSyncResult';
  attached: Scalars['Boolean']['output'];
  drafted: Scalars['Boolean']['output'];
  episodeId?: Maybe<Scalars['ID']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
};

export type SopSettings = {
  __typename?: 'SopSettings';
  autoDraftCopy: Scalars['Boolean']['output'];
  cadence: SopCadence;
  cadenceTime?: Maybe<Scalars['String']['output']>;
  cadenceTimezone: Scalars['String']['output'];
  cadenceWeekday?: Maybe<Scalars['Int']['output']>;
  copyModel?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  defaultCta?: Maybe<SopCta>;
  defaultDurationMinutes: Scalars['Int']['output'];
  defaultSkin: SopSkin;
  defaultVisibility: SopVisibility;
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  maxInvitesPerMember: Scalars['Int']['output'];
  referralRewardEnabled: Scalars['Boolean']['output'];
  referralRewardValue: Scalars['Float']['output'];
  tagline?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** Public page look */
export enum SopSkin {
  Bold = 'BOLD',
  Clean = 'CLEAN',
  Warm = 'WARM'
}

export type SopSuggestedTime = {
  __typename?: 'SopSuggestedTime';
  end: Scalars['DateTime']['output'];
  label: Scalars['String']['output'];
  reason: Scalars['String']['output'];
  standingSlot: Scalars['Boolean']['output'];
  start: Scalars['DateTime']['output'];
};

export type SopSuggestedTimes = {
  __typename?: 'SopSuggestedTimes';
  calendarsChecked: Scalars['Int']['output'];
  caveats: Array<Scalars['String']['output']>;
  eventsChecked: Scalars['Int']['output'];
  slots: Array<SopSuggestedTime>;
};

export type SopTopic = {
  __typename?: 'SopTopic';
  color?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  parentId?: Maybe<Scalars['ID']['output']>;
  slug: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** Who can reach an episode's page */
export enum SopVisibility {
  InvitedOnly = 'INVITED_ONLY',
  Members = 'MEMBERS',
  Public = 'PUBLIC',
  Unlisted = 'UNLISTED'
}

/** Sort order direction */
export enum SortOrder {
  Asc = 'ASC',
  Desc = 'DESC'
}

/** Video platform a Transcript Miner source harvests from (only YOUTUBE live in Phase 1) */
export enum SourcePlatform {
  Bitchute = 'BITCHUTE',
  RssFeed = 'RSS_FEED',
  Rumble = 'RUMBLE',
  Vimeo = 'VIMEO',
  Youtube = 'YOUTUBE'
}

/** Source enumeration status */
export enum SourceStatus {
  Enumerating = 'ENUMERATING',
  Failed = 'FAILED',
  Ready = 'READY'
}

export type SourceStatusBreakdown = {
  __typename?: 'SourceStatusBreakdown';
  downloading: Scalars['Int']['output'];
  failed: Scalars['Int']['output'];
  ingested: Scalars['Int']['output'];
  queued: Scalars['Int']['output'];
  skipped: Scalars['Int']['output'];
  transcribed: Scalars['Int']['output'];
  transcribing: Scalars['Int']['output'];
};

/** Kind of source URL */
export enum SourceType {
  Channel = 'CHANNEL',
  Playlist = 'PLAYLIST',
  Video = 'VIDEO',
  VideoList = 'VIDEO_LIST'
}

export type SovereigntyAdjustment = {
  __typename?: 'SovereigntyAdjustment';
  amountCents: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  journeyId: Scalars['ID']['output'];
  reason: Scalars['String']['output'];
  recordedBy: Scalars['ID']['output'];
  sourceReference: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type SovereigntyClientProgress = {
  __typename?: 'SovereigntyClientProgress';
  clientName: Scalars['String']['output'];
  steps: Array<SovereigntyClientStep>;
  termsStatus: Scalars['String']['output'];
  totalSpendCents: Scalars['Int']['output'];
};

export type SovereigntyClientStep = {
  __typename?: 'SovereigntyClientStep';
  category: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type SovereigntyJourney = {
  __typename?: 'SovereigntyJourney';
  accessEntitlementNote?: Maybe<Scalars['String']['output']>;
  clientName: Scalars['String']['output'];
  clientTenantId: Scalars['ID']['output'];
  clientVisible: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  draftMentorshipCents: Scalars['Int']['output'];
  draftMentorshipMonths: Scalars['Int']['output'];
  draftMilestoneCents: Scalars['Int']['output'];
  hardwareNote?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  ownershipEvidenceReference?: Maybe<Scalars['String']['output']>;
  ownershipPosition: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  termsNote?: Maybe<Scalars['String']['output']>;
  termsStatus: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type SovereigntyJourneyView = {
  __typename?: 'SovereigntyJourneyView';
  adjustments: Array<SovereigntyAdjustment>;
  journey: SovereigntyJourney;
  steps: Array<SovereigntyStep>;
  totalSpendCents: Scalars['Int']['output'];
};

export type SovereigntyStep = {
  __typename?: 'SovereigntyStep';
  category: Scalars['String']['output'];
  clientVisible: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  evidenceReference?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  journeyId: Scalars['ID']['output'];
  recordedBy: Scalars['ID']['output'];
  status: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type SpamBlockPreview = {
  __typename?: 'SpamBlockPreview';
  pastMessageCount: Scalars['Int']['output'];
  scope: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type SpamBlockResult = {
  __typename?: 'SpamBlockResult';
  calendarEventsRemoved: Scalars['Int']['output'];
  messagesMoved: Scalars['Int']['output'];
  ruleId: Scalars['ID']['output'];
  scope: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type SpamSenderStatus = {
  __typename?: 'SpamSenderStatus';
  blocked: Scalars['Boolean']['output'];
  deadline?: Maybe<Scalars['DateTime']['output']>;
  demandSentAt?: Maybe<Scalars['DateTime']['output']>;
  hasMachineReadableUnsubscribe: Scalars['Boolean']['output'];
  inBreach: Scalars['Boolean']['output'];
  messagesAfterDeadline: Scalars['Int']['output'];
  reason?: Maybe<Scalars['String']['output']>;
  ruleId?: Maybe<Scalars['ID']['output']>;
  sender: Scalars['String']['output'];
  workingDaysOverdue: Scalars['Int']['output'];
};

export type SphereFilterInput = {
  category?: InputMaybe<InfluenceCategory>;
  influence?: InputMaybe<InfluenceType>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type SphereOfInfluence = {
  __typename?: 'SphereOfInfluence';
  actionRequired?: Maybe<Scalars['String']['output']>;
  category: InfluenceCategory;
  createdAt: Scalars['DateTime']['output'];
  demandRating?: Maybe<Scalars['Int']['output']>;
  energyRating?: Maybe<Scalars['Int']['output']>;
  engagement?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  impactScore: Scalars['Int']['output'];
  influence: InfluenceType;
  interactionFrequency?: Maybe<InteractionFrequency>;
  linkedAspectIds?: Maybe<Array<Scalars['String']['output']>>;
  name: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  proximity?: Maybe<Scalars['Int']['output']>;
  relationshipLayer?: Maybe<RelationshipLayer>;
  relationshipType?: Maybe<Scalars['String']['output']>;
  roleTags?: Maybe<Array<Scalars['String']['output']>>;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  userId: Scalars['ID']['output'];
};

export type StageMetric = {
  __typename?: 'StageMetric';
  averageTimeInStage: Scalars['Float']['output'];
  conversionToNext: Scalars['Float']['output'];
  count: Scalars['Int']['output'];
  stageName: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};

export type StandardMetadata = {
  __typename?: 'StandardMetadata';
  name: Scalars['String']['output'];
  referenceUrl: Scalars['String']['output'];
  requirements: Array<StandardRequirement>;
  shortDescription: Scalars['String']['output'];
  standard: CiQualityStandard;
};

export type StandardRequirement = {
  __typename?: 'StandardRequirement';
  code: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type StartEmailBacklogJobInput = {
  folder?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type StartGovJobSpecInstanceInput = {
  dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  maxClaimants?: InputMaybe<Scalars['Int']['input']>;
  specId: Scalars['ID']['input'];
  titleSuffix?: InputMaybe<Scalars['String']['input']>;
};

export type StartRecipeCaptureInput = {
  fileCid?: InputMaybe<Scalars['String']['input']>;
  fileMimeType?: InputMaybe<Scalars['String']['input']>;
  fileName?: InputMaybe<Scalars['String']['input']>;
  kitchenId?: InputMaybe<Scalars['ID']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type StatementIssue = {
  __typename?: 'StatementIssue';
  name: Scalars['String']['output'];
  problem: Scalars['String']['output'];
};

export type StatementPeriodBlock = {
  __typename?: 'StatementPeriodBlock';
  costs: StatementRoleFigures;
  excludedDaysBeforeDataStart: Scalars['Int']['output'];
  fromDay: Scalars['String']['output'];
  hours: StatementRoleFigures;
  label: Scalars['String']['output'];
  occupiedBedDays: Scalars['Int']['output'];
  toDay: Scalars['String']['output'];
};

export type StatementRnCoverage = {
  __typename?: 'StatementRnCoverage';
  coverage?: Maybe<Scalars['Float']['output']>;
  daysInMonth: Scalars['Int']['output'];
  daysWithRn: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  month: Scalars['String']['output'];
  partialReason?: Maybe<Scalars['String']['output']>;
};

export type StatementRoleFigures = {
  __typename?: 'StatementRoleFigures';
  en: Scalars['Float']['output'];
  pcw: Scalars['Float']['output'];
  rn: Scalars['Float']['output'];
};

export type StepUpResult = {
  __typename?: 'StepUpResult';
  aal: Scalars['Int']['output'];
  amr: Array<Scalars['String']['output']>;
  token: Scalars['String']['output'];
};

/** Stool color */
export enum StoolColor {
  Black = 'BLACK',
  Brown = 'BROWN',
  Clay = 'CLAY',
  DarkBrown = 'DARK_BROWN',
  Green = 'GREEN',
  LightBrown = 'LIGHT_BROWN',
  Red = 'RED',
  Yellow = 'YELLOW'
}

export enum StorageOperation {
  Retrieval = 'RETRIEVAL',
  Upload = 'UPLOAD'
}

export type StorageUsageClientBreakdown = {
  __typename?: 'StorageUsageClientBreakdown';
  clientId: Scalars['String']['output'];
  clientName: Scalars['String']['output'];
  retrievalCount: Scalars['Int']['output'];
  tenantId: Scalars['String']['output'];
  tenantName: Scalars['String']['output'];
  totalCostCents: Scalars['Float']['output'];
  totalRetrievalBytes: Scalars['Int']['output'];
  totalUploadBytes: Scalars['Int']['output'];
  uploadCount: Scalars['Int']['output'];
};

export type StorageUsageFilter = {
  clientId?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  module?: InputMaybe<Scalars['String']['input']>;
  operation?: InputMaybe<StorageOperation>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
};

export type StorageUsageLog = {
  __typename?: 'StorageUsageLog';
  bytes: Scalars['Int']['output'];
  cid: Scalars['String']['output'];
  clientId?: Maybe<Scalars['String']['output']>;
  costCents: Scalars['Float']['output'];
  createdAt: Scalars['DateTime']['output'];
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  module: Scalars['String']['output'];
  operation: StorageOperation;
  success: Scalars['Boolean']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  userId?: Maybe<Scalars['String']['output']>;
};

export type StorageUsageModuleBreakdown = {
  __typename?: 'StorageUsageModuleBreakdown';
  module: Scalars['String']['output'];
  retrievalCount: Scalars['Int']['output'];
  totalCostCents: Scalars['Float']['output'];
  totalRetrievalBytes: Scalars['Int']['output'];
  totalUploadBytes: Scalars['Int']['output'];
  uploadCount: Scalars['Int']['output'];
};

export type StorageUsageOverall = {
  __typename?: 'StorageUsageOverall';
  retrievalCount: Scalars['Int']['output'];
  totalCostCents: Scalars['Float']['output'];
  totalRetrievalBytes: Scalars['Int']['output'];
  totalUploadBytes: Scalars['Int']['output'];
  uploadCount: Scalars['Int']['output'];
};

export type StorageUsageStats = {
  __typename?: 'StorageUsageStats';
  byClient: Array<StorageUsageClientBreakdown>;
  byModule: Array<StorageUsageModuleBreakdown>;
  byTenant: Array<StorageUsageTenantBreakdown>;
  overall: StorageUsageOverall;
};

export type StorageUsageTenantBreakdown = {
  __typename?: 'StorageUsageTenantBreakdown';
  retrievalCount: Scalars['Int']['output'];
  tenantId: Scalars['String']['output'];
  tenantName: Scalars['String']['output'];
  totalCostCents: Scalars['Float']['output'];
  totalRetrievalBytes: Scalars['Int']['output'];
  totalUploadBytes: Scalars['Int']['output'];
  uploadCount: Scalars['Int']['output'];
};

export type StpBuildResult = {
  __typename?: 'StpBuildResult';
  /** IPFS CID of the built STP2 payload XML */
  payloadCid: Scalars['String']['output'];
  /** Inline XML body (for FE inspection) */
  payloadXml: Scalars['String']['output'];
  stpLodgement: StpLodgement;
  warnings: Array<Scalars['String']['output']>;
};

/** STP2 event type */
export enum StpEventType {
  Finalisation = 'FINALISATION',
  FullFileReplacement = 'FULL_FILE_REPLACEMENT',
  Submit = 'SUBMIT',
  Update = 'UPDATE'
}

export type StpLodgement = {
  __typename?: 'StpLodgement';
  /** ATO message ID returned on lodgement */
  atoMessageId?: Maybe<Scalars['String']['output']>;
  /** IPFS CID of the ATO acknowledgement / response XML */
  atoResponseCid?: Maybe<Scalars['String']['output']>;
  atoSoftwareId?: Maybe<Scalars['String']['output']>;
  bmsId?: Maybe<Scalars['String']['output']>;
  builtAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  employeeCount: Scalars['Int']['output'];
  eventType: StpEventType;
  id: Scalars['ID']['output'];
  lodgedAt?: Maybe<Scalars['DateTime']['output']>;
  lodgedBy?: Maybe<Scalars['ID']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  payRunId: Scalars['ID']['output'];
  payloadBytes: Scalars['Int']['output'];
  /** IPFS CID of the built STP2 XML payload */
  payloadCid: Scalars['String']['output'];
  /** Short response text — error code if FAILED */
  responseMessage?: Maybe<Scalars['String']['output']>;
  status: StpLodgementStatus;
  /** Sphere / Payroo / DIRECT_AS4 — copied from PaySettings at lodge time */
  stpProvider?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  totalGrossCents: Scalars['Int']['output'];
  totalPaygCents: Scalars['Int']['output'];
  totalSuperCents: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** STP Phase 2 lodgement lifecycle */
export enum StpLodgementStatus {
  Built = 'BUILT',
  Failed = 'FAILED',
  Lodged = 'LODGED',
  Reversed = 'REVERSED'
}

/** Fuel supply stress level at a station */
export enum StressStatus {
  Critical = 'CRITICAL',
  Dry = 'DRY',
  Low = 'LOW',
  Normal = 'NORMAL',
  Unknown = 'UNKNOWN'
}

export type StripeConnectDetails = {
  __typename?: 'StripeConnectDetails';
  accountVerified?: Maybe<Scalars['Boolean']['output']>;
  stripeAccountId?: Maybe<Scalars['String']['output']>;
  verifiedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type StripeConnectDetailsInput = {
  accountVerified?: InputMaybe<Scalars['Boolean']['input']>;
  stripeAccountId?: InputMaybe<Scalars['String']['input']>;
  verifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SubSubTask = {
  __typename?: 'SubSubTask';
  assignedTo?: Maybe<Scalars['String']['output']>;
  assignedToName?: Maybe<Scalars['String']['output']>;
  completed: Scalars['Boolean']['output'];
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  completedBy?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  order: Scalars['Float']['output'];
  title: Scalars['String']['output'];
};

export type SubSubTaskInput = {
  assignedTo?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export type SubSubTaskUpdateInput = {
  assignedTo?: InputMaybe<Scalars['String']['input']>;
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['String']['input'];
  order?: InputMaybe<Scalars['Float']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type SubTask = {
  __typename?: 'SubTask';
  assignedTo?: Maybe<Scalars['String']['output']>;
  assignedToName?: Maybe<Scalars['String']['output']>;
  children?: Maybe<Array<SubSubTask>>;
  completed: Scalars['Boolean']['output'];
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  completedBy?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  order: Scalars['Float']['output'];
  title: Scalars['String']['output'];
};

export type SubTaskInput = {
  assignedTo?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export type SubTaskUpdateInput = {
  assignedTo?: InputMaybe<Scalars['String']['input']>;
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['String']['input'];
  order?: InputMaybe<Scalars['Float']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Status of the calculator submission/lead */
export enum SubmissionStatus {
  Closed = 'CLOSED',
  Contacted = 'CONTACTED',
  Converted = 'CONVERTED',
  Pending = 'PENDING',
  Qualified = 'QUALIFIED',
  SentToGhl = 'SENT_TO_GHL',
  SentToPipedrive = 'SENT_TO_PIPEDRIVE'
}

export type SubmissionsByDay = {
  __typename?: 'SubmissionsByDay';
  date: Scalars['String']['output'];
  leads: Scalars['Int']['output'];
  submissions: Scalars['Int']['output'];
};

export type SubmitCalculatorInput = {
  calculatorName: Scalars['String']['input'];
  calculatorPath: Scalars['String']['input'];
  calculatorType: CalculatorType;
  company?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  inputData: Scalars['String']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  marketingConsent?: InputMaybe<Scalars['Boolean']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  referrer?: InputMaybe<Scalars['String']['input']>;
  resultData: Scalars['String']['input'];
  sessionId?: InputMaybe<Scalars['String']['input']>;
  userAgent?: InputMaybe<Scalars['String']['input']>;
  utmCampaign?: InputMaybe<Scalars['String']['input']>;
  utmMedium?: InputMaybe<Scalars['String']['input']>;
  utmSource?: InputMaybe<Scalars['String']['input']>;
  visitorId?: InputMaybe<Scalars['String']['input']>;
};

export type SubmitCandidateFormViaSlugInput = {
  answers: Array<CandidateFormAnswerInput>;
  slug: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};

export type SubmitClub52WalletAddressInput = {
  inviteToken: Scalars['String']['input'];
  roomName: Scalars['String']['input'];
  walletAddress: Scalars['String']['input'];
};

export type SubmitContactFormInput = {
  acknowledgementChecked?: InputMaybe<Scalars['Boolean']['input']>;
  acn?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  formType?: InputMaybe<Scalars['String']['input']>;
  industry?: InputMaybe<Scalars['String']['input']>;
  investorType?: InputMaybe<Scalars['String']['input']>;
  isInterestedInBecomingHealer?: InputMaybe<Scalars['Boolean']['input']>;
  isSeekingSupport?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  notificationEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  numberOfEmployees?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  sessionId?: InputMaybe<Scalars['String']['input']>;
  sophisticatedInvestorCertificate?: InputMaybe<Scalars['Upload']['input']>;
  submissionUrl?: InputMaybe<Scalars['String']['input']>;
  telegram?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type SubmitEmployeeIncidentInput = {
  attachments?: InputMaybe<Array<EmployeeActivityAttachmentInput>>;
  bodyPartAffected?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  gpReferralNeeded?: InputMaybe<Scalars['Boolean']['input']>;
  harassmentSubType?: InputMaybe<HarassmentSubType>;
  howInjuryOccurred?: InputMaybe<Scalars['String']['input']>;
  immediateActionTaken?: InputMaybe<Scalars['String']['input']>;
  incidentDate: Scalars['DateTime']['input'];
  incidentTime?: InputMaybe<Scalars['String']['input']>;
  incidentType: EmployeeIncidentType;
  location?: InputMaybe<Scalars['String']['input']>;
  medicalAttentionNeeded?: InputMaybe<Scalars['Boolean']['input']>;
  natureOfMisconduct?: InputMaybe<Scalars['String']['input']>;
  personsInvolved?: InputMaybe<Array<Scalars['String']['input']>>;
  witnesses?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type SubmitEmployeeOnboardingAddressInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
};

export type SubmitEmployeeOnboardingEmergencyContactInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  relationship?: InputMaybe<Scalars['String']['input']>;
};

export type SubmitEmployeeOnboardingInput = {
  address?: InputMaybe<SubmitEmployeeOnboardingAddressInput>;
  bankAccountName?: InputMaybe<Scalars['String']['input']>;
  bankAccountNumber?: InputMaybe<Scalars['String']['input']>;
  bankBSB?: InputMaybe<Scalars['String']['input']>;
  certifications?: InputMaybe<Array<Scalars['String']['input']>>;
  claimsTaxFreeThreshold?: InputMaybe<Scalars['Boolean']['input']>;
  dateOfBirth?: InputMaybe<Scalars['String']['input']>;
  emergencyContact?: InputMaybe<SubmitEmployeeOnboardingEmergencyContactInput>;
  fName: Scalars['String']['input'];
  hasStudyTrainingLoan?: InputMaybe<Scalars['Boolean']['input']>;
  lName: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  qualifications?: InputMaybe<Array<Scalars['String']['input']>>;
  slug: Scalars['String']['input'];
  smsfAbn?: InputMaybe<Scalars['String']['input']>;
  smsfBankAccountName?: InputMaybe<Scalars['String']['input']>;
  smsfBankAccountNumber?: InputMaybe<Scalars['String']['input']>;
  smsfBankBSB?: InputMaybe<Scalars['String']['input']>;
  smsfEsa?: InputMaybe<Scalars['String']['input']>;
  superChoiceType?: InputMaybe<SuperChoiceType>;
  superFundABN?: InputMaybe<Scalars['String']['input']>;
  superFundUSI?: InputMaybe<Scalars['String']['input']>;
  superMemberNumber?: InputMaybe<Scalars['String']['input']>;
  superNameOnAccount?: InputMaybe<Scalars['String']['input']>;
  superannuationFund?: InputMaybe<Scalars['String']['input']>;
  taxFileNumber?: InputMaybe<Scalars['String']['input']>;
  taxResidencyStatus?: InputMaybe<TaxResidencyStatus>;
  tenantId: Scalars['String']['input'];
};

export type SubmitFeedbackInput = {
  aboutResident?: InputMaybe<Scalars['String']['input']>;
  desiredOutcome?: InputMaybe<Scalars['String']['input']>;
  details: Scalars['String']['input'];
  fromOther?: InputMaybe<Scalars['String']['input']>;
  fromType?: InputMaybe<FeedbackFrom>;
  immediateAction?: InputMaybe<Scalars['String']['input']>;
  isAnonymous?: InputMaybe<Scalars['Boolean']['input']>;
  isConfidential?: InputMaybe<Scalars['Boolean']['input']>;
  kind: FeedbackKind;
  media?: InputMaybe<Array<FeedbackMediaInput>>;
  room?: InputMaybe<Scalars['String']['input']>;
  submitterEmail?: InputMaybe<Scalars['String']['input']>;
  submitterName?: InputMaybe<Scalars['String']['input']>;
  submitterPhone?: InputMaybe<Scalars['String']['input']>;
  topic?: InputMaybe<FeedbackTopic>;
  wantsReply?: InputMaybe<Scalars['Boolean']['input']>;
  wing?: InputMaybe<Scalars['String']['input']>;
};

export type SubmitGovProofInput = {
  files?: InputMaybe<Array<GovProofFileInput>>;
  note?: InputMaybe<Scalars['String']['input']>;
  reportedAtEpisodeId?: InputMaybe<Scalars['ID']['input']>;
  workItemId: Scalars['ID']['input'];
};

export type SubmitLeadInput = {
  customFields?: InputMaybe<Scalars['JSON']['input']>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  formId?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  referralCode?: InputMaybe<Scalars['String']['input']>;
  utmCampaign?: InputMaybe<Scalars['String']['input']>;
  utmContent?: InputMaybe<Scalars['String']['input']>;
  utmMedium?: InputMaybe<Scalars['String']['input']>;
  utmSource?: InputMaybe<Scalars['String']['input']>;
  variantId?: InputMaybe<Scalars['String']['input']>;
};

export type SubmitOrderInput = {
  notes?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['ID']['input'];
};

export type SubmitPayrollEnquiryInput = {
  category: PayrollEnquiryCategory;
  message: Scalars['String']['input'];
  payPeriod?: InputMaybe<Scalars['String']['input']>;
  subject: Scalars['String']['input'];
};

export type SubmitPledgeInput = {
  campaignSlug: Scalars['String']['input'];
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  giftReason?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  notificationPreference?: InputMaybe<PledgeNotificationPreference>;
  phone?: InputMaybe<Scalars['String']['input']>;
  quantity: Scalars['Int']['input'];
  referralCode?: InputMaybe<Scalars['String']['input']>;
};

export type SubmitProgramApplicationInput = {
  businessDescription: Scalars['String']['input'];
  financialCapacityAnswer: Scalars['String']['input'];
  proofOfAssetsCids?: InputMaybe<Array<Scalars['String']['input']>>;
  willingnessScore: Scalars['Int']['input'];
};

export type SubmitPublicInquiryInput = {
  /** Permanent or respite */
  careType?: InputMaybe<EntryType>;
  /** Must be true: "I agree Paradise Lakes may contact me about this inquiry" */
  consent: Scalars['Boolean']['input'];
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactName: Scalars['String']['input'];
  contactPhone?: InputMaybe<Scalars['String']['input']>;
  contactRelationship?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  formToken: Scalars['String']['input'];
  fundingSupport?: InputMaybe<FundingSupport>;
  /** ACAT approval: yes / no; null = not sure */
  hasAcatApproval?: InputMaybe<Scalars['Boolean']['input']>;
  /** How they heard of us */
  heardVia?: InputMaybe<InquirySource>;
  lastName: Scalars['String']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
  receivingCareAtHome?: InputMaybe<Scalars['Boolean']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type SubmitPublicMaintenanceRequestInput = {
  category?: InputMaybe<MaintenanceCategory>;
  details: Scalars['String']['input'];
  locationId?: InputMaybe<Scalars['ID']['input']>;
  maintenanceItem?: InputMaybe<Scalars['String']['input']>;
  monthlyCheckId?: InputMaybe<Scalars['ID']['input']>;
  occupantPresent?: InputMaybe<Scalars['Boolean']['input']>;
  photos?: InputMaybe<Array<MaintenanceMediaInput>>;
  priority?: InputMaybe<MaintenancePriority>;
  requestedBy?: InputMaybe<RequestedByType>;
  room?: InputMaybe<Scalars['String']['input']>;
  submitterEmail?: InputMaybe<Scalars['String']['input']>;
  submitterName: Scalars['String']['input'];
  wing?: InputMaybe<Scalars['String']['input']>;
};

export type SubmitPublicMealFeedbackInput = {
  comments?: InputMaybe<Scalars['String']['input']>;
  feedbackType?: InputMaybe<FeedbackType>;
  mealPlanId?: InputMaybe<Scalars['ID']['input']>;
  photos?: InputMaybe<Array<MealMediaInput>>;
  rating: Scalars['Float']['input'];
  submitterEmail?: InputMaybe<Scalars['String']['input']>;
  submitterName: Scalars['String']['input'];
};

export type SubmitReferenceResult = {
  __typename?: 'SubmitReferenceResult';
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type SubmitSecurityScanInput = {
  authRan: Scalars['Boolean']['input'];
  authSkip?: InputMaybe<Scalars['String']['input']>;
  findings: Array<SecurityScanFindingInput>;
  finishedAt: Scalars['DateTime']['input'];
  frontendNote?: InputMaybe<Scalars['String']['input']>;
  frontendRan: Scalars['Boolean']['input'];
  passed: Array<Scalars['String']['input']>;
  phaseLabel: Scalars['String']['input'];
  runner: SecurityScanRunner;
  startedAt: Scalars['DateTime']['input'];
  target: SecurityScanTargetInput;
};

export type SubmitShelvFeedbackInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  rating: Scalars['Float']['input'];
};

export type SubmitSiteUpdateInput = {
  media?: InputMaybe<Array<SiteMediaInput>>;
  note?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  siteId: Scalars['ID']['input'];
};

export type SubmitVisionBoardFeedbackInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  rating: Scalars['Float']['input'];
};

export type SubscribeToApiInput = {
  apiListingId: Scalars['String']['input'];
  plan?: InputMaybe<Scalars['String']['input']>;
  userApiKey?: InputMaybe<Scalars['String']['input']>;
};

export type Subscription = {
  __typename?: 'Subscription';
  agentBoardChanged: AgentBoardEvent;
  chatMessageAdded: ChatMessage;
  chatTypingUpdate: TypingUpdate;
  inboxEventOccurred: InboxEvent;
  /** Something changed in payroll enquiries on this site — refetch what you show (kind + id only) */
  payrollEnquiryChanged: PayrollEnquiryEvent;
};


export type SubscriptionChatMessageAddedArgs = {
  roomId: Scalars['ID']['input'];
};


export type SubscriptionChatTypingUpdateArgs = {
  roomId: Scalars['ID']['input'];
};

export type SubscriptionActivationResult = {
  __typename?: 'SubscriptionActivationResult';
  clientSecret?: Maybe<Scalars['String']['output']>;
  courseStartUrl?: Maybe<Scalars['String']['output']>;
  enrollmentId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  subscriptionId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type SubscriptionBillActionResult = {
  __typename?: 'SubscriptionBillActionResult';
  errorCount: Scalars['Float']['output'];
  results: Array<SubscriptionBillResultItem>;
  skippedCount: Scalars['Float']['output'];
  success: Scalars['Boolean']['output'];
  successCount: Scalars['Float']['output'];
  totalAmountBilled: Scalars['Float']['output'];
  totalProcessed: Scalars['Float']['output'];
};

export type SubscriptionBillHistoryItem = {
  __typename?: 'SubscriptionBillHistoryItem';
  amountOutstanding: Scalars['Float']['output'];
  amountTotal: Scalars['Float']['output'];
  billId: Scalars['ID']['output'];
  billingPeriod?: Maybe<Scalars['String']['output']>;
  howPaid?: Maybe<Scalars['String']['output']>;
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  paidAt?: Maybe<Scalars['DateTime']['output']>;
  paymentState: BillPaymentState;
  stripeDashboardUrl?: Maybe<Scalars['String']['output']>;
};

export type SubscriptionBillResultItem = {
  __typename?: 'SubscriptionBillResultItem';
  amount?: Maybe<Scalars['Float']['output']>;
  billId?: Maybe<Scalars['String']['output']>;
  clientName: Scalars['String']['output'];
  error?: Maybe<Scalars['String']['output']>;
  skippedReason?: Maybe<Scalars['String']['output']>;
  subscriptionId: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type SubscriptionBillingDashboard = {
  __typename?: 'SubscriptionBillingDashboard';
  billedThisMonth: Scalars['Float']['output'];
  collectedThisMonth: Scalars['Float']['output'];
  currentBillingPeriod: Scalars['String']['output'];
  outstandingBalance: Scalars['Float']['output'];
  paidBills: Scalars['Float']['output'];
  tokenOffsetsApplied: Scalars['Float']['output'];
  totalTenants: Scalars['Float']['output'];
  unpaidBills: Scalars['Float']['output'];
};

/** MANUAL = a person presses charge (the only value in use). AUTO = a scheduler may charge — NOT IMPLEMENTED: nothing reads this field yet and no mutation writes it. */
export enum SubscriptionBillingMode {
  Auto = 'AUTO',
  Manual = 'MANUAL'
}

/** Derived billing situation for a subscription. NOT a stored field and NOT a schedule — nothing in this system bills automatically, so this describes what is OWED, never what will happen. */
export enum SubscriptionBillingState {
  Billed = 'BILLED',
  DueToday = 'DUE_TODAY',
  Inactive = 'INACTIVE',
  NotDue = 'NOT_DUE',
  NoCard = 'NO_CARD',
  Overdue = 'OVERDUE',
  Paid = 'PAID'
}

export type SubscriptionCardOnFile = {
  __typename?: 'SubscriptionCardOnFile';
  addedAt?: Maybe<Scalars['DateTime']['output']>;
  brand?: Maybe<Scalars['String']['output']>;
  expMonth?: Maybe<Scalars['Int']['output']>;
  expYear?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  isDefault: Scalars['Boolean']['output'];
  last4?: Maybe<Scalars['String']['output']>;
};

export type SubscriptionDetail = {
  __typename?: 'SubscriptionDetail';
  /** Whether automatic charging is live for this subscription. ALWAYS false — no scheduler exists. */
  autoChargeActive: Scalars['Boolean']['output'];
  /** True when a bill for the current period already exists. */
  billedThisPeriod: Scalars['Boolean']['output'];
  billingHistory: Array<SubscriptionBillHistoryItem>;
  /** Derived, Brisbane-anchored. Describes what is OWED — never what will happen, because nothing happens on its own. */
  billingState: SubscriptionBillingState;
  cardOnFile?: Maybe<SubscriptionCardOnFile>;
  /** The current billing period label, e.g. "August 2026". Both engines key off this STRING, never a date. */
  currentPeriod: Scalars['String']['output'];
  daysOverdue?: Maybe<Scalars['Int']['output']>;
  daysUntilDue?: Maybe<Scalars['Int']['output']>;
  /** Brisbane calendar day (yyyy-MM-dd) the next bill is due. */
  dueDayBrisbane?: Maybe<Scalars['String']['output']>;
  subscription: BillingSubscription;
};

export type SubscriptionInput = {
  clientId: Scalars['ID']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  paymentMethodId?: InputMaybe<Scalars['String']['input']>;
  plan: SubscriptionPlanInput;
  startDate?: InputMaybe<Scalars['String']['input']>;
  stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
  subscriptionProductId?: InputMaybe<Scalars['String']['input']>;
  trialEndsAt?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionPlan = {
  __typename?: 'SubscriptionPlan';
  amount: Scalars['Float']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  includedModules?: Maybe<Array<Scalars['String']['output']>>;
  interval: BillingInterval;
  maxClients?: Maybe<Scalars['Float']['output']>;
  maxUsers?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  stripePriceId?: Maybe<Scalars['String']['output']>;
  tier: Scalars['String']['output'];
};

export type SubscriptionPlanInput = {
  amount: Scalars['Float']['input'];
  currency?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  includedModules?: InputMaybe<Array<Scalars['String']['input']>>;
  interval: BillingInterval;
  maxClients?: InputMaybe<Scalars['Float']['input']>;
  maxUsers?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  stripePriceId?: InputMaybe<Scalars['String']['input']>;
  tier: Scalars['String']['input'];
};

export type SubscriptionProduct = {
  __typename?: 'SubscriptionProduct';
  allowCustomAmount: Scalars['Boolean']['output'];
  amount: Scalars['Float']['output'];
  badge?: Maybe<Scalars['String']['output']>;
  billingCycles?: Maybe<Scalars['Int']['output']>;
  chargeOnActivation: Scalars['Boolean']['output'];
  color?: Maybe<Scalars['String']['output']>;
  courseStartUrl?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  ctaText?: Maybe<Scalars['String']['output']>;
  currency: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  detailedDescription?: Maybe<Scalars['String']['output']>;
  features: Array<Scalars['String']['output']>;
  grantedPermissions?: Maybe<Array<Scalars['String']['output']>>;
  hideOtherProducts: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  includedAccessMonths?: Maybe<Scalars['Int']['output']>;
  includedModules?: Maybe<Array<Scalars['String']['output']>>;
  interval: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  isRecommended: Scalars['Boolean']['output'];
  isUnlisted: Scalars['Boolean']['output'];
  linkedCourseId?: Maybe<Scalars['String']['output']>;
  minAmount: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  salesPageUrl?: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  sortOrder: Scalars['Float']['output'];
  stripePriceId?: Maybe<Scalars['String']['output']>;
  stripeProductId?: Maybe<Scalars['String']['output']>;
  suggestedAmount?: Maybe<Scalars['Float']['output']>;
  tenantId: Scalars['String']['output'];
  tier?: Maybe<Scalars['String']['output']>;
  trialDays?: Maybe<Scalars['Float']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  welcomeEmailBody?: Maybe<Scalars['String']['output']>;
  welcomeEmailSubject?: Maybe<Scalars['String']['output']>;
};

export type SubscriptionProductInput = {
  allowCustomAmount?: InputMaybe<Scalars['Boolean']['input']>;
  amount: Scalars['Float']['input'];
  badge?: InputMaybe<Scalars['String']['input']>;
  billingCycles?: InputMaybe<Scalars['Int']['input']>;
  chargeOnActivation?: InputMaybe<Scalars['Boolean']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  courseStartUrl?: InputMaybe<Scalars['String']['input']>;
  ctaText?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  detailedDescription?: InputMaybe<Scalars['String']['input']>;
  features?: InputMaybe<Array<Scalars['String']['input']>>;
  grantedPermissions?: InputMaybe<Array<Scalars['String']['input']>>;
  hideOtherProducts?: InputMaybe<Scalars['Boolean']['input']>;
  includedAccessMonths?: InputMaybe<Scalars['Int']['input']>;
  includedModules?: InputMaybe<Array<Scalars['String']['input']>>;
  interval?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isRecommended?: InputMaybe<Scalars['Boolean']['input']>;
  isUnlisted?: InputMaybe<Scalars['Boolean']['input']>;
  linkedCourseId?: InputMaybe<Scalars['String']['input']>;
  minAmount?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  salesPageUrl?: InputMaybe<Scalars['String']['input']>;
  slug: Scalars['String']['input'];
  sortOrder?: InputMaybe<Scalars['Float']['input']>;
  stripePriceId?: InputMaybe<Scalars['String']['input']>;
  stripeProductId?: InputMaybe<Scalars['String']['input']>;
  suggestedAmount?: InputMaybe<Scalars['Float']['input']>;
  tier?: InputMaybe<Scalars['String']['input']>;
  trialDays?: InputMaybe<Scalars['Float']['input']>;
  welcomeEmailBody?: InputMaybe<Scalars['String']['input']>;
  welcomeEmailSubject?: InputMaybe<Scalars['String']['input']>;
};

export enum SubscriptionStatus {
  Active = 'ACTIVE',
  Canceled = 'CANCELED',
  Incomplete = 'INCOMPLETE',
  PastDue = 'PAST_DUE',
  Paused = 'PAUSED',
  Trialing = 'TRIALING'
}

export type SuburbStats = {
  __typename?: 'SuburbStats';
  computedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  /** Crime incidents per 1000 residents (rolling 12mo) */
  crimeRatePer1000?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  medianAge?: Maybe<Scalars['Float']['output']>;
  /** Median $/sqm computed from latest valuations */
  medianPricePerSqm?: Maybe<Scalars['Float']['output']>;
  population?: Maybe<Scalars['Int']['output']>;
  /** 5-year population growth rate (decimal, e.g. 0.12 = 12%) */
  populationGrowth5y?: Maybe<Scalars['Float']['output']>;
  suburb: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type SuggestedAction = {
  __typename?: 'SuggestedAction';
  description: Scalars['String']['output'];
  priority: Scalars['String']['output'];
  title: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type SuitabilityAssessment = {
  __typename?: 'SuitabilityAssessment';
  /** Name of the staff member who recorded this assessment */
  assessor?: Maybe<Scalars['String']['output']>;
  /** Clinical fit — does our care match their needs? YES / NO since 28 Sep 2026; HIGH / MEDIUM / LOW / NA are old ratings, kept as saved. */
  clinicalFit?: Maybe<SuitabilityFitLevel>;
  /** Why the clinical fit is NO (required for NO, 28 Sep 2026). Cleared when the fit is not NO. */
  clinicalFitComment?: Maybe<Scalars['String']['output']>;
  /** When status was set to APPROVED or DECLINED */
  decidedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Family readiness — family/POA understand and consent to placement */
  familyReadiness?: Maybe<SuitabilityFitLevel>;
  /** Financial fit — can funding, bond and ongoing fees be met? YES / NO since 28 Sep 2026; HIGH / MEDIUM / LOW / NA are old ratings, kept as saved. */
  financialFit?: Maybe<SuitabilityFitLevel>;
  /** Why the financial fit is NO (required for NO, 28 Sep 2026). Cleared when the fit is not NO. */
  financialFitComment?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  status: SuitabilityStatus;
};

export type SuitabilityAssessmentInput = {
  /** IGNORED since 2026-09-25 — the server records the signed-in person as the assessor. Kept so older pages still validate. */
  assessor?: InputMaybe<Scalars['String']['input']>;
  /** YES or NO (28 Sep 2026). An old rating (HIGH / MEDIUM / LOW / NA) is accepted only when it is the value already saved. null clears it. */
  clinicalFit?: InputMaybe<SuitabilityFitLevel>;
  /** Why the clinical fit is NO — required when clinicalFit is NO. Omitted = keep the saved comment. */
  clinicalFitComment?: InputMaybe<Scalars['String']['input']>;
  familyReadiness?: InputMaybe<SuitabilityFitLevel>;
  /** YES or NO (28 Sep 2026). An old rating (HIGH / MEDIUM / LOW / NA) is accepted only when it is the value already saved. null clears it. */
  financialFit?: InputMaybe<SuitabilityFitLevel>;
  /** Why the financial fit is NO — required when financialFit is NO. Omitted = keep the saved comment. */
  financialFitComment?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<SuitabilityStatus>;
  /** Why unsuitable — required when status is DECLINED (Unsuitable) */
  unsuitableReason?: InputMaybe<Scalars['String']['input']>;
};

/** Fit level for a single suitability dimension */
export enum SuitabilityFitLevel {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM',
  Na = 'NA',
  No = 'NO',
  Yes = 'YES'
}

/** Lifecycle of a suitability assessment */
export enum SuitabilityStatus {
  Approved = 'APPROVED',
  Declined = 'DECLINED',
  InReview = 'IN_REVIEW',
  Pending = 'PENDING'
}

export type SuitabilityStatusCount = {
  __typename?: 'SuitabilityStatusCount';
  count: Scalars['Int']['output'];
  /** null bucket = entries with no suitabilityAssessment yet */
  status?: Maybe<SuitabilityStatus>;
};

/** Superannuation standard choice form (NAT 13080) — which section the employee completed: B = existing fund, C = employer default fund, D = self-managed super fund. */
export enum SuperChoiceType {
  EmployerDefault = 'EMPLOYER_DEFAULT',
  ExistingFund = 'EXISTING_FUND',
  Smsf = 'SMSF'
}

export type Supplier = {
  __typename?: 'Supplier';
  abn?: Maybe<Scalars['String']['output']>;
  accountNumber?: Maybe<Scalars['String']['output']>;
  address?: Maybe<Scalars['String']['output']>;
  contactEmail?: Maybe<Scalars['String']['output']>;
  contactName?: Maybe<Scalars['String']['output']>;
  contactPhone?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  ingredientCount: Scalars['Float']['output'];
  ingredients: Array<Ingredient>;
  isActive: Scalars['Boolean']['output'];
  leadTimeDays: Scalars['Float']['output'];
  minimumOrder?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  orders: Array<SupplierOrder>;
  paymentTerms?: Maybe<Scalars['String']['output']>;
  preferredCategories?: Maybe<Array<IngredientCategory>>;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  website?: Maybe<Scalars['String']['output']>;
};

export type SupplierOrder = {
  __typename?: 'SupplierOrder';
  actualDelivery?: Maybe<Scalars['DateTime']['output']>;
  cancellationReason?: Maybe<Scalars['String']['output']>;
  cancelledAt?: Maybe<Scalars['DateTime']['output']>;
  cancelledBy?: Maybe<Scalars['String']['output']>;
  confirmedAt?: Maybe<Scalars['DateTime']['output']>;
  confirmedBy?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  deliveredAt?: Maybe<Scalars['DateTime']['output']>;
  deliveryNotes?: Maybe<Scalars['String']['output']>;
  discrepancyNotes?: Maybe<Scalars['String']['output']>;
  expectedDelivery?: Maybe<Scalars['DateTime']['output']>;
  hasDiscrepancies: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  itemCount: Scalars['Float']['output'];
  items: Array<SupplierOrderItem>;
  notes?: Maybe<Scalars['String']['output']>;
  orderDate: Scalars['DateTime']['output'];
  orderNumber?: Maybe<Scalars['String']['output']>;
  status: SupplierOrderStatus;
  submittedAt?: Maybe<Scalars['DateTime']['output']>;
  submittedBy?: Maybe<Scalars['String']['output']>;
  supplier?: Maybe<Supplier>;
  supplierId: Scalars['ID']['output'];
  supplierOrderNumber?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  totalAmount: Scalars['Float']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type SupplierOrderItem = {
  __typename?: 'SupplierOrderItem';
  createdAt: Scalars['DateTime']['output'];
  hasDiscrepancy: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  ingredient?: Maybe<Ingredient>;
  ingredientId: Scalars['ID']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  order?: Maybe<SupplierOrder>;
  orderId: Scalars['ID']['output'];
  quantity: Scalars['Float']['output'];
  receivedQuantity?: Maybe<Scalars['Float']['output']>;
  tenantId: Scalars['String']['output'];
  totalPrice: Scalars['Float']['output'];
  unit: UnitType;
  unitPrice: Scalars['Float']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type SupplierOrderItemInput = {
  ingredientId: Scalars['ID']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  quantity: Scalars['Float']['input'];
  unit: UnitType;
  unitPrice?: InputMaybe<Scalars['Float']['input']>;
};

/** Status of a supplier order */
export enum SupplierOrderStatus {
  Cancelled = 'CANCELLED',
  Confirmed = 'CONFIRMED',
  Delivered = 'DELIVERED',
  Draft = 'DRAFT',
  Shipped = 'SHIPPED',
  Submitted = 'SUBMITTED'
}

export type SupplierSpendingItem = {
  __typename?: 'SupplierSpendingItem';
  orderCount: Scalars['Float']['output'];
  supplierId: Scalars['String']['output'];
  supplierName: Scalars['String']['output'];
  totalSpent: Scalars['Float']['output'];
};

export type SupplierSpendingReport = {
  __typename?: 'SupplierSpendingReport';
  bySupplier: Array<SupplierSpendingItem>;
  totalSpent: Scalars['Float']['output'];
};

export type SupplyAgent = {
  __typename?: 'SupplyAgent';
  agentType: AgentType;
  capacityBpd?: Maybe<Scalars['Float']['output']>;
  capacityLitres?: Maybe<Scalars['Float']['output']>;
  country: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  fuelTypes: Array<FuelType>;
  id: Scalars['ID']['output'];
  linkedRouteIds: Array<Scalars['String']['output']>;
  linkedStationIds: Array<Scalars['String']['output']>;
  location?: Maybe<GeoPoint>;
  name: Scalars['String']['output'];
  owner?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** Supported crypto assets */
export enum SupportedAsset {
  Btc = 'BTC',
  Eth = 'ETH',
  Paxg = 'PAXG',
  Usdc = 'USDC',
  Xaut = 'XAUT',
  Zec = 'ZEC'
}

/** Supported blockchain networks */
export enum SupportedChain {
  Bitcoin = 'BITCOIN',
  Ethereum = 'ETHEREUM',
  Zcash = 'ZCASH'
}

export type SwapLinkAuthResult = {
  __typename?: 'SwapLinkAuthResult';
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  token?: Maybe<Scalars['String']['output']>;
};

export type TankBreakdown = {
  __typename?: 'TankBreakdown';
  fuelType: FuelType;
  litres: Scalars['Float']['output'];
};

export type Task = {
  __typename?: 'Task';
  assignedTo?: Maybe<Array<Client>>;
  billable: Scalars['Boolean']['output'];
  billed: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  media?: Maybe<Array<TaskMedia>>;
  order: Scalars['Float']['output'];
  projectId: Scalars['ID']['output'];
  status: TaskStatus;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type TaskInput = {
  assignedTo?: InputMaybe<Array<Scalars['ID']['input']>>;
  billable?: InputMaybe<Scalars['Boolean']['input']>;
  billed?: InputMaybe<Scalars['Boolean']['input']>;
  description: Scalars['String']['input'];
  media?: InputMaybe<Array<TaskMediaInput>>;
  order?: InputMaybe<Scalars['Float']['input']>;
  projectId: Scalars['ID']['input'];
  status: Scalars['String']['input'];
};

export type TaskMedia = {
  __typename?: 'TaskMedia';
  cid?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  fileType: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type TaskMediaInput = {
  cid?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

/** The status of a task */
export enum TaskStatus {
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS',
  Pending = 'PENDING'
}

/** TFN declaration Q8 — residency status for tax purposes (NAT 3092). Select only one. */
export enum TaxResidencyStatus {
  AustralianResident = 'AUSTRALIAN_RESIDENT',
  ForeignResident = 'FOREIGN_RESIDENT',
  WorkingHolidayMaker = 'WORKING_HOLIDAY_MAKER'
}

/** ADP-style tax scale code (display-only — STP2 uses Tax Treatment Code) */
export enum TaxScale {
  Scale_1 = 'SCALE_1',
  Scale_2 = 'SCALE_2',
  Scale_3 = 'SCALE_3',
  Scale_4 = 'SCALE_4',
  Scale_5 = 'SCALE_5',
  Scale_6 = 'SCALE_6'
}

export type Team = {
  __typename?: 'Team';
  code: Scalars['String']['output'];
  color?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  displayOrder?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  shiftUsageCount: Scalars['Int']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type TeamInput = {
  code: Scalars['String']['input'];
  color?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayOrder?: InputMaybe<Scalars['Float']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
};

export type TeamOverviewPreview = {
  __typename?: 'TeamOverviewPreview';
  body: Scalars['String']['output'];
  buildCount: Scalars['Int']['output'];
  recipients: Array<TeamOverviewRecipient>;
  subject: Scalars['String']['output'];
};

export type TeamOverviewRecipient = {
  __typename?: 'TeamOverviewRecipient';
  email?: Maybe<Scalars['String']['output']>;
  isDefault: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  profileKey?: Maybe<Scalars['String']['output']>;
};

export type TemperatureAlarm = {
  __typename?: 'TemperatureAlarm';
  alarmType: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  deadlineTime: Scalars['String']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  enabled: Scalars['Boolean']['output'];
  equipmentId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastTriggeredAt?: Maybe<Scalars['DateTime']['output']>;
  maxTemp?: Maybe<Scalars['Float']['output']>;
  minTemp?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  notifyViaEmail: Scalars['Boolean']['output'];
  notifyViaSms: Scalars['Boolean']['output'];
  recipientClientIds: Array<Scalars['String']['output']>;
  session: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type TemperatureFilterInput = {
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  method?: InputMaybe<TemperatureMethod>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  residentId?: InputMaybe<Scalars['ID']['input']>;
  wing?: InputMaybe<Scalars['String']['input']>;
};

/** Reason selected when submitting a flagged (out-of-range) temperature reading */
export enum TemperatureFlagReason {
  DoorLeftOpen = 'DOOR_LEFT_OPEN',
  EquipmentFault = 'EQUIPMENT_FAULT',
  FoodCheckedFine = 'FOOD_CHECKED_FINE',
  FoodRemoved = 'FOOD_REMOVED',
  Other = 'OTHER',
  PowerOutage = 'POWER_OUTAGE',
  TechnicianCalled = 'TECHNICIAN_CALLED'
}

export type TemperatureLog = {
  __typename?: 'TemperatureLog';
  actionNote?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  equipmentId: Scalars['String']['output'];
  equipmentName: Scalars['String']['output'];
  escalatedFromLogId?: Maybe<Scalars['ID']['output']>;
  flagReason?: Maybe<TemperatureFlagReason>;
  flagReasonOther?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isOutOfRange: Scalars['Boolean']['output'];
  location: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  recordedAt: Scalars['DateTime']['output'];
  recordedBy: Scalars['String']['output'];
  session?: Maybe<Scalars['String']['output']>;
  status: TemperatureStatus;
  temperature: Scalars['Float']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** Temperature measurement method with associated normal ranges */
export enum TemperatureMethod {
  Axillae = 'AXILLAE',
  Forehead = 'FOREHEAD',
  Orally = 'ORALLY',
  Otic = 'OTIC',
  Rectal = 'RECTAL',
  Unspecified = 'UNSPECIFIED'
}

export type TemperatureMethodInfo = {
  __typename?: 'TemperatureMethodInfo';
  description: Scalars['String']['output'];
  method: TemperatureMethod;
  normalMax: Scalars['Float']['output'];
  normalMin: Scalars['Float']['output'];
};

export type TemperatureObservation = {
  __typename?: 'TemperatureObservation';
  alertMessage?: Maybe<Scalars['String']['output']>;
  autoProgressNote: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  method: TemperatureMethod;
  progressNoteId?: Maybe<Scalars['ID']['output']>;
  residentId: Scalars['ID']['output'];
  residentName?: Maybe<Scalars['String']['output']>;
  residentRoom?: Maybe<Scalars['String']['output']>;
  residentWing?: Maybe<Scalars['String']['output']>;
  sourceAuthor?: Maybe<Scalars['String']['output']>;
  sourceBackupDate?: Maybe<Scalars['DateTime']['output']>;
  sourceHash?: Maybe<Scalars['String']['output']>;
  sourceId?: Maybe<Scalars['String']['output']>;
  sourceMethod?: Maybe<Scalars['String']['output']>;
  sourceSystem?: Maybe<Scalars['String']['output']>;
  takenAt: Scalars['DateTime']['output'];
  takenBy: Scalars['ID']['output'];
  takenByName?: Maybe<Scalars['String']['output']>;
  temperature: Scalars['Float']['output'];
  tenantId: Scalars['String']['output'];
  triggeredAlert: Scalars['Boolean']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type TemperatureObservationsResponse = {
  __typename?: 'TemperatureObservationsResponse';
  limit: Scalars['Int']['output'];
  observations: Array<TemperatureObservation>;
  offset: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type TemperatureRangeConfig = {
  __typename?: 'TemperatureRangeConfig';
  max: Scalars['Float']['output'];
  method: TemperatureMethod;
  min: Scalars['Float']['output'];
};

export type TemperatureRangeConfigInput = {
  max: Scalars['Float']['input'];
  method: TemperatureMethod;
  min: Scalars['Float']['input'];
};

/** Status of a temperature reading (OK, flagged out-of-range, escalated after 2 consecutive flags) */
export enum TemperatureStatus {
  Escalated = 'ESCALATED',
  Flagged = 'FLAGGED',
  Ok = 'OK'
}

export type TemplateGoal = {
  __typename?: 'TemplateGoal';
  achievementCriteria?: Maybe<Scalars['String']['output']>;
  defaultDaysToAchieve?: Maybe<Scalars['Float']['output']>;
  description: Scalars['String']['output'];
  priority?: Maybe<Scalars['Float']['output']>;
};

export type TemplateGoalInput = {
  achievementCriteria?: InputMaybe<Scalars['String']['input']>;
  defaultDaysToAchieve?: InputMaybe<Scalars['Float']['input']>;
  description: Scalars['String']['input'];
  priority?: InputMaybe<Scalars['Float']['input']>;
};

export type TemplateIntervention = {
  __typename?: 'TemplateIntervention';
  defaultScheduleTimes?: Maybe<Array<Scalars['String']['output']>>;
  description: Scalars['String']['output'];
  duration?: Maybe<Scalars['String']['output']>;
  frequency: InterventionFrequency;
  goalIndex?: Maybe<Scalars['Float']['output']>;
  instructions?: Maybe<Scalars['String']['output']>;
  responsibleRole: ResponsibleRole;
};

export type TemplateInterventionInput = {
  defaultScheduleTimes?: InputMaybe<Array<Scalars['String']['input']>>;
  description: Scalars['String']['input'];
  duration?: InputMaybe<Scalars['String']['input']>;
  frequency?: InputMaybe<InterventionFrequency>;
  goalIndex?: InputMaybe<Scalars['Float']['input']>;
  instructions?: InputMaybe<Scalars['String']['input']>;
  responsibleRole?: InputMaybe<ResponsibleRole>;
};

export type TemplateUsageStats = {
  __typename?: 'TemplateUsageStats';
  category: CarePlanCategory;
  isActive: Scalars['Boolean']['output'];
  templateId: Scalars['ID']['output'];
  templateName: Scalars['String']['output'];
  usageCount: Scalars['Int']['output'];
};

export type Tenant = {
  __typename?: 'Tenant';
  acmaRegistration?: Maybe<AcmaRegistration>;
  alphaId?: Maybe<Scalars['String']['output']>;
  apiKeys?: Maybe<TenantApiKeys>;
  authConfig?: Maybe<TenantAuthConfig>;
  billingExempt?: Maybe<Scalars['Boolean']['output']>;
  billingMode?: Maybe<Scalars['String']['output']>;
  branding?: Maybe<TenantBranding>;
  client?: Maybe<Client>;
  clientId: Scalars['ID']['output'];
  companyDetails?: Maybe<TenantCompanyDetails>;
  createdAt: Scalars['DateTime']['output'];
  curatedEmployeePermissions?: Maybe<Array<Scalars['String']['output']>>;
  dedicatedNumber?: Maybe<Scalars['String']['output']>;
  deploymentUrl?: Maybe<Scalars['String']['output']>;
  domain?: Maybe<Scalars['String']['output']>;
  emailConfig?: Maybe<TenantEmailConfig>;
  githubOwner?: Maybe<Scalars['String']['output']>;
  githubRepo?: Maybe<Scalars['String']['output']>;
  githubToken?: Maybe<Scalars['String']['output']>;
  hosting?: Maybe<TenantHosting>;
  id: Scalars['ID']['output'];
  lastBilledAt?: Maybe<Scalars['DateTime']['output']>;
  lastDeployment?: Maybe<Scalars['DateTime']['output']>;
  mainBranch?: Maybe<Scalars['String']['output']>;
  meetConfig?: Maybe<TenantMeetConfig>;
  moduleConfig: Array<TenantModuleConfig>;
  name: Scalars['String']['output'];
  notificationSettings?: Maybe<TenantNotificationSettings>;
  paymentReceivingDetails?: Maybe<PaymentReceivingDetails>;
  recruitmentPartners?: Maybe<Array<TenantRecruitmentPartner>>;
  skipPaymentCollection?: Maybe<Scalars['Boolean']['output']>;
  smsConfig?: Maybe<TenantSmsConfig>;
  status: TenantStatus;
  stripeCustomerId?: Maybe<Scalars['String']['output']>;
  subscriptionTier: Scalars['String']['output'];
  trialEndsAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  useAlphaId?: Maybe<Scalars['Boolean']['output']>;
  websiteUrl?: Maybe<Scalars['String']['output']>;
};

export type TenantAddress = {
  __typename?: 'TenantAddress';
  addressLine1?: Maybe<Scalars['String']['output']>;
  addressLine2?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
};

export type TenantAddressInput = {
  addressLine1?: InputMaybe<Scalars['String']['input']>;
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
};

export type TenantApiKeys = {
  __typename?: 'TenantApiKeys';
  azureFunctionKey?: Maybe<Scalars['String']['output']>;
  azureFunctionProvisionUrl?: Maybe<Scalars['String']['output']>;
  cellcastApiKey?: Maybe<Scalars['String']['output']>;
  dograhAgents?: Maybe<Array<DograhAgent>>;
  dograhApiBaseUrl?: Maybe<Scalars['String']['output']>;
  dograhEmbedToken?: Maybe<Scalars['String']['output']>;
  dograhWorkflowId?: Maybe<Scalars['String']['output']>;
  ghlApiToken?: Maybe<Scalars['String']['output']>;
  ghlFieldKeys?: Maybe<Scalars['String']['output']>;
  ghlLocationId?: Maybe<Scalars['String']['output']>;
  ghlPipelineId?: Maybe<Scalars['String']['output']>;
  ghlStageId?: Maybe<Scalars['String']['output']>;
  improvmxApiKey?: Maybe<Scalars['String']['output']>;
  improvmxDomain?: Maybe<Scalars['String']['output']>;
  ipfsApiUrl?: Maybe<Scalars['String']['output']>;
  ipfsBackupGatewayUrl?: Maybe<Scalars['String']['output']>;
  ipfsGatewayUrl?: Maybe<Scalars['String']['output']>;
  knowledgeFsSecret?: Maybe<Scalars['String']['output']>;
  knowledgeFsUrl?: Maybe<Scalars['String']['output']>;
  knowledgeHarnessSecret?: Maybe<Scalars['String']['output']>;
  knowledgeHarnessUrl?: Maybe<Scalars['String']['output']>;
  knowledgeRoot?: Maybe<Scalars['String']['output']>;
  localAiBaseUrl?: Maybe<Scalars['String']['output']>;
  localAiBearerToken?: Maybe<Scalars['String']['output']>;
  localAiDefaultModel?: Maybe<Scalars['String']['output']>;
  microsoft365CertThumbprint?: Maybe<Scalars['String']['output']>;
  microsoft365ClientId?: Maybe<Scalars['String']['output']>;
  microsoft365Organization?: Maybe<Scalars['String']['output']>;
  microsoft365TenantId?: Maybe<Scalars['String']['output']>;
  mobileForwardNumber?: Maybe<Scalars['String']['output']>;
  pipedriveApiToken?: Maybe<Scalars['String']['output']>;
  pipedriveCompanyDomain?: Maybe<Scalars['String']['output']>;
  postmarkApiKey?: Maybe<Scalars['String']['output']>;
  postmarkInboundAddress?: Maybe<Scalars['String']['output']>;
  resellerClubApiKey?: Maybe<Scalars['String']['output']>;
  resellerClubUserId?: Maybe<Scalars['String']['output']>;
  smsNumber?: Maybe<Scalars['String']['output']>;
  stripePublicKey?: Maybe<Scalars['String']['output']>;
  stripeSecretKey?: Maybe<Scalars['String']['output']>;
  stripeWebhookSecret?: Maybe<Scalars['String']['output']>;
  tollFreeNumber?: Maybe<Scalars['String']['output']>;
  twilioAccountSid?: Maybe<Scalars['String']['output']>;
  twilioApiKey?: Maybe<Scalars['String']['output']>;
  twilioApiSecret?: Maybe<Scalars['String']['output']>;
  twilioAppSid?: Maybe<Scalars['String']['output']>;
  twilioAuthToken?: Maybe<Scalars['String']['output']>;
  twilioPhoneNumber?: Maybe<Scalars['String']['output']>;
  unsplashAccessKey?: Maybe<Scalars['String']['output']>;
  unsplashApiKey?: Maybe<Scalars['String']['output']>;
  unsplashApplicationId?: Maybe<Scalars['String']['output']>;
  unsplashSecretKey?: Maybe<Scalars['String']['output']>;
  vapiAssistantId?: Maybe<Scalars['String']['output']>;
  vapiPhoneNumberId?: Maybe<Scalars['String']['output']>;
  vapiPrivateApiKey?: Maybe<Scalars['String']['output']>;
  vapiPublicApiKey?: Maybe<Scalars['String']['output']>;
  vercelToken?: Maybe<Scalars['String']['output']>;
};

export type TenantApiKeysInput = {
  azureFunctionKey?: InputMaybe<Scalars['String']['input']>;
  azureFunctionProvisionUrl?: InputMaybe<Scalars['String']['input']>;
  cellcastApiKey?: InputMaybe<Scalars['String']['input']>;
  dograhAgents?: InputMaybe<Array<DograhAgentInput>>;
  dograhApiBaseUrl?: InputMaybe<Scalars['String']['input']>;
  dograhEmbedToken?: InputMaybe<Scalars['String']['input']>;
  dograhWorkflowId?: InputMaybe<Scalars['String']['input']>;
  ghlApiToken?: InputMaybe<Scalars['String']['input']>;
  ghlFieldKeys?: InputMaybe<Scalars['String']['input']>;
  ghlLocationId?: InputMaybe<Scalars['String']['input']>;
  ghlPipelineId?: InputMaybe<Scalars['String']['input']>;
  ghlStageId?: InputMaybe<Scalars['String']['input']>;
  improvmxApiKey?: InputMaybe<Scalars['String']['input']>;
  improvmxDomain?: InputMaybe<Scalars['String']['input']>;
  ipfsApiUrl?: InputMaybe<Scalars['String']['input']>;
  ipfsBackupGatewayUrl?: InputMaybe<Scalars['String']['input']>;
  ipfsGatewayUrl?: InputMaybe<Scalars['String']['input']>;
  knowledgeFsSecret?: InputMaybe<Scalars['String']['input']>;
  knowledgeFsUrl?: InputMaybe<Scalars['String']['input']>;
  knowledgeHarnessSecret?: InputMaybe<Scalars['String']['input']>;
  knowledgeHarnessUrl?: InputMaybe<Scalars['String']['input']>;
  knowledgeRoot?: InputMaybe<Scalars['String']['input']>;
  localAiBaseUrl?: InputMaybe<Scalars['String']['input']>;
  localAiBearerToken?: InputMaybe<Scalars['String']['input']>;
  localAiDefaultModel?: InputMaybe<Scalars['String']['input']>;
  microsoft365CertThumbprint?: InputMaybe<Scalars['String']['input']>;
  microsoft365ClientId?: InputMaybe<Scalars['String']['input']>;
  microsoft365Organization?: InputMaybe<Scalars['String']['input']>;
  microsoft365TenantId?: InputMaybe<Scalars['String']['input']>;
  mobileForwardNumber?: InputMaybe<Scalars['String']['input']>;
  pipedriveApiToken?: InputMaybe<Scalars['String']['input']>;
  pipedriveCompanyDomain?: InputMaybe<Scalars['String']['input']>;
  postmarkApiKey?: InputMaybe<Scalars['String']['input']>;
  postmarkInboundAddress?: InputMaybe<Scalars['String']['input']>;
  resellerClubApiKey?: InputMaybe<Scalars['String']['input']>;
  resellerClubUserId?: InputMaybe<Scalars['String']['input']>;
  smsNumber?: InputMaybe<Scalars['String']['input']>;
  stripePublicKey?: InputMaybe<Scalars['String']['input']>;
  stripeSecretKey?: InputMaybe<Scalars['String']['input']>;
  stripeWebhookSecret?: InputMaybe<Scalars['String']['input']>;
  tollFreeNumber?: InputMaybe<Scalars['String']['input']>;
  twilioAccountSid?: InputMaybe<Scalars['String']['input']>;
  twilioApiKey?: InputMaybe<Scalars['String']['input']>;
  twilioApiSecret?: InputMaybe<Scalars['String']['input']>;
  twilioAppSid?: InputMaybe<Scalars['String']['input']>;
  twilioAuthToken?: InputMaybe<Scalars['String']['input']>;
  twilioPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  unsplashAccessKey?: InputMaybe<Scalars['String']['input']>;
  unsplashApiKey?: InputMaybe<Scalars['String']['input']>;
  unsplashApplicationId?: InputMaybe<Scalars['String']['input']>;
  unsplashSecretKey?: InputMaybe<Scalars['String']['input']>;
  vapiAssistantId?: InputMaybe<Scalars['String']['input']>;
  vapiPhoneNumberId?: InputMaybe<Scalars['String']['input']>;
  vapiPrivateApiKey?: InputMaybe<Scalars['String']['input']>;
  vapiPublicApiKey?: InputMaybe<Scalars['String']['input']>;
  vercelToken?: InputMaybe<Scalars['String']['input']>;
};

export type TenantAuthConfig = {
  __typename?: 'TenantAuthConfig';
  allowEmailLinkSignup: Scalars['Boolean']['output'];
  collectProfileAfterSignIn: Scalars['Boolean']['output'];
  defaultAuthMethod?: Maybe<Scalars['String']['output']>;
  discreteAlternativeAuth: Scalars['Boolean']['output'];
  emailLinkFlow: Scalars['String']['output'];
  emailSignInMode: Scalars['String']['output'];
  enableEmailAuth: Scalars['Boolean']['output'];
  enablePasskeyAuth: Scalars['Boolean']['output'];
  enablePhoneAuth: Scalars['Boolean']['output'];
  enableUsernamePassword: Scalars['Boolean']['output'];
  passkeySetupPrompt: Scalars['String']['output'];
  passwordSetupPrompt: Scalars['String']['output'];
  phoneSignInMode: Scalars['String']['output'];
  profileFields: AuthProfileFieldPolicy;
  profilePromptAfterLogins: Scalars['Int']['output'];
  profilePromptRepeatDays: Scalars['Int']['output'];
  signInOrigins?: Maybe<Array<Scalars['String']['output']>>;
};

export type TenantAuthConfigInput = {
  allowEmailLinkSignup?: InputMaybe<Scalars['Boolean']['input']>;
  collectProfileAfterSignIn?: InputMaybe<Scalars['Boolean']['input']>;
  defaultAuthMethod?: InputMaybe<Scalars['String']['input']>;
  discreteAlternativeAuth?: InputMaybe<Scalars['Boolean']['input']>;
  emailLinkFlow?: InputMaybe<Scalars['String']['input']>;
  emailSignInMode?: InputMaybe<Scalars['String']['input']>;
  enableEmailAuth?: InputMaybe<Scalars['Boolean']['input']>;
  enablePasskeyAuth?: InputMaybe<Scalars['Boolean']['input']>;
  enablePhoneAuth?: InputMaybe<Scalars['Boolean']['input']>;
  enableUsernamePassword?: InputMaybe<Scalars['Boolean']['input']>;
  passkeySetupPrompt?: InputMaybe<Scalars['String']['input']>;
  passwordSetupPrompt?: InputMaybe<Scalars['String']['input']>;
  phoneSignInMode?: InputMaybe<Scalars['String']['input']>;
  profileFields?: InputMaybe<AuthProfileFieldPolicyInput>;
  profilePromptAfterLogins?: InputMaybe<Scalars['Int']['input']>;
  profilePromptRepeatDays?: InputMaybe<Scalars['Int']['input']>;
  signInOrigins?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type TenantAuthenticationSettings = {
  __typename?: 'TenantAuthenticationSettings';
  missingFields: Array<Scalars['String']['output']>;
  saved: TenantAuthConfig;
};

export type TenantAutomationRun = {
  __typename?: 'TenantAutomationRun';
  claudePrompt?: Maybe<Scalars['String']['output']>;
  claudeResponse?: Maybe<Scalars['String']['output']>;
  communicationIds?: Maybe<Array<Scalars['String']['output']>>;
  createdAt: Scalars['DateTime']['output'];
  durationMs?: Maybe<Scalars['Int']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  results?: Maybe<AutomationRunResults>;
  runDate: Scalars['DateTime']['output'];
  runType: AutomationRunType;
  status: AutomationRunStatus;
  tenantId: Scalars['String']['output'];
  triggeredBy: Scalars['String']['output'];
  triggeredByName?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type TenantBillingRow = {
  __typename?: 'TenantBillingRow';
  billingExempt: Scalars['Boolean']['output'];
  billingMode?: Maybe<Scalars['String']['output']>;
  currentBillAmount?: Maybe<Scalars['Float']['output']>;
  currentBillId?: Maybe<Scalars['String']['output']>;
  hasCardOnFile: Scalars['Boolean']['output'];
  isPaid: Scalars['Boolean']['output'];
  lastBilledAt?: Maybe<Scalars['DateTime']['output']>;
  remainingBalance: Scalars['Float']['output'];
  status: Scalars['String']['output'];
  stripeCustomerId?: Maybe<Scalars['String']['output']>;
  subscriptionTier?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  tenantName: Scalars['String']['output'];
  tokenDiscount: Scalars['Float']['output'];
};

export type TenantBillingStatus = {
  __typename?: 'TenantBillingStatus';
  billingExempt: Scalars['Boolean']['output'];
  billingMode: Scalars['String']['output'];
  billingStatus: Scalars['String']['output'];
  currentBillAmount?: Maybe<Scalars['Float']['output']>;
  currentBillId?: Maybe<Scalars['String']['output']>;
  lastPaymentDate?: Maybe<Scalars['DateTime']['output']>;
  monthlyModuleTotal: Scalars['Float']['output'];
  tenantId: Scalars['String']['output'];
  tenantName: Scalars['String']['output'];
  tier: Scalars['String']['output'];
};

export type TenantBranding = {
  __typename?: 'TenantBranding';
  accentColor?: Maybe<Scalars['String']['output']>;
  aiAssistantName?: Maybe<Scalars['String']['output']>;
  /** Page background base for the site's default colour mode. */
  backgroundMain?: Maybe<Scalars['String']['output']>;
  bannerImage?: Maybe<Scalars['String']['output']>;
  bannerImageCid?: Maybe<Scalars['String']['output']>;
  colorMode?: Maybe<TenantColorMode>;
  ctaButtonStyle?: Maybe<CtaButtonStyle>;
  ctaButtonText?: Maybe<Scalars['String']['output']>;
  ctaButtonUrl?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  emailFont?: Maybe<EmailFont>;
  emailFooterText?: Maybe<Scalars['String']['output']>;
  emailLetterhead?: Maybe<Scalars['Boolean']['output']>;
  emailStyle?: Maybe<EmailStyle>;
  favicon?: Maybe<Scalars['String']['output']>;
  faviconCid?: Maybe<Scalars['String']['output']>;
  /** Body font family name. */
  fontBody?: Maybe<Scalars['String']['output']>;
  /** Heading font family name (e.g. Geist). Must be loadable by the site. */
  fontHeading?: Maybe<Scalars['String']['output']>;
  hideSiteName?: Maybe<Scalars['Boolean']['output']>;
  hideTagline?: Maybe<Scalars['Boolean']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  logoCid?: Maybe<Scalars['String']['output']>;
  logoGlyph?: Maybe<Scalars['String']['output']>;
  /** Wide lockup for dark backgrounds (site dark mode). Falls back to `logo`. */
  logoOnDark?: Maybe<Scalars['String']['output']>;
  logoOnDarkCid?: Maybe<Scalars['String']['output']>;
  /** Wide lockup for light backgrounds (site light mode). Falls back to `logo`. */
  logoOnLight?: Maybe<Scalars['String']['output']>;
  logoOnLightCid?: Maybe<Scalars['String']['output']>;
  /** Square logo mark URL (avatars, tiles, email header). `logo` is the wide lockup. */
  logoSquare?: Maybe<Scalars['String']['output']>;
  logoSquareCid?: Maybe<Scalars['String']['output']>;
  penName?: Maybe<Scalars['String']['output']>;
  primaryColor?: Maybe<Scalars['String']['output']>;
  /** Hover shade of primaryColor. Unset → the frontend derives one. */
  primaryColorHover?: Maybe<Scalars['String']['output']>;
  profilePhoto?: Maybe<Scalars['String']['output']>;
  profilePhotoCid?: Maybe<Scalars['String']['output']>;
  profilePhotoSize?: Maybe<Scalars['Int']['output']>;
  secondaryColor?: Maybe<Scalars['String']['output']>;
  /** Hover shade of secondaryColor. Unset → the frontend derives one. */
  secondaryColorHover?: Maybe<Scalars['String']['output']>;
  signatureImage?: Maybe<Scalars['String']['output']>;
  signatureImageCid?: Maybe<Scalars['String']['output']>;
  siteName: Scalars['String']['output'];
  socialIconStyle?: Maybe<SocialIconStyle>;
  socialLinks?: Maybe<TenantSocialLinks>;
  tagline?: Maybe<Scalars['String']['output']>;
};

/** Which tenant-branding image slot an upload targets */
export enum TenantBrandingImageField {
  Banner = 'BANNER',
  Favicon = 'FAVICON',
  Logo = 'LOGO',
  LogoOnDark = 'LOGO_ON_DARK',
  LogoOnLight = 'LOGO_ON_LIGHT',
  LogoSquare = 'LOGO_SQUARE',
  Profile = 'PROFILE',
  Signature = 'SIGNATURE'
}

export type TenantBrandingInput = {
  accentColor?: InputMaybe<Scalars['String']['input']>;
  aiAssistantName?: InputMaybe<Scalars['String']['input']>;
  backgroundMain?: InputMaybe<Scalars['String']['input']>;
  bannerImage?: InputMaybe<Scalars['String']['input']>;
  bannerImageCid?: InputMaybe<Scalars['String']['input']>;
  colorMode?: InputMaybe<TenantColorMode>;
  ctaButtonStyle?: InputMaybe<CtaButtonStyle>;
  ctaButtonText?: InputMaybe<Scalars['String']['input']>;
  ctaButtonUrl?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  emailFont?: InputMaybe<EmailFont>;
  emailFooterText?: InputMaybe<Scalars['String']['input']>;
  emailLetterhead?: InputMaybe<Scalars['Boolean']['input']>;
  emailStyle?: InputMaybe<EmailStyle>;
  favicon?: InputMaybe<Scalars['String']['input']>;
  faviconCid?: InputMaybe<Scalars['String']['input']>;
  fontBody?: InputMaybe<Scalars['String']['input']>;
  fontHeading?: InputMaybe<Scalars['String']['input']>;
  hideSiteName?: InputMaybe<Scalars['Boolean']['input']>;
  hideTagline?: InputMaybe<Scalars['Boolean']['input']>;
  logo?: InputMaybe<Scalars['String']['input']>;
  logoCid?: InputMaybe<Scalars['String']['input']>;
  logoGlyph?: InputMaybe<Scalars['String']['input']>;
  logoOnDark?: InputMaybe<Scalars['String']['input']>;
  logoOnDarkCid?: InputMaybe<Scalars['String']['input']>;
  logoOnLight?: InputMaybe<Scalars['String']['input']>;
  logoOnLightCid?: InputMaybe<Scalars['String']['input']>;
  logoSquare?: InputMaybe<Scalars['String']['input']>;
  logoSquareCid?: InputMaybe<Scalars['String']['input']>;
  penName?: InputMaybe<Scalars['String']['input']>;
  primaryColor?: InputMaybe<Scalars['String']['input']>;
  primaryColorHover?: InputMaybe<Scalars['String']['input']>;
  profilePhoto?: InputMaybe<Scalars['String']['input']>;
  profilePhotoCid?: InputMaybe<Scalars['String']['input']>;
  profilePhotoSize?: InputMaybe<Scalars['Int']['input']>;
  secondaryColor?: InputMaybe<Scalars['String']['input']>;
  secondaryColorHover?: InputMaybe<Scalars['String']['input']>;
  signatureImage?: InputMaybe<Scalars['String']['input']>;
  signatureImageCid?: InputMaybe<Scalars['String']['input']>;
  siteName: Scalars['String']['input'];
  socialIconStyle?: InputMaybe<SocialIconStyle>;
  socialLinks?: InputMaybe<TenantSocialLinksInput>;
  tagline?: InputMaybe<Scalars['String']['input']>;
};

/** Default colour mode for the tenant site (viewer preference still wins) */
export enum TenantColorMode {
  Dark = 'DARK',
  Light = 'LIGHT'
}

export type TenantCompanyDetails = {
  __typename?: 'TenantCompanyDetails';
  billingAddress?: Maybe<TenantAddress>;
  billingEmail?: Maybe<Scalars['String']['output']>;
  billingPhone?: Maybe<Scalars['String']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  invoicePreferences?: Maybe<TenantInvoicePreferences>;
  taxId?: Maybe<Scalars['String']['output']>;
  taxPercentage?: Maybe<Scalars['Float']['output']>;
};

export type TenantCompanyDetailsInput = {
  billingAddress?: InputMaybe<TenantAddressInput>;
  billingEmail?: InputMaybe<Scalars['String']['input']>;
  billingPhone?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  invoicePreferences?: InputMaybe<TenantInvoicePreferencesInput>;
  taxId?: InputMaybe<Scalars['String']['input']>;
  taxPercentage?: InputMaybe<Scalars['Float']['input']>;
};

export type TenantCsvExportResult = {
  __typename?: 'TenantCsvExportResult';
  /** CSV body (RFC 4180, CRLF). Hand to a FE Blob download. */
  csv: Scalars['String']['output'];
  /** <tenantShort>-<key>-<YYYYMMDD>.csv */
  filename: Scalars['String']['output'];
  key: Scalars['String']['output'];
  /** Data rows in the CSV (excludes header). */
  rowCount: Scalars['Int']['output'];
};

export type TenantDataExportEntry = {
  __typename?: 'TenantDataExportEntry';
  description?: Maybe<Scalars['String']['output']>;
  /** Exporter key, e.g. "clients.clients". Pass to exportTenantModuleCsv. */
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  /** Owning module id (matches moduleRegistry / permissions moduleId). */
  moduleId: Scalars['String']['output'];
  /** Module display name from the module registry (falls back to moduleId). */
  moduleName: Scalars['String']['output'];
  /** Rows the CSV will contain for this tenant right now (excludes the header row). */
  rowCount: Scalars['Int']['output'];
};

export type TenantDataExportManifest = {
  __typename?: 'TenantDataExportManifest';
  exporters: Array<TenantDataExportEntry>;
  /** When this manifest was computed (UTC). */
  generatedAt: Scalars['DateTime']['output'];
  /** Registered platform modules (moduleRegistry ids) that have NO exporter yet. Honest gap list — shown to the user as "not yet exportable". */
  notYetExportable: Array<Scalars['String']['output']>;
};

export type TenantEmailConfig = {
  __typename?: 'TenantEmailConfig';
  emailDomain?: Maybe<Scalars['String']['output']>;
  fromEmail: Scalars['String']['output'];
  fromName: Scalars['String']['output'];
  replyToEmail?: Maybe<Scalars['String']['output']>;
};

export type TenantEmailConfigInput = {
  emailDomain?: InputMaybe<Scalars['String']['input']>;
  fromEmail: Scalars['String']['input'];
  fromName: Scalars['String']['input'];
  replyToEmail?: InputMaybe<Scalars['String']['input']>;
};

export type TenantEmailSetupResult = {
  __typename?: 'TenantEmailSetupResult';
  dkimHost?: Maybe<Scalars['String']['output']>;
  dkimValue?: Maybe<Scalars['String']['output']>;
  domain?: Maybe<Scalars['String']['output']>;
  domainVerified?: Maybe<Scalars['Boolean']['output']>;
  inboundAddress?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
  returnPathHost?: Maybe<Scalars['String']['output']>;
  returnPathValue?: Maybe<Scalars['String']['output']>;
  serverId?: Maybe<Scalars['Float']['output']>;
  serverName?: Maybe<Scalars['String']['output']>;
  steps: Array<TenantEmailSetupStep>;
  suggestedFromEmail?: Maybe<Scalars['String']['output']>;
  summary: Scalars['String']['output'];
  tenantId: Scalars['ID']['output'];
  tenantName?: Maybe<Scalars['String']['output']>;
};

export type TenantEmailSetupStep = {
  __typename?: 'TenantEmailSetupStep';
  detail: Scalars['String']['output'];
  needs?: Maybe<Scalars['String']['output']>;
  state: TenantEmailStepState;
  step: Scalars['String']['output'];
};

/** What happened to one step of the email setup */
export enum TenantEmailStepState {
  Did = 'DID',
  Failed = 'FAILED',
  Needs = 'NEEDS',
  Ok = 'OK'
}

export type TenantGrowthSummary = {
  __typename?: 'TenantGrowthSummary';
  activeOpportunities: Scalars['Int']['output'];
  communicationsSentThisWeek: Scalars['Int']['output'];
  communicationsSentToday: Scalars['Int']['output'];
  lastRunDate?: Maybe<Scalars['DateTime']['output']>;
  lastRunStatus?: Maybe<Scalars['String']['output']>;
  overdueTasks: Scalars['Int']['output'];
  pipelineValue: Scalars['Float']['output'];
  staleDeals: Scalars['Int']['output'];
  tenantId: Scalars['String']['output'];
  tenantName: Scalars['String']['output'];
};

export type TenantHosting = {
  __typename?: 'TenantHosting';
  deployVerifyDisabled?: Maybe<Scalars['Boolean']['output']>;
  vercelProjectId?: Maybe<Scalars['String']['output']>;
  vercelTeamId?: Maybe<Scalars['String']['output']>;
};

export type TenantHostingInput = {
  deployVerifyDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  vercelProjectId?: InputMaybe<Scalars['String']['input']>;
  vercelTeamId?: InputMaybe<Scalars['String']['input']>;
};

export type TenantInput = {
  acmaRegistration?: InputMaybe<AcmaRegistrationInput>;
  alphaId?: InputMaybe<Scalars['String']['input']>;
  apiKeys?: InputMaybe<TenantApiKeysInput>;
  authConfig?: InputMaybe<TenantAuthConfigInput>;
  branding?: InputMaybe<TenantBrandingInput>;
  clientId: Scalars['ID']['input'];
  companyDetails?: InputMaybe<TenantCompanyDetailsInput>;
  curatedEmployeePermissions?: InputMaybe<Array<Scalars['String']['input']>>;
  dedicatedNumber?: InputMaybe<Scalars['String']['input']>;
  deploymentUrl?: InputMaybe<Scalars['String']['input']>;
  domain?: InputMaybe<Scalars['String']['input']>;
  emailConfig?: InputMaybe<TenantEmailConfigInput>;
  githubOwner?: InputMaybe<Scalars['String']['input']>;
  githubRepo?: InputMaybe<Scalars['String']['input']>;
  githubToken?: InputMaybe<Scalars['String']['input']>;
  hosting?: InputMaybe<TenantHostingInput>;
  mainBranch?: InputMaybe<Scalars['String']['input']>;
  meetConfig?: InputMaybe<TenantMeetConfigInput>;
  moduleConfig?: InputMaybe<Array<TenantModuleConfigInput>>;
  name: Scalars['String']['input'];
  notificationSettings?: InputMaybe<TenantNotificationSettingsInput>;
  paymentReceivingDetails?: InputMaybe<PaymentReceivingDetailsInput>;
  recruitmentPartners?: InputMaybe<Array<TenantRecruitmentPartnerInput>>;
  skipGithubRepo?: InputMaybe<Scalars['Boolean']['input']>;
  smsConfig?: InputMaybe<TenantSmsConfigInput>;
  subscriptionTier?: Scalars['String']['input'];
  useAlphaId?: InputMaybe<Scalars['Boolean']['input']>;
  websiteUrl?: InputMaybe<Scalars['String']['input']>;
};

export type TenantInvoicePreferences = {
  __typename?: 'TenantInvoicePreferences';
  autoPayEnabled: Scalars['Boolean']['output'];
  emailInvoices: Scalars['Boolean']['output'];
  invoiceLanguage: Scalars['String']['output'];
  taxIncluded: Scalars['Boolean']['output'];
};

export type TenantInvoicePreferencesInput = {
  autoPayEnabled: Scalars['Boolean']['input'];
  emailInvoices: Scalars['Boolean']['input'];
  invoiceLanguage: Scalars['String']['input'];
  taxIncluded: Scalars['Boolean']['input'];
};

export type TenantIpfsGatewayTestResult = {
  __typename?: 'TenantIpfsGatewayTestResult';
  error?: Maybe<Scalars['String']['output']>;
  latencyMs?: Maybe<Scalars['Float']['output']>;
  ok: Scalars['Boolean']['output'];
  statusCode?: Maybe<Scalars['Float']['output']>;
  testedUrl: Scalars['String']['output'];
};

export type TenantIpfsHealth = {
  __typename?: 'TenantIpfsHealth';
  cnameAtVercel: Scalars['Boolean']['output'];
  cnameValue?: Maybe<Scalars['String']['output']>;
  currentGatewayUrl?: Maybe<Scalars['String']['output']>;
  domain: Scalars['String']['output'];
  healthError?: Maybe<Scalars['String']['output']>;
  hostnameReachable: Scalars['Boolean']['output'];
  tenantRecordPointsAtBrandedHost: Scalars['Boolean']['output'];
};

export type TenantLocalAiStatus = {
  __typename?: 'TenantLocalAiStatus';
  baseUrl?: Maybe<Scalars['String']['output']>;
  defaultModel?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  models: Array<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
  source: Scalars['String']['output'];
};

export type TenantMeetConfig = {
  __typename?: 'TenantMeetConfig';
  defaultReminderMinutes?: Maybe<Scalars['Int']['output']>;
  liveKitRoomPrefix?: Maybe<Scalars['String']['output']>;
  recordingConsentText?: Maybe<Scalars['String']['output']>;
  recordingDefaultOn?: Maybe<Scalars['Boolean']['output']>;
};

export type TenantMeetConfigInput = {
  defaultReminderMinutes?: InputMaybe<Scalars['Int']['input']>;
  liveKitRoomPrefix?: InputMaybe<Scalars['String']['input']>;
  recordingConsentText?: InputMaybe<Scalars['String']['input']>;
  recordingDefaultOn?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TenantModuleConfig = {
  __typename?: 'TenantModuleConfig';
  customConfig?: Maybe<Scalars['String']['output']>;
  enabled: Scalars['Boolean']['output'];
  enabledAt?: Maybe<Scalars['DateTime']['output']>;
  moduleId: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export type TenantModuleConfigInput = {
  customConfig?: InputMaybe<Scalars['String']['input']>;
  enabled: Scalars['Boolean']['input'];
  enabledAt?: InputMaybe<Scalars['DateTime']['input']>;
  moduleId: Scalars['String']['input'];
  version: Scalars['String']['input'];
};

export type TenantNotificationSettings = {
  __typename?: 'TenantNotificationSettings';
  notifyOnCardSaved: Scalars['Boolean']['output'];
  notifyOnCardSavedEmail: Scalars['Boolean']['output'];
  notifyOnCardSavedSms: Scalars['Boolean']['output'];
  notifyOnModuleUpgrade: Scalars['Boolean']['output'];
  notifyOnSmsLogin: Scalars['Boolean']['output'];
  notifyOnSmsLoginEmail: Scalars['Boolean']['output'];
};

export type TenantNotificationSettingsInput = {
  notifyOnCardSaved?: InputMaybe<Scalars['Boolean']['input']>;
  notifyOnCardSavedEmail?: InputMaybe<Scalars['Boolean']['input']>;
  notifyOnCardSavedSms?: InputMaybe<Scalars['Boolean']['input']>;
  notifyOnModuleUpgrade?: InputMaybe<Scalars['Boolean']['input']>;
  notifyOnSmsLogin?: InputMaybe<Scalars['Boolean']['input']>;
  notifyOnSmsLoginEmail?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TenantRecruitmentPartner = {
  __typename?: 'TenantRecruitmentPartner';
  /** false = partnership paused; every further write from that partner is refused immediately. */
  active: Scalars['Boolean']['output'];
  addedAt?: Maybe<Scalars['DateTime']['output']>;
  addedById?: Maybe<Scalars['String']['output']>;
  addedByName?: Maybe<Scalars['String']['output']>;
  partnerName?: Maybe<Scalars['String']['output']>;
  /** Tenant id of the recruiting partner that may put candidates forward to this tenant. */
  partnerTenantId: Scalars['String']['output'];
};

export type TenantRecruitmentPartnerInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  addedAt?: InputMaybe<Scalars['DateTime']['input']>;
  addedById?: InputMaybe<Scalars['String']['input']>;
  addedByName?: InputMaybe<Scalars['String']['input']>;
  partnerName?: InputMaybe<Scalars['String']['input']>;
  partnerTenantId: Scalars['String']['input'];
};

export type TenantSecuritySettings = {
  __typename?: 'TenantSecuritySettings';
  requireTwoFactorForSensitiveData: Scalars['Boolean']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedById?: Maybe<Scalars['String']['output']>;
  updatedByName?: Maybe<Scalars['String']['output']>;
};

export type TenantSmsConfig = {
  __typename?: 'TenantSmsConfig';
  defaultList: Array<Scalars['String']['output']>;
  defaultTags: Array<Scalars['String']['output']>;
};

export type TenantSmsConfigInput = {
  defaultList: Array<Scalars['String']['input']>;
  defaultTags: Array<Scalars['String']['input']>;
};

export type TenantSocialLinks = {
  __typename?: 'TenantSocialLinks';
  facebook?: Maybe<Scalars['String']['output']>;
  instagram?: Maybe<Scalars['String']['output']>;
  linkedin?: Maybe<Scalars['String']['output']>;
  twitter?: Maybe<Scalars['String']['output']>;
  website?: Maybe<Scalars['String']['output']>;
  youtube?: Maybe<Scalars['String']['output']>;
};

export type TenantSocialLinksInput = {
  facebook?: InputMaybe<Scalars['String']['input']>;
  instagram?: InputMaybe<Scalars['String']['input']>;
  linkedin?: InputMaybe<Scalars['String']['input']>;
  twitter?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
  youtube?: InputMaybe<Scalars['String']['input']>;
};

/** The status of the tenant */
export enum TenantStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  Suspended = 'SUSPENDED',
  Trial = 'TRIAL'
}

export type TenantStorageStats = {
  __typename?: 'TenantStorageStats';
  droneFileBytes: Scalars['Float']['output'];
  droneFileCount: Scalars['Float']['output'];
  mediaItemBytes: Scalars['Float']['output'];
  mediaItemCount: Scalars['Float']['output'];
  tenantId: Scalars['String']['output'];
  tenantName: Scalars['String']['output'];
  totalBytes: Scalars['Float']['output'];
  totalFiles: Scalars['Float']['output'];
};

export type TenantTwoFactorAdoption = {
  __typename?: 'TenantTwoFactorAdoption';
  /** Sign-in accounts on this site holding EMPLOYEE, not blocked from signing in. */
  staffTotal: Scalars['Int']['output'];
  /** Of those, how many have two-step verification turned on. */
  staffWithTwoFactor: Scalars['Int']['output'];
};

export type TenantUpgradeStatus = {
  __typename?: 'TenantUpgradeStatus';
  appliedBy?: Maybe<Scalars['String']['output']>;
  appliedDate?: Maybe<Scalars['DateTime']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  status: UpgradeStatus;
  tenantId: Scalars['ID']['output'];
  tenantName: Scalars['String']['output'];
};

export type TenantUpgradeStatusInput = {
  appliedBy?: InputMaybe<Scalars['String']['input']>;
  appliedDate?: InputMaybe<Scalars['DateTime']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  status: UpgradeStatus;
  tenantId: Scalars['ID']['input'];
  tenantName: Scalars['String']['input'];
};

/** Testing tier classification for module test items */
export enum TestTier {
  EdgeCase = 'EDGE_CASE',
  Smoke = 'SMOKE',
  Workflow = 'WORKFLOW'
}

export type ThumbnailResult = {
  __typename?: 'ThumbnailResult';
  thumbnailUrl: Scalars['String']['output'];
};

export type TimeEntry = {
  __typename?: 'TimeEntry';
  amount: Scalars['Float']['output'];
  description: Scalars['String']['output'];
  hours: Scalars['Float']['output'];
  rate: Scalars['Float']['output'];
};

export type TimeEntryInput = {
  amount: Scalars['Float']['input'];
  description: Scalars['String']['input'];
  hours: Scalars['Float']['input'];
  rate: Scalars['Float']['input'];
};

export type TimeSeriesPoint = {
  __typename?: 'TimeSeriesPoint';
  date: Scalars['String']['output'];
  pageViews: Scalars['Int']['output'];
  sessions: Scalars['Int']['output'];
  visitors: Scalars['Int']['output'];
};

export type TimeWindow = {
  __typename?: 'TimeWindow';
  description?: Maybe<Scalars['String']['output']>;
  endTime: Scalars['String']['output'];
  startTime: Scalars['String']['output'];
};

export type TimeWindowInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  endTime: Scalars['String']['input'];
  startTime: Scalars['String']['input'];
};

export type TimesheetEntity = {
  __typename?: 'TimesheetEntity';
  complianceResults?: Maybe<ComplianceResults>;
  createdAt: Scalars['DateTime']['output'];
  digitizedData?: Maybe<DigitizedData>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  fileType?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  ipfsHash?: Maybe<Scalars['String']['output']>;
  ipfsUrl?: Maybe<Scalars['String']['output']>;
  matterId: Scalars['String']['output'];
  originalFileName?: Maybe<Scalars['String']['output']>;
  status: TimesheetStatus;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  uploadedAt: Scalars['DateTime']['output'];
  uploadedBy?: Maybe<Client>;
};

/** Status of timesheet analysis */
export enum TimesheetStatus {
  Analyzing = 'ANALYZING',
  Compliant = 'COMPLIANT',
  Digitized = 'DIGITIZED',
  Digitizing = 'DIGITIZING',
  Error = 'ERROR',
  Overpaid = 'OVERPAID',
  Underpaid = 'UNDERPAID',
  Uploaded = 'UPLOADED'
}

export type ToggleCommunityLikeInput = {
  targetId: Scalars['ID']['input'];
  targetType: CommunityReactionTarget;
};

export type TokenEconomicsReport = {
  __typename?: 'TokenEconomicsReport';
  breakageRate: Scalars['Float']['output'];
  issuedThisMonth: Scalars['Int']['output'];
  redeemedThisMonth: Scalars['Int']['output'];
  redeemedThisMonthValue: Scalars['Float']['output'];
  tokenLiability: Scalars['Float']['output'];
  totalActive: Scalars['Int']['output'];
  totalCancelled: Scalars['Int']['output'];
  totalExpired: Scalars['Int']['output'];
  totalExpiredValue: Scalars['Float']['output'];
  totalIssued: Scalars['Int']['output'];
  totalRedeemed: Scalars['Int']['output'];
  totalRedeemedValue: Scalars['Float']['output'];
};

export type TokenRedemptionResult = {
  __typename?: 'TokenRedemptionResult';
  billRemainingAmount?: Maybe<Scalars['Float']['output']>;
  message: Scalars['String']['output'];
  remainingBalance?: Maybe<Scalars['Float']['output']>;
  success: Scalars['Boolean']['output'];
  tokenValueApplied?: Maybe<Scalars['Float']['output']>;
  tokensRedeemed?: Maybe<Scalars['Int']['output']>;
};

export type TomActionResult = {
  __typename?: 'TomActionResult';
  actionId: Scalars['String']['output'];
  error?: Maybe<Scalars['String']['output']>;
  resultId?: Maybe<Scalars['String']['output']>;
  resultSummary?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
};

export type TomAttachment = {
  __typename?: 'TomAttachment';
  fileId?: Maybe<Scalars['String']['output']>;
  mimeType: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type TomAttachmentInput = {
  fileId?: InputMaybe<Scalars['String']['input']>;
  mimeType: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export type TomAuditLog = {
  __typename?: 'TomAuditLog';
  actionType: Scalars['String']['output'];
  conversationId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  error?: Maybe<Scalars['String']['output']>;
  executedAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  inputData: Scalars['JSON']['output'];
  messageId: Scalars['String']['output'];
  resultData?: Maybe<Scalars['JSON']['output']>;
  status: Scalars['String']['output'];
  targetEntityId?: Maybe<Scalars['String']['output']>;
  targetModule: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  userId: Scalars['String']['output'];
};

export type TomConversation = {
  __typename?: 'TomConversation';
  createdAt: Scalars['DateTime']['output'];
  entityContext?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastMessageAt?: Maybe<Scalars['DateTime']['output']>;
  messageCount: Scalars['Float']['output'];
  moduleContext: Scalars['String']['output'];
  status: TomConversationStatus;
  tenantId: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  userId: Scalars['String']['output'];
};

/** Status of a Tom conversation */
export enum TomConversationStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED'
}

export type TomConversationWithMessages = {
  __typename?: 'TomConversationWithMessages';
  conversation: TomConversation;
  messages: Array<TomMessage>;
};

/** User feedback on AI response helpfulness */
export enum TomFeedback {
  Helpful = 'HELPFUL',
  NotHelpful = 'NOT_HELPFUL'
}

export type TomInteractionLog = {
  __typename?: 'TomInteractionLog';
  actionsConfirmed: Scalars['Int']['output'];
  actionsRefined: Scalars['Int']['output'];
  actionsRejected: Scalars['Int']['output'];
  claudeModel: Scalars['String']['output'];
  claudeResponse: Scalars['JSON']['output'];
  claudeSystemPrompt: Scalars['String']['output'];
  claudeToolCalls?: Maybe<Array<Scalars['JSON']['output']>>;
  claudeToolResults?: Maybe<Array<Scalars['JSON']['output']>>;
  claudeToolsProvided: Array<Scalars['String']['output']>;
  conversationId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  entityContext?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  inputTokens: Scalars['Int']['output'];
  latencyMs: Scalars['Int']['output'];
  moduleContext: Scalars['String']['output'];
  outputTokens: Scalars['Int']['output'];
  pendingActionsGenerated: Scalars['Int']['output'];
  refinementFeedback?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  userFeedback?: Maybe<TomFeedback>;
  userId: Scalars['String']['output'];
  userMessage: Scalars['String']['output'];
};

export type TomMessage = {
  __typename?: 'TomMessage';
  attachments?: Maybe<Array<TomAttachment>>;
  content: Scalars['String']['output'];
  conversationId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  imageUrls?: Maybe<Array<Scalars['String']['output']>>;
  pendingActions?: Maybe<Array<TomPendingAction>>;
  role: TomMessageRole;
  tenantId: Scalars['String']['output'];
  toolCalls?: Maybe<Array<TomToolCall>>;
  updatedAt: Scalars['DateTime']['output'];
};

export type TomMessageResponse = {
  __typename?: 'TomMessageResponse';
  message: TomMessage;
};

/** Role of the message sender */
export enum TomMessageRole {
  Assistant = 'ASSISTANT',
  System = 'SYSTEM',
  User = 'USER'
}

export type TomPageContextInput = {
  additionalContext?: InputMaybe<Scalars['String']['input']>;
  assistantName?: InputMaybe<Scalars['String']['input']>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<Scalars['String']['input']>;
  module: Scalars['String']['input'];
  pageDataSummary?: InputMaybe<Scalars['String']['input']>;
  path: Scalars['String']['input'];
  selectedIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type TomPendingAction = {
  __typename?: 'TomPendingAction';
  actionType: Scalars['String']['output'];
  error?: Maybe<Scalars['String']['output']>;
  executedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  preview: Scalars['JSON']['output'];
  resultId?: Maybe<Scalars['String']['output']>;
  resultSummary?: Maybe<Scalars['String']['output']>;
  status: TomPendingActionStatus;
  summary: Scalars['String']['output'];
};

/** Status of a pending action */
export enum TomPendingActionStatus {
  Confirmed = 'CONFIRMED',
  Executed = 'EXECUTED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export type TomSettings = {
  __typename?: 'TomSettings';
  autoSuggestTasks: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  customSystemPrompt?: Maybe<Scalars['String']['output']>;
  enabledModules: Array<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isEnabled: Scalars['Boolean']['output'];
  maxConversationHistory: Scalars['Float']['output'];
  model: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type TomToolCall = {
  __typename?: 'TomToolCall';
  status: TomToolCallStatus;
  toolCallId: Scalars['String']['output'];
  toolInput?: Maybe<Scalars['JSON']['output']>;
  toolName: Scalars['String']['output'];
  toolResult?: Maybe<Scalars['JSON']['output']>;
};

/** Status of a tool call */
export enum TomToolCallStatus {
  Executed = 'EXECUTED',
  Failed = 'FAILED',
  Pending = 'PENDING'
}

export type TopPage = {
  __typename?: 'TopPage';
  avgScrollDepth: Scalars['Float']['output'];
  avgTimeOnPage: Scalars['Float']['output'];
  bounceRate: Scalars['Float']['output'];
  pagePath: Scalars['String']['output'];
  pageTitle?: Maybe<Scalars['String']['output']>;
  uniqueVisitors: Scalars['Int']['output'];
  views: Scalars['Int']['output'];
};

export type TrackEventInput = {
  browser?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  deviceType?: InputMaybe<Scalars['String']['input']>;
  eventName: Scalars['String']['input'];
  label?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['String']['input']>;
  pagePath: Scalars['String']['input'];
  pageTitle?: InputMaybe<Scalars['String']['input']>;
  sessionId: Scalars['String']['input'];
  userId?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['Float']['input']>;
  visitorId: Scalars['String']['input'];
};

export type TrackPageViewInput = {
  doNotTrack?: InputMaybe<Scalars['Boolean']['input']>;
  pagePath: Scalars['String']['input'];
  pageTitle?: InputMaybe<Scalars['String']['input']>;
  referrer?: InputMaybe<Scalars['String']['input']>;
  screenHeight?: InputMaybe<Scalars['Int']['input']>;
  screenWidth?: InputMaybe<Scalars['Int']['input']>;
  sessionId: Scalars['String']['input'];
  userAgent?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
  utmCampaign?: InputMaybe<Scalars['String']['input']>;
  utmContent?: InputMaybe<Scalars['String']['input']>;
  utmMedium?: InputMaybe<Scalars['String']['input']>;
  utmSource?: InputMaybe<Scalars['String']['input']>;
  utmTerm?: InputMaybe<Scalars['String']['input']>;
  visitorId: Scalars['String']['input'];
};

export type TrackedCompetition = {
  __typename?: 'TrackedCompetition';
  announceDate?: Maybe<Scalars['DateTime']['output']>;
  closeDate?: Maybe<Scalars['DateTime']['output']>;
  copyableMechanic?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  datesConfirmed: Scalars['Boolean']['output'];
  eligibility?: Maybe<Scalars['String']['output']>;
  entryImageCid?: Maybe<Scalars['String']['output']>;
  fee?: Maybe<Scalars['String']['output']>;
  fit?: Maybe<Scalars['String']['output']>;
  fitReason?: Maybe<Scalars['String']['output']>;
  howToEnter?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  medium?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  openDate?: Maybe<Scalars['DateTime']['output']>;
  organiser?: Maybe<Scalars['String']['output']>;
  prize?: Maybe<Scalars['String']['output']>;
  researchNotes?: Maybe<Scalars['String']['output']>;
  status: TrackedCompetitionStatus;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type TrackedCompetitionImportResult = {
  __typename?: 'TrackedCompetitionImportResult';
  created: Scalars['Int']['output'];
  errors: Array<Scalars['String']['output']>;
  skipped: Scalars['Int']['output'];
  updated: Scalars['Int']['output'];
};

export type TrackedCompetitionInput = {
  announceDate?: InputMaybe<Scalars['DateTime']['input']>;
  closeDate?: InputMaybe<Scalars['DateTime']['input']>;
  copyableMechanic?: InputMaybe<Scalars['String']['input']>;
  datesConfirmed?: InputMaybe<Scalars['Boolean']['input']>;
  eligibility?: InputMaybe<Scalars['String']['input']>;
  entryImageCid?: InputMaybe<Scalars['String']['input']>;
  fee?: InputMaybe<Scalars['String']['input']>;
  fit?: InputMaybe<Scalars['String']['input']>;
  fitReason?: InputMaybe<Scalars['String']['input']>;
  howToEnter?: InputMaybe<Scalars['String']['input']>;
  medium?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  openDate?: InputMaybe<Scalars['DateTime']['input']>;
  organiser?: InputMaybe<Scalars['String']['input']>;
  prize?: InputMaybe<Scalars['String']['input']>;
  researchNotes?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<TrackedCompetitionStatus>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/** Where Anna is up to with someone else's competition */
export enum TrackedCompetitionStatus {
  Entered = 'ENTERED',
  Idea = 'IDEA',
  NotSelected = 'NOT_SELECTED',
  Planning = 'PLANNING',
  Shortlisted = 'SHORTLISTED',
  Won = 'WON'
}

export type TradeRoute = {
  __typename?: 'TradeRoute';
  color?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  destinationAgentId?: Maybe<Scalars['String']['output']>;
  fuelTypes: Array<FuelType>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  riskLevel: RiskLevel;
  routeType: RouteType;
  sourceAgentId?: Maybe<Scalars['String']['output']>;
  status: RouteStatus;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  volumePerDay?: Maybe<Scalars['Float']['output']>;
  volumeUnit?: Maybe<Scalars['String']['output']>;
  waypoints: Array<GeoPoint>;
};

export type TradeRouteFiltersInput = {
  fuelTypes?: InputMaybe<Array<FuelType>>;
  routeType?: InputMaybe<RouteType>;
  status?: InputMaybe<RouteStatus>;
};

export type TrafficSourceStats = {
  __typename?: 'TrafficSourceStats';
  avgSessionDuration: Scalars['Float']['output'];
  bounceRate: Scalars['Float']['output'];
  pageViews: Scalars['Int']['output'];
  percentage: Scalars['Float']['output'];
  sessions: Scalars['Int']['output'];
  source: Scalars['String']['output'];
};

export type TransactionCoding = {
  __typename?: 'TransactionCoding';
  codedAt?: Maybe<Scalars['DateTime']['output']>;
  codedByClientId?: Maybe<Scalars['ID']['output']>;
  codedByName?: Maybe<Scalars['String']['output']>;
  gstCents: Scalars['Int']['output'];
  ledgerAccountId?: Maybe<Scalars['ID']['output']>;
  residentId?: Maybe<Scalars['ID']['output']>;
  status: AccountingCodingStatus;
  suggestedBy?: Maybe<AccountingSuggestedBy>;
  suggestedRuleId?: Maybe<Scalars['ID']['output']>;
};

export type TransactionFilters = {
  direction?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
};

export type TranscribeYouTubeVideoInput = {
  maxHeight?: InputMaybe<Scalars['Int']['input']>;
  videoUrl: Scalars['String']['input'];
};

export type TranscriptMinerStats = {
  __typename?: 'TranscriptMinerStats';
  archived: Scalars['Int']['output'];
  downloading: Scalars['Int']['output'];
  failed: Scalars['Int']['output'];
  lastActivityAt?: Maybe<Scalars['DateTime']['output']>;
  queued: Scalars['Int']['output'];
  staleDownloadMs: Scalars['Float']['output'];
  staleTranscribeMs: Scalars['Float']['output'];
  totalBytes: Scalars['Float']['output'];
  totalVideos: Scalars['Int']['output'];
  transcribed: Scalars['Int']['output'];
  transcribing: Scalars['Int']['output'];
};

/** Video transcription status */
export enum TranscriptStatus {
  Done = 'DONE',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Skipped = 'SKIPPED',
  Transcribing = 'TRANSCRIBING'
}

export type Transcription = {
  __typename?: 'Transcription';
  audioCid?: Maybe<Scalars['String']['output']>;
  audioIpfsHash?: Maybe<Scalars['String']['output']>;
  audioUrl?: Maybe<Scalars['String']['output']>;
  clientId?: Maybe<Scalars['String']['output']>;
  commentCount: Scalars['Int']['output'];
  confidence?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  detectedLanguage?: Maybe<Scalars['String']['output']>;
  diarizedSegments?: Maybe<Array<TranscriptionDiarizedSegment>>;
  duration?: Maybe<Scalars['Float']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  fileName?: Maybe<Scalars['String']['output']>;
  fileSize?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  meetingDate?: Maybe<Scalars['DateTime']['output']>;
  meetingRoomName?: Maybe<Scalars['String']['output']>;
  modelUsed?: Maybe<Scalars['String']['output']>;
  owner: Client;
  planClassification?: Maybe<Scalars['String']['output']>;
  planGeneratedAt?: Maybe<Scalars['DateTime']['output']>;
  planJson?: Maybe<Scalars['String']['output']>;
  processed: Scalars['Boolean']['output'];
  processingTime?: Maybe<Scalars['Float']['output']>;
  projectSlug?: Maybe<Scalars['String']['output']>;
  /** When the recording was made: meetingDate, else createdAt (upload time). */
  recordedAt: Scalars['DateTime']['output'];
  sourceMeetingId?: Maybe<Scalars['String']['output']>;
  speakers?: Maybe<Array<TranscriptionSpeaker>>;
  status: AudioTranscriptionStatus;
  summary?: Maybe<Scalars['String']['output']>;
  summaryGeneratedAt?: Maybe<Scalars['DateTime']['output']>;
  tenantId: Scalars['String']['output'];
  title: Scalars['String']['output'];
  transcription?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  vaultStem?: Maybe<Scalars['String']['output']>;
};

export type TranscriptionComment = {
  __typename?: 'TranscriptionComment';
  authorClientId: Scalars['ID']['output'];
  authorName: Scalars['String']['output'];
  body: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  tenantId: Scalars['String']['output'];
  transcriptionId: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type TranscriptionCommentInput = {
  body: Scalars['String']['input'];
  transcriptionId: Scalars['ID']['input'];
};

export type TranscriptionDiarizedSegment = {
  __typename?: 'TranscriptionDiarizedSegment';
  displayName?: Maybe<Scalars['String']['output']>;
  end?: Maybe<Scalars['Float']['output']>;
  speakerLabel?: Maybe<Scalars['String']['output']>;
  start?: Maybe<Scalars['Float']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type TranscriptionInput = {
  audioIpfsHash?: InputMaybe<Scalars['String']['input']>;
  audioUrl?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  fileName?: InputMaybe<Scalars['String']['input']>;
  fileSize?: InputMaybe<Scalars['Float']['input']>;
  owner: Scalars['ID']['input'];
  title: Scalars['String']['input'];
};

export type TranscriptionListInput = {
  /** Page size (default 20, max 100) */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Rows to skip (default 0) */
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** true = Done only, false = Not done only, omitted = all */
  processed?: InputMaybe<Scalars['Boolean']['input']>;
  /** Case-insensitive match on title, description, summary, speaker names */
  search?: InputMaybe<Scalars['String']['input']>;
};

export type TranscriptionModelsInfo = {
  __typename?: 'TranscriptionModelsInfo';
  available: Array<Scalars['String']['output']>;
  default: Scalars['String']['output'];
};

export type TranscriptionSpeaker = {
  __typename?: 'TranscriptionSpeaker';
  displayName?: Maybe<Scalars['String']['output']>;
  localLabel: Scalars['String']['output'];
  signatureLabel?: Maybe<Scalars['String']['output']>;
  voiceSignatureId?: Maybe<Scalars['ID']['output']>;
};

export type TranscriptionSpeakerContact = {
  __typename?: 'TranscriptionSpeakerContact';
  canViewClient: Scalars['Boolean']['output'];
  canViewEmployee: Scalars['Boolean']['output'];
  clientId?: Maybe<Scalars['ID']['output']>;
  clientName?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  employeeId?: Maybe<Scalars['ID']['output']>;
  isEmployee: Scalars['Boolean']['output'];
  isRecord: Scalars['Boolean']['output'];
  localLabel: Scalars['String']['output'];
  personalEmail?: Maybe<Scalars['String']['output']>;
  personalPhone?: Maybe<Scalars['String']['output']>;
  voiceSignatureId?: Maybe<Scalars['ID']['output']>;
  workEmail?: Maybe<Scalars['String']['output']>;
  workPhone?: Maybe<Scalars['String']['output']>;
};

/** The status of the transcription */
export enum TranscriptionStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  NotRequested = 'NOT_REQUESTED',
  Pending = 'PENDING'
}

export type TranscriptionUpdateInput = {
  clientId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  meetingDate?: InputMaybe<Scalars['DateTime']['input']>;
  processed?: InputMaybe<Scalars['Boolean']['input']>;
  projectSlug?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<AudioTranscriptionStatus>;
  title?: InputMaybe<Scalars['String']['input']>;
  transcription?: InputMaybe<Scalars['String']['input']>;
  vaultStem?: InputMaybe<Scalars['String']['input']>;
};

export type TranscriptionUploadInput = {
  audioIpfsHash?: InputMaybe<Scalars['String']['input']>;
  audioUrl: Scalars['String']['input'];
  fileName?: InputMaybe<Scalars['String']['input']>;
  fileSize?: InputMaybe<Scalars['Float']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  transcriptionId: Scalars['ID']['input'];
};

/** Level of assistance required for transfers */
export enum TransferAssistance {
  Hoist = 'HOIST',
  Independent = 'INDEPENDENT',
  OnePerson = 'ONE_PERSON',
  TwoPerson = 'TWO_PERSON'
}

export type TransferPhoneNumberInput = {
  targetClientIds: Array<Scalars['ID']['input']>;
  targetTenantId: Scalars['ID']['input'];
};

export type TransferResidentInput = {
  effectiveDate?: InputMaybe<Scalars['DateTime']['input']>;
  newBedNumber?: InputMaybe<Scalars['String']['input']>;
  newRoomId?: InputMaybe<Scalars['ID']['input']>;
  newRoomNumber: Scalars['String']['input'];
  newWing?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
};

/** Type of transfer assistance required */
export enum TransferType {
  Independent = 'INDEPENDENT',
  MechanicalLift = 'MECHANICAL_LIFT',
  OnePersonAssist = 'ONE_PERSON_ASSIST',
  SitToStand = 'SIT_TO_STAND',
  SlideBoard = 'SLIDE_BOARD',
  StandbyAssist = 'STANDBY_ASSIST',
  TwoPersonAssist = 'TWO_PERSON_ASSIST'
}

export type TreatingDoctorDetails = {
  __typename?: 'TreatingDoctorDetails';
  address?: Maybe<Scalars['String']['output']>;
  /** Reference to doctor in system (if exists) */
  doctorId?: Maybe<Scalars['ID']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  fax?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  mobile?: Maybe<Scalars['String']['output']>;
  /** Full name of the doctor */
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  providerNumber?: Maybe<Scalars['String']['output']>;
  specialty?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type TreatingDoctorDetailsInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  doctorId?: InputMaybe<Scalars['ID']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  fax?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mobile?: InputMaybe<Scalars['String']['input']>;
  /** Full name of the doctor */
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  providerNumber?: InputMaybe<Scalars['String']['input']>;
  specialty?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type TriggerAutomationInput = {
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  sendCommunications?: InputMaybe<Scalars['Boolean']['input']>;
  targetOpportunityIds?: InputMaybe<Array<Scalars['String']['input']>>;
  tenantId: Scalars['String']['input'];
};

export type TrustActivity = {
  __typename?: 'TrustActivity';
  calendarEventId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  date: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  personId: Scalars['ID']['output'];
  sourceId: Scalars['String']['output'];
  sourceName?: Maybe<Scalars['String']['output']>;
  sourceUrl: Scalars['String']['output'];
  summary?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  title: Scalars['String']['output'];
  type: TrustActivityType;
  updatedAt: Scalars['DateTime']['output'];
};

/** What kind of public activity this is */
export enum TrustActivityType {
  CouncilMeeting = 'COUNCIL_MEETING',
  MediaRelease = 'MEDIA_RELEASE',
  MinisterialDiary = 'MINISTERIAL_DIARY',
  Other = 'OTHER',
  Question = 'QUESTION',
  Speech = 'SPEECH',
  Vote = 'VOTE'
}

/** Local, state or federal */
export enum TrustLevel {
  Federal = 'FEDERAL',
  Local = 'LOCAL',
  State = 'STATE'
}

export type TrustPerson = {
  __typename?: 'TrustPerson';
  active: Scalars['Boolean']['output'];
  calendarId?: Maybe<Scalars['String']['output']>;
  confirmed: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  electorate?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  kind: TrustPersonKind;
  level: TrustLevel;
  name: Scalars['String']['output'];
  party?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  sources?: Maybe<TrustPersonSources>;
  tenantId: Scalars['String']['output'];
  topics: Array<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  why?: Maybe<Scalars['String']['output']>;
};

/** What kind of person in public life this is */
export enum TrustPersonKind {
  Politician = 'POLITICIAN'
}

export type TrustPersonSources = {
  __typename?: 'TrustPersonSources';
  councilMeetingsUrl?: Maybe<Scalars['String']['output']>;
  openAustralia?: Maybe<Scalars['String']['output']>;
  parliamentMember?: Maybe<Scalars['String']['output']>;
};

export type TrustPersonSourcesInput = {
  councilMeetingsUrl?: InputMaybe<Scalars['String']['input']>;
  openAustralia?: InputMaybe<Scalars['String']['input']>;
  parliamentMember?: InputMaybe<Scalars['String']['input']>;
};

export type TwilioPhoneNumber = {
  __typename?: 'TwilioPhoneNumber';
  assignedAt?: Maybe<Scalars['DateTime']['output']>;
  assignedBy?: Maybe<Scalars['String']['output']>;
  associatedClients?: Maybe<Array<Scalars['String']['output']>>;
  autoTranscribe: Scalars['Boolean']['output'];
  capabilities: Array<PhoneCapability>;
  createdAt: Scalars['DateTime']['output'];
  currency: Scalars['String']['output'];
  forwardToNumber?: Maybe<Scalars['String']['output']>;
  friendlyName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isAssigned: Scalars['Boolean']['output'];
  isoCountry?: Maybe<Scalars['String']['output']>;
  lastUsedAt?: Maybe<Scalars['DateTime']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  monthlyCost: Scalars['Float']['output'];
  phoneNumber: Scalars['String']['output'];
  phoneNumberSid: Scalars['String']['output'];
  postalCode?: Maybe<Scalars['String']['output']>;
  purchasedAt: Scalars['DateTime']['output'];
  recordCalls: Scalars['Boolean']['output'];
  recordings: Array<CallRecording>;
  region?: Maybe<Scalars['String']['output']>;
  status: PhoneNumberStatus;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  voiceUrl: Scalars['String']['output'];
};

export type TwilioPhoneNumberInput = {
  autoTranscribe?: InputMaybe<Scalars['Boolean']['input']>;
  forwardToNumber?: InputMaybe<Scalars['String']['input']>;
  recordCalls?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TwoFactorEnableResult = {
  __typename?: 'TwoFactorEnableResult';
  recoveryCodes: Array<Scalars['String']['output']>;
  token: Scalars['String']['output'];
};

export type TwoFactorStatus = {
  __typename?: 'TwoFactorStatus';
  /** At least two different method types and not already on. */
  canEnable: Scalars['Boolean']['output'];
  /** Two-step verification is on for this account. */
  enabled: Scalars['Boolean']['output'];
  enabledAt?: Maybe<Scalars['DateTime']['output']>;
  /** Distinct sign-in method types this person has set up and can use on this site: passkey, pwd, email_code, sms_code. */
  factorTypes: Array<Scalars['String']['output']>;
  /** Last second-method proof in this session. */
  mfaAt?: Maybe<Scalars['DateTime']['output']>;
  /** Plain words when two-step verification cannot be turned on yet. */
  reason?: Maybe<Scalars['String']['output']>;
  recoveryCodesRemaining: Scalars['Int']['output'];
  /** This request's session assurance level: 1 or 2. */
  sessionAal: Scalars['Int']['output'];
  sessionAmr: Array<Scalars['String']['output']>;
  /** Every session issued before this moment is refused — the last "Sign out everywhere", password change/reset or two-step verification change. Null = never. */
  sessionsValidAfter?: Maybe<Scalars['DateTime']['output']>;
};

export type TypingUpdate = {
  __typename?: 'TypingUpdate';
  displayName: Scalars['String']['output'];
  isTyping: Scalars['Boolean']['output'];
  participantId: Scalars['String']['output'];
};

export type UnitConfig = {
  __typename?: 'UnitConfig';
  createdAt: Scalars['DateTime']['output'];
  deactivatedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  displayOrder: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  inUseIngredientsCount?: Maybe<Scalars['Int']['output']>;
  inUseRecipeRowsCount?: Maybe<Scalars['Int']['output']>;
  isActive: Scalars['Boolean']['output'];
  migrateTo?: Maybe<UnitType>;
  tenantId: Scalars['String']['output'];
  unit: UnitType;
  updatedAt: Scalars['DateTime']['output'];
};

export type UnitRetireManualItem = {
  __typename?: 'UnitRetireManualItem';
  currentQuantity?: Maybe<Scalars['Float']['output']>;
  currentUnit: UnitType;
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  kind: Scalars['String']['output'];
  reason: Scalars['String']['output'];
};

export type UnitRetireReport = {
  __typename?: 'UnitRetireReport';
  ingredientsMigrated: Scalars['Int']['output'];
  manualLadder: Array<UnitRetireManualItem>;
  recipeRowsAutoConverted: Scalars['Int']['output'];
};

export type UnitRetireResult = {
  __typename?: 'UnitRetireResult';
  report: UnitRetireReport;
  unitConfig: UnitConfig;
};

export type UnitSyncMismatch = {
  __typename?: 'UnitSyncMismatch';
  currentQuantity: Scalars['Float']['output'];
  currentUnit: UnitType;
  recipeId: Scalars['ID']['output'];
  recipeIngredientId: Scalars['ID']['output'];
  recipeName: Scalars['String']['output'];
};

export type UnitSyncReport = {
  __typename?: 'UnitSyncReport';
  convertedCount: Scalars['Int']['output'];
  mismatched: Array<UnitSyncMismatch>;
};

/** Units of measurement for ingredients */
export enum UnitType {
  Bunches = 'BUNCHES',
  Cans = 'CANS',
  Cups = 'CUPS',
  Dozen = 'DOZEN',
  Grams = 'GRAMS',
  Kilograms = 'KILOGRAMS',
  Liters = 'LITERS',
  Milliliters = 'MILLILITERS',
  Packages = 'PACKAGES',
  Pieces = 'PIECES',
  Slices = 'SLICES',
  Tablespoons = 'TABLESPOONS',
  Teaspoons = 'TEASPOONS',
  Units = 'UNITS',
  Whole = 'WHOLE'
}

export type UpcomingReviewsSummary = {
  __typename?: 'UpcomingReviewsSummary';
  dueThisMonth: Scalars['Int']['output'];
  dueThisWeek: Scalars['Int']['output'];
  overdue: Scalars['Int']['output'];
  totalScheduled: Scalars['Int']['output'];
};

export type UpdateAcfiAssessmentInput = {
  domainScores?: InputMaybe<Array<AcfiDomainScoreInput>>;
  estimatedDailyRate?: InputMaybe<Scalars['Float']['input']>;
  expiryDate?: InputMaybe<Scalars['DateTime']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<AcfiStatus>;
};

export type UpdateAccountabilityGoalInput = {
  capacityIndex?: InputMaybe<CapacityIndexInput>;
  currentRating?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  importance?: InputMaybe<Scalars['Int']['input']>;
  integrationNotes?: InputMaybe<Scalars['String']['input']>;
  internalExperience?: InputMaybe<Scalars['Int']['input']>;
  reflectionNotes?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<AccountabilityGoalStatus>;
  targetDate?: InputMaybe<Scalars['DateTime']['input']>;
  targetRating?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateAccountingBankAccountInput = {
  accountNumberLast4?: InputMaybe<Scalars['String']['input']>;
  companyId?: InputMaybe<Scalars['ID']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  institutionName?: InputMaybe<Scalars['String']['input']>;
  ledgerAccountId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  purpose?: InputMaybe<AccountingBankPurpose>;
};

export type UpdateAdmissionNotificationRuleInput = {
  channels?: InputMaybe<Array<Scalars['String']['input']>>;
  filterEntryType?: InputMaybe<EntryType>;
  filterInquirySource?: InputMaybe<Scalars['String']['input']>;
  filterPriority?: InputMaybe<WaitingListPriority>;
  id: Scalars['ID']['input'];
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  messageTemplate?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  recipientIds?: InputMaybe<Array<Scalars['String']['input']>>;
  recipientRole?: InputMaybe<Scalars['String']['input']>;
  recipientType?: InputMaybe<AdmissionNotificationRecipientType>;
  triggers?: InputMaybe<Array<AdmissionNotificationTrigger>>;
};

export type UpdateAdmissionsSettingsInput = {
  /** Login id from waitingListAssignablePeople; send "" to clear */
  defaultResponsibleAdminId?: InputMaybe<Scalars['ID']['input']>;
  /** Login id from waitingListAssignablePeople; send "" to clear */
  defaultResponsibleClinicalId?: InputMaybe<Scalars['ID']['input']>;
  familyMessagesEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  publicEnquiryFormEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Tour address for family messages; send "" to clear */
  tourAddress?: InputMaybe<Scalars['String']['input']>;
  /** Tour phone number for family messages; send "" to clear */
  tourPhone?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateAdvisoryBodyInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  memberClientIds?: InputMaybe<Array<Scalars['String']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateAllergyInput = {
  allergen?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  reactionSeverity?: InputMaybe<AllergySeverity>;
  reactionType?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateAnalyticsNotificationRuleInput = {
  channels?: InputMaybe<Array<Scalars['String']['input']>>;
  id: Scalars['ID']['input'];
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  messageTemplate?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  recipientIds?: InputMaybe<Array<Scalars['String']['input']>>;
  recipientTag?: InputMaybe<Scalars['String']['input']>;
  recipientType?: InputMaybe<AnalyticsNotificationRecipientType>;
  thresholdPath?: InputMaybe<Scalars['String']['input']>;
  thresholdValue?: InputMaybe<Scalars['Float']['input']>;
  timing?: InputMaybe<AnalyticsNotificationTiming>;
  timingMinutes?: InputMaybe<Scalars['Float']['input']>;
  trigger?: InputMaybe<AnalyticsNotificationTrigger>;
};

export type UpdateApiCategoryInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Float']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateApiEndpointInput = {
  codeExamples?: InputMaybe<Array<CodeExampleInput>>;
  description?: InputMaybe<Scalars['String']['input']>;
  exampleResponse?: InputMaybe<Scalars['JSON']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  method?: InputMaybe<HttpMethod>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Float']['input']>;
  parameters?: InputMaybe<Array<EndpointParamInput>>;
  path?: InputMaybe<Scalars['String']['input']>;
  requestMappingBody?: InputMaybe<Scalars['JSON']['input']>;
  requestMappingHeaders?: InputMaybe<Scalars['JSON']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateApiListingInput = {
  authHeaderName?: InputMaybe<Scalars['String']['input']>;
  authType?: InputMaybe<ApiAuthType>;
  baseUrl?: InputMaybe<Scalars['String']['input']>;
  categoryId?: InputMaybe<Scalars['String']['input']>;
  defaultHeaders?: InputMaybe<Scalars['JSON']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  envFallbackKey?: InputMaybe<Scalars['String']['input']>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  providerName?: InputMaybe<Scalars['String']['input']>;
  providerType?: InputMaybe<ApiProviderType>;
  providerUrl?: InputMaybe<Scalars['String']['input']>;
  shortDescription?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ApiListingStatus>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  tenantApiKeyField?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateArtSessionInput = {
  ageBands?: InputMaybe<Array<CompetitionAgeBand>>;
  clearCompetition?: InputMaybe<Scalars['Boolean']['input']>;
  clearSchool?: InputMaybe<Scalars['Boolean']['input']>;
  competitionId?: InputMaybe<Scalars['ID']['input']>;
  endsAt?: InputMaybe<Scalars['DateTime']['input']>;
  isFree?: InputMaybe<Scalars['Boolean']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  schoolId?: InputMaybe<Scalars['ID']['input']>;
  startsAt?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<ArtSessionStatus>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateArtifactSharingInput = {
  assignedClientIds?: InputMaybe<Array<Scalars['String']['input']>>;
  commentsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  id: Scalars['ID']['input'];
  visibility?: InputMaybe<ArtifactVisibility>;
};

export type UpdateAssessmentCustomFieldInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  fieldType?: InputMaybe<FieldType>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isRequired?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  max?: InputMaybe<Scalars['Int']['input']>;
  min?: InputMaybe<Scalars['Int']['input']>;
  options?: InputMaybe<Array<Scalars['String']['input']>>;
  order?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateAssessmentDomainInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateAssessmentNotificationRuleInput = {
  channels?: InputMaybe<Array<Scalars['String']['input']>>;
  id: Scalars['ID']['input'];
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  messageTemplate?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  recipientIds?: InputMaybe<Array<Scalars['String']['input']>>;
  recipientTag?: InputMaybe<Scalars['String']['input']>;
  recipientType?: InputMaybe<AssessmentNotificationRecipientType>;
  timing?: InputMaybe<AssessmentNotificationTiming>;
  timingMinutes?: InputMaybe<Scalars['Float']['input']>;
  trigger?: InputMaybe<AssessmentNotificationTrigger>;
};

export type UpdateAssessmentSnapshotInput = {
  notes?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateAwardClassificationInput = {
  awardName?: InputMaybe<Scalars['String']['input']>;
  baseHourlyRate?: InputMaybe<Scalars['Float']['input']>;
  casualHourlyRate?: InputMaybe<Scalars['Float']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayOrder?: InputMaybe<Scalars['Float']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  payLevel?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateAwardInput = {
  awardId: Scalars['String']['input'];
  code?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  industry?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateAwardRateInput = {
  baseHourlyRate?: InputMaybe<Scalars['Float']['input']>;
  casualHourlyRate?: InputMaybe<Scalars['Float']['input']>;
  effectiveFromDate?: InputMaybe<Scalars['DateTime']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateBankingAccountInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  includeInPosition?: InputMaybe<Scalars['Boolean']['input']>;
  isLiability?: InputMaybe<Scalars['Boolean']['input']>;
  nickname?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateBankingCashEntryInput = {
  amountMinor: Scalars['Int']['input'];
  counterpartyClientId?: InputMaybe<Scalars['ID']['input']>;
  day: Scalars['String']['input'];
  description: Scalars['String']['input'];
  direction: BankingDirection;
  note?: InputMaybe<Scalars['String']['input']>;
  shape?: InputMaybe<BankingIncomeShape>;
  transactionId: Scalars['ID']['input'];
};

export type UpdateBankingDigestPreferenceInput = {
  combinedFrequency?: InputMaybe<BankingDigestFrequency>;
  email?: InputMaybe<Scalars['Boolean']['input']>;
  hourBrisbane?: InputMaybe<Scalars['Int']['input']>;
  perAccount?: InputMaybe<Array<BankingAccountDigestInput>>;
  sms?: InputMaybe<Scalars['Boolean']['input']>;
  weeklyDay?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateBankingMonthPlanInput = {
  expectedIncomeMinor?: InputMaybe<Scalars['Int']['input']>;
  gstRegistered?: InputMaybe<Scalars['Boolean']['input']>;
  month: Scalars['String']['input'];
  revenueGoalMinor?: InputMaybe<Scalars['Int']['input']>;
  savePct?: InputMaybe<Scalars['Float']['input']>;
  taxAccountId?: InputMaybe<Scalars['String']['input']>;
  taxRatePct?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateBankingSettingsInput = {
  backfillMonths?: InputMaybe<Scalars['Int']['input']>;
  pollEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateBdayGuestInput = {
  dietaryRequirements?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  inviteSentAt?: InputMaybe<Scalars['DateTime']['input']>;
  isFamily?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  plusOneNames?: InputMaybe<Array<Scalars['String']['input']>>;
  plusOnes?: InputMaybe<Scalars['Float']['input']>;
  rsvpStatus?: InputMaybe<RsvpStatus>;
  urlSlug?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateBillNotificationRuleInput = {
  channels?: InputMaybe<Array<Scalars['String']['input']>>;
  id: Scalars['ID']['input'];
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  messageTemplate?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  recipientIds?: InputMaybe<Array<Scalars['String']['input']>>;
  recipientTag?: InputMaybe<Scalars['String']['input']>;
  recipientType?: InputMaybe<BillNotificationRecipientType>;
  timing?: InputMaybe<BillNotificationTiming>;
  timingMinutes?: InputMaybe<Scalars['Float']['input']>;
  trigger?: InputMaybe<BillNotificationTrigger>;
};

export type UpdateBlogCategoryInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  parentId?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateBlogNotificationRuleInput = {
  channels?: InputMaybe<Array<Scalars['String']['input']>>;
  id: Scalars['ID']['input'];
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  messageTemplate?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  recipientIds?: InputMaybe<Array<Scalars['String']['input']>>;
  recipientType?: InputMaybe<BlogNotificationRecipientType>;
  timing?: InputMaybe<BlogNotificationTiming>;
  timingMinutes?: InputMaybe<Scalars['Int']['input']>;
  trigger?: InputMaybe<BlogNotificationTrigger>;
};

export type UpdateBlogPostInput = {
  aiChatEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  aiChatSeedQuestions?: InputMaybe<Array<Scalars['String']['input']>>;
  audioUrl?: InputMaybe<Scalars['String']['input']>;
  author?: InputMaybe<Scalars['String']['input']>;
  authorAvatarUrl?: InputMaybe<Scalars['String']['input']>;
  authorBio?: InputMaybe<Scalars['String']['input']>;
  bonusContent?: InputMaybe<Scalars['String']['input']>;
  bonusUnlockPercent?: InputMaybe<Scalars['Int']['input']>;
  categories?: InputMaybe<Array<Scalars['String']['input']>>;
  content?: InputMaybe<Scalars['String']['input']>;
  excerpt?: InputMaybe<Scalars['String']['input']>;
  featuredImage?: InputMaybe<Scalars['String']['input']>;
  leadFormId?: InputMaybe<Scalars['String']['input']>;
  leadMagnetDescription?: InputMaybe<Scalars['String']['input']>;
  leadMagnetTitle?: InputMaybe<Scalars['String']['input']>;
  metaDescription?: InputMaybe<Scalars['String']['input']>;
  metaTitle?: InputMaybe<Scalars['String']['input']>;
  ogImage?: InputMaybe<Scalars['String']['input']>;
  personalizationOptions?: InputMaybe<Array<PersonalizationOptionInput>>;
  personalizationQuestion?: InputMaybe<Scalars['String']['input']>;
  pollOptions?: InputMaybe<Array<PollOptionInput>>;
  pollQuestion?: InputMaybe<Scalars['String']['input']>;
  readTime?: InputMaybe<Scalars['Int']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<BlogPostStatus>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  title?: InputMaybe<Scalars['String']['input']>;
  toolCtaDescription?: InputMaybe<Scalars['String']['input']>;
  toolCtaText?: InputMaybe<Scalars['String']['input']>;
  toolCtaUrl?: InputMaybe<Scalars['String']['input']>;
  videoCid?: InputMaybe<Scalars['String']['input']>;
  videoCustomIframe?: InputMaybe<Scalars['String']['input']>;
  videoEmbedUrl?: InputMaybe<Scalars['String']['input']>;
  videoIpfsHash?: InputMaybe<Scalars['String']['input']>;
  videoProvider?: InputMaybe<BlogVideoProvider>;
  visibility?: InputMaybe<BlogPostVisibility>;
};

export type UpdateBusinessCalendarAvailabilityInput = {
  blockedDates?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  extraAvailableDates?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  slots?: InputMaybe<Array<BusinessCalendarAvailabilitySlotInput>>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateBusinessCalendarBookableEventTypeInput = {
  allowedDaysOfWeek?: InputMaybe<Array<Scalars['Int']['input']>>;
  autoGenerateMeetingLink?: InputMaybe<Scalars['Boolean']['input']>;
  bufferAfterMinutes?: InputMaybe<Scalars['Float']['input']>;
  bufferBeforeMinutes?: InputMaybe<Scalars['Float']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  confirmationMessage?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayOrder?: InputMaybe<Scalars['Float']['input']>;
  durationMinutes?: InputMaybe<Scalars['Float']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isPaid?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  locationType?: InputMaybe<Scalars['String']['input']>;
  maxBookingsPerDay?: InputMaybe<Scalars['Float']['input']>;
  maxFutureDays?: InputMaybe<Scalars['Float']['input']>;
  meetingLink?: InputMaybe<Scalars['String']['input']>;
  minNoticeHours?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  questions?: InputMaybe<Array<BusinessCalendarBookingQuestionInput>>;
  reminderHoursBefore?: InputMaybe<Scalars['Float']['input']>;
  stripePriceId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateBusinessCalendarInput = {
  allowPublicBooking?: InputMaybe<Scalars['Boolean']['input']>;
  bookingConfirmationEmailTemplate?: InputMaybe<Scalars['String']['input']>;
  bookingPageBranding?: InputMaybe<Scalars['JSONObject']['input']>;
  bookingPageDescription?: InputMaybe<Scalars['String']['input']>;
  bookingPageLogo?: InputMaybe<Scalars['String']['input']>;
  bookingPageProfilePhoto?: InputMaybe<Scalars['String']['input']>;
  bookingPageProfilePhotoCid?: InputMaybe<Scalars['String']['input']>;
  bookingPageSlug?: InputMaybe<Scalars['String']['input']>;
  bookingPageTitle?: InputMaybe<Scalars['String']['input']>;
  bookingReminderEmailTemplate?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  companyId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  iCalUrl?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  linkedEmailAddressId?: InputMaybe<Scalars['String']['input']>;
  linkedModules?: InputMaybe<Array<Scalars['String']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['String']['input']>;
  requirePaymentUpfront?: InputMaybe<Scalars['Boolean']['input']>;
  sendBookingConfirmations?: InputMaybe<Scalars['Boolean']['input']>;
  sendBookingReminders?: InputMaybe<Scalars['Boolean']['input']>;
  settings?: InputMaybe<CalendarSettingsInput>;
  sharedFromEmail?: InputMaybe<Scalars['String']['input']>;
  sharedFromName?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  syncInfo?: InputMaybe<CalendarSyncInfoInput>;
  type?: InputMaybe<CalendarType>;
  visibility?: InputMaybe<CalendarVisibility>;
};

export type UpdateBusinessDirectoryNotificationRuleInput = {
  channels: Array<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  messageTemplate?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  recipientIds?: InputMaybe<Array<Scalars['String']['input']>>;
  recipientType: BusinessDirectoryNotificationRecipientType;
  trigger: BusinessDirectoryNotificationTrigger;
};

export type UpdateCiActionInput = {
  assignedTo?: InputMaybe<Scalars['ID']['input']>;
  assignedToName?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<CiActionStatus>;
};

export type UpdateCiAgendaItemInput = {
  actionDueDate?: InputMaybe<Scalars['DateTime']['input']>;
  actionRequired?: InputMaybe<Scalars['String']['input']>;
  discussionNotes?: InputMaybe<Scalars['String']['input']>;
  itemIndex: Scalars['Float']['input'];
  responsiblePerson?: InputMaybe<Scalars['String']['input']>;
  responsiblePersonId?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<CiAgendaItemStatus>;
};

export type UpdateCiGovernanceMeetingInput = {
  agenda?: InputMaybe<Scalars['String']['input']>;
  attendees?: InputMaybe<Array<CiMeetingAttendeeInput>>;
  decisionsAndActions?: InputMaybe<Array<CiDecisionActionInput>>;
  documents?: InputMaybe<Array<CiDocumentAttachmentInput>>;
  duration?: InputMaybe<Scalars['Float']['input']>;
  initiativesReviewed?: InputMaybe<Array<Scalars['ID']['input']>>;
  issuesReviewed?: InputMaybe<Array<Scalars['ID']['input']>>;
  location?: InputMaybe<Scalars['String']['input']>;
  meetingType?: InputMaybe<CiMeetingType>;
  minutes?: InputMaybe<Scalars['String']['input']>;
  qualityStandardsDiscussed?: InputMaybe<Array<CiQualityStandard>>;
  scheduledDate?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledTime?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<CiMeetingStatus>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCiImprovementInitiativeInput = {
  dateIdentified?: InputMaybe<Scalars['DateTime']['input']>;
  documents?: InputMaybe<Array<CiDocumentAttachmentInput>>;
  isSuccessful?: InputMaybe<Scalars['Boolean']['input']>;
  isSustainable?: InputMaybe<Scalars['Boolean']['input']>;
  issueDescription?: InputMaybe<Scalars['String']['input']>;
  issueSource?: InputMaybe<CiIssueSource>;
  issueSourceDetails?: InputMaybe<Scalars['String']['input']>;
  issueTitle?: InputMaybe<Scalars['String']['input']>;
  linkedMeetingId?: InputMaybe<Scalars['ID']['input']>;
  measurementDetails?: InputMaybe<Scalars['String']['input']>;
  outcomes?: InputMaybe<Scalars['String']['input']>;
  plannedActions?: InputMaybe<Array<CiPlannedActionInput>>;
  plannedCompletionDate?: InputMaybe<Scalars['DateTime']['input']>;
  responsiblePersons?: InputMaybe<Array<CiResponsiblePersonInput>>;
  reviewCompletedDate?: InputMaybe<Scalars['DateTime']['input']>;
  reviewDate?: InputMaybe<Scalars['DateTime']['input']>;
  reviewNotes?: InputMaybe<Scalars['String']['input']>;
  standardLinks?: InputMaybe<Array<CiStandardLinkInput>>;
  status?: InputMaybe<CiInitiativeStatus>;
};

export type UpdateCiIssueReportInput = {
  category?: InputMaybe<CiIssueCategory>;
  description?: InputMaybe<Scalars['String']['input']>;
  documents?: InputMaybe<Array<CiDocumentAttachmentInput>>;
  followUpDate?: InputMaybe<Scalars['DateTime']['input']>;
  followUpNotes?: InputMaybe<Scalars['String']['input']>;
  followUpRequired?: InputMaybe<Scalars['Boolean']['input']>;
  linkedMeetingId?: InputMaybe<Scalars['ID']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  photos?: InputMaybe<Array<CiMediaAttachmentInitiativeInput>>;
  qualityStandards?: InputMaybe<Array<CiQualityStandard>>;
  resolutionDetails?: InputMaybe<Scalars['String']['input']>;
  room?: InputMaybe<Scalars['String']['input']>;
  severity?: InputMaybe<CiIssueSeverity>;
  status?: InputMaybe<CiIssueStatus>;
  title?: InputMaybe<Scalars['String']['input']>;
  wing?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCiNotificationRuleInput = {
  channels?: InputMaybe<Array<Scalars['String']['input']>>;
  filterStandard?: InputMaybe<CiQualityStandard>;
  id: Scalars['ID']['input'];
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  messageTemplate?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  recipientIds?: InputMaybe<Array<Scalars['String']['input']>>;
  recipientRole?: InputMaybe<Scalars['String']['input']>;
  recipientType?: InputMaybe<CiNotificationRecipientType>;
  scheduledDay?: InputMaybe<CiScheduleDay>;
  scheduledHour?: InputMaybe<Scalars['Float']['input']>;
  trigger?: InputMaybe<CiNotificationTrigger>;
};

export type UpdateCalendarEventTaskChecklistInput = {
  checklistItemId: Scalars['String']['input'];
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  taskId: Scalars['String']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCandidateFormPositionInput = {
  companyId?: InputMaybe<Scalars['ID']['input']>;
  earliestStartRequired?: InputMaybe<Scalars['Boolean']['input']>;
  minReferences?: InputMaybe<Scalars['Float']['input']>;
  positionTitle?: InputMaybe<Scalars['String']['input']>;
  /** Replaces the whole list when given */
  preScreenQuestions?: InputMaybe<Array<PreScreenQuestionInput>>;
  roleCategory?: InputMaybe<RoleCategory>;
};

export type UpdateCandidateInput = {
  addressCountry?: InputMaybe<Scalars['String']['input']>;
  addressPostcode?: InputMaybe<Scalars['String']['input']>;
  addressState?: InputMaybe<Scalars['String']['input']>;
  addressStreetName?: InputMaybe<Scalars['String']['input']>;
  addressStreetNumber?: InputMaybe<Scalars['String']['input']>;
  addressSuburb?: InputMaybe<Scalars['String']['input']>;
  companyId?: InputMaybe<Scalars['ID']['input']>;
  dateOfBirth?: InputMaybe<Scalars['String']['input']>;
  /** YYYY-MM-DD */
  earliestStart?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  rateContext?: InputMaybe<Scalars['String']['input']>;
  rejectionReason?: InputMaybe<Scalars['String']['input']>;
  roleCategory?: InputMaybe<RoleCategory>;
  stage?: InputMaybe<CandidateStage>;
  status?: InputMaybe<CandidateStatus>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  urgency?: InputMaybe<CandidateUrgency>;
};

export type UpdateCarePlanInput = {
  assessment?: InputMaybe<CarePlanAssessmentInput>;
  category?: InputMaybe<CarePlanCategory>;
  effectiveDate?: InputMaybe<Scalars['DateTime']['input']>;
  expiryDate?: InputMaybe<Scalars['DateTime']['input']>;
  nextReviewDate?: InputMaybe<Scalars['DateTime']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  planName?: InputMaybe<Scalars['String']['input']>;
  reviewFrequency?: InputMaybe<ReviewFrequency>;
  status?: InputMaybe<CarePlanStatus>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateCarePlanTemplateInput = {
  assessmentTemplate?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<CarePlanCategory>;
  defaultReviewFrequency?: InputMaybe<ReviewFrequency>;
  description?: InputMaybe<Scalars['String']['input']>;
  goals?: InputMaybe<Array<TemplateGoalInput>>;
  interventions?: InputMaybe<Array<TemplateInterventionInput>>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Change the care review cycle settings. Each value must sit inside its rule’s limits. */
export type UpdateCareReviewCycleSettingsInput = {
  admissionWindowDays?: InputMaybe<Scalars['Int']['input']>;
  carePlanReviewIntervalDays?: InputMaybe<Scalars['Int']['input']>;
  changeReviewWithinDays?: InputMaybe<Scalars['Int']['input']>;
  dueSoonDays?: InputMaybe<Scalars['Int']['input']>;
  fallIncidentTriggersReview?: InputMaybe<Scalars['Boolean']['input']>;
  hospitalReturnTriggersReview?: InputMaybe<Scalars['Boolean']['input']>;
  reassessmentIntervalDays?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateCareReviewInput = {
  actionItems?: InputMaybe<Array<CareReviewActionItemInput>>;
  attendees?: InputMaybe<Array<Scalars['String']['input']>>;
  carePlanUpdateNotes?: InputMaybe<Scalars['String']['input']>;
  carePlanUpdatesRequired?: InputMaybe<Scalars['Boolean']['input']>;
  changeTrigger?: InputMaybe<CareReviewChangeTrigger>;
  conductedByName?: InputMaybe<Scalars['String']['input']>;
  familyFeedback?: InputMaybe<Scalars['String']['input']>;
  familyNotified?: InputMaybe<Scalars['Boolean']['input']>;
  /** Link the review to the incident it answers (same resident) */
  incidentId?: InputMaybe<Scalars['ID']['input']>;
  nextReviewDate?: InputMaybe<Scalars['DateTime']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  outcomes?: InputMaybe<Scalars['String']['input']>;
  reviewDate?: InputMaybe<Scalars['DateTime']['input']>;
  reviewType?: InputMaybe<CareReviewType>;
  status?: InputMaybe<CareReviewStatus>;
  summary?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateChaseNotificationRuleInput = {
  action?: InputMaybe<ChaseRuleAction>;
  description?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  targetConfigIds?: InputMaybe<Array<Scalars['String']['input']>>;
  targetMilestoneId?: InputMaybe<Scalars['String']['input']>;
  triggerEvent?: InputMaybe<ChaseTriggerEvent>;
};

export type UpdateChecklistItemInput = {
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['String']['input'];
  text?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateChecklistTemplateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  tasks?: InputMaybe<Array<ChecklistTemplateTaskInput>>;
};

export type UpdateClientActivityInput = {
  activityDate?: InputMaybe<Scalars['DateTime']['input']>;
  activityType?: InputMaybe<Scalars['String']['input']>;
  details?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateClientChaseConfigInput = {
  aiPrompt?: InputMaybe<Scalars['String']['input']>;
  channel?: InputMaybe<ChaseChannel>;
  clientGoal?: InputMaybe<Scalars['String']['input']>;
  currentMilestone?: InputMaybe<Scalars['String']['input']>;
  goalActionLabel?: InputMaybe<Scalars['String']['input']>;
  goalActionUrl?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  journeyTemplateId?: InputMaybe<Scalars['String']['input']>;
  schedule?: InputMaybe<ChaseSchedule>;
  scheduleTime?: InputMaybe<Scalars['String']['input']>;
  sendMode?: InputMaybe<ChaseSendMode>;
  targetTenantUrl?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateClientInput = {
  billingAddresses?: InputMaybe<Array<ClientBillingDetailsInput>>;
  businessName?: InputMaybe<Scalars['String']['input']>;
  businessRegistrationNumber?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  encryptedSignatureIpfsUrl?: InputMaybe<Scalars['String']['input']>;
  fName?: InputMaybe<Scalars['String']['input']>;
  lName?: InputMaybe<Scalars['String']['input']>;
  paymentReceivingDetails?: InputMaybe<PaymentReceivingDetailsInput>;
  permissions?: InputMaybe<Array<ClientPermission>>;
  personalCalendarId?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  preferences?: InputMaybe<ClientPreferencesInput>;
  profilePhoto?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<ClientRole>;
  shippingAddresses?: InputMaybe<Array<ClientShippingDetailsInput>>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  websites?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateClientNotificationRuleInput = {
  channels?: InputMaybe<Array<Scalars['String']['input']>>;
  id: Scalars['ID']['input'];
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  messageTemplate?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  recipientIds?: InputMaybe<Array<Scalars['String']['input']>>;
  recipientTag?: InputMaybe<Scalars['String']['input']>;
  recipientType?: InputMaybe<ClientNotificationRecipientType>;
  timing?: InputMaybe<ClientNotificationTiming>;
  timingMinutes?: InputMaybe<Scalars['Float']['input']>;
  trigger?: InputMaybe<ClientNotificationTrigger>;
};

export type UpdateClinicalTaskInput = {
  assignedTo?: InputMaybe<Scalars['ID']['input']>;
  assignedToName?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  isRecurring?: InputMaybe<Scalars['Boolean']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<ClinicalTaskPriority>;
  recurrencePattern?: InputMaybe<Scalars['String']['input']>;
  residentId?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<ClinicalTaskStatus>;
  taskType?: InputMaybe<ClinicalTaskType>;
  title?: InputMaybe<Scalars['String']['input']>;
  wing?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateClub52PlayerInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  walletAddress?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateClub52SettingsInput = {
  appAccessInstructions?: InputMaybe<Scalars['String']['input']>;
  bankTopUpInstructions?: InputMaybe<Scalars['String']['input']>;
  dailyTreasuryCapMicro?: InputMaybe<Scalars['String']['input']>;
  explorerBaseUrl?: InputMaybe<Scalars['String']['input']>;
  nodeRestUrl?: InputMaybe<Scalars['String']['input']>;
  nodeRpcUrl?: InputMaybe<Scalars['String']['input']>;
  perGameBudgetMicro?: InputMaybe<Scalars['String']['input']>;
  quickFundPresetsMicro?: InputMaybe<Array<Scalars['String']['input']>>;
  rakeOwnerAddress?: InputMaybe<Scalars['String']['input']>;
  rakeOwnerMnemonic?: InputMaybe<Scalars['String']['input']>;
  treasuryMnemonic?: InputMaybe<Scalars['String']['input']>;
  walletPageUrl?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCoachAgreementInput = {
  effectiveDate?: InputMaybe<Scalars['DateTime']['input']>;
  expiryDate?: InputMaybe<Scalars['DateTime']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  pProposalId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<CoachAgreementStatus>;
};

export type UpdateCoachInput = {
  bio?: InputMaybe<Scalars['String']['input']>;
  externalBookingUrl?: InputMaybe<Scalars['String']['input']>;
  fName?: InputMaybe<Scalars['String']['input']>;
  lName?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  photoCid?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<CoachStatus>;
  tier?: InputMaybe<CoachTier>;
};

export type UpdateCodingRuleInput = {
  contains?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<AccountingRuleDirection>;
  id: Scalars['ID']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  ledgerAccountId?: InputMaybe<Scalars['ID']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateCommandIntegrationConfigInput = {
  ghlApiToken?: InputMaybe<Scalars['String']['input']>;
  ghlFieldKeys?: InputMaybe<Scalars['String']['input']>;
  ghlLocationId?: InputMaybe<Scalars['String']['input']>;
  ghlPipelineId?: InputMaybe<Scalars['String']['input']>;
  ghlStageId?: InputMaybe<Scalars['String']['input']>;
  googleServiceAccountEmail?: InputMaybe<Scalars['String']['input']>;
  googleServiceAccountKey?: InputMaybe<Scalars['String']['input']>;
  googleSheetId?: InputMaybe<Scalars['String']['input']>;
  googleSheetRange?: InputMaybe<Scalars['String']['input']>;
  onePropertyGhlApiToken?: InputMaybe<Scalars['String']['input']>;
  onePropertyGhlLocationId?: InputMaybe<Scalars['String']['input']>;
  onePropertyGhlPipelineId?: InputMaybe<Scalars['String']['input']>;
  onePropertyGhlStageId?: InputMaybe<Scalars['String']['input']>;
  pipedriveApiToken?: InputMaybe<Scalars['String']['input']>;
  pipedriveCompanyDomain?: InputMaybe<Scalars['String']['input']>;
  xeroClientId?: InputMaybe<Scalars['String']['input']>;
  xeroClientSecret?: InputMaybe<Scalars['String']['input']>;
  xeroConfigured?: InputMaybe<Scalars['Boolean']['input']>;
  xeroRefreshToken?: InputMaybe<Scalars['String']['input']>;
  xeroTenantId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCommsHealthSettingsInput = {
  minProbeIntervalMinutes?: InputMaybe<Scalars['Int']['input']>;
  reportRecipients?: InputMaybe<Array<Scalars['String']['input']>>;
  watchedAddresses?: InputMaybe<Array<Scalars['String']['input']>>;
  weeklyReportEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateCommsLogSettingsInput = {
  cellcastApiKeyOverride?: InputMaybe<Scalars['String']['input']>;
  clearCellcastOverride?: InputMaybe<Scalars['Boolean']['input']>;
  clearPostmarkOverride?: InputMaybe<Scalars['Boolean']['input']>;
  dailySummaryEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  postmarkApiKeyOverride?: InputMaybe<Scalars['String']['input']>;
  senderFilter?: InputMaybe<Array<Scalars['String']['input']>>;
  summaryHourBrisbane?: InputMaybe<Scalars['Int']['input']>;
  summaryRecipientClientIds?: InputMaybe<Array<Scalars['String']['input']>>;
  weeklySummaryEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateCommunicationTaskInput = {
  assignedTo?: InputMaybe<Array<Scalars['ID']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Float']['input']>;
  priority?: InputMaybe<CommunicationTaskPriority>;
  status?: InputMaybe<CommunicationTaskStatus>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCommunityCampaignInput = {
  audience?: InputMaybe<CommunityCampaignAudience>;
  body?: InputMaybe<Scalars['String']['input']>;
  clientIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  sendAt?: InputMaybe<Scalars['DateTime']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCommunityConfigInput = {
  customAffirmations?: InputMaybe<Array<Scalars['String']['input']>>;
  dailyEmailAutoSendEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  dailySendHour?: InputMaybe<Scalars['Float']['input']>;
  defaultDailyReminderEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  defaultEmailEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  defaultEngagementFrequency?: InputMaybe<CommunityEngagementFrequency>;
  defaultNotifyOnLapsed?: InputMaybe<Scalars['Boolean']['input']>;
  defaultNotifyOnReplies?: InputMaybe<Scalars['Boolean']['input']>;
  defaultSmsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  entryRewardEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  entryRewardValue?: InputMaybe<Scalars['Float']['input']>;
  globeEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  lapsedNudgeAfterDays?: InputMaybe<Scalars['Float']['input']>;
  lapsedNudgeBookingUrl?: InputMaybe<Scalars['String']['input']>;
  lapsedNudgeEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  leaderboardEmailFrequency?: InputMaybe<CommunityLeaderboardEmailFrequency>;
  leaderboardPrizeText?: InputMaybe<Scalars['String']['input']>;
  merchCtaLabel?: InputMaybe<Scalars['String']['input']>;
  merchCtaUrl?: InputMaybe<Scalars['String']['input']>;
  notificationsPaused?: InputMaybe<Scalars['Boolean']['input']>;
  notifyOnEveryPost?: InputMaybe<Scalars['Boolean']['input']>;
  postsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  publicQrSignupEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  publicSlug?: InputMaybe<Scalars['String']['input']>;
  referralRewardEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  referralRewardValue?: InputMaybe<Scalars['Float']['input']>;
  repliesEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  smsChannelAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  videoCallEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateCommunityEntryInput = {
  id: Scalars['ID']['input'];
  markDone?: InputMaybe<Scalars['Boolean']['input']>;
  profileBio?: InputMaybe<Scalars['String']['input']>;
  profileVibeName?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCommunityMemberSettingsInput = {
  country?: InputMaybe<Scalars['String']['input']>;
  dailyReminderEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  emailEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  engagementFrequency?: InputMaybe<CommunityEngagementFrequency>;
  notifyOnCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  notifyOnLapsed?: InputMaybe<Scalars['Boolean']['input']>;
  notifyOnPlanned?: InputMaybe<Scalars['Boolean']['input']>;
  notifyOnReplies?: InputMaybe<Scalars['Boolean']['input']>;
  smsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateCompanyInput = {
  abn?: InputMaybe<Scalars['String']['input']>;
  accountManager?: InputMaybe<Scalars['ID']['input']>;
  acn?: InputMaybe<Scalars['String']['input']>;
  annualRevenue?: InputMaybe<Scalars['Float']['input']>;
  billingEmail?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  employees?: InputMaybe<Array<Scalars['ID']['input']>>;
  establishedDate?: InputMaybe<Scalars['DateTime']['input']>;
  fax?: InputMaybe<Scalars['String']['input']>;
  financialYearEnd?: InputMaybe<Scalars['String']['input']>;
  industry?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  linkedTenantId?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  numberOfEmployees?: InputMaybe<Scalars['Float']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  physicalAddress?: InputMaybe<CompanyAddressInput>;
  postalAddress?: InputMaybe<CompanyAddressInput>;
  primaryContact?: InputMaybe<CompanyContactInput>;
  recruitmentContactEmail?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<CompanyStatus>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  taxNumber?: InputMaybe<Scalars['String']['input']>;
  tradingName?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<CompanyType>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCompanyKnowledgeInput = {
  allowPublicAccess?: InputMaybe<Scalars['Boolean']['input']>;
  allowedClientIds?: InputMaybe<Array<Scalars['String']['input']>>;
  category?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  contentType?: InputMaybe<ArticleContentType>;
  embeddedImages?: InputMaybe<Array<EmbeddedImageInput>>;
  embeddedVideos?: InputMaybe<Array<EmbeddedVideoInput>>;
  isPinned?: InputMaybe<Scalars['Boolean']['input']>;
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  metaDescription?: InputMaybe<Scalars['String']['input']>;
  metaKeywords?: InputMaybe<Array<Scalars['String']['input']>>;
  publicSlug?: InputMaybe<Scalars['String']['input']>;
  relatedArticleIds?: InputMaybe<Array<Scalars['String']['input']>>;
  requiredClientTags?: InputMaybe<Array<Scalars['String']['input']>>;
  showArticlePreview?: InputMaybe<Scalars['Boolean']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  title?: InputMaybe<Scalars['String']['input']>;
  videoFileSize?: InputMaybe<Scalars['Float']['input']>;
  videoIpfsHash?: InputMaybe<Scalars['String']['input']>;
  videoMimeType?: InputMaybe<Scalars['String']['input']>;
  visibility?: InputMaybe<ArticleVisibility>;
};

export type UpdateCompetitionInput = {
  ageBands?: InputMaybe<Array<CompetitionAgeBand>>;
  aiPolicy?: InputMaybe<Scalars['String']['input']>;
  announceWinnersAt?: InputMaybe<Scalars['DateTime']['input']>;
  briefMd?: InputMaybe<Scalars['String']['input']>;
  closesAt?: InputMaybe<Scalars['DateTime']['input']>;
  heroImageCid?: InputMaybe<Scalars['String']['input']>;
  maxEntriesPerPerson?: InputMaybe<Scalars['Int']['input']>;
  newEntryEmails?: InputMaybe<Scalars['Boolean']['input']>;
  opensAt?: InputMaybe<Scalars['DateTime']['input']>;
  prizes?: InputMaybe<Array<CompetitionPrizeInput>>;
  rightsTermsMd?: InputMaybe<Scalars['String']['input']>;
  rulesMd?: InputMaybe<Scalars['String']['input']>;
  shortlistRequired?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  sponsorIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  theme?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  visibility?: InputMaybe<CompetitionVisibility>;
  votingClosesAt?: InputMaybe<Scalars['DateTime']['input']>;
  votingMode?: InputMaybe<CompetitionVotingMode>;
  votingOpensAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UpdateCompetitionPrintOfferInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  artistSharePercent?: InputMaybe<Scalars['Int']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  printCost?: InputMaybe<Scalars['Float']['input']>;
  size?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCompetitionSchoolInput = {
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactName?: InputMaybe<Scalars['String']['input']>;
  contactPhone?: InputMaybe<Scalars['String']['input']>;
  lastContactedAt?: InputMaybe<Scalars['DateTime']['input']>;
  listedPublicly?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<CompetitionSchoolStatus>;
  suburb?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCompetitionSponsorInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  blurb?: InputMaybe<Scalars['String']['input']>;
  companyId?: InputMaybe<Scalars['ID']['input']>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactName?: InputMaybe<Scalars['String']['input']>;
  contactPhone?: InputMaybe<Scalars['String']['input']>;
  lastContactedAt?: InputMaybe<Scalars['DateTime']['input']>;
  logoCid?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  pipelineStatus?: InputMaybe<CompetitionSponsorPipelineStatus>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateConstructionSiteInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  assignedCrew?: InputMaybe<Array<SiteCrewMemberInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  ownerClientId?: InputMaybe<Scalars['ID']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<SiteStatus>;
};

export type UpdateContributingFactorInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateCouponInput = {
  appliesToProductIds?: InputMaybe<Array<Scalars['String']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  discountType?: InputMaybe<CouponDiscountType>;
  discountValue?: InputMaybe<Scalars['Float']['input']>;
  durationMonths?: InputMaybe<Scalars['Int']['input']>;
  expiresAt?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  maxRedemptions?: InputMaybe<Scalars['Int']['input']>;
  perClientLimit?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateCustomQuestionInput = {
  helpText?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isRequired?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<Array<Scalars['String']['input']>>;
  order?: InputMaybe<Scalars['Int']['input']>;
  question?: InputMaybe<Scalars['String']['input']>;
  questionType?: InputMaybe<CustomQuestionType>;
};

export type UpdateCustomTestDefinitionInput = {
  assignedRole?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  tier?: InputMaybe<TestTier>;
  userStoryAction?: InputMaybe<Scalars['String']['input']>;
  userStoryExpected?: InputMaybe<Scalars['String']['input']>;
  userStoryPage?: InputMaybe<Scalars['String']['input']>;
  userStoryRole?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateDailyCareProfileInput = {
  activities?: InputMaybe<ActivitiesProfileInput>;
  behavioralConsiderations?: InputMaybe<BehavioralConsiderationsInput>;
  communication?: InputMaybe<CommunicationProfileInput>;
  mobility?: InputMaybe<MobilityProfileInput>;
  notes?: InputMaybe<Scalars['String']['input']>;
  nutrition?: InputMaybe<NutritionProfileInput>;
  pain?: InputMaybe<PainProfileInput>;
  personalCare?: InputMaybe<PersonalCareInput>;
  pressureCare?: InputMaybe<PressureCareProfileInput>;
  profileType?: InputMaybe<ProfileType>;
  sleepPattern?: InputMaybe<SleepPatternInput>;
};

export type UpdateDepartmentInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  countsTowardCareMinutes?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayOrder?: InputMaybe<Scalars['Float']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateDigitalManagerInput = {
  avatarCid?: InputMaybe<Scalars['String']['input']>;
  modelOverride?: InputMaybe<Scalars['String']['input']>;
  personaName?: InputMaybe<Scalars['String']['input']>;
  proactiveChasingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  reportTo?: InputMaybe<Array<DigitalManagerReportToContactInput>>;
  responsibilitiesMarkdown?: InputMaybe<Scalars['String']['input']>;
  scheduleCron?: InputMaybe<Scalars['String']['input']>;
  scopeToolIds?: InputMaybe<Array<Scalars['String']['input']>>;
  standupCron?: InputMaybe<Scalars['String']['input']>;
  standupEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateDigitalManagerMemoryInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  body?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<Scalars['Float']['input']>;
  scope?: InputMaybe<DigitalManagerMemoryScope>;
  scopeValue?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateDigitalManagerNotificationRuleInput = {
  channels?: InputMaybe<Array<Scalars['String']['input']>>;
  costThresholdCents?: InputMaybe<Scalars['Int']['input']>;
  filterManagerId?: InputMaybe<Scalars['ID']['input']>;
  filterPriority?: InputMaybe<Scalars['String']['input']>;
  filterStatus?: InputMaybe<Scalars['String']['input']>;
  filterTemplate?: InputMaybe<Scalars['String']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  messageTemplate?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  recipientIds?: InputMaybe<Array<Scalars['String']['input']>>;
  recipientRole?: InputMaybe<Scalars['String']['input']>;
  recipientType?: InputMaybe<DigitalManagerNotificationRecipientType>;
  timing?: InputMaybe<DigitalManagerNotificationTiming>;
  timingMinutes?: InputMaybe<Scalars['Int']['input']>;
  trigger?: InputMaybe<DigitalManagerNotificationTrigger>;
};

export type UpdateDigitalManagerRuleInput = {
  actions?: InputMaybe<Array<DigitalManagerRuleActionInput>>;
  conditionCombinator?: InputMaybe<DigitalManagerRuleCombinator>;
  conditions?: InputMaybe<Array<DigitalManagerRuleConditionInput>>;
  description?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateDigitalManagerTemplateInput = {
  defaultModelOverride?: InputMaybe<Scalars['String']['input']>;
  defaultPersonaName?: InputMaybe<Scalars['String']['input']>;
  defaultProactiveChasingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  defaultResponsibilitiesMarkdown?: InputMaybe<Scalars['String']['input']>;
  defaultScheduleCron?: InputMaybe<Scalars['String']['input']>;
  defaultScopeToolIds?: InputMaybe<Array<Scalars['String']['input']>>;
  defaultStandupCron?: InputMaybe<Scalars['String']['input']>;
  defaultStandupEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  defaultTimezone?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  eventHookEntityNames?: InputMaybe<Array<Scalars['String']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateDroneSessionInput = {
  completedFiles?: InputMaybe<Scalars['Float']['input']>;
  failedFiles?: InputMaybe<Scalars['Float']['input']>;
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  lastError?: InputMaybe<Scalars['String']['input']>;
  sharePassword?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<DroneSessionStatus>;
  totalBytes?: InputMaybe<Scalars['Float']['input']>;
  totalFiles?: InputMaybe<Scalars['Float']['input']>;
  uploadedBytes?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateEmailAiMemoryInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  body?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<Scalars['Float']['input']>;
  scope?: InputMaybe<EmailAiMemoryScope>;
  scopeValue?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateEmailAiProactiveSettingsInput = {
  activeHoursEnd?: InputMaybe<Scalars['String']['input']>;
  activeHoursStart?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  maxPerSession?: InputMaybe<Scalars['Int']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  weeklyStaleDigest?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateEmailAiRuleInput = {
  actions?: InputMaybe<Array<EmailAiRuleActionInput>>;
  conditionCombinator?: InputMaybe<EmailAiRuleCombinator>;
  conditions?: InputMaybe<Array<EmailAiRuleConditionInput>>;
  description?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateEmployeeActivityInput = {
  activityDate?: InputMaybe<Scalars['DateTime']['input']>;
  activityType?: InputMaybe<Scalars['String']['input']>;
  attachments?: InputMaybe<Array<EmployeeActivityAttachmentInput>>;
  details?: InputMaybe<Scalars['String']['input']>;
  isPrivate?: InputMaybe<Scalars['Boolean']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateEmployeeActivityTagInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Personal fields HR can update on an employee's linked Client record. Includes fName/lName so HR can correct typos (Katie 2026-05-05) without the delete-and-recreate dance. */
export type UpdateEmployeeClientPersonalInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  fName?: InputMaybe<Scalars['String']['input']>;
  lName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateEmployeeContractTemplateInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  awardCode?: InputMaybe<ContractAwardCode>;
  awardName?: InputMaybe<Scalars['String']['input']>;
  employmentBasis?: InputMaybe<ContractEmploymentBasis>;
  /** Changing the body bumps `version`. */
  markdown?: InputMaybe<Scalars['String']['input']>;
  mergeFields?: InputMaybe<Array<ContractMergeFieldInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateEmployeeFormSettingInput = {
  adpClientId?: InputMaybe<Scalars['String']['input']>;
  adpClientName?: InputMaybe<Scalars['String']['input']>;
  adpCompanyGroupCode?: InputMaybe<Scalars['String']['input']>;
  adpDefaultThresholdLoading?: InputMaybe<Scalars['Boolean']['input']>;
  adpDefaultVoluntaryAgreement?: InputMaybe<Scalars['Boolean']['input']>;
  defaultFundAbn?: InputMaybe<Scalars['String']['input']>;
  defaultFundName?: InputMaybe<Scalars['String']['input']>;
  defaultFundUsi?: InputMaybe<Scalars['String']['input']>;
  employerAbn?: InputMaybe<Scalars['String']['input']>;
  employerBusinessName?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  formType: EmployeeFormType;
  mandatory?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateEmployeeIncidentInput = {
  reviewNotes?: InputMaybe<Scalars['String']['input']>;
  reviewedByName?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<EmployeeIncidentStatus>;
};

export type UpdateEmployeeIncidentNotificationRuleInput = {
  channels?: InputMaybe<Array<Scalars['String']['input']>>;
  id: Scalars['ID']['input'];
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  messageTemplate?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  recipientIds?: InputMaybe<Array<Scalars['String']['input']>>;
  recipientRole?: InputMaybe<Scalars['String']['input']>;
  recipientType?: InputMaybe<EmployeeIncidentNotificationRecipientType>;
  trigger?: InputMaybe<EmployeeIncidentNotificationTrigger>;
};

export type UpdateEmployeeInput = {
  address?: InputMaybe<EmployeeAddressInput>;
  adpLeaveBalanceAsAt?: InputMaybe<Scalars['DateTime']['input']>;
  adpOpeningAnnualLeaveHours?: InputMaybe<Scalars['Float']['input']>;
  adpOpeningLongServiceLeaveHours?: InputMaybe<Scalars['Float']['input']>;
  adpOpeningPersonalLeaveHours?: InputMaybe<Scalars['Float']['input']>;
  agencyCompany?: InputMaybe<Scalars['String']['input']>;
  annualLeaveEntitlementHours?: InputMaybe<Scalars['Float']['input']>;
  annualSalary?: InputMaybe<Scalars['Float']['input']>;
  awardClassificationId?: InputMaybe<Scalars['String']['input']>;
  bankAccountName?: InputMaybe<Scalars['String']['input']>;
  bankAccountNumber?: InputMaybe<Scalars['String']['input']>;
  bankBSB?: InputMaybe<Scalars['String']['input']>;
  carRegistration?: InputMaybe<Scalars['String']['input']>;
  certifications?: InputMaybe<Array<Scalars['String']['input']>>;
  claimsTaxFreeThreshold?: InputMaybe<Scalars['Boolean']['input']>;
  claimsThresholdLoading?: InputMaybe<Scalars['Boolean']['input']>;
  clientId?: InputMaybe<Scalars['ID']['input']>;
  companyId?: InputMaybe<Scalars['ID']['input']>;
  contractType?: InputMaybe<Scalars['String']['input']>;
  credentials?: InputMaybe<EmployeeCredentialsInput>;
  customAwardName?: InputMaybe<Scalars['String']['input']>;
  dateDeclinedPTLetterSent?: InputMaybe<Scalars['DateTime']['input']>;
  dateOfBirth?: InputMaybe<Scalars['DateTime']['input']>;
  dateOfferedPT?: InputMaybe<Scalars['DateTime']['input']>;
  dateTfnSigned?: InputMaybe<Scalars['DateTime']['input']>;
  departmentIds?: InputMaybe<Array<Scalars['String']['input']>>;
  emergencyContact?: InputMaybe<EmployeeEmergencyContactInput>;
  employeeNumber?: InputMaybe<Scalars['String']['input']>;
  employmentType?: InputMaybe<EmploymentType>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  hasStudyTrainingLoan?: InputMaybe<Scalars['Boolean']['input']>;
  hasVoluntaryAgreement?: InputMaybe<Scalars['Boolean']['input']>;
  hourlyRate?: InputMaybe<Scalars['Float']['input']>;
  hoursBasis?: InputMaybe<HoursBasis>;
  isShiftWorker?: InputMaybe<Scalars['Boolean']['input']>;
  locationIds?: InputMaybe<Array<Scalars['String']['input']>>;
  maxHoursPerWeek?: InputMaybe<Scalars['Float']['input']>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  minHoursPerWeek?: InputMaybe<Scalars['Float']['input']>;
  minimumHoursPerFortnight?: InputMaybe<Scalars['Float']['input']>;
  mobileNumber?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  payFrequency?: InputMaybe<Scalars['String']['input']>;
  payPointCode?: InputMaybe<Scalars['String']['input']>;
  payRates?: InputMaybe<Array<EmployeePayRateEntryInput>>;
  payeeAbn?: InputMaybe<Scalars['String']['input']>;
  paymentType?: InputMaybe<PaymentType>;
  personalLeaveEntitlementHours?: InputMaybe<Scalars['Float']['input']>;
  position?: InputMaybe<Scalars['String']['input']>;
  positionIds?: InputMaybe<Array<Scalars['String']['input']>>;
  preferredName?: InputMaybe<Scalars['String']['input']>;
  profilePhoto?: InputMaybe<Scalars['String']['input']>;
  profilePhotoCid?: InputMaybe<Scalars['String']['input']>;
  qualifications?: InputMaybe<Array<Scalars['String']['input']>>;
  reportingTo?: InputMaybe<Scalars['String']['input']>;
  reportsToEmployeeId?: InputMaybe<Scalars['String']['input']>;
  responsibilitiesMarkdown?: InputMaybe<Scalars['String']['input']>;
  roleIds?: InputMaybe<Array<Scalars['String']['input']>>;
  roleRates?: InputMaybe<Array<EmployeeRoleRateEntryInput>>;
  smsfAbn?: InputMaybe<Scalars['String']['input']>;
  smsfBankAccountName?: InputMaybe<Scalars['String']['input']>;
  smsfBankAccountNumber?: InputMaybe<Scalars['String']['input']>;
  smsfBankBSB?: InputMaybe<Scalars['String']['input']>;
  smsfEsa?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  superChoiceType?: InputMaybe<SuperChoiceType>;
  superFundABN?: InputMaybe<Scalars['String']['input']>;
  superFundUSI?: InputMaybe<Scalars['String']['input']>;
  superMemberNumber?: InputMaybe<Scalars['String']['input']>;
  superNameOnAccount?: InputMaybe<Scalars['String']['input']>;
  superannuationFund?: InputMaybe<Scalars['String']['input']>;
  taxFileNumber?: InputMaybe<Scalars['String']['input']>;
  taxResidencyStatus?: InputMaybe<TaxResidencyStatus>;
  taxScale?: InputMaybe<Scalars['String']['input']>;
  terminationReason?: InputMaybe<Scalars['String']['input']>;
  visaCountry?: InputMaybe<Scalars['String']['input']>;
  workEmail?: InputMaybe<Scalars['String']['input']>;
  workPhone?: InputMaybe<Scalars['String']['input']>;
  workingRights?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateEmployeeModuleSettingInput = {
  /** Company that employs this site's staff. Pass null to clear it. */
  employerCompanyId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateEmployeeNotificationRuleInput = {
  channels?: InputMaybe<Array<Scalars['String']['input']>>;
  chatRecipientCooldownMinutes?: InputMaybe<Scalars['Float']['input']>;
  chatSessionGapMinutes?: InputMaybe<Scalars['Float']['input']>;
  filterDepartmentId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  inviteLetterBody?: InputMaybe<Scalars['String']['input']>;
  inviteLetterSubject?: InputMaybe<Scalars['String']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  messageTemplate?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  recipientDepartmentId?: InputMaybe<Scalars['String']['input']>;
  recipientIds?: InputMaybe<Array<Scalars['String']['input']>>;
  recipientRole?: InputMaybe<Scalars['String']['input']>;
  recipientType?: InputMaybe<EmployeeNotificationRecipientType>;
  trigger?: InputMaybe<EmployeeNotificationTrigger>;
};

export type UpdateEmployeePositionInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayOrder?: InputMaybe<Scalars['Float']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateEmployeeReportsToInput = {
  employeeId: Scalars['ID']['input'];
  /** New manager Employee id, or null to unassign (move back to sidebar). */
  newReportsToEmployeeId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateEmployeeRoleInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  countsTowardCareMinutes?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayOrder?: InputMaybe<Scalars['Float']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  shortCode?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateEmployeeStatusOptionInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayOrder?: InputMaybe<Scalars['Float']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateEmployeeTrainingAssignmentInput = {
  categoryId?: InputMaybe<Scalars['ID']['input']>;
  dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<EmployeeTrainingPriority>;
  status?: InputMaybe<EmployeeTrainingStatus>;
  trainingType?: InputMaybe<EmployeeTrainingType>;
};

export type UpdateEmployeeTrainingCategoryInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayOrder?: InputMaybe<Scalars['Float']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isRequired?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  renewalPeriodMonths?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateEmpowermentCatchUpInput = {
  catchUpId: Scalars['ID']['input'];
  notesMarkdown?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<EmpowermentCatchUpStatus>;
};

export type UpdateEmpowermentGoalInput = {
  goalId: Scalars['ID']['input'];
  targetDate?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  whyMarkdown?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateEmpowermentJourneyInput = {
  journeyId: Scalars['ID']['input'];
  managerClientIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  probationMonths?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateEmpowermentSettingsInput = {
  defaultProbationMonths?: InputMaybe<Scalars['Int']['input']>;
  departmentHeads?: InputMaybe<Array<EmpowermentDepartmentHeadInput>>;
  enrolmentEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  enrolmentManagerClientIds?: InputMaybe<Array<Scalars['String']['input']>>;
  enrolmentScope?: InputMaybe<EmpowermentEnrolmentScope>;
  followUpDefaultDays?: InputMaybe<Scalars['Int']['input']>;
  introMarkdown?: InputMaybe<Scalars['String']['input']>;
  lowScoreThreshold?: InputMaybe<Scalars['Int']['input']>;
  managerScope?: InputMaybe<EmpowermentManagerScope>;
  milestones?: InputMaybe<Array<EmpowermentMilestoneDefInput>>;
  opensDaysBefore?: InputMaybe<Scalars['Int']['input']>;
  promptMode?: InputMaybe<EmpowermentPromptMode>;
  reportsMinResponses?: InputMaybe<Scalars['Int']['input']>;
  revealRule?: InputMaybe<EmpowermentRevealRule>;
  supportMarkdown?: InputMaybe<Scalars['String']['input']>;
  welcomeSpreadWeeks?: InputMaybe<Scalars['Int']['input']>;
  welcomeWeeklyCapPerManager?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateEnergyTrackerNotificationRuleInput = {
  channels?: InputMaybe<Array<Scalars['String']['input']>>;
  id: Scalars['ID']['input'];
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  messageTemplate?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  recipientIds?: InputMaybe<Array<Scalars['String']['input']>>;
  recipientType?: InputMaybe<EnergyTrackerRecipientType>;
  timing?: InputMaybe<EnergyTrackerNotificationTiming>;
  timingMinutes?: InputMaybe<Scalars['Float']['input']>;
  trigger?: InputMaybe<EnergyTrackerNotificationTrigger>;
};

export type UpdateFarmerInput = {
  aboutSection?: InputMaybe<FarmerAboutSectionInput>;
  allowedEditors?: InputMaybe<Array<Scalars['String']['input']>>;
  branding?: InputMaybe<FarmerBrandingInput>;
  contactInfo?: InputMaybe<FarmerContactInfoInput>;
  enableBlog?: InputMaybe<Scalars['Boolean']['input']>;
  enableCSA?: InputMaybe<Scalars['Boolean']['input']>;
  enableNewsletter?: InputMaybe<Scalars['Boolean']['input']>;
  enableRecipes?: InputMaybe<Scalars['Boolean']['input']>;
  enableReviews?: InputMaybe<Scalars['Boolean']['input']>;
  featuredProducts?: InputMaybe<Array<FarmerProductShowcaseInput>>;
  heroSection?: InputMaybe<FarmerHeroSectionInput>;
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  seoSettings?: InputMaybe<FarmerSeoSettingsInput>;
  status?: InputMaybe<FarmerStatus>;
  urlSlug?: InputMaybe<Scalars['String']['input']>;
  valuePropositions?: InputMaybe<Array<FarmerValuePropositionInput>>;
};

export type UpdateFeedbackInput = {
  aboutResident?: InputMaybe<Scalars['String']['input']>;
  dueDate?: InputMaybe<Scalars['String']['input']>;
  fromOther?: InputMaybe<Scalars['String']['input']>;
  fromType?: InputMaybe<FeedbackFrom>;
  isConfidential?: InputMaybe<Scalars['Boolean']['input']>;
  kind?: InputMaybe<FeedbackKind>;
  room?: InputMaybe<Scalars['String']['input']>;
  topic?: InputMaybe<FeedbackTopic>;
  wing?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateFeedbackNotificationRuleInput = {
  channels?: InputMaybe<Array<FeedbackNotificationChannel>>;
  filterKind?: InputMaybe<Scalars['String']['input']>;
  filterTopic?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  recipientIds?: InputMaybe<Array<Scalars['String']['input']>>;
  recipientRole?: InputMaybe<Scalars['String']['input']>;
  recipientType?: InputMaybe<FeedbackNotificationRecipientType>;
  trigger?: InputMaybe<FeedbackNotificationTrigger>;
};

export type UpdateFeedbackSettingsInput = {
  defaultAssigneeId?: InputMaybe<Scalars['ID']['input']>;
  emailDefaultAssignee?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateFileTransferInput = {
  checksum?: InputMaybe<Scalars['String']['input']>;
  checksumVerified?: InputMaybe<Scalars['Boolean']['input']>;
  cloudUrl?: InputMaybe<Scalars['String']['input']>;
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  ipfsHash?: InputMaybe<Scalars['String']['input']>;
  mediaItemId?: InputMaybe<Scalars['String']['input']>;
  stagingPath?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<FileTransferState>;
  totalChunks?: InputMaybe<Scalars['Float']['input']>;
  uploadId?: InputMaybe<Scalars['String']['input']>;
  uploadedBytes?: InputMaybe<Scalars['Float']['input']>;
  uploadedChunks?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateFoodBudgetInput = {
  currency?: InputMaybe<Scalars['String']['input']>;
  financialYearStartMonth?: InputMaybe<Scalars['Int']['input']>;
  monthlyBudget?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateFrontendUpgradeInput = {
  category?: InputMaybe<UpgradeCategory>;
  description?: InputMaybe<Scalars['String']['input']>;
  gitCommitUrls?: InputMaybe<Array<Scalars['String']['input']>>;
  markdownDocumentation?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateFuelStationInput = {
  id: Scalars['ID']['input'];
  operatingHours?: InputMaybe<Scalars['String']['input']>;
  stressStatus?: InputMaybe<StressStatus>;
};

export type UpdateGoalActionInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<ActionStatus>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateGoalCheckpointInput = {
  assignedTo?: InputMaybe<Scalars['String']['input']>;
  checkpointId: Scalars['String']['input'];
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  goalId: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateGoalProgressInput = {
  notes?: InputMaybe<Scalars['String']['input']>;
  progress?: InputMaybe<Scalars['String']['input']>;
  progressPercentage?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<CarePlanGoalStatus>;
};

export type UpdateGovJobSpecInput = {
  doneLooksLike?: InputMaybe<Scalars['String']['input']>;
  estimatedHours?: InputMaybe<Scalars['Float']['input']>;
  evidenceRequired?: InputMaybe<Scalars['String']['input']>;
  priceTokens?: InputMaybe<Scalars['Float']['input']>;
  publicListed?: InputMaybe<Scalars['Boolean']['input']>;
  sopEpisodeId?: InputMaybe<Scalars['ID']['input']>;
  steps?: InputMaybe<Scalars['String']['input']>;
  summary?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateGovMemberInput = {
  abn?: InputMaybe<Scalars['String']['input']>;
  businessName?: InputMaybe<Scalars['String']['input']>;
  paidThrough?: InputMaybe<Scalars['String']['input']>;
  planId?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<GovMemberRole>;
  status?: InputMaybe<GovMemberStatus>;
  votingWeight?: InputMaybe<Scalars['Float']['input']>;
  walletAddress?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateGovMembershipPlanInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  gstInclusive?: InputMaybe<Scalars['Boolean']['input']>;
  interval?: InputMaybe<GovPlanInterval>;
  name?: InputMaybe<Scalars['String']['input']>;
  priceCents?: InputMaybe<Scalars['Int']['input']>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateGovNotificationRuleInput = {
  channels?: InputMaybe<Array<GovNotificationChannel>>;
  customMessage?: InputMaybe<Scalars['String']['input']>;
  hoursBefore?: InputMaybe<Scalars['Int']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  recipientEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  recipientType?: InputMaybe<GovNotificationRecipientType>;
};

export type UpdateGovOrganisationInput = {
  admitWithoutApproval?: InputMaybe<Scalars['Boolean']['input']>;
  chainId?: InputMaybe<Scalars['Int']['input']>;
  defaultPassThresholdPercent?: InputMaybe<Scalars['Int']['input']>;
  defaultQuorumPercent?: InputMaybe<Scalars['Int']['input']>;
  defaultVotingHours?: InputMaybe<Scalars['Int']['input']>;
  digestDayOfWeek?: InputMaybe<Scalars['Int']['input']>;
  draftModel?: InputMaybe<Scalars['String']['input']>;
  jobSpecAdoption?: InputMaybe<GovJobSpecAdoption>;
  joinRequireAbn?: InputMaybe<Scalars['Boolean']['input']>;
  joinRequireBusinessName?: InputMaybe<Scalars['Boolean']['input']>;
  joinRequirePhone?: InputMaybe<Scalars['Boolean']['input']>;
  legalWrapper?: InputMaybe<GovLegalWrapper>;
  membershipGraceDays?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  participationDefaults?: InputMaybe<GovParticipationDefaultsInput>;
  publicMemberList?: InputMaybe<Scalars['Boolean']['input']>;
  publicPageEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  publicProof?: InputMaybe<Scalars['Boolean']['input']>;
  purpose?: InputMaybe<Scalars['String']['input']>;
  registrationNumber?: InputMaybe<Scalars['String']['input']>;
  rulesMarkdown?: InputMaybe<Scalars['String']['input']>;
  safeAddress?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  snapshotSpaceEns?: InputMaybe<Scalars['String']['input']>;
  sponsorsRequired?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<GovOrganisationStatus>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  tokenJourneyMarkdown?: InputMaybe<Scalars['String']['input']>;
  tokenKind?: InputMaybe<GovTokenKind>;
  tokenSymbol?: InputMaybe<Scalars['String']['input']>;
  treasuryPolicyMarkdown?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateGovParticipationInput = {
  digestFrequency?: InputMaybe<GovDigestFrequency>;
  emailEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<GovParticipationLevel>;
  notifyOnClosingSoon?: InputMaybe<Scalars['Boolean']['input']>;
  notifyOnDelegateVoted?: InputMaybe<Scalars['Boolean']['input']>;
  notifyOnMemberJoined?: InputMaybe<Scalars['Boolean']['input']>;
  notifyOnProposalClosed?: InputMaybe<Scalars['Boolean']['input']>;
  notifyOnProposalOpened?: InputMaybe<Scalars['Boolean']['input']>;
  notifyOnWorkOpened?: InputMaybe<Scalars['Boolean']['input']>;
  smsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateGovProposalInput = {
  attachments?: InputMaybe<Array<GovFileInput>>;
  body?: InputMaybe<Scalars['String']['input']>;
  changeNote?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateHarvestedVideoInput = {
  ipfsPublic?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateHolisticSnapshotInput = {
  notes?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateHostingAffiliateInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  defaultPercent?: InputMaybe<Scalars['Float']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateHostingOfferInput = {
  currency?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  monthlyPrice?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  subscriptionProductId?: InputMaybe<Scalars['ID']['input']>;
  subscriptionProductSlug?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateHostingReferralInput = {
  notes?: InputMaybe<Scalars['String']['input']>;
  percent?: InputMaybe<Scalars['Float']['input']>;
  referredEmail?: InputMaybe<Scalars['String']['input']>;
  referredName?: InputMaybe<Scalars['String']['input']>;
  subscriptionId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateHostingSiteInput = {
  branch?: InputMaybe<Scalars['String']['input']>;
  disabledReason?: InputMaybe<Scalars['String']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  liveUrl?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  ownerClientId?: InputMaybe<Scalars['ID']['input']>;
  repoUrl?: InputMaybe<Scalars['String']['input']>;
  vercelDeployHookUrl?: InputMaybe<Scalars['String']['input']>;
  vercelProjectId?: InputMaybe<Scalars['String']['input']>;
  vercelTeamId?: InputMaybe<Scalars['String']['input']>;
  viewerClientIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type UpdateInboxSummaryPreferenceInput = {
  frequency?: InputMaybe<InboxSummaryFrequency>;
  routeToEmployeeWorkEmailFirst?: InputMaybe<Scalars['Boolean']['input']>;
  sendViaEmail?: InputMaybe<Scalars['Boolean']['input']>;
  sendViaSms?: InputMaybe<Scalars['Boolean']['input']>;
  timeOfDay?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateIncidentInput = {
  comments?: InputMaybe<Scalars['String']['input']>;
  contributingFactorId?: InputMaybe<Scalars['ID']['input']>;
  hasInjury?: InputMaybe<Scalars['Boolean']['input']>;
  hospitalDetails?: InputMaybe<Scalars['String']['input']>;
  incidentTypeId?: InputMaybe<Scalars['ID']['input']>;
  injuryDescription?: InputMaybe<Scalars['String']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  logDate?: InputMaybe<Scalars['DateTime']['input']>;
  logTime?: InputMaybe<Scalars['String']['input']>;
  wasHospitalized?: InputMaybe<Scalars['Boolean']['input']>;
  wing?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateIncidentLocationInput = {
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  wing?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateIncidentTypeInput = {
  category?: InputMaybe<IncidentCategory>;
  defaultContributingFactorIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  requiresRiskAssessment?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateInfluencerInput = {
  acceptingCampaigns?: InputMaybe<Scalars['Boolean']['input']>;
  achievements?: InputMaybe<Array<Scalars['String']['input']>>;
  bio?: InputMaybe<Scalars['String']['input']>;
  contentSamples?: InputMaybe<Array<Scalars['String']['input']>>;
  countries?: InputMaybe<Array<Scalars['String']['input']>>;
  coverImage?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  fName?: InputMaybe<Scalars['String']['input']>;
  lName?: InputMaybe<Scalars['String']['input']>;
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
  metrics?: InputMaybe<InfluencerMetricsInput>;
  minimumRate?: InputMaybe<Scalars['Float']['input']>;
  niches?: InputMaybe<Array<ContentNiche>>;
  notes?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  preferredContactMethod?: InputMaybe<Scalars['String']['input']>;
  profileImage?: InputMaybe<Scalars['String']['input']>;
  socialAccounts?: InputMaybe<Array<SocialMediaAccountInput>>;
  specializations?: InputMaybe<Array<Scalars['String']['input']>>;
  status?: InputMaybe<InfluencerStatus>;
  websiteUrl?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateIngredientInput = {
  category?: InputMaybe<IngredientCategory>;
  conversions?: InputMaybe<Array<IngredientConversionInput>>;
  defaultUnit?: InputMaybe<UnitType>;
  description?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  minOrderQty?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  purchaseUnitsPerRecipeUnit?: InputMaybe<Scalars['Float']['input']>;
  purchasedUnit?: InputMaybe<UnitType>;
  shelfLifeDays?: InputMaybe<Scalars['Float']['input']>;
  storageInstructions?: InputMaybe<Scalars['String']['input']>;
  supplierId?: InputMaybe<Scalars['ID']['input']>;
  supplierSku?: InputMaybe<Scalars['String']['input']>;
  unitCost?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateIngredientResult = {
  __typename?: 'UpdateIngredientResult';
  ingredient: Ingredient;
  unitSyncReport: UnitSyncReport;
};

export type UpdateInvestmentProjectInput = {
  businessModel?: InputMaybe<Scalars['String']['input']>;
  capitalRaised?: InputMaybe<Scalars['Float']['input']>;
  capitalRequired?: InputMaybe<Scalars['Float']['input']>;
  companyRegistration?: InputMaybe<Scalars['String']['input']>;
  coverImageUrl?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  galleryImageUrls?: InputMaybe<Array<Scalars['String']['input']>>;
  hasEmploymentContracts?: InputMaybe<Scalars['Boolean']['input']>;
  hasFullTimeEmployees?: InputMaybe<Scalars['Boolean']['input']>;
  hasPhysicalOffice?: InputMaybe<Scalars['Boolean']['input']>;
  highlights?: InputMaybe<Array<Scalars['String']['input']>>;
  investmentCommitteeRole?: InputMaybe<Scalars['Boolean']['input']>;
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  minimumInvestment?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  passiveInvestmentMinimum?: InputMaybe<Scalars['Float']['input']>;
  risks?: InputMaybe<Array<Scalars['String']['input']>>;
  sector?: InputMaybe<ProjectSector>;
  shortDescription?: InputMaybe<Scalars['String']['input']>;
  stage?: InputMaybe<ProjectStage>;
  status?: InputMaybe<ProjectStatus>;
  subSector?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  targetReturn?: InputMaybe<Scalars['String']['input']>;
  visaSuitable?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateInvestorInput = {
  amlDocumentsReady?: InputMaybe<Scalars['Boolean']['input']>;
  assignedTo?: InputMaybe<Scalars['String']['input']>;
  clientId?: InputMaybe<Scalars['String']['input']>;
  countryOfOrigin?: InputMaybe<Scalars['String']['input']>;
  currentLocation?: InputMaybe<Scalars['String']['input']>;
  cvFileUrl?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  entrepreneurialExperience?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  fundsAvailableLocally?: InputMaybe<Scalars['Boolean']['input']>;
  fundsTransferMethod?: InputMaybe<Scalars['String']['input']>;
  intentions?: InputMaybe<Scalars['String']['input']>;
  investmentBudgetMax?: InputMaybe<Scalars['Float']['input']>;
  investmentBudgetMin?: InputMaybe<Scalars['Float']['input']>;
  investorType?: InputMaybe<InvestorType>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  matchedProjectIds?: InputMaybe<Array<Scalars['String']['input']>>;
  phone?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<InvestorPriority>;
  professionalBackground?: InputMaybe<Scalars['String']['input']>;
  riskTolerance?: InputMaybe<RiskTolerance>;
  sectorInterests?: InputMaybe<Array<Scalars['String']['input']>>;
  sourceOfFunds?: InputMaybe<Scalars['String']['input']>;
  sourceOfFundsVerified?: InputMaybe<Scalars['Boolean']['input']>;
  stage?: InputMaybe<InvestorStage>;
  visaExpiryDate?: InputMaybe<Scalars['DateTime']['input']>;
  visaStatus?: InputMaybe<VisaStatus>;
  visaSubclass?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateInvoiceInput = {
  billingAddress?: InputMaybe<Scalars['String']['input']>;
  billingEmail?: InputMaybe<Scalars['String']['input']>;
  discountAmount?: InputMaybe<Scalars['Float']['input']>;
  dueDate?: InputMaybe<Scalars['String']['input']>;
  lineItems?: InputMaybe<Array<InvoiceLineInput>>;
  notes?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<InvoiceStatus>;
  subtotal?: InputMaybe<Scalars['Float']['input']>;
  taxAmount?: InputMaybe<Scalars['Float']['input']>;
  total?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateJobInput = {
  allowedRoleIds?: InputMaybe<Array<Scalars['String']['input']>>;
  area?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<JobCategory>;
  checklist?: InputMaybe<Array<JobChecklistItemInput>>;
  color?: InputMaybe<Scalars['String']['input']>;
  complianceCode?: InputMaybe<Scalars['String']['input']>;
  dayOfMonth?: InputMaybe<Scalars['Float']['input']>;
  daysOfWeek?: InputMaybe<Array<DayOfWeek>>;
  departmentId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  effectiveFrom?: InputMaybe<Scalars['DateTime']['input']>;
  effectiveUntil?: InputMaybe<Scalars['DateTime']['input']>;
  estimatedDurationMinutes?: InputMaybe<Scalars['Float']['input']>;
  frequency?: InputMaybe<JobFrequency>;
  icon?: InputMaybe<Scalars['String']['input']>;
  instructions?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  locationId?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['JSONObject']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<JobPriority>;
  requiredCertifications?: InputMaybe<Array<Scalars['String']['input']>>;
  requiredEquipment?: InputMaybe<Array<Scalars['String']['input']>>;
  requiredSkills?: InputMaybe<Array<Scalars['String']['input']>>;
  requiredStaffCount?: InputMaybe<Scalars['Float']['input']>;
  requiredSupplies?: InputMaybe<Array<Scalars['String']['input']>>;
  requiresDocumentation?: InputMaybe<Scalars['Boolean']['input']>;
  requiresSignOff?: InputMaybe<Scalars['Boolean']['input']>;
  safetyNotes?: InputMaybe<Array<Scalars['String']['input']>>;
  status?: InputMaybe<JobStatus>;
  steps?: InputMaybe<Array<Scalars['String']['input']>>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  timeWindow?: InputMaybe<TimeWindowInput>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateJobVehicleInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  currentOdometer?: InputMaybe<Scalars['Float']['input']>;
  engineCode?: InputMaybe<Scalars['String']['input']>;
  make?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  ownerEmail?: InputMaybe<Scalars['String']['input']>;
  ownerName?: InputMaybe<Scalars['String']['input']>;
  ownerPhone?: InputMaybe<Scalars['String']['input']>;
  photoCid?: InputMaybe<Scalars['String']['input']>;
  photoUrl?: InputMaybe<Scalars['String']['input']>;
  registration?: InputMaybe<Scalars['String']['input']>;
  transmissionType?: InputMaybe<Scalars['String']['input']>;
  variant?: InputMaybe<Scalars['String']['input']>;
  vehicleModel?: InputMaybe<Scalars['String']['input']>;
  vehicleType?: InputMaybe<VehicleType>;
  vin?: InputMaybe<Scalars['String']['input']>;
  year?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateLmSettingsInput = {
  autoMarkOnNext?: InputMaybe<Scalars['Boolean']['input']>;
  autoMarkOnView?: InputMaybe<Scalars['Boolean']['input']>;
  autoMarkScrollThreshold?: InputMaybe<Scalars['Float']['input']>;
  autoMarkTimeThresholdMs?: InputMaybe<Scalars['Float']['input']>;
  autoMarkVideoThreshold?: InputMaybe<Scalars['Float']['input']>;
  showMarkCompleteButton?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateLeadFlowActionInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isHtml?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<LeadFlowActionType>;
};

export type UpdateLeadFlowFormInput = {
  displayStyle?: InputMaybe<LeadFlowFormDisplayStyle>;
  fields?: InputMaybe<Array<LeadFlowFormFieldInput>>;
  id: Scalars['ID']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notificationEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  redirectUrl?: InputMaybe<Scalars['String']['input']>;
  rewardTokensOnSubmit?: InputMaybe<Scalars['Int']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  thankYouMessage?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateLeadFlowNotificationRuleInput = {
  channels?: InputMaybe<Array<Scalars['String']['input']>>;
  id: Scalars['ID']['input'];
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  messageTemplate?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  recipientIds?: InputMaybe<Array<Scalars['String']['input']>>;
  recipientRole?: InputMaybe<Scalars['String']['input']>;
  recipientType?: InputMaybe<LeadFlowNotificationRecipientType>;
  timing?: InputMaybe<LeadFlowNotificationTiming>;
  timingMinutes?: InputMaybe<Scalars['Float']['input']>;
  trigger?: InputMaybe<LeadFlowNotificationTrigger>;
};

export type UpdateLeadFlowSequenceInput = {
  brandingId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  steps?: InputMaybe<Array<LeadFlowSequenceStepInput>>;
};

export type UpdateLeadFlowStageInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateLeadInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  stageId?: InputMaybe<Scalars['String']['input']>;
  stageName?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateLedgerAccountInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isClinical?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  taxType?: InputMaybe<LedgerTaxType>;
  type?: InputMaybe<LedgerAccountType>;
};

export type UpdateLifeAspectInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateLocationInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  building?: InputMaybe<Scalars['String']['input']>;
  capacity?: InputMaybe<Scalars['Float']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  defaultTaskTemplateIds?: InputMaybe<Array<Scalars['String']['input']>>;
  departmentIds?: InputMaybe<Array<Scalars['String']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  floor?: InputMaybe<Scalars['String']['input']>;
  geoCoordinates?: InputMaybe<GeoCoordinatesInput>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  lastCleanedAt?: InputMaybe<Scalars['DateTime']['input']>;
  lastInspectedAt?: InputMaybe<Scalars['DateTime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  parentLocationId?: InputMaybe<Scalars['ID']['input']>;
  qrCheckInEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  sortOrder?: InputMaybe<Scalars['Float']['input']>;
  status?: InputMaybe<LocationStatus>;
  type?: InputMaybe<LocationType>;
};

export type UpdateMaintenanceNotificationRuleInput = {
  channels?: InputMaybe<Array<Scalars['String']['input']>>;
  filterCategory?: InputMaybe<Scalars['String']['input']>;
  filterLocation?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  messageTemplate?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  recipientIds?: InputMaybe<Array<Scalars['String']['input']>>;
  recipientRole?: InputMaybe<Scalars['String']['input']>;
  recipientType?: InputMaybe<MaintenanceNotificationRecipientType>;
  scheduledDay?: InputMaybe<MaintenanceScheduleDay>;
  scheduledHour?: InputMaybe<Scalars['Float']['input']>;
  /** Deprecated: only IMMEDIATE is honoured. */
  timing?: InputMaybe<MaintenanceNotificationTiming>;
  timingMinutes?: InputMaybe<Scalars['Float']['input']>;
  trigger?: InputMaybe<MaintenanceNotificationTrigger>;
};

export type UpdateMaintenanceRequestInput = {
  blockedBy?: InputMaybe<Scalars['ID']['input']>;
  category?: InputMaybe<MaintenanceCategory>;
  details?: InputMaybe<Scalars['String']['input']>;
  estimatedCompletionDate?: InputMaybe<Scalars['DateTime']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  maintenanceItem?: InputMaybe<Scalars['String']['input']>;
  monthlyCheckId?: InputMaybe<Scalars['ID']['input']>;
  occupantPresent?: InputMaybe<Scalars['Boolean']['input']>;
  photos?: InputMaybe<Array<MaintenanceMediaInput>>;
  priority?: InputMaybe<MaintenancePriority>;
  requestedBy?: InputMaybe<RequestedByType>;
  room?: InputMaybe<Scalars['String']['input']>;
  statusNotes?: InputMaybe<Scalars['String']['input']>;
  wing?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateMealFeedbackInput = {
  comments?: InputMaybe<Scalars['String']['input']>;
  feedbackType?: InputMaybe<FeedbackType>;
  isResolved?: InputMaybe<Scalars['Boolean']['input']>;
  rating?: InputMaybe<Scalars['Float']['input']>;
  resolutionNotes?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateMealPlanInput = {
  accompaniments?: InputMaybe<Array<MealAccompanimentInput>>;
  mealDate?: InputMaybe<Scalars['String']['input']>;
  mealType?: InputMaybe<MealType>;
  quickDescription?: InputMaybe<Scalars['String']['input']>;
  recipeId?: InputMaybe<Scalars['ID']['input']>;
  servings?: InputMaybe<Scalars['Float']['input']>;
  specialNotes?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateMealPlanNotificationRuleInput = {
  channels?: InputMaybe<Array<Scalars['String']['input']>>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  messageTemplate?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  recipientClientIds?: InputMaybe<Array<Scalars['String']['input']>>;
  recipientRole?: InputMaybe<Scalars['String']['input']>;
  recipientType?: InputMaybe<MealPlanNotificationRecipientType>;
  trigger?: InputMaybe<MealPlanNotificationTrigger>;
};

export type UpdateMealPlanningSettingsInput = {
  cycleAnchorDate: Scalars['String']['input'];
  cycleWeeks?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateMechanicJobInput = {
  customerAddress?: InputMaybe<Scalars['String']['input']>;
  customerEmail?: InputMaybe<Scalars['String']['input']>;
  customerName?: InputMaybe<Scalars['String']['input']>;
  customerPhone?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  estimatedDuration?: InputMaybe<Scalars['Float']['input']>;
  laborCost?: InputMaybe<Scalars['Float']['input']>;
  mechanicNotes?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<MechanicJobPriority>;
  scheduledDate?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledTime?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  vehicles?: InputMaybe<Array<JobVehicleRefInput>>;
};

export type UpdateMechanicNotificationRuleInput = {
  channels?: InputMaybe<Array<MechanicNotificationChannel>>;
  dailyCap?: InputMaybe<Scalars['Int']['input']>;
  isArmed?: InputMaybe<Scalars['Boolean']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  messageTemplate?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  recipientClientIds?: InputMaybe<Array<Scalars['String']['input']>>;
  recipientType?: InputMaybe<MechanicNotificationRecipientType>;
  trigger?: InputMaybe<MechanicNotificationTrigger>;
};

export type UpdateMediaFolderInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateMediaItemInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  folderId?: InputMaybe<Scalars['String']['input']>;
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateMedicalRecordsShiftRuleInput = {
  exemptPermissions: Array<Scalars['String']['input']>;
  requireOnShift: Scalars['Boolean']['input'];
};

export type UpdateMedicationInput = {
  administrationTimes?: InputMaybe<Array<Scalars['String']['input']>>;
  crushable?: InputMaybe<Scalars['Boolean']['input']>;
  genericName?: InputMaybe<Scalars['String']['input']>;
  highAlertMedication?: InputMaybe<Scalars['Boolean']['input']>;
  selfAdministered?: InputMaybe<Scalars['Boolean']['input']>;
  specialInstructions?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateMeetRecordingInput = {
  processed?: InputMaybe<Scalars['Boolean']['input']>;
  transcription?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateMilestoneInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  targetDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UpdateMobilityAidsInput = {
  assistanceRequired?: InputMaybe<Scalars['Float']['input']>;
  dentureNotes?: InputMaybe<Scalars['String']['input']>;
  dentureType?: InputMaybe<Scalars['String']['input']>;
  dentures?: InputMaybe<Scalars['Boolean']['input']>;
  fireEvacAssistance?: InputMaybe<Scalars['Float']['input']>;
  fireEvacMobility?: InputMaybe<Scalars['String']['input']>;
  fireEvacSensory?: InputMaybe<Scalars['String']['input']>;
  glasses?: InputMaybe<Scalars['Boolean']['input']>;
  glassesNotes?: InputMaybe<Scalars['String']['input']>;
  glassesType?: InputMaybe<Scalars['String']['input']>;
  hearingAid?: InputMaybe<Scalars['Boolean']['input']>;
  hearingAidNotes?: InputMaybe<Scalars['String']['input']>;
  hearingAidType?: InputMaybe<Scalars['String']['input']>;
  manualHandlingNotes?: InputMaybe<Scalars['String']['input']>;
  mobilityAids?: InputMaybe<Array<Scalars['String']['input']>>;
  mobilityLevel?: InputMaybe<MedicationMobilityLevel>;
  otherAids?: InputMaybe<Array<Scalars['String']['input']>>;
  otherAidsUsed?: InputMaybe<Scalars['String']['input']>;
  pacemaker?: InputMaybe<Scalars['Boolean']['input']>;
  pacemakerInsertDate?: InputMaybe<Scalars['DateTime']['input']>;
  pacemakerNotes?: InputMaybe<Scalars['String']['input']>;
  pacemakerType?: InputMaybe<Scalars['String']['input']>;
  selfMedicates?: InputMaybe<Scalars['Boolean']['input']>;
  selfMedicatesNotes?: InputMaybe<Scalars['String']['input']>;
  sensoryHearing?: InputMaybe<Scalars['String']['input']>;
  sensoryVision?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateMonthlyChecklistSettingsInput = {
  cutoffDayOfMonth?: InputMaybe<Scalars['Float']['input']>;
  enabledLocationTypes?: InputMaybe<Array<LocationType>>;
  /** Deprecated: stored but never acted on. */
  remindersEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateMoodEntryInput = {
  emotionZone?: InputMaybe<EmotionZone>;
  energyLevel?: InputMaybe<Scalars['Int']['input']>;
  moodLabel?: InputMaybe<Scalars['String']['input']>;
  moodScore?: InputMaybe<Scalars['Int']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  selectedEmotions?: InputMaybe<Array<Scalars['String']['input']>>;
  stressLevel?: InputMaybe<Scalars['Int']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Client fields an employee can update on their own profile */
export type UpdateMyClientProfileInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  fName?: InputMaybe<Scalars['String']['input']>;
  lName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

/** Fields an employee can update on their own profile */
export type UpdateMyEmployeeProfileInput = {
  address?: InputMaybe<EmployeeAddressInput>;
  bankAccountName?: InputMaybe<Scalars['String']['input']>;
  bankAccountNumber?: InputMaybe<Scalars['String']['input']>;
  bankBSB?: InputMaybe<Scalars['String']['input']>;
  certifications?: InputMaybe<Array<Scalars['String']['input']>>;
  claimsTaxFreeThreshold?: InputMaybe<Scalars['Boolean']['input']>;
  dateOfBirth?: InputMaybe<Scalars['DateTime']['input']>;
  emergencyContact?: InputMaybe<EmployeeEmergencyContactInput>;
  gender?: InputMaybe<Scalars['String']['input']>;
  hasStudyTrainingLoan?: InputMaybe<Scalars['Boolean']['input']>;
  preferredName?: InputMaybe<Scalars['String']['input']>;
  profilePhoto?: InputMaybe<Scalars['String']['input']>;
  profilePhotoCid?: InputMaybe<Scalars['String']['input']>;
  qualifications?: InputMaybe<Array<Scalars['String']['input']>>;
  smsfAbn?: InputMaybe<Scalars['String']['input']>;
  smsfBankAccountName?: InputMaybe<Scalars['String']['input']>;
  smsfBankAccountNumber?: InputMaybe<Scalars['String']['input']>;
  smsfBankBSB?: InputMaybe<Scalars['String']['input']>;
  smsfEsa?: InputMaybe<Scalars['String']['input']>;
  superChoiceType?: InputMaybe<SuperChoiceType>;
  superFundABN?: InputMaybe<Scalars['String']['input']>;
  superFundUSI?: InputMaybe<Scalars['String']['input']>;
  superMemberNumber?: InputMaybe<Scalars['String']['input']>;
  superNameOnAccount?: InputMaybe<Scalars['String']['input']>;
  superannuationFund?: InputMaybe<Scalars['String']['input']>;
  taxFileNumber?: InputMaybe<Scalars['String']['input']>;
  taxResidencyStatus?: InputMaybe<TaxResidencyStatus>;
  visaCountry?: InputMaybe<Scalars['String']['input']>;
  workingRights?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateNameserversInput = {
  domainId: Scalars['ID']['input'];
  nameservers: Array<Scalars['String']['input']>;
};

export type UpdateNeurologicalPeriodInput = {
  comments?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  frequencyHours?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateNotificationContactsInput = {
  contacts: Array<NotificationContactInput>;
};

export type UpdateOrgChartConfigInput = {
  defaultZoom?: InputMaybe<Scalars['Float']['input']>;
  departmentColorOverrides?: InputMaybe<Scalars['JSONObject']['input']>;
  designatedRootEmployeeId?: InputMaybe<Scalars['String']['input']>;
  designatedRootPlacementId?: InputMaybe<Scalars['String']['input']>;
  layoutDirection?: InputMaybe<OrgChartLayoutDirection>;
  showDigitalManagers?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateP2ActionInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isHtml?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<P2ActionType>;
};

export type UpdateP2CampaignMessageInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  channel?: InputMaybe<P2MessageChannel>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Float']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateP2DailyChaseConfigInput = {
  campaignIds?: InputMaybe<Array<Scalars['String']['input']>>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  preferredTime?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateP2NotificationRuleInput = {
  channels?: InputMaybe<Array<Scalars['String']['input']>>;
  id: Scalars['ID']['input'];
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  messageTemplate?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  recipientIds?: InputMaybe<Array<Scalars['String']['input']>>;
  recipientType?: InputMaybe<P2NotificationRecipientType>;
  timing?: InputMaybe<P2NotificationTiming>;
  timingMinutes?: InputMaybe<Scalars['Float']['input']>;
  trigger?: InputMaybe<P2NotificationTrigger>;
};

export type UpdateP2SupplierInput = {
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactName?: InputMaybe<Scalars['String']['input']>;
  contactPhone?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  leadTimeDays?: InputMaybe<Scalars['Float']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  moq?: InputMaybe<Scalars['Float']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  shippingCostEstimate?: InputMaybe<Scalars['Float']['input']>;
  status?: InputMaybe<P2SupplierStatus>;
  supplierName?: InputMaybe<Scalars['String']['input']>;
  unitCost?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdatePProposalInput = {
  agreementMarkdown?: InputMaybe<Scalars['String']['input']>;
  clientEmail?: InputMaybe<Scalars['String']['input']>;
  clientName?: InputMaybe<Scalars['String']['input']>;
  clientPhone?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  lineItems?: InputMaybe<Array<PProposalLineItemInput>>;
  notes?: InputMaybe<Scalars['String']['input']>;
  notifyEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  notifyOnSign?: InputMaybe<Scalars['Boolean']['input']>;
  notifyOnView?: InputMaybe<Scalars['Boolean']['input']>;
  opportunityId?: InputMaybe<Scalars['ID']['input']>;
  paymentSchedule?: InputMaybe<Array<PProposalPaymentScheduleItemInput>>;
  priority?: InputMaybe<PProposalPriority>;
  proposalType?: InputMaybe<PProposalType>;
  requiredSignerCount?: InputMaybe<Scalars['Int']['input']>;
  signerInstructions?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<PProposalStatus>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  title?: InputMaybe<Scalars['String']['input']>;
  totalValue?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdatePageViewInput = {
  pageViewId: Scalars['String']['input'];
  scrollDepth?: InputMaybe<Scalars['Float']['input']>;
  timeOnPage?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdatePartsOrderInput = {
  discountAmount?: InputMaybe<Scalars['Float']['input']>;
  discountCode?: InputMaybe<Scalars['String']['input']>;
  expectedDeliveryDate?: InputMaybe<Scalars['DateTime']['input']>;
  financialCategory?: InputMaybe<Scalars['String']['input']>;
  isFinancialActivity?: InputMaybe<Scalars['Boolean']['input']>;
  items?: InputMaybe<Array<PartsOrderItemInput>>;
  notes?: InputMaybe<Scalars['String']['input']>;
  orderId?: InputMaybe<Scalars['String']['input']>;
  orderedAt?: InputMaybe<Scalars['DateTime']['input']>;
  receiptCid?: InputMaybe<Scalars['String']['input']>;
  receiptUrl?: InputMaybe<Scalars['String']['input']>;
  receipts?: InputMaybe<Array<ReceiptAttachmentInput>>;
  shippingCost?: InputMaybe<Scalars['Float']['input']>;
  subtotal?: InputMaybe<Scalars['Float']['input']>;
  supplierId?: InputMaybe<Scalars['ID']['input']>;
  supplierName?: InputMaybe<Scalars['String']['input']>;
  supplierOrderImageUrl?: InputMaybe<Scalars['String']['input']>;
  supplierOrderUrl?: InputMaybe<Scalars['String']['input']>;
  taxAmount?: InputMaybe<Scalars['Float']['input']>;
  total?: InputMaybe<Scalars['Float']['input']>;
  trackingNumber?: InputMaybe<Scalars['String']['input']>;
  trackingUrl?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePaySettingsInput = {
  aiAuditModel?: InputMaybe<Scalars['String']['input']>;
  aiAuditTolerancePct?: InputMaybe<Scalars['Float']['input']>;
  atoSoftwareId?: InputMaybe<Scalars['String']['input']>;
  bmsId?: InputMaybe<Scalars['String']['input']>;
  defaultSuperContributionPct?: InputMaybe<Scalars['Float']['input']>;
  /** Laundry allowance per worked hour (e.g. 0.16). 0 disables. */
  laundryAllowancePerHour?: InputMaybe<Scalars['Float']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  payBasis?: InputMaybe<PayBasis>;
  payrollCalendar?: InputMaybe<PayrollCalendarInput>;
  stpLodgementEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  stpProvider?: InputMaybe<Scalars['String']['input']>;
  superClearingHouse?: InputMaybe<Scalars['String']['input']>;
  tenantAbn?: InputMaybe<Scalars['String']['input']>;
  tenantBankAccountName?: InputMaybe<Scalars['String']['input']>;
  tenantBankAccountNumber?: InputMaybe<Scalars['String']['input']>;
  tenantBankBsb?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePayrollEnquirySettingsInput = {
  extraEmails: Array<Scalars['String']['input']>;
  notifyOnStaffReply: Scalars['Boolean']['input'];
  recipients: Array<PayrollEnquiryRecipientInput>;
};

export type UpdatePenaltyRateRuleInput = {
  additionalRate?: InputMaybe<Scalars['Float']['input']>;
  effectiveFromDate?: InputMaybe<Scalars['DateTime']['input']>;
  effectiveToDate?: InputMaybe<Scalars['DateTime']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  multiplier?: InputMaybe<Scalars['Float']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  timeEndMinutes?: InputMaybe<Scalars['Int']['input']>;
  timeStartMinutes?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdatePledgeCampaignInput = {
  coverImageUrl?: InputMaybe<Scalars['String']['input']>;
  deadlineAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  heroHeadline?: InputMaybe<Scalars['String']['input']>;
  heroSubhead?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  isReferralEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  productName?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<PledgeCampaignStatus>;
  tiers?: InputMaybe<Array<PledgeCampaignTierInput>>;
};

export type UpdatePolicySettingsInput = {
  chatEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  chatModel?: InputMaybe<Scalars['String']['input']>;
  docIdPrefix?: InputMaybe<Scalars['String']['input']>;
  editorClientIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  notifyByDefault?: InputMaybe<Scalars['Boolean']['input']>;
  requireChangeNote?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdatePrescriberInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  clinic?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  fax?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  providerNumber?: InputMaybe<Scalars['String']['input']>;
  specialty?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateProgramActivityInput = {
  activityDate?: InputMaybe<Scalars['DateTime']['input']>;
  activityType?: InputMaybe<Scalars['String']['input']>;
  attachments?: InputMaybe<Array<ProgramActivityAttachmentInput>>;
  details?: InputMaybe<Scalars['String']['input']>;
  isPrivate?: InputMaybe<Scalars['Boolean']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateProgramApplicationInput = {
  billId?: InputMaybe<Scalars['String']['input']>;
  businessDescription?: InputMaybe<Scalars['String']['input']>;
  financialCapacityAnswer?: InputMaybe<Scalars['String']['input']>;
  proofOfAssetsCids?: InputMaybe<Array<Scalars['String']['input']>>;
  willingnessScore?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateProgramCallNoteInput = {
  meetSessionId?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  outcome?: InputMaybe<Scalars['String']['input']>;
  scheduledFor?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UpdateProgramCommissionInput = {
  ongoingPct?: InputMaybe<Scalars['Float']['input']>;
  saleAmountCents?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<ProgramCommissionStatus>;
  upfrontPct?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateProgramConfigInput = {
  applicationPackPriceCents?: InputMaybe<Scalars['Int']['input']>;
  callSlaHours?: InputMaybe<Scalars['Int']['input']>;
  chaseWindowDays?: InputMaybe<Scalars['Int']['input']>;
  chatEmbedEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  defaultChannel?: InputMaybe<ProgramChannel>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  fromEmail?: InputMaybe<Scalars['String']['input']>;
  guaranteesMarkdown?: InputMaybe<Scalars['String']['input']>;
  leadFlowStageIds?: InputMaybe<Array<Scalars['String']['input']>>;
  logoCid?: InputMaybe<Scalars['String']['input']>;
  sharedCalendarId?: InputMaybe<Scalars['String']['input']>;
  tenantOwnerWowPageContent?: InputMaybe<Scalars['String']['input']>;
  termsUrl?: InputMaybe<Scalars['String']['input']>;
  tiers?: InputMaybe<Array<ProgramTierInput>>;
  tomWowPageContent?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateProgramMemberInput = {
  callSlaDeadline?: InputMaybe<Scalars['DateTime']['input']>;
  currentStage?: InputMaybe<ProgramMemberStage>;
  pProposalId?: InputMaybe<Scalars['String']['input']>;
  selectedTierId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateProgressNoteCarePlansInput = {
  relatedCarePlanCategories: Array<ProgressNoteCategory>;
};

export type UpdateProjectProgressInput = {
  progress: Scalars['Float']['input'];
};

export type UpdateProposalInput = {
  agreementMarkdown?: InputMaybe<Scalars['String']['input']>;
  billId?: InputMaybe<Scalars['ID']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  draftBillId?: InputMaybe<Scalars['ID']['input']>;
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['ID']['input']>;
  scheduledPayments?: InputMaybe<Array<ScheduledPaymentInput>>;
  status?: InputMaybe<ProposalStatus>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateProspectingNotificationRuleInput = {
  channels?: InputMaybe<Array<ProspectingNotificationChannel>>;
  chatRecipientCooldownMinutes?: InputMaybe<Scalars['Float']['input']>;
  chatSessionGapMinutes?: InputMaybe<Scalars['Float']['input']>;
  filterDepartmentId?: InputMaybe<Scalars['String']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  messageTemplate?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  recipientIds?: InputMaybe<Array<Scalars['String']['input']>>;
  recipientType?: InputMaybe<ProspectingNotificationRecipientType>;
  trigger?: InputMaybe<ProspectingNotificationTrigger>;
};

export type UpdatePublicHolidayInput = {
  date?: InputMaybe<Scalars['DateTime']['input']>;
  defaultPenaltyMultiplier?: InputMaybe<Scalars['Float']['input']>;
  holidayType?: InputMaybe<PublicHolidayType>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  observedDate?: InputMaybe<Scalars['DateTime']['input']>;
  payRates?: InputMaybe<Array<HolidayPayRateInput>>;
  region?: InputMaybe<Scalars['String']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateRecipeIngredientInput = {
  isOptional?: InputMaybe<Scalars['Boolean']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  sortOrder?: InputMaybe<Scalars['Float']['input']>;
  unit?: InputMaybe<UnitType>;
};

export type UpdateRecipeIngredientResult = {
  __typename?: 'UpdateRecipeIngredientResult';
  recipeIngredient: RecipeIngredient;
  unitSyncReport: UnitSyncReport;
};

export type UpdateRecipeInput = {
  caloriesPerServing?: InputMaybe<Scalars['Float']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  cookTime?: InputMaybe<Scalars['Float']['input']>;
  cuisine?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dietaryTags?: InputMaybe<Array<DietaryTag>>;
  dishType?: InputMaybe<RecipeDishType>;
  imageCid?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  instructions?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  prepTime?: InputMaybe<Scalars['Float']['input']>;
  servings?: InputMaybe<Scalars['Float']['input']>;
  sessionType?: InputMaybe<RecipeSessionType>;
  thumbnailUrl?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateRegistrationStatusInput = {
  id: Scalars['ID']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  status: RegistrationStatus;
};

export type UpdateResearchBaseInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  extractModel?: InputMaybe<Scalars['String']['input']>;
  proseModel?: InputMaybe<Scalars['String']['input']>;
  sharedRootAcknowledged?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  writerHost?: InputMaybe<KnowledgeHost>;
};

export type UpdateResidentContactInput = {
  bestTimeToContact?: InputMaybe<Scalars['String']['input']>;
  canMakeDecisions?: InputMaybe<Scalars['Boolean']['input']>;
  canReceiveUpdates?: InputMaybe<Scalars['Boolean']['input']>;
  chatEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emergencyContactOrder?: InputMaybe<Scalars['Int']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  hasPortalAccess?: InputMaybe<Scalars['Boolean']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isEmergencyContact?: InputMaybe<Scalars['Boolean']['input']>;
  isGuardian?: InputMaybe<Scalars['Boolean']['input']>;
  isNextOfKin?: InputMaybe<Scalars['Boolean']['input']>;
  isPrimaryContact?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  phoneHome?: InputMaybe<Scalars['String']['input']>;
  phoneMobile?: InputMaybe<Scalars['String']['input']>;
  phoneWork?: InputMaybe<Scalars['String']['input']>;
  portalPermissionLevel?: InputMaybe<Scalars['String']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  powerOfAttorney?: InputMaybe<PowerOfAttorneyDetailsInput>;
  preferredContactMethod?: InputMaybe<Scalars['String']['input']>;
  relationship?: InputMaybe<ContactRelationship>;
  relationshipOther?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  suburb?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateResidentInput = {
  acfi?: InputMaybe<AcfiDetailsInput>;
  admissionDate?: InputMaybe<Scalars['DateTime']['input']>;
  admittedFrom?: InputMaybe<Scalars['String']['input']>;
  allergies?: InputMaybe<Array<Scalars['String']['input']>>;
  ambulanceFundNumber?: InputMaybe<Scalars['String']['input']>;
  bedNumber?: InputMaybe<Scalars['String']['input']>;
  behaviorStatus?: InputMaybe<Scalars['String']['input']>;
  careType?: InputMaybe<CareType>;
  centrelinkNumber?: InputMaybe<Scalars['String']['input']>;
  cognitionLevel?: InputMaybe<Scalars['String']['input']>;
  communicationLevel?: InputMaybe<Scalars['String']['input']>;
  continenceStatus?: InputMaybe<Scalars['String']['input']>;
  contractSigned?: InputMaybe<Scalars['Boolean']['input']>;
  contractSignedDate?: InputMaybe<Scalars['DateTime']['input']>;
  culturalOrigin?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<Scalars['DateTime']['input']>;
  diagnoses?: InputMaybe<Array<Scalars['String']['input']>>;
  dietaryRequirements?: InputMaybe<Array<Scalars['String']['input']>>;
  discharge?: InputMaybe<DischargeInfoInput>;
  dva?: InputMaybe<DvaDetailsInput>;
  email?: InputMaybe<Scalars['String']['input']>;
  entryType?: InputMaybe<EntryType>;
  externalPatientId?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Gender>;
  hasHealthDirective?: InputMaybe<Scalars['Boolean']['input']>;
  hasPacemaker?: InputMaybe<Scalars['Boolean']['input']>;
  healthDirectiveDocumentId?: InputMaybe<Scalars['ID']['input']>;
  healthFund?: InputMaybe<HealthFundDetailsInput>;
  hospitalPreference?: InputMaybe<HospitalPreferenceInput>;
  interpreter?: InputMaybe<InterpreterDetailsInput>;
  isShellRecord?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** Linked Client ID for resident portal access */
  linkedClientId?: InputMaybe<Scalars['ID']['input']>;
  maritalStatus?: InputMaybe<MaritalStatus>;
  medicare?: InputMaybe<MedicareDetailsInput>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  mobilityLevel?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  nutritionStatus?: InputMaybe<Scalars['String']['input']>;
  painLevel?: InputMaybe<Scalars['String']['input']>;
  paymentMethod?: InputMaybe<Scalars['String']['input']>;
  pension?: InputMaybe<PensionDetailsInput>;
  pharmaceuticalSafetyNetNumber?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  preAdmissionDate?: InputMaybe<Scalars['DateTime']['input']>;
  preferredName?: InputMaybe<Scalars['String']['input']>;
  previousAddress?: InputMaybe<ResidentAddressInput>;
  primaryDiagnosis?: InputMaybe<Scalars['String']['input']>;
  religion?: InputMaybe<Scalars['String']['input']>;
  respiteDueOutDate?: InputMaybe<Scalars['DateTime']['input']>;
  roomId?: InputMaybe<Scalars['ID']['input']>;
  roomNumber?: InputMaybe<Scalars['String']['input']>;
  sarahCareId?: InputMaybe<Scalars['String']['input']>;
  seniorCard?: InputMaybe<SeniorCardDetailsInput>;
  skinIntegrity?: InputMaybe<Scalars['String']['input']>;
  socialStatus?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ResidentStatus>;
  title?: InputMaybe<Scalars['String']['input']>;
  treatingDoctor?: InputMaybe<TreatingDoctorDetailsInput>;
  wing?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateResidentLeaveInput = {
  actualReturnDate?: InputMaybe<Scalars['DateTime']['input']>;
  belongingsReturned?: InputMaybe<Scalars['String']['input']>;
  belongingsTaken?: InputMaybe<Scalars['String']['input']>;
  contactsNotified?: InputMaybe<Scalars['Boolean']['input']>;
  departureDate?: InputMaybe<Scalars['DateTime']['input']>;
  departureTime?: InputMaybe<Scalars['String']['input']>;
  destination?: InputMaybe<Scalars['String']['input']>;
  destinationContact?: InputMaybe<Scalars['String']['input']>;
  destinationPhone?: InputMaybe<Scalars['String']['input']>;
  expectedReturnDate?: InputMaybe<Scalars['DateTime']['input']>;
  hospitalBed?: InputMaybe<Scalars['String']['input']>;
  hospitalDiagnosis?: InputMaybe<Scalars['String']['input']>;
  hospitalDoctor?: InputMaybe<Scalars['String']['input']>;
  hospitalWard?: InputMaybe<Scalars['String']['input']>;
  leaveType?: InputMaybe<LeaveType>;
  notes?: InputMaybe<Scalars['String']['input']>;
  notifiedPersons?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  returnNotes?: InputMaybe<Scalars['String']['input']>;
  returnTime?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<LeaveStatus>;
};

export type UpdateResidentRiskAssessmentInput = {
  mitigationStrategies?: InputMaybe<Array<Scalars['String']['input']>>;
  notes?: InputMaybe<Scalars['String']['input']>;
  reviewDate?: InputMaybe<Scalars['DateTime']['input']>;
  riskFactors?: InputMaybe<Array<Scalars['String']['input']>>;
  riskLevel?: InputMaybe<ResidentRiskLevel>;
  status?: InputMaybe<ResidentRiskStatus>;
};

export type UpdateRespiteCareBookingInput = {
  actualCheckInDate?: InputMaybe<Scalars['DateTime']['input']>;
  actualCheckOutDate?: InputMaybe<Scalars['DateTime']['input']>;
  bedNumber?: InputMaybe<Scalars['String']['input']>;
  bookingType?: InputMaybe<RespiteCareBookingType>;
  clientDateOfBirth?: InputMaybe<Scalars['DateTime']['input']>;
  clientEmail?: InputMaybe<Scalars['String']['input']>;
  clientName?: InputMaybe<Scalars['String']['input']>;
  clientPhone?: InputMaybe<Scalars['String']['input']>;
  dailyRate?: InputMaybe<Scalars['Float']['input']>;
  dietaryNeeds?: InputMaybe<Scalars['String']['input']>;
  emergencyContactName?: InputMaybe<Scalars['String']['input']>;
  emergencyContactPhone?: InputMaybe<Scalars['String']['input']>;
  emergencyContactRelation?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  fundingSource?: InputMaybe<RespiteFundingSource>;
  gpName?: InputMaybe<Scalars['String']['input']>;
  gpPhone?: InputMaybe<Scalars['String']['input']>;
  medicationNotes?: InputMaybe<Scalars['String']['input']>;
  mobilityNotes?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  roomNumber?: InputMaybe<Scalars['String']['input']>;
  specialRequirements?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<RespiteCareBookingStatus>;
  totalEstimatedCost?: InputMaybe<Scalars['Float']['input']>;
  wing?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateRestraintRecordInput = {
  consentDate?: InputMaybe<Scalars['DateTime']['input']>;
  consentStatus?: InputMaybe<RestraintConsentStatus>;
  consentedBy?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<RestraintReason>;
  restraintType?: InputMaybe<RestraintType>;
  reviewDate?: InputMaybe<Scalars['DateTime']['input']>;
  reviewFrequencyDays?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateRewardTokenConfigInput = {
  defaultExpiryMonths?: InputMaybe<Scalars['Float']['input']>;
  emailNotificationEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  emailTemplateId?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  smsNotificationEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  smsTemplateId?: InputMaybe<Scalars['String']['input']>;
  subscriptionTokenDripEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  tokenColor?: InputMaybe<Scalars['String']['input']>;
  tokenIcon?: InputMaybe<Scalars['String']['input']>;
  tokenName?: InputMaybe<Scalars['String']['input']>;
  tokenNamePlural?: InputMaybe<Scalars['String']['input']>;
  tokenValue?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateRiskAssessmentInput = {
  comments?: InputMaybe<Scalars['String']['input']>;
  consequences?: InputMaybe<RiskConsequences>;
  controlMeasuresTaken?: InputMaybe<Scalars['String']['input']>;
  exposure?: InputMaybe<RiskExposure>;
  followUpNotes?: InputMaybe<Scalars['String']['input']>;
  numberOfPersonsAffected?: InputMaybe<Scalars['Int']['input']>;
  probability?: InputMaybe<RiskProbability>;
  sentToFollowUp?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateRoundInput = {
  notes?: InputMaybe<Scalars['String']['input']>;
  roundDate?: InputMaybe<Scalars['DateTime']['input']>;
  roundName?: InputMaybe<Scalars['String']['input']>;
  roundTime?: InputMaybe<Scalars['String']['input']>;
  wing?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSeoMetadataInput = {
  canonicalUrl?: InputMaybe<Scalars['String']['input']>;
  conversionGoal?: InputMaybe<Scalars['String']['input']>;
  linkedInDescription?: InputMaybe<Scalars['String']['input']>;
  linkedInImageCid?: InputMaybe<Scalars['String']['input']>;
  linkedInTitle?: InputMaybe<Scalars['String']['input']>;
  metaDescription?: InputMaybe<Scalars['String']['input']>;
  metaKeywords?: InputMaybe<Array<Scalars['String']['input']>>;
  metaTitle?: InputMaybe<Scalars['String']['input']>;
  ogDescription?: InputMaybe<Scalars['String']['input']>;
  ogImageCid?: InputMaybe<Scalars['String']['input']>;
  ogTitle?: InputMaybe<Scalars['String']['input']>;
  ogType?: InputMaybe<Scalars['String']['input']>;
  pageTitle?: InputMaybe<Scalars['String']['input']>;
  pinterestDescription?: InputMaybe<Scalars['String']['input']>;
  pinterestImageCid?: InputMaybe<Scalars['String']['input']>;
  pinterestTitle?: InputMaybe<Scalars['String']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  robots?: InputMaybe<Scalars['String']['input']>;
  structuredData?: InputMaybe<Scalars['String']['input']>;
  trackPageViews?: InputMaybe<Scalars['Boolean']['input']>;
  twitterCard?: InputMaybe<Scalars['String']['input']>;
  twitterDescription?: InputMaybe<Scalars['String']['input']>;
  twitterImageCid?: InputMaybe<Scalars['String']['input']>;
  twitterTitle?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSecurityFindingStatusInput = {
  id: Scalars['ID']['input'];
  /** Why — kept in the finding's history */
  reason: Scalars['String']['input'];
  status: SecurityFindingStatus;
};

export type UpdateSecurityTargetInput = {
  cadence?: InputMaybe<SecurityCadence>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
};

export type UpdateSellerProfileInput = {
  aboutStory?: InputMaybe<Scalars['String']['input']>;
  address?: InputMaybe<SellerProfileAddressInput>;
  allowedEditors?: InputMaybe<Array<Scalars['String']['input']>>;
  businessHours?: InputMaybe<Array<SellerProfileBusinessHoursInput>>;
  businessName?: InputMaybe<Scalars['String']['input']>;
  businessType?: InputMaybe<BusinessType>;
  categories?: InputMaybe<Array<Scalars['String']['input']>>;
  certifications?: InputMaybe<Scalars['String']['input']>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactPhone?: InputMaybe<Scalars['String']['input']>;
  deliveryRadius?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  images?: InputMaybe<Array<Scalars['String']['input']>>;
  logoImage?: InputMaybe<Scalars['String']['input']>;
  minimumOrderAmount?: InputMaybe<Scalars['Float']['input']>;
  offersDelivery?: InputMaybe<Scalars['Boolean']['input']>;
  offersPickup?: InputMaybe<Scalars['Boolean']['input']>;
  offersShipping?: InputMaybe<Scalars['Boolean']['input']>;
  socialMedia?: InputMaybe<SellerProfileSocialMediaInput>;
  specialties?: InputMaybe<Array<Scalars['String']['input']>>;
  status?: InputMaybe<SellerProfileStatus>;
  yearsInBusiness?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateSeparationAffiliateInput = {
  defaultPercent?: InputMaybe<Scalars['Float']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateShelvAiSettingsInput = {
  knowledgeFsSecret?: InputMaybe<Scalars['String']['input']>;
  knowledgeFsUrl?: InputMaybe<Scalars['String']['input']>;
  knowledgeHarnessSecret?: InputMaybe<Scalars['String']['input']>;
  knowledgeHarnessUrl?: InputMaybe<Scalars['String']['input']>;
  localAiBaseUrl?: InputMaybe<Scalars['String']['input']>;
  localAiBearerToken?: InputMaybe<Scalars['String']['input']>;
  localAiDefaultModel?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateShiftInput = {
  area?: InputMaybe<Scalars['String']['input']>;
  breaks?: InputMaybe<Array<BreakPeriodInput>>;
  color?: InputMaybe<Scalars['String']['input']>;
  departmentId?: InputMaybe<Scalars['String']['input']>;
  departmentIds?: InputMaybe<Array<Scalars['String']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  duties?: InputMaybe<Array<Scalars['String']['input']>>;
  employeeRoleId?: InputMaybe<Scalars['String']['input']>;
  endTime?: InputMaybe<Scalars['DateTime']['input']>;
  isFloat?: InputMaybe<Scalars['Boolean']['input']>;
  jobIds?: InputMaybe<Array<Scalars['String']['input']>>;
  locationIds?: InputMaybe<Array<Scalars['String']['input']>>;
  metadata?: InputMaybe<Scalars['JSONObject']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  payType?: InputMaybe<Scalars['String']['input']>;
  requiredCertifications?: InputMaybe<Array<Scalars['String']['input']>>;
  requiredSkills?: InputMaybe<Array<Scalars['String']['input']>>;
  requiredStaffCount?: InputMaybe<Scalars['Float']['input']>;
  residentIds?: InputMaybe<Array<Scalars['String']['input']>>;
  residentNames?: InputMaybe<Array<Scalars['String']['input']>>;
  rosterMode?: InputMaybe<RosterMode>;
  shiftType?: InputMaybe<Scalars['String']['input']>;
  startTime?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<ShiftStatus>;
  team?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  totalBreakMinutes?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateShiftNotificationRuleInput = {
  channels?: InputMaybe<Array<Scalars['String']['input']>>;
  filterDepartmentId?: InputMaybe<Scalars['String']['input']>;
  filterLocation?: InputMaybe<Scalars['String']['input']>;
  filterTeam?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  messageTemplate?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  recipientDepartmentId?: InputMaybe<Scalars['String']['input']>;
  recipientIds?: InputMaybe<Array<Scalars['String']['input']>>;
  recipientRole?: InputMaybe<Scalars['String']['input']>;
  recipientType?: InputMaybe<ShiftNotificationRecipientType>;
  timing?: InputMaybe<ShiftNotificationTiming>;
  timingMinutes?: InputMaybe<Scalars['Float']['input']>;
  trigger?: InputMaybe<ShiftNotificationTrigger>;
};

export type UpdateShiftSettingsInput = {
  allowNotAttending?: InputMaybe<Scalars['Boolean']['input']>;
  careMinutesDataStartDate?: InputMaybe<Scalars['String']['input']>;
  careMinutesTargetPerResident?: InputMaybe<Scalars['Float']['input']>;
  clockInCutoffMinutes?: InputMaybe<Scalars['Float']['input']>;
  clockOutReminderMinutesBefore?: InputMaybe<Scalars['Float']['input']>;
  coverageThresholdPct?: InputMaybe<Scalars['Float']['input']>;
  draftLeadDays?: InputMaybe<Scalars['Float']['input']>;
  earlyCheckInMinutes?: InputMaybe<Scalars['Float']['input']>;
  leadTimeWarningsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  leaveBlockThreshold?: InputMaybe<Scalars['Int']['input']>;
  masterRosterStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  maxPickupRequestsPerShift?: InputMaybe<Scalars['Float']['input']>;
  noCheckInAlertMinutes?: InputMaybe<Scalars['Float']['input']>;
  nonShiftWorkerCheckInCutoffMinutes?: InputMaybe<Scalars['Float']['input']>;
  nonShiftWorkerReminderEmail?: InputMaybe<Scalars['Boolean']['input']>;
  nonShiftWorkerReminderInApp?: InputMaybe<Scalars['Boolean']['input']>;
  nonShiftWorkerReminderMinutesBefore?: InputMaybe<Scalars['Float']['input']>;
  nonShiftWorkerReminderSms?: InputMaybe<Scalars['Boolean']['input']>;
  nonShiftWorkerRemindersEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  publishLeadDays?: InputMaybe<Scalars['Float']['input']>;
  reminderEmail?: InputMaybe<Scalars['Boolean']['input']>;
  reminderInApp?: InputMaybe<Scalars['Boolean']['input']>;
  reminderMinutesBefore?: InputMaybe<Scalars['Float']['input']>;
  reminderSms?: InputMaybe<Scalars['Boolean']['input']>;
  remindersEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  requireSickLeaveCertificate?: InputMaybe<Scalars['Boolean']['input']>;
  shiftPickupAutoConfirm?: InputMaybe<Scalars['Boolean']['input']>;
  shiftPickupPolicy?: InputMaybe<ShiftPickupPolicy>;
  showStaffLeaveBalance?: InputMaybe<Scalars['Boolean']['input']>;
  sickLeaveCertReminderDays?: InputMaybe<Scalars['Float']['input']>;
  swapApproverEmployeeIds?: InputMaybe<Array<Scalars['String']['input']>>;
  swapChaseEmail?: InputMaybe<Scalars['Boolean']['input']>;
  swapChaseEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  swapChaseEscalateHoursBefore?: InputMaybe<Scalars['Float']['input']>;
  swapChaseFrequencyMinutes?: InputMaybe<Scalars['Float']['input']>;
  swapChaseQuietEnd?: InputMaybe<Scalars['String']['input']>;
  swapChaseQuietStart?: InputMaybe<Scalars['String']['input']>;
  swapChaseSms?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateShiftTemplateInput = {
  breakMinutes?: InputMaybe<Scalars['Float']['input']>;
  department?: InputMaybe<Scalars['String']['input']>;
  departmentIds?: InputMaybe<Array<Scalars['String']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  employeeRoleId?: InputMaybe<Scalars['String']['input']>;
  endTime?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isFloat?: InputMaybe<Scalars['Boolean']['input']>;
  isOvernight?: InputMaybe<Scalars['Boolean']['input']>;
  locationIds?: InputMaybe<Array<Scalars['String']['input']>>;
  requiredStaffCount?: InputMaybe<Scalars['Float']['input']>;
  shiftType?: InputMaybe<Scalars['String']['input']>;
  skills?: InputMaybe<Array<Scalars['String']['input']>>;
  sortOrder?: InputMaybe<Scalars['Float']['input']>;
  startTime?: InputMaybe<Scalars['String']['input']>;
  team?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  weekdaysOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateShiftTypeInput = {
  category?: InputMaybe<ShiftTypeCategory>;
  code?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayOrder?: InputMaybe<Scalars['Float']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSiteEditorSiteInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  devServerIp?: InputMaybe<Scalars['String']['input']>;
  devServerPort?: InputMaybe<Scalars['Float']['input']>;
  githubToken?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  linkedTenantId?: InputMaybe<Scalars['String']['input']>;
  previewUrl?: InputMaybe<Scalars['String']['input']>;
  productionUrl?: InputMaybe<Scalars['String']['input']>;
  relayApiKey?: InputMaybe<Scalars['String']['input']>;
  relayUrl?: InputMaybe<Scalars['String']['input']>;
  repoUrl?: InputMaybe<Scalars['String']['input']>;
  siteName?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSmsNotificationRuleInput = {
  channels?: InputMaybe<Array<Scalars['String']['input']>>;
  filterKeyword?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  messageTemplate?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  recipientIds?: InputMaybe<Array<Scalars['String']['input']>>;
  recipientRole?: InputMaybe<Scalars['String']['input']>;
  recipientType?: InputMaybe<SmsNotificationRecipientType>;
  triggers?: InputMaybe<Array<SmsNotificationTrigger>>;
};

export type UpdateSopAgendaItemInput = {
  note?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  targetEpisodeId?: InputMaybe<Scalars['ID']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  topicId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateSopEpisodeInput = {
  bodyMarkdown?: InputMaybe<Scalars['String']['input']>;
  bullets?: InputMaybe<Array<Scalars['String']['input']>>;
  cta?: InputMaybe<SopCtaInput>;
  ctaDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  durationMinutes?: InputMaybe<Scalars['Int']['input']>;
  episodeNumber?: InputMaybe<Scalars['Int']['input']>;
  headline?: InputMaybe<Scalars['String']['input']>;
  linkedProposalId?: InputMaybe<Scalars['ID']['input']>;
  mermaidSource?: InputMaybe<Scalars['String']['input']>;
  nextEpisodeHint?: InputMaybe<Scalars['String']['input']>;
  presenterNotes?: InputMaybe<Scalars['String']['input']>;
  scheduledEnd?: InputMaybe<Scalars['DateTime']['input']>;
  scheduledStart?: InputMaybe<Scalars['DateTime']['input']>;
  skin?: InputMaybe<SopSkin>;
  slug?: InputMaybe<Scalars['String']['input']>;
  socialCopy?: InputMaybe<Scalars['String']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  topicId?: InputMaybe<Scalars['ID']['input']>;
  visibility?: InputMaybe<SopVisibility>;
};

export type UpdateSopSettingsInput = {
  autoDraftCopy?: InputMaybe<Scalars['Boolean']['input']>;
  cadence?: InputMaybe<SopCadence>;
  cadenceTime?: InputMaybe<Scalars['String']['input']>;
  cadenceTimezone?: InputMaybe<Scalars['String']['input']>;
  cadenceWeekday?: InputMaybe<Scalars['Int']['input']>;
  copyModel?: InputMaybe<Scalars['String']['input']>;
  defaultCta?: InputMaybe<SopCtaInput>;
  defaultDurationMinutes?: InputMaybe<Scalars['Int']['input']>;
  defaultSkin?: InputMaybe<SopSkin>;
  defaultVisibility?: InputMaybe<SopVisibility>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  maxInvitesPerMember?: InputMaybe<Scalars['Int']['input']>;
  referralRewardEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  referralRewardValue?: InputMaybe<Scalars['Float']['input']>;
  tagline?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSopTopicInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  parentId?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSphereOfInfluenceInput = {
  actionRequired?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<InfluenceCategory>;
  demandRating?: InputMaybe<Scalars['Int']['input']>;
  energyRating?: InputMaybe<Scalars['Int']['input']>;
  engagement?: InputMaybe<Scalars['Int']['input']>;
  impactScore?: InputMaybe<Scalars['Int']['input']>;
  influence?: InputMaybe<InfluenceType>;
  interactionFrequency?: InputMaybe<InteractionFrequency>;
  linkedAspectIds?: InputMaybe<Array<Scalars['String']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  proximity?: InputMaybe<Scalars['Int']['input']>;
  relationshipLayer?: InputMaybe<RelationshipLayer>;
  relationshipType?: InputMaybe<Scalars['String']['input']>;
  roleTags?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateSubmissionStatusInput = {
  notes?: InputMaybe<Scalars['String']['input']>;
  status: SubmissionStatus;
  submissionId: Scalars['ID']['input'];
};

export type UpdateSubscriptionInput = {
  cancellationReason?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  nextBillingDate?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  plan?: InputMaybe<SubscriptionPlanInput>;
  status?: InputMaybe<SubscriptionStatus>;
};

export type UpdateSubscriptionProductInput = {
  allowCustomAmount?: InputMaybe<Scalars['Boolean']['input']>;
  amount?: InputMaybe<Scalars['Float']['input']>;
  badge?: InputMaybe<Scalars['String']['input']>;
  billingCycles?: InputMaybe<Scalars['Int']['input']>;
  chargeOnActivation?: InputMaybe<Scalars['Boolean']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  courseStartUrl?: InputMaybe<Scalars['String']['input']>;
  ctaText?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  detailedDescription?: InputMaybe<Scalars['String']['input']>;
  features?: InputMaybe<Array<Scalars['String']['input']>>;
  grantedPermissions?: InputMaybe<Array<Scalars['String']['input']>>;
  hideOtherProducts?: InputMaybe<Scalars['Boolean']['input']>;
  includedAccessMonths?: InputMaybe<Scalars['Int']['input']>;
  includedModules?: InputMaybe<Array<Scalars['String']['input']>>;
  interval?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isRecommended?: InputMaybe<Scalars['Boolean']['input']>;
  isUnlisted?: InputMaybe<Scalars['Boolean']['input']>;
  linkedCourseId?: InputMaybe<Scalars['String']['input']>;
  minAmount?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  salesPageUrl?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['Float']['input']>;
  stripePriceId?: InputMaybe<Scalars['String']['input']>;
  stripeProductId?: InputMaybe<Scalars['String']['input']>;
  suggestedAmount?: InputMaybe<Scalars['Float']['input']>;
  tier?: InputMaybe<Scalars['String']['input']>;
  trialDays?: InputMaybe<Scalars['Float']['input']>;
  welcomeEmailBody?: InputMaybe<Scalars['String']['input']>;
  welcomeEmailSubject?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSupplierInput = {
  abn?: InputMaybe<Scalars['String']['input']>;
  accountNumber?: InputMaybe<Scalars['String']['input']>;
  address?: InputMaybe<Scalars['String']['input']>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactName?: InputMaybe<Scalars['String']['input']>;
  contactPhone?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  leadTimeDays?: InputMaybe<Scalars['Float']['input']>;
  minimumOrder?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  paymentTerms?: InputMaybe<Scalars['String']['input']>;
  preferredCategories?: InputMaybe<Array<IngredientCategory>>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSupplierOrderInput = {
  expectedDelivery?: InputMaybe<Scalars['DateTime']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<SupplierOrderStatus>;
  supplierOrderNumber?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTeamInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayOrder?: InputMaybe<Scalars['Float']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTemperatureAlarmInput = {
  alarmType?: InputMaybe<Scalars['String']['input']>;
  deadlineTime?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  equipmentId?: InputMaybe<Scalars['String']['input']>;
  maxTemp?: InputMaybe<Scalars['Float']['input']>;
  minTemp?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notifyViaEmail?: InputMaybe<Scalars['Boolean']['input']>;
  notifyViaSms?: InputMaybe<Scalars['Boolean']['input']>;
  recipientClientIds?: InputMaybe<Array<Scalars['String']['input']>>;
  session?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTenantInput = {
  acmaRegistration?: InputMaybe<AcmaRegistrationInput>;
  alphaId?: InputMaybe<Scalars['String']['input']>;
  apiKeys?: InputMaybe<TenantApiKeysInput>;
  authConfig?: InputMaybe<TenantAuthConfigInput>;
  billingExempt?: InputMaybe<Scalars['Boolean']['input']>;
  billingMode?: InputMaybe<Scalars['String']['input']>;
  branding?: InputMaybe<TenantBrandingInput>;
  clientId?: InputMaybe<Scalars['ID']['input']>;
  companyDetails?: InputMaybe<TenantCompanyDetailsInput>;
  curatedEmployeePermissions?: InputMaybe<Array<Scalars['String']['input']>>;
  dedicatedNumber?: InputMaybe<Scalars['String']['input']>;
  deploymentUrl?: InputMaybe<Scalars['String']['input']>;
  domain?: InputMaybe<Scalars['String']['input']>;
  emailConfig?: InputMaybe<TenantEmailConfigInput>;
  githubOwner?: InputMaybe<Scalars['String']['input']>;
  githubRepo?: InputMaybe<Scalars['String']['input']>;
  hosting?: InputMaybe<TenantHostingInput>;
  mainBranch?: InputMaybe<Scalars['String']['input']>;
  meetConfig?: InputMaybe<TenantMeetConfigInput>;
  moduleConfig?: InputMaybe<Array<TenantModuleConfigInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  notificationSettings?: InputMaybe<TenantNotificationSettingsInput>;
  paymentReceivingDetails?: InputMaybe<PaymentReceivingDetailsInput>;
  recruitmentPartners?: InputMaybe<Array<TenantRecruitmentPartnerInput>>;
  skipPaymentCollection?: InputMaybe<Scalars['Boolean']['input']>;
  smsConfig?: InputMaybe<TenantSmsConfigInput>;
  status?: InputMaybe<TenantStatus>;
  subscriptionTier?: InputMaybe<Scalars['String']['input']>;
  useAlphaId?: InputMaybe<Scalars['Boolean']['input']>;
  websiteUrl?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTimesheetComplianceInput = {
  complianceResults: ComplianceResultsInput;
  status: TimesheetStatus;
  timesheetId: Scalars['String']['input'];
};

export type UpdateTimesheetDigitizedDataInput = {
  digitizedData: DigitizedDataInput;
  timesheetId: Scalars['String']['input'];
};

export type UpdateTomSettingsInput = {
  autoSuggestTasks?: InputMaybe<Scalars['Boolean']['input']>;
  customSystemPrompt?: InputMaybe<Scalars['String']['input']>;
  enabledModules?: InputMaybe<Array<Scalars['String']['input']>>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTrackedCompetitionInput = {
  announceDate?: InputMaybe<Scalars['DateTime']['input']>;
  closeDate?: InputMaybe<Scalars['DateTime']['input']>;
  copyableMechanic?: InputMaybe<Scalars['String']['input']>;
  datesConfirmed?: InputMaybe<Scalars['Boolean']['input']>;
  eligibility?: InputMaybe<Scalars['String']['input']>;
  entryImageCid?: InputMaybe<Scalars['String']['input']>;
  fee?: InputMaybe<Scalars['String']['input']>;
  fit?: InputMaybe<Scalars['String']['input']>;
  fitReason?: InputMaybe<Scalars['String']['input']>;
  howToEnter?: InputMaybe<Scalars['String']['input']>;
  medium?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  openDate?: InputMaybe<Scalars['DateTime']['input']>;
  organiser?: InputMaybe<Scalars['String']['input']>;
  prize?: InputMaybe<Scalars['String']['input']>;
  researchNotes?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<TrackedCompetitionStatus>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTreatmentPlanInput = {
  administeredAt?: InputMaybe<Scalars['DateTime']['input']>;
  followUpDate?: InputMaybe<Scalars['DateTime']['input']>;
  followUpRequired?: InputMaybe<Scalars['Boolean']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  treatmentDescription?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTrustPersonInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  confirmed?: InputMaybe<Scalars['Boolean']['input']>;
  electorate?: InputMaybe<Scalars['String']['input']>;
  level?: InputMaybe<TrustLevel>;
  name?: InputMaybe<Scalars['String']['input']>;
  party?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  sources?: InputMaybe<TrustPersonSourcesInput>;
  topics?: InputMaybe<Array<Scalars['String']['input']>>;
  why?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateVaccinationInput = {
  administeredDate?: InputMaybe<Scalars['DateTime']['input']>;
  batchNumber?: InputMaybe<Scalars['String']['input']>;
  consentDate?: InputMaybe<Scalars['DateTime']['input']>;
  consentObtained?: InputMaybe<Scalars['Boolean']['input']>;
  declinedReason?: InputMaybe<Scalars['String']['input']>;
  expiryDate?: InputMaybe<Scalars['DateTime']['input']>;
  nextDueDate?: InputMaybe<Scalars['DateTime']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  site?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<VaccinationStatus>;
  vaccineName?: InputMaybe<Scalars['String']['input']>;
  vaccineType?: InputMaybe<VaccineType>;
};

export type UpdateVaultInput = {
  ownerBtcAddress?: InputMaybe<Scalars['String']['input']>;
  ownerWalletAddress?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<VaultStatus>;
  timelockDays?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateVaultInsightRuleInput = {
  cadence?: InputMaybe<VaultInsightCadence>;
  channels?: InputMaybe<Array<VaultInsightChannel>>;
  customPromptAddendum?: InputMaybe<Scalars['String']['input']>;
  daysOfWeek?: InputMaybe<Array<Scalars['Int']['input']>>;
  id: Scalars['ID']['input'];
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  lookbackDays?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  recipientClientIds?: InputMaybe<Array<Scalars['String']['input']>>;
  recipientTag?: InputMaybe<Scalars['String']['input']>;
  recipientType?: InputMaybe<VaultInsightRecipientType>;
  sections?: InputMaybe<Array<VaultInsightSection>>;
  timeOfDay?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateVisionBoardConfigInput = {
  maxFreeInvites?: InputMaybe<Scalars['Float']['input']>;
  referralRewardEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  referralRewardValue?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateVisionBoardItemInput = {
  achieved?: InputMaybe<Scalars['Boolean']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  imageCid?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  positionX?: InputMaybe<Scalars['Int']['input']>;
  positionY?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateVisionBoardNotificationRuleInput = {
  channels?: InputMaybe<Array<Scalars['String']['input']>>;
  id: Scalars['ID']['input'];
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  messageTemplate?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  recipientIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateVlogCategoryInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  parentId?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateVlogNotificationRuleInput = {
  channels?: InputMaybe<Array<Scalars['String']['input']>>;
  id: Scalars['ID']['input'];
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  messageTemplate?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  recipientIds?: InputMaybe<Array<Scalars['String']['input']>>;
  recipientType?: InputMaybe<VlogNotificationRecipientType>;
  timing?: InputMaybe<VlogNotificationTiming>;
  timingMinutes?: InputMaybe<Scalars['Int']['input']>;
  trigger?: InputMaybe<VlogNotificationTrigger>;
};

export type UpdateVlogPostInput = {
  aiChatEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  aiChatSeedQuestions?: InputMaybe<Array<Scalars['String']['input']>>;
  author?: InputMaybe<Scalars['String']['input']>;
  authorAvatarUrl?: InputMaybe<Scalars['String']['input']>;
  authorBio?: InputMaybe<Scalars['String']['input']>;
  bonusContent?: InputMaybe<Scalars['String']['input']>;
  bonusUnlockPercent?: InputMaybe<Scalars['Int']['input']>;
  bulletPoints?: InputMaybe<Array<Scalars['String']['input']>>;
  categories?: InputMaybe<Array<Scalars['String']['input']>>;
  companionArticleMarkdown?: InputMaybe<Scalars['String']['input']>;
  durationSeconds?: InputMaybe<Scalars['Int']['input']>;
  episodeNumber?: InputMaybe<Scalars['Int']['input']>;
  excerpt?: InputMaybe<Scalars['String']['input']>;
  leadFormId?: InputMaybe<Scalars['String']['input']>;
  leadMagnetDescription?: InputMaybe<Scalars['String']['input']>;
  leadMagnetTitle?: InputMaybe<Scalars['String']['input']>;
  metaDescription?: InputMaybe<Scalars['String']['input']>;
  metaTitle?: InputMaybe<Scalars['String']['input']>;
  ogImage?: InputMaybe<Scalars['String']['input']>;
  personalizationOptions?: InputMaybe<Array<VlogPersonalizationOptionInput>>;
  personalizationQuestion?: InputMaybe<Scalars['String']['input']>;
  pollOptions?: InputMaybe<Array<VlogPollOptionInput>>;
  pollQuestion?: InputMaybe<Scalars['String']['input']>;
  previewClipUrl?: InputMaybe<Scalars['String']['input']>;
  seriesId?: InputMaybe<Scalars['ID']['input']>;
  skin?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<VlogPostStatus>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  thumbnailCid?: InputMaybe<Scalars['String']['input']>;
  thumbnailUrl?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  toolCtaDescription?: InputMaybe<Scalars['String']['input']>;
  toolCtaText?: InputMaybe<Scalars['String']['input']>;
  toolCtaUrl?: InputMaybe<Scalars['String']['input']>;
  transcript?: InputMaybe<Scalars['String']['input']>;
  videoCid?: InputMaybe<Scalars['String']['input']>;
  videoCustomIframe?: InputMaybe<Scalars['String']['input']>;
  videoIpfsHash?: InputMaybe<Scalars['String']['input']>;
  videoProvider?: InputMaybe<VlogVideoProvider>;
  videoUrl?: InputMaybe<Scalars['String']['input']>;
  visibility?: InputMaybe<VlogPostVisibility>;
};

export type UpdateVlogSeriesInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  heroImage?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateWaitingListChecklistItemInput = {
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['String']['input'];
  text?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateWaitingListChecklistTemplateInput = {
  /** The whole list, in order */
  items: Array<WaitingListChecklistTemplateItemInput>;
  /** WAITLIST or PRE_ADMISSION */
  stage: WaitingListStage;
};

export type UpdateWaitingListEntryInput = {
  acatApprovalExpiry?: InputMaybe<Scalars['DateTime']['input']>;
  acatAssessmentDate?: InputMaybe<Scalars['DateTime']['input']>;
  acatReferenceNumber?: InputMaybe<Scalars['String']['input']>;
  accommodationPayment?: InputMaybe<WaitingListAccommodationPayment>;
  careNeeds?: InputMaybe<CareNeedsAssessmentInput>;
  contactPerson?: InputMaybe<WaitingListContactInput>;
  currentAddress?: InputMaybe<Scalars['String']['input']>;
  currentLocation?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<Scalars['DateTime']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  entryType?: InputMaybe<EntryType>;
  expectedAdmissionDate?: InputMaybe<Scalars['DateTime']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  fundingNotes?: InputMaybe<Scalars['String']['input']>;
  fundingSupport?: InputMaybe<FundingSupport>;
  gender?: InputMaybe<Gender>;
  hasAcatApproval?: InputMaybe<Scalars['Boolean']['input']>;
  inquirySource?: InputMaybe<InquirySource>;
  interestedInHomeCare?: InputMaybe<Scalars['Boolean']['input']>;
  isFundingEligible?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  preferredName?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<WaitingListPriority>;
  priorityScore?: InputMaybe<Scalars['Int']['input']>;
  receivingCareAtHome?: InputMaybe<Scalars['Boolean']['input']>;
  referralDate?: InputMaybe<Scalars['DateTime']['input']>;
  referralSource?: InputMaybe<Scalars['String']['input']>;
  referredBy?: InputMaybe<Scalars['String']['input']>;
  roomPreferences?: InputMaybe<RoomPreferencesInput>;
  status?: InputMaybe<WaitingListStatus>;
  statusChangeReason?: InputMaybe<Scalars['String']['input']>;
  suitabilityAssessment?: InputMaybe<SuitabilityAssessmentInput>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateWitnessInput = {
  signedOff?: InputMaybe<Scalars['Boolean']['input']>;
  statement?: InputMaybe<Scalars['String']['input']>;
  statementDate?: InputMaybe<Scalars['DateTime']['input']>;
  witnessContact?: InputMaybe<Scalars['String']['input']>;
  witnessName?: InputMaybe<Scalars['String']['input']>;
  witnessType?: InputMaybe<WitnessType>;
};

export type UpdateWorkerInput = {
  availableHoursPerWeek?: InputMaybe<Scalars['Int']['input']>;
  certifications?: InputMaybe<Array<WorkerCertificationInput>>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  documents?: InputMaybe<Array<WorkerDocumentInput>>;
  education?: InputMaybe<Array<WorkerEducationInput>>;
  email?: InputMaybe<Scalars['String']['input']>;
  experience?: InputMaybe<Array<WorkerExperienceInput>>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  isAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  languages?: InputMaybe<Array<WorkerLanguageInput>>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  preferredWorkingHours?: InputMaybe<Scalars['String']['input']>;
  profilePhoto?: InputMaybe<Scalars['String']['input']>;
  referralPercentage?: InputMaybe<Scalars['Float']['input']>;
  referredBy?: InputMaybe<Scalars['String']['input']>;
  skills?: InputMaybe<Array<Scalars['String']['input']>>;
  status?: InputMaybe<WorkerStatus>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  videoIntroUrl?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateWorkerTimeEntryInput = {
  category?: InputMaybe<WorkerTimeEntryCategory>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  durationMinutes?: InputMaybe<Scalars['Int']['input']>;
  hourlyRate?: InputMaybe<Scalars['Float']['input']>;
  lawFirmName?: InputMaybe<Scalars['String']['input']>;
  matterReference?: InputMaybe<Scalars['String']['input']>;
};

/** Category of frontend upgrade */
export enum UpgradeCategory {
  Accessibility = 'ACCESSIBILITY',
  BugFix = 'BUG_FIX',
  Feature = 'FEATURE',
  Other = 'OTHER',
  Performance = 'PERFORMANCE',
  Refactor = 'REFACTOR',
  Security = 'SECURITY',
  UiEnhancement = 'UI_ENHANCEMENT'
}

export type UpgradeStats = {
  __typename?: 'UpgradeStats';
  completedUpgrades: Scalars['Int']['output'];
  inProgressUpgrades: Scalars['Int']['output'];
  pendingUpgrades: Scalars['Int']['output'];
  totalUpgrades: Scalars['Int']['output'];
};

/** Status of upgrade application */
export enum UpgradeStatus {
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS',
  Pending = 'PENDING',
  Skipped = 'SKIPPED'
}

export type UploadDocumentInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  documentType: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
  fileSize: Scalars['Int']['input'];
  ipfsCid: Scalars['String']['input'];
  mimeType: Scalars['String']['input'];
};

export type UploadInvoiceInput = {
  fileCid?: InputMaybe<Scalars['String']['input']>;
  fileName: Scalars['String']['input'];
  fileUrl: Scalars['String']['input'];
  linkedOrderId?: InputMaybe<Scalars['ID']['input']>;
  mimeType: Scalars['String']['input'];
};

export type UploadMedicalRecordInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  documentType: MedicalDocumentType;
  facilityId?: InputMaybe<Scalars['ID']['input']>;
  patientId: Scalars['ID']['input'];
  sourceArchived?: InputMaybe<Scalars['Boolean']['input']>;
  sourceBackupDate?: InputMaybe<Scalars['DateTime']['input']>;
  sourceDocId?: InputMaybe<Scalars['String']['input']>;
  sourceDocumentDate?: InputMaybe<Scalars['DateTime']['input']>;
  sourceMetadataJson?: InputMaybe<Scalars['String']['input']>;
  sourceResidentId?: InputMaybe<Scalars['String']['input']>;
  sourceSha256?: InputMaybe<Scalars['String']['input']>;
  sourceSystem?: InputMaybe<Scalars['String']['input']>;
};

export type UploadProgressResult = {
  __typename?: 'UploadProgressResult';
  currentFile?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  failedFiles: Scalars['Float']['output'];
  isUploading?: Maybe<Scalars['Boolean']['output']>;
  sessionId: Scalars['String']['output'];
  shareUrl?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  totalBytes: Scalars['Float']['output'];
  totalFiles: Scalars['Float']['output'];
  uploadStartedAt?: Maybe<Scalars['DateTime']['output']>;
  uploadedBytes: Scalars['Float']['output'];
  uploadedFiles: Scalars['Float']['output'];
};

export type UploadWaitingListFileInput = {
  entryId: Scalars['ID']['input'];
  label?: InputMaybe<Scalars['String']['input']>;
};

export type UpsertBankingAlertRuleInput = {
  accountIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  direction: BankingAlertDirection;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  includePending?: InputMaybe<Scalars['Boolean']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  maxAmountMinor?: InputMaybe<Scalars['Int']['input']>;
  minAmountMinor?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  notifyEmail: Scalars['Boolean']['input'];
  notifySms: Scalars['Boolean']['input'];
};

export type UpsertBankingIncomeRuleInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  match: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  rank?: InputMaybe<Scalars['Int']['input']>;
  shape: BankingIncomeShape;
};

export type UpsertBankingMonthJobInput = {
  dueDay?: InputMaybe<Scalars['Int']['input']>;
  expectedMinor?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  month: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

/** A standing money move: a job that comes round every week, fortnight or month */
export type UpsertBankingStandingMoveInput = {
  cadence: BankingStandingCadence;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  expectedMinor: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  matchText?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type UpsertBusinessSnapshotInput = {
  generatedBy?: InputMaybe<Scalars['String']['input']>;
  period: SnapshotPeriod;
  periodEnd: Scalars['DateTime']['input'];
  periodStart: Scalars['DateTime']['input'];
  referencedIds?: InputMaybe<Array<Scalars['String']['input']>>;
  scope: SnapshotScope;
  source: SnapshotSource;
  subjectKey?: InputMaybe<Scalars['String']['input']>;
  subjectLabel?: InputMaybe<Scalars['String']['input']>;
  summaryMarkdown?: InputMaybe<Scalars['String']['input']>;
  totalItems?: InputMaybe<Scalars['Int']['input']>;
};

export type UpsertCareDayRecordInput = {
  dayKey: Scalars['String']['input'];
  residentCount?: InputMaybe<Scalars['Int']['input']>;
  targetMinutesPerResident?: InputMaybe<Scalars['Int']['input']>;
  targetRnMinutesPerResident?: InputMaybe<Scalars['Float']['input']>;
};

export type UpsertCareQuarterTargetInput = {
  enMinutesPerResident?: InputMaybe<Scalars['Float']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  quarter: Scalars['String']['input'];
  rnMinutesPerResident: Scalars['Float']['input'];
  source?: InputMaybe<CareTargetSource>;
  totalMinutesPerResident: Scalars['Float']['input'];
};

export type UpsertCommandDealInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  appSetter?: InputMaybe<Scalars['String']['input']>;
  buildPrice?: InputMaybe<Scalars['Float']['input']>;
  builder?: InputMaybe<Scalars['String']['input']>;
  client: Scalars['String']['input'];
  commandClientId?: InputMaybe<Scalars['String']['input']>;
  commsOwed?: InputMaybe<Scalars['Float']['input']>;
  commsPaid?: InputMaybe<Scalars['Float']['input']>;
  eoiDate?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  ipValue?: InputMaybe<Scalars['Float']['input']>;
  landPrice?: InputMaybe<Scalars['Float']['input']>;
  mortStage?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  payStatus?: InputMaybe<Scalars['String']['input']>;
  pcDue?: InputMaybe<Scalars['String']['input']>;
  sourceId?: InputMaybe<Scalars['String']['input']>;
  sourceSystem?: InputMaybe<CommandSourceSystem>;
  stage?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  strategist?: InputMaybe<Scalars['String']['input']>;
  structure?: InputMaybe<Scalars['String']['input']>;
  totalComms?: InputMaybe<Scalars['Float']['input']>;
};

export type UpsertPersonEnrichmentInput = {
  affiliation?: InputMaybe<Scalars['String']['input']>;
  baseId: Scalars['ID']['input'];
  birthYear?: InputMaybe<Scalars['Int']['input']>;
  deathYear?: InputMaybe<Scalars['Int']['input']>;
  lifeStatus?: InputMaybe<LifeStatus>;
  name: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  oneLiner?: InputMaybe<Scalars['String']['input']>;
  personSlug: Scalars['String']['input'];
  sourceTitle?: InputMaybe<Scalars['String']['input']>;
  sourceUrl?: InputMaybe<Scalars['String']['input']>;
};

export type UpsertVoipNumberInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  carrier?: InputMaybe<Scalars['String']['input']>;
  carrierCostMonthly?: InputMaybe<Scalars['Float']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  monthlyCostToCustomer?: InputMaybe<Scalars['Float']['input']>;
  number: Scalars['String']['input'];
  recordingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  serviceType?: InputMaybe<Scalars['String']['input']>;
  site?: InputMaybe<Scalars['String']['input']>;
};

export type UpsertVoipSnapshotInput = {
  flaggedItems?: InputMaybe<Array<VoipFlaggedItemInput>>;
  generatedBy?: InputMaybe<Scalars['String']['input']>;
  period: VoipSnapshotPeriod;
  periodEnd: Scalars['DateTime']['input'];
  periodStart: Scalars['DateTime']['input'];
  referencedIds?: InputMaybe<Array<Scalars['String']['input']>>;
  scope: VoipSnapshotScope;
  subjectKey?: InputMaybe<Scalars['String']['input']>;
  subjectLabel?: InputMaybe<Scalars['String']['input']>;
  summaryMarkdown?: InputMaybe<Scalars['String']['input']>;
  totalItems?: InputMaybe<Scalars['Int']['input']>;
};

/** Urgency level for booking requests */
export enum UrgencyLevel {
  Flexible = 'FLEXIBLE',
  Priority = 'PRIORITY',
  Standard = 'STANDARD',
  Urgent = 'URGENT'
}

export type UrinalysisFilterInput = {
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  residentId?: InputMaybe<Scalars['ID']['input']>;
  wing?: InputMaybe<Scalars['String']['input']>;
};

export type UrinalysisObservation = {
  __typename?: 'UrinalysisObservation';
  autoProgressNote: Scalars['Boolean']['output'];
  bilirubin?: Maybe<Scalars['String']['output']>;
  blood?: Maybe<Scalars['String']['output']>;
  comments?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  glucose?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  ketones?: Maybe<Scalars['String']['output']>;
  leucocytes?: Maybe<Scalars['String']['output']>;
  nitrites?: Maybe<Scalars['String']['output']>;
  ph?: Maybe<Scalars['String']['output']>;
  progressNoteId?: Maybe<Scalars['ID']['output']>;
  protein?: Maybe<Scalars['String']['output']>;
  residentId: Scalars['ID']['output'];
  residentName?: Maybe<Scalars['String']['output']>;
  residentRoom?: Maybe<Scalars['String']['output']>;
  residentWing?: Maybe<Scalars['String']['output']>;
  specificGravity?: Maybe<Scalars['String']['output']>;
  takenAt: Scalars['DateTime']['output'];
  takenBy: Scalars['ID']['output'];
  takenByName?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  urobilinogen?: Maybe<Scalars['String']['output']>;
};

export type UrinalysisObservationsResponse = {
  __typename?: 'UrinalysisObservationsResponse';
  limit: Scalars['Int']['output'];
  observations: Array<UrinalysisObservation>;
  offset: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type UserEditStats = {
  __typename?: 'UserEditStats';
  editCount: Scalars['Float']['output'];
  email: Scalars['String']['output'];
  lastEditAt?: Maybe<Scalars['DateTime']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type Vaccination = {
  __typename?: 'Vaccination';
  administeredBy?: Maybe<Scalars['ID']['output']>;
  administeredByName?: Maybe<Scalars['String']['output']>;
  administeredDate?: Maybe<Scalars['DateTime']['output']>;
  batchNumber?: Maybe<Scalars['String']['output']>;
  consentDate?: Maybe<Scalars['DateTime']['output']>;
  consentObtained?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['DateTime']['output'];
  declinedReason?: Maybe<Scalars['String']['output']>;
  expiryDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  nextDueDate?: Maybe<Scalars['DateTime']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  residentId: Scalars['ID']['output'];
  residentName?: Maybe<Scalars['String']['output']>;
  residentRoom?: Maybe<Scalars['String']['output']>;
  residentWing?: Maybe<Scalars['String']['output']>;
  site?: Maybe<Scalars['String']['output']>;
  sourceAuthor?: Maybe<Scalars['String']['output']>;
  sourceBackupDate?: Maybe<Scalars['DateTime']['output']>;
  sourceFields?: Maybe<SarahVaccinationSourceFields>;
  sourceHash?: Maybe<Scalars['String']['output']>;
  sourceId?: Maybe<Scalars['String']['output']>;
  sourceSystem?: Maybe<Scalars['String']['output']>;
  status: VaccinationStatus;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  vaccineName?: Maybe<Scalars['String']['output']>;
  vaccineType: VaccineType;
};

export type VaccinationFilterInput = {
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  residentId?: InputMaybe<Scalars['ID']['input']>;
  sourceSystem?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<VaccinationStatus>;
  vaccineType?: InputMaybe<VaccineType>;
  wing?: InputMaybe<Scalars['String']['input']>;
};

/** Status of a vaccination record */
export enum VaccinationStatus {
  Completed = 'COMPLETED',
  Contraindicated = 'CONTRAINDICATED',
  Declined = 'DECLINED',
  Overdue = 'OVERDUE',
  Scheduled = 'SCHEDULED'
}

export type VaccinationsResponse = {
  __typename?: 'VaccinationsResponse';
  limit: Scalars['Int']['output'];
  offset: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  vaccinations: Array<Vaccination>;
};

/** Type of vaccine administered or scheduled */
export enum VaccineType {
  Covid_19 = 'COVID_19',
  HepatitisB = 'HEPATITIS_B',
  Influenza = 'INFLUENZA',
  Other = 'OTHER',
  Pneumococcal = 'PNEUMOCOCCAL',
  Shingles = 'SHINGLES',
  Tetanus = 'TETANUS'
}

export type ValidateQrCodeInput = {
  code: Scalars['String']['input'];
  locationId: Scalars['ID']['input'];
};

export type ValidatorApproval = {
  __typename?: 'ValidatorApproval';
  approvedAt: Scalars['DateTime']['output'];
  transactionHash?: Maybe<Scalars['String']['output']>;
  validatorId: Scalars['String']['output'];
  validatorName: Scalars['String']['output'];
  validatorWalletAddress?: Maybe<Scalars['String']['output']>;
};

/** Status of a validator */
export enum ValidatorStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  Suspended = 'SUSPENDED'
}

/** Source of a statutory land valuation (CC-BY 4.0 government data only) */
export enum ValuationSource {
  BccRateable = 'BCC_RATEABLE',
  ValuerGeneralStatutory = 'VALUER_GENERAL_STATUTORY'
}

export type ValueStream = {
  __typename?: 'ValueStream';
  amount: Scalars['Float']['output'];
  currency: ValueStreamCurrency;
  description?: Maybe<Scalars['String']['output']>;
  probability?: Maybe<Scalars['Float']['output']>;
  type: ValueStreamType;
};

/** Currency or unit for a value stream */
export enum ValueStreamCurrency {
  Aud = 'AUD',
  Btc = 'BTC',
  Eth = 'ETH',
  Paxg = 'PAXG',
  Percent = 'PERCENT',
  Usd = 'USD'
}

export type ValueStreamInput = {
  amount: Scalars['Float']['input'];
  currency: ValueStreamCurrency;
  description?: InputMaybe<Scalars['String']['input']>;
  probability?: InputMaybe<Scalars['Float']['input']>;
  type: ValueStreamType;
};

/** Type of value stream (cash, crypto, or equity) */
export enum ValueStreamType {
  Cash = 'CASH',
  Crypto = 'CRYPTO',
  Equity = 'EQUITY'
}

export type VapiAccessToken = {
  __typename?: 'VapiAccessToken';
  expiresAt: Scalars['DateTime']['output'];
  token: Scalars['String']['output'];
};

export type VapiCallLog = {
  __typename?: 'VapiCallLog';
  assistantId?: Maybe<Scalars['String']['output']>;
  assistantName?: Maybe<Scalars['String']['output']>;
  budget?: Maybe<Scalars['String']['output']>;
  callId: Scalars['String']['output'];
  callbackTime?: Maybe<Scalars['String']['output']>;
  clientId?: Maybe<Scalars['ID']['output']>;
  cost?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['DateTime']['output'];
  customerNumber?: Maybe<Scalars['String']['output']>;
  direction: Scalars['String']['output'];
  duration: Scalars['Float']['output'];
  endedAt?: Maybe<Scalars['DateTime']['output']>;
  endedReason?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  interestedTier?: Maybe<Scalars['String']['output']>;
  leadBusinessName?: Maybe<Scalars['String']['output']>;
  leadEmail?: Maybe<Scalars['String']['output']>;
  leadName?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  rawWebhookData?: Maybe<Scalars['String']['output']>;
  recordingUrl?: Maybe<Scalars['String']['output']>;
  requirements?: Maybe<Scalars['String']['output']>;
  startedAt: Scalars['DateTime']['output'];
  status: Scalars['String']['output'];
  summary?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  timeline?: Maybe<Scalars['String']['output']>;
  transcript?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type VapiConfig = {
  __typename?: 'VapiConfig';
  assistantId?: Maybe<Scalars['String']['output']>;
  isConfigured: Scalars['Boolean']['output'];
  phoneNumberId?: Maybe<Scalars['String']['output']>;
  publicApiKey?: Maybe<Scalars['String']['output']>;
};

export type VapiWorkflow = {
  __typename?: 'VapiWorkflow';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  nodes?: Maybe<Array<VapiWorkflowNode>>;
  orgId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type VapiWorkflowNode = {
  __typename?: 'VapiWorkflowNode';
  id: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type VaultBalance = {
  __typename?: 'VaultBalance';
  amount: Scalars['Float']['output'];
  asset: Scalars['String']['output'];
  chain: Scalars['String']['output'];
};

/** How often a vault-insights digest should fire */
export enum VaultInsightCadence {
  Daily = 'DAILY',
  OnDemand = 'ON_DEMAND',
  Weekly = 'WEEKLY'
}

/** Delivery channel for the digest */
export enum VaultInsightChannel {
  Email = 'EMAIL',
  Sms = 'SMS'
}

/** Who receives the digest. SELF is the rule's creator (their Client+Employee record). */
export enum VaultInsightRecipientType {
  ClientTag = 'CLIENT_TAG',
  Self = 'SELF',
  SpecificClient = 'SPECIFIC_CLIENT',
  SpecificEmployee = 'SPECIFIC_EMPLOYEE'
}

export type VaultInsightRule = {
  __typename?: 'VaultInsightRule';
  cadence: VaultInsightCadence;
  channels: Array<VaultInsightChannel>;
  createdAt: Scalars['DateTime']['output'];
  createdByClientId?: Maybe<Scalars['String']['output']>;
  customPromptAddendum?: Maybe<Scalars['String']['output']>;
  daysOfWeek?: Maybe<Array<Scalars['Int']['output']>>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  isEnabled: Scalars['Boolean']['output'];
  lastFiredAt?: Maybe<Scalars['DateTime']['output']>;
  lookbackDays?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  nextFireAt?: Maybe<Scalars['DateTime']['output']>;
  recipientClientIds?: Maybe<Array<Scalars['String']['output']>>;
  recipientTag?: Maybe<Scalars['String']['output']>;
  recipientType: VaultInsightRecipientType;
  sections: Array<VaultInsightSection>;
  tenantId: Scalars['String']['output'];
  timeOfDay?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type VaultInsightRun = {
  __typename?: 'VaultInsightRun';
  aiPromptSent?: Maybe<Scalars['String']['output']>;
  aiResponseRaw?: Maybe<Scalars['String']['output']>;
  costCents?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['DateTime']['output'];
  emailHtml?: Maybe<Scalars['String']['output']>;
  emailSubject?: Maybe<Scalars['String']['output']>;
  emailsSent: Scalars['Int']['output'];
  errorMessage?: Maybe<Scalars['String']['output']>;
  firedAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  inputTokens?: Maybe<Scalars['Int']['output']>;
  latencyMs?: Maybe<Scalars['Int']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  outputTokens?: Maybe<Scalars['Int']['output']>;
  postmarkMessageIds?: Maybe<Scalars['String']['output']>;
  recipientCount: Scalars['Int']['output'];
  ruleId: Scalars['String']['output'];
  sectionsIncluded: Array<Scalars['String']['output']>;
  smsBody?: Maybe<Scalars['String']['output']>;
  smsSent: Scalars['Int']['output'];
  success: Scalars['Boolean']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** Toggleable sections of the digest body */
export enum VaultInsightSection {
  ActionItemBacklog = 'ACTION_ITEM_BACKLOG',
  AiCuratedNarrative = 'AI_CURATED_NARRATIVE',
  AudioInboxQueue = 'AUDIO_INBOX_QUEUE',
  Goal_60K = 'GOAL_60K',
  Pipeline = 'PIPELINE',
  RecentDailyLogs = 'RECENT_DAILY_LOGS',
  StaleProjects = 'STALE_PROJECTS',
  TodayTasks = 'TODAY_TASKS',
  WheelOfLifeDelta = 'WHEEL_OF_LIFE_DELTA'
}

/** Status of a custody vault */
export enum VaultStatus {
  Active = 'ACTIVE',
  Closed = 'CLOSED',
  Frozen = 'FROZEN'
}

/** Type of vehicle */
export enum VehicleType {
  Car = 'CAR',
  Equipment = 'EQUIPMENT',
  Motorcycle = 'MOTORCYCLE',
  Other = 'OTHER',
  Suv = 'SUV',
  Trailer = 'TRAILER',
  Truck = 'TRUCK',
  Van = 'VAN'
}

export type VercelDomainInfo = {
  __typename?: 'VercelDomainInfo';
  configured: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  verified: Scalars['Boolean']['output'];
};

export type VerifyDomainInput = {
  id: Scalars['ID']['input'];
};

export type VerifyEmailChangeInput = {
  clientId: Scalars['String']['input'];
  newEmail: Scalars['String']['input'];
  words: Scalars['String']['input'];
};

export type VerifyPProposalEmailInput = {
  email: Scalars['String']['input'];
  proposalId: Scalars['String']['input'];
  verificationCode: Scalars['String']['input'];
};

export type VerifyPasskeyAuthenticationInput = {
  responseJSON: Scalars['String']['input'];
};

export type VerifyPasskeyRegistrationInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  responseJSON: Scalars['String']['input'];
};

export type VerifyPasswordResetCodeInput = {
  code: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type VerifyPhoneChangeInput = {
  clientId: Scalars['String']['input'];
  newPhoneNumber: Scalars['String']['input'];
  words: Scalars['String']['input'];
};

export type VerifyProposalEmailInput = {
  email: Scalars['String']['input'];
  proposalId: Scalars['String']['input'];
  verificationCode: Scalars['String']['input'];
};

/** Types of embedded videos */
export enum VideoEmbedType {
  Ipfs = 'IPFS',
  Rumble = 'RUMBLE',
  Youtube = 'YOUTUBE'
}

/** Ordering for the harvested-video catalogue */
export enum VideoSort {
  AddedDesc = 'ADDED_DESC',
  DurationDesc = 'DURATION_DESC',
  PublishedAsc = 'PUBLISHED_ASC',
  PublishedDesc = 'PUBLISHED_DESC',
  TitleAsc = 'TITLE_ASC'
}

/** Current visa status */
export enum VisaStatus {
  InvestorVisaGranted = 'INVESTOR_VISA_GRANTED',
  InvestorVisaPending = 'INVESTOR_VISA_PENDING',
  NoVisa = 'NO_VISA',
  PermanentResident = 'PERMANENT_RESIDENT',
  Tourist = 'TOURIST',
  WorkVisa = 'WORK_VISA'
}

/** Why the caller may see this board: it is theirs, it was shared with them, or they hold the manager level. */
export enum VisionBoardAccess {
  Manager = 'MANAGER',
  Owner = 'OWNER',
  Shared = 'SHARED'
}

export type VisionBoardConfig = {
  __typename?: 'VisionBoardConfig';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  maxFreeInvites: Scalars['Float']['output'];
  referralRewardEnabled: Scalars['Boolean']['output'];
  referralRewardValue: Scalars['Float']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type VisionBoardInvite = {
  __typename?: 'VisionBoardInvite';
  accessMode: VisionBoardInviteAccessMode;
  accessedAt?: Maybe<Scalars['DateTime']['output']>;
  activatedAt?: Maybe<Scalars['DateTime']['output']>;
  clientId?: Maybe<Scalars['ID']['output']>;
  couponCode?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdByName?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  emailSentAt?: Maybe<Scalars['DateTime']['output']>;
  existingClientId?: Maybe<Scalars['ID']['output']>;
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  expiringSoonNotifiedAt?: Maybe<Scalars['DateTime']['output']>;
  fName?: Maybe<Scalars['String']['output']>;
  feedbackComment?: Maybe<Scalars['String']['output']>;
  feedbackRating?: Maybe<Scalars['Float']['output']>;
  feedbackSubmittedAt?: Maybe<Scalars['DateTime']['output']>;
  firstItemAddedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  invitedByClientId?: Maybe<Scalars['ID']['output']>;
  lName?: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  smsSentAt?: Maybe<Scalars['DateTime']['output']>;
  status: VisionBoardInviteStatus;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** How the invitee is meant to get access to the Vision Board */
export enum VisionBoardInviteAccessMode {
  Coupon = 'COUPON',
  Free = 'FREE',
  Paid = 'PAID',
  RewardTokens = 'REWARD_TOKENS'
}

export type VisionBoardInviteClaimResult = {
  __typename?: 'VisionBoardInviteClaimResult';
  hadExistingAccount: Scalars['Boolean']['output'];
  message: Scalars['String']['output'];
  requiresLogin: Scalars['Boolean']['output'];
  success: Scalars['Boolean']['output'];
  token?: Maybe<Scalars['String']['output']>;
};

export type VisionBoardInviteGraphNode = {
  __typename?: 'VisionBoardInviteGraphNode';
  canViewDetail: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  detailUrl?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  inviteId: Scalars['ID']['output'];
  invitedByClientId?: Maybe<Scalars['ID']['output']>;
  invitedByDisplayName?: Maybe<Scalars['String']['output']>;
  status: VisionBoardInviteStatus;
};

/** Status of a Vision Board onboarding invite */
export enum VisionBoardInviteStatus {
  Accessed = 'ACCESSED',
  Active = 'ACTIVE',
  Expired = 'EXPIRED',
  Paid = 'PAID',
  Pending = 'PENDING'
}

export type VisionBoardItem = {
  __typename?: 'VisionBoardItem';
  achieved: Scalars['Boolean']['output'];
  achievedAt?: Maybe<Scalars['DateTime']['output']>;
  color?: Maybe<Scalars['String']['output']>;
  content?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  imageCid?: Maybe<Scalars['String']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  order: Scalars['Int']['output'];
  positionX: Scalars['Int']['output'];
  positionY: Scalars['Int']['output'];
  tenantId: Scalars['String']['output'];
  type: VisionBoardItemType;
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<VisionBoardUser>;
  userId: Scalars['ID']['output'];
};

/** Type of vision board item (post-it note or uploaded image) */
export enum VisionBoardItemType {
  Image = 'IMAGE',
  Note = 'NOTE'
}

/** How to resolve who gets a vision-board notification */
export enum VisionBoardNotificationRecipientType {
  AllCoaches = 'ALL_COACHES',
  SpecificClient = 'SPECIFIC_CLIENT'
}

export type VisionBoardNotificationRule = {
  __typename?: 'VisionBoardNotificationRule';
  channels: Array<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  isEnabled: Scalars['Boolean']['output'];
  messageTemplate?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  recipientIds?: Maybe<Array<Scalars['String']['output']>>;
  recipientType: VisionBoardNotificationRecipientType;
  tenantId: Scalars['String']['output'];
  trigger: VisionBoardNotificationTrigger;
  updatedAt: Scalars['DateTime']['output'];
};

/** Event that triggers a vision-board notification */
export enum VisionBoardNotificationTrigger {
  FeedbackSubmitted = 'FEEDBACK_SUBMITTED',
  FirstItemAdded = 'FIRST_ITEM_ADDED',
  InviteAccessed = 'INVITE_ACCESSED',
  InviteActivated = 'INVITE_ACTIVATED',
  InviteExpiringSoon = 'INVITE_EXPIRING_SOON'
}

export type VisionBoardPerson = {
  __typename?: 'VisionBoardPerson';
  /** Masked email ("ma…@gmail.com") to tell same-named people apart; never the full address. */
  emailHint?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type VisionBoardReadOnly = {
  __typename?: 'VisionBoardReadOnly';
  access: VisionBoardAccess;
  items: Array<VisionBoardItem>;
  owner: VisionBoardPerson;
};

export type VisionBoardShareEntry = {
  __typename?: 'VisionBoardShareEntry';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  sharedWith: VisionBoardPerson;
};

/** What happened for ONE person in a share request — reported per person, never as one overall success. */
export enum VisionBoardShareOutcome {
  AlreadyShared = 'ALREADY_SHARED',
  Failed = 'FAILED',
  NotFound = 'NOT_FOUND',
  Self = 'SELF',
  Shared = 'SHARED'
}

export type VisionBoardShareResult = {
  __typename?: 'VisionBoardShareResult';
  clientId: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  outcome: VisionBoardShareOutcome;
};

export type VisionBoardSummary = {
  __typename?: 'VisionBoardSummary';
  achievedCount: Scalars['Int']['output'];
  imageCount: Scalars['Int']['output'];
  itemCount: Scalars['Int']['output'];
  /** Most recent change to any item on the board. */
  lastUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  owner: VisionBoardPerson;
  /** When the board was shared with the caller (shared-with-me list only). */
  sharedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type VisionBoardUser = {
  __typename?: 'VisionBoardUser';
  email?: Maybe<Scalars['String']['output']>;
  fName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lName?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
};

export type VlogCategory = {
  __typename?: 'VlogCategory';
  color?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  parentId?: Maybe<Scalars['ID']['output']>;
  slug: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** How to determine who receives a vlog notification */
export enum VlogNotificationRecipientType {
  AllAdmins = 'ALL_ADMINS',
  AllAuthors = 'ALL_AUTHORS',
  SpecificClients = 'SPECIFIC_CLIENTS'
}

export type VlogNotificationRule = {
  __typename?: 'VlogNotificationRule';
  channels: Array<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  isEnabled: Scalars['Boolean']['output'];
  messageTemplate?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  recipientIds?: Maybe<Array<Scalars['String']['output']>>;
  recipientType: VlogNotificationRecipientType;
  tenantId: Scalars['String']['output'];
  timing: VlogNotificationTiming;
  timingMinutes?: Maybe<Scalars['Int']['output']>;
  trigger: VlogNotificationTrigger;
  updatedAt: Scalars['DateTime']['output'];
};

/** When to send a vlog notification relative to trigger */
export enum VlogNotificationTiming {
  Immediate = 'IMMEDIATE',
  MinutesAfter = 'MINUTES_AFTER'
}

/** Events that can trigger a vlog notification */
export enum VlogNotificationTrigger {
  NewEpisodeInSeries = 'NEW_EPISODE_IN_SERIES',
  PollVoteReceived = 'POLL_VOTE_RECEIVED',
  PostArchived = 'POST_ARCHIVED',
  PostPublished = 'POST_PUBLISHED',
  PostUpdated = 'POST_UPDATED',
  ReactionMilestone = 'REACTION_MILESTONE',
  ViewMilestone = 'VIEW_MILESTONE'
}

export type VlogPersonalizationOption = {
  __typename?: 'VlogPersonalizationOption';
  contentVariant?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  label: Scalars['String']['output'];
};

export type VlogPersonalizationOptionInput = {
  contentVariant?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  label: Scalars['String']['input'];
};

export type VlogPollOption = {
  __typename?: 'VlogPollOption';
  count: Scalars['Int']['output'];
  label: Scalars['String']['output'];
};

export type VlogPollOptionInput = {
  count?: InputMaybe<Scalars['Int']['input']>;
  label: Scalars['String']['input'];
};

export type VlogPost = {
  __typename?: 'VlogPost';
  aiChatEnabled: Scalars['Boolean']['output'];
  aiChatSeedQuestions?: Maybe<Array<Scalars['String']['output']>>;
  author?: Maybe<Scalars['String']['output']>;
  authorAvatarUrl?: Maybe<Scalars['String']['output']>;
  authorBio?: Maybe<Scalars['String']['output']>;
  bonusContent?: Maybe<Scalars['String']['output']>;
  bonusUnlockPercent?: Maybe<Scalars['Int']['output']>;
  bulletPoints?: Maybe<Array<Scalars['String']['output']>>;
  categories?: Maybe<Array<Scalars['String']['output']>>;
  companionArticleMarkdown?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  ctaClickCount: Scalars['Int']['output'];
  durationSeconds: Scalars['Int']['output'];
  episodeNumber?: Maybe<Scalars['Int']['output']>;
  excerpt?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  leadFormId?: Maybe<Scalars['String']['output']>;
  leadMagnetDescription?: Maybe<Scalars['String']['output']>;
  leadMagnetTitle?: Maybe<Scalars['String']['output']>;
  metaDescription?: Maybe<Scalars['String']['output']>;
  metaTitle?: Maybe<Scalars['String']['output']>;
  ogImage?: Maybe<Scalars['String']['output']>;
  personalizationOptions?: Maybe<Array<VlogPersonalizationOption>>;
  personalizationQuestion?: Maybe<Scalars['String']['output']>;
  pollOptions?: Maybe<Array<VlogPollOption>>;
  pollQuestion?: Maybe<Scalars['String']['output']>;
  previewClipUrl?: Maybe<Scalars['String']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  seriesId?: Maybe<Scalars['ID']['output']>;
  seriesName?: Maybe<Scalars['String']['output']>;
  seriesSlug?: Maybe<Scalars['String']['output']>;
  skin?: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  status: VlogPostStatus;
  subtitle?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  tenantId: Scalars['String']['output'];
  thumbnailCid?: Maybe<Scalars['String']['output']>;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  toolCtaDescription?: Maybe<Scalars['String']['output']>;
  toolCtaText?: Maybe<Scalars['String']['output']>;
  toolCtaUrl?: Maybe<Scalars['String']['output']>;
  transcript?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  videoCid?: Maybe<Scalars['String']['output']>;
  videoCustomIframe?: Maybe<Scalars['String']['output']>;
  videoIpfsHash?: Maybe<Scalars['String']['output']>;
  videoProvider: VlogVideoProvider;
  videoUrl?: Maybe<Scalars['String']['output']>;
  viewCount: Scalars['Int']['output'];
  visibility: VlogPostVisibility;
};

export type VlogPostFilterInput = {
  author?: InputMaybe<Scalars['String']['input']>;
  categoryId?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  seriesId?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<VlogPostStatus>;
  tag?: InputMaybe<Scalars['String']['input']>;
  visibility?: InputMaybe<VlogPostVisibility>;
};

/** The publication status of a vlog post */
export enum VlogPostStatus {
  Archived = 'ARCHIVED',
  Draft = 'DRAFT',
  Published = 'PUBLISHED'
}

export type VlogPostView = {
  __typename?: 'VlogPostView';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  personaChoice?: Maybe<Scalars['String']['output']>;
  postId: Scalars['ID']['output'];
  scrollDepth?: Maybe<Scalars['Int']['output']>;
  sessionId: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  viewedAt: Scalars['DateTime']['output'];
  watchPercent?: Maybe<Scalars['Int']['output']>;
};

/** Who can view this vlog post */
export enum VlogPostVisibility {
  Authenticated = 'AUTHENTICATED',
  Premium = 'PREMIUM',
  Public = 'PUBLIC'
}

export type VlogReaction = {
  __typename?: 'VlogReaction';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  postId: Scalars['ID']['output'];
  reactionType: VlogReactionType;
  sessionId: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type VlogReactionCounts = {
  __typename?: 'VlogReactionCounts';
  helpful: Scalars['Int']['output'];
  inspiring: Scalars['Int']['output'];
  notHelpful: Scalars['Int']['output'];
  postId: Scalars['ID']['output'];
  practical: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type VlogReactionInput = {
  postId: Scalars['ID']['input'];
  reactionType: VlogReactionType;
  sessionId: Scalars['String']['input'];
};

/** Types of reactions viewers can leave on vlogs */
export enum VlogReactionType {
  Helpful = 'HELPFUL',
  Inspiring = 'INSPIRING',
  NotHelpful = 'NOT_HELPFUL',
  Practical = 'PRACTICAL'
}

export type VlogSeries = {
  __typename?: 'VlogSeries';
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  episodeCount?: Maybe<Scalars['Int']['output']>;
  heroImage?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  slug: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  totalDurationSeconds?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

/** Video hosting provider for embedded vlog videos */
export enum VlogVideoProvider {
  Bitchute = 'BITCHUTE',
  CustomIframe = 'CUSTOM_IFRAME',
  Ipfs = 'IPFS',
  None = 'NONE',
  Rumble = 'RUMBLE',
  Vimeo = 'VIMEO',
  Youtube = 'YOUTUBE'
}

export type VoiceContact = {
  __typename?: 'VoiceContact';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  phoneNumber: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type VoiceContactInput = {
  name: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
};

export type VoiceContactPage = {
  __typename?: 'VoiceContactPage';
  hasMore: Scalars['Boolean']['output'];
  items: Array<VoiceContact>;
};

export type VoiceLeaseTicket = {
  __typename?: 'VoiceLeaseTicket';
  leaseId?: Maybe<Scalars['String']['output']>;
  /** Why the call may not start right now (another voice call is running, or the Studio's collector is unreachable). */
  message?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
  ttlSec: Scalars['Int']['output'];
};

export type VoicePreferences = {
  __typename?: 'VoicePreferences';
  available: Scalars['Boolean']['output'];
  clientId: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  emailNotifications: Scalars['Boolean']['output'];
  forwardToNumber?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastSeenAt?: Maybe<Scalars['DateTime']['output']>;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type VoicePreferencesInput = {
  available?: InputMaybe<Scalars['Boolean']['input']>;
  emailNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  forwardToNumber?: InputMaybe<Scalars['String']['input']>;
};

export type VoiceSetupStatus = {
  __typename?: 'VoiceSetupStatus';
  browserConfigured: Scalars['Boolean']['output'];
  browserWebhookUrl: Scalars['String']['output'];
  canAdminister: Scalars['Boolean']['output'];
  inboundWebhookUrl: Scalars['String']['output'];
  serverConfigured: Scalars['Boolean']['output'];
};

export type VoiceSignature = {
  __typename?: 'VoiceSignature';
  createdAt: Scalars['DateTime']['output'];
  displayName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  lastSeenAt?: Maybe<Scalars['DateTime']['output']>;
  mappedClientId?: Maybe<Scalars['ID']['output']>;
  mappedName?: Maybe<Scalars['String']['output']>;
  sampleCount: Scalars['Float']['output'];
  tenantId: Scalars['String']['output'];
  transcriptions?: Maybe<Array<VoiceSignatureTranscriptionRef>>;
  updatedAt: Scalars['DateTime']['output'];
};

export type VoiceSignatureTranscriptionRef = {
  __typename?: 'VoiceSignatureTranscriptionRef';
  date?: Maybe<Scalars['DateTime']['output']>;
  localLabel?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  transcriptionId: Scalars['ID']['output'];
};

export type VoiceUser = {
  __typename?: 'VoiceUser';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type VoiceUserPage = {
  __typename?: 'VoiceUserPage';
  hasMore: Scalars['Boolean']['output'];
  items: Array<VoiceUser>;
};

export type VoipCall = {
  __typename?: 'VoipCall';
  audioIpfsCid?: Maybe<Scalars['String']['output']>;
  audioUrl?: Maybe<Scalars['String']['output']>;
  contactName?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  direction: VoipCallDirection;
  durationSeconds?: Maybe<Scalars['Int']['output']>;
  externalCallId?: Maybe<Scalars['String']['output']>;
  flagReason?: Maybe<Scalars['String']['output']>;
  flagged: Scalars['Boolean']['output'];
  fromNumber?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  missed: Scalars['Boolean']['output'];
  ownNumber: Scalars['String']['output'];
  rawData?: Maybe<Scalars['String']['output']>;
  recordingUrl?: Maybe<Scalars['String']['output']>;
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  toNumber?: Maybe<Scalars['String']['output']>;
  transcript?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export enum VoipCallDirection {
  Inbound = 'INBOUND',
  Outbound = 'OUTBOUND'
}

export type VoipCallFilterInput = {
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  direction?: InputMaybe<VoipCallDirection>;
  flaggedOnly?: InputMaybe<Scalars['Boolean']['input']>;
  ownNumber?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type VoipFlaggedItem = {
  __typename?: 'VoipFlaggedItem';
  callId: Scalars['String']['output'];
  priority?: Maybe<Scalars['String']['output']>;
  reason: Scalars['String']['output'];
};

export type VoipFlaggedItemInput = {
  callId: Scalars['String']['input'];
  priority?: InputMaybe<Scalars['String']['input']>;
  reason: Scalars['String']['input'];
};

export type VoipNumber = {
  __typename?: 'VoipNumber';
  active: Scalars['Boolean']['output'];
  carrier?: Maybe<Scalars['String']['output']>;
  carrierCostMonthly?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  label?: Maybe<Scalars['String']['output']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']['output']>;
  monthlyCostToCustomer?: Maybe<Scalars['Float']['output']>;
  number: Scalars['String']['output'];
  recordingEnabled: Scalars['Boolean']['output'];
  serviceType?: Maybe<Scalars['String']['output']>;
  site?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type VoipSnapshot = {
  __typename?: 'VoipSnapshot';
  createdAt: Scalars['DateTime']['output'];
  flaggedItems: Array<VoipFlaggedItem>;
  generatedBy?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  inboundCount: Scalars['Int']['output'];
  missedCount: Scalars['Int']['output'];
  outboundCount: Scalars['Int']['output'];
  period: VoipSnapshotPeriod;
  periodEnd: Scalars['DateTime']['output'];
  periodStart: Scalars['DateTime']['output'];
  referencedIds: Array<Scalars['String']['output']>;
  scope: VoipSnapshotScope;
  subjectKey?: Maybe<Scalars['String']['output']>;
  subjectLabel?: Maybe<Scalars['String']['output']>;
  summaryMarkdown?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  totalDurationSeconds: Scalars['Int']['output'];
  totalItems: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type VoipSnapshotFilterInput = {
  period?: InputMaybe<VoipSnapshotPeriod>;
  scope?: InputMaybe<VoipSnapshotScope>;
  subjectKey?: InputMaybe<Scalars['String']['input']>;
};

export enum VoipSnapshotPeriod {
  Daily = 'DAILY',
  Monthly = 'MONTHLY',
  Weekly = 'WEEKLY'
}

export enum VoipSnapshotScope {
  Number = 'NUMBER',
  Tenant = 'TENANT'
}

/** Concessional (supported) or RAD (refundable accommodation deposit) */
export enum WaitingListAccommodationPayment {
  Concessional = 'CONCESSIONAL',
  Rad = 'RAD',
  Unknown = 'UNKNOWN'
}

export type WaitingListActivity = {
  __typename?: 'WaitingListActivity';
  actorId?: Maybe<Scalars['ID']['output']>;
  /** Display name of whoever did it, as it was then */
  actorName: Scalars['String']['output'];
  /** When it happened (a check-in may be back-dated to when the call was made) */
  at: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  entryId: Scalars['ID']['output'];
  fileId?: Maybe<Scalars['ID']['output']>;
  fromStage?: Maybe<WaitingListStage>;
  id: Scalars['ID']['output'];
  method?: Maybe<WaitingListCheckInMethod>;
  /** The note, reason or check-in note typed by staff */
  note?: Maybe<Scalars['String']['output']>;
  /** The text as it was BEFORE this change (tour feedback edits) — so an edit never silently loses what was said */
  previousNote?: Maybe<Scalars['String']['output']>;
  /** What happened, in plain words */
  summary: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  toStage?: Maybe<WaitingListStage>;
  type: WaitingListActivityType;
};

export type WaitingListActivityPage = {
  __typename?: 'WaitingListActivityPage';
  items: Array<WaitingListActivity>;
  /** Every row for the entry — the page may show fewer */
  total: Scalars['Int']['output'];
};

/** What an inquiry/waitlist activity-log row records */
export enum WaitingListActivityType {
  Admitted = 'ADMITTED',
  Archived = 'ARCHIVED',
  ChecklistItemAdded = 'CHECKLIST_ITEM_ADDED',
  ChecklistItemRemoved = 'CHECKLIST_ITEM_REMOVED',
  ChecklistTicked = 'CHECKLIST_TICKED',
  ChecklistUnticked = 'CHECKLIST_UNTICKED',
  CheckIn = 'CHECK_IN',
  Created = 'CREATED',
  FamilyMessage = 'FAMILY_MESSAGE',
  FamilyResponse = 'FAMILY_RESPONSE',
  FieldsEdited = 'FIELDS_EDITED',
  FileAdded = 'FILE_ADDED',
  FileMoved = 'FILE_MOVED',
  FileOpened = 'FILE_OPENED',
  NoteAdded = 'NOTE_ADDED',
  ResponsibleChanged = 'RESPONSIBLE_CHANGED',
  Restored = 'RESTORED',
  StageMoved = 'STAGE_MOVED',
  SuitabilityRecorded = 'SUITABILITY_RECORDED',
  TourBooked = 'TOUR_BOOKED',
  TourCancelled = 'TOUR_CANCELLED',
  TourDone = 'TOUR_DONE',
  TourFeedback = 'TOUR_FEEDBACK',
  TourNotPossible = 'TOUR_NOT_POSSIBLE'
}

export type WaitingListAdmissionHistory = {
  __typename?: 'WaitingListAdmissionHistory';
  /** Enquiry source as recorded on the admission (words when SarahCare had a code) */
  enquirySource?: Maybe<Scalars['String']['output']>;
  /** Expected admission date recorded then */
  expectedAdmission?: Maybe<Scalars['DateTime']['output']>;
  recordedBy?: Maybe<Scalars['String']['output']>;
  /** Date SarahCare recorded the admission */
  recordedOn?: Maybe<Scalars['DateTime']['output']>;
  /** PLCC resident this admission became, when known */
  residentId?: Maybe<Scalars['ID']['output']>;
  room?: Maybe<Scalars['String']['output']>;
  /** WaitingList_Admissions:<ID> */
  sourceId: Scalars['String']['output'];
  /** SarahCare resident number (CustID) admitted */
  sourceResidentId?: Maybe<Scalars['String']['output']>;
  wing?: Maybe<Scalars['String']['output']>;
};

/** Why an inquiry/waitlist entry was archived (the stored status says where it ended up) */
export enum WaitingListArchiveReason {
  CouldNotContact = 'COULD_NOT_CONTACT',
  NoLongerNeeded = 'NO_LONGER_NEEDED',
  Other = 'OTHER',
  PassedAway = 'PASSED_AWAY',
  Unsuitable = 'UNSUITABLE',
  WentElsewhere = 'WENT_ELSEWHERE'
}

export type WaitingListAssignablePerson = {
  __typename?: 'WaitingListAssignablePerson';
  /** Login (client) id — what the entry stores and the notice goes to */
  clientId: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  /** Employee's first role, for the picker's second line */
  role?: Maybe<Scalars['String']['output']>;
};

/** How a waitlist check-in happened (recorded only — nothing is sent) */
export enum WaitingListCheckInMethod {
  Email = 'EMAIL',
  InPerson = 'IN_PERSON',
  Other = 'OTHER',
  Phone = 'PHONE',
  Sms = 'SMS'
}

export type WaitingListChecklistItem = {
  __typename?: 'WaitingListChecklistItem';
  completed: Scalars['Boolean']['output'];
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  completedBy?: Maybe<Scalars['String']['output']>;
  /** Login (client) id of whoever ticked it */
  completedById?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  /** Pre-admissions section (Admin / Clinical) */
  section?: Maybe<WaitingListChecklistSection>;
  /** Stage whose checklist this item belongs to (null = added by hand) */
  stage?: Maybe<WaitingListStage>;
  /** Checklist template item this came from (never duplicated on re-entry) */
  templateItemId?: Maybe<Scalars['String']['output']>;
  text: Scalars['String']['output'];
};

/** Admin or Clinical part of the pre-admissions checklist */
export enum WaitingListChecklistSection {
  Admin = 'ADMIN',
  Clinical = 'CLINICAL'
}

export type WaitingListChecklistTemplate = {
  __typename?: 'WaitingListChecklistTemplate';
  id: Scalars['ID']['output'];
  /** Still the starter items nobody has edited yet */
  isStarter: Scalars['Boolean']['output'];
  items: Array<WaitingListChecklistTemplateItem>;
  /** WAITLIST or PRE_ADMISSION */
  stage: WaitingListStage;
  tenantId: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedByName?: Maybe<Scalars['String']['output']>;
};

export type WaitingListChecklistTemplateItem = {
  __typename?: 'WaitingListChecklistTemplateItem';
  /** Stable id — entries match on it so re-entering a stage never duplicates */
  id: Scalars['String']['output'];
  /** Position — a meaningful sequence the manager sets (not A–Z) */
  order: Scalars['Int']['output'];
  /** Pre-admissions only: Admin or Clinical */
  section?: Maybe<WaitingListChecklistSection>;
  text: Scalars['String']['output'];
};

export type WaitingListChecklistTemplateItemInput = {
  /** Existing item id (keep it so entries still match); omit for a new item */
  id?: InputMaybe<Scalars['String']['input']>;
  section?: InputMaybe<WaitingListChecklistSection>;
  text: Scalars['String']['input'];
};

export type WaitingListContact = {
  __typename?: 'WaitingListContact';
  address?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  /** Mobile phone (SarahCare MPhone) */
  mobile?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  /** SarahCare recorded this contact as power of attorney (history — not a current authority) */
  powerOfAttorney?: Maybe<Scalars['Boolean']['output']>;
  relationship?: Maybe<Scalars['String']['output']>;
  /** SarahCare SortOrder */
  sortOrder?: Maybe<Scalars['Int']['output']>;
  /** WaitingList_Contacts:<ID> when this contact is SarahCare history */
  sourceId?: Maybe<Scalars['String']['output']>;
  /** Work phone (SarahCare WPhone) */
  workPhone?: Maybe<Scalars['String']['output']>;
};

export type WaitingListContactInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  relationship?: InputMaybe<Scalars['String']['input']>;
};

export type WaitingListEntry = {
  __typename?: 'WaitingListEntry';
  /** ACAT approval expiry date */
  acatApprovalExpiry?: Maybe<Scalars['DateTime']['output']>;
  /** Date ACAT assessment was completed */
  acatAssessmentDate?: Maybe<Scalars['DateTime']['output']>;
  /** ACAT reference number */
  acatReferenceNumber?: Maybe<Scalars['String']['output']>;
  /** Concessional or RAD */
  accommodationPayment?: Maybe<WaitingListAccommodationPayment>;
  /** Further contacts (SarahCare history; the first is contactPerson) */
  additionalContacts?: Maybe<Array<WaitingListContact>>;
  /** SarahCare admit-from-waiting-list records (WaitingList_Admissions) */
  admissionHistory?: Maybe<Array<WaitingListAdmissionHistory>>;
  /** Resident created when this entry was admitted (markWaitingListEntryAdmitted) */
  admittedResidentId?: Maybe<Scalars['ID']['output']>;
  /** Age in years */
  age?: Maybe<Scalars['Int']['output']>;
  archiveNote?: Maybe<Scalars['String']['output']>;
  /** Why it was archived (status keeps the stored outcome) */
  archiveReason?: Maybe<WaitingListArchiveReason>;
  careNeeds?: Maybe<CareNeedsAssessment>;
  /** Admission tasks (ACAT, bond paid, room ready, etc.) */
  checklist?: Maybe<Array<WaitingListChecklistItem>>;
  contactPerson?: Maybe<WaitingListContact>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<Scalars['ID']['output']>;
  currentAddress?: Maybe<Scalars['String']['output']>;
  /** Where person currently lives (home, hospital, other facility) */
  currentLocation?: Maybe<Scalars['String']['output']>;
  dateAdded: Scalars['DateTime']['output'];
  dateOfBirth?: Maybe<Scalars['DateTime']['output']>;
  /** Brisbane days in the current stage (entered date, else the suitability decision for a derived waitlister, else the date added) */
  daysInStage?: Maybe<Scalars['Int']['output']>;
  /** Brisbane days since the last check-in (or since the entry was added). Null once no longer waiting. */
  daysSinceContact?: Maybe<Scalars['Int']['output']>;
  /** Brisbane days since the inquiry was added. Null once no longer waiting. */
  daysSinceInquiry?: Maybe<Scalars['Int']['output']>;
  /** Days on waiting list */
  daysWaiting?: Maybe<Scalars['Int']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  entryType: EntryType;
  expectedAdmissionDate?: Maybe<Scalars['DateTime']['output']>;
  /** The family's latest answer on the confirm page */
  familyResponseAnswer?: Maybe<WaitingListFamilyAnswer>;
  familyResponseAt?: Maybe<Scalars['DateTime']['output']>;
  familyResponseDetails?: Maybe<Scalars['String']['output']>;
  /** true = a family answer is waiting for staff to read it */
  familyResponseOpen?: Maybe<Scalars['Boolean']['output']>;
  firstName: Scalars['String']['output'];
  /** SarahCare follow-up alerts (WaitingListAlerts) — history, never live alerts */
  followUpHistory?: Maybe<Array<WaitingListFollowUpHistory>>;
  /** Full name */
  fullName: Scalars['String']['output'];
  /** Funding notes */
  fundingNotes?: Maybe<Scalars['String']['output']>;
  /** Supported (government pays accommodation) / Non-supported (deposit needed) */
  fundingSupport?: Maybe<FundingSupport>;
  gender?: Maybe<Gender>;
  /** Has approved ACAT assessment */
  hasAcatApproval?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  /** How the inquiry first reached us — walk-in / phone / email / referral / other. Distinct from referralSource (who). */
  inquirySource?: Maybe<InquirySource>;
  /** Interested in our home care while they wait */
  interestedInHomeCare?: Maybe<Scalars['Boolean']['output']>;
  /** Eligible for government funding */
  isFundingEligible?: Maybe<Scalars['Boolean']['output']>;
  /** Last logged check-in with the person or family */
  lastContactAt?: Maybe<Scalars['DateTime']['output']>;
  /** When a message was last sent to the family */
  lastFamilyMessageAt?: Maybe<Scalars['DateTime']['output']>;
  /** true = every recipient of the last message was sent it */
  lastFamilyMessageOk?: Maybe<Scalars['Boolean']['output']>;
  /** What happened to the last family message, per recipient, in words */
  lastFamilyMessageSummary?: Maybe<Scalars['String']['output']>;
  lastName: Scalars['String']['output'];
  /** Waitlist entry with no check-in for 7+ days */
  needsCheckIn: Scalars['Boolean']['output'];
  /** SarahCare notes (WaitingList_Notes), oldest first */
  noteHistory?: Maybe<Array<WaitingListNoteHistory>>;
  notes?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  preferredName?: Maybe<Scalars['String']['output']>;
  priority: WaitingListPriority;
  /** Priority score (higher = more urgent) */
  priorityScore?: Maybe<Scalars['Int']['output']>;
  /** Reference given to the person who sent the public inquiry form (non-sequential) */
  publicReference?: Maybe<Scalars['String']['output']>;
  /** Receiving care at home now */
  receivingCareAtHome?: Maybe<Scalars['Boolean']['output']>;
  referralDate?: Maybe<Scalars['DateTime']['output']>;
  /** Where the referral came from */
  referralSource?: Maybe<Scalars['String']['output']>;
  /** Referring person/organization */
  referredBy?: Maybe<Scalars['String']['output']>;
  /** Resident ID if admitted */
  residentId?: Maybe<Scalars['ID']['output']>;
  /** Responsible admin person (login/client id) */
  responsibleAdminId?: Maybe<Scalars['ID']['output']>;
  responsibleAdminName?: Maybe<Scalars['String']['output']>;
  /** Responsible clinical person (login/client id) */
  responsibleClinicalId?: Maybe<Scalars['ID']['output']>;
  responsibleClinicalName?: Maybe<Scalars['String']['output']>;
  roomPreferences?: Maybe<RoomPreferences>;
  /** Site tour — absent means not booked (see siteTourStatus). Suitable needs DONE or NOT_POSSIBLE. */
  siteTour?: Maybe<WaitingListSiteTour>;
  /** Link to the video-call tour's calendar event, for this viewer only (null = none, or no access) */
  siteTourCalendarUrl?: Maybe<Scalars['String']['output']>;
  /** Site tour state; NOT_BOOKED when none was ever recorded */
  siteTourStatus: SiteTourStatus;
  /** Who put the person on the list in SarahCare */
  sourceAuthor?: Maybe<Scalars['String']['output']>;
  sourceBackupDate?: Maybe<Scalars['DateTime']['output']>;
  /** Original SarahCare Waiting list columns */
  sourceFields?: Maybe<SarahWaitingListSourceFields>;
  sourceHash?: Maybe<Scalars['String']['output']>;
  /** Waiting list:<WaitingID> */
  sourceId?: Maybe<Scalars['String']['output']>;
  /** SarahCare resident number (AssignedCustID) when the person was admitted */
  sourceResidentId?: Maybe<Scalars['String']['output']>;
  /** SARAHCARE when this entry is imported history (read-only) */
  sourceSystem?: Maybe<Scalars['String']['output']>;
  stage: WaitingListStage;
  /** When the entry entered its current stage (moves record it) */
  stageEnteredAt?: Maybe<Scalars['DateTime']['output']>;
  status: WaitingListStatus;
  /** Reason for status change */
  statusChangeReason?: Maybe<Scalars['String']['output']>;
  /** User who changed status */
  statusChangedBy?: Maybe<Scalars['ID']['output']>;
  /** Name of whoever last changed the status (archived / restored / admitted); null when not recorded */
  statusChangedByName?: Maybe<Scalars['String']['output']>;
  /** Date status changed */
  statusChangedDate?: Maybe<Scalars['DateTime']['output']>;
  /** Formal suitability assessment — must be APPROVED before promoting to admission when the feature flag is on. */
  suitabilityAssessment?: Maybe<SuitabilityAssessment>;
  tenantId: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
  /** Unsuitable entries with the same name (and the same date of birth when both have one). Empty when none, or when this entry is not waiting. */
  unsuitableMatches: Array<WaitingListUnsuitableMatch>;
  /** Why the person was found unsuitable (required when suitability is Unsuitable) */
  unsuitableReason?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy?: Maybe<Scalars['ID']['output']>;
};

/** A family's answer on the confirm page */
export enum WaitingListFamilyAnswer {
  DetailsCorrect = 'DETAILS_CORRECT',
  NoLongerNeeded = 'NO_LONGER_NEEDED',
  SomethingChanged = 'SOMETHING_CHANGED'
}

/** WAITLIST_WELCOME = "you're on the waitlist — please confirm your details"; CHECK_IN = "still waiting? anything changed?" */
export enum WaitingListFamilyMessageKind {
  CheckIn = 'CHECK_IN',
  WaitlistWelcome = 'WAITLIST_WELCOME'
}

export type WaitingListFamilyMessagePreview = {
  __typename?: 'WaitingListFamilyMessagePreview';
  /** false = the setting is off (or nobody to send to); disabledReason says why */
  canSend: Scalars['Boolean']['output'];
  disabledReason?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  emailBody: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  recipientName?: Maybe<Scalars['String']['output']>;
  smsBody: Scalars['String']['output'];
  subject: Scalars['String']['output'];
};

export type WaitingListFamilyMessageResult = {
  __typename?: 'WaitingListFamilyMessageResult';
  entry: WaitingListEntry;
  outcomes: Array<WaitingListMessageOutcome>;
};

export type WaitingListFile = {
  __typename?: 'WaitingListFile';
  canOpen: Scalars['Boolean']['output'];
  entryId: Scalars['ID']['output'];
  fileSize: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  /** What it is, in the uploader's words (e.g. "ACAT letter") */
  label?: Maybe<Scalars['String']['output']>;
  mimeType: Scalars['String']['output'];
  movedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The resident medical record it became on admission */
  movedToRecordId?: Maybe<Scalars['ID']['output']>;
  originalFileName: Scalars['String']['output'];
  status: WaitingListFileStatus;
  uploadedAt: Scalars['DateTime']['output'];
  uploadedByName: Scalars['String']['output'];
};

/** ACTIVE = held on the inquiry; MOVED_TO_RESIDENT = now in the resident's Documents */
export enum WaitingListFileStatus {
  Active = 'ACTIVE',
  MovedToResident = 'MOVED_TO_RESIDENT'
}

export type WaitingListFilterInput = {
  /** Concessional / RAD; UNKNOWN also matches entries where it was never asked */
  accommodationPayments?: InputMaybe<Array<WaitingListAccommodationPayment>>;
  entryType?: InputMaybe<EntryType>;
  /** Supported / Non-supported; UNKNOWN also matches entries where it was never asked */
  fundingSupports?: InputMaybe<Array<FundingSupport>>;
  /** With suitabilityStatuses: also include entries with no assessment yet ("To be assessed") */
  includeUnassessed?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by inquiry channel(s) — walk-in / phone / email / referral / other */
  inquirySources?: InputMaybe<Array<InquirySource>>;
  /** Page size (1–200). Omitted = every matching entry. */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** true = only entries where I am the responsible admin or clinical person */
  mine?: InputMaybe<Scalars['Boolean']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  priority?: InputMaybe<WaitingListPriority>;
  /** true = only SarahCare history; false = only entries made in PLCC; omitted = both */
  sarahHistory?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<Scalars['String']['input']>;
  /** Only this stage (entries without a stored stage are matched by their derived stage) */
  stage?: InputMaybe<WaitingListStage>;
  statuses?: InputMaybe<Array<WaitingListStatus>>;
  /** Filter by suitability assessment status */
  suitabilityStatuses?: InputMaybe<Array<SuitabilityStatus>>;
  /** Site tour state(s); NOT_BOOKED also matches entries that never had a tour recorded */
  tourStatuses?: InputMaybe<Array<SiteTourStatus>>;
};

export type WaitingListFollowUpHistory = {
  __typename?: 'WaitingListFollowUpHistory';
  addedAt?: Maybe<Scalars['DateTime']['output']>;
  addedBy?: Maybe<Scalars['String']['output']>;
  /** SarahCare alert type (e.g. Follow Up) */
  alertType?: Maybe<Scalars['String']['output']>;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  completedBy?: Maybe<Scalars['String']['output']>;
  /** Due date as SarahCare recorded it (text; history, never a live due date) */
  dueDateText?: Maybe<Scalars['String']['output']>;
  editedAt?: Maybe<Scalars['DateTime']['output']>;
  editedBy?: Maybe<Scalars['String']['output']>;
  followUpNotes?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  /** WaitingListAlerts:<WaitingListAlertID> */
  sourceId: Scalars['String']['output'];
};

/** How a family message went out */
export enum WaitingListMessageChannel {
  Email = 'EMAIL',
  Sms = 'SMS'
}

export type WaitingListMessageOutcome = {
  __typename?: 'WaitingListMessageOutcome';
  channel: WaitingListMessageChannel;
  detail: Scalars['String']['output'];
  /** true only when the provider accepted it */
  sent: Scalars['Boolean']['output'];
  to: Scalars['String']['output'];
};

export type WaitingListNoteHistory = {
  __typename?: 'WaitingListNoteHistory';
  /** When it was typed into SarahCare (AddDate) */
  addedAt?: Maybe<Scalars['DateTime']['output']>;
  /** SarahCare user who wrote it */
  author?: Maybe<Scalars['String']['output']>;
  /** When the note is about (SarahCare theDatetime) */
  noteDate?: Maybe<Scalars['DateTime']['output']>;
  /** WaitingList_Notes:<ID> */
  sourceId: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

export type WaitingListNoticeOutcome = {
  __typename?: 'WaitingListNoticeOutcome';
  /** true = the in-app notice was saved to their notification bell */
  delivered: Scalars['Boolean']['output'];
  /** Plain words: what happened for this person */
  detail: Scalars['String']['output'];
  recipientName: Scalars['String']['output'];
};

/** Priority level for waiting list placement */
export enum WaitingListPriority {
  Critical = 'CRITICAL',
  High = 'HIGH',
  Normal = 'NORMAL'
}

export type WaitingListResponsibleResult = {
  __typename?: 'WaitingListResponsibleResult';
  entry: WaitingListEntry;
  /** One row per person told (in-app only — no email, no SMS) */
  notices: Array<WaitingListNoticeOutcome>;
};

/** Responsible admin person or responsible clinical person */
export enum WaitingListResponsibleRole {
  Admin = 'ADMIN',
  Clinical = 'CLINICAL'
}

export type WaitingListSiteTour = {
  __typename?: 'WaitingListSiteTour';
  /** Who came, in words — e.g. "daughter and son" */
  attendees?: Maybe<Scalars['String']['output']>;
  /** When the tour happened */
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  /** What the person and family thought of the site (up to 4,000 characters) */
  feedback?: Maybe<Scalars['String']['output']>;
  feedbackRecordedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Who recorded the feedback (set by the server) */
  feedbackRecordedByName?: Maybe<Scalars['String']['output']>;
  /** Why a tour is not possible (required for NOT_POSSIBLE) */
  notPossibleReason?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  recordedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Who last recorded the tour state (set by the server) */
  recordedByName?: Maybe<Scalars['String']['output']>;
  /** When the booked tour is (a moment; shown in Brisbane time) */
  scheduledAt?: Maybe<Scalars['DateTime']['output']>;
  /** Staff member showing / who showed them around (set by the server) */
  shownBy?: Maybe<Scalars['String']['output']>;
  /** Login (client) id of the staff member showing them around */
  shownById?: Maybe<Scalars['ID']['output']>;
  status: SiteTourStatus;
  /** In person / family only / video call */
  tourType?: Maybe<SiteTourType>;
  /** The calendar event made for a video-call tour (calendar module) */
  videoCalendarEventId?: Maybe<Scalars['ID']['output']>;
  /** The calendar that event is on */
  videoCalendarId?: Maybe<Scalars['ID']['output']>;
  /** That calendar's name, as it was when the tour was booked */
  videoCalendarName?: Maybe<Scalars['String']['output']>;
  /** Why the video-call invite was not made, in words; the tour itself is still booked */
  videoInviteProblem?: Maybe<Scalars['String']['output']>;
  /** The video-call join link (Meet) — what the family is sent */
  videoJoinUrl?: Maybe<Scalars['String']['output']>;
};

/** Inquiry → Waitlist → Pre-admission (derived for entries saved before stages existed) */
export enum WaitingListStage {
  Inquiry = 'INQUIRY',
  PreAdmission = 'PRE_ADMISSION',
  Waitlist = 'WAITLIST'
}

export type WaitingListStageMoveResult = {
  __typename?: 'WaitingListStageMoveResult';
  /** Checklist items added from the new stage's template (0 when already there) */
  checklistItemsAdded: Scalars['Int']['output'];
  entry: WaitingListEntry;
  message: Scalars['String']['output'];
};

export type WaitingListStats = {
  __typename?: 'WaitingListStats';
  /** Entries ever admitted from the lists (status ADMITTED, including SarahCare history) */
  admitted: Scalars['Int']['output'];
  /** Entries taken off the lists without admission and not unsuitable (WITHDRAWN + DECEASED, including SarahCare history) — the Archived view */
  archived: Scalars['Int']['output'];
  /** Average days waiting for active entries */
  averageDaysWaiting?: Maybe<Scalars['Int']['output']>;
  /** Breakdown of active entries by inquiry channel */
  bySource: Array<InquirySourceCount>;
  /** Breakdown of active entries by suitability assessment status */
  bySuitabilityStatus: Array<SuitabilityStatusCount>;
  criticalPriority: Scalars['Int']['output'];
  highPriority: Scalars['Int']['output'];
  /** Active entries in Inquiries (stored or derived stage) */
  inquiries: Scalars['Int']['output'];
  permanentEntries: Scalars['Int']['output'];
  /** Active entries in Pre-admissions */
  preAdmissions: Scalars['Int']['output'];
  respiteEntries: Scalars['Int']['output'];
  totalActive: Scalars['Int']['output'];
  /** Entries assessed Unsuitable (DECLINED, including SarahCare history) — the Unsuitable list */
  unsuitable: Scalars['Int']['output'];
  /** Active entries on the Waitlist (stored or derived stage) */
  waitlist: Scalars['Int']['output'];
  /** Waitlist entries with no check-in for 7+ Brisbane days (worked out now — no timers) */
  waitlistNeedingCheckIn: Scalars['Int']['output'];
};

/** Status of a waiting list entry */
export enum WaitingListStatus {
  Active = 'ACTIVE',
  Admitted = 'ADMITTED',
  Deceased = 'DECEASED',
  Declined = 'DECLINED',
  Withdrawn = 'WITHDRAWN'
}

/** A calendar the signed-in person can put a video-call tour on */
export type WaitingListTourCalendarOption = {
  __typename?: 'WaitingListTourCalendarOption';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

/** Exactly what "Send the tour details" would send, and to whom — sends nothing */
export type WaitingListTourMessagePreview = {
  __typename?: 'WaitingListTourMessagePreview';
  canSend: Scalars['Boolean']['output'];
  disabledReason?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  emailBody: Scalars['String']['output'];
  /** The address the email is sent from */
  fromEmail: Scalars['String']['output'];
  /** The name it is sent from */
  fromName: Scalars['String']['output'];
  /** true = the sender's own work email; false = the site's sender (no work email on their staff record) */
  fromOwnWorkEmail: Scalars['Boolean']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  /** Contact person */
  recipientName?: Maybe<Scalars['String']['output']>;
  smsBody: Scalars['String']['output'];
  subject: Scalars['String']['output'];
  /** Missing facts the person should know about (no tour address set, …) */
  warning?: Maybe<Scalars['String']['output']>;
};

/** Can a video-call tour be put on your calendar with a Meet link here? Reads only. */
export type WaitingListTourVideoInviteOptions = {
  __typename?: 'WaitingListTourVideoInviteOptions';
  /** Calendars you can add events to, A–Z */
  calendars: Array<WaitingListTourCalendarOption>;
  canCreate: Scalars['Boolean']['output'];
  /** You have no calendar yet — your own is made for you when you book */
  createsOwnCalendar: Scalars['Boolean']['output'];
  /** Your main calendar (else your own, else the first) */
  defaultCalendarId?: Maybe<Scalars['ID']['output']>;
  /** Why not, in words (module switched off, no permission, …) */
  reason?: Maybe<Scalars['String']['output']>;
};

/** Someone on the Unsuitable list who matches an enquiry (name, and date of birth when both have one) */
export type WaitingListUnsuitableMatch = {
  __typename?: 'WaitingListUnsuitableMatch';
  /** Date-only (stored at T00:00:00.000Z) */
  dateOfBirth?: Maybe<Scalars['DateTime']['output']>;
  /** When they were found unsuitable (or taken off the list) */
  decidedAt?: Maybe<Scalars['DateTime']['output']>;
  fullName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** Why they were unsuitable, as recorded */
  reason?: Maybe<Scalars['String']['output']>;
  /** True when both have a date of birth and it is the same; false = matched on the name only */
  sameDateOfBirth: Scalars['Boolean']['output'];
  /** SARAHCARE when the record is SarahCare history */
  sourceSystem?: Maybe<Scalars['String']['output']>;
};

/** Type of walking aid used */
export enum WalkingAidType {
  ElectricWheelchair = 'ELECTRIC_WHEELCHAIR',
  FourWheelWalker = 'FOUR_WHEEL_WALKER',
  GutterFrame = 'GUTTER_FRAME',
  None = 'NONE',
  WalkingFrame = 'WALKING_FRAME',
  WalkingStick = 'WALKING_STICK',
  Wheelchair = 'WHEELCHAIR'
}

export type WalletContact = {
  __typename?: 'WalletContact';
  address: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isFavourite: Scalars['Boolean']['output'];
  lastUsedAt?: Maybe<Scalars['DateTime']['output']>;
  linkedClientId?: Maybe<Scalars['ID']['output']>;
  name: Scalars['String']['output'];
  note?: Maybe<Scalars['String']['output']>;
  ownerClientId: Scalars['ID']['output'];
  tenantId: Scalars['String']['output'];
  timesUsed: Scalars['Float']['output'];
  updatedAt: Scalars['DateTime']['output'];
  verification: WalletContactStanding;
  verifiedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type WalletContactInvite = {
  __typename?: 'WalletContactInvite';
  acceptedAddress?: Maybe<Scalars['String']['output']>;
  acceptedAt?: Maybe<Scalars['DateTime']['output']>;
  acceptedByClientId?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['DateTime']['output'];
  emailFailedReason?: Maybe<Scalars['String']['output']>;
  emailSentAt?: Maybe<Scalars['DateTime']['output']>;
  expiresAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  inviteeEmail?: Maybe<Scalars['String']['output']>;
  inviteeName: Scalars['String']['output'];
  inviterClientId: Scalars['ID']['output'];
  inviterName: Scalars['String']['output'];
  issuedAt: Scalars['DateTime']['output'];
  openedAt?: Maybe<Scalars['DateTime']['output']>;
  reciprocated: Scalars['Boolean']['output'];
  slug: Scalars['String']['output'];
  status: WalletInviteStatus;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type WalletContactStanding = {
  __typename?: 'WalletContactStanding';
  detail: Scalars['String']['output'];
  label: Scalars['String']['output'];
  level: WalletContactVerification;
  provenAt?: Maybe<Scalars['DateTime']['output']>;
  warn: Scalars['Boolean']['output'];
};

/** How much is actually known about an address in an address book */
export enum WalletContactVerification {
  Revoked = 'REVOKED',
  Superseded = 'SUPERSEDED',
  Unverified = 'UNVERIFIED',
  Verified = 'VERIFIED'
}

export type WalletDirectoryResult = {
  __typename?: 'WalletDirectoryResult';
  meDiscoverable: Scalars['Boolean']['output'];
  people: Array<WalletContact>;
  totalDiscoverable: Scalars['Int']['output'];
  truncated: Scalars['Boolean']['output'];
};

export type WalletInviteAcceptResult = {
  __typename?: 'WalletInviteAcceptResult';
  address?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
  reason?: Maybe<Scalars['String']['output']>;
  reciprocated: Scalars['Boolean']['output'];
  savedBy?: Maybe<Scalars['String']['output']>;
};

export type WalletInviteSendResult = {
  __typename?: 'WalletInviteSendResult';
  emailReason?: Maybe<Scalars['String']['output']>;
  emailed: Scalars['Boolean']['output'];
  invite: WalletContactInvite;
  url: Scalars['String']['output'];
};

/** Where an address-book invite has got to */
export enum WalletInviteStatus {
  Accepted = 'ACCEPTED',
  Cancelled = 'CANCELLED',
  Opened = 'OPENED',
  Pending = 'PENDING'
}

export type WalletKey = {
  __typename?: 'WalletKey';
  address: Scalars['String']['output'];
  clientId: Scalars['ID']['output'];
  countersignature?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  discoverable: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  kind: WalletKeyKind;
  label?: Maybe<Scalars['String']['output']>;
  linkSignature?: Maybe<Scalars['String']['output']>;
  linkedByAdminOverride: Scalars['Boolean']['output'];
  publicKey?: Maybe<Scalars['String']['output']>;
  revocationReason?: Maybe<Scalars['String']['output']>;
  scope: Scalars['String']['output'];
  status: WalletKeyStatus;
  supersedesKeyId?: Maybe<Scalars['ID']['output']>;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  validFrom: Scalars['DateTime']['output'];
  validUntil?: Maybe<Scalars['DateTime']['output']>;
};

/** Where a signing key lives */
export enum WalletKeyKind {
  Browser = 'BROWSER',
  External = 'EXTERNAL',
  Hardware = 'HARDWARE'
}

/** Whether a key is the current one, replaced, or withdrawn */
export enum WalletKeyStatus {
  Active = 'ACTIVE',
  Retired = 'RETIRED',
  Revoked = 'REVOKED'
}

export type WalletKeystorePayload = {
  __typename?: 'WalletKeystorePayload';
  ciphertext?: Maybe<Scalars['String']['output']>;
  iv?: Maybe<Scalars['String']['output']>;
  kdf?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
  reason?: Maybe<Scalars['String']['output']>;
  serverSalt?: Maybe<Scalars['String']['output']>;
};

export type WalletLinkChallenge = {
  __typename?: 'WalletLinkChallenge';
  address: Scalars['String']['output'];
  clientId: Scalars['String']['output'];
  expiresAt: Scalars['DateTime']['output'];
  issuedAt: Scalars['String']['output'];
  keystoreSalt: Scalars['String']['output'];
  nonce: Scalars['String']['output'];
  purpose: Scalars['String']['output'];
  rotating: Scalars['Boolean']['output'];
  scope: Scalars['String']['output'];
};

export type WalletUnlockRequestResult = {
  __typename?: 'WalletUnlockRequestResult';
  reason?: Maybe<Scalars['String']['output']>;
  sent: Scalars['Boolean']['output'];
  sentTo?: Maybe<Scalars['String']['output']>;
};

export type WaterlowAssessment = {
  __typename?: 'WaterlowAssessment';
  age: Scalars['Int']['output'];
  appetite: Scalars['Int']['output'];
  assessedBy: Scalars['ID']['output'];
  assessedByName?: Maybe<Scalars['String']['output']>;
  assessmentDate: Scalars['DateTime']['output'];
  autoProgressNote: Scalars['Boolean']['output'];
  buildWeight: Scalars['Int']['output'];
  continence: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  gender: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  medication: Scalars['Int']['output'];
  mobility: Scalars['Int']['output'];
  neurologicalDeficit: Scalars['Int']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  progressNoteId?: Maybe<Scalars['ID']['output']>;
  residentId: Scalars['ID']['output'];
  residentName?: Maybe<Scalars['String']['output']>;
  residentRoom?: Maybe<Scalars['String']['output']>;
  residentWing?: Maybe<Scalars['String']['output']>;
  riskCategory: Scalars['String']['output'];
  skinType: Scalars['Int']['output'];
  surgery: Scalars['Int']['output'];
  tenantId: Scalars['String']['output'];
  tissueNutrition: Scalars['Int']['output'];
  totalScore: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type WaterlowAssessmentFilterInput = {
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  residentId?: InputMaybe<Scalars['ID']['input']>;
  wing?: InputMaybe<Scalars['String']['input']>;
};

export type WaterlowAssessmentsResponse = {
  __typename?: 'WaterlowAssessmentsResponse';
  assessments: Array<WaterlowAssessment>;
  limit: Scalars['Int']['output'];
  offset: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type WebAuthnCredential = {
  __typename?: 'WebAuthnCredential';
  backedUp?: Maybe<Scalars['Boolean']['output']>;
  clientId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  credentialId: Scalars['String']['output'];
  deviceType?: Maybe<Scalars['String']['output']>;
  host?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastUsedAt?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  origin?: Maybe<Scalars['String']['output']>;
  rpId?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  transports?: Maybe<Array<Scalars['String']['output']>>;
};

export type WeeklyRevenuePoint = {
  __typename?: 'WeeklyRevenuePoint';
  total: Scalars['Float']['output'];
  week: Scalars['String']['output'];
};

export type WeightObservation = {
  __typename?: 'WeightObservation';
  alertMessage?: Maybe<Scalars['String']['output']>;
  autoProgressNote: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  progressNoteId?: Maybe<Scalars['ID']['output']>;
  residentId: Scalars['ID']['output'];
  residentName?: Maybe<Scalars['String']['output']>;
  residentRoom?: Maybe<Scalars['String']['output']>;
  residentWing?: Maybe<Scalars['String']['output']>;
  sourceAuthor?: Maybe<Scalars['String']['output']>;
  sourceBackupDate?: Maybe<Scalars['DateTime']['output']>;
  sourceCanonicalKey?: Maybe<Scalars['String']['output']>;
  sourceContext?: Maybe<SarahObservationSourceContext>;
  sourceContextBackupDate?: Maybe<Scalars['DateTime']['output']>;
  sourceContextImportedAt?: Maybe<Scalars['DateTime']['output']>;
  sourceHash?: Maybe<Scalars['String']['output']>;
  sourceId?: Maybe<Scalars['String']['output']>;
  sourceReviewFlaggedAt?: Maybe<Scalars['DateTime']['output']>;
  sourceReviewReason?: Maybe<Scalars['String']['output']>;
  sourceReviewResolution?: Maybe<Scalars['String']['output']>;
  sourceReviewResolvedAt?: Maybe<Scalars['DateTime']['output']>;
  sourceSystem?: Maybe<Scalars['String']['output']>;
  takenAt: Scalars['DateTime']['output'];
  takenBy: Scalars['ID']['output'];
  takenByName?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  triggeredAlert: Scalars['Boolean']['output'];
  updatedAt: Scalars['DateTime']['output'];
  weight: Scalars['Float']['output'];
};

export type WeightObservationFilterInput = {
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  includeMigrationReview?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  residentId?: InputMaybe<Scalars['ID']['input']>;
  wing?: InputMaybe<Scalars['String']['input']>;
};

export type WeightObservationsResponse = {
  __typename?: 'WeightObservationsResponse';
  limit: Scalars['Int']['output'];
  observations: Array<WeightObservation>;
  offset: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type WingCount = {
  __typename?: 'WingCount';
  count: Scalars['Int']['output'];
  wing: Scalars['String']['output'];
};

export type WithdrawalRequest = {
  __typename?: 'WithdrawalRequest';
  amount: Scalars['Float']['output'];
  approvalCount: Scalars['Int']['output'];
  approvals?: Maybe<Array<ValidatorApproval>>;
  asset: SupportedAsset;
  cancellationReason?: Maybe<Scalars['String']['output']>;
  cancelledAt?: Maybe<Scalars['DateTime']['output']>;
  chain: SupportedChain;
  createdAt: Scalars['DateTime']['output'];
  destinationAddress: Scalars['String']['output'];
  executedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  onChainRequestId?: Maybe<Scalars['String']['output']>;
  requestedBy: Scalars['String']['output'];
  requestedByName: Scalars['String']['output'];
  requiredApprovals: Scalars['Int']['output'];
  status: WithdrawalRequestStatus;
  tenantId: Scalars['String']['output'];
  totalValidatorFees?: Maybe<Scalars['Float']['output']>;
  transactionHash?: Maybe<Scalars['String']['output']>;
  unlockAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  validatorFeePercentage?: Maybe<Scalars['Float']['output']>;
  vaultId: Scalars['ID']['output'];
  withdrawalType: WithdrawalType;
};

/** Status of a withdrawal request */
export enum WithdrawalRequestStatus {
  Approved = 'APPROVED',
  AwaitingValidators = 'AWAITING_VALIDATORS',
  Cancelled = 'CANCELLED',
  Executed = 'EXECUTED',
  Expired = 'EXPIRED',
  Pending = 'PENDING'
}

/** Type of withdrawal */
export enum WithdrawalType {
  Emergency = 'EMERGENCY',
  Standard = 'STANDARD'
}

/** Reason for withholding a medication */
export enum WithholdReason {
  ClinicalDecision = 'CLINICAL_DECISION',
  Fasting = 'FASTING',
  Other = 'OTHER',
  SwallowingDifficulty = 'SWALLOWING_DIFFICULTY',
  Unavailable = 'UNAVAILABLE',
  VitalSigns = 'VITAL_SIGNS',
  Vomiting = 'VOMITING'
}

/** Relationship of witness to incident */
export enum WitnessType {
  Family = 'FAMILY',
  NotRecorded = 'NOT_RECORDED',
  Other = 'OTHER',
  Resident = 'RESIDENT',
  Staff = 'STAFF',
  Visitor = 'VISITOR'
}

export type WitnessesResponse = {
  __typename?: 'WitnessesResponse';
  total: Scalars['Int']['output'];
  witnesses: Array<IncidentWitness>;
};

export type Worker = {
  __typename?: 'Worker';
  activeAssignments?: Maybe<Scalars['Int']['output']>;
  availableHoursPerWeek?: Maybe<Scalars['Int']['output']>;
  averageResponseTime?: Maybe<Scalars['Float']['output']>;
  certifications?: Maybe<Array<WorkerCertification>>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  documents?: Maybe<Array<WorkerDocument>>;
  education?: Maybe<Array<WorkerEducation>>;
  email?: Maybe<Scalars['String']['output']>;
  experience?: Maybe<Array<WorkerExperience>>;
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isAvailable: Scalars['Boolean']['output'];
  languages?: Maybe<Array<WorkerLanguage>>;
  lastName: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  preferredWorkingHours?: Maybe<Scalars['String']['output']>;
  profilePhoto?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Scalars['Float']['output']>;
  referralPercentage?: Maybe<Scalars['Float']['output']>;
  referredBy?: Maybe<Scalars['String']['output']>;
  skills?: Maybe<Array<Scalars['String']['output']>>;
  status: WorkerStatus;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  tenantId: Scalars['String']['output'];
  timezone?: Maybe<Scalars['String']['output']>;
  totalHoursWorked?: Maybe<Scalars['Float']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  videoIntroUrl?: Maybe<Scalars['String']['output']>;
};

export type WorkerCertification = {
  __typename?: 'WorkerCertification';
  certifiedDate?: Maybe<Scalars['DateTime']['output']>;
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  level: CertificationLevel;
  software: Scalars['String']['output'];
};

export type WorkerCertificationInput = {
  certifiedDate?: InputMaybe<Scalars['DateTime']['input']>;
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  level: CertificationLevel;
  software: Scalars['String']['input'];
};

export type WorkerDocument = {
  __typename?: 'WorkerDocument';
  name: Scalars['String']['output'];
  type: WorkerDocumentType;
  uploadedAt: Scalars['DateTime']['output'];
  url: Scalars['String']['output'];
};

export type WorkerDocumentInput = {
  name: Scalars['String']['input'];
  type: WorkerDocumentType;
  url: Scalars['String']['input'];
};

/** Type of worker document */
export enum WorkerDocumentType {
  Certification = 'CERTIFICATION',
  Cv = 'CV',
  Id = 'ID',
  Other = 'OTHER'
}

export type WorkerEducation = {
  __typename?: 'WorkerEducation';
  country: Scalars['String']['output'];
  degree: Scalars['String']['output'];
  institution: Scalars['String']['output'];
  yearCompleted?: Maybe<Scalars['Int']['output']>;
};

export type WorkerEducationInput = {
  country: Scalars['String']['input'];
  degree: Scalars['String']['input'];
  institution: Scalars['String']['input'];
  yearCompleted?: InputMaybe<Scalars['Int']['input']>;
};

export type WorkerExperience = {
  __typename?: 'WorkerExperience';
  company: Scalars['String']['output'];
  country: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  startDate: Scalars['DateTime']['output'];
  title: Scalars['String']['output'];
};

export type WorkerExperienceInput = {
  company: Scalars['String']['input'];
  country: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  startDate: Scalars['DateTime']['input'];
  title: Scalars['String']['input'];
};

export type WorkerFilterInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  isAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  software?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<WorkerStatus>;
};

export type WorkerLanguage = {
  __typename?: 'WorkerLanguage';
  language: Scalars['String']['output'];
  proficiency: LanguageProficiency;
};

export type WorkerLanguageInput = {
  language: Scalars['String']['input'];
  proficiency: LanguageProficiency;
};

/** Worker lifecycle status */
export enum WorkerStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  PendingReview = 'PENDING_REVIEW',
  Suspended = 'SUSPENDED',
  Training = 'TRAINING'
}

export type WorkerTimeEntry = {
  __typename?: 'WorkerTimeEntry';
  approvedAt?: Maybe<Scalars['DateTime']['output']>;
  approvedBy?: Maybe<Scalars['String']['output']>;
  billId?: Maybe<Scalars['String']['output']>;
  billableAmount: Scalars['Float']['output'];
  category: WorkerTimeEntryCategory;
  createdAt: Scalars['DateTime']['output'];
  date: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  durationMinutes: Scalars['Int']['output'];
  hourlyRate: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  isBilled: Scalars['Boolean']['output'];
  lawFirmName: Scalars['String']['output'];
  matterReference: Scalars['String']['output'];
  status: WorkerTimeEntryStatus;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  workerId: Scalars['ID']['output'];
};

/** Category of work performed */
export enum WorkerTimeEntryCategory {
  ClientCommunication = 'CLIENT_COMMUNICATION',
  DatabaseCleanup = 'DATABASE_CLEANUP',
  DocumentReview = 'DOCUMENT_REVIEW',
  MatterManagement = 'MATTER_MANAGEMENT',
  Other = 'OTHER',
  Research = 'RESEARCH'
}

export type WorkerTimeEntryFilterInput = {
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  lawFirmName?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<WorkerTimeEntryStatus>;
  workerId?: InputMaybe<Scalars['ID']['input']>;
};

/** Time entry approval status */
export enum WorkerTimeEntryStatus {
  Approved = 'APPROVED',
  Draft = 'DRAFT',
  Rejected = 'REJECTED',
  Submitted = 'SUBMITTED'
}

export type Wound = {
  __typename?: 'Wound';
  bodyLocation: BodyLocation;
  cause?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['ID']['output'];
  createdByName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  locationDetail?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  onsetDate: Scalars['DateTime']['output'];
  pressureInjuryStage: PressureInjuryStage;
  residentId: Scalars['ID']['output'];
  residentName?: Maybe<Scalars['String']['output']>;
  residentRoom?: Maybe<Scalars['String']['output']>;
  residentWing?: Maybe<Scalars['String']['output']>;
  resolvedDate?: Maybe<Scalars['DateTime']['output']>;
  sourceAuthor?: Maybe<Scalars['String']['output']>;
  sourceBackupDate?: Maybe<Scalars['DateTime']['output']>;
  sourceFields?: Maybe<SarahWoundSourceFields>;
  sourceId?: Maybe<Scalars['String']['output']>;
  sourceSystem?: Maybe<Scalars['String']['output']>;
  status: WoundStatus;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  woundType: WoundType;
};

export type WoundAssessment = {
  __typename?: 'WoundAssessment';
  assessedBy: Scalars['ID']['output'];
  assessedByName?: Maybe<Scalars['String']['output']>;
  assessmentDate: Scalars['DateTime']['output'];
  autoProgressNote: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  depthCm?: Maybe<Scalars['Float']['output']>;
  dressingApplied?: Maybe<Scalars['String']['output']>;
  exudateAmount?: Maybe<ExudateAmount>;
  exudateType?: Maybe<ExudateType>;
  id: Scalars['ID']['output'];
  lengthCm?: Maybe<Scalars['Float']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  painLevel?: Maybe<Scalars['Int']['output']>;
  periwoundSkin?: Maybe<Scalars['String']['output']>;
  progressNoteId?: Maybe<Scalars['ID']['output']>;
  residentId: Scalars['ID']['output'];
  residentName?: Maybe<Scalars['String']['output']>;
  residentRoom?: Maybe<Scalars['String']['output']>;
  residentWing?: Maybe<Scalars['String']['output']>;
  signsOfInfection: Array<Scalars['String']['output']>;
  sourceAuthor?: Maybe<Scalars['String']['output']>;
  sourceBackupDate?: Maybe<Scalars['DateTime']['output']>;
  sourceFields?: Maybe<SarahWoundAssessmentSourceFields>;
  sourceId?: Maybe<Scalars['String']['output']>;
  sourceSystem?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  widthCm?: Maybe<Scalars['Float']['output']>;
  woundBed?: Maybe<WoundBedAppearance>;
  woundId: Scalars['ID']['output'];
};

export type WoundAssessmentFilterInput = {
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  residentId?: InputMaybe<Scalars['ID']['input']>;
  sarahHistory?: InputMaybe<Scalars['Boolean']['input']>;
  woundId?: InputMaybe<Scalars['ID']['input']>;
};

export type WoundAssessmentsResponse = {
  __typename?: 'WoundAssessmentsResponse';
  assessments: Array<WoundAssessment>;
  limit: Scalars['Int']['output'];
  offset: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

/** Wound bed appearance */
export enum WoundBedAppearance {
  Clean = 'CLEAN',
  Epithelialising = 'EPITHELIALISING',
  Granulating = 'GRANULATING',
  Mixed = 'MIXED',
  Necrotic = 'NECROTIC',
  Sloughy = 'SLOUGHY'
}

export type WoundFilterInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  residentId?: InputMaybe<Scalars['ID']['input']>;
  sarahHistory?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<WoundStatus>;
  woundType?: InputMaybe<WoundType>;
};

/** Current wound status */
export enum WoundStatus {
  Active = 'ACTIVE',
  Chronic = 'CHRONIC',
  Closed = 'CLOSED',
  Healing = 'HEALING',
  HistoryReview = 'HISTORY_REVIEW',
  Infected = 'INFECTED',
  Resolved = 'RESOLVED',
  Worsening = 'WORSENING'
}

/** Type of wound */
export enum WoundType {
  Abrasion = 'ABRASION',
  Burn = 'BURN',
  Laceration = 'LACERATION',
  NotRecorded = 'NOT_RECORDED',
  Other = 'OTHER',
  PressureInjury = 'PRESSURE_INJURY',
  SkinTear = 'SKIN_TEAR',
  Surgical = 'SURGICAL',
  UlcerArterial = 'ULCER_ARTERIAL',
  UlcerDiabetic = 'ULCER_DIABETIC',
  UlcerVenous = 'ULCER_VENOUS'
}

export type WoundsResponse = {
  __typename?: 'WoundsResponse';
  limit: Scalars['Int']['output'];
  offset: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  wounds: Array<Wound>;
};

export type XeroApiChartImportInput = {
  companyId: Scalars['ID']['input'];
  updateExisting?: InputMaybe<Scalars['Boolean']['input']>;
  xeroTenantId: Scalars['String']['input'];
};

export type XeroChartImportInput = {
  companyId: Scalars['ID']['input'];
  csvText: Scalars['String']['input'];
  updateExisting?: InputMaybe<Scalars['Boolean']['input']>;
};

export type XeroInvoiceDetail = {
  __typename?: 'XeroInvoiceDetail';
  amountDue?: Maybe<Scalars['Float']['output']>;
  amountPaid?: Maybe<Scalars['Float']['output']>;
  contactName?: Maybe<Scalars['String']['output']>;
  currencyCode?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['String']['output']>;
  fullyPaidOnDate?: Maybe<Scalars['String']['output']>;
  invoiceId: Scalars['String']['output'];
  invoiceNumber?: Maybe<Scalars['String']['output']>;
  lineAmountTypes?: Maybe<Scalars['String']['output']>;
  lines: Array<XeroInvoiceLine>;
  payments: Array<XeroInvoicePayment>;
  reference?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  subTotal?: Maybe<Scalars['Float']['output']>;
  total?: Maybe<Scalars['Float']['output']>;
  totalTax?: Maybe<Scalars['Float']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  xeroUrl?: Maybe<Scalars['String']['output']>;
};

export type XeroInvoiceLine = {
  __typename?: 'XeroInvoiceLine';
  accountCode?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  lineAmount?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  unitAmount?: Maybe<Scalars['Float']['output']>;
};

export type XeroInvoicePayment = {
  __typename?: 'XeroInvoicePayment';
  amount: Scalars['Float']['output'];
  date?: Maybe<Scalars['String']['output']>;
  paymentId?: Maybe<Scalars['String']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
};

export type XeroInvoiceSummary = {
  __typename?: 'XeroInvoiceSummary';
  amountDue?: Maybe<Scalars['Float']['output']>;
  amountPaid?: Maybe<Scalars['Float']['output']>;
  contactName?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['String']['output']>;
  invoiceId?: Maybe<Scalars['String']['output']>;
  invoiceNumber?: Maybe<Scalars['String']['output']>;
  lines: Array<XeroInvoiceLine>;
  reference?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  subTotal?: Maybe<Scalars['Float']['output']>;
  total?: Maybe<Scalars['Float']['output']>;
  totalTax?: Maybe<Scalars['Float']['output']>;
};

export type XeroPaymentSummary = {
  __typename?: 'XeroPaymentSummary';
  amount: Scalars['Float']['output'];
  contactName?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['String']['output']>;
  invoiceNumber?: Maybe<Scalars['String']['output']>;
};

export type XeroSummary = {
  __typename?: 'XeroSummary';
  amountAwaiting: Scalars['Float']['output'];
  configured: Scalars['Boolean']['output'];
  error?: Maybe<Scalars['String']['output']>;
  invoicesAwaiting: Scalars['Int']['output'];
  invoicesOverdue: Scalars['Int']['output'];
  matchedDeals: Scalars['Int']['output'];
  orgName?: Maybe<Scalars['String']['output']>;
  recentPayments: Array<XeroPaymentSummary>;
  revenueYtd: Scalars['Float']['output'];
};

export type XeroTransaction = {
  __typename?: 'XeroTransaction';
  amount: Scalars['Float']['output'];
  candidates: Array<MatchCandidateType>;
  contactName?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['String']['output']>;
  direction: Scalars['String']['output'];
  excludedReason?: Maybe<Scalars['String']['output']>;
  invoice?: Maybe<XeroInvoiceSummary>;
  invoiceId?: Maybe<Scalars['String']['output']>;
  invoiceNumber?: Maybe<Scalars['String']['output']>;
  invoiceType?: Maybe<Scalars['String']['output']>;
  isManualMatch: Scalars['Boolean']['output'];
  matchNote?: Maybe<Scalars['String']['output']>;
  matchState: Scalars['String']['output'];
  matchedProjectId?: Maybe<Scalars['String']['output']>;
  matchedProjectName?: Maybe<Scalars['String']['output']>;
  paymentId: Scalars['String']['output'];
  reference?: Maybe<Scalars['String']['output']>;
  xeroUrl?: Maybe<Scalars['String']['output']>;
};

/** One bank account's share of a Xero transactions import */
export type XeroTransactionBankLine = {
  __typename?: 'XeroTransactionBankLine';
  alreadyImportedCount: Scalars['Int']['output'];
  bankAccountId: Scalars['ID']['output'];
  bankName: Scalars['String']['output'];
  insertedCount: Scalars['Int']['output'];
  newCount: Scalars['Int']['output'];
  refreshedCount: Scalars['Int']['output'];
  suggestedCount: Scalars['Int']['output'];
  xeroCode: Scalars['String']['output'];
};

export type XeroTransactionImportInput = {
  companyId: Scalars['ID']['input'];
  fromDate: Scalars['String']['input'];
  xeroTenantId: Scalars['String']['input'];
};

/** Preview or result of importing transactions from Xero */
export type XeroTransactionImportResult = {
  __typename?: 'XeroTransactionImportResult';
  alreadyImportedCount: Scalars['Int']['output'];
  banks: Array<XeroTransactionBankLine>;
  committed: Scalars['Boolean']['output'];
  fromDate: Scalars['String']['output'];
  invoiceLinesRead: Scalars['Boolean']['output'];
  newCount: Scalars['Int']['output'];
  rows: Array<XeroTransactionPreviewRow>;
  shownRows: Scalars['Int']['output'];
  skippedBreakdown: Array<Scalars['String']['output']>;
  skippedDeletedCount: Scalars['Int']['output'];
  skippedUnreadableCount: Scalars['Int']['output'];
  suggestionsRefreshedCount: Scalars['Int']['output'];
  totalRead: Scalars['Int']['output'];
  unmatched: Array<XeroUnmatchedBank>;
};

/** One row of a Xero transactions preview */
export type XeroTransactionPreviewRow = {
  __typename?: 'XeroTransactionPreviewRow';
  amountCents: Scalars['Int']['output'];
  bankName: Scalars['String']['output'];
  day: Scalars['String']['output'];
  description: Scalars['String']['output'];
  direction: AccountingDirection;
  isNew: Scalars['Boolean']['output'];
  kind: Scalars['String']['output'];
  suggestedAccountCode?: Maybe<Scalars['String']['output']>;
};

export type XeroTransactionsResult = {
  __typename?: 'XeroTransactionsResult';
  error?: Maybe<Scalars['String']['output']>;
  excludedCount: Scalars['Int']['output'];
  excludedTotal: Scalars['Float']['output'];
  matchedCount: Scalars['Int']['output'];
  needsReviewCount: Scalars['Int']['output'];
  totalIn: Scalars['Float']['output'];
  totalOut: Scalars['Float']['output'];
  transactions: Array<XeroTransaction>;
  unmatchedCount: Scalars['Int']['output'];
};

/** A Xero bank account with transactions but no bank account here to put them in */
export type XeroUnmatchedBank = {
  __typename?: 'XeroUnmatchedBank';
  count: Scalars['Int']['output'];
  xeroCode: Scalars['String']['output'];
  xeroName: Scalars['String']['output'];
};

export type ZkAuthResponse = {
  __typename?: 'ZKAuthResponse';
  client: Client;
  token: Scalars['String']['output'];
};

export type ZkChallenge = {
  __typename?: 'ZKChallenge';
  challenge: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  expiresAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  isUsed: Scalars['Boolean']['output'];
  publicKey?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
};

export type ZkCredential = {
  __typename?: 'ZKCredential';
  clientId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  credentialType: ZkCredentialType;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  lastUsedAt?: Maybe<Scalars['DateTime']['output']>;
  publicKey: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** Type of biometric credential */
export enum ZkCredentialType {
  Face = 'FACE',
  FaceVoice = 'FACE_VOICE',
  Voice = 'VOICE'
}

export type ZkEnrollInput = {
  credentialType: ZkCredentialType;
  helperData: Scalars['String']['input'];
  publicKey: Scalars['String']['input'];
};

export type ZkVerifyInput = {
  challenge: Scalars['String']['input'];
  publicKey: Scalars['String']['input'];
  signature: Scalars['String']['input'];
};
